/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 604);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(611);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IconBase__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__twoTonePrimaryColor__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(229);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





 // Initial setting
// should move it to antd main repo?

Object(__WEBPACK_IMPORTED_MODULE_3__twoTonePrimaryColor__["b" /* setTwoToneColor */])('#1890ff');

var Icon = function Icon(props, ref) {
  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties(props, ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]);

  var classString = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('anticon', _defineProperty({}, "anticon-".concat(icon.name), Boolean(icon.name)), className);
  var svgClassString = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
    'anticon-spin': !!spin || icon.name === 'loading'
  });
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* normalizeTwoToneColors */])(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", Object.assign({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__IconBase__["a" /* default */], {
    className: svgClassString,
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
};

Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = __WEBPACK_IMPORTED_MODULE_3__twoTonePrimaryColor__["a" /* getTwoToneColor */];
Icon.setTwoToneColor = __WEBPACK_IMPORTED_MODULE_3__twoTonePrimaryColor__["b" /* setTwoToneColor */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Icon));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(911);

__webpack_require__(187);
//# sourceMappingURL=index.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Form = _interopRequireDefault(__webpack_require__(913));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Form["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var allIcons = _interopRequireWildcard(__webpack_require__(812));

var _iconsReact = _interopRequireDefault(__webpack_require__(417));

var _IconFont = _interopRequireDefault(__webpack_require__(846));

var _utils = __webpack_require__(847);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _twoTonePrimaryColor = __webpack_require__(848);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable camelcase */


// Initial setting
_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
  return allIcons[key];
})));

(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var defaultTheme = 'outlined';
var dangerousTheme;

function unstable_ChangeThemeOfIconsDangerously(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  dangerousTheme = theme;
}

function unstable_ChangeDefaultThemeOfIcons(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  defaultTheme = theme;
}

var Icon = function Icon(props) {
  var _classNames;

  var className = props.className,
      type = props.type,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      theme = props.theme,
      twoToneColor = props.twoToneColor,
      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);

  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  var renderInnerNode = function renderInnerNode() {
    // component > children > type
    if (Component) {
      return React.createElement(Component, innerSvgProps, children);
    }

    if (children) {
      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return React.createElement("svg", _extends({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    if (typeof type === 'string') {
      var computedType = type;

      if (theme) {
        var themeInName = (0, _utils.getThemeFromTypeName)(type);
        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
      }

      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
      return React.createElement(_iconsReact["default"], {
        className: svgClassString,
        type: computedType,
        primaryColor: twoToneColor,
        style: svgStyle
      });
    }
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return React.createElement(_LocaleReceiver["default"], {
    componentName: "Icon"
  }, function (locale) {
    return React.createElement("i", _extends({
      "aria-label": type && "".concat(locale.icon, ": ").concat(type)
    }, restProps, {
      tabIndex: iconTabIndex,
      onClick: onClick,
      className: classString
    }), renderInnerNode());
  });
};

Icon.createFromIconfontCN = _IconFont["default"];
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(858);
//# sourceMappingURL=index.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcSelect = _interopRequireWildcard(__webpack_require__(1207));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _type = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
var SelectPropTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(SelectSizes),
  notFoundContent: PropTypes.any,
  showSearch: PropTypes.bool,
  optionLabelProp: PropTypes.string,
  transitionName: PropTypes.string,
  choiceTransitionName: PropTypes.string,
  id: PropTypes.string
};

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _this.saveSelect = function (node) {
      _this.rcSelect = node;
    };

    _this.renderSelect = function (_ref) {
      var _classNames;

      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          _a$className = _a.className,
          className = _a$className === void 0 ? '' : _a$className,
          size = _a.size,
          mode = _a.mode,
          getPopupContainer = _a.getPopupContainer,
          removeIcon = _a.removeIcon,
          clearIcon = _a.clearIcon,
          menuItemSelectedIcon = _a.menuItemSelectedIcon,
          showArrow = _a.showArrow,
          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);

      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
      var prefixCls = getPrefixCls('select', customizePrefixCls);
      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
      var optionLabelProp = _this.props.optionLabelProp;

      if (_this.isCombobox()) {
        // children 带 dom 结构时，无法填入输入框
        optionLabelProp = optionLabelProp || 'value';
      }

      var modeConfig = {
        multiple: mode === 'multiple',
        tags: mode === 'tags',
        combobox: _this.isCombobox()
      };
      var finalRemoveIcon = removeIcon && (React.isValidElement(removeIcon) ? React.cloneElement(removeIcon, {
        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
      }) : removeIcon) || React.createElement(_icon["default"], {
        type: "close",
        className: "".concat(prefixCls, "-remove-icon")
      });
      var finalClearIcon = clearIcon && (React.isValidElement(clearIcon) ? React.cloneElement(clearIcon, {
        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
      }) : clearIcon) || React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        className: "".concat(prefixCls, "-clear-icon")
      });
      var finalMenuItemSelectedIcon = menuItemSelectedIcon && (React.isValidElement(menuItemSelectedIcon) ? React.cloneElement(menuItemSelectedIcon, {
        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
      }) : menuItemSelectedIcon) || React.createElement(_icon["default"], {
        type: "check",
        className: "".concat(prefixCls, "-selected-icon")
      });
      return React.createElement(_rcSelect["default"], _extends({
        inputIcon: _this.renderSuffixIcon(prefixCls),
        removeIcon: finalRemoveIcon,
        clearIcon: finalClearIcon,
        menuItemSelectedIcon: finalMenuItemSelectedIcon,
        showArrow: showArrow
      }, rest, modeConfig, {
        prefixCls: prefixCls,
        className: cls,
        optionLabelProp: optionLabelProp || 'children',
        notFoundContent: _this.getNotFoundContent(renderEmpty),
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        ref: _this.saveSelect
      }));
    };

    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
    return _this;
  }

  _createClass(Select, [{
    key: "getNotFoundContent",
    value: function getNotFoundContent(renderEmpty) {
      var notFoundContent = this.props.notFoundContent;

      if (notFoundContent !== undefined) {
        return notFoundContent;
      }

      if (this.isCombobox()) {
        return null;
      }

      return renderEmpty('Select');
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcSelect.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSelect.blur();
    }
  }, {
    key: "isCombobox",
    value: function isCombobox() {
      var mode = this.props.mode;
      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
    }
  }, {
    key: "renderSuffixIcon",
    value: function renderSuffixIcon(prefixCls) {
      var _this$props = this.props,
          loading = _this$props.loading,
          suffixIcon = _this$props.suffixIcon;

      if (suffixIcon) {
        return React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
        }) : suffixIcon;
      }

      if (loading) {
        return React.createElement(_icon["default"], {
          type: "loading"
        });
      }

      return React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-arrow-icon")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect);
    }
  }]);

  return Select;
}(React.Component);

exports["default"] = Select;
Select.Option = _rcSelect.Option;
Select.OptGroup = _rcSelect.OptGroup;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
Select.defaultProps = {
  showSearch: false,
  transitionName: 'slide-up',
  choiceTransitionName: 'zoom'
};
Select.propTypes = SelectPropTypes;
//# sourceMappingURL=index.js.map


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1203);

__webpack_require__(209);
//# sourceMappingURL=index.js.map


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(152);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(908));

var _buttonGroup = _interopRequireDefault(__webpack_require__(910));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_button["default"].Group = _buttonGroup["default"];
var _default = _button["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(906);
//# sourceMappingURL=index.js.map


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(616)();
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1005);

__webpack_require__(11);
//# sourceMappingURL=index.js.map


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(__webpack_require__(166));

var _Group = _interopRequireDefault(__webpack_require__(1007));

var _Search = _interopRequireDefault(__webpack_require__(1008));

var _TextArea = _interopRequireDefault(__webpack_require__(442));

var _Password = _interopRequireDefault(__webpack_require__(1016));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Input["default"].Group = _Group["default"];
_Input["default"].Search = _Search["default"];
_Input["default"].TextArea = _TextArea["default"];
_Input["default"].Password = _Password["default"];
var _default = _Input["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(652);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });






/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(187);
//# sourceMappingURL=index.js.map


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(188);

var _default = _grid.Col;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(187);
//# sourceMappingURL=index.js.map


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(188);

var _default = _grid.Row;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(803);
//# sourceMappingURL=index.js.map


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layout = _interopRequireDefault(__webpack_require__(411));

var _Sider = _interopRequireDefault(__webpack_require__(272));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_layout["default"].Sider = _Sider["default"];
var _default = _layout["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_cru_logo_png__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_cru_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_cru_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_diamind_logo_png__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_diamind_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_diamind_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_act_quicr_logo_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_act_quicr_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_act_quicr_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_settings_png__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Footer_css__);








var Footer = function Footer(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Footer, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', align: 'middle', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { md: 12, sm: 24 }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { lg: 24 }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: '/' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_10__assets_img_act_quicr_logo_png___default.a, style: { objectFit: 'contain', width: '20%', minWidth: 150, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'https://www.cru.ucalgary.ca', target: '_blank', rel: 'noopener noreferrer' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { alt: 'cru', src: __WEBPACK_IMPORTED_MODULE_8__assets_img_cru_logo_png___default.a, style: { objectFit: 'contain', width: '20%', minWidth: 150, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'https://www.diamindsolutions.ca', target: '_blank', rel: 'noopener noreferrer' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { alt: 'diamind', src: __WEBPACK_IMPORTED_MODULE_9__assets_img_diamind_logo_png___default.a, style: { objectFit: 'contain', width: '20%', minWidth: 200, height: 'auto', marginTop: 20 } }))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { md: 12, sm: 24 }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { float: 'right' } }, '\xA9 2020 | ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'https://www.diamindsolutions.ca', target: '_blank', rel: 'noopener noreferrer', style: { color: '#000000' } }, ' Diamind Solutions Inc. '), ' | ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'https://www.cru.ucalgary.ca', target: '_blank', rel: 'noopener noreferrer', style: { color: '#000000' } }, ' Clinical Research Unit '), ', University of Calgary, Cumming School of Medicine '))), !props.noAdminLink && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/admin/dashboard', className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.settingsLink }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { alt: 'admin', src: __WEBPACK_IMPORTED_MODULE_11__assets_img_settings_png___default.a, style: { width: '28px', height: '28px' } })));
};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(612);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(282);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(836);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(840);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(282);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return loginRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return loginTwoFactorRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return logoutRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return resetPasswordRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return resetPasswordConfirmUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return resetPasswordConfirmRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return resetPasswordProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return setPasswordConfirmRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return setPasswordConfirmUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getPermissionsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getQRCodeRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getNotificationSettingsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return setNotificationSettingsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getAccountInfoRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return updateAccountInfoRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getTwoFactorRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return updateTwoFactorMethodsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return setTwoFactorRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getSitesRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getFollowUpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getFollowUpsRequest; });
/* unused harmony export createFollowUpRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return updateFollowUpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return lockFollowUpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return unlockFollowUpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return deleteSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return activateSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return lockSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return unlockSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return updateSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return createSubjectRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return createRegistryIDProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return updateRegistryIDProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return updateEmailStatusRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return updateConsentGivenRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return updateAdjudicatedConsentStatusRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getDashboardRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getSAEsListRequest; });
/* unused harmony export getSAERequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return createSAERequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return updateSAERequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deleteSAERequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return lockSAERequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return unlockSAERequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return toggleActivateSAERequest; });
/* unused harmony export getPatientsRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getDocumentsSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getDocumentsTrainingSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getDocumentsPublicSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getSubjectSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getSettingsSitesRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return updateSiteRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return deleteSiteRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return activateSiteRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return createSiteRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getSettingsUsersRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getSettingsUserSingleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return contactUsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getPublicDocumentsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return updateUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return deleteUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return activateUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return createUserRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return createUserTrainingRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return createUserTrainingUploadRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return resetUserTrainingRetriesRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getSettingsRolesRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return updateRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return createRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return toggleActivateRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return toggleUserActivateRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return createUserRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return updateUserRoleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return createDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return createPatientProfileDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return updateDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return updatePatientProfileDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return deletePatientProfileDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return deleteDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return activateDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return activatePatientProfileDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return approveDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return unapproveDocumentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return updateConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deleteConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activateConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getSettingsGeneralRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return createSettingsGeneralRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return updateSettingsGeneralRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return deleteSettingsGeneralRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return activateSettingsGeneralRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return updateAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activateAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return deleteAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return resendAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return reviewedAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return unreviewedAuditLogsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getSimulationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return createSimulationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return updateSimulationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return deleteSimulationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return activateSimulationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return trainingGetRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return trainingStartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return trainingCheckRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return createNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return updateNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deleteNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return activateNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return sendNewsletterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return uploadNewsletterImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return activateSiteRandomizationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return deleteSiteRandomizationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getRolesLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getUsersLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getUserSites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return copyBulkUserPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getBulkSites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getBulkSiteRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return copyBulkSitePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return copyBulkSiteChangePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getFileReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getFileReportingByDepot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getAccountProfileId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getPrivateFileLinkRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return createCoenrollmentProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return updateCoenrollmentProfileRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_url__ = __webpack_require__(123);


/**
 * @file A point for all requests
 */var api = __webpack_require__(779);var getHeaders = function getHeaders() {
  return { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('token') } };
};var getHeadersFile = function getHeadersFile() {
  return { headers: { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + window.localStorage.getItem('token') } };
};var getHeadersRandomize = function getHeadersRandomize() {
  return { headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': "https://act.dctms.ca" }, auth: { username: "wiZzx1yTU1vSx89QKprP", password: "GmjMJuznKRqNxfca3gk6" } };
}; /**
   * Development/ production apiUrl()
   */var apiUrl = function apiUrl() {
  return "https://act-api.dctms.ca";
}; /**
   * login request
   */var loginRequest = function loginRequest(_ref) {
  var username = _ref.username,
      password = _ref.password;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.login, { username: username, password: password });
}; /**
   * login 2 factor request
   */var loginTwoFactorRequest = function loginTwoFactorRequest(_ref2) {
  var username = _ref2.username,
      password = _ref2.password,
      code = _ref2.code;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.loginTwoFactor, { username: username, password: password, code: code });
}; /**
   * Sign out request
   */var logoutRequest = function logoutRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.logout, null, getHeaders());
}; /**
   * Reset password request
   */var resetPasswordRequest = function resetPasswordRequest(_ref3) {
  var username = _ref3.username;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.resetPassword, { username: username });
}; /**
   * Reset password confirm user
   */var resetPasswordConfirmUserRequest = function resetPasswordConfirmUserRequest(_ref4) {
  var token = _ref4.token;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.resetPasswordConfirm, { token: token }));
}; /**
   * Reset password confirm user
   */var resetPasswordConfirmRequest = function resetPasswordConfirmRequest(_ref5) {
  var token = _ref5.token,
      password = _ref5.password,
      confirm_password = _ref5.confirm_password;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.resetPasswordConfirm, { token: token }), { password: password, confirm_password: confirm_password });
}; /**
   * Reset password in profile
   */var resetPasswordProfileRequest = function resetPasswordProfileRequest(_ref6) {
  var current_password = _ref6.current_password,
      new_password = _ref6.new_password,
      confirm_new_password = _ref6.confirm_new_password;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.resetPasswordProfile, { current_password: current_password, new_password: new_password, confirm_new_password: confirm_new_password }, getHeaders());
}; /**
   * Reset password confirm user
   */var setPasswordConfirmRequest = function setPasswordConfirmRequest(_ref7) {
  var token = _ref7.token,
      password = _ref7.password,
      confirm_password = _ref7.confirm_password;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.setPasswordConfirm, { token: token }), { password: password, confirm_password: confirm_password });
}; /**
   * Get setting password user
   */var setPasswordConfirmUserRequest = function setPasswordConfirmUserRequest(_ref8) {
  var token = _ref8.token;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.setPasswordConfirm, { token: token }));
}; /**
   * Get Permissions
   */var getPermissionsRequest = function getPermissionsRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.permissions, getHeaders());
}; /**
   * Get QR
   */var getQRCodeRequest = function getQRCodeRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.qrCode, getHeaders());
}; /**
   * Get notificationSettings
   */var getNotificationSettingsRequest = function getNotificationSettingsRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.notificationSettings, getHeaders());
}; /**
   * Set notificationSettings
   */var setNotificationSettingsRequest = function setNotificationSettingsRequest(notifications) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.notificationSettings, notifications, getHeaders());
}; /**
   * Get Account info
   */var getAccountInfoRequest = function getAccountInfoRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.accountProfile, getHeaders());
}; /**
   * Update Account info
   */var updateAccountInfoRequest = function updateAccountInfoRequest(profile) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.accountProfile, profile, getHeaders());
}; /**
   * Get two Factor status
   */var getTwoFactorRequest = function getTwoFactorRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.twoFactor, getHeaders());
}; /**
   * Update two Factor status
   */var updateTwoFactorMethodsRequest = function updateTwoFactorMethodsRequest(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.twoFactor, params, getHeaders());
}; /**
   * set two Factor status
   */var setTwoFactorRequest = function setTwoFactorRequest(status) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.twoFactorStatus, { status: status }), {}, getHeaders());
}; /**
   * Get Sites
   */var getSitesRequest = function getSitesRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.sites, getHeaders());
}; /**
   * Get followUp
   */var getFollowUpRequest = function getFollowUpRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followUp, { subjectID: subjectID }), getHeaders());
}; /**
   * Get followUps
   */var getFollowUpsRequest = function getFollowUpsRequest(_ref9) {
  var filter_by = _ref9.filter_by,
      page = _ref9.page,
      per_page = _ref9.per_page,
      site_id = _ref9.site_id;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followups, { filter_by: filter_by, page: page, per_page: per_page, site_id: site_id }), getHeaders());
}; /**
   * Create followUp
   */var createFollowUpRequest = function createFollowUpRequest(subjectID, followUp) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followUp, { subjectID: subjectID }), followUp, getHeaders());
}; /**
   * Update followUp
   */var updateFollowUpRequest = function updateFollowUpRequest(subjectID, followUp) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followUp, { subjectID: subjectID }), followUp, getHeaders());
}; /**
   * Lock followUp
   */var lockFollowUpRequest = function lockFollowUpRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followUpLock, { subjectID: subjectID }), {}, getHeaders());
}; /**
   * Unlock followUp
   */var unlockFollowUpRequest = function unlockFollowUpRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.followUpUnlock, { subjectID: subjectID }), {}, getHeaders());
}; /**
   * Get subject
   */var getSubjectRequest = function getSubjectRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + (subjectID ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectID, { subjectID: subjectID }) : api.subjects), getHeaders());
}; /**
   * Delete subject
   */var deleteSubjectRequest = function deleteSubjectRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectID, { subjectID: subjectID }), getHeaders());
}; /**
   * Activate subject
   */var activateSubjectRequest = function activateSubjectRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectActivate, { subjectID: subjectID }), {}, getHeaders());
}; /**
   * Lock subject
   */var lockSubjectRequest = function lockSubjectRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectLock, { subjectID: subjectID }), {}, getHeaders());
}; /**
   * Unlock subject
   */var unlockSubjectRequest = function unlockSubjectRequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectUnlock, { subjectID: subjectID }), {}, getHeaders());
}; /**
   * Update subject
   */var updateSubjectRequest = function updateSubjectRequest(subjectID, profile) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectProfile, { subjectID: subjectID }), profile, getHeaders());
}; /**
   * Create subject
   */var createSubjectRequest = function createSubjectRequest(subjectID, profile) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjectProfile, { subjectID: subjectID }), profile, getHeaders());
}; /**
   * Create registry IDs
   */var createRegistryIDProfileRequest = function createRegistryIDProfileRequest(id, registry) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.createRegistryID, { id: id }), registry, getHeaders());
}; /**
   * Update registry IDs
   */var updateRegistryIDProfileRequest = function updateRegistryIDProfileRequest(id, registry) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateRegistryID, { id: id }), registry, getHeaders());
}; /**
   * Update email status
   */var updateEmailStatusRequest = function updateEmailStatusRequest(id, consent_email_status) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateEmailStatus, { id: id }), { consent_email_status: consent_email_status }, getHeaders());
};var updateConsentGivenRequest = function updateConsentGivenRequest(id, custom_consent_given) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateConsentGiven, { id: id }), { custom_consent_given: custom_consent_given }, getHeaders());
};var updateAdjudicatedConsentStatusRequest = function updateAdjudicatedConsentStatusRequest(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateAdjudicatedConsentStatus, { id: id }), data, getHeaders());
}; /**
   * Get Dashboard data
   */var getDashboardRequest = function getDashboardRequest(_ref10) {
  var filter = _ref10.filter,
      siteCode = _ref10.siteCode,
      start_date = _ref10.start_date,
      end_date = _ref10.end_date;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.dashboard, { filter_by: filter, site_code: siteCode, start_date: start_date, end_date: end_date }), getHeaders());
}; /**
   * Get Saes list by filter
   */var getSAEsListRequest = function getSAEsListRequest(subjectID, siteCode) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saesList, { site_code: siteCode || undefined, subject_id: subjectID || undefined }), getHeaders());
}; /**
   * Get Sae by subjectID
   */var getSAERequest = function getSAERequest(subjectID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecording, { subjectID: subjectID }), getHeaders());
}; /**
   * Create SAE
   */var createSAERequest = function createSAERequest(subjectID, sae) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecording, { subjectID: subjectID }), sae, getHeaders());
}; /**
   * Update SAE
   */var updateSAERequest = function updateSAERequest(subjectID, saeID, sae) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecordingSave, { subjectID: subjectID, saeID: saeID }), sae, getHeaders());
}; /**
   * Delete SAE
   */var deleteSAERequest = function deleteSAERequest(subjectID, saeID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecordingSave, { subjectID: subjectID, saeID: saeID }), getHeaders());
}; /**
   * Lock SAE
   */var lockSAERequest = function lockSAERequest(subjectID, saeID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeLock, { subjectID: subjectID, saeID: saeID }), {}, getHeaders());
}; /**
   * Unlock SAE
   */var unlockSAERequest = function unlockSAERequest(subjectID, saeID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeUnlock, { subjectID: subjectID, saeID: saeID }), {}, getHeaders());
}; /**
   * Delete SAE
   */var toggleActivateSAERequest = function toggleActivateSAERequest(subjectID, saeID, state) {
  return state === 'inactive' ? __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecordingActivation, { subjectID: subjectID, saeID: saeID, status: 'activate' }), {}, getHeaders()) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.saeRecordingActivation, { subjectID: subjectID, saeID: saeID, status: 'deactivate' }), getHeaders());
}; /**
   * Get patients
   */var getPatientsRequest = function getPatientsRequest(_ref11) {
  var page = _ref11.page,
      per_page = _ref11.per_page;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.subjects, { page: page, per_page: per_page }), getHeaders());
}; /**
   * Get documents request
   */var getDocumentsSearchRequest = function getDocumentsSearchRequest(_ref12) {
  var nameSearch = _ref12.nameSearch,
      page = _ref12.page,
      per_page = _ref12.per_page,
      order_column = _ref12.order_column,
      order_direction = _ref12.order_direction,
      filter_by = _ref12.filter_by,
      filter_value = _ref12.filter_value,
      filter_approve = _ref12.filter_approve;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.documentsSearch, { name: nameSearch, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction }), { filter_by: filter_by, filter_value: filter_value, filter_approve: filter_approve }, getHeaders());
}; /**
   * Get documents training request
   */var getDocumentsTrainingSearchRequest = function getDocumentsTrainingSearchRequest(_ref13) {
  var nameSearch = _ref13.nameSearch,
      page = _ref13.page,
      per_page = _ref13.per_page,
      order_column = _ref13.order_column,
      order_direction = _ref13.order_direction;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.documentsTraining, { name: nameSearch, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction }), getHeaders());
}; /**
   * Get documents public request
   */var getDocumentsPublicSearchRequest = function getDocumentsPublicSearchRequest(_ref14) {
  var nameSearch = _ref14.nameSearch,
      page = _ref14.page,
      per_page = _ref14.per_page,
      order_column = _ref14.order_column,
      order_direction = _ref14.order_direction;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.documentsPublic, { name: nameSearch, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction }), getHeaders());
}; /**
   * Get subject request
   */var getSubjectSearchRequest = function getSubjectSearchRequest(_ref15) {
  var subjectID = _ref15.subjectID,
      filter_by = _ref15.filter_by,
      site_code = _ref15.site_code,
      events = _ref15.events,
      event_status = _ref15.event_status,
      order_direction = _ref15.order_direction,
      page = _ref15.page,
      per_page = _ref15.per_page,
      order_column = _ref15.order_column;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(subjectID ? api.subjectID : api.subjects, { subjectID: subjectID, filter_by: filter_by, site_code: site_code, events: events, event_status: event_status, order_direction: order_direction, page: page, per_page: per_page, order_column: order_column }), getHeaders());
}; /**
   * Get settings sites
   */var getSettingsSitesRequest = function getSettingsSitesRequest(_ref16) {
  var nameSearch = _ref16.nameSearch,
      order_column = _ref16.order_column,
      order_direction = _ref16.order_direction;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsSites, { search: nameSearch, order_column: order_column, order_direction: order_direction }), getHeaders());
}; /**
   * Update Site
   */var updateSiteRequest = function updateSiteRequest(siteID, site) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSite, { siteID: siteID }), site, getHeaders());
}; /**
   * Delete Site
   */var deleteSiteRequest = function deleteSiteRequest(siteID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSite, { siteID: siteID }), getHeaders());
}; /**
   * Activate Site
   */var activateSiteRequest = function activateSiteRequest(siteID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activateSite, { siteID: siteID }), {}, getHeaders());
}; /**
   * Create Site
   */var createSiteRequest = function createSiteRequest(site) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.createSite, site, getHeaders());
}; /**
   * Get settings users
   */var getSettingsUsersRequest = function getSettingsUsersRequest(_ref17) {
  var page = _ref17.page,
      per_page = _ref17.per_page,
      order_column = _ref17.order_column,
      order_direction = _ref17.order_direction,
      filter_by = _ref17.filter_by,
      user_id = _ref17.user_id,
      site_code = _ref17.site_code,
      nameSearch = _ref17.nameSearch;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsUsers, { name: nameSearch, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction, filter_by: filter_by, user_id: user_id, site_code: site_code }), getHeaders());
}; /**
   * Get single user
   */var getSettingsUserSingleRequest = function getSettingsUserSingleRequest(userID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.userSingle, { userID: userID }), getHeaders());
}; /**
   * Contact Us
   */var contactUsRequest = function contactUsRequest(payload) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.contactUs, payload, getHeadersRandomize());
}; /**
   * Trial documents
   */var getPublicDocumentsRequest = function getPublicDocumentsRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.publicDocuments, getHeadersRandomize());
}; /**
   * Update User
   */var updateUserRequest = function updateUserRequest(userID, user) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateUser, { userID: userID }), user, getHeaders());
}; /**
   * Delete User
   */var deleteUserRequest = function deleteUserRequest(userID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateUser, { userID: userID }), getHeaders());
}; /**
   * Activate User
   */var activateUserRequest = function activateUserRequest(userID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activateUser, { userID: userID }), {}, getHeaders());
}; /**
   * Create User
   */var createUserRequest = function createUserRequest(user) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.createUser, user, getHeaders());
}; /**
   * Create User Training
   */var createUserTrainingRequest = function createUserTrainingRequest(id, training) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.createUserTraining, { id: id }), training, getHeaders());
}; /**
   * Create User Training Upload
   */var createUserTrainingUploadRequest = function createUserTrainingUploadRequest(id, training) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.createUserTrainingUpload, { id: id }), training, getHeadersFile());
}; /**
   * Create User Training Upload
   */var resetUserTrainingRetriesRequest = function resetUserTrainingRetriesRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.resetUserTrainingRetriesRequest, { id: id }), {}, getHeadersFile());
}; /**
   * Get settings roles
   */var getSettingsRolesRequest = function getSettingsRolesRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.settingsRoles, getHeaders());
}; /**
   * Update Role
   */var updateRoleRequest = function updateRoleRequest(roleID, role) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateRole, { roleID: roleID }), role, getHeaders());
}; /**
   * Create Role
   */var createRoleRequest = function createRoleRequest(role) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.createRole, role, getHeaders());
}; /**
   * Toggle Role activation
   */var toggleActivateRoleRequest = function toggleActivateRoleRequest(roleID, state) {
  return state === 'inactive' ? __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activateRole, { roleID: roleID }), {}, getHeaders()) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateRole, { roleID: roleID }), getHeaders());
}; /**
   * Toggle User Role activation
   */var toggleUserActivateRoleRequest = function toggleUserActivateRoleRequest(userID, roleID, state) {
  return state === 'inactive' ? __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.userRoleSiteActivate, { userID: userID, roleID: roleID }), {}, getHeaders()) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.userRoleSiteDeactivate, { userID: userID, roleID: roleID }), getHeaders());
}; /**
   * Create user role
   */var createUserRoleRequest = function createUserRoleRequest(userID, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.userRoleCreate, { userID: userID }), data, getHeaders());
}; /**
   * Update user role
   */var updateUserRoleRequest = function updateUserRoleRequest(userID, siteID, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.userRoleUpdate, { userID: userID, siteID: siteID }), data, getHeaders());
}; /**
   * Create Document
   */var createDocumentRequest = function createDocumentRequest(document) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.documents, document, getHeaders());
}; /**
   * Create Patient Profile Document
   */var createPatientProfileDocumentRequest = function createPatientProfileDocumentRequest(document) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.patientProfileDocuments, document, getHeaders());
}; /**
   * Update Document
   */var updateDocumentRequest = function updateDocumentRequest(documentID, document) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateDocument, { documentID: documentID }), document, getHeadersFile());
}; /**
   * Update Patient Profile Document
   */var updatePatientProfileDocumentRequest = function updatePatientProfileDocumentRequest(documentID, document) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updatePatientProfileDocument, { documentID: documentID }), document, getHeadersFile());
}; /**
   * Delete Patient Profile Document
   */var deletePatientProfileDocumentRequest = function deletePatientProfileDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.deletePatientProfileDocument, { documentID: documentID }), getHeaders());
}; /**
   * Delete Document
   */var deleteDocumentRequest = function deleteDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateDocument, { documentID: documentID }), getHeaders());
}; /**
   * Activate Document
   */var activateDocumentRequest = function activateDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activateDocument, { documentID: documentID }), {}, getHeaders());
}; /**
   * Activate Patient Profile Document
   */var activatePatientProfileDocumentRequest = function activatePatientProfileDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activatePatientProfileDocument, { documentID: documentID }), {}, getHeaders());
}; /**
   * Approve Document
   */var approveDocumentRequest = function approveDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.approveDocument, { documentID: documentID }), {}, getHeaders());
}; /**
   * Unapprove Document
   */var unapproveDocumentRequest = function unapproveDocumentRequest(documentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.unapproveDocument, { documentID: documentID }), {}, getHeaders());
}; /**
   * Create Consent
   */var getConsentRequest = function getConsentRequest(_ref18) {
  var nameSearch = _ref18.nameSearch,
      stateFilter = _ref18.stateFilter;var params = {};if (nameSearch) {
    params['search'] = nameSearch;
  }if (stateFilter) {
    params['state'] = stateFilter;
  }return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsConsent, params), getHeaders());
}; /**
   * Create Consent
   */var createConsentRequest = function createConsentRequest(consent) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.settingsConsent, consent, getHeaders());
}; /**
   * Update Consent
   */var updateConsentRequest = function updateConsentRequest(consentID, consent) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsConsentUpdate, { consentID: consentID }), consent, getHeaders());
}; /**
   * Delete Consent
   */var deleteConsentRequest = function deleteConsentRequest(consentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsConsentUpdate, { consentID: consentID }), getHeaders());
}; /**
   * Activate Consent
   */var activateConsentRequest = function activateConsentRequest(consentID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsConsentActivate, { consentID: consentID }), {}, getHeaders());
}; /**
   * Get settings general
   */var getSettingsGeneralRequest = function getSettingsGeneralRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.settingsGeneral, getHeaders());
}; /**
   * Create settings
   */var createSettingsGeneralRequest = function createSettingsGeneralRequest(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.settingsGeneral, data, getHeaders());
}; /**
   * Update settings
   */var updateSettingsGeneralRequest = function updateSettingsGeneralRequest(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsGeneralUpdate, { id: id }), data, getHeaders());
}; /**
   * Delete setting
   */var deleteSettingsGeneralRequest = function deleteSettingsGeneralRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsGeneralUpdate, { id: id }), getHeaders());
}; /**
   * Activate setting
   */var activateSettingsGeneralRequest = function activateSettingsGeneralRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.settingsGeneralActivate, { id: id }), {}, getHeaders());
}; /**
   * Get audit logs
   */var getAuditLogsRequest = function getAuditLogsRequest(_ref19) {
  var nameSearch = _ref19.nameSearch,
      page = _ref19.page,
      per_page = _ref19.per_page,
      order_column = _ref19.order_column,
      order_direction = _ref19.order_direction,
      filter_by = _ref19.filter_by,
      filter_value = _ref19.filter_value,
      filter_approve = _ref19.filter_approve;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogsList, { name: nameSearch, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction }), { filter_by: filter_by, filter_value: filter_value, filter_approve: filter_approve }, getHeaders());
}; /**
   * Update audit logs
   */var updateAuditLogsRequest = function updateAuditLogsRequest(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogUpdate, { id: id }), data, getHeaders());
}; /**
   * Activate audit logs
   */var activateAuditLogsRequest = function activateAuditLogsRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogActivate, { id: id }), {}, getHeaders());
}; /**
   * Delete audit logs
   */var deleteAuditLogsRequest = function deleteAuditLogsRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogUpdate, { id: id }), getHeaders());
}; /**
   * Resend email for audit logs
   */var resendAuditLogsRequest = function resendAuditLogsRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogResend, { id: id }), {}, getHeaders());
}; /**
   * Reviewed audit logs
   */var reviewedAuditLogsRequest = function reviewedAuditLogsRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogReviewed, { id: id }), {}, getHeaders());
}; /**
   * Unreviewed audit logs
   */var unreviewedAuditLogsRequest = function unreviewedAuditLogsRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.auditLogUnreviewed, { id: id }), {}, getHeaders());
}; /**
   * Get simulation sites
   */var getSimulationRequest = function getSimulationRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.simulationList, getHeaders());
}; /**
   * Create simulation
   */var createSimulationRequest = function createSimulationRequest(simulation) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.createSimulation, simulation, getHeaders());
}; /**
   * Update simulation
   */var updateSimulationRequest = function updateSimulationRequest(ID, simulation) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSimulation, { ID: ID }), simulation, getHeaders());
}; /**
   * Delete simulation
   */var deleteSimulationRequest = function deleteSimulationRequest(ID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSimulation, { ID: ID }), getHeaders());
}; /**
   * Activate Site
   */var activateSimulationRequest = function activateSimulationRequest(ID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.activateSimulation, { ID: ID }), {}, getHeaders());
}; /**
   * Get training
   */var trainingGetRequest = function trainingGetRequest(_) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.trainingGet, getHeaders());
}; /**
   * Training start
   */var trainingStartRequest = function trainingStartRequest(_) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.trainingStart, {}, getHeaders());
}; /**
   * Training check
   */var trainingCheckRequest = function trainingCheckRequest(_ref20) {
  var token = _ref20.token,
      q_id = _ref20.q_id,
      q_ans = _ref20.q_ans;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.trainingVerify, { token: token }), { q_id: q_id, q_ans: q_ans }, getHeaders());
}; /**
   * Get newsletter request
   */var getNewsletterRequest = function getNewsletterRequest(_ref21) {
  var search = _ref21.search,
      page = _ref21.page,
      per_page = _ref21.per_page,
      order_column = _ref21.order_column,
      order_direction = _ref21.order_direction;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.newsletterList, { search: search, page: page, per_page: per_page, order_column: order_column, order_direction: order_direction }), getHeaders());
}; /**
   * Create Newsletter
   */var createNewsletterRequest = function createNewsletterRequest(newsletter) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.newsletter, newsletter, getHeaders());
}; /**
   * Update Newsletter
   */var updateNewsletterRequest = function updateNewsletterRequest(id, newsletter) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.newsletterByID, { id: id }), newsletter, getHeadersFile());
}; /**
   * Delete Newsletter
   */var deleteNewsletterRequest = function deleteNewsletterRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.newsletterByID, { id: id }), getHeadersFile());
}; /**
   * Activate Newsletter
   */var activateNewsletterRequest = function activateNewsletterRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.newsletterActivateByID, { id: id }), {}, getHeadersFile());
}; /**
   * Send Newsletter
   */var sendNewsletterRequest = function sendNewsletterRequest(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.newsletterSendByID, { id: id }), {}, getHeadersFile());
}; /**
   * Upload Newsletter Image
   */var uploadNewsletterImage = function uploadNewsletterImage(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.newsletterUploadImage, data, getHeadersFile());
}; /**
   * Activate Site Randomization
   */var activateSiteRandomizationRequest = function activateSiteRandomizationRequest(siteID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSiteRandomization, { siteID: siteID }), {}, getHeaders());
}; /**
   * Delete Site Randomization
   */var deleteSiteRandomizationRequest = function deleteSiteRandomizationRequest(siteID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateSiteRandomization, { siteID: siteID }), getHeaders());
}; /**
   * get Roles minimal
   */var getRolesLight = function getRolesLight() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.rolesLight, getHeaders());
}; /**
   * get Users minimal
   */var getUsersLight = function getUsersLight() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.usersLight, getHeaders());
}; /**
   * get Bulk Site Roles
   */var getUserSites = function getUserSites(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.bulkUserSites, { id: id }), getHeaders());
}; /**
   * copy Bulk User Permissions
   */var copyBulkUserPermissions = function copyBulkUserPermissions(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.bulkUserCopyPermission, data, getHeaders());
}; /**
   * get Bulk Sites
   */var getBulkSites = function getBulkSites() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + api.bulkSites, getHeaders());
}; /**
   * get Bulk Site Roles
   */var getBulkSiteRoles = function getBulkSiteRoles(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.bulkSiteRoles, { id: id }), getHeaders());
}; /**
   * copy Bulk Site Permissions
   */var copyBulkSitePermissions = function copyBulkSitePermissions(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.bulkSiteCopyPermission, data, getHeaders());
};var copyBulkSiteChangePermissions = function copyBulkSiteChangePermissions(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + api.bulkUserChangePermission, data, getHeaders());
}; /**
   * Reporting get
   */var getFileReporting = function getFileReporting(type, format) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl() + '/admin/reports/' + type + '?format=' + format, getHeaders());
}; /**
   * Reporting by depot
   */var getFileReportingByDepot = function getFileReportingByDepot(type, format) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl() + '/admin/reports/drug_by_depot?format=' + format, getHeaders());
};var getAccountProfileId = function getAccountProfileId(password) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + api.accountProfileId, { password: password }, getHeaders());
};var getPrivateFileLinkRequest = function getPrivateFileLinkRequest(_ref22) {
  var url = _ref22.url;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.privateDocument), { url: url }, getHeaders());
};var createCoenrollmentProfileRequest = function createCoenrollmentProfileRequest(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.createCoenrollmentID, { id: id }), data, getHeaders());
};var updateCoenrollmentProfileRequest = function updateCoenrollmentProfileRequest(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('' + apiUrl() + Object(__WEBPACK_IMPORTED_MODULE_1__utils_url__["a" /* withParams */])(api.updateCoenrollmentID, { id: id }), data, getHeaders());
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfigConsumer", {
  enumerable: true,
  get: function get() {
    return _context.ConfigConsumer;
  }
});
exports["default"] = exports.configConsumerProps = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _localeProvider = _interopRequireWildcard(__webpack_require__(790));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _context = __webpack_require__(793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
exports.configConsumerProps = configConsumerProps;

var ConfigProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  function ConfigProvider() {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).apply(this, arguments));

    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
      var _this$props$prefixCls = _this.props.prefixCls,
          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };

    _this.renderProvider = function (context, legacyLocale) {
      var _this$props = _this.props,
          children = _this$props.children,
          getPopupContainer = _this$props.getPopupContainer,
          renderEmpty = _this$props.renderEmpty,
          csp = _this$props.csp,
          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
          locale = _this$props.locale,
          pageHeader = _this$props.pageHeader;

      var config = _extends(_extends({}, context), {
        getPrefixCls: _this.getPrefixCls,
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton
      });

      if (getPopupContainer) {
        config.getPopupContainer = getPopupContainer;
      }

      if (renderEmpty) {
        config.renderEmpty = renderEmpty;
      }

      if (pageHeader) {
        config.pageHeader = pageHeader;
      }

      return React.createElement(_context.ConfigContext.Provider, {
        value: config
      }, React.createElement(_localeProvider["default"], {
        locale: locale || legacyLocale,
        _ANT_MARK__: _localeProvider.ANT_MARK
      }, children));
    };

    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
        return React.createElement(_context.ConfigConsumer, null, function (context) {
          return _this2.renderProvider(context, legacyLocale);
        });
      });
    }
  }]);

  return ConfigProvider;
}(React.Component);

var _default = ConfigProvider;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(107);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(244);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _group["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _radioButton["default"];
  }
});
exports["default"] = void 0;

var _radio = _interopRequireDefault(__webpack_require__(314));

var _group = _interopRequireDefault(__webpack_require__(1234));

var _radioButton = _interopRequireDefault(__webpack_require__(1235));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_radio["default"].Button = _radioButton["default"];
_radio["default"].Group = _group["default"];
var _default = _radio["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1231);
//# sourceMappingURL=index.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1458);
//# sourceMappingURL=index.js.map


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var _rcAnimate = _interopRequireDefault(__webpack_require__(90));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(461));

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function noop() {}

var Alert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).call(this, props));

    _this.handleClose = function (e) {
      e.preventDefault();
      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
      // 重复一次后才能正确设置 height

      dom.style.height = "".concat(dom.offsetHeight, "px");

      _this.setState({
        closing: true
      });

      (_this.props.onClose || noop)(e);
    };

    _this.animationEnd = function () {
      _this.setState({
        closing: false,
        closed: true
      });

      (_this.props.afterClose || noop)();
    };

    _this.renderAlert = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          description = _this$props.description,
          customizePrefixCls = _this$props.prefixCls,
          message = _this$props.message,
          closeText = _this$props.closeText,
          banner = _this$props.banner,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          style = _this$props.style,
          icon = _this$props.icon;
      var _this$props2 = _this.props,
          closable = _this$props2.closable,
          type = _this$props2.type,
          showIcon = _this$props2.showIcon,
          iconType = _this$props2.iconType;
      var _this$state = _this.state,
          closing = _this$state.closing,
          closed = _this$state.closed;
      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon

      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告

      type = banner && type === undefined ? 'warning' : type || 'info';
      var iconTheme = 'filled';

      if (!iconType) {
        switch (type) {
          case 'success':
            iconType = 'check-circle';
            break;

          case 'info':
            iconType = 'info-circle';
            break;

          case 'error':
            iconType = 'close-circle';
            break;

          case 'warning':
            iconType = 'exclamation-circle';
            break;

          default:
            iconType = 'default';
        } // use outline icon in alert with description


        if (description) {
          iconTheme = 'outlined';
        }
      } // closeable when closeText is assigned


      if (closeText) {
        closable = true;
      }

      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
      var closeIcon = closable ? React.createElement("button", {
        type: "button",
        onClick: _this.handleClose,
        className: "".concat(prefixCls, "-close-icon"),
        tabIndex: 0
      }, closeText ? React.createElement("span", {
        className: "".concat(prefixCls, "-close-text")
      }, closeText) : React.createElement(_icon["default"], {
        type: "close"
      })) : null;
      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
      var iconNode = icon && (React.isValidElement(icon) ? React.cloneElement(icon, {
        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
      }) : React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon)) || React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: iconType,
        theme: iconTheme
      });
      return closed ? null : React.createElement(_rcAnimate["default"], {
        component: "",
        showProp: "data-show",
        transitionName: "".concat(prefixCls, "-slide-up"),
        onEnd: _this.animationEnd
      }, React.createElement("div", _extends({
        "data-show": !closing,
        className: alertCls,
        style: style
      }, dataOrAriaProps), showIcon ? iconNode : null, React.createElement("span", {
        className: "".concat(prefixCls, "-message")
      }, message), React.createElement("span", {
        className: "".concat(prefixCls, "-description")
      }, description), closeIcon));
    };

    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
    _this.state = {
      closing: false,
      closed: false
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert);
    }
  }]);

  return Alert;
}(React.Component);

exports["default"] = Alert;
//# sourceMappingURL=index.js.map


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_SIGN_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginTwoFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAccountInfo; });
/* unused harmony export setAccountProfileId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_requests__ = __webpack_require__(29);


var _this = this;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}var USER_UPDATE = 'USER_UPDATE';var USER_SIGN_OUT = 'USER_SIGN_OUT';var login = function login(_ref) {
  var username = _ref.username,
      password = _ref.password;return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.prev = 0;_context.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["_29" /* loginRequest */])({ username: username, password: password });case 3:
              response = _context.sent;if (__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token')) {
                window.localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'));setPermissions(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'))(dispatch);setAccountInfo(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'))(dispatch);
              }return _context.abrupt('return', response);case 8:
              _context.prev = 8;_context.t0 = _context['catch'](0);throw new Error(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_context.t0, 'response.data.error'));case 11:case 'end':
              return _context.stop();}
        }
      }, _callee, _this, [[0, 8]]);
    }));return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};var loginTwoFactor = function loginTwoFactor(_ref3) {
  var username = _ref3.username,
      password = _ref3.password,
      code = _ref3.code;return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["_30" /* loginTwoFactorRequest */])({ username: username, password: password, code: code });case 3:
              response = _context2.sent;window.localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'));setPermissions(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'))(dispatch);setAccountInfo(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.access_token'))(dispatch); // dispatch(({ type: USER_UPDATE, payload: { token: get(response, 'data.access_token') } }));
              return _context2.abrupt('return', response);case 10:
              _context2.prev = 10;_context2.t0 = _context2['catch'](0);throw new Error(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_context2.t0, 'response.data.error'));case 13:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this, [[0, 10]]);
    }));return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};var setPermissions = function setPermissions(token) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      var _ref6, data, permissions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              _context3.prev = 0;_context3.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["_8" /* getPermissionsRequest */])();case 3:
              _ref6 = _context3.sent;data = _ref6.data;permissions = data.filter(function (permission) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(permission, 'state') === 'active';
              });dispatch({ type: USER_UPDATE, payload: { token: token, permissions: permissions } });return _context3.abrupt('return', token);case 10:
              _context3.prev = 10;_context3.t0 = _context3['catch'](0);if ([401, 422].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_context3.t0, 'response.status'))) {
                logoutHandle(dispatch);
              } // throw new Error(get(e, 'response.data.error'));
            case 13:case 'end':
              return _context3.stop();}
        }
      }, _callee3, _this, [[0, 10]]);
    }));return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};var setAccountInfo = function setAccountInfo(token) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch) {
      var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {case 0:
              _context4.prev = 0;_context4.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["S" /* getAccountInfoRequest */])();case 3:
              response = _context4.sent;dispatch({ type: USER_UPDATE, payload: { token: token, info: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data') } });return _context4.abrupt('return', token);case 8:
              _context4.prev = 8;_context4.t0 = _context4['catch'](0);if ([401, 422].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_context4.t0, 'response.status'))) {
                logoutHandle(dispatch);
              } // throw new Error(get(e, 'response.data.error'));
            case 11:case 'end':
              return _context4.stop();}
        }
      }, _callee4, _this, [[0, 8]]);
    }));return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};var setAccountProfileId = function setAccountProfileId(password) {
  return function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch) {
      var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {case 0:
              _context5.prev = 0;_context5.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["T" /* getAccountProfileId */])(password);case 3:
              response = _context5.sent;dispatch({ type: USER_UPDATE, payload: { profileId: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(response, 'data.user_id') } });_context5.next = 10;break;case 7:
              _context5.prev = 7;_context5.t0 = _context5['catch'](0);if ([401, 422].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_context5.t0, 'response.status'))) {
                logoutHandle(dispatch);
              } // throw new Error(get(e, 'response.data.error'));
            case 10:case 'end':
              return _context5.stop();}
        }
      }, _callee5, _this, [[0, 7]]);
    }));return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
};var logoutHandle = function logoutHandle(dispatch) {
  window.localStorage.removeItem('token');dispatch({ type: USER_SIGN_OUT });
};var logout = function logout() {
  return function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {case 0:
              _context6.prev = 0;_context6.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["_31" /* logoutRequest */])();case 3:
              logoutHandle(dispatch);_context6.next = 9;break;case 6:
              _context6.prev = 6;_context6.t0 = _context6['catch'](0);logoutHandle(dispatch);case 9:case 'end':
              return _context6.stop();}
        }
      }, _callee6, _this, [[0, 6]]);
    }));return function (_x6) {
      return _ref9.apply(this, arguments);
    };
  }();
};var resetPassword = function resetPassword(_ref10) {
  var username = _ref10.username;return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {case 0:
            return _context7.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_2__api_requests__["_36" /* resetPasswordRequest */])({ username: username }));case 1:case 'end':
            return _context7.stop();}
      }
    }, _callee7, _this);
  }));
}; //export const logout = () => async (dispatch, getState) => {
// console.log(getUserToken(getState()));
// try {
//   return await loginRequest({ username, password });
//   // dispatch(({ type: USER_UPDATE, payload: { token } }));
//   // return token;
// } catch (e) {
//   return e;
// }
// export const signOut = () => dispatch => dispatch(({ type: USER_SIGN_OUT }));

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDashboardPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDashboardFollowUp90dPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDashboardReadEnrolmentBySitePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDashboardEnrolmentStagesPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getDashboardReadSAEPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDashboardReadDeviationPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getPatientProfileReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getPatientProfileReadRestrictedPermission; });
/* unused harmony export getPatientProfileCreatePermission */
/* unused harmony export getPatientProfileUpdatePermission */
/* unused harmony export getPatientProfileDeletePermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getPatientProfileLockPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getPatientProfileUnlockPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getPatientProfileCreatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getPatientProfileUpdatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getPatientProfileDeletePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getSAEReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getSAECreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getSAEUpdatePermission; });
/* unused harmony export getSAEDeletePermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getSAELockPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getSAEUnlockPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getSAECentralCommentsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getSAECentralCommentsUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getSAETermCodesViewPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getSAETermCodesUpdatePermission; });
/* unused harmony export getSAECreatePermissionBySite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getSAEUpdatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getSAEDeletePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getFollowUp90dReadPermission; });
/* unused harmony export getFollowUp90dCreatePermission */
/* unused harmony export getFollowUp90dUpdatePermission */
/* unused harmony export getFollowUp90dDeletePermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getFollowUp90dCreatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getFollowUp90dUpdatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getFollowUp90dLockPermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getFollowUp90dUnlockPermissionBySite; });
/* unused harmony export getFollowUp90dDeletePermissionBySite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return getTwoFactorReadPermission; });
/* unused harmony export getTwoFactorCreatePermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return getTwoFactorUpdatePermission; });
/* unused harmony export getTwoFactorDeletePermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdminSettingsPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return getSiteReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return getUserReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return getSiteCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return getSiteDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return getSiteUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return getSiteUpdatePermissionBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return getUserCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getUserUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return getUserDeletePermission; });
/* unused harmony export getUserUpdatePermissionBySite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getRoleCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getRoleUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getRoleReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getRoleDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getPatientDocumentCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getDocumentCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getDocumentUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getDocumentReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getDocumentDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getDocumentApprovePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getDocumentUnapprovePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getDocumentTrainingReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getDocumentValidationReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getDocumentPublicReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getDocumentGeneralReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getDocumentGeneralPrivateReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getDocumentPerSiteReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getNewsletterCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getNewsletterReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getNewsletterUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getNewsletterDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getConsentCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getConsentUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getConsentReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getConsentDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getGeneralSettingsCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getGeneralSettingsUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getGeneralSettingsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getGeneralSettingsDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getNotificationRandomizationSummaryPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getNotificationRandomizationClosedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getNotificationRandomizationDetailedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getNotificationConsentPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getNotificationValidateRandomizationPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getNotificationValidationDiffersFromRandomizationPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getNotificationValidationSaeOccurredPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getNotification2DayReminderPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getNotification7DayReminderPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getNotificationReportSummaryPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getNotificationNewUserWelcomePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getNotificationNewUserPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getNotificationNewSitePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getNotificationSuspendedSitePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getNotificationDeathPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getNotification90DayFollowUpCompletedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getNotification90DayDeviationOccurredPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getNotificationDocumentPendingApprovalPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getNotificationDocumentDocumentApprovedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getNotificationTrainingCompletedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getNotificationNewsletterPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getNotificationSiteRandomizationStatusChangedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getNotificationDocumentExpirePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getNotificationConsentMissingReportPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getNotificationUserStatusChangedPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuditLogReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAuditLogUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuditLogDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAuditLogReviewPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return getSimulationReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getSimulationCreatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return getSimulationUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return getSimulationDeletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return getUserTrainingReadPermission; });
/* unused harmony export getUserTrainingStartPermission */
/* unused harmony export getUserTrainingVerifyPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return getUserTrainingResetPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConsentGivenUpdatePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return getUserInfo; });
/* unused harmony export getUserProfileId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return getUserTimezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return getUserShortTimezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getReportsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getReportsSitesReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getReportsUsersReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getReportsSubjectsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getReportsSaeReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getReportsDeviationsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getReportsConsentReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getReportsDeathReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getReportsBlindedAllocationsReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getReportsCombinedReadPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getReportsFollowUpReadPermission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


var getUser = function getUser(state) {
  return state.user;
};var getUserToken = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'token');
});var getDashboardPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_read');
  });
});var getDashboardFollowUp90dPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_90d_follow_ups');
  });
});var getDashboardReadEnrolmentBySitePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_read_enrolment_by_site');
  });
});var getDashboardEnrolmentStagesPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_read_enrolment_stages');
  });
});var getDashboardReadSAEPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_read_sae');
  });
});var getDashboardReadDeviationPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.dashboard_read_deviation');
  });
});var getPatientProfileReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_read');
  });
});var getPatientProfileReadRestrictedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_read_restricted');
  });
});var getPatientProfileCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_create');
  });
});var getPatientProfileUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_update');
  });
});var getPatientProfileDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_delete');
  });
});var getPatientProfileLockPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_lock');
  });
});var getPatientProfileUnlockPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_profile_unlock');
  });
});var getPatientProfileCreatePermissionBySite = function getPatientProfileCreatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.patient_profile_create');
  });
};var getPatientProfileUpdatePermissionBySite = function getPatientProfileUpdatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.patient_profile_update');
  });
};var getPatientProfileDeletePermissionBySite = function getPatientProfileDeletePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.patient_profile_delete');
  });
};var getSAEReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_read');
  });
});var getSAECreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_create');
  });
});var getSAEUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_update');
  });
});var getSAEDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_delete');
  });
});var getSAELockPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_lock');
  });
});var getSAEUnlockPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_unlock');
  });
});var getSAECentralCommentsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.central_sae_comments_read');
  });
});var getSAECentralCommentsUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.central_sae_comments_update');
  });
});var getSAETermCodesViewPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_term_codes_view');
  });
});var getSAETermCodesUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.sae_term_codes_update');
  });
});var getSAECreatePermissionBySite = function getSAECreatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.sae_create');
  });
};var getSAEUpdatePermissionBySite = function getSAEUpdatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.sae_update');
  });
};var getSAEDeletePermissionBySite = function getSAEDeletePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.sae_delete');
  });
};var getFollowUp90dReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.follow_up_90d_read');
  });
});var getFollowUp90dCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.follow_up_90d_create');
  });
});var getFollowUp90dUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.follow_up_90d_update');
  });
});var getFollowUp90dDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.follow_up_90d_delete');
  });
});var getFollowUp90dCreatePermissionBySite = function getFollowUp90dCreatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.follow_up_90d_create');
  });
};var getFollowUp90dUpdatePermissionBySite = function getFollowUp90dUpdatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.follow_up_90d_update');
  });
};var getFollowUp90dLockPermissionBySite = function getFollowUp90dLockPermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.follow_up_90d_lock');
  });
};var getFollowUp90dUnlockPermissionBySite = function getFollowUp90dUnlockPermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.follow_up_90d_unlock');
  });
};var getFollowUp90dDeletePermissionBySite = function getFollowUp90dDeletePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.follow_up_90d_delete');
  });
};var getTwoFactorReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.two_factor_read');
  });
});var getTwoFactorCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.two_factor_create');
  });
});var getTwoFactorUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.two_factor_update');
  });
});var getTwoFactorDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.two_factor_delete');
  });
});var getAdminSettingsPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.admin_settings');
  });
});var getSiteReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.site_read');
  });
});var getUserReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_read');
  });
});var getSiteCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.site_create');
  });
});var getSiteDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.site_delete');
  });
});var getSiteUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.site_update');
  });
});var getSiteUpdatePermissionBySite = function getSiteUpdatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.site_update');
  });
};var getUserCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_create');
  });
});var getUserUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_update');
  });
});var getUserDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_delete');
  });
});var getUserUpdatePermissionBySite = function getUserUpdatePermissionBySite(siteID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).find(function (item) {
      return item.site_id === siteID;
    }), 'user_role.user_update');
  });
};var getRoleCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.role_create');
  });
});var getRoleUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.role_update');
  });
});var getRoleReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.role_read');
  });
});var getRoleDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.role_delete');
  });
});var getPatientDocumentCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.patient_document_create');
  });
});var getDocumentCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_create');
  });
});var getDocumentUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_update');
  });
});var getDocumentReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_read');
  });
});var getDocumentDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_delete');
  });
});var getDocumentApprovePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_approve');
  });
});var getDocumentUnapprovePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_unapprove');
  });
});var getDocumentTrainingReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_training_access');
  });
});var getDocumentValidationReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_validation_access');
  });
});var getDocumentPublicReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_public_access');
  });
});var getDocumentGeneralReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_general_access');
  });
});var getDocumentGeneralPrivateReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_general_private_access');
  });
});var getDocumentPerSiteReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.document_per_site_access');
  });
});var getNewsletterCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.newsletter_create');
  });
});var getNewsletterReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.newsletter_read');
  });
});var getNewsletterUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.newsletter_update');
  });
});var getNewsletterDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.newsletter_delete');
  });
});var getConsentCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.consent_setting_create');
  });
});var getConsentUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.consent_setting_update');
  });
});var getConsentReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.consent_setting_read');
  });
});var getConsentDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.consent_setting_delete');
  });
});var getGeneralSettingsCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.general_setting_create');
  });
});var getGeneralSettingsUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.general_setting_update');
  });
});var getGeneralSettingsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.general_setting_read');
  });
});var getGeneralSettingsDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.general_setting_delete');
  });
});var getNotificationRandomizationSummaryPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_randomization_summary');
  });
});var getNotificationRandomizationClosedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_randomization_closed');
  });
});var getNotificationRandomizationDetailedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_randomization_detailed');
  });
});var getNotificationConsentPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_consent');
  });
});var getNotificationValidateRandomizationPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_validate_randomization');
  });
});var getNotificationValidationDiffersFromRandomizationPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_validation_differs_from_randomization');
  });
});var getNotificationValidationSaeOccurredPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_validation_sae_occurred');
  });
});var getNotification2DayReminderPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_2_day_reminder');
  });
});var getNotification7DayReminderPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_7_day_reminder');
  });
});var getNotificationReportSummaryPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.report_subject_summary');
  });
});var getNotificationNewUserWelcomePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_new_user_welcome');
  });
});var getNotificationNewUserPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_new_user');
  });
});var getNotificationNewSitePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_new_site');
  });
});var getNotificationSuspendedSitePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_suspended_site');
  });
});var getNotificationDeathPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_death');
  });
});var getNotification90DayFollowUpCompletedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_90_day_follow_up_completed');
  });
});var getNotification90DayDeviationOccurredPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_90_day_deviation_occurred');
  });
});var getNotificationDocumentPendingApprovalPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_document_pending_approval');
  });
});var getNotificationDocumentDocumentApprovedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_document_document_approved');
  });
});var getNotificationTrainingCompletedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_training_completed');
  });
});var getNotificationNewsletterPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_newsletter');
  });
});var getNotificationSiteRandomizationStatusChangedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_site_randomization_status_changed');
  });
});var getNotificationDocumentExpirePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_document_expire');
  });
});var getNotificationConsentMissingReportPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_consent_missing_report');
  });
});var getNotificationUserStatusChangedPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.notification_user_status_changed');
  });
});var getAuditLogReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.audit_log_read');
  });
});var getAuditLogUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.audit_log_edit');
  });
});var getAuditLogDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.audit_log_delete');
  });
});var getAuditLogReviewPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.audit_log_review');
  });
});var getSimulationReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.simulation_read');
  });
});var getSimulationCreatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.simulation_create');
  });
});var getSimulationUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.simulation_update');
  });
});var getSimulationDeletePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.simulation_delete');
  });
});var getUserTrainingReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_training_read');
  });
});var getUserTrainingStartPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_training_start');
  });
});var getUserTrainingVerifyPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_training_verify');
  });
});var getUserTrainingResetPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.user_training_reset');
  });
});var getConsentGivenUpdatePermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.consent_given_update');
  });
});var getUserInfo = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'info', {});
});var getUserProfileId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'profileId', {});
});var getUserTimezone = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'info.time_zone', null);
});var getUserShortTimezone = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'info.short_tz', null);
});var getReportsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_read');
  });
});var getReportsSitesReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_sites_read');
  });
});var getReportsUsersReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_users_read');
  });
});var getReportsSubjectsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_subjects_read');
  });
});var getReportsSaeReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_sae_read');
  });
});var getReportsDeviationsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_deviations_read');
  });
});var getReportsConsentReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_consent_read');
  });
});var getReportsDeathReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_death_read');
  });
});var getReportsBlindedAllocationsReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_blinded_allocations_read');
  });
});var getReportsCombinedReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_combined_read');
  });
});var getReportsFollowUpReadPermission = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUser, function (user) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(user, 'permissions', []).some(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, 'user_role.reports_follow_up_read');
  });
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__randomize_services__ = __webpack_require__(900);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__randomize_services__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consent_services__ = __webpack_require__(902);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__consent_services__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__consent_services__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__consent_services__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_services__ = __webpack_require__(903);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__validation_services__["a"]; });




/***/ }),
/* 40 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(805);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(891);
//# sourceMappingURL=index.js.map


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(429));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultDuration = 3;
var defaultTop;
var messageInstance;
var key = 1;
var prefixCls = 'ant-message';
var transitionName = 'move-up';
var getContainer;
var maxCount;

function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }

    messageInstance = instance;
    callback(instance);
  });
}

function notice(args) {
  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var iconType = {
    info: 'info-circle',
    success: 'check-circle',
    error: 'close-circle',
    warning: 'exclamation-circle',
    loading: 'loading'
  }[args.type];
  var target = args.key || key++;
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      return resolve(true);
    };

    getMessageInstance(function (instance) {
      var iconNode = React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      });
      var switchIconNode = iconType ? iconNode : '';
      instance.notice({
        key: target,
        duration: duration,
        style: {},
        content: React.createElement("div", {
          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
        }, args.icon ? args.icon : switchIconNode, React.createElement("span", null, args.content)),
        onClose: callback
      });
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
}

function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}

var api = {
  open: notice,
  config: function config(options) {
    if (options.top !== undefined) {
      defaultTop = options.top;
      messageInstance = null; // delete messageInstance for new defaultTop
    }

    if (options.duration !== undefined) {
      defaultDuration = options.duration;
    }

    if (options.prefixCls !== undefined) {
      prefixCls = options.prefixCls;
    }

    if (options.getContainer !== undefined) {
      getContainer = options.getContainer;
    }

    if (options.transitionName !== undefined) {
      transitionName = options.transitionName;
      messageInstance = null; // delete messageInstance for new transitionName
    }

    if (options.maxCount !== undefined) {
      maxCount = options.maxCount;
      messageInstance = null;
    }
  },
  destroy: function destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};
['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
  api[type] = function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return api.open(_extends(_extends({}, content), {
        type: type
      }));
    }

    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return api.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
});
api.warn = api.warning;
var _default = api;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(786);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(787);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Checkbox = _interopRequireDefault(__webpack_require__(504));

var _Group = _interopRequireDefault(__webpack_require__(1248));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Checkbox["default"].Group = _Group["default"];
var _default = _Checkbox["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1246);
//# sourceMappingURL=index.js.map


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1085);

__webpack_require__(468);

__webpack_require__(63);
//# sourceMappingURL=index.js.map


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Upload = _interopRequireDefault(__webpack_require__(469));

var _Dragger = _interopRequireDefault(__webpack_require__(1197));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Upload["default"].Dragger = _Dragger["default"];
var _default = _Upload["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(12),__webpack_require__(0),__webpack_require__(1199),__webpack_require__(1200)):"function"==typeof define&&define.amd?define(["prop-types","react","signature_pad","trim-canvas"],t):"object"==typeof exports?exports.SignatureCanvas=t(require("prop-types"),require("react"),require("signature_pad"),require("trim-canvas")):e.SignatureCanvas=t(e["prop-types"],e.react,e.signature_pad,e["trim-canvas"])}(this,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0,g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas()},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear()}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps())}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){e.exports=r}])});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(383);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSENT_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consentUpdate; });


var CONSENT_UPDATE = 'CONSENT_UPDATE';var consentUpdate = function consentUpdate(consent) {
  return function (dispatch) {
    dispatch({ type: CONSENT_UPDATE, payload: { data: consent } });
  };
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1797);
//# sourceMappingURL=index.js.map


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcAnimate = _interopRequireDefault(__webpack_require__(90));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _ScrollNumber = _interopRequireDefault(__webpack_require__(1799));

var _colors = __webpack_require__(466);

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function isPresetColor(color) {
  return _colors.PresetColorTypes.indexOf(color) !== -1;
}

var Badge =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Badge, _React$Component);

  function Badge() {
    var _this;

    _classCallCheck(this, Badge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Badge).apply(this, arguments));

    _this.renderBadge = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls,
          children = _a.children,
          status = _a.status,
          text = _a.text,
          color = _a.color,
          restProps = __rest(_a, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color"]);

      var omitArr = ['count', 'showZero', 'overflowCount', 'className', 'style', 'dot', 'offset', 'title'];
      var prefixCls = getPrefixCls('badge', customizePrefixCls);
      var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);

      var scrollNumber = _this.renderBadgeNumber(prefixCls, scrollNumberPrefixCls);

      var statusText = _this.renderStatusText(prefixCls);

      var statusCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-status-dot"), _this.hasStatus()), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames));
      var statusStyle = {};

      if (color && !isPresetColor(color)) {
        statusStyle.background = color;
      } // <Badge status="success" />


      if (!children && _this.hasStatus()) {
        var styleWithOffset = _this.getStyleWithOffset();

        var statusTextColor = styleWithOffset && styleWithOffset.color;
        return React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
          className: _this.getBadgeClassName(prefixCls),
          style: styleWithOffset
        }), React.createElement("span", {
          className: statusCls,
          style: statusStyle
        }), React.createElement("span", {
          style: {
            color: statusTextColor
          },
          className: "".concat(prefixCls, "-status-text")
        }, text));
      }

      return React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
        className: _this.getBadgeClassName(prefixCls)
      }), children, React.createElement(_rcAnimate["default"], {
        component: "",
        showProp: "data-show",
        transitionName: children ? "".concat(prefixCls, "-zoom") : '',
        transitionAppear: true
      }, scrollNumber), statusText);
    };

    return _this;
  }

  _createClass(Badge, [{
    key: "getNumberedDispayCount",
    value: function getNumberedDispayCount() {
      var _this$props = this.props,
          count = _this$props.count,
          overflowCount = _this$props.overflowCount;
      var displayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
      return displayCount;
    }
  }, {
    key: "getDispayCount",
    value: function getDispayCount() {
      var isDot = this.isDot(); // dot mode don't need count

      if (isDot) {
        return '';
      }

      return this.getNumberedDispayCount();
    }
  }, {
    key: "getScrollNumberTitle",
    value: function getScrollNumberTitle() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          count = _this$props2.count;

      if (title) {
        return title;
      }

      return typeof count === 'string' || typeof count === 'number' ? count : undefined;
    }
  }, {
    key: "getStyleWithOffset",
    value: function getStyleWithOffset() {
      var _this$props3 = this.props,
          offset = _this$props3.offset,
          style = _this$props3.style;
      return offset ? _extends({
        right: -parseInt(offset[0], 10),
        marginTop: offset[1]
      }, style) : style;
    }
  }, {
    key: "getBadgeClassName",
    value: function getBadgeClassName(prefixCls) {
      var _classNames2;

      var _this$props4 = this.props,
          className = _this$props4.className,
          children = _this$props4.children;
      return (0, _classnames["default"])(className, prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-status"), this.hasStatus()), _defineProperty(_classNames2, "".concat(prefixCls, "-not-a-wrapper"), !children), _classNames2));
    }
  }, {
    key: "hasStatus",
    value: function hasStatus() {
      var _this$props5 = this.props,
          status = _this$props5.status,
          color = _this$props5.color;
      return !!status || !!color;
    }
  }, {
    key: "isZero",
    value: function isZero() {
      var numberedDispayCount = this.getNumberedDispayCount();
      return numberedDispayCount === '0' || numberedDispayCount === 0;
    }
  }, {
    key: "isDot",
    value: function isDot() {
      var dot = this.props.dot;
      var isZero = this.isZero();
      return dot && !isZero || this.hasStatus();
    }
  }, {
    key: "isHidden",
    value: function isHidden() {
      var showZero = this.props.showZero;
      var displayCount = this.getDispayCount();
      var isZero = this.isZero();
      var isDot = this.isDot();
      var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
      return (isEmpty || isZero && !showZero) && !isDot;
    }
  }, {
    key: "renderStatusText",
    value: function renderStatusText(prefixCls) {
      var text = this.props.text;
      var hidden = this.isHidden();
      return hidden || !text ? null : React.createElement("span", {
        className: "".concat(prefixCls, "-status-text")
      }, text);
    }
  }, {
    key: "renderDispayComponent",
    value: function renderDispayComponent() {
      var count = this.props.count;
      var customNode = count;

      if (!customNode || _typeof(customNode) !== 'object') {
        return undefined;
      }

      return React.cloneElement(customNode, {
        style: _extends(_extends({}, this.getStyleWithOffset()), customNode.props && customNode.props.style)
      });
    }
  }, {
    key: "renderBadgeNumber",
    value: function renderBadgeNumber(prefixCls, scrollNumberPrefixCls) {
      var _classNames3;

      var _this$props6 = this.props,
          status = _this$props6.status,
          count = _this$props6.count,
          color = _this$props6.color;
      var displayCount = this.getDispayCount();
      var isDot = this.isDot();
      var hidden = this.isHidden();
      var scrollNumberCls = (0, _classnames["default"])((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple-words"), !isDot && count && count.toString && count.toString().length > 1), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames3));
      var statusStyle = this.getStyleWithOffset();

      if (color && !isPresetColor(color)) {
        statusStyle = statusStyle || {};
        statusStyle.background = color;
      }

      return hidden ? null : React.createElement(_ScrollNumber["default"], {
        prefixCls: scrollNumberPrefixCls,
        "data-show": !hidden,
        className: scrollNumberCls,
        count: displayCount,
        displayComponent: this.renderDispayComponent() // <Badge status="success" count={<Icon type="xxx" />}></Badge>
        ,
        title: this.getScrollNumberTitle(),
        style: statusStyle,
        key: "scrollNumber"
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderBadge);
    }
  }]);

  return Badge;
}(React.Component);

exports["default"] = Badge;
Badge.defaultProps = {
  count: null,
  showZero: false,
  dot: false,
  overflowCount: 99
};
Badge.propTypes = {
  count: PropTypes.node,
  showZero: PropTypes.bool,
  dot: PropTypes.bool,
  overflowCount: PropTypes.number
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "resetWarned", {
  enumerable: true,
  get: function get() {
    return _warning.resetWarned;
  }
});
exports["default"] = void 0;

var _warning = _interopRequireWildcard(__webpack_require__(189));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(valid, component, message) {
  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
};

exports["default"] = _default;
//# sourceMappingURL=warning.js.map


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConsentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(403);


 // import get from 'lodash/get';
var getConsent = function getConsent(state) {
  return state.consent;
};var getConsentData = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getConsent, function (consent) {
  return consent.data;
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_dropdown_style__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_dropdown__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_red_white_png__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_red_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_red_white_png__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var menuPatients = function menuPatients(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a, null, props.patientProfileReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.patientProfile }, '+ Patient profile')), props.followUp90dReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.followUp90Day }, '+ 90-day follow-up')), props.SAEReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.saeReporting }, '+ Record SAE')), props.patientProfileReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.enrolments }, 'View all enrolments')));
};var menuManageTrial = function menuManageTrial(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a, null, props.siteReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsSites, rel: 'noopener noreferrer' }, '+ Site')), props.roleReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsRoles, rel: 'noopener noreferrer' }, '+ Role')), props.userReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsUsers, rel: 'noopener noreferrer' }, '+ User')));
};var menuTrialResources = function menuTrialResources(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a, null, props.documentTrainingReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.documentsTraining, rel: 'noopener noreferrer' }, 'Training Documents')), props.documentPublicReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.documentsPublic, rel: 'noopener noreferrer' }, 'Public Documents')), props.auditLogReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.auditLogs, rel: 'noopener noreferrer' }, 'Audit logs')), props.simulationReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.simulation, rel: 'noopener noreferrer' }, 'Simulation')), props.userTrainingReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.training, rel: 'noopener noreferrer' }, 'Training')));
};var AdminHeader = function (_React$Component) {
  _inherits(AdminHeader, _React$Component);function AdminHeader() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, AdminHeader);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminHeader.__proto__ || Object.getPrototypeOf(AdminHeader)).call.apply(_ref, [this].concat(args))), _this), _this.changeLang = function (lang) {
      return function () {
        window.localStorage.setItem('lang', lang);__WEBPACK_IMPORTED_MODULE_13__i18n__["a" /* default */].changeLanguage(lang);
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(AdminHeader, [{ key: 'render', value: function render() {
      var _props = this.props,
          logout = _props.logout,
          patientProfileReadPermission = _props.patientProfileReadPermission,
          SAEReadPermission = _props.SAEReadPermission,
          newsletterReadPermission = _props.newsletterReadPermission,
          reportsReadPermission = _props.reportsReadPermission,
          followUp90dReadPermission = _props.followUp90dReadPermission,
          adminSettingsPermission = _props.adminSettingsPermission,
          userInfo = _props.userInfo,
          simulationReadPermission = _props.simulationReadPermission,
          userTrainingReadPermission = _props.userTrainingReadPermission,
          documentTrainingReadPermission = _props.documentTrainingReadPermission,
          documentPublicReadPermission = _props.documentPublicReadPermission,
          documentReadPermission = _props.documentReadPermission,
          auditLogReadPermission = _props.auditLogReadPermission,
          t = _props.t;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.header }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfile }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/admin', className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLogo }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_red_white_png___default.a })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLinksWrapper }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLinksLeft }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileUsername }, 'Welcome, ', __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(userInfo, 'first_name') ? '' + __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(userInfo, 'first_name') : __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(userInfo, 'email'), '\xA0 |\xA0'), adminSettingsPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settings, className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLink) }, 'Admin settings'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.myProfile, className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLink) }, 'My Profile'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerProfileLink), onClick: logout }, 'Sign Out')))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenu }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItemActive, this.props.location.pathname === routes.admin.dashboard)) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.dashboard, className: 'ant-dropdown-link' }, t('dashboard'))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/', className: 'ant-dropdown-link' }, 'Randomization Platform')), (patientProfileReadPermission || SAEReadPermission || followUp90dReadPermission) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItemActive, this.props.location.pathname.includes('/patient/'))) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_dropdown___default.a, { overlay: menuPatients(this.props) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { className: 'ant-dropdown-link' }, 'Patients ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'down' })))), documentReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItemActive, this.props.location.pathname === routes.admin.documentsEditor)) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.documentsEditor, className: 'ant-dropdown-link' }, t('documentManagement'))), (documentTrainingReadPermission || documentPublicReadPermission || auditLogReadPermission || simulationReadPermission || userTrainingReadPermission) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_dropdown___default.a, { overlay: menuTrialResources(this.props) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { className: 'ant-dropdown-link' }, 'Trial resources ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'down' })))), newsletterReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/admin/newsletter', className: 'ant-dropdown-link' }, 'Mailing List')), reportsReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_14__AdminHeader_css___default.a.headerMenuItemActive, this.props.location.pathname === routes.admin.reporting)) }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.reporting, className: 'ant-dropdown-link' }, 'Reporting'))));
    } }]);return AdminHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { token: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_65" /* getUserToken */])(state), patientProfileReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_18" /* getPatientProfileReadPermission */])(state), SAEReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_42" /* getSAEReadPermission */])(state), followUp90dReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["E" /* getFollowUp90dReadPermission */])(state), adminSettingsPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["a" /* getAdminSettingsPermission */])(state), userInfo: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_61" /* getUserInfo */])(state), userTrainingReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_66" /* getUserTrainingReadPermission */])(state), simulationReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_50" /* getSimulationReadPermission */])(state), siteReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_54" /* getSiteReadPermission */])(state), roleReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_35" /* getRoleReadPermission */])(state), userReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_62" /* getUserReadPermission */])(state), documentReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["x" /* getDocumentReadPermission */])(state), documentTrainingReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["y" /* getDocumentTrainingReadPermission */])(state), documentPublicReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["w" /* getDocumentPublicReadPermission */])(state), auditLogReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["c" /* getAuditLogReadPermission */])(state), newsletterReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["N" /* getNewsletterReadPermission */])(state), reportsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_15__reducers_user_selectors__["_28" /* getReportsReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_16__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_10_react_router__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* withNamespaces */])()(AdminHeader))));

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_user_selectors__ = __webpack_require__(37);


function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}/* harmony default export */ __webpack_exports__["a"] = (function (WrappedComponent) {
  var IsAuthenticated = function IsAuthenticated(_ref) {
    var userToken = _ref.userToken,
        props = _objectWithoutProperties(_ref, ['userToken']);if (!userToken) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: '/admin/login' });
    }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(function (state) {
    return { userToken: Object(__WEBPACK_IMPORTED_MODULE_3__reducers_user_selectors__["_65" /* getUserToken */])(state) };
  })(IsAuthenticated);
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(418);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1089);
//# sourceMappingURL=index.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _rcTooltip = _interopRequireDefault(__webpack_require__(1185));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _placements = _interopRequireDefault(__webpack_require__(1189));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var splitObject = function splitObject(obj, keys) {
  var picked = {};

  var omitted = _extends({}, obj);

  keys.forEach(function (key) {
    if (obj && key in obj) {
      picked[key] = obj[key];
      delete omitted[key];
    }
  });
  return {
    picked: picked,
    omitted: omitted
  };
}; // Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18


function getDisabledCompatibleChildren(element) {
  var elementType = element.type;

  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
    // Pick some layout related style properties up to span
    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
        picked = _splitObject.picked,
        omitted = _splitObject.omitted;

    var spanStyle = _extends(_extends({
      display: 'inline-block'
    }, picked), {
      cursor: 'not-allowed',
      width: element.props.block ? '100%' : null
    });

    var buttonStyle = _extends(_extends({}, omitted), {
      pointerEvents: 'none'
    });

    var child = React.cloneElement(element, {
      style: buttonStyle,
      className: null
    });
    return React.createElement("span", {
      style: spanStyle,
      className: element.props.className
    }, child);
  }

  return element;
}

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));

    _this.onVisibleChange = function (visible) {
      var onVisibleChange = _this.props.onVisibleChange;

      if (!('visible' in _this.props)) {
        _this.setState({
          visible: _this.isNoTitle() ? false : visible
        });
      }

      if (onVisibleChange && !_this.isNoTitle()) {
        onVisibleChange(visible);
      }
    };

    _this.saveTooltip = function (node) {
      _this.tooltip = node;
    }; // 动态设置动画点


    _this.onPopupAlign = function (domNode, align) {
      var placements = _this.getPlacements(); // 当前返回的位置


      var placement = Object.keys(placements).filter(function (key) {
        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
      })[0];

      if (!placement) {
        return;
      } // 根据当前坐标设置动画点


      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: '50%',
        left: '50%'
      };

      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }

      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }

      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };

    _this.renderTooltip = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          openClassName = props.openClassName,
          getPopupContainer = props.getPopupContainer,
          getTooltipContainer = props.getTooltipContainer;
      var children = props.children;
      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
      var visible = state.visible; // Hide tooltip when there is no title

      if (!('visible' in props) && _this.isNoTitle()) {
        visible = false;
      }

      var child = getDisabledCompatibleChildren(React.isValidElement(children) ? children : React.createElement("span", null, children));
      var childProps = child.props;
      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
      return React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: _this.saveTooltip,
        builtinPlacements: _this.getPlacements(),
        overlay: _this.getOverlay(),
        visible: visible,
        onVisibleChange: _this.onVisibleChange,
        onPopupAlign: _this.onPopupAlign
      }), visible ? React.cloneElement(child, {
        className: childCls
      }) : child);
    };

    _this.state = {
      visible: !!props.visible || !!props.defaultVisible
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.tooltip.getPopupDomNode();
    }
  }, {
    key: "getPlacements",
    value: function getPlacements() {
      var _this$props = this.props,
          builtinPlacements = _this$props.builtinPlacements,
          arrowPointAtCenter = _this$props.arrowPointAtCenter,
          autoAdjustOverflow = _this$props.autoAdjustOverflow;
      return builtinPlacements || (0, _placements["default"])({
        arrowPointAtCenter: arrowPointAtCenter,
        verticalArrowShift: 8,
        autoAdjustOverflow: autoAdjustOverflow
      });
    }
  }, {
    key: "isNoTitle",
    value: function isNoTitle() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          overlay = _this$props2.overlay;
      return !title && !overlay && title !== 0; // overlay for old version compatibility
    }
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          overlay = _this$props3.overlay;

      if (title === 0) {
        return title;
      }

      return overlay || title || '';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tooltip;
}(React.Component);

Tooltip.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big-fast',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  arrowPointAtCenter: false,
  autoAdjustOverflow: true
};
(0, _reactLifecyclesCompat.polyfill)(Tooltip);
var _default = Tooltip;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = {"admin":{"index":"/admin","dashboard":"/admin/dashboard","login":"/admin/login","resetPassword":"/admin/password/reset","resetPasswordConfirm":"/admin/password/confirm/:token","setPassword":"/admin/password/set/:token","patientProfile":"/admin/patient/profile","patientProfileSingle":"/admin/patient/profile/:subjectID","saeReporting":"/admin/sae-reporting","saeReportingSignle":"/admin/sae-reporting/:subjectID","followUp90Day":"/admin/90-day-follow-up","followUp90DaySingle":"/admin/90-day-follow-up/:subjectID","myProfile":"/admin/my-profile","enrolments":"/admin/enrolments","patientList":"/admin/patient-list","settings":"/admin/settings","settingsSites":"/admin/settings/sites","settingsUsers":"/admin/settings/users","settingsUsersBulk":"/admin/settings/users-bulk","settingsRoles":"/admin/settings/roles","settingsGeneral":"/admin/settings/general","settingsUsersRoles":"/admin/settings/users/roles/:userID","documentsEditor":"/admin/documents/editor","consentEditor":"/admin/consent/editor","documentsTraining":"/admin/documents/training","documentsPublic":"/admin/documents/public","auditLogs":"/admin/audit_logs","simulation":"/admin/simulation","training":"/admin/training","newsletter":"/admin/newsletter","reporting":"/admin/reporting"},"front":{"consentInvalid":"/consent_error","consentType2":"/consent/type/edmonton","consentType2Token":"/consent/type/edmonton/:token","consentTypeSunnybrook":"/consent/type/sunnybrook","consentTypeSunnybrookToken":"/consent/type/sunnybrook/:token","consentTypeTorontoUH":"/consent/type/toronto_uh","consentTypeTorontoUHToken":"/consent/type/toronto_uh/:token","consentTypeOttawa":"/consent/type/ottawa","consentTypeRoyalUniversityToken":"/consent/type/royal_university/:token","consentTypeRoyalUniversity":"/consent/type/royal_university","consentTypeRoyalToken":"/consent/type/royal/:token","consentTypeRoyal":"/consent/type/royal","consentTypeOttawaToken":"/consent/type/ottawa/:token","consentTypeKelowna":"/consent/type/kelowna","consentTypeKelownaToken":"/consent/type/kelowna/:token","consentTypeMontreal":"/consent/type/montreal","consentTypeMontrealToken":"/consent/type/montreal/:token","consentTypeVancouver":"/consent/type/vancouver","consentTypeChus":"/consent/type/chus","consentTypeChusToken":"/consent/type/chus/:token","consentTypeQuebecChu":"/consent/type/quebec_chu","consentTypeQuebecChuToken":"/consent/type/quebec_chu/:token","consentTypeWinnipeg":"/consent/type/winnipeg","consentTypeWinnipegToken":"/consent/type/winnipeg/:token","consentTypeUhn":"/consent/type/uhn","consentTypeUhnToken":"/consent/type/uhn/:token","consentTypeHalifax":"/consent/type/halifax","consentTypeHalifaxToken":"/consent/type/halifax/:token","consentTypeLhs":"/consent/type/lhs","consentTypeLhsToken":"/consent/type/lhs/:token","consentTypeGreyNuns":"/consent/type/grey_nuns","consentTypeGreyNunsToken":"/consent/type/grey_nuns/:token","consentTypeRedDeer":"/consent/type/red_deer","consentTypeRedDeerToken":"/consent/type/red_deer/:token","consentTypeMedicineHat":"/consent/type/medicine_hat","consentTypeMedicineHatToken":"/consent/type/medicine_hat/:token","consentTypeLethbridge":"/consent/type/lethbridge","consentTypeLethbridgeToken":"/consent/type/lethbridge/:token","consentTypeKingston":"/consent/type/kingston","consentTypeKingstonToken":"/consent/type/kingston/:token","consentTypeHamilton":"/consent/type/hamilton","consentTypeHamiltonToken":"/consent/type/hamilton/:token","consentTypePei":"/consent/type/pei","consentTypePeiToken":"/consent/type/pei/:token"}}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(418);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1019);

__webpack_require__(13);

__webpack_require__(1021);

__webpack_require__(444);
//# sourceMappingURL=index.js.map


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rcCalendar = _interopRequireDefault(__webpack_require__(445));

var _MonthCalendar = _interopRequireDefault(__webpack_require__(448));

var _createPicker = _interopRequireDefault(__webpack_require__(1050));

var _wrapPicker = _interopRequireDefault(__webpack_require__(1061));

var _RangePicker = _interopRequireDefault(__webpack_require__(1069));

var _WeekPicker = _interopRequireDefault(__webpack_require__(1078));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');

_extends(DatePicker, {
  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
  MonthPicker: MonthPicker,
  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
});

var _default = DatePicker;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 69 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1508);

__webpack_require__(209);

__webpack_require__(33);

__webpack_require__(47);

__webpack_require__(212);

__webpack_require__(332);

__webpack_require__(511);
//# sourceMappingURL=index.js.map


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Table = _interopRequireDefault(__webpack_require__(1514));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Table["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(436);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(976);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(977);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(978);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(979);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(980);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1772);

__webpack_require__(11);
//# sourceMappingURL=index.js.map


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Modal = _interopRequireWildcard(__webpack_require__(560));

var _confirm = _interopRequireDefault(__webpack_require__(1780));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function modalWarn(props) {
  var config = _extends({
    type: 'warning',
    icon: React.createElement(_icon["default"], {
      type: "exclamation-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
}

_Modal["default"].info = function infoFn(props) {
  var config = _extends({
    type: 'info',
    icon: React.createElement(_icon["default"], {
      type: "info-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].success = function successFn(props) {
  var config = _extends({
    type: 'success',
    icon: React.createElement(_icon["default"], {
      type: "check-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].error = function errorFn(props) {
  var config = _extends({
    type: 'error',
    icon: React.createElement(_icon["default"], {
      type: "close-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].warning = modalWarn;
_Modal["default"].warn = modalWarn;

_Modal["default"].confirm = function confirmFn(props) {
  var config = _extends({
    type: 'confirm',
    okCancel: true
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].destroyAll = function destroyAllFn() {
  while (_Modal.destroyFns.length) {
    var close = _Modal.destroyFns.pop();

    if (close) {
      close();
    }
  }
};

var _default = _Modal["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1782);
//# sourceMappingURL=index.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcSwitch = _interopRequireDefault(__webpack_require__(1784));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _wave = _interopRequireDefault(__webpack_require__(291));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).call(this, props));

    _this.saveSwitch = function (node) {
      _this.rcSwitch = node;
    };

    _this.renderSwitch = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          size = _this$props.size,
          loading = _this$props.loading,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          disabled = _this$props.disabled;
      var prefixCls = getPrefixCls('switch', customizePrefixCls);
      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
      var loadingIcon = loading ? React.createElement(_icon["default"], {
        type: "loading",
        className: "".concat(prefixCls, "-loading-icon")
      }) : null;
      return React.createElement(_wave["default"], {
        insertExtraNode: true
      }, React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
        prefixCls: prefixCls,
        className: classes,
        disabled: disabled || loading,
        ref: _this.saveSwitch,
        loadingIcon: loadingIcon
      })));
    };

    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
    return _this;
  }

  _createClass(Switch, [{
    key: "focus",
    value: function focus() {
      this.rcSwitch.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSwitch.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch);
    }
  }]);

  return Switch;
}(React.Component);

exports["default"] = Switch;
Switch.__ANT_SWITCH = true;
Switch.propTypes = {
  prefixCls: PropTypes.string,
  // HACK: https://github.com/ant-design/ant-design/issues/5368
  // size=default and size=large are the same
  size: PropTypes.oneOf(['small', 'default', 'large']),
  className: PropTypes.string
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(377);
var isBuffer = __webpack_require__(681);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tupleNum = exports.tuple = void 0;

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

exports.tuple = tuple;

var tupleNum = function tupleNum() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args;
};

exports.tupleNum = tupleNum;
//# sourceMappingURL=type.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(371);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _default = _interopRequireDefault(__webpack_require__(792));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LocaleReceiver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocaleReceiver, _React$Component);

  function LocaleReceiver() {
    _classCallCheck(this, LocaleReceiver);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocaleReceiver).apply(this, arguments));
  }

  _createClass(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || _default["default"][componentName || 'global'];
      var antLocale = this.context.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context.antLocale;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default["default"].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
    }
  }]);

  return LocaleReceiver;
}(React.Component);

exports["default"] = LocaleReceiver;
LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextTypes = {
  antLocale: PropTypes.object
};
//# sourceMappingURL=LocaleReceiver.js.map


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(279)('wks');
var uid = __webpack_require__(192);
var Symbol = __webpack_require__(98).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(426);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(1211);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(1212);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(1214);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(431);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(538);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(590);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(98);
var core = __webpack_require__(74);
var ctx = __webpack_require__(273);
var hide = __webpack_require__(127);
var has = __webpack_require__(110);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(128);
var IE8_DOM_DEFINE = __webpack_require__(412);
var toPrimitive = __webpack_require__(274);
var dP = Object.defineProperty;

exports.f = __webpack_require__(100) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(130)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1632);
moment.tz.load(__webpack_require__(1633));


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FileLink_css__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FileLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FileLink_css__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var FileLink = function (_React$Component) {
  _inherits(FileLink, _React$Component);function FileLink(props) {
    var _this2 = this;_classCallCheck(this, FileLink);var _this = _possibleConstructorReturn(this, (FileLink.__proto__ || Object.getPrototypeOf(FileLink)).call(this, props));_this.openPrivateFileLink = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data, link;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ privateFileLoading: true });_context.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_7__api_requests__["_9" /* getPrivateFileLinkRequest */])({ url: _this.props.url });case 3:
              _ref2 = _context.sent;data = _ref2.data;link = document.createElement("a");link.href = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, "private_url");link.target = "_blank";link.click();_this.setState({ privateFileLoading: false });case 10:case "end":
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.state = { privateFileLoading: null };return _this;
  }_createClass(FileLink, [{ key: "render", value: function render() {
      var privateFileLoading = this.state.privateFileLoading;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip___default.a, { placement: "topLeft", title: "View Document" }, privateFileLoading ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading", className: __WEBPACK_IMPORTED_MODULE_8__FileLink_css___default.a.icon }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_8__FileLink_css___default.a.preview, onClick: this.openPrivateFileLink }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "eye", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_8__FileLink_css___default.a.icon }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_8__FileLink_css___default.a.text }, this.props.text)));
    } }]);return FileLink;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FileLink);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1856);

__webpack_require__(350);

__webpack_require__(212);
//# sourceMappingURL=index.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Breadcrumb = _interopRequireDefault(__webpack_require__(1858));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(572));

var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1859));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
_Breadcrumb["default"].Separator = _BreadcrumbSeparator["default"];
var _default = _Breadcrumb["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(662),
    getValue = __webpack_require__(665);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(372),
    isLength = __webpack_require__(255);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(415);
var defined = __webpack_require__(276);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

exports.getTodayTime = getTodayTime;
exports.getTitleString = getTitleString;
exports.getTodayTimeStr = getTodayTimeStr;
exports.getMonthName = getMonthName;
exports.syncTime = syncTime;
exports.getTimeConfig = getTimeConfig;
exports.isTimeValidByConfig = isTimeValidByConfig;
exports.isTimeValid = isTimeValid;
exports.isAllowedDate = isAllowedDate;
exports.formatDate = formatDate;

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = (0, _moment2['default'])();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
  to.millisecond(from.millisecond());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var SignatureTrimmed = function (_React$Component) {
  _inherits(SignatureTrimmed, _React$Component);function SignatureTrimmed() {
    _classCallCheck(this, SignatureTrimmed);return _possibleConstructorReturn(this, (SignatureTrimmed.__proto__ || Object.getPrototypeOf(SignatureTrimmed)).apply(this, arguments));
  }_createClass(SignatureTrimmed, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getTrimmedCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return SignatureTrimmed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SignatureTrimmed);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1648),
    getValue = __webpack_require__(1653);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1815),
    findIndex = __webpack_require__(1816);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(79),
    isKey = __webpack_require__(246),
    stringToPath = __webpack_require__(656),
    toString = __webpack_require__(374);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    getRawTag = __webpack_require__(654),
    objectToString = __webpack_require__(655);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(153);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_with_query__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_trimEnd__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_trimEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_trimEnd__);


 /**
                                                                                                                                                                        * Takes an url and params and returns combined url
                                                                                                                                                                        * @param {String} url
                                                                                                                                                                        * @param {Object} params
                                                                                                                                                                        */var withParams = function withParams(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};var rest = Object.assign({}, params);var urlWithParams = ('' + url).replace(/:([\w\d.]+)(\?)?/gim, function (match, p1, p2) {
    var param = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(rest, p1, p2 && '');rest = __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(rest, p1);return param;
  }).replace('//', '/');return Object(__WEBPACK_IMPORTED_MODULE_0_with_query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_lodash_trimEnd___default()(urlWithParams, '/'), __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default()(rest, function (p) {
    return p !== null && p !== undefined && p !== '';
  }));
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(386),
    baseKeys = __webpack_require__(713),
    isArrayLike = __webpack_require__(109);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = interopDefault;

// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
function interopDefault(m) {
  return m["default"] || m;
}
//# sourceMappingURL=interopDefault.js.map


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(794);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(99);
var createDesc = __webpack_require__(159);
module.exports = __webpack_require__(100) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(129);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getTodayTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTitleString;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTodayTimeStr;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMonthName;
/* harmony export (immutable) */ __webpack_exports__["h"] = syncTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTimeConfig;
/* unused harmony export isTimeValidByConfig */
/* unused harmony export isTimeValid */
/* harmony export (immutable) */ __webpack_exports__["g"] = isAllowedDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(from) || !__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
  to.millisecond(from.millisecond());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
var _default = KeyCode;
exports.default = _default;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(1055);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1111),
    getValue = __webpack_require__(1114);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(1226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["e"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return menuAllProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isMobile__ = __webpack_require__(1215);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



function noop() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || "".concat(prefix, "item_").concat(index);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (c) {
    index += 1;

    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(c.props.children, function (c2) {
        index += 1;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (c) {
    if (c) {
      var construct = c.type;

      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof(elem.style) === 'object') {
    elem.style[styleProperty] = value;
  }
};
var isMobileDevice = function isMobileDevice() {
  return __WEBPACK_IMPORTED_MODULE_1__utils_isMobile__["a" /* default */].any;
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(513);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollbarVerticalSize;
var scrollbarHorizontalSize; // Measure scrollbar width for padding body during modal show/hide

var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px'
}; // This const is used for colgroup.col internal props. And should not provides to user.

exports.INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';

function measureScrollbar(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      prefixCls = _ref.prefixCls;

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }

  var isVertical = direction === 'vertical';

  if (isVertical && scrollbarVerticalSize) {
    return scrollbarVerticalSize;
  }

  if (!isVertical && scrollbarHorizontalSize) {
    return scrollbarHorizontalSize;
  }

  var scrollDiv = document.createElement('div');
  Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
  }); // apply hide scrollbar className ahead

  scrollDiv.className = "".concat(prefixCls, "-hide-scrollbar scroll-div-append-to-body"); // Append related overflow style

  if (isVertical) {
    scrollDiv.style.overflowY = 'scroll';
  } else {
    scrollDiv.style.overflowX = 'scroll';
  }

  document.body.appendChild(scrollDiv);
  var size = 0;

  if (isVertical) {
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    scrollbarVerticalSize = size;
  } else {
    size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    scrollbarHorizontalSize = size;
  }

  document.body.removeChild(scrollDiv);
  return size;
}

exports.measureScrollbar = measureScrollbar;

function debounce(func, wait, immediate) {
  var timeout;

  function debounceFunc() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this; // https://fb.me/react-event-pooling

    if (args[0] && args[0].persist) {
      args[0].persist();
    }

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  }

  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounceFunc;
}

exports.debounce = debounce;

function remove(array, item) {
  var index = array.indexOf(item);
  var front = array.slice(0, index);
  var last = array.slice(index + 1, array.length);
  return front.concat(last);
}

exports.remove = remove;
/**
 * Returns only data- and aria- key/value pairs
 * @param {object} props
 */

function getDataAndAriaProps(props) {
  return Object.keys(props).reduce(function (memo, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      memo[key] = props[key];
    }

    return memo;
  }, {});
}

exports.getDataAndAriaProps = getDataAndAriaProps;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(1728);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(1729);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(1730);

var _HelmetConstants = __webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["e"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["a"] = deprecated;
/* harmony export (immutable) */ __webpack_exports__["b"] = initSSR;
/* unused harmony export loadNamespaces */
/* harmony export (immutable) */ __webpack_exports__["c"] = shallowEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


function warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    console.warn.apply(null, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function deprecated() {
  if (process && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://act-api.dctms.ca","REACT_APP_UI_URL":"https://act.dctms.ca","REACT_APP_SECRET_NAME":"wiZzx1yTU1vSx89QKprP","REACT_APP_SECRET_KEY":"GmjMJuznKRqNxfca3gk6","REACT_APP_RECAPTCHA_SITE_KEY":"6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6"}) && (!"production" || "production" === 'development')) {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    if (typeof args[0] === 'string') args[0] = "deprecation warning -> ".concat(args[0]);
    warnOnce.apply(void 0, args);
  }
}
var initializedLanguageOnce = false;
var initializedStoreOnce = false;
function initSSR(props, setIsInitialSSR) {
  // nextjs / SSR: getting data from next.js or other ssr stack
  if (!initializedStoreOnce && props.initialI18nStore) {
    props.i18n.services.resourceStore.data = props.initialI18nStore;
    if (setIsInitialSSR) props.i18n.options.isInitialSSR = true;
    if (props.i18nOptions) props.i18nOptions.wait = false; // we got all passed down already

    initializedStoreOnce = true;
  }

  if (!initializedLanguageOnce && props.initialLanguage) {
    props.i18n.changeLanguage(props.initialLanguage);
    initializedLanguageOnce = true;
  }
} // --------------
// loadNamespaces

var objectEntries = Object.entries || function (obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
}; // Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16


function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = objectEntries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {
      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;
  var allNamespaces = filterAndFlattenComponents(components);
  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
} // -------------
// shallowEqual

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * @flow
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } // Step 6.a: NaN == NaN


  return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */


function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(objA) !== 'object' || objA === null || __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(objB) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(154)))

/***/ }),
/* 142 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(351);

var assertThisInitialized = __webpack_require__(552);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1740);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setDefaults;
/* unused harmony export getDefaults */
/* harmony export (immutable) */ __webpack_exports__["d"] = setI18n;
/* unused harmony export getI18n */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reactI18nextModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18nContext; });
/* unused harmony export withContext */
/* harmony export (immutable) */ __webpack_exports__["e"] = withI18n;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__);









var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true,
  transEmptyNodeValue: ''
};
var i18nInstance;
function setDefaults(options) {
  defaultOptions = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, defaultOptions, options);
}
function getDefaults() {
  return defaultOptions;
}
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var reactI18nextModule = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
var I18nContext = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createContext(); // hoc for context

function withContext() {
  return function Wrapper(WrappedComponent) {
    var WithContext =
    /*#__PURE__*/
    function (_Component) {
      __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WithContext, _Component);

      function WithContext() {
        __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, WithContext);

        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(WithContext).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(WithContext, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["innerRef"]);

          if (innerRef) rest.ref = innerRef;
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(I18nContext.Consumer, null, function (ctx) {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, ctx, rest));
          });
        }
      }]);

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

    return WithContext;
  };
}

function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}
/* eslint-disable react/no-multi-comp */


function withI18n() {
  return function Wrapper(WrappedComponent) {
    var WithMergedOptions =
    /*#__PURE__*/
    function (_Component2) {
      __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WithMergedOptions, _Component2);

      function WithMergedOptions() {
        __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, WithMergedOptions);

        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(WithMergedOptions).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(WithMergedOptions, [{
        key: "render",
        value: function render() {
          var _this = this;

          var _this$props2 = this.props,
              innerRef = _this$props2.innerRef,
              rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props2, ["innerRef"]);

          if (innerRef) rest.ref = innerRef; // merged extra props

          var extraProps = {};
          var i18nOptions = this.props.i18nOptions || this.i18nOptions; // as default we add i18n, basic t function and i18nOptions from setI18n
          // those get overridden by values passed by I18nContext.Provider <- eg. set in I18nextProvider

          var i18n = this.props.i18n || getI18n();

          if (!i18nOptions) {
            var possibleI18nOptionsFromProps = Object.keys(defaultOptions).reduce(function (mem, k) {
              if (_this.props[k]) mem[k] = _this.props[k];
              return mem;
            }, {});
            i18nOptions = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, getDefaults(), i18n && i18n.options && i18n.options.react, possibleI18nOptionsFromProps);
            this.i18nOptions = i18nOptions;
          }

          if (i18n) {
            extraProps.i18n = i18n;
            extraProps.t = i18n.t.bind(i18n);
            extraProps.lng = i18n.language;
            extraProps.i18nOptions = i18nOptions;
          }

          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, extraProps, rest));
        }
      }]);

      return WithMergedOptions;
    }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

    var WithMergedOptionsWithContext = withContext()(WithMergedOptions);
    WithMergedOptionsWithContext.WrappedComponent = WrappedComponent;
    WithMergedOptionsWithContext.displayName = "WithMergedOptions(".concat(getDisplayName(WrappedComponent), ")");
    return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(WithMergedOptionsWithContext, WrappedComponent);
  };
}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"patientProfileFormWrapper":"PatientProfileForm__patientProfileFormWrapper__1xL1N","registryFormWrapper":"PatientProfileForm__registryFormWrapper__chFes","toggleHeadline":"PatientProfileForm__toggleHeadline__1nVck","patientProfileForm":"PatientProfileForm__patientProfileForm__12hrU","fieldInline":"PatientProfileForm__fieldInline__1TU-f","collapseIcon":"PatientProfileForm__collapseIcon__3956_","submitButton":"PatientProfileForm__submitButton__1-Df5","deleteButton":"PatientProfileForm__deleteButton__2iEgG","paragraph":"PatientProfileForm__paragraph__3doOD","submitResult":"PatientProfileForm__submitResult__12rQR","table":"PatientProfileForm__table__3dpq9","tableAction":"PatientProfileForm__tableAction__31w4R","checkIcon":"PatientProfileForm__checkIcon__1x5wR","clockIcon":"PatientProfileForm__clockIcon__1X4Nu","checkIconGray":"PatientProfileForm__checkIconGray__2mJRk","warningIcon":"PatientProfileForm__warningIcon__3KHy1","formActions":"PatientProfileForm__formActions__4Dvkv","formActionsNotes":"PatientProfileForm__formActionsNotes__3k4VX","alertsMb":"PatientProfileForm__alertsMb__1U1_b","toggleText":"PatientProfileForm__toggleText__3vmFY"};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(3561),
    getValue = __webpack_require__(3566);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(618);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(118),
    toKey = __webpack_require__(122);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(119),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(252),
    baseAssignValue = __webpack_require__(384);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(751),
    baseMatchesProperty = __webpack_require__(761),
    identity = __webpack_require__(186),
    isArray = __webpack_require__(79),
    property = __webpack_require__(765);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(405));

var _en_US2 = _interopRequireDefault(__webpack_require__(270));

var _en_US3 = _interopRequireDefault(__webpack_require__(271));

var _en_US4 = _interopRequireDefault(__webpack_require__(791));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  locale: 'en',
  Pagination: _en_US["default"],
  DatePicker: _en_US2["default"],
  TimePicker: _en_US3["default"],
  Calendar: _en_US4["default"],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No Data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  PageHeader: {
    back: 'Back'
  }
};
exports["default"] = _default;
//# sourceMappingURL=default.js.map


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(276);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/act_quicr_logo.6c763c86.png";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(195),
    getRawTag = __webpack_require__(865),
    objectToString = __webpack_require__(866);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixControlledValue = fixControlledValue;
exports.resolveOnChange = resolveOnChange;
exports.getInputClassName = getInputClassName;
exports["default"] = exports.InputSizes = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _type = __webpack_require__(81);

var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(441));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputSizes = (0, _type.tuple)('small', 'default', 'large');
exports.InputSizes = InputSizes;

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

function resolveOnChange(target, e, onChange) {
  if (onChange) {
    var event = e;

    if (e.type === 'click') {
      // click clear icon
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input

      target.value = '';
      onChange(event); // reset target ref value

      target.value = originalInputValue;
      return;
    }

    onChange(event);
  }
}

function getInputClassName(prefixCls, size, disabled) {
  var _classNames;

  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _this.saveClearableInput = function (input) {
      _this.clearableInput = input;
    };

    _this.saveInput = function (input) {
      _this.input = input;
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.focus();
      });

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.renderInput = function (prefixCls) {
      var _this$props = _this.props,
          className = _this$props.className,
          addonBefore = _this$props.addonBefore,
          addonAfter = _this$props.addonAfter,
          size = _this$props.size,
          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      'defaultValue', 'size', 'inputType']);
      return React.createElement("input", _extends({}, otherProps, {
        onChange: _this.handleChange,
        onKeyDown: _this.handleKeyDown,
        className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
        ref: _this.saveInput
      }));
    };

    _this.clearPasswordValueAttribute = function () {
      // https://github.com/ant-design/ant-design/issues/20541
      _this.removePasswordTimeout = setTimeout(function () {
        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
          _this.input.removeAttribute('value');
        }
      });
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onPressEnter = _this$props2.onPressEnter,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "input",
        value: fixControlledValue(value),
        element: _this.renderInput(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.clearPasswordValueAttribute();
    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
    // We keep an empty function here.

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.removePasswordTimeout) {
        clearTimeout(this.removePasswordTimeout);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Input;
}(React.Component);

Input.defaultProps = {
  type: 'text'
};
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(InputSizes),
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefixCls: PropTypes.string,
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  allowClear: PropTypes.bool
};
(0, _reactLifecyclesCompat.polyfill)(Input);
var _default = Input;
exports["default"] = _default;
//# sourceMappingURL=Input.js.map


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(336),
    getRawTag = __webpack_require__(1531),
    objectToString = __webpack_require__(1532);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    getRawTag = __webpack_require__(1649),
    objectToString = __webpack_require__(1650);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return documentTypes; });
/* unused harmony export categoryPublic */
/* unused harmony export categoryGeneral */
/* unused harmony export categoryGeneralPrivate */
/* unused harmony export categoryTraining */
/* unused harmony export categoryPerSite */
/* unused harmony export categoryValidation */
/* unused harmony export categoryPatientDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__FileLink_FileLink__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__DocumentForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_moment__);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;var documentTypes = { // Site Specific category
  site_accreditation: "Site accreditation", doctor_license: "Professional/Medical license", training_completion_certificate: "Training Completion Certificate", cv: "CV", gcp_certificates: "GCP Certificates", reb_ethics_approval_letter: "REB/Ethics approval letter, annual renewals, amendments", ethics_membership_list: "Ethics Membership List", reb_ethics_correspondence: "REB/Ethics Correspondence", approved_consent_form: "Approved Consent forms for both patient and surrogate", site_doa_log: "Site DOA log", site_training_log: "Site training log", protocol_signature_page: "Protocol Signature Page", reba_form: "REBA (Health Canada) Form", ctsi: "CTSI", qiu: "QIU", nol: "NOL", hc_div_five: "HC Div 5", site_monitoring: "Site Monitoring", // Other
  other: "Other", // Public category
  trial_protocol: "Trial protocol", physician_script: "Physician script", patient_information_sheet_text: "Patient information sheet text", patient_information_sheet_visual: "Patient information sheet visual", patient_consent_form: "Patient consent form", surrogate_consent_form: "Surrogate consent form", letter_of_bereavement: "Letter of bereavement", sae_form: "SAE form", // Training Category
  technical_admin_user_guide: "Technical Admin User Guide", site_pi_and_coordinators_user_guide: "Site PI & Coordinators User Guide", site_investigator_user_guide: "Site Investigator User Guide", technical_admin_user_training_presentation: "Technical Admin User Training Presentation", site_pi_and_coordinators_user_training_presentation: "Site PI & Coordinators User Training Presentation", site_investigator_user_training_presentation: "Site Investigator User Training Presentation", // Validation Category
  master_validation_plan: "Master Validation Plan", master_validation_report: "Master Validation Report", installation_qualication_plan: "Installation Qualication Plan", installation_qualication_report: "Installation Qualication Report", operational_qualitification_plan: "Operational Qualitification Plan", operational_qualitification_report: "Operational Qualitification Report", perfomance_qualification_plan: "Perfomance Qualification Plan", perfomance_qualification_report: "Perfomance Qualification Report", testing_plan: "Testing Plan", testing_log: "Testing Log", data_managemnt_plan: "Data Management Plan", system_architecture: "System Architecture", general_patient_document: "General patient document", site_contract: "Site Contract", site_siv_letter: "Site SIV Letter", site_ethic_submission: "Site Ethic submission", other_documents: "Other Documents" };var categoryPublic = ["trial_protocol", "physician_script", "nol", "patient_information_sheet_text", "patient_information_sheet_visual", "patient_consent_form", "surrogate_consent_form", "letter_of_bereavement", "sae_form", "other"];var categoryGeneral = ["other"];var categoryGeneralPrivate = ["other"];var categoryTraining = ["technical_admin_user_guide", "site_pi_and_coordinators_user_guide", "site_investigator_user_guide", "technical_admin_user_training_presentation", "site_pi_and_coordinators_user_training_presentation", "site_investigator_user_training_presentation", "other"];var categoryPerSite = ["site_accreditation", "doctor_license", "training_completion_certificate", "cv", "gcp_certificates", "reb_ethics_approval_letter", "ethics_membership_list", "reb_ethics_correspondence", "approved_consent_form", "site_doa_log", "site_training_log", "protocol_signature_page", "reba_form", "ctsi", "qiu", "site_monitoring", "hc_div_five", "site_contract", "site_siv_letter", "site_ethic_submission", "other_documents"];var categoryValidation = ["master_validation_plan", "master_validation_report", "installation_qualication_plan", "installation_qualication_report", "operational_qualitification_plan", "operational_qualitification_report", "perfomance_qualification_plan", "perfomance_qualification_report", "testing_plan", "testing_log", "data_managemnt_plan", "system_architecture", "other"];var categoryPatientDocument = ["general_patient_document"];var DocumentForm = function (_React$Component) {
  _inherits(DocumentForm, _React$Component);function DocumentForm(props) {
    var _this2 = this;_classCallCheck(this, DocumentForm);var _this = _possibleConstructorReturn(this, (DocumentForm.__proto__ || Object.getPrototypeOf(DocumentForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var document, formData, errors;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 48;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;document = Object.assign({}, values);document.name = __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(document, "document_file.fileList", []).slice(-1).name;document.category = "per_site";document.document_file = values.document_file.file;formData = new FormData();if (values.document_file && values.document_file.file) {
                    formData.append("document_file", values.document_file.file);
                  }formData.append("name", values.name);formData.append("start_year", values.start_year.format("YYYY-MM-DD"));formData.append("expiry_year", values.expiry_year ? values.expiry_year.format("YYYY-MM-DD") : null);formData.append("type", values.type);formData.append("category", values.category);formData.append("comments", values.comments);formData.append("order_index", values.order_index ? values.order_index : 999);if (values.category === "per_site") {
                    formData.append("site_id", values.site_id);
                  }if (values.category === "public") {
                    formData.append("site_id", values.site_id ? values.site_id : null);
                  }if (_this.props.patient) {
                    formData.append("subject_profile_id", _this.props.patient.profile.id);formData.append("site_id", _this.props.patient.site.id);
                  }if (!_this.props.id) {
                    _context.next = 30;break;
                  }if (!_this.props.patient) {
                    _context.next = 26;break;
                  }_context.next = 24;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["_65" /* updatePatientProfileDocumentRequest */])(_this.props.id, formData);case 24:
                  _context.next = 28;break;case 26:
                  _context.next = 28;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["_61" /* updateDocumentRequest */])(_this.props.id, formData);case 28:
                  _context.next = 37;break;case 30:
                  if (!_this.props.patient) {
                    _context.next = 35;break;
                  }_context.next = 33;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["u" /* createPatientProfileDocumentRequest */])(formData);case 33:
                  _context.next = 37;break;case 35:
                  _context.next = 37;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["s" /* createDocumentRequest */])(formData);case 37:
                  _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 48;break;case 41:
                  _context.prev = 41;_context.t0 = _context["catch"](3);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 46;break;
                  }_this.props.logout();return _context.abrupt("return");case 46:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 48:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 41]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.onCategoryChange = function () {
      _this.props.form.setFieldsValue({ type: null });
    };_this.state = { isLoading: false, requestResult: {}, sites: [] };return _this;
  }_createClass(DocumentForm, [{ key: "componentDidMount", value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["_20" /* getSitesRequest */])();case 3:
                _ref3 = _context2.sent;data = _ref3.data;this.setState({ sites: data });_context2.next = 14;break;case 8:
                _context2.prev = 8;_context2.t0 = _context2["catch"](0);if (!(_context2.t0.response.status === 401)) {
                  _context2.next = 13;break;
                }this.props.logout();return _context2.abrupt("return");case 13:
                console.log(_context2.t0);case 14:case "end":
                return _context2.stop();}
          }
        }, _callee2, this, [[0, 8]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          sites = _state.sites;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          documentUpdatePermission = _props.documentUpdatePermission,
          documentCreatePermission = _props.documentCreatePermission,
          id = _props.id,
          isNew = _props.isNew,
          withPatient = _props.withPatient;var categoryVal = getFieldValue("category");var isEditable = id ? documentUpdatePermission : documentCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("h4", { className: "headline-default" }, this.props.id ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", null, this.props.name, " ", __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: "Edit", style: { backgroundColor: "#2968AE" } })) : isNew ? "Add New Document" : ""), !__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "patient.profile.id") && withPatient && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_alert___default.a, { type: "error", message: "Note: You must create the profile for this subject in order to upload the documents!" }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("document_file", { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "document_file", "") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_upload___default.a, { disabled: !isEditable, accept: ".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4", action: "", beforeUpload: function beforeUpload() {
          return false;
        }, multiple: false, fileList: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props.form.getFieldValue("document_file"), "fileList", []).slice(-1) }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: "upload" }), !this.props.form.getFieldValue("document_file") && this.props.url ? "Change file" : "Add New Document"))))), !this.props.form.getFieldValue("document_file") && this.props.url && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__FileLink_FileLink__["a" /* default */], { url: this.props.url, text: "File preview" }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null)))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Index"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, { style: { marginBottom: "12px" } }, getFieldDecorator("order_index", { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "order_index", "") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a, { disabled: !isEditable, placeholder: "999" })))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Category"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("category", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "category") })(this.props.patient ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, onChange: this.onCategoryChange }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "patient_documents", disabled: !this.props.documentGeneralReadPermission }, "Patient documents")) : __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, onChange: this.onCategoryChange }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "public", disabled: !this.props.documentPublicReadPermission }, "Public"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "general", disabled: !this.props.documentGeneralReadPermission }, "Central Shared"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "general_private", disabled: !this.props.documentGeneralPrivateReadPermission }, "Central Private"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "per_site", disabled: !this.props.documentPerSiteReadPermission }, "Site Specific"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "training", disabled: !this.props.documentTrainingReadPermission }, "Training"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "validation", disabled: !this.props.documentValidationReadPermission }, "Validation")))))), categoryVal === "public" && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Site ID"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("site_id", { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "site_id", null) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select Site ID", style: { width: "100%" }, allowClear: true }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: 0, value: null }, "General"), sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, " - ", site.name);
      })))))), categoryVal === "per_site" && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Site ID"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("site_id", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "site_id") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select Site ID", style: { width: "100%" }, allowClear: true }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, " - ", site.name);
      }))))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Document type"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("type", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "type") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable }, function () {
        var documentTypeList = [];if (categoryVal === "public") {
          documentTypeList = categoryPublic;
        }if (categoryVal === "general") {
          documentTypeList = categoryGeneral;
        }if (categoryVal === "general_private") {
          documentTypeList = categoryGeneralPrivate;
        }if (categoryVal === "per_site") {
          documentTypeList = categoryPerSite;
        }if (categoryVal === "training") {
          documentTypeList = categoryTraining;
        }if (categoryVal === "validation") {
          documentTypeList = categoryValidation;
        }if (categoryVal === "patient_documents") {
          documentTypeList = categoryPatientDocument;
        }return documentTypeList.map(function (key) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: key, value: key }, documentTypes[key]);
        });
      }()))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Document Name"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("name", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "name") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: !isEditable, type: "text" })))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Year"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("start_year", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "start_year") ? __WEBPACK_IMPORTED_MODULE_33_moment___default()(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "start_year")) : null })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { disabled: !isEditable, placeholder: "yyyy-mm-dd" }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Renewal/expiry year"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("expiry_year", { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "expiry_year") ? __WEBPACK_IMPORTED_MODULE_33_moment___default()(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "expiry_year")) : null })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { disabled: !isEditable, placeholder: "yyyy-mm-dd" })))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Comments"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("comments", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "comments") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a.TextArea, { disabled: !isEditable })))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default.a.submitButton, disabled: !__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, "patient.profile.id") && withPatient }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_31__DocumentForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"))));
    } }]);return DocumentForm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { documentCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["r" /* getDocumentCreatePermission */])(state), documentUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["A" /* getDocumentUpdatePermission */])(state), documentTrainingReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["y" /* getDocumentTrainingReadPermission */])(state), documentValidationReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["B" /* getDocumentValidationReadPermission */])(state), documentPublicReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["w" /* getDocumentPublicReadPermission */])(state), documentGeneralReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["u" /* getDocumentGeneralReadPermission */])(state), documentGeneralPrivateReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["t" /* getDocumentGeneralPrivateReadPermission */])(state), documentPerSiteReadPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["v" /* getDocumentPerSiteReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.create({ name: "user" })(Object(__WEBPACK_IMPORTED_MODULE_27_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(DocumentForm)));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(232),
    getRawTag = __webpack_require__(3562),
    objectToString = __webpack_require__(3563);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(623);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onLocationChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* unused harmony export push */
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var onLocationChanged = function onLocationChanged(location, action) {
  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: LOCATION_CHANGE,
    payload: {
      location: location,
      action: action,
      isFirstRendering: isFirstRendering
    }
  };
};
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */

var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
};
/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */


var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');
var routerActions = {
  push: push,
  replace: replace,
  go: go,
  goBack: goBack,
  goForward: goForward
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(670),
    listCacheDelete = __webpack_require__(671),
    listCacheGet = __webpack_require__(672),
    listCacheHas = __webpack_require__(673),
    listCacheSet = __webpack_require__(674);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(182);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(676);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(723),
    Map = __webpack_require__(248),
    Promise = __webpack_require__(724),
    Set = __webpack_require__(393),
    WeakMap = __webpack_require__(725),
    baseGetTag = __webpack_require__(119),
    toSource = __webpack_require__(373);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(788);
//# sourceMappingURL=index.js.map


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});

var _row = _interopRequireDefault(__webpack_require__(404));

var _col = _interopRequireDefault(__webpack_require__(410));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
//# sourceMappingURL=index.js.map


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = warning;
exports.note = note;
exports.resetWarned = resetWarned;
exports.call = call;
exports.warningOnce = warningOnce;
exports.noteOnce = noteOnce;
exports.default = void 0;

/* eslint-disable no-console */
var warned = {};

function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}

function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}

function resetWarned() {
  warned = {};
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}

function noteOnce(valid, message) {
  call(note, valid, message);
}

var _default = warningOnce;
/* eslint-enable */

exports.default = _default;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(414);
var enumBugKeys = __webpack_require__(280);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(164),
    isObjectLike = __webpack_require__(165);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(86);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(26));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom["default"].findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom["default"].findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(901);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__http__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__http__["b"]; });




/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapperRaf;

var _raf = _interopRequireDefault(__webpack_require__(433));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var id = 0;
var ids = {}; // Support call raf with delay specified frame

function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;

  function internalCallback() {
    restFrames -= 1;

    if (restFrames <= 0) {
      callback();
      delete ids[myId];
    } else {
      ids[myId] = (0, _raf["default"])(internalCallback);
    }
  }

  ids[myId] = (0, _raf["default"])(internalCallback);
  return myId;
}

wrapperRaf.cancel = function cancel(pid) {
  if (pid === undefined) return;

  _raf["default"].cancel(ids[pid]);

  delete ids[pid];
};

wrapperRaf.ids = ids; // export this for test usage
//# sourceMappingURL=raf.js.map


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(154)))

/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(299);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(301);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(949);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1101),
    listCacheDelete = __webpack_require__(1102),
    listCacheGet = __webpack_require__(1103),
    listCacheHas = __webpack_require__(1104),
    listCacheSet = __webpack_require__(1105);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(473);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1123);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(194);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1205);
//# sourceMappingURL=index.js.map


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_user_selectors__ = __webpack_require__(37);


function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}/* harmony default export */ __webpack_exports__["a"] = (function (WrappedComponent) {
  var IsAuthenticated = function IsAuthenticated(_ref) {
    var userToken = _ref.userToken,
        props = _objectWithoutProperties(_ref, ['userToken']);if (userToken) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: '/admin' });
    }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(function (state) {
    return { userToken: Object(__WEBPACK_IMPORTED_MODULE_3__reducers_user_selectors__["_65" /* getUserToken */])(state) };
  })(IsAuthenticated);
});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1510);

__webpack_require__(11);
//# sourceMappingURL=index.js.map


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(456));

var _reactDom = _interopRequireDefault(__webpack_require__(26));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1520),
    listCacheDelete = __webpack_require__(1521),
    listCacheGet = __webpack_require__(1522),
    listCacheHas = __webpack_require__(1523),
    listCacheSet = __webpack_require__(1524);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(216);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(334);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1545);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dropdown = _interopRequireDefault(__webpack_require__(340));

var _dropdownButton = _interopRequireDefault(__webpack_require__(1610));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dropdown["default"].Button = _dropdownButton["default"];
var _default = _dropdown["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = _interopRequireWildcard(__webpack_require__(135));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _reactLifecyclesCompat = __webpack_require__(38);

var _SubMenu = _interopRequireDefault(__webpack_require__(1615));

var _MenuItem = _interopRequireDefault(__webpack_require__(1616));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _Sider = __webpack_require__(272);

var _raf = _interopRequireDefault(__webpack_require__(198));

var _motion = _interopRequireDefault(__webpack_require__(1617));

var _MenuContext = _interopRequireDefault(__webpack_require__(341));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InternalMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InternalMenu, _React$Component);

  function InternalMenu(props) {
    var _this;

    _classCallCheck(this, InternalMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalMenu).call(this, props)); // Restore vertical mode when menu is collapsed responsively when mounted
    // https://github.com/ant-design/ant-design/issues/13104
    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation

    _this.handleMouseEnter = function (e) {
      _this.restoreModeVerticalFromInline();

      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(e);
      }
    };

    _this.handleTransitionEnd = function (e) {
      // when inlineCollapsed menu width animation finished
      // https://github.com/ant-design/ant-design/issues/12864
      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
      // https://github.com/ant-design/ant-design/issues/15699

      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.

      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
      // https://github.com/ant-design/ant-design-pro/issues/2783

      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;

      if (widthCollapsed || iconScaled) {
        _this.restoreModeVerticalFromInline();
      }
    };

    _this.handleClick = function (e) {
      _this.handleOpenChange([]);

      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    };

    _this.handleOpenChange = function (openKeys) {
      _this.setOpenKeys(openKeys);

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(openKeys);
      }
    };

    _this.renderMenu = function (_ref) {
      var getPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          className = _this$props.className,
          theme = _this$props.theme,
          collapsedWidth = _this$props.collapsedWidth;
      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);

      var menuMode = _this.getRealMenuMode();

      var menuOpenMotion = _this.getOpenMotionProps(menuMode);

      var prefixCls = getPrefixCls('menu', customizePrefixCls);
      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));

      var menuProps = _extends({
        openKeys: _this.state.openKeys,
        onOpenChange: _this.handleOpenChange,
        className: menuClassName,
        mode: menuMode
      }, menuOpenMotion);

      if (menuMode !== 'inline') {
        // closing vertical popup submenu after click it
        menuProps.onClick = _this.handleClick;
      } // https://github.com/ant-design/ant-design/issues/8587


      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');

      if (hideMenu) {
        menuProps.openKeys = [];
      }

      return React.createElement(_rcMenu["default"], _extends({
        getPopupContainer: getPopupContainer
      }, passProps, menuProps, {
        prefixCls: prefixCls,
        onTransitionEnd: _this.handleTransitionEnd,
        onMouseEnter: _this.handleMouseEnter
      }));
    };

    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
    var openKeys;

    if ('openKeys' in props) {
      openKeys = props.openKeys;
    } else if ('defaultOpenKeys' in props) {
      openKeys = props.defaultOpenKeys;
    }

    _this.state = {
      openKeys: openKeys || [],
      switchingModeFromInline: false,
      inlineOpenKeys: [],
      prevProps: props
    };
    return _this;
  }

  _createClass(InternalMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.mountRafId);
    }
  }, {
    key: "setOpenKeys",
    value: function setOpenKeys(openKeys) {
      if (!('openKeys' in this.props)) {
        this.setState({
          openKeys: openKeys
        });
      }
    }
  }, {
    key: "getRealMenuMode",
    value: function getRealMenuMode() {
      var inlineCollapsed = this.getInlineCollapsed();

      if (this.state.switchingModeFromInline && inlineCollapsed) {
        return 'inline';
      }

      var mode = this.props.mode;
      return inlineCollapsed ? 'vertical' : mode;
    }
  }, {
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var inlineCollapsed = this.props.inlineCollapsed;

      if (this.props.siderCollapsed !== undefined) {
        return this.props.siderCollapsed;
      }

      return inlineCollapsed;
    }
  }, {
    key: "getOpenMotionProps",
    value: function getOpenMotionProps(menuMode) {
      var _this$props2 = this.props,
          openTransitionName = _this$props2.openTransitionName,
          openAnimation = _this$props2.openAnimation,
          motion = _this$props2.motion; // Provides by user

      if (motion) {
        return {
          motion: motion
        };
      }

      if (openAnimation) {
        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
        return {
          openAnimation: openAnimation
        };
      }

      if (openTransitionName) {
        return {
          openTransitionName: openTransitionName
        };
      } // Default logic


      if (menuMode === 'horizontal') {
        return {
          motion: {
            motionName: 'slide-up'
          }
        };
      }

      if (menuMode === 'inline') {
        return {
          motion: _motion["default"]
        };
      } // When mode switch from inline
      // submenu should hide without animation


      return {
        motion: {
          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
        }
      };
    }
  }, {
    key: "restoreModeVerticalFromInline",
    value: function restoreModeVerticalFromInline() {
      var switchingModeFromInline = this.state.switchingModeFromInline;

      if (switchingModeFromInline) {
        this.setState({
          switchingModeFromInline: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_MenuContext["default"].Provider, {
        value: {
          inlineCollapsed: this.getInlineCollapsed() || false,
          antdMenuTheme: this.props.theme
        }
      }, React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: nextProps
      };

      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
        newState.switchingModeFromInline = true;
      }

      if ('openKeys' in nextProps) {
        newState.openKeys = nextProps.openKeys;
      } else {
        // [Legacy] Old code will return after `openKeys` changed.
        // Not sure the reason, we should keep this logic still.
        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
          newState.switchingModeFromInline = true;
          newState.inlineOpenKeys = prevState.openKeys;
          newState.openKeys = [];
        }

        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
          newState.openKeys = prevState.inlineOpenKeys;
          newState.inlineOpenKeys = [];
        }
      }

      return newState;
    }
  }]);

  return InternalMenu;
}(React.Component);

InternalMenu.defaultProps = {
  className: '',
  theme: 'light',
  focusable: false
};
(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able

var Menu =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Menu, _React$Component2);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, _getPrototypeOf(Menu).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
        return React.createElement(InternalMenu, _extends({}, _this2.props, context));
      });
    }
  }]);

  return Menu;
}(React.Component);

exports["default"] = Menu;
Menu.Divider = _rcMenu.Divider;
Menu.Item = _MenuItem["default"];
Menu.SubMenu = _SubMenu["default"];
Menu.ItemGroup = _rcMenu.ItemGroup;
//# sourceMappingURL=index.js.map


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1638),
    listCacheDelete = __webpack_require__(1639),
    listCacheGet = __webpack_require__(1640),
    listCacheHas = __webpack_require__(1641),
    listCacheSet = __webpack_require__(1642);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(536);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(91);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1662);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(349);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1739);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1845);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = warning;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIconDefinition;
/* unused harmony export normalizeAttrs */
/* harmony export (immutable) */ __webpack_exports__["a"] = generate;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSecondaryColor;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeTwoToneColors;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return svgBaseProps; });
/* unused harmony export iconStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useInsertStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_colors__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ant_design_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_insert_css__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_insert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_insert_css__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





function warning(valid, message) {
  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(node.tag, _objectSpread({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(node.tag, _objectSpread({
    key: key
  }, normalizeAttrs(node.attrs), {}, rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return Object(__WEBPACK_IMPORTED_MODULE_0__ant_design_colors__["generate"])(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4

var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var cssInjectedFlag = false;
var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (!cssInjectedFlag) {
      Object(__WEBPACK_IMPORTED_MODULE_3_insert_css__["insertCss"])(styleStr, {
        prepend: true
      });
      cssInjectedFlag = true;
    }
  }, []);
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3551),
    listCacheDelete = __webpack_require__(3552),
    listCacheGet = __webpack_require__(3553),
    listCacheHas = __webpack_require__(3554),
    listCacheSet = __webpack_require__(3555);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(357);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(93);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(3575);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(3595),
    baseKeys = __webpack_require__(3602),
    isArrayLike = __webpack_require__(236);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(589),
    isLength = __webpack_require__(362);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObjectLike = __webpack_require__(174);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(237);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(151);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectRouter; });
/* unused harmony export getLocation */
/* unused harmony export getAction */
/* unused harmony export getHash */
/* unused harmony export getSearch */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__structure_plain__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(178);
/* unused harmony reexport LOCATION_CHANGE */
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport onLocationChanged */
/* unused harmony reexport push */
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__middleware__["a"]; });






var ConnectedRouter =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);
var connectRouter =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);

var _createSelectors =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]),
    getLocation = _createSelectors.getLocation,
    getAction = _createSelectors.getAction,
    getHash = _createSelectors.getHash,
    getSearch = _createSelectors.getSearch,
    createMatchSelector = _createSelectors.createMatchSelector;



/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(244);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(243);


var history = Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])();/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(79),
    isSymbol = __webpack_require__(153);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(659),
    mapCacheDelete = __webpack_require__(675),
    mapCacheGet = __webpack_require__(677),
    mapCacheHas = __webpack_require__(678),
    mapCacheSet = __webpack_require__(679);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(80);
var normalizeHeaderName = __webpack_require__(683);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(378);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(378);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(154)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(180),
    stackClear = __webpack_require__(702),
    stackDelete = __webpack_require__(703),
    stackGet = __webpack_require__(704),
    stackHas = __webpack_require__(705),
    stackSet = __webpack_require__(706);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(384),
    eq = __webpack_require__(182);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(710),
    isObjectLike = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(82),
    stubFalse = __webpack_require__(711);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 255 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(371);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 257 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(386),
    baseKeysIn = __webpack_require__(716),
    isArrayLike = __webpack_require__(109);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(721),
    stubArray = __webpack_require__(389);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(388);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(392),
    getSymbolsIn = __webpack_require__(390),
    keysIn = __webpack_require__(258);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(394);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(260),
    isFlattenable = __webpack_require__(745);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(753),
    isObjectLike = __webpack_require__(88);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(247),
    setCacheAdd = __webpack_require__(754),
    setCacheHas = __webpack_require__(755);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _default = _interopRequireDefault(__webpack_require__(158));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var runtimeLocale = _extends({}, _default["default"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = _extends({}, _default["default"].Modal);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}
//# sourceMappingURL=locale.js.map


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(406));

var _en_US2 = _interopRequireDefault(__webpack_require__(271));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Merge into a locale object
var locale = {
  lang: _extends({
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date']
  }, _en_US["default"]),
  timePickerLocale: _extends({}, _en_US2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;
//# sourceMappingURL=en_US.js.map


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time'
};
var _default = locale;
exports["default"] = _default;
//# sourceMappingURL=en_US.js.map


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SiderContext = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _layout = __webpack_require__(411);

var _configProvider = __webpack_require__(30);

var _icon = _interopRequireDefault(__webpack_require__(4));

var _isNumeric = _interopRequireDefault(__webpack_require__(849));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
// TODO: Will be removed in antd 4.0 because we will no longer support ie9
if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
}

var dimensionMaxMap = {
  xs: '479.98px',
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
  xxl: '1599.98px'
};
var SiderContext = (0, _createReactContext["default"])({});
exports.SiderContext = SiderContext;

var generateId = function () {
  var i = 0;
  return function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    i += 1;
    return "".concat(prefix).concat(i);
  };
}();

var InternalSider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InternalSider, _React$Component);

  function InternalSider(props) {
    var _this;

    _classCallCheck(this, InternalSider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalSider).call(this, props));

    _this.responsiveHandler = function (mql) {
      _this.setState({
        below: mql.matches
      });

      var onBreakpoint = _this.props.onBreakpoint;

      if (onBreakpoint) {
        onBreakpoint(mql.matches);
      }

      if (_this.state.collapsed !== mql.matches) {
        _this.setCollapsed(mql.matches, 'responsive');
      }
    };

    _this.setCollapsed = function (collapsed, type) {
      if (!('collapsed' in _this.props)) {
        _this.setState({
          collapsed: collapsed
        });
      }

      var onCollapse = _this.props.onCollapse;

      if (onCollapse) {
        onCollapse(collapsed, type);
      }
    };

    _this.toggle = function () {
      var collapsed = !_this.state.collapsed;

      _this.setCollapsed(collapsed, 'clickTrigger');
    };

    _this.belowShowChange = function () {
      _this.setState(function (_ref) {
        var belowShow = _ref.belowShow;
        return {
          belowShow: !belowShow
        };
      });
    };

    _this.renderSider = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          theme = _a.theme,
          collapsible = _a.collapsible,
          reverseArrow = _a.reverseArrow,
          trigger = _a.trigger,
          style = _a.style,
          width = _a.width,
          collapsedWidth = _a.collapsedWidth,
          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);

      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width

      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0

      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? React.createElement("span", {
        onClick: _this.toggle,
        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
        style: zeroWidthTriggerStyle
      }, React.createElement(_icon["default"], {
        type: "bars"
      })) : null;
      var iconObj = {
        expanded: reverseArrow ? React.createElement(_icon["default"], {
          type: "right"
        }) : React.createElement(_icon["default"], {
          type: "left"
        }),
        collapsed: reverseArrow ? React.createElement(_icon["default"], {
          type: "left"
        }) : React.createElement(_icon["default"], {
          type: "right"
        })
      };
      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
      var defaultTrigger = iconObj[status];
      var triggerDom = trigger !== null ? zeroWidthTrigger || React.createElement("div", {
        className: "".concat(prefixCls, "-trigger"),
        onClick: _this.toggle,
        style: {
          width: siderWidth
        }
      }, trigger || defaultTrigger) : null;

      var divStyle = _extends(_extends({}, style), {
        flex: "0 0 ".concat(siderWidth),
        maxWidth: siderWidth,
        minWidth: siderWidth,
        width: siderWidth
      });

      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
      return React.createElement("aside", _extends({
        className: siderCls
      }, divProps, {
        style: divStyle
      }), React.createElement("div", {
        className: "".concat(prefixCls, "-children")
      }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null);
    };

    _this.uniqueId = generateId('ant-sider-');
    var matchMedia;

    if (typeof window !== 'undefined') {
      matchMedia = window.matchMedia;
    }

    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
    }

    var collapsed;

    if ('collapsed' in props) {
      collapsed = props.collapsed;
    } else {
      collapsed = props.defaultCollapsed;
    }

    _this.state = {
      collapsed: collapsed,
      below: false
    };
    return _this;
  }

  _createClass(InternalSider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mql) {
        this.mql.addListener(this.responsiveHandler);
        this.responsiveHandler(this.mql);
      }

      if (this.props.siderHook) {
        this.props.siderHook.addSider(this.uniqueId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mql) {
        this.mql.removeListener(this.responsiveHandler);
      }

      if (this.props.siderHook) {
        this.props.siderHook.removeSider(this.uniqueId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var collapsed = this.state.collapsed;
      var collapsedWidth = this.props.collapsedWidth;
      return React.createElement(SiderContext.Provider, {
        value: {
          siderCollapsed: collapsed,
          collapsedWidth: collapsedWidth
        }
      }, React.createElement(_configProvider.ConfigConsumer, null, this.renderSider));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('collapsed' in nextProps) {
        return {
          collapsed: nextProps.collapsed
        };
      }

      return null;
    }
  }]);

  return InternalSider;
}(React.Component);

InternalSider.defaultProps = {
  collapsible: false,
  defaultCollapsed: false,
  reverseArrow: false,
  width: 200,
  collapsedWidth: 80,
  style: {},
  theme: 'dark'
};
(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function

var Sider =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Sider, _React$Component2);

  function Sider() {
    _classCallCheck(this, Sider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Sider).apply(this, arguments));
  }

  _createClass(Sider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
        return React.createElement(InternalSider, _extends({}, context, _this2.props));
      });
    }
  }]);

  return Sider;
}(React.Component);

exports["default"] = Sider;
//# sourceMappingURL=Sider.js.map


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(808);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(129);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(279)('keys');
var uid = __webpack_require__(192);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(74);
var global = __webpack_require__(98);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(191) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 281 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(816);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(826);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(128);
var dPs = __webpack_require__(820);
var enumBugKeys = __webpack_require__(280);
var IE_PROTO = __webpack_require__(278)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(413)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(821).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(99).f;
var has = __webpack_require__(110);
var TAG = __webpack_require__(85)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(85);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(98);
var core = __webpack_require__(74);
var LIBRARY = __webpack_require__(191);
var wksExt = __webpack_require__(285);
var defineProperty = __webpack_require__(99).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(193);
var createDesc = __webpack_require__(159);
var toIObject = __webpack_require__(111);
var toPrimitive = __webpack_require__(274);
var has = __webpack_require__(110);
var IE8_DOM_DEFINE = __webpack_require__(412);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(100) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"PatientInformationSheet__content__2ofSV","parentContainer":"PatientInformationSheet__parentContainer__1WLHZ","ant-carousel":"PatientInformationSheet__ant-carousel__2yPYE","slick-slide":"PatientInformationSheet__slick-slide__yyQph"};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(60)))

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(430);
} catch (err) {
  var index = __webpack_require__(430);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(26);

var _Event = _interopRequireDefault(__webpack_require__(909));

var _raf = _interopRequireDefault(__webpack_require__(198));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {
    return false;
  }

  return !element || element.offsetParent === null;
}

function isNotGrey(color) {
  // eslint-disable-next-line no-useless-escape
  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

  if (match && match[1] && match[2] && match[3]) {
    return !(match[1] === match[2] && match[2] === match[3]);
  }

  return true;
}

var Wave =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Wave, _React$Component);

  function Wave() {
    var _this;

    _classCallCheck(this, Wave);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Wave).apply(this, arguments));
    _this.animationStart = false;
    _this.destroy = false;

    _this.onClick = function (node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = _this.props.insertExtraNode;
      _this.extraNode = document.createElement('div');

      var _assertThisInitialize = _assertThisInitialized(_this),
          extraNode = _assertThisInitialize.extraNode;

      extraNode.className = 'ant-click-animating-node';

      var attributeName = _this.getAttributeName();

      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey

      styleForPesudo = styleForPesudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        // Add nonce if CSP exist
        if (_this.csp && _this.csp.nonce) {
          styleForPesudo.nonce = _this.csp.nonce;
        }

        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");

        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      _Event["default"].addStartEventListener(node, _this.onTransitionStart);

      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
    };

    _this.onTransitionStart = function (e) {
      if (_this.destroy) return;
      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));

      if (!e || e.target !== node) {
        return;
      }

      if (!_this.animationStart) {
        _this.resetEffect(node);
      }
    };

    _this.onTransitionEnd = function (e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      _this.resetEffect(e.target);
    };

    _this.bindAnimationEvent = function (node) {
      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this.clickWaveTimeoutId = window.setTimeout(function () {
          return _this.onClick(node, waveColor);
        }, 0);

        _raf["default"].cancel(_this.animationStartId);

        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this.animationStartId = (0, _raf["default"])(function () {
          _this.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    };

    _this.renderWave = function (_ref) {
      var csp = _ref.csp;
      var children = _this.props.children;
      _this.csp = csp;
      return children;
    };

    return _this;
  }

  _createClass(Wave, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);

      if (!node || node.nodeType !== 1) {
        return;
      }

      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }

      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }

      this.destroy = true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

      if (styleForPesudo) {
        styleForPesudo.innerHTML = '';
      }

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      _Event["default"].removeStartEventListener(node, this.onTransitionStart);

      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
    }
  }]);

  return Wave;
}(React.Component);

exports["default"] = Wave;
//# sourceMappingURL=wave.js.map


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(915);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(200),
    isKey = __webpack_require__(920),
    stringToPath = __webpack_require__(924),
    toString = __webpack_require__(953);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(295),
    isObjectLike = __webpack_require__(298);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296),
    getRawTag = __webpack_require__(922),
    objectToString = __webpack_require__(923);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(297);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(921);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(931),
    getValue = __webpack_require__(936);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(294);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(959);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

exports.argumentContainer = argumentContainer;
exports.identity = identity;
exports.flattenArray = flattenArray;
exports.treeTraverse = treeTraverse;
exports.flattenFields = flattenFields;
exports.normalizeValidateRules = normalizeValidateRules;
exports.getValidateTriggers = getValidateTriggers;
exports.getValueFromEvent = getValueFromEvent;
exports.getErrorStrs = getErrorStrs;
exports.getParams = getParams;
exports.isEmptyObject = isEmptyObject;
exports.hasRules = hasRules;
exports.startsWith = startsWith;

var _hoistNonReactStatics = __webpack_require__(241);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
}

function identity(obj) {
  return obj;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function treeTraverse() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tree = arguments[1];
  var isLeafNode = arguments[2];
  var errorMessage = arguments[3];
  var callback = arguments[4];

  if (isLeafNode(path, tree)) {
    callback(path, tree);
  } else if (tree === undefined || tree === null) {
    // Do nothing
  } else if (Array.isArray(tree)) {
    tree.forEach(function (subTree, index) {
      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
    });
  } else {
    // It's object and not a leaf node
    if (typeof tree !== 'object') {
      (0, _warning2['default'])(false, errorMessage);
      return;
    }
    Object.keys(tree).forEach(function (subTreeKey) {
      var subTree = tree[subTreeKey];
      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
    });
  }
}

function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
  var fields = {};
  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
    fields[path] = node;
  });
  return fields;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = (0, _extends3['default'])({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

function getValidateTriggers(validateRules) {
  return validateRules.filter(function (item) {
    return !!item.rules && item.rules.length;
  }).map(function (item) {
    return item.trigger;
  }).reduce(function (pre, curr) {
    return pre.concat(curr);
  }, []);
}

function getValueFromEvent(e) {
  // To support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var options = opt;
  var callback = cb;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(names)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    options: options,
    callback: callback
  };
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(38);

var _createChainedFunction = __webpack_require__(1051);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _KeyCode = __webpack_require__(132);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _placements = __webpack_require__(1052);

var _placements2 = _interopRequireDefault(_placements);

var _rcTrigger = __webpack_require__(133);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = function (_React$Component) {
  (0, _inherits3['default'])(Picker, _React$Component);

  function Picker(props) {
    (0, _classCallCheck3['default'])(this, Picker);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var open = void 0;
    if ('open' in props) {
      open = props.open;
    } else {
      open = props.defaultOpen;
    }
    var value = props.value || props.defaultValue;
    _this.saveCalendarRef = refFn.bind(_this, 'calendarInstance');

    _this.state = {
      open: open,
      value: value
    };
    return _this;
  }

  Picker.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    if (!prevState.open && this.state.open) {
      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
    }
  };

  Picker.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
  };

  Picker.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    var newState = {};
    var value = nextProps.value,
        open = nextProps.open;

    if ('value' in nextProps) {
      newState.value = value;
    }
    if (open !== undefined) {
      newState.open = open;
    }
    return newState;
  };

  Picker.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        dropdownClassName = props.dropdownClassName,
        transitionName = props.transitionName,
        children = props.children;

    var state = this.state;
    return _react2['default'].createElement(
      _rcTrigger2['default'],
      {
        popup: this.getCalendarElement(),
        popupAlign: align,
        builtinPlacements: _placements2['default'],
        popupPlacement: placement,
        action: disabled && !state.open ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getCalendarContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: state.open,
        onPopupVisibleChange: this.onVisibleChange,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      },
      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
    );
  };

  return Picker;
}(_react2['default'].Component);

Picker.propTypes = {
  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
  disabled: _propTypes2['default'].bool,
  transitionName: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOpenChange: _propTypes2['default'].func,
  children: _propTypes2['default'].func,
  getCalendarContainer: _propTypes2['default'].func,
  calendar: _propTypes2['default'].element,
  style: _propTypes2['default'].object,
  open: _propTypes2['default'].bool,
  defaultOpen: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  placement: _propTypes2['default'].any,
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  align: _propTypes2['default'].object,
  dateRender: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func
};
Picker.defaultProps = {
  prefixCls: 'rc-calendar-picker',
  style: {},
  align: {},
  placement: 'bottomLeft',
  defaultOpen: false,
  onChange: noop,
  onOpenChange: noop,
  onBlur: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onCalendarKeyDown = function (event) {
    if (event.keyCode === _KeyCode2['default'].ESC) {
      event.stopPropagation();
      _this2.close(_this2.focus);
    }
  };

  this.onCalendarSelect = function (value) {
    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
      _this2.close(_this2.focus);
    }
    props.onChange(value);
  };

  this.onKeyDown = function (event) {
    if (!_this2.state.open && (event.keyCode === _KeyCode2['default'].DOWN || event.keyCode === _KeyCode2['default'].ENTER)) {
      _this2.open();
      event.preventDefault();
    }
  };

  this.onCalendarOk = function () {
    _this2.close(_this2.focus);
  };

  this.onCalendarClear = function () {
    _this2.close(_this2.focus);
  };

  this.onCalendarBlur = function () {
    _this2.setOpen(false);
  };

  this.onVisibleChange = function (open) {
    _this2.setOpen(open);
  };

  this.getCalendarElement = function () {
    var props = _this2.props;
    var state = _this2.state;
    var calendarProps = props.calendar.props;
    var value = state.value;

    var defaultValue = value;
    var extraProps = {
      ref: _this2.saveCalendarRef,
      defaultValue: defaultValue || calendarProps.defaultValue,
      selectedValue: value,
      onKeyDown: _this2.onCalendarKeyDown,
      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, _this2.onCalendarOk),
      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, _this2.onCalendarSelect),
      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, _this2.onCalendarClear),
      onBlur: (0, _createChainedFunction2['default'])(calendarProps.onBlur, _this2.onCalendarBlur)
    };

    return _react2['default'].cloneElement(props.calendar, extraProps);
  };

  this.setOpen = function (open, callback) {
    var onOpenChange = _this2.props.onOpenChange;

    if (_this2.state.open !== open) {
      if (!('open' in _this2.props)) {
        _this2.setState({
          open: open
        }, callback);
      }
      onOpenChange(open);
    }
  };

  this.open = function (callback) {
    _this2.setOpen(true, callback);
  };

  this.close = function (callback) {
    _this2.setOpen(false, callback);
  };

  this.focus = function () {
    if (!_this2.state.open) {
      _reactDom2['default'].findDOMNode(_this2).focus();
    }
  };

  this.focusCalendar = function () {
    if (_this2.state.open && !!_this2.calendarInstance) {
      _this2.calendarInstance.focus();
    }
  };
};

(0, _reactLifecyclesCompat.polyfill)(Picker);

exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1115),
    mapCacheDelete = __webpack_require__(1122),
    mapCacheGet = __webpack_require__(1124),
    mapCacheHas = __webpack_require__(1125),
    mapCacheSet = __webpack_require__(1126);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(102),
    isSymbol = __webpack_require__(194);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validProgress = validProgress;

// eslint-disable-next-line import/prefer-default-export
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["u"] = toTitle;
/* harmony export (immutable) */ __webpack_exports__["k"] = getValuePropValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getPropValue;
/* unused harmony export isMultiple */
/* harmony export (immutable) */ __webpack_exports__["m"] = isCombobox;
/* harmony export (immutable) */ __webpack_exports__["n"] = isMultipleOrTags;
/* harmony export (immutable) */ __webpack_exports__["o"] = isMultipleOrTagsOrCombobox;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSingleMode;
/* harmony export (immutable) */ __webpack_exports__["t"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMapKey;
/* harmony export (immutable) */ __webpack_exports__["q"] = preventDefaultEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = findIndexInValueBySingleValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLabelFromPropsValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSelectKeys;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSELECTABLE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNSELECTABLE_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = findFirstMenuItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = includesSeparators;
/* harmony export (immutable) */ __webpack_exports__["s"] = splitBySeparators;
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultFilterFn;
/* harmony export (immutable) */ __webpack_exports__["v"] = validateOptionValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = saveRef;
/* harmony export (immutable) */ __webpack_exports__["f"] = generateUUID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function toTitle(title) {
  if (typeof title === 'string') {
    return title;
  }

  return '';
}
function getValuePropValue(child) {
  if (!child) {
    return null;
  }

  var props = child.props;

  if ('value' in props) {
    return props.value;
  }

  if (child.key) {
    return child.key;
  }

  if (child.type && child.type.isSelectOptGroup && props.label) {
    return props.label;
  }

  throw new Error("Need at least a key or a value or a label (only for OptGroup) for ".concat(child));
}
function getPropValue(child, prop) {
  if (prop === 'value') {
    return getValuePropValue(child);
  }

  return child.props[prop];
}
function isMultiple(props) {
  return props.multiple;
}
function isCombobox(props) {
  return props.combobox;
}
function isMultipleOrTags(props) {
  return props.multiple || props.tags;
}
function isMultipleOrTagsOrCombobox(props) {
  return isMultipleOrTags(props) || isCombobox(props);
}
function isSingleMode(props) {
  return !isMultipleOrTagsOrCombobox(props);
}
function toArray(value) {
  var ret = value;

  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }

  return ret;
}
function getMapKey(value) {
  return "".concat(typeof value, "-").concat(value);
}
function preventDefaultEvent(e) {
  e.preventDefault();
}
function findIndexInValueBySingleValue(value, singleValue) {
  var index = -1;

  if (value) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === singleValue) {
        index = i;
        break;
      }
    }
  }

  return index;
}
function getLabelFromPropsValue(value, key) {
  var label;
  value = toArray(value);

  if (value) {
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < value.length; i++) {
      if (value[i].key === key) {
        label = value[i].label;
        break;
      }
    }
  }

  return label;
}
function getSelectKeys(menuItems, value) {
  if (value === null || value === undefined) {
    return [];
  }

  var selectedKeys = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(menuItems, function (item) {
    var type = item.type;

    if (type.isMenuItemGroup) {
      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
    } else {
      var itemValue = getValuePropValue(item);
      var itemKey = item.key;

      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
        selectedKeys.push(itemKey);
      }
    }
  });
  return selectedKeys;
}
var UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};
var UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};
function findFirstMenuItem(children) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < children.length; i++) {
    var child = children[i];

    if (child.type.isMenuItemGroup) {
      var found = findFirstMenuItem(child.props.children);

      if (found) {
        return found;
      }
    } else if (!child.props.disabled) {
      return child;
    }
  }

  return null;
}
function includesSeparators(str, separators) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < separators.length; ++i) {
    if (str.lastIndexOf(separators[i]) > 0) {
      return true;
    }
  }

  return false;
}
function splitBySeparators(str, separators) {
  var reg = new RegExp("[".concat(separators.join(), "]"));
  return str.split(reg).filter(function (token) {
    return token;
  });
}
function defaultFilterFn(input, child) {
  if (child.props.disabled) {
    return false;
  }

  var value = toArray(getPropValue(child, this.props.optionFilterProp)).join('');
  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
}
function validateOptionValue(value, props) {
  if (isSingleMode(props) || isMultiple(props)) {
    return;
  }

  if (typeof value !== 'string') {
    throw new Error("Invalid `value` of type `".concat(typeof value, "` supplied to Option, ") + "expected `string` when `tags/combobox` is `true`.");
  }
}
function saveRef(instance, name) {
  return function (node) {
    instance[name] = node;
  };
}
function generateUUID() {
  if (false) {
    return 'test-uuid';
  }

  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:no-bitwise
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16); // tslint:disable-next-line:no-bitwise

    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(503));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).apply(this, arguments));

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.onChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }

      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
        _this.context.radioGroup.onChange(e);
      }
    };

    _this.renderRadio = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          style = props.style,
          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

      var radioGroup = context.radioGroup;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);

      var radioProps = _extends({}, restProps);

      if (radioGroup) {
        radioProps.name = radioGroup.name;
        radioProps.onChange = _this.onChange;
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
      }

      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
      return (// eslint-disable-next-line jsx-a11y/label-has-associated-control
        React.createElement("label", {
          className: wrapperClassString,
          style: style,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave
        }, React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
          prefixCls: prefixCls,
          ref: _this.saveCheckbox
        })), children !== undefined ? React.createElement("span", null, children) : null)
      );
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio);
    }
  }]);

  return Radio;
}(React.Component);

exports["default"] = Radio;
Radio.defaultProps = {
  type: 'radio'
};
Radio.contextTypes = {
  radioGroup: PropTypes.any
};
//# sourceMappingURL=radio.js.map


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var SignatureTrimmed = function (_React$Component) {
  _inherits(SignatureTrimmed, _React$Component);function SignatureTrimmed() {
    _classCallCheck(this, SignatureTrimmed);return _possibleConstructorReturn(this, (SignatureTrimmed.__proto__ || Object.getPrototypeOf(SignatureTrimmed)).apply(this, arguments));
  }_createClass(SignatureTrimmed, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getTrimmedCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return SignatureTrimmed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SignatureTrimmed);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1379);
//# sourceMappingURL=index.js.map


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(429));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = 24;
var defaultBottom = 24;
var defaultPlacement = 'topRight';
var defaultGetContainer;
var defaultCloseIcon;

function setNotificationConfig(options) {
  var duration = options.duration,
      placement = options.placement,
      bottom = options.bottom,
      top = options.top,
      getContainer = options.getContainer,
      closeIcon = options.closeIcon;

  if (duration !== undefined) {
    defaultDuration = duration;
  }

  if (placement !== undefined) {
    defaultPlacement = placement;
  }

  if (bottom !== undefined) {
    defaultBottom = bottom;
  }

  if (top !== undefined) {
    defaultTop = top;
  }

  if (getContainer !== undefined) {
    defaultGetContainer = getContainer;
  }

  if (closeIcon !== undefined) {
    defaultCloseIcon = closeIcon;
  }
}

function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
  var style;

  switch (placement) {
    case 'topLeft':
      style = {
        left: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'topRight':
      style = {
        right: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom: bottom
      };
      break;

    default:
      style = {
        right: 0,
        top: 'auto',
        bottom: bottom
      };
      break;
  }

  return style;
}

function getNotificationInstance(_ref, callback) {
  var prefixCls = _ref.prefixCls,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
      top = _ref.top,
      bottom = _ref.bottom,
      _ref$closeIcon = _ref.closeIcon,
      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
  var cacheKey = "".concat(prefixCls, "-").concat(placement);

  if (notificationInstance[cacheKey]) {
    callback(notificationInstance[cacheKey]);
    return;
  }

  var closeIconToRender = React.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, closeIcon || React.createElement(_icon["default"], {
    className: "".concat(prefixCls, "-close-icon"),
    type: "close"
  }));

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    className: "".concat(prefixCls, "-").concat(placement),
    style: getPlacementStyle(placement, top, bottom),
    getContainer: getContainer,
    closeIcon: closeIconToRender
  }, function (notification) {
    notificationInstance[cacheKey] = notification;
    callback(notification);
  });
}

var typeToIcon = {
  success: 'check-circle-o',
  info: 'info-circle-o',
  error: 'close-circle-o',
  warning: 'exclamation-circle-o'
};

function notice(args) {
  var outerPrefixCls = args.prefixCls || 'ant-notification';
  var prefixCls = "".concat(outerPrefixCls, "-notice");
  var duration = args.duration === undefined ? defaultDuration : args.duration;
  var iconNode = null;

  if (args.icon) {
    iconNode = React.createElement("span", {
      className: "".concat(prefixCls, "-icon")
    }, args.icon);
  } else if (args.type) {
    var iconType = typeToIcon[args.type];
    iconNode = React.createElement(_icon["default"], {
      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
      type: iconType
    });
  }

  var autoMarginTag = !args.description && iconNode ? React.createElement("span", {
    className: "".concat(prefixCls, "-message-single-line-auto-margin")
  }) : null;
  var placement = args.placement,
      top = args.top,
      bottom = args.bottom,
      getContainer = args.getContainer,
      closeIcon = args.closeIcon;
  getNotificationInstance({
    prefixCls: outerPrefixCls,
    placement: placement,
    top: top,
    bottom: bottom,
    getContainer: getContainer,
    closeIcon: closeIcon
  }, function (notification) {
    notification.notice({
      content: React.createElement("div", {
        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
      }, iconNode, React.createElement("div", {
        className: "".concat(prefixCls, "-message")
      }, autoMarginTag, args.message), React.createElement("div", {
        className: "".concat(prefixCls, "-description")
      }, args.description), args.btn ? React.createElement("span", {
        className: "".concat(prefixCls, "-btn")
      }, args.btn) : null),
      duration: duration,
      closable: true,
      onClose: args.onClose,
      onClick: args.onClick,
      key: args.key,
      style: args.style || {},
      className: args.className
    });
  });
}

var api = {
  open: notice,
  close: function close(key) {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      return notificationInstance[cacheKey].removeNotice(key);
    });
  },
  config: setNotificationConfig,
  destroy: function destroy() {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      notificationInstance[cacheKey].destroy();
      delete notificationInstance[cacheKey];
    });
  }
};
['success', 'info', 'warning', 'error'].forEach(function (type) {
  api[type] = function (args) {
    return api.open(_extends(_extends({}, args), {
      type: type
    }));
  };
});
api.warn = api.warning;
var _default = api;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1481);
//# sourceMappingURL=index.js.map


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _debounce = _interopRequireDefault(__webpack_require__(425));

var _configProvider = __webpack_require__(30);

var _type = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator

var defaultIndicator = null;

function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null

  if (indicator === null) {
    return null;
  }

  if (React.isValidElement(indicator)) {
    return React.cloneElement(indicator, {
      className: (0, _classnames["default"])(indicator.props.className, dotClassName)
    });
  }

  if (React.isValidElement(defaultIndicator)) {
    return React.cloneElement(defaultIndicator, {
      className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
    });
  }

  return React.createElement("span", {
    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }));
}

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}

var Spin =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Spin, _React$Component);

  function Spin(props) {
    var _this;

    _classCallCheck(this, Spin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Spin).call(this, props));

    _this.debouncifyUpdateSpinning = function (props) {
      var _ref = props || _this.props,
          delay = _ref.delay;

      if (delay) {
        _this.cancelExistingSpin();

        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
      }
    };

    _this.updateSpinning = function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;

      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    };

    _this.renderSpin = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          size = _a.size,
          tip = _a.tip,
          wrapperClassName = _a.wrapperClassName,
          style = _a.style,
          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);

      var spinning = _this.state.spinning;
      var prefixCls = getPrefixCls('spin', customizePrefixCls);
      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop

      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
      var spinElement = React.createElement("div", _extends({}, divProps, {
        style: style,
        className: spinClassName
      }), renderIndicator(prefixCls, _this.props), tip ? React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);

      if (_this.isNestedPattern()) {
        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
        return React.createElement("div", _extends({}, divProps, {
          className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning && React.createElement("div", {
          key: "loading"
        }, spinElement), React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this.props.children));
      }

      return spinElement;
    };

    var spinning = props.spinning,
        delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;

    _this.debouncifyUpdateSpinning(props);

    return _this;
  }

  _createClass(Spin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;

      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);

  return Spin;
}(React.Component);

Spin.defaultProps = {
  spinning: true,
  size: 'default',
  wrapperClassName: ''
};
Spin.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  spinning: PropTypes.bool,
  size: PropTypes.oneOf(SpinSizes),
  wrapperClassName: PropTypes.string,
  indicator: PropTypes.element
};
var _default = Spin;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1530),
    getValue = __webpack_require__(1536);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(167),
    isObject = __webpack_require__(114);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(137);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(516);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(335),
    isLength = __webpack_require__(520);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(167),
    isObjectLike = __webpack_require__(138);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDropdown = _interopRequireDefault(__webpack_require__(1607));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _type = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).apply(this, arguments));

    _this.renderOverlay = function (prefixCls) {
      // rc-dropdown already can process the function of overlay, but we have check logic here.
      // So we need render the element to check and pass back to rc-dropdown.
      var overlay = _this.props.overlay;
      var overlayNode;

      if (typeof overlay === 'function') {
        overlayNode = overlay();
      } else {
        overlayNode = overlay;
      }

      overlayNode = React.Children.only(overlayNode);
      var overlayProps = overlayNode.props; // Warning if use other mode

      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
      // menu should be focusable in dropdown defaultly

      var _overlayProps$selecta = overlayProps.selectable,
          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
          _overlayProps$focusab = overlayProps.focusable,
          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
      var expandIcon = React.createElement("span", {
        className: "".concat(prefixCls, "-menu-submenu-arrow")
      }, React.createElement(_icon["default"], {
        type: "right",
        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
      }));
      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : React.cloneElement(overlayNode, {
        mode: 'vertical',
        selectable: selectable,
        focusable: focusable,
        expandIcon: expandIcon
      });
      return fixedModeOverlay;
    };

    _this.renderDropDown = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          children = _this$props.children,
          trigger = _this$props.trigger,
          disabled = _this$props.disabled,
          getPopupContainer = _this$props.getPopupContainer;
      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
      var child = React.Children.only(children);
      var dropdownTrigger = React.cloneElement(child, {
        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
        disabled: disabled
      });
      var triggerActions = disabled ? [] : trigger;
      var alignPoint;

      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
      }

      return React.createElement(_rcDropdown["default"], _extends({
        alignPoint: alignPoint
      }, _this.props, {
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: _this.getTransitionName(),
        trigger: triggerActions,
        overlay: function overlay() {
          return _this.renderOverlay(prefixCls);
        }
      }), dropdownTrigger);
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: "getTransitionName",
    value: function getTransitionName() {
      var _this$props2 = this.props,
          _this$props2$placemen = _this$props2.placement,
          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
          transitionName = _this$props2.transitionName;

      if (transitionName !== undefined) {
        return transitionName;
      }

      if (placement.indexOf('top') >= 0) {
        return 'slide-down';
      }

      return 'slide-up';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown);
    }
  }]);

  return Dropdown;
}(React.Component);

exports["default"] = Dropdown;
Dropdown.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1,
  placement: 'bottomLeft'
};
//# sourceMappingURL=dropdown.js.map


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuContext = (0, _createReactContext["default"])({
  inlineCollapsed: false
});
var _default = MenuContext;
exports["default"] = _default;
//# sourceMappingURL=MenuContext.js.map


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1637),
    isObjectLike = __webpack_require__(170);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(91);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1654),
    mapCacheDelete = __webpack_require__(1661),
    mapCacheGet = __webpack_require__(1663),
    mapCacheHas = __webpack_require__(1664),
    mapCacheSet = __webpack_require__(1665);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1682),
    baseKeys = __webpack_require__(1689),
    isArrayLike = __webpack_require__(545);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(92),
    isSymbol = __webpack_require__(349);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(170);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1731);

__webpack_require__(63);
//# sourceMappingURL=index.js.map


/***/ }),
/* 351 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1738);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1806);
//# sourceMappingURL=index.js.map


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _rcInputNumber = _interopRequireDefault(__webpack_require__(1808));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InputNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  function InputNumber() {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputNumber).apply(this, arguments));

    _this.saveInputNumber = function (inputNumberRef) {
      _this.inputNumberRef = inputNumberRef;
    };

    _this.renderInputNumber = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          className = _a.className,
          size = _a.size,
          customizePrefixCls = _a.prefixCls,
          others = __rest(_a, ["className", "size", "prefixCls"]);

      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
      var upIcon = React.createElement(_icon["default"], {
        type: "up",
        className: "".concat(prefixCls, "-handler-up-inner")
      });
      var downIcon = React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-handler-down-inner")
      });
      return React.createElement(_rcInputNumber["default"], _extends({
        ref: _this.saveInputNumber,
        className: inputNumberClass,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls
      }, others));
    };

    return _this;
  }

  _createClass(InputNumber, [{
    key: "focus",
    value: function focus() {
      this.inputNumberRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputNumberRef.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber);
    }
  }]);

  return InputNumber;
}(React.Component);

exports["default"] = InputNumber;
InputNumber.defaultProps = {
  step: 1
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(303);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.isEventFromHandle = isEventFromHandle;
exports.isValueOutOfRange = isValueOutOfRange;
exports.isNotTouchEvent = isNotTouchEvent;
exports.getClosestPoint = getClosestPoint;
exports.getPrecision = getPrecision;
exports.getMousePosition = getMousePosition;
exports.getTouchPosition = getTouchPosition;
exports.getHandleCenterPosition = getHandleCenterPosition;
exports.ensureValueInRange = ensureValueInRange;
exports.ensureValuePrecision = ensureValuePrecision;
exports.pauseEvent = pauseEvent;
exports.calculateNextValue = calculateNextValue;
exports.getKeyboardValueMutator = getKeyboardValueMutator;

var _reactDom = __webpack_require__(26);

var _KeyCode = __webpack_require__(132);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === (0, _reactDom.findDOMNode)(handles[key]);
    });
  } catch (error) {
    return false;
  }
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };

  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}

function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;
  switch (e.keyCode) {
    case _KeyCode2['default'].UP:
      method = vertical && reverse ? decrease : increase;break;
    case _KeyCode2['default'].RIGHT:
      method = !vertical && reverse ? decrease : increase;break;
    case _KeyCode2['default'].DOWN:
      method = vertical && reverse ? increase : decrease;break;
    case _KeyCode2['default'].LEFT:
      method = !vertical && reverse ? increase : decrease;break;

    case _KeyCode2['default'].END:
      return function (value, props) {
        return props.max;
      };
    case _KeyCode2['default'].HOME:
      return function (value, props) {
        return props.min;
      };
    case _KeyCode2['default'].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case _KeyCode2['default'].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(3549),
    baseMatchesProperty = __webpack_require__(3612),
    identity = __webpack_require__(3623),
    isArray = __webpack_require__(94),
    property = __webpack_require__(3624);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149),
    root = __webpack_require__(93);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3567),
    mapCacheDelete = __webpack_require__(3574),
    mapCacheGet = __webpack_require__(3576),
    mapCacheHas = __webpack_require__(3577),
    mapCacheSet = __webpack_require__(3578);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(3579),
    isObjectLike = __webpack_require__(174);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(94),
    isSymbol = __webpack_require__(237);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(607);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Context__ = __webpack_require__(239);










var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_8__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;
    var OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_6_react__["Component"];

    if (pure) {
      OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"];
    }

    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var lastSelectorFactoryOptions;
      var sourceSelector;
      return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }

        if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
          lastStore = store;
          lastSelectorFactoryOptions = selectorFactoryOptions;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }

        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);
        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }

    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
      return function selectChildElement(WrappedComponent, childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastComponent = WrappedComponent;
          lastChildElement = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, childProps, {
            ref: forwardRef
          }));
        }

        return lastChildElement;
      };
    }

    var Connect =
    /*#__PURE__*/
    function (_OuterBaseComponent) {
      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _OuterBaseComponent);

      function Connect(props) {
        var _this;

        _this = _OuterBaseComponent.call(this, props) || this;
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
        return _this;
      }

      var _proto = Connect.prototype;

      _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
        // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
        return this.renderWrappedComponent(value);
      };

      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;

        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }

        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
        return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
      };

      _proto.render = function render() {
        var ContextToUse = this.props.context && this.props.context.Consumer && Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
      };

      return Connect;
    }(OuterBaseComponent);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(367);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(368);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(107);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



var createSelectors = function createSelectors(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;

  var isRouter = function isRouter(value) {
    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
  };

  var getRouter = function getRouter(state) {
    var router = toJS(getIn(state, ['router']));

    if (!isRouter(router)) {
      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
    }

    return router;
  };

  var getLocation = function getLocation(state) {
    return toJS(getIn(getRouter(state), ['location']));
  };

  var getAction = function getAction(state) {
    return toJS(getIn(getRouter(state), ['action']));
  };

  var getSearch = function getSearch(state) {
    return toJS(getIn(getRouter(state), ['location', 'search']));
  };

  var getHash = function getHash(state) {
    return toJS(getIn(getRouter(state), ['location', 'hash']));
  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
  // of the location changes. That's why `createMatchSelector` memoizes
  // the latest result based on the location's pathname.


  var createMatchSelector = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function (state) {
      var _ref = getLocation(state) || {},
          pathname = _ref.pathname;

      if (pathname === lastPathname) {
        return lastMatch;
      }

      lastPathname = pathname;
      var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(pathname, path);

      if (!match || !lastMatch || match.url !== lastMatch.url) {
        lastMatch = match;
      }

      return lastMatch;
    };
  };

  return {
    getLocation: getLocation,
    getAction: getAction,
    getRouter: getRouter,
    getSearch: getSearch,
    getHash: getHash,
    createMatchSelector: createMatchSelector
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createSelectors);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(119),
    isObject = __webpack_require__(89);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(375);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    arrayMap = __webpack_require__(121),
    isArray = __webpack_require__(79),
    isSymbol = __webpack_require__(153);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(680);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);
var settle = __webpack_require__(684);
var buildURL = __webpack_require__(686);
var parseHeaders = __webpack_require__(687);
var isURLSameOrigin = __webpack_require__(688);
var createError = __webpack_require__(379);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(689);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(685);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var util = __webpack_require__(250);

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = util.assign(
    {
        'default': Format.RFC3986,
        formatters: {
            RFC1738: function (value) {
                return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function (value) {
                return String(value);
            }
        }
    },
    Format
);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(251),
    arrayEach = __webpack_require__(707),
    assignValue = __webpack_require__(252),
    baseAssign = __webpack_require__(708),
    baseAssignIn = __webpack_require__(715),
    cloneBuffer = __webpack_require__(718),
    copyArray = __webpack_require__(719),
    copySymbols = __webpack_require__(720),
    copySymbolsIn = __webpack_require__(722),
    getAllKeys = __webpack_require__(391),
    getAllKeysIn = __webpack_require__(262),
    getTag = __webpack_require__(185),
    initCloneArray = __webpack_require__(726),
    initCloneByTag = __webpack_require__(727),
    initCloneObject = __webpack_require__(732),
    isArray = __webpack_require__(79),
    isBuffer = __webpack_require__(254),
    isMap = __webpack_require__(734),
    isObject = __webpack_require__(89),
    isSet = __webpack_require__(736),
    keys = __webpack_require__(124),
    keysIn = __webpack_require__(258);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(385);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(709),
    isArguments = __webpack_require__(253),
    isArray = __webpack_require__(79),
    isBuffer = __webpack_require__(254),
    isIndex = __webpack_require__(184),
    isTypedArray = __webpack_require__(387);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(712),
    baseUnary = __webpack_require__(156),
    nodeUtil = __webpack_require__(256);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(260),
    getPrototype = __webpack_require__(261),
    getSymbols = __webpack_require__(259),
    stubArray = __webpack_require__(389);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(392),
    getSymbols = __webpack_require__(259),
    keys = __webpack_require__(124);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(260),
    isArray = __webpack_require__(79);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(746);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(747),
    shortOut = __webpack_require__(749);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(266),
    arraySome = __webpack_require__(756),
    cacheHas = __webpack_require__(267);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(402),
    baseIsNaN = __webpack_require__(773),
    strictIndexOf = __webpack_require__(774);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMemoize */
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _configProvider = __webpack_require__(30);

var _RowContext = _interopRequireDefault(__webpack_require__(407));

var _type = __webpack_require__(81);

var _responsiveObserve = _interopRequireWildcard(__webpack_require__(799));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');

var Row =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Row).apply(this, arguments));
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);

      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
        marginLeft: gutter[0] / -2,
        marginRight: gutter[0] / -2
      } : {}), gutter[1] > 0 ? {
        marginTop: gutter[1] / -2,
        marginBottom: gutter[1] / -2
      } : {}), style);

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return React.createElement(_RowContext["default"].Provider, {
        value: {
          gutter: gutter
        }
      }, React.createElement("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.token = _responsiveObserve["default"].subscribe(function (screens) {
        var gutter = _this2.props.gutter;

        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
          _this2.setState({
            screens: screens
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _responsiveObserve["default"].unsubscribe(this.token);
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var results = [0, 0];
      var gutter = this.props.gutter;
      var screens = this.state.screens;
      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
      normalizedGutter.forEach(function (g, index) {
        if (_typeof(g) === 'object') {
          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
            var breakpoint = _responsiveObserve.responsiveArray[i];

            if (screens[breakpoint] && g[breakpoint] !== undefined) {
              results[index] = g[breakpoint];
              break;
            }
          }
        } else {
          results[index] = g || 0;
        }
      });
      return results;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
    }
  }]);

  return Row;
}(React.Component);

exports["default"] = Row;
Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: PropTypes.oneOf(['flex']),
  align: PropTypes.oneOf(RowAligns),
  justify: PropTypes.oneOf(RowJustify),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  prefixCls: PropTypes.string
};
//# sourceMappingURL=row.js.map


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowContext = (0, _createReactContext["default"])({});
var _default = RowContext;
exports["default"] = _default;
//# sourceMappingURL=RowContext.js.map


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(800);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _RowContext = _interopRequireDefault(__webpack_require__(407));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);

var Col =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Col).apply(this, arguments));

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};
        var propSize = props[size];

        if (typeof propSize === 'number') {
          sizeProps.span = propSize;
        } else if (_typeof(propSize) === 'object') {
          sizeProps = propSize || {};
        }

        delete others[size];
        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter) {
          style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
            paddingLeft: gutter[0] / 2,
            paddingRight: gutter[0] / 2
          } : {}), gutter[1] > 0 ? {
            paddingTop: gutter[1] / 2,
            paddingBottom: gutter[1] / 2
          } : {}), style);
        }

        return React.createElement("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
    }
  }]);

  return Col;
}(React.Component);

exports["default"] = Col;
Col.propTypes = {
  span: PropTypes.number,
  order: PropTypes.number,
  offset: PropTypes.number,
  push: PropTypes.number,
  pull: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};
//# sourceMappingURL=col.js.map


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayoutContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var LayoutContext = (0, _createReactContext["default"])({
  siderHook: {
    addSider: function addSider() {
      return null;
    },
    removeSider: function removeSider() {
      return null;
    }
  }
});
exports.LayoutContext = LayoutContext;

function generator(_ref) {
  var suffixCls = _ref.suffixCls,
      tagName = _ref.tagName,
      displayName = _ref.displayName;
  return function (BasicComponent) {
    var _a;

    return _a =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Adapter, _React$Component);

      function Adapter() {
        var _this;

        _classCallCheck(this, Adapter);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Adapter).apply(this, arguments));

        _this.renderComponent = function (_ref2) {
          var getPrefixCls = _ref2.getPrefixCls;
          var customizePrefixCls = _this.props.prefixCls;
          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
          return React.createElement(BasicComponent, _extends({
            prefixCls: prefixCls,
            tagName: tagName
          }, _this.props));
        };

        return _this;
      }

      _createClass(Adapter, [{
        key: "render",
        value: function render() {
          return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
        }
      }]);

      return Adapter;
    }(React.Component), _a.displayName = displayName, _a;
  };
}

var Basic = function Basic(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      tagName = props.tagName,
      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);

  var classString = (0, _classnames["default"])(className, prefixCls);
  return React.createElement(tagName, _extends({
    className: classString
  }, others), children);
};

var BasicLayout =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(BasicLayout, _React$Component2);

  function BasicLayout() {
    var _this2;

    _classCallCheck(this, BasicLayout);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BasicLayout).apply(this, arguments));
    _this2.state = {
      siders: []
    };
    return _this2;
  }

  _createClass(BasicLayout, [{
    key: "getSiderHook",
    value: function getSiderHook() {
      var _this3 = this;

      return {
        addSider: function addSider(id) {
          _this3.setState(function (state) {
            return {
              siders: [].concat(_toConsumableArray(state.siders), [id])
            };
          });
        },
        removeSider: function removeSider(id) {
          _this3.setState(function (state) {
            return {
              siders: state.siders.filter(function (currentId) {
                return currentId !== id;
              })
            };
          });
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          prefixCls = _a.prefixCls,
          className = _a.className,
          children = _a.children,
          hasSider = _a.hasSider,
          Tag = _a.tagName,
          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);

      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
      return React.createElement(LayoutContext.Provider, {
        value: {
          siderHook: this.getSiderHook()
        }
      }, React.createElement(Tag, _extends({
        className: classString
      }, others), children));
    }
  }]);

  return BasicLayout;
}(React.Component);

var Layout = generator({
  suffixCls: 'layout',
  tagName: 'section',
  displayName: 'Layout'
})(BasicLayout);
var Header = generator({
  suffixCls: 'layout-header',
  tagName: 'header',
  displayName: 'Header'
})(Basic);
var Footer = generator({
  suffixCls: 'layout-footer',
  tagName: 'footer',
  displayName: 'Footer'
})(Basic);
var Content = generator({
  suffixCls: 'layout-content',
  tagName: 'main',
  displayName: 'Content'
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
var _default = Layout;
exports["default"] = _default;
//# sourceMappingURL=layout.js.map


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(100) && !__webpack_require__(130)(function () {
  return Object.defineProperty(__webpack_require__(413)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(129);
var document = __webpack_require__(98).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(110);
var toIObject = __webpack_require__(111);
var arrayIndexOf = __webpack_require__(810)(false);
var IE_PROTO = __webpack_require__(278)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(275);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(277);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a"]; });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(814), __esModule: true };

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(818)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(420)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(191);
var $export = __webpack_require__(97);
var redefine = __webpack_require__(421);
var hide = __webpack_require__(127);
var Iterators = __webpack_require__(161);
var $iterCreate = __webpack_require__(819);
var setToStringTag = __webpack_require__(284);
var getPrototypeOf = __webpack_require__(422);
var ITERATOR = __webpack_require__(85)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(127);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(110);
var toObject = __webpack_require__(160);
var IE_PROTO = __webpack_require__(278)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(414);
var hiddenKeys = __webpack_require__(280).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1 = __importDefault(__webpack_require__(844));
exports.generate = generate_1.default;
var presetPrimaryColors = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666',
};
exports.presetPrimaryColors = presetPrimaryColors;
var presetPalettes = {};
exports.presetPalettes = presetPalettes;
Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = generate_1.default(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];
});
var red = presetPalettes.red;
exports.red = red;
var volcano = presetPalettes.volcano;
exports.volcano = volcano;
var gold = presetPalettes.gold;
exports.gold = gold;
var orange = presetPalettes.orange;
exports.orange = orange;
var yellow = presetPalettes.yellow;
exports.yellow = yellow;
var lime = presetPalettes.lime;
exports.lime = lime;
var green = presetPalettes.green;
exports.green = green;
var cyan = presetPalettes.cyan;
exports.cyan = cyan;
var blue = presetPalettes.blue;
exports.blue = blue;
var geekblue = presetPalettes.geekblue;
exports.geekblue = geekblue;
var purple = presetPalettes.purple;
exports.purple = purple;
var magenta = presetPalettes.magenta;
exports.magenta = magenta;
var grey = presetPalettes.grey;
exports.grey = grey;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(163),
    now = __webpack_require__(864),
    toNumber = __webpack_require__(427);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(163),
    isSymbol = __webpack_require__(194);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(893);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(199)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 434 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(84);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(41);

var _extends6 = _interopRequireDefault(_extends5);

var _toConsumableArray2 = __webpack_require__(303);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(968);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _unsafeLifecyclesPolyfill = __webpack_require__(972);

var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);

var _asyncValidator = __webpack_require__(973);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

var _get = __webpack_require__(995);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(437);

var _set2 = _interopRequireDefault(_set);

var _eq = __webpack_require__(301);

var _eq2 = _interopRequireDefault(_eq);

var _createFieldsStore = __webpack_require__(1001);

var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);

var _utils = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prefer-es6-class */
/* eslint-disable prefer-promise-reject-errors */

var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      formName = option.name,
      withRef = option.withRef;


  return function decorate(WrappedComponent) {
    var Form = (0, _createReactClass2['default'])({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});

        this.instances = {};
        this.cachedBind = {};
        this.clearedFieldMetaCache = {};

        this.renderFields = {};
        this.domFields = {};

        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          _this[key] = function () {
            var _fieldsStore;

            if (false) {
              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            }
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentDidMount: function componentDidMount() {
        this.cleanUpUselessFields();
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      componentDidUpdate: function componentDidUpdate() {
        this.cleanUpUselessFields();
      },
      onCollectCommon: function onCollectCommon(name, action, args) {
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          var valuesAll = this.fieldsStore.getAllValues();
          var valuesAllSet = {};
          valuesAll[name] = value;
          Object.keys(valuesAll).forEach(function (key) {
            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
          });
          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), (0, _set2['default'])({}, name, value), valuesAllSet);
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: (0, _extends6['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;


        this.fieldsStore.setFieldsAsDirty();

        var newField = (0, _extends6['default'])({}, field, {
          dirty: (0, _utils.hasRules)(validate)
        });
        this.setFields((0, _defineProperty3['default'])({}, name, newField));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var newField = (0, _extends6['default'])({}, field, {
          dirty: true
        });

        this.fieldsStore.setFieldsAsDirty();

        this.validateFieldsInternal([newField], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        if (!this.cachedBind[name]) {
          this.cachedBind[name] = {};
        }
        var cache = this.cachedBind[name];
        if (!cache[action] || cache[action].oriFn !== fn) {
          cache[action] = {
            fn: fn.bind(this, name, action),
            oriFn: fn
          };
        }
        return cache[action].fn;
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          // We should put field in record if it is rendered
          _this2.renderFields[name] = true;

          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return _react2['default'].cloneElement(fieldElem, (0, _extends6['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }
        if (false) {
          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`. Check field: ' + name);
          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
        }

        delete this.clearedFieldMetaCache[name];

        var fieldOption = (0, _extends6['default'])({
          name: name,
          trigger: DEFAULT_TRIGGER,
          valuePropName: 'value',
          validate: []
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var inputProps = (0, _extends6['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
        }

        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = (0, _extends6['default'])({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        // This field is rendered, record it
        this.renderFields[name] = true;

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return (0, _utils.flattenArray)(actionRules);
      },
      setFields: function setFields(maybeNestedFields, callback) {
        var _this4 = this;

        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = Object.keys(fields).reduce(function (acc, name) {
            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
          }, {});
          onFieldsChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedFields, this.fieldsStore.getNestedAllFields());
        }
        this.forceUpdate(callback);
      },
      setFieldsValue: function setFieldsValue(changedValues, callback) {
        var fieldsMeta = this.fieldsStore.fieldsMeta;

        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
        var newFields = Object.keys(values).reduce(function (acc, name) {
          var isRegistered = fieldsMeta[name];
          if (false) {
            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
          if (isRegistered) {
            var value = values[name];
            acc[name] = {
              value: value
            };
          }
          return acc;
        }, {});
        this.setFields(newFields, callback);
        if (onValuesChange) {
          var allValues = this.fieldsStore.getAllValues();
          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedValues, allValues);
        }
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          var _fieldMeta = this.fieldsStore.getFieldMeta(name);
          if (!_fieldMeta.preserve) {
            // after destroy, delete data
            this.clearedFieldMetaCache[name] = {
              field: this.fieldsStore.getField(name),
              meta: _fieldMeta
            };
            this.clearField(name);
          }
          delete this.domFields[name];
          return;
        }
        this.domFields[name] = true;
        this.recoverClearedField(name);
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            } else if (typeof ref === 'function') {
              ref(component);
            } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
              ref.current = component;
            }
          }
        }
        this.instances[name] = component;
      },
      cleanUpUselessFields: function cleanUpUselessFields() {
        var _this5 = this;

        var fieldList = this.fieldsStore.getAllFieldsName();
        var removedList = fieldList.filter(function (field) {
          var fieldMeta = _this5.fieldsStore.getFieldMeta(field);
          return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
        });
        if (removedList.length) {
          removedList.forEach(this.clearField);
        }
        this.renderFields = {};
      },
      clearField: function clearField(name) {
        this.fieldsStore.clearField(name);
        delete this.instances[name];
        delete this.cachedBind[name];
      },
      resetFields: function resetFields(ns) {
        var _this6 = this;

        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
        if (ns) {
          var names = Array.isArray(ns) ? ns : [ns];
          names.forEach(function (name) {
            return delete _this6.clearedFieldMetaCache[name];
          });
        } else {
          this.clearedFieldMetaCache = {};
        }
      },
      recoverClearedField: function recoverClearedField(name) {
        if (this.clearedFieldMetaCache[name]) {
          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
          delete this.clearedFieldMetaCache[name];
        }
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this7 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
          var newField = (0, _extends6['default'])({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this7.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this7.fieldsStore.getFieldValue(f);
        });
        if (callback && (0, _utils.isEmptyObject)(allFields)) {
          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
          return;
        }
        var validator = new _asyncValidator2['default'](allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = (0, _extends6['default'])({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var errorFieldName = e.field;
              var fieldName = errorFieldName;

              // Handle using array validation rule.
              // ref: https://github.com/ant-design/ant-design/issues/14275
              Object.keys(allRules).some(function (ruleFieldName) {
                var rules = allRules[ruleFieldName] || [];

                // Exist if match rule
                if (ruleFieldName === errorFieldName) {
                  fieldName = ruleFieldName;
                  return true;
                }

                // Skip if not match array type
                if (rules.every(function (_ref2) {
                  var type = _ref2.type;
                  return type !== 'array';
                }) || errorFieldName.indexOf(ruleFieldName + '.') !== 0) {
                  return false;
                }

                // Exist if match the field name
                var restPath = errorFieldName.slice(ruleFieldName.length + 1);
                if (/^\d+$/.test(restPath)) {
                  fieldName = ruleFieldName;
                  return true;
                }

                return false;
              });

              var field = (0, _get2['default'])(errorsGroup, fieldName);
              if (typeof field !== 'object' || Array.isArray(field)) {
                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
            var nowField = _this7.fieldsStore.getField(name);
            // avoid concurrency problems
            if (!(0, _eq2['default'])(nowField.value, allValues[name])) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this7.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref3) {
                var name = _ref3.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                (0, _set2['default'])(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this8 = this;

        var pending = new Promise(function (resolve, reject) {
          var _getParams = (0, _utils.getParams)(ns, opt, cb),
              names = _getParams.names,
              options = _getParams.options;

          var _getParams2 = (0, _utils.getParams)(ns, opt, cb),
              callback = _getParams2.callback;

          if (!callback || typeof callback === 'function') {
            var oldCb = callback;
            callback = function callback(errors, values) {
              if (oldCb) {
                oldCb(errors, values);
              }
              if (errors) {
                reject({ errors: errors, values: values });
              } else {
                resolve(values);
              }
            };
          }
          var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
          var fields = fieldNames.filter(function (name) {
            var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
            return (0, _utils.hasRules)(fieldMeta.validate);
          }).map(function (name) {
            var field = _this8.fieldsStore.getField(name);
            field.value = _this8.fieldsStore.getFieldValue(name);
            return field;
          });
          if (!fields.length) {
            callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
            return;
          }
          if (!('firstFields' in options)) {
            options.firstFields = fieldNames.filter(function (name) {
              var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
              return !!fieldMeta.validateFirst;
            });
          }
          _this8.validateFieldsInternal(fields, {
            fieldNames: fieldNames,
            options: options
          }, callback);
        });
        pending['catch'](function (e) {
          // eslint-disable-next-line no-console
          if (console.error && "production" !== 'production') {
            // eslint-disable-next-line no-console
            console.error(e);
          }
          return e;
        });
        return pending;
      },
      isSubmitting: function isSubmitting() {
        if (false) {
          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this9 = this;

        if (false) {
          (0, _warning2['default'])(false, '`submit` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        var fn = function fn() {
          _this9.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']); // eslint-disable-line

        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
        if (withRef) {
          if (false) {
            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          }
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, (0, _extends6['default'])({}, formProps, restProps));
        return _react2['default'].createElement(WrappedComponent, props);
      }
    });

    return (0, _utils.argumentContainer)((0, _unsafeLifecyclesPolyfill2['default'])(Form), WrappedComponent);
  };
}

exports['default'] = createBaseForm;
module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(997);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.isFormField = isFormField;
exports["default"] = createFormField;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Field = function Field(fields) {
  (0, _classCallCheck3["default"])(this, Field);

  (0, _extends3["default"])(this, fields);
};

function isFormField(obj) {
  return obj instanceof Field;
}

function createFormField(field) {
  if (isFormField(field)) {
    return field;
  }
  return new Field(field);
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
var FIELD_META_PROP = 'data-__meta';
exports.FIELD_META_PROP = FIELD_META_PROP;
var FIELD_DATA_PROP = 'data-__field';
exports.FIELD_DATA_PROP = FIELD_DATA_PROP;
//# sourceMappingURL=constants.js.map


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormContext = (0, _createReactContext["default"])({
  labelAlign: 'right',
  vertical: false
});
var _default = FormContext;
exports["default"] = _default;
//# sourceMappingURL=context.js.map


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPrefixSuffix = hasPrefixSuffix;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _type = __webpack_require__(81);

var _Input = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ClearableInputType = (0, _type.tuple)('text', 'input');

function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

var ClearableLabeledInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClearableLabeledInput, _React$Component);

  function ClearableLabeledInput() {
    _classCallCheck(this, ClearableLabeledInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClearableLabeledInput).apply(this, arguments));
  }

  _createClass(ClearableLabeledInput, [{
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var _this$props = this.props,
          allowClear = _this$props.allowClear,
          value = _this$props.value,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          inputType = _this$props.inputType,
          handleReset = _this$props.handleReset;

      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
        return null;
      }

      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
      return React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        onClick: handleReset,
        className: className,
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props2 = this.props,
          suffix = _this$props2.suffix,
          allowClear = _this$props2.allowClear;

      if (suffix || allowClear) {
        return React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }

      return null;
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, element) {
      var _classNames;

      var props = this.props;
      var suffix = this.renderSuffix(prefixCls);

      if (!hasPrefixSuffix(props)) {
        return React.cloneElement(element, {
          value: props.value
        });
      }

      var prefix = props.prefix ? React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, props.prefix) : null;
      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
      return React.createElement("span", {
        className: affixWrapperCls,
        style: props.style
      }, prefix, React.cloneElement(element, {
        style: null,
        value: props.value,
        className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
      }), suffix);
    }
  }, {
    key: "renderInputWithLabel",
    value: function renderInputWithLabel(prefixCls, labeledElement) {
      var _classNames3;

      var _this$props3 = this.props,
          addonBefore = _this$props3.addonBefore,
          addonAfter = _this$props3.addonAfter,
          style = _this$props3.style,
          size = _this$props3.size,
          className = _this$props3.className; // Not wrap when there is not addons

      if (!addonBefore && !addonAfter) {
        return labeledElement;
      }

      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? React.createElement("span", {
        className: addonClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? React.createElement("span", {
        className: addonClassName
      }, addonAfter) : null;
      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper

      return React.createElement("span", {
        className: mergedGroupClassName,
        style: style
      }, React.createElement("span", {
        className: mergedWrapperClassName
      }, addonBeforeNode, React.cloneElement(labeledElement, {
        style: null
      }), addonAfterNode));
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function renderTextAreaWithClearIcon(prefixCls, element) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          allowClear = _this$props4.allowClear,
          className = _this$props4.className,
          style = _this$props4.style;

      if (!allowClear) {
        return React.cloneElement(element, {
          value: value
        });
      }

      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
      return React.createElement("span", {
        className: affixWrapperCls,
        style: style
      }, React.cloneElement(element, {
        style: null,
        value: value
      }), this.renderClearIcon(prefixCls));
    }
  }, {
    key: "renderClearableLabeledInput",
    value: function renderClearableLabeledInput() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          inputType = _this$props5.inputType,
          element = _this$props5.element;

      if (inputType === ClearableInputType[0]) {
        return this.renderTextAreaWithClearIcon(prefixCls, element);
      }

      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderClearableLabeledInput();
    }
  }]);

  return ClearableLabeledInput;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
var _default = ClearableLabeledInput;
exports["default"] = _default;
//# sourceMappingURL=ClearableLabeledInput.js.map


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(441));

var _ResizableTextArea = _interopRequireDefault(__webpack_require__(1010));

var _configProvider = __webpack_require__(30);

var _Input = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextArea).call(this, props));

    _this.saveTextArea = function (resizableTextArea) {
      _this.resizableTextArea = resizableTextArea;
    };

    _this.saveClearableInput = function (clearableInput) {
      _this.clearableInput = clearableInput;
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, function () {
        _this.resizableTextArea.resizeTextarea();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.resizableTextArea.renderTextArea();

        _this.focus();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.renderTextArea = function (prefixCls) {
      return React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        onKeyDown: _this.handleKeyDown,
        onChange: _this.handleChange,
        ref: _this.saveTextArea
      }));
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "text",
        value: (0, _Input.fixControlledValue)(value),
        element: _this.renderTextArea(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.resizableTextArea.textArea.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(TextArea);
var _default = TextArea;
exports["default"] = _default;
//# sourceMappingURL=TextArea.js.map


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactIs = __webpack_require__(151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toArray(children) {
  var ret = [];

  _react.default.Children.forEach(children, function (child) {
    if ((0, _reactIs.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });

  return ret;
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1024);
//# sourceMappingURL=index.js.map


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(1026);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSelf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, mirror);
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(132);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _reactLifecyclesCompat = __webpack_require__(38);

var _CalendarHeader = __webpack_require__(449);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _CalendarFooter = __webpack_require__(1048);

var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);

var _CalendarMixin = __webpack_require__(1049);

var _CommonMixin = __webpack_require__(454);

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MonthCalendar = function (_React$Component) {
  (0, _inherits3['default'])(MonthCalendar, _React$Component);

  function MonthCalendar(props) {
    (0, _classCallCheck3['default'])(this, MonthCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.onKeyDown = function (event) {
      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var stateValue = _this.state.value;
      var disabledDate = _this.props.disabledDate;

      var value = stateValue;
      switch (keyCode) {
        case _KeyCode2['default'].DOWN:
          value = stateValue.clone();
          value.add(3, 'months');
          break;
        case _KeyCode2['default'].UP:
          value = stateValue.clone();
          value.add(-3, 'months');
          break;
        case _KeyCode2['default'].LEFT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(-1, 'years');
          } else {
            value.add(-1, 'months');
          }
          break;
        case _KeyCode2['default'].RIGHT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(1, 'years');
          } else {
            value.add(1, 'months');
          }
          break;
        case _KeyCode2['default'].ENTER:
          if (!disabledDate || !disabledDate(stateValue)) {
            _this.onSelect(stateValue);
          }
          event.preventDefault();
          return 1;
        default:
          return undefined;
      }
      if (value !== stateValue) {
        _this.setValue(value);
        event.preventDefault();
        return 1;
      }
    };

    _this.handlePanelChange = function (_, mode) {
      if (mode !== 'date') {
        _this.setState({ mode: mode });
      }
    };

    _this.state = {
      mode: 'month',
      value: props.value || props.defaultValue || (0, _moment2['default'])(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  MonthCalendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var mode = state.mode,
        value = state.value;

    var children = _react2['default'].createElement(
      'div',
      { className: props.prefixCls + '-month-calendar-content' },
      _react2['default'].createElement(
        'div',
        { className: props.prefixCls + '-month-header-wrap' },
        _react2['default'].createElement(_CalendarHeader2['default'], {
          prefixCls: props.prefixCls,
          mode: mode,
          value: value,
          locale: props.locale,
          disabledMonth: props.disabledDate,
          monthCellRender: props.monthCellRender,
          monthCellContentRender: props.monthCellContentRender,
          onMonthSelect: this.onSelect,
          onValueChange: this.setValue,
          onPanelChange: this.handlePanelChange
        })
      ),
      _react2['default'].createElement(_CalendarFooter2['default'], {
        prefixCls: props.prefixCls,
        renderFooter: props.renderFooter
      })
    );
    return this.renderRoot({
      className: props.prefixCls + '-month-calendar',
      children: children
    });
  };

  return MonthCalendar;
}(_react2['default'].Component);

MonthCalendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
  monthCellRender: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  selectedValue: _propTypes2['default'].object,
  defaultSelectedValue: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func
});
MonthCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, _CalendarMixin.calendarMixinDefaultProps);
exports['default'] = (0, _reactLifecyclesCompat.polyfill)((0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(MonthCalendar)));
module.exports = exports['default'];

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(450);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _MonthPanel = __webpack_require__(1044);

var _MonthPanel2 = _interopRequireDefault(_MonthPanel);

var _YearPanel = __webpack_require__(1046);

var _YearPanel2 = _interopRequireDefault(_YearPanel);

var _DecadePanel = __webpack_require__(1047);

var _DecadePanel2 = _interopRequireDefault(_DecadePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  (0, _inherits3['default'])(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    (0, _classCallCheck3['default'])(this, CalendarHeader);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = _react2['default'].createElement(_MonthPanel2['default'], {
        locale: locale,
        value: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter,
        changeYear: this.changeYear
      });
    }
    if (mode === 'year') {
      panel = _react2['default'].createElement(_YearPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = _react2['default'].createElement(_DecadePanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-header' },
      _react2['default'].createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(_react2['default'].Component);

CalendarHeader.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  onValueChange: _propTypes2['default'].func,
  showTimePicker: _propTypes2['default'].bool,
  onPanelChange: _propTypes2['default'].func,
  locale: _propTypes2['default'].object,
  enablePrev: _propTypes2['default'].any,
  enableNext: _propTypes2['default'].any,
  disabledMonth: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  onMonthSelect: _propTypes2['default'].func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.changeYear = function (direction) {
    if (direction > 0) {
      _this3.nextYear();
    } else {
      _this3.previousYear();
    }
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = _react2['default'].createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return _react2['default'].createElement(
      'span',
      { className: selectClassName },
      (0, _mapSelf2['default'])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

exports['default'] = CalendarHeader;
module.exports = exports['default'];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSelf;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return _react.default.Children.map(children, mirror);
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TodayButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return _react2['default'].createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: (0, _util.getTodayTimeStr)(value)
    },
    localeNow
  );
}
module.exports = exports['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = OkButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return _react2["default"].createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}
module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TimePickerButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return _react2['default'].createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}
module.exports = exports['default'];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.commonMixinWrapper = exports.defaultProp = exports.propType = undefined;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _en_US = __webpack_require__(406);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

var propType = exports.propType = {
  className: _propTypes2['default'].string,
  locale: _propTypes2['default'].object,
  style: _propTypes2['default'].object,
  visible: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOk: _propTypes2['default'].func
};

var defaultProp = exports.defaultProp = {
  locale: _en_US2['default'],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = exports.commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _class.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps, _temp2;
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(1053);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ContainerRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  function ContainerRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContainerRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Portal).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataOrAriaProps;

function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}
//# sourceMappingURL=getDataOrAriaProps.js.map


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;

// eslint-disable-next-line import/prefer-default-export
function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _moment = _interopRequireDefault(__webpack_require__(21));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(38);

var _Header = _interopRequireDefault(__webpack_require__(1062));

var _Combobox = _interopRequireDefault(__webpack_require__(1063));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return (0, _moment["default"])("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: newValue
      });

      onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    return _this;
  }

  _createClass(Panel, [{
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      var onEsc = this.props.onEsc;
      onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var defaultOpenValue = this.props.defaultOpenValue;
      var value = this.state.value;
      var realValue = value || defaultOpenValue;
      return realValue.hour() >= 0 && realValue.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format = _this$props2.format,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          onEsc = _this$props2.onEsc,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          inputReadOnly = _this$props2.inputReadOnly,
          clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, "".concat(prefixCls, "-inner"))
      }, _react["default"].createElement(_Header["default"], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: validDefaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), _react["default"].createElement(_Combobox["default"], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        onEsc: onEsc,
        isAM: this.isAM()
      }), addon(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props) {
        return _objectSpread({}, state, {
          value: props.value
        });
      }

      return null;
    }
  }]);

  return Panel;
}(_react.Component);

_defineProperty(Panel, "propTypes", {
  clearText: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  className: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  value: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  inputReadOnly: _propTypes["default"].bool,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  addon: _propTypes["default"].func,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: (0, _moment["default"])(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  onAmPmChange: noop,
  inputReadOnly: false
});

(0, _reactLifecyclesCompat.polyfill)(Panel);
var _default = Panel;
exports["default"] = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _reactLifecyclesCompat = __webpack_require__(38);

var _icon = _interopRequireDefault(__webpack_require__(4));

var _CheckableTag = _interopRequireDefault(__webpack_require__(1077));

var _configProvider = __webpack_require__(30);

var _colors = __webpack_require__(466);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _wave = _interopRequireDefault(__webpack_require__(291));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));

var Tag =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tag, _React$Component);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tag).call(this, props));
    _this.state = {
      visible: true
    };

    _this.handleIconClick = function (e) {
      e.stopPropagation();

      _this.setVisible(false, e);
    };

    _this.renderTag = function (configProps) {
      var _a = _this.props,
          children = _a.children,
          otherProps = __rest(_a, ["children"]);

      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
      return isNeedWave ? React.createElement(_wave["default"], null, React.createElement("span", _extends({}, tagProps, {
        className: _this.getTagClassName(configProps),
        style: _this.getTagStyle()
      }), children, _this.renderCloseIcon())) : React.createElement("span", _extends({}, tagProps, {
        className: _this.getTagClassName(configProps),
        style: _this.getTagStyle()
      }), children, _this.renderCloseIcon());
    };

    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
    return _this;
  }

  _createClass(Tag, [{
    key: "getTagStyle",
    value: function getTagStyle() {
      var _this$props = this.props,
          color = _this$props.color,
          style = _this$props.style;
      var isPresetColor = this.isPresetColor();
      return _extends({
        backgroundColor: color && !isPresetColor ? color : undefined
      }, style);
    }
  }, {
    key: "getTagClassName",
    value: function getTagClassName(_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          color = _this$props2.color;
      var visible = this.state.visible;
      var isPresetColor = this.isPresetColor();
      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible, e) {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          afterClose = _this$props3.afterClose;

      if (onClose) {
        onClose(e);
      }

      if (afterClose && !onClose) {
        // next version remove.
        afterClose();
      }

      if (e.defaultPrevented) {
        return;
      }

      if (!('visible' in this.props)) {
        this.setState({
          visible: visible
        });
      }
    }
  }, {
    key: "isPresetColor",
    value: function isPresetColor() {
      var color = this.props.color;

      if (!color) {
        return false;
      }

      return PresetColorRegex.test(color);
    }
  }, {
    key: "renderCloseIcon",
    value: function renderCloseIcon() {
      var closable = this.props.closable;
      return closable ? React.createElement(_icon["default"], {
        type: "close",
        onClick: this.handleIconClick
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTag);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tag;
}(React.Component);

Tag.CheckableTag = _CheckableTag["default"];
Tag.defaultProps = {
  closable: false
};
(0, _reactLifecyclesCompat.polyfill)(Tag);
var _default = Tag;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColorTypes = void 0;

var _type = __webpack_require__(81);

// eslint-disable-next-line import/prefer-default-export
var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
exports.PresetColorTypes = PresetColorTypes;
//# sourceMappingURL=colors.js.map


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputIcon;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InputIcon(props) {
  var _classNames;

  var suffixIcon = props.suffixIcon,
      prefixCls = props.prefixCls;
  return suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
  }) : React.createElement("span", {
    className: "".concat(prefixCls, "-picker-icon")
  }, suffixIcon)) || React.createElement(_icon["default"], {
    type: "calendar",
    className: "".concat(prefixCls, "-picker-icon")
  });
}
//# sourceMappingURL=InputIcon.js.map


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1087);
//# sourceMappingURL=index.js.map


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _rcUpload = _interopRequireDefault(__webpack_require__(1091));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _uniqBy = _interopRequireDefault(__webpack_require__(1098));

var _findIndex = _interopRequireDefault(__webpack_require__(1181));

var _UploadList = _interopRequireDefault(__webpack_require__(1184));

var _utils = __webpack_require__(491);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _default2 = _interopRequireDefault(__webpack_require__(158));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Upload =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Upload, _React$Component);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Upload).call(this, props));

    _this.saveUpload = function (node) {
      _this.upload = node;
    };

    _this.onStart = function (file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.fileToObject)(file);
      targetItem.status = 'uploading';
      var nextFileList = fileList.concat();
      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
        var uid = _ref.uid;
        return uid === targetItem.uid;
      });

      if (fileIndex === -1) {
        nextFileList.push(targetItem);
      } else {
        nextFileList[fileIndex] = targetItem;
      }

      _this.onChange({
        file: targetItem,
        fileList: nextFileList
      }); // fix ie progress


      if (!window.File || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://act-api.dctms.ca","REACT_APP_UI_URL":"https://act.dctms.ca","REACT_APP_SECRET_NAME":"wiZzx1yTU1vSx89QKprP","REACT_APP_SECRET_KEY":"GmjMJuznKRqNxfca3gk6","REACT_APP_RECAPTCHA_SITE_KEY":"6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6"}).TEST_IE) {
        _this.autoUpdateProgress(0, targetItem);
      }
    };

    _this.onSuccess = function (response, file, xhr) {
      _this.clearProgressTimer();

      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.status = 'done';
      targetItem.response = response;
      targetItem.xhr = xhr;

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.onProgress = function (e, file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.percent = e.percent;

      _this.onChange({
        event: e,
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.onError = function (error, response, file) {
      _this.clearProgressTimer();

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.handleRemove = function (file) {
      var onRemove = _this.props.onRemove;
      var fileList = _this.state.fileList;
      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          return;
        }

        var removedFileList = (0, _utils.removeFileItem)(file, fileList);

        if (removedFileList) {
          file.status = 'removed'; // eslint-disable-line

          if (_this.upload) {
            _this.upload.abort(file);
          }

          _this.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    };

    _this.onChange = function (info) {
      if (!('fileList' in _this.props)) {
        _this.setState({
          fileList: info.fileList
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(info);
      }
    };

    _this.onFileDrop = function (e) {
      _this.setState({
        dragState: e.type
      });
    };

    _this.beforeUpload = function (file, fileList) {
      var beforeUpload = _this.props.beforeUpload;
      var stateFileList = _this.state.fileList;

      if (!beforeUpload) {
        return true;
      }

      var result = beforeUpload(file, fileList);

      if (result === false) {
        _this.onChange({
          file: file,
          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
            return item.uid;
          })
        });

        return false;
      }

      if (result && result.then) {
        return result;
      }

      return true;
    };

    _this.renderUploadList = function (locale) {
      var _this$props = _this.props,
          showUploadList = _this$props.showUploadList,
          listType = _this$props.listType,
          onPreview = _this$props.onPreview,
          onDownload = _this$props.onDownload,
          previewFile = _this$props.previewFile,
          disabled = _this$props.disabled,
          propLocale = _this$props.locale;
      var showRemoveIcon = showUploadList.showRemoveIcon,
          showPreviewIcon = showUploadList.showPreviewIcon,
          showDownloadIcon = showUploadList.showDownloadIcon;
      var fileList = _this.state.fileList;
      return React.createElement(_UploadList["default"], {
        listType: listType,
        items: fileList,
        previewFile: previewFile,
        onPreview: onPreview,
        onDownload: onDownload,
        onRemove: _this.handleRemove,
        showRemoveIcon: !disabled && showRemoveIcon,
        showPreviewIcon: showPreviewIcon,
        showDownloadIcon: showDownloadIcon,
        locale: _extends(_extends({}, locale), propLocale)
      });
    };

    _this.renderUpload = function (_ref2) {
      var _classNames2;

      var getPrefixCls = _ref2.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          showUploadList = _this$props2.showUploadList,
          listType = _this$props2.listType,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          style = _this$props2.style;
      var _this$state = _this.state,
          fileList = _this$state.fileList,
          dragState = _this$state.dragState;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);

      var rcUploadProps = _extends(_extends({
        onStart: _this.onStart,
        onError: _this.onError,
        onProgress: _this.onProgress,
        onSuccess: _this.onSuccess
      }, _this.props), {
        prefixCls: prefixCls,
        beforeUpload: _this.beforeUpload
      });

      delete rcUploadProps.className;
      delete rcUploadProps.style;
      var uploadList = showUploadList ? React.createElement(_LocaleReceiver["default"], {
        componentName: "Upload",
        defaultLocale: _default2["default"].Upload
      }, _this.renderUploadList) : null;

      if (type === 'drag') {
        var _classNames;

        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
          return file.status === 'uploading';
        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
        return React.createElement("span", null, React.createElement("div", {
          className: dragCls,
          onDrop: _this.onFileDrop,
          onDragOver: _this.onFileDrop,
          onDragLeave: _this.onFileDrop,
          style: style
        }, React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
          ref: _this.saveUpload,
          className: "".concat(prefixCls, "-btn")
        }), React.createElement("div", {
          className: "".concat(prefixCls, "-drag-container")
        }, children))), uploadList);
      }

      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2)); // Remove id to avoid open by label when trigger is hidden
      // https://github.com/ant-design/ant-design/issues/14298
      // https://github.com/ant-design/ant-design/issues/16478

      if (!children || disabled) {
        delete rcUploadProps.id;
      }

      var uploadButton = React.createElement("div", {
        className: uploadButtonCls,
        style: children ? undefined : {
          display: 'none'
        }
      }, React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
        ref: _this.saveUpload
      })));

      if (listType === 'picture-card') {
        return React.createElement("span", {
          className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
        }, uploadList, uploadButton);
      }

      return React.createElement("span", {
        className: className
      }, uploadButton, uploadList);
    };

    _this.state = {
      fileList: props.fileList || props.defaultFileList || [],
      dragState: 'drop'
    };
    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
    return _this;
  }

  _createClass(Upload, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearProgressTimer();
    }
  }, {
    key: "clearProgressTimer",
    value: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    }
  }, {
    key: "autoUpdateProgress",
    value: function autoUpdateProgress(_, file) {
      var _this2 = this;

      var getPercent = (0, _utils.genPercentAdd)();
      var curPercent = 0;
      this.clearProgressTimer();
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);

        _this2.onProgress({
          percent: curPercent * 100
        }, file);
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('fileList' in nextProps) {
        return {
          fileList: nextProps.fileList || []
        };
      }

      return null;
    }
  }]);

  return Upload;
}(React.Component);

Upload.defaultProps = {
  type: 'select',
  multiple: false,
  action: '',
  data: {},
  accept: '',
  beforeUpload: _utils.T,
  showUploadList: true,
  listType: 'text',
  className: '',
  disabled: false,
  supportServerRender: true
};
(0, _reactLifecyclesCompat.polyfill)(Upload);
var _default = Upload;
exports["default"] = _default;
//# sourceMappingURL=Upload.js.map


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var now = +new Date();
var index = 0;

function uid() {
  return "rc-upload-" + now + "-" + ++index;
}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1099),
    baseMatchesProperty = __webpack_require__(1158),
    identity = __webpack_require__(1169),
    isArray = __webpack_require__(102),
    property = __webpack_require__(1170);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(204),
    stackClear = __webpack_require__(1106),
    stackDelete = __webpack_require__(1107),
    stackGet = __webpack_require__(1108),
    stackHas = __webpack_require__(1109),
    stackSet = __webpack_require__(1110);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(164),
    isObject = __webpack_require__(163);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1127),
    isObjectLike = __webpack_require__(165);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(478),
    arraySome = __webpack_require__(1130),
    cacheHas = __webpack_require__(479);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(308),
    setCacheAdd = __webpack_require__(1128),
    setCacheHas = __webpack_require__(1129);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1141),
    baseKeys = __webpack_require__(1148),
    isArrayLike = __webpack_require__(1152);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1143),
    isObjectLike = __webpack_require__(165);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(86),
    stubFalse = __webpack_require__(1144);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 483 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1145),
    baseUnary = __webpack_require__(1146),
    nodeUtil = __webpack_require__(1147);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(163);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(489),
    toKey = __webpack_require__(208);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(102),
    isKey = __webpack_require__(311),
    stringToPath = __webpack_require__(1160),
    toString = __webpack_require__(1163);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T = T;
exports.fileToObject = fileToObject;
exports.genPercentAdd = genPercentAdd;
exports.getFileItem = getFileItem;
exports.removeFileItem = removeFileItem;
exports.previewImage = previewImage;
exports.isImageUrl = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object


function fileToObject(file) {
  return _extends(_extends({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */


function genPercentAdd() {
  var k = 0.1;
  var i = 0.01;
  var end = 0.98;
  return function (s) {
    var start = s;

    if (start >= end) {
      return start;
    }

    start += k;
    k -= i;

    if (k < 0.001) {
      k = 0.001;
    }

    return start;
  };
}

function getFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(function (item) {
    return item[matchKey] === file[matchKey];
  })[0];
}

function removeFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  var removed = fileList.filter(function (item) {
    return item[matchKey] !== file[matchKey];
  });

  if (removed.length === fileList.length) {
    return null;
  }

  return removed;
} // ==================== Default Image Preview ====================


var extname = function extname() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};

var isImageFileType = function isImageFileType(type) {
  return !!type && type.indexOf('image/') === 0;
};

var isImageUrl = function isImageUrl(file) {
  if (isImageFileType(file.type)) {
    return true;
  }

  var url = file.thumbUrl || file.url;
  var extension = extname(url);

  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }

  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }

  if (extension) {
    // other file types which have extension
    return false;
  }

  return true;
};

exports.isImageUrl = isImageUrl;
var MEASURE_SIZE = 200;

function previewImage(file) {
  return new Promise(function (resolve) {
    if (!isImageFileType(file.type)) {
      resolve('');
      return;
    }

    var canvas = document.createElement('canvas');
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var img = new Image();

    img.onload = function () {
      var width = img.width,
          height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;

      if (width < height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };

    img.src = window.URL.createObjectURL(file);
  });
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _progress = _interopRequireDefault(__webpack_require__(1191));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _progress["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var enhancer = function enhancer(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_WrappedComponent) {
      _inherits(Progress, _WrappedComponent);

      function Progress() {
        _classCallCheck(this, Progress);

        return _possibleConstructorReturn(this, _getPrototypeOf(Progress).apply(this, arguments));
      }

      _createClass(Progress, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          var _this = this;

          var now = Date.now();
          var updated = false;
          Object.keys(this.paths).forEach(function (key) {
            var path = _this.paths[key];

            if (!path) {
              return;
            }

            updated = true;
            var pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';

            if (_this.prevTimeStamp && now - _this.prevTimeStamp < 100) {
              pathStyle.transitionDuration = '0s, 0s';
            }
          });

          if (updated) {
            this.prevTimeStamp = Date.now();
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _get(_getPrototypeOf(Progress.prototype), "render", this).call(this);
        }
      }]);

      return Progress;
    }(WrappedComponent)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (enhancer);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};
var mixedType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]);
var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  percent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([mixedType, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(mixedType)]),
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object])), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['butt', 'round', 'square']),
  strokeWidth: mixedType,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  trailColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  trailWidth: mixedType
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var Option =
/*#__PURE__*/
function (_Component) {
  _inherits(Option, _Component);

  function Option() {
    _classCallCheck(this, Option);

    return _possibleConstructorReturn(this, _getPrototypeOf(Option).apply(this, arguments));
  }

  return Option;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);


Option.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]])
};
Option.isSelectOption = true;

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }



function propsValueType() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var props = args[0],
      propName = args[1],
      componentName = args[2],
      rest = args.slice(3);
  var basicType = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]]);
  var labelInValueShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
    key: basicType.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]
  });

  if (props.labelInValue) {
    var validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](labelInValueShape), labelInValueShape]);
    var error = validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));

    if (error) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + "when you set `labelInValue` to `true`, `".concat(propName, "` should in ") + "shape of `{ key: string | number, label?: ReactNode }`.");
    }
  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
    return new Error("Invalid prop `".concat(propName, "` of type `string` supplied to `").concat(componentName, "`, ") + "expected `array` when `multiple` or `tags` is `true`.");
  } else {
    var _validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](basicType), basicType]);

    return _validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));
  }

  return null;
}

var SelectPropTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  multiple: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  filterOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  showSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  allowClear: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  showArrow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionLabelProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionFilterProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  animation: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  choiceTransitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  defaultOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onInputKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  onDeselect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  labelInValue: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  value: propsValueType,
  defaultValue: propsValueType,
  dropdownStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  maxTagTextLength: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagCount: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagPlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["node"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]]),
  tokenSeparators: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  getInputElement: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  showAction: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  clearIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  inputIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  removeIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
};
/* harmony default export */ __webpack_exports__["a"] = (SelectPropTypes);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_createChainedFunction__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DOMWrap__ = __webpack_require__(1216);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: _objectSpread({}, state.activeKey, _defineProperty({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found;
    Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (c && c.props && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);

    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}
var SubPopupMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _this;

    _classCallCheck(this, SubPopupMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubPopupMenu).call(this, props));
    /**
     * all keyboard events callbacks run from here at first
     *
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e, callback) {
      var keyCode = e.keyCode;
      var handled;

      _this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        activeItem = _this.step(keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    };

    _this.onItemHover = function (e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
    };

    _this.onDeselect = function (selectInfo) {
      _this.props.onDeselect(selectInfo);
    };

    _this.onSelect = function (selectInfo) {
      _this.props.onSelect(selectInfo);
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onDestroy = function (key) {
      /* istanbul ignore next */
      _this.props.onDestroy(key);
    };

    _this.getFlatInstanceArray = function () {
      return _this.instanceArray;
    };

    _this.step = function (direction) {
      var children = _this.getFlatInstanceArray();

      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];

      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.props.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    };

    _this.renderCommonMenuItem = function (child, i, extraProps) {
      var state = _this.props.store.getState();

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var key = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055

      if (!childProps || typeof child.type === 'string') {
        return child;
      }

      var isActive = key === state.activeKey;

      var newChildProps = _objectSpread({
        mode: childProps.mode || props.mode,
        level: props.level,
        inlineIndent: props.inlineIndent,
        renderMenuItem: _this.renderMenuItem,
        rootPrefixCls: props.prefixCls,
        index: i,
        parentMenu: props.parentMenu,
        // customized ref function, need to be invoked manually in child's componentDidMount
        manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_assertThisInitialized(_this))),
        eventKey: key,
        active: !childProps.disabled && isActive,
        multiple: props.multiple,
        onClick: function onClick(e) {
          (childProps.onClick || __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */])(e);

          _this.onClick(e);
        },
        onItemHover: _this.onItemHover,
        motion: props.motion,
        subMenuOpenDelay: props.subMenuOpenDelay,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        onOpenChange: _this.onOpenChange,
        onDeselect: _this.onDeselect,
        onSelect: _this.onSelect,
        builtinPlacements: props.builtinPlacements,
        itemIcon: childProps.itemIcon || _this.props.itemIcon,
        expandIcon: childProps.expandIcon || _this.props.expandIcon
      }, extraProps); // ref: https://github.com/ant-design/ant-design/issues/13943


      if (props.mode === 'inline' || Object(__WEBPACK_IMPORTED_MODULE_6__util__["d" /* isMobileDevice */])()) {
        newChildProps.triggerSubMenuAction = 'click';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, newChildProps);
    };

    _this.renderMenuItem = function (c, i, subMenuKey) {
      /* istanbul ignore if */
      if (!c) {
        return null;
      }

      var state = _this.props.store.getState();

      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this.props.triggerSubMenuAction,
        subMenuKey: subMenuKey
      };
      return _this.renderCommonMenuItem(c, i, extraProps);
    };

    props.store.setState({
      activeKey: _objectSpread({}, props.store.getState().activeKey, _defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this.instanceArray = [];
    return _this;
  }

  _createClass(SubPopupMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !__WEBPACK_IMPORTED_MODULE_4_shallowequal___default()(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);

      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ('activeKey' in prevProps) {
        // If prev activeKey is not same as current activeKey,
        // we should set it.
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = _extends({}, this.props);

      this.instanceArray = [];
      var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className: className,
        // role could be 'select' and by default set to menu
        role: props.role || 'menu'
      };

      if (props.id) {
        domProps.id = props.id;
      }

      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }

      var prefixCls = props.prefixCls,
          eventKey = props.eventKey,
          visible = props.visible,
          level = props.level,
          mode = props.mode,
          overflowedIndicator = props.overflowedIndicator,
          theme = props.theme;
      __WEBPACK_IMPORTED_MODULE_6__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Otherwise, the propagated click event will trigger another onClick

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__DOMWrap__["a" /* default */], Object.assign({}, props, {
        prefixCls: prefixCls,
        mode: mode,
        tag: "ul",
        level: level,
        theme: theme,
        visible: visible,
        overflowedIndicator: overflowedIndicator
      }, domProps), __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(props.children, function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      }));
    }
  }]);

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_1_mini_store__["connect"])()(SubPopupMenu);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_trigger__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate_es_CSSMotion__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubPopupMenu__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(136);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // import Animate from 'rc-animate';







var guid = 0;
var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: _objectSpread({}, state.defaultActiveFirst, _defineProperty({}, menuId, defaultActiveFirst))
  });
};

var SubMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  function SubMenu(props) {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).call(this, props));

    _this.onDestroy = function (key) {
      _this.props.onDestroy(key);
    };
    /**
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */


    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      var menu = _this.menuInstance;
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          store = _this$props.store;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onTitleClick(e);

        updateDefaultActiveFirst(store, _this.props.eventKey, true);
        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
        if (isOpen) {
          menu.onKeyDown(e);
        } else {
          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value


          updateDefaultActiveFirst(store, _this.props.eventKey, true);
        }

        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].LEFT) {
        var handled;

        if (isOpen) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          _this.triggerOpenChange(false);

          handled = true;
        }

        return handled;
      }

      if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onPopupVisibleChange = function (visible) {
      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          key = _this$props2.eventKey,
          onMouseEnter = _this$props2.onMouseEnter,
          store = _this$props2.store;
      updateDefaultActiveFirst(store, _this.props.eventKey, false);
      onMouseEnter({
        key: key,
        domEvent: e
      });
    };

    _this.onMouseLeave = function (e) {
      var _this$props3 = _this.props,
          parentMenu = _this$props3.parentMenu,
          eventKey = _this$props3.eventKey,
          onMouseLeave = _this$props3.onMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized(_this);
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleMouseEnter = function (domEvent) {
      var _this$props4 = _this.props,
          key = _this$props4.eventKey,
          onItemHover = _this$props4.onItemHover,
          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
      onItemHover({
        key: key,
        hover: true
      });
      onTitleMouseEnter({
        key: key,
        domEvent: domEvent
      });
    };

    _this.onTitleMouseLeave = function (e) {
      var _this$props5 = _this.props,
          parentMenu = _this$props5.parentMenu,
          eventKey = _this$props5.eventKey,
          onItemHover = _this$props5.onItemHover,
          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized(_this);
      onItemHover({
        key: eventKey,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleClick = function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      props.onTitleClick({
        key: props.eventKey,
        domEvent: e
      });

      if (props.triggerSubMenuAction === 'hover') {
        return;
      }

      _this.triggerOpenChange(!props.isOpen, 'click');

      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
    };

    _this.onSubMenuClick = function (info) {
      // in the case of overflowed submenu
      // onClick is not copied over
      if (typeof _this.props.onClick === 'function') {
        _this.props.onClick(_this.addKeyPath(info));
      }
    };

    _this.onSelect = function (info) {
      _this.props.onSelect(info);
    };

    _this.onDeselect = function (info) {
      _this.props.onDeselect(info);
    };

    _this.getPrefixCls = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu");
    };

    _this.getActiveClassName = function () {
      return "".concat(_this.getPrefixCls(), "-active");
    };

    _this.getDisabledClassName = function () {
      return "".concat(_this.getPrefixCls(), "-disabled");
    };

    _this.getSelectedClassName = function () {
      return "".concat(_this.getPrefixCls(), "-selected");
    };

    _this.getOpenClassName = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
    };

    _this.saveMenuInstance = function (c) {
      // children menu instance
      _this.menuInstance = c;
    };

    _this.addKeyPath = function (info) {
      return _objectSpread({}, info, {
        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
      });
    };

    _this.triggerOpenChange = function (open, type) {
      var key = _this.props.eventKey;

      var openChange = function openChange() {
        _this.onOpenChange({
          key: key,
          item: _assertThisInitialized(_this),
          trigger: type,
          open: open
        });
      };

      if (type === 'mouseenter') {
        // make sure mouseenter happen after other menu item's mouseleave
        _this.mouseenterTimeout = setTimeout(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };

    _this.isChildrenSelected = function () {
      var ret = {
        find: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_9__util__["f" /* loopMenuItemRecursively */])(_this.props.children, _this.props.selectedKeys, ret);
      return ret.find;
    };

    _this.isOpen = function () {
      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
    };

    _this.adjustWidth = function () {
      /* istanbul ignore if */
      if (!_this.subMenuTitle || !_this.menuInstance) {
        return;
      }

      var popupMenu = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this.menuInstance);

      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */


      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
    };

    _this.saveSubMenuTitle = function (subMenuTitle) {
      _this.subMenuTitle = subMenuTitle;
    };

    var store = props.store,
        eventKey = props.eventKey;

    var _store$getState = store.getState(),
        defaultActiveFirst = _store$getState.defaultActiveFirst;

    _this.isRootMenu = false;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  _createClass(SubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props6 = this.props,
          mode = _this$props6.mode,
          parentMenu = _this$props6.parentMenu,
          manualRef = _this$props6.manualRef; // invoke customized ref to expose component to mixin

      if (manualRef) {
        manualRef(this);
      }

      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
        return;
      }

      this.minWidthTimeout = setTimeout(function () {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props,
          onDestroy = _this$props7.onDestroy,
          eventKey = _this$props7.eventKey;

      if (onDestroy) {
        onDestroy(eventKey);
      }
      /* istanbul ignore if */


      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      /* istanbul ignore if */


      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      var props = this.props;
      var baseProps = {
        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
        visible: this.props.isOpen,
        level: props.level + 1,
        inlineIndent: props.inlineIndent,
        focusable: false,
        onClick: this.onSubMenuClick,
        onSelect: this.onSelect,
        onDeselect: this.onDeselect,
        onDestroy: this.onDestroy,
        selectedKeys: props.selectedKeys,
        eventKey: "".concat(props.eventKey, "-menu-"),
        openKeys: props.openKeys,
        motion: props.motion,
        onOpenChange: this.onOpenChange,
        subMenuOpenDelay: props.subMenuOpenDelay,
        parentMenu: this,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        triggerSubMenuAction: props.triggerSubMenuAction,
        builtinPlacements: props.builtinPlacements,
        defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
        multiple: props.multiple,
        prefixCls: props.rootPrefixCls,
        id: this.internalMenuId,
        manualRef: this.saveMenuInstance,
        itemIcon: props.itemIcon,
        expandIcon: props.expandIcon
      };
      var haveRendered = this.haveRendered;
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null);
      } // ================== Motion ==================
      // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode


      var mergedMotion = _objectSpread({}, props.motion, {
        leavedClassName: "".concat(props.rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !baseProps.visible || baseProps.mode !== 'inline'
      });

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_animate_es_CSSMotion__["a" /* default */], Object.assign({
        visible: baseProps.visible
      }, mergedMotion), function (_ref) {
        var className = _ref.className,
            style = _ref.style;
        var mergedClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()("".concat(baseProps.prefixCls, "-sub"), className);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SubPopupMenu__["a" /* default */], Object.assign({}, baseProps, {
          id: _this3.internalMenuId,
          className: mergedClassName,
          style: style
        }), children);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = _objectSpread({}, this.props);

      var isOpen = props.isOpen;
      var prefixCls = this.getPrefixCls();
      var isInlineMode = props.mode === 'inline';
      var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames = {}, _defineProperty(_classNames, props.className, !!props.className), _defineProperty(_classNames, this.getOpenClassName(), isOpen), _defineProperty(_classNames, this.getActiveClassName(), props.active || isOpen && !isInlineMode), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _defineProperty(_classNames, this.getSelectedClassName(), this.isChildrenSelected()), _classNames));

      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }

      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};

      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        }; // only works in title, not outer li

        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }

      var style = {};

      if (isInlineMode) {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      var ariaOwns = {}; // only set aria-owns when menu is open
      // otherwise it would be an invalid aria-owns value
      // since corresponding node cannot be found

      if (this.props.isOpen) {
        ariaOwns = {
          'aria-owns': this.internalMenuId
        };
      } // expand custom icon should NOT be displayed in menu with horizontal mode.


      var icon = null;

      if (props.mode !== 'horizontal') {
        icon = this.props.expandIcon; // ReactNode

        if (typeof this.props.expandIcon === 'function') {
          icon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.expandIcon, _objectSpread({}, this.props));
        }
      }

      var title = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", Object.assign({
        ref: this.saveSubMenuTitle,
        style: style,
        className: "".concat(prefixCls, "-title")
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": isOpen
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === 'string' ? props.title : undefined
      }), props.title, icon || __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren(props.children);
      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[props.mode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
      var disabled = props.disabled,
          triggerSubMenuAction = props.triggerSubMenuAction,
          subMenuOpenDelay = props.subMenuOpenDelay,
          forceSubMenuRender = props.forceSubMenuRender,
          subMenuCloseDelay = props.subMenuCloseDelay,
          builtinPlacements = props.builtinPlacements;
      __WEBPACK_IMPORTED_MODULE_9__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, mouseEvents, {
        className: className,
        role: "menuitem"
      }), isInlineMode && title, isInlineMode && children, !isInlineMode && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["default"], {
        prefixCls: prefixCls,
        popupClassName: "".concat(prefixCls, "-popup ").concat(popupClassName),
        getPopupContainer: getPopupContainer,
        builtinPlacements: Object.assign({}, __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* default */], builtinPlacements),
        popupPlacement: popupPlacement,
        popupVisible: isOpen,
        popupAlign: popupAlign,
        popup: children,
        action: disabled ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender
      }, title));
    }
  }]);

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  mode: 'vertical',
  title: ''
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_6_mini_store__["connect"])(function (_ref2, _ref3) {
  var openKeys = _ref2.openKeys,
      activeKey = _ref2.activeKey,
      selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey,
      subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);
connected.isSubMenu = true;
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warning */
/* unused harmony export note */
/* unused harmony export resetWarned */
/* unused harmony export call */
/* unused harmony export warningOnce */
/* unused harmony export noteOnce */
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ __webpack_exports__["a"] = (warningOnce);
/* eslint-enable */

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);


function toArray(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_react_is__["isFragment"])(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(199)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1233);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(503));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.renderCheckbox = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          indeterminate = props.indeterminate,
          style = props.style,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);

      var checkboxGroup = context.checkboxGroup;
      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);

      var checkboxProps = _extends({}, restProps);

      if (checkboxGroup) {
        checkboxProps.onChange = function () {
          if (restProps.onChange) {
            restProps.onChange.apply(restProps, arguments);
          }

          checkboxGroup.toggleOption({
            label: children,
            value: props.value
          });
        };

        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
      }

      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
      return (// eslint-disable-next-line jsx-a11y/label-has-associated-control
        React.createElement("label", {
          className: classString,
          style: style,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
          prefixCls: prefixCls,
          className: checkboxClass,
          ref: _this.saveCheckbox
        })), children !== undefined && React.createElement("span", null, children))
      );
    };

    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;

      var _ref2 = this.context || {},
          _ref2$checkboxGroup = _ref2.checkboxGroup,
          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;

      if (checkboxGroup.registerValue) {
        checkboxGroup.registerValue(value);
      }

      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref3) {
      var prevValue = _ref3.value;
      var value = this.props.value;

      var _ref4 = this.context || {},
          _ref4$checkboxGroup = _ref4.checkboxGroup,
          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;

      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
        checkboxGroup.cancelValue(prevValue);
        checkboxGroup.registerValue(value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var value = this.props.value;

      var _ref5 = this.context || {},
          _ref5$checkboxGroup = _ref5.checkboxGroup,
          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;

      if (checkboxGroup.cancelValue) {
        checkboxGroup.cancelValue(value);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox);
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.__ANT_CHECKBOX = true;
Checkbox.defaultProps = {
  indeterminate: false
};
Checkbox.contextTypes = {
  checkboxGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(Checkbox);
var _default = Checkbox;
exports["default"] = _default;
//# sourceMappingURL=Checkbox.js.map


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({ symptomatic_intracerebral: 'Symptomatic intracerebral', none: 'None', peripheral_bleeding: 'Peripheral bleeding requirements', angioedema: 'Angioedema', other: 'Other' });

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"FileLink__icon__3QP7G","iconButton":"FileLink__iconButton__TSrcH","preview":"FileLink__preview__3la3V","text":"FileLink__text__1OZui"};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1512);

__webpack_require__(8);
//# sourceMappingURL=index.js.map


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(334),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1537),
    mapCacheDelete = __webpack_require__(1544),
    mapCacheGet = __webpack_require__(1546),
    mapCacheHas = __webpack_require__(1547),
    mapCacheSet = __webpack_require__(1548);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(337),
    eq = __webpack_require__(216);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(334);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1559);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1560),
    isObjectLike = __webpack_require__(138);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(137),
    stubFalse = __webpack_require__(1562);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1564),
    baseUnary = __webpack_require__(1565),
    nodeUtil = __webpack_require__(1566);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1570),
    baseKeysIn = __webpack_require__(1572),
    isArrayLike = __webpack_require__(338);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var mini_store_1 = __webpack_require__(87);

var classnames_1 = __importDefault(__webpack_require__(5));

var ColGroup_1 = __importDefault(__webpack_require__(1585));

var TableHeader_1 = __importDefault(__webpack_require__(1586));

var TableRow_1 = __importDefault(__webpack_require__(528));

var ExpandableRow_1 = __importDefault(__webpack_require__(1600));

var BaseTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseTable, _React$Component);

  function BaseTable() {
    var _this;

    _classCallCheck(this, BaseTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseTable).apply(this, arguments));

    _this.handleRowHover = function (isHover, key) {
      _this.props.store.setState({
        currentHoverKey: isHover ? key : null
      });
    };

    _this.renderRows = function (renderData, indent) {
      var ancestorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var table = _this.context.table;
      var columnManager = table.columnManager,
          components = table.components;
      var _table$props = table.props,
          prefixCls = _table$props.prefixCls,
          childrenColumnName = _table$props.childrenColumnName,
          rowClassName = _table$props.rowClassName,
          rowRef = _table$props.rowRef,
          onRowClick = _table$props.onRowClick,
          onRowDoubleClick = _table$props.onRowDoubleClick,
          onRowContextMenu = _table$props.onRowContextMenu,
          onRowMouseEnter = _table$props.onRowMouseEnter,
          onRowMouseLeave = _table$props.onRowMouseLeave,
          onRow = _table$props.onRow;
      var _this$props = _this.props,
          getRowKey = _this$props.getRowKey,
          fixed = _this$props.fixed,
          expander = _this$props.expander,
          isAnyColumnsFixed = _this$props.isAnyColumnsFixed;
      var rows = [];

      var _loop = function _loop(i) {
        var record = renderData[i];
        var key = getRowKey(record, i);
        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);
        var onHoverProps = {};

        if (columnManager.isAnyColumnsFixed()) {
          onHoverProps.onHover = _this.handleRowHover;
        }

        var leafColumns = void 0;

        if (fixed === 'left') {
          leafColumns = columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = columnManager.rightLeafColumns();
        } else {
          leafColumns = _this.getColumns(columnManager.leafColumns());
        }

        var rowPrefixCls = "".concat(prefixCls, "-row");
        var row = React.createElement(ExpandableRow_1.default, Object.assign({}, expander.props, {
          fixed: fixed,
          index: i,
          prefixCls: rowPrefixCls,
          record: record,
          key: key,
          rowKey: key,
          onRowClick: onRowClick,
          needIndentSpaced: expander.needIndentSpaced,
          onExpandedChange: expander.handleExpandChange
        }), function (expandableRow) {
          return React.createElement(TableRow_1.default, Object.assign({
            fixed: fixed,
            indent: indent,
            className: className,
            record: record,
            index: i,
            prefixCls: rowPrefixCls,
            childrenColumnName: childrenColumnName,
            columns: leafColumns,
            onRow: onRow,
            onRowDoubleClick: onRowDoubleClick,
            onRowContextMenu: onRowContextMenu,
            onRowMouseEnter: onRowMouseEnter,
            onRowMouseLeave: onRowMouseLeave
          }, onHoverProps, {
            rowKey: key,
            ancestorKeys: ancestorKeys,
            ref: rowRef(record, i, indent),
            components: components,
            isAnyColumnsFixed: isAnyColumnsFixed
          }, expandableRow));
        });
        rows.push(row);
        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
      };

      for (var i = 0; i < renderData.length; i += 1) {
        _loop(i);
      }

      return rows;
    };

    return _this;
  }

  _createClass(BaseTable, [{
    key: "getColumns",
    value: function getColumns(cols) {
      var _this$props2 = this.props,
          _this$props2$columns = _this$props2.columns,
          columns = _this$props2$columns === void 0 ? [] : _this$props2$columns,
          fixed = _this$props2.fixed;
      var table = this.context.table;
      var prefixCls = table.props.prefixCls;
      return (cols || columns).map(function (column) {
        return _objectSpread({}, column, {
          className: !!column.fixed && !fixed ? classnames_1.default("".concat(prefixCls, "-fixed-columns-in-body"), column.className) : column.className
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var table = this.context.table;
      var components = table.components;
      var _table$props2 = table.props,
          prefixCls = _table$props2.prefixCls,
          scroll = _table$props2.scroll,
          data = _table$props2.data,
          getBodyWrapper = _table$props2.getBodyWrapper;
      var _this$props3 = this.props,
          expander = _this$props3.expander,
          tableClassName = _this$props3.tableClassName,
          hasHead = _this$props3.hasHead,
          hasBody = _this$props3.hasBody,
          fixed = _this$props3.fixed;
      var tableStyle = {};

      if (!fixed && scroll.x) {
        // not set width, then use content fixed width
        tableStyle.width = scroll.x === true ? 'auto' : scroll.x;
      }

      var Table = hasBody ? components.table : 'table';
      var BodyWrapper = components.body.wrapper;
      var body;

      if (hasBody) {
        body = React.createElement(BodyWrapper, {
          className: "".concat(prefixCls, "-tbody")
        }, this.renderRows(data, 0));

        if (getBodyWrapper) {
          body = getBodyWrapper(body);
        }
      }

      var columns = this.getColumns();
      return React.createElement(Table, {
        className: tableClassName,
        style: tableStyle,
        key: "table"
      }, React.createElement(ColGroup_1.default, {
        columns: columns,
        fixed: fixed
      }), hasHead && React.createElement(TableHeader_1.default, {
        expander: expander,
        columns: columns,
        fixed: fixed
      }), body);
    }
  }]);

  return BaseTable;
}(React.Component);

BaseTable.contextTypes = {
  table: PropTypes.any
};
exports.default = mini_store_1.connect()(BaseTable);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var react_dom_1 = __importDefault(__webpack_require__(26));

var warning_1 = __importDefault(__webpack_require__(189));

var mini_store_1 = __webpack_require__(87);

var react_lifecycles_compat_1 = __webpack_require__(38);

var classnames_1 = __importDefault(__webpack_require__(5));

var TableCell_1 = __importDefault(__webpack_require__(1588));

var TableRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableRow, _React$Component);

  function TableRow() {
    var _this;

    _classCallCheck(this, TableRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableRow).apply(this, arguments));
    _this.state = {};

    _this.onTriggerEvent = function (rowPropFunc, legacyFunc, additionalFunc) {
      var _this$props = _this.props,
          record = _this$props.record,
          index = _this$props.index;
      return function () {
        // Additional function like trigger `this.onHover` to handle self logic
        if (additionalFunc) {
          additionalFunc();
        } // [Legacy] Some legacy function like `onRowClick`.


        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var event = args[0];

        if (legacyFunc) {
          legacyFunc(record, index, event);
        } // Pass to the function from `onRow`


        if (rowPropFunc) {
          rowPropFunc.apply(void 0, args);
        }
      };
    };

    _this.onMouseEnter = function () {
      var _this$props2 = _this.props,
          onHover = _this$props2.onHover,
          rowKey = _this$props2.rowKey;
      onHover(true, rowKey);
    };

    _this.onMouseLeave = function () {
      var _this$props3 = _this.props,
          onHover = _this$props3.onHover,
          rowKey = _this$props3.rowKey;
      onHover(false, rowKey);
    };

    return _this;
  }

  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.shouldRender) {
        this.saveRowRef();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !!(this.props.visible || nextProps.visible);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.shouldRender && !this.rowRef) {
        this.saveRowRef();
      }
    }
  }, {
    key: "setExpandedRowHeight",
    value: function setExpandedRowHeight() {
      var _this$props4 = this.props,
          store = _this$props4.store,
          rowKey = _this$props4.rowKey;

      var _store$getState = store.getState(),
          expandedRowsHeight = _store$getState.expandedRowsHeight;

      var _this$rowRef$getBound = this.rowRef.getBoundingClientRect(),
          height = _this$rowRef$getBound.height;

      expandedRowsHeight = _objectSpread({}, expandedRowsHeight, _defineProperty({}, rowKey, height));
      store.setState({
        expandedRowsHeight: expandedRowsHeight
      });
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight() {
      var _this$props5 = this.props,
          store = _this$props5.store,
          rowKey = _this$props5.rowKey;

      var _store$getState2 = store.getState(),
          fixedColumnsBodyRowsHeight = _store$getState2.fixedColumnsBodyRowsHeight;

      var _this$rowRef$getBound2 = this.rowRef.getBoundingClientRect(),
          height = _this$rowRef$getBound2.height;

      store.setState({
        fixedColumnsBodyRowsHeight: _objectSpread({}, fixedColumnsBodyRowsHeight, _defineProperty({}, rowKey, height))
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props6 = this.props,
          height = _this$props6.height,
          visible = _this$props6.visible;

      if (height && height !== this.style.height) {
        this.style = _objectSpread({}, this.style, {
          height: height
        });
      }

      if (!visible && !this.style.display) {
        this.style = _objectSpread({}, this.style, {
          display: 'none'
        });
      }

      return this.style;
    }
  }, {
    key: "saveRowRef",
    value: function saveRowRef() {
      this.rowRef = react_dom_1.default.findDOMNode(this);
      var _this$props7 = this.props,
          isAnyColumnsFixed = _this$props7.isAnyColumnsFixed,
          fixed = _this$props7.fixed,
          expandedRow = _this$props7.expandedRow,
          ancestorKeys = _this$props7.ancestorKeys;

      if (!isAnyColumnsFixed || !this.rowRef) {
        return;
      }

      if (!fixed && expandedRow) {
        this.setExpandedRowHeight();
      }

      if (!fixed && ancestorKeys.length >= 0) {
        this.setRowHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender) {
        return null;
      }

      var _this$props8 = this.props,
          prefixCls = _this$props8.prefixCls,
          columns = _this$props8.columns,
          record = _this$props8.record,
          rowKey = _this$props8.rowKey,
          index = _this$props8.index,
          onRow = _this$props8.onRow,
          indent = _this$props8.indent,
          indentSize = _this$props8.indentSize,
          hovered = _this$props8.hovered,
          height = _this$props8.height,
          visible = _this$props8.visible,
          components = _this$props8.components,
          hasExpandIcon = _this$props8.hasExpandIcon,
          renderExpandIcon = _this$props8.renderExpandIcon,
          renderExpandIconCell = _this$props8.renderExpandIconCell,
          onRowClick = _this$props8.onRowClick,
          onRowDoubleClick = _this$props8.onRowDoubleClick,
          onRowMouseEnter = _this$props8.onRowMouseEnter,
          onRowMouseLeave = _this$props8.onRowMouseLeave,
          onRowContextMenu = _this$props8.onRowContextMenu;
      var BodyRow = components.body.row;
      var BodyCell = components.body.cell;
      var className = this.props.className;

      if (hovered) {
        className += " ".concat(prefixCls, "-hover");
      }

      var cells = [];
      renderExpandIconCell(cells);

      for (var i = 0; i < columns.length; i += 1) {
        var column = columns[i];
        warning_1.default(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');
        cells.push(React.createElement(TableCell_1.default, {
          prefixCls: prefixCls,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: column,
          key: column.key || column.dataIndex,
          expandIcon: hasExpandIcon(i) && renderExpandIcon(),
          component: BodyCell
        }));
      }

      var _ref = onRow(record, index) || {},
          customClassName = _ref.className,
          customStyle = _ref.style,
          rowProps = _objectWithoutProperties(_ref, ["className", "style"]);

      var style = {
        height: height
      };

      if (!visible) {
        style.display = 'none';
      }

      style = _objectSpread({}, style, {}, customStyle);
      var rowClassName = classnames_1.default(prefixCls, className, "".concat(prefixCls, "-level-").concat(indent), customClassName);
      return React.createElement(BodyRow, Object.assign({}, rowProps, {
        onClick: this.onTriggerEvent(rowProps.onClick, onRowClick),
        onDoubleClick: this.onTriggerEvent(rowProps.onDoubleClick, onRowDoubleClick),
        onMouseEnter: this.onTriggerEvent(rowProps.onMouseEnter, onRowMouseEnter, this.onMouseEnter),
        onMouseLeave: this.onTriggerEvent(rowProps.onMouseLeave, onRowMouseLeave, this.onMouseLeave),
        onContextMenu: this.onTriggerEvent(rowProps.onContextMenu, onRowContextMenu),
        className: rowClassName,
        style: style,
        "data-row-key": rowKey
      }), cells);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.visible || !prevState.visible && nextProps.visible) {
        return {
          shouldRender: true,
          visible: nextProps.visible
        };
      }

      return {
        visible: nextProps.visible
      };
    }
  }]);

  return TableRow;
}(React.Component);

TableRow.defaultProps = {
  onRow: function onRow() {},
  onHover: function onHover() {},
  hasExpandIcon: function hasExpandIcon() {},
  renderExpandIcon: function renderExpandIcon() {},
  renderExpandIconCell: function renderExpandIconCell() {}
};

function getRowHeight(state, props) {
  var expandedRowsHeight = state.expandedRowsHeight,
      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
  var fixed = props.fixed,
      rowKey = props.rowKey;

  if (!fixed) {
    return null;
  }

  if (expandedRowsHeight[rowKey]) {
    return expandedRowsHeight[rowKey];
  }

  if (fixedColumnsBodyRowsHeight[rowKey]) {
    return fixedColumnsBodyRowsHeight[rowKey];
  }

  return null;
}

react_lifecycles_compat_1.polyfill(TableRow);
exports.default = mini_store_1.connect(function (state, props) {
  var currentHoverKey = state.currentHoverKey,
      _state$expandedRowKey = state.expandedRowKeys,
      expandedRowKeys = _state$expandedRowKey === void 0 ? [] : _state$expandedRowKey;
  var rowKey = props.rowKey,
      ancestorKeys = props.ancestorKeys;
  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
    return expandedRowKeys.includes(k);
  });
  return {
    visible: visible,
    hovered: currentHoverKey === rowKey,
    height: getRowHeight(state, props)
  };
})(TableRow);

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var ColumnGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColumnGroup, _React$Component);

  function ColumnGroup() {
    _classCallCheck(this, ColumnGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ColumnGroup).apply(this, arguments));
  }

  return ColumnGroup;
}(React.Component);

exports.default = ColumnGroup;
ColumnGroup.isTableColumnGroup = true;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatArray = flatArray;
exports.treeMap = treeMap;
exports.flatFilter = flatFilter;
exports.normalizeColumns = normalizeColumns;
exports.generateValueMaps = generateValueMaps;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function flatArray() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var result = [];

  var loop = function loop(array) {
    array.forEach(function (item) {
      if (item[childrenName]) {
        var newItem = _extends({}, item);

        delete newItem[childrenName];
        result.push(newItem);

        if (item[childrenName].length > 0) {
          loop(item[childrenName]);
        }
      } else {
        result.push(item);
      }
    });
  };

  loop(data);
  return result;
}

function treeMap(tree, mapper) {
  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  return tree.map(function (node, index) {
    var extra = {};

    if (node[childrenName]) {
      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
    }

    return _extends(_extends({}, mapper(node, index)), extra);
  });
}

function flatFilter(tree, callback) {
  return tree.reduce(function (acc, node) {
    if (callback(node)) {
      acc.push(node);
    }

    if (node.children) {
      var children = flatFilter(node.children, callback);
      acc.push.apply(acc, _toConsumableArray(children));
    }

    return acc;
  }, []);
}

function normalizeColumns(elements) {
  var columns = [];
  React.Children.forEach(elements, function (element) {
    if (!React.isValidElement(element)) {
      return;
    }

    var column = _extends({}, element.props);

    if (element.key) {
      column.key = element.key;
    }

    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
      column.children = normalizeColumns(column.children);
    }

    columns.push(column);
  });
  return columns;
}

function generateValueMaps(items) {
  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (items || []).forEach(function (_ref) {
    var value = _ref.value,
        children = _ref.children;
    maps[value.toString()] = value;
    generateValueMaps(children, maps);
  });
  return maps;
}
//# sourceMappingURL=util.js.map


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pagination = _interopRequireDefault(__webpack_require__(1624));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Pagination["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60), __webpack_require__(72)(module)))

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(221),
    stackClear = __webpack_require__(1643),
    stackDelete = __webpack_require__(1644),
    stackGet = __webpack_require__(1645),
    stackHas = __webpack_require__(1646),
    stackSet = __webpack_require__(1647);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObject = __webpack_require__(344);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 539 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1666),
    arraySome = __webpack_require__(1669),
    cacheHas = __webpack_require__(1670);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1684),
    isObjectLike = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(91),
    stubFalse = __webpack_require__(1685);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 543 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1686),
    baseUnary = __webpack_require__(1687),
    nodeUtil = __webpack_require__(1688);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(537),
    isLength = __webpack_require__(347);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(344);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(549),
    toKey = __webpack_require__(226);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(92),
    isKey = __webpack_require__(348),
    stringToPath = __webpack_require__(1715),
    toString = __webpack_require__(1718);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(141);
/* unused harmony reexport loadNamespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withNamespaces__ = __webpack_require__(1737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__withNamespaces__["a"]; });
/* unused harmony reexport translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NamespacesConsumer__ = __webpack_require__(554);
/* unused harmony reexport NamespacesConsumer */
/* unused harmony reexport I18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(1743);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(1749);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(147);
/* unused harmony reexport withI18n */
/* unused harmony reexport I18nContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__context__["b"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolate__ = __webpack_require__(1750);
/* unused harmony reexport Interpolate */





 // will be deprecated in v9.0.0



/***/ }),
/* 552 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(1741);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NamespacesConsumerComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NamespacesConsumer; });
/* unused harmony export I18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(141);









var removedIsInitialSSR = false;
var NamespacesConsumerComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NamespacesConsumerComponent, _Component);

  function NamespacesConsumerComponent(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NamespacesConsumerComponent);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NamespacesConsumerComponent).call(this, props));

    if (!props.i18n) {
      _this.state = {
        i18nLoadedAt: null,
        ready: false
      };
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* warnOnce */])('You will need pass in an i18next instance either by props, using I18nextProvider or by using i18nextReactModule. Learn more https://react.i18next.com/components/overview#getting-the-i-18-n-function-into-the-flow'));
    }

    if (typeof props.i18n.then === 'function') {
      _this.state = {
        i18nLoadedAt: null,
        ready: false
      };
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* warnOnce */])('Detected a promise instead of an i18next instance. Probably you passed the return value of the i18next.init() function, this is not possible anymore with v13 of i18next. Just pass in the i18next instance directly.'));
    } // nextjs / SSR: getting data from next.js or other ssr stack


    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* initSSR */])(props); // provider SSR: data was set in provider and ssr flag was set

    if (props.i18n.options && props.i18n.options.isInitialSSR) {
      props.i18nOptions.wait = false;
    } // reportNS if needed for SSR


    var namespaces = _this.getNamespaces();

    if (props.reportNS) {
      namespaces.forEach(props.reportNS);
    } // check if we could flag this ready already as all is loaded


    var language = props.i18n.languages && props.i18n.languages[0];
    var ready = !!language && namespaces.every(function (ns) {
      return props.i18n.hasResourceBundle(language, ns);
    });
    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };
    _this.t = _this.getI18nTranslate();
    _this.onI18nChanged = _this.onI18nChanged.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.getI18nTranslate = _this.getI18nTranslate.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.namespaces = _this.getNamespaces.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NamespacesConsumerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadNamespaces();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          i18nOptions = _this$props.i18nOptions;
      this.mounted = false;

      if (this.onI18nChanged) {
        if (i18nOptions.bindI18n) {
          var p = i18nOptions.bindI18n.split(' ');
          p.forEach(function (f) {
            return i18n.off(f, _this2.onI18nChanged);
          });
        }

        if (i18nOptions.bindStore) {
          var _p = i18nOptions.bindStore.split(' ');

          _p.forEach(function (f) {
            return i18n.store && i18n.store.off(f, _this2.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: "onI18nChanged",
    value: function onI18nChanged() {
      var i18nOptions = this.props.i18nOptions;
      var ready = this.state.ready;
      if (!this.mounted) return;
      if (!ready && i18nOptions.omitBoundRerender) return;
      this.t = this.getI18nTranslate();
      this.setState({
        i18nLoadedAt: new Date()
      }); // rerender
    }
  }, {
    key: "getI18nTranslate",
    value: function getI18nTranslate() {
      var _this$props2 = this.props,
          i18n = _this$props2.i18n,
          i18nOptions = _this$props2.i18nOptions;
      var namespaces = this.getNamespaces();
      return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces && namespaces.length ? namespaces[0] : 'translation');
    }
  }, {
    key: "getNamespaces",
    value: function getNamespaces() {
      var _this$props3 = this.props,
          i18n = _this$props3.i18n,
          ns = _this$props3.ns,
          defaultNS = _this$props3.defaultNS;
      var namespaces = typeof ns === 'function' ? ns(this.props) : ns || defaultNS || i18n.options && i18n.options.defaultNS;
      return typeof namespaces === 'string' ? [namespaces] : namespaces || [];
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces() {
      var _this3 = this;

      var _this$props4 = this.props,
          i18n = _this$props4.i18n,
          i18nOptions = _this$props4.i18nOptions;
      var ready = this.state.ready;

      var bind = function bind() {
        if (i18nOptions.bindI18n && i18n) i18n.on(i18nOptions.bindI18n, _this3.onI18nChanged);
        if (i18nOptions.bindStore && i18n.store) i18n.store.on(i18nOptions.bindStore, _this3.onI18nChanged);
      };

      this.mounted = true;
      i18n.loadNamespaces(this.getNamespaces(), function () {
        var handleReady = function handleReady() {
          if (_this3.mounted && !ready) {
            _this3.setState({
              ready: true
            }, function () {
              if (!i18nOptions.wait) _this3.onI18nChanged();
            });
          }

          if (i18nOptions.wait && _this3.mounted) bind();
        };

        if (i18n.isInitialized) {
          handleReady();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              i18n.off('initialized', initialized);
            }, 1000);
            handleReady();
          };

          i18n.on('initialized', initialized);
        }
      });
      if (!i18nOptions.wait) bind();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          i18n = _this$props5.i18n,
          defaultNS = _this$props5.defaultNS,
          reportNS = _this$props5.reportNS,
          i18nOptions = _this$props5.i18nOptions;

      var _ref = this.state || {
        ready: false
      },
          ready = _ref.ready; // fallback if state is null...unknown edge case https://github.com/i18next/react-i18next/issues/615


      var t = this.t;
      if (!ready && i18nOptions.wait) return null; // remove ssr flag set by provider - first render was done from now on wait if set to wait

      if (i18n.options && i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete i18n.options.isInitialSSR;
        }, 100);
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__context__["a" /* I18nContext */].Provider, {
        value: {
          i18n: i18n,
          t: t,
          defaultNS: defaultNS,
          reportNS: reportNS,
          lng: i18n && i18n.language
        }
      }, children(this.t, {
        i18n: i18n,
        t: t,
        lng: i18n.language,
        ready: ready
      }));
    }
  }]);

  return NamespacesConsumerComponent;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
var NamespacesConsumer = Object(__WEBPACK_IMPORTED_MODULE_7__context__["e" /* withI18n */])()(NamespacesConsumerComponent);
var I18n = NamespacesConsumer;

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locales_en_translation_json__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locales_en_translation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__locales_en_translation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales_ro_translation_json__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales_ro_translation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__locales_ro_translation_json__);


__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* reactI18nextModule */]).init({ resources: { en: { translation: __WEBPACK_IMPORTED_MODULE_2__locales_en_translation_json___default.a }, ro: { translation: __WEBPACK_IMPORTED_MODULE_3__locales_ro_translation_json___default.a } }, lng: window.localStorage.getItem('lang') || 'en', fallbackLng: 'en' });/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.destroyFns = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDialog = _interopRequireDefault(__webpack_require__(1774));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _addEventListener = _interopRequireDefault(__webpack_require__(213));

var _locale = __webpack_require__(269);

var _icon = _interopRequireDefault(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(10));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var mousePosition;
var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795

exports.destroyFns = destroyFns;

var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  }; // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开

  setTimeout(function () {
    return mousePosition = null;
  }, 100);
}; // 只有点击事件支持从鼠标位置动画展开


if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
}

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));

    _this.handleCancel = function (e) {
      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel(e);
      }
    };

    _this.handleOk = function (e) {
      var onOk = _this.props.onOk;

      if (onOk) {
        onOk(e);
      }
    };

    _this.renderFooter = function (locale) {
      var _this$props = _this.props,
          okText = _this$props.okText,
          okType = _this$props.okType,
          cancelText = _this$props.cancelText,
          confirmLoading = _this$props.confirmLoading;
      return React.createElement("div", null, React.createElement(_button["default"], _extends({
        onClick: _this.handleCancel
      }, _this.props.cancelButtonProps), cancelText || locale.cancelText), React.createElement(_button["default"], _extends({
        type: okType,
        loading: confirmLoading,
        onClick: _this.handleOk
      }, _this.props.okButtonProps), okText || locale.okText));
    };

    _this.renderModal = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          footer = _a.footer,
          visible = _a.visible,
          wrapClassName = _a.wrapClassName,
          centered = _a.centered,
          getContainer = _a.getContainer,
          closeIcon = _a.closeIcon,
          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);

      var prefixCls = getPrefixCls('modal', customizePrefixCls);
      var defaultFooter = React.createElement(_LocaleReceiver["default"], {
        componentName: "Modal",
        defaultLocale: (0, _locale.getConfirmLocale)()
      }, _this.renderFooter);
      var closeIconToRender = React.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
      }, closeIcon || React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-close-icon"),
        type: "close"
      }));
      return React.createElement(_rcDialog["default"], _extends({}, restProps, {
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible,
        mousePosition: mousePosition,
        onClose: _this.handleCancel,
        closeIcon: closeIconToRender
      }));
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderModal);
    }
  }]);

  return Modal;
}(React.Component);

exports["default"] = Modal;
Modal.defaultProps = {
  width: 520,
  transitionName: 'zoom',
  maskTransitionName: 'fade',
  confirmLoading: false,
  visible: false,
  okType: 'primary'
};
Modal.propTypes = {
  prefixCls: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okText: PropTypes.node,
  cancelText: PropTypes.node,
  centered: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  confirmLoading: PropTypes.bool,
  visible: PropTypes.bool,
  footer: PropTypes.node,
  title: PropTypes.node,
  closable: PropTypes.bool,
  closeIcon: PropTypes.node
};
//# sourceMappingURL=Modal.js.map


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */
function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$element = options.element,
      element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style); // IE browser compatible

  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}

/* harmony default export */ __webpack_exports__["a"] = (setStyle);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(264),
    baseOrderBy = __webpack_require__(1786),
    baseRest = __webpack_require__(564),
    isIterateeCall = __webpack_require__(1795);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1787),
    isArrayLike = __webpack_require__(109);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(186),
    overRest = __webpack_require__(396),
    setToString = __webpack_require__(397);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;

  var positonStyle = vertical ? (_ref = {}, (0, _defineProperty3['default'])(_ref, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref2, 'width', length + '%'), _ref2);

  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
}; /* eslint-disable react/prop-types */
exports['default'] = Track;
module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(84);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(1829);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSlider;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(213);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

var _Steps = __webpack_require__(1836);

var _Steps2 = _interopRequireDefault(_Steps);

var _Marks = __webpack_require__(1837);

var _Marks2 = _interopRequireDefault(_Marks);

var _Handle = __webpack_require__(568);

var _Handle2 = _interopRequireDefault(_Handle);

var _utils = __webpack_require__(355);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3['default'])(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      (0, _classCallCheck3['default'])(this, ComponentEnhancer);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (utils.isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        utils.pauseEvent(e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          utils.pauseEvent(e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = utils.getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
        _this.setState({ value: value }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;

      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
      (0, _warning2['default'])(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      _this.handlesRefs = {};
      return _this;
    }

    (0, _createClass3['default'])(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;

        var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;

        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;

        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
        return _react2['default'].createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          _react2['default'].createElement('div', {
            className: prefixCls + '-rail',
            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          _react2['default'].createElement(_Steps2['default'], {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          _react2['default'].createElement(_Marks2['default'], {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }),
          children
        );
      }
    }]);
    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
    min: _propTypes2['default'].number,
    max: _propTypes2['default'].number,
    step: _propTypes2['default'].number,
    marks: _propTypes2['default'].object,
    included: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    prefixCls: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    children: _propTypes2['default'].any,
    onBeforeChange: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onAfterChange: _propTypes2['default'].func,
    handle: _propTypes2['default'].func,
    dots: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    style: _propTypes2['default'].object,
    reverse: _propTypes2['default'].bool,
    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    railStyle: _propTypes2['default'].object,
    dotStyle: _propTypes2['default'].object,
    activeDotStyle: _propTypes2['default'].object,
    autoFocus: _propTypes2['default'].bool,
    onFocus: _propTypes2['default'].func,
    onBlur: _propTypes2['default'].func
  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);

      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }

      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}
module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(97);
var core = __webpack_require__(74);
var fails = __webpack_require__(130);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(84);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _addEventListener = __webpack_require__(213);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Handle = function (_React$Component) {
  (0, _inherits3['default'])(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleMouseDown = function () {
      // fix https://github.com/ant-design/ant-design/issues/15324
      _this.focus();
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2, _ref3;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);


      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
      var positionStyle = vertical ? (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, (0, _defineProperty3['default'])(_ref3, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref3, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
      var elStyle = (0, _extends3['default'])({}, style, positionStyle);

      var _tabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        _tabIndex = null;
      }

      return _react2['default'].createElement('div', (0, _extends3['default'])({
        ref: this.setHandleRef,
        tabIndex: _tabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);
  return Handle;
}(_react2['default'].Component);

exports['default'] = Handle;


Handle.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  style: _propTypes2['default'].object,
  disabled: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  tabIndex: _propTypes2['default'].number,
  reverse: _propTypes2['default'].bool
};
module.exports = exports['default'];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(401);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetProfileForm__loginForm__3iX60","alertsMb":"ResetProfileForm__alertsMb__15AIN","submitButton":"ResetProfileForm__submitButton__3wYO8","paragraph":"ResetProfileForm__paragraph__141JQ"};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _dropdown = _interopRequireDefault(__webpack_require__(340));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    var _this;

    _classCallCheck(this, BreadcrumbItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BreadcrumbItem).apply(this, arguments));

    _this.renderBreadcrumbItem = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          separator = _a.separator,
          children = _a.children,
          restProps = __rest(_a, ["prefixCls", "separator", "children"]);

      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
      var link;

      if ('href' in _this.props) {
        link = React.createElement("a", _extends({
          className: "".concat(prefixCls, "-link")
        }, (0, _omit["default"])(restProps, ['overlay'])), children);
      } else {
        link = React.createElement("span", _extends({
          className: "".concat(prefixCls, "-link")
        }, (0, _omit["default"])(restProps, ['overlay'])), children);
      } // wrap to dropDown


      link = _this.renderBreadcrumbNode(link, prefixCls);

      if (children) {
        return React.createElement("span", null, link, separator && separator !== '' && React.createElement("span", {
          className: "".concat(prefixCls, "-separator")
        }, separator));
      }

      return null;
    };
    /**
     * if overlay is have
     * Wrap a DropDown
     */


    _this.renderBreadcrumbNode = function (breadcrumbItem, prefixCls) {
      var overlay = _this.props.overlay;

      if (overlay) {
        return React.createElement(_dropdown["default"], {
          overlay: overlay,
          placement: "bottomCenter"
        }, React.createElement("span", {
          className: "".concat(prefixCls, "-overlay-link")
        }, breadcrumbItem, React.createElement(_icon["default"], {
          type: "down"
        })));
      }

      return breadcrumbItem;
    };

    return _this;
  }

  _createClass(BreadcrumbItem, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem);
    }
  }]);

  return BreadcrumbItem;
}(React.Component);

exports["default"] = BreadcrumbItem;
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
BreadcrumbItem.defaultProps = {
  separator: '/'
};
BreadcrumbItem.propTypes = {
  prefixCls: PropTypes.string,
  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  href: PropTypes.string
};
//# sourceMappingURL=BreadcrumbItem.js.map


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1881);

__webpack_require__(209);

__webpack_require__(332);

__webpack_require__(511);

__webpack_require__(187);
//# sourceMappingURL=index.js.map


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _spin = _interopRequireDefault(__webpack_require__(333));

var _configProvider = __webpack_require__(30);

var _pagination = _interopRequireDefault(__webpack_require__(532));

var _grid = __webpack_require__(188);

var _Item = _interopRequireDefault(__webpack_require__(1883));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var List =
/*#__PURE__*/
function (_React$Component) {
  _inherits(List, _React$Component);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(List).call(this, props));
    _this.defaultPaginationProps = {
      current: 1,
      total: 0
    };
    _this.keys = {};
    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');

    _this.renderItem = function (item, index) {
      var _this$props = _this.props,
          renderItem = _this$props.renderItem,
          rowKey = _this$props.rowKey;
      if (!renderItem) return null;
      var key;

      if (typeof rowKey === 'function') {
        key = rowKey(item);
      } else if (typeof rowKey === 'string') {
        key = item[rowKey];
      } else {
        key = item.key;
      }

      if (!key) {
        key = "list-item-".concat(index);
      }

      _this.keys[index] = key;
      return renderItem(item, index);
    };

    _this.renderEmpty = function (prefixCls, renderEmpty) {
      var locale = _this.props.locale;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-empty-text")
      }, locale && locale.emptyText || renderEmpty('List'));
    };

    _this.renderList = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;
      var _this$state = _this.state,
          paginationCurrent = _this$state.paginationCurrent,
          paginationSize = _this$state.paginationSize;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          bordered = _a.bordered,
          split = _a.split,
          className = _a.className,
          children = _a.children,
          itemLayout = _a.itemLayout,
          loadMore = _a.loadMore,
          pagination = _a.pagination,
          grid = _a.grid,
          _a$dataSource = _a.dataSource,
          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
          size = _a.size,
          header = _a.header,
          footer = _a.footer,
          loading = _a.loading,
          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var loadingProp = loading;

      if (typeof loadingProp === 'boolean') {
        loadingProp = {
          spinning: loadingProp
        };
      }

      var isLoading = loadingProp && loadingProp.spinning; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';
          break;

        default:
          break;
      }

      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));

      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
      }), pagination || {});

      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);

      if (paginationProps.current > largestPage) {
        paginationProps.current = largestPage;
      }

      var paginationContent = pagination ? React.createElement("div", {
        className: "".concat(prefixCls, "-pagination")
      }, React.createElement(_pagination["default"], _extends({}, paginationProps, {
        onChange: _this.onPaginationChange,
        onShowSizeChange: _this.onPaginationShowSizeChange
      }))) : null;

      var splitDataSource = _toConsumableArray(dataSource);

      if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
        }
      }

      var childrenContent;
      childrenContent = isLoading && React.createElement("div", {
        style: {
          minHeight: 53
        }
      });

      if (splitDataSource.length > 0) {
        var items = splitDataSource.map(function (item, index) {
          return _this.renderItem(item, index);
        });
        var childrenList = [];
        React.Children.forEach(items, function (child, index) {
          childrenList.push(React.cloneElement(child, {
            key: _this.keys[index]
          }));
        });
        childrenContent = grid ? React.createElement(_grid.Row, {
          gutter: grid.gutter
        }, childrenList) : React.createElement("ul", {
          className: "".concat(prefixCls, "-items")
        }, childrenList);
      } else if (!children && !isLoading) {
        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
      }

      var paginationPosition = paginationProps.position || 'bottom';
      return React.createElement("div", _extends({
        className: classString
      }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, header), React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent);
    };

    var pagination = props.pagination;
    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
    _this.state = {
      paginationCurrent: paginationObj.defaultCurrent || 1,
      paginationSize: paginationObj.defaultPageSize || 10
    };
    return _this;
  }

  _createClass(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        grid: this.props.grid,
        itemLayout: this.props.itemLayout
      };
    }
  }, {
    key: "triggerPaginationEvent",
    value: function triggerPaginationEvent(eventName) {
      var _this2 = this;

      return function (page, pageSize) {
        var pagination = _this2.props.pagination;

        _this2.setState({
          paginationCurrent: page,
          paginationSize: pageSize
        });

        if (pagination && pagination[eventName]) {
          pagination[eventName](page, pageSize);
        }
      };
    }
  }, {
    key: "isSomethingAfterLastItem",
    value: function isSomethingAfterLastItem() {
      var _this$props2 = this.props,
          loadMore = _this$props2.loadMore,
          pagination = _this$props2.pagination,
          footer = _this$props2.footer;
      return !!(loadMore || pagination || footer);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderList);
    }
  }]);

  return List;
}(React.Component);

exports["default"] = List;
List.Item = _Item["default"];
List.childContextTypes = {
  grid: PropTypes.any,
  itemLayout: PropTypes.string
};
List.defaultProps = {
  dataSource: [],
  bordered: false,
  split: true,
  loading: false,
  pagination: false
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({ permissions_radomize: { name: 'Permissions Randomization Platform', fields: [{ key: 'site_access', name: 'Site access' }, { key: 'randomization_access', name: 'Randomization access' }, { key: 'consent_access', name: 'Consent access' }, { key: 'validate_randomization_access', name: 'Validation access' }, { key: 'sae_access', name: 'SAE access' }] }, permissions_admin_dashboard: { name: 'Dashboard', fields: [{ key: 'dashboard', name: 'Dashboard', permissions: [{ key: 'read', value: 'Read' }, { key: 'read_enrolment_by_site', value: 'Enrolment by Site Graph' }, { key: 'read_enrolment_stages', value: 'Enrolment by Stage Graph' }, { key: 'read_sae', value: 'SAE Graph' }, { key: 'read_deviation', value: 'Deviations Graph' }, { key: '90d_follow_ups', value: '90-Day Follow-ups' }] }] }, permissions_admin_patient: { name: 'Patients', fields: [{ key: 'patient_profile', name: 'Patient Profile', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'read_restricted', value: 'Read restricted' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }, { key: 'unlock', value: 'Unlock' }, { key: 'lock', value: 'Lock' }] }, { key: 'patient_document', name: 'Patient Documents', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'follow_up_90d', name: '90-Day Follow-ups', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }, { key: 'unlock', value: 'Unlock' }, { key: 'lock', value: 'Lock' }] }, { key: 'sae', name: 'SAE', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }, { key: 'unlock', value: 'Unlock' }, { key: 'lock', value: 'Lock' }] }, { key: 'central_sae_comments', name: 'Central SAE Comments', permissions: [{ key: 'read', value: 'Central SAE Comments Read' }, { key: 'update', value: 'Central SAE Comments Update' }] }, { key: 'sae_term_codes', name: 'SAE term codes', permissions: [{ key: 'view', value: 'SAE Term Codes View' }, { key: 'update', value: 'SAE Term Codes Update' }] }, { key: 'enrolled_patient_summary_read', name: 'Enrolled Patients View' }, { key: 'consent_given_update', name: 'Consent given update' }] }, manage_trial: { name: 'Admin Settings', fields: [{ key: 'admin_settings', name: 'View Admin Settings Menu' }, { key: 'role', name: 'Role', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'user', name: 'User', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'training', name: 'Training', permissions: [{ key: 'upsert', value: 'Upsert' }] }, { key: 'site', name: 'Site', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'user_site_access', name: 'User Site Access', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'consent_setting', name: 'Consent Settings', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }, { key: 'general_setting', name: 'General Settings', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }] }, document_management: { name: 'Document Management', fields: [{ key: 'document', name: 'Document Management', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }, { key: 'approve', value: 'Approve' }, { key: 'unapprove', value: 'Unapprove' }] }] }, document_access: { name: 'Document Access', fields: [{ key: 'document_public_access', name: 'Public document access' }, { key: 'document_general_access', name: 'General document access' }, { key: 'document_general_private_access', name: 'General Private document access' }, { key: 'document_per_site_access', name: 'Site document access' }, { key: 'document_training_access', name: 'Training document access' }, { key: 'document_validation_access', name: 'Validation document access' }] }, multi_factor_authentication: { name: 'Multi-factor Authentication', fields: [{ key: 'two_factor', name: 'Multi-factor Authentication', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }] }, audit_log: { name: 'Audit Logs', fields: [{ key: 'audit_log', name: 'Audit Logs', permissions: [{ key: 'read', value: 'Read' }, { key: 'edit', value: 'Edit' }, { key: 'delete', value: 'Delete' }, { key: 'review', value: 'Review' }] }] }, simulation: { name: 'Simulation', fields: [{ key: 'simulation', name: 'Simulation', permissions: [{ key: 'read', value: 'Read' }, { key: 'create', value: 'Create' }, { key: 'delete', value: 'Delete' }, { key: 'update', value: 'Update' }] }] }, user_training: { name: 'Training Module', fields: [{ key: 'user_training', name: 'User Training', permissions: [{ key: 'read', value: 'Read' }, { key: 'start', value: 'Start' }, { key: 'verify', value: 'Verify' }, { key: 'reset', value: 'Reset Retries' }] }, { key: 'training_upsert', name: 'Create Training for users (admin only)' }] }, reports: { name: 'Reports', fields: [{ key: 'reports_read', name: 'Reports read' }, { key: 'reports_sites_read', name: 'Reports sites read' }, { key: 'reports_users_read', name: 'Reports users read' }, { key: 'reports_subjects_read', name: 'Reports subjects read' }, { key: 'reports_sae_read', name: 'Reports sae read' }, { key: 'reports_deviations_read', name: 'Reports deviations read' }, { key: 'reports_consent_read', name: 'Reports consent read' }, { key: 'reports_death_read', name: 'Reports death read' }, { key: 'reports_blinded_allocations_read', name: 'Reports blinded allocations read' }, { key: 'reports_combined_read', name: 'Reports combined read' }, { key: 'reports_follow_up_read', name: 'Reports follow up read' }] }, notifications: { name: 'Randomization Platform Notifications', fields: [{ key: 'notification', name: 'Randomization', permissions: [{ key: 'randomization_summary', value: 'Summary' }, { key: 'randomization_detailed', value: 'Detailed' }, { key: '2_day_reminder', value: '2-Day Reminder' }, { key: '7_day_reminder', value: '7-Day Reminder' }] }, { key: 'notification_consent', name: 'Consent Obtained' }, { key: 'notification_validate_randomization', name: 'Validate Randomization Complete' }, { key: 'notification_validation_differs_from_randomization', name: 'Validation Differs from randomization' }, { key: 'notification_randomization_closed', name: 'Notification Randomization Closed' }, { key: 'notification_validation_sae_occurred', name: 'SAE occured' }, { key: 'report_subject_summary', name: 'Report Subject Summary' }] }, notificationsAdmin: { name: 'Trial Management Portal Notifications', fields: [{ key: 'notification_death', name: 'Death Occured' }, { key: 'notification_new_user', name: 'New User' }, { key: 'notification_new_user_welcome', name: 'New User Welcome Email' }, { key: 'notification_new_site', name: 'New Site' }, { key: 'notification_suspended_site', name: 'Site Suspended' }, { key: 'notification_training_completed', name: 'Training Completed' }, { key: 'notification_site_randomization_status_changed', name: 'Site Randomization - Activate / Deactivate' }, { key: 'notification_document_expire', name: 'Notification document expire' }, { key: 'notification_newsletter', name: 'Notification Newsletter' }, { key: 'notification_consent_missing_report', name: 'Notification consent missing report' }, { key: 'notification_user_status_changed', name: 'Notification user status changed' }, { key: 'notification_90_day', name: '90-Day Follow-ups', permissions: [{ key: 'follow_up_completed', value: 'Completed' }] }, { key: 'notification_document', name: 'Documents', permissions: [{ key: 'pending_approval', value: 'Pending Approval' }, { key: 'document_approved', value: 'Document Approved' }] }] }, newsletter: { name: 'Newsletter', fields: [{ key: 'newsletter', name: 'Newsletter', permissions: [{ key: 'create', value: 'Create' }, { key: 'read', value: 'Read' }, { key: 'update', value: 'Update' }, { key: 'delete', value: 'Delete' }] }] } });

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(229);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getSecondaryColor */])(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties(props, ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"]);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getSecondaryColor */])(primaryColor)
    };
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* useInsertStyles */])();
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* warning */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isIconDefinition */])(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isIconDefinition */])(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread({}, target, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* generate */])(target.icon, "svg-".concat(target.name), _objectSpread({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
/* harmony default export */ __webpack_exports__["a"] = (IconBase);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setTwoToneColor;
/* harmony export (immutable) */ __webpack_exports__["a"] = getTwoToneColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconBase__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(229);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* normalizeTwoToneColors */])(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return __WEBPACK_IMPORTED_MODULE_0__IconBase__["a" /* default */].setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = __WEBPACK_IMPORTED_MODULE_0__IconBase__["a" /* default */].getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(229);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Icon = function Icon(props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = _objectWithoutProperties(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* warning */])(Boolean(Component || children), 'Should have `component` prop or `children`.');
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* useInsertStyles */])();
  var classString = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('anticon', className);
  var svgClassString = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* svgBaseProps */], {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* warning */])(Boolean(viewBox) || __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
};

Icon.displayName = 'AntdIcon';
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Icon));

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(69);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _input = _interopRequireDefault(__webpack_require__(14));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).apply(this, arguments));

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(e);
      }
    };

    _this.handleClear = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          handleClear = _this$props.handleClear,
          disabled = _this$props.disabled;

      if (!disabled && handleClear) {
        handleClear(e);
      }
    };

    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          prefixCls = _this$props2.prefixCls,
          disabled = _this$props2.disabled;
      var icon = value && value.length > 0 ? React.createElement("a", {
        href: "#",
        className: "".concat(prefixCls, "-action"),
        onClick: this.handleClear
      }, React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled"
      })) : React.createElement("span", {
        className: "".concat(prefixCls, "-action")
      }, React.createElement(_icon["default"], {
        type: "search"
      }));
      return React.createElement("div", null, React.createElement(_input["default"], {
        placeholder: placeholder,
        className: prefixCls,
        value: value,
        onChange: this.handleChange,
        disabled: disabled
      }), icon);
    }
  }]);

  return Search;
}(React.Component);

exports["default"] = Search;
Search.defaultProps = {
  placeholder: ''
};
//# sourceMappingURL=search.js.map


/***/ }),
/* 581 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(3519);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(582);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3542).Buffer))

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(3547);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Quill = __webpack_require__(584);

var QuillMixin = {

	/**
	Creates an editor on the given element. The editor will
	be passed the configuration, have its events bound,
	*/
	createEditor: function($el, config) {
		var editor = new Quill($el, config);
		if (config.tabIndex !== undefined) {
			this.setEditorTabIndex(editor, config.tabIndex);
		}
		this.hookEditor(editor);
		return editor;
	},

	hookEditor: function(editor) {
		// Expose the editor on change events via a weaker,
		// unprivileged proxy object that does not allow
		// accidentally modifying editor state.
		var unprivilegedEditor = this.makeUnprivilegedEditor(editor);

		this.handleTextChange = function(delta, oldDelta, source) {
			if (this.onEditorChangeText) {
				this.onEditorChangeText(
					editor.root.innerHTML, delta, source,
					unprivilegedEditor
				);
				this.onEditorChangeSelection(
					editor.getSelection(), source,
					unprivilegedEditor
				);
			}
		}.bind(this);

		this.handleSelectionChange = function(range, oldRange, source) {
			if (this.onEditorChangeSelection) {
				this.onEditorChangeSelection(
					range, source,
					unprivilegedEditor
				);
			}
		}.bind(this);

		editor.on('editor-change', function(eventType, rangeOrDelta, oldRangeOrOldDelta, source) {
			if (eventType === Quill.events.SELECTION_CHANGE) {
				this.handleSelectionChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}
			
			if (eventType === Quill.events.TEXT_CHANGE) {
				this.handleTextChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}
		}.bind(this));
	},

	unhookEditor: function(editor) {
		editor.off('selection-change');
		editor.off('text-change');
	},

	setEditorReadOnly: function(editor, value) {
		value? editor.disable()
		     : editor.enable();
	},

	/*
	Replace the contents of the editor, but keep
	the previous selection hanging around so that
	the cursor won't move.
	*/
	setEditorContents: function(editor, value) {
		var sel = editor.getSelection();

		if (typeof value === 'string') {
			editor.setContents(editor.clipboard.convert(value));
		} else {
			editor.setContents(value);
		}

		if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
	},

	setEditorSelection: function(editor, range) {
		if (range) {
			// Validate bounds before applying.
			var length = editor.getLength();
			range.index = Math.max(0, Math.min(range.index, length-1));
			range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
		}
		editor.setSelection(range);
	},

	setEditorTabIndex: function(editor, tabIndex) {
		if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
			editor.editor.scroll.domNode.tabIndex = tabIndex;
		}
	},

	/*
	Returns an weaker, unprivileged proxy object that only
	exposes read-only accessors found on the editor instance,
	without any state-modificating methods.
	*/
	makeUnprivilegedEditor: function(editor) {
		var e = editor;
		return {
			getLength:    function(){ return e.getLength.apply(e, arguments); },
			getText:      function(){ return e.getText.apply(e, arguments); },
			getHTML:      function(){ return e.root.innerHTML },
			getContents:  function(){ return e.getContents.apply(e, arguments); },
			getSelection: function(){ return e.getSelection.apply(e, arguments); },
			getBounds:    function(){ return e.getBounds.apply(e, arguments); },
		};
	}

};

module.exports = QuillMixin;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(3548),
    findIndex = __webpack_require__(3627);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230),
    stackClear = __webpack_require__(3556),
    stackDelete = __webpack_require__(3557),
    stackGet = __webpack_require__(3558),
    stackHas = __webpack_require__(3559),
    stackSet = __webpack_require__(3560);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObject = __webpack_require__(173);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 591 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(3580),
    arraySome = __webpack_require__(593),
    cacheHas = __webpack_require__(3583);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(3597),
    isObjectLike = __webpack_require__(174);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(93),
    stubFalse = __webpack_require__(3598);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(3599),
    baseUnary = __webpack_require__(3600),
    nodeUtil = __webpack_require__(3601);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(173);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(600),
    toKey = __webpack_require__(238);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(94),
    isKey = __webpack_require__(363),
    stringToPath = __webpack_require__(3614),
    toString = __webpack_require__(3617);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(360);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function(f) {
  if (true) {
    module.exports = f(__webpack_require__(0));
    /* global define */
  } else if (typeof define === 'function' && define.amd) {
    define(['react'], f);
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function(React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan'),
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});



/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(605);
module.exports = __webpack_require__(610);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(606).enable();
  window.Promise = __webpack_require__(608);
}

// fetch() polyfill for making API calls.
__webpack_require__(609);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(95);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(364);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(364);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 609 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_history__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_App_App__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_css__ = __webpack_require__(3659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(555);


Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["a" /* ConnectedRouter */], { history: __WEBPACK_IMPORTED_MODULE_5__store_history__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_App_App__["a" /* default */], null))), document.getElementById("root"));

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(95),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.0";


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(95),r=__webpack_require__(613);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;pa.hasOwnProperty("ReactCurrentDispatcher")||(pa.ReactCurrentDispatcher={current:null});pa.hasOwnProperty("ReactCurrentBatchConfig")||(pa.ReactCurrentBatchConfig={suspense:null});
var qa=/^(.*)[\\\/]/,v="function"===typeof Symbol&&Symbol.for,ra=v?Symbol.for("react.element"):60103,sa=v?Symbol.for("react.portal"):60106,ta=v?Symbol.for("react.fragment"):60107,ua=v?Symbol.for("react.strict_mode"):60108,va=v?Symbol.for("react.profiler"):60114,wa=v?Symbol.for("react.provider"):60109,xa=v?Symbol.for("react.context"):60110,ya=v?Symbol.for("react.concurrent_mode"):60111,za=v?Symbol.for("react.forward_ref"):60112,Aa=v?Symbol.for("react.suspense"):60113,Ba=v?Symbol.for("react.suspense_list"):
60120,Ca=v?Symbol.for("react.memo"):60115,Da=v?Symbol.for("react.lazy"):60116,Ea=v?Symbol.for("react.block"):60121,Fa="function"===typeof Symbol&&Symbol.iterator;function Ga(a){if(null===a||"object"!==typeof a)return null;a=Fa&&a[Fa]||a["@@iterator"];return"function"===typeof a?a:null}function Ha(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Ia(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ta:return"Fragment";case sa:return"Portal";case va:return"Profiler";case ua:return"StrictMode";case Aa:return"Suspense";case Ba:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case xa:return"Context.Consumer";case wa:return"Context.Provider";case za:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ca:return Ia(a.type);case Ea:return Ia(a.render);case Da:if(a=1===a._status?a._result:null)return Ia(a)}return null}function Ja(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ia(a.type);c=null;d&&(c=Ia(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(qa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ka=null,La={};
function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!Na[c]){if(!b.extractEvents)throw Error(u(97,a));Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(Oa.hasOwnProperty(h))throw Error(u(99,h));Oa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Pa(k[e],g,h);e=!0}else f.registrationName?(Pa(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function Pa(a,b,c){if(Qa[a])throw Error(u(100,a));Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!La.hasOwnProperty(c)||La[c]!==d){if(La[c])throw Error(u(102,c));La[c]=d;b=!0}}b&&Ma()}var Ta=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ua=null,Va=null,Wa=null;
function Xa(a){if(a=ma(a)){if("function"!==typeof Ua)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),Ua(a.stateNode,a.type,b))}}function Ya(a){Va?Wa?Wa.push(a):Wa=[a]:Va=a}function Za(){if(Va){var a=Va,b=Wa;Wa=Va=null;Xa(a);if(b)for(a=0;a<b.length;a++)Xa(b[a])}}function $a(a,b){return a(b)}function ab(a,b,c,d,e){return a(b,c,d,e)}function bb(){}var cb=$a,db=!1,eb=!1;function fb(){if(null!==Va||null!==Wa)bb(),Za()}
function gb(a,b,c){if(eb)return a(b,c);eb=!0;try{return cb(a,b,c)}finally{eb=!1,fb()}}var hb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ib=Object.prototype.hasOwnProperty,jb={},kb={};
function lb(a){if(ib.call(kb,a))return!0;if(ib.call(jb,a))return!1;if(hb.test(a))return kb[a]=!0;jb[a]=!0;return!1}function mb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function nb(a,b,c,d){if(null===b||"undefined"===typeof b||mb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var E={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new C(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new C(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new C(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new C(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new C(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){E[a]=new C(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){E[a]=new C(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){E[a]=new C(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){E[a]=new C(a,5,!1,a.toLowerCase(),null,!1)});var ob=/[\-:]([a-z])/g;function pb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ob,
pb);E[b]=new C(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!1)});
E.xlinkHref=new C("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!0)});
function qb(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(nb(b,c,e,d)&&(c=null),d||null===e?lb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&qb(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
Ta&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<Na.length;k++){var l=Na[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){db||bb();var e=id,f=db;db=!0;try{ab(e,a,b,c,d)}finally{(db=f)||fb()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{gb(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{gb(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=Ra[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=Ta&&"CompositionEvent"in window,ke=null;Ta&&"documentMode"in document&&(ke=document.documentMode);
var le=Ta&&"TextEvent"in window&&!ke,me=Ta&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Ya(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;Ta&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),db)mc(a);else{db=!0;try{$a(Ce,a)}finally{db=!1,fb()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=Ta&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=Ra.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(Ka)throw Error(u(101));Ka=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ma();var xf=Nc;la=Qd;ma=xf;na=Pd;Sa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Ia(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=pa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ra:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case sa:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
Ga(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ra:return c.key===e?c.type===ta?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case sa:return c.key===e?l(a,b,c,d):null}if(Og(c)||Ga(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ra:return a=a.get(null===d.key?c:d.key)||null,d.type===ta?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case sa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||Ga(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=Ga(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ta&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ra:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ta){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ta?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case sa:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(Ga(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=pa.ReactCurrentDispatcher,kh=pa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=pa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Qa.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(Qa.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):Qa.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(Qa.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&qb(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:Ja(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Ja(c));null!==c&&Ia(c.type);b=b.value;null!==a&&1===a.tag&&Ia(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):qb(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=pa.ReactCurrentDispatcher,dj=pa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):g.memoizedState=null}var m=0!==
(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;break a}h=void 0;g=b;var A=e.pingCache;
null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((Ia(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Ja(g))}S!==jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=
h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}
function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Ha(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===za)return 11;if(a===Ca)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ta:return Wg(c.children,e,f,b);case ya:g=8;e|=7;break;case ua:g=8;e|=1;break;case va:return a=Sh(12,c,b,e|8),a.elementType=va,a.type=va,a.expirationTime=f,a;case Aa:return a=Sh(13,c,b,e),a.type=Aa,a.elementType=Aa,a.expirationTime=f,a;case Ba:return a=Sh(19,c,b,e),a.elementType=Ba,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case wa:g=
10;break a;case xa:g=9;break a;case za:g=11;break a;case Ca:g=14;break a;case Da:g=16;d=null;break a;case Ea:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:sa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
Ua=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};$a=Mj;
ab=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};bb=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};cb=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,Sa,Oa,Xd,function(a){jc(a,Wd)},Ya,Za,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:pa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.0";


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(614);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context__ = __webpack_require__(239);





var Provider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };

  _proto.subscribe = function subscribe() {
    var _this2 = this;

    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();

      if (!_this2._isMounted) {
        return;
      }

      _this2.setState(function (providerState) {
        // If the value is the same, skip the unnecessary state update.
        if (providerState.storeState === newStoreState) {
          return null;
        }

        return {
          storeState: newStoreState
        };
      });
    }); // Actions might have been dispatched between render and mount - handle those

    var postMountStoreState = store.getState();

    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };

  _proto.render = function render() {
    var Context = this.props.context || __WEBPACK_IMPORTED_MODULE_3__Context__["a" /* ReactReduxContext */];
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(617);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(629);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(366);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(625);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(60), __webpack_require__(624)(module)))

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(366);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(367);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(630);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(368);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(370);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var createConnectedRouter = function createConnectedRouter(structure) {
  var _createSelectors = Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["a" /* default */])(structure),
      getLocation = _createSelectors.getLocation;
  /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */


  var ConnectedRouter =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ConnectedRouter, _PureComponent);

    function ConnectedRouter(props) {
      var _this;

      _classCallCheck(this, ConnectedRouter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectedRouter).call(this, props));
      var store = props.store,
          history = props.history,
          onLocationChanged = props.onLocationChanged;
      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling

      _this.unsubscribe = store.subscribe(function () {
        // Extract store's location
        var _getLocation = getLocation(store.getState()),
            pathnameInStore = _getLocation.pathname,
            searchInStore = _getLocation.search,
            hashInStore = _getLocation.hash,
            stateInStore = _getLocation.state; // Extract history's location


        var _history$location = history.location,
            pathnameInHistory = _history$location.pathname,
            searchInHistory = _history$location.search,
            hashInHistory = _history$location.hash,
            stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed

        if (props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || stateInStore !== stateInHistory)) {
          _this.inTimeTravelling = true; // Update history's location to match store's location

          history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore,
            state: stateInStore
          });
        }
      });

      var handleLocationChange = function handleLocationChange(location, action) {
        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // Dispatch onLocationChanged except when we're in time travelling
        if (!_this.inTimeTravelling) {
          onLocationChanged(location, action, isFirstRendering);
        } else {
          _this.inTimeTravelling = false;
        }
      }; // Listen to history changes


      _this.unlisten = history.listen(handleLocationChange); // Dispatch a location change action for the initial location.
      // This makes it backward-compatible with react-router-redux.
      // But, we add `isFirstRendering` to `true` to prevent double-rendering.

      handleLocationChange(history.location, history.action, true);
      return _this;
    }

    _createClass(ConnectedRouter, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unlisten();
        this.unsubscribe();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            history = _this$props.history,
            children = _this$props.children;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Router */], {
          history: history
        }, children);
      }
    }]);

    return ConnectedRouter;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

  ConnectedRouter.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      getState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      listen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    onLocationChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* onLocationChanged */])(location, action, isFirstRendering));
      }
    };
  };

  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
    var Context = props.context || __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* ReactReduxContext */];

    if (Context == null) {
      throw 'Please upgrade to react-redux v6';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Consumer, null, function (_ref) {
      var store = _ref.store;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedRouter, _extends({
        store: store
      }, props));
    });
  };

  ConnectedRouterWithContext.propTypes = {
    context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* connect */])(null, mapDispatchToProps)(ConnectedRouterWithContext);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedRouter);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(177);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 635 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(637)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(178);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */

var injectQuery = function injectQuery(location) {
  var searchQuery = location && location.search;

  if (typeof searchQuery !== 'string' || searchQuery.length === 0) {
    return _objectSpread({}, location, {
      query: {}
    });
  } // Ignore the `?` part of the search string e.g. ?username=codejockie


  var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy

  var queries = search.split('&'); // Contruct query

  var query = queries.reduce(function (acc, currentQuery) {
    // Split on `=`, to get key and value
    var _currentQuery$split = currentQuery.split('='),
        _currentQuery$split2 = _slicedToArray(_currentQuery$split, 2),
        queryKey = _currentQuery$split2[0],
        queryValue = _currentQuery$split2[1];

    return _objectSpread({}, acc, _defineProperty({}, queryKey, queryValue));
  }, {});
  return _objectSpread({}, location, {
    query: query
  });
};

var createConnectRouter = function createConnectRouter(structure) {
  var fromJS = structure.fromJS,
      merge = structure.merge;

  var createRouterReducer = function createRouterReducer(history) {
    var initialRouterState = fromJS({
      location: injectQuery(history.location),
      action: history.action
    });
    /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */

    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref.type,
          payload = _ref.payload;

      if (type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* LOCATION_CHANGE */]) {
        var location = payload.location,
            action = payload.action,
            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
        // to prevent the double-rendering issue on initilization

        return isFirstRendering ? state : merge(state, {
          location: fromJS(injectQuery(location)),
          action: action
        });
      }

      return state;
    };
  };

  return createRouterReducer;
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectRouter);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getIn__ = __webpack_require__(640);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var structure = {
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: __WEBPACK_IMPORTED_MODULE_0__getIn__["a" /* default */],
  merge: function merge(state, payload) {
    return _objectSpread({}, state, payload);
  },
  toJS: function toJS(value) {
    return value;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Code from github.com/erikras/redux-form by Erik Rasmussen */
var getIn = function getIn(state, path) {
  if (!state) {
    return state;
  }

  var length = path.length;

  if (!length) {
    return undefined;
  }

  var result = state;

  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(178);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */

var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      return function (action) {
        // eslint-disable-line no-unused-vars
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;
        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (routerMiddleware);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_localstorage__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(650);


var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["b" /* connectRouter */])(__WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__reducers__["a" /* default */]), {}, Object(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__["composeWithDevTools"])(__WEBPACK_IMPORTED_MODULE_5_redux_localstorage___default()(['user']), Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["c" /* routerMiddleware */])(__WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */])), Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */])));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(176).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = persistState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createSlicerJs = __webpack_require__(646);

var _createSlicerJs2 = _interopRequireDefault(_createSlicerJs);

var _utilMergeStateJs = __webpack_require__(649);

var _utilMergeStateJs2 = _interopRequireDefault(_utilMergeStateJs);

/**
 * @description
 * persistState is a Store Enhancer that syncs (a subset of) store state to localStorage.
 *
 * @param {String|String[]} [paths] Specify keys to sync with localStorage, if left undefined the whole store is persisted
 * @param {Object} [config] Optional config object
 * @param {String} [config.key="redux"] String used as localStorage key
 * @param {Function} [config.slicer] (paths) => (state) => subset. A function that returns a subset
 * of store state that should be persisted to localStorage
 * @param {Function} [config.serialize=JSON.stringify] (subset) => serializedData. Called just before persisting to
 * localStorage. Should transform the subset into a format that can be stored.
 * @param {Function} [config.deserialize=JSON.parse] (persistedData) => subset. Called directly after retrieving
 * persistedState from localStorage. Should transform the data into the format expected by your application
 *
 * @return {Function} An enhanced store
 */

function persistState(paths, config) {
  var cfg = _extends({
    key: 'redux',
    merge: _utilMergeStateJs2['default'],
    slicer: _createSlicerJs2['default'],
    serialize: JSON.stringify,
    deserialize: JSON.parse
  }, config);

  var key = cfg.key;
  var merge = cfg.merge;
  var slicer = cfg.slicer;
  var serialize = cfg.serialize;
  var deserialize = cfg.deserialize;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
        enhancer = initialState;
        initialState = undefined;
      }

      var persistedState = undefined;
      var finalInitialState = undefined;

      try {
        persistedState = deserialize(localStorage.getItem(key));
        finalInitialState = merge(initialState, persistedState);
      } catch (e) {
        console.warn('Failed to retrieve initialize state from localStorage:', e);
      }

      var store = next(reducer, finalInitialState, enhancer);
      var slicerFn = slicer(paths);

      store.subscribe(function () {
        var state = store.getState();
        var subset = slicerFn(state);

        try {
          localStorage.setItem(key, serialize(subset));
        } catch (e) {
          console.warn('Unable to persist state to localStorage:', e);
        }
      });

      return store;
    };
  };
}

module.exports = exports['default'];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = createSlicer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _getSubsetJs = __webpack_require__(647);

var _getSubsetJs2 = _interopRequireDefault(_getSubsetJs);

var _utilTypeOfJs = __webpack_require__(648);

var _utilTypeOfJs2 = _interopRequireDefault(_utilTypeOfJs);

/**
 * @description
 * createSlicer inspects the typeof paths and returns an appropriate slicer function.
 *
 * @param {String|String[]} [paths] The paths argument supplied to persistState.
 *
 * @return {Function} A slicer function, which returns the subset to store when called with Redux's store state.
 */

function createSlicer(paths) {
  switch ((0, _utilTypeOfJs2['default'])(paths)) {
    case 'void':
      return function (state) {
        return state;
      };
    case 'string':
      return function (state) {
        return (0, _getSubsetJs2['default'])(state, [paths]);
      };
    case 'array':
      return function (state) {
        return (0, _getSubsetJs2['default'])(state, paths);
      };
    default:
      return console.error('Invalid paths argument, should be of type String, Array or Void');
  }
}

module.exports = exports['default'];

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @description
 * getSubset returns an object with the same structure as the original object passed in,
 * but contains only the specified keys and only if that key has a truth-y value.
 *
 * @param {Object} obj The object from which to create a subset.
 * @param {String[]} paths An array of (top-level) keys that should be included in the subset.
 *
 * @return {Object} An object that contains the specified keys with truth-y values
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSubset;

function getSubset(obj, paths) {
  var subset = {};

  paths.forEach(function (key) {
    var slice = obj[key];
    if (slice) subset[key] = slice;
  });

  return subset;
}

module.exports = exports["default"];

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = typeOf;
var _isArray = Array.isArray || (Array.isArray = function (a) {
  return '' + a !== a && ({}).toString.call(a) === '[object Array]';
});

/**
 * @description
 * typeof method that
 * 1. groups all false-y & empty values as void
 * 2. distinguishes between object and array
 *
 * @param {*} thing The thing to inspect
 *
 * @return {String} Actionable type classification
 */

function typeOf(thing) {
  if (!thing) return 'void';

  if (_isArray(thing)) {
    if (!thing.length) return 'void';
    return 'array';
  }

  return typeof thing;
}

module.exports = exports['default'];

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = mergeState;

function mergeState(initialState, persistedState) {
  return persistedState ? _extends({}, initialState, persistedState) : initialState;
}

module.exports = exports["default"];

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export persistedReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_history__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consent__ = __webpack_require__(780);


var appReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({ router: Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["b" /* connectRouter */])(__WEBPACK_IMPORTED_MODULE_2__store_history__["a" /* default */]), user: __WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */], consent: __WEBPACK_IMPORTED_MODULE_4__consent__["a" /* default */] });var reducers = function reducers(state, action) {
  //console.log("Action =========> ", action);
  if (action.type === 'LOGOUT_REQUEST' || action.type === 'LOGOUT_SUCCESS') {
    state = undefined;
  }return appReducer(state, action);
};var persistedReducers = [__WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */]];/* harmony default export */ __webpack_exports__["a"] = (reducers);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { token: null };var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* USER_UPDATE */]:
      return Object.assign({}, state, action.payload);case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* USER_SIGN_OUT */]:
      return {};default:
      return state;}
});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(653);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(657);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(658);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(247);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(660),
    ListCache = __webpack_require__(180),
    Map = __webpack_require__(248);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(661),
    hashDelete = __webpack_require__(666),
    hashGet = __webpack_require__(667),
    hashHas = __webpack_require__(668),
    hashSet = __webpack_require__(669);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(179);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(372),
    isMasked = __webpack_require__(663),
    isObject = __webpack_require__(89),
    toSource = __webpack_require__(373);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(664);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(179);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(179);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(179);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(181);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(181);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(181);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(181);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(183);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(183);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(183);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(183);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);
var bind = __webpack_require__(377);
var Axios = __webpack_require__(682);
var defaults = __webpack_require__(249);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(381);
axios.CancelToken = __webpack_require__(695);
axios.isCancel = __webpack_require__(380);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(696);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(249);
var utils = __webpack_require__(80);
var InterceptorManager = __webpack_require__(690);
var dispatchRequest = __webpack_require__(691);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(379);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);
var transformData = __webpack_require__(692);
var isCancel = __webpack_require__(380);
var defaults = __webpack_require__(249);
var isAbsoluteURL = __webpack_require__(693);
var combineURLs = __webpack_require__(694);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(381);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function parseQuery(q, opt) {
  if (typeof q === 'object') {
    return q;
  }

  return q ? Object(__WEBPACK_IMPORTED_MODULE_0_qs__["parse"])(q, opt) : {};
}

function withQuery(url, query, opts) {
  if (url === void 0) {
    url = '';
  }

  if (!query || typeof query !== 'object' && typeof query !== 'string' || typeof query === 'object' && Object.keys(query).length < 1) {
    return url || '';
  }

  var parseOpt = opts && opts.parseOpt || {};
  var stringifyOpt = opts && opts.stringifyOpt || {};
  var noHash = opts && opts.noHash || false;
  var originalUrl = url || '';
  var baseUrl = originalUrl;
  var baseQuery = '';
  var baseHash = ''; // query

  if (originalUrl.indexOf('?') !== -1) {
    var parts = baseUrl.split('?');
    baseUrl = parts[0];
    baseQuery = parts[1];
  } // hash


  if (originalUrl.indexOf('#') !== -1) {
    if (baseUrl.indexOf('#') !== -1) {
      var _parts = baseUrl.split('#');

      baseUrl = _parts[0];
      baseHash = _parts[1];
    } else if (baseQuery && baseQuery.indexOf('#') !== -1) {
      var _parts2 = baseQuery.split('#');

      baseQuery = _parts2[0];
      baseHash = _parts2[1];
    }
  }

  var baseQueryObj = parseQuery(baseQuery, parseOpt);
  var queryObj = parseQuery(query || '', parseOpt);
  var finalQuery = Object(__WEBPACK_IMPORTED_MODULE_0_qs__["stringify"])(_extends({}, baseQueryObj, {}, queryObj), stringifyOpt);
  return "" + baseUrl + (finalQuery ? "?" + finalQuery : '') + (!noHash && baseHash ? "#" + baseHash : '');
}

/* harmony default export */ __webpack_exports__["a"] = (withQuery);



/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(699);
var parse = __webpack_require__(700);
var formats = __webpack_require__(382);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(250);
var formats = __webpack_require__(382);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(250);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset, 'value');
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(121),
    baseClone = __webpack_require__(383),
    baseUnset = __webpack_require__(738),
    castPath = __webpack_require__(118),
    copyObject = __webpack_require__(155),
    customOmitClone = __webpack_require__(741),
    flatRest = __webpack_require__(743),
    getAllKeysIn = __webpack_require__(262);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(180);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 705 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(180),
    Map = __webpack_require__(248),
    MapCache = __webpack_require__(247);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 707 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    keys = __webpack_require__(124);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(119),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(119),
    isLength = __webpack_require__(255),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(257),
    nativeKeys = __webpack_require__(714);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(388);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    keysIn = __webpack_require__(258);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isPrototype = __webpack_require__(257),
    nativeKeysIn = __webpack_require__(717);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(82);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 719 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    getSymbols = __webpack_require__(259);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 721 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    getSymbolsIn = __webpack_require__(390);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 726 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263),
    cloneDataView = __webpack_require__(728),
    cloneRegExp = __webpack_require__(729),
    cloneSymbol = __webpack_require__(730),
    cloneTypedArray = __webpack_require__(731);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 729 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(733),
    getPrototype = __webpack_require__(261),
    isPrototype = __webpack_require__(257);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(735),
    baseUnary = __webpack_require__(156),
    nodeUtil = __webpack_require__(256);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(185),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(737),
    baseUnary = __webpack_require__(156),
    nodeUtil = __webpack_require__(256);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(185),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(118),
    last = __webpack_require__(739),
    parent = __webpack_require__(740),
    toKey = __webpack_require__(122);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(152),
    baseSlice = __webpack_require__(395);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(742);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(119),
    getPrototype = __webpack_require__(261),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(744),
    overRest = __webpack_require__(396),
    setToString = __webpack_require__(397);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(264);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    isArguments = __webpack_require__(253),
    isArray = __webpack_require__(79);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(748),
    defineProperty = __webpack_require__(385),
    identity = __webpack_require__(186);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(121),
    baseIteratee = __webpack_require__(157),
    basePickBy = __webpack_require__(768),
    getAllKeysIn = __webpack_require__(262);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(752),
    getMatchData = __webpack_require__(760),
    matchesStrictComparable = __webpack_require__(400);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(251),
    baseIsEqual = __webpack_require__(265);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(251),
    equalArrays = __webpack_require__(398),
    equalByTag = __webpack_require__(757),
    equalObjects = __webpack_require__(759),
    getTag = __webpack_require__(185),
    isArray = __webpack_require__(79),
    isBuffer = __webpack_require__(254),
    isTypedArray = __webpack_require__(387);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    Uint8Array = __webpack_require__(394),
    eq = __webpack_require__(182),
    equalArrays = __webpack_require__(398),
    mapToArray = __webpack_require__(758),
    setToArray = __webpack_require__(268);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(391);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(399),
    keys = __webpack_require__(124);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(265),
    get = __webpack_require__(9),
    hasIn = __webpack_require__(762),
    isKey = __webpack_require__(246),
    isStrictComparable = __webpack_require__(399),
    matchesStrictComparable = __webpack_require__(400),
    toKey = __webpack_require__(122);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(763),
    hasPath = __webpack_require__(764);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(118),
    isArguments = __webpack_require__(253),
    isArray = __webpack_require__(79),
    isIndex = __webpack_require__(184),
    isLength = __webpack_require__(255),
    toKey = __webpack_require__(122);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(766),
    basePropertyDeep = __webpack_require__(767),
    isKey = __webpack_require__(246),
    toKey = __webpack_require__(122);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(152);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(152),
    baseSet = __webpack_require__(769),
    castPath = __webpack_require__(118);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(252),
    castPath = __webpack_require__(118),
    isIndex = __webpack_require__(184),
    isObject = __webpack_require__(89),
    toKey = __webpack_require__(122);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(375),
    castSlice = __webpack_require__(771),
    charsEndIndex = __webpack_require__(772),
    stringToArray = __webpack_require__(775),
    toString = __webpack_require__(374);

/** Used to match leading and trailing whitespace. */
var reTrimEnd = /\s+$/;

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimEnd, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

module.exports = trimEnd;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(395);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(401);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(776),
    hasUnicode = __webpack_require__(777),
    unicodeToArray = __webpack_require__(778);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 778 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = {"login":"/admin/login","loginTwoFactor":"/admin/login/two_factor","logout":"/admin/logout","qrCode":"/admin/account/two_factor/qr_code","twoFactor":"/admin/account/two_factor","twoFactorStatus":"/admin/account/two_factor/:status","accountProfile":"/admin/account/profile","resetPassword":"/admin/password/reset","resetPasswordConfirm":"/admin/password/confirm/:token","resetPasswordProfile":"/admin/account/password_management","setPasswordConfirm":"/admin/password/set/:token","createRegistryID":"/admin/subject_profile/:id","updateRegistryID":"/admin/subject_profile/:id/registry","createCoenrollmentID":"/admin/subject_profile/:id","updateCoenrollmentID":"/admin/subject_profile/:id/coenrollment","updateEmailStatus":"/admin/subject/:id/update_email_status","dashboard":"/admin/dashboard","subjects":"/admin/subjects","subjectID":"/admin/subject/:subjectID","subjectProfile":"/admin/subject_profile/:subjectID","subjectActivate":"/admin/subject/activate/:subjectID","subjectLock":"/admin/subject_profile/:subjectID/lock","subjectUnlock":"/admin/subject_profile/:subjectID/unlock","followUp":"/admin/follow_up_90_days/:subjectID","sites":"/admin/sites","saeRecording":"/admin/sae/:subjectID","saeRecordingSave":"/admin/sae/:subjectID/:saeID","saeRecordingActivation":"/admin/sae/:status/:subjectID/:saeID","saesList":"/admin/saes","saeLock":"/admin/sae/:subjectID/lock/:saeID","saeUnlock":"/admin/sae/:subjectID/unlock/:saeID","permissions":"/admin/account/permissions","settingsSites":"/admin/settings/sites","updateSite":"/admin/settings/site/:siteID","activateSite":"/admin/settings/site/activate/:siteID","createSite":"/admin/settings/sites","settingsUsers":"/admin/settings/users","settingsRoles":"/admin/settings/roles","updateUser":"/admin/settings/user/:userID","activateUser":"/admin/settings/user/activate/:userID","createUser":"/admin/settings/users","createUserTraining":"/admin/user/:id/training","createUserTrainingUpload":"/admin/user/:id/training/upload","resetUserTrainingRetriesRequest":"/admin/training/:id/reset","followups":"/admin/dashboard/followups","followUpLock":"/admin/follow_up_90_days/:subjectID/lock","followUpUnlock":"/admin/follow_up_90_days/:subjectID/unlock","notificationSettings":"/admin/account/notification/settings","createRole":"/admin/settings/roles","updateRole":"/admin/settings/role/:roleID","activateRole":"/admin/settings/role/activate/:roleID","contactUs":"/contact-us","publicDocuments":"/documents","documents":"/admin/documents","patientProfileDocuments":"/admin/subject_profile_document","documentsSearch":"/admin/documents_list","updateDocument":"/admin/document/:documentID","updatePatientProfileDocument":"/admin/subject_profile_document/:documentID","deletePatientProfileDocument":"/admin/subject_profile_document/:documentID","activateDocument":"/admin/document/activate/:documentID","activatePatientProfileDocument":"/admin/subject_profile_document/activate/:documentID","approveDocument":"/admin/document/approve/:documentID","unapproveDocument":"/admin/document/unapprove/:documentID","settingsConsent":"/admin/settings/consent_forms","settingsConsentUpdate":"/admin/settings/consent_form/:consentID","settingsConsentActivate":"/admin/settings/consent_form/activate/:consentID","documentsTraining":"/admin/training/documents","documentsPublic":"/admin/public/documents","userSingle":"/admin/settings/user/:userID","userRoleCreate":"/admin/settings/user/site_access/:userID","userRoleUpdate":"/admin/settings/user/:userID/site_access/:siteID","userRoleSiteActivate":"/admin/settings/user/site_access/:userID/activate/:roleID","userRoleSiteDeactivate":"/admin/settings/user/site_access/:userID/deactivate/:roleID","settingsGeneral":"/admin/settings/general","settingsGeneralUpdate":"/admin/settings/general/:id","settingsGeneralActivate":"/admin/settings/general/activate/:id","auditLogs":"/admin/settings/audit_logs","auditLogsList":"/admin/settings/audit_logs_list","auditLogUpdate":"/admin/settings/audit_log/:id","auditLogResend":"/admin/settings/audit_log/:id/resend","auditLogActivate":"/admin/settings/audit_log/:id/activate","auditLogReviewed":"/admin/settings/audit_log/:id/reviewed","auditLogUnreviewed":"/admin/settings/audit_log/:id/unreviewed","simulationList":"/admin/simulations","createSimulation":"/admin/simulations","updateSimulation":"/admin/simulation/:ID","activateSimulation":"/admin/simulation/:ID/activate","trainingGet":"/admin/training/quiz","trainingStart":"/admin/training/quiz/start","trainingVerify":"/admin/training/quiz/:token/verify","newsletterList":"/admin/newsletter/list","newsletter":"/admin/newsletter","newsletterByID":"/admin/newsletter/:id","newsletterActivateByID":"/admin/newsletter/activate/:id","newsletterSendByID":"/admin/newsletter/send/:id","newsletterCancelSchedule":"/admin/newsletter/cancel_scheduled/:id","newsletterUploadImage":"/admin/newsletter/upload_image","updateSiteRandomization":"/admin/settings/site/:siteID/randomization","updateConsentGiven":"/admin/subject/:id/update_consent_given","updateAdjudicatedConsentStatus":"/admin/subject/:id/adjudicated_consent_update","rolesLight":"/admin/settings/roles/list","usersLight":"/admin/settings/users/minimal_list","bulkSites":"/admin/settings/sites/list","bulkSiteRoles":"/admin/settings/site/:id/roles","bulkUserSites":"/admin/settings/user/:id/sites","bulkSiteCopyPermission":"/admin/settings/sites/copy_permissions","bulkUserCopyPermission":"/admin/settings/users/copy_permissions","bulkUserChangePermission":"/admin/settings/users/change_permissions","privateDocument":"/admin/private/document","accountProfileId":"/admin/account/profile/id"}

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CONSENT_UPDATE */]:
      return Object.assign({}, state, action.payload);default:
      return state;}
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_device_detect__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_idle_timer__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Home_Home__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Static_NotFound__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_PatientInformationSheet_PatientInformationSheet__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_PatientInformationSheet_PatientInformationSheetVisual__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_PatientInformationSheet_PatientInformationSheetText__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Consent_Consent__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_ConsentType2_ConsentType2__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_ConsentTypeSunnybrook_ConsentTypeSunnybrook__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_ConsentTypeTorontoUH_ConsentTypeTorontoUH__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_ConsentTypeOttawa_ConsentTypeOttawa__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_ConsentTypeRoyal_ConsentTypeRoyal__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_ConsentTypeRoyalUniversity_ConsentTypeRoyalUniversity__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ConsentTypeKelowna_ConsentTypeKelowna__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ConsentTypeMontreal_ConsentTypeMontreal__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ConsentTypeChus_ConsentTypeChus__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ConsentTypeQuebecChu_ConsentTypeQuebecChu__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ConsentTypeWinnipeg_ConsentTypeWinnipeg__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ConsentTypeUhn_ConsentTypeUhn__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ConsentTypeLhs_ConsentTypeLhs__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ConsentTypeHalifax_ConsentTypeHalifax__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ConsentTypePei_ConsentTypePei__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ConsentTypeGreyNuns_ConsentTypeGreyNuns__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ConsentTypeRedDeerCalgary_ConsentTypeRedDeerCalgary__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ConsentTypeMedicineHat_ConsentTypeMedicineHat__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ConsentTypeLethbridge_ConsentTypeLethbridge__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ConsentTypeKingston_ConsentTypeKingston__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ConsentTypeHamilton_ConsentTypeHamilton__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ConsentError_ConsentError__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__containers_PhysicianScript_PhysicianScript__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__containers_Randomize_Randomize__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__containers_ValidateRandomization_ValidateRandomization__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__containers_SaeRecording_SaeRecording__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__containers_Documents_Documents__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__containers_ContactUs_ContactUs__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__containers_Login_Login__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__containers_ResetPassword_ResetPassword__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__containers_ResetPasswordSend_ResetPasswordSend__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__containers_SetAccountPassword_SetAccountPassword__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__containers_AdminDashboard_AdminDashboard__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__containers_PatientProfile_PatientProfile__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__containers_SAEReporting_SAEReporting__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__containers_FollowUp90Day_FollowUp90Day__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__containers_MyProfile_MyProfile__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__containers_Enrolments_Enrolments__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__containers_AdminSettings_AdminSettings__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__containers_SettingsSites_SettingsSites__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__containers_SettingsUsers_SettingsUsers__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__containers_SettingsUsersBulk_SettingsUsersBulk__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__containers_SettingsRoles_SettingsRoles__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__containers_DocumentsEditor_DocumentsEditor__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__containers_SettingsConsent_SettingsConsent__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__containers_DocumentsTraining_DocumentsTraining__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__containers_DocumentsPublic_DocumentsPublic__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__containers_SettingsUserRoles_SettingsUserRoles__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__containers_SettingsGeneral_SettingsGeneral__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__containers_AuditLogs_AuditLogs__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__containers_Simulation_Simulation__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__containers_Training_Training__ = __webpack_require__(3530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__containers_Newsletter_Newsletter__ = __webpack_require__(3539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Reporting_Reporting__ = __webpack_require__(3646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__App_css__ = __webpack_require__(3648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ConsentTypeVancouver_ConsentTypeVancouver__ = __webpack_require__(3649);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import ConsentTypeMedicineHatCalgary from "../ConsentTypeMedicineHatCalgary/ConsentTypeMedicineHatCalgary";
var routes = __webpack_require__(65);var App = function (_React$Component) {
  _inherits(App, _React$Component);function App(props) {
    _classCallCheck(this, App);var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));_this.idleTimer = null;_this.handleOnIdle = _this.handleOnIdle.bind(_this);_this.state = { isLoading: false };return _this;
  }_createClass(App, [{ key: "componentDidMount", value: function componentDidMount() {
      if (this.props.token) {
        this.props.setPermissions(this.props.token);this.props.setAccountInfo(this.props.token);
      }
    } }, { key: "handleOnIdle", value: function handleOnIdle(event) {
      if (this.props.token && "production" !== "development") {
        this.props.logout();
      }
    } }, { key: "render", value: function render() {
      var _this2 = this;if (__WEBPACK_IMPORTED_MODULE_3_react_device_detect__["isIE"]) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_67_classnames___default()(__WEBPACK_IMPORTED_MODULE_68__App_css___default.a.errorBox, __WEBPACK_IMPORTED_MODULE_68__App_css___default.a.alert, __WEBPACK_IMPORTED_MODULE_68__App_css___default.a.verticalCenter) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_68__App_css___default.a.msg }, "Error \u2013 We noticed that you may be using Internet Explorer as your browser. Unfortunately, this browser does not support the latest features used in our application. Please switch to a modern browser such as Microsoft Edge, Google Chrome, or Mozilla Firefox. Thank you for understanding!"));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, this.props.token && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_idle_timer__["a" /* default */], { ref: function ref(_ref) {
          _this2.idleTimer = _ref;
        }, timeout: 1000 * 60 * 10, onIdle: this.handleOnIdle, debounce: 250 }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/", component: __WEBPACK_IMPORTED_MODULE_7__containers_Home_Home__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/patient-information-sheet", component: __WEBPACK_IMPORTED_MODULE_9__containers_PatientInformationSheet_PatientInformationSheet__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/patient-information-sheet-visual", component: __WEBPACK_IMPORTED_MODULE_10__containers_PatientInformationSheet_PatientInformationSheetVisual__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/patient-information-sheet-text", component: __WEBPACK_IMPORTED_MODULE_11__containers_PatientInformationSheet_PatientInformationSheetText__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/consent", component: __WEBPACK_IMPORTED_MODULE_12__containers_Consent_Consent__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/consent/:token", component: __WEBPACK_IMPORTED_MODULE_12__containers_Consent_Consent__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentType2, component: __WEBPACK_IMPORTED_MODULE_13__containers_ConsentType2_ConsentType2__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentType2Token, component: __WEBPACK_IMPORTED_MODULE_13__containers_ConsentType2_ConsentType2__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeSunnybrook, component: __WEBPACK_IMPORTED_MODULE_14__containers_ConsentTypeSunnybrook_ConsentTypeSunnybrook__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeSunnybrookToken, component: __WEBPACK_IMPORTED_MODULE_14__containers_ConsentTypeSunnybrook_ConsentTypeSunnybrook__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeTorontoUH, component: __WEBPACK_IMPORTED_MODULE_15__containers_ConsentTypeTorontoUH_ConsentTypeTorontoUH__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeTorontoUHToken, component: __WEBPACK_IMPORTED_MODULE_15__containers_ConsentTypeTorontoUH_ConsentTypeTorontoUH__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeOttawa, component: __WEBPACK_IMPORTED_MODULE_16__containers_ConsentTypeOttawa_ConsentTypeOttawa__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeOttawaToken, component: __WEBPACK_IMPORTED_MODULE_16__containers_ConsentTypeOttawa_ConsentTypeOttawa__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRoyal, component: __WEBPACK_IMPORTED_MODULE_17__containers_ConsentTypeRoyal_ConsentTypeRoyal__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRoyalToken, component: __WEBPACK_IMPORTED_MODULE_17__containers_ConsentTypeRoyal_ConsentTypeRoyal__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRoyalUniversity, component: __WEBPACK_IMPORTED_MODULE_18__containers_ConsentTypeRoyalUniversity_ConsentTypeRoyalUniversity__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRoyalUniversityToken, component: __WEBPACK_IMPORTED_MODULE_18__containers_ConsentTypeRoyalUniversity_ConsentTypeRoyalUniversity__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeKelowna, component: __WEBPACK_IMPORTED_MODULE_19__ConsentTypeKelowna_ConsentTypeKelowna__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeKelownaToken, component: __WEBPACK_IMPORTED_MODULE_19__ConsentTypeKelowna_ConsentTypeKelowna__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeMontreal, component: __WEBPACK_IMPORTED_MODULE_20__ConsentTypeMontreal_ConsentTypeMontreal__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeMontrealToken, component: __WEBPACK_IMPORTED_MODULE_20__ConsentTypeMontreal_ConsentTypeMontreal__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeVancouver, component: __WEBPACK_IMPORTED_MODULE_69__ConsentTypeVancouver_ConsentTypeVancouver__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeChus, component: __WEBPACK_IMPORTED_MODULE_21__ConsentTypeChus_ConsentTypeChus__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeChusToken, component: __WEBPACK_IMPORTED_MODULE_21__ConsentTypeChus_ConsentTypeChus__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeQuebecChu, component: __WEBPACK_IMPORTED_MODULE_22__ConsentTypeQuebecChu_ConsentTypeQuebecChu__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeQuebecChuToken, component: __WEBPACK_IMPORTED_MODULE_22__ConsentTypeQuebecChu_ConsentTypeQuebecChu__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeWinnipeg, component: __WEBPACK_IMPORTED_MODULE_23__ConsentTypeWinnipeg_ConsentTypeWinnipeg__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeWinnipegToken, component: __WEBPACK_IMPORTED_MODULE_23__ConsentTypeWinnipeg_ConsentTypeWinnipeg__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeUhn, component: __WEBPACK_IMPORTED_MODULE_24__ConsentTypeUhn_ConsentTypeUhn__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeUhnToken, component: __WEBPACK_IMPORTED_MODULE_24__ConsentTypeUhn_ConsentTypeUhn__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeHalifax, component: __WEBPACK_IMPORTED_MODULE_26__ConsentTypeHalifax_ConsentTypeHalifax__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeHalifaxToken, component: __WEBPACK_IMPORTED_MODULE_26__ConsentTypeHalifax_ConsentTypeHalifax__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypePei, component: __WEBPACK_IMPORTED_MODULE_27__ConsentTypePei_ConsentTypePei__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypePeiToken, component: __WEBPACK_IMPORTED_MODULE_27__ConsentTypePei_ConsentTypePei__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeLhs, component: __WEBPACK_IMPORTED_MODULE_25__ConsentTypeLhs_ConsentTypeLhs__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeLhsToken, component: __WEBPACK_IMPORTED_MODULE_25__ConsentTypeLhs_ConsentTypeLhs__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeGreyNuns, component: __WEBPACK_IMPORTED_MODULE_28__ConsentTypeGreyNuns_ConsentTypeGreyNuns__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeGreyNunsToken, component: __WEBPACK_IMPORTED_MODULE_28__ConsentTypeGreyNuns_ConsentTypeGreyNuns__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRedDeer, component: __WEBPACK_IMPORTED_MODULE_29__ConsentTypeRedDeerCalgary_ConsentTypeRedDeerCalgary__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeRedDeerToken, component: __WEBPACK_IMPORTED_MODULE_29__ConsentTypeRedDeerCalgary_ConsentTypeRedDeerCalgary__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeMedicineHat, component: __WEBPACK_IMPORTED_MODULE_30__ConsentTypeMedicineHat_ConsentTypeMedicineHat__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeMedicineHatToken, component: __WEBPACK_IMPORTED_MODULE_30__ConsentTypeMedicineHat_ConsentTypeMedicineHat__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeLethbridge, component: __WEBPACK_IMPORTED_MODULE_31__ConsentTypeLethbridge_ConsentTypeLethbridge__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeLethbridgeToken, component: __WEBPACK_IMPORTED_MODULE_31__ConsentTypeLethbridge_ConsentTypeLethbridge__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeKingston, component: __WEBPACK_IMPORTED_MODULE_32__ConsentTypeKingston_ConsentTypeKingston__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeKingstonToken, component: __WEBPACK_IMPORTED_MODULE_32__ConsentTypeKingston_ConsentTypeKingston__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeHamilton, component: __WEBPACK_IMPORTED_MODULE_33__ConsentTypeHamilton_ConsentTypeHamilton__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentTypeHamiltonToken, component: __WEBPACK_IMPORTED_MODULE_33__ConsentTypeHamilton_ConsentTypeHamilton__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.front.consentInvalid, component: __WEBPACK_IMPORTED_MODULE_34__ConsentError_ConsentError__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/physician-script", component: __WEBPACK_IMPORTED_MODULE_35__containers_PhysicianScript_PhysicianScript__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/randomize", component: __WEBPACK_IMPORTED_MODULE_36__containers_Randomize_Randomize__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/validate-randomization", component: __WEBPACK_IMPORTED_MODULE_37__containers_ValidateRandomization_ValidateRandomization__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/sae-recording", component: __WEBPACK_IMPORTED_MODULE_38__containers_SaeRecording_SaeRecording__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/documents", component: __WEBPACK_IMPORTED_MODULE_39__containers_Documents_Documents__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "/contact-us", component: __WEBPACK_IMPORTED_MODULE_40__containers_ContactUs_ContactUs__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: routes.admin.dashboard })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.login, component: __WEBPACK_IMPORTED_MODULE_41__containers_Login_Login__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.resetPassword, component: __WEBPACK_IMPORTED_MODULE_42__containers_ResetPassword_ResetPassword__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.resetPasswordConfirm, component: __WEBPACK_IMPORTED_MODULE_43__containers_ResetPasswordSend_ResetPasswordSend__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.setPassword, component: __WEBPACK_IMPORTED_MODULE_44__containers_SetAccountPassword_SetAccountPassword__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.dashboard, component: __WEBPACK_IMPORTED_MODULE_45__containers_AdminDashboard_AdminDashboard__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.patientProfile, component: __WEBPACK_IMPORTED_MODULE_46__containers_PatientProfile_PatientProfile__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.patientProfileSingle, component: __WEBPACK_IMPORTED_MODULE_46__containers_PatientProfile_PatientProfile__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.saeReporting, component: __WEBPACK_IMPORTED_MODULE_47__containers_SAEReporting_SAEReporting__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.saeReportingSignle, component: __WEBPACK_IMPORTED_MODULE_47__containers_SAEReporting_SAEReporting__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.followUp90Day, component: __WEBPACK_IMPORTED_MODULE_48__containers_FollowUp90Day_FollowUp90Day__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.followUp90DaySingle, component: __WEBPACK_IMPORTED_MODULE_48__containers_FollowUp90Day_FollowUp90Day__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.myProfile, component: __WEBPACK_IMPORTED_MODULE_49__containers_MyProfile_MyProfile__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.enrolments, component: __WEBPACK_IMPORTED_MODULE_50__containers_Enrolments_Enrolments__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settings, component: __WEBPACK_IMPORTED_MODULE_51__containers_AdminSettings_AdminSettings__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsSites, component: __WEBPACK_IMPORTED_MODULE_52__containers_SettingsSites_SettingsSites__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsUsers, component: __WEBPACK_IMPORTED_MODULE_53__containers_SettingsUsers_SettingsUsers__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsUsersBulk, component: __WEBPACK_IMPORTED_MODULE_54__containers_SettingsUsersBulk_SettingsUsersBulk__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsRoles, component: __WEBPACK_IMPORTED_MODULE_55__containers_SettingsRoles_SettingsRoles__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.documentsEditor, component: __WEBPACK_IMPORTED_MODULE_56__containers_DocumentsEditor_DocumentsEditor__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.consentEditor, component: __WEBPACK_IMPORTED_MODULE_57__containers_SettingsConsent_SettingsConsent__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.documentsTraining, component: __WEBPACK_IMPORTED_MODULE_58__containers_DocumentsTraining_DocumentsTraining__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.documentsPublic, component: __WEBPACK_IMPORTED_MODULE_59__containers_DocumentsPublic_DocumentsPublic__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsUsersRoles, component: __WEBPACK_IMPORTED_MODULE_60__containers_SettingsUserRoles_SettingsUserRoles__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.settingsGeneral, component: __WEBPACK_IMPORTED_MODULE_61__containers_SettingsGeneral_SettingsGeneral__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.auditLogs, component: __WEBPACK_IMPORTED_MODULE_62__containers_AuditLogs_AuditLogs__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.simulation, component: __WEBPACK_IMPORTED_MODULE_63__containers_Simulation_Simulation__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.training, component: __WEBPACK_IMPORTED_MODULE_64__containers_Training_Training__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.newsletter, component: __WEBPACK_IMPORTED_MODULE_65__containers_Newsletter_Newsletter__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: routes.admin.reporting, component: __WEBPACK_IMPORTED_MODULE_66__Reporting_Reporting__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: "*", component: __WEBPACK_IMPORTED_MODULE_8__containers_Static_NotFound__["a" /* NotFound */] }))));
    } }]);return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { token: Object(__WEBPACK_IMPORTED_MODULE_6__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { setPermissions: __WEBPACK_IMPORTED_MODULE_5__reducers_user_actions__["h" /* setPermissions */], setAccountInfo: __WEBPACK_IMPORTED_MODULE_5__reducers_user_actions__["g" /* setAccountInfo */], logout: __WEBPACK_IMPORTED_MODULE_5__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(App));

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(783);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};
var BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari",
  EDGE_CHROMIUM: "Edge Chromium"
};
var OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone",
  WINDOWS: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return {
        isMobile: true
      };

    case DEVICE_TYPES.TABLET:
      return {
        isTablet: true
      };

    case DEVICE_TYPES.SMART_TV:
      return {
        isSmartTV: true
      };

    case DEVICE_TYPES.CONSOLE:
      return {
        isConsole: true
      };

    case DEVICE_TYPES.WEARABLE:
      return {
        isWearable: true
      };

    case DEVICE_TYPES.BROWSER:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DEVICE_TYPES.MOBILE;
};

var isTabletType = function isTabletType() {
  return device.type === DEVICE_TYPES.TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DEVICE_TYPES.MOBILE:
    case DEVICE_TYPES.TABLET:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  if (os.name === OS_TYPES.WINDOWS && os.version === '10') {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
  }

  return false;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DEVICE_TYPES.SMART_TV;
};

var isBrowserType = function isBrowserType() {
  return device.type === DEVICE_TYPES.BROWSER;
};

var isWearableType = function isWearableType() {
  return device.type === DEVICE_TYPES.WEARABLE;
};

var isConsoleType = function isConsoleType() {
  return device.type === DEVICE_TYPES.CONSOLE;
};

var isAndroidType = function isAndroidType() {
  return os.name === OS_TYPES.ANDROID;
};

var isWindowsType = function isWindowsType() {
  return os.name === OS_TYPES.WINDOWS;
};

var isMacOsType = function isMacOsType() {
  return os.name === OS_TYPES.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OS_TYPES.WINDOWS_PHONE;
};

var isIOSType = function isIOSType() {
  return os.name === OS_TYPES.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BROWSER_TYPES.CHROME;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BROWSER_TYPES.FIREFOX;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BROWSER_TYPES.CHROMIUM;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BROWSER_TYPES.EDGE;
};

var isYandexType = function isYandexType() {
  return browser.name === BROWSER_TYPES.YANDEX;
};

var isSafariType = function isSafariType() {
  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isOperaType = function isOperaType() {
  return browser.name === BROWSER_TYPES.OPERA;
};

var isIEType = function isIEType() {
  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;
  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;
  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;
  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;
  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;
  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;
  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;
  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;
  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;
  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;
  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;
  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;
  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.21
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.21",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIdleTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function s(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function a(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?s(e):t}function l(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,o=u(e);if(t){var r=u(this).constructor;n=Reflect.construct(o,arguments,r)}else n=o.apply(this,arguments);return a(this,n)}}var d="object"===("undefined"==typeof window||"undefined"==typeof window?"undefined":r(window)),f=d?document:{},v=["mousemove","keydown","wheel","DOMMouseScroll","mouseWheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange"];function p(e,t){var n;return function(){for(var o=arguments.length,r=new Array(o),i=0;i<o;i++)r[i]=arguments[i];n&&clearTimeout(n),n=setTimeout((function(){e.apply(void 0,r),n=null}),t)}}function h(e,t){var n=0;return function(){var o=(new Date).getTime();if(!(o-n<t))return n=o,e.apply(void 0,arguments)}}var m=function(t){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&c(e,t)}(a,__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var n,o,r,u=l(a);function a(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(t=u.call(this,e)).state={idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null,pageX:null,pageY:null},t.tId=null,t.eventsBound=!1,e.debounce>0&&e.throttle>0)throw new Error("onAction can either be throttled or debounced (not both)");return e.debounce>0?t._onAction=p(e.onAction,e.debounce):e.throttle>0?t._onAction=h(e.onAction,e.throttle):e.onAction?t._onAction=e.onAction:t._onAction=function(){},e.eventsThrottle>0?t._handleEvent=h(t._handleEvent.bind(s(t)),e.eventsThrottle):t._handleEvent=t._handleEvent.bind(s(t)),e.startOnMount||(t.state.idle=!0),t._toggleIdleState=t._toggleIdleState.bind(s(t)),t.reset=t.reset.bind(s(t)),t.pause=t.pause.bind(s(t)),t.resume=t.resume.bind(s(t)),t.getRemainingTime=t.getRemainingTime.bind(s(t)),t.getElapsedTime=t.getElapsedTime.bind(s(t)),t.getLastActiveTime=t.getLastActiveTime.bind(s(t)),t.isIdle=t.isIdle.bind(s(t)),t}return n=a,(o=[{key:"componentDidMount",value:function(){this._bindEvents(),this.props.startOnMount&&this.reset()}},{key:"componentDidUpdate",value:function(e){e.debounce!==this.props.debounce&&(this._onAction=p(this._onAction,this.props.debounce)),e.throttle!==this.props.throttle&&(this._onAction=h(this._onAction,this.props.throttle)),e.eventsThrottle!==this.props.eventsThrottle&&(this._handleEvent=h(this._handleEvent,this.props.eventsThrottle))}},{key:"componentWillUnmount",value:function(){clearTimeout(this.tId),this._unbindEvents(!0)}},{key:"render",value:function(){return this.props.children||null}},{key:"_bindEvents",value:function(){var e=this;if(d){var t=this.props,n=t.element,o=t.events,r=t.passive,i=t.capture;this.eventsBound||(o.forEach((function(t){n.addEventListener(t,e._handleEvent,{capture:i,passive:r})})),this.eventsBound=!0)}}},{key:"_unbindEvents",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(d){var n=this.props,o=n.element,r=n.events,i=n.passive,u=n.capture;(this.eventsBound||t)&&(r.forEach((function(t){o.removeEventListener(t,e._handleEvent,{capture:u,passive:i})})),this.eventsBound=!1)}}},{key:"_toggleIdleState",value:function(e){var t=this;this.setState((function(e){return{idle:!e.idle}}),(function(){var n=t.props,o=n.onActive,r=n.onIdle,i=n.stopOnIdle;t.state.idle?(i&&(clearTimeout(t.tId),t.tId=null,t._unbindEvents()),r(e)):i||(t._bindEvents(),o(e))}))}},{key:"_handleEvent",value:function(e){var t=this.state,n=t.remaining,o=t.pageX,r=t.pageY,i=t.idle,u=this.props,c=u.timeout,s=u.stopOnIdle;if(this._onAction(e),!n){if("mousemove"===e.type){if(e.pageX===o&&e.pageY===r)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(this.getElapsedTime()<200)return}clearTimeout(this.tId),this.tId=null;var a=+new Date-this.getLastActiveTime();(i&&!s||!i&&a>c)&&this._toggleIdleState(e),this.setState({lastActive:+new Date,pageX:e.pageX,pageY:e.pageY}),i&&s||(this.tId=setTimeout(this._toggleIdleState,c))}}},{key:"reset",value:function(){clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null});var e=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,e)}},{key:"pause",value:function(){null===this.state.remaining&&(this._unbindEvents(),clearTimeout(this.tId),this.tId=null,this.setState({remaining:this.getRemainingTime()}))}},{key:"resume",value:function(){var e=this.state,t=e.remaining,n=e.idle;null!==t&&(this._bindEvents(),n||(this.tId=setTimeout(this._toggleIdleState,t),this.setState({remaining:null,lastActive:+new Date})))}},{key:"getRemainingTime",value:function(){var e=this.state,t=e.remaining,n=e.lastActive,o=this.props.timeout;if(null!==t)return t<0?0:t;var r=o-(+new Date-n);return r<0?0:r}},{key:"getElapsedTime",value:function(){var e=this.state.oldDate;return+new Date-e}},{key:"getLastActiveTime",value:function(){return this.state.lastActive}},{key:"isIdle",value:function(){return this.state.idle}}])&&i(n.prototype,o),r&&i(n,r),a}();function b(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=e.timeout,r=void 0===o?12e5:o,i=e.element,u=void 0===i?f:i,c=e.events,s=void 0===c?v:c,a=e.onIdle,l=void 0===a?function(){}:a,m=e.onActive,b=void 0===m?function(){}:m,g=e.onAction,y=void 0===g?function(){}:g,T=e.debounce,w=void 0===T?0:T,_=e.throttle,A=void 0===_?0:_,I=e.eventsThrottle,E=void 0===I?200:I,O=e.startOnMount,D=void 0===O||O,S=e.stopOnIdle,k=void 0!==S&&S,M=e.capture,R=void 0===M||M,j=e.passive,P=void 0===j||j,L=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!1),X=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!0),Y=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(+new Date),B=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(+new Date),x=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),U=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),W=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),C=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),q=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(l),z=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(b),F=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(y),G=function(e){var t=!X.current;X.current=t,t?(k&&(clearTimeout(C.current),C.current=null,K()),q.current(e)):k||(J(),z.current(e))},H=function(e){if(F.current(e),!x.current){if("mousemove"===e.type){if(e.pageX===U&&e.pageY===W)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(Q()<200)return}clearTimeout(C.current),C.current=null;var t=+new Date-V();(X.current&&!k||!X.current&&t>r)&&G(e),B.current=+new Date,U.current=e.pageX,W.current=e.pageY,X.current&&k||(C.current=setTimeout(G,r))}},J=function(){d&&(L.current||(s.forEach((function(e){u.addEventListener(e,H,{capture:R,passive:P})})),L.current=!0))},K=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];d&&(L.current||e)&&(s.forEach((function(e){u.removeEventListener(e,H,{capture:R,passive:P})})),L.current=!1)},N=function(){if(null!==x.current)return x.current<0?0:x.current;var e=r-(+new Date-B.current);return e<0?0:e},Q=function(){return+new Date-Y.current},V=function(){return B.current},Z=function(){return X.current},$=function(){clearTimeout(C.current),C.current=null,J(),X.current=!1,Y.current=+new Date,B.current=+new Date,x.current=null,C.current=setTimeout(G,r)},ee=function(){null===x.current&&(K(),clearTimeout(C.current),C.current=null,x.current=N())},te=function(){null!==x.current&&(J(),X.current||(C.current=setTimeout(G,x.current),x.current=null,B.current=+new Date))};return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){if(w>0&&A>0)throw new Error("onAction can either be throttled or debounced (not both)");return E>0&&(H=h(H,E)),J(),D&&$(),function(){clearTimeout(C.current),K(!0)}}),[]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){q.current=l}),[l]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){z.current=b}),[b]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){F.current=w>0?p(y,w):A>0?h(y,A):y}),[y]),{isIdle:Z,pause:ee,reset:$,resume:te,getLastActiveTime:V,getElapsedTime:Q,getRemainingTime:N}}m.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},m.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0},b.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},b.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0};/* harmony default export */ __webpack_exports__["a"] = (m);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Home_css__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Home_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home() {
    _classCallCheck(this, Home);return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }_createClass(Home, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__Home_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_9__Home_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 12, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, ' Welcome to the AcT Trial Application. Please select one of the following options: '), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/physician-script', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Physician Script ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/patient-information-sheet', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Patient Information Sheet ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/randomize', style: { color: '#FAFAFA' }, className: 'menu-item-green' }, ' Randomize ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/consent', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Consent ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/sae-recording', style: { color: '#FAFAFA' }, className: 'menu-item' }, 'SAE Recording ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/validate-randomization', style: { color: '#FAFAFA' }, className: 'menu-item' }, 'Validate Randomization')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/documents', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Trial Documents ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/contact-us', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Contact Us ')))))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* stylelint-disable at-rule-no-unknown */\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\narticle,\naside,\ndialog,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\nbody {\n  margin: 0;\n  color: #424242;\n  font-size: 14px;\n  font-family: Oxygen \", BlinkMacSystemFont, Ubuntu, Segoe UI, Roboto, Arial, sans-serif, \" Apple Color Emoji \", \" Segoe UI Emoji \", \" Segoe UI Symbol;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  background-color: #fff;\n  font-feature-settings: 'tnum';\n}\n[tabindex='-1']:focus {\n  outline: none !important;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  border-bottom: 0;\n  cursor: help;\n}\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 500;\n}\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1em;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: #4CDEF5;\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #78f1ff;\n}\na:active {\n  color: #36b5cf;\n}\na:active,\na:hover {\n  text-decoration: none;\n  outline: 0;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1em;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1em;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: rgba(0, 0, 0, 0.45);\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit;\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n[type='search'] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nmark {\n  padding: 0.2em;\n  background-color: #feffe6;\n}\n::selection {\n  color: #fff;\n  background: #4CDEF5;\n}\n.clearfix {\n  zoom: 1;\n}\n.clearfix::before,\n.clearfix::after {\n  display: table;\n  content: '';\n}\n.clearfix::after {\n  clear: both;\n}\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon > * {\n  line-height: 1;\n}\n.anticon svg {\n  display: inline-block;\n}\n.anticon::before {\n  display: none;\n}\n.anticon .anticon-icon {\n  display: block;\n}\n.anticon[tabindex] {\n  cursor: pointer;\n}\n.anticon-spin::before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.anticon-spin {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.fade-enter,\n.fade-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-enter.fade-enter-active,\n.fade-appear.fade-appear-active {\n  animation-name: antFadeIn;\n  animation-play-state: running;\n}\n.fade-leave.fade-leave-active {\n  animation-name: antFadeOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.fade-enter,\n.fade-appear {\n  opacity: 0;\n  animation-timing-function: linear;\n}\n.fade-leave {\n  animation-timing-function: linear;\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.move-up-enter,\n.move-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-enter.move-up-enter-active,\n.move-up-appear.move-up-appear-active {\n  animation-name: antMoveUpIn;\n  animation-play-state: running;\n}\n.move-up-leave.move-up-leave-active {\n  animation-name: antMoveUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-up-enter,\n.move-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-up-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-down-enter,\n.move-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-enter.move-down-enter-active,\n.move-down-appear.move-down-appear-active {\n  animation-name: antMoveDownIn;\n  animation-play-state: running;\n}\n.move-down-leave.move-down-leave-active {\n  animation-name: antMoveDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-down-enter,\n.move-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-down-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-left-enter,\n.move-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-enter.move-left-enter-active,\n.move-left-appear.move-left-appear-active {\n  animation-name: antMoveLeftIn;\n  animation-play-state: running;\n}\n.move-left-leave.move-left-leave-active {\n  animation-name: antMoveLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-left-enter,\n.move-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-left-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-right-enter,\n.move-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-enter.move-right-enter-active,\n.move-right-appear.move-right-appear-active {\n  animation-name: antMoveRightIn;\n  animation-play-state: running;\n}\n.move-right-leave.move-right-leave-active {\n  animation-name: antMoveRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-right-enter,\n.move-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-right-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@keyframes antMoveDownIn {\n  0% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n[ant-click-animating='true'],\n[ant-click-animating-without-extra-node='true'] {\n  position: relative;\n}\nhtml {\n  --antd-wave-shadow-color: #4CDEF5;\n}\n[ant-click-animating-without-extra-node='true']::after,\n.ant-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 #4CDEF5;\n  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n@keyframes waveEffect {\n  100% {\n    box-shadow: 0 0 0 #4CDEF5;\n    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n.slide-up-enter,\n.slide-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-enter.slide-up-enter-active,\n.slide-up-appear.slide-up-appear-active {\n  animation-name: antSlideUpIn;\n  animation-play-state: running;\n}\n.slide-up-leave.slide-up-leave-active {\n  animation-name: antSlideUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-up-enter,\n.slide-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-up-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-down-enter,\n.slide-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-enter.slide-down-enter-active,\n.slide-down-appear.slide-down-appear-active {\n  animation-name: antSlideDownIn;\n  animation-play-state: running;\n}\n.slide-down-leave.slide-down-leave-active {\n  animation-name: antSlideDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-down-enter,\n.slide-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-left-enter,\n.slide-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-enter.slide-left-enter-active,\n.slide-left-appear.slide-left-appear-active {\n  animation-name: antSlideLeftIn;\n  animation-play-state: running;\n}\n.slide-left-leave.slide-left-leave-active {\n  animation-name: antSlideLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-left-enter,\n.slide-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-left-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-right-enter,\n.slide-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-enter.slide-right-enter-active,\n.slide-right-appear.slide-right-appear-active {\n  animation-name: antSlideRightIn;\n  animation-play-state: running;\n}\n.slide-right-leave.slide-right-leave-active {\n  animation-name: antSlideRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-right-enter,\n.slide-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-right-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes antSlideUpIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n.swing-enter,\n.swing-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.swing-enter.swing-enter-active,\n.swing-appear.swing-appear-active {\n  animation-name: antSwingIn;\n  animation-play-state: running;\n}\n@keyframes antSwingIn {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-10px);\n  }\n  40% {\n    transform: translateX(10px);\n  }\n  60% {\n    transform: translateX(-5px);\n  }\n  80% {\n    transform: translateX(5px);\n  }\n}\n.zoom-enter,\n.zoom-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-enter.zoom-enter-active,\n.zoom-appear.zoom-appear-active {\n  animation-name: antZoomIn;\n  animation-play-state: running;\n}\n.zoom-leave.zoom-leave-active {\n  animation-name: antZoomOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-enter,\n.zoom-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-enter.zoom-big-enter-active,\n.zoom-big-appear.zoom-big-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-leave.zoom-big-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-leave {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-enter.zoom-big-fast-enter-active,\n.zoom-big-fast-appear.zoom-big-fast-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-fast-leave.zoom-big-fast-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-fast-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-enter.zoom-up-enter-active,\n.zoom-up-appear.zoom-up-appear-active {\n  animation-name: antZoomUpIn;\n  animation-play-state: running;\n}\n.zoom-up-leave.zoom-up-leave-active {\n  animation-name: antZoomUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-up-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-enter.zoom-down-enter-active,\n.zoom-down-appear.zoom-down-appear-active {\n  animation-name: antZoomDownIn;\n  animation-play-state: running;\n}\n.zoom-down-leave.zoom-down-leave-active {\n  animation-name: antZoomDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-enter.zoom-left-enter-active,\n.zoom-left-appear.zoom-left-appear-active {\n  animation-name: antZoomLeftIn;\n  animation-play-state: running;\n}\n.zoom-left-leave.zoom-left-leave-active {\n  animation-name: antZoomLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-left-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-enter.zoom-right-enter-active,\n.zoom-right-appear.zoom-right-appear-active {\n  animation-name: antZoomRightIn;\n  animation-play-state: running;\n}\n.zoom-right-leave.zoom-right-leave-active {\n  animation-name: antZoomRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-right-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@keyframes antZoomIn {\n  0% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n}\n.ant-motion-collapse-legacy-active {\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-motion-collapse {\n  overflow: hidden;\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n", ""]);

// exports


/***/ }),
/* 787 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(789);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-row {\n  position: relative;\n  height: auto;\n  margin-right: 0;\n  margin-left: 0;\n  zoom: 1;\n  display: block;\n  box-sizing: border-box;\n}\n.ant-row::before,\n.ant-row::after {\n  display: table;\n  content: '';\n}\n.ant-row::after {\n  clear: both;\n}\n.ant-row-flex {\n  display: flex;\n  flex-flow: row wrap;\n}\n.ant-row-flex::before,\n.ant-row-flex::after {\n  display: flex;\n}\n.ant-row-flex-start {\n  justify-content: flex-start;\n}\n.ant-row-flex-center {\n  justify-content: center;\n}\n.ant-row-flex-end {\n  justify-content: flex-end;\n}\n.ant-row-flex-space-between {\n  justify-content: space-between;\n}\n.ant-row-flex-space-around {\n  justify-content: space-around;\n}\n.ant-row-flex-top {\n  align-items: flex-start;\n}\n.ant-row-flex-middle {\n  align-items: center;\n}\n.ant-row-flex-bottom {\n  align-items: flex-end;\n}\n.ant-col {\n  position: relative;\n  min-height: 1px;\n}\n.ant-col-1,\n.ant-col-xs-1,\n.ant-col-sm-1,\n.ant-col-md-1,\n.ant-col-lg-1,\n.ant-col-2,\n.ant-col-xs-2,\n.ant-col-sm-2,\n.ant-col-md-2,\n.ant-col-lg-2,\n.ant-col-3,\n.ant-col-xs-3,\n.ant-col-sm-3,\n.ant-col-md-3,\n.ant-col-lg-3,\n.ant-col-4,\n.ant-col-xs-4,\n.ant-col-sm-4,\n.ant-col-md-4,\n.ant-col-lg-4,\n.ant-col-5,\n.ant-col-xs-5,\n.ant-col-sm-5,\n.ant-col-md-5,\n.ant-col-lg-5,\n.ant-col-6,\n.ant-col-xs-6,\n.ant-col-sm-6,\n.ant-col-md-6,\n.ant-col-lg-6,\n.ant-col-7,\n.ant-col-xs-7,\n.ant-col-sm-7,\n.ant-col-md-7,\n.ant-col-lg-7,\n.ant-col-8,\n.ant-col-xs-8,\n.ant-col-sm-8,\n.ant-col-md-8,\n.ant-col-lg-8,\n.ant-col-9,\n.ant-col-xs-9,\n.ant-col-sm-9,\n.ant-col-md-9,\n.ant-col-lg-9,\n.ant-col-10,\n.ant-col-xs-10,\n.ant-col-sm-10,\n.ant-col-md-10,\n.ant-col-lg-10,\n.ant-col-11,\n.ant-col-xs-11,\n.ant-col-sm-11,\n.ant-col-md-11,\n.ant-col-lg-11,\n.ant-col-12,\n.ant-col-xs-12,\n.ant-col-sm-12,\n.ant-col-md-12,\n.ant-col-lg-12,\n.ant-col-13,\n.ant-col-xs-13,\n.ant-col-sm-13,\n.ant-col-md-13,\n.ant-col-lg-13,\n.ant-col-14,\n.ant-col-xs-14,\n.ant-col-sm-14,\n.ant-col-md-14,\n.ant-col-lg-14,\n.ant-col-15,\n.ant-col-xs-15,\n.ant-col-sm-15,\n.ant-col-md-15,\n.ant-col-lg-15,\n.ant-col-16,\n.ant-col-xs-16,\n.ant-col-sm-16,\n.ant-col-md-16,\n.ant-col-lg-16,\n.ant-col-17,\n.ant-col-xs-17,\n.ant-col-sm-17,\n.ant-col-md-17,\n.ant-col-lg-17,\n.ant-col-18,\n.ant-col-xs-18,\n.ant-col-sm-18,\n.ant-col-md-18,\n.ant-col-lg-18,\n.ant-col-19,\n.ant-col-xs-19,\n.ant-col-sm-19,\n.ant-col-md-19,\n.ant-col-lg-19,\n.ant-col-20,\n.ant-col-xs-20,\n.ant-col-sm-20,\n.ant-col-md-20,\n.ant-col-lg-20,\n.ant-col-21,\n.ant-col-xs-21,\n.ant-col-sm-21,\n.ant-col-md-21,\n.ant-col-lg-21,\n.ant-col-22,\n.ant-col-xs-22,\n.ant-col-sm-22,\n.ant-col-md-22,\n.ant-col-lg-22,\n.ant-col-23,\n.ant-col-xs-23,\n.ant-col-sm-23,\n.ant-col-md-23,\n.ant-col-lg-23,\n.ant-col-24,\n.ant-col-xs-24,\n.ant-col-sm-24,\n.ant-col-md-24,\n.ant-col-lg-24 {\n  position: relative;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-col-1,\n.ant-col-2,\n.ant-col-3,\n.ant-col-4,\n.ant-col-5,\n.ant-col-6,\n.ant-col-7,\n.ant-col-8,\n.ant-col-9,\n.ant-col-10,\n.ant-col-11,\n.ant-col-12,\n.ant-col-13,\n.ant-col-14,\n.ant-col-15,\n.ant-col-16,\n.ant-col-17,\n.ant-col-18,\n.ant-col-19,\n.ant-col-20,\n.ant-col-21,\n.ant-col-22,\n.ant-col-23,\n.ant-col-24 {\n  flex: 0 0 auto;\n  float: left;\n}\n.ant-col-24 {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n}\n.ant-col-push-24 {\n  left: 100%;\n}\n.ant-col-pull-24 {\n  right: 100%;\n}\n.ant-col-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-order-24 {\n  order: 24;\n}\n.ant-col-23 {\n  display: block;\n  box-sizing: border-box;\n  width: 95.83333333%;\n}\n.ant-col-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-order-23 {\n  order: 23;\n}\n.ant-col-22 {\n  display: block;\n  box-sizing: border-box;\n  width: 91.66666667%;\n}\n.ant-col-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-order-22 {\n  order: 22;\n}\n.ant-col-21 {\n  display: block;\n  box-sizing: border-box;\n  width: 87.5%;\n}\n.ant-col-push-21 {\n  left: 87.5%;\n}\n.ant-col-pull-21 {\n  right: 87.5%;\n}\n.ant-col-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-order-21 {\n  order: 21;\n}\n.ant-col-20 {\n  display: block;\n  box-sizing: border-box;\n  width: 83.33333333%;\n}\n.ant-col-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-order-20 {\n  order: 20;\n}\n.ant-col-19 {\n  display: block;\n  box-sizing: border-box;\n  width: 79.16666667%;\n}\n.ant-col-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-order-19 {\n  order: 19;\n}\n.ant-col-18 {\n  display: block;\n  box-sizing: border-box;\n  width: 75%;\n}\n.ant-col-push-18 {\n  left: 75%;\n}\n.ant-col-pull-18 {\n  right: 75%;\n}\n.ant-col-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-order-18 {\n  order: 18;\n}\n.ant-col-17 {\n  display: block;\n  box-sizing: border-box;\n  width: 70.83333333%;\n}\n.ant-col-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-order-17 {\n  order: 17;\n}\n.ant-col-16 {\n  display: block;\n  box-sizing: border-box;\n  width: 66.66666667%;\n}\n.ant-col-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-order-16 {\n  order: 16;\n}\n.ant-col-15 {\n  display: block;\n  box-sizing: border-box;\n  width: 62.5%;\n}\n.ant-col-push-15 {\n  left: 62.5%;\n}\n.ant-col-pull-15 {\n  right: 62.5%;\n}\n.ant-col-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-order-15 {\n  order: 15;\n}\n.ant-col-14 {\n  display: block;\n  box-sizing: border-box;\n  width: 58.33333333%;\n}\n.ant-col-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-order-14 {\n  order: 14;\n}\n.ant-col-13 {\n  display: block;\n  box-sizing: border-box;\n  width: 54.16666667%;\n}\n.ant-col-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-order-13 {\n  order: 13;\n}\n.ant-col-12 {\n  display: block;\n  box-sizing: border-box;\n  width: 50%;\n}\n.ant-col-push-12 {\n  left: 50%;\n}\n.ant-col-pull-12 {\n  right: 50%;\n}\n.ant-col-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-order-12 {\n  order: 12;\n}\n.ant-col-11 {\n  display: block;\n  box-sizing: border-box;\n  width: 45.83333333%;\n}\n.ant-col-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-order-11 {\n  order: 11;\n}\n.ant-col-10 {\n  display: block;\n  box-sizing: border-box;\n  width: 41.66666667%;\n}\n.ant-col-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-order-10 {\n  order: 10;\n}\n.ant-col-9 {\n  display: block;\n  box-sizing: border-box;\n  width: 37.5%;\n}\n.ant-col-push-9 {\n  left: 37.5%;\n}\n.ant-col-pull-9 {\n  right: 37.5%;\n}\n.ant-col-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-order-9 {\n  order: 9;\n}\n.ant-col-8 {\n  display: block;\n  box-sizing: border-box;\n  width: 33.33333333%;\n}\n.ant-col-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-order-8 {\n  order: 8;\n}\n.ant-col-7 {\n  display: block;\n  box-sizing: border-box;\n  width: 29.16666667%;\n}\n.ant-col-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-order-7 {\n  order: 7;\n}\n.ant-col-6 {\n  display: block;\n  box-sizing: border-box;\n  width: 25%;\n}\n.ant-col-push-6 {\n  left: 25%;\n}\n.ant-col-pull-6 {\n  right: 25%;\n}\n.ant-col-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-order-6 {\n  order: 6;\n}\n.ant-col-5 {\n  display: block;\n  box-sizing: border-box;\n  width: 20.83333333%;\n}\n.ant-col-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-order-5 {\n  order: 5;\n}\n.ant-col-4 {\n  display: block;\n  box-sizing: border-box;\n  width: 16.66666667%;\n}\n.ant-col-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-order-4 {\n  order: 4;\n}\n.ant-col-3 {\n  display: block;\n  box-sizing: border-box;\n  width: 12.5%;\n}\n.ant-col-push-3 {\n  left: 12.5%;\n}\n.ant-col-pull-3 {\n  right: 12.5%;\n}\n.ant-col-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-order-3 {\n  order: 3;\n}\n.ant-col-2 {\n  display: block;\n  box-sizing: border-box;\n  width: 8.33333333%;\n}\n.ant-col-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-order-2 {\n  order: 2;\n}\n.ant-col-1 {\n  display: block;\n  box-sizing: border-box;\n  width: 4.16666667%;\n}\n.ant-col-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-order-1 {\n  order: 1;\n}\n.ant-col-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-offset-0 {\n  margin-left: 0;\n}\n.ant-col-order-0 {\n  order: 0;\n}\n.ant-col-xs-1,\n.ant-col-xs-2,\n.ant-col-xs-3,\n.ant-col-xs-4,\n.ant-col-xs-5,\n.ant-col-xs-6,\n.ant-col-xs-7,\n.ant-col-xs-8,\n.ant-col-xs-9,\n.ant-col-xs-10,\n.ant-col-xs-11,\n.ant-col-xs-12,\n.ant-col-xs-13,\n.ant-col-xs-14,\n.ant-col-xs-15,\n.ant-col-xs-16,\n.ant-col-xs-17,\n.ant-col-xs-18,\n.ant-col-xs-19,\n.ant-col-xs-20,\n.ant-col-xs-21,\n.ant-col-xs-22,\n.ant-col-xs-23,\n.ant-col-xs-24 {\n  flex: 0 0 auto;\n  float: left;\n}\n.ant-col-xs-24 {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n}\n.ant-col-xs-push-24 {\n  left: 100%;\n}\n.ant-col-xs-pull-24 {\n  right: 100%;\n}\n.ant-col-xs-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-xs-order-24 {\n  order: 24;\n}\n.ant-col-xs-23 {\n  display: block;\n  box-sizing: border-box;\n  width: 95.83333333%;\n}\n.ant-col-xs-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-xs-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-xs-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-xs-order-23 {\n  order: 23;\n}\n.ant-col-xs-22 {\n  display: block;\n  box-sizing: border-box;\n  width: 91.66666667%;\n}\n.ant-col-xs-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-xs-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-xs-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-xs-order-22 {\n  order: 22;\n}\n.ant-col-xs-21 {\n  display: block;\n  box-sizing: border-box;\n  width: 87.5%;\n}\n.ant-col-xs-push-21 {\n  left: 87.5%;\n}\n.ant-col-xs-pull-21 {\n  right: 87.5%;\n}\n.ant-col-xs-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-xs-order-21 {\n  order: 21;\n}\n.ant-col-xs-20 {\n  display: block;\n  box-sizing: border-box;\n  width: 83.33333333%;\n}\n.ant-col-xs-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-xs-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-xs-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-xs-order-20 {\n  order: 20;\n}\n.ant-col-xs-19 {\n  display: block;\n  box-sizing: border-box;\n  width: 79.16666667%;\n}\n.ant-col-xs-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-xs-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-xs-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-xs-order-19 {\n  order: 19;\n}\n.ant-col-xs-18 {\n  display: block;\n  box-sizing: border-box;\n  width: 75%;\n}\n.ant-col-xs-push-18 {\n  left: 75%;\n}\n.ant-col-xs-pull-18 {\n  right: 75%;\n}\n.ant-col-xs-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-xs-order-18 {\n  order: 18;\n}\n.ant-col-xs-17 {\n  display: block;\n  box-sizing: border-box;\n  width: 70.83333333%;\n}\n.ant-col-xs-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-xs-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-xs-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-xs-order-17 {\n  order: 17;\n}\n.ant-col-xs-16 {\n  display: block;\n  box-sizing: border-box;\n  width: 66.66666667%;\n}\n.ant-col-xs-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-xs-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-xs-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-xs-order-16 {\n  order: 16;\n}\n.ant-col-xs-15 {\n  display: block;\n  box-sizing: border-box;\n  width: 62.5%;\n}\n.ant-col-xs-push-15 {\n  left: 62.5%;\n}\n.ant-col-xs-pull-15 {\n  right: 62.5%;\n}\n.ant-col-xs-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-xs-order-15 {\n  order: 15;\n}\n.ant-col-xs-14 {\n  display: block;\n  box-sizing: border-box;\n  width: 58.33333333%;\n}\n.ant-col-xs-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-xs-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-xs-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-xs-order-14 {\n  order: 14;\n}\n.ant-col-xs-13 {\n  display: block;\n  box-sizing: border-box;\n  width: 54.16666667%;\n}\n.ant-col-xs-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-xs-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-xs-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-xs-order-13 {\n  order: 13;\n}\n.ant-col-xs-12 {\n  display: block;\n  box-sizing: border-box;\n  width: 50%;\n}\n.ant-col-xs-push-12 {\n  left: 50%;\n}\n.ant-col-xs-pull-12 {\n  right: 50%;\n}\n.ant-col-xs-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-xs-order-12 {\n  order: 12;\n}\n.ant-col-xs-11 {\n  display: block;\n  box-sizing: border-box;\n  width: 45.83333333%;\n}\n.ant-col-xs-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-xs-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-xs-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-xs-order-11 {\n  order: 11;\n}\n.ant-col-xs-10 {\n  display: block;\n  box-sizing: border-box;\n  width: 41.66666667%;\n}\n.ant-col-xs-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-xs-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-xs-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-xs-order-10 {\n  order: 10;\n}\n.ant-col-xs-9 {\n  display: block;\n  box-sizing: border-box;\n  width: 37.5%;\n}\n.ant-col-xs-push-9 {\n  left: 37.5%;\n}\n.ant-col-xs-pull-9 {\n  right: 37.5%;\n}\n.ant-col-xs-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-xs-order-9 {\n  order: 9;\n}\n.ant-col-xs-8 {\n  display: block;\n  box-sizing: border-box;\n  width: 33.33333333%;\n}\n.ant-col-xs-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-xs-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-xs-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-xs-order-8 {\n  order: 8;\n}\n.ant-col-xs-7 {\n  display: block;\n  box-sizing: border-box;\n  width: 29.16666667%;\n}\n.ant-col-xs-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-xs-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-xs-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-xs-order-7 {\n  order: 7;\n}\n.ant-col-xs-6 {\n  display: block;\n  box-sizing: border-box;\n  width: 25%;\n}\n.ant-col-xs-push-6 {\n  left: 25%;\n}\n.ant-col-xs-pull-6 {\n  right: 25%;\n}\n.ant-col-xs-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-xs-order-6 {\n  order: 6;\n}\n.ant-col-xs-5 {\n  display: block;\n  box-sizing: border-box;\n  width: 20.83333333%;\n}\n.ant-col-xs-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-xs-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-xs-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-xs-order-5 {\n  order: 5;\n}\n.ant-col-xs-4 {\n  display: block;\n  box-sizing: border-box;\n  width: 16.66666667%;\n}\n.ant-col-xs-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-xs-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-xs-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-xs-order-4 {\n  order: 4;\n}\n.ant-col-xs-3 {\n  display: block;\n  box-sizing: border-box;\n  width: 12.5%;\n}\n.ant-col-xs-push-3 {\n  left: 12.5%;\n}\n.ant-col-xs-pull-3 {\n  right: 12.5%;\n}\n.ant-col-xs-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-xs-order-3 {\n  order: 3;\n}\n.ant-col-xs-2 {\n  display: block;\n  box-sizing: border-box;\n  width: 8.33333333%;\n}\n.ant-col-xs-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-xs-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-xs-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-xs-order-2 {\n  order: 2;\n}\n.ant-col-xs-1 {\n  display: block;\n  box-sizing: border-box;\n  width: 4.16666667%;\n}\n.ant-col-xs-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-xs-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-xs-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-xs-order-1 {\n  order: 1;\n}\n.ant-col-xs-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-xs-push-0 {\n  left: auto;\n}\n.ant-col-xs-pull-0 {\n  right: auto;\n}\n.ant-col-xs-offset-0 {\n  margin-left: 0;\n}\n.ant-col-xs-order-0 {\n  order: 0;\n}\n@media (min-width: 576px) {\n  .ant-col-sm-1,\n  .ant-col-sm-2,\n  .ant-col-sm-3,\n  .ant-col-sm-4,\n  .ant-col-sm-5,\n  .ant-col-sm-6,\n  .ant-col-sm-7,\n  .ant-col-sm-8,\n  .ant-col-sm-9,\n  .ant-col-sm-10,\n  .ant-col-sm-11,\n  .ant-col-sm-12,\n  .ant-col-sm-13,\n  .ant-col-sm-14,\n  .ant-col-sm-15,\n  .ant-col-sm-16,\n  .ant-col-sm-17,\n  .ant-col-sm-18,\n  .ant-col-sm-19,\n  .ant-col-sm-20,\n  .ant-col-sm-21,\n  .ant-col-sm-22,\n  .ant-col-sm-23,\n  .ant-col-sm-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-sm-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-sm-push-24 {\n    left: 100%;\n  }\n  .ant-col-sm-pull-24 {\n    right: 100%;\n  }\n  .ant-col-sm-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-sm-order-24 {\n    order: 24;\n  }\n  .ant-col-sm-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-sm-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-sm-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-sm-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-sm-order-23 {\n    order: 23;\n  }\n  .ant-col-sm-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-sm-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-sm-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-sm-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-sm-order-22 {\n    order: 22;\n  }\n  .ant-col-sm-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-sm-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-sm-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-sm-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-sm-order-21 {\n    order: 21;\n  }\n  .ant-col-sm-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-sm-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-sm-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-sm-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-sm-order-20 {\n    order: 20;\n  }\n  .ant-col-sm-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-sm-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-sm-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-sm-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-sm-order-19 {\n    order: 19;\n  }\n  .ant-col-sm-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-sm-push-18 {\n    left: 75%;\n  }\n  .ant-col-sm-pull-18 {\n    right: 75%;\n  }\n  .ant-col-sm-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-sm-order-18 {\n    order: 18;\n  }\n  .ant-col-sm-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-sm-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-sm-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-sm-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-sm-order-17 {\n    order: 17;\n  }\n  .ant-col-sm-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-sm-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-sm-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-sm-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-sm-order-16 {\n    order: 16;\n  }\n  .ant-col-sm-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-sm-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-sm-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-sm-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-sm-order-15 {\n    order: 15;\n  }\n  .ant-col-sm-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-sm-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-sm-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-sm-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-sm-order-14 {\n    order: 14;\n  }\n  .ant-col-sm-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-sm-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-sm-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-sm-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-sm-order-13 {\n    order: 13;\n  }\n  .ant-col-sm-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-sm-push-12 {\n    left: 50%;\n  }\n  .ant-col-sm-pull-12 {\n    right: 50%;\n  }\n  .ant-col-sm-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-sm-order-12 {\n    order: 12;\n  }\n  .ant-col-sm-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-sm-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-sm-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-sm-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-sm-order-11 {\n    order: 11;\n  }\n  .ant-col-sm-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-sm-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-sm-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-sm-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-sm-order-10 {\n    order: 10;\n  }\n  .ant-col-sm-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-sm-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-sm-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-sm-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-sm-order-9 {\n    order: 9;\n  }\n  .ant-col-sm-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-sm-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-sm-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-sm-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-sm-order-8 {\n    order: 8;\n  }\n  .ant-col-sm-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-sm-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-sm-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-sm-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-sm-order-7 {\n    order: 7;\n  }\n  .ant-col-sm-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-sm-push-6 {\n    left: 25%;\n  }\n  .ant-col-sm-pull-6 {\n    right: 25%;\n  }\n  .ant-col-sm-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-sm-order-6 {\n    order: 6;\n  }\n  .ant-col-sm-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-sm-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-sm-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-sm-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-sm-order-5 {\n    order: 5;\n  }\n  .ant-col-sm-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-sm-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-sm-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-sm-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-sm-order-4 {\n    order: 4;\n  }\n  .ant-col-sm-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-sm-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-sm-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-sm-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-sm-order-3 {\n    order: 3;\n  }\n  .ant-col-sm-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-sm-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-sm-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-sm-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-sm-order-2 {\n    order: 2;\n  }\n  .ant-col-sm-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-sm-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-sm-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-sm-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-sm-order-1 {\n    order: 1;\n  }\n  .ant-col-sm-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-push-0 {\n    left: auto;\n  }\n  .ant-col-sm-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-sm-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 768px) {\n  .ant-col-md-1,\n  .ant-col-md-2,\n  .ant-col-md-3,\n  .ant-col-md-4,\n  .ant-col-md-5,\n  .ant-col-md-6,\n  .ant-col-md-7,\n  .ant-col-md-8,\n  .ant-col-md-9,\n  .ant-col-md-10,\n  .ant-col-md-11,\n  .ant-col-md-12,\n  .ant-col-md-13,\n  .ant-col-md-14,\n  .ant-col-md-15,\n  .ant-col-md-16,\n  .ant-col-md-17,\n  .ant-col-md-18,\n  .ant-col-md-19,\n  .ant-col-md-20,\n  .ant-col-md-21,\n  .ant-col-md-22,\n  .ant-col-md-23,\n  .ant-col-md-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-md-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-md-push-24 {\n    left: 100%;\n  }\n  .ant-col-md-pull-24 {\n    right: 100%;\n  }\n  .ant-col-md-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-md-order-24 {\n    order: 24;\n  }\n  .ant-col-md-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-md-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-md-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-md-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-md-order-23 {\n    order: 23;\n  }\n  .ant-col-md-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-md-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-md-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-md-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-md-order-22 {\n    order: 22;\n  }\n  .ant-col-md-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-md-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-md-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-md-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-md-order-21 {\n    order: 21;\n  }\n  .ant-col-md-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-md-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-md-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-md-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-md-order-20 {\n    order: 20;\n  }\n  .ant-col-md-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-md-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-md-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-md-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-md-order-19 {\n    order: 19;\n  }\n  .ant-col-md-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-md-push-18 {\n    left: 75%;\n  }\n  .ant-col-md-pull-18 {\n    right: 75%;\n  }\n  .ant-col-md-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-md-order-18 {\n    order: 18;\n  }\n  .ant-col-md-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-md-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-md-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-md-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-md-order-17 {\n    order: 17;\n  }\n  .ant-col-md-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-md-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-md-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-md-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-md-order-16 {\n    order: 16;\n  }\n  .ant-col-md-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-md-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-md-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-md-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-md-order-15 {\n    order: 15;\n  }\n  .ant-col-md-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-md-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-md-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-md-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-md-order-14 {\n    order: 14;\n  }\n  .ant-col-md-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-md-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-md-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-md-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-md-order-13 {\n    order: 13;\n  }\n  .ant-col-md-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-md-push-12 {\n    left: 50%;\n  }\n  .ant-col-md-pull-12 {\n    right: 50%;\n  }\n  .ant-col-md-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-md-order-12 {\n    order: 12;\n  }\n  .ant-col-md-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-md-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-md-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-md-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-md-order-11 {\n    order: 11;\n  }\n  .ant-col-md-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-md-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-md-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-md-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-md-order-10 {\n    order: 10;\n  }\n  .ant-col-md-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-md-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-md-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-md-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-md-order-9 {\n    order: 9;\n  }\n  .ant-col-md-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-md-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-md-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-md-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-md-order-8 {\n    order: 8;\n  }\n  .ant-col-md-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-md-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-md-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-md-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-md-order-7 {\n    order: 7;\n  }\n  .ant-col-md-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-md-push-6 {\n    left: 25%;\n  }\n  .ant-col-md-pull-6 {\n    right: 25%;\n  }\n  .ant-col-md-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-md-order-6 {\n    order: 6;\n  }\n  .ant-col-md-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-md-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-md-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-md-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-md-order-5 {\n    order: 5;\n  }\n  .ant-col-md-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-md-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-md-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-md-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-md-order-4 {\n    order: 4;\n  }\n  .ant-col-md-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-md-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-md-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-md-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-md-order-3 {\n    order: 3;\n  }\n  .ant-col-md-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-md-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-md-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-md-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-md-order-2 {\n    order: 2;\n  }\n  .ant-col-md-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-md-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-md-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-md-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-md-order-1 {\n    order: 1;\n  }\n  .ant-col-md-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-push-0 {\n    left: auto;\n  }\n  .ant-col-md-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-md-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 992px) {\n  .ant-col-lg-1,\n  .ant-col-lg-2,\n  .ant-col-lg-3,\n  .ant-col-lg-4,\n  .ant-col-lg-5,\n  .ant-col-lg-6,\n  .ant-col-lg-7,\n  .ant-col-lg-8,\n  .ant-col-lg-9,\n  .ant-col-lg-10,\n  .ant-col-lg-11,\n  .ant-col-lg-12,\n  .ant-col-lg-13,\n  .ant-col-lg-14,\n  .ant-col-lg-15,\n  .ant-col-lg-16,\n  .ant-col-lg-17,\n  .ant-col-lg-18,\n  .ant-col-lg-19,\n  .ant-col-lg-20,\n  .ant-col-lg-21,\n  .ant-col-lg-22,\n  .ant-col-lg-23,\n  .ant-col-lg-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-lg-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-lg-push-24 {\n    left: 100%;\n  }\n  .ant-col-lg-pull-24 {\n    right: 100%;\n  }\n  .ant-col-lg-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-lg-order-24 {\n    order: 24;\n  }\n  .ant-col-lg-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-lg-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-lg-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-lg-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-lg-order-23 {\n    order: 23;\n  }\n  .ant-col-lg-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-lg-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-lg-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-lg-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-lg-order-22 {\n    order: 22;\n  }\n  .ant-col-lg-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-lg-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-lg-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-lg-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-lg-order-21 {\n    order: 21;\n  }\n  .ant-col-lg-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-lg-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-lg-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-lg-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-lg-order-20 {\n    order: 20;\n  }\n  .ant-col-lg-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-lg-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-lg-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-lg-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-lg-order-19 {\n    order: 19;\n  }\n  .ant-col-lg-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-lg-push-18 {\n    left: 75%;\n  }\n  .ant-col-lg-pull-18 {\n    right: 75%;\n  }\n  .ant-col-lg-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-lg-order-18 {\n    order: 18;\n  }\n  .ant-col-lg-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-lg-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-lg-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-lg-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-lg-order-17 {\n    order: 17;\n  }\n  .ant-col-lg-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-lg-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-lg-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-lg-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-lg-order-16 {\n    order: 16;\n  }\n  .ant-col-lg-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-lg-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-lg-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-lg-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-lg-order-15 {\n    order: 15;\n  }\n  .ant-col-lg-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-lg-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-lg-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-lg-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-lg-order-14 {\n    order: 14;\n  }\n  .ant-col-lg-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-lg-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-lg-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-lg-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-lg-order-13 {\n    order: 13;\n  }\n  .ant-col-lg-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-lg-push-12 {\n    left: 50%;\n  }\n  .ant-col-lg-pull-12 {\n    right: 50%;\n  }\n  .ant-col-lg-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-lg-order-12 {\n    order: 12;\n  }\n  .ant-col-lg-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-lg-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-lg-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-lg-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-lg-order-11 {\n    order: 11;\n  }\n  .ant-col-lg-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-lg-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-lg-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-lg-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-lg-order-10 {\n    order: 10;\n  }\n  .ant-col-lg-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-lg-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-lg-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-lg-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-lg-order-9 {\n    order: 9;\n  }\n  .ant-col-lg-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-lg-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-lg-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-lg-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-lg-order-8 {\n    order: 8;\n  }\n  .ant-col-lg-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-lg-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-lg-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-lg-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-lg-order-7 {\n    order: 7;\n  }\n  .ant-col-lg-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-lg-push-6 {\n    left: 25%;\n  }\n  .ant-col-lg-pull-6 {\n    right: 25%;\n  }\n  .ant-col-lg-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-lg-order-6 {\n    order: 6;\n  }\n  .ant-col-lg-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-lg-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-lg-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-lg-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-lg-order-5 {\n    order: 5;\n  }\n  .ant-col-lg-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-lg-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-lg-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-lg-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-lg-order-4 {\n    order: 4;\n  }\n  .ant-col-lg-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-lg-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-lg-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-lg-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-lg-order-3 {\n    order: 3;\n  }\n  .ant-col-lg-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-lg-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-lg-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-lg-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-lg-order-2 {\n    order: 2;\n  }\n  .ant-col-lg-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-lg-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-lg-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-lg-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-lg-order-1 {\n    order: 1;\n  }\n  .ant-col-lg-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-push-0 {\n    left: auto;\n  }\n  .ant-col-lg-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-lg-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .ant-col-xl-1,\n  .ant-col-xl-2,\n  .ant-col-xl-3,\n  .ant-col-xl-4,\n  .ant-col-xl-5,\n  .ant-col-xl-6,\n  .ant-col-xl-7,\n  .ant-col-xl-8,\n  .ant-col-xl-9,\n  .ant-col-xl-10,\n  .ant-col-xl-11,\n  .ant-col-xl-12,\n  .ant-col-xl-13,\n  .ant-col-xl-14,\n  .ant-col-xl-15,\n  .ant-col-xl-16,\n  .ant-col-xl-17,\n  .ant-col-xl-18,\n  .ant-col-xl-19,\n  .ant-col-xl-20,\n  .ant-col-xl-21,\n  .ant-col-xl-22,\n  .ant-col-xl-23,\n  .ant-col-xl-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-xl-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-xl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xl-order-24 {\n    order: 24;\n  }\n  .ant-col-xl-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-xl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xl-order-23 {\n    order: 23;\n  }\n  .ant-col-xl-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-xl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xl-order-22 {\n    order: 22;\n  }\n  .ant-col-xl-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-xl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xl-order-21 {\n    order: 21;\n  }\n  .ant-col-xl-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-xl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xl-order-20 {\n    order: 20;\n  }\n  .ant-col-xl-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-xl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xl-order-19 {\n    order: 19;\n  }\n  .ant-col-xl-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-xl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xl-order-18 {\n    order: 18;\n  }\n  .ant-col-xl-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-xl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xl-order-17 {\n    order: 17;\n  }\n  .ant-col-xl-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-xl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xl-order-16 {\n    order: 16;\n  }\n  .ant-col-xl-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-xl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xl-order-15 {\n    order: 15;\n  }\n  .ant-col-xl-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-xl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xl-order-14 {\n    order: 14;\n  }\n  .ant-col-xl-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-xl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xl-order-13 {\n    order: 13;\n  }\n  .ant-col-xl-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-xl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xl-order-12 {\n    order: 12;\n  }\n  .ant-col-xl-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-xl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xl-order-11 {\n    order: 11;\n  }\n  .ant-col-xl-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-xl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xl-order-10 {\n    order: 10;\n  }\n  .ant-col-xl-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-xl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xl-order-9 {\n    order: 9;\n  }\n  .ant-col-xl-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-xl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xl-order-8 {\n    order: 8;\n  }\n  .ant-col-xl-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-xl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xl-order-7 {\n    order: 7;\n  }\n  .ant-col-xl-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-xl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xl-order-6 {\n    order: 6;\n  }\n  .ant-col-xl-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-xl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xl-order-5 {\n    order: 5;\n  }\n  .ant-col-xl-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-xl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xl-order-4 {\n    order: 4;\n  }\n  .ant-col-xl-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-xl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xl-order-3 {\n    order: 3;\n  }\n  .ant-col-xl-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-xl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xl-order-2 {\n    order: 2;\n  }\n  .ant-col-xl-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-xl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xl-order-1 {\n    order: 1;\n  }\n  .ant-col-xl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-push-0 {\n    left: auto;\n  }\n  .ant-col-xl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xl-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1600px) {\n  .ant-col-xxl-1,\n  .ant-col-xxl-2,\n  .ant-col-xxl-3,\n  .ant-col-xxl-4,\n  .ant-col-xxl-5,\n  .ant-col-xxl-6,\n  .ant-col-xxl-7,\n  .ant-col-xxl-8,\n  .ant-col-xxl-9,\n  .ant-col-xxl-10,\n  .ant-col-xxl-11,\n  .ant-col-xxl-12,\n  .ant-col-xxl-13,\n  .ant-col-xxl-14,\n  .ant-col-xxl-15,\n  .ant-col-xxl-16,\n  .ant-col-xxl-17,\n  .ant-col-xxl-18,\n  .ant-col-xxl-19,\n  .ant-col-xxl-20,\n  .ant-col-xxl-21,\n  .ant-col-xxl-22,\n  .ant-col-xxl-23,\n  .ant-col-xxl-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-xxl-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-xxl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xxl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xxl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xxl-order-24 {\n    order: 24;\n  }\n  .ant-col-xxl-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-xxl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xxl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xxl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xxl-order-23 {\n    order: 23;\n  }\n  .ant-col-xxl-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-xxl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xxl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xxl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xxl-order-22 {\n    order: 22;\n  }\n  .ant-col-xxl-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-xxl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xxl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xxl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xxl-order-21 {\n    order: 21;\n  }\n  .ant-col-xxl-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-xxl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xxl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xxl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xxl-order-20 {\n    order: 20;\n  }\n  .ant-col-xxl-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-xxl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xxl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xxl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xxl-order-19 {\n    order: 19;\n  }\n  .ant-col-xxl-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-xxl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xxl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xxl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xxl-order-18 {\n    order: 18;\n  }\n  .ant-col-xxl-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-xxl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xxl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xxl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xxl-order-17 {\n    order: 17;\n  }\n  .ant-col-xxl-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-xxl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xxl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xxl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xxl-order-16 {\n    order: 16;\n  }\n  .ant-col-xxl-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-xxl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xxl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xxl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xxl-order-15 {\n    order: 15;\n  }\n  .ant-col-xxl-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-xxl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xxl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xxl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xxl-order-14 {\n    order: 14;\n  }\n  .ant-col-xxl-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-xxl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xxl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xxl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xxl-order-13 {\n    order: 13;\n  }\n  .ant-col-xxl-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-xxl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xxl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xxl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xxl-order-12 {\n    order: 12;\n  }\n  .ant-col-xxl-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-xxl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xxl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xxl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xxl-order-11 {\n    order: 11;\n  }\n  .ant-col-xxl-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-xxl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xxl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xxl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xxl-order-10 {\n    order: 10;\n  }\n  .ant-col-xxl-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-xxl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xxl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xxl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xxl-order-9 {\n    order: 9;\n  }\n  .ant-col-xxl-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-xxl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xxl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xxl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xxl-order-8 {\n    order: 8;\n  }\n  .ant-col-xxl-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-xxl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xxl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xxl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xxl-order-7 {\n    order: 7;\n  }\n  .ant-col-xxl-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-xxl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xxl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xxl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xxl-order-6 {\n    order: 6;\n  }\n  .ant-col-xxl-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-xxl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xxl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xxl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xxl-order-5 {\n    order: 5;\n  }\n  .ant-col-xxl-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-xxl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xxl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xxl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xxl-order-4 {\n    order: 4;\n  }\n  .ant-col-xxl-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-xxl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xxl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xxl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xxl-order-3 {\n    order: 3;\n  }\n  .ant-col-xxl-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-xxl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xxl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xxl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xxl-order-2 {\n    order: 2;\n  }\n  .ant-col-xxl-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-xxl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xxl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xxl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xxl-order-1 {\n    order: 1;\n  }\n  .ant-col-xxl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-push-0 {\n    left: auto;\n  }\n  .ant-col-xxl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xxl-order-0 {\n    order: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ANT_MARK = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _locale = __webpack_require__(269);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ANT_MARK = 'internalMark';
exports.ANT_MARK = ANT_MARK;

function setMomentLocale(locale) {
  if (locale && locale.locale) {
    (0, _interopDefault["default"])(moment).locale(locale.locale);
  } else {
    (0, _interopDefault["default"])(moment).locale('en');
  }
}

var LocaleProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  function LocaleProvider(props) {
    var _this;

    _classCallCheck(this, LocaleProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocaleProvider).call(this, props));
    setMomentLocale(props.locale);
    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    return _this;
  }

  _createClass(LocaleProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        antLocale: _extends(_extends({}, this.props.locale), {
          exist: true
        })
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var locale = this.props.locale;

      if (prevProps.locale !== locale) {
        setMomentLocale(locale);
        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _locale.changeConfirmLocale)();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return LocaleProvider;
}(React.Component);

exports["default"] = LocaleProvider;
LocaleProvider.propTypes = {
  locale: PropTypes.object
};
LocaleProvider.defaultProps = {
  locale: {}
};
LocaleProvider.childContextTypes = {
  antLocale: PropTypes.object
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(270));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _en_US["default"];
exports["default"] = _default;
//# sourceMappingURL=en_US.js.map


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default2 = _interopRequireDefault(__webpack_require__(158));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _default2["default"];
exports["default"] = _default;
//# sourceMappingURL=default.js.map


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withConfigConsumer = withConfigConsumer;
exports.ConfigConsumer = exports.ConfigContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createReactContext = _interopRequireDefault(__webpack_require__(126));

var _renderEmpty = _interopRequireDefault(__webpack_require__(795));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ConfigContext = (0, _createReactContext["default"])({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "ant-".concat(suffixCls);
  },
  renderEmpty: _renderEmpty["default"]
});
exports.ConfigContext = ConfigContext;
var ConfigConsumer = ConfigContext.Consumer;
exports.ConfigConsumer = ConfigConsumer;

function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return React.createElement(Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };

    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || 'Component';
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}
//# sourceMappingURL=context.js.map


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(369);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _empty = _interopRequireDefault(__webpack_require__(796));

var _ = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var renderEmpty = function renderEmpty(componentName) {
  return React.createElement(_.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
      case 'Mentions':
        return React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });

      default:
        return React.createElement(_empty["default"], null);
    }
  });
};

var _default = renderEmpty;
exports["default"] = _default;
//# sourceMappingURL=renderEmpty.js.map


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _empty = _interopRequireDefault(__webpack_require__(797));

var _simple = _interopRequireDefault(__webpack_require__(798));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var defaultEmptyImg = React.createElement(_empty["default"], null);
var simpleEmptyImg = React.createElement(_simple["default"], null);

var Empty = function Empty(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        customizePrefixCls = props.prefixCls,
        _props$image = props.image,
        image = _props$image === void 0 ? defaultEmptyImg : _props$image,
        description = props.description,
        children = props.children,
        imageStyle = props.imageStyle,
        restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);

    return React.createElement(_LocaleReceiver["default"], {
      componentName: "Empty"
    }, function (locale) {
      var prefixCls = getPrefixCls('empty', customizePrefixCls);
      var des = typeof description !== 'undefined' ? description : locale.description;
      var alt = typeof des === 'string' ? des : 'empty';
      var imageNode = null;

      if (typeof image === 'string') {
        imageNode = React.createElement("img", {
          alt: alt,
          src: image
        });
      } else {
        imageNode = image;
      }

      return React.createElement("div", _extends({
        className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
      }, restProps), React.createElement("div", {
        className: "".concat(prefixCls, "-image"),
        style: imageStyle
      }, imageNode), des && React.createElement("p", {
        className: "".concat(prefixCls, "-description")
      }, des), children && React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, children));
    });
  });
};

Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
var _default = Empty;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Empty = function Empty() {
  return React.createElement("svg", {
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(24 31.67)"
  }, React.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), React.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), React.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), React.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), React.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), React.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), React.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, React.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), React.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};

var _default = Empty;
exports["default"] = _default;
//# sourceMappingURL=empty.js.map


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Simple = function Simple() {
  return React.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#D9D9D9"
  }, React.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), React.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: "#FAFAFA"
  }))));
};

var _default = Simple;
exports["default"] = _default;
//# sourceMappingURL=simple.js.map


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require

  enquire = __webpack_require__(408);
}

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
exports.responsiveArray = responsiveArray;
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
exports.responsiveMap = responsiveMap;
var subscribers = [];
var subUid = -1;
var screens = {};
var responsiveObserve = {
  dispatch: function dispatch(pointMap) {
    screens = pointMap;

    if (subscribers.length < 1) {
      return false;
    }

    subscribers.forEach(function (item) {
      item.func(screens);
    });
    return true;
  },
  subscribe: function subscribe(func) {
    if (subscribers.length === 0) {
      this.register();
    }

    var token = (++subUid).toString();
    subscribers.push({
      token: token,
      func: func
    });
    func(screens);
    return token;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers = subscribers.filter(function (item) {
      return item.token !== token;
    });

    if (subscribers.length === 0) {
      this.unregister();
    }
  },
  unregister: function unregister() {
    Object.keys(responsiveMap).map(function (screen) {
      return enquire.unregister(responsiveMap[screen]);
    });
  },
  register: function register() {
    var _this = this;

    Object.keys(responsiveMap).map(function (screen) {
      return enquire.register(responsiveMap[screen], {
        match: function match() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));

          _this.dispatch(pointMap);
        },
        unmatch: function unmatch() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));

          _this.dispatch(pointMap);
        },
        // Keep a empty destory to avoid triggering unmatch when unregister
        destroy: function destroy() {}
      });
    });
  }
};
var _default = responsiveObserve;
exports["default"] = _default;
//# sourceMappingURL=responsiveObserve.js.map


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(801);
var Util = __webpack_require__(409);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(802);
var each = __webpack_require__(409).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(804);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-layout {\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n  background: linear-gradient(120deg, #FAFAFA 18%, #E1F5FE 25%, #FAFAFA 32%);\n}\n.ant-layout,\n.ant-layout * {\n  box-sizing: border-box;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout,\n.ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: hidden;\n}\n.ant-layout-header,\n.ant-layout-footer {\n  flex: 0 0 auto;\n}\n.ant-layout-header {\n  height: 64px;\n  padding: 0 50px;\n  line-height: 64px;\n  background: rgba(0, 0, 0, 0);\n}\n.ant-layout-footer {\n  padding: 24px 50px;\n  color: #424242;\n  font-size: 14px;\n  background: rgba(0, 0, 0, 0);\n}\n.ant-layout-content {\n  flex: auto;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n}\n.ant-layout-sider {\n  position: relative;\n  /* fix firefox can't set width smaller than content on flex item */\n  min-width: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: all 0.2s;\n}\n.ant-layout-sider-children {\n  height: 100%;\n  margin-top: -0.1px;\n  padding-top: 0.1px;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 48px;\n}\n.ant-layout-sider-right {\n  order: 1;\n}\n.ant-layout-sider-trigger {\n  position: fixed;\n  bottom: 0;\n  z-index: 1;\n  height: 48px;\n  color: #fff;\n  line-height: 48px;\n  text-align: center;\n  background: #002140;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.ant-layout-sider-zero-width > * {\n  overflow: hidden;\n}\n.ant-layout-sider-zero-width-trigger {\n  position: absolute;\n  top: 64px;\n  right: -36px;\n  z-index: 1;\n  width: 36px;\n  height: 42px;\n  color: #fff;\n  font-size: 18px;\n  line-height: 42px;\n  text-align: center;\n  background: rgba(0, 0, 0, 0);\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-layout-sider-zero-width-trigger:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.ant-layout-sider-zero-width-trigger-right {\n  left: -36px;\n  border-radius: 4px 0 0 4px;\n}\n.ant-layout-sider-light {\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-trigger {\n  color: #424242;\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {\n  color: #424242;\n  background: #fff;\n}\n", ""]);

// exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(807);
module.exports = __webpack_require__(74).Object.assign;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(97);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(809) });


/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(100);
var getKeys = __webpack_require__(190);
var gOPS = __webpack_require__(281);
var pIE = __webpack_require__(193);
var toObject = __webpack_require__(160);
var IObject = __webpack_require__(415);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(130)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(111);
var toLength = __webpack_require__(416);
var toAbsoluteIndex = __webpack_require__(811);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(277);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var normalViewBox = '0 0 1024 1024';
var newViewBox = '64 64 896 896';
var fill = 'fill';
var outline = 'outline';
var twotone = 'twotone';
function getNode(viewBox) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    return {
        tag: 'svg',
        attrs: { viewBox: viewBox, focusable: false },
        children: paths.map(function (path) {
            if (Array.isArray(path)) {
                return {
                    tag: 'path',
                    attrs: {
                        fill: path[0],
                        d: path[1]
                    }
                };
            }
            return {
                tag: 'path',
                attrs: {
                    d: path
                }
            };
        })
    };
}
function getIcon(name, theme, icon) {
    return {
        name: name,
        theme: theme,
        icon: icon
    };
}
exports.AccountBookFill = getIcon('account-book', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.AlertFill = getIcon('alert', fill, getNode(newViewBox, 'M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z'));
exports.AlipaySquareFill = getIcon('alipay-square', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z'));
exports.AliwangwangFill = getIcon('aliwangwang', fill, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z'));
exports.AlipayCircleFill = getIcon('alipay-circle', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AmazonCircleFill = getIcon('amazon-circle', fill, getNode(newViewBox, 'M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z'));
exports.AndroidFill = getIcon('android', fill, getNode(newViewBox, 'M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z'));
exports.AmazonSquareFill = getIcon('amazon-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z'));
exports.ApiFill = getIcon('api', fill, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z'));
exports.AppstoreFill = getIcon('appstore', fill, getNode(newViewBox, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'));
exports.AudioFill = getIcon('audio', fill, getNode(newViewBox, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'));
exports.AppleFill = getIcon('apple', fill, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardFill = getIcon('backward', fill, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankFill = getIcon('bank', fill, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'));
exports.BehanceCircleFill = getIcon('behance-circle', fill, getNode(newViewBox, 'M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z'));
exports.BellFill = getIcon('bell', fill, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z'));
exports.BehanceSquareFill = getIcon('behance-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookFill = getIcon('book', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'));
exports.BoxPlotFill = getIcon('box-plot', fill, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z'));
exports.BugFill = getIcon('bug', fill, getNode(newViewBox, 'M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 0 0 123.2-149.5A120.4 120.4 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.CalculatorFill = getIcon('calculator', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z'));
exports.BulbFill = getIcon('bulb', fill, getNode(newViewBox, 'M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z'));
exports.BuildFill = getIcon('build', fill, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarFill = getIcon('calendar', fill, getNode(newViewBox, 'M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z'));
exports.CameraFill = getIcon('camera', fill, getNode(newViewBox, 'M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z'));
exports.CarFill = getIcon('car', fill, getNode(newViewBox, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z'));
exports.CaretDownFill = getIcon('caret-down', fill, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftFill = getIcon('caret-left', fill, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightFill = getIcon('caret-right', fill, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutFill = getIcon('carry-out', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.CaretUpFill = getIcon('caret-up', fill, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckCircleFill = getIcon('check-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'));
exports.CheckSquareFill = getIcon('check-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'));
exports.ChromeFill = getIcon('chrome', fill, getNode(newViewBox, 'M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z'));
exports.CiCircleFill = getIcon('ci-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'));
exports.ClockCircleFill = getIcon('clock-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'));
exports.CloseCircleFill = getIcon('close-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'));
exports.CloudFill = getIcon('cloud', fill, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloseSquareFill = getIcon('close-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z'));
exports.CodeSandboxSquareFill = getIcon('code-sandbox-square', fill, getNode(newViewBox, 'M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z'));
exports.CodeSandboxCircleFill = getIcon('code-sandbox-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z'));
exports.CodeFill = getIcon('code', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z'));
exports.CompassFill = getIcon('compass', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'));
exports.CodepenCircleFill = getIcon('codepen-circle', fill, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CodepenSquareFill = getIcon('codepen-square', fill, getNode(newViewBox, 'M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z'));
exports.ContactsFill = getIcon('contacts', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z'));
exports.ControlFill = getIcon('control', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z'));
exports.ContainerFill = getIcon('container', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z'));
exports.CopyFill = getIcon('copy', fill, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z'));
exports.CopyrightCircleFill = getIcon('copyright-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z'));
exports.CreditCardFill = getIcon('credit-card', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z'));
exports.CrownFill = getIcon('crown', fill, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z'));
exports.CustomerServiceFill = getIcon('customer-service', fill, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z'));
exports.DashboardFill = getIcon('dashboard', fill, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z'));
exports.DeleteFill = getIcon('delete', fill, getNode(newViewBox, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z'));
exports.DiffFill = getIcon('diff', fill, getNode(newViewBox, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z'));
exports.DingtalkCircleFill = getIcon('dingtalk-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DatabaseFill = getIcon('database', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'));
exports.DingtalkSquareFill = getIcon('dingtalk-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DislikeFill = getIcon('dislike', fill, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z'));
exports.DollarCircleFill = getIcon('dollar-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'));
exports.DownCircleFill = getIcon('down-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DownSquareFill = getIcon('down-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DribbbleCircleFill = getIcon('dribbble-circle', fill, getNode(newViewBox, 'M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z'));
exports.DribbbleSquareFill = getIcon('dribbble-square', fill, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.DropboxCircleFill = getIcon('dropbox-circle', fill, getNode(newViewBox, 'M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z'));
exports.DropboxSquareFill = getIcon('dropbox-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z'));
exports.EnvironmentFill = getIcon('environment', fill, getNode(newViewBox, 'M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.EditFill = getIcon('edit', fill, getNode(newViewBox, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z'));
exports.ExclamationCircleFill = getIcon('exclamation-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.EuroCircleFill = getIcon('euro-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z'));
exports.ExperimentFill = getIcon('experiment', fill, getNode(newViewBox, 'M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z'));
exports.EyeInvisibleFill = getIcon('eye-invisible', fill, getNode(newViewBox, 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z', 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'));
exports.EyeFill = getIcon('eye', fill, getNode(newViewBox, 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.FacebookFill = getIcon('facebook', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z'));
exports.FastBackwardFill = getIcon('fast-backward', fill, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardFill = getIcon('fast-forward', fill, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddFill = getIcon('file-add', fill, getNode(newViewBox, 'M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FileExcelFill = getIcon('file-excel', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z'));
exports.FileExclamationFill = getIcon('file-exclamation', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z'));
exports.FileImageFill = getIcon('file-image', fill, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z'));
exports.FileMarkdownFill = getIcon('file-markdown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z'));
exports.FilePdfFill = getIcon('file-pdf', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z'));
exports.FilePptFill = getIcon('file-ppt', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z'));
exports.FileTextFill = getIcon('file-text', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'));
exports.FileWordFill = getIcon('file-word', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z'));
exports.FileUnknownFill = getIcon('file-unknown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z'));
exports.FileZipFill = getIcon('file-zip', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z'));
exports.FileFill = getIcon('file', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FilterFill = getIcon('filter', fill, getNode(newViewBox, 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'));
exports.FireFill = getIcon('fire', fill, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z'));
exports.FlagFill = getIcon('flag', fill, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z'));
exports.FolderAddFill = getIcon('folder-add', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z'));
exports.FolderFill = getIcon('folder', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'));
exports.FolderOpenFill = getIcon('folder-open', fill, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'));
exports.ForwardFill = getIcon('forward', fill, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownFill = getIcon('frown', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FundFill = getIcon('fund', fill, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z'));
exports.FunnelPlotFill = getIcon('funnel-plot', fill, getNode(newViewBox, 'M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z'));
exports.GiftFill = getIcon('gift', fill, getNode(newViewBox, 'M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z'));
exports.GithubFill = getIcon('github', fill, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabFill = getIcon('gitlab', fill, getNode(newViewBox, 'M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z'));
exports.GoldenFill = getIcon('golden', fill, getNode(newViewBox, 'M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z'));
exports.GoogleCircleFill = getIcon('google-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.GooglePlusCircleFill = getIcon('google-plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GooglePlusSquareFill = getIcon('google-plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GoogleSquareFill = getIcon('google-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.HddFill = getIcon('hdd', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z'));
exports.HeartFill = getIcon('heart', fill, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z'));
exports.HighlightFill = getIcon('highlight', fill, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z'));
exports.HomeFill = getIcon('home', fill, getNode(newViewBox, 'M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z'));
exports.HourglassFill = getIcon('hourglass', fill, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z'));
exports.Html5Fill = getIcon('html5', fill, getNode(newViewBox, 'M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z'));
exports.IdcardFill = getIcon('idcard', fill, getNode(newViewBox, 'M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z'));
exports.IeCircleFill = getIcon('ie-circle', fill, getNode(newViewBox, 'M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.IeSquareFill = getIcon('ie-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.InfoCircleFill = getIcon('info-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.InstagramFill = getIcon('instagram', fill, getNode(newViewBox, 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z'));
exports.InsuranceFill = getIcon('insurance', fill, getNode(newViewBox, 'M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z'));
exports.InteractionFill = getIcon('interaction', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.InterationFill = getIcon('interation', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.LayoutFill = getIcon('layout', fill, getNode(newViewBox, 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'));
exports.LeftCircleFill = getIcon('left-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z'));
exports.LeftSquareFill = getIcon('left-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z'));
exports.LikeFill = getIcon('like', fill, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z'));
exports.LockFill = getIcon('lock', fill, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z'));
exports.LinkedinFill = getIcon('linkedin', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z'));
exports.MailFill = getIcon('mail', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z'));
exports.MedicineBoxFill = getIcon('medicine-box', fill, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z'));
exports.MediumCircleFill = getIcon('medium-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MediumSquareFill = getIcon('medium-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MehFill = getIcon('meh', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.MessageFill = getIcon('message', fill, getNode(newViewBox, 'M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z'));
exports.MinusCircleFill = getIcon('minus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MinusSquareFill = getIcon('minus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MobileFill = getIcon('mobile', fill, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.MoneyCollectFill = getIcon('money-collect', fill, getNode(newViewBox, 'M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z'));
exports.PauseCircleFill = getIcon('pause-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'));
exports.PayCircleFill = getIcon('pay-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z'));
exports.NotificationFill = getIcon('notification', fill, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z'));
exports.PhoneFill = getIcon('phone', fill, getNode(newViewBox, 'M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z'));
exports.PictureFill = getIcon('picture', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z'));
exports.PieChartFill = getIcon('pie-chart', fill, getNode(newViewBox, 'M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z'));
exports.PlayCircleFill = getIcon('play-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z'));
exports.PlaySquareFill = getIcon('play-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z'));
exports.PlusCircleFill = getIcon('plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PlusSquareFill = getIcon('plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PoundCircleFill = getIcon('pound-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z'));
exports.PrinterFill = getIcon('printer', fill, getNode(newViewBox, 'M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'));
exports.ProfileFill = getIcon('profile', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z'));
exports.ProjectFill = getIcon('project', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z'));
exports.PushpinFill = getIcon('pushpin', fill, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z'));
exports.PropertySafetyFill = getIcon('property-safety', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.QqCircleFill = getIcon('qq-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QqSquareFill = getIcon('qq-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QuestionCircleFill = getIcon('question-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'));
exports.ReadFill = getIcon('read', fill, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z'));
exports.ReconciliationFill = getIcon('reconciliation', fill, getNode(newViewBox, 'M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'));
exports.RedEnvelopeFill = getIcon('red-envelope', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z'));
exports.RedditCircleFill = getIcon('reddit-circle', fill, getNode(newViewBox, 'M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RedditSquareFill = getIcon('reddit-square', fill, getNode(newViewBox, 'M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RestFill = getIcon('rest', fill, getNode(newViewBox, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z'));
exports.RightCircleFill = getIcon('right-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.RocketFill = getIcon('rocket', fill, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z'));
exports.RightSquareFill = getIcon('right-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.SafetyCertificateFill = getIcon('safety-certificate', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SaveFill = getIcon('save', fill, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z'));
exports.ScheduleFill = getIcon('schedule', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SecurityScanFill = getIcon('security-scan', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z'));
exports.SettingFill = getIcon('setting', fill, getNode(newViewBox, 'M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z'));
exports.ShopFill = getIcon('shop', fill, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z'));
exports.ShoppingFill = getIcon('shopping', fill, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z'));
exports.SketchCircleFill = getIcon('sketch-circle', fill, getNode(newViewBox, 'M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z'));
exports.SketchSquareFill = getIcon('sketch-square', fill, getNode(newViewBox, 'M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z'));
exports.SkinFill = getIcon('skin', fill, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z'));
exports.SlackCircleFill = getIcon('slack-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlackSquareFill = getIcon('slack-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SkypeFill = getIcon('skype', fill, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z'));
exports.SlidersFill = getIcon('sliders', fill, getNode(newViewBox, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z'));
exports.SmileFill = getIcon('smile', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.SnippetsFill = getIcon('snippets', fill, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundFill = getIcon('sound', fill, getNode(newViewBox, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z'));
exports.StarFill = getIcon('star', fill, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z'));
exports.StepBackwardFill = getIcon('step-backward', fill, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardFill = getIcon('step-forward', fill, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopFill = getIcon('stop', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'));
exports.SwitcherFill = getIcon('switcher', fill, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'));
exports.TabletFill = getIcon('tablet', fill, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.TagFill = getIcon('tag', fill, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'));
exports.TagsFill = getIcon('tags', fill, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleFill = getIcon('taobao-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.TaobaoSquareFill = getIcon('taobao-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolFill = getIcon('tool', fill, getNode(newViewBox, 'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'));
exports.ThunderboltFill = getIcon('thunderbolt', fill, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z'));
exports.TrademarkCircleFill = getIcon('trademark-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'));
exports.TwitterCircleFill = getIcon('twitter-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.TrophyFill = getIcon('trophy', fill, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.TwitterSquareFill = getIcon('twitter-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.UnlockFill = getIcon('unlock', fill, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z'));
exports.UpCircleFill = getIcon('up-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UpSquareFill = getIcon('up-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UsbFill = getIcon('usb', fill, getNode(newViewBox, 'M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletFill = getIcon('wallet', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.VideoCameraFill = getIcon('video-camera', fill, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z'));
exports.WarningFill = getIcon('warning', fill, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.WeiboCircleFill = getIcon('weibo-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WechatFill = getIcon('wechat', fill, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WindowsFill = getIcon('windows', fill, getNode(newViewBox, 'M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z'));
exports.YahooFill = getIcon('yahoo', fill, getNode(newViewBox, 'M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z'));
exports.WeiboSquareFill = getIcon('weibo-square', fill, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueFill = getIcon('yuque', fill, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z'));
exports.YoutubeFill = getIcon('youtube', fill, getNode(newViewBox, 'M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'));
exports.ZhihuSquareFill = getIcon('zhihu-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.ZhihuCircleFill = getIcon('zhihu-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.AccountBookOutline = getIcon('account-book', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'));
exports.AlertOutline = getIcon('alert', outline, getNode(newViewBox, 'M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z'));
exports.AlipayCircleOutline = getIcon('alipay-circle', outline, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AliwangwangOutline = getIcon('aliwangwang', outline, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z'));
exports.AndroidOutline = getIcon('android', outline, getNode(newViewBox, 'M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z'));
exports.ApiOutline = getIcon('api', outline, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z'));
exports.AppstoreOutline = getIcon('appstore', outline, getNode(newViewBox, 'M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'));
exports.AudioOutline = getIcon('audio', outline, getNode(newViewBox, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z'));
exports.AppleOutline = getIcon('apple', outline, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardOutline = getIcon('backward', outline, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankOutline = getIcon('bank', outline, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z'));
exports.BellOutline = getIcon('bell', outline, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z'));
exports.BehanceSquareOutline = getIcon('behance-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookOutline = getIcon('book', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'));
exports.BoxPlotOutline = getIcon('box-plot', outline, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z'));
exports.BulbOutline = getIcon('bulb', outline, getNode(newViewBox, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'));
exports.BugOutline = getIcon('bug', outline, getNode(newViewBox, 'M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 0 0 123.2-149.5A120 120 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 0 1 308 680V412h408v268z'));
exports.CalculatorOutline = getIcon('calculator', outline, getNode(newViewBox, 'M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z'));
exports.BuildOutline = getIcon('build', outline, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarOutline = getIcon('calendar', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'));
exports.CameraOutline = getIcon('camera', outline, getNode(newViewBox, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'));
exports.CarOutline = getIcon('car', outline, getNode(newViewBox, 'M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CaretDownOutline = getIcon('caret-down', outline, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftOutline = getIcon('caret-left', outline, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightOutline = getIcon('caret-right', outline, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutOutline = getIcon('carry-out', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'));
exports.CheckCircleOutline = getIcon('check-circle', outline, getNode(newViewBox, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CaretUpOutline = getIcon('caret-up', outline, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckSquareOutline = getIcon('check-square', outline, getNode(newViewBox, 'M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ChromeOutline = getIcon('chrome', outline, getNode(newViewBox, 'M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z'));
exports.ClockCircleOutline = getIcon('clock-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'));
exports.CloseCircleOutline = getIcon('close-circle', outline, getNode(newViewBox, 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z', 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CloudOutline = getIcon('cloud', outline, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'));
exports.CloseSquareOutline = getIcon('close-square', outline, getNode(newViewBox, 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodeOutline = getIcon('code', outline, getNode(newViewBox, 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodepenCircleOutline = getIcon('codepen-circle', outline, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CompassOutline = getIcon('compass', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z'));
exports.ContactsOutline = getIcon('contacts', outline, getNode(newViewBox, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'));
exports.ContainerOutline = getIcon('container', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.ControlOutline = getIcon('control', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z'));
exports.CopyOutline = getIcon('copy', outline, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'));
exports.CreditCardOutline = getIcon('credit-card', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'));
exports.CrownOutline = getIcon('crown', outline, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z'));
exports.CustomerServiceOutline = getIcon('customer-service', outline, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'));
exports.DashboardOutline = getIcon('dashboard', outline, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'));
exports.DeleteOutline = getIcon('delete', outline, getNode(newViewBox, 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'));
exports.DiffOutline = getIcon('diff', outline, getNode(newViewBox, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'));
exports.DatabaseOutline = getIcon('database', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.DislikeOutline = getIcon('dislike', outline, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'));
exports.DownCircleOutline = getIcon('down-circle', outline, getNode(newViewBox, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.DownSquareOutline = getIcon('down-square', outline, getNode(newViewBox, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.DribbbleSquareOutline = getIcon('dribbble-square', outline, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.EnvironmentOutline = getIcon('environment', outline, getNode(newViewBox, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'));
exports.EditOutline = getIcon('edit', outline, getNode(newViewBox, 'M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z'));
exports.ExclamationCircleOutline = getIcon('exclamation-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'));
exports.ExperimentOutline = getIcon('experiment', outline, getNode(newViewBox, 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z'));
exports.EyeInvisibleOutline = getIcon('eye-invisible', outline, getNode(newViewBox, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z', 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'));
exports.EyeOutline = getIcon('eye', outline, getNode(newViewBox, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FacebookOutline = getIcon('facebook', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'));
exports.FastBackwardOutline = getIcon('fast-backward', outline, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardOutline = getIcon('fast-forward', outline, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddOutline = getIcon('file-add', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'));
exports.FileExcelOutline = getIcon('file-excel', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'));
exports.FileExclamationOutline = getIcon('file-exclamation', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z'));
exports.FileImageOutline = getIcon('file-image', outline, getNode(newViewBox, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileMarkdownOutline = getIcon('file-markdown', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'));
exports.FilePptOutline = getIcon('file-ppt', outline, getNode(newViewBox, 'M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileTextOutline = getIcon('file-text', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'));
exports.FilePdfOutline = getIcon('file-pdf', outline, getNode(newViewBox, 'M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileZipOutline = getIcon('file-zip', outline, getNode(newViewBox, 'M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'));
exports.FileOutline = getIcon('file', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FilterOutline = getIcon('filter', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'));
exports.FileWordOutline = getIcon('file-word', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'));
exports.FireOutline = getIcon('fire', outline, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'));
exports.FileUnknownOutline = getIcon('file-unknown', outline, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z'));
exports.FlagOutline = getIcon('flag', outline, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'));
exports.FolderAddOutline = getIcon('folder-add', outline, getNode(newViewBox, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOutline = getIcon('folder', outline, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOpenOutline = getIcon('folder-open', outline, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'));
exports.ForwardOutline = getIcon('forward', outline, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownOutline = getIcon('frown', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z'));
exports.FundOutline = getIcon('fund', outline, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'));
exports.FunnelPlotOutline = getIcon('funnel-plot', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'));
exports.GiftOutline = getIcon('gift', outline, getNode(newViewBox, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z'));
exports.GithubOutline = getIcon('github', outline, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabOutline = getIcon('gitlab', outline, getNode(newViewBox, 'M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z'));
exports.HeartOutline = getIcon('heart', outline, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'));
exports.HddOutline = getIcon('hdd', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.HighlightOutline = getIcon('highlight', outline, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z'));
exports.HomeOutline = getIcon('home', outline, getNode(newViewBox, 'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'));
exports.HourglassOutline = getIcon('hourglass', outline, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'));
exports.Html5Outline = getIcon('html5', outline, getNode(newViewBox, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'));
exports.IdcardOutline = getIcon('idcard', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'));
exports.InfoCircleOutline = getIcon('info-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'));
exports.InstagramOutline = getIcon('instagram', outline, getNode(newViewBox, 'M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z'));
exports.InsuranceOutline = getIcon('insurance', outline, getNode(newViewBox, 'M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'));
exports.InteractionOutline = getIcon('interaction', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.InterationOutline = getIcon('interation', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.LayoutOutline = getIcon('layout', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z'));
exports.LeftCircleOutline = getIcon('left-circle', outline, getNode(newViewBox, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.LeftSquareOutline = getIcon('left-square', outline, getNode(newViewBox, 'M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.LikeOutline = getIcon('like', outline, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z'));
exports.LinkedinOutline = getIcon('linkedin', outline, getNode(newViewBox, 'M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z'));
exports.LockOutline = getIcon('lock', outline, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.MedicineBoxOutline = getIcon('medicine-box', outline, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MehOutline = getIcon('meh', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MailOutline = getIcon('mail', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'));
exports.MessageOutline = getIcon('message', outline, getNode(newViewBox, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'));
exports.MinusCircleOutline = getIcon('minus-circle', outline, getNode(newViewBox, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.MinusSquareOutline = getIcon('minus-square', outline, getNode(newViewBox, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.MobileOutline = getIcon('mobile', outline, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.MoneyCollectOutline = getIcon('money-collect', outline, getNode(newViewBox, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z'));
exports.PauseCircleOutline = getIcon('pause-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'));
exports.PayCircleOutline = getIcon('pay-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z'));
exports.NotificationOutline = getIcon('notification', outline, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'));
exports.PhoneOutline = getIcon('phone', outline, getNode(newViewBox, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'));
exports.PictureOutline = getIcon('picture', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'));
exports.PieChartOutline = getIcon('pie-chart', outline, getNode(newViewBox, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'));
exports.PlaySquareOutline = getIcon('play-square', outline, getNode(newViewBox, 'M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PlayCircleOutline = getIcon('play-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'));
exports.PlusCircleOutline = getIcon('plus-circle', outline, getNode(newViewBox, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.PrinterOutline = getIcon('printer', outline, getNode(newViewBox, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'));
exports.PlusSquareOutline = getIcon('plus-square', outline, getNode(newViewBox, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ProfileOutline = getIcon('profile', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ProjectOutline = getIcon('project', outline, getNode(newViewBox, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PushpinOutline = getIcon('pushpin', outline, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'));
exports.PropertySafetyOutline = getIcon('property-safety', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z'));
exports.QuestionCircleOutline = getIcon('question-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ReadOutline = getIcon('read', outline, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z'));
exports.ReconciliationOutline = getIcon('reconciliation', outline, getNode(newViewBox, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.RedEnvelopeOutline = getIcon('red-envelope', outline, getNode(newViewBox, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'));
exports.RestOutline = getIcon('rest', outline, getNode(newViewBox, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z', 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'));
exports.RightCircleOutline = getIcon('right-circle', outline, getNode(newViewBox, 'M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.RocketOutline = getIcon('rocket', outline, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'));
exports.RightSquareOutline = getIcon('right-square', outline, getNode(newViewBox, 'M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.SafetyCertificateOutline = getIcon('safety-certificate', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'));
exports.ScheduleOutline = getIcon('schedule', outline, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z'));
exports.SaveOutline = getIcon('save', outline, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'));
exports.SecurityScanOutline = getIcon('security-scan', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z'));
exports.SettingOutline = getIcon('setting', outline, getNode(newViewBox, 'M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z'));
exports.ShoppingOutline = getIcon('shopping', outline, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'));
exports.SkinOutline = getIcon('skin', outline, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'));
exports.SkypeOutline = getIcon('skype', outline, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z'));
exports.SlackSquareOutline = getIcon('slack-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlidersOutline = getIcon('sliders', outline, getNode(newViewBox, 'M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z'));
exports.SmileOutline = getIcon('smile', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z'));
exports.SnippetsOutline = getIcon('snippets', outline, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundOutline = getIcon('sound', outline, getNode(newViewBox, 'M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z'));
exports.StarOutline = getIcon('star', outline, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z'));
exports.StepBackwardOutline = getIcon('step-backward', outline, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardOutline = getIcon('step-forward', outline, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopOutline = getIcon('stop', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'));
exports.SwitcherOutline = getIcon('switcher', outline, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z'));
exports.TagOutline = getIcon('tag', outline, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'));
exports.TabletOutline = getIcon('tablet', outline, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ShopOutline = getIcon('shop', outline, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'));
exports.TagsOutline = getIcon('tags', outline, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleOutline = getIcon('taobao-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolOutline = getIcon('tool', outline, getNode(newViewBox, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'));
exports.ThunderboltOutline = getIcon('thunderbolt', outline, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z'));
exports.TrophyOutline = getIcon('trophy', outline, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.UnlockOutline = getIcon('unlock', outline, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.UpCircleOutline = getIcon('up-circle', outline, getNode(newViewBox, 'M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.UpSquareOutline = getIcon('up-square', outline, getNode(newViewBox, 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.UsbOutline = getIcon('usb', outline, getNode(newViewBox, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.VideoCameraOutline = getIcon('video-camera', outline, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletOutline = getIcon('wallet', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.WarningOutline = getIcon('warning', outline, getNode(newViewBox, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'));
exports.WechatOutline = getIcon('wechat', outline, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WeiboCircleOutline = getIcon('weibo-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WindowsOutline = getIcon('windows', outline, getNode(newViewBox, 'M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z'));
exports.YahooOutline = getIcon('yahoo', outline, getNode(newViewBox, 'M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z'));
exports.WeiboSquareOutline = getIcon('weibo-square', outline, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueOutline = getIcon('yuque', outline, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z'));
exports.YoutubeOutline = getIcon('youtube', outline, getNode(newViewBox, 'M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'));
exports.AlibabaOutline = getIcon('alibaba', outline, getNode(newViewBox, 'M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z'));
exports.AlignCenterOutline = getIcon('align-center', outline, getNode(newViewBox, 'M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignLeftOutline = getIcon('align-left', outline, getNode(newViewBox, 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignRightOutline = getIcon('align-right', outline, getNode(newViewBox, 'M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlipayOutline = getIcon('alipay', outline, getNode(newViewBox, 'M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z'));
exports.AliyunOutline = getIcon('aliyun', outline, getNode(newViewBox, 'M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z'));
exports.AmazonOutline = getIcon('amazon', outline, getNode(newViewBox, 'M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z'));
exports.AntCloudOutline = getIcon('ant-cloud', outline, getNode(newViewBox, 'M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z'));
exports.ApartmentOutline = getIcon('apartment', outline, getNode(newViewBox, 'M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z'));
exports.AntDesignOutline = getIcon('ant-design', outline, getNode(newViewBox, 'M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z'));
exports.AreaChartOutline = getIcon('area-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'));
exports.ArrowLeftOutline = getIcon('arrow-left', outline, getNode(newViewBox, 'M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.ArrowDownOutline = getIcon('arrow-down', outline, getNode(newViewBox, 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'));
exports.ArrowUpOutline = getIcon('arrow-up', outline, getNode(newViewBox, 'M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z'));
exports.ArrowsAltOutline = getIcon('arrows-alt', outline, getNode(newViewBox, 'M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z'));
exports.ArrowRightOutline = getIcon('arrow-right', outline, getNode(newViewBox, 'M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z'));
exports.AuditOutline = getIcon('audit', outline, getNode(newViewBox, 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'));
exports.BarChartOutline = getIcon('bar-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'));
exports.BarcodeOutline = getIcon('barcode', outline, getNode(newViewBox, 'M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.BarsOutline = getIcon('bars', outline, getNode(normalViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.BgColorsOutline = getIcon('bg-colors', outline, getNode(newViewBox, 'M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z'));
exports.BehanceOutline = getIcon('behance', outline, getNode(newViewBox, 'M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z'));
exports.BlockOutline = getIcon('block', outline, getNode(newViewBox, 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'));
exports.BoldOutline = getIcon('bold', outline, getNode(newViewBox, 'M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z'));
exports.BorderBottomOutline = getIcon('border-bottom', outline, getNode(newViewBox, 'M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderLeftOutline = getIcon('border-left', outline, getNode(newViewBox, 'M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOuterOutline = getIcon('border-outer', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderInnerOutline = getIcon('border-inner', outline, getNode(newViewBox, 'M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderRightOutline = getIcon('border-right', outline, getNode(newViewBox, 'M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderHorizontalOutline = getIcon('border-horizontal', outline, getNode(newViewBox, 'M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderTopOutline = getIcon('border-top', outline, getNode(newViewBox, 'M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderVerticleOutline = getIcon('border-verticle', outline, getNode(newViewBox, 'M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOutline = getIcon('border', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.BranchesOutline = getIcon('branches', outline, getNode(newViewBox, 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.CheckOutline = getIcon('check', outline, getNode(newViewBox, 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'));
exports.CiOutline = getIcon('ci', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'));
exports.CloseOutline = getIcon('close', outline, getNode(newViewBox, 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'));
exports.CloudDownloadOutline = getIcon('cloud-download', outline, getNode(newViewBox, 'M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloudServerOutline = getIcon('cloud-server', outline, getNode(newViewBox, 'M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z', 'M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z', 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z'));
exports.CloudSyncOutline = getIcon('cloud-sync', outline, getNode(newViewBox, 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z', 'M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z'));
exports.CloudUploadOutline = getIcon('cloud-upload', outline, getNode(newViewBox, 'M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.ClusterOutline = getIcon('cluster', outline, getNode(newViewBox, 'M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CodepenOutline = getIcon('codepen', outline, getNode(newViewBox, 'M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z'));
exports.CodeSandboxOutline = getIcon('code-sandbox', outline, getNode(newViewBox, 'M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z'));
exports.ColumHeightOutline = getIcon('colum-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.ColumnWidthOutline = getIcon('column-width', outline, getNode(newViewBox, 'M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z'));
exports.ColumnHeightOutline = getIcon('column-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.CoffeeOutline = getIcon('coffee', outline, getNode(normalViewBox, 'M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z'));
exports.CopyrightOutline = getIcon('copyright', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'));
exports.DashOutline = getIcon('dash', outline, getNode(newViewBox, 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z'));
exports.DeploymentUnitOutline = getIcon('deployment-unit', outline, getNode(newViewBox, 'M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z'));
exports.DesktopOutline = getIcon('desktop', outline, getNode(newViewBox, 'M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z'));
exports.DingdingOutline = getIcon('dingding', outline, getNode(newViewBox, 'M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z'));
exports.DisconnectOutline = getIcon('disconnect', outline, getNode(newViewBox, 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'));
exports.DollarOutline = getIcon('dollar', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'));
exports.DoubleRightOutline = getIcon('double-right', outline, getNode(newViewBox, 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'));
exports.DotChartOutline = getIcon('dot-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.DoubleLeftOutline = getIcon('double-left', outline, getNode(newViewBox, 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'));
exports.DownloadOutline = getIcon('download', outline, getNode(newViewBox, 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.DribbbleOutline = getIcon('dribbble', outline, getNode(newViewBox, 'M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z'));
exports.DropboxOutline = getIcon('dropbox', outline, getNode(newViewBox, 'M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z'));
exports.EllipsisOutline = getIcon('ellipsis', outline, getNode(newViewBox, 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.EnterOutline = getIcon('enter', outline, getNode(newViewBox, 'M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z'));
exports.EuroOutline = getIcon('euro', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z'));
exports.ExceptionOutline = getIcon('exception', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ExclamationOutline = getIcon('exclamation', outline, getNode(newViewBox, 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.ExportOutline = getIcon('export', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.FallOutline = getIcon('fall', outline, getNode(newViewBox, 'M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z'));
exports.FileDoneOutline = getIcon('file-done', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.FileSyncOutline = getIcon('file-sync', outline, getNode(newViewBox, 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z'));
exports.FileProtectOutline = getIcon('file-protect', outline, getNode(newViewBox, 'M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z'));
exports.FileSearchOutline = getIcon('file-search', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FileJpgOutline = getIcon('file-jpg', outline, getNode(normalViewBox, 'M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z'));
exports.FontColorsOutline = getIcon('font-colors', outline, getNode(newViewBox, 'M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z'));
exports.FontSizeOutline = getIcon('font-size', outline, getNode(newViewBox, 'M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z'));
exports.ForkOutline = getIcon('fork', outline, getNode(newViewBox, 'M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FormOutline = getIcon('form', outline, getNode(newViewBox, 'M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z', 'M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z'));
exports.FullscreenExitOutline = getIcon('fullscreen-exit', outline, getNode(newViewBox, 'M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z'));
exports.FullscreenOutline = getIcon('fullscreen', outline, getNode(newViewBox, 'M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z'));
exports.GatewayOutline = getIcon('gateway', outline, getNode(newViewBox, 'M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z'));
exports.DownOutline = getIcon('down', outline, getNode(newViewBox, 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'));
exports.DragOutline = getIcon('drag', outline, getNode(newViewBox, 'M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z'));
exports.GlobalOutline = getIcon('global', outline, getNode(newViewBox, 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'));
exports.GooglePlusOutline = getIcon('google-plus', outline, getNode(newViewBox, 'M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z'));
exports.GoogleOutline = getIcon('google', outline, getNode(newViewBox, 'M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z'));
exports.HeatMapOutline = getIcon('heat-map', outline, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z'));
exports.GoldOutline = getIcon('gold', outline, getNode(newViewBox, 'M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z'));
exports.HistoryOutline = getIcon('history', outline, getNode(newViewBox, 'M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z'));
exports.IeOutline = getIcon('ie', outline, getNode(newViewBox, 'M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z'));
exports.InboxOutline = getIcon('inbox', outline, getNode(normalViewBox, 'M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z'));
exports.ImportOutline = getIcon('import', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.InfoOutline = getIcon('info', outline, getNode(newViewBox, 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'));
exports.ItalicOutline = getIcon('italic', outline, getNode(newViewBox, 'M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.IssuesCloseOutline = getIcon('issues-close', outline, getNode(newViewBox, 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z'));
exports.KeyOutline = getIcon('key', outline, getNode(newViewBox, 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z'));
exports.LaptopOutline = getIcon('laptop', outline, getNode(newViewBox, 'M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z'));
exports.LeftOutline = getIcon('left', outline, getNode(newViewBox, 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'));
exports.LinkOutline = getIcon('link', outline, getNode(newViewBox, 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'));
exports.LineChartOutline = getIcon('line-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'));
exports.LineHeightOutline = getIcon('line-height', outline, getNode(newViewBox, 'M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z'));
exports.LineOutline = getIcon('line', outline, getNode(newViewBox, 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.Loading3QuartersOutline = getIcon('loading-3-quarters', outline, getNode(normalViewBox, 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z'));
exports.LoadingOutline = getIcon('loading', outline, getNode(normalViewBox, 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'));
exports.LoginOutline = getIcon('login', outline, getNode(newViewBox, 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'));
exports.LogoutOutline = getIcon('logout', outline, getNode(newViewBox, 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.ManOutline = getIcon('man', outline, getNode(newViewBox, 'M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'));
exports.MediumOutline = getIcon('medium', outline, getNode(newViewBox, 'M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z'));
exports.MediumWorkmarkOutline = getIcon('medium-workmark', outline, getNode(normalViewBox, 'M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z'));
exports.MenuUnfoldOutline = getIcon('menu-unfold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'));
exports.MenuFoldOutline = getIcon('menu-fold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'));
exports.MenuOutline = getIcon('menu', outline, getNode(newViewBox, 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.MinusOutline = getIcon('minus', outline, getNode(newViewBox, 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.MonitorOutline = getIcon('monitor', outline, getNode(newViewBox, 'M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z'));
exports.MoreOutline = getIcon('more', outline, getNode(newViewBox, 'M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.OrderedListOutline = getIcon('ordered-list', outline, getNode(newViewBox, 'M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z'));
exports.NumberOutline = getIcon('number', outline, getNode(newViewBox, 'M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z'));
exports.PauseOutline = getIcon('pause', outline, getNode(newViewBox, 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'));
exports.PercentageOutline = getIcon('percentage', outline, getNode(newViewBox, 'M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z'));
exports.PaperClipOutline = getIcon('paper-clip', outline, getNode(newViewBox, 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'));
exports.PicCenterOutline = getIcon('pic-center', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z'));
exports.PicLeftOutline = getIcon('pic-left', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PlusOutline = getIcon('plus', outline, getNode(newViewBox, 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z', 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'));
exports.PicRightOutline = getIcon('pic-right', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PoundOutline = getIcon('pound', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'));
exports.PoweroffOutline = getIcon('poweroff', outline, getNode(newViewBox, 'M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.PullRequestOutline = getIcon('pull-request', outline, getNode(newViewBox, 'M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z'));
exports.QqOutline = getIcon('qq', outline, getNode(newViewBox, 'M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z'));
exports.QuestionOutline = getIcon('question', outline, getNode(newViewBox, 'M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'));
exports.RadarChartOutline = getIcon('radar-chart', outline, getNode(newViewBox, 'M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z'));
exports.QrcodeOutline = getIcon('qrcode', outline, getNode(newViewBox, 'M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomleftOutline = getIcon('radius-bottomleft', outline, getNode(newViewBox, 'M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomrightOutline = getIcon('radius-bottomright', outline, getNode(newViewBox, 'M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z'));
exports.RadiusUpleftOutline = getIcon('radius-upleft', outline, getNode(newViewBox, 'M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusUprightOutline = getIcon('radius-upright', outline, getNode(newViewBox, 'M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z'));
exports.RadiusSettingOutline = getIcon('radius-setting', outline, getNode(newViewBox, 'M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z'));
exports.RedditOutline = getIcon('reddit', outline, getNode(newViewBox, 'M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.RedoOutline = getIcon('redo', outline, getNode(newViewBox, 'M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z'));
exports.ReloadOutline = getIcon('reload', outline, getNode(newViewBox, 'M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z'));
exports.RetweetOutline = getIcon('retweet', outline, getNode(normalViewBox, 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'));
exports.RightOutline = getIcon('right', outline, getNode(newViewBox, 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'));
exports.RiseOutline = getIcon('rise', outline, getNode(newViewBox, 'M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z'));
exports.RollbackOutline = getIcon('rollback', outline, getNode(newViewBox, 'M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z'));
exports.SafetyOutline = getIcon('safety', outline, getNode(normalViewBox, 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z', 'M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z'));
exports.RobotOutline = getIcon('robot', outline, getNode(newViewBox, 'M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SearchOutline = getIcon('search', outline, getNode(newViewBox, 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'));
exports.ScanOutline = getIcon('scan', outline, getNode(newViewBox, 'M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ScissorOutline = getIcon('scissor', outline, getNode(newViewBox, 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'));
exports.SelectOutline = getIcon('select', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z'));
exports.ShakeOutline = getIcon('shake', outline, getNode(newViewBox, 'M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z'));
exports.ShareAltOutline = getIcon('share-alt', outline, getNode(newViewBox, 'M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z'));
exports.ShoppingCartOutline = getIcon('shopping-cart', outline, getNode(normalViewBox, 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z'));
exports.ShrinkOutline = getIcon('shrink', outline, getNode(newViewBox, 'M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z'));
exports.SlackOutline = getIcon('slack', outline, getNode(newViewBox, 'M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 0 0-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z'));
exports.SmallDashOutline = getIcon('small-dash', outline, getNode(newViewBox, 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'));
exports.SolutionOutline = getIcon('solution', outline, getNode(newViewBox, 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'));
exports.SketchOutline = getIcon('sketch', outline, getNode(newViewBox, 'M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z'));
exports.SortDescendingOutline = getIcon('sort-descending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z'));
exports.SortAscendingOutline = getIcon('sort-ascending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z'));
exports.StockOutline = getIcon('stock', outline, getNode(newViewBox, 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'));
exports.SwapLeftOutline = getIcon('swap-left', outline, getNode(normalViewBox, 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SwapRightOutline = getIcon('swap-right', outline, getNode(normalViewBox, 'M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z'));
exports.StrikethroughOutline = getIcon('strikethrough', outline, getNode(newViewBox, 'M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z'));
exports.SwapOutline = getIcon('swap', outline, getNode(newViewBox, 'M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SyncOutline = getIcon('sync', outline, getNode(newViewBox, 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'));
exports.TableOutline = getIcon('table', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'));
exports.TeamOutline = getIcon('team', outline, getNode(newViewBox, 'M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z'));
exports.TaobaoOutline = getIcon('taobao', outline, getNode(newViewBox, 'M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z'));
exports.ToTopOutline = getIcon('to-top', outline, getNode(newViewBox, 'M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z'));
exports.TrademarkOutline = getIcon('trademark', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z'));
exports.TransactionOutline = getIcon('transaction', outline, getNode(newViewBox, 'M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z'));
exports.TwitterOutline = getIcon('twitter', outline, getNode(newViewBox, 'M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z'));
exports.UnderlineOutline = getIcon('underline', outline, getNode(newViewBox, 'M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z'));
exports.UndoOutline = getIcon('undo', outline, getNode(newViewBox, 'M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z'));
exports.UnorderedListOutline = getIcon('unordered-list', outline, getNode(newViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.UpOutline = getIcon('up', outline, getNode(newViewBox, 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'));
exports.UploadOutline = getIcon('upload', outline, getNode(newViewBox, 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.UserAddOutline = getIcon('user-add', outline, getNode(newViewBox, 'M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupAddOutline = getIcon('usergroup-add', outline, getNode(newViewBox, 'M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.UserOutline = getIcon('user', outline, getNode(newViewBox, 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'));
exports.UserDeleteOutline = getIcon('user-delete', outline, getNode(newViewBox, 'M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupDeleteOutline = getIcon('usergroup-delete', outline, getNode(newViewBox, 'M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.VerticalAlignBottomOutline = getIcon('vertical-align-bottom', outline, getNode(newViewBox, 'M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z'));
exports.VerticalAlignMiddleOutline = getIcon('vertical-align-middle', outline, getNode(newViewBox, 'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'));
exports.VerticalAlignTopOutline = getIcon('vertical-align-top', outline, getNode(newViewBox, 'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z'));
exports.VerticalRightOutline = getIcon('vertical-right', outline, getNode(newViewBox, 'M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z'));
exports.VerticalLeftOutline = getIcon('vertical-left', outline, getNode(newViewBox, 'M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z'));
exports.WifiOutline = getIcon('wifi', outline, getNode(newViewBox, 'M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z'));
exports.ZhihuOutline = getIcon('zhihu', outline, getNode(newViewBox, 'M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z'));
exports.WeiboOutline = getIcon('weibo', outline, getNode(newViewBox, 'M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z'));
exports.WomanOutline = getIcon('woman', outline, getNode(newViewBox, 'M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z'));
exports.ZoomInOutline = getIcon('zoom-in', outline, getNode(newViewBox, 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AccountBookTwoTone = getIcon('account-book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z'
    ], [
        primaryColor,
        'M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ]);
});
exports.ZoomOutOutline = getIcon('zoom-out', outline, getNode(newViewBox, 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AlertTwoTone = getIcon('alert', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z'
    ], [
        primaryColor,
        'M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z'
    ]);
});
exports.ApiTwoTone = getIcon('api', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z'
    ], [
        primaryColor,
        'M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z'
    ]);
});
exports.AppstoreTwoTone = getIcon('appstore', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'
    ], [
        secondaryColor,
        'M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z'
    ]);
});
exports.BankTwoTone = getIcon('bank', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M240.9 393.9h542.2L512 196.7z'], [
        primaryColor,
        'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z'
    ]);
});
exports.AudioTwoTone = getIcon('audio', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z'
    ], [
        primaryColor,
        'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'
    ], [
        primaryColor,
        'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z'
    ]);
});
exports.BellTwoTone = getIcon('bell', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z'
    ], [
        primaryColor,
        'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z'
    ]);
});
exports.BookTwoTone = getIcon('book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'
    ], [secondaryColor, 'M668 345.9V136h-96v211.4l49.5-35.4z'], [
        secondaryColor,
        'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z'
    ]);
});
exports.BoxPlotTwoTone = getIcon('box-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M296 368h88v288h-88zm152 0h280v288H448z'], [
        primaryColor,
        'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z'
    ]);
});
exports.BugTwoTone = getIcon('bug', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 0 1-22.66 49.02 281.39 281.39 0 0 1-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 0 1-100.45-100.45 278.63 278.63 0 0 1-22.66-49.02A119.95 119.95 0 0 0 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8 63 63 0 0 0 63 63h560a63 63 0 0 0 63-63 8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.77-62.23 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0 1 74.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0 1 74.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 0 0-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 0 0-45.4 45.39C373.95 218.85 368 243.67 368 272z'
    ], [
        secondaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308z'
    ]);
});
exports.BulbTwoTone = getIcon('bulb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z'
    ], [
        primaryColor,
        'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'
    ]);
});
exports.CalculatorTwoTone = getIcon('calculator', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z'
    ], [
        primaryColor,
        'M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z'
    ]);
});
exports.BuildTwoTone = getIcon('build', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M144 546h200v200H144zm268-268h200v200H412z'], [
        primaryColor,
        'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z'
    ]);
});
exports.CalendarTwoTone = getIcon('calendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});
exports.CameraTwoTone = getIcon('camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z'
    ], [
        primaryColor,
        'M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'
    ], [
        primaryColor,
        'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z'
    ]);
});
exports.CarTwoTone = getIcon('car', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [primaryColor, 'M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        primaryColor,
        'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z'
    ], [
        primaryColor,
        'M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z'
    ]);
});
exports.CarryOutTwoTone = getIcon('carry-out', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ], [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z'
    ], [
        primaryColor,
        'M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'
    ]);
});
exports.CheckCircleTwoTone = getIcon('check-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.CheckSquareTwoTone = getIcon('check-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z'
    ]);
});
exports.ClockCircleTwoTone = getIcon('clock-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'
    ], [
        primaryColor,
        'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z'
    ]);
});
exports.CloseCircleTwoTone = getIcon('close-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'
    ], [
        primaryColor,
        'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
    ]);
});
exports.CloudTwoTone = getIcon('cloud', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z'
    ], [
        primaryColor,
        'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'
    ]);
});
exports.CloseSquareTwoTone = getIcon('close-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'
    ], [
        primaryColor,
        'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z'
    ]);
});
exports.CodeTwoTone = getIcon('code', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z'
    ], [
        primaryColor,
        'M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z'
    ]);
});
exports.CompassTwoTone = getIcon('compass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'
    ], [
        primaryColor,
        'M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ]);
});
exports.ContactsTwoTone = getIcon('contacts', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z'
    ], [
        primaryColor,
        'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ]);
});
exports.ContainerTwoTone = getIcon('container', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z'
    ], [
        primaryColor,
        'M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z'
    ], [
        primaryColor,
        'M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ControlTwoTone = getIcon('control', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z'
    ], [
        primaryColor,
        'M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z'
    ]);
});
exports.CopyTwoTone = getIcon('copy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z'], [
        primaryColor,
        'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'
    ]);
});
exports.CreditCardTwoTone = getIcon('credit-card', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z'
    ], [
        primaryColor,
        'M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z'
    ]);
});
exports.CrownTwoTone = getIcon('crown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z'
    ], [
        secondaryColor,
        'M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z'
    ], [
        primaryColor,
        'M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z'
    ], [
        primaryColor,
        'M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z'
    ]);
});
exports.CustomerServiceTwoTone = getIcon('customer-service', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M696 632h128v192H696zm-496 0h128v192H200z'], [
        primaryColor,
        'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'
    ]);
});
exports.DashboardTwoTone = getIcon('dashboard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z'
    ], [
        primaryColor,
        'M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'
    ]);
});
exports.DeleteTwoTone = getIcon('delete', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M292.7 840h438.6l24.2-512h-487z'], [
        primaryColor,
        'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z'
    ]);
});
exports.DiffTwoTone = getIcon('diff', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z'
    ], [
        primaryColor,
        'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'
    ], [
        primaryColor,
        'M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z'
    ], [
        primaryColor,
        'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z'
    ]);
});
exports.DatabaseTwoTone = getIcon('database', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ]);
});
exports.DislikeTwoTone = getIcon('dislike', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z'
    ], [
        primaryColor,
        'M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'
    ]);
});
exports.DownCircleTwoTone = getIcon('down-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.DownSquareTwoTone = getIcon('down-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z'
    ]);
});
exports.EnvironmentTwoTone = getIcon('environment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'
    ], [
        primaryColor,
        'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z'
    ]);
});
exports.EditTwoTone = getIcon('edit', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'], [
        primaryColor,
        'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z'
    ]);
});
exports.ExclamationCircleTwoTone = getIcon('exclamation-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.ExperimentTwoTone = getIcon('experiment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z'
    ], [
        primaryColor,
        'M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z'
    ], [
        primaryColor,
        'M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z'
    ]);
});
exports.EyeInvisibleTwoTone = getIcon('eye-invisible', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M254.89 758.85l125.57-125.57a176 176 0 0 1 248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 0 1-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'
    ], [
        primaryColor,
        'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zM878.63 165.56L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z'
    ], [
        primaryColor,
        'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'
    ]);
});
exports.EyeTwoTone = getIcon('eye', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z'
    ], [
        secondaryColor,
        'M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z'
    ], [
        primaryColor,
        'M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
    ]);
});
exports.FileAddTwoTone = getIcon('file-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'
    ]);
});
exports.FileExclamationTwoTone = getIcon('file-exclamation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileImageTwoTone = getIcon('file-image', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileExcelTwoTone = getIcon('file-excel', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'
    ]);
});
exports.FileMarkdownTwoTone = getIcon('file-markdown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'
    ]);
});
exports.FilePdfTwoTone = getIcon('file-pdf', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z'
    ], [
        secondaryColor,
        'M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z'
    ]);
});
exports.FilePptTwoTone = getIcon('file-ppt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z'
    ]);
});
exports.FileTextTwoTone = getIcon('file-text', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.FileUnknownTwoTone = getIcon('file-unknown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z'
    ], [
        primaryColor,
        'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z'
    ]);
});
exports.FileZipTwoTone = getIcon('file-zip', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M344 630h32v2h-32z'], [
        secondaryColor,
        'M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z'
    ]);
});
exports.FileWordTwoTone = getIcon('file-word', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'
    ]);
});
exports.FileTwoTone = getIcon('file', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z'], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ]);
});
exports.FilterTwoTone = getIcon('filter', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'
    ]);
});
exports.FireTwoTone = getIcon('fire', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z'
    ], [
        primaryColor,
        'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'
    ]);
});
exports.FolderAddTwoTone = getIcon('folder-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z'
    ], [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [
        primaryColor,
        'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z'
    ]);
});
exports.FlagTwoTone = getIcon('flag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 232h368v336H184z'], [secondaryColor, 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'], [
        primaryColor,
        'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'
    ]);
});
exports.FolderTwoTone = getIcon('folder', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1z']);
});
exports.FolderOpenTwoTone = getIcon('folder-open', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M159 768h612.3l103.4-256H262.3z'], [
        primaryColor,
        'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'
    ]);
});
exports.FrownTwoTone = getIcon('frown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.FundTwoTone = getIcon('fund', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z'
    ], [
        primaryColor,
        'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'
    ]);
});
exports.FunnelPlotTwoTone = getIcon('funnel-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'
    ]);
});
exports.GiftTwoTone = getIcon('gift', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z'
    ], [
        primaryColor,
        'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z'
    ]);
});
exports.HddTwoTone = getIcon('hdd', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ], [
        primaryColor,
        'M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.HeartTwoTone = getIcon('heart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'
    ], [
        secondaryColor,
        'M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z'
    ]);
});
exports.HighlightTwoTone = getIcon('highlight', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z'
    ], [
        primaryColor,
        'M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z'
    ]);
});
exports.HomeTwoTone = getIcon('home', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z'
    ], [
        primaryColor,
        'M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'
    ]);
});
exports.HourglassTwoTone = getIcon('hourglass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z'
    ], [
        primaryColor,
        'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'
    ]);
});
exports.Html5TwoTone = getIcon('html5', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z'
    ], [
        secondaryColor,
        'M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z'
    ], [
        primaryColor,
        'M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'
    ]);
});
exports.IdcardTwoTone = getIcon('idcard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z'
    ], [
        secondaryColor,
        'M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        primaryColor,
        'M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'
    ]);
});
exports.InfoCircleTwoTone = getIcon('info-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'
    ]);
});
exports.InsuranceTwoTone = getIcon('insurance', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [secondaryColor, 'M521.9 358.8h97.9v41.6h-97.9z'], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z'
    ]);
});
exports.InteractionTwoTone = getIcon('interaction', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.InterationTwoTone = getIcon('interation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.LayoutTwoTone = getIcon('layout', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z'
    ], [
        primaryColor,
        'M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z'
    ]);
});
exports.LeftCircleTwoTone = getIcon('left-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z'
    ]);
});
exports.LeftSquareTwoTone = getIcon('left-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z'
    ], [
        primaryColor,
        'M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z'
    ]);
});
exports.LikeTwoTone = getIcon('like', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z'
    ], [
        primaryColor,
        'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z'
    ]);
});
exports.LockTwoTone = getIcon('lock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z'
    ], [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ]);
});
exports.MailTwoTone = getIcon('mail', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z'
    ], [secondaryColor, 'M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z'], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z'
    ]);
});
exports.MedicineBoxTwoTone = getIcon('medicine-box', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z'
    ]);
});
exports.MehTwoTone = getIcon('meh', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.MessageTwoTone = getIcon('message', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ], [
        primaryColor,
        'M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'
    ], [primaryColor, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.MinusCircleTwoTone = getIcon('minus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MinusSquareTwoTone = getIcon('minus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.MobileTwoTone = getIcon('mobile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'
    ], [
        secondaryColor,
        'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.PauseCircleTwoTone = getIcon('pause-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'
    ], [
        primaryColor,
        'M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MoneyCollectTwoTone = getIcon('money-collect', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z'
    ], [
        primaryColor,
        'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z'
    ], [
        primaryColor,
        'M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z'
    ]);
});
exports.NotificationTwoTone = getIcon('notification', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z'
    ], [
        primaryColor,
        'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'
    ]);
});
exports.PhoneTwoTone = getIcon('phone', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z'
    ], [
        primaryColor,
        'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'
    ]);
});
exports.PictureTwoTone = getIcon('picture', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z'
    ], [
        secondaryColor,
        'M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z'
    ], [
        secondaryColor,
        'M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z'
    ], [secondaryColor, 'M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z'], [
        primaryColor,
        'M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'
    ]);
});
exports.PlayCircleTwoTone = getIcon('play-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z'
    ], [
        primaryColor,
        'M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z'
    ]);
});
exports.PlaySquareTwoTone = getIcon('play-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z'
    ], [
        primaryColor,
        'M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z'
    ]);
});
exports.PieChartTwoTone = getIcon('pie-chart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'
    ], [
        secondaryColor,
        'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z'
    ], [
        secondaryColor,
        'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'
    ], [
        primaryColor,
        'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z'
    ], [
        primaryColor,
        'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'
    ]);
});
exports.PlusCircleTwoTone = getIcon('plus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PlusSquareTwoTone = getIcon('plus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PoundCircleTwoTone = getIcon('pound-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z'
    ], [
        primaryColor,
        'M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PrinterTwoTone = getIcon('printer', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'
    ], [
        primaryColor,
        'M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'
    ], [
        primaryColor,
        'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z'
    ]);
});
exports.ProfileTwoTone = getIcon('profile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ProjectTwoTone = getIcon('project', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z'
    ], [
        primaryColor,
        'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PushpinTwoTone = getIcon('pushpin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z'
    ], [
        primaryColor,
        'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'
    ]);
});
exports.PropertySafetyTwoTone = getIcon('property-safety', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z'
    ], [
        primaryColor,
        'M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z'
    ]);
});
exports.QuestionCircleTwoTone = getIcon('question-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
    ], [
        primaryColor,
        'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z'
    ]);
});
exports.ReconciliationTwoTone = getIcon('reconciliation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [secondaryColor, 'M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z'], [
        primaryColor,
        'M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ], [
        primaryColor,
        'M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z'
    ], [
        primaryColor,
        'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'
    ]);
});
exports.RedEnvelopeTwoTone = getIcon('red-envelope', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'
    ], [
        secondaryColor,
        'M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z'
    ], [secondaryColor, 'M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z'], [
        primaryColor,
        'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z'
    ]);
});
exports.RestTwoTone = getIcon('rest', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'
    ], [
        primaryColor,
        'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
    ], [
        primaryColor,
        'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'
    ]);
});
exports.RightCircleTwoTone = getIcon('right-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z'
    ]);
});
exports.RocketTwoTone = getIcon('rocket', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z'
    ], [primaryColor, 'M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.RightSquareTwoTone = getIcon('right-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z'
    ], [
        primaryColor,
        'M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z'
    ]);
});
exports.SafetyCertificateTwoTone = getIcon('safety-certificate', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z'
    ], [
        primaryColor,
        'M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'
    ]);
});
exports.SaveTwoTone = getIcon('save', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z'
    ], [
        primaryColor,
        'M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
    ], [
        primaryColor,
        'M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z'
    ]);
});
exports.ScheduleTwoTone = getIcon('schedule', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z'
    ], [
        primaryColor,
        'M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ], [
        primaryColor,
        'M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.SecurityScanTwoTone = getIcon('security-scan', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z'
    ], [
        primaryColor,
        'M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z'
    ]);
});
exports.SettingTwoTone = getIcon('setting', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z'
    ], [
        secondaryColor,
        'M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z'
    ], [
        primaryColor,
        'M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z'
    ], [
        primaryColor,
        'M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z'
    ]);
});
exports.ShopTwoTone = getIcon('shop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z'
    ], [
        primaryColor,
        'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'
    ]);
});
exports.ShoppingTwoTone = getIcon('shopping', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z'
    ], [
        primaryColor,
        'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'
    ]);
});
exports.SkinTwoTone = getIcon('skin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z'
    ], [
        primaryColor,
        'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'
    ]);
});
exports.SlidersTwoTone = getIcon('sliders', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z'
    ], [
        primaryColor,
        'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z'
    ]);
});
exports.SmileTwoTone = getIcon('smile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.SnippetsTwoTone = getIcon('snippets', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'
    ], [
        primaryColor,
        'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'
    ]);
});
exports.SoundTwoTone = getIcon('sound', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z'
    ], [
        primaryColor,
        'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z'
    ]);
});
exports.StarTwoTone = getIcon('star', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z'
    ], [
        primaryColor,
        'M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z'
    ]);
});
exports.StopTwoTone = getIcon('stop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z'
    ]);
});
exports.SwitcherTwoTone = getIcon('switcher', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 840h528V312H184v528zm116-290h296v64H300v-64z'], [
        primaryColor,
        'M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z'
    ], [primaryColor, 'M300 550h296v64H300z']);
});
exports.TabletTwoTone = getIcon('tablet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'
    ], [
        secondaryColor,
        'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.TagTwoTone = getIcon('tag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'
    ], [
        primaryColor,
        'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
    ], [
        primaryColor,
        'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z'
    ]);
});
exports.TagsTwoTone = getIcon('tags', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z'
    ], [
        secondaryColor,
        'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'
    ], [
        primaryColor,
        'M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z'
    ], [
        primaryColor,
        'M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z'
    ]);
});
exports.ToolTwoTone = getIcon('tool', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z'
    ], [
        primaryColor,
        'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'
    ]);
});
exports.TrademarkCircleTwoTone = getIcon('trademark-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z'
    ], [
        secondaryColor,
        'M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'
    ], [
        primaryColor,
        'M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z'
    ]);
});
exports.UnlockTwoTone = getIcon('unlock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ], [
        primaryColor,
        'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z'
    ]);
});
exports.TrophyTwoTone = getIcon('trophy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z'
    ], [
        primaryColor,
        'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'
    ]);
});
exports.UpCircleTwoTone = getIcon('up-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z'
    ]);
});
exports.ThunderboltTwoTone = getIcon('thunderbolt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z'
    ], [
        primaryColor,
        'M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z'
    ]);
});
exports.UpSquareTwoTone = getIcon('up-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z'
    ], [
        primaryColor,
        'M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z'
    ]);
});
exports.UsbTwoTone = getIcon('usb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'
    ], [
        primaryColor,
        'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z'
    ]);
});
exports.VideoCameraTwoTone = getIcon('video-camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z'
    ], [
        primaryColor,
        'M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.WalletTwoTone = getIcon('wallet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z'
    ], [
        secondaryColor,
        'M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        secondaryColor,
        'M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z'
    ]);
});
exports.WarningTwoTone = getIcon('warning', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'
    ], [
        secondaryColor,
        'M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ]);
});
exports.CiTwoTone = getIcon('ci', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'
    ], [
        primaryColor,
        'M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'
    ]);
});
exports.CopyrightTwoTone = getIcon('copyright', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'
    ], [
        primaryColor,
        'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'
    ]);
});
exports.DollarTwoTone = getIcon('dollar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z'
    ], [
        primaryColor,
        'M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'
    ]);
});
exports.EuroTwoTone = getIcon('euro', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z'
    ], [
        primaryColor,
        'M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z'
    ]);
});
exports.GoldTwoTone = getIcon('gold', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z'
    ], [
        secondaryColor,
        'M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z'
    ]);
});
exports.CanlendarTwoTone = getIcon('canlendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(843);









var twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6'
};

var Icon = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

    function Icon() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Icon);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Icon, [{
        key: 'render',
        value: function render() {
            var _extends2;

            var _props = this.props,
                type = _props.type,
                className = _props.className,
                onClick = _props.onClick,
                style = _props.style,
                primaryColor = _props.primaryColor,
                secondaryColor = _props.secondaryColor,
                rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);

            var target = void 0;
            var colors = twoToneColorPalette;
            if (primaryColor) {
                colors = {
                    primaryColor: primaryColor,
                    secondaryColor: secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor)
                };
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* isIconDefinition */])(type)) {
                target = type;
            } else if (typeof type === 'string') {
                target = Icon.get(type, colors);
                if (!target) {
                    // log(`Could not find icon: ${type}`);
                    return null;
                }
            }
            if (!target) {
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* log */])('type should be string or icon definiton, but got ' + type);
                return null;
            }
            if (target && typeof target.icon === 'function') {
                target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                    icon: target.icon(colors.primaryColor, colors.secondaryColor)
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* generate */])(target.icon, 'svg-' + target.name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()((_extends2 = {
                className: className,
                onClick: onClick,
                style: style
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'data-icon', target.name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'width', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'height', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'fill', 'currentColor'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'aria-hidden', 'true'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'focusable', 'false'), _extends2), rest));
        }
    }], [{
        key: 'add',
        value: function add() {
            var _this2 = this;

            for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
                icons[_key] = arguments[_key];
            }

            icons.forEach(function (icon) {
                _this2.definitions.set(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* withSuffix */])(icon.name, icon.theme), icon);
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.definitions.clear();
        }
    }, {
        key: 'get',
        value: function get(key) {
            var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;

            if (key) {
                var target = this.definitions.get(key);
                if (target && typeof target.icon === 'function') {
                    target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                        icon: target.icon(colors.primaryColor, colors.secondaryColor)
                    });
                }
                return target;
            }
        }
    }, {
        key: 'setTwoToneColors',
        value: function setTwoToneColors(_ref) {
            var primaryColor = _ref.primaryColor,
                secondaryColor = _ref.secondaryColor;

            twoToneColorPalette.primaryColor = primaryColor;
            twoToneColorPalette.secondaryColor = secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor);
        }
    }, {
        key: 'getTwoToneColors',
        value: function getTwoToneColors() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, twoToneColorPalette);
        }
    }]);

    return Icon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Icon.displayName = 'IconReact';
Icon.definitions = new __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* MiniMap */]();
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(815);
var $Object = __webpack_require__(74).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(97);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(100), 'Object', { defineProperty: __webpack_require__(99).f });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(817), __esModule: true };

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(419);
__webpack_require__(822);
module.exports = __webpack_require__(285).f('iterator');


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(277);
var defined = __webpack_require__(276);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(283);
var descriptor = __webpack_require__(159);
var setToStringTag = __webpack_require__(284);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(127)(IteratorPrototype, __webpack_require__(85)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(99);
var anObject = __webpack_require__(128);
var getKeys = __webpack_require__(190);

module.exports = __webpack_require__(100) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(98).document;
module.exports = document && document.documentElement;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(823);
var global = __webpack_require__(98);
var hide = __webpack_require__(127);
var Iterators = __webpack_require__(161);
var TO_STRING_TAG = __webpack_require__(85)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(824);
var step = __webpack_require__(825);
var Iterators = __webpack_require__(161);
var toIObject = __webpack_require__(111);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(420)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(827), __esModule: true };

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(828);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
module.exports = __webpack_require__(74).Symbol;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(98);
var has = __webpack_require__(110);
var DESCRIPTORS = __webpack_require__(100);
var $export = __webpack_require__(97);
var redefine = __webpack_require__(421);
var META = __webpack_require__(829).KEY;
var $fails = __webpack_require__(130);
var shared = __webpack_require__(279);
var setToStringTag = __webpack_require__(284);
var uid = __webpack_require__(192);
var wks = __webpack_require__(85);
var wksExt = __webpack_require__(285);
var wksDefine = __webpack_require__(286);
var enumKeys = __webpack_require__(830);
var isArray = __webpack_require__(831);
var anObject = __webpack_require__(128);
var isObject = __webpack_require__(129);
var toObject = __webpack_require__(160);
var toIObject = __webpack_require__(111);
var toPrimitive = __webpack_require__(274);
var createDesc = __webpack_require__(159);
var _create = __webpack_require__(283);
var gOPNExt = __webpack_require__(832);
var $GOPD = __webpack_require__(287);
var $GOPS = __webpack_require__(281);
var $DP = __webpack_require__(99);
var $keys = __webpack_require__(190);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(423).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(193).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(191)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(127)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(192)('meta');
var isObject = __webpack_require__(129);
var has = __webpack_require__(110);
var setDesc = __webpack_require__(99).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(130)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(190);
var gOPS = __webpack_require__(281);
var pIE = __webpack_require__(193);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(275);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(111);
var gOPN = __webpack_require__(423).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 833 */
/***/ (function(module, exports) {



/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286)('asyncIterator');


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286)('observable');


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(837), __esModule: true };

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(838);
module.exports = __webpack_require__(74).Object.setPrototypeOf;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(97);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(839).set });


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(129);
var anObject = __webpack_require__(128);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(273)(Function.call, __webpack_require__(287).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(841), __esModule: true };

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(842);
var $Object = __webpack_require__(74).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(97);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(283) });


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["e"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIconDefinition;
/* unused harmony export normalizeAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSecondaryColor;
/* harmony export (immutable) */ __webpack_exports__["f"] = withSuffix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





function log(message) {
    if (!(process && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://act-api.dctms.ca","REACT_APP_UI_URL":"https://act.dctms.ca","REACT_APP_SECRET_NAME":"wiZzx1yTU1vSx89QKprP","REACT_APP_SECRET_KEY":"GmjMJuznKRqNxfca3gk6","REACT_APP_RECAPTCHA_SITE_KEY":"6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6"}) && "production" === 'production')) {
        console.error('[@ant-design/icons-react]: ' + message + '.');
    }
}
function isIconDefinition(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.keys(attrs).reduce(function (acc, key) {
        var val = attrs[key];
        switch (key) {
            case 'class':
                acc.className = val;
                delete acc['class'];
                break;
            default:
                acc[key] = val;
        }
        return acc;
    }, {});
}
var MiniMap = function () {
    function MiniMap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MiniMap);

        this.collection = {};
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MiniMap, [{
        key: 'clear',
        value: function clear() {
            this.collection = {};
        }
    }, {
        key: 'delete',
        value: function _delete(key) {
            return delete this.collection[key];
        }
    }, {
        key: 'get',
        value: function get(key) {
            return this.collection[key];
        }
    }, {
        key: 'has',
        value: function has(key) {
            return Boolean(this.collection[key]);
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.collection[key] = value;
            return this;
        }
    }, {
        key: 'size',
        get: function get() {
            return Object.keys(this.collection).length;
        }
    }]);

    return MiniMap;
}();
function generate(node, key, rootProps) {
    if (!rootProps) {
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
            return generate(child, key + '-' + node.tag + '-' + index);
        }));
    }
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        key: key
    }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
        return generate(child, key + '-' + node.tag + '-' + index);
    }));
}
function getSecondaryColor(primaryColor) {
    // choose the second color
    return Object(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__["generate"])(primaryColor)[0];
}
function withSuffix(name, theme) {
    switch (theme) {
        case 'fill':
            return name + '-fill';
        case 'outline':
            return name + '-o';
        case 'twotone':
            return name + '-twotone';
        default:
            throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(154)))

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(__webpack_require__(845));
var hueStep = 2; // 色相阶梯
var saturationStep = 16; // 饱和度阶梯，浅色部分
var saturationStep2 = 5; // 饱和度阶梯，深色部分
var brightnessStep1 = 5; // 亮度阶梯，浅色部分
var brightnessStep2 = 15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下
function getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
        hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    }
    else {
        hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    }
    if (hue < 0) {
        hue += 360;
    }
    else if (hue >= 360) {
        hue -= 360;
    }
    return hue;
}
function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) {
        return hsv.s;
    }
    var saturation;
    if (light) {
        saturation = Math.round(hsv.s * 100) - saturationStep * i;
    }
    else if (i === darkColorCount) {
        saturation = Math.round(hsv.s * 100) + saturationStep;
    }
    else {
        saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    }
    // 边界值修正
    if (saturation > 100) {
        saturation = 100;
    }
    // 第一格的 s 限制在 6-10 之间
    if (light && i === lightColorCount && saturation > 10) {
        saturation = 10;
    }
    if (saturation < 6) {
        saturation = 6;
    }
    return saturation;
}
function getValue(hsv, i, light) {
    if (light) {
        return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }
    return Math.round(hsv.v * 100) - brightnessStep2 * i;
}
function generate(color) {
    var patterns = [];
    var pColor = tinycolor2_1.default(color);
    for (var i = lightColorCount; i > 0; i -= 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i, true),
            s: getSaturation(hsv, i, true),
            v: getValue(hsv, i, true),
        }).toHexString();
        patterns.push(colorString);
    }
    patterns.push(pColor.toHexString());
    for (var i = 1; i <= darkColorCount; i += 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i),
            s: getSaturation(hsv, i),
            v: getValue(hsv, i),
        }).toHexString();
        patterns.push(colorString);
    }
    return patterns;
}
exports.default = generate;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = create;

var React = _interopRequireWildcard(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var customCache = new Set();

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    var type = props.type,
        children = props.children,
        restProps = __rest(props, ["type", "children"]); // component > children > type


    var content = null;

    if (props.type) {
      content = React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content);
  };

  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}
//# sourceMappingURL=IconFont.js.map


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeFromTypeName = getThemeFromTypeName;
exports.removeTypeTheme = removeTypeTheme;
exports.withThemeSuffix = withThemeSuffix;
exports.alias = alias;
exports.svgBaseProps = void 0;

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': true,
  focusable: 'false'
};
exports.svgBaseProps = svgBaseProps;
var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;

function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}

function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}

function withThemeSuffix(type, theme) {
  var result = type;

  if (theme === 'filled') {
    result += '-fill';
  } else if (theme === 'outlined') {
    result += '-o';
  } else if (theme === 'twoTone') {
    result += '-twotone';
  } else {
    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result;
} // For alias or compatibility


function alias(type) {
  var newType = type;

  switch (type) {
    case 'cross':
      newType = 'close';
      break;
    // https://github.com/ant-design/ant-design/issues/13007

    case 'interation':
      newType = 'interaction';
      break;
    // https://github.com/ant-design/ant-design/issues/16810

    case 'canlendar':
      newType = 'calendar';
      break;
    // https://github.com/ant-design/ant-design/issues/17448

    case 'colum-height':
      newType = 'column-height';
      break;

    default:
  }

  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
  return newType;
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = _interopRequireDefault(__webpack_require__(417));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function setTwoToneColor(primaryColor) {
  return _iconsReact["default"].setTwoToneColors({
    primaryColor: primaryColor
  });
}

function getTwoToneColor() {
  var colors = _iconsReact["default"].getTwoToneColors();

  return colors.primaryColor;
}
//# sourceMappingURL=twoTonePrimaryColor.js.map


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

var _default = isNumeric;
exports["default"] = _default;
//# sourceMappingURL=isNumeric.js.map


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cru_logo.f6945e2a.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diamind_logo.6ecd38a6.png";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"settingsLink":"Footer__settingsLink__20EXo"};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Home__content__4md9A","parentContainer":"Home__parentContainer__3dFRQ"};

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(31);






var NotFound = function NotFound() {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center', align: 'middle' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { span: 5 }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1', null, 'Page not found'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', null, 'Nothing to see here'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */], { to: '/' }, 'Take me home'))));
};

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home() {
    _classCallCheck(this, Home);return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }_createClass(Home, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', null, 'AcT - Patient Information Sheet'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', null, 'Please select whether you would like to view the Text-only or Visual Patient Information Sheet'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/patient-information-sheet-visual', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Visual Patient Information Sheet ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/patient-information-sheet-text', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Text Only Patient Information Sheet '))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Home ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/randomize', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Randomize ')))))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_carousel_style__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_carousel_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_carousel_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_carousel__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatientInformationSheet_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatientInformationSheet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__PatientInformationSheet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_01_jpg__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_01_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_01_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_02_jpg__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_02_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_02_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_03_jpg__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_03_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_03_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_04_jpg__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_04_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_04_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_05_jpg__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_05_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_05_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_06_jpg__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_06_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_06_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_07_jpg__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_07_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_07_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_08_jpg__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_08_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_08_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_09_jpg__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_09_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_09_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_10_jpg__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_10_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_10_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_11_jpg__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_11_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_11_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_12_jpg__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_12_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_12_jpg__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home(props) {
    _classCallCheck(this, Home);var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));_this.next = _this.next.bind(_this);_this.previous = _this.previous.bind(_this);_this.carousel = __WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();return _this;
  }_createClass(Home, [{ key: 'next', value: function next() {
      this.carousel.next();
    } }, { key: 'previous', value: function previous() {
      this.carousel.prev();
    } }, { key: 'render', value: function render() {
      var _this2 = this;var props = { dots: true, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1 };return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_13__PatientInformationSheet_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_13__PatientInformationSheet_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h2', null, 'AcT - Patient Information Sheet - Visual'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_carousel___default.a, Object.assign({ ref: function ref(node) {
          return _this2.carousel = node;
        } }, props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 1', src: __WEBPACK_IMPORTED_MODULE_14__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_01_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 2', src: __WEBPACK_IMPORTED_MODULE_15__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_02_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You have just had a test. We examined you and took pictures of your brain. This showed you are having a stroke.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 3', src: __WEBPACK_IMPORTED_MODULE_16__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_03_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Common stroke signs are facial droop, weakness of one side of your body, or difficulty speaking or understanding.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 4', src: __WEBPACK_IMPORTED_MODULE_17__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_04_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your stroke is caused by a blockage of an artery in the brain. In standard practice, we can treat some people with a medicine to break up the blockage (clot-busting medicine). This treatment has to be administered fast because injury to the brain happens quickly.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 5', src: __WEBPACK_IMPORTED_MODULE_18__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_05_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Someone saw your symptoms and you have been brought to the hospital to see if we can help your stroke.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 6', src: __WEBPACK_IMPORTED_MODULE_19__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_06_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You are a good candidate for a study about how best to treat your stroke. Let me explain.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 7', src: __WEBPACK_IMPORTED_MODULE_20__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_07_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "In the study (called the \u201CAcT\u201D Study) we are comparing two clot-busting medicines: either alteplase (tPA) or tenecteplase (TNK). Both of these clot-busting drugs are approved treatments (alteplase for acute stroke and tenecteplase for acute heart attacks).  They are supposed to open the blocked artery in your brain. With this study we are trying to figure out if tenecteplase is as good as alteplase in treating patients with a stroke like yours.")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 8', src: __WEBPACK_IMPORTED_MODULE_21__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_08_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Everyone in this study will get one of the two clot-busting medicines.  The rest of your care will be same as for every other stroke patient. We will provide more details to you and your family in the following hours and days.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 8', src: __WEBPACK_IMPORTED_MODULE_22__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_09_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 8', src: __WEBPACK_IMPORTED_MODULE_23__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_10_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 8', src: __WEBPACK_IMPORTED_MODULE_24__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_11_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', { alt: 'Patient Information Sheet Page 8', src: __WEBPACK_IMPORTED_MODULE_25__assets_documents_2020_06_25_17_29_33_Ontario_Visual_Patient_Information_Sheet_12_jpg___default.a, style: { objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' } })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('a', { onClick: this.previous }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'left-circle', style: { color: '#FAFAFA' } }), ' Previous'), '\xA0\xA0\xA0|\xA0\xA0', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('a', { onClick: this.next }, 'Next ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'right-circle', style: { color: '#FAFAFA' } }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Home ')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* Link */], { to: '/randomize', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Randomize ')))))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(859);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", ""]);

// exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(861);
//# sourceMappingURL=index.js.map


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(862);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-carousel {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-carousel .slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.ant-carousel .slick-list {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.ant-carousel .slick-list:focus {\n  outline: none;\n}\n.ant-carousel .slick-list.dragging {\n  cursor: pointer;\n}\n.ant-carousel .slick-list .slick-slide {\n  pointer-events: none;\n}\n.ant-carousel .slick-list .slick-slide.slick-active {\n  pointer-events: auto;\n}\n.ant-carousel .slick-slider .slick-track,\n.ant-carousel .slick-slider .slick-list {\n  transform: translate3d(0, 0, 0);\n}\n.ant-carousel .slick-track {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n}\n.ant-carousel .slick-track::before,\n.ant-carousel .slick-track::after {\n  display: table;\n  content: '';\n}\n.ant-carousel .slick-track::after {\n  clear: both;\n}\n.slick-loading .ant-carousel .slick-track {\n  visibility: hidden;\n}\n.ant-carousel .slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir='rtl'] .ant-carousel .slick-slide {\n  float: right;\n}\n.ant-carousel .slick-slide img {\n  display: block;\n}\n.ant-carousel .slick-slide.slick-loading img {\n  display: none;\n}\n.ant-carousel .slick-slide.dragging img {\n  pointer-events: none;\n}\n.ant-carousel .slick-initialized .slick-slide {\n  display: block;\n}\n.ant-carousel .slick-loading .slick-slide {\n  visibility: hidden;\n}\n.ant-carousel .slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n.ant-carousel .slick-arrow.slick-hidden {\n  display: none;\n}\n.ant-carousel .slick-prev,\n.ant-carousel .slick-next {\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  line-height: 0;\n  background: transparent;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n}\n.ant-carousel .slick-prev:hover,\n.ant-carousel .slick-next:hover,\n.ant-carousel .slick-prev:focus,\n.ant-carousel .slick-next:focus {\n  color: transparent;\n  background: transparent;\n  outline: none;\n}\n.ant-carousel .slick-prev:hover::before,\n.ant-carousel .slick-next:hover::before,\n.ant-carousel .slick-prev:focus::before,\n.ant-carousel .slick-next:focus::before {\n  opacity: 1;\n}\n.ant-carousel .slick-prev.slick-disabled::before,\n.ant-carousel .slick-next.slick-disabled::before {\n  opacity: 0.25;\n}\n.ant-carousel .slick-prev {\n  left: -25px;\n}\n.ant-carousel .slick-prev::before {\n  content: '\\2190';\n}\n.ant-carousel .slick-next {\n  right: -25px;\n}\n.ant-carousel .slick-next::before {\n  content: '\\2192';\n}\n.ant-carousel .slick-dots {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 3px;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  list-style: none;\n}\n.ant-carousel .slick-dots-bottom {\n  bottom: 12px;\n}\n.ant-carousel .slick-dots-top {\n  top: 12px;\n}\n.ant-carousel .slick-dots li {\n  position: relative;\n  display: inline-block;\n  margin: 0 2px;\n  padding: 0;\n  text-align: center;\n  vertical-align: top;\n}\n.ant-carousel .slick-dots li button {\n  display: block;\n  width: 16px;\n  height: 3px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  background: #fff;\n  border: 0;\n  border-radius: 1px;\n  outline: none;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: all 0.5s;\n}\n.ant-carousel .slick-dots li button:hover,\n.ant-carousel .slick-dots li button:focus {\n  opacity: 0.75;\n}\n.ant-carousel .slick-dots li.slick-active button {\n  width: 24px;\n  background: #fff;\n  opacity: 1;\n}\n.ant-carousel .slick-dots li.slick-active button:hover,\n.ant-carousel .slick-dots li.slick-active button:focus {\n  opacity: 1;\n}\n.ant-carousel-vertical .slick-dots {\n  top: 50%;\n  bottom: auto;\n  width: 3px;\n  height: auto;\n  transform: translateY(-50%);\n}\n.ant-carousel-vertical .slick-dots-left {\n  left: 12px;\n}\n.ant-carousel-vertical .slick-dots-right {\n  right: 12px;\n}\n.ant-carousel-vertical .slick-dots li {\n  margin: 0 2px;\n  vertical-align: baseline;\n}\n.ant-carousel-vertical .slick-dots li button {\n  width: 3px;\n  height: 16px;\n}\n.ant-carousel-vertical .slick-dots li.slick-active button {\n  width: 3px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _debounce = _interopRequireDefault(__webpack_require__(425));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
// TODO: Will be removed in antd 4.0 because we will no longer support ie9
if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
} // Use require over import (will be lifted up)
// make sure matchMedia polyfill run before require('react-slick')
// Fix https://github.com/ant-design/ant-design/issues/6560
// Fix https://github.com/ant-design/ant-design/issues/3308


var SlickCarousel = __webpack_require__(867)["default"];

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));

    _this.saveSlick = function (node) {
      _this.slick = node;
    };

    _this.onWindowResized = function () {
      // Fix https://github.com/ant-design/ant-design/issues/2550
      var autoplay = _this.props.autoplay;

      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
        _this.slick.innerSlider.autoPlay();
      }
    };

    _this.renderCarousel = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var props = _extends({}, _this.props);

      if (props.effect === 'fade') {
        props.fade = true;
      }

      var className = getPrefixCls('carousel', props.prefixCls);
      var dotsClass = 'slick-dots';

      var dotPosition = _this.getDotPosition();

      props.vertical = dotPosition === 'left' || dotPosition === 'right';
      props.dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');

      if (props.vertical) {
        className = "".concat(className, " ").concat(className, "-vertical");
      }

      return React.createElement("div", {
        className: className
      }, React.createElement(SlickCarousel, _extends({
        ref: _this.saveSlick
      }, props)));
    };

    _this.onWindowResized = (0, _debounce["default"])(_this.onWindowResized, 500, {
      leading: false
    });

    if ('vertical' in _this.props) {
      (0, _warning["default"])(!_this.props.vertical, 'Carousel', '`vertical` is deprecated, please use `dotPosition` instead.');
    }

    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoplay = this.props.autoplay;

      if (autoplay) {
        window.addEventListener('resize', this.onWindowResized);
      } // https://github.com/ant-design/ant-design/issues/7191


      this.innerSlider = this.slick && this.slick.innerSlider;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
        this.goTo(this.props.initialSlide || 0, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var autoplay = this.props.autoplay;

      if (autoplay) {
        window.removeEventListener('resize', this.onWindowResized);
        this.onWindowResized.cancel();
      }
    }
  }, {
    key: "getDotPosition",
    value: function getDotPosition() {
      if (this.props.dotPosition) {
        return this.props.dotPosition;
      }

      if ('vertical' in this.props) {
        return this.props.vertical ? 'right' : 'bottom';
      }

      return 'bottom';
    }
  }, {
    key: "next",
    value: function next() {
      this.slick.slickNext();
    }
  }, {
    key: "prev",
    value: function prev() {
      this.slick.slickPrev();
    }
  }, {
    key: "goTo",
    value: function goTo(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.slick.slickGoTo(slide, dontAnimate);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCarousel);
    }
  }]);

  return Carousel;
}(React.Component);

exports["default"] = Carousel;
Carousel.defaultProps = {
  dots: true,
  arrows: false,
  draggable: false
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(86);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(195);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(__webpack_require__(868));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _innerSlider = __webpack_require__(869);

var _json2mq = _interopRequireDefault(__webpack_require__(874));

var _defaultProps = _interopRequireDefault(__webpack_require__(876));

var _innerSliderUtils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(408);

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react["default"].createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(26));

var _initialState = _interopRequireDefault(__webpack_require__(870));

var _lodash = _interopRequireDefault(__webpack_require__(428));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _innerSliderUtils = __webpack_require__(196);

var _track = __webpack_require__(871);

var _dots = __webpack_require__(872);

var _arrows = __webpack_require__(873);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(289));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, {}, _this.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom["default"].findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, {}, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, {}, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, {}, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState["default"], {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _innerSliderUtils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react["default"].createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames["default"])({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react["default"].createElement("li", {
          key: i,
          className: className
        }, _react["default"].cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _innerSliderUtils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
      } else {
        prevArrow = _react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
      } else {
        nextArrow = _react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(875);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 875 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-01.cd72a1bd.jpg";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-02.ad7653f9.jpg";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-03.3c07d2ea.jpg";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-04.c3fd3229.jpg";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-05.0fb0625e.jpg";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-06.77d63f5a.jpg";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-07.8b77c8fd.jpg";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-08.836b1997.jpg";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-09.cb52d0e7.jpg";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-10.f8e4e065.jpg";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-11.0548a66a.jpg";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-12.f20225dc.jpg";

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home() {
    _classCallCheck(this, Home);return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }_createClass(Home, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_9__PatientInformationSheet_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', null, 'AcT - Patient and Family Information Sheet - Text'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke (AcT): QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'SPONSOR-INVESTIGATOR:\xA0 Dr. Bijoy Menon, University of Calgary'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'AcT Ethics Lead: Dr. Michel Shamy, Ottawa, ON'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'SITE INVESTIGATOR: Dr. Shelagh Coutts'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You/ Your loved one was enrolled in the AcT study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'This information sheet provides you with some basic information about the AcT study. A more detailed consent form will be made available to you in the coming days.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'This is a study in which patients receive one of two different treatments, and their outcomes are compared so that the research team can determine if one treatment is better, worse, or the same as the other. Both treatments are approved medications.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The AcT study is for people with acute ischemic stroke. Ischemic stroke is caused by a blockage in an artery in the brain. In standard practice, patients with ischemic stroke are evaluated quickly to determine if they are candidates for a CLOT BUSTING DRUG, also called a thrombolytic.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0In the AcT study, eligible patients are randomly chosen by a computer program to receive one of two different CLOT BUSTING DRUGS: either Alteplase (tPA) or Tenecteplase (TNK). In AcT, everyone will receive one of these two drugs, and the rest of their care will be the same as it would have been otherwise.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Alteplase is the CLOT BUSTING DRUG that is usually used for patients with stroke, and Tenecteplase is the CLOT BUSTING DRUG more commonly used for patients with heart attack. Some studies suggest that Tenecteplase may be better than Alteplase for patients with stroke and appears to be just as safe. We are trying to figure out if Tenecteplase is as good as Alteplase in patients with acute ischemic stroke.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, "Because time is of the essence when giving any CLOT BUSTING DRUG to a patient with stroke, patients who are candidates for the ACT study are enrolled by deferral of consent. This means that the research team decides who is a candidate, and one of the CLOT BUSTING DRUGS \u2013 either Alteplase or Tenecteplase \u2013 is given as quickly as possible. The research team will provide all the details later on and give you and/or your family a chance to agree to ongoing participation. This process was designed in consultation with experts in research ethics and with stroke patients and was approved by your hospital\u2019s RESEARCH ETHICS BOARD."), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions or concerns, please do not hesitate to contact our team.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts (403) 944-1591 or'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Stroke Research office (403) 944-2863'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990. The University of Calgary Conjoint Health Research Ethics Board has approved this research study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Home ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/randomize', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Randomize ')))))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Consent_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Consent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Consent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Consent_Consent__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__reducers_consent_actions__ = __webpack_require__(52);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var ConsentComponent = function (_React$Component) {
  _inherits(ConsentComponent, _React$Component);function ConsentComponent(props) {
    _classCallCheck(this, ConsentComponent);var _this = _possibleConstructorReturn(this, (ConsentComponent.__proto__ || Object.getPrototypeOf(ConsentComponent)).call(this, props));_this.handleChange = function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;_this.setState(_defineProperty({}, name, value));
    };_this.handleDatePickerChange = function (event) {
      _this.setState({ dateOfBirth: event });
    };_this.handleSigChange = function (event) {
      _this.setState({ signature: event }, function () {
        // console.log(this.state.signature);
        console.log('');
      });
    };_this.handleWitnessSigChange = function (event) {
      _this.setState({ witnessSignature: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handleInvestigatorSigChange = function (event) {
      _this.setState({ investigatorSignature: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handleFileChange = function (event) {
      _this.setState({ consentFile: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handlePrev = function () {
      var _this$state = _this.state,
          currentStep = _this$state.currentStep,
          currentStepInt = _this$state.currentStepInt;if (currentStep === 'Step 2') {
        _this.handleReset();
      } else if (currentStep === 'Step 3a') {
        _this.handleReset();
      } else if (currentStep === 'Step 3b') {
        _this.handleReset();
      }
    };_this.state = { currentStep: 'Step 1', currentStepType: '', currentStepInt: 1, subjectID: '', userID: '', siteID: '', consentType: '', consentPersonType: '', consentMethodType: '', fullName: '', dateOfBirth: '', signature: '', sigPad: {}, representativeFullName: '', witnessFullName: '', witnessSignature: '', witnessSigPad: {}, investigatorFullName: '', investigatorSignature: '', investigatorSigPad: {}, date: '', consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, fileListDc: {}, datasetdc: {}, fileListWithdraw: {}, datasetwithdraw: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: false, consentExistsOverwrite: true, consentExistsType: '', consentExistsPersonType: '', consentExistsMethodType: '', consentExistsEmailStatus: '', consentExistsLink: '', consentExistsDate: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: false, randomization_platform_step_3_patient_content: '', has_randomization_platform_step_3_patient_regained_capacity: false, randomization_platform_step_3_patient_regained_capacity_content: '', has_randomization_platform_step_3_surrogate: false, randomization_platform_step_3_surrogate_content: '', has_randomization_platform_step_3_withdraw: false, randomization_platform_step_3_withdraw_content: '', has_randomization_platform_step_3_deferred: false, randomization_platform_step_3_deferred_content: '' };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.handleReset = _this.handleReset.bind(_this);_this.handleChange = _this.handleChange.bind(_this);_this.handleDatePickerChange = _this.handleDatePickerChange.bind(_this);_this.handleSigChange = _this.handleSigChange.bind(_this);_this.handleWitnessSigChange = _this.handleWitnessSigChange.bind(_this);_this.handleInvestigatorSigChange = _this.handleInvestigatorSigChange.bind(_this);_this.handleFileChange = _this.handleFileChange.bind(_this);_this.fileDummyRequest = _this.fileDummyRequest.bind(_this);_this.normFile = _this.normFile.bind(_this);_this.handleNext = _this.handleNext.bind(_this);_this.handlePrev = _this.handlePrev.bind(_this);return _this;
  }_createClass(ConsentComponent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');if (!token) {
                  _context.next = 15;break;
                }this.setState({ currentStep: 'Step 3a', currentStepType: 'step2patientEmail', // consentPersonType: 'Patient',
                  consentOverwrite: 'yes', consentMethodType: 'Email', investigatorFullName: 'TestName' });_context.prev = 3;_context.next = 6;return __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].getConsentByToken(token);case 6:
                _ref2 = _context.sent;data = _ref2.data;this.setState(Object.assign({}, data, { consentPersonType: data.consentExistsPersonType, consentMethodType: data.consentExistsMethodType }));_context.next = 15;break;case 11:
                _context.prev = 11;_context.t0 = _context['catch'](3);this.handleReset();this.props.history.push('/consent_error');case 15:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[3, 11]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'fileDummyRequest', value: function fileDummyRequest(_ref3) {
      var file = _ref3.file,
          onSuccess = _ref3.onSuccess;setTimeout(function () {
        onSuccess("ok");
      }, 0);
    } }, { key: 'normFile', value: function normFile(e) {
      // console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }this.setState({ fileList: e.fileList }, function () {
        //console.log(this.state.fileList);
        console.log('');
      });return e && e.fileList;
    } }, { key: 'handleSubmit', value: function handleSubmit(values) {
      var _this2 = this;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');this.setState({ loading: true, currentStep: 'Step 4', currentStepInt: 4 });if (token) {
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].confirmConsentByToken(token, Object.assign({}, values, this.state)).then(function (response) {
          var consentResponse = response.data;
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this2.setState({ consentExists: false, consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].create(values).then(function (response) {
          var consentResponse = response.data;
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this2.setState({ consentExists: false, consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        });
      }
    } }, { key: 'handleReset', value: function handleReset() {
      this.setState({ currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: '', consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, fileListDc: {}, datasetdc: {}, fileListWithdraw: {}, datasetwithdraw: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: false, consentExistsOverwrite: false, consentExistsType: '', consentExistsPersonType: '', consentExistsMethodType: '', consentExistsEmailStatus: '', consentExistsDate: '', consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: false, randomization_platform_step_3_patient_content: '', has_randomization_platform_step_3_patient_regained_capacity: false, randomization_platform_step_3_patient_regained_capacity_content: '', has_randomization_platform_step_3_surrogate: false, randomization_platform_step_3_surrogate_content: '', has_randomization_platform_step_3_withdraw: false, randomization_platform_step_3_withdraw_content: '', has_randomization_platform_step_3_deferred: false, randomization_platform_step_3_deferred_content: '' });
    } }, { key: 'handleNext', value: function handleNext(values) {
      var _this3 = this;var _state = this.state,
          currentStep = _state.currentStep,
          currentStepInt = _state.currentStepInt;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');if (currentStep === 'Step 1') {
        this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].create(this.state).then(function (response) {
          var consentResponse = response.data;if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "edmonton") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentType2);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "sunnybrook") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeSunnybrook);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "toronto_uh") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeTorontoUH);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "kelowna") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeKelowna);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "montreal") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeMontreal);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "vancouver") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeVancouver);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "winnipeg") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeWinnipeg);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "uhn") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeUhn);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "halifax") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeHalifax);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "lhs") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeLhs);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "grey_nuns") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeGreyNuns);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "red_deer") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeRedDeer);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "medicine_hat") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeMedicineHat);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "lethbridge") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeLethbridge);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "kingston") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeKingston);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "quebec_chu") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeQuebecChu);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "chus") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeChus);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "hamilton") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeHamilton);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "ottawa") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeOttawa);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "royal_university") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeRoyalUniversity);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "royal") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypeRoyal);
          } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(consentResponse, 'consent_workflow_type') === "pei") {
            _this3.props.consentUpdate(Object.assign({}, consentResponse, { siteID: _this3.state.siteID, userID: _this3.state.userID }));_this3.props.history.push(routes.front.consentTypePei);
          } else {
            _this3.setState({ currentStep: 'Step 2', currentStepInt: 2, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentDate: consentResponse['consentDate'], consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: false, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: consentResponse['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: consentResponse['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: consentResponse['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: consentResponse['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: consentResponse['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: consentResponse['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: consentResponse['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: consentResponse['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: consentResponse['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: consentResponse['randomization_platform_step_3_deferred_content'] });
          }
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.setState({ currentStep: 'Step 1', currentStepInt: 1, consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: '', consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, fileListDc: {}, datasetdc: {}, fileListWithdraw: {}, datasetwithdraw: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: false, consentExistsOverwrite: false, consentExistsType: '', consentExistsPersonType: '', consentExistsMethodType: '', consentExistsEmailStatus: '', consentExistsDate: '', consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: false, randomization_platform_step_3_patient_content: '', has_randomization_platform_step_3_patient_regained_capacity: false, randomization_platform_step_3_patient_regained_capacity_content: '', has_randomization_platform_step_3_surrogate: false, randomization_platform_step_3_surrogate_content: '', has_randomization_platform_step_3_withdraw: false, randomization_platform_step_3_withdraw_content: '', has_randomization_platform_step_3_deferred: false, randomization_platform_step_3_deferred_content: '' });
        });
      } else if (currentStep === 'Step 2' && this.state.consentMethodType === 'Electronic') {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && (this.state.consentMethodType === 'Email' || this.state.consentMethodType === 'EmailRegainedCapacity')) {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && this.state.consentMethodType === 'Paper') {
        this.setState({ currentStep: 'Step 3b', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && this.state.consentMethodType === 'RegainedCapacity') {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 3a' && this.state.consentExistsOverwrite && this.state.consentProvided === 'yes') {
        if (values['dateOfBirth']) {
          values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD');
        } // window.alert('step 3 submit: DOB: ' + values['dateOfBirth'] + ' .. ' + moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD') + ' .. ' + Date())
        this.setState({ loading: true });if (token) {
          __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].confirmConsentByToken(token, this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature']).then(function (response) {
            var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
          }, function (error) {
            if (error.response) {
              var errors = error.response.data.error;if (errors) {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
              }
            }_this3.handleReset();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].create(this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature']).then(function (response) {
            var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
          }, function (error) {
            if (error.response) {
              var errors = error.response.data.error;if (errors) {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
              }
            }_this3.handleReset();
          });
        }
      } else if (currentStep === 'Step 3b' && this.state.consentExistsOverwrite) {
        this.setState({ loading: true }); //        console.log(values['consentFile'])
        //        console.log(this.state.fileList)
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].create(this.state, '', '', '', '', values['consentFile']).then(function (response) {
          var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentFile: {}, fileList: {}, dataset: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.handleReset();
        });
      } else {
        this.handleReset();
      }
    } }, { key: 'render', value: function render() {
      var _state2 = this.state,
          loading = _state2.loading,
          consentSaved = _state2.consentSaved;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_15__Consent_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_15__Consent_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Consent_Consent__["a" /* default */], Object.assign({ token: token, loading: loading }, this.state, { handleChange: this.handleChange, handleDatePickerChange: this.handleDatePickerChange, handleSigChange: this.handleSigChange, handleWitnessSigChange: this.handleWitnessSigChange, handleInvestigatorSigChange: this.handleInvestigatorSigChange, handleFileChange: this.handleFileChange, fileDummyRequest: this.fileDummyRequest, normFile: this.normFile, handleSubmit: this.handleSubmit, handleNext: this.handleNext, handlePrev: this.handlePrev }))))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Footer_Footer__["a" /* default */], null)));
    } }]);return ConsentComponent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_17__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(function () {
  return {};
}, mapDispatchToProps)(ConsentComponent));

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-message {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  top: 16px;\n  left: 0;\n  z-index: 1010;\n  width: 100%;\n  pointer-events: none;\n}\n.ant-message-notice {\n  padding: 8px;\n  text-align: center;\n}\n.ant-message-notice:first-child {\n  margin-top: -8px;\n}\n.ant-message-notice-content {\n  display: inline-block;\n  padding: 10px 16px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: all;\n}\n.ant-message-success .anticon {\n  color: #52c41a;\n}\n.ant-message-error .anticon {\n  color: #f5222d;\n}\n.ant-message-warning .anticon {\n  color: #faad14;\n}\n.ant-message-info .anticon,\n.ant-message-loading .anticon {\n  color: #1890ff;\n}\n.ant-message .anticon {\n  position: relative;\n  top: 1px;\n  margin-right: 8px;\n  font-size: 16px;\n}\n.ant-message-notice.move-up-leave.move-up-leave-active {\n  overflow: hidden;\n  animation-name: MessageMoveOut;\n  animation-duration: 0.3s;\n}\n@keyframes MessageMoveOut {\n  0% {\n    max-height: 150px;\n    padding: 8px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(899);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      var maxCount = _this.props.maxCount;

      _this.setState(function (previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function (v) {
          return v.key;
        }).indexOf(key);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, notice);
        } else {
          if (maxCount && notices.length >= maxCount) {
                                                notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key;
            updatedNotices.shift();
          }
          updatedNotices.push(notice);
        }
        return {
          notices: updatedNotices
        };
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var notices = this.state.notices;

      var noticeNodes = notices.map(function (notice, index) {
        var update = Boolean(index === notices.length - 1 && notice.updateKey);
        var key = notice.updateKey ? notice.updateKey : notice.key;
        var onClose = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            key: key,
            update: update,
            onClose: onClose,
            onClick: notice.onClick,
            closeIcon: props.closeIcon
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  maxCount: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  closeIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = document.createElement('div');
  if (getContainer) {
    var root = getContainer();
    root.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(431);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function (e) {
      if (e) {
        e.stopPropagation();
      }
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.update) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'restartCloseTimer',
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className),
          style: props.style,
          onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer,
          onClick: props.onClick
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          props.closeIcon || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  update: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  closeIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return randomizeServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(197);


var randomizeServices = { create: create };function create(params) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/web', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
}

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiFormInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var apiInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: "https://act-api.dctms.ca", headers: { 'Content-Type': 'application/json', //'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': "https://act.dctms.ca" //'Access-Control-Allow-Origin': '*',
    //'Access-Control-Allow-Credentials': 'true',
    //'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': 'X-Requested-With'
  }, auth: { username: "wiZzx1yTU1vSx89QKprP", password: "GmjMJuznKRqNxfca3gk6" } });var apiFormInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: "https://act-api.dctms.ca", headers: { 'Content-Type': 'multipart/form-data', //'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': "https://act.dctms.ca" //'Access-Control-Allow-Origin': '*',
    //'Access-Control-Allow-Credentials': 'true',
    //'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': 'X-Requested-With'
  }, auth: { username: "wiZzx1yTU1vSx89QKprP", password: "GmjMJuznKRqNxfca3gk6" } });

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSENT_HALIFAX_URL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONSENT_PEI_URL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consentServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(197);


var CONSENT_HALIFAX_URL_NAME = 'halifax';var CONSENT_PEI_URL_NAME = 'pei';function create(params) {
  var dateOfBirth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var signature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var witnessSignature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var investigatorSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var consentFile = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key]) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}var createCalgaryLikeConsentByUrl = function createCalgaryLikeConsentByUrl(url) {
  return function (params) {
    var dateOfBirth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var signature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var witnessSignature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var investigatorSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var consentFile = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';if (dateOfBirth !== '') {
      params.dateOfBirth = dateOfBirth;
    }if (signature !== '') {
      params.signature = signature;
    }if (witnessSignature !== '') {
      params.witnessSignature = witnessSignature;
    }if (investigatorSignature !== '') {
      params.investigatorSignature = investigatorSignature;
    }if (consentFile !== '') {
      params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
        if (params[key]) {
          formData.append(key, params[key]);
        }
      });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post(url, formData).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post(url, params).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  };
};function createEdmonton(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/edmonton', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/edmonton', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createMedicineHat(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/medicine_hat', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/medicine_hat', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createGreyNuns(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/grey_nuns', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/grey_nuns', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}var getConsentGreyNunsByToken = function getConsentGreyNunsByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/grey_nuns/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentGreyNunsByToken = function confirmConsentGreyNunsByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/grey_nuns/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};function createSunnyBrook(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/sunnybrook', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/sunnybrook', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createTorontoUH(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/toronto_uh', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/toronto_uh', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createOttawa(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/ottawa', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/ottawa', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createRoyal(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/royal', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/royal', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createRoyalUniversity(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/royal_university', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/royal_university', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createWinnipeg(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/winnipeg', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/winnipeg', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createUhn(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/uhn', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/uhn', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createMontreal(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/montreal', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/montreal', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createVancouver(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/vancouver', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/vancouver', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createChus(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/chus', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/chus', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createQuebecChu(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/quebec_chu', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/quebec_chu', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createConsentByType(workflow_type, params) {
  var consentFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';if (consentFile !== '') {
    params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'fileList'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/' + workflow_type, formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/' + workflow_type, params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}function createKelowna(params) {
  var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
    params.consentFile = consentFile;if (consentFileDc !== null) {
      params.consentFileDc = consentFileDc;
    }if (consentFileWithdraw !== null) {
      params.consentFileWithdraw = consentFileWithdraw;
    }var formData = new FormData();Object.keys(params).map(function (key) {
      if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
        formData.append(key, params[key]);
      }
    });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
      formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
    }if (consentFileWithdraw !== null) {
      formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post('/consent/workflow/kelowna', formData).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/kelowna', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }
}var getConsentByToken = function getConsentByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentEdmontonByToken = function getConsentEdmontonByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/edmonton/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentMedicineHatByToken = function getConsentMedicineHatByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/medicine_hat/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentSunnyBrookByToken = function getConsentSunnyBrookByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/sunnybrook/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentTorontoUHByToken = function getConsentTorontoUHByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/toronto_uh/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentOttawaByToken = function getConsentOttawaByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/ottawa/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentRoyalByToken = function getConsentRoyalByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/royal/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentRoyalUniversityByToken = function getConsentRoyalUniversityByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/royal_university/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentUhnByToken = function getConsentUhnByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/sunnybrook/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentByWorkflowTypeAndToken = function getConsentByWorkflowTypeAndToken(workflow_type, token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/' + workflow_type + '/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentWinnipegByToken = function getConsentWinnipegByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/winnipeg/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentMontrealByToken = function getConsentMontrealByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/montreal/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentVancouverByToken = function getConsentVancouverByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/vancouver/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentChusByToken = function getConsentChusByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/chus/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentQuebecChuByToken = function getConsentQuebecChuByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/quebec_chu/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var getConsentKelownaByToken = function getConsentKelownaByToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('/consent/workflow/kelowna/' + token).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentByToken = function confirmConsentByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentEdmontonByToken = function confirmConsentEdmontonByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/edmonton/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentMedicineHatByToken = function confirmConsentMedicineHatByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/medicine_hat/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentSunnyBrookByToken = function confirmConsentSunnyBrookByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/sunnybrook/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentTorontoUHByToken = function confirmConsentTorontoUHByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/toronto_uh/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentOttawaByToken = function confirmConsentOttawaByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/ottawa/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentRoyalByToken = function confirmConsentRoyalByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/royal/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentRoyalUniversityByToken = function confirmConsentRoyalUniversityByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/royal_university/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentWinnipegByToken = function confirmConsentWinnipegByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/winnipeg/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentUhnByToken = function confirmConsentUhnByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/uhn/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentMontrealByToken = function confirmConsentMontrealByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/montreal/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentChusByToken = function confirmConsentChusByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/chus/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentQuebecChuByToken = function confirmConsentQuebecChuByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/quebec_chu/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentKelownaByToken = function confirmConsentKelownaByToken(token, params) {
  var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }if (signature !== '') {
    params.signature = signature;
  }if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/kelowna/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var confirmConsentByTypeAndToken = function confirmConsentByTypeAndToken(workflow_type, token, params) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/consent/workflow/' + workflow_type + '/' + token + '/confirm', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
};var createConsentByUrl = function createConsentByUrl(url) {
  return function (params) {
    var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (consentFile !== '') {
      params.consentFile = consentFile;var formData = new FormData();Object.keys(params).map(function (key) {
        if (params[key] && !['consentFile', 'fileList'].includes(key)) {
          formData.append(key, params[key]);
        }
      });formData.append('consentFile', params.consentFile[0].originFileObj);return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post(url, formData).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post(url, params).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  };
};var getConsentByUrlToken = function getConsentByUrlToken(url) {
  return function (token) {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].get('' + url + token).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  };
};var confirmConsentByUrlToken = function confirmConsentByUrlToken(url) {
  return function (token, params) {
    var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var signature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var witnessSignature = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var investigatorSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';var consentFile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';if (dateOfBirth !== '') {
      params.dateOfBirth = dateOfBirth;
    }if (signature !== '') {
      params.signature = signature;
    }if (witnessSignature !== '') {
      params.witnessSignature = witnessSignature;
    }if (investigatorSignature !== '') {
      params.investigatorSignature = investigatorSignature;
    }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('' + url + token + '/confirm', params).then(function (response) {
      return response;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  };
};var createConsentWithFileWithdrawByUrl = function createConsentWithFileWithdrawByUrl(url) {
  return function (params) {
    var consentFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var consentFileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var consentFileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (consentFile !== '' || consentFileDc !== null || consentFileWithdraw !== null) {
      params.consentFile = consentFile;if (consentFileDc !== null) {
        params.consentFileDc = consentFileDc;
      }if (consentFileWithdraw !== null) {
        params.consentFileWithdraw = consentFileWithdraw;
      }var formData = new FormData();Object.keys(params).map(function (key) {
        if (params[key] && !['consentFile', 'consentFileDc', 'consentFileWithdraw', 'fileList', 'fileListDc', 'fileListWithdraw'].includes(key)) {
          formData.append(key, params[key]);
        }
      });formData.append('consentFile', params.consentFile[0].originFileObj);if (consentFileDc !== null) {
        formData.append('consentFileDc', params.consentFileDc[0].originFileObj);
      }if (consentFileWithdraw !== null) {
        formData.append('consentFileWithdraw', params.consentFileWithdraw[0].originFileObj);
      }return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* apiFormInstance */].post(url, formData).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post(url, params).then(function (response) {
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  };
};var consentServices = { create: create, createEdmonton: createEdmonton, createSunnyBrook: createSunnyBrook, createTorontoUH: createTorontoUH, createKelowna: createKelowna, createMontreal: createMontreal, createVancouver: createVancouver, createChus: createChus, createQuebecChu: createQuebecChu, createWinnipeg: createWinnipeg, createUhn: createUhn, createConsentByType: createConsentByType, getConsentByToken: getConsentByToken, getConsentEdmontonByToken: getConsentEdmontonByToken, getConsentSunnyBrookByToken: getConsentSunnyBrookByToken, getConsentTorontoUHByToken: getConsentTorontoUHByToken, getConsentKelownaByToken: getConsentKelownaByToken, getConsentMontrealByToken: getConsentMontrealByToken, getConsentVancouverByToken: getConsentVancouverByToken, getConsentChusByToken: getConsentChusByToken, getConsentQuebecChuByToken: getConsentQuebecChuByToken, getConsentWinnipegByToken: getConsentWinnipegByToken, getConsentUhnByToken: getConsentUhnByToken, getConsentByWorkflowTypeAndToken: getConsentByWorkflowTypeAndToken, confirmConsentByToken: confirmConsentByToken, confirmConsentEdmontonByToken: confirmConsentEdmontonByToken, confirmConsentSunnyBrookByToken: confirmConsentSunnyBrookByToken, confirmConsentTorontoUHByToken: confirmConsentTorontoUHByToken, confirmConsentKelownaByToken: confirmConsentKelownaByToken, confirmConsentMontrealByToken: confirmConsentMontrealByToken, confirmConsentChusByToken: confirmConsentChusByToken, confirmConsentQuebecChuByToken: confirmConsentQuebecChuByToken, confirmConsentWinnipegByToken: confirmConsentWinnipegByToken, confirmConsentUhnByToken: confirmConsentUhnByToken, confirmConsentByTypeAndToken: confirmConsentByTypeAndToken, createLhs: createConsentByUrl('/consent/workflow/lhs'), getConsentLhsByToken: getConsentByUrlToken('/consent/workflow/lhs/'), confirmConsentLhsByToken: confirmConsentByUrlToken('/consent/workflow/lhs/'), createGreyNuns: createGreyNuns, getConsentGreyNunsByToken: getConsentGreyNunsByToken, confirmConsentGreyNunsByToken: confirmConsentGreyNunsByToken, createRedDeer: createCalgaryLikeConsentByUrl('/consent/workflow/red_deer'), getConsentRedDeerByToken: getConsentByUrlToken('/consent/workflow/red_deer/'), confirmConsentRedDeerByToken: confirmConsentByUrlToken('/consent/workflow/red_deer/'), createMedicineHat: createMedicineHat, getConsentMedicineHatByToken: getConsentMedicineHatByToken, confirmConsentMedicineHatByToken: confirmConsentMedicineHatByToken, createLethbridge: createConsentWithFileWithdrawByUrl('/consent/workflow/lethbridge'), getConsentLethbridgeByToken: getConsentByUrlToken('/consent/workflow/lethbridge/'), confirmConsentLethbridgeByToken: confirmConsentByUrlToken('/consent/workflow/lethbridge/'), createKingston: createConsentByUrl('/consent/workflow/kingston'), getConsentKingstonByToken: getConsentByUrlToken('/consent/workflow/kingston/'), confirmConsentKingstonByToken: confirmConsentByUrlToken('/consent/workflow/kingston/'), createHamilton: createConsentByUrl('/consent/workflow/hamilton'), getConsentHamiltonByToken: getConsentByUrlToken('/consent/workflow/hamilton/'), confirmConsentHamiltonByToken: confirmConsentByUrlToken('/consent/workflow/hamilton/'), createOttawa: createOttawa, confirmConsentOttawaByToken: confirmConsentOttawaByToken, getConsentOttawaByToken: getConsentOttawaByToken, createRoyalUniversity: createRoyalUniversity, confirmConsentRoyalUniversityByToken: confirmConsentRoyalUniversityByToken, getConsentRoyalUniversityByToken: getConsentRoyalUniversityByToken, createRoyal: createRoyal, confirmConsentRoyalByToken: confirmConsentRoyalByToken, getConsentRoyalByToken: getConsentRoyalByToken };

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validationServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(197);


var validationServices = { create: create, createSAE: createSAE };function create(params) {
  var validationExistsVialExpiryDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';if (validationExistsVialExpiryDate !== '') {
    params.validationExistsVialExpiryDate = validationExistsVialExpiryDate;
  }return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/validation', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
}function createSAE(params) {
  return __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* apiInstance */].post('/sae_reporting', params).then(function (response) {
    return response;
  }).catch(function (error) {
    return Promise.reject(error);
  });
}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Consent__content__1qqkm","parentContainer":"Consent__parentContainer__1TN4e"};

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Step1_js__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step2_js__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step3aPatient_js__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatientEmail__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aSurrogate__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aSurrogateEmail__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacityEmail__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step3b_js__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Step4_js__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas__);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, Consent);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Consent.__proto__ || Object.getPrototypeOf(Consent)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleSubmit(values);
        }
      });
    }, _this.handleNext = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;if (values['currentStep'] === 'Step 3a') {
            if (_this.props.consentMethodType !== 'Email' && _this.props.consentMethodType !== 'EmailRegainedCapacity' || _this.props.token) {
              values['signature'] = _this.sigPad.getTrimmedCanvas().toDataURL('image/png');if (_this.witnessSigPad) {
                values['witnessSignature'] = _this.witnessSigPad.getTrimmedCanvas().toDataURL('image/png');
              }_this.props.handleSigChange(values['signature']);_this.props.handleWitnessSigChange(values['witnessSignature']);
            }if (!_this.props.token) {
              values['investigatorSignature'] = _this.investigatorSigPad.getTrimmedCanvas().toDataURL('image/png');
            }_this.props.handleInvestigatorSigChange(values['investigatorSignature']);
          } else if (values['currentStep'] === 'Step 3b') {
            _this.props.handleFileChange(values['consentFile']);
          }_this.props.handleNext(values);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Consent, [{ key: 'previousButton', value: function previousButton() {
      var _props = this.props,
          currentStep = _props.currentStep,
          currentStepType = _props.currentStepType;if (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment, null, currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.props.handlePrev }, 'Back')));
      }return null;
    } }, { key: 'nextButton', value: function nextButton() {
      var _props2 = this.props,
          currentStep = _props2.currentStep,
          currentStepInt = _props2.currentStepInt;if (currentStep === 'Step 1' || currentStep === 'Step 2') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Next'));
      } else if (currentStep === 'Step 3a' || currentStep === 'Step 3b') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Submit'));
      }return null;
    } }, { key: 'signatureCanvas', value: function signatureCanvas() {
      var _this2 = this;var getFieldDecorator = this.props.form.getFieldDecorator;var _props3 = this.props,
          currentStep = _props3.currentStep,
          currentStepInt = _props3.currentStepInt,
          consentMethodType = _props3.consentMethodType,
          currentStepType = _props3.currentStepType;if (currentStep === 'Step 3a') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, (consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' || currentStepType === 'step2patientEmail') && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Participant/Legally Authorized Representative Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'Signature', name: 'Signature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref2) {
            _this2.sigPad = _ref2;
          } }))), currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Investigator/Delegate Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'investigatorSignature', name: 'investigatorSignature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref3) {
            _this2.investigatorSigPad = _ref3;
          } }))), consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Witness Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'witnessSignature', name: 'witnessSignature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref4) {
            _this2.witnessSigPad = _ref4;
          } }))), (consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' || currentStepType === 'step2patientEmail') && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.sigPad.clear();
          } }, 'Clear Participant/Surrogate Signature')), consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.witnessSigPad.clear();
          } }, 'Clear Witness Signature')), currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.investigatorSigPad.clear();
          } }, 'Clear Investigator Signature')));
      }
    } }, { key: 'render', value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;var ConsentFormStep3aPatientComponent = this.props.consentMethodType === 'Email' ? __WEBPACK_IMPORTED_MODULE_13__Step3aPatientEmail__["a" /* ConsentFormStep3aPatientEmail */] : __WEBPACK_IMPORTED_MODULE_12__Step3aPatient_js__["a" /* ConsentFormStep3aPatient */];var ConsentFormStep3aSurrogateComponent = this.props.consentMethodType === 'Email' ? __WEBPACK_IMPORTED_MODULE_15__Step3aSurrogateEmail__["a" /* ConsentFormStep3aSurrogateEmail */] : __WEBPACK_IMPORTED_MODULE_14__Step3aSurrogate__["a" /* ConsentFormStep3aSurrogate */];var ConsentFormStep3aRegainedCapacityComponent = this.props.consentMethodType === 'EmailRegainedCapacity' ? __WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacityEmail__["a" /* ConsentFormStep3aRegainedCapacityEmail */] : __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* ConsentFormStep3aRegainedCapacity */];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h2', null, ' Consent - ', this.props.currentStep), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Step1_js__["a" /* ConsentFormStep1 */], { consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Step2_js__["a" /* ConsentFormStep2 */], { consentExistsEmailStatus: this.props.consentExistsEmailStatus, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, consentExists: this.props.consentExists, consentExistsOverwrite: this.props.consentExistsOverwrite, consentExistsLink: this.props.consentExistsLink, consentExistsType: this.props.consentExistsType, consentExistsPersonType: this.props.consentExistsPersonType, consentExistsMethodType: this.props.consentExistsMethodType, consentExistsDate: this.props.consentExistsDate, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aPatientComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, currentStepType: this.props.currentStepType, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_patient: this.props.has_randomization_platform_step_3_patient, randomization_platform_step_3_patient_content: this.props.randomization_platform_step_3_patient_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aSurrogateComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, representativeFullName: this.props.representativeFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, currentStepType: this.props.currentStepType, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_surrogate: this.props.has_randomization_platform_step_3_surrogate, randomization_platform_step_3_surrogate_content: this.props.randomization_platform_step_3_surrogate_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aRegainedCapacityComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStepType: this.props.currentStepType, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, representativeFullName: this.props.representativeFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_patient_regained_capacity: this.props.has_randomization_platform_step_3_patient_regained_capacity, randomization_platform_step_3_patient_regained_capacity_content: this.props.randomization_platform_step_3_patient_regained_capacity_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3b_js__["a" /* ConsentFormStep3b */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, date: this.props.date, fileDummyRequest: this.props.fileDummyRequest, normFile: this.props.normFile, consentFile: this.props.consentFile, handleFileChange: this.props.handleFileChange, fileList: this.props.fileList, dataset: this.props.dataset, consentProvided: this.props.consentProvided, consentPaperBlankLink: this.props.consentPaperBlankLink, consentPaperUpload: this.props.consentPaperUpload, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step4_js__["a" /* ConsentFormStep4 */], { token: this.props.token, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentPaperBlankLink: this.props.consentPaperBlankLink, consentPaperUpload: this.props.consentPaperUpload, consentExistsPersonType: this.props.consentExistsPersonType, consentExistsMethodType: this.props.consentExistsMethodType, consentExistsEmailStatus: this.props.consentExistsEmailStatus, consentExists: this.props.consentExists, consentExistsLink: this.props.consentExistsLink, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), this.signatureCanvas(), this.nextButton(), this.previousButton()), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA', width: '12rem' }, className: 'menu-item' }, ' Home ')))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(907);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-btn {\n  line-height: 1.499;\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n  white-space: nowrap;\n  text-align: center;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  height: 32px;\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  color: #424242;\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-btn > .anticon {\n  line-height: 1;\n}\n.ant-btn,\n.ant-btn:active,\n.ant-btn:focus {\n  outline: 0;\n}\n.ant-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-btn:not([disabled]):active {\n  outline: 0;\n  box-shadow: none;\n}\n.ant-btn.disabled,\n.ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-btn.disabled > *,\n.ant-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-btn-lg {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-sm {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-btn > a:only-child {\n  color: currentColor;\n}\n.ant-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: #78f1ff;\n  background-color: #fff;\n  border-color: #78f1ff;\n}\n.ant-btn:hover > a:only-child,\n.ant-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn:hover > a:only-child::after,\n.ant-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:active,\n.ant-btn.active {\n  color: #36b5cf;\n  background-color: #fff;\n  border-color: #36b5cf;\n}\n.ant-btn:active > a:only-child,\n.ant-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn:active > a:only-child::after,\n.ant-btn.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-disabled,\n.ant-btn.disabled,\n.ant-btn[disabled],\n.ant-btn-disabled:hover,\n.ant-btn.disabled:hover,\n.ant-btn[disabled]:hover,\n.ant-btn-disabled:focus,\n.ant-btn.disabled:focus,\n.ant-btn[disabled]:focus,\n.ant-btn-disabled:active,\n.ant-btn.disabled:active,\n.ant-btn[disabled]:active,\n.ant-btn-disabled.active,\n.ant-btn.disabled.active,\n.ant-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-disabled > a:only-child,\n.ant-btn.disabled > a:only-child,\n.ant-btn[disabled] > a:only-child,\n.ant-btn-disabled:hover > a:only-child,\n.ant-btn.disabled:hover > a:only-child,\n.ant-btn[disabled]:hover > a:only-child,\n.ant-btn-disabled:focus > a:only-child,\n.ant-btn.disabled:focus > a:only-child,\n.ant-btn[disabled]:focus > a:only-child,\n.ant-btn-disabled:active > a:only-child,\n.ant-btn.disabled:active > a:only-child,\n.ant-btn[disabled]:active > a:only-child,\n.ant-btn-disabled.active > a:only-child,\n.ant-btn.disabled.active > a:only-child,\n.ant-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-disabled > a:only-child::after,\n.ant-btn.disabled > a:only-child::after,\n.ant-btn[disabled] > a:only-child::after,\n.ant-btn-disabled:hover > a:only-child::after,\n.ant-btn.disabled:hover > a:only-child::after,\n.ant-btn[disabled]:hover > a:only-child::after,\n.ant-btn-disabled:focus > a:only-child::after,\n.ant-btn.disabled:focus > a:only-child::after,\n.ant-btn[disabled]:focus > a:only-child::after,\n.ant-btn-disabled:active > a:only-child::after,\n.ant-btn.disabled:active > a:only-child::after,\n.ant-btn[disabled]:active > a:only-child::after,\n.ant-btn-disabled.active > a:only-child::after,\n.ant-btn.disabled.active > a:only-child::after,\n.ant-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus,\n.ant-btn:active,\n.ant-btn.active {\n  text-decoration: none;\n  background: #fff;\n}\n.ant-btn > i,\n.ant-btn > span {\n  display: inline-block;\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  pointer-events: none;\n}\n.ant-btn-primary {\n  color: #FAFAFA;\n  background-color: #4CDEF5;\n  border-color: #4CDEF5;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #FAFAFA;\n  background-color: #78f1ff;\n  border-color: #78f1ff;\n}\n.ant-btn-primary:hover > a:only-child,\n.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:active,\n.ant-btn-primary.active {\n  color: #FAFAFA;\n  background-color: #36b5cf;\n  border-color: #36b5cf;\n}\n.ant-btn-primary:active > a:only-child,\n.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:active > a:only-child::after,\n.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary-disabled,\n.ant-btn-primary.disabled,\n.ant-btn-primary[disabled],\n.ant-btn-primary-disabled:hover,\n.ant-btn-primary.disabled:hover,\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary-disabled:focus,\n.ant-btn-primary.disabled:focus,\n.ant-btn-primary[disabled]:focus,\n.ant-btn-primary-disabled:active,\n.ant-btn-primary.disabled:active,\n.ant-btn-primary[disabled]:active,\n.ant-btn-primary-disabled.active,\n.ant-btn-primary.disabled.active,\n.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-primary-disabled > a:only-child,\n.ant-btn-primary.disabled > a:only-child,\n.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {\n  border-right-color: #78f1ff;\n  border-left-color: #78f1ff;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {\n  border-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {\n  border-right-color: #78f1ff;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {\n  border-right-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-left-color: #78f1ff;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-left-color: #d9d9d9;\n}\n.ant-btn-ghost {\n  color: #424242;\n  background-color: transparent;\n  border-color: #d9d9d9;\n}\n.ant-btn-ghost > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:hover,\n.ant-btn-ghost:focus {\n  color: #78f1ff;\n  background-color: transparent;\n  border-color: #78f1ff;\n}\n.ant-btn-ghost:hover > a:only-child,\n.ant-btn-ghost:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:hover > a:only-child::after,\n.ant-btn-ghost:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:active,\n.ant-btn-ghost.active {\n  color: #36b5cf;\n  background-color: transparent;\n  border-color: #36b5cf;\n}\n.ant-btn-ghost:active > a:only-child,\n.ant-btn-ghost.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:active > a:only-child::after,\n.ant-btn-ghost.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost-disabled,\n.ant-btn-ghost.disabled,\n.ant-btn-ghost[disabled],\n.ant-btn-ghost-disabled:hover,\n.ant-btn-ghost.disabled:hover,\n.ant-btn-ghost[disabled]:hover,\n.ant-btn-ghost-disabled:focus,\n.ant-btn-ghost.disabled:focus,\n.ant-btn-ghost[disabled]:focus,\n.ant-btn-ghost-disabled:active,\n.ant-btn-ghost.disabled:active,\n.ant-btn-ghost[disabled]:active,\n.ant-btn-ghost-disabled.active,\n.ant-btn-ghost.disabled.active,\n.ant-btn-ghost[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-ghost-disabled > a:only-child,\n.ant-btn-ghost.disabled > a:only-child,\n.ant-btn-ghost[disabled] > a:only-child,\n.ant-btn-ghost-disabled:hover > a:only-child,\n.ant-btn-ghost.disabled:hover > a:only-child,\n.ant-btn-ghost[disabled]:hover > a:only-child,\n.ant-btn-ghost-disabled:focus > a:only-child,\n.ant-btn-ghost.disabled:focus > a:only-child,\n.ant-btn-ghost[disabled]:focus > a:only-child,\n.ant-btn-ghost-disabled:active > a:only-child,\n.ant-btn-ghost.disabled:active > a:only-child,\n.ant-btn-ghost[disabled]:active > a:only-child,\n.ant-btn-ghost-disabled.active > a:only-child,\n.ant-btn-ghost.disabled.active > a:only-child,\n.ant-btn-ghost[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost-disabled > a:only-child::after,\n.ant-btn-ghost.disabled > a:only-child::after,\n.ant-btn-ghost[disabled] > a:only-child::after,\n.ant-btn-ghost-disabled:hover > a:only-child::after,\n.ant-btn-ghost.disabled:hover > a:only-child::after,\n.ant-btn-ghost[disabled]:hover > a:only-child::after,\n.ant-btn-ghost-disabled:focus > a:only-child::after,\n.ant-btn-ghost.disabled:focus > a:only-child::after,\n.ant-btn-ghost[disabled]:focus > a:only-child::after,\n.ant-btn-ghost-disabled:active > a:only-child::after,\n.ant-btn-ghost.disabled:active > a:only-child::after,\n.ant-btn-ghost[disabled]:active > a:only-child::after,\n.ant-btn-ghost-disabled.active > a:only-child::after,\n.ant-btn-ghost.disabled.active > a:only-child::after,\n.ant-btn-ghost[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed {\n  color: #424242;\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: dashed;\n}\n.ant-btn-dashed > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:hover,\n.ant-btn-dashed:focus {\n  color: #78f1ff;\n  background-color: #fff;\n  border-color: #78f1ff;\n}\n.ant-btn-dashed:hover > a:only-child,\n.ant-btn-dashed:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:hover > a:only-child::after,\n.ant-btn-dashed:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:active,\n.ant-btn-dashed.active {\n  color: #36b5cf;\n  background-color: #fff;\n  border-color: #36b5cf;\n}\n.ant-btn-dashed:active > a:only-child,\n.ant-btn-dashed.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:active > a:only-child::after,\n.ant-btn-dashed.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed-disabled,\n.ant-btn-dashed.disabled,\n.ant-btn-dashed[disabled],\n.ant-btn-dashed-disabled:hover,\n.ant-btn-dashed.disabled:hover,\n.ant-btn-dashed[disabled]:hover,\n.ant-btn-dashed-disabled:focus,\n.ant-btn-dashed.disabled:focus,\n.ant-btn-dashed[disabled]:focus,\n.ant-btn-dashed-disabled:active,\n.ant-btn-dashed.disabled:active,\n.ant-btn-dashed[disabled]:active,\n.ant-btn-dashed-disabled.active,\n.ant-btn-dashed.disabled.active,\n.ant-btn-dashed[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dashed-disabled > a:only-child,\n.ant-btn-dashed.disabled > a:only-child,\n.ant-btn-dashed[disabled] > a:only-child,\n.ant-btn-dashed-disabled:hover > a:only-child,\n.ant-btn-dashed.disabled:hover > a:only-child,\n.ant-btn-dashed[disabled]:hover > a:only-child,\n.ant-btn-dashed-disabled:focus > a:only-child,\n.ant-btn-dashed.disabled:focus > a:only-child,\n.ant-btn-dashed[disabled]:focus > a:only-child,\n.ant-btn-dashed-disabled:active > a:only-child,\n.ant-btn-dashed.disabled:active > a:only-child,\n.ant-btn-dashed[disabled]:active > a:only-child,\n.ant-btn-dashed-disabled.active > a:only-child,\n.ant-btn-dashed.disabled.active > a:only-child,\n.ant-btn-dashed[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed-disabled > a:only-child::after,\n.ant-btn-dashed.disabled > a:only-child::after,\n.ant-btn-dashed[disabled] > a:only-child::after,\n.ant-btn-dashed-disabled:hover > a:only-child::after,\n.ant-btn-dashed.disabled:hover > a:only-child::after,\n.ant-btn-dashed[disabled]:hover > a:only-child::after,\n.ant-btn-dashed-disabled:focus > a:only-child::after,\n.ant-btn-dashed.disabled:focus > a:only-child::after,\n.ant-btn-dashed[disabled]:focus > a:only-child::after,\n.ant-btn-dashed-disabled:active > a:only-child::after,\n.ant-btn-dashed.disabled:active > a:only-child::after,\n.ant-btn-dashed[disabled]:active > a:only-child::after,\n.ant-btn-dashed-disabled.active > a:only-child::after,\n.ant-btn-dashed.disabled.active > a:only-child::after,\n.ant-btn-dashed[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger {\n  color: #fff;\n  background-color: #ff4d4f;\n  border-color: #ff4d4f;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff;\n  background-color: #ff7875;\n  border-color: #ff7875;\n}\n.ant-btn-danger:hover > a:only-child,\n.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:active,\n.ant-btn-danger.active {\n  color: #fff;\n  background-color: #d9363e;\n  border-color: #d9363e;\n}\n.ant-btn-danger:active > a:only-child,\n.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:active > a:only-child::after,\n.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger-disabled,\n.ant-btn-danger.disabled,\n.ant-btn-danger[disabled],\n.ant-btn-danger-disabled:hover,\n.ant-btn-danger.disabled:hover,\n.ant-btn-danger[disabled]:hover,\n.ant-btn-danger-disabled:focus,\n.ant-btn-danger.disabled:focus,\n.ant-btn-danger[disabled]:focus,\n.ant-btn-danger-disabled:active,\n.ant-btn-danger.disabled:active,\n.ant-btn-danger[disabled]:active,\n.ant-btn-danger-disabled.active,\n.ant-btn-danger.disabled.active,\n.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-danger-disabled > a:only-child,\n.ant-btn-danger.disabled > a:only-child,\n.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link {\n  color: #4CDEF5;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus {\n  color: #78f1ff;\n  background-color: transparent;\n  border-color: #78f1ff;\n}\n.ant-btn-link:hover > a:only-child,\n.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:hover > a:only-child::after,\n.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:active,\n.ant-btn-link.active {\n  color: #36b5cf;\n  background-color: transparent;\n  border-color: #36b5cf;\n}\n.ant-btn-link:active > a:only-child,\n.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:active > a:only-child::after,\n.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus,\n.ant-btn-link:active {\n  border-color: transparent;\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-icon-only {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-lg {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  font-size: 18px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-sm {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only > i {\n  vertical-align: middle;\n}\n.ant-btn-round {\n  height: 32px;\n  padding: 0 16px;\n  font-size: 14px;\n  border-radius: 32px;\n}\n.ant-btn-round.ant-btn-lg {\n  height: 40px;\n  padding: 0 20px;\n  font-size: 16px;\n  border-radius: 40px;\n}\n.ant-btn-round.ant-btn-sm {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 14px;\n  border-radius: 24px;\n}\n.ant-btn-round.ant-btn-icon-only {\n  width: auto;\n}\n.ant-btn-circle,\n.ant-btn-circle-outline {\n  min-width: 32px;\n  padding-right: 0;\n  padding-left: 0;\n  text-align: center;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-lg,\n.ant-btn-circle-outline.ant-btn-lg {\n  min-width: 40px;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-sm,\n.ant-btn-circle-outline.ant-btn-sm {\n  min-width: 24px;\n  border-radius: 50%;\n}\n.ant-btn::before {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  z-index: 1;\n  display: none;\n  background: #fff;\n  border-radius: inherit;\n  opacity: 0.35;\n  transition: opacity 0.2s;\n  content: '';\n  pointer-events: none;\n}\n.ant-btn .anticon {\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn .anticon.anticon-plus > svg,\n.ant-btn .anticon.anticon-minus > svg {\n  shape-rendering: optimizeSpeed;\n}\n.ant-btn.ant-btn-loading {\n  position: relative;\n}\n.ant-btn.ant-btn-loading:not([disabled]) {\n  pointer-events: none;\n}\n.ant-btn.ant-btn-loading::before {\n  display: block;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 29px;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon:not(:last-child) {\n  margin-left: -14px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 24px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon {\n  margin-left: -17px;\n}\n.ant-btn-group {\n  position: relative;\n  display: inline-block;\n}\n.ant-btn-group > .ant-btn,\n.ant-btn-group > span > .ant-btn {\n  position: relative;\n}\n.ant-btn-group > .ant-btn:hover,\n.ant-btn-group > span > .ant-btn:hover,\n.ant-btn-group > .ant-btn:focus,\n.ant-btn-group > span > .ant-btn:focus,\n.ant-btn-group > .ant-btn:active,\n.ant-btn-group > span > .ant-btn:active,\n.ant-btn-group > .ant-btn.active,\n.ant-btn-group > span > .ant-btn.active {\n  z-index: 2;\n}\n.ant-btn-group > .ant-btn:disabled,\n.ant-btn-group > span > .ant-btn:disabled {\n  z-index: 0;\n}\n.ant-btn-group > .ant-btn-icon-only {\n  font-size: 14px;\n}\n.ant-btn-group-lg > .ant-btn,\n.ant-btn-group-lg > span > .ant-btn {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 0;\n  line-height: 38px;\n}\n.ant-btn-group-lg > .ant-btn.ant-btn-icon-only {\n  width: 40px;\n  height: 40px;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-btn-group-sm > .ant-btn,\n.ant-btn-group-sm > span > .ant-btn {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 0;\n  line-height: 22px;\n}\n.ant-btn-group-sm > .ant-btn > .anticon,\n.ant-btn-group-sm > span > .ant-btn > .anticon {\n  font-size: 14px;\n}\n.ant-btn-group-sm > .ant-btn.ant-btn-icon-only {\n  width: 24px;\n  height: 24px;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn + .ant-btn-group,\n.ant-btn-group span + .ant-btn,\n.ant-btn-group .ant-btn + span,\n.ant-btn-group > span + span,\n.ant-btn-group + .ant-btn,\n.ant-btn-group + .ant-btn-group {\n  margin-left: -1px;\n}\n.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {\n  border-left-color: transparent;\n}\n.ant-btn-group .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn:first-child,\n.ant-btn-group > span:first-child > .ant-btn {\n  margin-left: 0;\n}\n.ant-btn-group > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group > .ant-btn:first-child:not(:last-child),\n.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group > .ant-btn:last-child:not(:first-child),\n.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group > .ant-btn-group {\n  float: left;\n}\n.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {\n  padding-right: 8px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {\n  padding-left: 8px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn:focus > span,\n.ant-btn:active > span {\n  position: relative;\n}\n.ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-left: 8px;\n}\n.ant-btn-background-ghost {\n  color: #fff;\n  background: transparent !important;\n  border-color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  color: #4CDEF5;\n  background-color: transparent;\n  border-color: #4CDEF5;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  color: #78f1ff;\n  background-color: transparent;\n  border-color: #78f1ff;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:active,\n.ant-btn-background-ghost.ant-btn-primary.active {\n  color: #36b5cf;\n  background-color: transparent;\n  border-color: #36b5cf;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled,\n.ant-btn-background-ghost.ant-btn-primary.disabled,\n.ant-btn-background-ghost.ant-btn-primary[disabled],\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger {\n  color: #ff4d4f;\n  background-color: transparent;\n  border-color: #ff4d4f;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:hover,\n.ant-btn-background-ghost.ant-btn-danger:focus {\n  color: #ff7875;\n  background-color: transparent;\n  border-color: #ff7875;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:active,\n.ant-btn-background-ghost.ant-btn-danger.active {\n  color: #d9363e;\n  background-color: transparent;\n  border-color: #d9363e;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled,\n.ant-btn-background-ghost.ant-btn-danger.disabled,\n.ant-btn-background-ghost.ant-btn-danger[disabled],\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link {\n  color: #4CDEF5;\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:hover,\n.ant-btn-background-ghost.ant-btn-link:focus {\n  color: #78f1ff;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:active,\n.ant-btn-background-ghost.ant-btn-link.active {\n  color: #36b5cf;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link-disabled,\n.ant-btn-background-ghost.ant-btn-link.disabled,\n.ant-btn-background-ghost.ant-btn-link[disabled],\n.ant-btn-background-ghost.ant-btn-link-disabled:hover,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-link-disabled:active,\n.ant-btn-background-ghost.ant-btn-link.disabled:active,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active,\n.ant-btn-background-ghost.ant-btn-link-disabled.active,\n.ant-btn-background-ghost.ant-btn-link.disabled.active,\n.ant-btn-background-ghost.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-two-chinese-chars::first-letter {\n  letter-spacing: 0.34em;\n}\n.ant-btn-two-chinese-chars > *:not(.anticon) {\n  margin-right: -0.34em;\n  letter-spacing: 0.34em;\n}\n.ant-btn-block {\n  width: 100%;\n}\n.ant-btn:empty {\n  vertical-align: top;\n}\na.ant-btn {\n  padding-top: 0.1px;\n  line-height: 30px;\n}\na.ant-btn-lg {\n  line-height: 38px;\n}\na.ant-btn-sm {\n  line-height: 22px;\n}\n", ""]);

// exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(38);

var _omit = _interopRequireDefault(__webpack_require__(56));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _wave = _interopRequireDefault(__webpack_require__(291));

var _type = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/button-has-type */


var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

function isString(str) {
  return typeof str === 'string';
} // Insert one space between two chinese characters automatically.


function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }

  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }

    return React.createElement("span", null, child);
  }

  return child;
}

function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = _typeof(child);

    var isCurrentChildPure = type === 'string' || type === 'number';

    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }

    isPrevChildPure = isCurrentChildPure;
  }); // Pass to React.Children.map to auto fill key

  return React.Children.map(childList, function (child) {
    return insertSpace(child, needInserted);
  });
}

var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

    _this.saveButtonRef = function (node) {
      _this.buttonNode = node;
    };

    _this.handleClick = function (e) {
      var loading = _this.state.loading;
      var onClick = _this.props.onClick;

      if (loading) {
        return;
      }

      if (onClick) {
        onClick(e);
      }
    };

    _this.renderButton = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          shape = _a.shape,
          size = _a.size,
          className = _a.className,
          children = _a.children,
          icon = _a.icon,
          ghost = _a.ghost,
          block = _a.block,
          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);

      var _this$state = _this.state,
          loading = _this$state.loading,
          hasTwoCNChar = _this$state.hasTwoCNChar;
      var prefixCls = getPrefixCls('btn', customizePrefixCls);
      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';
          break;

        default:
          break;
      }

      var iconType = loading ? 'loading' : icon;
      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
      var iconNode = iconType ? React.createElement(_icon["default"], {
        type: iconType
      }) : null;
      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);

      if (linkButtonRestProps.href !== undefined) {
        return React.createElement("a", _extends({}, linkButtonRestProps, {
          className: classes,
          onClick: _this.handleClick,
          ref: _this.saveButtonRef
        }), iconNode, kids);
      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.


      var _b = rest,
          htmlType = _b.htmlType,
          otherProps = __rest(_b, ["htmlType"]);

      var buttonNode = React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
        type: htmlType,
        className: classes,
        onClick: _this.handleClick,
        ref: _this.saveButtonRef
      }), iconNode, kids);

      if (type === 'link') {
        return buttonNode;
      }

      return React.createElement(_wave["default"], null, buttonNode);
    };

    _this.state = {
      loading: props.loading,
      hasTwoCNChar: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fixTwoCNChar();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      this.fixTwoCNChar();

      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
        clearTimeout(this.delayTimeout);
      }

      var loading = this.props.loading;

      if (loading && typeof loading !== 'boolean' && loading.delay) {
        this.delayTimeout = window.setTimeout(function () {
          _this2.setState({
            loading: loading
          });
        }, loading.delay);
      } else if (prevProps.loading !== loading) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          loading: loading
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: "fixTwoCNChar",
    value: function fixTwoCNChar() {
      // Fix for HOC usage like <FormatMessage />
      if (!this.buttonNode) {
        return;
      }

      var buttonText = this.buttonNode.textContent;

      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
        if (!this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: true
          });
        }
      } else if (this.state.hasTwoCNChar) {
        this.setState({
          hasTwoCNChar: false
        });
      }
    }
  }, {
    key: "isNeedInserted",
    value: function isNeedInserted() {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children,
          type = _this$props.type;
      return React.Children.count(children) === 1 && !icon && type !== 'link';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return Button;
}(React.Component);

Button.__ANT_BUTTON = true;
Button.defaultProps = {
  loading: false,
  ghost: false,
  block: false,
  htmlType: 'button'
};
Button.propTypes = {
  type: PropTypes.string,
  shape: PropTypes.oneOf(ButtonShapes),
  size: PropTypes.oneOf(ButtonSizes),
  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
  onClick: PropTypes.func,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  className: PropTypes.string,
  icon: PropTypes.string,
  block: PropTypes.bool,
  title: PropTypes.string
};
(0, _reactLifecyclesCompat.polyfill)(Button);
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=button.js.map


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = function ButtonGroup(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);

    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
    // small => sm

    var sizeCls = '';

    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;

      case 'small':
        sizeCls = 'sm';
        break;

      default:
        break;
    }

    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
    return React.createElement("div", _extends({}, others, {
      className: classes
    }));
  });
};

var _default = ButtonGroup;
exports["default"] = _default;
//# sourceMappingURL=button-group.js.map


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(912);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-form {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-form legend {\n  display: block;\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 16px;\n  line-height: inherit;\n  border: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-form label {\n  font-size: 14px;\n}\n.ant-form input[type='search'] {\n  box-sizing: border-box;\n}\n.ant-form input[type='radio'],\n.ant-form input[type='checkbox'] {\n  line-height: normal;\n}\n.ant-form input[type='file'] {\n  display: block;\n}\n.ant-form input[type='range'] {\n  display: block;\n  width: 100%;\n}\n.ant-form select[multiple],\n.ant-form select[size] {\n  height: auto;\n}\n.ant-form input[type='file']:focus,\n.ant-form input[type='radio']:focus,\n.ant-form input[type='checkbox']:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.ant-form output {\n  display: block;\n  padding-top: 15px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n}\n.ant-form-item-required::before {\n  display: inline-block;\n  margin-right: 4px;\n  color: #f5222d;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n.ant-form-hide-required-mark .ant-form-item-required::before {\n  display: none;\n}\n.ant-form-item-label > label {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-form-item-label > label::after {\n  content: ':';\n  position: relative;\n  top: -0.5px;\n  margin: 0 8px 0 2px;\n}\n.ant-form-item-label > label.ant-form-item-no-colon::after {\n  content: ' ';\n}\n.ant-form-item {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin-bottom: 24px;\n  vertical-align: top;\n}\n.ant-form-item label {\n  position: relative;\n}\n.ant-form-item label > .anticon {\n  font-size: 14px;\n  vertical-align: top;\n}\n.ant-form-item-control {\n  position: relative;\n  line-height: 40px;\n  zoom: 1;\n}\n.ant-form-item-control::before,\n.ant-form-item-control::after {\n  display: table;\n  content: '';\n}\n.ant-form-item-control::after {\n  clear: both;\n}\n.ant-form-item-children {\n  position: relative;\n}\n.ant-form-item-with-help {\n  margin-bottom: 5px;\n}\n.ant-form-item-label {\n  display: inline-block;\n  overflow: hidden;\n  line-height: 39.9999px;\n  white-space: nowrap;\n  text-align: right;\n  vertical-align: middle;\n}\n.ant-form-item-label-left {\n  text-align: left;\n}\n.ant-form-item .ant-switch {\n  margin: 2px 0 4px;\n}\n.ant-form-explain,\n.ant-form-extra {\n  clear: both;\n  min-height: 22px;\n  margin-top: -2px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  line-height: 1.5;\n  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-form-explain {\n  margin-bottom: -1px;\n}\n.ant-form-extra {\n  padding-top: 4px;\n}\n.ant-form-text {\n  display: inline-block;\n  padding-right: 8px;\n}\n.ant-form-split {\n  display: block;\n  text-align: center;\n}\nform .has-feedback .ant-input {\n  padding-right: 30px;\n}\nform .has-feedback .ant-input-affix-wrapper .ant-input-suffix {\n  padding-right: 18px;\n}\nform .has-feedback .ant-input-affix-wrapper .ant-input {\n  padding-right: 49px;\n}\nform .has-feedback .ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input {\n  padding-right: 68px;\n}\nform .has-feedback > .ant-select .ant-select-arrow,\nform .has-feedback > .ant-select .ant-select-selection__clear,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection__clear {\n  right: 28px;\n}\nform .has-feedback > .ant-select .ant-select-selection-selected-value,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {\n  padding-right: 42px;\n}\nform .has-feedback .ant-cascader-picker-arrow {\n  margin-right: 17px;\n}\nform .has-feedback .ant-cascader-picker-clear {\n  right: 28px;\n}\nform .has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {\n  right: 28px;\n}\nform .has-feedback .ant-calendar-picker-icon,\nform .has-feedback .ant-time-picker-icon,\nform .has-feedback .ant-calendar-picker-clear,\nform .has-feedback .ant-time-picker-clear {\n  right: 28px;\n}\nform .ant-mentions,\nform textarea.ant-input {\n  height: auto;\n  margin-bottom: 4px;\n}\nform .ant-upload {\n  background: transparent;\n}\nform input[type='radio'],\nform input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\nform .ant-radio-inline,\nform .ant-checkbox-inline {\n  display: inline-block;\n  margin-left: 8px;\n  font-weight: normal;\n  vertical-align: middle;\n  cursor: pointer;\n}\nform .ant-radio-inline:first-child,\nform .ant-checkbox-inline:first-child {\n  margin-left: 0;\n}\nform .ant-checkbox-vertical,\nform .ant-radio-vertical {\n  display: block;\n}\nform .ant-checkbox-vertical + .ant-checkbox-vertical,\nform .ant-radio-vertical + .ant-radio-vertical {\n  margin-left: 0;\n}\nform .ant-input-number + .ant-form-text {\n  margin-left: 8px;\n}\nform .ant-input-number-handler-wrap {\n  z-index: 2;\n}\nform .ant-select,\nform .ant-cascader-picker {\n  width: 100%;\n}\nform .ant-input-group .ant-select,\nform .ant-input-group .ant-cascader-picker {\n  width: auto;\n}\nform :not(.ant-input-group-wrapper) > .ant-input-group,\nform .ant-input-group-wrapper {\n  display: inline-block;\n  vertical-align: middle;\n}\nform:not(.ant-form-vertical) :not(.ant-input-group-wrapper) > .ant-input-group,\nform:not(.ant-form-vertical) .ant-input-group-wrapper {\n  position: relative;\n  top: -1px;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  display: block;\n  margin: 0;\n  padding: 0 0 8px;\n  line-height: 1.5;\n  white-space: initial;\n  text-align: left;\n}\n.ant-form-vertical .ant-form-item-label label::after,\n.ant-col-24.ant-form-item-label label::after,\n.ant-col-xl-24.ant-form-item-label label::after {\n  display: none;\n}\n.ant-form-vertical .ant-form-item {\n  padding-bottom: 8px;\n}\n.ant-form-vertical .ant-form-item-control {\n  line-height: 1.5;\n}\n.ant-form-vertical .ant-form-explain {\n  margin-top: 2px;\n  margin-bottom: -5px;\n}\n.ant-form-vertical .ant-form-extra {\n  margin-top: 2px;\n  margin-bottom: -4px;\n}\n@media (max-width: 575px) {\n  .ant-form-item-label,\n  .ant-form-item-control-wrapper {\n    display: block;\n    width: 100%;\n  }\n  .ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-form-item-label label::after {\n    display: none;\n  }\n  .ant-col-xs-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xs-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .ant-col-sm-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-sm-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .ant-col-md-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-md-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-col-lg-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-lg-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-col-xl-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.5;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xl-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n.ant-form-inline .ant-form-item {\n  display: inline-block;\n  margin-right: 16px;\n  margin-bottom: 0;\n}\n.ant-form-inline .ant-form-item-with-help {\n  margin-bottom: 24px;\n}\n.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper,\n.ant-form-inline .ant-form-item > .ant-form-item-label {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-form-inline .ant-form-text {\n  display: inline-block;\n}\n.ant-form-inline .has-feedback {\n  display: inline-block;\n}\n.has-success.has-feedback .ant-form-item-children-icon,\n.has-warning.has-feedback .ant-form-item-children-icon,\n.has-error.has-feedback .ant-form-item-children-icon,\n.is-validating.has-feedback .ant-form-item-children-icon {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  z-index: 1;\n  width: 32px;\n  height: 20px;\n  margin-top: -10px;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  visibility: visible;\n  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  pointer-events: none;\n}\n.has-success.has-feedback .ant-form-item-children-icon svg,\n.has-warning.has-feedback .ant-form-item-children-icon svg,\n.has-error.has-feedback .ant-form-item-children-icon svg,\n.is-validating.has-feedback .ant-form-item-children-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.has-success.has-feedback .ant-form-item-children-icon {\n  color: #52c41a;\n  animation-name: diffZoomIn1 !important;\n}\n.has-warning .ant-form-explain,\n.has-warning .ant-form-split {\n  color: #faad14;\n}\n.has-warning .ant-input,\n.has-warning .ant-input:hover {\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #faad14;\n}\n.has-warning .ant-input:focus {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-input:not([disabled]):hover {\n  border-color: #faad14;\n}\n.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-input-affix-wrapper .ant-input,\n.has-warning .ant-input-affix-wrapper .ant-input:hover {\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #faad14;\n}\n.has-warning .ant-input-affix-wrapper .ant-input:focus {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #faad14;\n}\n.has-warning .ant-input-prefix {\n  color: #faad14;\n}\n.has-warning .ant-input-group-addon {\n  color: #faad14;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #faad14;\n}\n.has-warning .has-feedback {\n  color: #faad14;\n}\n.has-warning.has-feedback .ant-form-item-children-icon {\n  color: #faad14;\n  animation-name: diffZoomIn3 !important;\n}\n.has-warning .ant-select-selection {\n  border-color: #faad14;\n}\n.has-warning .ant-select-selection:hover {\n  border-color: #faad14;\n}\n.has-warning .ant-select-open .ant-select-selection,\n.has-warning .ant-select-focused .ant-select-selection {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-calendar-picker-icon::after,\n.has-warning .ant-time-picker-icon::after,\n.has-warning .ant-picker-icon::after,\n.has-warning .ant-select-arrow,\n.has-warning .ant-cascader-picker-arrow {\n  color: #faad14;\n}\n.has-warning .ant-input-number,\n.has-warning .ant-time-picker-input {\n  border-color: #faad14;\n}\n.has-warning .ant-input-number-focused,\n.has-warning .ant-time-picker-input-focused,\n.has-warning .ant-input-number:focus,\n.has-warning .ant-time-picker-input:focus {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-input-number:not([disabled]):hover,\n.has-warning .ant-time-picker-input:not([disabled]):hover {\n  border-color: #faad14;\n}\n.has-warning .ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #ffc53d;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);\n}\n.has-warning .ant-cascader-picker:hover .ant-cascader-input {\n  border-color: #faad14;\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-split {\n  color: #f5222d;\n}\n.has-error .ant-input,\n.has-error .ant-input:hover {\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #f5222d;\n}\n.has-error .ant-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-affix-wrapper .ant-input,\n.has-error .ant-input-affix-wrapper .ant-input:hover {\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #f5222d;\n}\n.has-error .ant-input-affix-wrapper .ant-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #f5222d;\n}\n.has-error .ant-input-prefix {\n  color: #f5222d;\n}\n.has-error .ant-input-group-addon {\n  color: #f5222d;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #f5222d;\n}\n.has-error .has-feedback {\n  color: #f5222d;\n}\n.has-error.has-feedback .ant-form-item-children-icon {\n  color: #f5222d;\n  animation-name: diffZoomIn2 !important;\n}\n.has-error .ant-select-selection {\n  border-color: #f5222d;\n}\n.has-error .ant-select-selection:hover {\n  border-color: #f5222d;\n}\n.has-error .ant-select-open .ant-select-selection,\n.has-error .ant-select-focused .ant-select-selection {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-select.ant-select-auto-complete .ant-input:focus {\n  border-color: #f5222d;\n}\n.has-error .ant-input-group-addon .ant-select-selection {\n  border-color: transparent;\n  box-shadow: none;\n}\n.has-error .ant-calendar-picker-icon::after,\n.has-error .ant-time-picker-icon::after,\n.has-error .ant-picker-icon::after,\n.has-error .ant-select-arrow,\n.has-error .ant-cascader-picker-arrow {\n  color: #f5222d;\n}\n.has-error .ant-input-number,\n.has-error .ant-time-picker-input {\n  border-color: #f5222d;\n}\n.has-error .ant-input-number-focused,\n.has-error .ant-time-picker-input-focused,\n.has-error .ant-input-number:focus,\n.has-error .ant-time-picker-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-number:not([disabled]):hover,\n.has-error .ant-time-picker-input:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-mention-wrapper .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-mention-wrapper.ant-mention-active:not([disabled]) .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-cascader-picker:hover .ant-cascader-input {\n  border-color: #f5222d;\n}\n.has-error .ant-transfer-list {\n  border-color: #f5222d;\n}\n.has-error .ant-transfer-list-search:not([disabled]) {\n  border-color: #d9d9d9;\n}\n.has-error .ant-transfer-list-search:not([disabled]):hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.has-error .ant-transfer-list-search:not([disabled]):focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.is-validating.has-feedback .ant-form-item-children-icon {\n  display: inline-block;\n  color: #4CDEF5;\n}\n.ant-advanced-search-form .ant-form-item {\n  margin-bottom: 24px;\n}\n.ant-advanced-search-form .ant-form-item-with-help {\n  margin-bottom: 5px;\n}\n.show-help-enter,\n.show-help-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.show-help-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.show-help-enter.show-help-enter-active,\n.show-help-appear.show-help-appear-active {\n  animation-name: antShowHelpIn;\n  animation-play-state: running;\n}\n.show-help-leave.show-help-leave-active {\n  animation-name: antShowHelpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.show-help-enter,\n.show-help-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.show-help-leave {\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n@keyframes antShowHelpIn {\n  0% {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes antShowHelpOut {\n  to {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n}\n@keyframes diffZoomIn1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn2 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn3 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n", ""]);

// exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _createDOMForm = _interopRequireDefault(__webpack_require__(914));

var _createFormField = _interopRequireDefault(__webpack_require__(438));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _configProvider = __webpack_require__(30);

var _type = __webpack_require__(81);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _FormItem = _interopRequireDefault(__webpack_require__(1003));

var _constants = __webpack_require__(439);

var _context = _interopRequireDefault(__webpack_require__(440));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _this.renderForm = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          hideRequiredMark = _this$props.hideRequiredMark,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          layout = _this$props.layout;
      var prefixCls = getPrefixCls('form', customizePrefixCls);
      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
      return React.createElement("form", _extends({}, formProps, {
        className: formClassName
      }));
    };

    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperCol = _this$props2.wrapperCol,
          labelAlign = _this$props2.labelAlign,
          labelCol = _this$props2.labelCol,
          layout = _this$props2.layout,
          colon = _this$props2.colon;
      return React.createElement(_context["default"].Provider, {
        value: {
          wrapperCol: wrapperCol,
          labelAlign: labelAlign,
          labelCol: labelCol,
          vertical: layout === 'vertical',
          colon: colon
        }
      }, React.createElement(_configProvider.ConfigConsumer, null, this.renderForm));
    }
  }]);

  return Form;
}(React.Component);

exports["default"] = Form;
Form.defaultProps = {
  colon: true,
  layout: 'horizontal',
  hideRequiredMark: false,
  onSubmit: function onSubmit(e) {
    e.preventDefault();
  }
};
Form.propTypes = {
  prefixCls: PropTypes.string,
  layout: PropTypes.oneOf(FormLayouts),
  children: PropTypes.any,
  onSubmit: PropTypes.func,
  hideRequiredMark: PropTypes.bool,
  colon: PropTypes.bool
};
Form.Item = _FormItem["default"];
Form.createFormField = _createFormField["default"];

Form.create = function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _createDOMForm["default"])(_extends(_extends({
    fieldNameProp: 'id'
  }, options), {
    fieldMetaProp: _constants.FIELD_META_PROP,
    fieldDataProp: _constants.FIELD_DATA_PROP
  }));
};
//# sourceMappingURL=Form.js.map


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domScrollIntoView = __webpack_require__(292);

var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);

var _has = __webpack_require__(917);

var _has2 = _interopRequireDefault(_has);

var _createBaseForm = __webpack_require__(435);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

var _createForm = __webpack_require__(1002);

var _utils = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function computedStyle(el, prop) {
  var getComputedStyle = window.getComputedStyle;
  var style =
  // If we have getComputedStyle
  getComputedStyle ?
  // Query it
  // TODO: From CSS-Query notes, we might need (node, null) for FF
  getComputedStyle(el) :

  // Otherwise, we are in IE and use currentStyle
  el.currentStyle;
  if (style) {
    return style[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })];
  }
  return undefined;
}

function getScrollableContainer(n) {
  var node = n;
  var nodeName = void 0;
  /* eslint no-cond-assign:0 */
  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
    var overflowY = computedStyle(node, 'overflowY');
    // https://stackoverflow.com/a/36900407/3040605
    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentNode;
  }
  return nodeName === 'body' ? node.ownerDocument : node;
}

var mixin = {
  getForm: function getForm() {
    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
      validateFieldsAndScroll: this.validateFieldsAndScroll
    });
  },
  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
    var _this = this;

    var _getParams = (0, _utils.getParams)(ns, opt, cb),
        names = _getParams.names,
        callback = _getParams.callback,
        options = _getParams.options;

    var newCb = function newCb(error, values) {
      if (error) {
        var validNames = _this.fieldsStore.getValidFieldsName();
        var firstNode = void 0;
        var firstTop = void 0;

        validNames.forEach(function (name) {
          if ((0, _has2['default'])(error, name)) {
            var instance = _this.getFieldInstance(name);
            if (instance) {
              var node = _reactDom2['default'].findDOMNode(instance);
              var top = node.getBoundingClientRect().top;
              if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                firstTop = top;
                firstNode = node;
              }
            }
          }
        });

        if (firstNode) {
          var c = options.container || getScrollableContainer(firstNode);
          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
            onlyScrollIfNeeded: true
          }, options.scroll));
        }
      }

      if (typeof callback === 'function') {
        callback(error, values);
      }
    };

    return this.validateFields(names, options, newCb);
  }
};

function createDOMForm(option) {
  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
}

exports['default'] = createDOMForm;
module.exports = exports['default'];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(916);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(918),
    hasPath = __webpack_require__(919);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(293),
    isArguments = __webpack_require__(956),
    isArray = __webpack_require__(200),
    isIndex = __webpack_require__(434),
    isLength = __webpack_require__(958),
    toKey = __webpack_require__(302);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(200),
    isSymbol = __webpack_require__(294);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(925);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(926);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(927);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(928),
    mapCacheDelete = __webpack_require__(948),
    mapCacheGet = __webpack_require__(950),
    mapCacheHas = __webpack_require__(951),
    mapCacheSet = __webpack_require__(952);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(929),
    ListCache = __webpack_require__(941),
    Map = __webpack_require__(947);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(930),
    hashDelete = __webpack_require__(937),
    hashGet = __webpack_require__(938),
    hashHas = __webpack_require__(939),
    hashSet = __webpack_require__(940);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(201);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(932),
    isMasked = __webpack_require__(933),
    isObject = __webpack_require__(300),
    toSource = __webpack_require__(935);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(295),
    isObject = __webpack_require__(300);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(934);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(297);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 937 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(201);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(201);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(201);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(942),
    listCacheDelete = __webpack_require__(943),
    listCacheGet = __webpack_require__(944),
    listCacheHas = __webpack_require__(945),
    listCacheSet = __webpack_require__(946);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(299),
    root = __webpack_require__(297);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(954);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296),
    arrayMap = __webpack_require__(955),
    isArray = __webpack_require__(200),
    isSymbol = __webpack_require__(294);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 955 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(957),
    isObjectLike = __webpack_require__(298);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(295),
    isObjectLike = __webpack_require__(298);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(960), __esModule: true };

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(419);
__webpack_require__(961);
module.exports = __webpack_require__(74).Array.from;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(273);
var $export = __webpack_require__(97);
var toObject = __webpack_require__(160);
var call = __webpack_require__(962);
var isArrayIter = __webpack_require__(963);
var toLength = __webpack_require__(416);
var createProperty = __webpack_require__(964);
var getIterFn = __webpack_require__(965);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(128);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(161);
var ITERATOR = __webpack_require__(85)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(99);
var createDesc = __webpack_require__(159);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(966);
var ITERATOR = __webpack_require__(85)('iterator');
var Iterators = __webpack_require__(161);
module.exports = __webpack_require__(74).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(275);
var TAG = __webpack_require__(85)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(85)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(969);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(95);

var emptyObject = __webpack_require__(970);
var _invariant = __webpack_require__(971);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!_react.default.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

var _default = unsafeLifecyclesPolyfill;
exports.default = _default;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(61);

var _validator = __webpack_require__(974);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(994);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(975);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(981);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(982);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(983);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(984);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(985);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(986);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(987);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(988);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(989);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(990);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(991);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(992);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(993);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(436);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(61);

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(73);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(996);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(293),
    toKey = __webpack_require__(302);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(998),
    castPath = __webpack_require__(293),
    isIndex = __webpack_require__(434),
    isObject = __webpack_require__(300),
    toKey = __webpack_require__(302);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(999),
    eq = __webpack_require__(301);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1000);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(299);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

exports['default'] = createFieldsStore;

var _set = __webpack_require__(437);

var _set2 = _interopRequireDefault(_set);

var _createFormField = __webpack_require__(438);

var _createFormField2 = _interopRequireDefault(_createFormField);

var _utils = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function partOf(a, b) {
  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
}

function internalFlattenFields(fields) {
  return (0, _utils.flattenFields)(fields, function (_, node) {
    return (0, _createFormField.isFormField)(node);
  }, 'You must wrap field data with `createFormField`.');
}

var FieldsStore = function () {
  function FieldsStore(fields) {
    (0, _classCallCheck3['default'])(this, FieldsStore);

    _initialiseProps.call(this);

    this.fields = internalFlattenFields(fields);
    this.fieldsMeta = {};
  }

  (0, _createClass3['default'])(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      this.fields = internalFlattenFields(fields);
    }
  }, {
    key: 'flattenRegisteredFields',
    value: function flattenRegisteredFields(fields) {
      var validFieldsName = this.getAllFieldsName();
      return (0, _utils.flattenFields)(fields, function (path) {
        return validFieldsName.indexOf(path) >= 0;
      }, 'You cannot set a form field before rendering a field associated with the value.');
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = _this.getFieldMeta(f);
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var fields = this.fields;

      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
      return names.reduce(function (acc, name) {
        var field = fields[name];
        if (field && 'value' in field) {
          acc[name] = {};
        }
        return acc;
      }, {});
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'setFieldsAsDirty',
    value: function setFieldsAsDirty() {
      var _this2 = this;

      Object.keys(this.fields).forEach(function (name) {
        var field = _this2.fields[name];
        var fieldMeta = _this2.fieldsMeta[name];
        if (field && fieldMeta && (0, _utils.hasRules)(fieldMeta.validate)) {
          _this2.fields[name] = (0, _extends3['default'])({}, field, {
            dirty: true
          });
        }
      });
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
      return this.fieldsMeta[name];
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.getFieldMeta(name);
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var _this3 = this;

      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !_this3.getFieldMeta(name).hidden;
      }) : [];
    }
  }, {
    key: 'getAllFieldsName',
    value: function getAllFieldsName() {
      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta) : [];
    }
  }, {
    key: 'getValidFieldsFullName',
    value: function getValidFieldsFullName(maybePartialName) {
      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
      return this.getValidFieldsName().filter(function (fullName) {
        return maybePartialNames.some(function (partialName) {
          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
        });
      });
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;

      var field = this.getField(name);
      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return (0, _extends3['default'])({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getNotCollectedFields',
    value: function getNotCollectedFields() {
      var _this4 = this;

      var fieldsName = this.getValidFieldsName();
      return fieldsName.filter(function (name) {
        return !_this4.fields[name];
      }).map(function (name) {
        return {
          name: name,
          dirty: false,
          value: _this4.getFieldMeta(name).initialValue
        };
      }).reduce(function (acc, field) {
        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
      }, {});
    }
  }, {
    key: 'getNestedAllFields',
    value: function getNestedAllFields() {
      var _this5 = this;

      return Object.keys(this.fields).reduce(function (acc, name) {
        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this5.fields[name]));
      }, this.getNotCollectedFields());
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getNestedFields',
    value: function getNestedFields(names, getter) {
      var fields = names || this.getValidFieldsName();
      return fields.reduce(function (acc, f) {
        return (0, _set2['default'])(acc, f, getter(f));
      }, {});
    }
  }, {
    key: 'getNestedField',
    value: function getNestedField(name, getter) {
      var fullNames = this.getValidFieldsFullName(name);
      if (fullNames.length === 0 || // Not registered
      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
      ) {
          return getter(name);
        }
      var isArrayValue = fullNames[0][name.length] === '[';
      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
      return fullNames.reduce(function (acc, fullName) {
        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
      }, isArrayValue ? [] : {});
    }
  }, {
    key: 'isValidNestedFieldName',


    // @private
    // BG: `a` and `a.b` cannot be use in the same form
    value: function isValidNestedFieldName(name) {
      var names = this.getAllFieldsName();
      return names.every(function (n) {
        return !partOf(n, name) && !partOf(name, n);
      });
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);
  return FieldsStore;
}();

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.setFieldsInitialValue = function (initialValues) {
    var flattenedInitialValues = _this6.flattenRegisteredFields(initialValues);
    var fieldsMeta = _this6.fieldsMeta;
    Object.keys(flattenedInitialValues).forEach(function (name) {
      if (fieldsMeta[name]) {
        _this6.setFieldMeta(name, (0, _extends3['default'])({}, _this6.getFieldMeta(name), {
          initialValue: flattenedInitialValues[name]
        }));
      }
    });
  };

  this.getAllValues = function () {
    var fieldsMeta = _this6.fieldsMeta,
        fields = _this6.fields;

    return Object.keys(fieldsMeta).reduce(function (acc, name) {
      return (0, _set2['default'])(acc, name, _this6.getValueFromFields(name, fields));
    }, {});
  };

  this.getFieldsValue = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldValue);
  };

  this.getFieldValue = function (name) {
    var fields = _this6.fields;

    return _this6.getNestedField(name, function (fullName) {
      return _this6.getValueFromFields(fullName, fields);
    });
  };

  this.getFieldsError = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldError);
  };

  this.getFieldError = function (name) {
    return _this6.getNestedField(name, function (fullName) {
      return (0, _utils.getErrorStrs)(_this6.getFieldMember(fullName, 'errors'));
    });
  };

  this.isFieldValidating = function (name) {
    return _this6.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this6.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new FieldsStore(fields);
}
module.exports = exports['default'];

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixin = undefined;

var _createBaseForm = __webpack_require__(435);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mixin = exports.mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return (0, _createBaseForm2['default'])(options, [mixin]);
}

exports['default'] = createForm;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _rcAnimate = _interopRequireDefault(__webpack_require__(90));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _row = _interopRequireDefault(__webpack_require__(404));

var _col = _interopRequireDefault(__webpack_require__(410));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _type = __webpack_require__(81);

var _constants = __webpack_require__(439);

var _context = _interopRequireDefault(__webpack_require__(440));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
var FormLabelAligns = (0, _type.tuple)('left', 'right');

function intersperseSpace(list) {
  return list.reduce(function (current, item) {
    return [].concat(_toConsumableArray(current), [' ', item]);
  }, []).slice(1);
}

var FormItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormItem, _React$Component);

  function FormItem() {
    var _this;

    _classCallCheck(this, FormItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormItem).apply(this, arguments));
    _this.helpShow = false; // Resolve duplicated ids bug between different forms
    // https://github.com/ant-design/ant-design/issues/7351

    _this.onLabelClick = function () {
      var id = _this.props.id || _this.getId();

      if (!id) {
        return;
      }

      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));

      if (control && control.focus) {
        control.focus();
      }
    };

    _this.onHelpAnimEnd = function (_key, helpShow) {
      _this.helpShow = helpShow;

      if (!helpShow) {
        _this.setState({});
      }
    };

    _this.renderFormItem = function (_ref) {
      var _itemClassName;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          style = _a.style,
          className = _a.className,
          restProps = __rest(_a, ["prefixCls", "style", "className"]);

      var prefixCls = getPrefixCls('form', customizePrefixCls);

      var children = _this.renderChildren(prefixCls);

      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
      return React.createElement(_row["default"], _extends({
        className: (0, _classnames["default"])(itemClassName),
        style: style
      }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
        key: "row"
      }), children);
    };

    return _this;
  }

  _createClass(FormItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          children = _this$props.children,
          help = _this$props.help,
          validateStatus = _this$props.validateStatus,
          id = _this$props.id;
      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
    }
  }, {
    key: "getHelpMessage",
    value: function getHelpMessage() {
      var help = this.props.help;

      if (help === undefined && this.getOnlyControl()) {
        var _this$getField = this.getField(),
            errors = _this$getField.errors;

        if (errors) {
          return intersperseSpace(errors.map(function (e, index) {
            var node = null;

            if (React.isValidElement(e)) {
              node = e;
            } else if (React.isValidElement(e.message)) {
              node = e.message;
            } // eslint-disable-next-line react/no-array-index-key


            return node ? React.cloneElement(node, {
              key: index
            }) : e.message;
          }));
        }

        return '';
      }

      return help;
    }
  }, {
    key: "getControls",
    value: function getControls(children, recursively) {
      var controls = [];
      var childrenArray = React.Children.toArray(children);

      for (var i = 0; i < childrenArray.length; i++) {
        if (!recursively && controls.length > 0) {
          break;
        }

        var child = childrenArray[i];

        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
          continue;
        }

        if (!child.props) {
          continue;
        }

        if (_constants.FIELD_META_PROP in child.props) {
          // And means FIELD_DATA_PROP in child.props, too.
          controls.push(child);
        } else if (child.props.children) {
          controls = controls.concat(this.getControls(child.props.children, recursively));
        }
      }

      return controls;
    }
  }, {
    key: "getOnlyControl",
    value: function getOnlyControl() {
      var child = this.getControls(this.props.children, false)[0];
      return child !== undefined ? child : null;
    }
  }, {
    key: "getChildProp",
    value: function getChildProp(prop) {
      var child = this.getOnlyControl();
      return child && child.props && child.props[prop];
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.getChildProp('id');
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      return this.getChildProp(_constants.FIELD_META_PROP);
    }
  }, {
    key: "getField",
    value: function getField() {
      return this.getChildProp(_constants.FIELD_DATA_PROP);
    }
  }, {
    key: "getValidateStatus",
    value: function getValidateStatus() {
      var onlyControl = this.getOnlyControl();

      if (!onlyControl) {
        return '';
      }

      var field = this.getField();

      if (field.validating) {
        return 'validating';
      }

      if (field.errors) {
        return 'error';
      }

      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;

      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
        return 'success';
      }

      return '';
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      var required = this.props.required;

      if (required !== undefined) {
        return required;
      }

      if (this.getOnlyControl()) {
        var meta = this.getMeta() || {};
        var validate = meta.validate || [];
        return validate.filter(function (item) {
          return !!item.rules;
        }).some(function (item) {
          return item.rules.some(function (rule) {
            return rule.required;
          });
        });
      }

      return false;
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(prefixCls) {
      var help = this.getHelpMessage();
      var children = help ? React.createElement("div", {
        className: "".concat(prefixCls, "-explain"),
        key: "help"
      }, help) : null;

      if (children) {
        this.helpShow = !!children;
      }

      return React.createElement(_rcAnimate["default"], {
        transitionName: "show-help",
        component: "",
        transitionAppear: true,
        key: "help",
        onEnd: this.onHelpAnimEnd
      }, children);
    }
  }, {
    key: "renderExtra",
    value: function renderExtra(prefixCls) {
      var extra = this.props.extra;
      return extra ? React.createElement("div", {
        className: "".concat(prefixCls, "-extra")
      }, extra) : null;
    }
  }, {
    key: "renderValidateWrapper",
    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
      var props = this.props;
      var onlyControl = this.getOnlyControl;
      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
      var classes = "".concat(prefixCls, "-item-control");

      if (validateStatus) {
        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
          'has-feedback': props.hasFeedback || validateStatus === 'validating',
          'has-success': validateStatus === 'success',
          'has-warning': validateStatus === 'warning',
          'has-error': validateStatus === 'error',
          'is-validating': validateStatus === 'validating'
        });
      }

      var iconType = '';

      switch (validateStatus) {
        case 'success':
          iconType = 'check-circle';
          break;

        case 'warning':
          iconType = 'exclamation-circle';
          break;

        case 'error':
          iconType = 'close-circle';
          break;

        case 'validating':
          iconType = 'loading';
          break;

        default:
          iconType = '';
          break;
      }

      var icon = props.hasFeedback && iconType ? React.createElement("span", {
        className: "".concat(prefixCls, "-item-children-icon")
      }, React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      })) : null;
      return React.createElement("div", {
        className: classes
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-item-children")
      }, c1, icon), c2, c3);
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(prefixCls, children) {
      var _this2 = this;

      return React.createElement(_context["default"].Consumer, {
        key: "wrapper"
      }, function (_ref2) {
        var contextWrapperCol = _ref2.wrapperCol,
            vertical = _ref2.vertical;
        var wrapperCol = _this2.props.wrapperCol;
        var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
        var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless

        return React.createElement(_context["default"].Provider, {
          value: {
            vertical: vertical
          }
        }, React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
          className: className
        }), children));
      });
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(prefixCls) {
      var _this3 = this;

      return React.createElement(_context["default"].Consumer, {
        key: "label"
      }, function (_ref3) {
        var _classNames;

        var vertical = _ref3.vertical,
            contextLabelAlign = _ref3.labelAlign,
            contextLabelCol = _ref3.labelCol,
            contextColon = _ref3.colon;
        var _this3$props = _this3.props,
            label = _this3$props.label,
            labelCol = _this3$props.labelCol,
            labelAlign = _this3$props.labelAlign,
            colon = _this3$props.colon,
            id = _this3$props.id,
            htmlFor = _this3$props.htmlFor;

        var required = _this3.isRequired();

        var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
        var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
        var labelClsBasic = "".concat(prefixCls, "-item-label");
        var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
        var labelChildren = label; // Keep label is original where there should have no colon

        var computedColon = colon === true || contextColon !== false && colon !== false;
        var haveColon = computedColon && !vertical; // Remove duplicated user input colon

        if (haveColon && typeof label === 'string' && label.trim() !== '') {
          labelChildren = label.replace(/[：:]\s*$/, '');
        }

        var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
        return label ? React.createElement(_col["default"], _extends({}, mergedLabelCol, {
          className: labelColClassName
        }), React.createElement("label", {
          htmlFor: htmlFor || id || _this3.getId(),
          className: labelClassName,
          title: typeof label === 'string' ? label : '',
          onClick: _this3.onLabelClick
        }, labelChildren)) : null;
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(prefixCls) {
      var children = this.props.children;
      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem);
    }
  }]);

  return FormItem;
}(React.Component);

exports["default"] = FormItem;
FormItem.defaultProps = {
  hasFeedback: false
};
FormItem.propTypes = {
  prefixCls: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelCol: PropTypes.object,
  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  validateStatus: PropTypes.oneOf(ValidateStatuses),
  hasFeedback: PropTypes.bool,
  wrapperCol: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  colon: PropTypes.bool
};
//# sourceMappingURL=FormItem.js.map


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var ConsentFormStep1 = function ConsentFormStep1(props) {
  if (props.currentStep !== 'Step 1') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('siteID', { initialValue: props.siteID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input site id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'medicine-box', style: { color: '#FAFAFA' } }), id: 'siteID', name: 'siteID', placeholder: 'Site ID', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('userID', { initialValue: props.userID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input user id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), id: 'userID', name: 'userID', placeholder: 'User ID', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('subjectID', { initialValue: props.subjectID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input subject id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'subjectID', name: 'subjectID', placeholder: 'Subject ID', allowClear: true, size: 'large' }))));
};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1006);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-input {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  padding: 4px 11px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n.ant-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-input:focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 32px;\n  line-height: 1.5;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-input-group[class*='col-'] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-input-group > [class*='col-'] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*='col-']:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n  text-align: inherit;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-group .ant-input:hover {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-group-addon {\n  position: relative;\n  padding: 0 11px;\n  color: #F5F5F5;\n  font-weight: normal;\n  font-size: 14px;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -5px -11px;\n}\n.ant-input-group-addon .ant-select .ant-select-selection {\n  margin: -1px;\n  background-color: inherit;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selection,\n.ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #4CDEF5;\n}\n.ant-input-group-addon > i:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  content: '';\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,\n.ant-input-group-addon:first-child .ant-select .ant-select-selection {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,\n.ant-input-group-addon:last-child .ant-select .ant-select-selection {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-group-lg .ant-select-selection--single {\n  height: 40px;\n}\n.ant-input-group-sm .ant-select-selection--single {\n  height: 24px;\n}\n.ant-input-group .ant-input-affix-wrapper {\n  display: table-cell;\n  float: left;\n  width: 100%;\n}\n.ant-input-group.ant-input-group-compact {\n  display: block;\n  zoom: 1;\n}\n.ant-input-group.ant-input-group-compact::before,\n.ant-input-group.ant-input-group-compact::after {\n  display: table;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::after {\n  clear: both;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > * {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > *:not(:last-child) {\n  margin-right: -1px;\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input {\n  border-right-width: 1px;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:hover,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:hover,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:focus,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:focus,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {\n  border-right-width: 1px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {\n  vertical-align: top;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n  vertical-align: top;\n}\n.ant-input-affix-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n}\n.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-input-affix-wrapper .ant-input {\n  position: relative;\n  text-align: inherit;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  color: #F5F5F5;\n  line-height: 0;\n  transform: translateY(-50%);\n}\n.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),\n.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {\n  line-height: 1.5;\n}\n.ant-input-affix-wrapper .ant-input-disabled ~ .ant-input-suffix .anticon {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  left: 12px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  right: 12px;\n}\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 30px;\n}\n.ant-input-affix-wrapper .ant-input:not(:last-child) {\n  padding-right: 30px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input:not(:last-child) {\n  padding-right: 49px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input {\n  padding-right: 22px;\n}\n.ant-input-affix-wrapper .ant-input {\n  min-height: 100%;\n}\n.ant-input-password-icon {\n  color: rgba(0, 0, 0, 0.45);\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-input-password-icon:hover {\n  color: #333;\n}\n.ant-input-clear-icon {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  vertical-align: 0;\n}\n.ant-input-clear-icon:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-input-clear-icon:active {\n  color: #424242;\n}\n.ant-input-clear-icon + i {\n  margin-left: 6px;\n}\n.ant-input-textarea-clear-icon {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 8px 8px 0 0;\n}\n.ant-input-textarea-clear-icon:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-input-textarea-clear-icon:active {\n  color: #424242;\n}\n.ant-input-textarea-clear-icon + i {\n  margin-left: 6px;\n}\n.ant-input-search-icon {\n  color: rgba(0, 0, 0, 0.45);\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-input-search-icon:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n.ant-input-search-enter-button input {\n  border-right: 0;\n}\n.ant-input-search-enter-button + .ant-input-group-addon,\n.ant-input-search-enter-button input + .ant-input-group-addon {\n  padding: 0;\n  border: 0;\n}\n.ant-input-search-enter-button + .ant-input-group-addon .ant-input-search-button,\n.ant-input-search-enter-button input + .ant-input-group-addon .ant-input-search-button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Group = function Group(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
    return React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

var _default = Group;
exports["default"] = _default;
//# sourceMappingURL=Group.js.map


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _isMobile = __webpack_require__(1009);

var _Input = _interopRequireDefault(__webpack_require__(166));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(10));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).apply(this, arguments));

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.onChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSearch = _this$props.onSearch;

      if (e && e.target && e.type === 'click' && onSearch) {
        onSearch(e.target.value, e);
      }

      if (onChange) {
        onChange(e);
      }
    };

    _this.onSearch = function (e) {
      var _this$props2 = _this.props,
          onSearch = _this$props2.onSearch,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled;

      if (loading || disabled) {
        return;
      }

      if (onSearch) {
        onSearch(_this.input.input.value, e);
      }

      if (!(0, _isMobile.isMobile)({
        tablet: true
      })) {
        _this.input.focus();
      }
    };

    _this.renderLoading = function (prefixCls) {
      var _this$props3 = _this.props,
          enterButton = _this$props3.enterButton,
          size = _this$props3.size;

      if (enterButton) {
        return React.createElement(_button["default"], {
          className: "".concat(prefixCls, "-button"),
          type: "primary",
          size: size,
          key: "enterButton"
        }, React.createElement(_icon["default"], {
          type: "loading"
        }));
      }

      return React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "loading",
        key: "loadingIcon"
      });
    };

    _this.renderSuffix = function (prefixCls) {
      var _this$props4 = _this.props,
          suffix = _this$props4.suffix,
          enterButton = _this$props4.enterButton,
          loading = _this$props4.loading;

      if (loading && !enterButton) {
        return [suffix, _this.renderLoading(prefixCls)];
      }

      if (enterButton) return suffix;
      var icon = React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "search",
        key: "searchIcon",
        onClick: _this.onSearch
      });

      if (suffix) {
        return [React.isValidElement(suffix) ? React.cloneElement(suffix, {
          key: 'suffix'
        }) : null, icon];
      }

      return icon;
    };

    _this.renderAddonAfter = function (prefixCls) {
      var _this$props5 = _this.props,
          enterButton = _this$props5.enterButton,
          size = _this$props5.size,
          disabled = _this$props5.disabled,
          addonAfter = _this$props5.addonAfter,
          loading = _this$props5.loading;
      var btnClassName = "".concat(prefixCls, "-button");

      if (loading && enterButton) {
        return [_this.renderLoading(prefixCls), addonAfter];
      }

      if (!enterButton) return addonAfter;
      var button;
      var enterButtonAsElement = enterButton;
      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;

      if (isAntdButton || enterButtonAsElement.type === 'button') {
        button = React.cloneElement(enterButtonAsElement, _extends({
          onClick: _this.onSearch,
          key: 'enterButton'
        }, isAntdButton ? {
          className: btnClassName,
          size: size
        } : {}));
      } else {
        button = React.createElement(_button["default"], {
          className: btnClassName,
          type: "primary",
          size: size,
          disabled: disabled,
          key: "enterButton",
          onClick: _this.onSearch
        }, enterButton === true ? React.createElement(_icon["default"], {
          type: "search"
        }) : enterButton);
      }

      if (addonAfter) {
        return [button, React.isValidElement(addonAfter) ? React.cloneElement(addonAfter, {
          key: 'addonAfter'
        }) : null];
      }

      return button;
    };

    _this.renderSearch = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeInputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          enterButton = _a.enterButton,
          className = _a.className,
          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);

      delete restProps.onSearch;
      delete restProps.loading;
      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
      var inputClassName;

      if (enterButton) {
        var _classNames;

        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
      } else {
        inputClassName = (0, _classnames["default"])(prefixCls, className);
      }

      return React.createElement(_Input["default"], _extends({
        onPressEnter: _this.onSearch
      }, restProps, {
        size: size,
        prefixCls: inputPrefixCls,
        addonAfter: _this.renderAddonAfter(prefixCls),
        suffix: _this.renderSuffix(prefixCls),
        onChange: _this.onChange,
        ref: _this.saveInput,
        className: inputClassName
      }));
    };

    return _this;
  }

  _createClass(Search, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
    }
  }]);

  return Search;
}(React.Component);

exports["default"] = Search;
Search.defaultProps = {
  enterButton: false
};
//# sourceMappingURL=Search.js.map


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = isMobile
module.exports.isMobile = isMobile
module.exports.default = isMobile

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i

function isMobile (opts) {
  if (!opts) opts = {}
  var ua = opts.ua
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent']
  }
  if (typeof ua !== 'string') return false

  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true
  }

  return result
}


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(1011));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(1015));

var _raf = _interopRequireDefault(__webpack_require__(198));

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ResizableTextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ResizableTextArea, _React$Component);

  function ResizableTextArea(props) {
    var _this;

    _classCallCheck(this, ResizableTextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResizableTextArea).call(this, props));

    _this.saveTextArea = function (textArea) {
      _this.textArea = textArea;
    };

    _this.resizeOnNextFrame = function () {
      _raf["default"].cancel(_this.nextFrameActionId);

      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autoSize = _this.props.autoSize || _this.props.autosize;

      if (!autoSize || !_this.textArea) {
        return;
      }

      var minRows = autoSize.minRows,
          maxRows = autoSize.maxRows;
      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles,
        resizing: true
      }, function () {
        _raf["default"].cancel(_this.resizeFrameId);

        _this.resizeFrameId = (0, _raf["default"])(function () {
          _this.setState({
            resizing: false
          });
        });
      });
    };

    _this.renderTextArea = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          autoSize = _this$props.autoSize,
          autosize = _this$props.autosize,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var _this$state = _this.state,
          textareaStyles = _this$state.textareaStyles,
          resizing = _this$state.resizing;
      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator

      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
        overflow: 'hidden'
      } : null);

      return React.createElement(_rcResizeObserver["default"], {
        onResize: _this.resizeOnNextFrame,
        disabled: !(autoSize || autosize)
      }, React.createElement("textarea", _extends({}, otherProps, {
        className: cls,
        style: style,
        ref: _this.saveTextArea
      })));
    };

    _this.state = {
      textareaStyles: {},
      resizing: false
    };
    return _this;
  }

  _createClass(ResizableTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeTextarea();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content then recalculate the height as required.
      if (prevProps.value !== this.props.value) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.nextFrameActionId);

      _raf["default"].cancel(this.resizeFrameId);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderTextArea();
    }
  }]);

  return ResizableTextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
var _default = ResizableTextArea;
exports["default"] = _default;
//# sourceMappingURL=ResizableTextArea.js.map


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var findDOMNode_1 = __importDefault(__webpack_require__(1012));

var toArray_1 = __importDefault(__webpack_require__(443));

var warning_1 = __importDefault(__webpack_require__(189));

var ref_1 = __webpack_require__(1013);

var resize_observer_polyfill_1 = __importDefault(__webpack_require__(289));

var util_1 = __webpack_require__(1014);

var INTERNAL_PREFIX_KEY = 'rc-observer-key'; // Still need to be compatible with React 15, we use class component here

var ReactResizeObserver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactResizeObserver, _React$Component);

  function ReactResizeObserver() {
    var _this;

    _classCallCheck(this, ReactResizeObserver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactResizeObserver).apply(this, arguments));
    _this.resizeObserver = null;
    _this.childNode = null;
    _this.currentElement = null;
    _this.state = {
      width: 0,
      height: 0
    };

    _this.onResize = function (entries) {
      var onResize = _this.props.onResize;
      var target = entries[0].target;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          width = _target$getBoundingCl.width,
          height = _target$getBoundingCl.height;
      /**
       * Resize observer trigger when content size changed.
       * In most case we just care about element size,
       * let's use `boundary` instead of `contentRect` here to avoid shaking.
       */


      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);

      if (_this.state.width !== fixedWidth || _this.state.height !== fixedHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight
        };

        _this.setState(size);

        if (onResize) {
          onResize(size);
        }
      }
    };

    _this.setChildNode = function (node) {
      _this.childNode = node;
    };

    return _this;
  }

  _createClass(ReactResizeObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyObserver();
    }
  }, {
    key: "onComponentUpdated",
    value: function onComponentUpdated() {
      var disabled = this.props.disabled; // Unregister if disabled

      if (disabled) {
        this.destroyObserver();
        return;
      } // Unregister if element changed


      var element = findDOMNode_1.default(this.childNode || this);
      var elementChanged = element !== this.currentElement;

      if (elementChanged) {
        this.destroyObserver();
        this.currentElement = element;
      }

      if (!this.resizeObserver && element) {
        this.resizeObserver = new resize_observer_polyfill_1.default(this.onResize);
        this.resizeObserver.observe(element);
      }
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var childNodes = toArray_1.default(children);

      if (childNodes.length > 1) {
        warning_1.default(false, 'Find more than one child node with `children` in ResizeObserver. Will only observe first one.');
      } else if (childNodes.length === 0) {
        warning_1.default(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
        return null;
      }

      var childNode = childNodes[0];

      if (React.isValidElement(childNode) && util_1.supportRef(childNode)) {
        var ref = childNode.ref;
        childNodes[0] = React.cloneElement(childNode, {
          ref: ref_1.composeRef(ref, this.setChildNode)
        });
      }

      return childNodes.length === 1 ? childNodes[0] : childNodes.map(function (node, index) {
        if (!React.isValidElement(node) || 'key' in node && node.key !== null) {
          return node;
        }

        return React.cloneElement(node, {
          key: "".concat(INTERNAL_PREFIX_KEY, "-").concat(index)
        });
      });
    }
  }]);

  return ReactResizeObserver;
}(React.Component);

ReactResizeObserver.displayName = 'ResizeObserver';
exports.default = ReactResizeObserver;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findDOMNode;

var _reactDom = _interopRequireDefault(__webpack_require__(26));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return _reactDom.default.findDOMNode(node);
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillRef = fillRef;
exports.composeRef = composeRef;
exports.supportRef = supportRef;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */


function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}

function supportRef(nodeOrComponent) {
  // Function component node
  if (nodeOrComponent.type && nodeOrComponent.type.prototype && !nodeOrComponent.type.prototype.render) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && nodeOrComponent.prototype && !nodeOrComponent.prototype.render) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function supportRef(node) {
  // Function component
  if (node.type && node.type.prototype && !node.type.prototype.render) {
    return false;
  }

  return true;
}

exports.supportRef = supportRef;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNodeStyling = calculateNodeStyling;
exports["default"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea;

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY
  };
}
//# sourceMappingURL=calculateNodeHeight.js.map


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _Input = _interopRequireDefault(__webpack_require__(166));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};

var Password =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Password, _React$Component);

  function Password() {
    var _this;

    _classCallCheck(this, Password);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Password).apply(this, arguments));
    _this.state = {
      visible: false
    };

    _this.onVisibleChange = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setState(function (_ref) {
        var visible = _ref.visible;
        return {
          visible: !visible
        };
      });
    };

    _this.saveInput = function (instance) {
      if (instance && instance.input) {
        _this.input = instance.input;
      }
    };

    return _this;
  }

  _createClass(Password, [{
    key: "getIcon",
    value: function getIcon() {
      var _iconProps;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          action = _this$props.action;
      var iconTrigger = ActionMap[action] || '';
      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      }), _iconProps);
      return React.createElement(_icon["default"], iconProps);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          prefixCls = _a.prefixCls,
          inputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          visibilityToggle = _a.visibilityToggle,
          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);

      var suffixIcon = visibilityToggle && this.getIcon();
      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
      return React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
        type: this.state.visible ? 'text' : 'password',
        size: size,
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon,
        ref: this.saveInput
      }));
    }
  }]);

  return Password;
}(React.Component);

exports["default"] = Password;
Password.defaultProps = {
  inputPrefixCls: 'ant-input',
  prefixCls: 'ant-input-password',
  action: 'click',
  visibilityToggle: true
};
//# sourceMappingURL=Password.js.map


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var ConsentFormStep2 = function ConsentFormStep2(props) {
  var consentExistsText;if (props.currentStep !== 'Step 2') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Subject Found! Please verify details below:'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExists === true ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null, 'No'))), function () {
    if (props.consentExists) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsMethodType)), ['Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsEmailStatus.replace(/_/g, ' '))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Document Link: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: props.consentExistsLink, target: '_blank' }, 'Consent Document'))));
    }
  }(), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType, onChange: props.handleChange, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Who will be providing Consent?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentPersonType', name: 'consentPersonType', autoFocus: true, size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Consent Person'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentMethodType', { initialValue: props.consentMethodType, onChange: props.handleChange, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Consent Type'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentMethodType', name: 'consentMethodType', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Consent Type'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Electronic' }, 'Electronic Signature'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Email' }, 'Email'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Paper' }, 'Paper'))))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOverwrite', { initialValue: props.consentOverwrite, onChange: props.handleChange, rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Overwrite existing consent, if it exists?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentOverwrite', name: 'consentOverwrite', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Overwrite Consent?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aPatient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);










var ConsentFormStep3aPatient = function ConsentFormStep3aPatient(props) {
  if (props.currentStep !== "Step 3a" || props.consentPersonType !== "Patient" || props.consentMethodType !== "Electronic") {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Electronic Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Site ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "User ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Subject ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.subjectID)), props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "INFORMATION AND CONSENT FORM"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "(Subject Deferred Consent Form)"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "Title of Study:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in patients with Acute Ischemic\xA0\xA0 Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Site Investigator: Dr. Shelagh Coutts")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Coordinating Center: The Governors of the University of Calgary")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Introduction")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here. Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Why is this Study being done?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You were enrolled as a participant in this study because you had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.\xA0 Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you were incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "What will happen if I take part in this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.\xA0 This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.\xA0 The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.\xA0 After the 3-month assessment (phone call and online assessment) is finished, your participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Up to 1600 people at hospitals in Canada will participate in this study. Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Are there any potential risks or discomforts that I can expect from this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "5. The risk to an unborn child is uncertain. If you are pregnant, you have been enrolled into this study after an in-depth consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Are there any potential benefits if I participate?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "What if researchers discover something about me?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120. The patient will receive any new information during the course of the study concerning significant treatment findings."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Will my information and participation be kept confidential?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. \xA0Your name, telephone number and/or email, will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. An additional contact person will be requested, as a back-up contact, for the Day 90-120-day telephone follow-up. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.\xA0 Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with your health care number.\xA0 Your name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "A description of this clinical trial is available on", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "If I suffer a research-related injury, will I be compensated?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In the event that you suffer injury because of participating in this research, the University of Calgary, Alberta Health Services, or the Researchers will provide no compensation for you. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Will I be paid for participating, or do I have to pay for anything?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "CONSENT")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Please select the appropriate option to indicate your decision:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "SIGNATURES")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Dr. Shelagh Coutts (403) 944-1591 or"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Stroke Research office (403) 944-2863"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The University of Calgary Conjoint Health Research Ethics Board has approved this research study.\xA0 A signed copy of this consent form has been given to you to keep for your records and reference."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "REB#18-1101:"), " Title: Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke (AcT): QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial \xA0\xA0", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "PI"), ": Dr. Shelagh Coutts Version 2.0 26 March 2021")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("fullName", { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Participant's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "fullName", name: "fullName", placeholder: "Participant Full Name", autoFocus: true, allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("dateOfBirth", { initialValue: props.dateOfBirth, onChange: props.handleDatePickerChange, rules: [{ required: false, message: "Please select your Date of Birth" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "dateOfBirth", name: "dateOfBirth", placeholder: "Date of Birth (optional)", allowClear: true, size: "large", className: "ant-input ant-input-lg" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("investigatorFullName", { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Investigator/Delegate's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "investigatorFullName", name: "investigatorFullName", placeholder: "Investigator/Delegate Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("witnessFullName", { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "witnessFullName", name: "witnessFullName", placeholder: "Witness Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentOption", { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: "Please select consent option below:" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Please select consent option below:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentOption", name: "consentOption", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Consent Option?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "stay_in_study" }, "I wish for the patient to stay in the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study" }, "I wish to withdraw the patient from the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw the patient from the study but allow data to be collected from this point onward via health record linkage."))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentProvided", { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Do you consent to the terms described above? If no, please click on the Back button!"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentProvided", name: "consentProvided", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Provide Consent?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "No"))))));
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-calendar-picker-container {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1050;\n  font-family: Oxygen \", BlinkMacSystemFont, Ubuntu, Segoe UI, Roboto, Arial, sans-serif, \" Apple Color Emoji \", \" Segoe UI Emoji \", \" Segoe UI Symbol;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-calendar-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  outline: none;\n  cursor: text;\n  transition: opacity 0.3s;\n}\n.ant-calendar-picker-input {\n  outline: none;\n}\n.ant-calendar-picker-input.ant-input {\n  line-height: 1.5;\n}\n.ant-calendar-picker-input.ant-input-sm {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #78f1ff;\n}\n.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-calendar-picker-clear,\n.ant-calendar-picker-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -7px;\n  font-size: 12px;\n  line-height: 14px;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-calendar-picker-clear {\n  z-index: 2;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  background: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-calendar-picker-clear:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-calendar-picker:hover .ant-calendar-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-calendar-picker-icon {\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  line-height: 1;\n}\n.ant-calendar-picker-small .ant-calendar-picker-clear,\n.ant-calendar-picker-small .ant-calendar-picker-icon {\n  right: 8px;\n}\n.ant-calendar {\n  position: relative;\n  width: 280px;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #fff;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-calendar-input-wrap {\n  height: 34px;\n  padding: 6px 10px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-calendar-input {\n  width: 100%;\n  height: 22px;\n  color: #F5F5F5;\n  background: rgba(0, 0, 0, 0);\n  border: 0;\n  outline: 0;\n  cursor: auto;\n}\n.ant-calendar-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-week-number {\n  width: 286px;\n}\n.ant-calendar-week-number-cell {\n  text-align: center;\n}\n.ant-calendar-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n}\n.ant-calendar-header a:hover {\n  color: #78f1ff;\n}\n.ant-calendar-header .ant-calendar-century-select,\n.ant-calendar-header .ant-calendar-decade-select,\n.ant-calendar-header .ant-calendar-year-select,\n.ant-calendar-header .ant-calendar-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-header .ant-calendar-century-select-arrow,\n.ant-calendar-header .ant-calendar-decade-select-arrow,\n.ant-calendar-header .ant-calendar-year-select-arrow,\n.ant-calendar-header .ant-calendar-month-select-arrow {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-prev-month-btn,\n.ant-calendar-header .ant-calendar-next-month-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::before,\n.ant-calendar-header .ant-calendar-prev-decade-btn::before,\n.ant-calendar-header .ant-calendar-prev-year-btn::before,\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-prev-century-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-decade-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-year-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-century-btn:hover::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn:hover::after,\n.ant-calendar-header .ant-calendar-prev-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before,\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-next-century-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-decade-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-year-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-century-btn:hover::after,\n.ant-calendar-header .ant-calendar-next-decade-btn:hover::after,\n.ant-calendar-header .ant-calendar-next-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before,\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn::before,\n.ant-calendar-header .ant-calendar-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-prev-month-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::before,\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-next-month-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::before,\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-body {\n  padding: 8px 12px;\n}\n.ant-calendar table {\n  width: 100%;\n  max-width: 100%;\n  background-color: transparent;\n  border-collapse: collapse;\n}\n.ant-calendar table,\n.ant-calendar th,\n.ant-calendar td {\n  text-align: center;\n  border: 0;\n}\n.ant-calendar-calendar-table {\n  margin-bottom: 0;\n  border-spacing: 0;\n}\n.ant-calendar-column-header {\n  width: 33px;\n  padding: 6px 0;\n  line-height: 18px;\n  text-align: center;\n}\n.ant-calendar-column-header .ant-calendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-calendar-week-number-header .ant-calendar-column-header-inner {\n  display: none;\n}\n.ant-calendar-cell {\n  height: 30px;\n  padding: 3px 0;\n}\n.ant-calendar-date {\n  display: block;\n  width: 24px;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0;\n  color: #424242;\n  line-height: 22px;\n  text-align: center;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-date-panel {\n  position: relative;\n  outline: none;\n}\n.ant-calendar-date:hover {\n  background: #f0fffe;\n  cursor: pointer;\n}\n.ant-calendar-date:active {\n  color: #fff;\n  background: #78f1ff;\n}\n.ant-calendar-today .ant-calendar-date {\n  color: #4CDEF5;\n  font-weight: bold;\n  border-color: #4CDEF5;\n}\n.ant-calendar-selected-day .ant-calendar-date {\n  background: #f0ffff;\n}\n.ant-calendar-last-month-cell .ant-calendar-date,\n.ant-calendar-next-month-btn-day .ant-calendar-date,\n.ant-calendar-last-month-cell .ant-calendar-date:hover,\n.ant-calendar-next-month-btn-day .ant-calendar-date:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border-color: transparent;\n}\n.ant-calendar-disabled-cell .ant-calendar-date {\n  position: relative;\n  width: auto;\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  border: 1px solid transparent;\n  border-radius: 0;\n  cursor: not-allowed;\n}\n.ant-calendar-disabled-cell .ant-calendar-date:hover {\n  background: #f5f5f5;\n}\n.ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date::before {\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 24px;\n  height: 24px;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 2px;\n  content: '';\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {\n  position: relative;\n  padding-right: 5px;\n  padding-left: 5px;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date::before {\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 24px;\n  height: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 2px;\n  content: ' ';\n}\n.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-calendar-footer {\n  padding: 0 12px;\n  line-height: 38px;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-footer:empty {\n  border-top: 0;\n}\n.ant-calendar-footer-btn {\n  display: block;\n  text-align: center;\n}\n.ant-calendar-footer-extra {\n  text-align: left;\n}\n.ant-calendar .ant-calendar-today-btn,\n.ant-calendar .ant-calendar-clear-btn {\n  display: inline-block;\n  margin: 0 0 0 8px;\n  text-align: center;\n}\n.ant-calendar .ant-calendar-today-btn-disabled,\n.ant-calendar .ant-calendar-clear-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-today-btn:only-child,\n.ant-calendar .ant-calendar-clear-btn:only-child {\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn {\n  position: absolute;\n  top: 7px;\n  right: 5px;\n  display: none;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  overflow: hidden;\n  line-height: 20px;\n  text-align: center;\n  text-indent: -76px;\n}\n.ant-calendar .ant-calendar-clear-btn::after {\n  display: inline-block;\n  width: 20px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  line-height: 1;\n  text-indent: 43px;\n  transition: color 0.3s ease;\n}\n.ant-calendar .ant-calendar-clear-btn:hover::after {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-calendar .ant-calendar-ok-btn {\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n  white-space: nowrap;\n  text-align: center;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  height: 32px;\n  padding: 0 15px;\n  color: #FAFAFA;\n  background-color: #4CDEF5;\n  border-color: #4CDEF5;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 4px;\n  line-height: 22px;\n}\n.ant-calendar .ant-calendar-ok-btn > .anticon {\n  line-height: 1;\n}\n.ant-calendar .ant-calendar-ok-btn,\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  outline: 0;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {\n  outline: 0;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > *,\n.ant-calendar .ant-calendar-ok-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-calendar .ant-calendar-ok-btn-lg {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-calendar .ant-calendar-ok-btn-sm {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn:hover,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  color: #FAFAFA;\n  background-color: #78f1ff;\n  border-color: #78f1ff;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn.active {\n  color: #FAFAFA;\n  background-color: #36b5cf;\n  border-color: #36b5cf;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn-disabled,\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn-disabled:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn-disabled:active,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn-disabled.active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn-disabled,\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn-disabled:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn-disabled:active,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn-disabled.active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar-range-picker-input {\n  width: 44%;\n  height: 99%;\n  text-align: center;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n}\n.ant-calendar-range-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-range-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-range-picker-input[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar-range-picker-separator {\n  display: inline-block;\n  min-width: 10px;\n  height: 100%;\n  color: rgba(0, 0, 0, 0.45);\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: top;\n  pointer-events: none;\n}\n.ant-calendar-range {\n  width: 552px;\n  overflow: hidden;\n}\n.ant-calendar-range .ant-calendar-date-panel::after {\n  display: block;\n  clear: both;\n  height: 0;\n  visibility: hidden;\n  content: '.';\n}\n.ant-calendar-range-part {\n  position: relative;\n  width: 50%;\n}\n.ant-calendar-range-left {\n  float: left;\n}\n.ant-calendar-range-left .ant-calendar-time-picker-inner {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-calendar-range-right {\n  float: right;\n}\n.ant-calendar-range-right .ant-calendar-time-picker-inner {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-calendar-range-middle {\n  position: absolute;\n  left: 50%;\n  z-index: 1;\n  height: 34px;\n  margin: 1px 0 0 0;\n  padding: 0 200px 0 0;\n  color: rgba(0, 0, 0, 0.45);\n  line-height: 34px;\n  text-align: center;\n  transform: translateX(-50%);\n  pointer-events: none;\n}\n.ant-calendar-range-right .ant-calendar-date-input-wrap {\n  margin-left: -90px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-range-middle {\n  padding: 0 10px 0 0;\n  transform: translateX(-50%);\n}\n.ant-calendar-range .ant-calendar-today :not(.ant-calendar-disabled-cell) :not(.ant-calendar-last-month-cell) :not(.ant-calendar-next-month-btn-day) .ant-calendar-date {\n  color: #4CDEF5;\n  background: #f0ffff;\n  border-color: #4CDEF5;\n}\n.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,\n.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date {\n  color: #fff;\n  background: #4CDEF5;\n  border: 1px solid transparent;\n}\n.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date:hover,\n.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date:hover {\n  background: #4CDEF5;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-range-right .ant-calendar-date-input-wrap {\n  margin-left: 0;\n}\n.ant-calendar-range .ant-calendar-input-wrap {\n  position: relative;\n  height: 34px;\n}\n.ant-calendar-range .ant-calendar-input,\n.ant-calendar-range .ant-calendar-time-picker-input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  padding: 4px 11px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all 0.3s;\n  height: 24px;\n  padding-right: 0;\n  padding-left: 0;\n  line-height: 24px;\n  border: 0;\n  box-shadow: none;\n}\n.ant-calendar-range .ant-calendar-input::-moz-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input:-ms-input-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range .ant-calendar-input::-webkit-input-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range .ant-calendar-input:placeholder-shown,\n.ant-calendar-range .ant-calendar-time-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-range .ant-calendar-input:hover,\n.ant-calendar-range .ant-calendar-time-picker-input:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-calendar-range .ant-calendar-input:focus,\n.ant-calendar-range .ant-calendar-time-picker-input:focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-calendar-range .ant-calendar-input-disabled,\n.ant-calendar-range .ant-calendar-time-picker-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input-disabled:hover,\n.ant-calendar-range .ant-calendar-time-picker-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-calendar-range .ant-calendar-input[disabled],\n.ant-calendar-range .ant-calendar-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input[disabled]:hover,\n.ant-calendar-range .ant-calendar-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-calendar-range .ant-calendar-input,\ntextarea.ant-calendar-range .ant-calendar-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 32px;\n  line-height: 1.5;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-calendar-range .ant-calendar-input-lg,\n.ant-calendar-range .ant-calendar-time-picker-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-calendar-range .ant-calendar-input-sm,\n.ant-calendar-range .ant-calendar-time-picker-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-calendar-range .ant-calendar-input:focus,\n.ant-calendar-range .ant-calendar-time-picker-input:focus {\n  box-shadow: none;\n}\n.ant-calendar-range .ant-calendar-time-picker-icon {\n  display: none;\n}\n.ant-calendar-range.ant-calendar-week-number {\n  width: 574px;\n}\n.ant-calendar-range.ant-calendar-week-number .ant-calendar-range-part {\n  width: 286px;\n}\n.ant-calendar-range .ant-calendar-year-panel,\n.ant-calendar-range .ant-calendar-month-panel,\n.ant-calendar-range .ant-calendar-decade-panel {\n  top: 34px;\n}\n.ant-calendar-range .ant-calendar-month-panel .ant-calendar-year-panel {\n  top: 0;\n}\n.ant-calendar-range .ant-calendar-decade-panel-table,\n.ant-calendar-range .ant-calendar-year-panel-table,\n.ant-calendar-range .ant-calendar-month-panel-table {\n  height: 208px;\n}\n.ant-calendar-range .ant-calendar-in-range-cell {\n  position: relative;\n  border-radius: 0;\n}\n.ant-calendar-range .ant-calendar-in-range-cell > div {\n  position: relative;\n  z-index: 1;\n}\n.ant-calendar-range .ant-calendar-in-range-cell::before {\n  position: absolute;\n  top: 4px;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  display: block;\n  background: #f0fffe;\n  border: 0;\n  border-radius: 0;\n  content: '';\n}\n.ant-calendar-range .ant-calendar-footer-extra {\n  float: left;\n}\ndiv.ant-calendar-range-quick-selector {\n  text-align: left;\n}\ndiv.ant-calendar-range-quick-selector > a {\n  margin-right: 8px;\n}\n.ant-calendar-range .ant-calendar-header,\n.ant-calendar-range .ant-calendar-month-panel-header,\n.ant-calendar-range .ant-calendar-year-panel-header,\n.ant-calendar-range .ant-calendar-decade-panel-header {\n  border-bottom: 0;\n}\n.ant-calendar-range .ant-calendar-body,\n.ant-calendar-range .ant-calendar-month-panel-body,\n.ant-calendar-range .ant-calendar-year-panel-body,\n.ant-calendar-range .ant-calendar-decade-panel-body {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker {\n  top: 68px;\n  z-index: 2;\n  width: 100%;\n  height: 207px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-panel {\n  height: 267px;\n  margin-top: -34px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-inner {\n  height: 100%;\n  padding-top: 40px;\n  background: none;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-combobox {\n  display: inline-block;\n  height: 100%;\n  background-color: #fff;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select {\n  height: 100%;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select ul {\n  max-height: 100%;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  margin-right: 8px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-today-btn {\n  height: 22px;\n  margin: 8px 12px;\n  line-height: 22px;\n}\n.ant-calendar-range-with-ranges.ant-calendar-time .ant-calendar-time-picker {\n  height: 233px;\n}\n.ant-calendar-range.ant-calendar-show-time-picker .ant-calendar-body {\n  border-top-color: transparent;\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  top: 40px;\n  width: 100%;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  position: absolute;\n  z-index: 1050;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: none;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  position: relative;\n  float: left;\n  height: 226px;\n  overflow: hidden;\n  font-size: 14px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  margin-left: 0;\n  border-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  width: 100%;\n  max-height: 206px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-calendar-time-picker-select li {\n  width: 100%;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n  text-align: center;\n  list-style: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-calendar-time-picker-select li:last-child::after {\n  display: block;\n  height: 202px;\n  content: '';\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #f0fffe;\n}\n.ant-calendar-time-picker-select li:focus {\n  color: #4CDEF5;\n  font-weight: 600;\n  outline: none;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  font-weight: 600;\n  background: #f5f5f5;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-calendar-month-panel > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.ant-calendar-month-panel-hidden {\n  display: none;\n}\n.ant-calendar-month-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-month-panel-header a:hover {\n  color: #78f1ff;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-month-panel-body {\n  flex: 1;\n}\n.ant-calendar-month-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-month-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-month-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-month-panel-cell {\n  text-align: center;\n}\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-calendar-month-panel-month {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 8px;\n  color: #424242;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-month-panel-month:hover {\n  background: #f0fffe;\n  cursor: pointer;\n}\n.ant-calendar-year-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-calendar-year-panel > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.ant-calendar-year-panel-hidden {\n  display: none;\n}\n.ant-calendar-year-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-year-panel-header a:hover {\n  color: #78f1ff;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-year-panel-body {\n  flex: 1;\n}\n.ant-calendar-year-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-year-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-year-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-year-panel-cell {\n  text-align: center;\n}\n.ant-calendar-year-panel-year {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 8px;\n  color: #424242;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-year-panel-year:hover {\n  background: #f0fffe;\n  cursor: pointer;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,\n.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {\n  color: rgba(0, 0, 0, 0.25);\n  user-select: none;\n}\n.ant-calendar-decade-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-calendar-decade-panel-hidden {\n  display: none;\n}\n.ant-calendar-decade-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-decade-panel-header a:hover {\n  color: #78f1ff;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::after {\n  border-color: #424242;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-decade-panel-body {\n  flex: 1;\n}\n.ant-calendar-decade-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-decade-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-decade-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-decade-panel-cell {\n  white-space: nowrap;\n  text-align: center;\n}\n.ant-calendar-decade-panel-decade {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 6px;\n  color: #424242;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-decade-panel-decade:hover {\n  background: #f0fffe;\n  cursor: pointer;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {\n  color: #fff;\n  background: #4CDEF5;\n}\n.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,\n.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {\n  color: rgba(0, 0, 0, 0.25);\n  user-select: none;\n}\n.ant-calendar-month .ant-calendar-month-header-wrap {\n  position: relative;\n  height: 288px;\n}\n.ant-calendar-month .ant-calendar-month-panel,\n.ant-calendar-month .ant-calendar-year-panel {\n  top: 0;\n  height: 100%;\n}\n.ant-calendar-week-number-cell {\n  opacity: 0.5;\n}\n.ant-calendar-week-number .ant-calendar-body tr {\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-calendar-week-number .ant-calendar-body tr:hover {\n  background: #f0fffe;\n}\n.ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {\n  font-weight: bold;\n  background: #f0ffff;\n}\n.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day .ant-calendar-date,\n.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day:hover .ant-calendar-date {\n  color: #424242;\n  background: transparent;\n}\n", ""]);

// exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1022);
//# sourceMappingURL=index.js.map


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-time-picker-panel {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1050;\n  font-family: Oxygen \", BlinkMacSystemFont, Ubuntu, Segoe UI, Roboto, Arial, sans-serif, \" Apple Color Emoji \", \" Segoe UI Emoji \", \" Segoe UI Symbol;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  left: -2px;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-time-picker-panel-input {\n  width: 100%;\n  max-width: 154px;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  border: 0;\n  outline: 0;\n  cursor: auto;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-panel-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-time-picker-panel-input-wrap {\n  position: relative;\n  padding: 7px 2px 7px 12px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: #f5222d;\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  position: relative;\n  float: left;\n  width: 56px;\n  max-height: 192px;\n  overflow: hidden;\n  font-size: 14px;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  margin-left: 0;\n  border-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  width: 56px;\n  margin: 0;\n  padding: 0 0 160px;\n  list-style: none;\n}\n.ant-time-picker-panel-select li {\n  width: 100%;\n  height: 32px;\n  margin: 0;\n  padding: 0 0 0 12px;\n  line-height: 32px;\n  text-align: left;\n  list-style: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-time-picker-panel-select li:focus {\n  color: #4CDEF5;\n  font-weight: 600;\n  outline: none;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #f0fffe;\n}\nli.ant-time-picker-panel-select-option-selected {\n  font-weight: 600;\n  background: #f5f5f5;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f5f5f5;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\nli.ant-time-picker-panel-select-option-disabled:focus {\n  color: rgba(0, 0, 0, 0.25);\n  font-weight: inherit;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox::before,\n.ant-time-picker-panel-combobox::after {\n  display: table;\n  content: '';\n}\n.ant-time-picker-panel-combobox::after {\n  clear: both;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 128px;\n  outline: none;\n  cursor: text;\n  transition: opacity 0.3s;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  padding: 4px 11px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-time-picker-input:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-input:focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-time-picker-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 32px;\n  line-height: 1.5;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-time-picker-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-time-picker-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon,\n.ant-time-picker-clear {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -7px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 14px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n}\n.ant-time-picker-icon .ant-time-picker-clock-icon,\n.ant-time-picker-clear .ant-time-picker-clock-icon {\n  display: block;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 1;\n}\n.ant-time-picker-clear {\n  z-index: 2;\n  background: rgba(0, 0, 0, 0);\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-time-picker-clear:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-time-picker:hover .ant-time-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-time-picker-small .ant-time-picker-icon,\n.ant-time-picker-small .ant-time-picker-clear {\n  right: 7px;\n}\n@media not all and (min-resolution: 0.001dpcm) {\n  @supports (-webkit-appearance: none) and (stroke-color: transparent) {\n    .ant-input {\n      line-height: 1.5;\n    }\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1025);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-tag {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  height: auto;\n  margin-right: 8px;\n  padding: 0 7px;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  background: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  cursor: default;\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-tag:hover {\n  opacity: 0.85;\n}\n.ant-tag,\n.ant-tag a,\n.ant-tag a:hover {\n  color: #424242;\n}\n.ant-tag > a:first-child:last-child {\n  display: inline-block;\n  margin: 0 -8px;\n  padding: 0 8px;\n}\n.ant-tag .anticon-close {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  margin-left: 3px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n:root .ant-tag .anticon-close {\n  font-size: 12px;\n}\n.ant-tag .anticon-close:hover {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-tag-has-color {\n  border-color: transparent;\n}\n.ant-tag-has-color,\n.ant-tag-has-color a,\n.ant-tag-has-color a:hover,\n.ant-tag-has-color .anticon-close,\n.ant-tag-has-color .anticon-close:hover {\n  color: #fff;\n}\n.ant-tag-checkable {\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #4CDEF5;\n}\n.ant-tag-checkable:active,\n.ant-tag-checkable-checked {\n  color: #fff;\n}\n.ant-tag-checkable-checked {\n  background-color: #4CDEF5;\n}\n.ant-tag-checkable:active {\n  background-color: #36b5cf;\n}\n.ant-tag-hidden {\n  display: none;\n}\n.ant-tag-pink {\n  color: #eb2f96;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-pink-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-magenta {\n  color: #eb2f96;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-magenta-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-red {\n  color: #f5222d;\n  background: #fff1f0;\n  border-color: #ffa39e;\n}\n.ant-tag-red-inverse {\n  color: #fff;\n  background: #f5222d;\n  border-color: #f5222d;\n}\n.ant-tag-volcano {\n  color: #fa541c;\n  background: #fff2e8;\n  border-color: #ffbb96;\n}\n.ant-tag-volcano-inverse {\n  color: #fff;\n  background: #fa541c;\n  border-color: #fa541c;\n}\n.ant-tag-orange {\n  color: #fa8c16;\n  background: #fff7e6;\n  border-color: #ffd591;\n}\n.ant-tag-orange-inverse {\n  color: #fff;\n  background: #fa8c16;\n  border-color: #fa8c16;\n}\n.ant-tag-yellow {\n  color: #fadb14;\n  background: #feffe6;\n  border-color: #fffb8f;\n}\n.ant-tag-yellow-inverse {\n  color: #fff;\n  background: #fadb14;\n  border-color: #fadb14;\n}\n.ant-tag-gold {\n  color: #faad14;\n  background: #fffbe6;\n  border-color: #ffe58f;\n}\n.ant-tag-gold-inverse {\n  color: #fff;\n  background: #faad14;\n  border-color: #faad14;\n}\n.ant-tag-cyan {\n  color: #13c2c2;\n  background: #e6fffb;\n  border-color: #87e8de;\n}\n.ant-tag-cyan-inverse {\n  color: #fff;\n  background: #13c2c2;\n  border-color: #13c2c2;\n}\n.ant-tag-lime {\n  color: #a0d911;\n  background: #fcffe6;\n  border-color: #eaff8f;\n}\n.ant-tag-lime-inverse {\n  color: #fff;\n  background: #a0d911;\n  border-color: #a0d911;\n}\n.ant-tag-green {\n  color: #52c41a;\n  background: #f6ffed;\n  border-color: #b7eb8f;\n}\n.ant-tag-green-inverse {\n  color: #fff;\n  background: #52c41a;\n  border-color: #52c41a;\n}\n.ant-tag-blue {\n  color: #1890ff;\n  background: #e6f7ff;\n  border-color: #91d5ff;\n}\n.ant-tag-blue-inverse {\n  color: #fff;\n  background: #1890ff;\n  border-color: #1890ff;\n}\n.ant-tag-geekblue {\n  color: #2f54eb;\n  background: #f0f5ff;\n  border-color: #adc6ff;\n}\n.ant-tag-geekblue-inverse {\n  color: #fff;\n  background: #2f54eb;\n  border-color: #2f54eb;\n}\n.ant-tag-purple {\n  color: #722ed1;\n  background: #f9f0ff;\n  border-color: #d3adf7;\n}\n.ant-tag-purple-inverse {\n  color: #fff;\n  background: #722ed1;\n  border-color: #722ed1;\n}\n", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__date_DateTable__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__date_DateInput__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_toTime__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);



















function noop() {}

var getMomentObjectIfValid = function getMomentObjectIfValid(date) {
  if (__WEBPACK_IMPORTED_MODULE_17_moment___default.a.isMoment(date) && date.isValid()) {
    return date;
  }
  return false;
};

var Calendar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Calendar, _React$Component);

  function Calendar(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Calendar);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      mode: _this.props.mode || 'date',
      value: getMomentObjectIfValid(props.value) || getMomentObjectIfValid(props.defaultValue) || __WEBPACK_IMPORTED_MODULE_17_moment___default()(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    if (this.props.showDateInput) {
      this.saveFocusElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */].getInstance());
    }
  };

  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var value = nextProps.value,
        selectedValue = nextProps.selectedValue;

    var newState = {};

    if ('mode' in nextProps && state.mode !== nextProps.mode) {
      newState = { mode: nextProps.mode };
    }
    if ('value' in nextProps) {
      newState.value = getMomentObjectIfValid(value) || getMomentObjectIfValid(nextProps.defaultValue) || Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["d" /* getNowByCurrentStateValue */])(state.value);
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = selectedValue;
    }

    return newState;
  };

  Calendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        disabledDate = props.disabledDate,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        clearIcon = props.clearIcon,
        renderFooter = props.renderFooter,
        inputMode = props.inputMode,
        monthCellRender = props.monthCellRender,
        monthCellContentRender = props.monthCellContentRender;
    var value = state.value,
        selectedValue = state.selectedValue,
        mode = state.mode;

    var showTimePicker = mode === 'time';
    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? Object(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* getTimeConfig */])(selectedValue, disabledTime) : null;

    var timePickerEle = null;

    if (timePicker && showTimePicker) {
      var timePickerProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        showHour: true,
        showSecond: true,
        showMinute: true
      }, timePicker.props, disabledTimeConfig, {
        onChange: this.onDateInputChange,
        value: selectedValue,
        disabledTime: disabledTime
      });

      if (timePicker.props.defaultValue !== undefined) {
        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
      }

      timePickerEle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(timePicker, timePickerProps);
    }

    var dateInputElement = props.showDateInput ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */], {
      format: this.getFormat(),
      key: 'date-input',
      value: value,
      locale: locale,
      placeholder: dateInputPlaceholder,
      showClear: true,
      disabledTime: disabledTime,
      disabledDate: disabledDate,
      onClear: this.onClear,
      prefixCls: prefixCls,
      selectedValue: selectedValue,
      onChange: this.onDateInputChange,
      onSelect: this.onDateInputSelect,
      clearIcon: clearIcon,
      inputMode: inputMode
    }) : null;

    var children = [];
    if (props.renderSidebar) {
      children.push(props.renderSidebar());
    }
    children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: prefixCls + '-panel', key: 'panel' },
      dateInputElement,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          tabIndex: this.props.focusablePanel ? 0 : undefined,
          className: prefixCls + '-date-panel'
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__["a" /* default */], {
          locale: locale,
          mode: mode,
          value: value,
          onValueChange: this.setValue,
          onPanelChange: this.onPanelChange,
          renderFooter: renderFooter,
          showTimePicker: showTimePicker,
          prefixCls: prefixCls,
          monthCellRender: monthCellRender,
          monthCellContentRender: monthCellContentRender
        }),
        timePicker && showTimePicker ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__date_DateTable__["a" /* default */], {
            locale: locale,
            value: value,
            selectedValue: selectedValue,
            prefixCls: prefixCls,
            dateRender: props.dateRender,
            onSelect: this.onDateTableSelect,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__["a" /* default */], {
          showOk: props.showOk,
          mode: mode,
          renderFooter: props.renderFooter,
          locale: locale,
          prefixCls: prefixCls,
          showToday: props.showToday,
          disabledTime: disabledTime,
          showTimePicker: showTimePicker,
          showDateInput: props.showDateInput,
          timePicker: timePicker,
          selectedValue: selectedValue,
          value: value,
          disabledDate: disabledDate,
          okDisabled: props.showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)),
          onOk: this.onOk,
          onSelect: this.onSelect,
          onToday: this.onToday,
          onOpenTimePicker: this.openTimePicker,
          onCloseTimePicker: this.closeTimePicker
        })
      )
    ));

    return this.renderRoot({
      children: children,
      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
    });
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Calendar.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["b" /* calendarMixinPropTypes */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["c" /* propType */], {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultSelectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['time', 'date', 'month', 'year', 'decade']),
  locale: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showToday: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  dateInputPlaceholder: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onClear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  dateRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderSidebar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  focusablePanel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  inputMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
});
Calendar.defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["a" /* calendarMixinDefaultProps */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["b" /* defaultProp */], {
  showToday: true,
  showDateInput: true,
  timePicker: null,
  onOk: noop,
  onPanelChange: noop,
  focusablePanel: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    if (!('mode' in props)) {
      _this2.setState({ mode: mode });
    }
    props.onPanelChange(value || state.value, mode);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return undefined;
    }
    var keyCode = event.keyCode;
    // mac
    var ctrlKey = event.ctrlKey || event.metaKey;
    var disabledDate = _this2.props.disabledDate;
    var value = _this2.state.value;

    switch (keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN:
        _this2.goTime(1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].UP:
        _this2.goTime(-1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].LEFT:
        if (ctrlKey) {
          _this2.goTime(-1, 'years');
        } else {
          _this2.goTime(-1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].RIGHT:
        if (ctrlKey) {
          _this2.goTime(1, 'years');
        } else {
          _this2.goTime(1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].HOME:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["b" /* goStartMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].END:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["a" /* goEndMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
        _this2.goTime(1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
        _this2.goTime(-1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER:
        if (!disabledDate || !disabledDate(value)) {
          _this2.onSelect(value, {
            source: 'keyboard'
          });
        }
        event.preventDefault();
        return 1;
      default:
        _this2.props.onKeyDown(event);
        return 1;
    }
  };

  this.onClear = function () {
    _this2.onSelect(null);
    _this2.props.onClear();
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDate(selectedValue)) {
      _this2.props.onOk(selectedValue);
    }
  };

  this.onDateInputChange = function (value) {
    _this2.onSelect(value, {
      source: 'dateInput'
    });
  };

  this.onDateInputSelect = function (value) {
    _this2.onSelect(value, {
      source: 'dateInputSelect'
    });
  };

  this.onDateTableSelect = function (value) {
    var timePicker = _this2.props.timePicker;
    var selectedValue = _this2.state.selectedValue;

    if (!selectedValue && timePicker) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (timePickerDefaultValue) {
        Object(__WEBPACK_IMPORTED_MODULE_15__util__["h" /* syncTime */])(timePickerDefaultValue, value);
      }
    }
    _this2.onSelect(value);
  };

  this.onToday = function () {
    var value = _this2.state.value;

    var now = Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* getTodayTime */])(value);
    _this2.onSelect(now, {
      source: 'todayButton'
    });
  };

  this.onBlur = function (event) {
    setTimeout(function () {
      var dateInput = __WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */].getInstance();
      var rootInstance = _this2.rootInstance;

      if (!rootInstance || rootInstance.contains(document.activeElement) || dateInput && dateInput.contains(document.activeElement)) {
        // focused element is still part of Calendar
        return;
      }

      if (_this2.props.onBlur) {
        _this2.props.onBlur(event);
      }
    }, 0);
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this2);
  };

  this.openTimePicker = function () {
    _this2.onPanelChange(null, 'time');
  };

  this.closeTimePicker = function () {
    _this2.onPanelChange(null, 'date');
  };

  this.goTime = function (direction, unit) {
    _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["c" /* goTime */])(_this2.state.value, direction, unit));
  };
};

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Calendar);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["c" /* calendarMixinWrapper */])(Object(__WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["a" /* commonMixinWrapper */])(Calendar)));

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTHead__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTBody__ = __webpack_require__(1029);








var DateTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTable, _React$Component);

  function DateTable() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTable);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DateTHead__["a" /* default */], props),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateTBody__["a" /* default */], props)
    );
  };

  return DateTable;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTable);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateConstants__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var DateTHead = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTHead, _React$Component);

  function DateTHead() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTHead);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
    for (var dateColIndex = 0; dateColIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'thead',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTHead);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateConstants__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___ = __webpack_require__(131);









function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTBody, _React$Component);

  function DateTBody() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTBody);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = Object(__WEBPACK_IMPORTED_MODULE_7__util___["e" /* getTodayTime */])(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: Object(__WEBPACK_IMPORTED_MODULE_7__util___["d" /* getTitleString */])(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateTBody.propTypes = {
  contentRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  dateRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  selectedValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object)]),
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  hoverValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
/* harmony default export */ __webpack_exports__["a"] = (DateTBody);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__year_YearPanel__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__ = __webpack_require__(1034);










function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CalendarHeader);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__["a" /* default */], {
        locale: locale,
        value: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter,
        changeYear: this.changeYear
      });
    }
    if (mode === 'year') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__year_YearPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-header' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CalendarHeader.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onValueChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  showTimePicker: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  enablePrev: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  enableNext: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  disabledMonth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMonthSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.changeYear = function (direction) {
    if (direction > 0) {
      _this3.nextYear();
    } else {
      _this3.previousYear();
    }
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'span',
      { className: selectClassName },
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__["a" /* default */])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarHeader);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonthTable__ = __webpack_require__(1032);








function goYear(direction) {
  this.props.changeYear(direction);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthPanel, _React$Component);

  function MonthPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if ('value' in _this.props) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var newState = {};

    if ('value' in props) {
      newState = {
        value: props.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls, style: props.style },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MonthTable__["a" /* default */], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MonthPanel.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(MonthPanel);

/* harmony default export */ __webpack_exports__["a"] = (MonthPanel);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(131);









var ROW = 4;
var COL = 3;

function noop() {}

var MonthTable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthTable, _Component);

  function MonthTable() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MonthTable.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if ('value' in props) {
      return { value: props.value };
    }
    return null;
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.chooseMonth = function chooseMonth(month) {
    var next = this.state.value.clone();
    next.month(month);
    this.setAndSelectValue(next);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["b" /* getMonthName */])(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* getTodayTime */])(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : function () {
              return _this2.chooseMonth(monthData.value);
            },
            title: monthData.title,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          cellEl
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

MonthTable.defaultProps = {
  onSelect: noop
};

MonthTable.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  cellRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(MonthTable);

/* harmony default export */ __webpack_exports__["a"] = (MonthTable);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);






var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.setState({
    value: value
  });
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(YearPanel, _React$Component);

  function YearPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, YearPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (YearPanel);


YearPanel.propTypes = {
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);





var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DecadePanel, _React$Component);

  function DecadePanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DecadePanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-body' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DecadePanel);


DecadePanel.propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__ = __webpack_require__(1038);













var CalendarFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(CalendarFooter, _React$Component);

  function CalendarFooter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CalendarFooter);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__["a" /* default */], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__["a" /* default */], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__["a" /* default */])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CalendarFooter.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CalendarFooter);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TodayButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___ = __webpack_require__(131);



function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !Object(__WEBPACK_IMPORTED_MODULE_1__util___["g" /* isAllowedDate */])(Object(__WEBPACK_IMPORTED_MODULE_1__util___["e" /* getTodayTime */])(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: Object(__WEBPACK_IMPORTED_MODULE_1__util___["f" /* getTodayTimeStr */])(value)
    },
    localeNow
  );
}

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OkButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimePickerButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getNowByCurrentStateValue;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calendarMixinPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calendarMixinDefaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calendarMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(131);









function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* getTodayTime */])(value);
  } else {
    ret = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
  }
  return ret;
}

var calendarMixinPropTypes = {
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown,
            onBlur: _this.onBlur
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["g" /* isAllowedDate */])(value, disabledDate, disabledTime);
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _temp2;
};

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return propType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_en_US__ = __webpack_require__(1041);






function noop() {}

var propType = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  visible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProp = {
  locale: __WEBPACK_IMPORTED_MODULE_4__locale_en_US__["a" /* default */],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _class.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps, _temp2;
};

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(131);











var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateInput, _React$Component);

  function DateInput(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateInput);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon,
        inputMode = props.inputMode;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          inputMode: inputMode
        })
      ),
      props.showClear ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateInput.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  timePicker: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  format: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledDate: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectedValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  clearIcon: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  inputMode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = __WEBPACK_IMPORTED_MODULE_8_moment___default()(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (event) {
    var keyCode = event.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value,
        disabledDate = _props2.disabledDate;

    if (keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ENTER && onSelect) {
      var validateDate = !disabledDate || !disabledDate(value);
      if (validateDate) {
        onSelect(value.clone());
      }
      event.preventDefault();
    }
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(DateInput);

/* harmony default export */ __webpack_exports__["a"] = (DateInput);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = goStartMonth;
/* harmony export (immutable) */ __webpack_exports__["a"] = goEndMonth;
/* harmony export (immutable) */ __webpack_exports__["c"] = goTime;
/* unused harmony export includesTime */
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(38);

var _MonthTable = __webpack_require__(1045);

var _MonthTable2 = _interopRequireDefault(_MonthTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goYear(direction) {
  this.props.changeYear(direction);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  (0, _inherits3['default'])(MonthPanel, _React$Component);

  function MonthPanel(props) {
    (0, _classCallCheck3['default'])(this, MonthPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if ('value' in _this.props) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var newState = {};

    if ('value' in props) {
      newState = {
        value: props.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return _react2['default'].createElement(
      'div',
      { className: prefixCls, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_MonthTable2['default'], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(_react2['default'].Component);

MonthPanel.propTypes = {
  onChange: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


(0, _reactLifecyclesCompat.polyfill)(MonthPanel);

exports['default'] = MonthPanel;
module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLifecyclesCompat = __webpack_require__(38);

var _index = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function noop() {}

var MonthTable = function (_Component) {
  (0, _inherits3['default'])(MonthTable, _Component);

  function MonthTable() {
    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, MonthTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  MonthTable.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if ('value' in props) {
      return { value: props.value };
    }
    return null;
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.chooseMonth = function chooseMonth(month) {
    var next = this.state.value.clone();
    next.month(month);
    this.setAndSelectValue(next);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = (0, _index.getMonthName)(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = (0, _index.getTodayTime)(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = _react2['default'].createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : function () {
              return _this2.chooseMonth(monthData.value);
            },
            title: monthData.title,
            className: (0, _classnames2['default'])(classNameMap)
          },
          cellEl
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(_react.Component);

MonthTable.defaultProps = {
  onSelect: noop
};

MonthTable.propTypes = {
  onSelect: _propTypes2['default'].func,
  cellRender: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object
};

(0, _reactLifecyclesCompat.polyfill)(MonthTable);

exports['default'] = MonthTable;
module.exports = exports['default'];

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.setState({
    value: value
  });
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  (0, _inherits3['default'])(YearPanel, _React$Component);

  function YearPanel(props) {
    (0, _classCallCheck3['default'])(this, YearPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            _react2['default'].createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(_react2['default'].Component);

exports['default'] = YearPanel;


YearPanel.propTypes = {
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  (0, _inherits3['default'])(DecadePanel, _React$Component);

  function DecadePanel(props) {
    (0, _classCallCheck3['default'])(this, DecadePanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return _react2['default'].createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-header' },
        _react2['default'].createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        _react2['default'].createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-body' },
        _react2['default'].createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          _react2['default'].createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && _react2['default'].createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(_react2['default'].Component);

exports['default'] = DecadePanel;


DecadePanel.propTypes = {
  locale: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  rootPrefixCls: _propTypes2['default'].string,
  renderFooter: _propTypes2['default'].func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(450);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _TodayButton = __webpack_require__(451);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(452);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(453);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarFooter = function (_React$Component) {
  (0, _inherits3['default'])(CalendarFooter, _React$Component);

  function CalendarFooter() {
    (0, _classCallCheck3['default'])(this, CalendarFooter);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return _reactDom2['default'].findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = _react2['default'].createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = (0, _classnames2['default'])(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = _react2['default'].createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(_react2['default'].Component);

CalendarFooter.propTypes = {
  prefixCls: _propTypes2['default'].string,
  showDateInput: _propTypes2['default'].bool,
  disabledTime: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].element,
  selectedValue: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func,
  defaultValue: _propTypes2['default'].object,
  mode: _propTypes2['default'].string
};
exports['default'] = CalendarFooter;
module.exports = exports['default'];

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calendarMixinWrapper = exports.calendarMixinDefaultProps = exports.calendarMixinPropTypes = undefined;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getNowByCurrentStateValue = getNowByCurrentStateValue;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = (0, _index.getTodayTime)(value);
  } else {
    ret = (0, _moment2['default'])();
  }
  return ret;
}

var calendarMixinPropTypes = exports.calendarMixinPropTypes = {
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  onKeyDown: _propTypes2['default'].func
};

var calendarMixinDefaultProps = exports.calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = exports.calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return _react2['default'].createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + (0, _classnames2['default'])(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown,
            onBlur: _this.onBlur
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _temp2;
};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(38);

var _MonthCalendar = _interopRequireDefault(__webpack_require__(448));

var _Picker = _interopRequireDefault(__webpack_require__(305));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(461));

var _utils = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function createPicker(TheCalendar) {
  var CalenderWrapper =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(CalenderWrapper, _React$Component);

    function CalenderWrapper(props) {
      var _this;

      _classCallCheck(this, CalenderWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CalenderWrapper).call(this, props));

      _this.saveInput = function (node) {
        _this.input = node;
      };

      _this.clearSelection = function (e) {
        e.preventDefault();
        e.stopPropagation();

        _this.handleChange(null);
      };

      _this.handleChange = function (value) {
        var _assertThisInitialize = _assertThisInitialized(_this),
            props = _assertThisInitialize.props;

        if (!('value' in props)) {
          _this.setState({
            value: value,
            showDate: value
          });
        }

        props.onChange(value, (0, _utils.formatDate)(value, props.format));
      };

      _this.handleCalendarChange = function (value) {
        _this.setState({
          showDate: value
        });
      };

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;

        if (!('open' in _this.props)) {
          _this.setState({
            open: open
          });
        }

        if (onOpenChange) {
          onOpenChange(open);
        }
      };

      _this.renderFooter = function () {
        var renderExtraFooter = _this.props.renderExtraFooter;

        var _assertThisInitialize2 = _assertThisInitialized(_this),
            prefixCls = _assertThisInitialize2.prefixCls;

        return renderExtraFooter ? React.createElement("div", {
          className: "".concat(prefixCls, "-footer-extra")
        }, renderExtraFooter.apply(void 0, arguments)) : null;
      };

      _this.renderPicker = function (_ref) {
        var _classNames, _classNames2;

        var getPrefixCls = _ref.getPrefixCls;
        var _this$state = _this.state,
            value = _this$state.value,
            showDate = _this$state.showDate,
            open = _this$state.open;
        var props = (0, _omit["default"])(_this.props, ['onChange']);
        var customizePrefixCls = props.prefixCls,
            locale = props.locale,
            localeCode = props.localeCode,
            suffixIcon = props.suffixIcon;
        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
        // Have to add prefixCls on the instance.
        // https://github.com/facebook/react/issues/12397

        _this.prefixCls = prefixCls;
        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
        var disabledTime = props.showTime ? props.disabledTime : null;
        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));

        if (value && localeCode) {
          value.locale(localeCode);
        }

        var pickerProps = {};
        var calendarProps = {};
        var pickerStyle = {};

        if (props.showTime) {
          calendarProps = {
            // fix https://github.com/ant-design/ant-design/issues/1902
            onSelect: _this.handleChange
          };
          pickerStyle.minWidth = 195;
        } else {
          pickerProps = {
            onChange: _this.handleChange
          };
        }

        if ('mode' in props) {
          calendarProps.mode = props.mode;
        }

        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
        var calendar = React.createElement(TheCalendar, _extends({}, calendarProps, {
          disabledDate: props.disabledDate,
          disabledTime: disabledTime,
          locale: locale.lang,
          timePicker: props.timePicker,
          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
          dateInputPlaceholder: placeholder,
          prefixCls: prefixCls,
          className: calendarClassName,
          onOk: props.onOk,
          dateRender: props.dateRender,
          format: props.format,
          showToday: props.showToday,
          monthCellContentRender: props.monthCellContentRender,
          renderFooter: _this.renderFooter,
          onPanelChange: props.onPanelChange,
          onChange: _this.handleCalendarChange,
          value: showDate
        }));
        var clearIcon = !props.disabled && props.allowClear && value ? React.createElement(_icon["default"], {
          type: "close-circle",
          className: "".concat(prefixCls, "-picker-clear"),
          onClick: _this.clearSelection,
          theme: "filled"
        }) : null;
        var inputIcon = suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
        }) : React.createElement("span", {
          className: "".concat(prefixCls, "-picker-icon")
        }, suffixIcon)) || React.createElement(_icon["default"], {
          type: "calendar",
          className: "".concat(prefixCls, "-picker-icon")
        });
        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);

        var input = function input(_ref2) {
          var inputValue = _ref2.value;
          return React.createElement("div", null, React.createElement("input", _extends({
            ref: _this.saveInput,
            disabled: props.disabled,
            readOnly: true,
            value: (0, _utils.formatDate)(inputValue, props.format),
            placeholder: placeholder,
            className: props.pickerInputClass,
            tabIndex: props.tabIndex,
            name: props.name
          }, dataOrAriaProps)), clearIcon, inputIcon);
        };

        return React.createElement("span", {
          id: props.id,
          className: (0, _classnames["default"])(props.className, props.pickerClass),
          style: _extends(_extends({}, pickerStyle), props.style),
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave
        }, React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
          calendar: calendar,
          value: value,
          prefixCls: "".concat(prefixCls, "-picker-container"),
          style: props.popupStyle,
          open: open,
          onOpenChange: _this.handleOpenChange
        }), input));
      };

      var value = props.value || props.defaultValue;

      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
      }

      _this.state = {
        value: value,
        showDate: value,
        open: false
      };
      return _this;
    }

    _createClass(CalenderWrapper, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(_, prevState) {
        if (!('open' in this.props) && prevState.open && !this.state.open) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.input.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.input.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var state = {};
        var open = prevState.open;

        if ('open' in nextProps) {
          state.open = nextProps.open;
          open = nextProps.open || false;
        }

        if ('value' in nextProps) {
          state.value = nextProps.value;

          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
            state.showDate = nextProps.value;
          }
        }

        return Object.keys(state).length > 0 ? state : null;
      }
    }]);

    return CalenderWrapper;
  }(React.Component);

  CalenderWrapper.defaultProps = {
    allowClear: true,
    showToday: true
  };
  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
  return CalenderWrapper;
}
//# sourceMappingURL=createPicker.js.map


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainedFunction;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;
module.exports = exports['default'];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(1054);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(95);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(459);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1057);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(1059);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0; // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target) {
  var visibleRect = getVisibleRectForElement(target);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(306);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(460);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(38);

var _Panel = _interopRequireDefault(__webpack_require__(463));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _en_US = _interopRequireDefault(__webpack_require__(270));

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _timePicker = __webpack_require__(1066);

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DEFAULT_FORMAT = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  week: 'gggg-wo',
  month: 'YYYY-MM'
};
var LOCALE_FORMAT_MAPPING = {
  date: 'dateFormat',
  dateTime: 'dateTimeFormat',
  week: 'weekFormat',
  month: 'monthFormat'
};

function getColumns(_ref) {
  var showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond,
      use12Hours = _ref.use12Hours;
  var column = 0;

  if (showHour) {
    column += 1;
  }

  if (showMinute) {
    column += 1;
  }

  if (showSecond) {
    column += 1;
  }

  if (use12Hours) {
    column += 1;
  }

  return column;
}

function checkValidate(value, propName) {
  var values = Array.isArray(value) ? value : [value];
  values.forEach(function (val) {
    if (!val) return;
    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
  });
}

function wrapPicker(Picker, pickerType) {
  var PickerWrapper =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(PickerWrapper, _React$Component);

    function PickerWrapper() {
      var _this;

      _classCallCheck(this, PickerWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(PickerWrapper).apply(this, arguments)); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.

      _this.state = {};

      _this.savePicker = function (node) {
        _this.picker = node;
      };

      _this.getDefaultLocale = function () {
        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);

        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
        return result;
      };

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;
        onOpenChange(open);
      };

      _this.handleFocus = function (e) {
        var onFocus = _this.props.onFocus;

        if (onFocus) {
          onFocus(e);
        }
      };

      _this.handleBlur = function (e) {
        var onBlur = _this.props.onBlur;

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        if (onMouseEnter) {
          onMouseEnter(e);
        }
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;

        if (onMouseLeave) {
          onMouseLeave(e);
        }
      };

      _this.renderPicker = function (locale, localeCode) {
        var _this$props = _this.props,
            format = _this$props.format,
            showTime = _this$props.showTime;
        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
        return React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
          var _classNames2;

          var getPrefixCls = _ref2.getPrefixCls,
              getContextPopupContainer = _ref2.getPopupContainer;
          var _this$props2 = _this.props,
              customizePrefixCls = _this$props2.prefixCls,
              customizeInputPrefixCls = _this$props2.inputPrefixCls,
              getCalendarContainer = _this$props2.getCalendarContainer,
              size = _this$props2.size,
              disabled = _this$props2.disabled;
          var getPopupContainer = getCalendarContainer || getContextPopupContainer;
          var prefixCls = getPrefixCls('calendar', customizePrefixCls);
          var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
          var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
          var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
          var timeFormat = showTime && showTime.format || 'HH:mm:ss';

          var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
            format: timeFormat,
            use12Hours: showTime && showTime.use12Hours
          });

          var columns = getColumns(rcTimePickerProps);
          var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
          var timePicker = showTime ? React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
            prefixCls: "".concat(prefixCls, "-time-picker"),
            className: timePickerCls,
            placeholder: locale.timePickerLocale.placeholder,
            transitionName: "slide-up",
            onEsc: function onEsc() {}
          })) : null;
          return React.createElement(Picker, _extends({}, _this.props, {
            getCalendarContainer: getPopupContainer,
            format: mergedFormat,
            ref: _this.savePicker,
            pickerClass: pickerClass,
            pickerInputClass: pickerInputClass,
            locale: locale,
            localeCode: localeCode,
            timePicker: timePicker,
            onOpenChange: _this.handleOpenChange,
            onFocus: _this.handleFocus,
            onBlur: _this.handleBlur,
            onMouseEnter: _this.handleMouseEnter,
            onMouseLeave: _this.handleMouseLeave
          }));
        });
      };

      return _this;
    }

    _createClass(PickerWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props3 = this.props,
            autoFocus = _this$props3.autoFocus,
            disabled = _this$props3.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.picker.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.picker.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(_LocaleReceiver["default"], {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        }, this.renderPicker);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3) {
        var value = _ref3.value,
            defaultValue = _ref3.defaultValue;
        checkValidate(defaultValue, 'defaultValue');
        checkValidate(value, 'value');
        return {};
      }
    }]);

    return PickerWrapper;
  }(React.Component);

  PickerWrapper.defaultProps = {
    transitionName: 'slide-up',
    popupStyle: {},
    onChange: function onChange() {},
    onOk: function onOk() {},
    onOpenChange: function onOpenChange() {},
    locale: {}
  };
  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
  return PickerWrapper;
}
//# sourceMappingURL=wrapPicker.js.map


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _moment = _interopRequireDefault(__webpack_require__(21));

var _classnames = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var str = event.target.value;

      _this.setState({
        str: str
      });

      var _this$props = _this.props,
          format = _this$props.format,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          secondOptions = _this$props.secondOptions,
          disabledHours = _this$props.disabledHours,
          disabledMinutes = _this$props.disabledMinutes,
          disabledSeconds = _this$props.disabledSeconds,
          onChange = _this$props.onChange;

      if (str) {
        var originalValue = _this.props.value;

        var value = _this.getProtoValue().clone();

        var parsed = (0, _moment["default"])(str, format, true);

        if (!parsed.isValid()) {
          _this.setState({
            invalid: true
          });

          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          _this.setState({
            invalid: true
          });

          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          _this.setState({
            invalid: true
          });

          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());
            onChange(changedValue);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        onChange(null);
      }

      _this.setState({
        invalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onEsc = _this$props2.onEsc,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 27) {
        onEsc();
      }

      onKeyDown(e);
    });

    var _value = props.value,
        _format = props.format;
    _this.state = {
      str: _value && _value.format(_format) || '',
      invalid: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var focusOnOpen = this.props.focusOnOpen;

      if (focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refInput.focus();

          _this2.refInput.select();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          format = _this$props3.format;

      if (value !== prevProps.value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          str: value && value.format(format) || '',
          invalid: false
        });
      }
    }
  }, {
    key: "getProtoValue",
    value: function getProtoValue() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          defaultOpenValue = _this$props4.defaultOpenValue;
      return value || defaultOpenValue;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          inputReadOnly = _this$props5.inputReadOnly;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return _react["default"].createElement("input", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-input"), invalidClass),
        ref: function ref(_ref) {
          _this3.refInput = _ref;
        },
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, this.getInput());
    }
  }]);

  return Header;
}(_react.Component);

_defineProperty(Header, "propTypes", {
  format: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  disabledDate: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  defaultOpenValue: _propTypes["default"].object,
  currentSelectPanel: _propTypes["default"].string,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Header, "defaultProps", {
  inputReadOnly: false
});

var _default = Header;
exports["default"] = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _Select = _interopRequireDefault(__webpack_require__(1064));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox =
/*#__PURE__*/
function (_Component) {
  _inherits(Combobox, _Component);

  function Combobox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours,
          propValue = _this$props.value,
          isAM = _this$props.isAM,
          onAmPmChange = _this$props.onAmPmChange;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        onAmPmChange(ampm);
      } else {
        value.second(+itemValue);
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
      onCurrentSelectPanelChange(range);
    });

    return _this;
  }

  _createClass(Combobox, [{
    key: "getHourSelect",
    value: function getHourSelect(hour) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          hourOptions = _this$props2.hourOptions,
          disabledHours = _this$props2.disabledHours,
          showHour = _this$props2.showHour,
          use12Hours = _this$props2.use12Hours,
          onEsc = _this$props2.onEsc;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this2.onEnterSelectPanel('hour');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function getMinuteSelect(minute) {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          minuteOptions = _this$props3.minuteOptions,
          disabledMinutes = _this$props3.disabledMinutes,
          defaultOpenValue = _this$props3.defaultOpenValue,
          showMinute = _this$props3.showMinute,
          propValue = _this$props3.value,
          onEsc = _this$props3.onEsc;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this3.onEnterSelectPanel('minute');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getSecondSelect",
    value: function getSecondSelect(second) {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          secondOptions = _this$props4.secondOptions,
          disabledSeconds = _this$props4.disabledSeconds,
          showSecond = _this$props4.showSecond,
          defaultOpenValue = _this$props4.defaultOpenValue,
          propValue = _this$props4.value,
          onEsc = _this$props4.onEsc;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this4.onEnterSelectPanel('second');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function getAMPMSelect() {
      var _this5 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          use12Hours = _this$props5.use12Hours,
          format = _this$props5.format,
          isAM = _this$props5.isAM,
          onEsc = _this$props5.onEsc;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this5.onEnterSelectPanel('ampm');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          defaultOpenValue = _this$props6.defaultOpenValue,
          propValue = _this$props6.value;
      var value = propValue || defaultOpenValue;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-combobox")
      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
    }
  }]);

  return Combobox;
}(_react.Component);

_defineProperty(Combobox, "propTypes", {
  format: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  prefixCls: _propTypes["default"].string,
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onCurrentSelectPanelChange: _propTypes["default"].func,
  use12Hours: _propTypes["default"].bool,
  onEsc: _propTypes["default"].func,
  isAM: _propTypes["default"].bool
});

var _default = Combobox;
exports["default"] = _default;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _reactDom = _interopRequireDefault(__webpack_require__(26));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _raf = _interopRequireDefault(__webpack_require__(1065));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var scrollTo = function scrollTo(element, to, duration) {
  // jump to target if duration zero
  if (duration <= 0) {
    (0, _raf["default"])(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  (0, _raf["default"])(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;
      onSelect(type, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        active: true
      });

      onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
      _this.list = node;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option

      if (prevProps.selectedIndex !== selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          selectedIndex = _this$props2.selectedIndex,
          prefixCls = _this$props2.prefixCls,
          onEsc = _this$props2.onEsc;
      return options.map(function (item, index) {
        var _classNames;

        var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
        var onClick = item.disabled ? undefined : function () {
          _this2.onSelect(item.value);
        };

        var onKeyDown = function onKeyDown(e) {
          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
        };

        return _react["default"].createElement("li", {
          role: "button",
          onClick: onClick,
          className: cls,
          key: index,
          disabled: item.disabled,
          tabIndex: "0",
          onKeyDown: onKeyDown
        }, item.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function scrollToSelected(duration) {
      // move to selected item
      var selectedIndex = this.props.selectedIndex;

      var select = _reactDom["default"].findDOMNode(this);

      var list = _reactDom["default"].findDOMNode(this.list);

      if (!list) {
        return;
      }

      var index = selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          options = _this$props3.options;
      var active = this.state.active;

      if (options.length === 0) {
        return null;
      }

      var cls = (0, _classnames["default"])("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
      return _react["default"].createElement("div", {
        className: cls,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, _react["default"].createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]);

  return Select;
}(_react.Component);

_defineProperty(Select, "propTypes", {
  prefixCls: _propTypes["default"].string,
  options: _propTypes["default"].array,
  selectedIndex: _propTypes["default"].number,
  type: _propTypes["default"].string,
  onSelect: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onEsc: _propTypes["default"].func
});

var _default = Select;
exports["default"] = _default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(199)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _reactLifecyclesCompat = __webpack_require__(38);

var _TimePicker = _interopRequireDefault(__webpack_require__(1067));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(55));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _configProvider = __webpack_require__(30);

var _en_US = _interopRequireDefault(__webpack_require__(271));

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}

var TimePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));

    _this.getDefaultLocale = function () {
      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);

      return defaultLocale;
    };

    _this.handleOpenClose = function (_ref) {
      var open = _ref.open;
      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.saveTimePicker = function (timePickerRef) {
      _this.timePickerRef = timePickerRef;
    };

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$format = _this$props.format,
          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;

      if (onChange) {
        onChange(value, value && value.format(format) || '');
      }
    };

    _this.renderTimePicker = function (locale) {
      return React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
        var getContextPopupContainer = _ref2.getPopupContainer,
            getPrefixCls = _ref2.getPrefixCls;

        var _a = _this.props,
            getPopupContainer = _a.getPopupContainer,
            customizePrefixCls = _a.prefixCls,
            className = _a.className,
            addon = _a.addon,
            placeholder = _a.placeholder,
            props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);

        var size = props.size;
        var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);

        var format = _this.getDefaultFormat();

        var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
        var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));

        var pickerAddon = function pickerAddon(panel) {
          return addon ? React.createElement("div", {
            className: "".concat(prefixCls, "-panel-addon")
          }, addon(panel)) : null;
        };

        return React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
          allowEmpty: _this.getAllowClear(),
          prefixCls: prefixCls,
          getPopupContainer: getPopupContainer || getContextPopupContainer,
          ref: _this.saveTimePicker,
          format: format,
          className: pickerClassName,
          value: _this.state.value,
          placeholder: placeholder === undefined ? locale.placeholder : placeholder,
          onChange: _this.handleChange,
          onOpen: _this.handleOpenClose,
          onClose: _this.handleOpenClose,
          addon: pickerAddon,
          inputIcon: _this.renderInputIcon(prefixCls),
          clearIcon: _this.renderClearIcon(prefixCls)
        }));
      });
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
    }

    _this.state = {
      value: value
    };
    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
    return _this;
  }

  _createClass(TimePicker, [{
    key: "getDefaultFormat",
    value: function getDefaultFormat() {
      var _this$props2 = this.props,
          format = _this$props2.format,
          use12Hours = _this$props2.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        return 'h:mm:ss a';
      }

      return 'HH:mm:ss';
    }
  }, {
    key: "getAllowClear",
    value: function getAllowClear() {
      var _this$props3 = this.props,
          allowClear = _this$props3.allowClear,
          allowEmpty = _this$props3.allowEmpty;

      if ('allowClear' in this.props) {
        return allowClear;
      }

      return allowEmpty;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.timePickerRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.timePickerRef.blur();
    }
  }, {
    key: "renderInputIcon",
    value: function renderInputIcon(prefixCls) {
      var suffixIcon = this.props.suffixIcon;
      var clockIcon = suffixIcon && React.isValidElement(suffixIcon) && React.cloneElement(suffixIcon, {
        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
      }) || React.createElement(_icon["default"], {
        type: "clock-circle",
        className: "".concat(prefixCls, "-clock-icon")
      });
      return React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, clockIcon);
    }
  }, {
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var clearIcon = this.props.clearIcon;
      var clearIconPrefixCls = "".concat(prefixCls, "-clear");

      if (clearIcon && React.isValidElement(clearIcon)) {
        return React.cloneElement(clearIcon, {
          className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
        });
      }

      return React.createElement(_icon["default"], {
        type: "close-circle",
        className: clearIconPrefixCls,
        theme: "filled"
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_LocaleReceiver["default"], {
        componentName: "TimePicker",
        defaultLocale: this.getDefaultLocale()
      }, this.renderTimePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.defaultProps = {
  align: {
    offset: [0, -2]
  },
  disabledHours: undefined,
  disabledMinutes: undefined,
  disabledSeconds: undefined,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  transitionName: 'slide-up',
  focusOnOpen: true
};
(0, _reactLifecyclesCompat.polyfill)(TimePicker);
var _default = TimePicker;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _rcTrigger = _interopRequireDefault(__webpack_require__(133));

var _moment = _interopRequireDefault(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _Panel = _interopRequireDefault(__webpack_require__(463));

var _placements = _interopRequireDefault(__webpack_require__(1068));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker =
/*#__PURE__*/
function (_Component) {
  _inherits(Picker, _Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
      event.stopPropagation();

      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          use12Hours = _this$props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          placeholder = _this$props2.placeholder,
          disabledHours = _this$props2.disabledHours,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          inputReadOnly = _this$props2.inputReadOnly,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          clearIcon = _this$props2.clearIcon;
      var value = this.state.value;
      return _react["default"].createElement(_Panel["default"], {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props3 = this.props,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          use12Hours = _this$props3.use12Hours,
          prefixCls = _this$props3.prefixCls,
          popupClassName = _this$props3.popupClassName;
      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      } // Keep it for old compatibility


      return (0, _classnames["default"])(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props4 = this.props,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowEmpty = _this$props5.allowEmpty,
          clearIcon = _this$props5.clearIcon,
          clearText = _this$props5.clearText,
          disabled = _this$props5.disabled;

      if (!allowEmpty || !value || disabled) {
        return null;
      }

      if (_react["default"].isValidElement(clearIcon)) {
        var _ref = clearIcon.props || {},
            _onClick = _ref.onClick;

        return _react["default"].cloneElement(clearIcon, {
          onClick: function onClick() {
            if (_onClick) _onClick.apply(void 0, arguments);

            _this2.onClear.apply(_this2, arguments);
          }
        });
      }

      return _react["default"].createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear"),
        title: clearText,
        onClick: this.onClear,
        tabIndex: 0
      }, clearIcon || _react["default"].createElement("i", {
        className: "".concat(prefixCls, "-clear-icon")
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          placeholder = _this$props6.placeholder,
          placement = _this$props6.placement,
          align = _this$props6.align,
          id = _this$props6.id,
          disabled = _this$props6.disabled,
          transitionName = _this$props6.transitionName,
          style = _this$props6.style,
          className = _this$props6.className,
          getPopupContainer = _this$props6.getPopupContainer,
          name = _this$props6.name,
          autoComplete = _this$props6.autoComplete,
          onFocus = _this$props6.onFocus,
          onBlur = _this$props6.onBlur,
          autoFocus = _this$props6.autoFocus,
          inputReadOnly = _this$props6.inputReadOnly,
          inputIcon = _this$props6.inputIcon,
          popupStyle = _this$props6.popupStyle;
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      var popupClassName = this.getPopupClassName();
      return _react["default"].createElement(_rcTrigger["default"], {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: _placements["default"],
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, _react["default"].createElement("span", {
        className: (0, _classnames["default"])(prefixCls, className),
        style: style
      }, _react["default"].createElement("input", {
        className: "".concat(prefixCls, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: placeholder,
        name: name,
        onKeyDown: this.onKeyDown,
        disabled: disabled,
        value: value && value.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        onChange: noop,
        readOnly: !!inputReadOnly,
        id: id
      }), inputIcon || _react["default"].createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }), this.renderClearButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = {};

      if ('value' in props) {
        newState.value = props.value;
      }

      if (props.open !== undefined) {
        newState.open = props.open;
      }

      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
    }
  }]);

  return Picker;
}(_react.Component);

_defineProperty(Picker, "propTypes", {
  prefixCls: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  defaultOpenValue: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  allowEmpty: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].object,
  open: _propTypes["default"].bool,
  defaultOpen: _propTypes["default"].bool,
  align: _propTypes["default"].object,
  placement: _propTypes["default"].any,
  transitionName: _propTypes["default"].string,
  getPopupContainer: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string,
  popupClassName: _propTypes["default"].string,
  popupStyle: _propTypes["default"].object,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  addon: _propTypes["default"].func,
  name: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  inputIcon: _propTypes["default"].node,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  align: {},
  defaultOpenValue: (0, _moment["default"])(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
});

(0, _reactLifecyclesCompat.polyfill)(Picker);
var _default = Picker;
exports["default"] = _default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
var _default = placements;
exports["default"] = _default;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(38);

var _RangeCalendar = _interopRequireDefault(__webpack_require__(1070));

var _Picker = _interopRequireDefault(__webpack_require__(305));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _tag = _interopRequireDefault(__webpack_require__(465));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _utils = __webpack_require__(462);

var _InputIcon = _interopRequireDefault(__webpack_require__(467));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getShowDateFromValue(value, mode) {
  var _value = _slicedToArray(value, 2),
      start = _value[0],
      end = _value[1]; // value could be an empty array, then we should not reset showDate


  if (!start && !end) {
    return;
  }

  if (mode && mode[0] === 'month') {
    return [start, end];
  }

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function pickerValueAdapter(value) {
  if (!value) {
    return;
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value, value.clone().add(1, 'month')];
}

function isEmptyArray(arr) {
  if (Array.isArray(arr)) {
    return arr.length === 0 || arr.every(function (i) {
      return !i;
    });
  }

  return false;
}

function fixLocale(value, localeCode) {
  if (!localeCode) {
    return;
  }

  if (!value || value.length === 0) {
    return;
  }

  var _value2 = _slicedToArray(value, 2),
      start = _value2[0],
      end = _value2[1];

  if (start) {
    start.locale(localeCode);
  }

  if (end) {
    end.locale(localeCode);
  }
}

var RangePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RangePicker, _React$Component);

  function RangePicker(props) {
    var _this;

    _classCallCheck(this, RangePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangePicker).call(this, props));

    _this.savePicker = function (node) {
      _this.picker = node;
    };

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        value: []
      });

      _this.handleChange([]);
    };

    _this.clearHoverValue = function () {
      return _this.setState({
        hoverValue: []
      });
    };

    _this.handleChange = function (value) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (!('value' in props)) {
        _this.setState(function (_ref) {
          var showDate = _ref.showDate;
          return {
            value: value,
            showDate: getShowDateFromValue(value) || showDate
          };
        });
      }

      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
        value[1] = undefined;
      }

      var _value3 = _slicedToArray(value, 2),
          start = _value3[0],
          end = _value3[1];

      if (typeof props.onChange === 'function') {
        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
      }
    };

    _this.handleOpenChange = function (open) {
      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (open === false) {
        _this.clearHoverValue();
      }

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.handleShowDateChange = function (showDate) {
      return _this.setState({
        showDate: showDate
      });
    };

    _this.handleHoverChange = function (hoverValue) {
      return _this.setState({
        hoverValue: hoverValue
      });
    };

    _this.handleRangeMouseLeave = function () {
      if (_this.state.open) {
        _this.clearHoverValue();
      }
    };

    _this.handleCalendarInputSelect = function (value) {
      var _value4 = _slicedToArray(value, 1),
          start = _value4[0];

      if (!start) {
        return;
      }

      _this.setState(function (_ref2) {
        var showDate = _ref2.showDate;
        return {
          value: value,
          showDate: getShowDateFromValue(value) || showDate
        };
      });
    };

    _this.handleRangeClick = function (value) {
      if (typeof value === 'function') {
        value = value();
      }

      _this.setValue(value, true);

      var _this$props = _this.props,
          onOk = _this$props.onOk,
          onOpenChange = _this$props.onOpenChange;

      if (onOk) {
        onOk(value);
      }

      if (onOpenChange) {
        onOpenChange(false);
      }
    };

    _this.renderFooter = function () {
      var _this$props2 = _this.props,
          ranges = _this$props2.ranges,
          renderExtraFooter = _this$props2.renderExtraFooter;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          prefixCls = _assertThisInitialize2.prefixCls,
          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;

      if (!ranges && !renderExtraFooter) {
        return null;
      }

      var customFooter = renderExtraFooter ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra"),
        key: "extra"
      }, renderExtraFooter()) : null;
      var operations = ranges && Object.keys(ranges).map(function (range) {
        var value = ranges[range];
        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
        return React.createElement(_tag["default"], {
          key: range,
          prefixCls: tagPrefixCls,
          color: "blue",
          onClick: function onClick() {
            return _this.handleRangeClick(value);
          },
          onMouseEnter: function onMouseEnter() {
            return _this.setState({
              hoverValue: hoverValue
            });
          },
          onMouseLeave: _this.handleRangeMouseLeave
        }, range);
      });
      var rangeNode = operations && operations.length > 0 ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
        key: "range"
      }, operations) : null;
      return [rangeNode, customFooter];
    };

    _this.renderRangePicker = function (_ref3) {
      var _classNames;

      var getPrefixCls = _ref3.getPrefixCls;

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          state = _assertThisInitialize3.state,
          props = _assertThisInitialize3.props;

      var value = state.value,
          showDate = state.showDate,
          hoverValue = state.hoverValue,
          open = state.open;
      var customizePrefixCls = props.prefixCls,
          customizeTagPrefixCls = props.tagPrefixCls,
          popupStyle = props.popupStyle,
          style = props.style,
          disabledDate = props.disabledDate,
          disabledTime = props.disabledTime,
          showTime = props.showTime,
          showToday = props.showToday,
          ranges = props.ranges,
          onOk = props.onOk,
          locale = props.locale,
          localeCode = props.localeCode,
          format = props.format,
          dateRender = props.dateRender,
          onCalendarChange = props.onCalendarChange,
          suffixIcon = props.suffixIcon,
          separator = props.separator;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      _this.tagPrefixCls = tagPrefixCls;
      fixLocale(value, localeCode);
      fixLocale(showDate, localeCode);
      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

      var pickerChangeHandler = {
        onChange: _this.handleChange
      };
      var calendarProps = {
        onOk: _this.handleChange
      };

      if (props.timePicker) {
        pickerChangeHandler.onChange = function (changedValue) {
          return _this.handleChange(changedValue);
        };
      } else {
        calendarProps = {};
      }

      if ('mode' in props) {
        calendarProps.mode = props.mode;
      }

      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
      var calendar = React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
        seperator: separator,
        onChange: onCalendarChange,
        format: format,
        prefixCls: prefixCls,
        className: calendarClassName,
        renderFooter: _this.renderFooter,
        timePicker: props.timePicker,
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
        locale: locale.lang,
        onOk: onOk,
        dateRender: dateRender,
        value: showDate,
        onValueChange: _this.handleShowDateChange,
        hoverValue: hoverValue,
        onHoverChange: _this.handleHoverChange,
        onPanelChange: props.onPanelChange,
        showToday: showToday,
        onInputSelect: _this.handleCalendarInputSelect
      })); // default width for showTime

      var pickerStyle = {};

      if (props.showTime) {
        pickerStyle.width = style && style.width || 350;
      }

      var _value5 = _slicedToArray(value, 2),
          startValue = _value5[0],
          endValue = _value5[1];

      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = React.createElement(_InputIcon["default"], {
        suffixIcon: suffixIcon,
        prefixCls: prefixCls
      });

      var input = function input(_ref4) {
        var inputValue = _ref4.value;

        var _inputValue = _slicedToArray(inputValue, 2),
            start = _inputValue[0],
            end = _inputValue[1];

        return React.createElement("span", {
          className: props.pickerInputClass
        }, React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: (0, _utils.formatDate)(start, props.format),
          placeholder: startPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), React.createElement("span", {
          className: "".concat(prefixCls, "-range-picker-separator")
        }, " ", separator, " "), React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: (0, _utils.formatDate)(end, props.format),
          placeholder: endPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), clearIcon, inputIcon);
      };

      return React.createElement("span", {
        ref: _this.savePicker,
        id: typeof props.id === 'number' ? props.id.toString() : props.id,
        className: (0, _classnames["default"])(props.className, props.pickerClass),
        style: _extends(_extends({}, style), pickerStyle),
        tabIndex: props.disabled ? -1 : 0,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
      }, React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
        calendar: calendar,
        value: value,
        open: open,
        onOpenChange: _this.handleOpenChange,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue || [];

    var _value6 = _slicedToArray(value, 2),
        start = _value6[0],
        end = _value6[1];

    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
    }

    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
    _this.state = {
      value: value,
      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
      open: props.open,
      hoverValue: []
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, hidePanel) {
      this.handleChange(value);

      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var state = null;

      if ('value' in nextProps) {
        var value = nextProps.value || [];
        state = {
          value: value
        };

        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
          state = _extends(_extends({}, state), {
            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
          });
        }
      }

      if ('open' in nextProps && prevState.open !== nextProps.open) {
        state = _extends(_extends({}, state), {
          open: nextProps.open
        });
      }

      return state;
    }
  }]);

  return RangePicker;
}(React.Component);

RangePicker.defaultProps = {
  allowClear: true,
  showToday: false,
  separator: '~'
};
(0, _reactLifecyclesCompat.polyfill)(RangePicker);
var _default = RangePicker;
exports["default"] = _default;
//# sourceMappingURL=RangePicker.js.map


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactLifecyclesCompat = __webpack_require__(38);

var _KeyCode = __webpack_require__(132);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarPart = __webpack_require__(1071);

var _CalendarPart2 = _interopRequireDefault(_CalendarPart);

var _TodayButton = __webpack_require__(451);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(452);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(453);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

var _CommonMixin = __webpack_require__(454);

var _util = __webpack_require__(112);

var _toTime = __webpack_require__(1076);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;
  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var start = selectedValue[0],
      end = selectedValue[1];

  if (end && (start === undefined || start === null)) {
    start = end.clone().subtract(1, 'month');
  }

  if (start && (end === undefined || end === null)) {
    end = start.clone().add(1, 'month');
  }
  return [start, end];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
}

function generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];
  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }
  return arr;
}

function onInputSelect(direction, value, cause) {
  if (!value) {
    return;
  }
  var originalValue = this.state.selectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;
  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }
  this.props.onInputSelect(selectedValue);
  this.fireSelectValueChange(selectedValue, null, cause || { source: 'dateInput' });
}

var RangeCalendar = function (_React$Component) {
  (0, _inherits3['default'])(RangeCalendar, _React$Component);

  function RangeCalendar(props) {
    (0, _classCallCheck3['default'])(this, RangeCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue || props.defaultSelectedValue;
    var value = normalizeAnchor(props, 1);
    _this.state = {
      selectedValue: selectedValue,
      prevSelectedValue: selectedValue,
      firstSelectedValue: null,
      hoverValue: props.hoverValue || [],
      value: value,
      showTimePicker: false,
      mode: props.mode || ['date', 'date'],
      panelTriggerSource: '' // Trigger by which picker panel: 'start' & 'end'
    };
    return _this;
  }

  RangeCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};
    if ('value' in nextProps) {
      newState.value = normalizeAnchor(nextProps, 0);
    }
    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
      newState.hoverValue = nextProps.hoverValue;
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = nextProps.selectedValue;
      newState.prevSelectedValue = nextProps.selectedValue;
    }
    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
      newState.mode = nextProps.mode;
    }
    return newState;
  };

  // get disabled hours for second picker


  RangeCalendar.prototype.render = function render() {
    var _className, _classnames;

    var props = this.props,
        state = this.state;
    var prefixCls = props.prefixCls,
        dateInputPlaceholder = props.dateInputPlaceholder,
        seperator = props.seperator,
        timePicker = props.timePicker,
        showOk = props.showOk,
        locale = props.locale,
        showClear = props.showClear,
        showToday = props.showToday,
        type = props.type,
        clearIcon = props.clearIcon;
    var hoverValue = state.hoverValue,
        selectedValue = state.selectedValue,
        mode = state.mode,
        showTimePicker = state.showTimePicker;

    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
    var classes = (0, _classnames3['default'])(className);
    var newProps = {
      selectedValue: state.selectedValue,
      onSelect: this.onSelect,
      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
    };

    var placeholder1 = void 0;
    var placeholder2 = void 0;

    if (dateInputPlaceholder) {
      if (Array.isArray(dateInputPlaceholder)) {
        placeholder1 = dateInputPlaceholder[0];
        placeholder2 = dateInputPlaceholder[1];
      } else {
        placeholder1 = placeholder2 = dateInputPlaceholder;
      }
    }
    var showOkButton = showOk === true || showOk !== false && !!timePicker;
    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));

    var startValue = this.getStartValue();
    var endValue = this.getEndValue();
    var todayTime = (0, _util.getTodayTime)(startValue);
    var thisMonth = todayTime.month();
    var thisYear = todayTime.year();
    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
    var nextMonthOfStart = startValue.clone().add(1, 'months');
    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();

    var extraFooter = props.renderFooter();

    return _react2['default'].createElement(
      'div',
      {
        ref: this.saveRoot,
        className: classes,
        style: props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      props.renderSidebar(),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-panel' },
        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement(
          'a',
          {
            role: 'button',
            title: locale.clear,
            onClick: this.clear
          },
          clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
        ) : null,
        _react2['default'].createElement(
          'div',
          {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          },
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputChange: this.onStartInputChange,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker || mode[0] === 'time',
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
            clearIcon: clearIcon
          })),
          _react2['default'].createElement(
            'span',
            { className: prefixCls + '-range-middle' },
            seperator
          ),
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputChange: this.onEndInputChange,
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker || mode[1] === 'time',
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true,
            clearIcon: clearIcon
          }))
        ),
        _react2['default'].createElement(
          'div',
          { className: cls },
          showToday || props.timePicker || showOkButton || extraFooter ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-footer-btn' },
            extraFooter,
            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
              disabled: isTodayInView,
              value: state.value[0],
              onToday: this.onToday,
              text: locale.backToToday
            })) : null,
            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
              showTimePicker: showTimePicker || mode[0] === 'time' && mode[1] === 'time',
              onOpenTimePicker: this.onOpenTimePicker,
              onCloseTimePicker: this.onCloseTimePicker,
              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
            })) : null,
            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
              onOk: this.onOk,
              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
            })) : null
          ) : null
        )
      )
    );
  };

  return RangeCalendar;
}(_react2['default'].Component);

RangeCalendar.propTypes = (0, _extends3['default'])({}, _CommonMixin.propType, {
  prefixCls: _propTypes2['default'].string,
  dateInputPlaceholder: _propTypes2['default'].any,
  seperator: _propTypes2['default'].string,
  defaultValue: _propTypes2['default'].any,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['time', 'date', 'month', 'year', 'decade'])),
  showDateInput: _propTypes2['default'].bool,
  timePicker: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  showToday: _propTypes2['default'].bool,
  defaultSelectedValue: _propTypes2['default'].array,
  selectedValue: _propTypes2['default'].array,
  onOk: _propTypes2['default'].func,
  showClear: _propTypes2['default'].bool,
  locale: _propTypes2['default'].object,
  onChange: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  onValueChange: _propTypes2['default'].func,
  onHoverChange: _propTypes2['default'].func,
  onPanelChange: _propTypes2['default'].func,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
  onClear: _propTypes2['default'].func,
  type: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].func,
  disabledTime: _propTypes2['default'].func,
  clearIcon: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func
});
RangeCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, {
  type: 'both',
  seperator: '~',
  defaultSelectedValue: [],
  onValueChange: noop,
  onHoverChange: noop,
  onPanelChange: noop,
  disabledTime: noop,
  onInputSelect: noop,
  showToday: true,
  showDateInput: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onDatePanelEnter = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange(_this2.state.selectedValue.concat());
    }
  };

  this.onDatePanelLeave = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange([]);
    }
  };

  this.onSelect = function (value) {
    var type = _this2.props.type;
    var _state = _this2.state,
        selectedValue = _state.selectedValue,
        prevSelectedValue = _state.prevSelectedValue,
        firstSelectedValue = _state.firstSelectedValue;

    var nextSelectedValue = void 0;
    if (type === 'both') {
      if (!firstSelectedValue) {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      } else if (_this2.compare(firstSelectedValue, value) < 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [firstSelectedValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
        nextSelectedValue = [value, firstSelectedValue];
      }
    } else if (type === 'start') {
      (0, _util.syncTime)(prevSelectedValue[0], value);
      var endValue = selectedValue[1];
      nextSelectedValue = endValue && _this2.compare(endValue, value) > 0 ? [value, endValue] : [value];
    } else {
      // type === 'end'
      var startValue = selectedValue[0];
      if (startValue && _this2.compare(startValue, value) <= 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [startValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      }
    }

    _this2.fireSelectValueChange(nextSelectedValue);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return;
    }

    var keyCode = event.keyCode;

    var ctrlKey = event.ctrlKey || event.metaKey;

    var _state2 = _this2.state,
        selectedValue = _state2.selectedValue,
        hoverValue = _state2.hoverValue,
        firstSelectedValue = _state2.firstSelectedValue,
        value = _state2.value;
    var _props = _this2.props,
        onKeyDown = _props.onKeyDown,
        disabledDate = _props.disabledDate;

    // Update last time of the picker

    var updateHoverPoint = function updateHoverPoint(func) {
      // Change hover to make focus in UI
      var currentHoverTime = void 0;
      var nextHoverTime = void 0;
      var nextHoverValue = void 0;

      if (!firstSelectedValue) {
        currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
        nextHoverTime = func(currentHoverTime);
        nextHoverValue = [nextHoverTime];
        _this2.fireHoverValueChange(nextHoverValue);
      } else {
        if (hoverValue.length === 1) {
          currentHoverTime = hoverValue[0].clone();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        } else {
          currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        }
      }

      // Find origin hover time on value index
      if (nextHoverValue.length >= 2) {
        var miss = nextHoverValue.some(function (ht) {
          return !(0, _toTime.includesTime)(value, ht, 'month');
        });
        if (miss) {
          var newValue = nextHoverValue.slice().sort(function (t1, t2) {
            return t1.valueOf() - t2.valueOf();
          });
          if (newValue[0].isSame(newValue[1], 'month')) {
            newValue[1] = newValue[0].clone().add(1, 'month');
          }
          _this2.fireValueChange(newValue);
        }
      } else if (nextHoverValue.length === 1) {
        // If only one value, let's keep the origin panel
        var oriValueIndex = value.findIndex(function (time) {
          return time.isSame(currentHoverTime, 'month');
        });
        if (oriValueIndex === -1) oriValueIndex = 0;

        if (value.every(function (time) {
          return !time.isSame(nextHoverTime, 'month');
        })) {
          var _newValue = value.slice();
          _newValue[oriValueIndex] = nextHoverTime.clone();
          _this2.fireValueChange(_newValue);
        }
      }

      event.preventDefault();

      return nextHoverTime;
    };

    switch (keyCode) {
      case _KeyCode2['default'].DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'weeks');
        });
        return;
      case _KeyCode2['default'].UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'weeks');
        });
        return;
      case _KeyCode2['default'].LEFT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].RIGHT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].HOME:
        updateHoverPoint(function (time) {
          return (0, _toTime.goStartMonth)(time);
        });
        return;
      case _KeyCode2['default'].END:
        updateHoverPoint(function (time) {
          return (0, _toTime.goEndMonth)(time);
        });
        return;
      case _KeyCode2['default'].PAGE_DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'month');
        });
        return;
      case _KeyCode2['default'].PAGE_UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'month');
        });
        return;
      case _KeyCode2['default'].ENTER:
        {
          var lastValue = void 0;
          if (hoverValue.length === 0) {
            lastValue = updateHoverPoint(function (time) {
              return time;
            });
          } else if (hoverValue.length === 1) {
            lastValue = hoverValue[0];
          } else {
            lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          }
          if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
            _this2.onSelect(lastValue);
          }
          event.preventDefault();
          return;
        }
      default:
        if (onKeyDown) {
          onKeyDown(event);
        }
    }
  };

  this.onDayHover = function (value) {
    var hoverValue = [];
    var _state3 = _this2.state,
        selectedValue = _state3.selectedValue,
        firstSelectedValue = _state3.firstSelectedValue;
    var type = _this2.props.type;

    if (type === 'start' && selectedValue[1]) {
      hoverValue = _this2.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
    } else if (type === 'end' && selectedValue[0]) {
      hoverValue = _this2.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
    } else {
      if (!firstSelectedValue) {
        if (_this2.state.hoverValue.length) {
          _this2.setState({ hoverValue: [] });
        }
        return hoverValue;
      }
      hoverValue = _this2.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
    }
    _this2.fireHoverValueChange(hoverValue);

    return hoverValue;
  };

  this.onToday = function () {
    var startValue = (0, _util.getTodayTime)(_this2.state.value[0]);
    var endValue = startValue.clone().add(1, 'months');
    _this2.setState({ value: [startValue, endValue] });
  };

  this.onOpenTimePicker = function () {
    _this2.setState({
      showTimePicker: true
    });
  };

  this.onCloseTimePicker = function () {
    _this2.setState({
      showTimePicker: false
    });
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDateAndTime(selectedValue)) {
      _this2.props.onOk(_this2.state.selectedValue);
    }
  };

  this.onStartInputChange = function () {
    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
      oargs[_key] = arguments[_key];
    }

    var args = ['left'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onEndInputChange = function () {
    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      oargs[_key2] = arguments[_key2];
    }

    var args = ['right'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onStartInputSelect = function (value) {
    var args = ['left', value, { source: 'dateInputSelect' }];
    return onInputSelect.apply(_this2, args);
  };

  this.onEndInputSelect = function (value) {
    var args = ['right', value, { source: 'dateInputSelect' }];
    return onInputSelect.apply(_this2, args);
  };

  this.onStartValueChange = function (leftValue) {
    var value = [].concat(_this2.state.value);
    value[0] = leftValue;
    return _this2.fireValueChange(value);
  };

  this.onEndValueChange = function (rightValue) {
    var value = [].concat(_this2.state.value);
    value[1] = rightValue;
    return _this2.fireValueChange(value);
  };

  this.onStartPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [mode, state.mode[1]];
    var newState = {
      panelTriggerSource: 'start'
    };
    if (!('mode' in props)) {
      newState.mode = newMode;
    }
    _this2.setState(newState);
    var newValue = [value || state.value[0], state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.onEndPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [state.mode[0], mode];
    var newState = {
      panelTriggerSource: 'end'
    };
    if (!('mode' in props)) {
      newState.mode = newMode;
    }
    _this2.setState(newState);
    var newValue = [state.value[0], value || state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.getStartValue = function () {
    var _state4 = _this2.state,
        selectedValue = _state4.selectedValue,
        showTimePicker = _state4.showTimePicker,
        value = _state4.value,
        mode = _state4.mode,
        panelTriggerSource = _state4.panelTriggerSource;

    var startValue = value[0];
    // keep selectedTime when select date
    if (selectedValue[0] && _this2.props.timePicker) {
      startValue = startValue.clone();
      (0, _util.syncTime)(selectedValue[0], startValue);
    }
    if (showTimePicker && selectedValue[0]) {
      startValue = selectedValue[0];
    }

    // Adjust month if date not align
    if (panelTriggerSource === 'end' && mode[0] === 'date' && mode[1] === 'date' && startValue.isSame(value[1], 'month')) {
      startValue = startValue.clone().subtract(1, 'month');
    }

    return startValue;
  };

  this.getEndValue = function () {
    var _state5 = _this2.state,
        value = _state5.value,
        selectedValue = _state5.selectedValue,
        showTimePicker = _state5.showTimePicker,
        mode = _state5.mode,
        panelTriggerSource = _state5.panelTriggerSource;

    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
    // keep selectedTime when select date
    if (selectedValue[1] && _this2.props.timePicker) {
      (0, _util.syncTime)(selectedValue[1], endValue);
    }
    if (showTimePicker) {
      endValue = selectedValue[1] ? selectedValue[1] : _this2.getStartValue();
    }

    // Adjust month if date not align
    if (!showTimePicker && panelTriggerSource !== 'end' && mode[0] === 'date' && mode[1] === 'date' && endValue.isSame(value[0], 'month')) {
      endValue = endValue.clone().add(1, 'month');
    }

    return endValue;
  };

  this.getEndDisableTime = function () {
    var _state6 = _this2.state,
        selectedValue = _state6.selectedValue,
        value = _state6.value;
    var disabledTime = _this2.props.disabledTime;

    var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
    var startValue = selectedValue && selectedValue[0] || value[0].clone();
    // if startTime and endTime is same day..
    // the second time picker will not able to pick time before first time picker
    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
      var hours = startValue.hour();
      var minutes = startValue.minute();
      var second = startValue.second();
      var _disabledHours = userSettingDisabledTime.disabledHours,
          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
          _disabledSeconds = userSettingDisabledTime.disabledSeconds;

      var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
      var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
      _disabledHours = generateOptions(hours, _disabledHours);
      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
      _disabledSeconds = generateOptions(second, _disabledSeconds);
      return {
        disabledHours: function disabledHours() {
          return _disabledHours;
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === hours) {
            return _disabledMinutes;
          }
          return oldDisabledMinutes;
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === hours && minute === minutes) {
            return _disabledSeconds;
          }
          return olddisabledSeconds;
        }
      };
    }
    return userSettingDisabledTime;
  };

  this.isAllowedDateAndTime = function (selectedValue) {
    return (0, _util.isAllowedDate)(selectedValue[0], _this2.props.disabledDate, _this2.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], _this2.props.disabledDate, _this2.disabledEndTime);
  };

  this.isMonthYearPanelShow = function (mode) {
    return ['month', 'year', 'decade'].indexOf(mode) > -1;
  };

  this.hasSelectedValue = function () {
    var selectedValue = _this2.state.selectedValue;

    return !!selectedValue[1] && !!selectedValue[0];
  };

  this.compare = function (v1, v2) {
    if (_this2.props.timePicker) {
      return v1.diff(v2);
    }
    return v1.diff(v2, 'days');
  };

  this.fireSelectValueChange = function (selectedValue, direct, cause) {
    var timePicker = _this2.props.timePicker;
    var prevSelectedValue = _this2.state.prevSelectedValue;

    if (timePicker && timePicker.props.defaultValue) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (!prevSelectedValue[0] && selectedValue[0]) {
        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
      }
      if (!prevSelectedValue[1] && selectedValue[1]) {
        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
      }
    }

    if (!('selectedValue' in _this2.props)) {
      _this2.setState({
        selectedValue: selectedValue
      });
    }

    // 尚未选择过时间，直接输入的话
    if (!_this2.state.selectedValue[0] || !_this2.state.selectedValue[1]) {
      var startValue = selectedValue[0] || (0, _moment2['default'])();
      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
      _this2.setState({
        selectedValue: selectedValue,
        value: getValueFromSelectedValue([startValue, endValue])
      });
    }

    if (selectedValue[0] && !selectedValue[1]) {
      _this2.setState({ firstSelectedValue: selectedValue[0] });
      _this2.fireHoverValueChange(selectedValue.concat());
    }
    _this2.props.onChange(selectedValue);
    if (direct || selectedValue[0] && selectedValue[1]) {
      _this2.setState({
        prevSelectedValue: selectedValue,
        firstSelectedValue: null
      });
      _this2.fireHoverValueChange([]);
      _this2.props.onSelect(selectedValue, cause);
    }
  };

  this.fireValueChange = function (value) {
    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    props.onValueChange(value);
  };

  this.fireHoverValueChange = function (hoverValue) {
    var props = _this2.props;
    if (!('hoverValue' in props)) {
      _this2.setState({ hoverValue: hoverValue });
    }
    props.onHoverChange(hoverValue);
  };

  this.clear = function () {
    _this2.fireSelectValueChange([], true);
    _this2.props.onClear();
  };

  this.disabledStartTime = function (time) {
    return _this2.props.disabledTime(time, 'start');
  };

  this.disabledEndTime = function (time) {
    return _this2.props.disabledTime(time, 'end');
  };

  this.disabledStartMonth = function (month) {
    var value = _this2.state.value;

    return month.isAfter(value[1], 'month');
  };

  this.disabledEndMonth = function (month) {
    var value = _this2.state.value;

    return month.isBefore(value[0], 'month');
  };
};

(0, _reactLifecyclesCompat.polyfill)(RangeCalendar);

exports['default'] = (0, _CommonMixin.commonMixinWrapper)(RangeCalendar);
module.exports = exports['default'];

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CalendarHeader = __webpack_require__(449);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _DateTable = __webpack_require__(1072);

var _DateTable2 = _interopRequireDefault(_DateTable);

var _DateInput = __webpack_require__(1075);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _index = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarPart = function (_React$Component) {
  (0, _inherits3['default'])(CalendarPart, _React$Component);

  function CalendarPart() {
    (0, _classCallCheck3['default'])(this, CalendarPart);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarPart.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        value = props.value,
        hoverValue = props.hoverValue,
        selectedValue = props.selectedValue,
        mode = props.mode,
        direction = props.direction,
        locale = props.locale,
        format = props.format,
        placeholder = props.placeholder,
        disabledDate = props.disabledDate,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        timePickerDisabledTime = props.timePickerDisabledTime,
        showTimePicker = props.showTimePicker,
        onInputChange = props.onInputChange,
        onInputSelect = props.onInputSelect,
        enablePrev = props.enablePrev,
        enableNext = props.enableNext,
        clearIcon = props.clearIcon,
        showClear = props.showClear,
        inputMode = props.inputMode;

    var shouldShowTimePicker = showTimePicker && timePicker;
    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
    var rangeClassName = prefixCls + '-range';
    var newProps = {
      locale: locale,
      value: value,
      prefixCls: prefixCls,
      showTimePicker: showTimePicker
    };
    var index = direction === 'left' ? 0 : 1;
    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
      showHour: true,
      showMinute: true,
      showSecond: true
    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
      onChange: onInputChange,
      defaultOpenValue: value,
      value: selectedValue[index]
    }));

    var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
      format: format,
      locale: locale,
      prefixCls: prefixCls,
      timePicker: timePicker,
      disabledDate: disabledDate,
      placeholder: placeholder,
      disabledTime: disabledTime,
      value: value,
      showClear: showClear || false,
      selectedValue: selectedValue[index],
      onChange: onInputChange,
      onSelect: onInputSelect,
      clearIcon: clearIcon,
      inputMode: inputMode
    });

    return _react2['default'].createElement(
      'div',
      {
        className: rangeClassName + '-part ' + rangeClassName + '-' + direction
      },
      dateInputElement,
      _react2['default'].createElement(
        'div',
        { style: { outline: 'none' } },
        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
          mode: mode,
          enableNext: enableNext,
          enablePrev: enablePrev,
          onValueChange: props.onValueChange,
          onPanelChange: props.onPanelChange,
          disabledMonth: props.disabledMonth
        })),
        showTimePicker ? _react2['default'].createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          }))
        )
      )
    );
  };

  return CalendarPart;
}(_react2['default'].Component);

CalendarPart.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  selectedValue: _propTypes2['default'].any,
  direction: _propTypes2['default'].any,
  locale: _propTypes2['default'].any,
  showDateInput: _propTypes2['default'].bool,
  showTimePicker: _propTypes2['default'].bool,
  format: _propTypes2['default'].any,
  placeholder: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].any,
  disabledTime: _propTypes2['default'].any,
  onInputChange: _propTypes2['default'].func,
  onInputSelect: _propTypes2['default'].func,
  timePickerDisabledTime: _propTypes2['default'].object,
  enableNext: _propTypes2['default'].any,
  enablePrev: _propTypes2['default'].any,
  clearIcon: _propTypes2['default'].node,
  dateRender: _propTypes2['default'].func,
  inputMode: _propTypes2['default'].string
};
exports['default'] = CalendarPart;
module.exports = exports['default'];

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateTHead = __webpack_require__(1073);

var _DateTHead2 = _interopRequireDefault(_DateTHead);

var _DateTBody = __webpack_require__(1074);

var _DateTBody2 = _interopRequireDefault(_DateTBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTable = function (_React$Component) {
  (0, _inherits3['default'])(DateTable, _React$Component);

  function DateTable() {
    (0, _classCallCheck3['default'])(this, DateTable);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(_DateTHead2['default'], props),
      _react2['default'].createElement(_DateTBody2['default'], props)
    );
  };

  return DateTable;
}(_react2['default'].Component);

exports['default'] = DateTable;
module.exports = exports['default'];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateConstants = __webpack_require__(464);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTHead = function (_React$Component) {
  (0, _inherits3['default'])(DateTHead, _React$Component);

  function DateTHead() {
    (0, _classCallCheck3['default'])(this, DateTHead);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = (0, _moment2['default'])();
    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = _react2['default'].createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return _react2['default'].createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return _react2['default'].createElement(
      'thead',
      null,
      _react2['default'].createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(_react2['default'].Component);

exports['default'] = DateTHead;
module.exports = exports['default'];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _DateConstants = __webpack_require__(464);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _util = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  (0, _inherits3['default'])(DateTBody, _React$Component);

  function DateTBody() {
    (0, _classCallCheck3['default'])(this, DateTBody);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = (0, _util.getTodayTime)(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = _react2['default'].createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = _react2['default'].createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(_react2['default'].createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: (0, _util.getTitleString)(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(_react2['default'].createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return _react2['default'].createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(_react2['default'].Component);

DateTBody.propTypes = {
  contentRender: _propTypes2['default'].func,
  dateRender: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
  value: _propTypes2['default'].object,
  hoverValue: _propTypes2['default'].any,
  showWeekNumber: _propTypes2['default'].bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
exports['default'] = DateTBody;
module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(132);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _reactLifecyclesCompat = __webpack_require__(38);

var _moment = __webpack_require__(21);

var _moment2 = _interopRequireDefault(_moment);

var _util = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  (0, _inherits3['default'])(DateInput, _React$Component);

  function DateInput(props) {
    (0, _classCallCheck3['default'])(this, DateInput);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: (0, _util.formatDate)(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: (0, _util.formatDate)(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon,
        inputMode = props.inputMode;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        _react2['default'].createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          inputMode: inputMode
        })
      ),
      props.showClear ? _react2['default'].createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(_react2['default'].Component);

DateInput.propTypes = {
  prefixCls: _propTypes2['default'].string,
  timePicker: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  disabledTime: _propTypes2['default'].any,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
  locale: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func,
  onChange: _propTypes2['default'].func,
  onClear: _propTypes2['default'].func,
  placeholder: _propTypes2['default'].string,
  onSelect: _propTypes2['default'].func,
  selectedValue: _propTypes2['default'].object,
  clearIcon: _propTypes2['default'].node,
  inputMode: _propTypes2['default'].string
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = (0, _moment2['default'])(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: (0, _util.formatDate)(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (event) {
    var keyCode = event.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value,
        disabledDate = _props2.disabledDate;

    if (keyCode === _KeyCode2['default'].ENTER && onSelect) {
      var validateDate = !disabledDate || !disabledDate(value);
      if (validateDate) {
        onSelect(value.clone());
      }
      event.preventDefault();
    }
  };

  this.getRootDOMNode = function () {
    return _reactDom2['default'].findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

(0, _reactLifecyclesCompat.polyfill)(DateInput);

exports['default'] = DateInput;
module.exports = exports['default'];

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.goStartMonth = goStartMonth;
exports.goEndMonth = goEndMonth;
exports.goTime = goTime;
exports.includesTime = includesTime;
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckableTag =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckableTag, _React$Component);

  function CheckableTag() {
    var _this;

    _classCallCheck(this, CheckableTag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckableTag).apply(this, arguments));

    _this.handleClick = function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange;

      if (onChange) {
        onChange(!checked);
      }
    };

    _this.renderCheckableTag = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          checked = _a.checked,
          restProps = __rest(_a, ["prefixCls", "className", "checked"]);

      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
      delete restProps.onChange; // TypeScript cannot check delete now.

      return React.createElement("span", _extends({}, restProps, {
        className: cls,
        onClick: _this.handleClick
      }));
    };

    return _this;
  }

  _createClass(CheckableTag, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag);
    }
  }]);

  return CheckableTag;
}(React.Component);

exports["default"] = CheckableTag;
//# sourceMappingURL=CheckableTag.js.map


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(38);

var _rcCalendar = _interopRequireDefault(__webpack_require__(445));

var _Picker = _interopRequireDefault(__webpack_require__(305));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _interopDefault = _interopRequireDefault(__webpack_require__(125));

var _InputIcon = _interopRequireDefault(__webpack_require__(467));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function formatValue(value, format) {
  return value && value.format(format) || '';
}

var WeekPicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WeekPicker, _React$Component);

  function WeekPicker(props) {
    var _this;

    _classCallCheck(this, WeekPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeekPicker).call(this, props));

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.weekDateRender = function (current) {
      var selectedValue = _this.state.value;

      var _assertThisInitialize = _assertThisInitialized(_this),
          prefixCls = _assertThisInitialize.prefixCls;

      var dateRender = _this.props.dateRender;
      var dateNode = dateRender ? dateRender(current) : current.date();

      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "-selected-day")
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-date")
        }, dateNode));
      }

      return React.createElement("div", {
        className: "".concat(prefixCls, "-date")
      }, dateNode);
    };

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      _this.props.onChange(value, formatValue(value, _this.props.format));
    };

    _this.handleOpenChange = function (open) {
      var onOpenChange = _this.props.onOpenChange;

      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.handleChange(null);
    };

    _this.renderFooter = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          renderExtraFooter = _this$props.renderExtraFooter;
      return renderExtraFooter ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
      }, renderExtraFooter.apply(void 0, arguments)) : null;
    };

    _this.renderWeekPicker = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          pickerClass = _this$props2.pickerClass,
          popupStyle = _this$props2.popupStyle,
          pickerInputClass = _this$props2.pickerInputClass,
          format = _this$props2.format,
          allowClear = _this$props2.allowClear,
          locale = _this$props2.locale,
          localeCode = _this$props2.localeCode,
          disabledDate = _this$props2.disabledDate,
          style = _this$props2.style,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          id = _this$props2.id,
          suffixIcon = _this$props2.suffixIcon,
          defaultPickerValue = _this$props2.defaultPickerValue;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      var _this$state = _this.state,
          open = _this$state.open,
          pickerValue = _this$state.value;

      if (pickerValue && localeCode) {
        pickerValue.locale(localeCode);
      }

      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
      var calendar = React.createElement(_rcCalendar["default"], {
        showWeekNumber: true,
        dateRender: _this.weekDateRender,
        prefixCls: prefixCls,
        format: format,
        locale: locale.lang,
        showDateInput: false,
        showToday: false,
        disabledDate: disabledDate,
        renderFooter: _this.renderFooter,
        defaultValue: defaultPickerValue
      });
      var clearIcon = !disabled && allowClear && _this.state.value ? React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = React.createElement(_InputIcon["default"], {
        suffixIcon: suffixIcon,
        prefixCls: prefixCls
      });

      var input = function input(_ref2) {
        var value = _ref2.value;
        return React.createElement("span", {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, React.createElement("input", {
          ref: _this.saveInput,
          disabled: disabled,
          readOnly: true,
          value: value && value.format(format) || '',
          placeholder: placeholder,
          className: pickerInputClass,
          onFocus: onFocus,
          onBlur: onBlur
        }), clearIcon, inputIcon);
      };

      return React.createElement("span", {
        className: (0, _classnames["default"])(className, pickerClass),
        style: style,
        id: id
      }, React.createElement(_Picker["default"], _extends({}, _this.props, {
        calendar: calendar,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        value: pickerValue,
        onChange: _this.handleChange,
        open: open,
        onOpenChange: _this.handleOpenChange,
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
    }

    _this.state = {
      value: value,
      open: props.open
    };
    return _this;
  }

  _createClass(WeekPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps || 'open' in nextProps) {
        var state = {};

        if ('value' in nextProps) {
          state.value = nextProps.value;
        }

        if ('open' in nextProps) {
          state.open = nextProps.open;
        }

        return state;
      }

      return null;
    }
  }]);

  return WeekPicker;
}(React.Component);

WeekPicker.defaultProps = {
  format: 'gggg-wo',
  allowClear: true
};
(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
var _default = WeekPicker;
exports["default"] = _default;
//# sourceMappingURL=WeekPicker.js.map


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aPatientEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);








var ConsentFormStep3aPatientEmail = function ConsentFormStep3aPatientEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'Email') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Patient'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, '(Subject Deferred Consent Form)'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', null, 'Title of Study:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in patients with Acute Ischemic\xA0\xA0 Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Site Investigator: Dr. Shelagh Coutts')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Coordinating Center: The Governors of the University of Calgary')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Introduction')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here.  Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Why is this Study being done?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You were enrolled as a participant in this study because you had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.\xA0 Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you were incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'What will happen if I take part in this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.\xA0 This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.\xA0 The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.\xA0 After the 3-month assessment (phone call and online assessment) is finished, your participation in the study will be complete.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Up to 1600 people at hospitals in Canada will participate in this study.  Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Are there any potential risks or discomforts that I can expect from this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '5. The risk to an unborn child is uncertain. If you are pregnant, you have been enrolled into this study after an in-depth consultation with an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Are there any potential benefits if I participate?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'What if researchers discover something about me?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120. The patient will receive any new information during the course of the study concerning significant treatment findings.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Will my information and participation be kept confidential?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. \xA0Your name, telephone number and/or email, will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. An additional contact person will be requested, as a back-up contact, for the Day 90-120-day telephone follow-up. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.\xA0 Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with your health care number.\xA0 Your name is not included in these databases.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', target: '_blank' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'If I suffer a research-related injury, will I be compensated?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In the event that you suffer injury because of participating in this research, the University of Calgary, Alberta Health Services, or the Researchers will provide no compensation for you. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Will I be paid for participating, or do I have to pay for anything?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'CONSENT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Please select the appropriate option to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'SIGNATURES')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts (403) 944-1591 or'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Stroke Research office (403) 944-2863'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study.\xA0 A signed copy of this consent form has been given to you to keep for your records and reference.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'REB#18-1101:'), ' Title: Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke (AcT): QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial \xA0\xA0', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'PI'), ': Dr. Shelagh Coutts Version 2.0 26 March 2021')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Participant Email', size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish for the patient to stay in the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw the patient from the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I  wish  to  withdraw  the  patient  from  the  study  but  allow  data  to  be  collected  from  this  point  onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aSurrogate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);










var ConsentFormStep3aSurrogate = function ConsentFormStep3aSurrogate(props) {
  if (props.currentStep !== "Step 3a" || props.consentPersonType !== "Surrogate" || props.consentMethodType !== "Electronic") {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Electronic Consent Process - Surrogate"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Site ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "User ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Subject ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.subjectID)), props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "INFORMATION AND CONSENT FORM"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "Title:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Site Investigator: Dr. Shelagh Coutts")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Coordinating Center: The Governors of the University of Calgary")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here. Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Why is this study being done?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \"the patient\" throughout this consent form refers to that individual.\xA0 Your obligation is to try to determine what the patient would do if competent, or if the patient\u2019s wishes cannot be determined, what you think is in their best interest.")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The patient was enrolled as a participant in this study because they had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and the patient was incapacitated at the time of their stroke. The patient was enrolled by deferral of consent, meaning that they received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by this hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "How many people will take part in this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Up to 1600 people at hospitals in Canada will participate in this study. Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Are there any potential risks or discomforts that I can expect from this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by the treating physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "1. Bruising or bleeding from the injection site, nose or gums. Generally, such bleeding is easily controlled."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "5. The risk to an unborn child is uncertain. If the patient is pregnant, she has been enrolled into this study after an in-depth consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "Are there any potential benefits if I participate?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you agree for the patient to participate in this study, there may or may not be a direct medical benefit to the patient. Participation in this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. The patient's stroke may be improved during the study but there is no guarantee of that. The possible benefits to the patient from taking part in this study are close monitoring of their stroke, general health status, and any symptoms that they may experience during the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "What if researchers discover something about me?\xA0")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Will my information and participation be kept confidential?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, we will be collecting health data about the patient. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release information with the patient's name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that all health information is kept private."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "No data relating to this study that includes the patient's name will be released to anyone outside of the research team, nor will the researchers publish it.\xA0Your name, as well as the patient's name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you or the patient for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive all private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about the patient from a number of sources.\xA0Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, the hospital site, other health care providers that the patient may have seen in the past (i.e. family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with their health care number.\xA0 The patient's name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In order to locate information about the patient's past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where the patient was originally admitted at the time of their stroke, authorized personnel from the study hospitals or registries will provide their health care number directly to CIHI solely for the purpose of extracting their hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store the patient's health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study, after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "A description of this clinical trial is available on", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "If I suffer a research-related injury, will I be compensated?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In the event that the patient suffers injury as a result of participating in this research, no compensation will be provided for the patient by the University of Calgary, Alberta Health Services, or the Researchers. The patient still have all of their legal rights. Nothing said here about treatment or compensation in any way alters their right to recover damages."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "Will I be paid for participating, or do I have to pay for anything?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "CONSENT")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You are providing consent for the patient to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent on behalf of the patient, data collected up until this point will be retained. You nor the patient will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Please check the appropriate boxes to indicate your decision:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("b", { style: { textDecoration: 'underline' } }, "SIGNATURES"))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient's participation in the research project and agree for the patient to participate as a participant. In no way does this waive the patient's legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw the patient from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Dr. Shelagh Coutts (403) 944-1591"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "OR"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "The Stroke Research office (403) 944-2863"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "REGAINED CAPACITY CONSENT FORM")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Please check the appropriate boxes to indicate your decision:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Dr. Shelagh Coutts: (403)-944-1594"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Chair of the Conjoint Health Research Ethics Board, University of Calgary at (403) 220-7990."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The University of Calgary Conjoint Health Research Ethics Board has approved this research study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "A signed copy of this consent form will be is provided for your records and reference."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "REB#18-1101: Title:"), " Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research AlbertaStroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "PI:"), " Dr. Shelagh Coutts"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Version 2.0 26 March 2021"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("fullName", { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Participant's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "fullName", name: "fullName", placeholder: "Participant Full Name", autoFocus: true, allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("dateOfBirth", { initialValue: props.dateOfBirth, onChange: props.handleDatePickerChange, rules: [{ required: false, message: "Please select the Participant's Date of Birth" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "dateOfBirth", name: "dateOfBirth", placeholder: "Participant Date of Birth (optional)", allowClear: true, size: "large", className: "ant-input ant-input-lg" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("representativeFullName", { initialValue: props.representativeFullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Legally Authorized Representative's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "representativeFullName", name: "representativeFullName", placeholder: "Representative's Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("investigatorFullName", { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Investigator/Delegate's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "investigatorFullName", name: "investigatorFullName", placeholder: "Investigator/Delegate Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("witnessFullName", { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "witnessFullName", name: "witnessFullName", placeholder: "Witness Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentOption", { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: "Please select consent option below:" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Please select consent option below:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentOption", name: "consentOption", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Consent Option?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "stay_in_study" }, "I wish for the patient to stay in the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study" }, "I wish to withdraw the patient from the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw the patient from the study but allow data to be collected from this point onward via health record linkage."))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentProvided", { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Do you consent to the terms described above? If no, please click on the Back button!"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentProvided", name: "consentProvided", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Provide Consent?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "No"))))));
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aSurrogateEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);








var ConsentFormStep3aSurrogateEmail = function ConsentFormStep3aSurrogateEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Surrogate' || props.consentMethodType !== 'Email') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Surrogate'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, 'Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', null, 'Title:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Site Investigator: Dr. Shelagh Coutts')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Coordinating Center: The Governors of the University of Calgary')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here.  Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Why is this study being done?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', null, 'If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, "the patient" throughout this consent form refers to that individual.\xA0 Your obligation is to try to determine what the patient would do if competent, or if the patient\u2019s wishes cannot be determined, what you think is in their best interest.')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The patient was enrolled as a participant in this study because they had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and the patient was incapacitated at the time of their stroke. The patient was enrolled by deferral of consent, meaning that they received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by this hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'How many people will take part in this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Up to 1600 people at hospitals in Canada will participate in this study. Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Are there any potential risks or discomforts that I can expect from this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by the treating physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '1. Bruising or bleeding from the injection site, nose or gums. Generally, such bleeding is easily controlled.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '5. The risk to an unborn child is uncertain. If the patient is pregnant, she has been enrolled into this study after an in-depth consultation with an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'Are there any potential benefits if I participate?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you agree for the patient to participate in this study, there may or may not be a direct medical benefit to the patient. Participation in this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. The patient\'s stroke may be improved during the study but there is no guarantee of that. The possible benefits to the patient from taking part in this study are close monitoring of their stroke, general health status, and any symptoms that they may experience during the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'What if researchers discover something about me?\xA0')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you.  You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Will my information and participation be kept confidential?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, we will be collecting health data about the patient. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release information with the patient\'s name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that all health information is kept private.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'No data relating to this study that includes the patient\'s name will be released to anyone outside of the research team, nor will the researchers publish it.\xA0Your name, as well as the patient\'s name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you or the patient for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive all private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about the patient from a number of sources.\xA0Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, the hospital site, other health care providers that the patient may have seen in the past (i.e. family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with their health care number.\xA0 The patient\'s name is not included in these databases.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In order to locate information about the patient\'s past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where the patient was originally admitted at the time of their stroke, authorized personnel from the study hospitals or registries will provide their health care number directly to CIHI solely for the purpose of extracting their hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store the patient\'s health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study, after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', target: '_blank' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'If I suffer a research-related injury, will I be compensated?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In the event that the patient suffers injury as a result of participating in this research, no compensation will be provided for the patient by the University of Calgary, Alberta Health Services, or the Researchers. The patient still have all of their legal rights. Nothing said here about treatment or compensation in any way alters their right to recover damages.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'Will I be paid for participating, or do I have to pay for anything?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'CONSENT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You are providing consent for the patient to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent on behalf of the patient, data collected up until this point will be retained. You nor the patient will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Please check the appropriate boxes to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b', { style: { textDecoration: 'underline' } }, 'SIGNATURES'))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\'s participation in the research project and agree for the patient to participate as a participant. In no way does this waive the patient\'s legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw the patient from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts (403) 944-1591'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'OR'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'The Stroke Research office (403) 944-2863'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'REGAINED CAPACITY CONSENT FORM')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Please check the appropriate boxes to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts: (403)-944-1594'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Chair of the Conjoint Health Research Ethics Board, University of Calgary at (403) 220-7990.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'A signed copy of this consent form will be is provided for your records and reference.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'REB#18-1101: Title:'), ' Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research AlbertaStroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'PI:'), ' Dr. Shelagh Coutts'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Version 2.0  26 March 2021'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Legally Authorized Representative\'s full name'), props.getFieldDecorator('representativeFullName', { initialValue: props.representativeFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Legally Authorized Representative\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'representativeFullName', name: 'representativeFullName', placeholder: 'Representative\'s Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the representative\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Representative\'s Email', size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish for the patient to stay in the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw the patient from the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I  wish  to  withdraw  the  patient  from  the  study  but  allow  data  to  be  collected  from  this  point  onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aRegainedCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);










var ConsentFormStep3aRegainedCapacity = function ConsentFormStep3aRegainedCapacity(props) {
  if (props.currentStep !== "Step 3a" || props.consentPersonType !== "Patient" || props.consentMethodType !== "RegainedCapacity") {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Electronic Consent Process - Regained capacity"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Site ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "User ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Subject ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", { style: { color: "#4CDEF5", display: "inline-block" } }, props.subjectID)), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "INFORMATION AND CONSENT FORM"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { align: "center" }, "Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "Title:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Site Investigator: Dr. Shelagh Coutts")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Coordinating Center: The Governors of the University of Calgary")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here. Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Why is this study being done?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \"the patient\" throughout this consent form refers to that individual.\xA0 Your obligation is to try to determine what the patient would do if competent, or if the patient\u2019s wishes cannot be determined, what you think is in their best interest.")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The patient was enrolled as a participant in this study because they had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and the patient was incapacitated at the time of their stroke. The patient was enrolled by deferral of consent, meaning that they received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by this hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "How many people will take part in this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Up to 1600 people at hospitals in Canada will participate in this study. Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Are there any potential risks or discomforts that I can expect from this study?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by the treating physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "1. Bruising or bleeding from the injection site, nose or gums. Generally, such bleeding is easily controlled."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "5. The risk to an unborn child is uncertain. If the patient is pregnant, she has been enrolled into this study after an in-depth consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "Are there any potential benefits if I participate?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you agree for the patient to participate in this study, there may or may not be a direct medical benefit to the patient. Participation in this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. The patient's stroke may be improved during the study but there is no guarantee of that. The possible benefits to the patient from taking part in this study are close monitoring of their stroke, general health status, and any symptoms that they may experience during the study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "What if researchers discover something about me?\xA0")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Will my information and participation be kept confidential?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During the study, we will be collecting health data about the patient. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release information with the patient's name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that all health information is kept private."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "No data relating to this study that includes the patient's name will be released to anyone outside of the research team, nor will the researchers publish it.\xA0Your name, as well as the patient's name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you or the patient for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive all private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about the patient from a number of sources.\xA0Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, the hospital site, other health care providers that the patient may have seen in the past (i.e. family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with their health care number.\xA0 The patient's name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In order to locate information about the patient's past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where the patient was originally admitted at the time of their stroke, authorized personnel from the study hospitals or registries will provide their health care number directly to CIHI solely for the purpose of extracting their hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store the patient's health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study, after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "A description of this clinical trial is available on", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "If I suffer a research-related injury, will I be compensated?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "In the event that the patient suffers injury as a result of participating in this research, no compensation will be provided for the patient by the University of Calgary, Alberta Health Services, or the Researchers. The patient still have all of their legal rights. Nothing said here about treatment or compensation in any way alters their right to recover damages."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br", null), "Will I be paid for participating, or do I have to pay for anything?")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "CONSENT")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "You are providing consent for the patient to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent on behalf of the patient, data collected up until this point will be retained. You nor the patient will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Please check the appropriate boxes to indicate your decision:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("b", { style: { textDecoration: 'underline' } }, "SIGNATURES"))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient's participation in the research project and agree for the patient to participate as a participant. In no way does this waive the patient's legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw the patient from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Dr. Shelagh Coutts (403) 944-1591"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "OR"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "The Stroke Research office (403) 944-2863"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "REGAINED CAPACITY CONSENT FORM")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Please check the appropriate boxes to indicate your decision:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Dr. Shelagh Coutts: (403)-944-1594"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Chair of the Conjoint Health Research Ethics Board, University of Calgary at (403) 220-7990."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The University of Calgary Conjoint Health Research Ethics Board has approved this research study."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "A signed copy of this consent form will be is provided for your records and reference."), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "REB#18-1101: Title:"), " Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research AlbertaStroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "PI:"), " Dr. Shelagh Coutts"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { align: "center" }, "Version 2.0 26 March 2021"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("fullName", { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Participant's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "fullName", name: "fullName", placeholder: "Participant Full Name", autoFocus: true, allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("dateOfBirth", { initialValue: props.dateOfBirth || null, onChange: props.handleDatePickerChange, rules: [{ required: false, message: "Please select the Participant's Date of Birth" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "dateOfBirth", name: "dateOfBirth", placeholder: "Participant Date of Birth (optional)", allowClear: true, size: "large", className: "ant-input ant-input-lg" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("investigatorFullName", { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: "Please enter the Investigator/Delegate's full name" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "investigatorFullName", name: "investigatorFullName", placeholder: "Investigator/Delegate Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("witnessFullName", { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), id: "witnessFullName", name: "witnessFullName", placeholder: "Witness Full Name", allowClear: true, size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentOption", { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: "Please select consent option below:" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Please select consent option below:"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentOption", name: "consentOption", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Consent Option?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "stay_in_study" }, "I wish to stay in the study"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage"))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator("consentProvided", { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Do you consent to the terms described above? If no, please click on the Back button!"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "consentProvided", name: "consentProvided", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Provide Consent?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "No"))))));
};

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aRegainedCapacityEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);








var ConsentFormStep3aRegainedCapacityEmail = function ConsentFormStep3aRegainedCapacityEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'EmailRegainedCapacity') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Email Consent Process - Regained capacity'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { align: 'center' }, 'Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', null, 'Title:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Sponsor-Investigator/Funder:\xA0 Dr. Bijoy Menon, CIHR (Canadian Institutes of Health Research)')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Site Investigator: Dr. Shelagh Coutts')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Coordinating Center: The Governors of the University of Calgary')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. Please ask if you would like more detail about something mentioned here, or information not included here.  Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Why is this study being done?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', null, 'If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, "the patient" throughout this consent form refers to that individual.\xA0 Your obligation is to try to determine what the patient would do if competent, or if the patient\u2019s wishes cannot be determined, what you think is in their best interest.')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The patient was enrolled as a participant in this study because they had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and the patient was incapacitated at the time of their stroke. The patient was enrolled by deferral of consent, meaning that they received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by this hospital\u2019s research ethics board. You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'How many people will take part in this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Up to 1600 people at hospitals in Canada will participate in this study. Approximately 500 people who will take part in this study at the Foothills Medical Centre- University of Calgary.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Are there any potential risks or discomforts that I can expect from this study?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by the treating physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '1. Bruising or bleeding from the injection site, nose or gums. Generally, such bleeding is easily controlled.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '5. The risk to an unborn child is uncertain. If the patient is pregnant, she has been enrolled into this study after an in-depth consultation with an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'Are there any potential benefits if I participate?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you agree for the patient to participate in this study, there may or may not be a direct medical benefit to the patient. Participation in this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. The patient\'s stroke may be improved during the study but there is no guarantee of that. The possible benefits to the patient from taking part in this study are close monitoring of their stroke, general health status, and any symptoms that they may experience during the study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'What if researchers discover something about me?\xA0')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you.  You will be helped with arranging appropriate follow up and care. These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Will my information and participation be kept confidential?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During the study, we will be collecting health data about the patient. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release information with the patient\'s name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that all health information is kept private.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'No data relating to this study that includes the patient\'s name will be released to anyone outside of the research team, nor will the researchers publish it.\xA0Your name, as well as the patient\'s name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you or the patient for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive all private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about the patient from a number of sources.\xA0Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include personal hospital electronic medical records, including Netcare, the QuICR/OPTIMISE registries, the hospital site, other health care providers that the patient may have seen in the past (i.e. family doctor) or the Canadian Institute for Health Information (CIHI) databases.\xA0 CIHI collects data from hospitals in Canada including information about how often'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.\xA0 This information is stored in the CIHI clinical administrative databases, along with their health care number.\xA0 The patient\'s name is not included in these databases.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In order to locate information about the patient\'s past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where the patient was originally admitted at the time of their stroke, authorized personnel from the study hospitals or registries will provide their health care number directly to CIHI solely for the purpose of extracting their hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store the patient\'s health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study, after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', target: '_blank' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'If I suffer a research-related injury, will I be compensated?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'In the event that the patient suffers injury as a result of participating in this research, no compensation will be provided for the patient by the University of Calgary, Alberta Health Services, or the Researchers. The patient still have all of their legal rights. Nothing said here about treatment or compensation in any way alters their right to recover damages.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), 'Will I be paid for participating, or do I have to pay for anything?')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'CONSENT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You are providing consent for the patient to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent on behalf of the patient, data collected up until this point will be retained. You nor the patient will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Please check the appropriate boxes to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b', { style: { textDecoration: 'underline' } }, 'SIGNATURES'))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\'s participation in the research project and agree for the patient to participate as a participant. In no way does this waive the patient\'s legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw the patient from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts (403) 944-1591'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'OR'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'The Stroke Research office (403) 944-2863'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'REGAINED CAPACITY CONSENT FORM')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Please check the appropriate boxes to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Dr. Shelagh Coutts: (403)-944-1594'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Chair of the Conjoint Health Research Ethics Board, University of Calgary at (403) 220-7990.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'A signed copy of this consent form will be is provided for your records and reference.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'REB#18-1101: Title:'), ' Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research AlbertaStroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'PI:'), ' Dr. Shelagh Coutts'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { align: 'center' }, 'Version 2.0  26 March 2021'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType === 'EmailRegainedCapacity' ? 'Email Regained Capacity' : props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Participant Email', size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3b; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);










var ConsentFormStep3b = function ConsentFormStep3b(props) {
  if (props.currentStep !== 'Step 3b') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: props.fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Do you consent to the terms described above? If no, please click on the Back button!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1086);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-upload {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  outline: 0;\n}\n.ant-upload p {\n  margin: 0;\n}\n.ant-upload-btn {\n  display: block;\n  width: 100%;\n  outline: none;\n}\n.ant-upload input[type='file'] {\n  cursor: pointer;\n}\n.ant-upload.ant-upload-select {\n  display: inline-block;\n}\n.ant-upload.ant-upload-disabled {\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-select-picture-card {\n  display: table;\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  vertical-align: top;\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n.ant-upload.ant-upload-select-picture-card > .ant-upload {\n  display: table-cell;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  text-align: center;\n  vertical-align: middle;\n}\n.ant-upload.ant-upload-select-picture-card:hover {\n  border-color: #4CDEF5;\n}\n.ant-upload.ant-upload-drag {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: border-color 0.3s;\n}\n.ant-upload.ant-upload-drag .ant-upload {\n  padding: 16px 0;\n}\n.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {\n  border-color: #36b5cf;\n}\n.ant-upload.ant-upload-drag.ant-upload-disabled {\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-drag .ant-upload-btn {\n  display: table;\n  height: 100%;\n}\n.ant-upload.ant-upload-drag .ant-upload-drag-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {\n  border-color: #78f1ff;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon {\n  margin-bottom: 20px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {\n  color: #78f1ff;\n  font-size: 48px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-text {\n  margin: 0 0 4px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-hint {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n.ant-upload.ant-upload-drag .anticon-plus {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 30px;\n  transition: all 0.3s;\n}\n.ant-upload.ant-upload-drag .anticon-plus:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-upload.ant-upload-drag:hover .anticon-plus {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-upload-picture-card-wrapper {\n  zoom: 1;\n  display: inline-block;\n  width: 100%;\n}\n.ant-upload-picture-card-wrapper::before,\n.ant-upload-picture-card-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::after {\n  clear: both;\n}\n.ant-upload-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  zoom: 1;\n}\n.ant-upload-list::before,\n.ant-upload-list::after {\n  display: table;\n  content: '';\n}\n.ant-upload-list::after {\n  clear: both;\n}\n.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 14px;\n}\n.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 28px;\n}\n.ant-upload-list-item {\n  position: relative;\n  height: 22px;\n  margin-top: 8px;\n  font-size: 14px;\n}\n.ant-upload-list-item-name {\n  display: inline-block;\n  width: 100%;\n  padding-left: 22px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-upload-list-item-name-icon-count-1 {\n  padding-right: 14px;\n}\n.ant-upload-list-item-card-actions {\n  position: absolute;\n  right: 0;\n  opacity: 0;\n}\n.ant-upload-list-item-card-actions.picture {\n  top: 25px;\n  line-height: 1;\n  opacity: 1;\n}\n.ant-upload-list-item-card-actions .anticon {\n  padding-right: 6px;\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-upload-list-item-info {\n  height: 100%;\n  padding: 0 12px 0 4px;\n  transition: background-color 0.3s;\n}\n.ant-upload-list-item-info > span {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.ant-upload-list-item-info .anticon-loading,\n.ant-upload-list-item-info .anticon-paper-clip {\n  position: absolute;\n  top: 5px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n.ant-upload-list-item .anticon-close {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  position: absolute;\n  top: 6px;\n  right: 4px;\n  color: rgba(0, 0, 0, 0.45);\n  line-height: 0;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.3s;\n}\n:root .ant-upload-list-item .anticon-close {\n  font-size: 12px;\n}\n.ant-upload-list-item .anticon-close:hover {\n  color: #424242;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-info {\n  background-color: #f0fffe;\n}\n.ant-upload-list-item:hover .anticon-close {\n  opacity: 1;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-card-actions {\n  opacity: 1;\n}\n.ant-upload-list-item-error,\n.ant-upload-list-item-error .anticon-paper-clip,\n.ant-upload-list-item-error .ant-upload-list-item-name {\n  color: #f5222d;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions {\n  opacity: 1;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {\n  color: #f5222d;\n}\n.ant-upload-list-item-progress {\n  position: absolute;\n  bottom: -12px;\n  width: 100%;\n  padding-left: 26px;\n  font-size: 14px;\n  line-height: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item,\n.ant-upload-list-picture-card .ant-upload-list-item {\n  position: relative;\n  height: 66px;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover,\n.ant-upload-list-picture-card .ant-upload-list-item:hover {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-error,\n.ant-upload-list-picture-card .ant-upload-list-item-error {\n  border-color: #f5222d;\n}\n.ant-upload-list-picture .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  padding: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading {\n  border-style: dashed;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 48px;\n  height: 48px;\n  font-size: 26px;\n  line-height: 54px;\n  text-align: center;\n  opacity: 0.8;\n}\n.ant-upload-list-picture .ant-upload-list-item-icon,\n.ant-upload-list-picture-card .ant-upload-list-item-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 26px;\n  transform: translate(-50%, -50%);\n}\n.ant-upload-list-picture .ant-upload-list-item-image,\n.ant-upload-list-picture-card .ant-upload-list-item-image {\n  max-width: 100%;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail img,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  display: block;\n  width: 48px;\n  height: 48px;\n  overflow: hidden;\n}\n.ant-upload-list-picture .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: inline-block;\n  box-sizing: border-box;\n  max-width: 100%;\n  margin: 0 0 0 8px;\n  padding-right: 8px;\n  padding-left: 48px;\n  overflow: hidden;\n  line-height: 44px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,\n.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 18px;\n}\n.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,\n.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 36px;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {\n  line-height: 28px;\n}\n.ant-upload-list-picture .ant-upload-list-item-progress,\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 14px;\n  width: calc(100% - 24px);\n  margin-top: 0;\n  padding-left: 56px;\n}\n.ant-upload-list-picture .anticon-close,\n.ant-upload-list-picture-card .anticon-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  line-height: 1;\n  opacity: 1;\n}\n.ant-upload-list-picture-card.ant-upload-list::after {\n  display: none;\n}\n.ant-upload-list-picture-card-container {\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info::before {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: all 0.3s;\n  content: ' ';\n}\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n  white-space: nowrap;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {\n  z-index: 10;\n  width: 16px;\n  margin: 0 4px;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {\n  color: #fff;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,\n.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: none;\n  margin: 8px 0 0;\n  padding: 0;\n  line-height: 1.5;\n  text-align: center;\n}\n.ant-upload-list-picture-card .anticon-picture + .ant-upload-list-item-name {\n  position: absolute;\n  bottom: 10px;\n  display: block;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {\n  background-color: #fafafa;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {\n  height: auto;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye-o,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {\n  display: none;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading-text {\n  margin-top: 18px;\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 32px;\n  padding-left: 0;\n}\n.ant-upload-list .ant-upload-success-icon {\n  color: #52c41a;\n  font-weight: bold;\n}\n.ant-upload-list .ant-upload-animate-enter,\n.ant-upload-list .ant-upload-animate-leave,\n.ant-upload-list .ant-upload-animate-inline-enter,\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-upload-list .ant-upload-animate-enter {\n  animation-name: uploadAnimateIn;\n}\n.ant-upload-list .ant-upload-animate-leave {\n  animation-name: uploadAnimateOut;\n}\n.ant-upload-list .ant-upload-animate-inline-enter {\n  animation-name: uploadAnimateInlineIn;\n}\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-name: uploadAnimateInlineOut;\n}\n@keyframes uploadAnimateIn {\n  from {\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateOut {\n  to {\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateInlineIn {\n  from {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateInlineOut {\n  to {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1088);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-progress {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-progress-line {\n  position: relative;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-progress-small.ant-progress-line,\n.ant-progress-small.ant-progress-line .ant-progress-text .anticon {\n  font-size: 12px;\n}\n.ant-progress-outer {\n  display: inline-block;\n  width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n}\n.ant-progress-show-info .ant-progress-outer {\n  margin-right: calc(-2em - 8px);\n  padding-right: calc(2em + 8px);\n}\n.ant-progress-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  vertical-align: middle;\n  background-color: #f5f5f5;\n  border-radius: 100px;\n}\n.ant-progress-circle-trail {\n  stroke: #f5f5f5;\n}\n.ant-progress-circle-path {\n  animation: ant-progress-appear 0.3s;\n}\n.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #1890ff;\n}\n.ant-progress-success-bg,\n.ant-progress-bg {\n  position: relative;\n  background-color: #1890ff;\n  border-radius: 100px;\n  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;\n}\n.ant-progress-success-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #52c41a;\n}\n.ant-progress-text {\n  display: inline-block;\n  width: 2em;\n  margin-left: 8px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 1em;\n  line-height: 1;\n  white-space: nowrap;\n  text-align: left;\n  vertical-align: middle;\n  word-break: normal;\n}\n.ant-progress-text .anticon {\n  font-size: 14px;\n}\n.ant-progress-status-active .ant-progress-bg::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  border-radius: 10px;\n  opacity: 0;\n  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;\n  content: '';\n}\n.ant-progress-status-exception .ant-progress-bg {\n  background-color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #f5222d;\n}\n.ant-progress-status-success .ant-progress-bg {\n  background-color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #52c41a;\n}\n.ant-progress-circle .ant-progress-inner {\n  position: relative;\n  line-height: 1;\n  background-color: transparent;\n}\n.ant-progress-circle .ant-progress-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  line-height: 1;\n  white-space: normal;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n.ant-progress-circle .ant-progress-text .anticon {\n  font-size: 1.16666667em;\n}\n.ant-progress-circle.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-circle.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n@keyframes ant-progress-active {\n  0% {\n    width: 0;\n    opacity: 0.1;\n  }\n  20% {\n    width: 0;\n    opacity: 0.5;\n  }\n  100% {\n    width: 100%;\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1090);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-tooltip {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1060;\n  display: block;\n  max-width: 250px;\n  visibility: visible;\n}\n.ant-tooltip-hidden {\n  display: none;\n}\n.ant-tooltip-placement-top,\n.ant-tooltip-placement-topLeft,\n.ant-tooltip-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-tooltip-placement-right,\n.ant-tooltip-placement-rightTop,\n.ant-tooltip-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-tooltip-placement-bottom,\n.ant-tooltip-placement-bottomLeft,\n.ant-tooltip-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-tooltip-placement-left,\n.ant-tooltip-placement-leftTop,\n.ant-tooltip-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-tooltip-inner {\n  min-width: 30px;\n  min-height: 32px;\n  padding: 6px 8px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  word-wrap: break-word;\n  background-color: rgba(0, 0, 0, 0.75);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 13.07106781px;\n  height: 13.07106781px;\n  overflow: hidden;\n  background: transparent;\n  pointer-events: none;\n}\n.ant-tooltip-arrow::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 5px;\n  height: 5px;\n  margin: auto;\n  background-color: rgba(0, 0, 0, 0.75);\n  content: '';\n  pointer-events: auto;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  bottom: -5.07106781px;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow::before,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow::before,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow::before {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(-6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  right: 13px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  left: -5.07106781px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow::before,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow::before,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow::before {\n  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  right: -5.07106781px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow::before,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow::before,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow::before {\n  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(-6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  top: -5.07106781px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow::before,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow::before,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow::before {\n  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  right: 13px;\n}\n", ""]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload__ = __webpack_require__(1092);
// export this package's api


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Upload__["a" /* default */]);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IframeUploader__ = __webpack_require__(1097);










function empty() {}

var Upload = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Upload, _Component);

  function Upload() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      Component: null
    }, _this.saveUploader = function (node) {
      _this.uploader = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Upload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.supportServerRender) {
        /* eslint react/no-did-mount-set-state:0 */
        this.setState({
          Component: this.getComponent()
        }, this.props.onReady);
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return typeof File !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__IframeUploader__["a" /* default */];
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.supportServerRender) {
        var _ComponentUploader = this.state.Component;
        if (_ComponentUploader) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(_ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
        }
        return null;
      }
      var ComponentUploader = this.getComponent();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
    }
  }]);

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Upload.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multipart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onError: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSuccess: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  accept: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReady: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  supportServerRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
Upload.defaultProps = {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onReady: empty,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  supportServerRender: false,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true
};


/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__attr_accept__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__traverseFileTree__ = __webpack_require__(1096);






/* eslint react/no-is-mounted:0 react/sort-comp:0 */









var AjaxUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AjaxUploader, _Component);

  function AjaxUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AjaxUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])() }, _this.reqs = {}, _this.onChange = function (e) {
      var files = e.target.files;
      _this.uploadFiles(files);
      _this.reset();
    }, _this.onClick = function () {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      el.click();
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.onClick();
      }
    }, _this.onFileDrop = function (e) {
      var multiple = _this.props.multiple;


      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (_this.props.directory) {
        Object(__WEBPACK_IMPORTED_MODULE_12__traverseFileTree__["a" /* default */])(e.dataTransfer.items, _this.uploadFiles, function (_file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(_file, _this.props.accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(file, _this.props.accept);
        });

        if (multiple === false) {
          files = files.slice(0, 1);
        }

        _this.uploadFiles(files);
      }
    }, _this.uploadFiles = function (files) {
      var postFiles = Array.prototype.slice.call(files);
      postFiles.map(function (file) {
        file.uid = Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])();
        return file;
      }).forEach(function (file) {
        _this.upload(file, postFiles);
      });
    }, _this.saveFileInput = function (node) {
      _this.fileInput = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AjaxUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: 'upload',
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }

      var before = props.beforeUpload(file, fileList);
      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);
          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            return _this2.post(processedFile);
          }
          return _this2.post(file);
        })['catch'](function (e) {
          console && console.log(e); // eslint-disable-line
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this3 = this;

      if (!this._isMounted) {
        return;
      }
      var props = this.props;
      var data = props.data;
      var onStart = props.onStart,
          onProgress = props.onProgress,
          _props$transformFile = props.transformFile,
          transformFile = _props$transformFile === undefined ? function (originFile) {
        return originFile;
      } : _props$transformFile;


      new Promise(function (resolve) {
        var action = props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        var uid = file.uid;

        var request = props.customRequest || __WEBPACK_IMPORTED_MODULE_9__request__["a" /* default */];
        var transform = Promise.resolve(transformFile(file))['catch'](function (e) {
          console.error(e); // eslint-disable-line no-console
        });

        transform.then(function (transformedFile) {
          if (typeof data === 'function') {
            data = data(file);
          }

          var requestOption = {
            action: action,
            filename: props.name,
            data: data,
            file: transformedFile,
            headers: props.headers,
            withCredentials: props.withCredentials,
            method: props.method || 'post',
            onProgress: onProgress ? function (e) {
              onProgress(e, file);
            } : null,
            onSuccess: function onSuccess(ret, xhr) {
              delete _this3.reqs[uid];
              props.onSuccess(ret, file, xhr);
            },
            onError: function onError(err, ret) {
              delete _this3.reqs[uid];
              props.onError(err, ret, file);
            }
          };
          _this3.reqs[uid] = request(requestOption);
          onStart(file);
        });
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])()
      });
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }
        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }
          delete reqs[uid];
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled,
          id = _props.id,
          style = _props.style,
          multiple = _props.multiple,
          accept = _props.accept,
          children = _props.children,
          directory = _props.directory,
          openFileDialogOnClick = _props.openFileDialogOnClick;

      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function () {},
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function () {},
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, events, {
          className: cls,
          role: 'button',
          style: style
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
          id: id,
          type: 'file',
          ref: this.saveFileInput,
          onClick: function onClick(e) {
            return e.stopPropagation();
          } // https://github.com/ant-design/ant-design/issues/19948
          , key: this.state.uid,
          style: { display: 'none' },
          accept: accept,
          directory: directory ? 'directory' : null,
          webkitdirectory: directory ? 'webkitdirectory' : null,
          multiple: multiple,
          onChange: this.onChange
        }),
        children
      );
    }
  }]);

  return AjaxUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AjaxUploader.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transformFile: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (AjaxUploader);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
function getError(option, xhr) {
  var msg = 'cannot ' + option.method + ' ' + option.action + ' ' + xhr.status + '\'';
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }
function upload(option) {
  var xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      var value = option.data[key];
      // support key-value array data
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
          formData.append(key + '[]', item);
        });
        return;
      }

      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open(option.method, option.action, true);

  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  for (var h in headers) {
    if (headers.hasOwnProperty(h) && headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  }
  xhr.send(formData);

  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');

    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();
      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];

  function sequence() {
    dirReader.readEntries(function (entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);

      // Check if all the file has been viewed
      var isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}

var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree(item, path) {
    path = path || '';
    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          // https://github.com/ant-design/ant-design/issues/16426
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function (entries) {
        entries.forEach(function (entryItem) {
          _traverseFileTree(entryItem, '' + path + item.name + '/');
        });
      });
    }
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var file = _step.value;

      _traverseFileTree(file.webkitGetAsEntry());
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (traverseFileTree);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);






/* eslint react/sort-comp:0 */







var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
};

// diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IframeUploader, _Component);

  function IframeUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IframeUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
      if (!_this.state.uploading) {
        return;
      }
      var _this2 = _this,
          props = _this2.props,
          file = _this2.file;

      var response = void 0;
      try {
        var doc = _this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];
        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }
        response = doc.body.innerHTML;
        props.onSuccess(response, file);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_11_warning___default()(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        props.onError(err, null, file);
      }
      _this.endUpload();
    }, _this.onChange = function () {
      var target = _this.getFormInputNode();
      // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
      var file = _this.file = {
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])(),
        name: target.value && target.value.substring(target.value.lastIndexOf('\\') + 1, target.value.length)
      };
      _this.startUpload();
      var _this3 = _this,
          props = _this3.props;

      if (!props.beforeUpload) {
        return _this.post(file);
      }
      var before = props.beforeUpload(file);
      if (before && before.then) {
        before.then(function () {
          _this.post(file);
        }, function () {
          _this.endUpload();
        });
      } else if (before !== false) {
        _this.post(file);
      } else {
        _this.endUpload();
      }
    }, _this.saveIframe = function (node) {
      _this.iframe = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IframeUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateIframeWH();
      this.initIframe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateIframeWH();
    }
  }, {
    key: 'getIframeNode',
    value: function getIframeNode() {
      return this.iframe;
    }
  }, {
    key: 'getIframeDocument',
    value: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    }
  }, {
    key: 'getFormNode',
    value: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    }
  }, {
    key: 'getFormInputNode',
    value: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    }
  }, {
    key: 'getFormDataNode',
    value: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    }
  }, {
    key: 'getFileForMultiple',
    value: function getFileForMultiple(file) {
      return this.props.multiple ? [file] : file;
    }
  }, {
    key: 'getIframeHTML',
    value: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';
      if (domain) {
        var script = 'script';
        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
      }
      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
    }
  }, {
    key: 'initIframeSrc',
    value: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
      }
    }
  }, {
    key: 'initIframe',
    value: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc = void 0;
      this.domain = this.domain || '';
      this.initIframeSrc();
      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }
      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    }
  }, {
    key: 'endUpload',
    value: function endUpload() {
      if (this.state.uploading) {
        this.file = {};
        // hack avoid batch
        this.state.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    }
  }, {
    key: 'startUpload',
    value: function startUpload() {
      if (!this.state.uploading) {
        this.state.uploading = true;
        this.setState({
          uploading: true
        });
      }
    }
  }, {
    key: 'updateIframeWH',
    value: function updateIframeWH() {
      var rootNode = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this);
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = rootNode.offsetHeight + 'px';
      iframeNode.style.width = rootNode.offsetWidth + 'px';
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this4 = this;

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.props.data;
      var onStart = this.props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = document.createDocumentFragment();
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var input = document.createElement('input');
          input.setAttribute('name', key);
          input.value = data[key];
          inputs.appendChild(input);
        }
      }
      dataSpan.appendChild(inputs);
      new Promise(function (resolve) {
        var action = _this4.props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        formNode.setAttribute('action', action);
        formNode.submit();
        dataSpan.innerHTML = '';
        onStart(file);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          disabled = _props.disabled,
          className = _props.className,
          prefixCls = _props.prefixCls,
          children = _props.children,
          style = _props.style;

      var iframeStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, IFRAME_STYLE, {
        display: this.state.uploading || disabled ? 'none' : ''
      });
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        {
          className: cls,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ position: 'relative', zIndex: 0 }, style)
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('iframe', {
          ref: this.saveIframe,
          onLoad: this.onLoad,
          style: iframeStyle
        }),
        children
      );
    }
  }]);

  return IframeUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

IframeUploader.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (IframeUploader);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(471),
    baseUniq = __webpack_require__(1173);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1100),
    getMatchData = __webpack_require__(1157),
    matchesStrictComparable = __webpack_require__(487);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(472),
    baseIsEqual = __webpack_require__(476);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1101 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(205);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(205);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(205);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(205);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(204);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(204),
    Map = __webpack_require__(307),
    MapCache = __webpack_require__(308);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(474),
    isMasked = __webpack_require__(1112),
    isObject = __webpack_require__(163),
    toSource = __webpack_require__(475);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1113);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(86);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1116),
    ListCache = __webpack_require__(204),
    Map = __webpack_require__(307);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1117),
    hashDelete = __webpack_require__(1118),
    hashGet = __webpack_require__(1119),
    hashHas = __webpack_require__(1120),
    hashSet = __webpack_require__(1121);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1118 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(207);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1123 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(207);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(207);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(207);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(472),
    equalArrays = __webpack_require__(477),
    equalByTag = __webpack_require__(1131),
    equalObjects = __webpack_require__(1134),
    getTag = __webpack_require__(1153),
    isArray = __webpack_require__(102),
    isBuffer = __webpack_require__(482),
    isTypedArray = __webpack_require__(484);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1130 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(195),
    Uint8Array = __webpack_require__(1132),
    eq = __webpack_require__(473),
    equalArrays = __webpack_require__(477),
    mapToArray = __webpack_require__(1133),
    setToArray = __webpack_require__(309);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(86);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1135);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1136),
    getSymbols = __webpack_require__(1138),
    keys = __webpack_require__(480);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1137),
    isArray = __webpack_require__(102);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1139),
    stubArray = __webpack_require__(1140);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1142),
    isArguments = __webpack_require__(481),
    isArray = __webpack_require__(102),
    isBuffer = __webpack_require__(482),
    isIndex = __webpack_require__(483),
    isTypedArray = __webpack_require__(484);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(164),
    isObjectLike = __webpack_require__(165);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(164),
    isLength = __webpack_require__(310),
    isObjectLike = __webpack_require__(165);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(426);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1149),
    nativeKeys = __webpack_require__(1150);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1149 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1151);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(474),
    isLength = __webpack_require__(310);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1154),
    Map = __webpack_require__(307),
    Promise = __webpack_require__(1155),
    Set = __webpack_require__(485),
    WeakMap = __webpack_require__(1156),
    baseGetTag = __webpack_require__(164),
    toSource = __webpack_require__(475);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(486),
    keys = __webpack_require__(480);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(476),
    get = __webpack_require__(1159),
    hasIn = __webpack_require__(1166),
    isKey = __webpack_require__(311),
    isStrictComparable = __webpack_require__(486),
    matchesStrictComparable = __webpack_require__(487),
    toKey = __webpack_require__(208);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(488);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1161);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1162);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(308);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1164);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(195),
    arrayMap = __webpack_require__(1165),
    isArray = __webpack_require__(102),
    isSymbol = __webpack_require__(194);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1167),
    hasPath = __webpack_require__(1168);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(489),
    isArguments = __webpack_require__(481),
    isArray = __webpack_require__(102),
    isIndex = __webpack_require__(483),
    isLength = __webpack_require__(310),
    toKey = __webpack_require__(208);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1171),
    basePropertyDeep = __webpack_require__(1172),
    isKey = __webpack_require__(311),
    toKey = __webpack_require__(208);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(488);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(478),
    arrayIncludes = __webpack_require__(1174),
    arrayIncludesWith = __webpack_require__(1178),
    cacheHas = __webpack_require__(479),
    createSet = __webpack_require__(1179),
    setToArray = __webpack_require__(309);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1175);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(490),
    baseIsNaN = __webpack_require__(1176),
    strictIndexOf = __webpack_require__(1177);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(485),
    noop = __webpack_require__(1180),
    setToArray = __webpack_require__(309);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(490),
    baseIteratee = __webpack_require__(471),
    toInteger = __webpack_require__(1182);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1183);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(427);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcAnimate = _interopRequireDefault(__webpack_require__(90));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _utils = __webpack_require__(491);

var _icon = _interopRequireDefault(__webpack_require__(4));

var _tooltip = _interopRequireDefault(__webpack_require__(64));

var _progress = _interopRequireDefault(__webpack_require__(492));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UploadList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UploadList, _React$Component);

  function UploadList() {
    var _this;

    _classCallCheck(this, UploadList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadList).apply(this, arguments));

    _this.handlePreview = function (file, e) {
      var onPreview = _this.props.onPreview;

      if (!onPreview) {
        return;
      }

      e.preventDefault();
      return onPreview(file);
    };

    _this.handleDownload = function (file) {
      var onDownload = _this.props.onDownload;

      if (typeof onDownload === 'function') {
        onDownload(file);
      } else if (file.url) {
        window.open(file.url);
      }
    };

    _this.handleClose = function (file) {
      var onRemove = _this.props.onRemove;

      if (onRemove) {
        onRemove(file);
      }
    };

    _this.renderUploadList = function (_ref) {
      var _classNames4;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          listType = _this$props.listType,
          showPreviewIcon = _this$props.showPreviewIcon,
          showRemoveIcon = _this$props.showRemoveIcon,
          showDownloadIcon = _this$props.showDownloadIcon,
          locale = _this$props.locale,
          progressAttr = _this$props.progressAttr;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);
      var list = items.map(function (file) {
        var _classNames, _classNames2;

        var progress;
        var icon = React.createElement(_icon["default"], {
          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
        });

        if (listType === 'picture' || listType === 'picture-card') {
          if (listType === 'picture-card' && file.status === 'uploading') {
            icon = React.createElement("div", {
              className: "".concat(prefixCls, "-list-item-uploading-text")
            }, locale.uploading);
          } else if (!file.thumbUrl && !file.url) {
            icon = React.createElement(_icon["default"], {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              type: "picture",
              theme: "twoTone"
            });
          } else {
            var thumbnail = (0, _utils.isImageUrl)(file) ? React.createElement("img", {
              src: file.thumbUrl || file.url,
              alt: file.name,
              className: "".concat(prefixCls, "-list-item-image")
            }) : React.createElement(_icon["default"], {
              type: "file",
              className: "".concat(prefixCls, "-list-item-icon"),
              theme: "twoTone"
            });
            icon = React.createElement("a", {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              onClick: function onClick(e) {
                return _this.handlePreview(file, e);
              },
              href: file.url || file.thumbUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, thumbnail);
          }
        }

        if (file.status === 'uploading') {
          // show loading icon if upload progress listener is disabled
          var loadingProgress = 'percent' in file ? React.createElement(_progress["default"], _extends({
            type: "line"
          }, progressAttr, {
            percent: file.percent
          })) : null;
          progress = React.createElement("div", {
            className: "".concat(prefixCls, "-list-item-progress"),
            key: "progress"
          }, loadingProgress);
        }

        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
        var removeIcon = showRemoveIcon ? React.createElement(_icon["default"], {
          type: "delete",
          title: locale.removeFile,
          onClick: function onClick() {
            return _this.handleClose(file);
          }
        }) : null;
        var downloadIcon = showDownloadIcon && file.status === 'done' ? React.createElement(_icon["default"], {
          type: "download",
          title: locale.downloadFile,
          onClick: function onClick() {
            return _this.handleDownload(file);
          }
        }) : null;
        var downloadOrDelete = listType !== 'picture-card' && React.createElement("span", {
          key: "download-delete",
          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
        }, downloadIcon && React.createElement("a", {
          title: locale.downloadFile
        }, downloadIcon), removeIcon && React.createElement("a", {
          title: locale.removeFile
        }, removeIcon));
        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
          return x;
        }).length), true), _classNames2));
        var preview = file.url ? [React.createElement("a", _extends({
          key: "view",
          target: "_blank",
          rel: "noopener noreferrer",
          className: listItemNameClass,
          title: file.name
        }, linkProps, {
          href: file.url,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          }
        }), file.name), downloadOrDelete] : [React.createElement("span", {
          key: "view",
          className: listItemNameClass,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: file.name
        }, file.name), downloadOrDelete];
        var style = {
          pointerEvents: 'none',
          opacity: 0.5
        };
        var previewIcon = showPreviewIcon ? React.createElement("a", {
          href: file.url || file.thumbUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          style: file.url || file.thumbUrl ? undefined : style,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: locale.previewFile
        }, React.createElement(_icon["default"], {
          type: "eye-o"
        })) : null;
        var actions = listType === 'picture-card' && file.status !== 'uploading' && React.createElement("span", {
          className: "".concat(prefixCls, "-list-item-actions")
        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
        var message;

        if (file.response && typeof file.response === 'string') {
          message = file.response;
        } else {
          message = file.error && file.error.statusText || locale.uploadError;
        }

        var iconAndPreview = React.createElement("span", null, icon, preview);
        var dom = React.createElement("div", {
          className: infoUploadingClass
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-list-item-info")
        }, iconAndPreview), actions, React.createElement(_rcAnimate["default"], {
          transitionName: "fade",
          component: ""
        }, progress));
        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
        return React.createElement("div", {
          key: file.uid,
          className: listContainerNameClass
        }, file.status === 'error' ? React.createElement(_tooltip["default"], {
          title: message
        }, dom) : React.createElement("span", null, dom));
      });
      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
      return React.createElement(_rcAnimate["default"], {
        transitionName: "".concat(prefixCls, "-").concat(animationDirection),
        component: "div",
        className: listClassNames
      }, list);
    };

    return _this;
  }

  _createClass(UploadList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props2 = this.props,
          listType = _this$props2.listType,
          items = _this$props2.items,
          previewFile = _this$props2.previewFile;

      if (listType !== 'picture' && listType !== 'picture-card') {
        return;
      }

      (items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
          return;
        }

        file.thumbUrl = '';

        if (previewFile) {
          previewFile(file.originFileObj).then(function (previewDataUrl) {
            // Need append '' to avoid dead loop
            file.thumbUrl = previewDataUrl || '';

            _this2.forceUpdate();
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList);
    }
  }]);

  return UploadList;
}(React.Component);

exports["default"] = UploadList;
UploadList.defaultProps = {
  listType: 'text',
  progressAttr: {
    strokeWidth: 2,
    showInfo: false
  },
  showRemoveIcon: true,
  showDownloadIcon: false,
  showPreviewIcon: true,
  previewFile: _utils.previewImage
};
//# sourceMappingURL=UploadList.js.map


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1186);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1188);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverflowOptions = getOverflowOptions;
exports["default"] = getPlacements;

var _placements = __webpack_require__(1190);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset = [0, 0];

function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }

  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}

function getPlacements() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$arrowWidth = config.arrowWidth,
      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
      _config$horizontalArr = config.horizontalArrowShift,
      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
      _config$verticalArrow = config.verticalArrowShift,
      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
      _config$autoAdjustOve = config.autoAdjustOverflow,
      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-4, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [4, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -4]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, 4]
    },
    topLeft: {
      points: ['bl', 'tc'],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ['tr', 'cl'],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ['br', 'tc'],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ['tl', 'cr'],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ['tr', 'bc'],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ['bl', 'cr'],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ['tl', 'bc'],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ['br', 'cl'],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: targetOffset
    }) : _extends(_extends({}, _placements.placements[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
    placementMap[key].ignoreShake = true;
  });
  return placementMap;
}
//# sourceMappingURL=placements.js.map


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = exports.placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

var _type = __webpack_require__(81);

var _Line = _interopRequireDefault(__webpack_require__(1192));

var _Circle = _interopRequireDefault(__webpack_require__(1193));

var _utils = __webpack_require__(312);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');

var Progress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Progress).apply(this, arguments));

    _this.renderProgress = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          size = props.size,
          type = props.type,
          showInfo = props.showInfo,
          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);

      var prefixCls = getPrefixCls('progress', customizePrefixCls);

      var progressStatus = _this.getProgressStatus();

      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);

      var progress; // Render progress shape

      if (type === 'line') {
        progress = React.createElement(_Line["default"], _extends({}, _this.props, {
          prefixCls: prefixCls
        }), progressInfo);
      } else if (type === 'circle' || type === 'dashboard') {
        progress = React.createElement(_Circle["default"], _extends({}, _this.props, {
          prefixCls: prefixCls,
          progressStatus: progressStatus
        }), progressInfo);
      }

      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
      return React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
        className: classString
      }), progress);
    };

    return _this;
  }

  _createClass(Progress, [{
    key: "getPercentNumber",
    value: function getPercentNumber() {
      var _this$props = this.props,
          successPercent = _this$props.successPercent,
          _this$props$percent = _this$props.percent,
          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    }
  }, {
    key: "getProgressStatus",
    value: function getProgressStatus() {
      var status = this.props.status;

      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return 'success';
      }

      return status || 'normal';
    }
  }, {
    key: "renderProcessInfo",
    value: function renderProcessInfo(prefixCls, progressStatus) {
      var _this$props2 = this.props,
          showInfo = _this$props2.showInfo,
          format = _this$props2.format,
          type = _this$props2.type,
          percent = _this$props2.percent,
          successPercent = _this$props2.successPercent;
      if (!showInfo) return null;
      var text;

      var textFormatter = format || function (percentNumber) {
        return "".concat(percentNumber, "%");
      };

      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';

      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
      } else if (progressStatus === 'exception') {
        text = React.createElement(_icon["default"], {
          type: "close".concat(iconType),
          theme: type === 'line' ? 'filled' : 'outlined'
        });
      } else if (progressStatus === 'success') {
        text = React.createElement(_icon["default"], {
          type: "check".concat(iconType),
          theme: type === 'line' ? 'filled' : 'outlined'
        });
      }

      return React.createElement("span", {
        className: "".concat(prefixCls, "-text"),
        title: typeof text === 'string' ? text : undefined
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress);
    }
  }]);

  return Progress;
}(React.Component);

exports["default"] = Progress;
Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  trailColor: '#f3f3f3',
  size: 'default',
  gapDegree: 0,
  strokeLinecap: 'round'
};
Progress.propTypes = {
  status: PropTypes.oneOf(ProgressStatuses),
  type: PropTypes.oneOf(ProgressTypes),
  showInfo: PropTypes.bool,
  percent: PropTypes.number,
  width: PropTypes.number,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.oneOf(['round', 'square']),
  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  trailColor: PropTypes.string,
  format: PropTypes.func,
  gapDegree: PropTypes.number
};
//# sourceMappingURL=progress.js.map


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.handleGradient = exports.sortGradient = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(312);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * {
 *   '0%': '#afc163',
 *   '75%': '#009900',
 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
 *   '25%': '#66FF00',
 *   '100%': '#ffffff'
 * }
 */
var sortGradient = function sortGradient(gradients) {
  var tempArr = []; // eslint-disable-next-line no-restricted-syntax

  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var formatKey = parseFloat(key.replace(/%/g, ''));

    if (isNaN(formatKey)) {
      return {};
    }

    tempArr.push({
      key: formatKey,
      value: value
    });
  }

  tempArr = tempArr.sort(function (a, b) {
    return a.key - b.key;
  });
  return tempArr.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return "".concat(value, " ").concat(key, "%");
  }).join(', ');
};
/**
 * {
 *   '0%': '#afc163',
 *   '25%': '#66FF00',
 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
 *   '100%': '#ffffff'
 * }
 *
 * Then this man came to realize the truth:
 * Besides six pence, there is the moon.
 * Besides bread and butter, there is the bug.
 * And...
 * Besides women, there is the code.
 */


exports.sortGradient = sortGradient;

var handleGradient = function handleGradient(strokeColor) {
  var _strokeColor$from = strokeColor.from,
      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
      _strokeColor$to = strokeColor.to,
      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
      _strokeColor$directio = strokeColor.direction,
      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
      rest = __rest(strokeColor, ["from", "to", "direction"]);

  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
    };
  }

  return {
    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
  };
};

exports.handleGradient = handleGradient;

var Line = function Line(props) {
  var prefixCls = props.prefixCls,
      percent = props.percent,
      successPercent = props.successPercent,
      strokeWidth = props.strokeWidth,
      size = props.size,
      strokeColor = props.strokeColor,
      strokeLinecap = props.strokeLinecap,
      children = props.children;
  var backgroundProps;

  if (strokeColor && typeof strokeColor !== 'string') {
    backgroundProps = handleGradient(strokeColor);
  } else {
    backgroundProps = {
      background: strokeColor
    };
  }

  var percentStyle = _extends({
    width: "".concat((0, _utils.validProgress)(percent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : ''
  }, backgroundProps);

  var successPercentStyle = {
    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : ''
  };
  var successSegment = successPercent !== undefined ? React.createElement("div", {
    className: "".concat(prefixCls, "-success-bg"),
    style: successPercentStyle
  }) : null;
  return React.createElement("div", null, React.createElement("div", {
    className: "".concat(prefixCls, "-outer")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-inner")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-bg"),
    style: percentStyle
  }), successSegment)), children);
};

var _default = Line;
exports["default"] = _default;
//# sourceMappingURL=Line.js.map


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcProgress = __webpack_require__(1194);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _utils = __webpack_require__(312);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusColorMap = {
  normal: '#108ee9',
  exception: '#ff5500',
  success: '#87d068'
};

function getPercentage(_ref) {
  var percent = _ref.percent,
      successPercent = _ref.successPercent;
  var ptg = (0, _utils.validProgress)(percent);

  if (!successPercent) {
    return ptg;
  }

  var successPtg = (0, _utils.validProgress)(successPercent);
  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
}

function getStrokeColor(_ref2) {
  var progressStatus = _ref2.progressStatus,
      successPercent = _ref2.successPercent,
      strokeColor = _ref2.strokeColor;
  var color = strokeColor || statusColorMap[progressStatus];

  if (!successPercent) {
    return color;
  }

  return [statusColorMap.success, color];
}

var Circle = function Circle(props) {
  var prefixCls = props.prefixCls,
      width = props.width,
      strokeWidth = props.strokeWidth,
      trailColor = props.trailColor,
      strokeLinecap = props.strokeLinecap,
      gapPosition = props.gapPosition,
      gapDegree = props.gapDegree,
      type = props.type,
      children = props.children;
  var circleSize = width || 120;
  var circleStyle = {
    width: circleSize,
    height: circleSize,
    fontSize: circleSize * 0.15 + 6
  };
  var circleWidth = strokeWidth || 6;
  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
  var strokeColor = getStrokeColor(props);
  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
  return React.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, React.createElement(_rcProgress.Circle, {
    percent: getPercentage(props),
    strokeWidth: circleWidth,
    trailWidth: circleWidth,
    strokeColor: strokeColor,
    strokeLinecap: strokeLinecap,
    trailColor: trailColor,
    prefixCls: prefixCls,
    gapDegree: gapDeg,
    gapPosition: gapPos
  }), children);
};

var _default = Circle;
exports["default"] = _default;
//# sourceMappingURL=Circle.js.map


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Line__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Circle__ = __webpack_require__(1196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__Line__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_1__Circle__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = ({
  Line: __WEBPACK_IMPORTED_MODULE_0__Line__["a" /* default */],
  Circle: __WEBPACK_IMPORTED_MODULE_1__Circle__["a" /* default */]
});

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enhancer__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(494);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Line =
/*#__PURE__*/
function (_Component) {
  _inherits(Line, _Component);

  function Line() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "paths", {});

    return _this;
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          percent = _this$props.percent,
          prefixCls = _this$props.prefixCls,
          strokeColor = _this$props.strokeColor,
          strokeLinecap = _this$props.strokeLinecap,
          strokeWidth = _this$props.strokeWidth,
          style = _this$props.style,
          trailColor = _this$props.trailColor,
          trailWidth = _this$props.trailWidth,
          transition = _this$props.transition,
          restProps = _objectWithoutProperties(_this$props, ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"]);

      delete restProps.gapPosition;
      var percentList = Array.isArray(percent) ? percent : [percent];
      var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
      var center = strokeWidth / 2;
      var right = 100 - strokeWidth / 2;
      var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n           L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
      var viewBoxString = "0 0 100 ".concat(strokeWidth);
      var stackPtg = 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
        className: "".concat(prefixCls, "-line ").concat(className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
      }, restProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
      }), percentList.map(function (ptg, index) {
        var pathStyle = {
          strokeDasharray: "".concat(ptg, "px, 100px"),
          strokeDashoffset: "-".concat(stackPtg, "px"),
          transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-line-path"),
          d: pathString,
          strokeLinecap: strokeLinecap,
          stroke: color,
          strokeWidth: strokeWidth,
          fillOpacity: "0",
          ref: function ref(path) {
            _this2.paths[index] = path;
          },
          style: pathStyle
        });
      }));
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Line.propTypes = __WEBPACK_IMPORTED_MODULE_2__types__["b" /* propTypes */];
Line.defaultProps = __WEBPACK_IMPORTED_MODULE_2__types__["a" /* defaultProps */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__enhancer__["a" /* default */])(Line));

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enhancer__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(494);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/prop-types: 0 */




var gradientSeed = 0;

function stripPercentToNumber(percent) {
  return +percent.replace('%', '');
}

function toArray(symArray) {
  return Array.isArray(symArray) ? symArray : [symArray];
}

function getPathStyles(offset, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : undefined;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;

  switch (gapPosition) {
    case 'left':
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;

    case 'right':
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;

    case 'bottom':
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;

    default:
  }

  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: strokeColor,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line

  };
  return {
    pathString: pathString,
    pathStyle: pathStyle
  };
}

var Circle =
/*#__PURE__*/
function (_Component) {
  _inherits(Circle, _Component);

  function Circle() {
    var _this;

    _classCallCheck(this, Circle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Circle).call(this));

    _defineProperty(_assertThisInitialized(_this), "paths", {});

    _defineProperty(_assertThisInitialized(_this), "gradientId", 0);

    _this.gradientId = gradientSeed;
    gradientSeed += 1;
    return _this;
  }

  _createClass(Circle, [{
    key: "getStokeList",
    value: function getStokeList() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          percent = _this$props.percent,
          strokeColor = _this$props.strokeColor,
          strokeWidth = _this$props.strokeWidth,
          strokeLinecap = _this$props.strokeLinecap,
          gapDegree = _this$props.gapDegree,
          gapPosition = _this$props.gapPosition;
      var percentList = toArray(percent);
      var strokeColorList = toArray(strokeColor);
      var stackPtg = 0;
      return percentList.map(function (ptg, index) {
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        var stroke = Object.prototype.toString.call(color) === '[object Object]' ? "url(#".concat(prefixCls, "-gradient-").concat(_this2.gradientId, ")") : '';

        var _getPathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition),
            pathString = _getPathStyles.pathString,
            pathStyle = _getPathStyles.pathStyle;

        stackPtg += ptg;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-circle-path"),
          d: pathString,
          stroke: stroke,
          strokeLinecap: strokeLinecap,
          strokeWidth: ptg === 0 ? 0 : strokeWidth,
          fillOpacity: "0",
          style: pathStyle,
          ref: function ref(path) {
            _this2.paths[index] = path;
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          strokeWidth = _this$props2.strokeWidth,
          trailWidth = _this$props2.trailWidth,
          gapDegree = _this$props2.gapDegree,
          gapPosition = _this$props2.gapPosition,
          trailColor = _this$props2.trailColor,
          strokeLinecap = _this$props2.strokeLinecap,
          style = _this$props2.style,
          className = _this$props2.className,
          strokeColor = _this$props2.strokeColor,
          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor"]);

      var _getPathStyles2 = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
          pathString = _getPathStyles2.pathString,
          pathStyle = _getPathStyles2.pathStyle;

      delete restProps.percent;
      var strokeColorList = toArray(strokeColor);
      var gradient = strokeColorList.find(function (color) {
        return Object.prototype.toString.call(color) === '[object Object]';
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
        className: "".concat(prefixCls, "-circle ").concat(className),
        viewBox: "0 0 100 100",
        style: style
      }, restProps), gradient && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient", {
        id: "".concat(prefixCls, "-gradient-").concat(this.gradientId),
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "0%"
      }, Object.keys(gradient).sort(function (a, b) {
        return stripPercentToNumber(a) - stripPercentToNumber(b);
      }).map(function (key, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
          key: index,
          offset: key,
          stopColor: gradient[key]
        });
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        className: "".concat(prefixCls, "-circle-trail"),
        d: pathString,
        stroke: trailColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0",
        style: pathStyle
      }), this.getStokeList().reverse());
    }
  }]);

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Circle.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* propTypes */], {
  gapPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right'])
});
Circle.defaultProps = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* defaultProps */], {
  gapPosition: 'top'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__enhancer__["a" /* default */])(Circle));

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Upload = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// stick class comoponent to avoid React ref warning inside Form
// https://github.com/ant-design/ant-design/issues/18707
// eslint-disable-next-line react/prefer-stateless-function
var Dragger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dragger, _React$Component);

  function Dragger() {
    _classCallCheck(this, Dragger);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dragger).apply(this, arguments));
  }

  _createClass(Dragger, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement(_Upload["default"], _extends({}, props, {
        type: "drag",
        style: _extends(_extends({}, props.style), {
          height: props.height
        })
      }));
    }
  }]);

  return Dragger;
}(React.Component);

exports["default"] = Dragger;
//# sourceMappingURL=Dragger.js.map


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ConsentFormStep4 = function ConsentFormStep4(props) {
  if (props.currentStep !== 'Step 4') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, !props.token && (props.consentExistsMethodType === 'Email' || props.consentExistsMethodType === 'EmailRegainedCapacity') ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsMethodType)), ['Email', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsEmailStatus.replace(/_/g, ' '))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink, target: '_blank' }, 'Consent Document'))));
};

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["default"] = (SignaturePad);


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.trimCanvas=t():e.trimCanvas=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentType2_ConsentForm__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentType2_css__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentType2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentType2_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentEdmontonByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined, has_randomization_platform_step_3_patient: data['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: data['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: data['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: data['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: data['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: data['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: data['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: data['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: data['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: data['randomization_platform_step_3_deferred_content'] };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentType2_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentType2_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentType2_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentType2_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            } else {
                              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('Error, please check required fields', 5);
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentEdmontonByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createEdmonton(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1204);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-select {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  outline: 0;\n}\n.ant-select ul,\n.ant-select ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-select > ul > li > a {\n  padding: 0;\n  background-color: #fff;\n}\n.ant-select-arrow {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  line-height: 1;\n  transform-origin: 50% 50%;\n}\n.ant-select-arrow > * {\n  line-height: 1;\n}\n.ant-select-arrow svg {\n  display: inline-block;\n}\n.ant-select-arrow::before {\n  display: none;\n}\n.ant-select-arrow .ant-select-arrow-icon {\n  display: block;\n}\n.ant-select-arrow .ant-select-arrow-icon svg {\n  transition: transform 0.3s;\n}\n.ant-select-selection {\n  display: block;\n  box-sizing: border-box;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-top-width: 1.02px;\n  border-radius: 4px;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n}\n.ant-select-selection:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-select-focused .ant-select-selection,\n.ant-select-selection:focus,\n.ant-select-selection:active {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-select-selection__clear {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  z-index: 1;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  font-style: normal;\n  line-height: 12px;\n  text-align: center;\n  text-transform: none;\n  background: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: color 0.3s ease, opacity 0.15s ease;\n  text-rendering: auto;\n}\n.ant-select-selection__clear::before {\n  display: block;\n}\n.ant-select-selection__clear:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-select-selection:hover .ant-select-selection__clear {\n  opacity: 1;\n}\n.ant-select-selection-selected-value {\n  float: left;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-select-no-arrow .ant-select-selection-selected-value {\n  padding-right: 0;\n}\n.ant-select-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-disabled .ant-select-selection {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-select-disabled .ant-select-selection:hover,\n.ant-select-disabled .ant-select-selection:focus,\n.ant-select-disabled .ant-select-selection:active {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-select-disabled .ant-select-selection__clear {\n  display: none;\n  visibility: hidden;\n  pointer-events: none;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {\n  padding-right: 10px;\n  color: rgba(0, 0, 0, 0.33);\n  background: #f5f5f5;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  display: none;\n}\n.ant-select-selection--single {\n  position: relative;\n  height: 32px;\n  cursor: pointer;\n}\n.ant-select-selection--single .ant-select-selection__rendered {\n  margin-right: 24px;\n}\n.ant-select-no-arrow .ant-select-selection__rendered {\n  margin-right: 11px;\n}\n.ant-select-selection__rendered {\n  position: relative;\n  display: block;\n  margin-right: 11px;\n  margin-left: 11px;\n  line-height: 30px;\n}\n.ant-select-selection__rendered::after {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '.';\n  pointer-events: none;\n}\n.ant-select-lg {\n  font-size: 16px;\n}\n.ant-select-lg .ant-select-selection--single {\n  height: 40px;\n}\n.ant-select-lg .ant-select-selection__rendered {\n  line-height: 38px;\n}\n.ant-select-lg .ant-select-selection--multiple {\n  min-height: 40px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 32px;\n  line-height: 32px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-lg .ant-select-selection--multiple .ant-select-arrow {\n  top: 20px;\n}\n.ant-select-sm .ant-select-selection--single {\n  height: 24px;\n}\n.ant-select-sm .ant-select-selection__rendered {\n  margin-left: 7px;\n  line-height: 22px;\n}\n.ant-select-sm .ant-select-selection--multiple {\n  min-height: 24px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 16px;\n  line-height: 14px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-sm .ant-select-selection--multiple .ant-select-arrow {\n  top: 12px;\n}\n.ant-select-sm .ant-select-selection__clear,\n.ant-select-sm .ant-select-arrow {\n  right: 8px;\n}\n.ant-select-disabled .ant-select-selection__choice__remove {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: default;\n}\n.ant-select-disabled .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-search__field__wrap {\n  position: relative;\n  display: inline-block;\n}\n.ant-select-selection__placeholder,\n.ant-select-search__field__placeholder {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  left: 0;\n  max-width: 100%;\n  height: 20px;\n  margin-top: -10px;\n  overflow: hidden;\n  color: #bfbfbf;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: left;\n  text-overflow: ellipsis;\n}\n.ant-select-search__field__placeholder {\n  left: 12px;\n}\n.ant-select-search__field__mirror {\n  position: absolute;\n  top: 0;\n  left: 0;\n  white-space: pre;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-select-search--inline {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field {\n  width: 100%;\n  height: 100%;\n  font-size: 100%;\n  line-height: 1;\n  background: transparent;\n  border-width: 0;\n  border-radius: 4px;\n  outline: 0;\n}\n.ant-select-search--inline > i {\n  float: right;\n}\n.ant-select-selection--multiple {\n  min-height: 32px;\n  padding-bottom: 3px;\n  cursor: text;\n  zoom: 1;\n}\n.ant-select-selection--multiple::before,\n.ant-select-selection--multiple::after {\n  display: table;\n  content: '';\n}\n.ant-select-selection--multiple::after {\n  clear: both;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  position: static;\n  float: left;\n  width: auto;\n  max-width: 100%;\n  padding: 0;\n}\n.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {\n  width: 0.75em;\n  max-width: 100%;\n}\n.ant-select-selection--multiple .ant-select-selection__rendered {\n  height: auto;\n  margin-bottom: -3px;\n  margin-left: 5px;\n}\n.ant-select-selection--multiple .ant-select-selection__placeholder {\n  margin-left: 6px;\n}\n.ant-select-selection--multiple > ul > li,\n.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {\n  height: 24px;\n  margin-top: 3px;\n  line-height: 22px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice {\n  position: relative;\n  float: left;\n  max-width: 99%;\n  margin-right: 4px;\n  padding: 0 20px 0 10px;\n  overflow: hidden;\n  color: #424242;\n  background-color: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 2px;\n  cursor: default;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__disabled {\n  padding: 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__content {\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 4px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: bold;\n  line-height: inherit;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove > * {\n  line-height: 1;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove svg {\n  display: inline-block;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove::before {\n  display: none;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove .ant-select-selection--multiple .ant-select-selection__choice__remove-icon {\n  display: block;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 12px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-selection--multiple .ant-select-arrow {\n  top: 16px;\n}\n.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,\n.ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-open .ant-select-arrow-icon svg {\n  transform: rotate(180deg);\n}\n.ant-select-open .ant-select-selection {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-select-combobox .ant-select-arrow {\n  display: none;\n}\n.ant-select-combobox .ant-select-search--inline {\n  float: none;\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  box-shadow: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0s;\n}\n.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered,\n.ant-select-combobox.ant-select-show-arrow .ant-select-selection:hover .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-dropdown {\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-variant: initial;\n  background-color: #fff;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-select-dropdown-hidden {\n  display: none;\n}\n.ant-select-dropdown-menu {\n  max-height: 250px;\n  margin-bottom: 0;\n  padding: 4px 0;\n  padding-left: 0;\n  overflow: auto;\n  list-style: none;\n  outline: none;\n}\n.ant-select-dropdown-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {\n  padding-left: 20px;\n}\n.ant-select-dropdown-menu-item-group-title {\n  height: 32px;\n  padding: 0 12px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n  line-height: 32px;\n}\n.ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:first-child:not(:last-child),\n.ant-select-dropdown-menu-item-group:not(:last-child) .ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:last-child {\n  border-radius: 0;\n}\n.ant-select-dropdown-menu-item {\n  position: relative;\n  display: block;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #424242;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: #f0fffe;\n}\n.ant-select-dropdown-menu-item-selected {\n  color: #424242;\n  font-weight: 600;\n  background-color: #fafafa;\n}\n.ant-select-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: #f0fffe;\n}\n.ant-select-dropdown-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {\n  padding-right: 32px;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item .ant-select-selected-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  color: transparent;\n  font-weight: bold;\n  font-size: 12px;\n  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;\n  transform: translateY(-50%);\n  transition: all 0.2s;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover .ant-select-selected-icon {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled .ant-select-selected-icon {\n  display: none;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected .ant-select-selected-icon,\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover .ant-select-selected-icon {\n  display: inline-block;\n  color: #4CDEF5;\n}\n.ant-select-dropdown--empty.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {\n  padding-right: 12px;\n}\n.ant-select-dropdown-container-open .ant-select-dropdown,\n.ant-select-dropdown-open .ant-select-dropdown {\n  display: block;\n}\n", ""]);

// exports


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1206);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-empty {\n  margin: 0 8px;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n}\n.ant-empty-image {\n  height: 100px;\n  margin-bottom: 8px;\n}\n.ant-empty-image img {\n  height: 100%;\n}\n.ant-empty-image svg {\n  height: 100%;\n  margin: auto;\n}\n.ant-empty-description {\n  margin: 0;\n}\n.ant-empty-footer {\n  margin-top: 16px;\n}\n.ant-empty-normal {\n  margin: 32px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-normal .ant-empty-image {\n  height: 40px;\n}\n.ant-empty-small {\n  margin: 8px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-small .ant-empty-image {\n  height: 35px;\n}\n", ""]);

// exports


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OptGroup__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropTypes__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select__ = __webpack_require__(1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OptGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__PropTypes__["a"]; });




__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].Option = __WEBPACK_IMPORTED_MODULE_1__Option__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].OptGroup = __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */]);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var OptGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(OptGroup, _Component);

  function OptGroup() {
    _classCallCheck(this, OptGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptGroup).apply(this, arguments));
  }

  return OptGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


OptGroup.isSelectOptGroup = true;

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_animate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Option__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PropTypes__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectTrigger__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(313);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }











 // Where el is the DOM element you'd like to test for visibility

function isHidden(node) {
  return !node || node.offsetParent === null;
}




var SELECT_EMPTY_VALUE_KEY = 'RC_SELECT_EMPTY_VALUE_KEY';

var noop = function noop() {
  return null;
};

function chaining() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < fns.length; i++) {
      if (fns[i] && typeof fns[i] === 'function') {
        fns[i].apply(chaining, args);
      }
    }
  };
}

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.inputRef = null;
    _this.inputMirrorRef = null;
    _this.topCtrlRef = null;
    _this.selectTriggerRef = null;
    _this.rootRef = null;
    _this.selectionRef = null;
    _this.dropdownContainer = null;
    _this.blurTimer = null;
    _this.focusTimer = null;
    _this.comboboxTimer = null; // tslint:disable-next-line:variable-name

    _this._focused = false; // tslint:disable-next-line:variable-name

    _this._mouseDown = false; // tslint:disable-next-line:variable-name

    _this._options = []; // tslint:disable-next-line:variable-name

    _this._empty = false;

    _this.onInputChange = function (event) {
      var tokenSeparators = _this.props.tokenSeparators;
      var val = event.target.value;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) && tokenSeparators.length && Object(__WEBPACK_IMPORTED_MODULE_13__util__["l" /* includesSeparators */])(val, tokenSeparators)) {
        var nextValue = _this.getValueByInput(val);

        if (nextValue !== undefined) {
          _this.fireChange(nextValue);
        }

        _this.setOpenState(false, {
          needFocus: true
        });

        _this.setInputValue('', false);

        return;
      }

      _this.setInputValue(val);

      _this.setState({
        open: true
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.fireChange([val]);
      }
    };

    _this.onDropdownVisibleChange = function (open) {
      if (open && !_this._focused) {
        _this.clearBlurTime();

        _this.timeoutFocus();

        _this._focused = true;

        _this.updateFocusClassName();
      }

      _this.setOpenState(open);
    }; // combobox ignore


    _this.onKeyDown = function (event) {
      var open = _this.state.open;
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var keyCode = event.keyCode;

      if (open && !_this.getInputDOMNode()) {
        _this.onInputKeyDown(event);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!open) {
          _this.setOpenState(true);
        }

        event.preventDefault();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].SPACE) {
        // Not block space if popup is shown
        if (!open) {
          _this.setOpenState(true);

          event.preventDefault();
        }
      }
    };

    _this.onInputKeyDown = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          combobox = _this$props.combobox,
          defaultActiveFirstOption = _this$props.defaultActiveFirstOption;

      if (disabled) {
        return;
      }

      var state = _this.state;

      var isRealOpen = _this.getRealOpenState(state); // magic code


      var keyCode = event.keyCode;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) && !event.target.value && keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
        event.preventDefault();
        var value = state.value;

        if (value.length) {
          _this.removeSelected(value[value.length - 1]);
        }

        return;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!state.open) {
          _this.openIfHasChildren();

          event.preventDefault();
          event.stopPropagation();
          return;
        }
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER && state.open) {
        // Aviod trigger form submit when select item
        // https://github.com/ant-design/ant-design/issues/10861
        // https://github.com/ant-design/ant-design/issues/14544
        if (isRealOpen || !combobox) {
          event.preventDefault();
        } // Hard close popup to avoid lock of non option in combobox mode


        if (isRealOpen && combobox && defaultActiveFirstOption === false) {
          _this.comboboxTimer = setTimeout(function () {
            _this.setOpenState(false);
          });
        }
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ESC) {
        if (state.open) {
          _this.setOpenState(false);

          event.preventDefault();
          event.stopPropagation();
        }

        return;
      }

      if (isRealOpen && _this.selectTriggerRef) {
        var menu = _this.selectTriggerRef.getInnerMenu();

        if (menu && menu.onKeyDown(event, _this.handleBackfill)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    _this.onMenuSelect = function (_ref) {
      var item = _ref.item;

      if (!item) {
        return;
      }

      var value = _this.state.value;
      var props = _this.props;
      var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);
      var lastValue = value[value.length - 1];
      var skipTrigger = false;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(value, selectedValue) !== -1) {
          skipTrigger = true;
        } else {
          value = value.concat([selectedValue]);
        }
      } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) && lastValue !== undefined && lastValue === selectedValue && selectedValue !== _this.state.backfillValue) {
          _this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });

          skipTrigger = true;
        } else {
          value = [selectedValue];

          _this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });
        }
      }

      if (!skipTrigger) {
        _this.fireChange(value);
      }

      _this.fireSelect(selectedValue);

      if (!skipTrigger) {
        var inputValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(item, props.optionLabelProp) : '';

        if (props.autoClearSearchValue) {
          _this.setInputValue(inputValue, false);
        }
      }
    };

    _this.onMenuDeselect = function (_ref2) {
      var item = _ref2.item,
          domEvent = _ref2.domEvent;

      if (domEvent.type === 'keydown' && domEvent.keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        var menuItemDomNode = __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](item); // https://github.com/ant-design/ant-design/issues/20465#issuecomment-569033796

        if (!isHidden(menuItemDomNode)) {
          _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));
        }

        return;
      }

      if (domEvent.type === 'click') {
        _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));
      }

      var props = _this.props;

      if (props.autoClearSearchValue) {
        _this.setInputValue('');
      }
    };

    _this.onArrowClick = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (!_this.props.disabled) {
        _this.setOpenState(!_this.state.open, {
          needFocus: !_this.state.open
        });
      }
    };

    _this.onPlaceholderClick = function () {
      if (_this.getInputDOMNode && _this.getInputDOMNode()) {
        _this.getInputDOMNode().focus();
      }
    };

    _this.onOuterFocus = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.clearBlurTime(); // In IE11, onOuterFocus will be trigger twice when focus input
      // First one: e.target is div
      // Second one: e.target is input
      // other browser only trigger second one
      // https://github.com/ant-design/ant-design/issues/15942
      // Here we ignore the first one when e.target is div


      var inputNode = _this.getInputDOMNode();

      if (inputNode && e.target === _this.rootRef) {
        return;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) && e.target === inputNode) {
        return;
      }

      if (_this._focused) {
        return;
      }

      _this._focused = true;

      _this.updateFocusClassName(); // only effect multiple or tag mode


      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) || !_this._mouseDown) {
        _this.timeoutFocus();
      }
    };

    _this.onPopupFocus = function () {
      // fix ie scrollbar, focus element again
      _this.maybeFocus(true, true);
    };

    _this.onOuterBlur = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.blurTimer = window.setTimeout(function () {
        _this._focused = false;

        _this.updateFocusClassName();

        var props = _this.props;
        var value = _this.state.value;
        var inputValue = _this.state.inputValue;

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
          var options = _this._options || [];

          if (options.length) {
            var firstOption = Object(__WEBPACK_IMPORTED_MODULE_13__util__["d" /* findFirstMenuItem */])(options);

            if (firstOption) {
              value = [Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(firstOption)];

              _this.fireChange(value);
            }
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && inputValue) {
          if (_this._mouseDown) {
            // need update dropmenu when not blur
            _this.setInputValue('');
          } else {
            // why not use setState?
            // https://github.com/ant-design/ant-design/issues/14262
            _this.state.inputValue = '';

            if (_this.getInputDOMNode && _this.getInputDOMNode()) {
              _this.getInputDOMNode().value = '';
            }
          }

          var tmpValue = _this.getValueByInput(inputValue);

          if (tmpValue !== undefined) {
            value = tmpValue;

            _this.fireChange(value);
          }
        } // if click the rest space of Select in multiple mode


        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && _this._mouseDown) {
          _this.maybeFocus(true, true);

          _this._mouseDown = false;
          return;
        }

        _this.setOpenState(false);

        if (props.onBlur) {
          props.onBlur(_this.getVLForOnChange(value));
        }
      }, 10);
    };

    _this.onClearSelection = function (event) {
      var props = _this.props;
      var state = _this.state;

      if (props.disabled) {
        return;
      }

      var inputValue = state.inputValue;
      var value = state.value;
      event.stopPropagation();

      if (inputValue || value.length) {
        if (value.length) {
          _this.fireChange([]);
        }

        _this.setOpenState(false, {
          needFocus: true
        });

        if (inputValue) {
          _this.setInputValue('');
        }
      }
    };

    _this.onChoiceAnimationLeave = function () {
      _this.forcePopupAlign();
    };

    _this.getOptionInfoBySingleValue = function (value, optionsInfo) {
      var info;
      optionsInfo = optionsInfo || _this.state.optionsInfo;

      if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
        info = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)];
      }

      if (info) {
        return info;
      }

      var defaultLabel = value;

      if (_this.props.labelInValue) {
        var valueLabel = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* getLabelFromPropsValue */])(_this.props.value, value);
        var defaultValueLabel = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* getLabelFromPropsValue */])(_this.props.defaultValue, value);

        if (valueLabel !== undefined) {
          defaultLabel = valueLabel;
        } else if (defaultValueLabel !== undefined) {
          defaultLabel = defaultValueLabel;
        }
      }

      var defaultInfo = {
        option: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Option__["a" /* default */], {
          value: value,
          key: value
        }, value),
        value: value,
        label: defaultLabel
      };
      return defaultInfo;
    };

    _this.getOptionBySingleValue = function (value) {
      var _this$getOptionInfoBy = _this.getOptionInfoBySingleValue(value),
          option = _this$getOptionInfoBy.option;

      return option;
    };

    _this.getOptionsBySingleValue = function (values) {
      return values.map(function (value) {
        return _this.getOptionBySingleValue(value);
      });
    };

    _this.getValueByLabel = function (label) {
      if (label === undefined) {
        return null;
      }

      var value = null;
      Object.keys(_this.state.optionsInfo).forEach(function (key) {
        var info = _this.state.optionsInfo[key];
        var disabled = info.disabled;

        if (disabled) {
          return;
        }

        var oldLable = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(info.label);

        if (oldLable && oldLable.join('') === label) {
          value = info.value;
        }
      });
      return value;
    };

    _this.getVLBySingleValue = function (value) {
      if (_this.props.labelInValue) {
        return {
          key: value,
          label: _this.getLabelBySingleValue(value)
        };
      }

      return value;
    };

    _this.getVLForOnChange = function (vlsS) {
      var vls = vlsS;

      if (vls !== undefined) {
        if (!_this.props.labelInValue) {
          vls = vls.map(function (v) {
            return v;
          });
        } else {
          vls = vls.map(function (vl) {
            return {
              key: vl,
              label: _this.getLabelBySingleValue(vl)
            };
          });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? vls : vls[0];
      }

      return vls;
    };

    _this.getLabelBySingleValue = function (value, optionsInfo) {
      var _this$getOptionInfoBy2 = _this.getOptionInfoBySingleValue(value, optionsInfo),
          label = _this$getOptionInfoBy2.label;

      return label;
    };

    _this.getDropdownContainer = function () {
      if (!_this.dropdownContainer) {
        _this.dropdownContainer = document.createElement('div');
        document.body.appendChild(_this.dropdownContainer);
      }

      return _this.dropdownContainer;
    };

    _this.getPlaceholderElement = function () {
      var props = _this.props;
      var state = _this.state;
      var hidden = false;

      if (state.inputValue) {
        hidden = true;
      }

      var value = state.value;

      if (value.length) {
        hidden = true;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) && value.length === 1 && state.value && !state.value[0]) {
        hidden = false;
      }

      var placeholder = props.placeholder;

      if (placeholder) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
          onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
          style: _extends({
            display: hidden ? 'none' : 'block'
          }, __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */])
        }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
          onClick: _this.onPlaceholderClick,
          className: "".concat(props.prefixCls, "-selection__placeholder")
        }), placeholder);
      }

      return null;
    };

    _this.getInputElement = function () {
      var props = _this.props;
      var defaultInput = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
        id: props.id,
        autoComplete: "off"
      }); // tslint:disable-next-line:typedef-whitespace

      var inputElement = props.getInputElement ? props.getInputElement() : defaultInput;
      var inputCls = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(inputElement.props.className, _defineProperty({}, "".concat(props.prefixCls, "-search__field"), true)); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
      // Add space to the end of the inputValue as the width measurement tolerance

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "".concat(props.prefixCls, "-search__field__wrap")
      }, __WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"](inputElement, {
        ref: _this.saveInputRef,
        onChange: _this.onInputChange,
        onKeyDown: chaining(_this.onInputKeyDown, inputElement.props.onKeyDown, _this.props.onInputKeyDown),
        value: _this.state.inputValue,
        disabled: props.disabled,
        className: inputCls
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        ref: _this.saveInputMirrorRef,
        className: "".concat(props.prefixCls, "-search__field__mirror")
      }, _this.state.inputValue, "\xA0"));
    };

    _this.getInputDOMNode = function () {
      return _this.topCtrlRef ? _this.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this.inputRef;
    };

    _this.getInputMirrorDOMNode = function () {
      return _this.inputMirrorRef;
    };

    _this.getPopupDOMNode = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getPopupDOMNode();
      }
    };

    _this.getPopupMenuComponent = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getInnerMenu();
      }
    };

    _this.setOpenState = function (open) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var needFocus = config.needFocus,
          fireSearch = config.fireSearch;
      var props = _this.props;
      var state = _this.state;

      if (state.open === open) {
        _this.maybeFocus(open, !!needFocus);

        return;
      }

      if (_this.props.onDropdownVisibleChange) {
        _this.props.onDropdownVisibleChange(open);
      }

      var nextState = {
        open: open,
        backfillValue: ''
      }; // clear search input value when open is false in singleMode.
      // https://github.com/ant-design/ant-design/issues/16572

      if (!open && Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch) {
        _this.setInputValue('', fireSearch);
      }

      if (!open) {
        _this.maybeFocus(open, !!needFocus);
      }

      _this.setState(_extends({
        open: open
      }, nextState), function () {
        if (open) {
          _this.maybeFocus(open, !!needFocus);
        }
      });
    };

    _this.setInputValue = function (inputValue) {
      var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var onSearch = _this.props.onSearch;

      if (inputValue !== _this.state.inputValue) {
        _this.setState(function (prevState) {
          // Additional check if `inputValue` changed in latest state.
          if (fireSearch && inputValue !== prevState.inputValue && onSearch) {
            onSearch(inputValue);
          }

          return {
            inputValue: inputValue
          };
        }, _this.forcePopupAlign);
      }
    };

    _this.getValueByInput = function (str) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          tokenSeparators = _this$props2.tokenSeparators;
      var nextValue = _this.state.value;
      var hasNewValue = false;
      Object(__WEBPACK_IMPORTED_MODULE_13__util__["s" /* splitBySeparators */])(str, tokenSeparators).forEach(function (label) {
        var selectedValue = [label];

        if (multiple) {
          var value = _this.getValueByLabel(label);

          if (value && Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, value) === -1) {
            nextValue = nextValue.concat(value);
            hasNewValue = true;

            _this.fireSelect(value);
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, label) === -1) {
          nextValue = nextValue.concat(selectedValue);
          hasNewValue = true;

          _this.fireSelect(label);
        }
      });
      return hasNewValue ? nextValue : undefined;
    };

    _this.getRealOpenState = function (state) {
      // tslint:disable-next-line:variable-name
      var _open = _this.props.open;

      if (typeof _open === 'boolean') {
        return _open;
      }

      var open = (state || _this.state).open;
      var options = _this._options || [];

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) || !_this.props.showSearch) {
        if (open && !options.length) {
          open = false;
        }
      }

      return open;
    };

    _this.markMouseDown = function () {
      _this._mouseDown = true;
    };

    _this.markMouseLeave = function () {
      _this._mouseDown = false;
    };

    _this.handleBackfill = function (item) {
      if (!_this.props.backfill || !(Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(_this.props) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props))) {
        return;
      }

      var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.setInputValue(key, false);
      }

      _this.setState({
        value: [key],
        backfillValue: key
      });
    };

    _this.filterOption = function (input, child) {
      var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_13__util__["c" /* defaultFilterFn */];
      var value = _this.state.value;
      var lastValue = value[value.length - 1];

      if (!input || lastValue && lastValue === _this.state.backfillValue) {
        return true;
      }

      var filterFn = _this.props.filterOption;

      if ('filterOption' in _this.props) {
        if (filterFn === true) {
          filterFn = defaultFilter.bind(_assertThisInitialized(_this));
        }
      } else {
        filterFn = defaultFilter.bind(_assertThisInitialized(_this));
      }

      if (!filterFn) {
        return true;
      } else if (typeof filterFn === 'function') {
        return filterFn.call(_assertThisInitialized(_this), input, child);
      } else if (child.props.disabled) {
        return false;
      }

      return true;
    };

    _this.timeoutFocus = function () {
      var onFocus = _this.props.onFocus;

      if (_this.focusTimer) {
        _this.clearFocusTime();
      }

      _this.focusTimer = window.setTimeout(function () {
        if (onFocus) {
          onFocus();
        }
      }, 10);
    };

    _this.clearFocusTime = function () {
      if (_this.focusTimer) {
        clearTimeout(_this.focusTimer);
        _this.focusTimer = null;
      }
    };

    _this.clearBlurTime = function () {
      if (_this.blurTimer) {
        clearTimeout(_this.blurTimer);
        _this.blurTimer = null;
      }
    };

    _this.clearComboboxTime = function () {
      if (_this.comboboxTimer) {
        clearTimeout(_this.comboboxTimer);
        _this.comboboxTimer = null;
      }
    };

    _this.updateFocusClassName = function () {
      var rootRef = _this.rootRef;
      var props = _this.props; // avoid setState and its side effect

      if (_this._focused) {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).add("".concat(props.prefixCls, "-focused"));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).remove("".concat(props.prefixCls, "-focused"));
      }
    };

    _this.maybeFocus = function (open, needFocus) {
      if (needFocus || open) {
        var input = _this.getInputDOMNode();

        var _document = document,
            activeElement = _document.activeElement;

        if (input && (open || Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props))) {
          if (activeElement !== input) {
            input.focus();
            _this._focused = true;
          }
        } else if (activeElement !== _this.selectionRef && _this.selectionRef) {
          _this.selectionRef.focus();

          _this._focused = true;
        }
      }
    };

    _this.removeSelected = function (selectedKey, e) {
      var props = _this.props;

      if (props.disabled || _this.isChildDisabled(selectedKey)) {
        return;
      } // Do not trigger Trigger popup


      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      var oldValue = _this.state.value;
      var value = oldValue.filter(function (singleValue) {
        return singleValue !== selectedKey;
      });
      var canMultiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props);

      if (canMultiple) {
        var event = selectedKey;

        if (props.labelInValue) {
          event = {
            key: selectedKey,
            label: _this.getLabelBySingleValue(selectedKey)
          };
        }

        if (props.onDeselect) {
          props.onDeselect(event, _this.getOptionBySingleValue(selectedKey));
        }
      }

      _this.fireChange(value);
    };

    _this.openIfHasChildren = function () {
      var props = _this.props;

      if (__WEBPACK_IMPORTED_MODULE_6_react__["Children"].count(props.children) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        _this.setOpenState(true);
      }
    };

    _this.fireSelect = function (value) {
      if (_this.props.onSelect) {
        _this.props.onSelect(_this.getVLBySingleValue(value), _this.getOptionBySingleValue(value));
      }
    };

    _this.fireChange = function (value) {
      var props = _this.props;

      if (!('value' in props)) {
        _this.setState({
          value: value
        }, _this.forcePopupAlign);
      }

      var vls = _this.getVLForOnChange(value);

      var options = _this.getOptionsBySingleValue(value);

      if (props.onChange) {
        props.onChange(vls, Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? options : options[0]);
      }
    };

    _this.isChildDisabled = function (key) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(_this.props.children).some(function (child) {
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        return childValue === key && child.props && child.props.disabled;
      });
    };

    _this.forcePopupAlign = function () {
      if (!_this.state.open) {
        return;
      }

      if (_this.selectTriggerRef && _this.selectTriggerRef.triggerRef) {
        _this.selectTriggerRef.triggerRef.forcePopupAlign();
      }
    };

    _this.renderFilterOptions = function () {
      var inputValue = _this.state.inputValue;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          tags = _this$props3.tags,
          notFoundContent = _this$props3.notFoundContent;
      var menuItems = [];
      var childrenKeys = [];
      var empty = false;

      var options = _this.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);

      if (tags) {
        // tags value must be string
        var value = _this.state.value;
        value = value.filter(function (singleValue) {
          return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
        }); // sort by length

        value.sort(function (val1, val2) {
          return val1.length - val2.length;
        });
        value.forEach(function (singleValue) {
          var key = singleValue;
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            role: "option",
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: key,
            key: key
          }, key);
          options.push(menuItem);
          menuItems.push(menuItem);
        }); // ref: https://github.com/ant-design/ant-design/issues/14090

        if (inputValue && menuItems.every(function (option) {
          return Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option) !== inputValue;
        })) {
          options.unshift(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            role: "option",
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: inputValue,
            key: inputValue
          }, inputValue));
        }
      }

      if (!options.length && notFoundContent) {
        empty = true;
        options = [__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
          style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
          attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
          disabled: true,
          role: "option",
          value: "NOT_FOUND",
          key: "NOT_FOUND"
        }, notFoundContent)];
      }

      return {
        empty: empty,
        options: options
      };
    };

    _this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
      var sel = [];
      var props = _this.props;
      var inputValue = _this.state.inputValue;
      var tags = props.tags;
      __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
        if (!child) {
          return;
        }

        var type = child.type;

        if (type.isSelectOptGroup) {
          var label = child.props.label;
          var key = child.key;

          if (!key && typeof label === 'string') {
            key = label;
          } else if (!label && key) {
            label = key;
          } // Match option group label


          if (inputValue && _this.filterOption(inputValue, child)) {
            var innerItems = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(child.props.children).map(function (subChild) {
              var childValueSub = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(subChild) || subChild.key;
              return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
                key: childValueSub,
                value: childValueSub
              }, subChild.props));
            });
            sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
              key: key,
              title: label
            }, innerItems)); // Not match
          } else {
            var _innerItems = _this.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);

            if (_innerItems.length) {
              sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
                key: key,
                title: label
              }, _innerItems));
            }
          }

          return;
        }

        __WEBPACK_IMPORTED_MODULE_9_warning___default()(type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + "instead of `".concat(type.name || type.displayName || child.type, "`."));
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        Object(__WEBPACK_IMPORTED_MODULE_13__util__["v" /* validateOptionValue */])(childValue, _this.props);

        if (_this.filterOption(inputValue, child)) {
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: childValue,
            key: childValue,
            role: "option"
          }, child.props));
          sel.push(menuItem);
          menuItems.push(menuItem);
        }

        if (tags) {
          childrenKeys.push(childValue);
        }
      });
      return sel;
    };

    _this.renderTopControlNode = function () {
      var _this$state = _this.state,
          open = _this$state.open,
          inputValue = _this$state.inputValue;
      var value = _this.state.value;
      var props = _this.props;
      var choiceTransitionName = props.choiceTransitionName,
          prefixCls = props.prefixCls,
          maxTagTextLength = props.maxTagTextLength,
          maxTagCount = props.maxTagCount,
          showSearch = props.showSearch,
          removeIcon = props.removeIcon;
      var maxTagPlaceholder = props.maxTagPlaceholder;
      var className = "".concat(prefixCls, "-selection__rendered"); // search input is inside topControlNode in single, multiple & combobox. 2016/04/13

      var innerNode = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        var selectedValue = null;

        if (value.length) {
          var showSelectedValue = false;
          var opacity = 1;

          if (!showSearch) {
            showSelectedValue = true;
          } else if (open) {
            showSelectedValue = !inputValue;

            if (showSelectedValue) {
              opacity = 0.4;
            }
          } else {
            showSelectedValue = true;
          }

          var singleValue = value[0];

          var _this$getOptionInfoBy3 = _this.getOptionInfoBySingleValue(singleValue),
              label = _this$getOptionInfoBy3.label,
              title = _this$getOptionInfoBy3.title;

          selectedValue = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            key: "value",
            className: "".concat(prefixCls, "-selection-selected-value"),
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title || label),
            style: {
              display: showSelectedValue ? 'block' : 'none',
              opacity: opacity
            }
          }, label);
        }

        if (!showSearch) {
          innerNode = [selectedValue];
        } else {
          innerNode = [selectedValue, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
            key: "input",
            style: {
              display: open ? 'block' : 'none'
            }
          }, _this.getInputElement())];
        }
      } else {
        var selectedValueNodes = [];
        var limitedCountValue = value;
        var maxTagPlaceholderEl;

        if (maxTagCount !== undefined && value.length > maxTagCount) {
          limitedCountValue = limitedCountValue.slice(0, maxTagCount);

          var omittedValues = _this.getVLForOnChange(value.slice(maxTagCount, value.length));

          var content = "+ ".concat(value.length - maxTagCount, " ...");

          if (maxTagPlaceholder) {
            content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
          }

          maxTagPlaceholderEl = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
          }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
            role: "presentation",
            onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
            className: "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled"),
            key: "maxTagPlaceholder",
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(content)
          }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-selection__choice__content")
          }, content));
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
          selectedValueNodes = limitedCountValue.map(function (singleValue) {
            var info = _this.getOptionInfoBySingleValue(singleValue);

            var content = info.label;
            var title = info.title || content;

            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
              content = "".concat(content.slice(0, maxTagTextLength), "...");
            }

            var disabled = _this.isChildDisabled(singleValue);

            var choiceClassName = disabled ? "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled") : "".concat(prefixCls, "-selection__choice");
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
              style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
            }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
              onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
              className: choiceClassName,
              role: "presentation",
              key: singleValue || SELECT_EMPTY_VALUE_KEY,
              title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title)
            }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
              className: "".concat(prefixCls, "-selection__choice__content")
            }, content), disabled ? null : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
              onClick: function onClick(event) {
                _this.removeSelected(singleValue, event);
              },
              className: "".concat(prefixCls, "-selection__choice__remove")
            }, removeIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
              className: "".concat(prefixCls, "-selection__choice__remove-icon")
            }, "\xD7")));
          });
        }

        if (maxTagPlaceholderEl) {
          selectedValueNodes.push(maxTagPlaceholderEl);
        }

        selectedValueNodes.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", {
          className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
          key: "__input"
        }, _this.getInputElement()));

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && choiceTransitionName) {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_animate__["default"], {
            onLeave: _this.onChoiceAnimationLeave,
            component: "ul",
            transitionName: choiceTransitionName
          }, selectedValueNodes);
        } else {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("ul", null, selectedValueNodes);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: className,
        ref: _this.saveTopCtrlRef
      }, _this.getPlaceholderElement(), innerNode);
    };

    var optionsInfo = Select.getOptionsInfoFromProps(props);

    if (props.tags && typeof props.filterOption !== 'function') {
      var isDisabledExist = Object.keys(optionsInfo).some(function (key) {
        return optionsInfo[key].disabled;
      });
      __WEBPACK_IMPORTED_MODULE_9_warning___default()(!isDisabledExist, 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    }

    _this.state = {
      value: Select.getValueFromProps(props, true),
      inputValue: props.combobox ? Select.getInputValueForCombobox(props, optionsInfo, true) : '',
      open: props.defaultOpen,
      optionsInfo: optionsInfo,
      backfillValue: '',
      // a flag for aviod redundant getOptionsInfoFromProps call
      skipBuildOptionsInfo: true,
      ariaId: ''
    };
    _this.saveInputRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'inputRef');
    _this.saveInputMirrorRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'inputMirrorRef');
    _this.saveTopCtrlRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'topCtrlRef');
    _this.saveSelectTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'selectTriggerRef');
    _this.saveRootRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'rootRef');
    _this.saveSelectionRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'selectionRef');
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // when defaultOpen is true, we should auto focus search input
      // https://github.com/ant-design/ant-design/issues/14254
      if (this.props.autoFocus || this.state.open) {
        this.focus();
      }

      this.setState({
        ariaId: Object(__WEBPACK_IMPORTED_MODULE_13__util__["f" /* generateUUID */])()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(this.props)) {
        var inputNode = this.getInputDOMNode();
        var mirrorNode = this.getInputMirrorDOMNode();

        if (inputNode && inputNode.value && mirrorNode) {
          inputNode.style.width = '';
          inputNode.style.width = "".concat(mirrorNode.clientWidth, "px");
        } else if (inputNode) {
          inputNode.style.width = '';
        }
      }

      this.forcePopupAlign();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearFocusTime();
      this.clearBlurTime();
      this.clearComboboxTime();

      if (this.dropdownContainer) {
        __WEBPACK_IMPORTED_MODULE_7_react_dom__["unmountComponentAtNode"](this.dropdownContainer);
        document.body.removeChild(this.dropdownContainer);
        this.dropdownContainer = null;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.focus();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.blur();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().blur();
      }
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(multiple) {
      // showArrow : Set to true if not multiple by default but keep set value.
      var _this$props4 = this.props,
          _this$props4$showArro = _this$props4.showArrow,
          showArrow = _this$props4$showArro === void 0 ? !multiple : _this$props4$showArro,
          loading = _this$props4.loading,
          inputIcon = _this$props4.inputIcon,
          prefixCls = _this$props4.prefixCls;

      if (!showArrow && !loading) {
        return null;
      } // if loading  have loading icon


      var defaultIcon = loading ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-loading")
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-icon")
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "arrow",
        className: "".concat(prefixCls, "-arrow"),
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onArrowClick
      }), inputIcon || defaultIcon);
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowClear = _this$props5.allowClear,
          clearIcon = _this$props5.clearIcon;
      var inputValue = this.state.inputValue;
      var value = this.state.value;
      var clear = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "clear",
        className: "".concat(prefixCls, "-selection__clear"),
        onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onClearSelection
      }), clearIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-selection__clear-icon")
      }, "\xD7"));

      if (!allowClear) {
        return null;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(this.props)) {
        if (inputValue) {
          return clear;
        }

        return null;
      }

      if (inputValue || value.length) {
        return clear;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _rootCls;

      var props = this.props;
      var multiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props); // Default set showArrow to true if not set (not set directly in defaultProps to handle multiple case)

      var _props$showArrow = props.showArrow,
          showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
      var state = this.state;
      var className = props.className,
          disabled = props.disabled,
          prefixCls = props.prefixCls,
          loading = props.loading;
      var ctrlNode = this.renderTopControlNode();
      var _this$state2 = this.state,
          open = _this$state2.open,
          ariaId = _this$state2.ariaId;

      if (open) {
        var filterOptions = this.renderFilterOptions();
        this._empty = filterOptions.empty;
        this._options = filterOptions.options;
      }

      var realOpen = this.getRealOpenState();
      var empty = this._empty;
      var options = this._options || [];
      var dataOrAriaAttributeProps = {};
      Object.keys(props).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(props, key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
          dataOrAriaAttributeProps[key] = props[key];
        }
      }); // for (const key in props) {
      //   if (
      //     Object.prototype.hasOwnProperty.call(props, key) &&
      //     (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')
      //   ) {
      //     dataOrAriaAttributeProps[key] = props[key];
      //   }
      // }

      var extraSelectionProps = _extends({}, dataOrAriaAttributeProps);

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(props)) {
        extraSelectionProps = _extends(_extends({}, extraSelectionProps), {
          onKeyDown: this.onKeyDown,
          tabIndex: props.disabled ? -1 : props.tabIndex
        });
      }

      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, className, !!className), _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), _defineProperty(_rootCls, "".concat(prefixCls, "-focused"), open || !!this._focused), _defineProperty(_rootCls, "".concat(prefixCls, "-combobox"), Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props)), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-enabled"), !disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-allow-clear"), !!props.allowClear), _defineProperty(_rootCls, "".concat(prefixCls, "-no-arrow"), !showArrow), _defineProperty(_rootCls, "".concat(prefixCls, "-loading"), !!loading), _rootCls);
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SelectTrigger__["a" /* default */], {
        onPopupFocus: this.onPopupFocus,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        dropdownAlign: props.dropdownAlign,
        dropdownClassName: props.dropdownClassName,
        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        transitionName: props.transitionName,
        animation: props.animation,
        prefixCls: props.prefixCls,
        dropdownStyle: props.dropdownStyle,
        combobox: props.combobox,
        showSearch: props.showSearch,
        options: options,
        empty: empty,
        multiple: multiple,
        disabled: disabled,
        visible: realOpen,
        inputValue: state.inputValue,
        value: state.value,
        backfillValue: state.backfillValue,
        firstActiveValue: props.firstActiveValue,
        onDropdownVisibleChange: this.onDropdownVisibleChange,
        getPopupContainer: props.getPopupContainer,
        onMenuSelect: this.onMenuSelect,
        onMenuDeselect: this.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        showAction: props.showAction,
        ref: this.saveSelectTriggerRef,
        menuItemSelectedIcon: props.menuItemSelectedIcon,
        dropdownRender: props.dropdownRender,
        ariaId: ariaId
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        id: props.id,
        style: props.style,
        ref: this.saveRootRef,
        onBlur: this.onOuterBlur,
        onFocus: this.onOuterFocus,
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(rootCls),
        onMouseDown: this.markMouseDown,
        onMouseUp: this.markMouseLeave,
        onMouseOut: this.markMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
        ref: this.saveSelectionRef,
        key: "selection",
        className: "".concat(prefixCls, "-selection\n            ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single'),
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-haspopup": "true",
        "aria-controls": ariaId,
        "aria-expanded": realOpen
      }, extraSelectionProps), ctrlNode, this.renderClear(), this.renderArrow(!!multiple))));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Select.propTypes = __WEBPACK_IMPORTED_MODULE_11__PropTypes__["a" /* default */];
Select.defaultProps = {
  prefixCls: 'rc-select',
  defaultOpen: false,
  labelInValue: false,
  defaultActiveFirstOption: true,
  showSearch: true,
  allowClear: false,
  placeholder: '',
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  onSelect: noop,
  onSearch: noop,
  onDeselect: noop,
  onInputKeyDown: noop,
  dropdownMatchSelectWidth: true,
  dropdownStyle: {},
  dropdownMenuStyle: {},
  optionFilterProp: 'value',
  optionLabelProp: 'value',
  notFoundContent: 'Not Found',
  backfill: false,
  showAction: ['click'],
  tokenSeparators: [],
  autoClearSearchValue: true,
  tabIndex: 0,
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};

Select.getDerivedStateFromProps = function (nextProps, prevState) {
  var optionsInfo = prevState.skipBuildOptionsInfo ? prevState.optionsInfo : Select.getOptionsInfoFromProps(nextProps, prevState);
  var newState = {
    optionsInfo: optionsInfo,
    skipBuildOptionsInfo: false
  };

  if ('open' in nextProps) {
    newState.open = nextProps.open;
  }

  if (nextProps.disabled && prevState.open) {
    newState.open = false;
  }

  if ('value' in nextProps) {
    var value = Select.getValueFromProps(nextProps);
    newState.value = value;

    if (nextProps.combobox) {
      newState.inputValue = Select.getInputValueForCombobox(nextProps, optionsInfo);
    }
  }

  return newState;
};

Select.getOptionsFromChildren = function (children) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
    if (!child) {
      return;
    }

    var type = child.type;

    if (type.isSelectOptGroup) {
      Select.getOptionsFromChildren(child.props.children, options);
    } else {
      options.push(child);
    }
  });
  return options;
};

Select.getInputValueForCombobox = function (props, optionsInfo, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (value.length) {
    value = value[0];
  } else {
    return '';
  }

  var label = value;

  if (props.labelInValue) {
    label = value.label;
  } else if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
    label = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)].label;
  }

  if (label === undefined) {
    label = '';
  }

  return label;
};

Select.getLabelFromOption = function (props, option) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(option, props.optionLabelProp);
};

Select.getOptionsInfoFromProps = function (props, preState) {
  var options = Select.getOptionsFromChildren(props.children);
  var optionsInfo = {};
  options.forEach(function (option) {
    var singleValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option);
    optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(singleValue)] = {
      option: option,
      value: singleValue,
      label: Select.getLabelFromOption(props, option),
      title: option.props.title,
      disabled: option.props.disabled
    };
  });

  if (preState) {
    // keep option info in pre state value.
    var oldOptionsInfo = preState.optionsInfo;
    var value = preState.value;

    if (value) {
      value.forEach(function (v) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(v);

        if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
          optionsInfo[key] = oldOptionsInfo[key];
        }
      });
    }
  }

  return optionsInfo;
};

Select.getValueFromProps = function (props, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (props.labelInValue) {
    value = value.map(function (v) {
      return v.key;
    });
  }

  return value;
};

Select.displayName = 'Select';
Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Select);
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__ = __webpack_require__(1223);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }







var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));

    _this.onSelect = function (selectInfo) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.selectable) {
        // root menu
        var _this$store$getState = _this.store.getState(),
            _selectedKeys = _this$store$getState.selectedKeys;

        var selectedKey = selectInfo.key;

        if (props.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys
          });
        }

        props.onSelect(_objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys
        }));
      }
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    }; // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself


    _this.onKeyDown = function (e, callback) {
      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };

    _this.onOpenChange = function (event) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          props = _assertThisInitialize2.props;

      var openKeys = _this.store.getState().openKeys.concat();

      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!('openKeys' in _this.props)) {
          _this.store.setState({
            openKeys: openKeys
          });
        }

        props.onOpenChange(openKeys);
      }
    };

    _this.onDeselect = function (selectInfo) {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          props = _assertThisInitialize3.props;

      if (props.selectable) {
        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();

        var selectedKey = selectInfo.key;

        var index = _selectedKeys2.indexOf(selectedKey);

        if (index !== -1) {
          _selectedKeys2.splice(index, 1);
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys2
          });
        }

        props.onDeselect(_objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys2
        }));
      }
    };

    _this.getOpenTransitionName = function () {
      var _assertThisInitialize4 = _assertThisInitialized(_this),
          props = _assertThisInitialize4.props;

      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
      }

      return transitionName;
    };

    _this.setInnerMenu = function (node) {
      _this.innerMenu = node;
    };

    _this.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_1_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey)
      }
    });
    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMiniStore();
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ('selectedKeys' in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }

      if ('openKeys' in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = _objectSpread({}, this.props);

      props.className += " ".concat(props.prefixCls, "-root");
      props = _objectSpread({}, props, {
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        parentMenu: this,
        motion: Object(__WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__["a" /* getMotion */])(this.props)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_mini_store__["Provider"], {
        store: this.store
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__["a" /* default */], Object.assign({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "\xB7\xB7\xB7")
};
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(497);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(69);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(1213);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__(38);

var _PropTypes = __webpack_require__(497);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          _this.setState({ subscribed: nextState });
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = ua.split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = _slicedToArray(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = _slicedToArray(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = _objectSpread({}, isMobile(), {
  isMobile: isMobile
});

/* harmony default export */ __webpack_exports__["a"] = (defaultResult);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubMenu__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(136);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr

if (canUseDOM) {
  // eslint-disable-next-line global-require
  __webpack_require__(1222);
}

var DOMWrap =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DOMWrap, _React$Component);

  function DOMWrap() {
    var _this;

    _classCallCheck(this, DOMWrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMWrap).apply(this, arguments));
    _this.resizeObserver = null;
    _this.mutationObserver = null; // original scroll size of the list

    _this.originalTotalWidth = 0; // copy of overflowed items

    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    _this.menuItemSizes = [];
    _this.state = {
      lastVisibleIndex: undefined
    }; // get all valid menuItem nodes

    _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;
      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };

    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = _this.props.children[0];

      var _copy$props = copy.props,
          throwAway = _copy$props.children,
          title = _copy$props.title,
          propStyle = _copy$props.style,
          rest = _objectWithoutProperties(_copy$props, ["children", "title", "style"]);

      var style = _objectSpread({}, propStyle);

      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = _objectSpread({}, style, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = _objectSpread({}, style, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      __WEBPACK_IMPORTED_MODULE_4__util__["g" /* menuAllProps */].forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__SubMenu__["a" /* default */], Object.assign({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName: popupClassName
      }, props, {
        key: key,
        eventKey: eventKey,
        disabled: false,
        style: style
      }), overflowedItems);
    }; // memorize rendered menuSize


    _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation


      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(c, 'display', 'inline-block');
      });
      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(c);
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(ul.children[ul.children.length - 1]);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      _this.handleResize(); // prevent the overflowed indicator from taking space;


      Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    };

    _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var width = Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(ul);
      _this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      _this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    };

    return _this;
  }

  _createClass(DOMWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setChildrenWidthAndResize();

      if (this.props.level === 1 && this.props.mode === 'horizontal') {
        var menuUl = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this);

        if (!menuUl) {
          return;
        }

        this.resizeObserver = new __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__["default"](function (entries) {
          entries.forEach(_this2.setChildrenWidthAndResize);
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this2.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(function () {
            _this2.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this2.resizeObserver.observe(el);
            });

            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;

        if (_this3.props.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);

          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index > lastVisibleIndex) {
              item = __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                eventKey: "".concat(childNode.props.eventKey, "-hidden"),

                /**
                 * Legacy code. Here `className` never used:
                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
                 */
                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: c.props.eventKey,
                  mode: 'vertical-left'
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }

          return ret;
        }

        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          prefixCls = _this$props2.prefixCls,
          overflowedIndicator = _this$props2.overflowedIndicator,
          mode = _this$props2.mode,
          level = _this$props2.level,
          tag = _this$props2.tag,
          children = _this$props2.children,
          theme = _this$props2.theme,
          rest = _objectWithoutProperties(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);

      var Tag = tag;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tag, Object.assign({}, rest), this.renderChildren(children));
    }
  }]);

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MotionPropTypes */
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_motion__ = __webpack_require__(1220);






/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */








var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

var MotionPropTypes = {
  eventProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, // Internal usage. Only pass by CSSMotionList
  visible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  motionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  motionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionLeaveImmediately: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, // Trigger leave motion immediately
  removeOnLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  leavedClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onAppearStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppearActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppearEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!__WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef;

  if (typeof config === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CSSMotion, _React$Component);

    function CSSMotion() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CSSMotion);

      var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = _this.getElement();
        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);
          _this.addEventListener($ele);
          _this.$cacheEle = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;

        _this.node = node;

        if (typeof internalRef === 'function') {
          internalRef(node);
        } else if (internalRef && 'current' in internalRef) {
          internalRef.current = node;
        }
      };

      _this.getElement = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__["a" /* default */])(_this.node || _this);
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          _this.updateStatus(styleFunc, { statusActive: true });
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = __WEBPACK_IMPORTED_MODULE_11_raf___default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          __WEBPACK_IMPORTED_MODULE_11_raf___default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave,
            leavedClassName = _props.leavedClassName,
            eventProps = _props.eventProps;


        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps), this.setNodeRef);
          } else if (!removeOnLeave) {
            return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps, { className: leavedClassName }), this.setNodeRef);
          }

          return null;
        }

        return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps, {
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status), status !== STATUS_NONE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status + '-active'), status !== STATUS_NONE && statusActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Clean up status if prop set to false
        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        }

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  CSSMotion.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, MotionPropTypes, {

    internalRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func])
  });
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };


  Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(CSSMotion);

  if (!forwardRef) {
    return CSSMotion;
  }

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CSSMotion, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ internalRef: ref }, props));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_12__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(node);
}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(199)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transitionEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportTransition; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransitionName;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var style = {};

if (canUseDOM) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
// Authors: Graeme Yeates (github.com/megawac) 
window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&
a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,
type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,
q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),
u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=
a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_warning__ = __webpack_require__(500);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      openAnimation = _ref.openAnimation,
      openTransitionName = _ref.openTransitionName;

  if (motion) {
    return motion;
  }

  if (_typeof(openAnimation) === 'object' && openAnimation) {
    Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_warning__["a" /* default */])(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
  } else if (typeof openAnimation === 'string') {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }

  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  }

  return null;
}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(136);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);

        return true;
      }

      return undefined;
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _assertThisInitialized(_this),
        domEvent: e
      };
      onClick(info);

      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    _this.saveNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          active = _this$props4.active,
          parentMenu = _this$props4.parentMenu,
          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
      // https://github.com/ant-design/ant-design/issues/16181

      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
        if (this.node) {
          __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view___default()(this.node, __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](parentMenu), {
            onlyScrollIfNeeded: true
          });
          parentMenu["scrolled-".concat(eventKey)] = true;
        }
      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
        delete parentMenu["scrolled-".concat(eventKey)];
      }

      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;

      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = _objectSpread({}, this.props);

      var className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _classNames));

      var attrs = _objectSpread({}, props.attribute, {
        title: props.title,
        className: className,
        // set to menuitem by default
        role: props.role || 'menuitem',
        'aria-disabled': props.disabled
      });

      if (props.role === 'option') {
        // overwrite to option
        attrs = _objectSpread({}, attrs, {
          role: 'option',
          'aria-selected': props.isSelected
        });
      } else if (props.role === null || props.role === 'none') {
        // sometimes we want to specify role inside <li/> element
        // <li><a role='menuitem'>Link</a></li> would be a good example
        // in this case the role on <li/> should be "none" to
        // remove the implied listitem role.
        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
        attrs.role = 'none';
      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };

      var style = _objectSpread({}, props.style);

      if (props.mode === 'inline') {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      __WEBPACK_IMPORTED_MODULE_6__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      });
      var icon = this.props.itemIcon;

      if (typeof this.props.itemIcon === 'function') {
        // TODO: This is a bug which should fixed after TS refactor
        icon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.itemIcon, this.props);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, attrs, mouseEvent, {
        style: style,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
MenuItem.isMenuItem = true;
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_5_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(136);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var MenuItemGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _this;

    _classCallCheck(this, MenuItemGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItemGroup).apply(this, arguments));

    _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;
      return renderMenuItem(item, index, _this.props.subMenuKey);
    };

    return _this;
  }

  _createClass(MenuItemGroup, [{
    key: "render",
    value: function render() {
      var props = _extends({}, this.props);

      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title,
          children = props.children;
      __WEBPACK_IMPORTED_MODULE_1__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, {
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        className: titleClassName,
        title: typeof title === 'string' ? title : undefined
      }, title), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", {
        className: listClassName
      }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, this.renderInnerMenuItem)));
    }
  }]);

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.defaultProps = {
  disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Divider = function Divider(_ref) {
  var className = _ref.className,
      rootPrefixCls = _ref.rootPrefixCls,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};

Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropdownMenu__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(313);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









__WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"].displayName = 'Trigger';
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

var SelectTrigger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectTrigger, _React$Component);

  function SelectTrigger(props) {
    var _this;

    _classCallCheck(this, SelectTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTrigger).call(this, props));
    _this.dropdownMenuRef = null;
    _this.rafInstance = null;

    _this.setDropdownWidth = function () {
      _this.cancelRafInstance();

      _this.rafInstance = __WEBPACK_IMPORTED_MODULE_2_raf___default()(function () {
        var dom = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](_assertThisInitialized(_this));
        var width = dom.offsetWidth;

        if (width !== _this.state.dropdownWidth) {
          _this.setState({
            dropdownWidth: width
          });
        }
      });
    };

    _this.cancelRafInstance = function () {
      if (_this.rafInstance) {
        __WEBPACK_IMPORTED_MODULE_2_raf___default.a.cancel(_this.rafInstance);
      }
    };

    _this.getInnerMenu = function () {
      return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
    };

    _this.getPopupDOMNode = function () {
      return _this.triggerRef.getPopupDomNode();
    };

    _this.getDropdownElement = function (newProps) {
      var props = _this.props;
      var dropdownRender = props.dropdownRender,
          ariaId = props.ariaId;
      var menuNode = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__DropdownMenu__["a" /* default */], _extends({
        ref: _this.saveDropdownMenuRef
      }, newProps, {
        ariaId: ariaId,
        prefixCls: _this.getDropdownPrefixCls(),
        onMenuSelect: props.onMenuSelect,
        onMenuDeselect: props.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        value: props.value,
        backfillValue: props.backfillValue,
        firstActiveValue: props.firstActiveValue,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        menuItemSelectedIcon: props.menuItemSelectedIcon
      }));

      if (dropdownRender) {
        return dropdownRender(menuNode, props);
      }

      return null;
    };

    _this.getDropdownTransitionName = function () {
      var props = _this.props;
      var transitionName = props.transitionName;

      if (!transitionName && props.animation) {
        transitionName = "".concat(_this.getDropdownPrefixCls(), "-").concat(props.animation);
      }

      return transitionName;
    };

    _this.getDropdownPrefixCls = function () {
      return "".concat(_this.props.prefixCls, "-dropdown");
    };

    _this.saveDropdownMenuRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'dropdownMenuRef');
    _this.saveTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'triggerRef');
    _this.state = {
      dropdownWidth: 0
    };
    return _this;
  }

  _createClass(SelectTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDropdownWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDropdownWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRafInstance();
    }
  }, {
    key: "render",
    value: function render() {
      var _popupClassName;

      var _a = this.props,
          onPopupFocus = _a.onPopupFocus,
          empty = _a.empty,
          props = __rest(_a, ["onPopupFocus", "empty"]);

      var multiple = props.multiple,
          visible = props.visible,
          inputValue = props.inputValue,
          dropdownAlign = props.dropdownAlign,
          disabled = props.disabled,
          showSearch = props.showSearch,
          dropdownClassName = props.dropdownClassName,
          dropdownStyle = props.dropdownStyle,
          dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
      var dropdownPrefixCls = this.getDropdownPrefixCls();
      var popupClassName = (_popupClassName = {}, _defineProperty(_popupClassName, dropdownClassName, !!dropdownClassName), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--").concat(multiple ? 'multiple' : 'single'), 1), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--empty"), empty), _popupClassName);
      var popupElement = this.getDropdownElement({
        menuItems: props.options,
        onPopupFocus: onPopupFocus,
        multiple: multiple,
        inputValue: inputValue,
        visible: visible
      });
      var hideAction;

      if (disabled) {
        hideAction = [];
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* isSingleMode */])(props) && !showSearch) {
        hideAction = ['click'];
      } else {
        hideAction = ['blur'];
      }

      var popupStyle = _extends({}, dropdownStyle);

      var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';

      if (this.state.dropdownWidth) {
        popupStyle[widthProp] = "".concat(this.state.dropdownWidth, "px");
      }

      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"], _extends({}, props, {
        showAction: disabled ? [] : this.props.showAction,
        hideAction: hideAction,
        ref: this.saveTriggerRef,
        popupPlacement: "bottomLeft",
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: this.getDropdownTransitionName(),
        onPopupVisibleChange: props.onDropdownVisibleChange,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: props.getPopupContainer,
        popupClassName: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(popupClassName),
        popupStyle: popupStyle
      }), props.children);
    }
  }]);

  return SelectTrigger;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


SelectTrigger.defaultProps = {
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};
SelectTrigger.propTypes = {
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  dropdownMatchSelectWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  showSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  filterOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  popupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]),
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
};
SelectTrigger.displayName = 'SelectTrigger';

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(313);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }










var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).call(this, props));
    _this.rafInstance = null;
    _this.lastVisible = false;

    _this.scrollActiveItemToView = function () {
      // scroll into view
      var itemComponent = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.firstActiveItem);
      var _this$props = _this.props,
          visible = _this$props.visible,
          firstActiveValue = _this$props.firstActiveValue;
      var value = _this.props.value;

      if (!itemComponent || !visible) {
        return;
      }

      var scrollIntoViewOpts = {
        onlyScrollIfNeeded: true
      };

      if ((!value || value.length === 0) && firstActiveValue) {
        scrollIntoViewOpts.alignWithTop = true;
      } // Delay to scroll since current frame item position is not ready when pre view is by filter
      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462


      _this.rafInstance = __WEBPACK_IMPORTED_MODULE_2_raf___default()(function () {
        __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default()(itemComponent, Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.menuRef), scrollIntoViewOpts);
      });
    };

    _this.renderMenu = function () {
      var _this$props2 = _this.props,
          menuItems = _this$props2.menuItems,
          menuItemSelectedIcon = _this$props2.menuItemSelectedIcon,
          defaultActiveFirstOption = _this$props2.defaultActiveFirstOption,
          prefixCls = _this$props2.prefixCls,
          multiple = _this$props2.multiple,
          onMenuSelect = _this$props2.onMenuSelect,
          inputValue = _this$props2.inputValue,
          backfillValue = _this$props2.backfillValue,
          onMenuDeselect = _this$props2.onMenuDeselect,
          visible = _this$props2.visible;
      var firstActiveValue = _this.props.firstActiveValue;

      if (menuItems && menuItems.length) {
        var menuProps = {};

        if (multiple) {
          menuProps.onDeselect = onMenuDeselect;
          menuProps.onSelect = onMenuSelect;
        } else {
          menuProps.onClick = onMenuSelect;
        }

        var value = _this.props.value;
        var selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["j" /* getSelectKeys */])(menuItems, value);
        var activeKeyProps = {};
        var defaultActiveFirst = defaultActiveFirstOption;
        var clonedMenuItems = menuItems;

        if (selectedKeys.length || firstActiveValue) {
          if (visible && !_this.lastVisible) {
            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
          } else if (!visible) {
            // Do not trigger auto active since we already have selectedKeys
            if (selectedKeys[0]) {
              defaultActiveFirst = false;
            }

            activeKeyProps.activeKey = undefined;
          }

          var foundFirst = false; // set firstActiveItem via cloning menus
          // for scroll into view

          var clone = function clone(item) {
            var key = item.key;

            if (!foundFirst && selectedKeys.indexOf(key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
              foundFirst = true;
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {
                ref: function ref(_ref) {
                  _this.firstActiveItem = _ref;
                }
              });
            }

            return item;
          };

          clonedMenuItems = menuItems.map(function (item) {
            if (item.type.isMenuItemGroup) {
              var children = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(item.props.children).map(clone);
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {}, children);
            }

            return clone(item);
          });
        } else {
          // Clear firstActiveItem when dropdown menu items was empty
          // Avoid `Unable to find node on an unmounted component`
          // https://github.com/ant-design/ant-design/issues/10774
          _this.firstActiveItem = null;
        } // clear activeKey when inputValue change


        var lastValue = value && value[value.length - 1];

        if (inputValue !== _this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
          activeKeyProps.activeKey = '';
        }

        return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["default"], _extends({
          ref: _this.saveMenuRef,
          style: _this.props.dropdownMenuStyle,
          defaultActiveFirst: defaultActiveFirst,
          role: "listbox",
          itemIcon: multiple ? menuItemSelectedIcon : null
        }, activeKeyProps, {
          multiple: multiple
        }, menuProps, {
          selectedKeys: selectedKeys,
          prefixCls: "".concat(prefixCls, "-menu")
        }), clonedMenuItems);
      }

      return null;
    };

    _this.lastInputValue = props.inputValue;
    _this.saveMenuRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'menuRef');
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollActiveItemToView();
      this.lastVisible = this.props.visible;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (!nextProps.visible) {
        this.lastVisible = false;
      } // freeze when hide


      return this.props.visible && !nextProps.visible || nextProps.visible || nextProps.inputValue !== this.props.inputValue;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (!prevProps.visible && props.visible) {
        this.scrollActiveItemToView();
      }

      this.lastVisible = props.visible;
      this.lastInputValue = props.inputValue;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafInstance) {
        __WEBPACK_IMPORTED_MODULE_2_raf___default.a.cancel(this.rafInstance);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderMenu = this.renderMenu();
      return renderMenu ? __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        style: {
          overflow: 'auto',
          transform: 'translateZ(0)'
        },
        id: this.props.ariaId,
        onFocus: this.props.onPopupFocus,
        onMouseDown: __WEBPACK_IMPORTED_MODULE_7__util__["q" /* preventDefaultEvent */],
        onScroll: this.props.onPopupScroll
      }, renderMenu) : null;
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.propTypes = {
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  dropdownMenuStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuDeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItems: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  firstActiveValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]])
};

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(315);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === 'Email';var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'center' } }, 'Dr.Brian Buck(780) 248-1927 ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' or ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' the Stroke Research office (780) 407-4366'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Participant\u2019s Name"), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Participant\u2019s Name" })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Legally Authorized Representative\u2019s Name"), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Legally Authorized Representative\u2019s Name" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Legally Authorized Representative', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Witness\u2019 Name (If applicable)"), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('sb_dic_witness_name') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form will be is provided for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1232);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-radio-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-radio-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  margin-right: 8px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.ant-radio {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: sub;\n  outline: none;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-input:focus + .ant-radio-inner {\n  border-color: #4CDEF5;\n}\n.ant-radio-input:focus + .ant-radio-inner {\n  box-shadow: 0 0 0 3px rgba(76, 222, 245, 0.08);\n}\n.ant-radio-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #4CDEF5;\n  border-radius: 50%;\n  visibility: hidden;\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  content: '';\n}\n.ant-radio:hover::after,\n.ant-radio-wrapper:hover .ant-radio::after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 100px;\n  transition: all 0.3s;\n}\n.ant-radio-inner::after {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  display: table;\n  width: 8px;\n  height: 8px;\n  background-color: #4CDEF5;\n  border-top: 0;\n  border-left: 0;\n  border-radius: 8px;\n  transform: scale(0);\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  content: ' ';\n}\n.ant-radio-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #4CDEF5;\n}\n.ant-radio-checked .ant-radio-inner::after {\n  transform: scale(1);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled .ant-radio-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n  cursor: not-allowed;\n}\n.ant-radio-disabled .ant-radio-inner::after {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-radio-button-wrapper {\n  position: relative;\n  display: inline-block;\n  height: 32px;\n  margin: 0;\n  padding: 0 15px;\n  color: #424242;\n  line-height: 30px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  border-top-width: 1.02px;\n  border-left: 0;\n  cursor: pointer;\n  transition: color 0.3s, background 0.3s, border-color 0.3s;\n}\n.ant-radio-button-wrapper a {\n  color: #424242;\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  display: block;\n  width: 0;\n  height: 0;\n  margin-left: 0;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 40px;\n  font-size: 16px;\n  line-height: 38px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 24px;\n  padding: 0 7px;\n  line-height: 22px;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  position: absolute;\n  top: 0;\n  left: -1px;\n  display: block;\n  width: 1px;\n  height: 100%;\n  background-color: #d9d9d9;\n  content: '';\n}\n.ant-radio-button-wrapper:first-child {\n  border-left: 1px solid #d9d9d9;\n  border-radius: 4px 0 0 4px;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 4px;\n}\n.ant-radio-button-wrapper:hover {\n  position: relative;\n  color: #4CDEF5;\n}\n.ant-radio-button-wrapper:focus-within {\n  outline: 3px solid rgba(76, 222, 245, 0.06);\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type='checkbox'],\n.ant-radio-button-wrapper input[type='radio'] {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  z-index: 1;\n  color: #4CDEF5;\n  background: #fff;\n  border-color: #4CDEF5;\n  box-shadow: -1px 0 0 0 #4CDEF5;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {\n  background-color: #4CDEF5 !important;\n  opacity: 0.1;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {\n  border-color: #4CDEF5;\n  box-shadow: none !important;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #78f1ff;\n  border-color: #78f1ff;\n  box-shadow: -1px 0 0 0 #78f1ff;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #36b5cf;\n  border-color: #36b5cf;\n  box-shadow: -1px 0 0 0 #36b5cf;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  outline: 3px solid rgba(76, 222, 245, 0.06);\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: #fff;\n  background: #4CDEF5;\n  border-color: #4CDEF5;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #fff;\n  background: #78f1ff;\n  border-color: #78f1ff;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #fff;\n  background: #36b5cf;\n  border-color: #36b5cf;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  outline: 3px solid rgba(76, 222, 245, 0.06);\n}\n.ant-radio-button-wrapper-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: #fff;\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n@supports (-moz-appearance: meterbar) and (background-blend-mode: difference, normal) {\n  .ant-radio {\n    vertical-align: text-bottom;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(38);










var Checkbox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }
      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }
      if (onChange) {
        onChange({
          target: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, {
            checked: e.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          },

          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if ('checked' in props) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
        checked: props.checked
      });
    }
    return null;
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        id = _props.id,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        others = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'span',
      { className: classString, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        name: name,
        id: id,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};


Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Checkbox);

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _reactLifecyclesCompat = __webpack_require__(38);

var _radio = _interopRequireDefault(__webpack_require__(314));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getCheckedValue(children) {
  var value = null;
  var matched = false;
  React.Children.forEach(children, function (radio) {
    if (radio && radio.props && radio.props.checked) {
      value = radio.props.value;
      matched = true;
    }
  });
  return matched ? {
    value: value
  } : undefined;
}

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).call(this, props));

    _this.onRadioChange = function (ev) {
      var lastValue = _this.state.value;
      var value = ev.target.value;

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange && value !== lastValue) {
        onChange(ev);
      }
    };

    _this.renderGroup = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          options = props.options,
          buttonStyle = props.buttonStyle;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
      var children = props.children; // 如果存在 options, 优先使用

      if (options && options.length > 0) {
        children = options.map(function (option) {
          if (typeof option === 'string') {
            // 此处类型自动推导为 string
            return React.createElement(_radio["default"], {
              key: option,
              prefixCls: prefixCls,
              disabled: _this.props.disabled,
              value: option,
              checked: _this.state.value === option
            }, option);
          } // 此处类型自动推导为 { label: string value: string }


          return React.createElement(_radio["default"], {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || _this.props.disabled,
            value: option.value,
            checked: _this.state.value === option.value
          }, option.label);
        });
      }

      return React.createElement("div", {
        className: classString,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        id: props.id
      }, children);
    };

    var value;

    if ('value' in props) {
      value = props.value;
    } else if ('defaultValue' in props) {
      value = props.defaultValue;
    } else {
      var checkedValue = getCheckedValue(props.children);
      value = checkedValue && checkedValue.value;
    }

    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        radioGroup: {
          onChange: this.onRadioChange,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      var checkedValue = getCheckedValue(nextProps.children);

      if (checkedValue) {
        return {
          value: checkedValue.value
        };
      }

      return null;
    }
  }]);

  return RadioGroup;
}(React.Component);

RadioGroup.defaultProps = {
  buttonStyle: 'outline'
};
RadioGroup.childContextTypes = {
  radioGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
var _default = RadioGroup;
exports["default"] = _default;
//# sourceMappingURL=group.js.map


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _radio = _interopRequireDefault(__webpack_require__(314));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RadioButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioButton).apply(this, arguments));

    _this.renderRadioButton = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          radioProps = __rest(_a, ["prefixCls"]);

      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);

      if (_this.context.radioGroup) {
        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
      }

      return React.createElement(_radio["default"], _extends({
        prefixCls: prefixCls
      }, radioProps));
    };

    return _this;
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton);
    }
  }]);

  return RadioButton;
}(React.Component);

exports["default"] = RadioButton;
RadioButton.contextTypes = {
  radioGroup: PropTypes.any
};
//# sourceMappingURL=radioButton.js.map


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "INFORMATION AND CONSENT FORM ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject DeferredConsent Form)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Title of Study", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor-Investigator/Funder:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Bijoy Menon"), ", CIHR (Canadian Institutes of Health Research)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "SITE INVESTIGATOR:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Brian Buck(patient electronic text)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Coordinating Centre:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "The Governors of the University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve.Please ask if you would like more detail about something mentioned here, or information not included here. Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Why is this Study being done?"), " You were enrolled as a participant in this study because you had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you were incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.You are now being asked to provide your consent to continue to take part in the study. You will be told which medication you received after the treatment is completed, and also during this consent process.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will happen if I take part in this study?"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If you are interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study will be complete.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "How many people will take part in this study?"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " Up to 1600 people at hospitals in Canada will participate in this study. Approximately 300 people will take part in this study at the University of Alberta Hospital."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Are there any potential risks or discomforts that I can expect from this study?", " "), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "5. The risk to an unborn child is uncertain. If you are pregnant, you have been enrolled into this study after an in-depth consultation with an expert stroke physician. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "6. Baseline and 24-hourCT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Are there any potential benefits if I participate?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you agree to participate in this study,there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What if researchers discover something about me?"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care.These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will my information and participation be kept confidential?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "During the study,we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.Your name, telephone number and/or email,will be provided to the AcT Coordinating Centre located at theUniversity of Calgary/Foothills Medical Centre, to contact you for conducting the telephone assessment required as part of this study. An additional contact person will be requested, as a back-up contact, for the Day 90-120-day telephone follow-up. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Alberta Hospitaland the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records,including Netcare, the QuICR/OPTIMISE registries, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely storeyour health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial isavailable on", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results.You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "If I suffer a research-related injury, will I be compensated?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "In the event that you suffer injury because of participating in this research, the University ofCalgary, University of Alberta, Alberta Health Services, or the Researchers will provide no compensation for you. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will I be paid for participating, or do I have to pay for anything?", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone.If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "INFORMATION AND CONSENT FORM ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject DeferredConsent Form)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Title of Study", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor-Investigator/Funder:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Bijoy Menon"), ", CIHR (Canadian Institutes of Health Research)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "SITE INVESTIGATOR:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Brian Buck(step electronic text)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Coordinating Centre:"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "The Governors of the University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This consent form is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve.Please ask if you would like more detail about something mentioned here, or information not included here. Take the time to read this carefully and to understand any accompanying information. You will receive a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Why is this Study being done?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cthe patient\u201D throughout this consent form refers to that individual. Your obligation is to try to determine what the patient would do if competent, or if the patient\u2019s wishes cannot be determined, what you think is in their best interest."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The patient was enrolled as a participant in this study because they had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite thebenefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplasewith Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and the patient was incapacitated at the time of their stroke. The patient was enrolled by deferral of consent, meaning that they received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by this hospital\u2019s research ethics board.You are now being asked to provide your consent for the patient to continue to take part in the study. You will be told which medication the patient received after the treatment is completed, and also during this consent process."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will happen if I decide for the patient take part in this study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you consent for the patient to participate in this study, regular standard of care assessments will be performed, including routine follow up with their treating physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The interview will last about 5 minutes. You,or the patient, will be called one time at 3 months(as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If the patient is interested, we will also ask the patient to complete an online assessment. The purpose of the assessment is to find out any differences in memory or thinking between the groups of people who received the two drugs. The patient does not have to complete this online assessment to be part of the main study. After the 3-month assessment (phone call and online assessment) is finished, their participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "How many people will take part in this study?"), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " Up to 1600 people at hospitals in Canada will participate in this study. Approximately 300 people will take part in this study at the University of Alberta Hospital."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Are there any potential risks or discomforts that I can expect from this study?", " "), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks below may occur within the first 24 hours after receiving the medication. After 24 hours, the risk is minimal:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "5. The risk to an unborn child is uncertain. If you are pregnant, you have been enrolled into this study after an in-depth consultation with an expert stroke physician. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "6. Baseline and 24-hourCT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Are there any potential benefits if the patient participates?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you agree to participate in this study,there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What if researchers discover something about the patient? "), " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "During the study, the researchers could learn something about you that they did not expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care.These findings may affect your willingness to be contacted for a telephone follow-up between Day 90-120."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will the patient\u2019s information and participation be kept confidential?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "During the study,we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.Your name, telephone number and/or email,will be provided to the AcT Coordinating Centre located at theUniversity of Calgary/Foothills Medical Centre, to contact you for conducting the telephone assessment required as part of this study. An additional contact person will be requested, as a back-up contact, for the Day 90-120-day telephone follow-up. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Alberta Hospitaland the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records,including Netcare, the QuICR/OPTIMISE registries, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial isavailable on", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results.You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "If the patient suffers a research-related injury, will they be compensated?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "In the event that you suffer injury because of participating in this research, the University ofCalgary, University of Alberta, Alberta Health Services, or the Researchers will provide no compensation for you. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will I be paid for participating, or do I have to pay for anything?", " "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not be paid for your participation in this research study. There will be no medical costs to you for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone.If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(315);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'REGAINED CAPACITY CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'center' } }, 'Dr.Brian Buck(780) 248-1927 ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' or ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' the Stroke Research office (780) 407-4366'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Witness\u2019 Name (If applicable)"), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentType2__contentWrap__2sJ8l"};

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeSunnybrook_ConsentForm__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentSunnyBrookByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeSunnybrook_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeSunnybrook_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentSunnyBrookByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createSunnyBrook(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(316);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: true, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.')))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' }))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h3', null, 'DEFERRAL OF CONSENT SUB-STUDY'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "We\u2019d like to ask you a few survey questions about how you feel about this study and having been a part of it. The purpose of the survey is to capture the attitudes and experience of participants/SDMs with the deferral of consent process used in the study. This survey is optional. You do not have to take part in the survey to be a part of the main study."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dcss_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'yes' }, 'I wish to take part in the survey.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'no' }, 'I wish NOT to take part in the survey.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'not_applicable' }, 'Not applicable (site is not participating in the ethics survey)'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1247);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: -0.09em;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: middle;\n  outline: none;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #4CDEF5;\n}\n.ant-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #4CDEF5;\n  border-radius: 2px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-checkbox:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox::after {\n  visibility: visible;\n}\n.ant-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 22%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-checkbox-checked .ant-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #4CDEF5;\n  border-color: #4CDEF5;\n}\n.ant-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-checkbox-disabled .ant-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-checkbox-disabled .ant-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-wrapper + .ant-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-checkbox-group-item {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-checkbox-group-item + .ant-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #4CDEF5;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n", ""]);

// exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _reactLifecyclesCompat = __webpack_require__(38);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _Checkbox = _interopRequireDefault(__webpack_require__(504));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));

    _this.cancelValue = function (value) {
      _this.setState(function (_ref) {
        var registeredValues = _ref.registeredValues;
        return {
          registeredValues: registeredValues.filter(function (val) {
            return val !== value;
          })
        };
      });
    };

    _this.registerValue = function (value) {
      _this.setState(function (_ref2) {
        var registeredValues = _ref2.registeredValues;
        return {
          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
        };
      });
    };

    _this.toggleOption = function (option) {
      var registeredValues = _this.state.registeredValues;

      var optionIndex = _this.state.value.indexOf(option.value);

      var value = _toConsumableArray(_this.state.value);

      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        var options = _this.getOptions();

        onChange(value.filter(function (val) {
          return registeredValues.indexOf(val) !== -1;
        }).sort(function (a, b) {
          var indexA = options.findIndex(function (opt) {
            return opt.value === a;
          });
          var indexB = options.findIndex(function (opt) {
            return opt.value === b;
          });
          return indexA - indexB;
        }));
      }
    };

    _this.renderGroup = function (_ref3) {
      var getPrefixCls = _ref3.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          style = props.style,
          options = props.options,
          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);

      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
      var children = props.children;

      if (options && options.length > 0) {
        children = _this.getOptions().map(function (option) {
          return React.createElement(_Checkbox["default"], {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : props.disabled,
            value: option.value,
            checked: state.value.indexOf(option.value) !== -1,
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item")
          }, option.label);
        });
      }

      var classString = (0, _classnames["default"])(groupPrefixCls, className);
      return React.createElement("div", _extends({
        className: classString,
        style: style
      }, domProps), children);
    };

    _this.state = {
      value: props.value || props.defaultValue || [],
      registeredValues: []
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        checkboxGroup: {
          toggleOption: this.toggleOption,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name,
          // https://github.com/ant-design/ant-design/issues/16376
          registerValue: this.registerValue,
          cancelValue: this.cancelValue
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960

      return options.map(function (option) {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option
          };
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value || []
        };
      }

      return null;
    }
  }]);

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.defaultProps = {
  options: []
};
CheckboxGroup.propTypes = {
  defaultValue: PropTypes.array,
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func
};
CheckboxGroup.childContextTypes = {
  checkboxGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
var _default = CheckboxGroup;
exports["default"] = _default;
//# sourceMappingURL=Group.js.map


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'Informed Consent Form for Participation in a Research Study: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Doctor: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dr. Houman Khosravani', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Department of Neurology', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '(416)-480-6100 ext. 3669'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Sponsor/Funder(s):'), '  University of Calgary'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Emergency Contact Number (24 hours / 7 days a week):'), ' Dr. Houman Khosravani, (647)-444-5201'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION SHEET: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Doctor: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dr. Houman Khosravani', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Department of Neurology', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '(416)-480-6100 ext. 3669'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Sponsor/Funder(s):'), '  University of Calgary'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Emergency Contact Number (24 hours / 7 days a week):'), ' Dr. Houman Khosravani, (647)-444-5201'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(316);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeSunnybrook__contentWrap__3IVtB"};

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeTorontoUH_ConsentForm__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentTorontoUHByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, has_randomization_platform_step_3_patient: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'has_randomization_platform_step_3_patient') || undefined, randomization_platform_step_3_patient_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'randomization_platform_step_3_patient_content') || undefined, has_randomization_platform_step_3_patient_regained_capacity: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'has_randomization_platform_step_3_patient_regained_capacity') || undefined, randomization_platform_step_3_patient_regained_capacity_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'randomization_platform_step_3_patient_regained_capacity_content') || undefined, has_randomization_platform_step_3_surrogate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'has_randomization_platform_step_3_surrogate') || undefined, randomization_platform_step_3_surrogate_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'randomization_platform_step_3_surrogate_content') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeTorontoUH_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeTorontoUH_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentTorontoUHByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createTorontoUH(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(317);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === "Email" && !props.token);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h4", null, props.consentPersonType === "Surrogate" ? "Consent Process - Surrogate" : "Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-group-details" }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("b", null, props.subjectID))), props.consentPersonType === "Surrogate" ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h4", null, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { style: { textAlign: "left" } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("sb_dic_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to stay in the study."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.")))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h4", null, "SIGNATURES"), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "All of my questions have been answered,"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "I understand the information within this informed consent form,", " ", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), "I allow access to medical records and related personal health information as explained in this consent form,", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), "I do not give up any legal rights by signing this consent form,", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), "I understand that my family doctor/health care provider will be informed of study participation", __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), "I agree, or agree to allow the person I am responsible for, to take part in this study."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Participant Name"), props.form.getFieldDecorator("sb_dic_research_subject_name", { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant Name" })))), props.consentMethodType === "Email" && props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision Maker"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the SDM's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: "Substitute Decision Maker Email" })))), props.consentMethodType === "Email" && props.consentPersonType === "Patient" && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), props.consentPersonType === "Patient" && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: "sb_dic_research_subject_signature", label: "Signature of Participant", form: props.form })), props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision-Maker Name"), props.form.getFieldDecorator("sb_dic_surrogate_name", { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Substitute Decision-Maker Name" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: "sb_dic_surrogate_signature", label: "Signature of Substitute Decision-Maker", form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Person Conducting the Consent Discussion Name & Role"), props.form.getFieldDecorator("sb_dic_investigator_name_and_role", { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name & Role" })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: "sb_dic_investigator_signature", label: "Signature of Person Conducting the Consent Discussion", form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "The following attestation must be provided if the participant is unable to read or requires an oral translation:"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("b", null, "If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:")), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator("sb_dic_is_interpreter", { initialValue: false, valuePropName: "checked" })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process."))), props.form.getFieldValue("sb_dic_is_interpreter") && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Interpreter Name"), props.form.getFieldDecorator("sb_dic_interpreter_name", { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Interpreter Name" })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: "sb_dic_interpreter_signature", label: "Signature of Interpreter", form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Interpreter Language"), props.form.getFieldDecorator("sb_dic_interpreter_language", { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: "Interpreter Language" })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator("sb_dic_interpreter_was_read", { initialValue: false, valuePropName: "checked", rules: [{ required: true, transform: function transform(value) {
            return value || undefined;
          }, type: "boolean", message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Witness Name"), props.form.getFieldDecorator("sb_dic_witness_name", { initialValue: props.sb_dic_witness_name, rules: [{ required: false, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Witness Name" })))), props.form.getFieldValue("sb_dic_witness_name") && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: "sb_dic_witness_signature", label: "Signature of Witness", form: props.form, optional: false }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Relationship to Participant"), props.form.getFieldDecorator("sb_dic_witness_relationship", { initialValue: props.sb_dic_witness_relationship, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: "Relationship to Participant" })))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: "" }, "No"))))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, 'Consent template not loaded'));
});

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, 'Consent template not loaded'));
});

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(317);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeTorontoUH__contentWrap__15kVG"};

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeOttawa_ConsentForm__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentOttawaByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeOttawa_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeOttawa_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentOttawaByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createOttawa(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(318);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === 'Email';var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' }))))), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: false, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.'))), !isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' }))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h3', null, 'DEFERRAL OF CONSENT SUB-STUDY'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "We\u2019d like to ask you a few survey questions about how you feel about this study and having been a part of it. The purpose of the survey is to capture the attitudes and experience of participants/SDMs with the deferral of consent process used in the study. This survey is optional. You do not have to take part in the survey to be a part of the main study."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dcss_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'yes' }, 'I wish to take part in the survey.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'no' }, 'I wish NOT to take part in the survey.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'not_applicable' }, 'Not applicable (site is not participating in the ethics survey)'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'Informed Consent Form for Participation in a Research Study: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Doctor: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Sponsor/Funder(s):'), '  University of Calgary'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Emergency Contact Number (24 hours / 7 days a week):'), ' 613-761-4709'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION SHEET: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Doctor: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Sponsor/Funder(s):'), '  University of Calgary'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Emergency Contact Number (24 hours / 7 days a week):'), ' 613-761-4709 '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(318);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeOttawa__contentWrap__1T1dg"};

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeRoyal_ConsentForm__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentRoyalByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyal_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeRoyal_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentRoyalByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createRoyal(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(319);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === 'Email';var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You may withdraw your participation at any time without giving reasons. Withdrawing from further participation has no effect on how you will be treated by the doctors currently providing care. If you choose to participate and then decide to withdraw at a later time, all data collected prior to your withdrawal of consent will be retained for the database. It is a legal requirement that these data cannot be destroyed for Health Canada regulated research only.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Site PI: Dr. George Medvedev 604-759-2140'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Study Coordinator: Vishaya Naidoo 778-865-4586'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Fraser Health Research Ethics Board co-Chair by calling 604-587-4681.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Participant\u2019s Name/Legally Authorized Representative"), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Participant\u2019s Name/Legally Authorized Representative" })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant/Legally Authorized Representative', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s"), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name and Relationship'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('sb_dic_witness_name') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'Informed Consent Form for Participation in a Research Study: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR(Quality  Improvement & Clinical Research) & OPTIMISE Registry based Pragmatic'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Randomized Controlled  Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SPONSOR-INVESTIGATOR: '), '  Dr. Bijoy Menon, University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SITE INVESTIGATOR:'), ' Dr. George Medvedev  ph.604-759-2140'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION SHEET: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR(Quality  Improvement & Clinical Research) & OPTIMISE Registry based Pragmatic'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Randomized Controlled  Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SPONSOR-INVESTIGATOR: '), '  Dr. Bijoy Menon, University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SITE INVESTIGATOR:'), ' Dr. George Medvedev  ph.604-759-2140'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(319);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'REGAINED CAPACITY CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Dr. George Medvedev 604-759-2140'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Fraser Health Research Ethics Board co-Chair by calling 604-587-4681.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name and Relationship'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Fraser Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeRoyal__contentWrap__1sinN"};

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeRoyalUniversity_ConsentForm__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentRoyalUniversityByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeRoyalUniversity_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeRoyalUniversity_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined, sb_dic_surrogate_name_not_applicable: undefined, witness_not_applicable: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentRoyalUniversityByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createRoyalUniversity(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(320);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === 'Email';var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You may withdraw your participation at any time without giving reasons. Withdrawing from further participation has no effect on how you will be treated by the doctors currently providing care. If you choose to participate and then decide to withdraw at a later time, all data collected prior to your withdrawal of consent will be retained for the database. It is a legal requirement that these data cannot be destroyed for Health Canada regulated research only.')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Site PI: Dr. George Medvedev 604-759-2140'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Study Coordinator: Vishaya Naidoo 778-865-4586'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Fraser Health Research Ethics Board co-Chair by calling 604-587-4681.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "Participant\u2019s Name"), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: false, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Participant\u2019s Name" })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'Incapacitated participants who have the capability of understanding their diagnosis and consequences of the diagnosis have had the study and treatment explained to them, in the presence of their authorized representative or an impartial witness. Consent, was obtained from the authorized representative and verbal assent was obtained from the incapacitated participant.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('assent_not_applicable', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'Assent not applicable')))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('assent_verbally_obtained', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'Assent verbally obtained'))))), props.consentPersonType === 'Patient' && showForEmail && !(props.form.getFieldValue('assent_not_applicable') || props.form.getFieldValue('assent_verbally_obtained')) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, !props.form.getFieldValue('sb_dic_surrogate_name_not_applicable') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Authorized Representative Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Authorized Representative Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('sb_dic_surrogate_name_not_applicable', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'Authorized Representative Name is Not applicable')))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Authorized Representative Relationship to Participant'), props.form.getFieldDecorator('kw_representative_relationship_to_participant', { initialValue: props.kw_representative_relationship_to_participant })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Authorized Representative Relationship to Participant' })))), showForEmail && !(props.form.getFieldValue('assent_not_applicable') || props.form.getFieldValue('assent_verbally_obtained')) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Authorized Representative', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('i', null, "*An authorized representative in this study is the person who has the authority to make a decision about participation in the study on behalf of a participant who does not have the capacity to decide, as the participant\u2019s parent or guardian or as someone who was entrusted by the participant to make such decision when the participant was competent. The authorized representative should make decisions according to the participant\u2019s wishes and best interests."))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Obtaining Consent Name'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Person Obtaining Consent Name Signature', form: props.form })), !props.token && !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Impartial Witness'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'This section is required only if the participant (or their authorized representative, as applicable) is unable to read or unable to write, or if remote consent is obtained from the Authorized Representative. An impartial witness may also be used in any other circumstance where the study personnel feel it would be beneficial.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The consent form was accurately explained to, and apparently understood by, the participant (or their authorized representative as applicable), and consent was freely given by the participant (or authorized representative as applicable).'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Impartial Witness'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('sb_dic_witness_name') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: false }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('i', null, "**Impartial Witness: A person, who is independent of the trial, who cannot be unfairly influenced by people involved with the trial, who attends the consent process if the participant or the participant\u2019s authorized representative cannot read/write, in the case of remote consent, or for any other reason where the study staff feels it is appropriate, and who reads the consent and any other written information supplied to the participant.")))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Contact Information for Study Results'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'To receive notification of the outcome of this study from the hospital and/or research site, please provide your name, as well as at least one of the following: mailing address, email address or phone number.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Mailing Address:'), props.form.getFieldDecorator('consent_participant_address', { initialValue: props.consent_participant_address, rules: [{ required: !(props.form.getFieldValue('consent_participant_phone') || props.form.getFieldValue('consent_participant_email')), message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Mailing Address' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Email address:'), props.form.getFieldDecorator('consent_participant_email', { initialValue: props.consent_participant_email, rules: [{ required: !(props.form.getFieldValue('consent_participant_phone') || props.form.getFieldValue('consent_participant_address')), message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Email address' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Phone number:'), props.form.getFieldDecorator('consent_participant_phone', { initialValue: props.consent_participant_phone, rules: [{ required: !(props.form.getFieldValue('consent_participant_address') || props.form.getFieldValue('consent_participant_email')), message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Phone number' }))))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'Informed Consent Form for Participation in a Research Study: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR(Quality  Improvement & Clinical Research) & OPTIMISE Registry based Pragmatic'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Randomized Controlled  Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SPONSOR-INVESTIGATOR: '), '  Dr. Bijoy Menon, University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SITE INVESTIGATOR:'), ' Dr. George Medvedev  ph.604-759-2140'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION SHEET: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'Study Title:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR(Quality  Improvement & Clinical Research) & OPTIMISE Registry based Pragmatic'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Randomized Controlled  Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SPONSOR-INVESTIGATOR: '), '  Dr. Bijoy Menon, University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'SITE INVESTIGATOR:'), ' Dr. George Medvedev  ph.604-759-2140'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INTRODUCTION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself.  If the participant gains the capacity to consent for him/herself, your consent for them will end.  Throughout this form, \u201Cyou\u201D means the person you are representing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have.  All your questions should be answered to your satisfaction before you decide whether to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Taking part in this study is voluntary.  You have the option to not participate at all or you may choose to leave the study at any time.  Whatever you choose, it will not affect the usual medical care that you receive outside the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Please take your time in making your decision.  You may find it helpful to discuss it with your friends and family. '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IS THERE A CONFLICT OF INTEREST?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Sunnybrook Health Sciences Centre is receiving financial payment to cover the cost of conducting this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke.  Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHY IS THIS STUDY BEING DONE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT OTHER CHOICES ARE THERE?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in this study in order to receive treatment or care.  You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Blood thinners called antiplatelets which prevent\xA0blood\xA0cells called platelets from clumping'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Other research studies may be available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that about 1600 people will take part in this study, from research sites located in Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study should take 3 years to complete and the results should be known in about 3.5 years.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT WILL HAPPEN DURING THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ASSIGNMENT TO A GROUP')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have been "randomized" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told which group you are in.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE STUDY INTERVENTION?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 1 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Experimental intervention'), '): ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Tenecteplase (TNK)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Group 2 (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Non-Experimental/Standard Intervention'), '): Alteplase (tPA)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you choose to participate in this study, you will be expected to:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete a telephone interview 90-120 days after your stroke', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Complete memory and attention tests online', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function.  Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We are also interested in knowing more about how you feel about the consenting process we used to enroll you into this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We may ask you to complete a short survey with a member of the research team about your attitudes and experience with the deferral of consent process used in the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The survey will take approximately 5-10 minutes to complete and will be administered by a member of the research team either in person or by telephone. Your survey answers will be recorded using the secure Qualtrics online platform hosted at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You do not have to take part in the survey to be a part of the main study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW LONG WILL PARTICIPANTS BE IN THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study participation can last for up to 1 year.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study.  After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish.  '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason.  If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CAN PARTICIPATION IN THIS STUDY END EARLY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor may stop your participation in the study early, and without your consent, for reasons such as:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sponsor decides to stop the study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may experience side effects from participating in this study.  Some side effects are known and are listed below, but there may be other side effects that are not expected.  You should discuss these with the study doctor.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Less likely (5 \u2013 20%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Rarely (1 \u2013 4%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Very Rarely (< 1%):'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE REPRODUCTIVE RISKS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The University of Calgary, the Sponsor of this study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'This institution and affiliated sites, to oversee the conduct of research at this location'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Health Canada (because they oversee the use of drugs in Canada)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Information that is collected about you for the study (called study data) may also be sent to the organizations listed above.  Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study.  No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The following information will be transferred to the University of Calgary:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'First and last name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Date of treatment'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Telephone number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Email address'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Family Physician')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases.  CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart.A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WILL information about this study BE available online?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.clinicaltrials.gov' }, 'http://www.ClinicalTrials.gov'), ', as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT IS THE COST TO PARTICIPANTS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will not be paid for taking part in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You have the right to be informed of the results of this study once the entire study is complete.  The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will be given a copy of this signed and dated consent form prior to participating in this study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(320);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 ')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'REGAINED CAPACITY CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Dr. George Medvedev 604-759-2140'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Fraser Health Research Ethics Board co-Chair by calling 604-587-4681.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name and Relationship'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Fraser Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeRoyalUniversity__contentWrap__2FPOe"};

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeKelowna_ConsentForm__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentKelownaByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), kw_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_participant_email') || undefined, kw_rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_rccf_participant_email') || undefined, kw_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_consent_participant_name') || undefined, kw_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_consent_investigator_name') || undefined, kw_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_investigator_name') || undefined, kw_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.kw_representative_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeKelowna_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeKelowna_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_19__services__["c" /* consentServices */].confirmConsentKelownaByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_19__services__["c" /* consentServices */].createKelowna(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: 'Paper', rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(505);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('kw_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant\'s Name'), props.form.getFieldDecorator('kw_consent_participant_name', { initialValue: props.kw_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant\'s Name' })))), props.consentMethodType === 'Email' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('kw_participant_email', { initialValue: props.kw_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Dr. Aleksander Tkach 250-800-1196 or', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), 'Clinical Research Department 778-214-2065'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Interior Health Research Ethics Board Chair by calling 250-870-4602 or email researchethics@interiorhealth.ca.')), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'kw_consent_participant_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Legally Authorized'), props.form.getFieldDecorator('kw_representative_name', { initialValue: props.kw_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Legally Authorized' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('kw_representative_relationship_to_participant', { initialValue: props.kw_representative_relationship_to_participant, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'kw_representative_signature', label: 'Signature of Legally Authorized', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('kw_consent_investigator_name', { initialValue: props.kw_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'kw_consent_investigator_signature', label: 'Signature of Investigator/Delegate', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Interior Health Research Ethics Board has approved this research study.  A signed copy of this consent form has been given to you to keep for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { align: 'center' }, 'INFORMATION AND CONSENT FORM', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '(Subject Deferred Consent Form)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'TITLE:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'SPONSOR-INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Bijoy Menon, University of Calgary.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Funded by Canadian Institutes of Health Research (CIHR)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'SITE INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, ' Dr. Aleksander Tkach, Kelowna General Hospital')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cell# 1-250-800-1196, email: Aleksander.Tkach@interiorhealth.ca'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'PURPOSE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Your continued participation is voluntary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your continued participation is entirely voluntary and will not in any way affect the support or treatment you receive as a patient of the Interior Health physician or at the Kelowna General Hospital. You have the right to refuse to participate in this study. If you decide to participate, you may still choose to withdraw from the study at any time without any negative consequences to the medical care, education, or other services to which you are entitled or are presently receiving as a patient of Interior Health physicians or at the Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patientsIf you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.  The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment by phone is finished, your participation in the study will be complete.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that approximately 50-75 participants will be enrolled at Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'RISKS AND DISCOMFORTS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. The effects of bleeding into the brain may cause no symptoms at all, worsening of neurological symptoms, permanent disability, or death.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '5. The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'POSSIBLE BENEFITS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'NEW FINDINGS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'CONFIDENTIALITY'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private. The AcT Coordinating Centre at the University of Calgary is the main Canadian study site running this trial.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.  Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Interior Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital chart, electronic medical records, including CareConnect, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. The OPTIMISE Registry is a database that Canadian stroke centres use to enter information regarding stroke patients who receive thrombolysis to dissolve the clot causing their stroke, or endovascular treatment to remove the clot. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in the OPTIMISE or CIHI databases.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using a coded study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on http://www.ClinicalTrials.gov, and entering the AcT Study ID# NCT03889249, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'COMPENSATION FOR INJURY'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participation in this study, medical treatment will be provided at no additional cost to you. The costs of your medical treatment will be paid by your provincial medical plan. Financial compensation for such things as lost wages, disability or discomfort due to this type of injury is not routinely available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participating in this research, no compensation will be provided for you by the University of Calgary, Alberta Health Services, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'My signature on this consent form means:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\u25AA I have read and understood all 6 pages of this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I have been enrolled in the research study.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have had enough time to think about the information provided.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have been able to ask for advice if needed.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have been able to ask questions and have had satisfactory responses to my questions.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that all of the information collected will be kept confidential and that the results will only     be used for scientific purposes.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that my participation in this study is voluntary.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I am completely free at any time to refuse to participate or to withdraw from this study at any time, and that this will not change the quality of care that I receive.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I authorize access to my health records as described in this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I am not waiving any of my legal rights as a result of signing this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that there is no guarantee that this study will provide any benefits to me.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { align: 'center' }, 'INFORMATION AND CONSENT FORM', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '(Subject Deferred Consent Form)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'TITLE:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'SPONSOR-INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Bijoy Menon, University of Calgary.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Funded by Canadian Institutes of Health Research (CIHR)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'SITE INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, ' Dr. Aleksander Tkach, Kelowna General Hospital')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cell# 1-250-800-1196, email: Aleksander.Tkach@interiorhealth.ca'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'PURPOSE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Your continued participation is voluntary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your continued participation is entirely voluntary and will not in any way affect the support or treatment you receive as a patient of the Interior Health physician or at the Kelowna General Hospital. You have the right to refuse to participate in this study. If you decide to participate, you may still choose to withdraw from the study at any time without any negative consequences to the medical care, education, or other services to which you are entitled or are presently receiving as a patient of Interior Health physicians or at the Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patientsIf you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.  The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment by phone is finished, your participation in the study will be complete.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'It is anticipated that approximately 50-75 participants will be enrolled at Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'RISKS AND DISCOMFORTS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. The effects of bleeding into the brain may cause no symptoms at all, worsening of neurological symptoms, permanent disability, or death.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '5. The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'POSSIBLE BENEFITS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'NEW FINDINGS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'CONFIDENTIALITY'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private. The AcT Coordinating Centre at the University of Calgary is the main Canadian study site running this trial.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.  Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Interior Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital chart, electronic medical records, including CareConnect, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. The OPTIMISE Registry is a database that Canadian stroke centres use to enter information regarding stroke patients who receive thrombolysis to dissolve the clot causing their stroke, or endovascular treatment to remove the clot. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in the OPTIMISE or CIHI databases.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using a coded study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'A description of this clinical trial is available on http://www.ClinicalTrials.gov, and entering the AcT Study ID# NCT03889249, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'COMPENSATION FOR INJURY'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participation in this study, medical treatment will be provided at no additional cost to you. The costs of your medical treatment will be paid by your provincial medical plan. Financial compensation for such things as lost wages, disability or discomfort due to this type of injury is not routinely available.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participating in this research, no compensation will be provided for you by the University of Calgary, Alberta Health Services, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'My signature on this consent form means:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\u25AA I have read and understood all 6 pages of this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I have been enrolled in the research study.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have had enough time to think about the information provided.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have been able to ask for advice if needed.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I have been able to ask questions and have had satisfactory responses to my questions.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that all of the information collected will be kept confidential and that the results will only     be used for scientific purposes.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that my participation in this study is voluntary.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I am completely free at any time to refuse to participate or to withdraw from this study at any time, and that this will not change the quality of care that I receive.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I authorize access to my health records as described in this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that I am not waiving any of my legal rights as a result of signing this consent form.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u25AA I understand that there is no guarantee that this study will provide any benefits to me.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(505);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', { align: 'center' }, 'INFORMATION AND CONSENT FORM', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '(Subject Deferred Consent Form)'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('u', null, 'TITLE:')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('u', null, 'SPONSOR-INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Bijoy Menon, University of Calgary.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Funded by Canadian Institutes of Health Research (CIHR)'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('u', null, 'SITE INVESTIGATOR:')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, ' Dr. Aleksander Tkach, Kelowna General Hospital')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Cell# 1-250-800-1196, email: Aleksander.Tkach@interiorhealth.ca'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'PURPOSE'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject).  Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest.")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Your continued participation is voluntary')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your continued participation is entirely voluntary and will not in any way affect the support or treatment you receive as a patient of the Interior Health physician or at the Kelowna General Hospital. You have the right to refuse to participate in this study. If you decide to participate, you may still choose to withdraw from the study at any time without any negative consequences to the medical care, education, or other services to which you are entitled or are presently receiving as a patient of Interior Health physicians or at the Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TnK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.  The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule).'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment by phone is finished, your participation in the study will be complete.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'It is anticipated that approximately 50-75 participants will be enrolled at Kelowna General Hospital.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'RISKS AND DISCOMFORTS'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. The effects of bleeding into the brain may cause no symptoms at all, worsening of neurological symptoms, permanent disability, or death.', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '5. The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician.', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), '6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'POSSIBLE BENEFITS'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'NEW FINDINGS'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'CONFIDENTIALITY'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private. The AcT Coordinating Centre at the University of Calgary is the main Canadian study site running this trial.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.  Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Interior Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital chart, electronic medical records, including CareConnect, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. The OPTIMISE Registry is a database that Canadian stroke centres use to enter information regarding stroke patients who receive thrombolysis to dissolve the clot causing their stroke, or endovascular treatment to remove the clot. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in the OPTIMISE or CIHI databases.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using a coded study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'A description of this clinical trial is available on http://www.ClinicalTrials.gov, and entering the AcT Study ID# NCT03889249, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'COMPENSATION FOR INJURY'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participation in this study, medical treatment will be provided at no additional cost to you. The costs of your medical treatment will be paid by your provincial medical plan. Financial compensation for such things as lost wages, disability or discomfort due to this type of injury is not routinely available.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you become ill or physically injured as a result of participating in this research, no compensation will be provided for you by the University of Calgary, Alberta Health Services, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h3', null, 'CONSENT'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'My signature on this consent form means:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "\u25AA I have read and understood all 6 pages of this consent form.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that I have been enrolled in the research study.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I have had enough time to think about the information provided.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I have been able to ask for advice if needed.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I have been able to ask questions and have had satisfactory responses to my questions.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that all of the information collected will be kept confidential and that the results will only     be used for scientific purposes.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that my participation in this study is voluntary.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that I am completely free at any time to refuse to participate or to withdraw from this study at any time, and that this will not change the quality of care that I receive.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I authorize access to my health records as described in this consent form.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that I am not waiving any of my legal rights as a result of signing this consent form.", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), "\u25AA I understand that there is no guarantee that this study will provide any benefits to me.")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Please check the appropriate box to indicate your decision:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('kw_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('kw_consent_participant_name', { initialValue: props.kw_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('kw_participant_email', { initialValue: props.kw_rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Dr. Aleksander Tkach 250-800-1196 or', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), 'Clinical Research Department 778-214-2065'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Interior Health Research Ethics Board Chair by calling 250-870-4602 or email researchethics@interiorhealth.ca.')), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Legally Authorized'), props.form.getFieldDecorator('kw_representative_name', { initialValue: props.kw_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Legally Authorized' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('kw_representative_relationship_to_participant', { initialValue: props.kw_representative_relationship_to_participant, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'kw_representative_signature', label: 'Signature of Legally Authorized', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('kw_investigator_name', { initialValue: props.kw_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'kw_investigator_signature', label: 'Signature of Investigator', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, "Participant Consent for Continued Participation After a Legally Authorized Representative\u2019s Consent was Obtained"), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'kw_consent_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('kw_consent_investigator_name', { initialValue: props.kw_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'kw_consent_investigator_signature', label: 'Signature of Investigator', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Interior Health Research Ethics Board has approved this research study.  A signed copy of this consent form has been given to you to keep for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeKelowna__contentWrap__33bYb"};

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeMontreal_ConsentForm__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentMontrealByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), mtl_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_participant_name') || undefined, mtl_consent_attending_physician_name_and_contact: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_attending_physician_name_and_contact') || undefined, mtl_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_name') || undefined, mtl_consent_investigator_name_1: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_1') || undefined, mtl_consent_investigator_name_2: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_2') || undefined, mtl_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_investigator_name') || undefined, mtl_consent_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_email') || undefined, mtl_rccf_consent_witness_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_witness_name_and_relationship') || undefined, mtl_consent_representative_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name_and_relationship') || undefined, mtl_consent_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name') || undefined, has_randomization_platform_step_3_patient: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.has_randomization_platform_step_3_patient') || undefined, randomization_platform_step_3_patient_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.randomization_platform_step_3_patient_content') || undefined, has_randomization_platform_step_3_patient_regained_capacity: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.has_randomization_platform_step_3_patient_regained_capacity') || undefined, randomization_platform_step_3_patient_regained_capacity_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.randomization_platform_step_3_patient_regained_capacity_content') || undefined, has_randomization_platform_step_3_surrogate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.has_randomization_platform_step_3_surrogate') || undefined, randomization_platform_step_3_surrogate_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.randomization_platform_step_3_surrogate_content') || undefined, has_randomization_platform_step_3_withdraw: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.has_randomization_platform_step_3_withdraw') || undefined, randomization_platform_step_3_withdraw_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.randomization_platform_step_3_withdraw_content') || undefined, has_randomization_platform_step_3_deferred: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.has_randomization_platform_step_3_deferred') || undefined, randomization_platform_step_3_deferred_content: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.randomization_platform_step_3_deferred_content') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeMontreal_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeMontreal_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step2__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatient__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3b__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step4__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services__ = __webpack_require__(39);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Signature from "./Signature";
 // const { Option } = Select;
var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_11_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].confirmConsentMontrealByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].createMontreal(formData, file);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(506);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai pris connaissance du formulaire d\u2019information et de consentement. On m\u2019a expliqu\xE9 le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement. On a r\xE9pondu \xE0 mes questions et on m\u2019a laiss\xE9 le temps voulu pour prendre une d\xE9cision. Apr\xE8s r\xE9flexion, je consens \xE0 participer \xE0 ce projet de recherche aux conditions qui y sont \xE9nonc\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de recherche \xE0 avoir acc\xE8s \xE0 mon dossier m\xE9dical."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_authorize_investigator', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom et coordonn\xE9es du m\xE9decin traitant:'), props.form.getFieldDecorator('mtl_consent_attending_physician_name_and_contact', { initialValue: props.mtl_consent_attending_physician_name_and_contact, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom et coordonn\xE9es du m\xE9decin traitant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_participant_name', { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_participant_signature', label: 'Signature du/de la participant(e)', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DE LA PERSONNE QUI OBTIENT LE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au/\xE0 la participant(e) le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu aux questions qu\u2019il/elle m\u2019a pos\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_investigator_name_1', { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_1', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), !isEmail && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "SIGNATURE D\u2019UN T\xC9MOIN"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_has_witness', { rules: [{ initialValue: props.mtl_consent_has_witness || 'false', required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), props.form.getFieldValue('mtl_consent_has_witness') === 'true' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "La signature d\u2019un t\xE9moin est requise pour les raisons suivantes:"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_1', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Difficult\xE9 ou incapacit\xE9 \xE0 lire. La personne (t\xE9moin impartial) qui appose sa signature ci-dessous atteste qu\u2019on a lu le formulaire de consentement et qu\u2019on a expliqu\xE9 pr\xE9cis\xE9ment le projet au (\xE0 la) participant(e), qui semble l\u2019avoir compris.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_2', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Incompr\xE9hension de la langue du formulaire de consentement - La personne qui appose sa signature ci-dessous a fait fonction d\u2019interpr\xE8te pour le ou la participant(e) au cours du processus visant \xE0 obtenir le consentement.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es)'), props.form.getFieldDecorator('mtl_consent_witness_name', { initialValue: props.mtl_consent_witness_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_witness_signature', label: 'Signature du t\xE9moin', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('u', null, 'Veuillez noter:'))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Il faut consigner dans le dossier de recherche du (de la) participant(e), le cas \xE9ch\xE9ant, d\u2019autres renseignements sur l\u2019aide fournie au cours du processus visant \xE0 obtenir le consentement.")), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "APPROBATION PAR LE COMIT\xC9 D\u2019\xC9THIQUE DE LA RECHERCHE"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Le comit\xE9 d\u2019\xE9thique de la recherche du CHUM a approuv\xE9 le projet et assurera le suivi du projet pour les \xE9tablissements du r\xE9seau de la sant\xE9 et des services sociaux du Qu\xE9bec participants.")), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DU REPR\xC9SENTANT L\xC9GALEMENT AUTORIS\xC9'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature du repr\xE9sentant l\xE9galement autoris\xE9')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "\xC0titre de repr\xE9sentant l\xE9galement autoris\xE9, j\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "De plus, on m\u2019a inform\xE9 que si la personne que je repr\xE9sente redevient apte \xE0 consentir \xE0 ce projet par elle-m\xEAme, et si sa participation au projet de recherche est toujours en cours, elle sera aussi invit\xE9e \xE0 signer ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Apr\xE8s r\xE9flexion, j\u2019accepte que la personne que je repr\xE9sente participe \xE0 ce projet de recherche, conform\xE9ment aux conditions \xE9nonc\xE9es ci-dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der au dossier m\xE9dical de la personne que je repr\xE9sente pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "(Facultatif) J\u2019autorise le m\xE9decin de l\u2019\xE9tude \xE0 informer le ou les m\xE9decins traitants de la personne que je repr\xE9sente qu\u2019elle participe \xE0 cette \xE9tude:"), props.form.getFieldDecorator('mtl_consent_study_physician', { rules: [{ initialValue: props.mtl_consent_study_physician, required: false }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant /lien avec le repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name_and_relationship', { initialValue: props.mtl_consent_representative_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant /lien avec le repr\xE9sentant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name', { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du repr\xE9sentant' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_representative_signature', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au repr\xE9sentant l\xE9galement autoris\xE9 du participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom de la personne obtenant le consentement:'), props.form.getFieldDecorator('mtl_consent_investigator_name_2', { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom de la personne obtenant le consentement' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_2', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Yan Deschaintre', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Nicole ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), ' Dre Laura Gioia ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Gr\xE9gory Jacquin ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Alexandre Poppe ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dre C\xE9line Odier ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Christian Stapf', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologues')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUM.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUS au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUS pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUM au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Yan Deschaintre', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Nicole ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), ' Dre Laura Gioia ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Gr\xE9gory Jacquin ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Alexandre Poppe ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dre C\xE9line Odier ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Christian Stapf', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologues')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUM.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUM au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUM pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUM au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(506);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);var isEmail = props.consentMethodType === 'EmailRegainedCapacity';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURE DU PARTICIPANT REDEVENU APTE'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement et je comprends que mon repr\xE9sentant l\xE9galement autoris\xE9 a accept\xE9, en mon nom, que je participe \xE0 ce projet de recherche. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je consens \xE0 continuer \xE0 participer \xE0 ce projet de recherche conform\xE9ment aux conditions \xE9nonc\xE9es ci- dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der \xE0 mon dossier m\xE9dical pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant (patient):'), props.form.getFieldDecorator('mtl_rccf_consent_participant_name', { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant (patient)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_participant_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du t\xE9moin/lien avec le participant:'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du t\xE9moin/lien avec le participant' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Un t\xE9moin appose sa signature (i) en plus du patient si le consentement \xE9clair\xE9 est lu au patient, ou (ii) \xE0 la place du patient pour les patients qui sont l\xE9galement aptes \xE0 donner leur consentement, mais qui sont incapables de lire ou d\u2019\xE9crire (p. ex., la signature du t\xE9moin est appos\xE9e \xE0 c\xF4t\xE9 de l\u2019empreinte du pouce du patient)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_rccf_consent_investigator_name', { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_investigator_signature', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeMontreal__contentWrap__1PdIl"};

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeChus_ConsentForm__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentChusByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), mtl_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_participant_name') || undefined, mtl_consent_attending_physician_name_and_contact: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_attending_physician_name_and_contact') || undefined, mtl_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_name') || undefined, mtl_consent_investigator_name_1: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_1') || undefined, mtl_consent_investigator_name_2: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_2') || undefined, mtl_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_investigator_name') || undefined, mtl_consent_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_email') || undefined, mtl_rccf_consent_witness_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_witness_name_and_relationship') || undefined, mtl_consent_representative_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name_and_relationship') || undefined, mtl_consent_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeChus_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeChus_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step2__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatient__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3b__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step4__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services__ = __webpack_require__(39);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Signature from "./Signature";
 // const { Option } = Select;
var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_11_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].confirmConsentChusByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].createChus(formData, file);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 23;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 23:
                _this.setState({ loading: false });case 24:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(507);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai pris connaissance du formulaire d\u2019information et de consentement. On m\u2019a expliqu\xE9 le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement. On a r\xE9pondu \xE0 mes questions et on m\u2019a laiss\xE9 le temps voulu pour prendre une d\xE9cision. Apr\xE8s r\xE9flexion, je consens \xE0 participer \xE0 ce projet de recherche aux conditions qui y sont \xE9nonc\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de recherche \xE0 avoir acc\xE8s \xE0 mon dossier m\xE9dical."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_authorize_investigator', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom et coordonn\xE9es du m\xE9decin traitant:'), props.form.getFieldDecorator('mtl_consent_attending_physician_name_and_contact', { initialValue: props.mtl_consent_attending_physician_name_and_contact, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom et coordonn\xE9es du m\xE9decin traitant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_participant_name', { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_participant_signature', label: 'Signature du/de la participant(e)', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DE LA PERSONNE QUI OBTIENT LE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au/\xE0 la participant(e) le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu aux questions qu\u2019il/elle m\u2019a pos\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_investigator_name_1', { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_1', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), !isEmail && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "SIGNATURE D\u2019UN T\xC9MOIN"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, '\xA0'), props.form.getFieldDecorator('mtl_consent_has_witness', { rules: [{ initialValue: props.mtl_consent_has_witness || 'false', required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), props.form.getFieldValue('mtl_consent_has_witness') === 'true' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "La signature d\u2019un t\xE9moin est requise pour les raisons suivantes:"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_1', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Difficult\xE9 ou incapacit\xE9 \xE0 lire. La personne (t\xE9moin impartial) qui appose sa signature ci-dessous atteste qu\u2019on a lu le formulaire de consentement et qu\u2019on a expliqu\xE9 pr\xE9cis\xE9ment le projet au (\xE0 la) participant(e), qui semble l\u2019avoir compris.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_2', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Incompr\xE9hension de la langue du formulaire de consentement - La personne qui appose sa signature ci-dessous a fait fonction d\u2019interpr\xE8te pour le ou la participant(e) au cours du processus visant \xE0 obtenir le consentement.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es)'), props.form.getFieldDecorator('mtl_consent_witness_name', { initialValue: props.mtl_consent_witness_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_witness_signature', label: 'Signature du t\xE9moin', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('u', null, 'Veuillez noter:'))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Il faut consigner dans le dossier de recherche du (de la) participant(e), le cas \xE9ch\xE9ant, d\u2019autres renseignements sur l\u2019aide fournie au cours du processus visant \xE0 obtenir le consentement.")), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "APPROBATION PAR LE COMIT\xC9 D\u2019\xC9THIQUE DE LA RECHERCHE"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Le comit\xE9 d\u2019\xE9thique de la recherche du CHUM a approuv\xE9 le projet et assurera le suivi du projet pour les \xE9tablissements du r\xE9seau de la sant\xE9 et des services sociaux du Qu\xE9bec participants.")), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DU REPR\xC9SENTANT L\xC9GALEMENT AUTORIS\xC9'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature du repr\xE9sentant l\xE9galement autoris\xE9')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "\xC0titre de repr\xE9sentant l\xE9galement autoris\xE9, j\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "De plus, on m\u2019a inform\xE9 que si la personne que je repr\xE9sente redevient apte \xE0 consentir \xE0 ce projet par elle-m\xEAme, et si sa participation au projet de recherche est toujours en cours, elle sera aussi invit\xE9e \xE0 signer ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Apr\xE8s r\xE9flexion, j\u2019accepte que la personne que je repr\xE9sente participe \xE0 ce projet de recherche, conform\xE9ment aux conditions \xE9nonc\xE9es ci-dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der au dossier m\xE9dical de la personne que je repr\xE9sente pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "(Facultatif) J\u2019autorise le m\xE9decin de l\u2019\xE9tude \xE0 informer le ou les m\xE9decins traitants de la personne que je repr\xE9sente qu\u2019elle participe \xE0 cette \xE9tude:"), props.form.getFieldDecorator('mtl_consent_study_physician', { rules: [{ initialValue: props.mtl_consent_study_physician, required: false }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant /lien avec le repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name_and_relationship', { initialValue: props.mtl_consent_representative_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant /lien avec le repr\xE9sentant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name', { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du repr\xE9sentant' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_representative_signature', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au repr\xE9sentant l\xE9galement autoris\xE9 du participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom de la personne obtenant le consentement:'), props.form.getFieldDecorator('mtl_consent_investigator_name_2', { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom de la personne obtenant le consentement' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_2', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Fran\xE7ois Moreau', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Sylvie Moreau', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUS.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUS au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUS pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUS au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Fran\xE7ois Moreau', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUS'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Sylvie Moreau', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUS.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUS au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUS pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUS au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(507);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);var isEmail = props.consentMethodType === 'EmailRegainedCapacity';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Version 2.1(2020-12-10)')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURE DU PARTICIPANT REDEVENU APTE'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement et je comprends que mon repr\xE9sentant l\xE9galement autoris\xE9 a accept\xE9, en mon nom, que je participe \xE0 ce projet de recherche. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je consens \xE0 continuer \xE0 participer \xE0 ce projet de recherche conform\xE9ment aux conditions \xE9nonc\xE9es ci- dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der \xE0 mon dossier m\xE9dical pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant (patient):'), props.form.getFieldDecorator('mtl_rccf_consent_participant_name', { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant (patient)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_participant_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du t\xE9moin/lien avec le participant:'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du t\xE9moin/lien avec le participant' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Un t\xE9moin appose sa signature (i) en plus du patient si le consentement \xE9clair\xE9 est lu au patient, ou (ii) \xE0 la place du patient pour les patients qui sont l\xE9galement aptes \xE0 donner leur consentement, mais qui sont incapables de lire ou d\u2019\xE9crire (p. ex., la signature du t\xE9moin est appos\xE9e \xE0 c\xF4t\xE9 de l\u2019empreinte du pouce du patient)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_rccf_consent_investigator_name', { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_investigator_signature', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeChus__contentWrap__13mks"};

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeQuebecChu_ConsentForm__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentQuebecChuByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), mtl_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_participant_name') || undefined, mtl_consent_attending_physician_name_and_contact: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_attending_physician_name_and_contact') || undefined, mtl_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_name') || undefined, mtl_consent_investigator_name_1: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_1') || undefined, mtl_consent_investigator_name_2: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_2') || undefined, mtl_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_investigator_name') || undefined, mtl_consent_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_email') || undefined, mtl_rccf_consent_witness_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_witness_name_and_relationship') || undefined, mtl_consent_representative_name_and_relationship: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name_and_relationship') || undefined, mtl_consent_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeQuebecChu_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeQuebecChu_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step2__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatient__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3b__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step4__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services__ = __webpack_require__(39);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Signature from "./Signature";
 // const { Option } = Select;
var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_11_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].confirmConsentQuebecChuByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].createQuebecChu(formData, file);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 23;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 23:
                _this.setState({ loading: false });case 24:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(508);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai pris connaissance du formulaire d\u2019information et de consentement. On m\u2019a expliqu\xE9 le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement. On a r\xE9pondu \xE0 mes questions et on m\u2019a laiss\xE9 le temps voulu pour prendre une d\xE9cision. Apr\xE8s r\xE9flexion, je consens \xE0 participer \xE0 ce projet de recherche aux conditions qui y sont \xE9nonc\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de recherche \xE0 avoir acc\xE8s \xE0 mon dossier m\xE9dical."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_authorize_investigator', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom et coordonn\xE9es du m\xE9decin traitant:'), props.form.getFieldDecorator('mtl_consent_attending_physician_name_and_contact', { initialValue: props.mtl_consent_attending_physician_name_and_contact, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom et coordonn\xE9es du m\xE9decin traitant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_participant_name', { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_participant_signature', label: 'Signature du/de la participant(e)', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DE LA PERSONNE QUI OBTIENT LE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au/\xE0 la participant(e) le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu aux questions qu\u2019il/elle m\u2019a pos\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_investigator_name_1', { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_1', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), !isEmail && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "SIGNATURE D\u2019UN T\xC9MOIN"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, '\xA0'), props.form.getFieldDecorator('mtl_consent_has_witness', { rules: [{ initialValue: props.mtl_consent_has_witness || 'false', required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), props.form.getFieldValue('mtl_consent_has_witness') === 'true' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "La signature d\u2019un t\xE9moin est requise pour les raisons suivantes:"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_1', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Difficult\xE9 ou incapacit\xE9 \xE0 lire. La personne (t\xE9moin impartial) qui appose sa signature ci-dessous atteste qu\u2019on a lu le formulaire de consentement et qu\u2019on a expliqu\xE9 pr\xE9cis\xE9ment le projet au (\xE0 la) participant(e), qui semble l\u2019avoir compris.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_2', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Incompr\xE9hension de la langue du formulaire de consentement - La personne qui appose sa signature ci-dessous a fait fonction d\u2019interpr\xE8te pour le ou la participant(e) au cours du processus visant \xE0 obtenir le consentement.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es)'), props.form.getFieldDecorator('mtl_consent_witness_name', { initialValue: props.mtl_consent_witness_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_witness_signature', label: 'Signature du t\xE9moin', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('u', null, 'Veuillez noter:'))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Il faut consigner dans le dossier de recherche du (de la) participant(e), le cas \xE9ch\xE9ant, d\u2019autres renseignements sur l\u2019aide fournie au cours du processus visant \xE0 obtenir le consentement.")), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "APPROBATION PAR LE COMIT\xC9 D\u2019\xC9THIQUE DE LA RECHERCHE"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Le comit\xE9 d\u2019\xE9thique de la recherche du CHUM a approuv\xE9 le projet et assurera le suivi du projet pour les \xE9tablissements du r\xE9seau de la sant\xE9 et des services sociaux du Qu\xE9bec participants.")), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DU REPR\xC9SENTANT L\xC9GALEMENT AUTORIS\xC9'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature du repr\xE9sentant l\xE9galement autoris\xE9')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "\xC0titre de repr\xE9sentant l\xE9galement autoris\xE9, j\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "De plus, on m\u2019a inform\xE9 que si la personne que je repr\xE9sente redevient apte \xE0 consentir \xE0 ce projet par elle-m\xEAme, et si sa participation au projet de recherche est toujours en cours, elle sera aussi invit\xE9e \xE0 signer ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Apr\xE8s r\xE9flexion, j\u2019accepte que la personne que je repr\xE9sente participe \xE0 ce projet de recherche, conform\xE9ment aux conditions \xE9nonc\xE9es ci-dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der au dossier m\xE9dical de la personne que je repr\xE9sente pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "(Facultatif) J\u2019autorise le m\xE9decin de l\u2019\xE9tude \xE0 informer le ou les m\xE9decins traitants de la personne que je repr\xE9sente qu\u2019elle participe \xE0 cette \xE9tude:"), props.form.getFieldDecorator('mtl_consent_study_physician', { rules: [{ initialValue: props.mtl_consent_study_physician, required: false }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant /lien avec le repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name_and_relationship', { initialValue: props.mtl_consent_representative_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant /lien avec le repr\xE9sentant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name', { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du repr\xE9sentant' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_representative_signature', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au repr\xE9sentant l\xE9galement autoris\xE9 du participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom de la personne obtenant le consentement:'), props.form.getFieldDecorator('mtl_consent_investigator_name_2', { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom de la personne obtenant le consentement' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_2', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "100%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Titre du projet:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "L\u2019alt\xE9plase compar\xE9 au t\xE9nect\xE9plase chez des patients avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Chercheur responsable au CHUM:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Dre Marie-Christine Camden, Neurologue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Co-chercheurs au CHUM:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Dre Ariane Mackey", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dr Steve Verreault ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dre St\xE9phanie Gosselin-Lefebvre", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Neurologues")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Organisme Subventionnaire:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Universit\xE9 de Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Identifiant multicentrique:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "MP-20-2020-8866")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "No de projet au CHU de Qu\xE9bec-Universit\xE9 Laval:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "MEO-02-2021-5212")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { border: "1px solid white", padding: "15px" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Processus de consentement dans le contexte actuel de la pand\xE9mie\xA0de\xA0COVID-19"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Si le patient est apte\xA0\xE0 consentir:"), " consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Si le patient est inapte \xE0 consentir:"), " consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PR\xC9AMBULE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Nous sollicitons votre participation \xE0 un projet de recherche parce que vous souffrez d\u2019un accident vasculaire c\xE9r\xE9bral isch\xE9mique (AVC). Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les questions que vous jugerez utiles au chercheur responsable du projet ou aux autres membres du personnel affect\xE9 au projet de recherche et \xE0 leur demander de vous expliquer tout mot ou renseignement qui n\u2019est pas clair."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NATURE ET OBJECTIFS DU PROJET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d'un seul coup, par opposition \xE0 l'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l'alt\xE9plase en terme d'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 100 au CHU de Qu\xE9bec-Universit\xE9 Laval- H\xF4pital de l\u2019Enfant-J\xE9sus."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NATURE DE LA PARTICIPATION DEMAND\xC9E")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Groupe 1 (exp\xE9rimental):"), " Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d'un seul coup"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Groupe 2 (soins standard):"), " Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous.", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "D\xC9ROULEMENT DU PROJET / PROC\xC9DURES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Cette \xE9tude comportera 3 p\xE9riodes:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de traitement"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de suivi")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre des soins clinique usuels")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos ant\xE9c\xE9dents m\xE9dicaux"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos m\xE9dicaments"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de votre tension art\xE9rielle et de votre pouls"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2) P\xE9riode de traitement")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre de la recherche")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous recevrez l\u2019alt\xE9plase dans une veine ou"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous recevrez le t\xE9nect\xE9plase dans une veine")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "3) P\xE9riode de suivi")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dans le cadre des soins cliniques usuels"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Scanner c\xE9r\xE9bral (imagerie de votre cerveau)")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique(facultative) (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dans le cadre des soins cliniques usuels, le m\xE9decin traitant qui assurera votre suivi pourrait effectuer les \xE9valuations suivantes selon son jugement clinique (facultatives):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de votre \xE9tat de sant\xE9"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos m\xE9dicaments"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de la tension art\xE9rielle et de votre pouls"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre de la recherche, vous serez contact\xE9 par t\xE9l\xE9phone")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique\xA0:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "\xC9chelle Rankin."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence de l\u2019H\xF4pital de l\u2019enfant-J\xE9sus au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que l\u2019H\xF4pital de l\u2019enfant-J\xE9sus pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.", " ")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\xC0 noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "RISQUES ET INCONV\xC9NIENTS")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Fr\xE9quents (entre 1 et 5%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement au cerveau."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Ecchymoses (bleu sur la peau)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement de nez, des gencives et du site d\u2019injection"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Moins fr\xE9quents (entre 0% et 1%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement dans l\u2019urine"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Rares (entre 0% et 0.0001%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "AVANTAGES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CONFIDENTIALIT\xC9")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Pour assurer votre s\xE9curit\xE9, une mention de votre participation \xE0 ce projet de recherche sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\xC0 des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "POSSIBILIT\xC9 DE COMMERCIALISATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FINANCEMENT DU PROJET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "COMPENSATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "EN CAS DE PR\xC9JUDICE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez-vous en clinique est une visite standard pour tout patient avec AVC."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "AUTRES TRAITEMENTS POSSIBLES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "IDENTIFICATION DES PERSONNES-RESSOURCES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dre Marie-Christine Camden, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 418-649-5892, entre 8h00 et 16h00, du lundi au vendredi."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHU de Qu\xE9bec-Universit\xE9 Laval au 418-525-5312, par courriel \xE0 plaintes@chudequebec.ca ou en ligne \xE0 chudequebec.ca: formulaire de plainte ou d'insatisfaction.."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Une description de cette \xE9tude est disponible en anglais seulement sur", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", rel: "noopener noreferrer", target: "_blank" }, "http://www.ClinicalTrials.gov"), ". Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protocole v 1.6 (04 septembre 2019)", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " ICF version 3.0 dat\xE9 du 24 mars 2021", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " Utilisation autoris\xE9e CHU de Qu\xE9bec-Universit\xE9 Laval : 13 mai 2021"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "100%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Titre du projet:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "L\u2019alt\xE9plase compar\xE9 au t\xE9nect\xE9plase chez des patients avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Chercheur responsable au CHUM:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Dre Marie-Christine Camden, Neurologue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Co-chercheurs au CHUM:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Dre Ariane Mackey", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dr Steve Verreault ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dre St\xE9phanie Gosselin-Lefebvre", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Neurologues")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Organisme Subventionnaire:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Universit\xE9 de Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Identifiant multicentrique:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "MP-20-2020-8866")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "No de projet au CHU de Qu\xE9bec-Universit\xE9 Laval:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "MEO-02-2021-5212")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { border: "1px solid white", padding: "15px" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Processus de consentement dans le contexte actuel de la pand\xE9mie\xA0de\xA0COVID-19"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Si le patient est apte\xA0\xE0 consentir:"), " consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Si le patient est inapte \xE0 consentir:"), " consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PR\xC9AMBULE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Nous sollicitons votre participation \xE0 un projet de recherche parce que vous souffrez d\u2019un accident vasculaire c\xE9r\xE9bral isch\xE9mique (AVC). Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les questions que vous jugerez utiles au chercheur responsable du projet ou aux autres membres du personnel affect\xE9 au projet de recherche et \xE0 leur demander de vous expliquer tout mot ou renseignement qui n\u2019est pas clair."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NATURE ET OBJECTIFS DU PROJET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d'un seul coup, par opposition \xE0 l'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l'alt\xE9plase en terme d'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 100 au CHU de Qu\xE9bec-Universit\xE9 Laval- H\xF4pital de l\u2019Enfant-J\xE9sus."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "NATURE DE LA PARTICIPATION DEMAND\xC9E")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Groupe 1 (exp\xE9rimental):"), " Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d'un seul coup"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Groupe 2 (soins standard):"), " Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous.", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "D\xC9ROULEMENT DU PROJET / PROC\xC9DURES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Cette \xE9tude comportera 3 p\xE9riodes:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de traitement"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "la p\xE9riode de suivi")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre des soins clinique usuels")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos ant\xE9c\xE9dents m\xE9dicaux"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos m\xE9dicaments"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de votre tension art\xE9rielle et de votre pouls"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2) P\xE9riode de traitement")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre de la recherche")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous recevrez l\u2019alt\xE9plase dans une veine ou"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous recevrez le t\xE9nect\xE9plase dans une veine")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "3) P\xE9riode de suivi")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dans le cadre des soins cliniques usuels"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Scanner c\xE9r\xE9bral (imagerie de votre cerveau)")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\u2013\xA0\xA0\xA0\xA0Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique(facultative) (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dans le cadre des soins cliniques usuels, le m\xE9decin traitant qui assurera votre suivi pourrait effectuer les \xE9valuations suivantes selon son jugement clinique (facultatives):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de votre \xE9tat de sant\xE9"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Revue de vos m\xE9dicaments"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Prise de la tension art\xE9rielle et de votre pouls"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Dans le cadre de la recherche, vous serez contact\xE9 par t\xE9l\xE9phone")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique\xA0:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "\xC9chelle Rankin."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence de l\u2019H\xF4pital de l\u2019enfant-J\xE9sus au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que l\u2019H\xF4pital de l\u2019enfant-J\xE9sus pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.", " ")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\xC0 noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "RISQUES ET INCONV\xC9NIENTS")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Fr\xE9quents (entre 1 et 5%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement au cerveau."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Ecchymoses (bleu sur la peau)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement de nez, des gencives et du site d\u2019injection"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Moins fr\xE9quents (entre 0% et 1%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Saignement dans l\u2019urine"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Rares (entre 0% et 0.0001%)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "AVANTAGES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CONFIDENTIALIT\xC9")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Pour assurer votre s\xE9curit\xE9, une mention de votre participation \xE0 ce projet de recherche sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\xC0 des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "POSSIBILIT\xC9 DE COMMERCIALISATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FINANCEMENT DU PROJET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "COMPENSATION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "EN CAS DE PR\xC9JUDICE")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez-vous en clinique est une visite standard pour tout patient avec AVC."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "AUTRES TRAITEMENTS POSSIBLES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "IDENTIFICATION DES PERSONNES-RESSOURCES")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dre Marie-Christine Camden, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 418-649-5892, entre 8h00 et 16h00, du lundi au vendredi."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHU de Qu\xE9bec-Universit\xE9 Laval au 418-525-5312, par courriel \xE0 plaintes@chudequebec.ca ou en ligne \xE0 chudequebec.ca: formulaire de plainte ou d'insatisfaction.."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Une description de cette \xE9tude est disponible en anglais seulement sur", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", rel: "noopener noreferrer", target: "_blank" }, "http://www.ClinicalTrials.gov"), ". Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protocole v 1.6 (04 septembre 2019)", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " ICF version 3.0 dat\xE9 du 24 mars 2021", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " Utilisation autoris\xE9e CHU de Qu\xE9bec-Universit\xE9 Laval : 13 mai 2021"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(508);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);var isEmail = props.consentMethodType === 'EmailRegainedCapacity';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Protocole v 1.6 (04 septembre 2019)', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' ICF version 3.0 dat\xE9 du 24 mars 2021', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' Utilisation autoris\xE9e CHU de Qu\xE9bec-Universit\xE9 Laval : 13 mai 2021')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURE DU PARTICIPANT REDEVENU APTE'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement et je comprends que mon repr\xE9sentant l\xE9galement autoris\xE9 a accept\xE9, en mon nom, que je participe \xE0 ce projet de recherche. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je consens \xE0 continuer \xE0 participer \xE0 ce projet de recherche conform\xE9ment aux conditions \xE9nonc\xE9es ci- dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der \xE0 mon dossier m\xE9dical pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant (patient):'), props.form.getFieldDecorator('mtl_rccf_consent_participant_name', { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant (patient)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_participant_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du t\xE9moin/lien avec le participant:'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du t\xE9moin/lien avec le participant' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Un t\xE9moin appose sa signature (i) en plus du patient si le consentement \xE9clair\xE9 est lu au patient, ou (ii) \xE0 la place du patient pour les patients qui sont l\xE9galement aptes \xE0 donner leur consentement, mais qui sont incapables de lire ou d\u2019\xE9crire (p. ex., la signature du t\xE9moin est appos\xE9e \xE0 c\xF4t\xE9 de l\u2019empreinte du pouce du patient)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_rccf_consent_investigator_name', { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_investigator_signature', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeQuebecChu__contentWrap__3NcpE"};

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeWinnipeg_ConsentForm__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentWinnipegByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), wp_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_participant_email') || undefined, wp_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_consent_participant_name') || undefined, wp_consent_guardian_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_consent_guardian_name') || undefined, wp_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_consent_investigator_name') || undefined, wp_consent_investigator_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_consent_investigator_role') || undefined, wp_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_rccf_consent_participant_name') || undefined, wp_rccf_consent_guardian_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_rccf_consent_guardian_name') || undefined, wp_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_rccf_consent_investigator_name') || undefined, wp_rccf_consent_investigator_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wp_rccf_consent_investigator_role') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeWinnipeg_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeWinnipeg_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3aSubstudy__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step3b__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Step4__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Signature__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Patient_SubstudyElectronic': 'consent_patient_substudy_electronic', 'Patient_SubstudyPaper': 'consent_patient_substudy_paper', 'Patient_SubstudyEmail': 'consent_patient_substudy_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email', 'Surrogate_SubstudyElectronic': 'consent_surrogate_substudy_electronic', 'Surrogate_SubstudyPaper': 'consent_surrogate_substudy_paper', 'Surrogate_SubstudyEmail': 'consent_surrogate_substudy_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'SubstudyElectronic', 'EmailRegainedCapacity', 'SubstudyEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['Paper', 'SubstudyPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                console.log(_this.state);token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 5;if (!token) {
                  _context4.next = 14;break;
                }_context4.next = 9;return __WEBPACK_IMPORTED_MODULE_21__services__["c" /* consentServices */].confirmConsentWinnipegByToken(token, formData);case 9:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 19;break;case 14:
                _context4.next = 16;return __WEBPACK_IMPORTED_MODULE_21__services__["c" /* consentServices */].createWinnipeg(formData, file, fileDc, fileWithdraw);case 16:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 19:
                _context4.next = 25;break;case 21:
                _context4.prev = 21;_context4.t0 = _context4['catch'](5);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 25:
                _this.setState({ loading: false });case 26:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[5, 21]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['SubstudyElectronic', 'SubstudyEmail'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3aSubstudy__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'SubstudyElectronic' }, 'Substudy Electronic'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'SubstudyPaper' }, 'Substudy Paper'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'SubstudyEmail' }, 'Substudy Email'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__ = __webpack_require__(321);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), isSurrogate ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('wp_participant_email', { initialValue: props.wp_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('wp_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'I agree to being contacted in relation to this study'), props.form.getFieldDecorator('wp_participant_agree_being_contacted', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'false' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant printed name'), props.form.getFieldDecorator('wp_consent_participant_name', { initialValue: props.wp_consent_participant_name, rules: [{ required: true, message: 'Participant printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant printed name' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'wp_consent_participant_signature', label: 'Participant signature', form: props.form }), isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Legal guardian\u2019s printed name"), props.form.getFieldDecorator('wp_consent_guardian_name', { initialValue: props.wp_consent_guardian_name, rules: [{ required: true, message: 'Legal guardian’s printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Legal guardian\u2019s printed name" })))), isSurrogate && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'wp_consent_guardian_signature', label: 'Legal guardian\'s signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness printed name'), props.form.getFieldDecorator('wp_consent_witness_name', { initialValue: props.wp_consent_witness_name, rules: [{ required: true, message: 'Witness printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness printed name' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'wp_consent_witness_signature', label: 'Witness signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'I, the undersigned, have fully explained the relevant details of this research study to the participant named above and believe that the participant has understood and has knowingly given their consent.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Printed Name'), props.form.getFieldDecorator('wp_consent_investigator_name', { initialValue: props.wp_consent_investigator_name, rules: [{ required: true, message: 'Printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Printed Name' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Role in the study'), props.form.getFieldDecorator('wp_consent_investigator_role', { initialValue: props.wp_consent_investigator_role, rules: [{ required: true, message: 'Role in the study is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Role in the study' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: 'wp_consent_investigator_signature', label: 'Signature', form: props.form }), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__["a" /* default */], { fieldName: 'wp_participants_initial', label: 'Participants Initials', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "RESEARCH PARTICIPANT INFORMATION AND CONSENT FORM"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "(Participant Deferred Consent Form)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "100%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Title of Study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Protocol number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "AcT 01.6 Original Protocol")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Principal Investigator"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Jai Jai Shiva Shankar"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rady Faculty of Health Sciences", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Manitoba", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room 807K-JBRC/715 Mc Dermot Avenue", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Winnipeg, MB R3E 3P5", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: +1-431-373-4164", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Sponsor"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Bijoy Menon"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Center", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "1403 29th Street NW", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Calgary, AB, T2N 2T9")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Purpose of Study")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care but has shown very promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Risks and Discomforts")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about a 1 in 20 chance, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Possible Benefits")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "New Findings")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Confidentiality")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Manitoba Bannatyne Campus Research Ethics Boards, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, including EPR, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation for Injury")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Manitoba, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Questions"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "You are free to ask any questions that you may have about your treatment and your rights as a research participant. If any questions come up during or after the study or if you have a research-related injury, contact the study doctor and the study staff: Dr. Jai Jai Shiva Shankar at 1-431-373-4164.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "For questions about your rights as a research participant, you may contact The University of Manitoba Biomedical Research Ethics Board at (204) 789-3389.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Do not sign this consent form unless you have had a chance to ask questions and have received satisfactory answers to all of your questions.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Statement of Consent"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "I have read this consent form. I have had the opportunity to discuss this research study with Dr. Jai Jai Shiva Shankar and or his study staff. I have had my questions answered by them in language I understand. The risks and benefits have been explained to me. I believe that I have not been unduly influenced by any study team member to participate in the research study by any statement or implied statements. Any relationship (such as employee, student or family member) I may have with the study team has not affected my decision to participate. I understand that I will be given a copy of this consent form after signing it. I understand that my participation in this clinical trial is voluntary and that I may choose to withdraw at any time. I freely agree to participate in this research study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "I understand that information regarding my personal identity will be kept confidential, but that confidentiality is not guaranteed. I authorize the inspection of my medical records by Dr. Bijoy Menon, University of Calgary, the Food and Drug Administration, the Health Protection Branch, government agencies in other countries, and The University of Manitoba Biomedical Research Ethics Board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this consent form, I have not waived any of the legal rights that I have as a participant in a research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "RESEARCH PARTICIPANT INFORMATION AND CONSENT FORM"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "(Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "100%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Title of Study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Protocol number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "AcT 01.6 Original Protocol")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Principal Investigator"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Jai Jai Shiva Shankar"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rady Faculty of Health Sciences", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Manitoba", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room 807K-JBRC/715 Mc Dermot Avenue", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Winnipeg, MB R3E 3P5", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: +1-431-373-4164", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Sponsor"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Dr. Bijoy Menon"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Center", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "1403 29th Street NW", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Calgary, AB, T2N 2T9")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Purpose of Study")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject). Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care but has shown very promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Risks and Discomforts")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about a 1 in 20 chance, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Possible Benefits")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "New Findings")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Confidentiality")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Manitoba Bannatyne Campus Research Ethics Boards, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, including EPR, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation for Injury")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Manitoba, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Questions"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "You are free to ask any questions that you may have about your treatment and your rights as a research participant. If any questions come up during or after the study or if you have a research-related injury, contact the study doctor and the study staff: Dr. Jai Jai Shiva Shankar at 1-431-373-4164.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "For questions about your rights as a research participant, you may contact The University of Manitoba Biomedical Research Ethics Board at (204) 789-3389.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Do not sign this consent form unless you have had a chance to ask questions and have received satisfactory answers to all of your questions.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Statement of Consent"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "I have read this consent form. I have had the opportunity to discuss this research study with Dr. Jai Jai Shiva Shankar and or his study staff. I have had my questions answered by them in language I understand. The risks and benefits have been explained to me. I believe that I have not been unduly influenced by any study team member to participate in the research study by any statement or implied statements. Any relationship (such as employee, student or family member) I may have with the study team has not affected my decision to participate. I understand that I will be given a copy of this consent form after signing it. I understand that my participation in this clinical trial is voluntary and that I may choose to withdraw at any time. I freely agree to participate in this research study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "I understand that information regarding my personal identity will be kept confidential, but that confidentiality is not guaranteed. I authorize the inspection of my medical records by Dr. Bijoy Menon, University of Calgary, the Food and Drug Administration, the Health Protection Branch, government agencies in other countries, and The University of Manitoba Biomedical Research Ethics Board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this consent form, I have not waived any of the legal rights that I have as a participant in a research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SignatureTrimmed__ = __webpack_require__(321);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);var isEmail = props.consentMethodType === 'EmailRegainedCapacity';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation; you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage. ")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('wp_participant_email', { initialValue: props.wp_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('wp_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant printed name'), props.form.getFieldDecorator('wp_rccf_consent_participant_name', { initialValue: props.wp_rccf_consent_participant_name, rules: [{ required: true, message: 'Participant printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant printed name' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Legal guardian\u2019s printed name"), props.form.getFieldDecorator('wp_rccf_consent_guardian_name', { initialValue: props.wp_rccf_consent_guardian_name, rules: [{ required: true, message: 'Legal guardian’s printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Legal guardian\u2019s printed name" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'wp_rccf_consent_guardian_signature', label: 'Legal guardian\'s signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness printed name'), props.form.getFieldDecorator('wp_rccf_consent_witness_name', { initialValue: props.wp_rccf_consent_witness_name, rules: [{ required: true, message: 'Witness printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness printed name' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'wp_rccf_consent_witness_signature', label: 'Witness signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'I, the undersigned, have fully explained the relevant details of this research study to the participant named above and believe that the participant has understood and has knowingly given their consent.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Printed Name'), props.form.getFieldDecorator('wp_rccf_consent_investigator_name', { initialValue: props.wp_rccf_consent_investigator_name, rules: [{ required: true, message: 'Printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Printed Name' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Role in the study'), props.form.getFieldDecorator('wp_rccf_consent_investigator_role', { initialValue: props.wp_rccf_consent_investigator_role, rules: [{ required: true, message: 'Role in the study is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Role in the study' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'wp_rccf_consent_investigator_signature', label: 'Signature', form: props.form }), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SignatureTrimmed__["a" /* default */], { fieldName: 'wp_participants_initial', label: 'Participants Initials', form: props.form }), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_SubstudyText__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Signature__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SignatureTrimmed__ = __webpack_require__(321);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'SubstudyEmail' && !props.token);var isEmail = props.consentMethodType === 'SubstudyEmail';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - Substudy'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_SubstudyText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('wp_participant_email', { initialValue: props.wp_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'I agree to being contacted in relation to this study'), props.form.getFieldDecorator('wp_participant_agree_being_contacted', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'false' }, 'No'))))), isPatient && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant printed name'), props.form.getFieldDecorator('wp_consent_participant_name', { initialValue: props.wp_consent_participant_name, rules: [{ required: true, message: 'Participant printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant printed name' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Signature__["a" /* default */], { fieldName: 'wp_consent_participant_signature', label: 'Participant signature', form: props.form }), isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Legal guardian\u2019s printed name"), props.form.getFieldDecorator('wp_consent_guardian_name', { initialValue: props.wp_consent_guardian_name, rules: [{ required: true, message: 'Legal guardian’s printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Legal guardian\u2019s printed name" })))), isSurrogate && !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Signature__["a" /* default */], { fieldName: 'wp_consent_guardian_signature', label: 'Legal guardian\'s signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness printed name'), props.form.getFieldDecorator('wp_consent_witness_name', { initialValue: props.wp_consent_witness_name, rules: [{ required: true, message: 'Witness printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness printed name' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Signature__["a" /* default */], { fieldName: 'wp_consent_witness_signature', label: 'Witness signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'I, the undersigned, have fully explained the relevant details of this research study to the participant named above and believe that the participant has understood and has knowingly given their consent.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Printed Name'), props.form.getFieldDecorator('wp_consent_investigator_name', { initialValue: props.wp_consent_investigator_name, rules: [{ required: true, message: 'Printed name is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Printed Name' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Role in the study'), props.form.getFieldDecorator('wp_consent_investigator_role', { initialValue: props.wp_consent_investigator_role, rules: [{ required: true, message: 'Role in the study is required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Role in the study' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Signature__["a" /* default */], { fieldName: 'wp_consent_investigator_signature', label: 'Signature', form: props.form }), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SignatureTrimmed__["a" /* default */], { fieldName: 'wp_participants_initial', label: 'Participants Initials', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.randomization_platform_step_3_withdraw_content ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_withdraw_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'RESEARCH PARTICIPANT INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, '(Participant Information and Consent for Sub Study Survey)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Title of Study'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Protocol number'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'AcT 01.6 Original Protocol')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Principal Investigator'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Jai Jai Shiva Shankar'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Rady Faculty of Health Sciences', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'University of Manitoba', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Room 807K-JBRC/715 Mc Dermot Avenue', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Winnipeg, MB R3E 3P5', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Phone: +1-431-373-4164', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Sponsor'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dr. Bijoy Menon'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'University of Calgary', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Foothills Medical Center', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '1403 29th Street NW', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Calgary, AB, T2N 2T9')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Purpose')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are being asked to take part in this study because you have had an acute ischemic stroke and you were enrolled in the AcT study by deferral of consent. The aim of this study is to determine how much you understand about the AcT study, how you felt about being enrolled by deferral of consent, and what you think about deferral of consent in general.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You will have been asked separately to consent to ongoing participation in that study. Now you are being asked to consent to completing a brief questionnaire about your experiences with the AcT study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may consent to participate in the AcT study and not consent to complete this questionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw consent from the AcT study and not consent to complete this questionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You may withdraw consent from the AcT study but consent to complete this questionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Whether or not you participate in this study will have no impact on your clinical care.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Risks and Benefits')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We do not anticipate any risks related to completing this questionnaire, though you could find the questions difficult or upsetting.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We do not anticipate any direct benefits to you of completing this questionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'There is no compensation for completing this questionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Confidentiality')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'During the study we will NOT be collecting health data about you. Your responses will be stored using a unique identifier number, not your name. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Questions')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You are free to ask any questions that you may have about your treatment and your rights as a research participant. If any questions come up during or after the study or if you have a research-related injury, contact the study doctor and the study staff: Dr. Jai Jai Shiva Shankar at 1-431-373-4164'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'For questions about your rights as a research participant, you may contact The University of Manitoba Biomedical Research Ethics Board at (204) 789-3389'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Do not sign this consent form unless you have had a chance to ask questions and have received satisfactory answers to all of your questions.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Statement of Consent'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { style: { fontWeight: 'bold' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'I have read this consent form. I have had the opportunity to discuss this research study with Dr. Jai Jai Shiva Shankar and or his study staff. I have had my questions answered by them in language I understand. The risks and benefits have been explained to me. I believe that I have not been unduly influenced by any study team member to participate in the research study by any statement or implied statements. Any relationship (such as employee, student or family member) I may have with the study team has not affected my decision to participate. I understand that I will be given a copy of this consent form after signing it. I understand that my participation in this clinical trial is voluntary and that I may choose to withdraw at any time. I freely agree to participate in this research study.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'I understand that information regarding my personal identity will be kept confidential, but that confidentiality is not guaranteed. I authorize the inspection of my medical records by Dr. Bijoy Menon, University of Calgary, the Food and Drug Administration, the Health Protection Branch, government agencies in other countries, and The University of Manitoba Biomedical Research Ethics Board.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'By signing this consent form, I have not waived any of the legal rights that I have as a participant in a research study.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeWinnipeg__contentWrap__3fe6i"};

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeUhn_ConsentForm__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentUhnByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeUhn_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeUhn_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentUhnByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createUhn(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(322);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' }))))), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: false, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.'))), !isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Study Title:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Study Doctor: "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dr. Aleksandra Pikula", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Department of Neurology", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University Health Network", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Toronto Western Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "416-464-0929"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):"), " University of Calgary"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number:"), " (24 hours / 7 days a week): 416-464-0929"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Toronto Western Hospital is receiving financial payment to cover the cost of conducting this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (< 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Toronto Western Hospital, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Research Information in Shared Clinical Records", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you participate in this study, information about you from this research project may be stored in your hospital file and in the University Health Network (UHN) computer system. The UHN shares the patient information stored on its computers with other hospitals and health care providers in Ontario so they can access the information if it is needed for your clinical care. The study team can tell you what information about you will be stored electronically and may be shared outside of the UHN. If you have any concerns about this, or have any questions, please contact the UHN Privacy Office at 416-340-4800, x6937 (or by email at privacy@uhn.ca)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are harmed as a direct result of taking part in this study, all necessary medical treatment will be made available to you at no cost."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "70%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Dr. Aleksandra Pikula"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "416-464-0929")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Telephone")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Study Title:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Study Doctor: "), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Dr. Aleksandra Pikula", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Department of Neurology", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University Health Network", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Toronto Western Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "416-464-0929"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):"), " University of Calgary"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number:"), " (24 hours / 7 days a week): 416-464-0929"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you. The Toronto Western Hospital is receiving financial payment to cover the cost of conducting this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can chose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (< 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Toronto Western Hospital, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Research Information in Shared Clinical Records", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you participate in this study, information about you from this research project may be stored in your hospital file and in the University Health Network (UHN) computer system. The UHN shares the patient information stored on its computers with other hospitals and health care providers in Ontario so they can access the information if it is needed for your clinical care. The study team can tell you what information about you will be stored electronically and may be shared outside of the UHN. If you have any concerns about this, or have any questions, please contact the UHN Privacy Office at 416-340-4800, x6937 (or by email at privacy@uhn.ca)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are harmed as a direct result of taking part in this study, all necessary medical treatment will be made available to you at no cost."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: "70%", textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Dr. Aleksandra Pikula"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "416-464-0929")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "30%" }, valign: "top" }, "Name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: "70%" }, valign: "top" }, "Telephone")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)));
});

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(322);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeUhn__contentWrap__2qVxq"};

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeLhs_ConsentForm__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentLhsByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeLhs_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeLhs_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentLhsByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createLhs(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' }))))), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: false, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.'))), !isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_SignatureTrimmed__["a" /* default */], { fieldName: 'initials_signature', label: 'Participant/SDM initials', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 35406", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre\u2013University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room ALL-130 \u2013 339 Windermere Road", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, Ontario N6A 5A5")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, Pager 13755")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (", '{', "'<'", '}', " 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on ", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 35406", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre\u2013University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room ALL-130 \u2013 339 Windermere Road", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, Ontario N6A 5A5")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, Pager 13755")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (< 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on ", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ConsentTypeHalifax_SignatureTrimmed__["a" /* default */], { fieldName: 'initials_signature', label: 'Participant/SDM initials', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeLhs__contentWrap__1DzN5"};

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeHalifax_ConsentForm__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentByWorkflowTypeAndToken(__WEBPACK_IMPORTED_MODULE_13__services__["a" /* CONSENT_HALIFAX_URL_NAME */], token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), mtl_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_name') || undefined, mtl_consent_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name') || undefined, mtl_consent_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_email') || undefined, mtl_consent_investigator_name_1: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_1') || undefined, mtl_consent_investigator_name_2: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_2') || undefined, sb_dic_interpreter_language: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_interpreter_language') || undefined, sb_dic_interpreter_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_interpreter_name') || undefined, mtl_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, mtl_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_investigator_name') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeHalifax_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentByTypeAndToken(__WEBPACK_IMPORTED_MODULE_20__services__["a" /* CONSENT_HALIFAX_URL_NAME */], token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createConsentByType(__WEBPACK_IMPORTED_MODULE_20__services__["a" /* CONSENT_HALIFAX_URL_NAME */], formData, file);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token, classes: this.props.classes }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__ = __webpack_require__(113);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === "Email" && !props.token);var isEmail = props.consentMethodType === "Email";var isPatient = props.consentPersonType === "Patient";var isSurrogate = props.consentPersonType === "Surrogate";var hasLanguage = props.form.getFieldValue('sb_dic_interpreter_language') !== undefined && props.form.getFieldValue('sb_dic_interpreter_language').length > 0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, props.consentPersonType === "Surrogate" ? "Consent Process - Surrogate" : "Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), props.consentPersonType === "Surrogate" ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", { style: { textAlign: "left" } }, "20. Consent Form Signature Page"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I have reviewed all the information in this consent form related to the study called:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", { style: { textAlign: "center" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("i", null, "Alteplase Compared to Tenecteplase in Patients with Acute Ischemic Stroke: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry based Pragmatic Randomized Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I have been given the opportunity to discuss this study. All of my questions have been answered to my satisfaction.", " "), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I authorize access to my personal health information, and research study data as explained in this form."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "This signature on this consent form means that I agree to stay in this study. I understand that I am free to withdraw at any time without affecting my future care."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "decision-box" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("sb_dic_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to stay in the study."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage."))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "E-messaging (email and texting) can be used by a member or members of the research team to communicate with you while you are in this study. All local communication done with you will be done only through a NSHA Webmail account, or text by a phone issued to a research member through NSHA. You will also receive e-messages from the research team in Calgary. All efforts are made to keep information sent or received private, but it is possible other people may be able to see, read, and change messages sent to or from NSHA or Calgary."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, props.form.getFieldDecorator("wp_participant_agree_being_contacted", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "I give my permission to be contacted by a member or members of the research team from an NSHA Webmail account or an NSHA cell phone by research staff as well as the research staff in Calgary to communicate during this study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "I do not wish to be contacted by email or text message, unless I otherwise give permission at another time during this study"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") === "true" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "no-bottom-margin" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label", style: { display: "inline-block", width: "150px" } }, "Email"), props.form.getFieldDecorator("halifax_contact_by_email", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "No"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") === "true" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label", style: { display: "inline-block", width: "150px" } }, "Text message"), props.form.getFieldDecorator("halifax_contact_by_message", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "No"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__["a" /* default */], { fieldName: "initials_signature", label: "Initials", form: props.form })), isPatient && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Name"), props.form.getFieldDecorator("mtl_consent_participant_name", { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant Name" })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision Maker"), props.form.getFieldDecorator("mtl_consent_participant_email", { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: "Please enter the Substitute Decision Maker's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Substitute Decision Maker Email" })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("mtl_consent_participant_email", { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_participant_signature", label: "Signature of Participant", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Person Conducting the Consent Discussion Name"), props.form.getFieldDecorator("mtl_consent_investigator_name_1", { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_investigator_signature_1", label: "Signature of Person Conducting the Consent Discussion", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Principal Investigator Name"), props.form.getFieldDecorator("mtl_consent_investigator_name_2", { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_investigator_signature_2", label: "Signature of Principal Investigator", form: props.form })), isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision Maker Name"), props.form.getFieldDecorator("mtl_consent_representative_name", { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_representative_signature", label: "Signature of Participant's Substitute Decision Maker", form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Impartial Witness Name"), props.form.getFieldDecorator("mtl_consent_witness_name", { initialValue: props.mtl_consent_witness_name, rules: [{ required: !props.token, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Impartial Witness Name" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_witness_signature", label: "Signature of Impartial Witness", form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If the consent discussion has been conducted in a language other than English, please indicate:"), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Language"), props.form.getFieldDecorator("sb_dic_interpreter_language", { initialValue: props.sb_dic_interpreter_language })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: "Language" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Translator Name"), props.form.getFieldDecorator("sb_dic_interpreter_name", { initialValue: props.sb_dic_interpreter_name, rules: [{ required: hasLanguage, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Translator Name (Printed)" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_interpreter_signature", label: "Signature of Translator", form: props.form, optional: !hasLanguage })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form ACT RCCT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY TITLE:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Patients with Acute Ischemic Stroke:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "based Pragmatic Randomized:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CLINICAL STUDY REGISTRATION NUMBER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "NCT03889249")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PRINCIPAL INVESTIGATOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Stephen Phillips, M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Professor of Medicine (Neurology),", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dalhousie University Stroke Neurologist", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "NSHA QEII Halifax Infirmary", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "1796 Summer Street, 3rd Floor, Rm. 3851", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(902) 473-5423")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY SPONSOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Bijoy K. Menon M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary Room 1049A,", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Centre 1403, 29th Street NW Calgary, AB, T2N 2T9", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: 403-944-8107 Fax: 403-283-2270", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "email: Bijoy.Menon@Albertahealthservices.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FUNDER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "1) Heart and Stroke Foundation of Alberta", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2) Alberta Innovates-Health Solutions", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3) Canadian Institutes of Health Research", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4) University of Calgary")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { borderBottom: '1px solid white' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "1. Introduction"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject). Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been invited to take part in a research study. A research study is a way of gathering information on a treatment, procedure or medical device or to answer a question about something that is not well understood. Taking part in this study is voluntary. It is up to you to decide whether to be in the study or not. Before you decide, you need to understand what the study is for, what risks you might take and what benefits you might receive. This consent form explains the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will tell you if there are any study timelines for making your decision.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Please ask the research team or the principal investigator to clarify anything you do not understand or would like to know more about. Make sure all your questions are answered to your satisfaction before deciding whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The researchers will:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Discuss the study with you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Answer your questions."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Be available during the study to deal with problems and answer questions."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to stay in this study because you have had an ischemic stroke. This is when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide not to take part or if you leave the study early, your usual health care will not be affected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "2. Why is there a need for this study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Stroke is an emergency where every minute counts. Because of this, you were enrolled in this study by deferral of consent. This means that you had either Alteplase or Tenecteplase without first being asked. This process was created with experts in research ethics and with stroke patients. This was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The goal of this study is to compare the drug Alteplase with the trial drug Tenecteplase. Alteplase is the existing treatment for stroke (blocked blood vessel in the brain). Tenecteplase is not approved for treatment in stroke. It is a treatment for a heart attack (a blocked blood vessel in the heart). This study is to decide if patients who receive Tenecteplase do as well as those who receive Alteplase, after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This is a", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Phase III"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "Study- The drug is given to even larger groups of people (usually 1,000 or more) to:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "confirm its effectiveness")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "monitor side effects")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "compare it to commonly used treatments")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "collect information that will allow the investigational product or test article to be used safely on the market")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is being done for many reasons. Some of these reasons are listed below:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New research has shown that tenecteplase may break down the clot in the brain better than alteplase. This is because tenecteplase connects to the clot differently than Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Tenecteplase is given in a single dose of a drug called a bolus. Alteplase is given in a single bolus followed by a 60-minute drip line of drug. This needs a special pump and two separate calculations of the dose. This difference in how the drug is given makes tenecteplase easier and ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "possibly"), " safer to give than alteplase as there is less math and equipment needed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Transfer of patients from one hospital to another is easier without the need for pumps as well as faster because you don\u2019t need to wait for the 60-minute drip line of drug to finish before transfer."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Therefore, it is possible that the use of tenecteplase in patients with stroke may result in faster treatment and transport, saving time, reducing problems and possibly improving patient results while saving on health care costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "3. What Is Being Tested?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a drug called Alteplase (tPA) can decrease brain damage from a stroke by breaking down the clot in the blocked blood vessel. This helps to return normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Even with the benefits of Alteplase reducing brain damage/disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is a different clot-busting drug that is similar to Alteplase and is often used for patients who have a heart attack. This is where there is a clot blocking a blood vessel in the heart."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Health Canada has approved the sale and use of Tenecteplase to treat heart attack. Although they have not approved its use for stroke, they have allowed its use in this clinical trial."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "One half of study participants will receive Alteplase as this is the standard treatment for stroke currently available and this group will act as a control group."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The other half of study participants will receive Tenecteplase as the study drug. The study has been designed this way to directly compare the two drugs, their side effects, and to see which one is the better treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "4. How Long Will I Be In The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The length of this study for participants is approximately 3 months or 90 days. The entire study is expected to take about 2 years to complete and the results should be known 1-2 years after the study has ended."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "5. How Many People Will Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will participate in this study throughout Canada. About 200-300 people will participate in this study at the QEII Halifax Infirmary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "6. How Is The Study Being Done?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Participants in this study have been randomly (by chance) placed in one of 2 study groups. Neither you, the study staff nor the investigator(s) can influence which group you were assigned. You had a 50% chance of being placed in either group. You and the research team will know which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group A: Called the Intervention Group had received the drug Tenecteplase as a single dose (called a bolus) based on your weight, as soon as possible after randomization"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group B: Called the Control Group had received the drug Alteplase via as a single dose (bolus) followed by a 60-minute drip line of the drug based on your weight as soon as possible after randomization."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All patients will receive standard stroke care on a stroke care unit after receiving either drug. While on the stroke care unit all tests will be standard tests given to all stroke patients regardless of which drug you received."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be asked to return to the hospital for 1 visit at 3 months (90 days) as standard stroke care follow up. You will also be asked to accept 1 phone call at 3 months (90-120 days) for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "7. What Will Happen If I Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "STUDY", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "We have done the following as part of this trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "We have given you one of the two drugs A) Alteplase (standard stroke treatment) or B) Tenecteplase (study stroke treatment)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "You have and will continue to receive the same stroke care that all stroke patients receive.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to stay in this study, you will be asked to do the following as part of the trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "A follow up visit at 3 months (90 days), would happen as is standard with your stroke doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There will be a one-time telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The phone call will last about 5 minutes. This call will be as close to 90 days as possible, to a limit of 120 days based on your schedule. For people who are not fluent in English, the services of an interpreter will be offered."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. This assessment will be done at 90-120 days and/or at 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "After this period (phone call and/or online assessment) is finished, your participation in the study will be complete."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may ask not to have further tests done or to participate in any study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is important that you tell the research team about any treatment therapies, drugs or medicines you are taking or wish to take. You must also tell the research team about anything unusual that is happening with your health. This includes any medical problems that seem to be getting worse. If you see another doctor or must go to a hospital, you should let the doctors know that you are in a research study. You should also tell your own doctor as quickly as possible, for your safety."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "8. Are There Risks To The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There are risks with this, or any study. To give you the most complete information available, we have listed many possible risks, which may appear alarming. We do not want to alarm you but we do want to make sure that if you decide to stay in the study, you have had a chance to think about the risks carefully. Please also be aware that there may be risks in participating in this study that we do not know about yet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There is a risk that that Tenecteplase may not be as effective in the treatment of stroke as Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During this study you will have the same number of tests using radiation that are used to diagnose or treat your existing medical condition. You will not receive any extra radiation procedures while you are enrolled in this study. The procedures will be done using established procedures of this institution and be performed by authorized persons.\u201D"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "DRUG EFFECTS"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks of Alteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths reported"), " due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Major risks for Tenecteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 3-4%, as per recent data; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100) but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is minor and easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths"), " reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may notice none, some, or all of these side effects and they may be mild, moderate, or severe. Many side effects disappear after treatment is stopped. The principal investigator may prescribe medications to ease the discomfort you may experience if any of these side effects occur. If any severe reaction to the study drug occurs, the principal investigator may interrupt or discontinue the study drug treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will be checking you closely to see if any of these side effects are occurring."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There may be side effects that are not yet known. You must tell the research team about any new symptoms you experience."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects or discomforts of tests/procedures that are part of this study but are also part of your normal clinical care will be reviewed by your treating doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "QUESTIONNAIRES:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may find the interviews and questionnaires you receive during the course of the study upsetting or distressing. You may not like all of the questions that you will be asked. You do not have to answer those questions you find too distressing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment may interfere with medications, both prescribed and over the counter that you are currently taking. You should ask the research team if the study treatment could interfere with your medications before consenting to be in this study. You should also consult with the research team before taking any new medications."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told about any new information that might reasonably affect your willingness to continue to participate in this study as soon as the information becomes available to the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "9. Are There Benefits Of Participating In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may or may not benefit directly from participating in this study. However, possible benefits include close monitoring of your stroke, general health status and any symptoms that you may experience during the study. Your participation may or may not help other people with stroke in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "10. Are There Other Choices?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "New treatments become available for this sort of condition at different times and in different parts of the world. Like many other hospitals, we do not feel it is helpful to test more than one experimental treatment for the same condition at the same time in the same person. This could even be dangerous. So, you will not receive two experimental treatments at the same time.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are free to seek other opinions or choices in other hospitals or cities if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "11. What Happens at the End of the Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment will be provided to you only during this study and not after the study is over."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study results are expected to be finished months to years after the study ends. A summary will be available on\xA0", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "12. What Are My Responsibilities?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a study participant you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Follow the directions of the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report all medications being taken or that you plan on taking;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any changes in your health to the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any problems that you experience that you think might be related to participating in the study;"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "13. Can My Participation in this Study End Early?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study sponsor, the Nova Scotia Health Authority Research Ethics Board, Health Canada, and the principal investigator have the right to stop patient recruitment or cancel the study at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator may decide to remove you from this study without your consent for any of the following reasons:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "You do not follow the directions of the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There is new information that shows that being in this study is not in your best interests."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are withdrawn from this study, a member of the research team will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to end your participation at any time. If you choose to withdraw from this study by providing notice to the research team, your decision will have no effect on your current or future medical treatment and healthcare. Your health records may be examined in connection with this study or further analyses related to it. Your health records will only be made available as described above. However the above agencies, including the sponsor, will only look at and use study related records up to the date of your withdrawal from the study, except where it is necessary to ensure that the study is scientifically reliable and to report side effects associated with the study medication as required by regulatory authorities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may request not to have further tests done or to participate in any additional study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "14. What About New Information?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that new information may become available while you are in the study about side effects or a new treatment for your condition. You will be told about any other new information that might affect your health, welfare, or willingness to stay in the study and will be asked whether you wish to continue taking part in the study or not."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "15. Will It Cost Me Anything?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not have to pay for any study related treatments you take while participating in this study. You may need to pay for medications to treat any side effects you may experience as a result of participating in this study. Your private health care insurer may not pay for all of these added costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Research Related Injury"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you become ill or injured as a direct result of participating in this study, necessary medical treatment will be available at no additional cost to you. Your signature on this form only indicates that you have understood to your satisfaction the information regarding your participation in the study and agree to participate in the study. In no way does this waive your legal rights nor release the principal investigator, the research team, the study sponsor or involved institutions from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "16. What About My Privacy and Confidentiality?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protecting your privacy is an important part of this study and every effort to protect your privacy will be made. However, complete privacy cannot be guaranteed. For example, the principal investigator may be required by law to allow access to research records. Your family doctor will be told that you are taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are presented to the public, nobody will be able to tell that you were in the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to stay in this study, the research team will collect personal health information from you and your health record. The research team will collect and use only the information they need for this study and to judge the safety and usefulness of the study treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u201CPersonal health information\u201D is health information about you that could identify you because it includes information such as your;", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Name,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Age or month/year of birth (MM/YY),"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Information from the study interviews and questionnaires;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New and existing medical records, or"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The types, dates and results of various tests and procedures."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Other people may need to look at your personal health information to check that the information collected for the study is correct and to make sure the study followed the required laws and guidelines. These people might include:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bijoy K. Menon M.D., and its representatives and partner companies as per the title page of this consent form;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Nova Scotia Health Authority Research Ethics Board (NSHA REB) and people working for or with the NSHA REB because they oversee the ethical conduct of research studies within the Nova Scotia Health Authority;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Representatives of Health Canada, who oversee the use of drugs, natural health products and medical devices in research in Canada;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to collect information from the Department of Health and Wellness' SHARE Electronic Health Record (which contains laboratory test results, Diagnostic Imaging as well as admissions, discharge and transfer records from across the province"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to access your health information for/from various registries including OPTIMISE (another study database), and CIHI (another hospital database)"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "OPTIMISE collects data from hospitals in Canada including information about when you had your stroke, what treatment you had, and how that treatment worked. All data in this database are coded with a unique ID number and does not have any information that could identify you. The OPTIMISE data base will be linked to the study database discussed in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/ emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "These people will view your study records at this institution and will not take identifying information away with them. In order to complete the 90-day telephone follow up, your contact information will be sent to the research team in Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Use of Your Study Information"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Any study data about you that is sent outside of the Nova Scotia Health Authority will have a code and will not contain your name or address, or any information that directly identifies you except those needed to complete the 90-day telephone follow up. Your contact information including your phone number will be sent to the research team in Calgary. This will allow them to complete the follow up as discussed in this document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "De-identified study data may be transferred to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The sponsor and companies working for and with the sponsor and;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Regulatory authorities within Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The 90 day cognitive online assessment will be located on servers in the USA under similar security and privacy protocols used by the USA department of defense."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor and companies working for and with the sponsor will use the information collected about you during the study, only for scientific research and/or drug development purposes. Study data that is sent outside of the Nova Scotia Health Authority will be used for the research purposes explained in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team and the other people listed above will keep the information they see or receive about you confidential, to the extent permitted by applicable laws. Even though the risk of identifying you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will keep any personal health information about you in a secure and confidential location for 25 years and then destroy it according to NSHA policy. Your personal health information will not be shared with others without your permission"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After your part in the study ends, we may continue to review your health records for safety and data accuracy until the study is finished or you withdraw your consent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The REB and people working for or with the REB may also contact you personally for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please be aware that once your data is sent outside of Canada it may be accessed by regulatory authorities in other countries who may not have the same privacy laws as we do."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Your Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have the right to access, review, and request changes to your study data.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "A description of this clinical trial will be available on http://www.ClinicalTrials.gov,. This Web site will not include information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "17. Declaration of Financial Interest"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor/funder is reimbursing the principal investigator and/or the principal investigator\u2019s institution to conduct this study. The amount of payment is sufficient to cover the costs of conducting the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "18. What About Questions or Problems?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "For further information about the study you may call the principal investigator who is the person in charge of this study and/or any other research team member listed below."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator is Dr. Stephen Phillips.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 473- 5423."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your research coordinator is Susannah Piercey RN", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 719-8291"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you experience any symptoms or possible side effects or other medical problems, please let the principal investigator or research coordinator know as soon as possible."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you can't reach the principal investigator or research coordinator, or it is after regular business hours, speak to the stroke neurologist on call. The after hour\u2019s number is ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "(902) 473-2222."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This doctor may not be the one you usually see while in this study. Please call the principal investigator or research coordinator the next business day to tell them about the possible side effects or other medical problems you experienced."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "19. What Are My Rights?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to all information that could help you make a decision about staying in this study. You also have the right to ask questions about this study and your rights as a research participant, and to have them answered to your satisfaction before you make any decision. You also have the right to ask questions and to receive answers throughout this study. You have the right to withdraw your consent at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a research participant, and/or concerns or complaints about this research study, you can contact the Nova Scotia Health Authority Research Ethics Board manager at 902-473-8426 or Patient Relations at (902) 473-2133 or 1-855-799-0990 or ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "healthcareexperience@nshealth.ca.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in the future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the next part you will be asked if you agree (consent) to stay in this study. If the answer is \u201Cyes\u201D, please sign the form.")));
});

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form ACT RCCT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY TITLE:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Patients with Acute Ischemic Stroke:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "based Pragmatic Randomized:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CLINICAL STUDY REGISTRATION NUMBER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "NCT03889249")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PRINCIPAL INVESTIGATOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Stephen Phillips, M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Professor of Medicine (Neurology),", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Dalhousie University Stroke Neurologist", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "NSHA QEII Halifax Infirmary", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "1796 Summer Street, 3rd Floor, Rm. 3851", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(902) 473-5423")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY SPONSOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Bijoy K. Menon M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary Room 1049A,", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Centre 1403, 29th Street NW Calgary, AB, T2N 2T9", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: 403-944-8107 Fax: 403-283-2270", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "email: Bijoy.Menon@Albertahealthservices.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FUNDER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "1) Heart and Stroke Foundation of Alberta", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2) Alberta Innovates-Health Solutions", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3) Canadian Institutes of Health Research", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4) University of Calgary")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { borderBottom: '1px solid white' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "1. Introduction"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject). Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been invited to take part in a research study. A research study is a way of gathering information on a treatment, procedure or medical device or to answer a question about something that is not well understood. Taking part in this study is voluntary. It is up to you to decide whether to be in the study or not. Before you decide, you need to understand what the study is for, what risks you might take and what benefits you might receive. This consent form explains the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will tell you if there are any study timelines for making your decision.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Please ask the research team or the principal investigator to clarify anything you do not understand or would like to know more about. Make sure all your questions are answered to your satisfaction before deciding whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The researchers will:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Discuss the study with you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Answer your questions."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Be available during the study to deal with problems and answer questions."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to stay in this study because you have had an ischemic stroke. This is when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide not to take part or if you leave the study early, your usual health care will not be affected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "2. Why is there a need for this study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Stroke is an emergency where every minute counts. Because of this, you were enrolled in this study by deferral of consent. This means that you had either Alteplase or Tenecteplase without first being asked. This process was created with experts in research ethics and with stroke patients. This was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The goal of this study is to compare the drug Alteplase with the trial drug Tenecteplase. Alteplase is the existing treatment for stroke (blocked blood vessel in the brain). Tenecteplase is not approved for treatment in stroke. It is a treatment for a heart attack (a blocked blood vessel in the heart). This study is to decide if patients who receive Tenecteplase do as well as those who receive Alteplase, after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This is a", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Phase III"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "Study- The drug is given to even larger groups of people (usually 1,000 or more) to:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "confirm its effectiveness")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "monitor side effects")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "compare it to commonly used treatments")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "collect information that will allow the investigational product or test article to be used safely on the market")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is being done for many reasons. Some of these reasons are listed below:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New research has shown that tenecteplase may break down the clot in the brain better than alteplase. This is because tenecteplase connects to the clot differently than Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Tenecteplase is given in a single dose of a drug called a bolus. Alteplase is given in a single bolus followed by a 60-minute drip line of drug. This needs a special pump and two separate calculations of the dose. This difference in how the drug is given makes tenecteplase easier and ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "possibly"), " safer to give than alteplase as there is less math and equipment needed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Transfer of patients from one hospital to another is easier without the need for pumps as well as faster because you don\u2019t need to wait for the 60-minute drip line of drug to finish before transfer."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Therefore, it is possible that the use of tenecteplase in patients with stroke may result in faster treatment and transport, saving time, reducing problems and possibly improving patient results while saving on health care costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "3. What Is Being Tested?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a drug called Alteplase (tPA) can decrease brain damage from a stroke by breaking down the clot in the blocked blood vessel. This helps to return normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Even with the benefits of Alteplase reducing brain damage/disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is a different clot-busting drug that is similar to Alteplase and is often used for patients who have a heart attack. This is where there is a clot blocking a blood vessel in the heart."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Health Canada has approved the sale and use of Tenecteplase to treat heart attack. Although they have not approved its use for stroke, they have allowed its use in this clinical trial."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "One half of study participants will receive Alteplase as this is the standard treatment for stroke currently available and this group will act as a control group."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The other half of study participants will receive Tenecteplase as the study drug. The study has been designed this way to directly compare the two drugs, their side effects, and to see which one is the better treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "4. How Long Will I Be In The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The length of this study for participants is approximately 3 months or 90 days. The entire study is expected to take about 2 years to complete and the results should be known 1-2 years after the study has ended."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "5. How Many People Will Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will participate in this study throughout Canada. About 200-300 people will participate in this study at the QEII Halifax Infirmary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "6. How Is The Study Being Done?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Participants in this study have been randomly (by chance) placed in one of 2 study groups. Neither you, the study staff nor the investigator(s) can influence which group you were assigned. You had a 50% chance of being placed in either group. You and the research team will know which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group A: Called the Intervention Group had received the drug Tenecteplase as a single dose (called a bolus) based on your weight, as soon as possible after randomization"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group B: Called the Control Group had received the drug Alteplase via as a single dose (bolus) followed by a 60-minute drip line of the drug based on your weight as soon as possible after randomization."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All patients will receive standard stroke care on a stroke care unit after receiving either drug. While on the stroke care unit all tests will be standard tests given to all stroke patients regardless of which drug you received."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be asked to return to the hospital for 1 visit at 3 months (90 days) as standard stroke care follow up. You will also be asked to accept 1 phone call at 3 months (90-120 days) for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "7. What Will Happen If I Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "STUDY", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "We have done the following as part of this trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "We have given you one of the two drugs A) Alteplase (standard stroke treatment) or B) Tenecteplase (study stroke treatment)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "You have and will continue to receive the same stroke care that all stroke patients receive.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to stay in this study, you will be asked to do the following as part of the trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "A follow up visit at 3 months (90 days), would happen as is standard with your stroke doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There will be a one-time telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The phone call will last about 5 minutes. This call will be as close to 90 days as possible, to a limit of 120 days based on your schedule. For people who are not fluent in English, the services of an interpreter will be offered."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. This assessment will be done at 90-120 days and/or at 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "After this period (phone call and/or online assessment) is finished, your participation in the study will be complete."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may ask not to have further tests done or to participate in any study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is important that you tell the research team about any treatment therapies, drugs or medicines you are taking or wish to take. You must also tell the research team about anything unusual that is happening with your health. This includes any medical problems that seem to be getting worse. If you see another doctor or must go to a hospital, you should let the doctors know that you are in a research study. You should also tell your own doctor as quickly as possible, for your safety."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "8. Are There Risks To The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There are risks with this, or any study. To give you the most complete information available, we have listed many possible risks, which may appear alarming. We do not want to alarm you but we do want to make sure that if you decide to stay in the study, you have had a chance to think about the risks carefully. Please also be aware that there may be risks in participating in this study that we do not know about yet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There is a risk that that Tenecteplase may not be as effective in the treatment of stroke as Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During this study you will have the same number of tests using radiation that are used to diagnose or treat your existing medical condition. You will not receive any extra radiation procedures while you are enrolled in this study. The procedures will be done using established procedures of this institution and be performed by authorized persons.\u201D"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "DRUG EFFECTS"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks of Alteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths reported"), " due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Major risks for Tenecteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 3-4%, as per recent data; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100) but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is minor and easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths"), " reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may notice none, some, or all of these side effects and they may be mild, moderate, or severe. Many side effects disappear after treatment is stopped. The principal investigator may prescribe medications to ease the discomfort you may experience if any of these side effects occur. If any severe reaction to the study drug occurs, the principal investigator may interrupt or discontinue the study drug treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will be checking you closely to see if any of these side effects are occurring."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There may be side effects that are not yet known. You must tell the research team about any new symptoms you experience."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects or discomforts of tests/procedures that are part of this study but are also part of your normal clinical care will be reviewed by your treating doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "QUESTIONNAIRES:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may find the interviews and questionnaires you receive during the course of the study upsetting or distressing. You may not like all of the questions that you will be asked. You do not have to answer those questions you find too distressing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment may interfere with medications, both prescribed and over the counter that you are currently taking. You should ask the research team if the study treatment could interfere with your medications before consenting to be in this study. You should also consult with the research team before taking any new medications."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told about any new information that might reasonably affect your willingness to continue to participate in this study as soon as the information becomes available to the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "9. Are There Benefits Of Participating In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may or may not benefit directly from participating in this study. However, possible benefits include close monitoring of your stroke, general health status and any symptoms that you may experience during the study. Your participation may or may not help other people with stroke in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "10. Are There Other Choices?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "New treatments become available for this sort of condition at different times and in different parts of the world. Like many other hospitals, we do not feel it is helpful to test more than one experimental treatment for the same condition at the same time in the same person. This could even be dangerous. So, you will not receive two experimental treatments at the same time.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are free to seek other opinions or choices in other hospitals or cities if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "11. What Happens at the End of the Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment will be provided to you only during this study and not after the study is over."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study results are expected to be finished months to years after the study ends. A summary will be available on\xA0", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "12. What Are My Responsibilities?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a study participant you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Follow the directions of the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report all medications being taken or that you plan on taking;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any changes in your health to the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any problems that you experience that you think might be related to participating in the study;"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "13. Can My Participation in this Study End Early?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study sponsor, the Nova Scotia Health Authority Research Ethics Board, Health Canada, and the principal investigator have the right to stop patient recruitment or cancel the study at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator may decide to remove you from this study without your consent for any of the following reasons:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "You do not follow the directions of the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There is new information that shows that being in this study is not in your best interests."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are withdrawn from this study, a member of the research team will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to end your participation at any time. If you choose to withdraw from this study by providing notice to the research team, your decision will have no effect on your current or future medical treatment and healthcare. Your health records may be examined in connection with this study or further analyses related to it. Your health records will only be made available as described above. However the above agencies, including the sponsor, will only look at and use study related records up to the date of your withdrawal from the study, except where it is necessary to ensure that the study is scientifically reliable and to report side effects associated with the study medication as required by regulatory authorities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may request not to have further tests done or to participate in any additional study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "14. What About New Information?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that new information may become available while you are in the study about side effects or a new treatment for your condition. You will be told about any other new information that might affect your health, welfare, or willingness to stay in the study and will be asked whether you wish to continue taking part in the study or not."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "15. Will It Cost Me Anything?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not have to pay for any study related treatments you take while participating in this study. You may need to pay for medications to treat any side effects you may experience as a result of participating in this study. Your private health care insurer may not pay for all of these added costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Research Related Injury"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you become ill or injured as a direct result of participating in this study, necessary medical treatment will be available at no additional cost to you. Your signature on this form only indicates that you have understood to your satisfaction the information regarding your participation in the study and agree to participate in the study. In no way does this waive your legal rights nor release the principal investigator, the research team, the study sponsor or involved institutions from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "16. What About My Privacy and Confidentiality?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protecting your privacy is an important part of this study and every effort to protect your privacy will be made. However, complete privacy cannot be guaranteed. For example, the principal investigator may be required by law to allow access to research records. Your family doctor will be told that you are taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are presented to the public, nobody will be able to tell that you were in the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to stay in this study, the research team will collect personal health information from you and your health record. The research team will collect and use only the information they need for this study and to judge the safety and usefulness of the study treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u201CPersonal health information\u201D is health information about you that could identify you because it includes information such as your;", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Name,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Age or month/year of birth (MM/YY),"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Information from the study interviews and questionnaires;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New and existing medical records, or"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The types, dates and results of various tests and procedures."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Other people may need to look at your personal health information to check that the information collected for the study is correct and to make sure the study followed the required laws and guidelines. These people might include:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bijoy K. Menon M.D., and its representatives and partner companies as per the title page of this consent form;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Nova Scotia Health Authority Research Ethics Board (NSHA REB) and people working for or with the NSHA REB because they oversee the ethical conduct of research studies within the Nova Scotia Health Authority;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Representatives of Health Canada, who oversee the use of drugs, natural health products and medical devices in research in Canada;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to collect information from the Department of Health and Wellness' SHARE Electronic Health Record (which contains laboratory test results, Diagnostic Imaging as well as admissions, discharge and transfer records from across the province"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to access your health information for/from various registries including OPTIMISE (another study database), and CIHI (another hospital database)"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "OPTIMISE collects data from hospitals in Canada including information about when you had your stroke, what treatment you had, and how that treatment worked. All data in this database are coded with a unique ID number and does not have any information that could identify you. The OPTIMISE data base will be linked to the study database discussed in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/ emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "These people will view your study records at this institution and will not take identifying information away with them. In order to complete the 90-day telephone follow up, your contact information will be sent to the research team in Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Use of Your Study Information"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Any study data about you that is sent outside of the Nova Scotia Health Authority will have a code and will not contain your name or address, or any information that directly identifies you except those needed to complete the 90-day telephone follow up. Your contact information including your phone number will be sent to the research team in Calgary. This will allow them to complete the follow up as discussed in this document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "De-identified study data may be transferred to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The sponsor and companies working for and with the sponsor and;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Regulatory authorities within Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The 90 day cognitive online assessment will be located on servers in the USA under similar security and privacy protocols used by the USA department of defense."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor and companies working for and with the sponsor will use the information collected about you during the study, only for scientific research and/or drug development purposes. Study data that is sent outside of the Nova Scotia Health Authority will be used for the research purposes explained in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team and the other people listed above will keep the information they see or receive about you confidential, to the extent permitted by applicable laws. Even though the risk of identifying you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will keep any personal health information about you in a secure and confidential location for 25 years and then destroy it according to NSHA policy. Your personal health information will not be shared with others without your permission"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After your part in the study ends, we may continue to review your health records for safety and data accuracy until the study is finished or you withdraw your consent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The REB and people working for or with the REB may also contact you personally for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please be aware that once your data is sent outside of Canada it may be accessed by regulatory authorities in other countries who may not have the same privacy laws as we do."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Your Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have the right to access, review, and request changes to your study data.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "A description of this clinical trial will be available on http://www.ClinicalTrials.gov,. This Web site will not include information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "17. Declaration of Financial Interest"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor/funder is reimbursing the principal investigator and/or the principal investigator\u2019s institution to conduct this study. The amount of payment is sufficient to cover the costs of conducting the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "18. What About Questions or Problems?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "For further information about the study you may call the principal investigator who is the person in charge of this study and/or any other research team member listed below."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator is Dr. Stephen Phillips.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 473- 5423."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your research coordinator is Susannah Piercey RN", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 719-8291"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you experience any symptoms or possible side effects or other medical problems, please let the principal investigator or research coordinator know as soon as possible."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you can't reach the principal investigator or research coordinator, or it is after regular business hours, speak to the stroke neurologist on call. The after hour\u2019s number is ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "(902) 473-2222."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This doctor may not be the one you usually see while in this study. Please call the principal investigator or research coordinator the next business day to tell them about the possible side effects or other medical problems you experienced."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "19. What Are My Rights?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to all information that could help you make a decision about staying in this study. You also have the right to ask questions about this study and your rights as a research participant, and to have them answered to your satisfaction before you make any decision. You also have the right to ask questions and to receive answers throughout this study. You have the right to withdraw your consent at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a research participant, and/or concerns or complaints about this research study, you can contact the Nova Scotia Health Authority Research Ethics Board manager at 902-473-8426 or Patient Relations at (902) 473-2133 or 1-855-799-0990 or ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "healthcareexperience@nshealth.ca.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in the future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the next part you will be asked if you agree (consent) to stay in this study. If the answer is \u201Cyes\u201D, please sign the form.")));
});

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(324);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === "EmailRegainedCapacity" && !props.token);var isEmail = props.consentMethodType === "EmailRegainedCapacity";var isPatient = props.consentPersonType === "Patient";var isSurrogate = props.consentPersonType === "Surrogate";var hasLanguage = props.form.getFieldValue('rccf_language') !== undefined && props.form.getFieldValue('rccf_language').length > 0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "Consent Process - REGAINED CAPACITY CONSENT FORM"), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care.")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "decision-box" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("mtl_rccf_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to stay in the study."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage."))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Name"), props.form.getFieldDecorator("mtl_rccf_consent_participant_name", { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant Name" })))), isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("rccf_participant_email", { initialValue: props.rccf_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_participant_signature", label: "Signature of Participant", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Person Conducting the Consent Discussion Name"), props.form.getFieldDecorator("mtl_rccf_consent_investigator_name", { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_investigator_signature", label: "Signature of Person Conducting the Consent Discussion", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Principal Investigator Name"), props.form.getFieldDecorator("rccf_investigator_name", { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "rccf_investigator_signature", label: "Signature of Principal Investigator", form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Impartial Witness Name"), props.form.getFieldDecorator("mtl_rccf_consent_witness_name_and_relationship", { initialValue: props.mtl_rccf_consent_witness_name_and_relationship, rules: [{ required: !props.token, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Impartial Witness Name" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_witness_signature", label: "Signature of Impartial Witness", form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If the consent discussion has been conducted in a language other than English, please indicate:"), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Language"), props.form.getFieldDecorator("rccf_language", { initialValue: props.rccf_language })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: "Language" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Translator Name"), props.form.getFieldDecorator("rccf_interpreter_name", { initialValue: props.rccf_interpreter_name, rules: [{ required: hasLanguage, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Translator Name (Printed)" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "rccf_interpreter_signature", label: "Signature of Translator", form: props.form, optional: !hasLanguage })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeHalifax__contentWrap__3gRYM"};

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypePei_ConsentForm__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentByWorkflowTypeAndToken(__WEBPACK_IMPORTED_MODULE_13__services__["b" /* CONSENT_PEI_URL_NAME */], token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), mtl_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_name') || undefined, mtl_consent_representative_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_representative_name') || undefined, mtl_consent_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_participant_email') || undefined, mtl_consent_investigator_name_1: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_1') || undefined, mtl_consent_investigator_name_2: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_consent_investigator_name_2') || undefined, sb_dic_interpreter_language: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_interpreter_language') || undefined, sb_dic_interpreter_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_interpreter_name') || undefined, mtl_rccf_consent_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, mtl_rccf_consent_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.mtl_rccf_consent_investigator_name') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypePei_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypePei_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step2__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3aPatient__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step3aRegainedCapacity__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Step3b__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Step4__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Signature__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services__ = __webpack_require__(39);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_15_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            } else {
                              __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a.error({ message: "Error", description: "Please check required fields" });
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_15_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_22__services__["c" /* consentServices */].confirmConsentByTypeAndToken(__WEBPACK_IMPORTED_MODULE_22__services__["b" /* CONSENT_PEI_URL_NAME */], token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_22__services__["c" /* consentServices */].createConsentByType(__WEBPACK_IMPORTED_MODULE_22__services__["b" /* CONSENT_PEI_URL_NAME */], formData, file);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token, classes: this.props.classes }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1380);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-notification {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  z-index: 1010;\n  width: 384px;\n  max-width: calc(100vw - 32px);\n  margin-right: 24px;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-right: 0;\n  margin-left: 24px;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationLeftFadeIn;\n}\n.ant-notification-close-icon {\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-notification-notice {\n  position: relative;\n  margin-bottom: 16px;\n  padding: 16px 24px;\n  overflow: hidden;\n  line-height: 1.5;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n.ant-notification-notice-message {\n  display: inline-block;\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  display: block;\n  width: calc(384px - 24px * 2 - 24px - 48px - 100%);\n  max-width: 4px;\n  background-color: transparent;\n  pointer-events: none;\n}\n.ant-notification-notice-message-single-line-auto-margin::before {\n  display: block;\n  content: '';\n}\n.ant-notification-notice-description {\n  font-size: 14px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-bottom: 4px;\n  margin-left: 48px;\n  font-size: 16px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 14px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  margin-left: 4px;\n  font-size: 24px;\n  line-height: 24px;\n}\n.anticon.ant-notification-notice-icon-success {\n  color: #52c41a;\n}\n.anticon.ant-notification-notice-icon-info {\n  color: #1890ff;\n}\n.anticon.ant-notification-notice-icon-warning {\n  color: #faad14;\n}\n.anticon.ant-notification-notice-icon-error {\n  color: #f5222d;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  top: 16px;\n  right: 22px;\n  color: rgba(0, 0, 0, 0.45);\n  outline: none;\n}\n.ant-notification-notice-close:hover {\n  color: rgba(0, 0, 0, 0.67);\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  opacity: 0;\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  animation-duration: 0.2s;\n  animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationFadeIn;\n  animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  animation-name: NotificationFadeOut;\n  animation-play-state: running;\n}\n@keyframes NotificationFadeIn {\n  0% {\n    left: 384px;\n    opacity: 0;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    right: 384px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    max-height: 150px;\n    margin-bottom: 16px;\n    padding-top: 16px 24px;\n    padding-bottom: 16px 24px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__ = __webpack_require__(1385);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === "Email" && !props.token);var isEmail = props.consentMethodType === "Email";var isPatient = props.consentPersonType === "Patient";var isSurrogate = props.consentPersonType === "Surrogate";var hasLanguage = props.form.getFieldValue('sb_dic_interpreter_language') !== undefined && props.form.getFieldValue('sb_dic_interpreter_language').length > 0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, props.consentPersonType === "Surrogate" ? "Consent Process - Surrogate" : "Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), props.consentPersonType === "Surrogate" ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", { style: { textAlign: "left" } }, "20. Consent Form Signature Page"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I have reviewed all the information in this consent form related to the study called:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", { style: { textAlign: "center" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("i", null, "Alteplase Compared to Tenecteplase in Patients with Acute Ischemic Stroke: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry based Pragmatic Randomized Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. You are now being asked to consent to data collection. If you decide not to consent, you will not be contacted in the future. You may also withdraw consent for further contact but continue follow-up via health record linkage. Serious adverse drug reactions and serious adverse events related to studies must be reported to authorities, whether or not you consent."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I have been given the opportunity to discuss this study. All of my questions have been answered to my satisfaction.", " "), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "I authorize access to my personal health information, and research study data as explained in this form."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "This signature on this consent form means that I agree to stay in this study. I understand that I am free to withdraw at any time without affecting my future care."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "decision-box" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("sb_dic_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I do not wish to participate in this study. Do not use any of my data."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study, but my data collected up to date may be used. I do not wish to be contacted in the future or have any more of my data collected."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study_no_contact" }, "I wish to participate in the study. My health data may be used, but I do not wish to be contacted in the future."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to participate in this study. My health data can be used, and you may contact me to answer the questionnaire in the future."))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "E-messaging (email and texting) can be used by a member or members of the research team to communicate with you while you are in this study. All local communication done with you will be done only through a Health PEI Webmail account, or by a phone issued to a research member through Health PEI. You will also receive e-messages from the research team in Calgary. All efforts are made to keep information sent or received private, but it is possible other people may be able to see, read, and change messages sent to or from Health PEI or Calgary."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, props.form.getFieldDecorator("wp_participant_agree_being_contacted", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "I give my permission to be contacted by a member or members of the research team from aHealth PEI Webmail account or aHealth PEI cell phone by research staffas well as the research staff in Calgary to communicate during this study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "I do not wish to be contacted by email or text message, unless I otherwise give permission at another time during this study"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") === "true" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "no-bottom-margin" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label", style: { display: "inline-block", width: "150px" } }, "Email"), props.form.getFieldDecorator("pei_contact_by_email", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "No"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") === "true" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label", style: { display: "inline-block", width: "150px" } }, "Text message"), props.form.getFieldDecorator("pei_contact_by_message", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "false" }, "No"))))), showForEmail && props.form.getFieldValue("wp_participant_agree_being_contacted") && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SignatureTrimmed__["a" /* default */], { fieldName: "initials_signature", label: "Initials", form: props.form })), isPatient && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Name"), props.form.getFieldDecorator("mtl_consent_participant_name", { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant Name" })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision Maker"), props.form.getFieldDecorator("mtl_consent_participant_email", { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: "Please enter the Substitute Decision Maker's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Substitute Decision Maker Email" })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("mtl_consent_participant_email", { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_participant_signature", label: "Signature of Participant", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Person Conducting the Consent Discussion Name"), props.form.getFieldDecorator("mtl_consent_investigator_name_1", { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_investigator_signature_1", label: "Signature of Person Conducting the Consent Discussion", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Principal Investigator Name"), props.form.getFieldDecorator("mtl_consent_investigator_name_2", { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_investigator_signature_2", label: "Signature of Principal Investigator", form: props.form })), isSurrogate && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Substitute Decision Maker Name"), props.form.getFieldDecorator("mtl_consent_representative_name", { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_representative_signature", label: "Signature of Participant's Substitute Decision Maker", form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Impartial Witness Name"), props.form.getFieldDecorator("mtl_consent_witness_name", { initialValue: props.mtl_consent_witness_name })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Impartial Witness Name" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "mtl_consent_witness_signature", label: "Signature of Impartial Witness", form: props.form, optional: true }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If the consent discussion has been conducted in a language other than English, please indicate:"), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Language"), props.form.getFieldDecorator("sb_dic_interpreter_language", { initialValue: props.sb_dic_interpreter_language })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: "Language" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Translator Name"), props.form.getFieldDecorator("sb_dic_interpreter_name", { initialValue: props.sb_dic_interpreter_name, rules: [{ required: hasLanguage, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Translator Name (Printed)" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_interpreter_signature", label: "Signature of Translator", form: props.form, optional: !hasLanguage })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form ACT RCCT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY TITLE:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Patients with Acute Ischemic Stroke:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "based Pragmatic Randomized:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CLINICAL STUDY REGISTRATION NUMBER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "NCT03889249")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PRINCIPAL INVESTIGATOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Heather Williams, M.D., BSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "CSCN (EMG)", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Neurologist", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "201-199 Grafton St.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Charlottetown, PE C1A 1L2", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "902-629-8872")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY SPONSOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Bijoy K. Menon M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary Room 1049A,", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Centre 1403, 29th Street", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "NW Calgary, AB, T2N 2T9", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: 403-944-8107 Fax: 403-283-2270", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "email: Bijoy.Menon@Albertahealthservices.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FUNDER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "1) Heart and Stroke Foundation of Alberta", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2) Alberta Innovates-Health Solutions", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3) Canadian Institutes of Health Research", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4) University of Calgary")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { borderBottom: '1px solid white' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "1. Introduction"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject). Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been invited to take part in a research study. A research study is a way of gathering information on a treatment, procedure or medical device or to answer a question about something that is not well understood. Taking part in this study is voluntary. It is up to you to decide whether to be in the study or not. Before you decide, you need to understand what the study is for, what risks you might take and what benefits you might receive. This consent form explains the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will tell you if there are any study timelines for making your decision.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Please ask the research team or the principal investigator to clarify anything you do not understand or would like to know more about. Make sure all your questions are answered to your satisfaction before deciding whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The researchers will:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Discuss the study with you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Answer your questions."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Be available during the study to deal with problems and answer questions."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to stay in this study because you have had an ischemic stroke. This is when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide not to take part or if you leave the study early, your usual health care will not be affected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "2. Why is there a need for this study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Stroke is an emergency where every minute counts. Because of this, you were enrolled in this study by deferral of consent. This means that you had either Alteplase or Tenecteplase without first being asked. This process was created with experts in research ethics and with stroke patients. This was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The goal of this study is to compare the drug Alteplase with the trial drug Tenecteplase. Alteplase is the existing treatment for stroke (blocked blood vessel in the brain). Tenecteplase is not approved for treatment in stroke. It is a treatment for a heart attack (a blocked blood vessel in the heart). This study is to decide if patients who receive Tenecteplase do as well as those who receive Alteplase, after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This is a", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Phase III"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "Study- The drug is given to even larger groups of people (usually 1,000 or more) to:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "confirm its effectiveness")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "monitor side effects")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "compare it to commonly used treatments")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "collect information that will allow the investigational product or test article to be used safely on the market")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is being done for many reasons. Some of these reasons are listed below:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New research has shown that tenecteplase may break down the clot in the brain better than alteplase. This is because tenecteplase connects to the clot differently than Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Tenecteplase is given in a single dose of a drug called a bolus. Alteplase is given in a single bolus followed by a 60-minute drip line of drug. This needs a special pump and two separate calculations of the dose. This difference in how the drug is given makes tenecteplase easier and ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "possibly"), " safer to give than alteplase as there is less math and equipment needed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Transfer of patients from one hospital to another is easier without the need for pumps as well as faster because you don\u2019t need to wait for the 60-minute drip line of drug to finish before transfer."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Therefore, it is possible that the use of tenecteplase in patients with stroke may result in faster treatment and transport, saving time, reducing problems and possibly improving patient results while saving on health care costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "3. What Is Being Tested?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a drug called Alteplase (tPA) can decrease brain damage from a stroke by breaking down the clot in the blocked blood vessel. This helps to return normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Even with the benefits of Alteplase reducing brain damage/disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is a different clot-busting drug that is similar to Alteplase and is often used for patients who have a heart attack. This is where there is a clot blocking a blood vessel in the heart."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Health Canada has approved the sale and use of Tenecteplase to treat heart attack. Although they have not approved its use for stroke, they have allowed its use in this clinical trial."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "One half of study participants will receive Alteplase as this is the standard treatment for stroke currently available and this group will act as a control group."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The other half of study participants will receive Tenecteplase as the study drug. The study has been designed this way to directly compare the two drugs, their side effects, and to see which one is the better treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "4. How Long Will I Be In The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The length of this study for participants is approximately 3 months or 90 days. The entire study is expected to take about 2 years to complete and the results should be known 1-2 years after the study has ended."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "5. How Many People Will Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will participate in this study throughout Canada. About 25-50 people will participate in this study at the Queen Elizabeth Hospital."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "6. How Is The Study Being Done?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Participants in this study have been randomly (by chance) placed in one of 2 study groups. Neither you, the study staff nor the investigator(s) can influence which group you were assigned. You had a 50% chance of being placed in either group. You and the research team will know which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group A: Called the Intervention Group had received the drug Tenecteplase as a single dose (called a bolus) based on your weight, as soon as possible after randomization"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group B: Called the Control Group had received the drug Alteplase via as a single dose (bolus) followed by a 60-minute drip line of the drug based on your weight as soon as possible after randomization."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All patients will receive standard stroke care on a stroke care unit after receiving either drug. While on the stroke care unit all tests will be standard tests given to all stroke patients regardless of which drug you received."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be asked to return to the hospital for 1 visit at 3 months (90 days) as standard stroke care follow up. You will also be asked to accept 1 phone call at 3 months (90-120 days) for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "7. What Will Happen If I Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "STUDY", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "We have done the following as part of this trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "We have given you one of the two drugs A) Alteplase (standard stroke treatment) or B) Tenecteplase (study stroke treatment)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "You have and will continue to receive the same stroke care that all stroke patients receive.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to stay in this study, you will be asked to do the following as part of the trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "A follow up visit at 3 months (90 days), would happen as is standard with your stroke doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There will be a one-time telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The phone call will last about 5 minutes. This call will be as close to 90 days as possible, to a limit of 120 days based on your schedule. For people who are not fluent in English, the services of an interpreter will be offered."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. This assessment will be done at 90-120 days and/or at 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "After this period (phone call and/or online assessment) is finished, your participation in the study will be complete."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may ask not to have further tests done or to participate in any study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is important that you tell the research team about any treatment therapies, drugs or medicines you are taking or wish to take. You must also tell the research team about anything unusual that is happening with your health. This includes any medical problems that seem to be getting worse. If you see another doctor or must go to a hospital, you should let the doctors know that you are in a research study. You should also tell your own doctor as quickly as possible, for your safety."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "8. Are There Risks To The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There are risks with this, or any study. To give you the most complete information available, we have listed many possible risks, which may appear alarming. We do not want to alarm you but we do want to make sure that if you decide to stay in the study, you have had a chance to think about the risks carefully. Please also be aware that there may be risks in participating in this study that we do not know about yet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There is a risk that that Tenecteplase may not be as effective in the treatment of stroke as Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During this study you will have the same number of tests using radiation that are used to diagnose or treat your existing medical condition. You will not receive any extra radiation procedures while you are enrolled in this study. The procedures will be done using established procedures of this institution and be performed by authorized persons.\u201D"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "DRUG EFFECTS"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks of Alteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths reported"), " due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Major risks for Tenecteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 3-4%, as per recent data; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100) but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is minor and easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths"), " reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may notice none, some, or all of these side effects and they may be mild, moderate, or severe. Many side effects disappear after treatment is stopped. The principal investigator may prescribe medications to ease the discomfort you may experience if any of these side effects occur. If any severe reaction to the study drug occurs, the principal investigator may interrupt or discontinue the study drug treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will be checking you closely to see if any of these side effects are occurring."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There may be side effects that are not yet known. You must tell the research team about any new symptoms you experience."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects or discomforts of tests/procedures that are part of this study but are also part of your normal clinical care will be reviewed by your treating doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "QUESTIONNAIRES:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may find the interviews and questionnaires you receive during the course of the study upsetting or distressing. You may not like all of the questions that you will be asked. You do not have to answer those questions you find too distressing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment may interfere with medications, both prescribed and over the counter that you are currently taking. You should ask the research team if the study treatment could interfere with your medications before consenting to be in this study. You should also consult with the research team before taking any new medications."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told about any new information that might reasonably affect your willingness to continue to participate in this study as soon as the information becomes available to the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "9. Are There Benefits Of Participating In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may or may not benefit directly from participating in this study. However, possible benefits include close monitoring of your stroke, general health status and any symptoms that you may experience during the study. Your participation may or may not help other people with stroke in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "10. Are There Other Choices?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "New treatments become available for this sort of condition at different times and in different parts of the world. Like many other hospitals, we do not feel it is helpful to test more than one experimental treatment for the same condition at the same time in the same person. This could even be dangerous. So, you will not receive two experimental treatments at the same time.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are free to seek other opinions or choices in other hospitals or cities if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "11. What Happens at the End of the Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment will be provided to you only during this study and not after the study is over."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study results are expected to be finished months to years after the study ends. A summary will be available on\xA0", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "12. What Are My Responsibilities?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a study participant you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Follow the directions of the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report all medications being taken or that you plan on taking;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any changes in your health to the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any problems that you experience that you think might be related to participating in the study;"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "13. Can My Participation in this Study End Early?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study sponsor, the Health PEI Research Ethics Board, Health Canada, and the principal investigator have the right to stop patient recruitment or cancel the study at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator may decide to remove you from this study without your consent for any of the following reasons:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "You do not follow the directions of the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There is new information that shows that being in this study is not in your best interests."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are withdrawn from this study, a member of the research team will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to end your participation at any time. If you choose to withdraw from this study by providing notice to the research team, your decision will have no effect on your current or future medical treatment and healthcare. Your health records may be examined in connection with this study or further analyses related to it. Your health records will only be made available as described above. However the above agencies, including the sponsor, will only look at and use study related records up to the date of your withdrawal from the study, except where it is necessary to ensure that the study is scientifically reliable and to report side effects associated with the study medication as required by regulatory authorities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may request not to have further tests done or to participate in any additional study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "14. What About New Information?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that new information may become available while you are in the study about side effects or a new treatment for your condition. You will be told about any other new information that might affect your health, welfare, or willingness to stay in the study and will be asked whether you wish to continue taking part in the study or not."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "15. Will It Cost Me Anything?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not have to pay for any study related treatments you take while participating in this study. You may need to pay for medications to treat any side effects you may experience as a result of participating in this study. Your private health care insurer may not pay for all of these added costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Research Related Injury"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you become ill or injured as a direct result of participating in this study, necessary medical treatment will be available at no additional cost to you. Your signature on this form only indicates that you have understood to your satisfaction the information regarding your participation in the study and agree to participate in the study. In no way does this waive your legal rights nor release the principal investigator, the research team, the study sponsor or involved institutions from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "16. What About My Privacy and Confidentiality?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protecting your privacy is an important part of this study and every effort to protect your privacy will be made. However, complete privacy cannot be guaranteed. For example, the principal investigator may be required by law to allow access to research records. Your family doctor will be told that you are taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are presented to the public, nobody will be able to tell that you were in the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to stay in this study, the research team will collect personal health information from you and your health record. The research team will collect and use only the information they need for this study and to judge the safety and usefulness of the study treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u201CPersonal health information\u201D is health information about you that could identify you because it includes information such as your;", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Name,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Age or month/year of birth (MM/YY),"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Information from the study interviews and questionnaires;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New and existing medical records, or"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The types, dates and results of various tests and procedures."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Other people may need to look at your personal health information to check that the information collected for the study is correct and to make sure the study followed the required laws and guidelines. These people might include:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bijoy K. Menon M.D., and its representatives and partner companies as per the title page of this consent form;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Health PEI Research Ethics Board and people working for or with the Health PEI REB because they oversee the ethical conduct of research studies within Health PEI"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Representatives of Health Canada, who oversee the use of drugs, natural health products and medical devices in research in Canada;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to collect information from the Department of Health and Wellness' SHARE Electronic Health Record (which contains laboratory test results, Diagnostic Imaging as well as admissions, discharge and transfer records from across the province"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to access your health information for/from various registries including OPTIMISE (another study database), and CIHI (another hospital database)"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "OPTIMISE collects data from hospitals in Canada including information about when you had your stroke, what treatment you had, and how that treatment worked. All data in this database are coded with a unique ID number and does not have any information that could identify you. The OPTIMISE data base will be linked to the study database discussed in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/ emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "These people will view your study records at this institution and will not take identifying information away with them. In order to complete the 90-day telephone follow up, your contact information will be sent to the research team in Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Use of Your Study Information"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Any study data about you that is sent outside of the Nova Scotia Health Authority will have a code and will not contain your name or address, or any information that directly identifies you except those needed to complete the 90-day telephone follow up. Your contact information including your phone number will be sent to the research team in Calgary. This will allow them to complete the follow up as discussed in this document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "De-identified study data may be transferred to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The sponsor and companies working for and with the sponsor and;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Regulatory authorities within Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The 90 day cognitive online assessment will be located on servers in the USA under similar security and privacy protocols used by the USA department of defense."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor and companies working for and with the sponsor will use the information collected about you during the study, only for scientific research and/or drug development purposes. Study data that is sent outside of the Nova Scotia Health Authority will be used for the research purposes explained in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team and the other people listed above will keep the information they see or receive about you confidential, to the extent permitted by applicable laws. Even though the risk of identifying you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will keep any personal health information about you in a secure and confidential location for 25 years and then destroy it according to NSHA policy. Your personal health information will not be shared with others without your permission"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After your part in the study ends, we may continue to review your health records for safety and data accuracy until the study is finished or you withdraw your consent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The REB and people working for or with the REB may also contact you personally for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please be aware that once your data is sent outside of Canada it may be accessed by regulatory authorities in other countries who may not have the same privacy laws as we do."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Your Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have the right to access, review, and request changes to your study data.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "A description of this clinical trial will be available on http://www.ClinicalTrials.gov,. This Web site will not include information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "17. Declaration of Financial Interest"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor/funder is reimbursing the principal investigator and/or the principal investigator\u2019s institution to conduct this study. The amount of payment is sufficient to cover the costs of conducting the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "18. What About Questions or Problems?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "For further information about the study you may call the principal investigator who is the person in charge of this study and/or any other research team member listed below."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator is Dr. Heather Williams", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 629-8872"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your research coordinator is Dr. Heather Williams", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 629-8872"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you experience any symptoms or possible side effects or other medical problems, please let the principal investigator or research coordinator know as soon as possible."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you can't reach the principal investigator or research coordinator, or it is after regular business hours, call ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "8-1-1")), " for advice or present to your nearest hospital emergency department."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please call the principal investigator or research coordinator the next business day to tell them about the possible side effects or other medical problems you experienced."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "19. What Are My Rights?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to all information that could help you make a decision about staying in this study. You also have the right to ask questions about this study and your rights as a research participant, and to have them answered to your satisfaction before you make any decision. You also have the right to ask questions and to receive answers throughout this study. You have the right to withdraw your consent at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a research participant, and/or concerns or complaints about this research study, you can contact the Health PEI Research Ethics Board at (902) 569-0576 or ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "reb@ihis.org")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in the future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the next part you will be asked if you agree (consent) to stay in this study. If the answer is \u201Cyes\u201D, please sign the form.")));
});

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Informed Consent Form ACT RCCT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY TITLE:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Patients with Acute Ischemic Stroke:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "QuICR and OPTIMISE Registry:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "based Pragmatic Randomized:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Controlled Trial (ACT RRCT)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "CLINICAL STUDY REGISTRATION NUMBER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "NCT03889249")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PRINCIPAL INVESTIGATOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Heather Williams, M.D., BSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "CSCN (EMG)", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Neurologist", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "201-199 Grafton St.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Charlottetown, PE C1A 1L2", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "902-629-8872")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "STUDY SPONSOR:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Bijoy K. Menon M.D., MSc, FRCPC", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "University of Calgary Room 1049A,", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Foothills Medical Centre 1403, 29th Street", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "NW Calgary, AB, T2N 2T9", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Phone: 403-944-8107 Fax: 403-283-2270", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "email: Bijoy.Menon@Albertahealthservices.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "FUNDER:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "1) Heart and Stroke Foundation of Alberta", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "2) Alberta Innovates-Health Solutions", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "3) Canadian Institutes of Health Research", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "4) University of Calgary")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { borderBottom: '1px solid white' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "1. Introduction"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, \u201Cyou\u201D throughout this consent form refers to that individual (the subject). Your obligation is to try to determine what the individual would do if competent, or if the subject\u2019s wishes cannot be determined, what you think is in the person\u2019s best interest.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have been invited to take part in a research study. A research study is a way of gathering information on a treatment, procedure or medical device or to answer a question about something that is not well understood. Taking part in this study is voluntary. It is up to you to decide whether to be in the study or not. Before you decide, you need to understand what the study is for, what risks you might take and what benefits you might receive. This consent form explains the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will tell you if there are any study timelines for making your decision.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Please ask the research team or the principal investigator to clarify anything you do not understand or would like to know more about. Make sure all your questions are answered to your satisfaction before deciding whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The researchers will:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Discuss the study with you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Answer your questions."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Be available during the study to deal with problems and answer questions."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to stay in this study because you have had an ischemic stroke. This is when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide not to take part or if you leave the study early, your usual health care will not be affected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "2. Why is there a need for this study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Stroke is an emergency where every minute counts. Because of this, you were enrolled in this study by deferral of consent. This means that you had either Alteplase or Tenecteplase without first being asked. This process was created with experts in research ethics and with stroke patients. This was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The goal of this study is to compare the drug Alteplase with the trial drug Tenecteplase. Alteplase is the existing treatment for stroke (blocked blood vessel in the brain). Tenecteplase is not approved for treatment in stroke. It is a treatment for a heart attack (a blocked blood vessel in the heart). This study is to decide if patients who receive Tenecteplase do as well as those who receive Alteplase, after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This is a", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Phase III"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "Study- The drug is given to even larger groups of people (usually 1,000 or more) to:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "confirm its effectiveness")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "monitor side effects")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "compare it to commonly used treatments")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "collect information that will allow the investigational product or test article to be used safely on the market")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study is being done for many reasons. Some of these reasons are listed below:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New research has shown that tenecteplase may break down the clot in the brain better than alteplase. This is because tenecteplase connects to the clot differently than Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Tenecteplase is given in a single dose of a drug called a bolus. Alteplase is given in a single bolus followed by a 60-minute drip line of drug. This needs a special pump and two separate calculations of the dose. This difference in how the drug is given makes tenecteplase easier and ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "possibly"), " safer to give than alteplase as there is less math and equipment needed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Transfer of patients from one hospital to another is easier without the need for pumps as well as faster because you don\u2019t need to wait for the 60-minute drip line of drug to finish before transfer."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Therefore, it is possible that the use of tenecteplase in patients with stroke may result in faster treatment and transport, saving time, reducing problems and possibly improving patient results while saving on health care costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "3. What Is Being Tested?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a drug called Alteplase (tPA) can decrease brain damage from a stroke by breaking down the clot in the blocked blood vessel. This helps to return normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Even with the benefits of Alteplase reducing brain damage/disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is a different clot-busting drug that is similar to Alteplase and is often used for patients who have a heart attack. This is where there is a clot blocking a blood vessel in the heart."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Health Canada has approved the sale and use of Tenecteplase to treat heart attack. Although they have not approved its use for stroke, they have allowed its use in this clinical trial."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "One half of study participants will receive Alteplase as this is the standard treatment for stroke currently available and this group will act as a control group."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The other half of study participants will receive Tenecteplase as the study drug. The study has been designed this way to directly compare the two drugs, their side effects, and to see which one is the better treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "4. How Long Will I Be In The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The length of this study for participants is approximately 3 months or 90 days. The entire study is expected to take about 2 years to complete and the results should be known 1-2 years after the study has ended."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "5. How Many People Will Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will participate in this study throughout Canada. About 25-50 people will participate in this study at the Queen Elizabeth Hospital."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "6. How Is The Study Being Done?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Participants in this study have been randomly (by chance) placed in one of 2 study groups. Neither you, the study staff nor the investigator(s) can influence which group you were assigned. You had a 50% chance of being placed in either group. You and the research team will know which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group A: Called the Intervention Group had received the drug Tenecteplase as a single dose (called a bolus) based on your weight, as soon as possible after randomization"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group B: Called the Control Group had received the drug Alteplase via as a single dose (bolus) followed by a 60-minute drip line of the drug based on your weight as soon as possible after randomization."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All patients will receive standard stroke care on a stroke care unit after receiving either drug. While on the stroke care unit all tests will be standard tests given to all stroke patients regardless of which drug you received."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be asked to return to the hospital for 1 visit at 3 months (90 days) as standard stroke care follow up. You will also be asked to accept 1 phone call at 3 months (90-120 days) for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "7. What Will Happen If I Take Part In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "STUDY", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "We have done the following as part of this trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "We have given you one of the two drugs A) Alteplase (standard stroke treatment) or B) Tenecteplase (study stroke treatment)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "You have and will continue to receive the same stroke care that all stroke patients receive.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to stay in this study, you will be asked to do the following as part of the trial:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "A follow up visit at 3 months (90 days), would happen as is standard with your stroke doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There will be a one-time telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The phone call will last about 5 minutes. This call will be as close to 90 days as possible, to a limit of 120 days based on your schedule. For people who are not fluent in English, the services of an interpreter will be offered."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "If you are able and interested, we will also ask you to complete an online assessment to find out if there are any differences in memory or thinking between the groups of people who got the two drugs. You do not have to complete this online assessment to be part of the main study. This assessment will be done at 90-120 days and/or at 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "After this period (phone call and/or online assessment) is finished, your participation in the study will be complete."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may ask not to have further tests done or to participate in any study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is important that you tell the research team about any treatment therapies, drugs or medicines you are taking or wish to take. You must also tell the research team about anything unusual that is happening with your health. This includes any medical problems that seem to be getting worse. If you see another doctor or must go to a hospital, you should let the doctors know that you are in a research study. You should also tell your own doctor as quickly as possible, for your safety."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "8. Are There Risks To The Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There are risks with this, or any study. To give you the most complete information available, we have listed many possible risks, which may appear alarming. We do not want to alarm you but we do want to make sure that if you decide to stay in the study, you have had a chance to think about the risks carefully. Please also be aware that there may be risks in participating in this study that we do not know about yet."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There is a risk that that Tenecteplase may not be as effective in the treatment of stroke as Alteplase."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During this study you will have the same number of tests using radiation that are used to diagnose or treat your existing medical condition. You will not receive any extra radiation procedures while you are enrolled in this study. The procedures will be done using established procedures of this institution and be performed by authorized persons.\u201D"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "DRUG EFFECTS"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks of Alteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Alteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths reported"), " due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The Major risks for Tenecteplase are:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 3-4%, as per recent data; this is the major side effect. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Bleeding into the brain may lead to death.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100) but may require specific treatment (such as surgery) or a blood transfusion."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is minor and easily controlled. This risk may occur in one of every 5 patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Very rarely, Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "This could potentially be fatal, but there have been no deaths"), " reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may notice none, some, or all of these side effects and they may be mild, moderate, or severe. Many side effects disappear after treatment is stopped. The principal investigator may prescribe medications to ease the discomfort you may experience if any of these side effects occur. If any severe reaction to the study drug occurs, the principal investigator may interrupt or discontinue the study drug treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will be checking you closely to see if any of these side effects are occurring."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "There may be side effects that are not yet known. You must tell the research team about any new symptoms you experience."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects or discomforts of tests/procedures that are part of this study but are also part of your normal clinical care will be reviewed by your treating doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "QUESTIONNAIRES:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may find the interviews and questionnaires you receive during the course of the study upsetting or distressing. You may not like all of the questions that you will be asked. You do not have to answer those questions you find too distressing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment may interfere with medications, both prescribed and over the counter that you are currently taking. You should ask the research team if the study treatment could interfere with your medications before consenting to be in this study. You should also consult with the research team before taking any new medications."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told about any new information that might reasonably affect your willingness to continue to participate in this study as soon as the information becomes available to the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "9. Are There Benefits Of Participating In This Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may or may not benefit directly from participating in this study. However, possible benefits include close monitoring of your stroke, general health status and any symptoms that you may experience during the study. Your participation may or may not help other people with stroke in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "10. Are There Other Choices?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "New treatments become available for this sort of condition at different times and in different parts of the world. Like many other hospitals, we do not feel it is helpful to test more than one experimental treatment for the same condition at the same time in the same person. This could even be dangerous. So, you will not receive two experimental treatments at the same time.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You are free to seek other opinions or choices in other hospitals or cities if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "11. What Happens at the End of the Study?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study treatment will be provided to you only during this study and not after the study is over."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study results are expected to be finished months to years after the study ends. A summary will be available on\xA0", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "12. What Are My Responsibilities?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a study participant you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Follow the directions of the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report all medications being taken or that you plan on taking;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any changes in your health to the research team;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Report any problems that you experience that you think might be related to participating in the study;"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "13. Can My Participation in this Study End Early?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study sponsor, the Health PEI Research Ethics Board, Health Canada, and the principal investigator have the right to stop patient recruitment or cancel the study at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator may decide to remove you from this study without your consent for any of the following reasons:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "You do not follow the directions of the research team."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "There is new information that shows that being in this study is not in your best interests."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are withdrawn from this study, a member of the research team will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to end your participation at any time. If you choose to withdraw from this study by providing notice to the research team, your decision will have no effect on your current or future medical treatment and healthcare. Your health records may be examined in connection with this study or further analyses related to it. Your health records will only be made available as described above. However the above agencies, including the sponsor, will only look at and use study related records up to the date of your withdrawal from the study, except where it is necessary to ensure that the study is scientifically reliable and to report side effects associated with the study medication as required by regulatory authorities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Of course, you may request not to have further tests done or to participate in any additional study procedures at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "14. What About New Information?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that new information may become available while you are in the study about side effects or a new treatment for your condition. You will be told about any other new information that might affect your health, welfare, or willingness to stay in the study and will be asked whether you wish to continue taking part in the study or not."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "15. Will It Cost Me Anything?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Compensation"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You will not have to pay for any study related treatments you take while participating in this study. You may need to pay for medications to treat any side effects you may experience as a result of participating in this study. Your private health care insurer may not pay for all of these added costs."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Research Related Injury"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "If you become ill or injured as a direct result of participating in this study, necessary medical treatment will be available at no additional cost to you. Your signature on this form only indicates that you have understood to your satisfaction the information regarding your participation in the study and agree to participate in the study. In no way does this waive your legal rights nor release the principal investigator, the research team, the study sponsor or involved institutions from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "16. What About My Privacy and Confidentiality?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Protecting your privacy is an important part of this study and every effort to protect your privacy will be made. However, complete privacy cannot be guaranteed. For example, the principal investigator may be required by law to allow access to research records. Your family doctor will be told that you are taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are presented to the public, nobody will be able to tell that you were in the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to stay in this study, the research team will collect personal health information from you and your health record. The research team will collect and use only the information they need for this study and to judge the safety and usefulness of the study treatment."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u201CPersonal health information\u201D is health information about you that could identify you because it includes information such as your;", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Name,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number,"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Age or month/year of birth (MM/YY),"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Information from the study interviews and questionnaires;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "New and existing medical records, or"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The types, dates and results of various tests and procedures."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Other people may need to look at your personal health information to check that the information collected for the study is correct and to make sure the study followed the required laws and guidelines. These people might include:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bijoy K. Menon M.D., and its representatives and partner companies as per the title page of this consent form;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Health PEI Research Ethics Board and people working for or with the Health PEI REB because they oversee the ethical conduct of research studies within Health PEI"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Representatives of Health Canada, who oversee the use of drugs, natural health products and medical devices in research in Canada;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to collect information from the Department of Health and Wellness' SHARE Electronic Health Record (which contains laboratory test results, Diagnostic Imaging as well as admissions, discharge and transfer records from across the province"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "When you sign this consent form you give us permission to access your health information for/from various registries including OPTIMISE (another study database), and CIHI (another hospital database)"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "OPTIMISE collects data from hospitals in Canada including information about when you had your stroke, what treatment you had, and how that treatment worked. All data in this database are coded with a unique ID number and does not have any information that could identify you. The OPTIMISE data base will be linked to the study database discussed in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/ emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "These people will view your study records at this institution and will not take identifying information away with them. In order to complete the 90-day telephone follow up, your contact information will be sent to the research team in Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Use of Your Study Information"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Any study data about you that is sent outside of the Nova Scotia Health Authority will have a code and will not contain your name or address, or any information that directly identifies you except those needed to complete the 90-day telephone follow up. Your contact information including your phone number will be sent to the research team in Calgary. This will allow them to complete the follow up as discussed in this document."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "De-identified study data may be transferred to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The sponsor and companies working for and with the sponsor and;"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Regulatory authorities within Canada."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The 90 day cognitive online assessment will be located on servers in the USA under similar security and privacy protocols used by the USA department of defense."))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor and companies working for and with the sponsor will use the information collected about you during the study, only for scientific research and/or drug development purposes. Study data that is sent outside of the Nova Scotia Health Authority will be used for the research purposes explained in this consent form."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team and the other people listed above will keep the information they see or receive about you confidential, to the extent permitted by applicable laws. Even though the risk of identifying you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The research team will keep any personal health information about you in a secure and confidential location for 25 years and then destroy it according to NSHA policy. Your personal health information will not be shared with others without your permission"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After your part in the study ends, we may continue to review your health records for safety and data accuracy until the study is finished or you withdraw your consent."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The REB and people working for or with the REB may also contact you personally for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please be aware that once your data is sent outside of Canada it may be accessed by regulatory authorities in other countries who may not have the same privacy laws as we do."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Your Access to Records"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have the right to access, review, and request changes to your study data.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "A description of this clinical trial will be available on http://www.ClinicalTrials.gov,. This Web site will not include information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "17. Declaration of Financial Interest"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The sponsor/funder is reimbursing the principal investigator and/or the principal investigator\u2019s institution to conduct this study. The amount of payment is sufficient to cover the costs of conducting the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "18. What About Questions or Problems?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "For further information about the study you may call the principal investigator who is the person in charge of this study and/or any other research team member listed below."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The principal investigator is Dr. Heather Williams", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 629-8872"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your research coordinator is Dr. Heather Williams", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Telephone: (902) 629-8872"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you experience any symptoms or possible side effects or other medical problems, please let the principal investigator or research coordinator know as soon as possible."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you can't reach the principal investigator or research coordinator, or it is after regular business hours, call ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "8-1-1")), " for advice or present to your nearest hospital emergency department."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please call the principal investigator or research coordinator the next business day to tell them about the possible side effects or other medical problems you experienced."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "19. What Are My Rights?"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to all information that could help you make a decision about staying in this study. You also have the right to ask questions about this study and your rights as a research participant, and to have them answered to your satisfaction before you make any decision. You also have the right to ask questions and to receive answers throughout this study. You have the right to withdraw your consent at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about your rights as a research participant, and/or concerns or complaints about this research study, you can contact the Health PEI Research Ethics Board at (902) 569-0576 or ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "reb@ihis.org")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in the future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the next part you will be asked if you agree (consent) to stay in this study. If the answer is \u201Cyes\u201D, please sign the form.")));
});

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var SignatureTrimmed = function (_React$Component) {
  _inherits(SignatureTrimmed, _React$Component);function SignatureTrimmed() {
    _classCallCheck(this, SignatureTrimmed);return _possibleConstructorReturn(this, (SignatureTrimmed.__proto__ || Object.getPrototypeOf(SignatureTrimmed)).apply(this, arguments));
  }_createClass(SignatureTrimmed, [{ key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getTrimmedCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return SignatureTrimmed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SignatureTrimmed);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(327);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === "EmailRegainedCapacity" && !props.token);var isEmail = props.consentMethodType === "EmailRegainedCapacity";var isPatient = props.consentPersonType === "Patient";var isSurrogate = props.consentPersonType === "Surrogate";var hasLanguage = props.form.getFieldValue('rccf_language') !== undefined && props.form.getFieldValue('rccf_language').length > 0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "Consent Process - REGAINED CAPACITY CONSENT FORM"), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care.")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, { className: "decision-box" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("mtl_rccf_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I do not wish to participate in this study. Do not use any of my data."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study, but my data collected up to date may be used. I do not wish to be contacted in the future or have any more of my data collected."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study_no_contact" }, "I wish to participate in the study. My health data may be used, but I do not wish to be contacted in the future."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to participate in this study. My health data can be used, and you may contact me to answer the questionnaire in the future."))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Name"), props.form.getFieldDecorator("mtl_rccf_consent_participant_name", { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant Name" })))), isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("rccf_participant_email", { initialValue: props.rccf_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_participant_signature", label: "Signature of Participant", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Person Conducting the Consent Discussion Name"), props.form.getFieldDecorator("mtl_rccf_consent_investigator_name", { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_investigator_signature", label: "Signature of Person Conducting the Consent Discussion", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Principal Investigator Name"), props.form.getFieldDecorator("rccf_investigator_name", { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Name (Printed)" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "rccf_investigator_signature", label: "Signature of Principal Investigator", form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Impartial Witness Name"), props.form.getFieldDecorator("mtl_rccf_consent_witness_name_and_relationship", { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Impartial Witness Name" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "mtl_rccf_consent_witness_signature", label: "Signature of Impartial Witness", form: props.form, optional: true }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If the consent discussion has been conducted in a language other than English, please indicate:"), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Language"), props.form.getFieldDecorator("rccf_language", { initialValue: props.rccf_language })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { placeholder: "Language" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Translator Name"), props.form.getFieldDecorator("rccf_interpreter_name", { initialValue: props.rccf_interpreter_name, rules: [{ required: hasLanguage, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Translator Name (Printed)" })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: "rccf_interpreter_signature", label: "Signature of Translator", form: props.form, optional: !hasLanguage })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypePei__contentWrap__BB6Jo"};

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeGreyNuns_ConsentForm__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentGreyNunsByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined, has_randomization_platform_step_3_patient: data['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: data['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: data['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: data['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: data['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: data['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: data['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: data['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: data['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: data['randomization_platform_step_3_deferred_content'] };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeGreyNuns_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeGreyNuns_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            } else {
                              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('Error, please check required fields', 5);
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentGreyNunsByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createGreyNuns(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(328);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === "Email";var showForEmail = !(props.consentMethodType === "Email" && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, props.consentPersonType === "Surrogate" ? "Consent Process - Surrogate" : "Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, props.consentPersonType === "Surrogate" ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "CONSENT"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("sb_dic_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to stay in the study."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "SIGNATURES"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", { style: { textAlign: "center" } }, "Dr.Muzaffar Siddiqui (780) 735-9626 ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), " or ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), " Stroke Research office (780) 735-9626"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant\u2019s Name"), props.form.getFieldDecorator("sb_dic_research_subject_name", { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant\u2019s Name" })))), props.consentMethodType === "Email" && props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), props.consentMethodType === "Email" && props.consentPersonType === "Patient" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), props.consentPersonType === "Patient" && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_research_subject_signature", label: "Signature of Participant", form: props.form })), props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Legally Authorized Representative\u2019s Name"), props.form.getFieldDecorator("sb_dic_surrogate_name", { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Legally Authorized Representative\u2019s Name" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_surrogate_signature", label: "Signature of Legally Authorized Representative", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator("sb_dic_investigator_name_and_role", { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_investigator_signature", label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Witness\u2019 Name (If applicable)"), props.form.getFieldDecorator("sb_dic_witness_name", { initialValue: props.sb_dic_witness_name })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Witness Name" })))), props.form.getFieldValue("sb_dic_witness_name") && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_witness_signature", label: "Signature of Witness", form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form will be is provided for your records and reference.")));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "PATIENT CONSENT FORM NOT LOADED")));
});

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "SURROGATE CONSENT FORM NOT LOADED")));
});

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(328);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'center' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null, 'REGAINED CONSENT FORM NOT LOADED')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'REGAINED CAPACITY CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'center' } }, 'Dr. Herbert Alejandro Manosalva A. (403) 529-8810 ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' or ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' the Stroke Research office (403) 944-4286'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Witness\u2019 Name"), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeGreyNuns__contentWrap__3kR-0"};

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConsentTypeRedDeerCalgary_css__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConsentTypeRedDeerCalgary_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ConsentTypeRedDeerCalgary_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ConsentTypeRedDeerCalgary_Consent__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reducers_consent_selectors__ = __webpack_require__(57);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var ConsentComponent = function (_React$Component) {
  _inherits(ConsentComponent, _React$Component);function ConsentComponent(props) {
    _classCallCheck(this, ConsentComponent);var _this = _possibleConstructorReturn(this, (ConsentComponent.__proto__ || Object.getPrototypeOf(ConsentComponent)).call(this, props));_this.handleChange = function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;_this.setState(_defineProperty({}, name, value));
    };_this.handleDatePickerChange = function (event) {
      _this.setState({ dateOfBirth: event });
    };_this.handleSigChange = function (event) {
      _this.setState({ signature: event }, function () {
        // console.log(this.state.signature);
        console.log('');
      });
    };_this.handleWitnessSigChange = function (event) {
      _this.setState({ witnessSignature: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handleInvestigatorSigChange = function (event) {
      _this.setState({ investigatorSignature: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handleFileChange = function (event) {
      _this.setState({ consentFile: event }, function () {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    };_this.handlePrev = function () {
      _this.props.history.push('/consent');
    };_this.state = { currentStep: 'Step 1', currentStepType: '', currentStepInt: 1, subjectID: '', userID: '', siteID: '', consentType: '', consentPersonType: '', consentMethodType: '', fullName: '', dateOfBirth: '', signature: '', sigPad: {}, representativeFullName: '', witnessFullName: '', witnessSignature: '', witnessSigPad: {}, investigatorFullName: '', investigatorSignature: '', investigatorSigPad: {}, date: '', consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, fileListDc: {}, datasetdc: {}, fileListWithdraw: {}, datasetwithdraw: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: false, consentExistsOverwrite: true, consentExistsType: '', consentExistsPersonType: '', consentExistsMethodType: '', consentExistsEmailStatus: '', consentExistsLink: '', consentExistsDate: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: false, randomization_platform_step_3_patient_content: '', has_randomization_platform_step_3_patient_regained_capacity: false, randomization_platform_step_3_patient_regained_capacity_content: '', has_randomization_platform_step_3_surrogate: false, randomization_platform_step_3_surrogate_content: '', has_randomization_platform_step_3_withdraw: false, randomization_platform_step_3_withdraw_content: '', has_randomization_platform_step_3_deferred: false, randomization_platform_step_3_deferred_content: '' };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.handleReset = _this.handleReset.bind(_this);_this.handleChange = _this.handleChange.bind(_this);_this.handleDatePickerChange = _this.handleDatePickerChange.bind(_this);_this.handleSigChange = _this.handleSigChange.bind(_this);_this.handleWitnessSigChange = _this.handleWitnessSigChange.bind(_this);_this.handleInvestigatorSigChange = _this.handleInvestigatorSigChange.bind(_this);_this.handleFileChange = _this.handleFileChange.bind(_this);_this.fileDummyRequest = _this.fileDummyRequest.bind(_this);_this.normFile = _this.normFile.bind(_this);_this.handleNext = _this.handleNext.bind(_this);_this.handlePrev = _this.handlePrev.bind(_this);return _this;
  }_createClass(ConsentComponent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, consentResponse, _ref2, data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 7;break;
                }consentResponse = this.props.consentData;this.setState({ siteID: consentResponse.siteID, userID: consentResponse.userID, currentStep: 'Step 2', currentStepInt: 2, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentDate: consentResponse['consentDate'], consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: false, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: consentResponse['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: consentResponse['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: consentResponse['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: consentResponse['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: consentResponse['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: consentResponse['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: consentResponse['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: consentResponse['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: consentResponse['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: consentResponse['randomization_platform_step_3_deferred_content'] });this.props.consentUpdate({});_context.next = 24;break;case 7:
                if (!token) {
                  _context.next = 23;break;
                }this.setState({ currentStep: 'Step 3a', currentStepType: 'step2patientEmail', // consentPersonType: 'Patient',
                  consentOverwrite: 'yes', consentMethodType: 'Email', investigatorFullName: 'TestName' });_context.prev = 9;_context.next = 12;return __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].getConsentRedDeerByToken(token);case 12:
                _ref2 = _context.sent;data = _ref2.data;this.setState(Object.assign({}, data, { consentPersonType: data.consentExistsPersonType, consentMethodType: data.consentExistsMethodType }));_context.next = 21;break;case 17:
                _context.prev = 17;_context.t0 = _context['catch'](9);this.handleReset();this.props.history.push('/consent_error');case 21:
                _context.next = 24;break;case 23:
                this.props.history.push('/consent');case 24:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[9, 17]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'fileDummyRequest', value: function fileDummyRequest(_ref3) {
      var file = _ref3.file,
          onSuccess = _ref3.onSuccess;setTimeout(function () {
        onSuccess("ok");
      }, 0);
    } }, { key: 'normFile', value: function normFile(e) {
      // console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }this.setState({ fileList: e.fileList }, function () {
        //console.log(this.state.fileList);
        console.log('');
      });return e && e.fileList;
    } }, { key: 'handleSubmit', value: function handleSubmit(values) {
      var _this2 = this;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');this.setState({ loading: true, currentStep: 'Step 4', currentStepInt: 4 });if (token) {
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].confirmConsentRedDeerByToken(token, Object.assign({}, values, this.state)).then(function (response) {
          var consentResponse = response.data;
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this2.setState({ consentExists: false, consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].createRedDeer(values).then(function (response) {
          var consentResponse = response.data;
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this2.setState({ consentExists: false, consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        });
      }
    } }, { key: 'handleReset', value: function handleReset() {
      this.setState({ currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: '', consentFile: {}, consentFileDc: {}, consentFileWithdraw: {}, fileList: {}, dataset: {}, fileListDc: {}, datasetdc: {}, fileListWithdraw: {}, datasetwithdraw: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: false, consentExistsOverwrite: false, consentExistsType: '', consentExistsPersonType: '', consentExistsMethodType: '', consentExistsEmailStatus: '', consentExistsDate: '', consentExistsLink: '', consentSaved: false, consentSavedLink: '', submitted: false, loading: false, has_randomization_platform_step_3_patient: false, randomization_platform_step_3_patient_content: '', has_randomization_platform_step_3_patient_regained_capacity: false, randomization_platform_step_3_patient_regained_capacity_content: '', has_randomization_platform_step_3_surrogate: false, randomization_platform_step_3_surrogate_content: '', has_randomization_platform_step_3_withdraw: false, randomization_platform_step_3_withdraw_content: '', has_randomization_platform_step_3_deferred: false, randomization_platform_step_3_deferred_content: '' });
    } }, { key: 'handleNext', value: function handleNext(values) {
      var _this3 = this;var _state = this.state,
          currentStep = _state.currentStep,
          currentStepInt = _state.currentStepInt;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');if (currentStep === 'Step 2' && this.state.consentMethodType === 'Electronic') {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && (this.state.consentMethodType === 'Email' || this.state.consentMethodType === 'EmailRegainedCapacity')) {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && this.state.consentMethodType === 'Paper') {
        this.setState({ currentStep: 'Step 3b', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 2' && this.state.consentMethodType === 'RegainedCapacity') {
        this.setState({ currentStep: 'Step 3a', currentStepInt: 3, consentExistsOverwrite: true });
      } else if (currentStep === 'Step 3a' && this.state.consentExistsOverwrite && this.state.consentProvided === 'yes') {
        if (values['dateOfBirth']) {
          values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD');
        } // window.alert('step 3 submit: DOB: ' + values['dateOfBirth'] + ' .. ' + moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD') + ' .. ' + Date())
        this.setState({ loading: true });if (token) {
          __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].confirmConsentRedDeerByToken(token, this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature']).then(function (response) {
            var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], has_randomization_platform_step_3_patient: consentResponse['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: consentResponse['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: consentResponse['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: consentResponse['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: consentResponse['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: consentResponse['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: consentResponse['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: consentResponse['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: consentResponse['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: consentResponse['randomization_platform_step_3_deferred_content'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
          }, function (error) {
            if (error.response) {
              var errors = error.response.data.error;if (errors) {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
              }
            }_this3.handleReset();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].createRedDeer(this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature']).then(function (response) {
            var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
          }, function (error) {
            if (error.response) {
              var errors = error.response.data.error;if (errors) {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
              }
            }_this3.handleReset();
          });
        }
      } else if (currentStep === 'Step 3b' && this.state.consentExistsOverwrite) {
        this.setState({ loading: true }); //        console.log(values['consentFile'])
        //        console.log(this.state.fileList)
        __WEBPACK_IMPORTED_MODULE_14__services__["c" /* consentServices */].createRedDeer(this.state, '', '', '', '', values['consentFile']).then(function (response) {
          var consentResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: consentResponse['subjectID'], consentType: '', consentPersonType: '', consentMethodType: '', currentStepType: '', fullName: '', dateOfBirth: '', signature: '', witnessSignature: '', witnessFullName: '', representativeFullName: '', investigatorSignature: '', investigatorFullName: '', date: consentResponse['consentDate'], consentFile: {}, fileList: {}, dataset: {}, consentProvided: '', consentOption: '', consentPaperBlankLink: '', consentPaperUpload: '', consentExists: consentResponse['consentExists'], consentExistsOverwrite: true, consentExistsType: consentResponse['consentExistsType'], consentExistsPersonType: consentResponse['consentExistsPersonType'], consentExistsMethodType: consentResponse['consentExistsMethodType'], consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'], consentExistsDate: consentResponse['consentExistsDate'], consentExistsLink: consentResponse['consentExistsLink'], consentSaved: false, consentSavedLink: '', submitted: false, loading: false });
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.handleReset();
        });
      } else {
        this.handleReset();
      }
    } }, { key: 'render', value: function render() {
      var _state2 = this.state,
          loading = _state2.loading,
          consentSaved = _state2.consentSaved;var token = __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_15__ConsentTypeRedDeerCalgary_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_15__ConsentTypeRedDeerCalgary_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ConsentTypeRedDeerCalgary_Consent__["a" /* default */], Object.assign({ token: token, loading: loading }, this.state, { handleChange: this.handleChange, handleDatePickerChange: this.handleDatePickerChange, handleSigChange: this.handleSigChange, handleWitnessSigChange: this.handleWitnessSigChange, handleInvestigatorSigChange: this.handleInvestigatorSigChange, handleFileChange: this.handleFileChange, fileDummyRequest: this.fileDummyRequest, normFile: this.normFile, handleSubmit: this.handleSubmit, handleNext: this.handleNext, handlePrev: this.handlePrev }))))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Footer_Footer__["a" /* default */], null)));
    } }]);return ConsentComponent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_17__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(ConsentComponent));

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ConsentTypeRedDeerCalgary__content__2wKl6","parentContainer":"ConsentTypeRedDeerCalgary__parentContainer__1g7y4"};

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Step1_js__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step2_js__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step3aPatient_js__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatientEmail__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aSurrogate__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aSurrogateEmail__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacityEmail__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step3b_js__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Step4_js__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas__);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, Consent);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Consent.__proto__ || Object.getPrototypeOf(Consent)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleSubmit(values);
        }
      });
    }, _this.handleNext = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;if (values['currentStep'] === 'Step 3a') {
            if (_this.props.consentMethodType !== 'Email' && _this.props.consentMethodType !== 'EmailRegainedCapacity' || _this.props.token) {
              values['signature'] = _this.sigPad.getTrimmedCanvas().toDataURL('image/png');if (_this.witnessSigPad) {
                values['witnessSignature'] = _this.witnessSigPad.getTrimmedCanvas().toDataURL('image/png');
              }_this.props.handleSigChange(values['signature']);_this.props.handleWitnessSigChange(values['witnessSignature']);
            }if (!_this.props.token) {
              values['investigatorSignature'] = _this.investigatorSigPad.getTrimmedCanvas().toDataURL('image/png');
            }_this.props.handleInvestigatorSigChange(values['investigatorSignature']);
          } else if (values['currentStep'] === 'Step 3b') {
            _this.props.handleFileChange(values['consentFile']);
          }_this.props.handleNext(values);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Consent, [{ key: 'previousButton', value: function previousButton() {
      var _props = this.props,
          currentStep = _props.currentStep,
          currentStepType = _props.currentStepType;if (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment, null, currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.props.handlePrev }, 'Back')));
      }return null;
    } }, { key: 'nextButton', value: function nextButton() {
      var _props2 = this.props,
          currentStep = _props2.currentStep,
          currentStepInt = _props2.currentStepInt;if (currentStep === 'Step 1' || currentStep === 'Step 2') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Next'));
      } else if (currentStep === 'Step 3a' || currentStep === 'Step 3b') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Submit'));
      }return null;
    } }, { key: 'signatureCanvas', value: function signatureCanvas() {
      var _this2 = this;var getFieldDecorator = this.props.form.getFieldDecorator;var _props3 = this.props,
          currentStep = _props3.currentStep,
          currentStepInt = _props3.currentStepInt,
          consentMethodType = _props3.consentMethodType,
          currentStepType = _props3.currentStepType;if (currentStep === 'Step 3a') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, (consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' || currentStepType === 'step2patientEmail') && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Participant/Legally Authorized Representative Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'Signature', name: 'Signature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref2) {
            _this2.sigPad = _ref2;
          } }))), consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Witness Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'witnessSignature', name: 'witnessSignature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref3) {
            _this2.witnessSigPad = _ref3;
          } }))), currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Investigator/Delegate Signature'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_signature_canvas___default.a, { clearOnResize: false, penColor: 'black', id: 'investigatorSignature', name: 'investigatorSignature', canvasProps: { backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas' }, ref: function ref(_ref4) {
            _this2.investigatorSigPad = _ref4;
          } }))), (consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' || currentStepType === 'step2patientEmail') && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.sigPad.clear();
          } }, 'Clear Participant/Surrogate Signature')), consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.witnessSigPad.clear();
          } }, 'Clear Witness Signature')), currentStepType !== 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: function onClick(e) {
            _this2.investigatorSigPad.clear();
          } }, 'Clear Investigator Signature')));
      }
    } }, { key: 'render', value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;var ConsentFormStep3aPatientComponent = this.props.consentMethodType === 'Email' ? __WEBPACK_IMPORTED_MODULE_13__Step3aPatientEmail__["a" /* ConsentFormStep3aPatientEmail */] : __WEBPACK_IMPORTED_MODULE_12__Step3aPatient_js__["a" /* ConsentFormStep3aPatient */];var ConsentFormStep3aSurrogateComponent = this.props.consentMethodType === 'Email' ? __WEBPACK_IMPORTED_MODULE_15__Step3aSurrogateEmail__["a" /* ConsentFormStep3aSurrogateEmail */] : __WEBPACK_IMPORTED_MODULE_14__Step3aSurrogate__["a" /* ConsentFormStep3aSurrogate */];var ConsentFormStep3aRegainedCapacityComponent = this.props.consentMethodType === 'EmailRegainedCapacity' ? __WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacityEmail__["a" /* ConsentFormStep3aRegainedCapacityEmail */] : __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* ConsentFormStep3aRegainedCapacity */];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h2', null, ' Consent - ', this.props.currentStep), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Step1_js__["a" /* ConsentFormStep1 */], { consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Step2_js__["a" /* ConsentFormStep2 */], { consentExistsEmailStatus: this.props.consentExistsEmailStatus, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, consentExists: this.props.consentExists, consentExistsOverwrite: this.props.consentExistsOverwrite, consentExistsLink: this.props.consentExistsLink, consentExistsType: this.props.consentExistsType, consentExistsPersonType: this.props.consentExistsPersonType, consentExistsMethodType: this.props.consentExistsMethodType, consentExistsDate: this.props.consentExistsDate, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aPatientComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, currentStepType: this.props.currentStepType, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_patient: this.props.has_randomization_platform_step_3_patient, randomization_platform_step_3_patient_content: this.props.randomization_platform_step_3_patient_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aSurrogateComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, representativeFullName: this.props.representativeFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, currentStepType: this.props.currentStepType, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_surrogate: this.props.has_randomization_platform_step_3_surrogate, randomization_platform_step_3_surrogate_content: this.props.randomization_platform_step_3_surrogate_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConsentFormStep3aRegainedCapacityComponent, { participantEmail: this.props.participantEmail, consentExistsDate: this.props.consentExistsDate, consentDate: this.props.consentDate, currentStepType: this.props.currentStepType, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleDatePickerChange: this.props.handleDatePickerChangeChange, handleSigChange: this.props.handleSigChange, handleWitnessSigChange: this.props.handleWitnessSigChange, handleInvestigatorSigChange: this.props.handleInvestigatorSigChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, representativeFullName: this.props.representativeFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentProvided: this.props.consentProvided, consentOption: this.props.consentOption, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator, has_randomization_platform_step_3_patient_regained_capacity: this.props.has_randomization_platform_step_3_patient_regained_capacity, randomization_platform_step_3_patient_regained_capacity_content: this.props.randomization_platform_step_3_patient_regained_capacity_content }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3b_js__["a" /* ConsentFormStep3b */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, date: this.props.date, fileDummyRequest: this.props.fileDummyRequest, normFile: this.props.normFile, consentFile: this.props.consentFile, handleFileChange: this.props.handleFileChange, fileList: this.props.fileList, dataset: this.props.dataset, consentProvided: this.props.consentProvided, consentPaperBlankLink: this.props.consentPaperBlankLink, consentPaperUpload: this.props.consentPaperUpload, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step4_js__["a" /* ConsentFormStep4 */], { token: this.props.token, currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, consentType: this.props.consentType, consentPersonType: this.props.consentPersonType, consentMethodType: this.props.consentMethodType, fullName: this.props.fullName, dateOfBirth: this.props.dateOfBirth, signature: this.props.signature, witnessSignature: this.props.witnessSignature, witnessFullName: this.props.witnessFullName, investigatorSignature: this.props.investigatorSignature, investigatorFullName: this.props.investigatorFullName, date: this.props.date, consentPaperBlankLink: this.props.consentPaperBlankLink, consentPaperUpload: this.props.consentPaperUpload, consentExistsPersonType: this.props.consentExistsPersonType, consentExistsMethodType: this.props.consentExistsMethodType, consentExistsEmailStatus: this.props.consentExistsEmailStatus, consentExists: this.props.consentExists, consentExistsLink: this.props.consentExistsLink, consentSaved: this.props.consentSaved, consentSavedLink: this.props.consentSavedLink, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), this.signatureCanvas(), this.nextButton(), this.previousButton()), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA', width: '12rem' }, className: 'menu-item' }, ' Home ')))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var ConsentFormStep1 = function ConsentFormStep1(props) {
  if (props.currentStep !== 'Step 1') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('siteID', { initialValue: props.siteID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input site id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'medicine-box', style: { color: '#FAFAFA' } }), id: 'siteID', name: 'siteID', placeholder: 'Site ID', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('userID', { initialValue: props.userID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input user id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), id: 'userID', name: 'userID', placeholder: 'User ID', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('subjectID', { initialValue: props.subjectID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input subject id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'subjectID', name: 'subjectID', placeholder: 'Subject ID', allowClear: true, size: 'large' }))));
};

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var ConsentFormStep2 = function ConsentFormStep2(props) {
  var consentExistsText;if (props.currentStep !== 'Step 2') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Subject Found! Please verify details below:'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExists === true ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null, 'No'))), function () {
    if (props.consentExists) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsMethodType)), ['Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsEmailStatus.replace(/_/g, ' '))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Document Link: ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: props.consentExistsLink, target: '_blank' }, 'Consent Document'))));
    }
  }(), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType, onChange: props.handleChange, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Who will be providing Consent?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentPersonType', name: 'consentPersonType', autoFocus: true, size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Consent Person'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentMethodType', { initialValue: props.consentMethodType, onChange: props.handleChange, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Consent Type'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentMethodType', name: 'consentMethodType', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Consent Type'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Electronic' }, 'Electronic Signature'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Email' }, 'Email'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'Paper' }, 'Paper'))))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOverwrite', { initialValue: props.consentOverwrite, onChange: props.handleChange, rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5', null, 'Overwrite existing consent, if it exists?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select', { id: 'consentOverwrite', name: 'consentOverwrite', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'Overwrite Consent?'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aPatient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);










var ConsentFormStep3aPatient = function ConsentFormStep3aPatient(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'Electronic') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('dateOfBirth', { initialValue: props.dateOfBirth, onChange: props.handleDatePickerChange, rules: [{ required: false, message: 'Please select your Date of Birth' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'dateOfBirth', name: 'dateOfBirth', placeholder: 'Date of Birth (optional)', allowClear: true, size: 'large', className: 'ant-input ant-input-lg' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('witnessFullName', { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'witnessFullName', name: 'witnessFullName', placeholder: 'Witness Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Do you consent to the terms described above? If no, please click on the Back button!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aPatientEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);








var ConsentFormStep3aPatientEmail = function ConsentFormStep3aPatientEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'Email') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Patient'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Participant Email', size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aSurrogate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);










var ConsentFormStep3aSurrogate = function ConsentFormStep3aSurrogate(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Surrogate' || props.consentMethodType !== 'Electronic') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Surrogate'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('dateOfBirth', { initialValue: props.dateOfBirth, onChange: props.handleDatePickerChange, rules: [{ required: false, message: 'Please select the Participant\'s Date of Birth' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'dateOfBirth', name: 'dateOfBirth', placeholder: 'Participant Date of Birth (optional)', allowClear: true, size: 'large', className: 'ant-input ant-input-lg' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('representativeFullName', { initialValue: props.representativeFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Legally Authorized Representative\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'representativeFullName', name: 'representativeFullName', placeholder: 'Representative\'s Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('witnessFullName', { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'witnessFullName', name: 'witnessFullName', placeholder: 'Witness Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Do you consent to the terms described above? If no, please click on the Back button!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aSurrogateEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);








var ConsentFormStep3aSurrogateEmail = function ConsentFormStep3aSurrogateEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Surrogate' || props.consentMethodType !== 'Email') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Surrogate'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Legally Authorized Representative\'s full name'), props.getFieldDecorator('representativeFullName', { initialValue: props.representativeFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Legally Authorized Representative\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'representativeFullName', name: 'representativeFullName', placeholder: 'Representative\'s Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the representative\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Representative\'s Email', size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aRegainedCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);










var ConsentFormStep3aRegainedCapacity = function ConsentFormStep3aRegainedCapacity(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'RegainedCapacity') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Electronic Consent Process - Regained capacity'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('dateOfBirth', { initialValue: props.dateOfBirth || null, onChange: props.handleDatePickerChange, rules: [{ required: false, message: 'Please select the Participant\'s Date of Birth' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'dateOfBirth', name: 'dateOfBirth', placeholder: 'Participant Date of Birth (optional)', allowClear: true, size: 'large', className: 'ant-input ant-input-lg' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('witnessFullName', { initialValue: props.witnessFullName, onChange: props.handleChange })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'witnessFullName', name: 'witnessFullName', placeholder: 'Witness Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Do you consent to the terms described above? If no, please click on the Back button!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3aRegainedCapacityEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);








var ConsentFormStep3aRegainedCapacityEmail = function ConsentFormStep3aRegainedCapacityEmail(props) {
  if (props.currentStep !== 'Step 3a' || props.consentPersonType !== 'Patient' || props.consentMethodType !== 'EmailRegainedCapacity') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Email Consent Process - Regained capacity'), props.siteID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Form not loaded.')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Created Date (UTC): ', props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType === 'EmailRegainedCapacity' ? 'Email Regained Capacity' : props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Participant\'s full name'), props.getFieldDecorator('fullName', { initialValue: props.fullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'fullName', name: 'fullName', placeholder: 'Participant Full Name', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('participantEmail', { initialValue: props.participantEmail, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', id: 'participantEmail', name: 'participantEmail', placeholder: 'Participant Email', size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { textAlign: 'left', color: '#fff' } }, 'Investigator/Delegate\'s full name'), props.getFieldDecorator('investigatorFullName', { initialValue: props.investigatorFullName, onChange: props.handleChange, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.currentStepType === 'step2patientEmail', prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'investigatorFullName', name: 'investigatorFullName', placeholder: 'Investigator/Delegate Full Name', allowClear: true, size: 'large' }))), props.currentStepType === 'step2patientEmail' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentOption', { initialValue: props.consentOption, onChange: props.handleChange, rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Please select consent option below:'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentOption', name: 'consentOption', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Consent Option?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'stay_in_study' }, 'I wish to stay in the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage'))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you confirm the options selected above are correct?' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', null, 'Do you confirm the options selected above are correct?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep3b; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);










var ConsentFormStep3b = function ConsentFormStep3b(props) {
  if (props.currentStep !== 'Step 3b') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: props.fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.getFieldDecorator('consentProvided', { initialValue: props.consentProvided, onChange: props.handleChange, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Do you consent to the terms described above? If no, please click on the Back button!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'consentProvided', name: 'consentProvided', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Provide Consent?'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentFormStep4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ConsentFormStep4 = function ConsentFormStep4(props) {
  if (props.currentStep !== 'Step 4') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, !props.token && (props.consentExistsMethodType === 'Email' || props.consentExistsMethodType === 'EmailRegainedCapacity') ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsMethodType)), ['Email', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExistsEmailStatus.replace(/_/g, ' '))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink, target: '_blank' }, 'Consent Document'))));
};

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeMedicineHat_ConsentForm__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentMedicineHatByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined, has_randomization_platform_step_3_patient: data['has_randomization_platform_step_3_patient'], randomization_platform_step_3_patient_content: data['randomization_platform_step_3_patient_content'], has_randomization_platform_step_3_patient_regained_capacity: data['has_randomization_platform_step_3_patient_regained_capacity'], randomization_platform_step_3_patient_regained_capacity_content: data['randomization_platform_step_3_patient_regained_capacity_content'], has_randomization_platform_step_3_surrogate: data['has_randomization_platform_step_3_surrogate'], randomization_platform_step_3_surrogate_content: data['randomization_platform_step_3_surrogate_content'], has_randomization_platform_step_3_withdraw: data['has_randomization_platform_step_3_withdraw'], randomization_platform_step_3_withdraw_content: data['randomization_platform_step_3_withdraw_content'], has_randomization_platform_step_3_deferred: data['has_randomization_platform_step_3_deferred'], randomization_platform_step_3_deferred_content: data['randomization_platform_step_3_deferred_content'] };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeMedicineHat_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeMedicineHat_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            } else {
                              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('Error, please check required fields', 5);
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentMedicineHatByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createMedicineHat(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Signature__ = __webpack_require__(329);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: "componentDidMount", value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: "render", value: function render() {
      var props = this.props;var isEmail = props.consentMethodType === "Email";var showForEmail = !(props.consentMethodType === "Email" && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, props.consentPersonType === "Surrogate" ? "Consent Process - Surrogate" : "Consent Process - Patient"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-group-details" }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Site ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "User ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h5", null, "Subject ID: ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b", null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, props.consentPersonType === "Surrogate" ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Server Date (UTC): ", props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Type: ", props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong", null, "Consent Method: ", props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { style: { textAlign: "left" } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "CONSENT"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Please check the appropriate box to indicate your decision:"), props.form.getFieldDecorator("sb_dic_consent_option", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "stay_in_study" }, "I wish to stay in the study."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study" }, "I wish to withdraw from the study"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: "withdraw_from_study_allow_data_collection_via_linkage" }, "I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h4", null, "SIGNATURES"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", { style: { textAlign: "center" } }, "Dr. Herbert Alejandro Manosalva A. (403) 529-8810 ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), " or ", __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), " Stroke Research office (403) 944-4286"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant\u2019s Name"), props.form.getFieldDecorator("sb_dic_research_subject_name", { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Participant\u2019s Name" })))), props.consentMethodType === "Email" && props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), props.consentMethodType === "Email" && props.consentPersonType === "Patient" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Participant Email"), props.form.getFieldDecorator("sb_dic_participant_email", { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: "Please enter the participant's email" }, { type: "email" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: "Participant Email" })))), props.consentPersonType === "Patient" && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_research_subject_signature", label: "Signature of Participant", form: props.form })), props.consentPersonType === "Surrogate" && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Legally Authorized Representative\u2019s Name"), props.form.getFieldDecorator("sb_dic_surrogate_name", { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Legally Authorized Representative\u2019s Name" })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_surrogate_signature", label: "Signature of Legally Authorized Representative", form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator("sb_dic_investigator_name_and_role", { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_investigator_signature", label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Witness\u2019 Name (If applicable)"), props.form.getFieldDecorator("sb_dic_witness_name", { initialValue: props.sb_dic_witness_name })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#eee" } }), placeholder: "Witness Name" })))), props.form.getFieldValue("sb_dic_witness_name") && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Signature__["a" /* default */], { fieldName: "sb_dic_witness_signature", label: "Signature of Witness", form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "form-label" }, "Do you consent to the terms described above?"), props.form.getFieldDecorator("consent_provided", { initialValue: props.consent_provided, rules: [{ required: true, message: "Do you consent to the terms described above?" }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: "" }, "No")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p", null, "The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form will be is provided for your records and reference.")));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "PATIENT CONSENT FORM NOT LOADED")));
});

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "SURROGATE CONSENT FORM NOT LOADED")));
});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(329);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'center' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null, 'REGAINED CONSENT FORM NOT LOADED')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'REGAINED CAPACITY CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your surrogate to stay in the trial for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. Any information that was obtained when the researchers were acting on your surrogate\u2019s consent for your involvement will remain part of the study, but it is now your choice whether to continue or not. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURES'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient\u2019s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient\u2019slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:"), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', { style: { textAlign: 'center' } }, 'Dr. Herbert Alejandro Manosalva A. (403) 529-8810 ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' or ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), ' the Stroke Research office (403) 944-4286'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: "Investigator/Delegate\u2019s Name" })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: "Signature of Investigator/Delegate\u2019s", form: props.form })), showForEmail && !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Witness\u2019 Name"), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature of Witness', form: props.form, optional: false })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeMedicineHat__contentWrap__2j4lR"};

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeLethbridge_ConsentForm__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentLethbridgeByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), pcf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.pcf_participant_email') || undefined, dc_patient_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.dc_patient_name') || undefined, wcf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wcf_participant_email') || undefined, wcf_person_obtaining_consent_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wcf_person_obtaining_consent_name') || undefined, wcf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.wcf_participant_name') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeLethbridge_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeLethbridge_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aInvestigator__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacity__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step3aWithdrawal__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Step3b__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Step4__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Signature__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }if (Array.isArray(values['consentFileDc']) && !values['consentFileDc'].length) {
                                values['consentFileDc'] = null;
                              }if (Array.isArray(values['consentFileWithdraw']) && !values['consentFileWithdraw'].length) {
                                values['consentFileWithdraw'] = null;
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: 'Investigator' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_22__services__["c" /* consentServices */].confirmConsentLethbridgeByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_22__services__["c" /* consentServices */].createLethbridge(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && currentStepPerson === 'Investigator' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aInvestigator__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'dc_investigator_signature', dateFieldName: 'dc_investigator_signature_datetime', label: 'Signature of investigator/designee', form: this.props.form })), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token })), consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'pcf_research_subject_signature', dateFieldName: 'pcf_research_subject_datetime', label: 'Signature of Research Subject', form: this.props.form }), consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'pcf_sdm_signature', label: 'Substitute Decision Maker', form: this.props.form }), consentMethodType !== 'Email' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'pcf_investigator_signature', dateFieldName: 'pcf_investigator_signature_datetime', label: 'Signature of investigator/designee', form: this.props.form, fromDataURL: step.dc_investigator_signature })), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token })), (token || consentMethodType !== 'EmailRegainedCapacity') && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', dateFieldName: 'rccf_participant_datetime', label: 'Participant/Legally Authorized Representative Signature', form: this.props.form }), !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', dateFieldName: 'rccf_investigator_datetime', label: "Investigator/Delegate\u2019s Name", form: this.props.form })), currentStep === 'Step 3a' && ['WithdrawConsentElectronic', 'WithdrawConsentEmail'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step3aWithdrawal__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token })), (token || consentMethodType !== 'WithdrawConsentEmail') && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'wcf_participant_signature', dateFieldName: 'wcf_participant_datetime', label: "Participant\u2019s Signature", form: this.props.form, fromDataURL: step.pcf_research_subject_signature }), !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Signature__["a" /* default */], { fieldName: 'wcf_person_obtaining_consent_signature', dateFieldName: 'wcf_person_obtaining_consent_datetime', label: 'Person obtaining consent Signature', form: this.props.form, fromDataURL: step.pcf_investigator_signature })), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'WithdrawConsentElectronic' }, 'Withdraw Consent Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'WithdrawConsentPaper' }, 'Withdraw Consent Paper'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'WithdrawConsentEmail' }, 'Withdraw Consent Email'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__ = __webpack_require__(1428);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you understand that you have been asked to be in a research study?'), props.form.getFieldDecorator('pcf_question_1', { initialValue: props.pcf_question_1, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Have you read and received a copy of the attached Information Sheet?'), props.form.getFieldDecorator('pcf_question_2', { initialValue: props.pcf_question_2, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you understand the benefits and risks involved in taking part in this research study?'), props.form.getFieldDecorator('pcf_question_3', { initialValue: props.pcf_question_3, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Have you had an opportunity to ask questions and discuss this study?'), props.form.getFieldDecorator('pcf_question_4', { initialValue: props.pcf_question_4, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you understand that you are free to withdraw from the study at any time, without having to give a reason and without affecting your future medical care?'), props.form.getFieldDecorator('pcf_question_5', { initialValue: props.pcf_question_5, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Has the issue of confidentiality been explained to you?'), props.form.getFieldDecorator('pcf_question_6', { initialValue: props.pcf_question_6, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you understand who will have access to your records, including personally identifiable health information?'), props.form.getFieldDecorator('pcf_question_7', { initialValue: props.pcf_question_7, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you want the investigator(s) to inform your family doctor that you are participating in this research study?'), props.form.getFieldDecorator('pcf_question_8', { initialValue: props.pcf_question_8, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), props.form.getFieldValue('pcf_question_8') === 'true' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Your family doctor\'s name'), props.form.getFieldDecorator('pcf_question_8_name', { initialValue: props.pcf_question_8_name, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, null))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Who explained this study to you?'), props.form.getFieldDecorator('pcf_question_9_who', { initialValue: props.pcf_question_9_who, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, null))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'I agree to take part in this study:'), props.form.getFieldDecorator('pcf_question_10_agree', { initialValue: props.pcf_question_10_agree, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'No')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Research Subject Name'), props.form.getFieldDecorator('pcf_research_subject_name', { initialValue: props.pcf_research_subject_name || props.dc_patient_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Research Subject Name' })))), props.consentMethodType === 'Email' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('pcf_participant_email', { initialValue: props.pcf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: true, placeholder: 'Participant Email' }))), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Witness (to SDM)'), props.form.getFieldDecorator('pcf_witness_to_sdm', { initialValue: props.pcf_witness_to_sdm, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, null))), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Decision maker relationship'), props.form.getFieldDecorator('pcf_relationship_to_participant', { initialValue: props.pcf_relationship_to_participant, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, null)))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "INFORMATION SHEET: ", props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "TITLE:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Principal Investigator:\xA0 Dr. Brian Buck.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Research Coordinators: Paige Fairall (780-248-1118), Juline Jabs & Lori Piquette (780-248-2014)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "When reading this form, please note that the words \u201Cyou\u201D or \u201Cyour\u201D refer to the person in the study rather than to a legally authorized representative who will or might, sign this form on behalf of the person in the study.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Why am I being asked to take part in this research study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies. Health Canada has approved the use of tenecteplase for this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Before you make a decision one of the researchers will go over this form with you. You are encouraged to ask questions if you feel anything needs to be made clearer. You will be given a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What is the reason for doing the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will happen in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment (phone call) is finished, your participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What are the risks and discomforts?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "- Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "CT Scan:"), " Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What are the benefits to me?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will I need to do while I am in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study has only one follow-up visit, which will take place around 90 days after consent into the trial. The visit is completed by telephone and we ask that you answer the phone call from the coordinating site, the University of Calgary. During the call, please answer all questions honestly and truthfully. You will have the option of completing an online survey. This survey is not mandatory."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What happens if I am injured because of this research?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you become ill or injured as a result of being in this study, you will receive necessary medical treatment, at no additional cost to you. By signing this consent form you are not releasing the investigator(s), institution(s) and/or sponsor(s) from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Do I have to take part in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Being in this study is your choice. If you decide to be in the study, you can change your mind and stop being in the study at any time, and it will in no way affect the care or treatment that you are entitled to. However, the administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Can my participation in the study end early?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are free to withdraw from the study at any time. The administration of study medication has already been given and cannot be undone though. If you wish to not be followed by the study team for the remainder of the 90 day period, please let a member of the study team know. We will not collect any future data from you but we will keep data that we have already collected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will I be informed of new findings?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will my information be kept private?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. No data relating to this study that includes your name will be released outside of the study doctor\u2019s office or published by the researchers. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor/study staff may need to look at your personal health records held at the study doctor\u2019s office, and/or kept by other health care providers that you may have seen in the past (i.e. your family doctor). Any personal health information that we get from these records will be only what is needed for the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name and telephone number will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you leave the study, we will not collect new health information about you, but we will need to keep the data that we have already collected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on http://www.ClinicalTrials.gov, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What if I have questions?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about the research now or later, please contact Dr. Brian Buck (780-248-1927) or the study coordinator (780-248-1118)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions regarding your rights as a research participant, you may contact the Health Research Ethics Board at 780-492-2615. This office is independent of the study investigators.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PARTICIPANT CONSENT FORM")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, "TITLE: Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT QuICR) Principal Investigator: Dr. Brian Buck Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani"));
});

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "INFORMATION SHEET: ", props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "TITLE:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Principal Investigator:\xA0 Dr. Brian Buck.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Research Coordinators: Paige Fairall (780-248-1118), Juline Jabs & Lori Piquette (780-248-2014)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "When reading this form, please note that the words \u201Cyou\u201D or \u201Cyour\u201D refer to the person in the study rather than to a legally authorized representative who will or might, sign this form on behalf of the person in the study.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Why am I being asked to take part in this research study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TNK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies. Health Canada has approved the use of tenecteplase for this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Before you make a decision one of the researchers will go over this form with you. You are encouraged to ask questions if you feel anything needs to be made clearer. You will be given a copy of this form for your records."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What is the reason for doing the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will happen in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment (phone call) is finished, your participation in the study will be complete."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What are the risks and discomforts?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "- Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled. ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "- Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, "CT Scan:"), " Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What are the benefits to me?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What will I need to do while I am in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study has only one follow-up visit, which will take place around 90 days after consent into the trial. The visit is completed by telephone and we ask that you answer the phone call from the coordinating site, the University of Calgary. During the call, please answer all questions honestly and truthfully. You will have the option of completing an online survey. This survey is not mandatory."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What happens if I am injured because of this research?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you become ill or injured as a result of being in this study, you will receive necessary medical treatment, at no additional cost to you. By signing this consent form you are not releasing the investigator(s), institution(s) and/or sponsor(s) from their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Do I have to take part in the study?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Being in this study is your choice. If you decide to be in the study, you can change your mind and stop being in the study at any time, and it will in no way affect the care or treatment that you are entitled to. However, the administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Can my participation in the study end early?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are free to withdraw from the study at any time. The administration of study medication has already been given and cannot be undone though. If you wish to not be followed by the study team for the remainder of the 90 day period, please let a member of the study team know. We will not collect any future data from you but we will keep data that we have already collected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will I be informed of new findings?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Will my information be kept private?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. No data relating to this study that includes your name will be released outside of the study doctor\u2019s office or published by the researchers. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor/study staff may need to look at your personal health records held at the study doctor\u2019s office, and/or kept by other health care providers that you may have seen in the past (i.e. your family doctor). Any personal health information that we get from these records will be only what is needed for the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name and telephone number will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Conjoint Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you leave the study, we will not collect new health information about you, but we will need to keep the data that we have already collected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on http://www.ClinicalTrials.gov, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "What if I have questions?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about the research now or later, please contact Dr. Brian Buck (780-248-1927) or the study coordinator (780-248-1118)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions regarding your rights as a research participant, you may contact the Health Research Ethics Board at 780-492-2615. This office is independent of the study investigators.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "PARTICIPANT CONSENT FORM")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, "TITLE: Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT QuICR) Principal Investigator: Dr. Brian Buck Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani"));
});

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option; // window.scrollTo(0, 0);
var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var oneOfReasons = props.form.getFieldValue('dc_reason_deferred_1') || props.form.getFieldValue('dc_reason_deferred_2') || props.form.getFieldValue('dc_reason_deferred_3') || props.form.getFieldValue('dc_reason_deferred_4') || props.form.getFieldValue('dc_reason_deferred_5');return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - Investigator'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_deferred ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_deferred_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM: ', props.has_randomization_platform_step_3_patient), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'Deferred Consent for Research Participation'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Title of Project: Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Principal Investigator:\xA0  Dr. Brian Buck')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Phone Number: 780-248-1927'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The patient named below is being enrolled in this research study by deferred consent.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'When a previously incapacitated participant regains capacity, or when a substitute decision maker is found, consent shall be sought promptly for continuation in the study, and for subsequent examinations or tests related to the research study. Seeking consent prior to study participation is always preferable.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If no substitute decision maker/family member is available on site or they refuse to give consent, any data or samples collected for study purposes will be destroyed.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Date/time assessed for enrolment: ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Patient\'s name'), props.form.getFieldDecorator('dc_patient_name', { initialValue: props.dc_patient_name, rules: [{ required: true, message: 'Please enter the Patient\'s name' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Patient\'s name' })))), props.consentMethodType === 'Email' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('pcf_participant_email', { initialValue: props.pcf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Participant Email' }))), props.consentMethodType === 'Email' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Person obtaining consent'), props.form.getFieldDecorator('wcf_person_obtaining_consent_name', { initialValue: props.wcf_person_obtaining_consent_name, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Person obtaining consent name', autoFocus: true }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Reason(s) deferred consent process is used (check all that apply):')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, props.form.getFieldDecorator('dc_reason_deferred_1', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The patient is unconscious or lacks capacity to understand the risks, methods and purposes of the research study.')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, props.form.getFieldDecorator('dc_reason_deferred_2', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'No next of kin/substitute decision maker is available to provide consent, or attempts to contact them have been unsuccessful despite diligent and documented efforts.')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, props.form.getFieldDecorator('dc_reason_deferred_3', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'A substitute decision maker has been contacted by telephone, and the purpose, methods and risks of participation in this study have been explained to the third party. While the substitute decision maker has given verbal consent for participation, written consent must be still be obtained.')))), props.form.getFieldValue('dc_reason_deferred_3') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Decision maker name and relationship'), props.form.getFieldDecorator('dc_reason_deferred_3_name_relationship', { rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, null))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, props.form.getFieldDecorator('dc_reason_deferred_4', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'No relevant prior directive by the patient is known to exist.')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, props.form.getFieldDecorator('dc_reason_deferred_5', { initialValue: false, valuePropName: 'checked', rules: [{ required: !oneOfReasons, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'One of reasons must be selected' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'Other')))), props.form.getFieldValue('dc_reason_deferred_5') && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Other reasons'), props.form.getFieldDecorator('dc_reason_deferred_5_other', { initialValue: props.dc_reason_deferred_5_other, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a.TextArea, { placeholder: 'Other reasons' })))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'Surrogate Deferred Consent and Regained Capacity following Deferral of Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'TITLE:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Principal Investigator:'), ' Dr. Brian Buck'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Co-Investigators:'), ' Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness made it impossible for you to participate fully in the informed consent process, consent to participate in this research study was obtained via deferred consent from a physician. Your physician believed it was in your best interest clinically to participate in this research. The administration of either Alteplase or Tenecteplase cannot be undone.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Informed consent is essential throughout a research study. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your physician or substitute decision maker for you to participate. A member of the study team will go over the Information and Consent Form signed on your behalf, and answer all of your questions about the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you agree to stay in the study, please sign below. If you do not agree, tell the study staff so that all data already collected about you will be destroyed.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have questions or concerns about your rights as a study participant, you may contact the Research Ethics Office, at 780-492-2615. This office is independent of the researchers.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), (props.consentMethodType !== 'EmailRegainedCapacity' || props.token) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please select consent option below:'), props.form.getFieldDecorator('rccf_option', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, null, 'I wish to remain in the study. I have reviewed the information and consent form originally signed on my behalf, and my questions have been answered.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Participant\u2019s Name"), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Please enter the Participant\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Full Name', autoFocus: true }))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, "Investigator/Delegate\u2019s Name"), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Please enter the Investigator/Delegate\'s full name' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Investigator/Delegate Full Name' }))), (props.consentMethodType !== 'EmailRegainedCapacity' || props.token) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - WITHDRAWAL CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_withdraw ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_withdraw_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'INFORMATION AND CONSENT FORM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', { align: 'center' }, 'Withdrawal Consent Form'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'TITLE:\xA0\xA0\xA0 Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Principal Investigator:'), ' Dr. Brian Buck'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Co-Investigators:'), ' Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr. Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali Nomani'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'You previously agreed to participate in this research study, but now have told us that you would like to withdraw your consent to participate. As stated in the original consent you signed, you are free to withdraw from this research, without giving a reason, and this will in no way affect the care that you are entitled to receive at this Institution. You do not need to sign this form to withdraw from this study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The purpose of this form is to see if you would agree to continue to attend follow-up visits and/or to allow information about you to be collected for the study. If this is ok with you, please check the boxes below to indicate your decision:')), (props.consentMethodType !== 'WithdrawConsentEmail' || props.token) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('wcf_option_1', { rules: [{ required: true, message: 'Please select consent option below:' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'I agree to allow the study doctor to contact me at regular intervals to collect study-related information about how I am doing.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'I will not be contacted by the study doctor, but I agree to allow the study doctor to collect study-related information about me and my health from medical records.')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have questions or concerns about your rights as a study participant including your right to freely withdraw from this study, you may contact the Research Ethics Office, at 780-492-2615.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant\'s Name'), props.form.getFieldDecorator('wcf_participant_name', { initialValue: props.wcf_participant_name || props.pcf_research_subject_name, rules: [{ required: true, message: 'Please enter the Participant\'s name' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant name', autoFocus: true }))), props.consentMethodType === 'WithdrawConsentEmail' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('wcf_participant_email', { initialValue: props.wcf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Person obtaining consent'), props.form.getFieldDecorator('wcf_person_obtaining_consent_name', { initialValue: props.wcf_person_obtaining_consent_name, rules: [{ required: true, message: 'required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Person obtaining consent name', autoFocus: true }))), (props.consentMethodType !== 'WithdrawConsentEmail' || props.token) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), (props.consentPersonType === 'Surrogate' || props.consentPersonType === 'Patient') && props.consentMethodType === 'Paper' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFileDc', { initialValue: props.datasetdc && props.datasetdc.filename ? props.datasetdc.filename : [], valuePropName: 'fileListDc', getValueFromEvent: props.normFileDc })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFileDc', name: 'consentFileDc', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Deferred Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFileWithdraw', { initialValue: props.datasetwithdraw && props.datasetwithdraw.filename ? props.datasetwithdraw.filename : [], valuePropName: 'fileListWithdraw', getValueFromEvent: props.normFileWithdraw })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFileWithdraw', name: 'consentFileWithdraw', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Withdraw Consent Form'))))) : null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Signature = function (_React$Component) {
  _inherits(Signature, _React$Component);function Signature() {
    _classCallCheck(this, Signature);return _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).apply(this, arguments));
  }_createClass(Signature, [{ key: "render", // componentDidMount() {
    //   if (this.props.fromDataURL) {
    //     this.sigPad.fromDataURL(this.props.fromDataURL);
    //   }
    // }
    value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-form-item" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", null, this.props.label), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-wrap" }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "signature-canvas-wrap" }, this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_canvas___default.a, { clearOnResize: false, penColor: "black", canvasProps: { width: 310, height: 150, className: 'sig-canvas' }, ref: function ref(_ref) {
          _this2.sigPad = _ref;
        }, onEnd: function onEnd() {
          _this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, _this2.sigPad.getCanvas().toDataURL('image/png')));
        } }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "danger", htmlType: "button", onClick: function onClick() {
          _this2.sigPad.clear();_this2.props.form.setFieldsValue(_defineProperty({}, _this2.props.fieldName, null));
        } }, "Clear"))));
    } }]);return Signature;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Signature);

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeLethbridge__contentWrap__3DdgU"};

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeKingston_ConsentForm__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentKingstonByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeKingston_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeKingston_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentKingstonByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createKingston(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' }))))), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: false, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.'))), !isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 35406", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre\u2013University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room ALL-130 \u2013 339 Windermere Road", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, Ontario N6A 5A5")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, Pager 13755")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (", '{', "'<'", '}', " 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 35406", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre\u2013University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Room ALL-130 \u2013 339 Windermere Road", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, Ontario N6A 5A5")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Jennifer Mandzia", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, Pager 13755")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (< 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeKingston__contentWrap__MqdC-"};

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeHamilton_ConsentForm__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentHamiltonByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate'), sb_dic_surrogate_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_surrogate_name') || undefined, sb_dic_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_participant_email') || undefined, sb_dic_research_subject_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_research_subject_name') || undefined, sb_dic_investigator_name_and_role: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.sb_dic_investigator_name_and_role') || undefined, rccf_participant_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_name') || undefined, rccf_participant_email: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_participant_email') || undefined, rccf_investigator_name: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'details.rccf_investigator_name') || undefined };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeHamilton_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeHamilton_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step2__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3aPatient__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Step3b__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Step4__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Signature__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services__ = __webpack_require__(39);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_13_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data, _ref6, _data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;if (!token) {
                  _context4.next = 13;break;
                }_context4.next = 8;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].confirmConsentHamiltonByToken(token, formData);case 8:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 18;break;case 13:
                _context4.next = 15;return __WEBPACK_IMPORTED_MODULE_20__services__["c" /* consentServices */].createHamilton(formData, file, fileDc, fileWithdraw);case 15:
                _ref6 = _context4.sent;_data = _ref6.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, _data) };
                });case 18:
                _context4.next = 24;break;case 20:
                _context4.prev = 20;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 24:
                _this.setState({ loading: false });case 25:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 20]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Electronic' }, 'Electronic Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Email' }, 'E-mail Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacity' }, 'Regained Capacity Electronic'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'EmailRegainedCapacity' }, 'Regained Capacity Email'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';var isPatient = props.consentPersonType === 'Patient';var isSurrogate = props.consentPersonType === 'Surrogate';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'DOCUMENTATION OF INFORMED CONSENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('sb_dic_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURES'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'All of my questions have been answered,'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'I understand the information within this informed consent form, ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I allow access to medical records and related personal health information as explained in this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I do not give up any legal rights by signing this consent form,', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I understand that my family doctor/health care provider will be informed of study participation', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), 'I agree, or agree to allow the person I am responsible for, to take part in this study.'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('sb_dic_research_subject_name', { initialValue: props.sb_dic_research_subject_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), isEmail && isSurrogate && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision Maker'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the SDM\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Substitute Decision Maker Email' })))), isEmail && isPatient && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Email'), props.form.getFieldDecorator('sb_dic_participant_email', { initialValue: props.sb_dic_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' })))), isPatient && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_research_subject_signature', label: 'Signature of Participant', form: props.form })), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Substitute Decision-Maker Name'), props.form.getFieldDecorator('sb_dic_surrogate_name', { initialValue: props.sb_dic_surrogate_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Substitute Decision-Maker Name' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_surrogate_signature', label: 'Signature of Substitute Decision-Maker', form: props.form })), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Person Conducting the Consent Discussion Name & Role'), props.form.getFieldDecorator('sb_dic_investigator_name_and_role', { initialValue: props.sb_dic_investigator_name_and_role, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name & Role' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_investigator_signature', label: 'Signature of Person Conducting the Consent Discussion', form: props.form })), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, 'The following attestation must be provided if the participant is unable to read or requires an oral translation:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_is_interpreter', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.'))), props.form.getFieldValue('sb_dic_is_interpreter') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Name'), props.form.getFieldDecorator('sb_dic_interpreter_name', { initialValue: props.sb_dic_interpreter_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Interpreter Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_interpreter_signature', label: 'Signature of Interpreter', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Interpreter Language'), props.form.getFieldDecorator('sb_dic_interpreter_language', { initialValue: props.sb_dic_interpreter_language, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Interpreter Language' }))))), !isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('sb_dic_interpreter_was_read', { initialValue: false, valuePropName: 'checked', rules: [{ required: false, transform: function transform(value) {
            return value || undefined;
          }, type: 'boolean', message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, 'The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.'))), !isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Witness Name'), props.form.getFieldDecorator('sb_dic_witness_name', { initialValue: props.sb_dic_witness_name, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Witness Name' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'sb_dic_witness_signature', label: 'Signature of Witness', form: props.form, optional: props.token }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Relationship to Participant'), props.form.getFieldDecorator('sb_dic_witness_relationship', { initialValue: props.sb_dic_witness_relationship, rules: [{ required: !props.token, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { placeholder: 'Relationship to Participant' })))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No')))))));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "justify" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Ashkan Shoamanesh")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "905-521-2100 x46311(paging); Ask for the TPA doctor on call")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (", '{', "'<'", '}', " 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Informed Consent Form for Participation in a Research Study", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Subject Deferred Consent Form)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Title:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Alteplase Compared to Tenecteplase in patients with Acute", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Randomized Controlled Trial")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Study Doctor:")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "Dr. Ashkan Shoamanesh")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Sponsor/Funder(s):")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "University of Calgary")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Emergency Contact Number"), "(24 hours / 7 days a week):"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "905-521-2100 x46311(paging); Ask for the TPA doctor on call")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "INTRODUCTION")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As a Substitute Decision Maker, you are being asked to provide informed consent on behalf of a person who is unable to provide consent for him/herself. If the participant gains the capacity to consent for him/herself, your consent for them will end. Throughout this form, \u201Cyou\u201D means the person you are representing."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are being invited to participate in a clinical trial (a type of study that involves research). You are invited to participate in this trial because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently. This consent form provides you with information to help you make an informed choice. Please read this document carefully and ask any questions you may have. All your questions should be answered to your satisfaction before you decide whether to participate in this research study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase, \u201Cclot-busting\u201D medications used to treat your stroke without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients, and was approved by your hospital\u2019s research ethics board."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone. We are asking for your consent to stay in the study for ongoing data collection."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Taking part in this study is voluntary. You have the option to not participate at all or you may choose to leave the study at any time. Whatever you choose, it will not affect the usual medical care that you receive outside the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Please take your time in making your decision. You may find it helpful to discuss it with your friends and family."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "IS THERE A CONFLICT OF INTEREST?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The hospital is receiving financial payment from the Sponsor to cover the cost of conducting this study. If you would like additional information about the funding for this study, or about the role of the doctor in charge of this study, please speak to the study staff or the Patient Relations Office at LHSC at (519) 685-8500 ext. 52036 or access the online form at", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact"), ". This study is funded by the University of Calgary with a grant from the Canadian Institute of Health Research. Study medications are provided by the hospital pharmacy at no cost to you."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The standard or usual treatment for stroke emergencies caused by a blood clot is a medication called Alteplase (Tissue Plasminogen Activator - tPA). We know that Alteplase can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Tenecteplase (TNK) is another clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart. It is also a tissue plasminogen activator. Health Canada, the regulatory body that oversees the use of drugs in Canada, has not approved the sale or use of Tenecteplase for acute ischemic stroke. Health Canada has allowed Tenecteplase to be used in this study. Although Tenecteplase is not currently approved for use in acute stroke care, it has shown promising results in recent stroke studies."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHY IS THIS STUDY BEING DONE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The main purpose of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT OTHER CHOICES ARE THERE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You do not have to take part in this study in order to receive treatment or care. You can opt out of study follow-up or health record linkage. Standard of care treatments for your stroke will not be affected, including, but not limited to treatment with:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Blood thinners called antiplatelets which prevent blood cells called platelets from clumping"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Endovascular thrombectomy (EVT), a surgery to try to remove the blood clot from your brain")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Other research studies may be available."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is anticipated that about 1600 people will take part in this study, from research sites located in Canada. At London Health Sciences Centre \u2013 University Hospital we anticipate we will enroll approximately 225 participants (75 participants per year)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study should take 3 years to complete and the results should be known in about 3.5 years."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT WILL HAPPEN DURING THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ASSIGNMENT TO A GROUP"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "You have been \"randomized\" into one of the groups described below. Randomization means that you were put into a group by chance (like flipping a coin). There is no way to predict which group you would be assigned to before randomization. You had a 50% chance of being placed in either group. Neither you, the study staff, nor the study doctors can choose what group you would be in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told which group you are in."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Once 1600 participants have entered the study from all of the research sites combined, no more participants will be enrolled into the study at any site."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE STUDY INTERVENTION?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Experimental Intervention: At the time of your stroke, you were given a clot-busting medication by needle into one of your veins. You received this medication once."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 1 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Experimental intervention):"), " Tenecteplase (TNK)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Tenecteplase by needle into one of your veins. This procedure took about 1 minute. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Group 2 ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "(Non-Experimental/Standard Intervention):"), " Alteplase (tPA)"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you were randomized to this group, we have given you a clot-busting drug called Alteplase by needle into one of you veins. This procedure took about 1 hour. This medication was only given to you one time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The administration of either Alteplase or Tenecteplase cannot be undone."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you choose to participate in this study, you will be expected to:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete a telephone interview 90-120 days after your stroke"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke. This assessment will be done through a telephone interview with research staff from the University of Calgary. The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule). For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Complete memory and attention tests online"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are able and interested, we will ask you to complete an online assessment at 3-months and 1 year after the stroke, to find out if there are any differences in memory or thinking between the groups of people who received the two drugs. You do not have to complete this online assessment to be part of the main study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you consent, you will be provided with a link and instructions to complete memory and attention tests online. The purpose of these tests is to understand how the study intervention and illness affects your brain function. Each test will take about 35-45 minutes to complete and you can do this from your home. You can choose not to complete the memory and attention tests if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Even though you may have completed the memory and attention tests, these results will not be reviewed by your health care team or study team.")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up as planned by your treating physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW LONG WILL PARTICIPANTS BE IN THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study participation can last for up to 1 year."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "No matter which group you are randomized to, we would like to keep track of your health for 3 months to look at the long-term effects of your participation on this study. After the 3-month assessment (phone call and online assessment) is finished, your participation in the study\u2019s main phase will be complete, and you can choose to continue with the online testing at 3 months and at 1 year, if you wish."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can choose to end your participation in this research (called withdrawal) at any time without having to provide a reason. If you choose to withdraw from the study, you are encouraged to contact the study doctor or study staff."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may withdraw your permission to use information that was collected about you for this study at any time by letting the study doctor know."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that was recorded before you withdrew will be used by the researchers for the purposes of the study, but no information will be collected or sent to the sponsor after you withdraw your permission."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You can also choose to withdraw from the study but allow your data to be collected from that point onward via health record linkage. If you choose this option, we will not contact you about the study in the future."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "CAN PARTICIPATION IN THIS STUDY END EARLY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor may stop your participation in the study early, and without your consent, for reasons such as:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sponsor decides to stop the study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Regulatory Authority/ies (for example, Health Canada) or research ethics board withdraw permission for this study to continue")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you are removed from this study, the study doctor will discuss the reasons with you and plans will be made for your continued care outside of the study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You may experience side effects from participating in this study. Some side effects are known and are listed below, but there may be other side effects that are not expected. You should discuss these with the study doctor."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The study doctor will watch you closely to see if you have side effects. When possible, other medicine will be given to you to make side effects less serious and more tolerable. Many side effects go away shortly after the study intervention is stopped, but in some cases side effects can be serious, long-lasting, permanent, or may even cause death."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "The major risks are:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Less likely (5 \u2013 20%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Rarely (1 \u2013 4%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Very Rarely (< 1%):", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bleeding from the stomach or urinary tract. This is very rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "It is possible that other drugs (prescription and non-prescription drugs), vitamins, or herbals can interact with the study intervention. This can result in either the intervention not working as expected or result in severe side effect."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE REPRODUCTIVE RISKS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The effects that tPA and TNK may have on an unborn baby (fetus) are unknown. If you are pregnant, you will only be allowed to participate in this study at the discretion of an expert stroke physician."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your stroke may be improved during the study, but there is no guarantee of that."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "We hope the information learned from this study will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you decide to participate in this study, the study doctors and study staff will only collect the information they need for this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Records identifying you at this centre will be kept confidential and, to the extent permitted by the applicable laws, will not be disclosed or made publicly available, except as described in this consent document. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Authorized representatives of the following organizations may look at your original (identifiable) medical/clinical study records at the site where these records are held, to check that the information collected for the study is correct and follows proper laws and guidelines.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The University of Calgary, the Sponsor of this study"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Sunnybrook Research Ethics Board, who oversees the ethical conduct of this study in Ontario"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "This institution and affiliated sites, to oversee the conduct of research at this location"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "The Quality Assurance and Education Officers from Lawson Health Research Institute (Lawson) who may audit this research study for quality assurance purposes."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Health Canada (because they oversee the use of drugs in Canada)")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Information that is collected about you for the study (called study data) may also be sent to the organizations listed above. Representatives of Clinical Trials Ontario, a not-for-profit organization, may see study data that is sent to the research ethics board for this study. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers. Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Sunnybrook Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "This study requires the transfer of identifiable information to the AcT Coordinating Centre located at the University of Calgary."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The following information will be transferred to the University of Calgary:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "First and last name"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Date of treatment"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Telephone number"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Email address"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Weight"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Family Physician")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If the results of this study are published, your identity will remain confidential. It is expected that the information collected during this study will be used in analyses and will be published/ presented to the scientific community at meetings and in journals. This information may also be used as part of a submission to regulatory authorities around the world to support the approval of the study intervention."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources. Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital electronic medical records, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases, along with your health care number. Your name is not included in these databases. Even though the likelihood that someone may identify you from the study data is very small, it can never be completely eliminated."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using an anonymized study identification number. The study investigators will add the CIHI data to the study data based on this study identification number."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The original copy of the signed consent form will be kept on-site at the hospital for at least 5 years. A copy of the consent form that you sign to enter the study may be included in your health record/hospital chart. A redacted copy will also be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have any questions about your rights as a research participant, any ethical issues related to this study, or about the confidentiality of your data, you may call The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS PARTICIPATING IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your family doctor/health care provider will be informed that you had a stroke and were treated with a clot-busting medication so that you can be provided with appropriate medical care."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "A description of this clinical trial is available on", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "http://www.ClinicalTrials.gov", target: "_blank", rel: "noopener noreferrer" }, "http://www.ClinicalTrials.gov"), ", as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT IS THE COST TO PARTICIPANTS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "The clot-busting medication (TNK or tPA) has been supplied to you at no charge. The costs of your medical treatment will be paid for by your provincial medical plan to the extent that such coverage is available. Participation in this study will not involve any additional costs to you or your private health care insurance."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will not be paid for taking part in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "In the case of research-related side effects or injury, medical care will be provided by your stroke doctor. In the event that you suffer injury as a result of participating in this research, no compensation will be provided for you by the University of Calgary, the hospital you received stroke treatment from, or the researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be told, in a timely manner, about new information that may be relevant to your willingness to stay in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You have the right to be informed of the results of this study once the entire study is complete. The results of this study will be available on the clinical trial registry (see the \u201CWill information about this study be available online\u201D section for more details)."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Your rights to privacy are legally protected by federal and provincial laws that require safeguards to ensure that your privacy is respected."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "By signing this form, you do not give up any of your legal rights against the study doctor, sponsor or involved institutions for compensation, nor does this form relieve the study doctor, sponsor or their agents of their legal and professional responsibilities."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You will be given a copy of this signed and dated consent form prior to participating in this study."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "If you have questions about taking part in this study, or if you suffer a research-related injury, you can talk to your study doctor, or the doctor who is in charge of the study at this institution. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '30%' }, valign: "top" }, "Dr. Jennifer Mandzia and/or Stroke Research Coordinators"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '70%' }, valign: "top" }, "519-686-8500 ext. 35406")))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "By mail:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London Health Sciences Centre \u2013 University Hospital", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Stroke Research Office", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Rm ALL-130 \u2013 339 Windermere Rd.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "London, ON N6A 5A5 or by email: strokeresearch@lhsc.on.ca", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have any questions about your rights as a research participant or the conduct of this study, you may contact:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "Patient Relations Office at LHSC at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "519-685-8500, ext. 52036", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Or", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Access the online form at:", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form", target: "_blank", rel: "noopener noreferrer" }, "https://apps.lhsc.on.ca/?q=forms/patient-relations-contact-form")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "If you have questions about your rights as a participant or about ethical issues related to this study, you can talk to someone who is not involved in the study at all. That person is:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { align: "center" }, "The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { align: "center" }, "DOCUMENTATION OF INFORMED CONSENT"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.")));
});

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConsentTypeHalifax_SignatureTrimmed__ = __webpack_require__(113);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Consent Process - REGAINED CAPACITY CONSENT FORM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker\u2019s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Dr. Houman Khosravani at (416) 480-6100 ext. 3669.')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'If you have any questions concerning your rights as a possible participant in this research, please contact ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Please check the appropriate box to indicate your decision:'), props.form.getFieldDecorator('rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, 'I wish to stay in the study.'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, 'I wish to withdraw from the study'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study_allow_data_collection_via_linkage' }, 'I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Participant Name'), props.form.getFieldDecorator('rccf_participant_name', { initialValue: props.rccf_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Participant Name' })))), props.consentMethodType === 'EmailRegainedCapacity' && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('rccf_participant_email', { initialValue: props.rccf_participant_email, rules: [{ required: true, message: 'Please enter the participant\'s email' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Participant Email' }))), props.consentPersonType === 'Patient' && showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_participant_signature', label: 'Signature of Participant', form: props.form })), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Person Obtaining Consent'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'By signing this form, I confirm that:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'This study and its purpose has been explained to the participant named above'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'All questions asked by the participant have been answered'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, 'I will give a copy of this signed and dated document to the participant'))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Name of Person Obtaining Consent'), props.form.getFieldDecorator('rccf_investigator_name', { initialValue: props.rccf_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Name of Person Obtaining Consent' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'rccf_investigator_signature', label: 'Signature of Person Obtaining Consent', form: props.form })), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, 'The Sunnybrook Research Ethics Board has approved this research study.')));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeHamilton__contentWrap__iuQRG"};

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ConsentError_ConsentForm__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConsentError_css__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConsentError_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ConsentError_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_15__ConsentError_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_15__ConsentError_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__ConsentError_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ConsentError_ConsentForm__["a" /* default */], { history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_13__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_14__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent() {
    _classCallCheck(this, Consent);return _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).apply(this, arguments));
  }_createClass(Consent, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Consent Process - Error occured'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: 'Error', style: { textAlign: 'left' }, description: 'Consent document already signed or link has expired.', type: 'error', showIcon: true })));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1459);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-alert {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding: 8px 15px 8px 37px;\n  word-wrap: break-word;\n  border-radius: 4px;\n}\n.ant-alert.ant-alert-no-icon {\n  padding: 8px 15px;\n}\n.ant-alert.ant-alert-closable {\n  padding-right: 30px;\n}\n.ant-alert-icon {\n  position: absolute;\n  top: 11.5px;\n  left: 16px;\n}\n.ant-alert-description {\n  display: none;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-alert-success {\n  background-color: #f6ffed;\n  border: 1px solid #b7eb8f;\n}\n.ant-alert-success .ant-alert-icon {\n  color: #52c41a;\n}\n.ant-alert-info {\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n}\n.ant-alert-info .ant-alert-icon {\n  color: #1890ff;\n}\n.ant-alert-warning {\n  background-color: #fffbe6;\n  border: 1px solid #ffe58f;\n}\n.ant-alert-warning .ant-alert-icon {\n  color: #faad14;\n}\n.ant-alert-error {\n  background-color: #fff1f0;\n  border: 1px solid #ffa39e;\n}\n.ant-alert-error .ant-alert-icon {\n  color: #f5222d;\n}\n.ant-alert-close-icon {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  padding: 0;\n  overflow: hidden;\n  font-size: 12px;\n  line-height: 22px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n.ant-alert-close-icon .anticon-close {\n  color: rgba(0, 0, 0, 0.45);\n  transition: color 0.3s;\n}\n.ant-alert-close-icon .anticon-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-close-text {\n  color: rgba(0, 0, 0, 0.45);\n  transition: color 0.3s;\n}\n.ant-alert-close-text:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-with-description {\n  position: relative;\n  padding: 15px 15px 15px 64px;\n  color: #424242;\n  line-height: 1.5;\n  border-radius: 4px;\n}\n.ant-alert-with-description.ant-alert-no-icon {\n  padding: 15px;\n}\n.ant-alert-with-description .ant-alert-icon {\n  position: absolute;\n  top: 16px;\n  left: 24px;\n  font-size: 24px;\n}\n.ant-alert-with-description .ant-alert-close-icon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-alert-with-description .ant-alert-message {\n  display: block;\n  margin-bottom: 4px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n}\n.ant-alert-message {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-alert-with-description .ant-alert-description {\n  display: block;\n}\n.ant-alert.ant-alert-closing {\n  height: 0 !important;\n  margin: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  transform-origin: 50% 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-alert-slide-up-leave {\n  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-alert-banner {\n  margin-bottom: 0;\n  border: 0;\n  border-radius: 0;\n}\n@keyframes antAlertSlideUpIn {\n  0% {\n    transform: scaleY(0);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antAlertSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentError__contentWrap__3twj4"};

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PhysicianScript_css__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PhysicianScript_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PhysicianScript_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home() {
    _classCallCheck(this, Home);return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }_createClass(Home, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__PhysicianScript_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_9__PhysicianScript_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', null, 'Physician Script'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'You/Your loved one is having a stroke, caused by a blood clot in the brain. We will be giving you a clot-busting drug as soon as possible. The hope is that this drug will open up the blockage in your brain caused by the clot. The main risk of this drug is bleeding, which is rare; 5% chance or less, so there is at least a 95% chance that the drug will not harm you.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, 'Today, we [the ____________ Hospital] are participating in a clinical study in which the choice of which clot-busting drug you receive is determined by chance. This is intended to compare two different clot-busting drugs for patients like you having a stroke. Based on what we know so far, these two drugs are similar. You are guaranteed to receive one of the two drugs. For the sake of time, I will make sure you/your loved one gets the drug now and can answer more questions later. Here is an information sheet for you to read in the meantime.'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Home ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/patient-information-sheet', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Patient Information Sheet ')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/randomize', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Randomize ')))))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"PhysicianScript__content__36uxi","parentContainer":"PhysicianScript__parentContainer__2oHOn"};

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Randomize_Randomize__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Randomize_css__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Randomize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Randomize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Results_Results__ = __webpack_require__(1466);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var Randomize = function (_React$Component) {
  _inherits(Randomize, _React$Component);function Randomize(props) {
    _classCallCheck(this, Randomize);var _this = _possibleConstructorReturn(this, (Randomize.__proto__ || Object.getPrototypeOf(Randomize)).call(this, props));_this.state = { group: '', tnkDose: '', tpaBolusDose: '', tpaInfusionDose: '', date: '', studyID: '', weight: '', consentType: '', randomized: false, loading: false };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.handleReset = _this.handleReset.bind(_this);return _this;
  }_createClass(Randomize, [{ key: 'handleSubmit', value: function handleSubmit(values) {
      var _this2 = this;this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_11__services__["d" /* randomizeServices */].create(values).then(function (response) {
        var subject = response.data;if (subject.group === 'tpa') {
          _this2.setState({ group: subject.group, tpaBolusDose: subject.tpa_bolus_dose, tpaInfusionDose: subject.tpa_infusion_dose, date: subject.randomization_date, studyID: subject.study_id, weight: subject.weight, randomized: true, loading: false });
        } else if (subject.group === 'tnk_tpa') {
          _this2.setState({ group: subject.group, tnkDose: subject.tnk_dose, date: subject.randomization_date, studyID: subject.study_id, weight: subject.weight, randomized: true, loading: false });
        }
      }, function (error) {
        if (error.response) {
          var errors = error.response.data.error;if (errors) {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
          }
        }_this2.setState({ group: '', tnkDose: '', tpaBolusDose: '', tpaInfusionDose: '', date: '', studyID: '', weight: '', randomized: false, loading: false });
      });
    } }, { key: 'handleReset', value: function handleReset() {
      this.setState({ group: '', tnkDose: '', tpaBolusDose: '', tpaInfusionDose: '', date: '', studyID: '', weight: '', randomized: false, loading: false });
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          randomized = _state.randomized;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_12__Randomize_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_12__Randomize_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), randomized ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Results_Results__["a" /* Results */], Object.assign({}, this.state, { onBackClick: this.handleReset })) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Randomize_Randomize__["a" /* default */], { loading: loading, handleSubmit: this.handleSubmit })))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Randomize;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Randomize);

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(31);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Randomize = function (_React$Component) {
  _inherits(Randomize, _React$Component);function Randomize() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, Randomize);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Randomize.__proto__ || Object.getPrototypeOf(Randomize)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['weight'] = values['weight'] + 'kg';_this.props.handleSubmit(values);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Randomize, [{ key: 'render', value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;var loading = this.props.loading;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h2', null, ' Randomize '), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, getFieldDecorator('site', { rules: [{ required: true, message: 'Please input site id' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'medicine-box', style: { color: '#FAFAFA' } }), placeholder: 'Site ID', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, getFieldDecorator('user', { rules: [{ required: true, message: 'Please input user id' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), placeholder: 'User ID', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, getFieldDecorator('weight', { rules: [{ required: true, message: 'Please input weight' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), placeholder: 'Weight', allowClear: true, addonAfter: 'kg', size: 'large' }))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, getFieldDecorator('confirm', { rules: [{ required: true, message: 'Is the above information correct?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Is the above information correct?'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('select', { id: 'confirm', name: 'confirm', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('option', { value: '' }, 'Is the above information correct?'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('option', { value: 'yes' }, 'Yes'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { size: 'large', loading: loading, type: 'primary', htmlType: 'submit', className: 'btn-submit' }, loading ? 'Randomization in progress. Please wait ...' : 'Randomize'))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'OR ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), ' select one of the following options:'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA', width: '12rem' }, className: 'menu-item' }, ' Home ')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */], { to: '/patient-information-sheet', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Patient Information Sheet ')))));
    } }]);return Randomize;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);var RondomizeForm = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(Randomize);/* harmony default export */ __webpack_exports__["a"] = (RondomizeForm);

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Randomize__content__1Cr-A","parentContainer":"Randomize__parentContainer__2Nf6j"};

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var Results = function Results(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a, { xs: 24, sm: 24, md: 20, lg: 18, xl: 12, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Drug: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.group === 'tpa' ? 'Alteplase tPA (0.9 mg/kg body weight, max dose 90 mg)' : 'Tenecteplase tNK (0.25 mg/kg body weight, max dose 25 mg)')), props.tnkDose ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Dose: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.tnkDose)) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Bolus Dose: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.tpaBolusDose)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Infusion Dose: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.tpaInfusionDose))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Study ID: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.studyID)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Weight: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.weight, ' kg')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Date and Time: ', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.date)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p', { style: { marginTop: '2rem', display: 'inline-block !important', fontSize: '18px', textAlign: 'center' } }, 'Please remember to note the lot number and expiry date of the drug used!"'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5', { className: 'btn-custom', style: { marginTop: '5rem' }, onClick: props.onBackClick }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'arrow-left', style: { marginRight: '0.5rem' } }), 'Back')));
};

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ValidateRandomization_css__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ValidateRandomization_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ValidateRandomization_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ValidateRandomization_ValidateRandomization__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var Validation = function (_React$Component) {
  _inherits(Validation, _React$Component);function Validation(props) {
    _classCallCheck(this, Validation);var _this = _possibleConstructorReturn(this, (Validation.__proto__ || Object.getPrototypeOf(Validation)).call(this, props));_this.handleChange = function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;_this.setState(_defineProperty({}, name, value));
    };_this.handleVialExpiryDatePickerChange = function (event) {
      _this.setState({ validationExistsVialExpiryDate: event });
    };_this.handlePrev = function () {
      var _this$state = _this.state,
          currentStep = _this$state.currentStep,
          currentStepInt = _this$state.currentStepInt;if (currentStep === 'Step 2') {
        _this.handleReset();
      } else if (currentStep === 'Step 3') {
        _this.handleReset();
      }
    };_this.state = { currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', randomizationDate: '', randomizationGroup: '', randomizationWeight: '', randomizationTNKDose: '', randomizationTPABolusDose: '', randomizationTPAInfusionDose: '', consentExists: '', validationExists: '', validationExistsDate: '', validationExistsUsedRecommendedValues: '', validationExistsDeviationOccurred: '', deviationExists: '', validationExistsWeight: '', validationExistsGroup: '', validationExistsTNKDose: '', validationExistsTPABolusDose: '', validationExistsTPAInfusionDose: '', validationExistsComments: '', validationExistsOptimizeRegistryID: '', validationExistsVialNumber: '', validationExistsVialExpiryDate: '', validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.handleReset = _this.handleReset.bind(_this);_this.handleChange = _this.handleChange.bind(_this);_this.handleVialExpiryDatePickerChange = _this.handleVialExpiryDatePickerChange.bind(_this);_this.handleNext = _this.handleNext.bind(_this);_this.handlePrev = _this.handlePrev.bind(_this);return _this;
  }_createClass(Validation, [{ key: 'handleSubmit', value: function handleSubmit(values) {
      var _this2 = this;this.setState({ loading: true, currentStep: 'Step 4', currentStepInt: 4 });__WEBPACK_IMPORTED_MODULE_10__services__["e" /* validationServices */].create(values).then(function (response) {
        var validationResponse = response.data;
      }, function (error) {
        if (error.response) {
          var errors = error.response.data.error;if (errors) {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
          }
        }_this2.setState({ validationExists: false, validationExistsLink: '', validationSaved: false, submitted: false, loading: false });
      });
    } }, { key: 'handleReset', value: function handleReset() {
      this.setState({ currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', randomizationDate: '', randomizationGroup: '', randomizationWeight: '', randomizationTNKDose: '', randomizationTPABolusDose: '', randomizationTPAInfusionDose: '', consentExists: '', validationExists: '', validationExistsDate: '', validationExistsUsedRecommendedValues: '', validationExistsDeviationOccurred: '', validationDeviationExistsComments: '', deviationExists: '', validationExistsWeight: '', validationExistsGroup: '', validationExistsTNKDose: '', validationExistsTPABolusDose: '', validationExistsTPAInfusionDose: '', validationExistsComments: '', validationExistsOptimizeRegistryID: '', validationExistsVialNumber: '', validationExistsVialExpiryDate: '', validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false });
    } }, { key: 'handleNext', value: function handleNext(values) {
      var _this3 = this;var _state = this.state,
          currentStep = _state.currentStep,
          currentStepInt = _state.currentStepInt;if (currentStep === 'Step 1') {
        this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_10__services__["e" /* validationServices */].create(this.state).then(function (response) {
          var validationResponse = response.data;_this3.setState({ currentStep: 'Step 2', currentStepInt: 2, subjectID: validationResponse['subjectID'], userID: validationResponse['userID'], siteID: validationResponse['siteID'], randomizationDate: validationResponse['randomizationDate'], randomizationGroup: validationResponse['randomizationGroup'], randomizationWeight: validationResponse['randomizationWeight'], randomizationTNKDose: validationResponse['randomizationTNKDose'], randomizationTPABolusDose: validationResponse['randomizationTPABolusDose'], randomizationTPAInfusionDose: validationResponse['randomizationTPAInfusionDose'], consentExists: validationResponse['consentExists'], validationExists: validationResponse['validationExists'], validationExistsDate: validationResponse['validationExistsDate'], validationExistsUsedRecommendedValues: validationResponse['validationExistsUsedRecommendedValues'], deviationExists: validationResponse['deviationExists'], validationExistsDeviationOccurred: validationResponse['validationExistsDeviationOccurred'], validationDeviationExistsComments: validationResponse['validationDeviationExistsComments'], validationExistsWeight: validationResponse['validationExistsWeight'], validationExistsGroup: validationResponse['validationExistsGroup'], saeExists: validationResponse['saeExists'], validationExistsTNKDose: validationResponse['validationExistsTNKDose'], validationExistsTPABolusDose: validationResponse['validationExistsTPABolusDose'], validationExistsTPAInfusionDose: validationResponse['validationExistsTPAInfusionDose'], validationExistsComments: validationResponse['validationExistsComments'], validationExistsOptimizeRegistryID: validationResponse['validationExistsOptimizeRegistryID'], validationExistsVialNumber: validationResponse['validationExistsVialNumber'], validationExistsVialExpiryDate: validationResponse['validationExistsVialExpiryDate'], validationExistsVialExpiryDateMoment: validationResponse['validationExistsVialExpiryDateUTC'] ? __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(validationResponse['validationExistsVialExpiryDateUTC']).local() : undefined, validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false });if (validationResponse['validationExistsVialExpiryDateUTC'] === null) {
            _this3.setState({ validationExistsVialExpiryDateMoment: null });
          }
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.setState({ currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', randomizationDate: '', randomizationGroup: '', randomizationWeight: '', randomizationTNKDose: '', randomizationTPABolusDose: '', randomizationTPAInfusionDose: '', consentExists: '', validationExists: '', validationExistsDate: '', validationExistsUsedRecommendedValues: '', validationExistsDeviationOccurred: '', validationDeviationExistsComments: '', deviationExists: '', validationExistsWeight: '', validationExistsGroup: '', validationExistsTNKDose: '', validationExistsTPABolusDose: '', validationExistsTPAInfusionDose: '', validationExistsComments: '', validationExistsOptimizeRegistryID: '', validationExistsVialNumber: '', validationExistsVialExpiryDate: '', validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false });
        });
      } else if (currentStep === 'Step 2') {
        if (this.state.validationExistsUsedRecommendedValues === 'true') {
          this.setState({ validationExistsDate: this.state.randomizationDate, validationExistsWeight: this.state.randomizationWeight, validationExistsGroup: this.state.randomizationGroup, validationExistsTNKDose: this.state.randomizationTNKDose, validationExistsTPABolusDose: this.state.randomizationTPABolusDose, validationExistsTPAInfusionDose: this.state.randomizationTPAInfusionDose });
        }this.setState({ currentStep: 'Step 3', currentStepInt: 3, validationExistsOverwrite: true });
      } else if (currentStep === 'Step 3' && this.state.validationExistsOverwrite && this.state.validationProvided === 'yes') {
        if (values['validationExistsVialExpiryDate'] !== '') {
          values['validationExistsVialExpiryDate'] = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(values['validationExistsVialExpiryDate'], 'YYYY-MM-DD').local().endOf("month").format('YYYY-MM-DD');
        } // window.alert('step 3 submit: DOB: ' + values['dateOfBirth'] + ' .. ' + moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD') + ' .. ' + Date())
        if (this.state.validationExistsUsedRecommendedValues === 'true') {
          this.setState({ validationExistsDate: this.state.randomizationDate, validationExistsWeight: this.state.randomizationWeight, validationExistsGroup: this.state.randomizationGroup, validationExistsTNKDose: this.state.randomizationTNKDose, validationExistsTPABolusDose: this.state.randomizationTPABolusDose, validationExistsTPAInfusionDose: this.state.randomizationTPAInfusionDose });
        }this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_10__services__["e" /* validationServices */].create(Object.assign({}, this.state), values['validationExistsVialExpiryDate']).then(function (response) {
          var validationResponse = response.data;_this3.setState({ currentStep: 'Step 4', currentStepInt: 4, subjectID: validationResponse['subjectID'], userID: validationResponse['userID'], siteID: validationResponse['siteID'], randomizationDate: validationResponse['randomizationDate'], randomizationGroup: validationResponse['randomizationGroup'], randomizationWeight: validationResponse['randomizationWeight'], randomizationTNKDose: validationResponse['randomizationTNKDose'], randomizationTPABolusDose: validationResponse['randomizationTPABolusDose'], randomizationTPAInfusionDose: validationResponse['randomizationTPAInfusionDose'], consentExists: validationResponse['consentExists'], validationExists: validationResponse['validationExists'], validationExistsDate: validationResponse['validationExistsDate'], validationExistsUsedRecommendedValues: validationResponse['validationExistsUsedRecommendedValues'], deviationExists: validationResponse['deviationExists'], validationExistsDeviationOccurred: validationResponse['validationExistsDeviationOccurred'], validationDeviationExistsComments: validationResponse['validationDeviationExistsComments'], validationExistsWeight: validationResponse['validationExistsWeight'], validationExistsGroup: validationResponse['validationExistsGroup'], validationExistsTNKDose: validationResponse['validationExistsTNKDose'], validationExistsTPABolusDose: validationResponse['validationExistsTPABolusDose'], saeExists: validationResponse['saeExists'], validationExistsTPAInfusionDose: validationResponse['validationExistsTPAInfusionDose'], validationExistsComments: validationResponse['validationExistsComments'], validationExistsOptimizeRegistryID: validationResponse['validationExistsOptimizeRegistryID'], validationExistsVialNumber: validationResponse['validationExistsVialNumber'], validationExistsVialExpiryDate: validationResponse['validationExistsVialExpiryDate'], validationExistsOverwrite: true, validationSaved: true, submitted: false, loading: false });
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.handleReset();
        });
      } else {
        this.handleReset();
      }
    } }, { key: 'render', value: function render() {
      var _state2 = this.state,
          loading = _state2.loading,
          validationSaved = _state2.validationSaved;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_11__ValidateRandomization_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_11__ValidateRandomization_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ValidateRandomization_ValidateRandomization__["a" /* default */], Object.assign({ loading: loading }, this.state, { handleChange: this.handleChange, handleVialExpiryDatePickerChange: this.handleVialExpiryDatePickerChange, handleSubmit: this.handleSubmit, handleNext: this.handleNext, handlePrev: this.handlePrev }))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Validation;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Validation);

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ValidateRandomization__content__1lg2C","parentContainer":"ValidateRandomization__parentContainer__1yCfn"};

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step1_js__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step2_js__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3_js__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step4_js__ = __webpack_require__(1473);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Validation = function (_React$Component) {
  _inherits(Validation, _React$Component);function Validation() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, Validation);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Validation.__proto__ || Object.getPrototypeOf(Validation)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleSubmit(values);
        }
      });
    }, _this.handleNext = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleNext(values);
        } else {
          __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error('Please check required inputs');
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Validation, [{ key: 'previousButton', value: function previousButton() {
      var _props = this.props,
          currentStep = _props.currentStep,
          currentStepInt = _props.currentStepInt;if (currentStep === 'Step 2' || currentStep === 'Step 3') {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.props.handlePrev }, 'Back'));
      }return null;
    } }, { key: 'nextButton', value: function nextButton() {
      var _props2 = this.props,
          currentStep = _props2.currentStep,
          currentStepInt = _props2.currentStepInt;if (currentStep === 'Step 1' || currentStep === 'Step 2') {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Next'));
      } else if (currentStep === 'Step 3') {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Submit'));
      }return null;
    } }, { key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var loading = this.props.loading;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h2', null, ' Validate Randomization - ', this.props.currentStep), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step1_js__["a" /* ValidationFormStep1 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Step2_js__["a" /* ValidationFormStep2 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleVialExpiryDatePickerChange: this.props.handleVialExpiryDatePickerChangeChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, randomizationDate: this.props.randomizationDate, randomizationGroup: this.props.randomizationGroup, randomizationWeight: this.props.randomizationWeight, randomizationTNKDose: this.props.randomizationTNKDose, randomizationTPABolusDose: this.props.randomizationTPABolusDose, randomizationTPAInfusionDose: this.props.randomizationTPAInfusionDose, consentExists: this.props.consentExists, validationExists: this.props.validationExists, validationExistsDate: this.props.validationExistsDate, validationExistsUsedRecommendedValues: this.props.validationExistsUsedRecommendedValues, deviationExists: this.props.deviationExists, validationExistsDeviationOccurred: this.props.validationExistsDeviationOccurred, validationDeviationExistsComments: this.props.validationDeviationExistsComments, validationExistsWeight: this.props.validationExistsWeight, validationExistsGroup: this.props.validationExistsGroup, validationExistsTNKDose: this.props.validationExistsTNKDose, validationExistsTPABolusDose: this.props.validationExistsTPABolusDose, validationExistsTPAInfusionDose: this.props.validationExistsTPAInfusionDose, validationExistsComments: this.props.validationExistsComments, validationExistsOptimizeRegistryID: this.props.validationExistsOptimizeRegistryID, validationExistsVialNumber: this.props.validationExistsVialNumber, saeExists: this.props.saeExists, validationExistsVialExpiryDate: this.props.validationExistsVialExpiryDate, validationExistsVialExpiryDateMoment: this.props.validationExistsVialExpiryDateMoment, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step3_js__["a" /* ValidationFormStep3 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleVialExpiryDatePickerChange: this.props.handleVialExpiryDatePickerChangeChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, randomizationDate: this.props.randomizationDate, randomizationGroup: this.props.randomizationGroup, randomizationWeight: this.props.randomizationWeight, randomizationTNKDose: this.props.randomizationTNKDose, randomizationTPABolusDose: this.props.randomizationTPABolusDose, randomizationTPAInfusionDose: this.props.randomizationTPAInfusionDose, consentExists: this.props.consentExists, validationExists: this.props.validationExists, validationExistsDate: this.props.validationExistsDate, validationExistsUsedRecommendedValues: this.props.validationExistsUsedRecommendedValues, deviationExists: this.props.deviationExists, validationExistsDeviationOccurred: this.props.validationExistsDeviationOccurred, validationDeviationExistsComments: this.props.validationDeviationExistsComments, validationExistsWeight: this.props.validationExistsWeight, validationExistsGroup: this.props.validationExistsGroup, validationExistsTNKDose: this.props.validationExistsTNKDose, validationExistsTPABolusDose: this.props.validationExistsTPABolusDose, validationExistsTPAInfusionDose: this.props.validationExistsTPAInfusionDose, validationExistsComments: this.props.validationExistsComments, validationExistsOptimizeRegistryID: this.props.validationExistsOptimizeRegistryID, validationExistsVialNumber: this.props.validationExistsVialNumber, validationExistsVialExpiryDate: this.props.validationExistsVialExpiryDate, validationExistsVialExpiryDateMoment: this.props.validationExistsVialExpiryDateMoment, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator, getFieldValue: getFieldValue }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step4_js__["a" /* ValidationFormStep4 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, randomizationDate: this.props.randomizationDate, randomizationGroup: this.props.randomizationGroup, randomizationWeight: this.props.randomizationWeight, randomizationTNKDose: this.props.randomizationTNKDose, randomizationTPABolusDose: this.props.randomizationTPABolusDose, randomizationTPAInfusionDose: this.props.randomizationTPAInfusionDose, consentExists: this.props.consentExists, validationExists: this.props.validationExists, saeExists: this.props.saeExists, validationExistsDate: this.props.validationExistsDate, validationExistsUsedRecommendedValues: this.props.validationExistsUsedRecommendedValues, deviationExists: this.props.deviationExists, validationExistsDeviationOccurred: this.props.validationExistsDeviationOccurred, validationDeviationExistsComments: this.props.validationDeviationExistsComments, validationExistsWeight: this.props.validationExistsWeight, validationExistsGroup: this.props.validationExistsGroup, validationExistsTNKDose: this.props.validationExistsTNKDose, validationExistsTPABolusDose: this.props.validationExistsTPABolusDose, validationExistsTPAInfusionDose: this.props.validationExistsTPAInfusionDose, validationExistsComments: this.props.validationExistsComments, validationExistsOptimizeRegistryID: this.props.validationExistsOptimizeRegistryID, validationExistsVialNumber: this.props.validationExistsVialNumber, validationExistsVialExpiryDate: this.props.validationExistsVialExpiryDate, validationExistsVialExpiryDateMoment: this.props.validationExistsVialExpiryDateMoment, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), this.nextButton(), this.previousButton()), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA', width: '12rem' }, className: 'menu-item' }, ' Home ')))));
    } }]);return Validation;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);var ValidationForm = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(Validation);/* harmony default export */ __webpack_exports__["a"] = (ValidationForm);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var ValidationFormStep1 = function ValidationFormStep1(props) {
  if (props.currentStep !== 'Step 1') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('siteID', { initialValue: props.siteID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input site id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'medicine-box', style: { color: '#FAFAFA' } }), id: 'siteID', name: 'siteID', placeholder: 'Site ID', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('userID', { initialValue: props.userID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input user id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), id: 'userID', name: 'userID', placeholder: 'User ID', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('subjectID', { initialValue: props.subjectID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input subject id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'subjectID', name: 'subjectID', placeholder: 'Subject ID', allowClear: true, size: 'large' }))));
};

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);






var MonthPicker = __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default.a.MonthPicker,
    RangePicker = __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default.a.RangePicker,
    WeekPicker = __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default.a.WeekPicker;var ValidationFormStep2 = function ValidationFormStep2(props) {
  var validationExistsText;if (props.currentStep !== 'Step 2') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Subject Found! Please verify details below:'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Randomization Information'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Randomization Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject Weight: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationWeight, ' kg')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Randomization Drug: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK')), props.randomizationGroup === 'tnk_tpa' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Tenecteplase tNK Randomization Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationTNKDose)) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Alteplase tPA Randomization Bolus Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationTPABolusDose)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Alteplase tPA Randomization Infusion Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.randomizationTPAInfusionDose))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Consent Information'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.consentExists === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'No'))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Validation Information'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExists === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'No'))), function () {
    if (props.validationExists) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'validation-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Drug allocated as per randomization administered: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsUsedRecommendedValues === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'No'))), props.validationExistsUsedRecommendedValues === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, '\xA0') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Weight: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsWeight, ' kg')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Drug: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK')), props.validationExistsGroup === 'tnk_tpa' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTNKDose)) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Bolus Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTPABolusDose)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Infusion Dose: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'bigger', style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTPAInfusionDose)))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Comments: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsComments)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Vial Information'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Vial Number: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsVialNumber)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Vial Expiry Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsVialExpiryDate)));
    }
  }(), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Deviation Details'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Any other protocol deviation(s) occurred: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsDeviationOccurred === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'No'))), props.validationExistsDeviationOccurred === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Deviation Comments: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationDeviationExistsComments)) : null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'SAE Information'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.saeExists === true ? 'Yes' : props.saeExists === false ? 'No' : 'Not entered')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Validation Options'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('validationExistsUsedRecommendedValues', { initialValue: '', onChange: props.handleChange, rules: [{ required: true, message: 'Was the drug allocated as per randomization administered?' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Was the drug allocated as per randomization administered?'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('select', { id: 'validationExistsUsedRecommendedValues', name: 'validationExistsUsedRecommendedValues', autoFocus: true, size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: '' }, 'Please select an option'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: 'false' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('validationExistsDeviationOccurred', { initialValue: '', onChange: props.handleChange, rules: [{ required: true, message: 'Did any other protocol deviation(s) occur?' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Did any other protocol deviation(s) occur?'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('select', { id: 'validationExistsDeviationOccurred', name: 'validationExistsDeviationOccurred', autoFocus: true, size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: '' }, 'Please select an option'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: 'false' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, props.getFieldDecorator('validationOverwrite', { initialValue: props.validationOverwrite, onChange: props.handleChange, rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Overwrite existing validation data, if it exists?'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('select', { id: 'validationOverwrite', name: 'validationOverwrite', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: '' }, 'Overwrite Validation Data?'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option', { value: '' }, 'No'))))));
};

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep3; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);










var TextArea = __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea;var MonthPicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.MonthPicker,
    RangePicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.RangePicker,
    WeekPicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.WeekPicker;var ValidationFormStep3 = function ValidationFormStep3(props) {
  if (props.currentStep !== "Step 3") {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Site ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { color: "#4CDEF5", display: "inline-block" } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "User ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { color: "#4CDEF5", display: "inline-block" } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Subject ID:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { color: "#4CDEF5", display: "inline-block" } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Validation Date:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, " "), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Randomization Information"), props.validationExistsUsedRecommendedValues === "true" ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "The information below is read-only as you indicated that you have used the recommended randomization values"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Randomization Date:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.randomizationDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Drug allocated as per randomization administered:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsUsedRecommendedValues === "true" ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, "Yes") : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, "No"))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Validation Weight:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsWeight, " kg")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Validation Drug:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h2", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsGroup === "tpa" ? "Alteplase tPA" : "Tenecteplase tNK")), props.validationExistsGroup === "tnk_tpa" ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { marginTop: "2rem", display: "inline-block !important" } }, "Tenecteplase tNK Dose:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h2", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsTNKDose)) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { marginTop: "2rem", display: "inline-block !important" } }, "Alteplase tPA Bolus Dose:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h2", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsTPABolusDose)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { marginTop: "2rem", display: "inline-block !important" } }, "Alteplase tPA Infusion Dose:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h2", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsTPAInfusionDose))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsComments", { initialValue: props.validationExistsComments, onChange: props.handleChange, rules: [{ required: false, message: "Comments" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Validation Comments"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TextArea, { id: "validationExistsComments", name: "validationExistsComments", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Comments", allowClear: true, autoFocus: true, size: "large", autoSize: { minRows: 3, maxRows: 8 } }))))) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "Please enter the randomization values that were used and explain in the comments box why the recommended values were not used"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Randomization Date:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.randomizationDate)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", { style: { display: "inline-block !important" } }, "Drug allocated as per randomization administered:", " ", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", { style: { color: "#4CDEF5", display: "inline-block" } }, props.validationExistsUsedRecommendedValues === "true" ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, "Yes") : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, "No"))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsWeight", { initialValue: props.validationExistsWeight, onChange: props.handleChange, rules: [{ required: true, message: "Please input weight" }, { validator: function validator(rule, value, callback) {
        if (value) {
          try {
            if (!Number.isInteger(+value) || !!~value.indexOf('.')) {
              throw new Error();
            }callback();
          } catch (err) {
            callback(err);
          }
        } else {
          callback();
        }
      }, message: "Whole numbers only" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { id: "validationExistsWeight", name: "validationExistsWeight", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Weight", allowClear: true, autoFocus: true, addonAfter: "kg", size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsGroup", { initialValue: props.validationExistsGroup, onChange: props.handleChange, rules: [{ required: true, message: "Which drug was administered?" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Which drug was administered?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "validationExistsGroup", name: "validationExistsGroup", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Please select an option"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "tpa" }, "Alteplase tPA"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "tnk_tpa" }, "Tenecteplase tNK"))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { id: "tnkDosageInformation", style: props.validationExistsGroup !== "tnk_tpa" ? { display: "none" } : { display: "block" } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "Note: Only enter the below information if you administered Tenecteplase tNK"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsTNKDose", { initialValue: props.validationExistsTNKDose, onChange: props.handleChange, rules: [{ required: false, message: "Please enter the Tenecteplase tNK dose that was administered" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { id: "validationExistsTNKDose", name: "validationExistsTNKDose", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Please enter the Tenecteplase tNK dose that was administered", allowClear: true, addonAfter: "x.x ml", size: "large" })))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", { id: "tpaDosageInformation", style: props.validationExistsGroup !== "tpa" ? { display: "none" } : { display: "block" } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "Note: Only enter the below information if you administered Alteplase tPA"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsTPABolusDose", { initialValue: props.validationExistsTPABolusDose, onChange: props.handleChange, rules: [{ required: false, message: "Please enter the Alteplase tPA bolus dose that was administered" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { id: "validationExistsTPABolusDose", name: "validationExistsTPABolusDose", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Please enter the Alteplase tPA bolus dose that was administered", allowClear: true, addonAfter: "x.x ml", size: "large" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsTPAInfusionDose", { initialValue: props.validationExistsTPAInfusionDose, onChange: props.handleChange, rules: [{ required: false, message: "Please enter the Alteplase tPA infusion dose that was administered" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { id: "validationExistsTPAInfusionDose", name: "validationExistsTPAInfusionDose", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Please enter the Alteplase tPA infusion dose that was administered", allowClear: true, addonAfter: "xx ml over 1 hour", size: "large" })))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsComments", { initialValue: props.validationExistsComments, onChange: props.handleChange, rules: [{ required: true, message: "Please explain in the comments box why the administered drug differs from the randomization allocation drug!" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Validation Comments"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TextArea, { id: "validationExistsComments", name: "validationExistsComments", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Please explain in the comments box why the administered drug differs from the randomization allocation drug!", allowClear: true, size: "large", autoSize: { minRows: 3, maxRows: 8 } }))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, " "), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Deviation Details"), props.validationExistsDeviationOccurred === "true" ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "You have indicated that other deviation from the protocol has occured"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationDeviationExistsComments", { initialValue: props.validationDeviationExistsComments, onChange: props.handleChange, rules: [{ required: true, message: "Please provide deviation comments" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Deviation Comments"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TextArea, { id: "validationDeviationExistsComments", name: "validationDeviationExistsComments", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Comments", allowClear: true, autoFocus: true, size: "large", autoSize: { minRows: 3, maxRows: 8 } }))))) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", { style: { display: "inline-block !important", textAlign: "center" } }, "You have indicated that no other deviation from the protocol has occured")), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, " "), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Vial Information"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsVialNumber", { initialValue: props.validationExistsVialNumber, onChange: props.handleChange, rules: [{ required: false, message: "Please enter the drug lot number" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { id: "validationExistsVialNumber", name: "validationExistsVialNumber", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "skin", style: { color: "#FAFAFA" } }), placeholder: "Please enter the drug lot number", allowClear: true, size: "large" }))), props.getFieldValue("validationExistsVialNumber") && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationExistsVialExpiryDate", { initialValue: props.validationExistsVialExpiryDateMoment, onChange: props.handleVialExpiryDatePickerChange, rules: [{ required: false, message: "Please enter the drug vial expiry date" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(MonthPicker, { id: "validationExistsVialExpiryDate", name: "validationExistsVialExpiryDate", prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "user", style: { color: "#FAFAFA" } }), placeholder: "Please enter the drug vial expiry date", allowClear: true, size: "large", className: "ant-input ant-input-lg" }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, " "), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", { style: { display: "inline-block !important" } }, "Validation Options"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator("validationProvided", { initialValue: props.validationProvided, onChange: props.handleChange, rules: [{ required: true, message: "Do you confirm that the information presented above is correct and agree to validate the randomization information for this subject?" }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h5", null, "Do you confirm that the information presented above is correct and agree to validate the randomization information for this subject? If no, please click on the Back button!"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("select", { id: "validationProvided", name: "validationProvided", size: "large", className: "ant-input ant-input-lg" }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "Accept Validation?"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "yes" }, "Yes"), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("option", { value: "" }, "No"))))));
};

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ValidationFormStep4 = function ValidationFormStep4(props) {
  if (props.currentStep !== 'Step 4') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Confirmation - Validation has been recorded!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'validation-exists' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Validation Information'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Date: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsDate)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Drug allocated as per randomization administered: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsUsedRecommendedValues === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'No'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Weight: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsWeight, ' kg')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Drug: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK')), props.validationExistsGroup === 'tnk_tpa' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Dose: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTNKDose)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Bolus Dose: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTPABolusDose)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'Validation Infusion Dose: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsTPAInfusionDose)))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Validation Comments: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsComments)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Deviation Details'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Any other protocol deviation(s) occurred: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsDeviationOccurred === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'No'))), props.validationExistsDeviationOccurred === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Deviation Comments: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationDeviationExistsComments)) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Vial Information'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Vial Number: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsVialNumber)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Vial Expiry Date: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsVialExpiryDate)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'SAE Information'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE exists: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.saeExists === true ? 'Yes' : props.saeExists === false ? 'No' : 'Not entered'))));
};

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SaeRecording_css__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SaeRecording_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SaeRecording_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SaeRecording_SaeRecording__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var SaeRecording = function (_React$Component) {
  _inherits(SaeRecording, _React$Component);function SaeRecording(props) {
    _classCallCheck(this, SaeRecording);var _this = _possibleConstructorReturn(this, (SaeRecording.__proto__ || Object.getPrototypeOf(SaeRecording)).call(this, props));_this.handleChange = function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;_this.setState(_defineProperty({}, name, value));
    };_this.handleVialExpiryDatePickerChange = function (event) {
      _this.setState({ validationExistsVialExpiryDate: event });
    };_this.handleSAEDatePickerChange = function (event) {
      _this.setState({ validationExistsSAEDate: event, validationExistsSAEDateMoment: __WEBPACK_IMPORTED_MODULE_14_moment___default()(event) });
    };_this.handlePrev = function () {
      var _this$state = _this.state,
          currentStep = _this$state.currentStep,
          currentStepInt = _this$state.currentStepInt;if (currentStep === 'Step 2') {
        _this.handleReset();
      } else if (currentStep === 'Step 3') {
        _this.handleReset();
      }
    };_this.state = { currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', randomizationDate: '', randomizationGroup: '', randomizationWeight: '', randomizationTNKDose: '', randomizationTPABolusDose: '', randomizationTPAInfusionDose: '', consentExists: '', validationExists: '', validationExistsDate: '', validationExistsUsedRecommendedValues: '', validationExistsWeight: '', validationExistsGroup: '', validationExistsTNKDose: '', validationExistsTPABolusDose: '', saeDateInSiteTimezone: '', validationExistsTPAInfusionDose: '', validationExistsComments: '', validationExistsOptimizeRegistryID: '', validationExistsVialNumber: '', validationExistsVialExpiryDate: '', validationExistsSAEOccurred: '', validationExistsSAEType: '', validationExistsSAEDate: '', validationExistsSAEComments: '', other_event_comments: '', validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.handleReset = _this.handleReset.bind(_this);_this.handleChange = _this.handleChange.bind(_this);_this.handleVialExpiryDatePickerChange = _this.handleVialExpiryDatePickerChange.bind(_this);_this.handleSAEDatePickerChange = _this.handleSAEDatePickerChange.bind(_this);_this.handleNext = _this.handleNext.bind(_this);_this.handlePrev = _this.handlePrev.bind(_this);return _this;
  }_createClass(SaeRecording, [{ key: 'handleSubmit', value: function handleSubmit(values) {
      var _this2 = this;this.setState({ loading: true, currentStep: 'Step 3', currentStepInt: 3 });__WEBPACK_IMPORTED_MODULE_11__services__["e" /* validationServices */].create(values).then(function (response) {
        var validationResponse = response.data;
      }, function (error) {
        if (error.response) {
          var errors = error.response.data.error;if (errors) {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
          }
        }_this2.setState({ validationExists: false, validationExistsLink: '', validationSaved: false, submitted: false, loading: false });
      });
    } }, { key: 'handleReset', value: function handleReset() {
      this.setState({ currentStep: 'Step 1', currentStepInt: 1, subjectID: '', userID: '', siteID: '', randomizationDate: '', randomizationGroup: '', randomizationWeight: '', randomizationTNKDose: '', randomizationTPABolusDose: '', randomizationTPAInfusionDose: '', consentExists: '', validationExists: '', validationExistsDate: '', validationExistsUsedRecommendedValues: '', saeDateInSiteTimezone: '', validationExistsWeight: '', validationExistsGroup: '', validationExistsTNKDose: '', validationExistsTPABolusDose: '', validationExistsTPAInfusionDose: '', validationExistsComments: '', validationExistsOptimizeRegistryID: '', validationExistsVialNumber: '', validationExistsVialExpiryDate: '', validationExistsSAEOccurred: '', validationExistsSAEType: '', validationExistsSAEDate: '', validationExistsSAEComments: '', other_event_comments: '', validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false });
    } }, { key: 'handleNext', value: function handleNext(values) {
      var _this3 = this;var _state = this.state,
          currentStep = _state.currentStep,
          currentStepInt = _state.currentStepInt;if (currentStep === 'Step 1') {
        this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_11__services__["e" /* validationServices */].createSAE({ site_id: this.state.siteID, user_id: this.state.userID, subject_id: this.state.subjectID, current_step: 1 }).then(function (response) {
          var validationResponse = response.data;_this3.setState({ currentStep: 'Step 2', currentStepInt: 2, subjectID: validationResponse['subject_id'], userID: validationResponse['user_id'], siteID: validationResponse['site_id'], saeDateInSiteTimezone: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae_date_in_site_timezone'), validationExistsSAEOccurred: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.is_sae_occurred', null), isSAEOccurred: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.is_sae_occurred', null), validationExistsSAEType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.event_type'), validationExistsSAEDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.sae_date'), validationExistsSAEDateMoment: __WEBPACK_IMPORTED_MODULE_14_moment___default.a.utc(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.sae_date')).local(), validationExistsSAEComments: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.event_comments'), other_event_comments: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.other_event_comments'), validationExistsOverwrite: false, validationSaved: false, submitted: false, loading: false });if (validationResponse['validationExistsSAEDateUTC'] === null) {
            _this3.setState({ validationExistsSAEDateMoment: null });
          }if (validationResponse['validationExistsVialExpiryDateUTC'] === null) {
            _this3.setState({ validationExistsVialExpiryDateMoment: null });
          }
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.setState({ currentStep: 'Step 1', currentStepInt: 1, validationSaved: false, submitted: false, loading: false });
        });
      } else if (currentStep === 'Step 2') {
        var validationExistsSAEOccurred = this.state.validationExistsSAEOccurred;this.setState({ validationExistsOverwrite: true });this.setState({ loading: true });__WEBPACK_IMPORTED_MODULE_11__services__["e" /* validationServices */].createSAE({ site_id: this.state.siteID, user_id: this.state.userID, subject_id: this.state.subjectID, current_step: 2, sae: { "is_sae_occurred": validationExistsSAEOccurred === 'true' ? true : validationExistsSAEOccurred === 'false' ? false : null, "sae_date": __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.state.validationExistsSAEDateMoment.format('YYYY-MM-DDT') + __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('HH:mm')).utc().format('YYYY-MM-DDTHH:mm:ss'), "event_comments": this.state.validationExistsSAEComments, "event_type": this.state.validationExistsSAEType, "other_event_comments": this.state.other_event_comments } }).then(function (response) {
          var validationResponse = response.data;_this3.setState({ currentStep: 'Step 3', currentStepInt: 3, subjectID: validationResponse['subject_id'], userID: validationResponse['user_id'], validationExistsSAEOccurred: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.is_sae_occurred'), validationExistsSAEType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.event_type'), validationExistsSAEDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae_date_in_site_timezone'), validationExistsSAEComments: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.event_comments'), other_event_comments: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(validationResponse, 'sae.other_event_comments'), validationSaved: true, submitted: false, loading: false });
        }, function (error) {
          if (error.response) {
            var errors = error.response.data.error;if (errors) {
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.config({ style: { color: '#424242' } });__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(errors, 5);
            }
          }_this3.handleReset();
        });
      } else {
        this.handleReset();
      }
    } }, { key: 'render', value: function render() {
      var _state2 = this.state,
          loading = _state2.loading,
          validationSaved = _state2.validationSaved;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_12__SaeRecording_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_12__SaeRecording_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_SaeRecording_SaeRecording__["a" /* default */], Object.assign({ loading: loading }, this.state, { handleChange: this.handleChange, handleVialExpiryDatePickerChange: this.handleVialExpiryDatePickerChange, handleSAEDatePickerChange: this.handleSAEDatePickerChange, handleSubmit: this.handleSubmit, handleNext: this.handleNext, handlePrev: this.handlePrev }))))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer_Footer__["a" /* default */], null)));
    } }]);return SaeRecording;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SaeRecording);

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SaeRecording__content__2Rywc","parentContainer":"SaeRecording__parentContainer__1LIhz"};

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Step1_js__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step2_js__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step3_js__ = __webpack_require__(1479);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var SaeRecording = function (_React$Component) {
  _inherits(SaeRecording, _React$Component);function SaeRecording() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, SaeRecording);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SaeRecording.__proto__ || Object.getPrototypeOf(SaeRecording)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleSubmit(values);
        }
      });
    }, _this.handleNext = function (e) {
      e.preventDefault();_this.props.form.validateFields(function (err, values) {
        if (!err) {
          values['currentStepInt'] = _this.props.currentStepInt;values['currentStep'] = _this.props.currentStep;_this.props.handleNext(values);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(SaeRecording, [{ key: 'previousButton', value: function previousButton() {
      var _props = this.props,
          currentStep = _props.currentStep,
          currentStepInt = _props.currentStepInt;if (currentStep === 'Step 2') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.props.handlePrev }, 'Back'));
      }return null;
    } }, { key: 'nextButton', value: function nextButton() {
      var _props2 = this.props,
          currentStep = _props2.currentStep,
          currentStepInt = _props2.currentStepInt;if (currentStep === 'Step 1') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Next'));
      } else if (currentStep === 'Step 2') {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { color: '#FAFAFA' }, size: 'large', type: 'button', loading: this.props.loading, className: 'btn-submit', onClick: this.handleNext }, 'Submit'));
      }return null;
    } }, { key: 'render', value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;var loading = this.props.loading;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h2', null, 'SAE Recording - ', this.props.currentStep), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Step1_js__["a" /* ValidationFormStep1 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Step2_js__["a" /* ValidationFormStep2 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleSAEDatePickerChange: this.props.handleSAEDatePickerChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, validationExistsSAEOccurred: this.props.validationExistsSAEOccurred, isSAEOccurred: this.props.isSAEOccurred, validationExistsSAEType: this.props.validationExistsSAEType, saeDateInSiteTimezone: this.props.saeDateInSiteTimezone, validationExistsSAEDate: this.props.validationExistsSAEDate, validationExistsSAEDateMoment: this.props.validationExistsSAEDateMoment, validationExistsSAEComments: this.props.validationExistsSAEComments, other_event_comments: this.props.other_event_comments, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step3_js__["a" /* ValidationFormStep3 */], { currentStep: this.props.currentStep, currentStepInt: this.props.currentStepInt, handleChange: this.props.handleChange, handleSAEDatePickerChange: this.props.handleSAEDatePickerChange, subjectID: this.props.subjectID, userID: this.props.userID, siteID: this.props.siteID, validationExistsSAEOccurred: this.props.validationExistsSAEOccurred, validationExistsSAEType: this.props.validationExistsSAEType, validationExistsSAEDate: this.props.validationExistsSAEDate, validationExistsSAEDateMoment: this.props.validationExistsSAEDateMoment, validationExistsSAEComments: this.props.validationExistsSAEComments, other_event_comments: this.props.other_event_comments, submitted: this.props.submitted, loading: this.props.loading, getFieldDecorator: getFieldDecorator }), this.nextButton(), this.previousButton()), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA', width: '12rem' }, className: 'menu-item' }, ' Home ')))));
    } }]);return SaeRecording;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);var SaeRecordingForm = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(SaeRecording);/* harmony default export */ __webpack_exports__["a"] = (SaeRecordingForm);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var ValidationFormStep1 = function ValidationFormStep1(props) {
  if (props.currentStep !== 'Step 1') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('siteID', { initialValue: props.siteID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input site id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'medicine-box', style: { color: '#FAFAFA' } }), id: 'siteID', name: 'siteID', placeholder: 'Site ID', autoFocus: true, allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('userID', { initialValue: props.userID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input user id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), id: 'userID', name: 'userID', placeholder: 'User ID', allowClear: true, size: 'large' }))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item, null, props.getFieldDecorator('subjectID', { initialValue: props.subjectID, onChange: props.handleChange, rules: [{ required: true, message: 'Please input subject id' }] })(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), id: 'subjectID', name: 'subjectID', placeholder: 'Subject ID', allowClear: true, size: 'large' }))));
};

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__eventTypes__ = __webpack_require__(509);










var TextArea = __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea;var MonthPicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.MonthPicker,
    RangePicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.RangePicker,
    WeekPicker = __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a.WeekPicker;var ValidationFormStep2 = function ValidationFormStep2(props) {
  if (props.currentStep !== 'Step 2') {
    return null;
  }var isEventTypeOther = props.validationExistsSAEType === 'other';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE Occurred: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.isSAEOccurred === true ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, 'Yes') : props.isSAEOccurred === false ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, 'No') : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, 'Not entered'))), props.isSAEOccurred === true && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE event type: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_11__eventTypes__["a" /* default */][props.validationExistsSAEType])), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE comments: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsSAEComments)), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE Date: ', __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.saeDateInSiteTimezone))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Has a SAE occurred?'), props.getFieldDecorator('validationExistsSAEOccurred', { initialValue: '', onChange: props.handleChange, rules: [{ required: true, message: 'Has an SAE occurred?' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'validationExistsSAEOccurred', name: 'validationExistsSAEOccurred', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Please select an option'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'false' }, 'No'))))), props.validationExistsSAEOccurred === 'true' ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'SAE Information'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', { style: { display: 'inline-block !important', textAlign: 'center' } }, 'You have indicated that an SAE has occurred. Please fill out the information below and also ensure that you have filled out the appropriate SAE form!'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator('validationExistsSAEDate', { initialValue: props.validationExistsSAEDateMoment.utc().local(), onChange: props.handleSAEDatePickerChange, rules: [{ required: true, message: 'Please select the date of the SAE' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a, { id: 'validationExistsSAEDate', name: 'validationExistsSAEDate', prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#FAFAFA' } }), placeholder: 'SAE Date', disabledDate: function disabledDate(currentDate) {
      return currentDate.diff(__WEBPACK_IMPORTED_MODULE_10_moment___default.a.now()) > 86400;
    }, allowClear: true, size: 'large', className: 'ant-input ant-input-lg' }))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'Event type'), props.getFieldDecorator('validationExistsSAEType', { initialValue: props.validationExistsSAEType, onChange: props.handleChange, rules: [{ message: 'Event type' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('select', { id: 'validationExistsSAEType', name: 'validationExistsSAEType', size: 'large', className: 'ant-input ant-input-lg' }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: '' }, 'Please select an option'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'symptomatic_intracerebral' }, 'Symptomatic intracerebral hemorrhage'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'peripheral_bleeding' }, 'Peripheral bleeding requiring blood transfusion'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'angioedema' }, 'Angioedema'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'other' }, 'Others (give diagnosis, if possible)'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('option', { value: 'none' }, 'None'))))), isEventTypeOther && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'If other, please indicate what event occurred:'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator('other_event_comments', { onChange: props.handleChange, initialValue: props.other_event_comments })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea, { id: 'other_event_comments', name: 'other_event_comments' })))), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item, null, props.getFieldDecorator('validationExistsSAEComments', { initialValue: props.validationExistsSAEComments, onChange: props.handleChange, rules: [{ required: true, message: 'SAE Comments' }] })(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5', null, 'SAE Comments'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TextArea, { id: 'validationExistsSAEComments', name: 'validationExistsSAEComments', prefix: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'skin', style: { color: '#FAFAFA' } }), placeholder: 'SAE Comments', allowClear: true, size: 'large', autoSize: { minRows: 3, maxRows: 8 } }))))) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', null, ' '), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'SAE Information'), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p', { style: { display: 'inline-block !important', textAlign: 'center' } }, 'You have indicated that an SAE has not occurred. If an SAE does occur, please fill out the appropriate SAE form!')));
};

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationFormStep3; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventTypes__ = __webpack_require__(509);


var ValidationFormStep3 = function ValidationFormStep3(props) {
  if (props.currentStep !== 'Step 3') {
    return null;
  }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'Confirmation - SAE has been recorded!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.siteID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'validation-exists' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { style: { display: 'inline-block !important' } }, 'SAE Information'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE Occurred: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsSAEOccurred === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Yes') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'No'))), props.validationExistsSAEOccurred && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.validationExistsSAEType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { display: 'inline-block !important' } }, 'SAE event type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, __WEBPACK_IMPORTED_MODULE_1__eventTypes__["a" /* default */][props.validationExistsSAEType])), props.validationExistsSAEOccurred ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'SAE Date: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsSAEDate)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { style: { marginTop: '2rem', display: 'inline-block !important' } }, 'SAE Comments: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#4CDEF5', display: 'inline-block' } }, props.validationExistsSAEComments))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\xA0'))));
};

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Documents_css__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Documents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Documents_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_FileLink_FileButton__ = __webpack_require__(1484);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import PhysicianScript from "../../assets/documents/Physician-Script.pdf";
// import PatientInformationSheetText from "../../assets/documents/Patient-Information-Sheet-Text.pdf";
// import PatientInformationSheetVisual from "../../assets/documents/Patient-Information-Sheet-Visual.pdf";
// import PatientConsentForm from "../../assets/documents/Patient-Consent-Form.pdf";
// import SurrogateConsentForm from "../../assets/documents/Surrogate-Consent-Form.pdf";
// import LetterOfBereavement from "../../assets/documents/Letter-of-Bereavement.docx";
// import SAEForm from "../../assets/documents/AcT-SAE-Report.pdf";
// import TrialProtocol from "../../assets/documents/AcT-trial-protocol.pdf";
var Content = __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default.a.Content;var ALL_SITES_FILTER = "ALL_SITES_FILTER";var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home(props) {
    var _this2 = this;_classCallCheck(this, Home);var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));_this.componentDidMount = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ isLoading: true });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_18__api_requests__["_10" /* getPublicDocumentsRequest */])();case 4:
              response = _context.sent;_this.setState({ isLoading: false, documents: __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(response, "data") });_context.next = 11;break;case 8:
              _context.prev = 8;_context.t0 = _context["catch"](1);_this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_context.t0, "response.data.error", "Error") } });case 11:case "end":
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 8]]);
    }));_this.state = { isLoading: false, documents: [], requestResult: {}, sitesFilter: ALL_SITES_FILTER };return _this;
  }_createClass(Home, [{ key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          documents = _state.documents,
          requestResult = _state.requestResult;var sites = documents.reduce(function (result, item) {
        if (item.site === null && result.includes(null)) {
          return result;
        }if (result.find(function (resultItem) {
          return __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(resultItem, "id") === __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(item.site, "id");
        })) {
          return result;
        }result.push(item.site);return result;
      }, []);var documentsFiltered = function documentsFiltered() {
        if (_this3.state.sitesFilter === null) {
          return documents.filter(function (document) {
            return document.site === null;
          });
        }if (_this3.state.sitesFilter !== ALL_SITES_FILTER) {
          return documents.filter(function (document) {
            return __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(document.site, "id") === _this3.state.sitesFilter;
          });
        }return documents;
      };var listItems = documentsFiltered().map(function (document) {
        return __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(document, "url", "").slice(-4).includes(".mp4") ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("li", { key: document.name }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("video", { width: "100%", height: "320px", controls: true }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("source", { src: document.url, type: "video/mp4" }))) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("li", { key: document.name }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("a", { href: document.url, target: "_blank", style: { color: "#FAFAFA" }, className: "menu-item" }, document.name));
      });return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_17__Documents_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_17__Documents_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: "4rem" } }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("h1", null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("span", { style: { color: "#286DA8" } }, "AcT")), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { type: "flex", justify: "center" }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: "frosted-card" }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("h2", null, "Trial Documents"), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p", null, "This page contains links to the various Trial documents"), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p", null, "\xA0"), sites.length > 0 && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a, { optionFilterProp: "children", className: __WEBPACK_IMPORTED_MODULE_17__Documents_css___default.a.siteFilterSelect, filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }, onChange: function onChange(value) {
          return _this3.setState({ sitesFilter: value });
        }, placeholder: "Site Filter" }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option, { value: ALL_SITES_FILTER }, "All Sites"), sites.map(function (site, index) {
        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option, { key: index, value: site ? site.id : null }, site ? site.code + " - " + site.name : "General");
      })), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p", null, "\xA0"), isLoading && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a, { tip: "Loading..." }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("ul", null, !isLoading && listItems), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p", null, "\xA0"), requestResult.type && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_17__Documents_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("ul", null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["b" /* Link */], { to: "/", style: { color: "#FAFAFA" }, className: "menu-item" }, " ", "Home", " ")))))))), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1482);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-spin {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  display: none;\n  color: #4CDEF5;\n  text-align: center;\n  vertical-align: middle;\n  opacity: 0;\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-spin-spinning {\n  position: static;\n  display: inline-block;\n  opacity: 1;\n}\n.ant-spin-nested-loading {\n  position: relative;\n}\n.ant-spin-nested-loading > div > .ant-spin {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -10px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 5px;\n  text-shadow: 0 1px 2px #fff;\n}\n.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {\n  margin-top: -20px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {\n  margin: -7px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {\n  padding-top: 2px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {\n  margin-top: -17px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {\n  margin: -16px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {\n  padding-top: 11px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {\n  margin-top: -26px;\n}\n.ant-spin-container {\n  position: relative;\n  transition: opacity 0.3s;\n}\n.ant-spin-container::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: none \\9;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  opacity: 0;\n  transition: all 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-spin-blur {\n  clear: both;\n  overflow: hidden;\n  opacity: 0.5;\n  user-select: none;\n  pointer-events: none;\n}\n.ant-spin-blur::after {\n  opacity: 0.4;\n  pointer-events: auto;\n}\n.ant-spin-tip {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-spin-dot {\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  width: 1em;\n  height: 1em;\n}\n.ant-spin-dot-item {\n  position: absolute;\n  display: block;\n  width: 9px;\n  height: 9px;\n  background-color: #4CDEF5;\n  border-radius: 100%;\n  transform: scale(0.75);\n  transform-origin: 50% 50%;\n  opacity: 0.3;\n  animation: antSpinMove 1s infinite linear alternate;\n}\n.ant-spin-dot-item:nth-child(1) {\n  top: 0;\n  left: 0;\n}\n.ant-spin-dot-item:nth-child(2) {\n  top: 0;\n  right: 0;\n  animation-delay: 0.4s;\n}\n.ant-spin-dot-item:nth-child(3) {\n  right: 0;\n  bottom: 0;\n  animation-delay: 0.8s;\n}\n.ant-spin-dot-item:nth-child(4) {\n  bottom: 0;\n  left: 0;\n  animation-delay: 1.2s;\n}\n.ant-spin-dot-spin {\n  transform: rotate(45deg);\n  animation: antRotate 1.2s infinite linear;\n}\n.ant-spin-sm .ant-spin-dot {\n  font-size: 14px;\n}\n.ant-spin-sm .ant-spin-dot i {\n  width: 6px;\n  height: 6px;\n}\n.ant-spin-lg .ant-spin-dot {\n  font-size: 32px;\n}\n.ant-spin-lg .ant-spin-dot i {\n  width: 14px;\n  height: 14px;\n}\n.ant-spin.ant-spin-show-text .ant-spin-text {\n  display: block;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ */\n  .ant-spin-blur {\n    background: #fff;\n    opacity: 0.5;\n  }\n}\n@keyframes antSpinMove {\n  to {\n    opacity: 1;\n  }\n}\n@keyframes antRotate {\n  to {\n    transform: rotate(405deg);\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Documents__content__2YvLL","parentContainer":"Documents__parentContainer__2Ixaj","siteFilterSelect":"Documents__siteFilterSelect__1ZFwI"};

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileLink_css__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FileLink_css__);





var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var FileButton = function (_React$Component) {
  _inherits(FileButton, _React$Component);function FileButton(props) {
    var _this2 = this;_classCallCheck(this, FileButton);var _this = _possibleConstructorReturn(this, (FileButton.__proto__ || Object.getPrototypeOf(FileButton)).call(this, props));_this.openPrivateFileLink = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(e) {
        var _ref2, data, link;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                e.preventDefault();_this.setState({ privateFileLoading: true });_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_5__api_requests__["_9" /* getPrivateFileLinkRequest */])({ url: _this.props.url });case 4:
                _ref2 = _context.sent;data = _ref2.data;link = document.createElement("a");link.href = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, "private_url");link.target = "_blank";link.click();_this.setState({ privateFileLoading: false });case 11:case "end":
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.state = { privateFileLoading: null };return _this;
  }_createClass(FileButton, [{ key: "render", value: function render() {
      var privateFileLoading = this.state.privateFileLoading;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a", { onClick: this.openPrivateFileLink, style: { color: "#FAFAFA" }, className: "menu-item" }, privateFileLoading && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading", className: __WEBPACK_IMPORTED_MODULE_6__FileLink_css___default.a.iconButton }), this.props.text);
    } }]);return FileButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (FileButton);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContactUsForm_ContactUsForm__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactUs_css__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactUs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ContactUs_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Home = function (_React$Component) {
  _inherits(Home, _React$Component);function Home() {
    _classCallCheck(this, Home);return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }_createClass(Home, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_10__ContactUs_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_10__ContactUs_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 22, className: 'frosted-card' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ContactUsForm_ContactUsForm__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */], { to: '/', style: { color: '#FAFAFA' }, className: 'menu-item' }, ' Home ')))))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_recaptcha_v3__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_recaptcha_v3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_recaptcha_v3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css__);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var ContactUsForm = function (_React$Component) {
  _inherits(ContactUsForm, _React$Component);function ContactUsForm(props) {
    var _this2 = this;_classCallCheck(this, ContactUsForm);var _this = _possibleConstructorReturn(this, (ContactUsForm.__proto__ || Object.getPrototypeOf(ContactUsForm)).call(this, props));_this.componentDidMount = function () {
      Object(__WEBPACK_IMPORTED_MODULE_18_react_recaptcha_v3__["loadReCaptcha"])("6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6");
    };_this.verifyCallback = function (recaptchaToken) {
      _this.setState({ token: recaptchaToken });
    };_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var payload, response, errors;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 20;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;payload = Object.assign({}, values);payload['recaptcha_response'] = _this.state.token;_context.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["m" /* contactUsRequest */])(payload);case 8:
                  response = _context.sent;_this.setState({ isLoading: false, requestResult: { type: 'success', message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(response, 'data.message') } });setTimeout(function () {
                    window.location.href = "/";
                  }, 1500);_context.next = 20;break;case 13:
                  _context.prev = 13;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 18;break;
                  }_this.props.logout();return _context.abrupt('return');case 18:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 20:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 13]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {}, token: '' };return _this;
  }_createClass(ContactUsForm, [{ key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var getFieldDecorator = this.props.form.getFieldDecorator;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h4', { className: 'headline-default' }, 'Contact Us'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, 'Feel free to contact us with any comments, questions or concerns below. Your email will be sent to act@ucalgary.ca', __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), 'Please enter your email, a short subject, and a brief description of what you require help with.'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, 'Regards,', __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), ' The AcT Team'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Email:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('email', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'email', '') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'email', placeholder: 'email' })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Subject:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('subject', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'subject', '') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { placeholder: 'Subject' })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Message:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('message', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'message', '') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea, { placeholder: 'Message' })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_recaptcha_v3__["ReCaptcha"], { ref: this.recaptcha, sitekey: "6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6", action: 'contact_us', verifyCallback: this.verifyCallback }), requestResult.type && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css___default.a.actionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'default', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_19_classnames___default()(__WEBPACK_IMPORTED_MODULE_22__ContactUsForm_css___default.a.submitButton, 'menu-item') }, 'Send', isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })))));
    } }]);return ContactUsForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: 'user' })(ContactUsForm));

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(n){var r={};function o(e){if(r[e])return r[e].exports;var t=r[e]={i:e,l:!1,exports:{}};return n[e].call(t.exports,t,t.exports,o),t.l=!0,t.exports}return o.m=n,o.c=r,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)o.d(n,r,function(e){return t[e]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=1)}([function(e,t){e.exports=__webpack_require__(0)},function(e,t,n){var r=n(2).default,o=n(4).default;e.exports={ReCaptcha:r,loadReCaptcha:o}},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n.n(r);n(3);function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function u(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function i(e){return(i=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function f(e,t){return(f=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function l(){return"undefined"!=typeof window&&void 0!==window.grecaptcha&&void 0!==window.grecaptcha.execute}var p,s=function(e){function n(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(t=function(e,t){return!t||"object"!==a(t)&&"function"!=typeof t?c(e):t}(this,i(n).call(this,e))).execute=t.execute.bind(c(t)),t.state={ready:l()},t.state.ready||(p=setInterval(t._updateReadyState.bind(c(t)),1e3)),t}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&f(e,t)}(n,r["Component"]),function(e,t,n){t&&u(e.prototype,t),n&&u(e,n)}(n,[{key:"componentDidMount",value:function(){this.state.ready&&this.execute()}},{key:"componentDidUpdate",value:function(e,t){this.state.ready&&!t.ready&&this.execute()}},{key:"componentWillUnmount",value:function(){clearInterval(p)}},{key:"execute",value:function(){var e=this.props,t=e.sitekey,n=e.verifyCallback,r=e.action;this.state.ready&&window.grecaptcha.execute(t,{action:r}).then(function(e){void 0!==n&&n(e)})}},{key:"_updateReadyState",value:function(){l()&&(this.setState(function(){return{ready:!0}}),clearInterval(p))}},{key:"render",value:function(){return this.state.ready?o.a.createElement("div",{id:this.props.elementID,"data-verifycallbackname":this.props.verifyCallbackName}):o.a.createElement("div",{id:this.props.elementID,className:"g-recaptcha"})}}]),n}();s.defaultProps={elementID:"g-recaptcha",verifyCallbackName:"verifyCallback"},t.default=s},function(e,t){e.exports=__webpack_require__(12)},function(e,t,n){"use strict";n.r(t);t.default=function(e){var t=document.createElement("script");t.src="https://www.google.com/recaptcha/api.js?render=".concat(e),document.body.appendChild(t)}}]);

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ContactUsForm__wrapper__3L87y","submitButton":"ContactUsForm__submitButton__1KgC1","actionWrapper":"ContactUsForm__actionWrapper__1CcuA"};

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ContactUs__content__1x5aM","parentContainer":"ContactUs__parentContainer__3ASch"};

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LoginForm_LoginForm__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Login_css__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_isNotAuthenticated__ = __webpack_require__(211);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import { Link } from 'react-router-dom'
var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Login = function (_React$Component) {
  _inherits(Login, _React$Component);function Login() {
    _classCallCheck(this, Login);return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
  }_createClass(Login, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__Login_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_9__Login_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_9__Login_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_LoginForm_LoginForm__["a" /* default */], null)))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Login;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_isNotAuthenticated__["a" /* default */])(Login));

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LoginForm_css__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__LoginForm_css__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var LoginForm = function (_React$Component) {
  _inherits(LoginForm, _React$Component);function LoginForm(props) {
    var _this2 = this;_classCallCheck(this, LoginForm);var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var response;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 25;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });if (!(_this.state.step === 1)) {
                    _context.next = 15;break;
                  }_context.prev = 4;_context.next = 7;return _this.props.login({ username: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'username'), password: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'password') });case 7:
                  response = _context.sent;_this.setState({ responseMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(response, 'data.message'), step: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(response, 'data.access_token') ? 1 : 2 });_context.next = 14;break;case 11:
                  _context.prev = 11;_context.t0 = _context['catch'](4);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context.t0, 'message') });case 14:
                  _this.setState({ isLoading: false });case 15:
                  if (!(_this.state.step === 2 && __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'code'))) {
                    _context.next = 25;break;
                  }_context.prev = 16;_context.next = 19;return _this.props.loginTwoFactor({ username: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'username'), password: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'password'), code: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'code') });case 19:
                  _context.next = 25;break;case 21:
                  _context.prev = 21;_context.t1 = _context['catch'](16);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context.t1, 'message') });_this.setState({ isLoading: false });case 25:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[4, 11], [16, 21]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, step: 1 };return _this;
  }_createClass(LoginForm, [{ key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldError = _props$form.getFieldError,
          isFieldTouched = _props$form.isFieldTouched;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isSubmitted = _state.isSubmitted,
          step = _state.step;var usernameError = (isFieldTouched('username') || isSubmitted) && getFieldError('username');var passwordError = (isFieldTouched('password') || isSubmitted) && getFieldError('password');var codeError = (isFieldTouched('code') || isSubmitted) && getFieldError('code');return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h2', { className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.headline, style: { color: 'rgb(40, 109, 168)' } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_17__assets_img_act_quicr_logo_png___default.a, style: { objectFit: 'contain', width: '60px', height: 'auto' } }), 'AcT Admin Portal'), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: usernameError ? 'error' : '', help: usernameError || '' }, getFieldDecorator('username', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'user', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Username' }))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: passwordError ? 'error' : '', help: passwordError || '' }, getFieldDecorator('password', { rules: [{ required: true, message: 'Please input your Password!' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), type: 'password', placeholder: 'Password' }))), step === 2 && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', null, 'Input the 6-digit code sent to your email'), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: codeError ? 'error' : '', help: codeError || '' }, getFieldDecorator('code', { rules: [{ required: true, message: 'Please input your Password!' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'code', placeholder: 'code' })))), errorMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.alertsMb }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.submitButton }, 'Authenticate', isLoading && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' })))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.paragraph }, 'Forgot your User ID or password? ', __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */], { to: routes.admin.resetPassword }, 'Click here')), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_18__LoginForm_css___default.a.paragraph }, 'Need help? ', __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */], { to: '/contact-us' }, 'Click here')));
    } }]);return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { token: Object(__WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { login: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["c" /* login */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({ name: 'login' })(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(LoginForm)));

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"LoginForm__loginForm__3HpEG","headline":"LoginForm__headline__2lysS","alertsMb":"LoginForm__alertsMb__kBPCR","submitButton":"LoginForm__submitButton__2Jjah","paragraph":"LoginForm__paragraph__3aJtM"};

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Login__content__1ytYp","parentContainer":"Login__parentContainer__3Ux-e","loginForm":"Login__loginForm__XYJZW"};

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ResetForm_ResetForm__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResetPassword_css__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResetPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ResetPassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__ = __webpack_require__(211);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import { Link } from 'react-router-dom'
var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var ResetPassword = function (_React$Component) {
  _inherits(ResetPassword, _React$Component);function ResetPassword() {
    _classCallCheck(this, ResetPassword);return _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).apply(this, arguments));
  }_createClass(ResetPassword, [{ key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_10__ResetPassword_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_10__ResetPassword_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_10__ResetPassword_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ResetForm_ResetForm__["a" /* default */], { token: token })))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return ResetPassword;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__["a" /* default */])(ResetPassword));

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResetForm_css__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ResetForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var ResetForm = function (_React$Component) {
  _inherits(ResetForm, _React$Component);function ResetForm(props) {
    var _this2 = this;_classCallCheck(this, ResetForm);var _this = _possibleConstructorReturn(this, (ResetForm.__proto__ || Object.getPrototypeOf(ResetForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var response;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 14;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return _this.props.resetPassword({ username: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'username') });case 6:
                  response = _context.sent;_this.setState({ responseMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(response, 'data.message') });_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context.t0, 'response.data.msg') });case 13:
                  _this.setState({ isLoading: false });case 14:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: '' };return _this;
  }_createClass(ResetForm, [{ key: 'componentDidMount', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (!this.props.token) {
                  _context2.next = 9;break;
                }_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_34" /* resetPasswordConfirmUserRequest */])({ token: this.props.token });case 4:
                _context2.next = 9;break;case 6:
                _context2.prev = 6;_context2.t0 = _context2['catch'](1);this.setState({ checkConfirmRequestError: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context2.t0, 'response.data.message', 'Error') });case 9:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this, [[1, 6]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = this.props.token;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldError = _props$form.getFieldError,
          isFieldTouched = _props$form.isFieldTouched;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isSubmitted = _state.isSubmitted,
          checkConfirmRequestError = _state.checkConfirmRequestError;var usernameError = (isFieldTouched('username') || isSubmitted) && getFieldError('username');return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h2', { className: __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default.a.headline, style: { color: 'rgb(40, 109, 168)' } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png___default.a, style: { objectFit: 'contain', width: '60px', height: 'auto' } }), 'Reset password'), !token && !responseMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: usernameError ? 'error' : '', help: usernameError || '' }, getFieldDecorator('username', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'user', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Username' })))), errorMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_18__ResetForm_css___default.a.submitButton }, 'Reset password', isLoading && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' })))));
    } }]);return ResetForm;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({ name: 'login' })(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(ResetForm)));

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetForm__loginForm__9JUb7","alertsMb":"ResetForm__alertsMb__3mmp3","submitButton":"ResetForm__submitButton__1lCWz","paragraph":"ResetForm__paragraph__2G9NE","headline":"ResetForm__headline__NBE_g"};

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ResetPassword__content__1HUpi","parentContainer":"ResetPassword__parentContainer__2Q-t_","loginForm":"ResetPassword__loginForm__2PaNU"};

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ResetSendForm_ResetSendForm__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__ = __webpack_require__(211);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import { Link } from 'react-router-dom'
var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var ResetPasswordSend = function (_React$Component) {
  _inherits(ResetPasswordSend, _React$Component);function ResetPasswordSend() {
    _classCallCheck(this, ResetPasswordSend);return _possibleConstructorReturn(this, (ResetPasswordSend.__proto__ || Object.getPrototypeOf(ResetPasswordSend)).apply(this, arguments));
  }_createClass(ResetPasswordSend, [{ key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 12, className: __WEBPACK_IMPORTED_MODULE_10__ResetPasswordSend_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ResetSendForm_ResetSendForm__["a" /* default */], { token: token, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return ResetPasswordSend;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__["a" /* default */])(ResetPasswordSend));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var ResetSendForm = function (_React$Component) {
  _inherits(ResetSendForm, _React$Component);function ResetSendForm(props) {
    var _this2 = this;_classCallCheck(this, ResetSendForm);var _this = _possibleConstructorReturn(this, (ResetSendForm.__proto__ || Object.getPrototypeOf(ResetSendForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_33" /* resetPasswordConfirmRequest */])({ password: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'password'), confirm_password: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(values, 'passwordConfirm'), token: _this.props.token });case 6:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.history.push(routes.admin.login);
                  }, 1200);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context.t0, 'response.data.msg'), isLoading: false });case 13:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: 'Checking...', username: '' };return _this;
  }_createClass(ResetSendForm, [{ key: 'componentDidMount', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (!this.props.token) {
                  _context2.next = 12;break;
                }_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_34" /* resetPasswordConfirmUserRequest */])({ token: this.props.token });case 4:
                _ref3 = _context2.sent;data = _ref3.data;this.setState({ checkConfirmRequestError: null, username: data.username });_context2.next = 12;break;case 9:
                _context2.prev = 9;_context2.t0 = _context2['catch'](1);this.setState({ checkConfirmRequestError: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context2.t0, 'response.data.message') });case 12:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldError = _props$form.getFieldError,
          isFieldTouched = _props$form.isFieldTouched;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isSubmitted = _state.isSubmitted,
          checkConfirmRequestError = _state.checkConfirmRequestError,
          username = _state.username;var passwordError = (isFieldTouched('password') || isSubmitted) && getFieldError('password');var passwordConfirmError = (isFieldTouched('passwordConfirm') || isSubmitted) && getFieldError('passwordConfirm');return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h2', { className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.headline, style: { color: 'rgb(40, 109, 168)' } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_19__assets_img_act_quicr_logo_png___default.a, style: { objectFit: 'contain', width: '60px', height: 'auto' } }), 'Reset password'), username && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', null, 'For: ', __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('b', null, username)), !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: passwordError ? 'error' : '', help: passwordError || '' }, getFieldDecorator('password', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Password' }))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: passwordConfirmError ? 'error' : '', help: passwordConfirmError || '' }, getFieldDecorator('passwordConfirm', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Repeat password' })))), errorMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.submitButton }, 'Reset password', isLoading && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' }))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_18__ResetSendForm_css___default.a.paragraph }, 'To first step ', __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */], { to: routes.admin.resetPassword }, 'Click here'))));
    } }]);return ResetSendForm;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_16__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_15__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({ name: 'login' })(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(ResetSendForm)));

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetSendForm__loginForm__3ZNkC","alertsMb":"ResetSendForm__alertsMb__2N6Uf","submitButton":"ResetSendForm__submitButton__2RTzn","paragraph":"ResetSendForm__paragraph__1Yqrp","headline":"ResetSendForm__headline__3AGxm"};

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ResetPasswordSend__content__17VN2","parentContainer":"ResetPasswordSend__parentContainer__1AoSa","loginForm":"ResetPasswordSend__loginForm__1k-AP"};

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SetAccountPasswordForm_SetAccountPasswordForm__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__ = __webpack_require__(211);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import { Link } from 'react-router-dom'
var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var SetAccountPassword = function (_React$Component) {
  _inherits(SetAccountPassword, _React$Component);function SetAccountPassword() {
    _classCallCheck(this, SetAccountPassword);return _possibleConstructorReturn(this, (SetAccountPassword.__proto__ || Object.getPrototypeOf(SetAccountPassword)).apply(this, arguments));
  }_createClass(SetAccountPassword, [{ key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(this.props, 'match.params.token');return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: 24, sm: 18, md: 18, lg: 20, xl: 12, className: __WEBPACK_IMPORTED_MODULE_10__SetAccountPassword_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SetAccountPasswordForm_SetAccountPasswordForm__["a" /* default */], { token: token, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SetAccountPassword;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_isNotAuthenticated__["a" /* default */])(SetAccountPassword));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_passwordValidationRegex__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_act_quicr_logo_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_act_quicr_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_act_quicr_logo_png__);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var SetAccountPasswordForm = function (_React$Component) {
  _inherits(SetAccountPasswordForm, _React$Component);function SetAccountPasswordForm(props) {
    var _this2 = this;_classCallCheck(this, SetAccountPasswordForm);var _this = _possibleConstructorReturn(this, (SetAccountPasswordForm.__proto__ || Object.getPrototypeOf(SetAccountPasswordForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_15__api_requests__["_41" /* setPasswordConfirmRequest */])({ password: __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(values, 'password'), confirm_password: __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(values, 'passwordConfirm'), token: _this.props.token });case 6:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.history.push(routes.admin.login);
                  }, 1200);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(_context.t0, 'response.data.msg'), isLoading: false });case 13:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: 'Checking...', username: '' };return _this;
  }_createClass(SetAccountPasswordForm, [{ key: 'componentDidMount', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (!this.props.token) {
                  _context2.next = 12;break;
                }_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_15__api_requests__["_42" /* setPasswordConfirmUserRequest */])({ token: this.props.token });case 4:
                _ref3 = _context2.sent;data = _ref3.data;this.setState({ checkConfirmRequestError: null, username: data.username });_context2.next = 12;break;case 9:
                _context2.prev = 9;_context2.t0 = _context2['catch'](1);this.setState({ checkConfirmRequestError: __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(_context2.t0, 'response.data.message') });case 12:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldError = _props$form.getFieldError,
          isFieldTouched = _props$form.isFieldTouched;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isSubmitted = _state.isSubmitted,
          checkConfirmRequestError = _state.checkConfirmRequestError,
          username = _state.username;var passwordError = (isFieldTouched('password') || isSubmitted) && getFieldError('password');var passwordConfirmError = (isFieldTouched('passwordConfirm') || isSubmitted) && getFieldError('passwordConfirm');return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('h2', { className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.headline, style: { color: 'rgb(40, 109, 168)' } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', { alt: 'act', src: __WEBPACK_IMPORTED_MODULE_18__assets_img_act_quicr_logo_png___default.a, style: { objectFit: 'contain', width: '60px', height: 'auto' } }), 'Set Account Password'), username && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p', null, 'For: ', __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('b', null, username)), !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: passwordError ? 'error' : '', help: passwordError || '' }, getFieldDecorator('password', { rules: [{ required: true, message: 'Required' }, { pattern: __WEBPACK_IMPORTED_MODULE_16__utils_passwordValidationRegex__["a" /* passwordValidationRegex */], message: 'The password must contain at least one UPPERCASE letter, one lowercase letter, one number. Password length: 8-32 characters.' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Password' }))), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, { validateStatus: passwordConfirmError ? 'error' : '', help: passwordConfirmError || '' }, getFieldDecorator('passwordConfirm', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Repeat password' })))), errorMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_17__SetAccountPasswordForm_css___default.a.submitButton }, 'Set password', isLoading && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' })))));
    } }]);return SetAccountPasswordForm;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({ name: 'login' })(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["c" /* connect */])(mapStateToProps)(SetAccountPasswordForm)));

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return passwordValidationRegex; });


var passwordValidationRegex = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-_@$!%*.+=~{}\\|/\[\],#?&<>()^]{8,32}$/);

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"SetAccountPasswordForm__loginForm__3Vb35","alertsMb":"SetAccountPasswordForm__alertsMb__2j95L","submitButton":"SetAccountPasswordForm__submitButton__2x3oi","paragraph":"SetAccountPasswordForm__paragraph__2QqG5","headline":"SetAccountPasswordForm__headline__1l1ID"};

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SetAccountPassword__content__165He","parentContainer":"SetAccountPassword__parentContainer__3snMF","loginForm":"SetAccountPassword__loginForm__1mTyn"};

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_progress_style__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_progress__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_url__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__ = __webpack_require__(37);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a.Content;var Option = __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;var RangePicker = __WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker___default.a.RangePicker;var AdminDashboard = function (_React$Component) {
  _inherits(AdminDashboard, _React$Component);function AdminDashboard(props) {
    var _this2 = this;_classCallCheck(this, AdminDashboard);var _this = _possibleConstructorReturn(this, (AdminDashboard.__proto__ || Object.getPrototypeOf(AdminDashboard)).call(this, props));_this.columns = [{ dataIndex: "site", key: "site", title: "Site", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(val, 'code'), ' - ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(val, 'name'));
      } }, { dataIndex: "subject", key: "subject", title: "Subject", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(val, 'code'));
      } }, { dataIndex: "created", key: "created", title: "Created", render: function render(val, record) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default.a.utc(val).tz(_this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'site.time_zone') || 'UTC').format('YYYY-MM-DD HH:mm'), ' ', _this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'site.short_tz') || 'UTC');
      } }, { dataIndex: "scheduled_date", key: "scheduled_date", title: "Scheduled date", render: function render(val, record) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default.a.utc(val).tz(_this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'site.time_zone') || 'UTC').format('YYYY-MM-DD HH:mm'), ' ', _this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'site.short_tz') || 'UTC');
      } }, { dataIndex: "subject", key: "subject_action", title: "Actions", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_router_dom__["b" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_31__utils_url__["a" /* withParams */])(routes.admin.followUp90DaySingle, { subjectID: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(val, 'code') }) }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.viewIcon })));
      } }];_this.handleFilterChange = function (value) {
      if (value === 'month') {
        _this.setState({ dateRange: [__WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(), __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()().add(30, 'days')] });
      }_this.setState({ filter: value, site: null }, _this.getDashboardData);
    };_this.handleSiteChange = function (value) {
      _this.setState({ site: value }, _this.getDashboardData);
    };_this.handleSiteFollowUpFilterChange = function (value) {
      _this.setState({ filterSiteId: value }, _this.getFollowUps);
    };_this.getDashboardData = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dateRangeParams, dateRange, _ref2, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ isLoadingFollowUps: true });_context.prev = 1;dateRangeParams = {};if (_this.state.filter === 'month') {
                dateRange = _this.state.dateRange;dateRangeParams = { // start_date: moment.utc(dateRange[0]).tz(this.props.userTimezone).format('YYYY-MM-DDT00:00'),
                  start_date: __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(dateRange[0]).format('YYYY-MM-DDT00:00')).toISOString(), end_date: __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(dateRange[1]).add(1, 'day').format('YYYY-MM-DDT00:00')).toISOString() };
              }_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["Y" /* getDashboardRequest */])(Object.assign({ filter: _this.state.filter, siteCode: _this.state.site }, dateRangeParams));case 6:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ dashboard: data });_context.next = 17;break;case 11:
              _context.prev = 11;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 16;break;
              }_this.props.logout();return _context.abrupt('return');case 16:
              console.log(_context.t0);case 17:
              _this.setState({ isLoadingFollowUps: false });case 18:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 11]]);
    }));_this.getFollowUps = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref4, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_5" /* getFollowUpsRequest */])({ filter_by: _this.state.followup_filter, site_id: _this.state.filterSiteId, page: page, per_page: per_page });case 3:
              _ref4 = _context2.sent;data = _ref4.data;_this.setState({ followups: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'data'), total: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'total_pages') * per_page, currentPage: page });_context2.next = 14;break;case 8:
              _context2.prev = 8;_context2.t0 = _context2['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 13;break;
              }_this.props.logout();return _context2.abrupt('return');case 13:
              console.log(_context2.t0);case 14:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 8]]);
    }));_this.setFollowUpFilter = function (filter) {
      _this.setState({ followup_filter: filter, filterSiteId: null }, function () {
        if (filter !== 'site') {
          _this.getFollowUps();
        }
      });
    };_this.clearFollowUpFilter = function (filter) {
      _this.setState({ followup_filter: 'follow_ups_due' });
    };_this.handleTableChange = function (pagination) {
      _this.setState({ pageSize: pagination.pageSize }, function () {
        return _this.getFollowUps(pagination.current, pagination.pageSize);
      });
    };_this.getEnrolmentsLabels = function () {
      var filter = _this.state.filter;var enrolments = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolments');return Array.isArray(enrolments) ? enrolments.map(function (item) {
        if (filter === 'site') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'site');
        }if (filter === 'month') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'year_month');
        }
      }) : [_this.state.site ? __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.sites.find(function (item) {
        return item.code === _this.state.site;
      }), 'name') : 'All sites'];
    };_this.getEnrolmentsDatasets = function () {
      var dataSet = [{ label: "Total subjects", backgroundColor: "#3e95cd" }];var enrolments = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolments', []);if (Array.isArray(enrolments)) {
        dataSet[0].data = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolments', []).map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
        });
      } else {
        dataSet[0].data = [enrolments];
      }return dataSet;
    };_this.getSaesLabels = function () {
      var filter = _this.state.filter;var sae = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'sae');return Array.isArray(sae) ? sae.map(function (item) {
        if (filter === 'site') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'site');
        }if (filter === 'month') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'year_month');
        }
      }) : [_this.state.site ? __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.sites.find(function (item) {
        return item.code === _this.state.site;
      }), 'name') : 'All sites'];
    };_this.getSaesDatasets = function () {
      var dataSet = [{ label: "SAE", backgroundColor: "#f00" }];var sae = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'sae', []);if (Array.isArray(sae)) {
        dataSet[0].data = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'sae', []).map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
        });
      } else {
        dataSet[0].data = [sae];
      }return dataSet;
    };_this.getDeviationsLabels = function () {
      var filter = _this.state.filter;var protocolDeviations = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'protocol_deviations');return Array.isArray(protocolDeviations) ? protocolDeviations.map(function (item) {
        if (filter === 'site') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'site');
        }if (filter === 'month') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'year_month');
        }
      }) : [_this.state.site ? __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.sites.find(function (item) {
        return item.code === _this.state.site;
      }), 'name') : 'All sites'];
    };_this.getDeviationsDatasets = function () {
      var dataSet = [{ label: "Deviations", backgroundColor: "#e1e023" }];var protocol_deviations = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'protocol_deviations', []);if (Array.isArray(protocol_deviations)) {
        dataSet[0].data = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'protocol_deviations', []).map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
        });
      } else {
        dataSet[0].data = [protocol_deviations];
      }return dataSet;
    };_this.getEnrolmentsStageLabels = function () {
      var filter = _this.state.filter;var enrolmentStagesRandomize = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.randomize');return Array.isArray(enrolmentStagesRandomize) ? enrolmentStagesRandomize.map(function (item) {
        if (filter === 'site') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'site');
        }if (filter === 'month') {
          return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'year_month');
        }
      }) : [_this.state.site ? __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.sites.find(function (item) {
        return item.code === _this.state.site;
      }), 'name') : 'All sites'];
    };_this.getEnrolmentsStageDatasets = function () {
      var dataSet = [{ label: "Randomize", backgroundColor: "#3e95cd" }, { label: "SAE", backgroundColor: "#f00" }, { label: "Consent", backgroundColor: "#49c850" }, { label: "Validation", backgroundColor: "#e11eb0" }, { label: "Deviation", backgroundColor: "#e1e023" }, { label: "Profile", backgroundColor: "#c137bd" }, { label: "Registry id", backgroundColor: "#41aac4" }, { label: "Follow up 90 days", backgroundColor: "#e18e2d" }, { label: "Death", backgroundColor: "#797677" }];var esRandomize = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.randomize');var esSAE = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.sae');var esConsent = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.consent');var esValidation = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.validation');var esDeviation = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.deviation');var esProfile = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.profile');var esRegistryID = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.registry_id');var esFollowUp90Days = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.follow_up_90_days');var esDeath = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_this.state.dashboard, 'enrolment_stages.death');dataSet[0].data = Array.isArray(esRandomize) ? esRandomize.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esRandomize];dataSet[1].data = Array.isArray(esSAE) ? esSAE.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esSAE];dataSet[2].data = Array.isArray(esConsent) ? esConsent.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esConsent];dataSet[3].data = Array.isArray(esValidation) ? esValidation.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esValidation];dataSet[4].data = Array.isArray(esDeviation) ? esDeviation.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esDeviation];dataSet[5].data = Array.isArray(esProfile) ? esProfile.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esProfile];dataSet[6].data = Array.isArray(esRegistryID) ? esRegistryID.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esRegistryID];dataSet[7].data = Array.isArray(esFollowUp90Days) ? esFollowUp90Days.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esFollowUp90Days];dataSet[8].data = Array.isArray(esDeath) ? esDeath.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(item, 'count');
      }) : [esDeath];return dataSet;
    };_this.onDateRangeChange = function (val) {
      _this.setState({ dateRange: val }, _this.getDashboardData);
    };_this.expandedRowRender = function (record) {
      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile') ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { lg: 6, md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Patient info'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Name:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.first_name'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.last_name')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Email:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.email')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Phone:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.phone_number_type_1'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.phone_number_1')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Address:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.street_address'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.city'), ', ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.postal_code')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Is deceased:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.is_deceased') ? 'Yes' : 'No')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { lg: 6, md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Other contact'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Name:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_first_name'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_last_name')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Relationship:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_relationship_type').replace(/_/g, ' ')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Email:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_email')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Phone:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_phone_number_type'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_1_phone_number'))), __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_first_name') && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { lg: 6, md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Other contact 2'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Name:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_first_name'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_last_name')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Relationship:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_relationship_type').replace(/_/g, ' ')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Email:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_email')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Phone:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_phone_number_type'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.contact_2_phone_number'))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { lg: 6, md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Family Doctor'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Name:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.family_doctor_first_name'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.family_doctor_last_name')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Clinic:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.family_doctor_clinic_name')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Phone:'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.family_doctor_phone_number_type'), ' ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(record, 'subject.profile.family_doctor_phone_number')))) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, 'Profile is empty'));
    };_this.state = { dashboard: {}, filter: '', filterSiteId: null, site: '', sites: [], dateRange: [__WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()(), __WEBPACK_IMPORTED_MODULE_20_moment_timezone___default()().add(30, 'days')], followup_filter: 'follow_ups_due', followups: [], currentPage: 1, total: 1, pageSize: 25, isLoadingFollowUps: false };return _this;
  }_createClass(AdminDashboard, [{ key: 'componentDidMount', value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref6, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.getDashboardData();this.getFollowUps();_context3.prev = 2;_context3.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_20" /* getSitesRequest */])();case 5:
                _ref6 = _context3.sent;data = _ref6.data;this.setState({ sites: data });_context3.next = 16;break;case 10:
                _context3.prev = 10;_context3.t0 = _context3['catch'](2);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                  _context3.next = 15;break;
                }this.props.logout();return _context3.abrupt('return');case 15:
                console.log(_context3.t0);case 16:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this, [[2, 10]]);
      }));function componentDidMount() {
        return _ref5.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'customExpandIcon', value: function customExpandIcon(props) {
      if (props.expanded) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('a', { style: { color: 'black' }, onClick: function onClick(e) {
            props.onExpand(props.record, e);
          } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'eye-invisible', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.viewIcon }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('a', { style: { color: 'black' }, onClick: function onClick(e) {
            props.onExpand(props.record, e);
          } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'eye', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.viewIcon }));
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          dashboard = _state.dashboard,
          filter = _state.filter,
          sites = _state.sites,
          dateRange = _state.dateRange,
          followups = _state.followups,
          total = _state.total,
          pageSize = _state.pageSize,
          currentPage = _state.currentPage,
          followup_filter = _state.followup_filter,
          isLoadingFollowUps = _state.isLoadingFollowUps;var progressPar = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'progress_bar');var report30days = __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_next_30_days_records', null);return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' }, className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('title', null, 'Trial Management Portal: Dashboard')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h4', { className: 'headline-default' }, 'Study progress'), __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'target_count') && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Target count: ', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'target_count', 0))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, { className: 'contentMb-24' }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Follow up 90 days completed'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_progress___default.a, { percent: +(100 * __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'follow_up_90_days_completed_count', 0) / __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'target_count', 1)).toFixed(3), strokeColor: '#74B584' }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Follow up 90 days not Completed'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_progress___default.a, { percent: +(100 * __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'follow_up_90_days_not_completed_count', 0) / __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(progressPar, 'target_count', 1)).toFixed(3), strokeColor: '#F2A788' })), this.props.dashboardPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, this.props.dashboardFollowUp90dPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, '90-day Follow-up Summary'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__["b" /* HorizontalBar */], { data: { labels: [''], datasets: [{ label: "Followup not due", backgroundColor: "#8b8b8d", data: [__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_not_due', 0)] }, { label: "Upcoming follow-ups", backgroundColor: "#e1e023", data: [__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_next_30_days', 0)] }, { label: "Follow-ups due", backgroundColor: "#c78538", data: [__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_next_90_120_days_count', 0)] }, { label: "Overdue follow-ups", backgroundColor: "#be0000", data: [__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_next_over_120_days_count', 0)] }, { label: "Followup completed", backgroundColor: "#2ca022", data: [__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(dashboard, 'summary_bi_report.follow_up_completed', 0)] }] }, width: 100, height: 300, options: { maintainAspectRatio: false, type: 'horizontalBar', scales: { xAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }] } }, type: 'horizontalBar' })))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h4', { className: 'headline-default' }, 'Upcoming follow-ups'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { style: { display: 'flex' } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { style: { marginRight: '1rem' } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', { style: { width: '300px', display: 'block' } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Filter:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { value: followup_filter, onChange: this.setFollowUpFilter, style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'upcoming_not_due' }, 'Upcoming not due'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'upcoming_next_30_days' }, 'Upcoming next 30 days'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'follow_ups_due' }, 'Followups due'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'follow_ups_overdue' }, 'Followups overdue'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'follow_ups_completed' }, 'Followups completed')))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', { style: { width: '300px', display: 'block' } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Site:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { placeholder: 'Select Site ID', style: { width: '100%' }, value: this.state.filterSiteId, onChange: this.handleSiteFollowUpFilterChange }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: null }, 'All'), Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["uniqBy"])(this.state.sites, 'id').map(function (site, index) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: index, value: site.id }, site.code, ' - ', site.name);
      }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a, { className: __WEBPACK_IMPORTED_MODULE_27__AdminDashboard_css___default.a.tableWrapper, columns: this.columns, dataSource: followups, loading: isLoadingFollowUps, rowKey: 'id', onChange: this.handleTableChange, expandedRowRender: this.expandedRowRender, expandIcon: function expandIcon(props) {
          return _this3.customExpandIcon(props);
        }, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null)), (this.props.dashboardReadEnrolmentBySitePermission || this.props.dashboardEnrolmentStagesPermission || this.props.dashboardReadSAEPermission || this.props.dashboardReadDeviationPermission) && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12, lg: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Filter:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { value: filter, onChange: this.handleFilterChange, style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'site' }, 'By Site'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'month' }, 'By Date Range'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: '' }, 'None')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null)), filter === 'month' && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12, lg: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Select date range'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(RangePicker, { value: dateRange, onChange: this.onDateRangeChange, format: 'DD MMM, YYYY', allowClear: false })), (filter === 'site' || filter === 'month') && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12, lg: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Site:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { onChange: this.handleSiteChange, style: { width: '100%' }, placeholder: 'Select' }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: site.id, value: site.code }, site.code, ' - ', site.name);
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: '' }, 'All sites')))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a, null, this.props.dashboardReadEnrolmentBySitePermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Enrolment by Site'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__["a" /* Bar */], { data: { labels: this.getEnrolmentsLabels(), datasets: this.getEnrolmentsDatasets() }, width: 100, height: 300, options: { maintainAspectRatio: false, scales: { yAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }] } } }))), this.props.dashboardEnrolmentStagesPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Enrolment Stage'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__["b" /* HorizontalBar */], { data: { labels: this.getEnrolmentsStageLabels(), datasets: this.getEnrolmentsStageDatasets() }, width: 100, height: 300, options: { maintainAspectRatio: false, type: 'horizontalBar', scales: { xAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }] } }, type: 'horizontalBar' }))), this.props.dashboardReadSAEPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'SAEs'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__["b" /* HorizontalBar */], { data: { labels: this.getSaesLabels(), datasets: this.getSaesDatasets() }, width: 100, height: 300, options: { maintainAspectRatio: false, type: 'horizontalBar', scales: { xAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }] } }, type: 'horizontalBar' }))), this.props.dashboardReadDeviationPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h5', { className: 'headline-default' }, 'Deviations'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_chartjs_2__["b" /* HorizontalBar */], { data: { labels: this.getDeviationsLabels(), datasets: this.getDeviationsDatasets() }, width: 100, height: 300, options: { maintainAspectRatio: false, type: 'horizontalBar', scales: { xAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }] } }, type: 'horizontalBar' })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return AdminDashboard;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), dashboardPermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["m" /* getDashboardPermission */])(state), dashboardFollowUp90dPermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["l" /* getDashboardFollowUp90dPermission */])(state), dashboardReadEnrolmentBySitePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["o" /* getDashboardReadEnrolmentBySitePermission */])(state), dashboardEnrolmentStagesPermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["k" /* getDashboardEnrolmentStagesPermission */])(state), dashboardReadSAEPermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["p" /* getDashboardReadSAEPermission */])(state), dashboardReadDeviationPermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["n" /* getDashboardReadDeviationPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_28__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(AdminDashboard)));

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1509);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-table-wrapper {\n  zoom: 1;\n}\n.ant-table-wrapper::before,\n.ant-table-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-table-wrapper::after {\n  clear: both;\n}\n.ant-table {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  clear: both;\n}\n.ant-table-body {\n  transition: opacity 0.3s;\n}\n.ant-table-empty .ant-table-body {\n  overflow-x: auto !important;\n  overflow-y: hidden !important;\n}\n.ant-table table {\n  width: 100%;\n  text-align: left;\n  border-radius: 4px 4px 0 0;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-table-layout-fixed table {\n  table-layout: fixed;\n}\n.ant-table-thead > tr > th {\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  text-align: left;\n  background: #fafafa;\n  border-bottom: 1px solid #e8e8e8;\n  transition: background 0.3s ease;\n}\n.ant-table-thead > tr > th[colspan]:not([colspan='1']) {\n  text-align: center;\n}\n.ant-table-thead > tr > th .anticon-filter,\n.ant-table-thead > tr > th .ant-table-filter-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 28px;\n  height: 100%;\n  color: #bfbfbf;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-table-thead > tr > th .anticon-filter > svg,\n.ant-table-thead > tr > th .ant-table-filter-icon > svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -5px;\n  margin-left: -6px;\n}\n.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {\n  color: #4CDEF5;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner {\n  height: 1em;\n  margin-top: 0.35em;\n  margin-left: 0.57142857em;\n  color: #bfbfbf;\n  line-height: 1em;\n  text-align: center;\n  transition: all 0.3s;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 11px \\9;\n  transform: scale(0.91666667) rotate(0deg);\n  display: block;\n  height: 1em;\n  line-height: 1em;\n  transition: all 0.3s;\n}\n:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,\n:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {\n  font-size: 12px;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {\n  color: #4CDEF5;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full {\n  margin-top: -0.15em;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-up,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {\n  height: 0.5em;\n  line-height: 0.5em;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {\n  margin-top: 0.125em;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions {\n  position: relative;\n  background-clip: padding-box;\n  /* stylelint-disable-next-line */\n  -webkit-background-clip: border-box;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {\n  padding-right: 30px !important;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .anticon-filter.ant-table-filter-open,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .ant-table-filter-icon.ant-table-filter-open {\n  color: rgba(0, 0, 0, 0.45);\n  background: #e5e5e5;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:hover,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:hover {\n  color: rgba(0, 0, 0, 0.45);\n  background: #e5e5e5;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:active,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:active {\n  color: #424242;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {\n  cursor: pointer;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {\n  background: #f2f2f2;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .anticon-filter,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .ant-table-filter-icon {\n  background: #f2f2f2;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-up:not(.on),\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-down:not(.on) {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-table-thead > tr > th .ant-table-header-column {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters {\n  display: table;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > .ant-table-column-title {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > *:not(.ant-table-column-sorter) {\n  position: relative;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  transition: all 0.3s;\n  content: '';\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters:hover::before {\n  background: rgba(0, 0, 0, 0.04);\n}\n.ant-table-thead > tr > th.ant-table-column-has-sorters {\n  user-select: none;\n}\n.ant-table-thead > tr:first-child > th:first-child {\n  border-top-left-radius: 4px;\n}\n.ant-table-thead > tr:first-child > th:last-child {\n  border-top-right-radius: 4px;\n}\n.ant-table-thead > tr:not(:last-child) > th[colspan] {\n  border-bottom: 0;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e8e8e8;\n  transition: all 0.3s, border 0s;\n}\n.ant-table-thead > tr,\n.ant-table-tbody > tr {\n  transition: all 0.3s, height 0s;\n}\n.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #f0fffe;\n}\n.ant-table-thead > tr.ant-table-row-selected > td.ant-table-column-sort,\n.ant-table-tbody > tr.ant-table-row-selected > td.ant-table-column-sort {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover.ant-table-row-selected > td,\n.ant-table-tbody > tr:hover.ant-table-row-selected > td {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover.ant-table-row-selected > td.ant-table-column-sort,\n.ant-table-tbody > tr:hover.ant-table-row-selected > td.ant-table-column-sort {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover {\n  background: none;\n}\n.ant-table-footer {\n  position: relative;\n  padding: 16px 16px;\n  color: rgba(0, 0, 0, 0.85);\n  background: #fafafa;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 4px 4px;\n}\n.ant-table-footer::before {\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #fafafa;\n  content: '';\n}\n.ant-table.ant-table-bordered .ant-table-footer {\n  border: 1px solid #e8e8e8;\n}\n.ant-table-title {\n  position: relative;\n  top: 1px;\n  padding: 16px 0;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table.ant-table-bordered .ant-table-title {\n  padding-right: 16px;\n  padding-left: 16px;\n  border: 1px solid #e8e8e8;\n}\n.ant-table-title + .ant-table-content {\n  position: relative;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-bordered .ant-table-title + .ant-table-content,\n.ant-table-bordered .ant-table-title + .ant-table-content table,\n.ant-table-bordered .ant-table-title + .ant-table-content .ant-table-thead > tr:first-child > th {\n  border-radius: 0;\n}\n.ant-table-without-column-header .ant-table-title + .ant-table-content,\n.ant-table-without-column-header table {\n  border-radius: 0;\n}\n.ant-table-without-column-header.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-top: 1px solid #e8e8e8;\n  border-radius: 4px;\n}\n.ant-table-tbody > tr.ant-table-row-selected td {\n  color: inherit;\n  background: #fafafa;\n}\n.ant-table-thead > tr > th.ant-table-column-sort {\n  background: #f5f5f5;\n}\n.ant-table-tbody > tr > td.ant-table-column-sort {\n  background: rgba(0, 0, 0, 0.01);\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  padding: 16px 16px;\n  overflow-wrap: break-word;\n}\n.ant-table-expand-icon-th,\n.ant-table-row-expand-icon-cell {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n}\n.ant-table-header {\n  overflow: hidden;\n  background: #fafafa;\n}\n.ant-table-header table {\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-loading {\n  position: relative;\n}\n.ant-table-loading .ant-table-body {\n  background: #fff;\n  opacity: 0.5;\n}\n.ant-table-loading .ant-table-spin-holder {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 20px;\n  margin-left: -30px;\n  line-height: 20px;\n}\n.ant-table-loading .ant-table-with-pagination {\n  margin-top: -20px;\n}\n.ant-table-loading .ant-table-without-pagination {\n  margin-top: 10px;\n}\n.ant-table-bordered .ant-table-header > table,\n.ant-table-bordered .ant-table-body > table,\n.ant-table-bordered .ant-table-fixed-left table,\n.ant-table-bordered .ant-table-fixed-right table {\n  border: 1px solid #e8e8e8;\n  border-right: 0;\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-right: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header + .ant-table-body > table,\n.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {\n  border-top: 0;\n}\n.ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-bordered .ant-table-thead > tr > th,\n.ant-table-bordered .ant-table-tbody > tr > td {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-placeholder {\n  position: relative;\n  z-index: 1;\n  margin-top: -1px;\n  padding: 16px 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  text-align: center;\n  background: #fff;\n  border-top: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 0 0 4px 4px;\n}\n.ant-table-pagination.ant-pagination {\n  float: right;\n  margin: 16px 0;\n}\n.ant-table-filter-dropdown {\n  position: relative;\n  min-width: 96px;\n  margin-left: -8px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  border: 0;\n  border-radius: 4px 4px 0 0;\n  box-shadow: none;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {\n  max-height: 400px;\n  overflow-x: hidden;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {\n  padding-right: 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-sub {\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title::after {\n  color: #4CDEF5;\n  font-weight: bold;\n  text-shadow: 0 0 2px #f0ffff;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item {\n  overflow: hidden;\n}\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0;\n}\n.ant-table-filter-dropdown-btns {\n  padding: 7px 8px;\n  overflow: hidden;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-filter-dropdown-link {\n  color: #4CDEF5;\n}\n.ant-table-filter-dropdown-link:hover {\n  color: #78f1ff;\n}\n.ant-table-filter-dropdown-link:active {\n  color: #36b5cf;\n}\n.ant-table-filter-dropdown-link.confirm {\n  float: left;\n}\n.ant-table-filter-dropdown-link.clear {\n  float: right;\n}\n.ant-table-selection {\n  white-space: nowrap;\n}\n.ant-table-selection-select-all-custom {\n  margin-right: 4px !important;\n}\n.ant-table-selection .anticon-down {\n  color: #bfbfbf;\n  transition: all 0.3s;\n}\n.ant-table-selection-menu {\n  min-width: 96px;\n  margin-top: 5px;\n  margin-left: -30px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-selection-menu .ant-action-down {\n  color: #bfbfbf;\n}\n.ant-table-selection-down {\n  display: inline-block;\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n}\n.ant-table-selection-down:hover .anticon-down {\n  color: rgba(0, 0, 0, 0.6);\n}\n.ant-table-row-expand-icon {\n  color: #4CDEF5;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  color: inherit;\n  line-height: 13px;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 2px;\n  outline: none;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-table-row-expand-icon:focus,\n.ant-table-row-expand-icon:hover {\n  color: #78f1ff;\n}\n.ant-table-row-expand-icon:active {\n  color: #36b5cf;\n}\n.ant-table-row-expand-icon:focus,\n.ant-table-row-expand-icon:hover,\n.ant-table-row-expand-icon:active {\n  border-color: currentColor;\n}\n.ant-table-row-expanded::after {\n  content: '-';\n}\n.ant-table-row-collapsed::after {\n  content: '+';\n}\n.ant-table-row-spaced {\n  visibility: hidden;\n}\n.ant-table-row-spaced::after {\n  content: '.';\n}\n.ant-table-row-cell-ellipsis,\n.ant-table-row-cell-ellipsis .ant-table-column-title {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-table-row-cell-ellipsis .ant-table-column-title {\n  display: block;\n}\n.ant-table-row-cell-break-word {\n  word-wrap: break-word;\n  word-break: break-word;\n}\ntr.ant-table-expanded-row,\ntr.ant-table-expanded-row:hover {\n  background: #fbfbfb;\n}\ntr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -16px -16px -17px;\n}\n.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 8px;\n}\n.ant-table-scroll {\n  overflow: auto;\n  overflow-x: hidden;\n}\n.ant-table-scroll table {\n  min-width: 100%;\n}\n.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) {\n  color: transparent;\n}\n.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) > * {\n  visibility: hidden;\n}\n.ant-table-body-inner {\n  height: 100%;\n}\n.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  position: relative;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-body-inner {\n  overflow: scroll;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  margin-bottom: -20px;\n  padding-bottom: 20px;\n  overflow: scroll;\n  opacity: 0.9999;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {\n  border: 1px solid #e8e8e8;\n  border-width: 0 0 1px 0;\n}\n.ant-table-hide-scrollbar {\n  scrollbar-color: transparent transparent;\n  min-width: unset;\n}\n.ant-table-hide-scrollbar::-webkit-scrollbar {\n  min-width: inherit;\n  background-color: transparent;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {\n  border: 1px solid #e8e8e8;\n  border-width: 1px 1px 1px 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header.ant-table-hide-scrollbar .ant-table-thead > tr:only-child > th:last-child {\n  border-right-color: transparent;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-right {\n  position: absolute;\n  top: 0;\n  z-index: auto;\n  overflow: hidden;\n  border-radius: 0;\n  transition: box-shadow 0.3s ease;\n}\n.ant-table-fixed-left table,\n.ant-table-fixed-right table {\n  width: auto;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,\n.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {\n  border-radius: 0;\n}\n.ant-table-fixed-left {\n  left: 0;\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.ant-table-fixed-left .ant-table-header {\n  overflow-y: hidden;\n}\n.ant-table-fixed-left .ant-table-body-inner {\n  margin-right: -20px;\n  padding-right: 20px;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {\n  padding-right: 0;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-left table {\n  border-radius: 4px 0 0 0;\n}\n.ant-table-fixed-left .ant-table-thead > tr > th:last-child {\n  border-top-right-radius: 0;\n}\n.ant-table-fixed-right {\n  right: 0;\n  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.ant-table-fixed-right,\n.ant-table-fixed-right table {\n  border-radius: 0 4px 0 0;\n}\n.ant-table-fixed-right .ant-table-expanded-row {\n  color: transparent;\n  pointer-events: none;\n}\n.ant-table-fixed-right .ant-table-thead > tr > th:first-child {\n  border-top-left-radius: 0;\n}\n.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {\n  box-shadow: none;\n}\n.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {\n  box-shadow: none;\n}\n.ant-table colgroup > col.ant-table-selection-col {\n  width: 60px;\n}\n.ant-table-thead > tr > th.ant-table-selection-column-custom .ant-table-selection {\n  margin-right: -15px;\n}\n.ant-table-thead > tr > th.ant-table-selection-column,\n.ant-table-tbody > tr > td.ant-table-selection-column {\n  text-align: center;\n}\n.ant-table-thead > tr > th.ant-table-selection-column .ant-radio-wrapper,\n.ant-table-tbody > tr > td.ant-table-selection-column .ant-radio-wrapper {\n  margin-right: 0;\n}\n.ant-table-row[class*='ant-table-row-level-0'] .ant-table-selection-column > span {\n  display: inline-block;\n}\n.ant-table-filter-dropdown .ant-checkbox-wrapper + span,\n.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {\n  padding-left: 8px;\n}\n/**\n* Another fix of Firefox:\n*/\n@supports (-moz-appearance: meterbar) {\n  .ant-table-thead > tr > th.ant-table-column-has-actions {\n    background-clip: padding-box;\n  }\n}\n.ant-table-middle > .ant-table-title,\n.ant-table-middle > .ant-table-content > .ant-table-footer {\n  padding: 12px 8px;\n}\n.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {\n  padding: 12px 8px;\n}\n.ant-table-middle tr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -12px -8px -13px;\n}\n.ant-table-small {\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n}\n.ant-table-small > .ant-table-title,\n.ant-table-small > .ant-table-content > .ant-table-footer {\n  padding: 8px 8px;\n}\n.ant-table-small > .ant-table-title {\n  top: 0;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-footer {\n  background-color: transparent;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-footer::before {\n  background-color: transparent;\n}\n.ant-table-small > .ant-table-content > .ant-table-body {\n  margin: 0 8px;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  border: 0;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {\n  padding: 8px 8px;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th {\n  background-color: transparent;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort {\n  background-color: rgba(0, 0, 0, 0.01);\n}\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  padding: 0;\n}\n.ant-table-small > .ant-table-content .ant-table-header {\n  background-color: transparent;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-small > .ant-table-content .ant-table-placeholder,\n.ant-table-small > .ant-table-content .ant-table-row:last-child td {\n  border-bottom: 0;\n}\n.ant-table-small.ant-table-bordered {\n  border-right: 0;\n}\n.ant-table-small.ant-table-bordered .ant-table-title {\n  border: 0;\n  border-right: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-content {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-footer {\n  border: 0;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-footer::before {\n  display: none;\n}\n.ant-table-small.ant-table-bordered .ant-table-placeholder {\n  border-right: 0;\n  border-bottom: 0;\n  border-left: 0;\n}\n.ant-table-small.ant-table-bordered .ant-table-thead > tr > th.ant-table-row-cell-last,\n.ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child {\n  border-right: none;\n}\n.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-thead > tr > th:last-child,\n.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-tbody > tr > td:last-child {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-fixed-right {\n  border-right: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-table-small tr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -8px -8px -9px;\n}\n.ant-table-small.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  border-radius: 0 0 4px 4px;\n}\n", ""]);

// exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1511);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  display: block;\n}\n.ant-dropdown::before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  bottom: -7px;\n  left: -7px;\n  z-index: -9999;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down::before {\n  transition: transform 0.2s;\n}\n.ant-dropdown-wrap-open .anticon-down::before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  position: relative;\n  margin: 0;\n  padding: 4px 0;\n  text-align: left;\n  list-style-type: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.ant-dropdown-menu-item-group-title {\n  padding: 5px 12px;\n  color: rgba(0, 0, 0, 0.45);\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n}\n.ant-dropdown-menu-submenu-popup > .ant-dropdown-menu {\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu-popup ul,\n.ant-dropdown-menu-submenu-popup li {\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-popup ul {\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n  padding: 0;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  clear: both;\n  margin: 0;\n  padding: 5px 12px;\n  color: #424242;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-item > .anticon:first-child,\n.ant-dropdown-menu-submenu-title > .anticon:first-child,\n.ant-dropdown-menu-item > span > .anticon:first-child,\n.ant-dropdown-menu-submenu-title > span > .anticon:first-child {\n  min-width: 12px;\n  margin-right: 8px;\n  font-size: 12px;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  display: block;\n  margin: -5px -12px;\n  padding: 5px 12px;\n  color: #424242;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #4CDEF5;\n  background-color: #f0fffe;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #f0fffe;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  margin: 4px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow {\n  position: absolute;\n  right: 8px;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  color: rgba(0, 0, 0, 0.45);\n  font-style: normal;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,\n:root .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  font-size: 12px;\n}\n.ant-dropdown-menu-item-group-list {\n  margin: 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-title {\n  padding-right: 26px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {\n  color: #4CDEF5;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger > .anticon.anticon-down,\n.ant-dropdown-link > .anticon.anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-trigger > .anticon.anticon-down,\n:root .ant-dropdown-link > .anticon.anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-dropdown-button .anticon.anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-button .anticon.anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: rgba(0, 0, 0, 0);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow::after {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  color: #fff;\n  background: #4CDEF5;\n}\n", ""]);

// exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1513);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-pagination {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-pagination ul,\n.ant-pagination ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-pagination::after {\n  display: block;\n  clear: both;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n  content: ' ';\n}\n.ant-pagination-total-text {\n  display: inline-block;\n  height: 32px;\n  margin-right: 8px;\n  line-height: 30px;\n  vertical-align: middle;\n}\n.ant-pagination-item {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  font-family: Arial;\n  line-height: 30px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  outline: 0;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-pagination-item a {\n  display: block;\n  padding: 0 6px;\n  color: #424242;\n  transition: none;\n}\n.ant-pagination-item a:hover {\n  text-decoration: none;\n}\n.ant-pagination-item:focus,\n.ant-pagination-item:hover {\n  border-color: #4CDEF5;\n  transition: all 0.3s;\n}\n.ant-pagination-item:focus a,\n.ant-pagination-item:hover a {\n  color: #4CDEF5;\n}\n.ant-pagination-item-active {\n  font-weight: 500;\n  background: #fff;\n  border-color: #4CDEF5;\n}\n.ant-pagination-item-active a {\n  color: #4CDEF5;\n}\n.ant-pagination-item-active:focus,\n.ant-pagination-item-active:hover {\n  border-color: #78f1ff;\n}\n.ant-pagination-item-active:focus a,\n.ant-pagination-item-active:hover a {\n  color: #78f1ff;\n}\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  outline: 0;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container,\n.ant-pagination-jump-next .ant-pagination-item-container {\n  position: relative;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 12px \\9;\n  transform: scale(1) rotate(0deg);\n  color: #4CDEF5;\n  letter-spacing: -1px;\n  opacity: 0;\n  transition: all 0.2s;\n}\n:root .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n:root .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  font-size: 12px;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  margin: auto;\n  color: rgba(0, 0, 0, 0.25);\n  letter-spacing: 2px;\n  text-align: center;\n  text-indent: 0.13em;\n  opacity: 1;\n  transition: all 0.2s;\n}\n.ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:focus .ant-pagination-item-link-icon,\n.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {\n  opacity: 1;\n}\n.ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,\n.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {\n  opacity: 0;\n}\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  margin-right: 8px;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  color: #424242;\n  font-family: Arial;\n  line-height: 32px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-pagination-prev,\n.ant-pagination-next {\n  outline: 0;\n}\n.ant-pagination-prev a,\n.ant-pagination-next a {\n  color: #424242;\n  user-select: none;\n}\n.ant-pagination-prev:hover a,\n.ant-pagination-next:hover a {\n  border-color: #78f1ff;\n}\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  display: block;\n  height: 100%;\n  font-size: 12px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  outline: none;\n  transition: all 0.3s;\n}\n.ant-pagination-prev:focus .ant-pagination-item-link,\n.ant-pagination-next:focus .ant-pagination-item-link,\n.ant-pagination-prev:hover .ant-pagination-item-link,\n.ant-pagination-next:hover .ant-pagination-item-link {\n  color: #4CDEF5;\n  border-color: #4CDEF5;\n}\n.ant-pagination-disabled,\n.ant-pagination-disabled:hover,\n.ant-pagination-disabled:focus {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled a,\n.ant-pagination-disabled:hover a,\n.ant-pagination-disabled:focus a,\n.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination-disabled:hover .ant-pagination-item-link,\n.ant-pagination-disabled:focus .ant-pagination-item-link {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination-slash {\n  margin: 0 10px 0 5px;\n}\n.ant-pagination-options {\n  display: inline-block;\n  margin-left: 16px;\n  vertical-align: middle;\n}\n.ant-pagination-options-size-changer.ant-select {\n  display: inline-block;\n  width: auto;\n  margin-right: 8px;\n}\n.ant-pagination-options-quick-jumper {\n  display: inline-block;\n  height: 32px;\n  line-height: 32px;\n  vertical-align: top;\n}\n.ant-pagination-options-quick-jumper input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  padding: 4px 11px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all 0.3s;\n  width: 50px;\n  margin: 0 8px;\n}\n.ant-pagination-options-quick-jumper input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-pagination-options-quick-jumper input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-pagination-options-quick-jumper input:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input:focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-pagination-options-quick-jumper input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-pagination-options-quick-jumper input {\n  max-width: 100%;\n  height: auto;\n  min-height: 32px;\n  line-height: 1.5;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-pagination-options-quick-jumper input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-pagination-options-quick-jumper input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination-simple .ant-pagination-next {\n  height: 24px;\n  line-height: 24px;\n  vertical-align: top;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {\n  height: 24px;\n  border: 0;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager {\n  display: inline-block;\n  height: 24px;\n  margin-right: 8px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  box-sizing: border-box;\n  height: 100%;\n  margin-right: 8px;\n  padding: 0 6px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #4CDEF5;\n}\n.ant-pagination.mini .ant-pagination-total-text,\n.ant-pagination.mini .ant-pagination-simple-pager {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-item {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 22px;\n}\n.ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.mini .ant-pagination-prev,\n.ant-pagination.mini .ant-pagination-next {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-jump-prev,\n.ant-pagination.mini .ant-pagination-jump-next {\n  height: 24px;\n  margin-right: 0;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-options {\n  margin-left: 2px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper input {\n  height: 24px;\n  padding: 1px 7px;\n  width: 44px;\n}\n.ant-pagination.ant-pagination-disabled {\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item a {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border: none;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {\n  background: #dbdbdb;\n  border-color: transparent;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {\n  color: #fff;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:hover,\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:focus {\n  color: rgba(0, 0, 0, 0.45);\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-link-icon {\n  opacity: 0;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {\n  opacity: 1;\n}\n@media only screen and (max-width: 992px) {\n  .ant-pagination-item-after-jump-prev,\n  .ant-pagination-item-before-jump-next {\n    display: none;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .ant-pagination-options {\n    display: none;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _rcTable = _interopRequireWildcard(__webpack_require__(1515));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _reactLifecyclesCompat = __webpack_require__(38);

var _filterDropdown = _interopRequireDefault(__webpack_require__(1604));

var _createStore = _interopRequireDefault(__webpack_require__(1612));

var _SelectionBox = _interopRequireDefault(__webpack_require__(1613));

var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1614));

var _Column = _interopRequireDefault(__webpack_require__(1618));

var _ColumnGroup = _interopRequireDefault(__webpack_require__(1619));

var _createBodyRow = _interopRequireDefault(__webpack_require__(1620));

var _util = __webpack_require__(531);

var _scrollTo = _interopRequireDefault(__webpack_require__(1621));

var _pagination = _interopRequireDefault(__webpack_require__(532));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _spin = _interopRequireDefault(__webpack_require__(333));

var _transButton = _interopRequireDefault(__webpack_require__(1631));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _default2 = _interopRequireDefault(__webpack_require__(158));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable prefer-spread */


function noop() {}

function stopPropagation(e) {
  e.stopPropagation();
}

function getRowSelection(props) {
  return props.rowSelection || {};
}

function getColumnKey(column, index) {
  return column.key || column.dataIndex || index;
}

function isSameColumn(a, b) {
  if (a && b && a.key && a.key === b.key) {
    return true;
  }

  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
    // https://github.com/ant-design/ant-design/issues/12737
    if (typeof value === 'function' && typeof other === 'function') {
      return value === other || value.toString() === other.toString();
    } // https://github.com/ant-design/ant-design/issues/19398


    if (Array.isArray(value) && Array.isArray(other)) {
      return value === other || (0, _shallowequal["default"])(value, other);
    }
  });
}

var defaultPagination = {
  onChange: noop,
  onShowSizeChange: noop
};
/**
 * Avoid creating new object, so that parent component's shouldComponentUpdate
 * can works appropriately。
 */

var emptyObject = {};

var createComponents = function createComponents() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var bodyRow = components && components.body && components.body.row;
  return _extends(_extends({}, components), {
    body: _extends(_extends({}, components.body), {
      row: (0, _createBodyRow["default"])(bodyRow)
    })
  });
};

function isTheSameComponents() {
  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
    return (0, _shallowequal["default"])(components1[key], components2[key]);
  });
}

function getFilteredValueColumns(state, columns) {
  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
    return typeof column.filteredValue !== 'undefined';
  });
}

function getFiltersFromColumns() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var columns = arguments.length > 1 ? arguments[1] : undefined;
  var filters = {};
  getFilteredValueColumns(state, columns).forEach(function (col) {
    var colKey = getColumnKey(col);
    filters[colKey] = col.filteredValue;
  });
  return filters;
}

function isFiltersChanged(state, filters) {
  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
    return true;
  }

  return Object.keys(filters).some(function (columnKey) {
    return filters[columnKey] !== state.filters[columnKey];
  });
}

var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _this.setTableRef = function (table) {
      _this.rcTable = table;
    };

    _this.getCheckboxPropsByItem = function (item, index) {
      var rowSelection = getRowSelection(_this.props);

      if (!rowSelection.getCheckboxProps) {
        return {};
      }

      var key = _this.getRecordKey(item, index); // Cache checkboxProps


      if (!_this.props.checkboxPropsCache[key]) {
        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
        var checkboxProps = _this.props.checkboxPropsCache[key];
        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
      }

      return _this.props.checkboxPropsCache[key];
    };

    _this.getRecordKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
      return recordKey === undefined ? index : recordKey;
    };

    _this.onRow = function (prefixCls, record, index) {
      var onRow = _this.props.onRow;
      var custom = onRow ? onRow(record, index) : {};
      return _extends(_extends({}, custom), {
        prefixCls: prefixCls,
        store: _this.props.store,
        rowKey: _this.getRecordKey(record, index)
      });
    };

    _this.generatePopupContainerFunc = function (getPopupContainer) {
      var scroll = _this.props.scroll;
      var table = _this.rcTable;

      if (getPopupContainer) {
        return getPopupContainer;
      } // Use undefined to let rc component use default logic.


      return scroll && table ? function () {
        return table.tableNode;
      } : undefined;
    };

    _this.scrollToFirstRow = function () {
      var scroll = _this.props.scroll;

      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
        (0, _scrollTo["default"])(0, {
          getContainer: function getContainer() {
            return _this.rcTable.bodyTable;
          }
        });
      }
    };

    _this.handleFilter = function (column, nextFilters) {
      var props = _this.props;

      var pagination = _extends({}, _this.state.pagination);

      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns


      var currentColumnKeys = [];
      (0, _util.treeMap)(_this.state.columns, function (c) {
        if (!c.children) {
          currentColumnKeys.push(getColumnKey(c));
        }
      });
      Object.keys(filters).forEach(function (columnKey) {
        if (currentColumnKeys.indexOf(columnKey) < 0) {
          delete filters[columnKey];
        }
      });

      if (props.pagination) {
        // Reset current prop
        pagination.current = 1;
        pagination.onChange(pagination.current);
      }

      var newState = {
        pagination: pagination,
        filters: {}
      };

      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled


      getFilteredValueColumns(_this.state).forEach(function (col) {
        var columnKey = getColumnKey(col);

        if (columnKey) {
          delete filtersToSetState[columnKey];
        }
      });

      if (Object.keys(filtersToSetState).length > 0) {
        newState.filters = filtersToSetState;
      } // Controlled current prop will not respond user interaction


      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _extends(_extends({}, pagination), {
          current: _this.state.pagination.current
        });
      }

      _this.setState(newState, function () {
        _this.scrollToFirstRow();

        _this.props.store.setState({
          selectionDirty: false
        });

        var onChange = _this.props.onChange;

        if (onChange) {
          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
            selectionDirty: false,
            filters: filters,
            pagination: pagination
          })));
        }
      });
    };

    _this.handleSelect = function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;
      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);

      var key = _this.getRecordKey(record, rowIndex);

      var pivot = _this.state.pivot;

      var rows = _this.getFlatCurrentPageData();

      var realIndex = rowIndex;

      if (_this.props.expandedRowRender) {
        realIndex = rows.findIndex(function (row) {
          return _this.getRecordKey(row, rowIndex) === key;
        });
      }

      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
        var changeRowKeys = [];
        var direction = Math.sign(pivot - realIndex);
        var dist = Math.abs(pivot - realIndex);
        var step = 0;

        var _loop = function _loop() {
          var i = realIndex + step * direction;
          step += 1;
          var row = rows[i];

          var rowKey = _this.getRecordKey(row, i);

          var checkboxProps = _this.getCheckboxPropsByItem(row, i);

          if (!checkboxProps.disabled) {
            if (selectedRowKeys.includes(rowKey)) {
              if (!checked) {
                selectedRowKeys = selectedRowKeys.filter(function (j) {
                  return rowKey !== j;
                });
                changeRowKeys.push(rowKey);
              }
            } else if (checked) {
              selectedRowKeys.push(rowKey);
              changeRowKeys.push(rowKey);
            }
          }
        };

        while (step <= dist) {
          _loop();
        }

        _this.setState({
          pivot: realIndex
        });

        _this.props.store.setState({
          selectionDirty: true
        });

        _this.setSelectedRowKeys(selectedRowKeys, {
          selectWay: 'onSelectMultiple',
          record: record,
          checked: checked,
          changeRowKeys: changeRowKeys,
          nativeEvent: nativeEvent
        });
      } else {
        if (checked) {
          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
        } else {
          selectedRowKeys = selectedRowKeys.filter(function (i) {
            return key !== i;
          });
        }

        _this.setState({
          pivot: realIndex
        });

        _this.props.store.setState({
          selectionDirty: true
        });

        _this.setSelectedRowKeys(selectedRowKeys, {
          selectWay: 'onSelect',
          record: record,
          checked: checked,
          changeRowKeys: undefined,
          nativeEvent: nativeEvent
        });
      }
    };

    _this.handleRadioSelect = function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;

      var key = _this.getRecordKey(record, rowIndex);

      var selectedRowKeys = [key];

      _this.props.store.setState({
        selectionDirty: true
      });

      _this.setSelectedRowKeys(selectedRowKeys, {
        selectWay: 'onSelect',
        record: record,
        checked: checked,
        changeRowKeys: undefined,
        nativeEvent: nativeEvent
      });
    };

    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
      var data = _this.getFlatCurrentPageData();

      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);

      var changeableRowKeys = data.filter(function (item, i) {
        return !_this.getCheckboxPropsByItem(item, i).disabled;
      }).map(function (item, i) {
        return _this.getRecordKey(item, i);
      });
      var changeRowKeys = [];
      var selectWay = 'onSelectAll';
      var checked; // handle default selection

      switch (selectionKey) {
        case 'all':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = true;
          break;

        case 'removeAll':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) >= 0) {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = false;
          break;

        case 'invert':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
            } else {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
            }

            changeRowKeys.push(key);
            selectWay = 'onSelectInvert';
          });
          break;

        default:
          break;
      }

      _this.props.store.setState({
        selectionDirty: true
      }); // when select custom selection, callback selections[n].onSelect


      var rowSelection = _this.props.rowSelection;
      var customSelectionStartIndex = 2;

      if (rowSelection && rowSelection.hideDefaultSelections) {
        customSelectionStartIndex = 0;
      }

      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
        return onSelectFunc(changeableRowKeys);
      }

      _this.setSelectedRowKeys(selectedRowKeys, {
        selectWay: selectWay,
        checked: checked,
        changeRowKeys: changeRowKeys
      });
    };

    _this.handlePageChange = function (current) {
      var props = _this.props;

      var pagination = _extends({}, _this.state.pagination);

      if (current) {
        pagination.current = current;
      } else {
        pagination.current = pagination.current || 1;
      }

      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        otherArguments[_key - 1] = arguments[_key];
      }

      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
      var newState = {
        pagination: pagination
      }; // Controlled current prop will not respond user interaction

      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _extends(_extends({}, pagination), {
          current: _this.state.pagination.current
        });
      }

      _this.setState(newState, _this.scrollToFirstRow);

      _this.props.store.setState({
        selectionDirty: false
      });

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
          selectionDirty: false,
          pagination: pagination
        })));
      }
    };

    _this.handleShowSizeChange = function (current, pageSize) {
      var pagination = _this.state.pagination;
      pagination.onShowSizeChange(current, pageSize);

      var nextPagination = _extends(_extends({}, pagination), {
        pageSize: pageSize,
        current: current
      });

      _this.setState({
        pagination: nextPagination
      }, _this.scrollToFirstRow);

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
          pagination: nextPagination
        })));
      }
    };

    _this.renderExpandIcon = function (prefixCls) {
      return function (_ref) {
        var expandable = _ref.expandable,
            expanded = _ref.expanded,
            needIndentSpaced = _ref.needIndentSpaced,
            record = _ref.record,
            onExpand = _ref.onExpand;

        if (expandable) {
          return React.createElement(_LocaleReceiver["default"], {
            componentName: "Table",
            defaultLocale: _default2["default"].Table
          }, function (locale) {
            var _classNames;

            return React.createElement(_transButton["default"], {
              className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
              onClick: function onClick(event) {
                onExpand(record, event);
              },
              "aria-label": expanded ? locale.collapse : locale.expand,
              noStyle: true
            });
          });
        }

        if (needIndentSpaced) {
          return React.createElement("span", {
            className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
          });
        }

        return null;
      };
    };

    _this.renderSelectionBox = function (type) {
      return function (_, record, index) {
        var rowKey = _this.getRecordKey(record, index);

        var props = _this.getCheckboxPropsByItem(record, index);

        var handleChange = function handleChange(e) {
          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
        };

        return React.createElement("span", {
          onClick: stopPropagation
        }, React.createElement(_SelectionBox["default"], _extends({
          type: type,
          store: _this.props.store,
          rowIndex: rowKey,
          onChange: handleChange,
          defaultSelection: _this.getDefaultSelection()
        }, props)));
      };
    };

    _this.renderTable = function (_ref2) {
      var _classNames2;

      var prefixCls = _ref2.prefixCls,
          renderEmpty = _ref2.renderEmpty,
          dropdownPrefixCls = _ref2.dropdownPrefixCls,
          contextLocale = _ref2.contextLocale,
          contextGetPopupContainer = _ref2.getPopupContainer;

      var _a = _this.props,
          showHeader = _a.showHeader,
          locale = _a.locale,
          getPopupContainer = _a.getPopupContainer,
          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div


      var restProps = (0, _omit["default"])(restTableProps, ['style']);

      var data = _this.getCurrentPageData();

      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first

      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales

      var mergedLocale = _extends(_extends({}, contextLocale), locale);

      if (!locale || !locale.emptyText) {
        mergedLocale.emptyText = renderEmpty('Table');
      }

      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));

      var columnsWithRowSelection = _this.renderRowSelection({
        prefixCls: prefixCls,
        locale: mergedLocale,
        getPopupContainer: realGetPopupContainer
      });

      var columns = _this.renderColumnsDropdown({
        columns: columnsWithRowSelection,
        prefixCls: prefixCls,
        dropdownPrefixCls: dropdownPrefixCls,
        locale: mergedLocale,
        getPopupContainer: realGetPopupContainer
      }).map(function (column, i) {
        var newColumn = _extends({}, column);

        newColumn.key = getColumnKey(newColumn, i);
        return newColumn;
      });

      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;

      if ('expandIconColumnIndex' in restProps) {
        expandIconColumnIndex = restProps.expandIconColumnIndex;
      }

      return React.createElement(_rcTable["default"], _extends({
        ref: _this.setTableRef,
        key: "table",
        expandIcon: _this.renderExpandIcon(prefixCls)
      }, restProps, {
        onRow: function onRow(record, index) {
          return _this.onRow(prefixCls, record, index);
        },
        components: _this.state.components,
        prefixCls: prefixCls,
        data: data,
        columns: columns,
        showHeader: showHeader,
        className: classString,
        expandIconColumnIndex: expandIconColumnIndex,
        expandIconAsCell: expandIconAsCell,
        emptyText: mergedLocale.emptyText
      }));
    };

    _this.renderComponent = function (_ref3) {
      var getPrefixCls = _ref3.getPrefixCls,
          renderEmpty = _ref3.renderEmpty,
          getPopupContainer = _ref3.getPopupContainer;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
          style = _this$props.style,
          className = _this$props.className;

      var data = _this.getCurrentPageData();

      var loading = _this.props.loading;

      if (typeof loading === 'boolean') {
        loading = {
          spinning: loading
        };
      }

      var prefixCls = getPrefixCls('table', customizePrefixCls);
      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
      var table = React.createElement(_LocaleReceiver["default"], {
        componentName: "Table",
        defaultLocale: _default2["default"].Table
      }, function (locale) {
        return _this.renderTable({
          prefixCls: prefixCls,
          renderEmpty: renderEmpty,
          dropdownPrefixCls: dropdownPrefixCls,
          contextLocale: locale,
          getPopupContainer: getPopupContainer
        });
      }); // if there is no pagination or no data,
      // the height of spin should decrease by half of pagination

      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
      return React.createElement("div", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
        style: style
      }, React.createElement(_spin["default"], _extends({}, loading, {
        className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
      }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')));
    };

    var expandedRowRender = props.expandedRowRender,
        columnsProp = props.columns;
    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');

    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
      var fixed = _ref4.fixed;
      return !!fixed;
    })) {
      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
    }

    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
      // 减少状态
      filters: _this.getDefaultFilters(columns),
      pagination: _this.getDefaultPagination(props),
      pivot: undefined,
      prevProps: props,
      components: createComponents(props.components),
      columns: columns
    });
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          columns = _this$state.columns,
          sortColumn = _this$state.sortColumn,
          sortOrder = _this$state.sortOrder;

      if (this.getSortOrderColumns(columns).length > 0) {
        var sortState = this.getSortStateFromColumns(columns);

        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
          this.setState(sortState);
        }
      }
    }
  }, {
    key: "getDefaultSelection",
    value: function getDefaultSelection() {
      var _this2 = this;

      var rowSelection = getRowSelection(this.props);

      if (!rowSelection.getCheckboxProps) {
        return [];
      }

      return this.getFlatData().filter(function (item, rowIndex) {
        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
      }).map(function (record, rowIndex) {
        return _this2.getRecordKey(record, rowIndex);
      });
    }
  }, {
    key: "getDefaultPagination",
    value: function getDefaultPagination(props) {
      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
      var current;

      if ('current' in pagination) {
        current = pagination.current;
      } else if ('defaultCurrent' in pagination) {
        current = pagination.defaultCurrent;
      }

      var pageSize;

      if ('pageSize' in pagination) {
        pageSize = pagination.pageSize;
      } else if ('defaultPageSize' in pagination) {
        pageSize = pagination.defaultPageSize;
      }

      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
        current: current || 1,
        pageSize: pageSize || 10
      }) : {};
    }
  }, {
    key: "getSortOrderColumns",
    value: function getSortOrderColumns(columns) {
      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
        return 'sortOrder' in column;
      });
    }
  }, {
    key: "getDefaultFilters",
    value: function getDefaultFilters(columns) {
      var definedFilters = getFiltersFromColumns(this.state, columns);
      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
        return typeof column.defaultFilteredValue !== 'undefined';
      });
      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
        var colKey = getColumnKey(col);
        soFar[colKey] = col.defaultFilteredValue;
        return soFar;
      }, {});
      return _extends(_extends({}, defaultFilters), definedFilters);
    }
  }, {
    key: "getDefaultSortOrder",
    value: function getDefaultSortOrder(columns) {
      var definedSortState = this.getSortStateFromColumns(columns);
      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
        return column.defaultSortOrder != null;
      })[0];

      if (defaultSortedColumn && !definedSortState.sortColumn) {
        return {
          sortColumn: defaultSortedColumn,
          sortOrder: defaultSortedColumn.defaultSortOrder
        };
      }

      return definedSortState;
    }
  }, {
    key: "getSortStateFromColumns",
    value: function getSortStateFromColumns(columns) {
      // return first column which sortOrder is not falsy
      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
        return col.sortOrder;
      })[0];

      if (sortedColumn) {
        return {
          sortColumn: sortedColumn,
          sortOrder: sortedColumn.sortOrder
        };
      }

      return {
        sortColumn: null,
        sortOrder: null
      };
    }
  }, {
    key: "getMaxCurrent",
    value: function getMaxCurrent(total) {
      var _this$state$paginatio = this.state.pagination,
          current = _this$state$paginatio.current,
          pageSize = _this$state$paginatio.pageSize;

      if ((current - 1) * pageSize >= total) {
        return Math.floor((total - 1) / pageSize) + 1;
      }

      return current;
    }
  }, {
    key: "getSorterFn",
    value: function getSorterFn(state) {
      var _ref5 = state || this.state,
          sortOrder = _ref5.sortOrder,
          sortColumn = _ref5.sortColumn;

      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
        return;
      }

      return function (a, b) {
        var result = sortColumn.sorter(a, b, sortOrder);

        if (result !== 0) {
          return sortOrder === 'descend' ? -result : result;
        }

        return 0;
      };
    }
  }, {
    key: "getCurrentPageData",
    value: function getCurrentPageData() {
      var data = this.getLocalData();
      var current;
      var pageSize;
      var state = this.state; // 如果没有分页的话，默认全部展示

      if (!this.hasPagination()) {
        pageSize = Number.MAX_VALUE;
        current = 1;
      } else {
        pageSize = state.pagination.pageSize;
        current = this.getMaxCurrent(state.pagination.total || data.length);
      } // 分页
      // ---
      // 当数据量少于等于每页数量时，直接设置数据
      // 否则进行读取分页数据


      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
        data = data.slice((current - 1) * pageSize, current * pageSize);
      }

      return data;
    }
  }, {
    key: "getFlatData",
    value: function getFlatData() {
      var childrenColumnName = this.props.childrenColumnName;
      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
    }
  }, {
    key: "getFlatCurrentPageData",
    value: function getFlatCurrentPageData() {
      var childrenColumnName = this.props.childrenColumnName;
      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
    }
  }, {
    key: "getLocalData",
    value: function getLocalData(state) {
      var _this3 = this;

      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var currentState = state || this.state;
      var dataSource = this.props.dataSource;
      var data = dataSource || []; // 优化本地排序

      data = data.slice(0);
      var sorterFn = this.getSorterFn(currentState);

      if (sorterFn) {
        data = this.recursiveSort(data, sorterFn);
      } // 筛选


      if (filter && currentState.filters) {
        Object.keys(currentState.filters).forEach(function (columnKey) {
          var col = _this3.findColumn(columnKey);

          if (!col) {
            return;
          }

          var values = currentState.filters[columnKey] || [];

          if (values.length === 0) {
            return;
          }

          var onFilter = col.onFilter;
          data = onFilter ? data.filter(function (record) {
            return values.some(function (v) {
              return onFilter(v, record);
            });
          }) : data;
        });
      }

      return data;
    }
  }, {
    key: "setSelectedRowKeys",
    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
      var _this4 = this;

      var selectWay = selectionInfo.selectWay,
          record = selectionInfo.record,
          checked = selectionInfo.checked,
          changeRowKeys = selectionInfo.changeRowKeys,
          nativeEvent = selectionInfo.nativeEvent;
      var rowSelection = getRowSelection(this.props);

      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
        this.props.store.setState({
          selectedRowKeys: selectedRowKeys
        });
      }

      var data = this.getFlatData();

      if (!rowSelection.onChange && !rowSelection[selectWay]) {
        return;
      }

      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
      });

      if (rowSelection.onChange) {
        rowSelection.onChange(selectedRowKeys, selectedRows);
      }

      if (selectWay === 'onSelect' && rowSelection.onSelect) {
        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
        var changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
        });
        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
        var _changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
        });

        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
        rowSelection.onSelectInvert(selectedRowKeys);
      }
    }
  }, {
    key: "toggleSortOrder",
    value: function toggleSortOrder(column) {
      var sortDirections = column.sortDirections || this.props.sortDirections;
      var _this$state2 = this.state,
          sortOrder = _this$state2.sortOrder,
          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题

      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态

      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
        // 按照sortDirections的内容依次切换排序状态
        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
      } else {
        newSortOrder = sortDirections[0];
      }

      var newState = {
        sortOrder: newSortOrder,
        sortColumn: newSortOrder ? column : null
      }; // Controlled

      if (this.getSortOrderColumns().length === 0) {
        this.setState(newState, this.scrollToFirstRow);
      }

      var onChange = this.props.onChange;

      if (onChange) {
        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
      }
    }
  }, {
    key: "hasPagination",
    value: function hasPagination(props) {
      return (props || this.props).pagination !== false;
    }
  }, {
    key: "isSortColumn",
    value: function isSortColumn(column) {
      var sortColumn = this.state.sortColumn;

      if (!column || !sortColumn) {
        return false;
      }

      return getColumnKey(sortColumn) === getColumnKey(column);
    } // Get pagination, filters, sorter

  }, {
    key: "prepareParamsArguments",
    value: function prepareParamsArguments(state, column) {
      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange


      delete pagination.onChange;
      delete pagination.onShowSizeChange;
      var filters = state.filters;
      var sorter = {};
      var currentColumn = column;

      if (state.sortColumn && state.sortOrder) {
        currentColumn = state.sortColumn;
        sorter.column = state.sortColumn;
        sorter.order = state.sortOrder;
      }

      if (currentColumn) {
        sorter.field = currentColumn.dataIndex;
        sorter.columnKey = getColumnKey(currentColumn);
      }

      var extra = {
        currentDataSource: this.getLocalData(state)
      };
      return [pagination, filters, sorter, extra];
    }
  }, {
    key: "findColumn",
    value: function findColumn(myKey) {
      var column;
      (0, _util.treeMap)(this.state.columns, function (c) {
        if (getColumnKey(c) === myKey) {
          column = c;
        }
      });
      return column;
    }
  }, {
    key: "recursiveSort",
    value: function recursiveSort(data, sorterFn) {
      var _this5 = this;

      var _this$props$childrenC = this.props.childrenColumnName,
          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
      return data.sort(sorterFn).map(function (item) {
        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
      });
    }
  }, {
    key: "renderPagination",
    value: function renderPagination(prefixCls, paginationPosition) {
      // 强制不需要分页
      if (!this.hasPagination()) {
        return null;
      }

      var size = 'default';
      var pagination = this.state.pagination;

      if (pagination.size) {
        size = pagination.size;
      } else if (this.props.size === 'middle' || this.props.size === 'small') {
        size = 'small';
      }

      var position = pagination.position || 'bottom';
      var total = pagination.total || this.getLocalData().length;
      return total > 0 && (position === paginationPosition || position === 'both') ? React.createElement(_pagination["default"], _extends({
        key: "pagination-".concat(paginationPosition)
      }, pagination, {
        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
        onChange: this.handlePageChange,
        total: total,
        size: size,
        current: this.getMaxCurrent(total),
        onShowSizeChange: this.handleShowSizeChange
      })) : null;
    }
  }, {
    key: "renderRowSelection",
    value: function renderRowSelection(_ref6) {
      var _this6 = this;

      var prefixCls = _ref6.prefixCls,
          locale = _ref6.locale,
          getPopupContainer = _ref6.getPopupContainer;
      var rowSelection = this.props.rowSelection;
      var columns = this.state.columns.concat();

      if (rowSelection) {
        var data = this.getFlatCurrentPageData().filter(function (item, index) {
          if (rowSelection.getCheckboxProps) {
            return !_this6.getCheckboxPropsByItem(item, index).disabled;
          }

          return true;
        });
        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));

        var selectionColumn = _defineProperty({
          key: 'selection-column',
          render: this.renderSelectionBox(rowSelection.type),
          className: selectionColumnClass,
          fixed: rowSelection.fixed,
          width: rowSelection.columnWidth,
          title: rowSelection.columnTitle
        }, _rcTable.INTERNAL_COL_DEFINE, {
          className: "".concat(prefixCls, "-selection-col")
        });

        if (rowSelection.type !== 'radio') {
          var checkboxAllDisabled = data.every(function (item, index) {
            return _this6.getCheckboxPropsByItem(item, index).disabled;
          });
          selectionColumn.title = selectionColumn.title || React.createElement(_SelectionCheckboxAll["default"], {
            store: this.props.store,
            locale: locale,
            data: data,
            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
            getRecordKey: this.getRecordKey,
            disabled: checkboxAllDisabled,
            prefixCls: prefixCls,
            onSelect: this.handleSelectRow,
            selections: rowSelection.selections,
            hideDefaultSelections: rowSelection.hideDefaultSelections,
            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
          });
        }

        if ('fixed' in rowSelection) {
          selectionColumn.fixed = rowSelection.fixed;
        } else if (columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        })) {
          selectionColumn.fixed = 'left';
        }

        if (columns[0] && columns[0].key === 'selection-column') {
          columns[0] = selectionColumn;
        } else {
          columns.unshift(selectionColumn);
        }
      }

      return columns;
    }
  }, {
    key: "renderColumnsDropdown",
    value: function renderColumnsDropdown(_ref7) {
      var _this7 = this;

      var prefixCls = _ref7.prefixCls,
          dropdownPrefixCls = _ref7.dropdownPrefixCls,
          columns = _ref7.columns,
          locale = _ref7.locale,
          getPopupContainer = _ref7.getPopupContainer;
      var _this$state3 = this.state,
          sortOrder = _this$state3.sortOrder,
          filters = _this$state3.filters;
      return (0, _util.treeMap)(columns, function (column, i) {
        var _classNames4;

        var key = getColumnKey(column, i);
        var filterDropdown;
        var sortButton;
        var onHeaderCell = column.onHeaderCell;

        var isSortColumn = _this7.isSortColumn(column);

        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
          var colFilters = key in filters ? filters[key] : [];
          filterDropdown = React.createElement(_filterDropdown["default"], {
            locale: locale,
            column: column,
            selectedKeys: colFilters,
            confirmFilter: _this7.handleFilter,
            prefixCls: "".concat(prefixCls, "-filter"),
            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
            key: "filter-dropdown"
          });
        }

        if (column.sorter) {
          var sortDirections = column.sortDirections || _this7.props.sortDirections;
          var isAscend = isSortColumn && sortOrder === 'ascend';
          var isDescend = isSortColumn && sortOrder === 'descend';
          var ascend = sortDirections.indexOf('ascend') !== -1 && React.createElement(_icon["default"], {
            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
            type: "caret-up",
            theme: "filled"
          });
          var descend = sortDirections.indexOf('descend') !== -1 && React.createElement(_icon["default"], {
            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
            type: "caret-down",
            theme: "filled"
          });
          sortButton = React.createElement("div", {
            title: locale.sortTitle,
            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
            key: "sorter"
          }, ascend, descend);

          onHeaderCell = function onHeaderCell(col) {
            var colProps = {}; // Get original first

            if (column.onHeaderCell) {
              colProps = _extends({}, column.onHeaderCell(col));
            } // Add sorter logic


            var onHeaderCellClick = colProps.onClick;

            colProps.onClick = function () {
              _this7.toggleSortOrder(column);

              if (onHeaderCellClick) {
                onHeaderCellClick.apply(void 0, arguments);
              }
            };

            return colProps;
          };
        }

        return _extends(_extends({}, column), {
          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
          title: [React.createElement("span", {
            key: "title",
            className: "".concat(prefixCls, "-header-column")
          }, React.createElement("div", {
            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
          }, React.createElement("span", {
            className: "".concat(prefixCls, "-column-title")
          }, _this7.renderColumnTitle(column.title)), React.createElement("span", {
            className: "".concat(prefixCls, "-column-sorter")
          }, sortButton))), filterDropdown],
          onHeaderCell: onHeaderCell
        });
      });
    }
  }, {
    key: "renderColumnTitle",
    value: function renderColumnTitle(title) {
      var _this$state4 = this.state,
          filters = _this$state4.filters,
          sortOrder = _this$state4.sortOrder,
          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167

      if (title instanceof Function) {
        return title({
          filters: filters,
          sortOrder: sortOrder,
          sortColumn: sortColumn
        });
      }

      return title;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;
      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);

      var nextState = _extends(_extends({}, prevState), {
        prevProps: nextProps,
        columns: columns
      });

      if ('pagination' in nextProps || 'pagination' in prevProps) {
        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);

        newPagination.current = newPagination.current || 1;
        newPagination.pageSize = newPagination.pageSize || 10;
        nextState = _extends(_extends({}, nextState), {
          pagination: nextProps.pagination !== false ? newPagination : emptyObject
        });
      }

      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
        nextProps.store.setState({
          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
        });
      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
        nextProps.store.setState({
          selectedRowKeys: []
        });
      }

      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
        nextProps.store.setState({
          selectionDirty: false
        });
      } // https://github.com/ant-design/ant-design/issues/10133


      nextProps.setCheckboxPropsCache({}); // Update filters

      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);

      if (filteredValueColumns.length > 0) {
        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);

        var newFilters = _extends({}, nextState.filters);

        Object.keys(filtersFromColumns).forEach(function (key) {
          newFilters[key] = filtersFromColumns[key];
        });

        if (isFiltersChanged(nextState, newFilters)) {
          nextState = _extends(_extends({}, nextState), {
            filters: newFilters
          });
        }
      }

      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
        var components = createComponents(nextProps.components);
        nextState = _extends(_extends({}, nextState), {
          components: components
        });
      }

      return nextState;
    }
  }]);

  return Table;
}(React.Component);

Table.propTypes = {
  dataSource: PropTypes.array,
  columns: PropTypes.array,
  prefixCls: PropTypes.string,
  useFixedHeader: PropTypes.bool,
  rowSelection: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  bordered: PropTypes.bool,
  onChange: PropTypes.func,
  locale: PropTypes.object,
  dropdownPrefixCls: PropTypes.string,
  sortDirections: PropTypes.array,
  getPopupContainer: PropTypes.func
};
Table.defaultProps = {
  dataSource: [],
  useFixedHeader: false,
  className: '',
  size: 'default',
  loading: false,
  bordered: false,
  indentSize: 20,
  locale: {},
  rowKey: 'key',
  showHeader: true,
  sortDirections: ['ascend', 'descend'],
  childrenColumnName: 'children'
};
(0, _reactLifecyclesCompat.polyfill)(Table);

var StoreTable =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(StoreTable, _React$Component2);

  function StoreTable(props) {
    var _this8;

    _classCallCheck(this, StoreTable);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(StoreTable).call(this, props));

    _this8.setCheckboxPropsCache = function (cache) {
      return _this8.CheckboxPropsCache = cache;
    };

    _this8.CheckboxPropsCache = {};
    _this8.store = (0, _createStore["default"])({
      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
      selectionDirty: false
    });
    return _this8;
  }

  _createClass(StoreTable, [{
    key: "render",
    value: function render() {
      return React.createElement(Table, _extends({}, this.props, {
        store: this.store,
        checkboxPropsCache: this.CheckboxPropsCache,
        setCheckboxPropsCache: this.setCheckboxPropsCache
      }));
    }
  }]);

  return StoreTable;
}(React.Component);

StoreTable.displayName = 'withStore(Table)';
StoreTable.Column = _Column["default"];
StoreTable.ColumnGroup = _ColumnGroup["default"];
var _default = StoreTable;
exports["default"] = _default;
//# sourceMappingURL=Table.js.map


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Table_1 = __importDefault(__webpack_require__(1516));

var Column_1 = __importDefault(__webpack_require__(529));

exports.Column = Column_1.default;

var ColumnGroup_1 = __importDefault(__webpack_require__(530));

exports.ColumnGroup = ColumnGroup_1.default;

var utils_1 = __webpack_require__(139);

exports.INTERNAL_COL_DEFINE = utils_1.INTERNAL_COL_DEFINE;
exports.default = Table_1.default;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var shallowequal_1 = __importDefault(__webpack_require__(69));

var addEventListener_1 = __importDefault(__webpack_require__(213));

var warning_1 = __importDefault(__webpack_require__(189));

var mini_store_1 = __webpack_require__(87);

var merge_1 = __importDefault(__webpack_require__(1517));

var component_classes_1 = __importDefault(__webpack_require__(290));

var classnames_1 = __importDefault(__webpack_require__(5));

var react_lifecycles_compat_1 = __webpack_require__(38);

var utils_1 = __webpack_require__(139);

var ColumnManager_1 = __importDefault(__webpack_require__(1583));

var HeadTable_1 = __importDefault(__webpack_require__(1584));

var BodyTable_1 = __importDefault(__webpack_require__(1602));

var Column_1 = __importDefault(__webpack_require__(529));

var ColumnGroup_1 = __importDefault(__webpack_require__(530));

var ExpandableTable_1 = __importDefault(__webpack_require__(1603));

var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.state = {};

    _this.getRowKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      warning_1.default(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    };

    _this.handleWindowResize = function () {
      _this.syncFixedTableRowHeight();

      _this.setScrollPositionClassName();
    };

    _this.syncFixedTableRowHeight = function () {
      var tableRect = _this.tableNode.getBoundingClientRect(); // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
      // see: https://github.com/ant-design/ant-design/issues/4836


      if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }

      var prefixCls = _this.props.prefixCls;
      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
      var bodyRows = _this.bodyTable.querySelectorAll(".".concat(prefixCls, "-row")) || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });

      var state = _this.store.getState();

      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
        var rowKey = row.getAttribute('data-row-key');
        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        acc[rowKey] = height;
        return acc;
      }, {});

      if (shallowequal_1.default(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal_1.default(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }

      _this.store.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    };

    _this.handleBodyScrollLeft = function (e) {
      // Fix https://github.com/ant-design/ant-design/issues/7635
      if (e.currentTarget !== e.target) {
        return;
      }

      var target = e.target;
      var _this$props$scroll = _this.props.scroll,
          scroll = _this$props$scroll === void 0 ? {} : _this$props$scroll;

      var _assertThisInitialize = _assertThisInitialized(_this),
          headTable = _assertThisInitialize.headTable,
          bodyTable = _assertThisInitialize.bodyTable;

      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
        }

        _this.setScrollPositionClassName();
      } // Remember last scrollLeft for scroll direction detecting.


      _this.lastScrollLeft = target.scrollLeft;
    };

    _this.handleBodyScrollTop = function (e) {
      var target = e.target; // Fix https://github.com/ant-design/ant-design/issues/9033

      if (e.currentTarget !== target) {
        return;
      }

      var _this$props$scroll2 = _this.props.scroll,
          scroll = _this$props$scroll2 === void 0 ? {} : _this$props$scroll2;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          headTable = _assertThisInitialize2.headTable,
          bodyTable = _assertThisInitialize2.bodyTable,
          fixedColumnsBodyLeft = _assertThisInitialize2.fixedColumnsBodyLeft,
          fixedColumnsBodyRight = _assertThisInitialize2.fixedColumnsBodyRight;

      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }

        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      } // Remember last scrollTop for scroll direction detecting.


      _this.lastScrollTop = target.scrollTop;
    };

    _this.handleBodyScroll = function (e) {
      _this.handleBodyScrollLeft(e);

      _this.handleBodyScrollTop(e);
    };

    _this.handleWheel = function (event) {
      var _this$props$scroll3 = _this.props.scroll,
          scroll = _this$props$scroll3 === void 0 ? {} : _this$props$scroll3;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        event.preventDefault();
        var wd = event.deltaY;
        var target = event.target;

        var _assertThisInitialize3 = _assertThisInitialized(_this),
            bodyTable = _assertThisInitialize3.bodyTable,
            fixedColumnsBodyLeft = _assertThisInitialize3.fixedColumnsBodyLeft,
            fixedColumnsBodyRight = _assertThisInitialize3.fixedColumnsBodyRight;

        var scrollTop = 0;

        if (_this.lastScrollTop) {
          scrollTop = _this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }

        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
    };

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    _this.saveTableNodeRef = function (node) {
      _this.tableNode = node;
    };

    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      warning_1.default(props[name] === undefined, "".concat(name, " is deprecated, please use onRow instead."));
    });
    warning_1.default(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');
    _this.columnManager = new ColumnManager_1.default(props.columns, props.children);
    _this.store = mini_store_1.create({
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: {}
    });

    _this.setScrollPosition('left');

    _this.debouncedWindowResize = utils_1.debounce(_this.handleWindowResize, 150);
    return _this;
  }

  _createClass(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        table: {
          props: this.props,
          columnManager: this.columnManager,
          saveRef: this.saveRef,
          components: merge_1.default({
            table: 'table',
            header: {
              wrapper: 'thead',
              row: 'tr',
              cell: 'th'
            },
            body: {
              wrapper: 'tbody',
              row: 'tr',
              cell: 'td'
            }
          }, this.props.components)
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
      } // https://github.com/ant-design/ant-design/issues/11635


      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }

      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();

        if (!this.resizeEvent) {
          this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
        }
      } // when table changes to empty, reset scrollLeft


      if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
        this.resetScrollX();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }

      if (this.debouncedWindowResize) {
        this.debouncedWindowResize.cancel();
      }
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(position) {
      this.scrollPosition = position;

      if (this.tableNode) {
        var prefixCls = this.props.prefixCls;

        if (position === 'both') {
          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-left")).add("".concat(prefixCls, "-scroll-position-right"));
        } else {
          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-").concat(position));
        }
      }
    }
  }, {
    key: "setScrollPositionClassName",
    value: function setScrollPositionClassName() {
      var node = this.bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;

      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: "isTableLayoutFixed",
    value: function isTableLayoutFixed() {
      var _this$props = this.props,
          tableLayout = _this$props.tableLayout,
          _this$props$columns = _this$props.columns,
          columns = _this$props$columns === void 0 ? [] : _this$props$columns,
          useFixedHeader = _this$props.useFixedHeader,
          _this$props$scroll4 = _this$props.scroll,
          scroll = _this$props$scroll4 === void 0 ? {} : _this$props$scroll4;

      if (typeof tableLayout !== 'undefined') {
        return tableLayout === 'fixed';
      } // if one column is ellipsis, use fixed table layout to fix align issue


      if (columns.some(function (_ref) {
        var ellipsis = _ref.ellipsis;
        return !!ellipsis;
      })) {
        return true;
      } // if header fixed, use fixed table layout to fix align issue


      if (useFixedHeader || scroll.y) {
        return true;
      } // if scroll.x is number/px/% width value, we should fixed table layout
      // to avoid long word layout broken issue


      if (scroll.x && scroll.x !== true && scroll.x !== 'max-content') {
        return true;
      }

      return false;
    }
  }, {
    key: "resetScrollX",
    value: function resetScrollX() {
      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }

      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: "hasScrollX",
    value: function hasScrollX() {
      var _this$props$scroll5 = this.props.scroll,
          scroll = _this$props$scroll5 === void 0 ? {} : _this$props$scroll5;
      return 'x' in scroll;
    }
  }, {
    key: "renderMainTable",
    value: function renderMainTable() {
      var _this$props2 = this.props,
          scroll = _this$props2.scroll,
          prefixCls = _this$props2.prefixCls;
      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
      var table = [this.renderTable({
        columns: this.columnManager.groupedColumns(),
        isAnyColumnsFixed: isAnyColumnsFixed
      }), this.renderEmptyText(), this.renderFooter()];
      return scrollable ? React.createElement("div", {
        className: "".concat(prefixCls, "-scroll")
      }, table) : table;
    }
  }, {
    key: "renderLeftFixedTable",
    value: function renderLeftFixedTable() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-fixed-left")
      }, this.renderTable({
        columns: this.columnManager.leftColumns(),
        fixed: 'left'
      }));
    }
  }, {
    key: "renderRightFixedTable",
    value: function renderRightFixedTable() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-fixed-right")
      }, this.renderTable({
        columns: this.columnManager.rightColumns(),
        fixed: 'right'
      }));
    }
  }, {
    key: "renderTable",
    value: function renderTable(options) {
      var columns = options.columns,
          fixed = options.fixed,
          isAnyColumnsFixed = options.isAnyColumnsFixed;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          _this$props3$scroll = _this$props3.scroll,
          scroll = _this$props3$scroll === void 0 ? {} : _this$props3$scroll;
      var tableClassName = scroll.x || fixed ? "".concat(prefixCls, "-fixed") : '';
      var headTable = React.createElement(HeadTable_1.default, {
        key: "head",
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        handleBodyScrollLeft: this.handleBodyScrollLeft,
        expander: this.expander
      });
      var bodyTable = React.createElement(BodyTable_1.default, {
        key: "body",
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        getRowKey: this.getRowKey,
        handleWheel: this.handleWheel,
        handleBodyScroll: this.handleBodyScroll,
        expander: this.expander,
        isAnyColumnsFixed: isAnyColumnsFixed
      });
      return [headTable, bodyTable];
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          prefixCls = _this$props4.prefixCls;
      return title ? React.createElement("div", {
        className: "".concat(prefixCls, "-title"),
        key: "title"
      }, title(this.props.data)) : null;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props5 = this.props,
          footer = _this$props5.footer,
          prefixCls = _this$props5.prefixCls;
      return footer ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer"),
        key: "footer"
      }, footer(this.props.data)) : null;
    }
  }, {
    key: "renderEmptyText",
    value: function renderEmptyText() {
      var _this$props6 = this.props,
          emptyText = _this$props6.emptyText,
          prefixCls = _this$props6.prefixCls,
          data = _this$props6.data;

      if (data.length) {
        return null;
      }

      var emptyClassName = "".concat(prefixCls, "-placeholder");
      return React.createElement("div", {
        className: emptyClassName,
        key: "emptyText"
      }, typeof emptyText === 'function' ? emptyText() : emptyText);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames_1$default,
          _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;

      if (this.state.columns) {
        this.columnManager.reset(props.columns);
      } else if (this.state.children) {
        this.columnManager.reset(null, props.children);
      }

      var tableClassName = classnames_1.default(props.prefixCls, props.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-fixed-header"), props.useFixedHeader || props.scroll && props.scroll.y), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-left ").concat(prefixCls, "-scroll-position-right"), this.scrollPosition === 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-").concat(this.scrollPosition), this.scrollPosition !== 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-layout-fixed"), this.isTableLayoutFixed()), _classnames_1$default));
      var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
      var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
      var dataAndAriaProps = utils_1.getDataAndAriaProps(props);
      return React.createElement(mini_store_1.Provider, {
        store: this.store
      }, React.createElement(ExpandableTable_1.default, Object.assign({}, props, {
        columnManager: this.columnManager,
        getRowKey: this.getRowKey
      }), function (expander) {
        _this2.expander = expander;
        return React.createElement("div", Object.assign({
          ref: _this2.saveTableNodeRef,
          className: tableClassName,
          style: props.style,
          id: props.id
        }, dataAndAriaProps), _this2.renderTitle(), React.createElement("div", {
          className: "".concat(prefixCls, "-content")
        }, _this2.renderMainTable(), hasLeftFixed && _this2.renderLeftFixedTable(), hasRightFixed && _this2.renderRightFixedTable()));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.columns && nextProps.columns !== prevState.columns) {
        return {
          columns: nextProps.columns,
          children: null
        };
      }

      if (nextProps.children !== prevState.children) {
        return {
          columns: null,
          children: nextProps.children
        };
      }

      return null;
    }
  }]);

  return Table;
}(React.Component);

Table.childContextTypes = {
  table: PropTypes.any,
  components: PropTypes.any
};
Table.Column = Column_1.default;
Table.ColumnGroup = ColumnGroup_1.default;
Table.defaultProps = {
  data: [],
  useFixedHeader: false,
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  onRow: function onRow() {},
  onHeaderRow: function onHeaderRow() {},
  prefixCls: 'rc-table',
  bodyStyle: {},
  style: {},
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  emptyText: function emptyText() {
    return 'No Data';
  }
};
react_lifecycles_compat_1.polyfill(Table);
exports.default = Table;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1518),
    createAssigner = __webpack_require__(1574);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1519),
    assignMergeValue = __webpack_require__(515),
    baseFor = __webpack_require__(1549),
    baseMergeDeep = __webpack_require__(1551),
    isObject = __webpack_require__(114),
    keysIn = __webpack_require__(524),
    safeGet = __webpack_require__(523);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(214),
    stackClear = __webpack_require__(1525),
    stackDelete = __webpack_require__(1526),
    stackGet = __webpack_require__(1527),
    stackHas = __webpack_require__(1528),
    stackSet = __webpack_require__(1529);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(215);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(215);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(215);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(215);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(214);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1526 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(214),
    Map = __webpack_require__(512),
    MapCache = __webpack_require__(514);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(335),
    isMasked = __webpack_require__(1533),
    isObject = __webpack_require__(114),
    toSource = __webpack_require__(1535);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(336);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1534);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(137);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1538),
    ListCache = __webpack_require__(214),
    Map = __webpack_require__(512);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1539),
    hashDelete = __webpack_require__(1540),
    hashGet = __webpack_require__(1541),
    hashHas = __webpack_require__(1542),
    hashSet = __webpack_require__(1543);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1550);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(515),
    cloneBuffer = __webpack_require__(1552),
    cloneTypedArray = __webpack_require__(1553),
    copyArray = __webpack_require__(1556),
    initCloneObject = __webpack_require__(1557),
    isArguments = __webpack_require__(519),
    isArray = __webpack_require__(168),
    isArrayLikeObject = __webpack_require__(1561),
    isBuffer = __webpack_require__(521),
    isFunction = __webpack_require__(335),
    isObject = __webpack_require__(114),
    isPlainObject = __webpack_require__(1563),
    isTypedArray = __webpack_require__(522),
    safeGet = __webpack_require__(523),
    toPlainObject = __webpack_require__(1567);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(137);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1554);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1555);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(137);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1558),
    getPrototype = __webpack_require__(517),
    isPrototype = __webpack_require__(518);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1559 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(167),
    isObjectLike = __webpack_require__(138);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(338),
    isObjectLike = __webpack_require__(138);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1562 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(167),
    getPrototype = __webpack_require__(517),
    isObjectLike = __webpack_require__(138);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(167),
    isLength = __webpack_require__(520),
    isObjectLike = __webpack_require__(138);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1565 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(513);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(1568),
    keysIn = __webpack_require__(524);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1569),
    baseAssignValue = __webpack_require__(337);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(337),
    eq = __webpack_require__(216);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1571),
    isArguments = __webpack_require__(519),
    isArray = __webpack_require__(168),
    isBuffer = __webpack_require__(521),
    isIndex = __webpack_require__(525),
    isTypedArray = __webpack_require__(522);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114),
    isPrototype = __webpack_require__(518),
    nativeKeysIn = __webpack_require__(1573);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1573 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(1575),
    isIterateeCall = __webpack_require__(1582);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(526),
    overRest = __webpack_require__(1576),
    setToString = __webpack_require__(1578);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1577);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1579),
    shortOut = __webpack_require__(1581);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1580),
    defineProperty = __webpack_require__(516),
    identity = __webpack_require__(526);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(216),
    isArrayLike = __webpack_require__(338),
    isIndex = __webpack_require__(525),
    isObject = __webpack_require__(114);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-underscore-dangle */

var React = __importStar(__webpack_require__(0));

var ColumnManager =
/*#__PURE__*/
function () {
  function ColumnManager(columns, elements) {
    _classCallCheck(this, ColumnManager);

    this._cached = {};
    this.columns = columns || this.normalize(elements);
  }

  _createClass(ColumnManager, [{
    key: "isAnyColumnsFixed",
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: "isAnyColumnsLeftFixed",
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "isAnyColumnsRightFixed",
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "leftColumns",
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "rightColumns",
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "leafColumns",
    value: function leafColumns() {
      var _this6 = this;

      return this._cache('leafColumns', function () {
        return _this6._leafColumns(_this6.columns);
      });
    }
  }, {
    key: "leftLeafColumns",
    value: function leftLeafColumns() {
      var _this7 = this;

      return this._cache('leftLeafColumns', function () {
        return _this7._leafColumns(_this7.leftColumns());
      });
    }
  }, {
    key: "rightLeafColumns",
    value: function rightLeafColumns() {
      var _this8 = this;

      return this._cache('rightLeafColumns', function () {
        return _this8._leafColumns(_this8.rightColumns());
      });
    } // add appropriate rowspan and colspan to column

  }, {
    key: "groupedColumns",
    value: function groupedColumns() {
      var _this9 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

          /* eslint-disable no-param-reassign */
          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];

          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;

            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };

          columns.forEach(function (column, index) {
            var newColumn = _objectSpread({}, column);

            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;

            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan += newColumn.colSpan;
            } else {
              parentColumn.colSpan += 1;
            } // update rowspan to all same row columns


            for (var i = 0; i < rows[currentRow].length - 1; i += 1) {
              setRowSpan(rows[currentRow][i]);
            } // last column, update rowspan immediately


            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }

            grouped.push(newColumn);
          });
          return grouped;
          /* eslint-enable no-param-reassign */
        };

        return _groupColumns(_this9.columns);
      });
    }
  }, {
    key: "normalize",
    value: function normalize(elements) {
      var _this10 = this;

      var columns = [];
      React.Children.forEach(elements, function (element) {
        if (!React.isValidElement(element)) {
          return;
        }

        var column = _objectSpread({}, element.props);

        if (element.key) {
          column.key = element.key;
        }

        if (element.type.isTableColumnGroup) {
          column.children = _this10.normalize(column.children);
        }

        columns.push(column);
      });
      return columns;
    }
  }, {
    key: "reset",
    value: function reset(columns, elements) {
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: "_cache",
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }

      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: "_leafColumns",
    value: function _leafColumns(columns) {
      var _this11 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, _toConsumableArray(_this11._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

exports.default = ColumnManager;
/* eslint-enable */

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var classnames_1 = __importDefault(__webpack_require__(5));

var utils_1 = __webpack_require__(139);

var BaseTable_1 = __importDefault(__webpack_require__(527));

function HeadTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll,
      showHeader = _table$props.showHeader;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      handleBodyScrollLeft = props.handleBodyScrollLeft,
      expander = props.expander;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;
  var headStyle = {};
  var scrollbarWidth = utils_1.measureScrollbar({
    direction: 'vertical'
  });

  if (scroll.y) {
    useFixedHeader = true; // https://github.com/ant-design/ant-design/issues/17051

    var scrollbarWidthOfHeader = utils_1.measureScrollbar({
      direction: 'horizontal',
      prefixCls: prefixCls
    }); // Add negative margin bottom for scroll bar overflow bug

    if (scrollbarWidthOfHeader > 0 && !fixed) {
      headStyle.marginBottom = "-".concat(scrollbarWidthOfHeader, "px");
      headStyle.paddingBottom = '0px'; // https://github.com/ant-design/ant-design/pull/19986

      headStyle.minWidth = "".concat(scrollbarWidth, "px"); // https://github.com/ant-design/ant-design/issues/17051

      headStyle.overflowX = 'scroll';
      headStyle.overflowY = scrollbarWidth === 0 ? 'hidden' : 'scroll';
    }
  }

  if (!useFixedHeader || !showHeader) {
    return null;
  }

  return React.createElement("div", {
    key: "headTable",
    ref: fixed ? null : saveRef('headTable'),
    className: classnames_1.default("".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-hide-scrollbar"), scrollbarWidth > 0)),
    style: headStyle,
    onScroll: handleBodyScrollLeft
  }, React.createElement(BaseTable_1.default, {
    tableClassName: tableClassName,
    hasHead: true,
    hasBody: false,
    fixed: fixed,
    columns: columns,
    expander: expander
  }));
}

exports.default = HeadTable;
HeadTable.contextTypes = {
  table: PropTypes.any
};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var utils_1 = __webpack_require__(139);

var ColGroup = function ColGroup(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      expandIconAsCell = _table$props.expandIconAsCell;
  var fixed = props.fixed;
  var cols = [];

  if (expandIconAsCell && fixed !== 'right') {
    cols.push(React.createElement("col", {
      className: "".concat(prefixCls, "-expand-icon-col"),
      key: "rc-table-expand-icon-col"
    }));
  }

  var leafColumns;

  if (fixed === 'left') {
    leafColumns = table.columnManager.leftLeafColumns();
  } else if (fixed === 'right') {
    leafColumns = table.columnManager.rightLeafColumns();
  } else {
    leafColumns = table.columnManager.leafColumns();
  }

  cols = cols.concat(leafColumns.map(function (_ref2) {
    var key = _ref2.key,
        dataIndex = _ref2.dataIndex,
        width = _ref2.width,
        additionalProps = _ref2[utils_1.INTERNAL_COL_DEFINE];
    var mergedKey = key !== undefined ? key : dataIndex;
    return React.createElement("col", Object.assign({
      key: mergedKey,
      style: {
        width: width,
        minWidth: width
      }
    }, additionalProps));
  }));
  return React.createElement("colgroup", null, cols);
};

ColGroup.contextTypes = {
  table: PropTypes.any
};
exports.default = ColGroup;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var TableHeaderRow_1 = __importDefault(__webpack_require__(1587));

function getHeaderRows(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$currentRow = _ref.currentRow,
      currentRow = _ref$currentRow === void 0 ? 0 : _ref$currentRow,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      _ref$isLast = _ref.isLast,
      isLast = _ref$isLast === void 0 ? true : _ref$isLast;
  // eslint-disable-next-line no-param-reassign
  rows[currentRow] = rows[currentRow] || [];
  columns.forEach(function (column, i) {
    if (column.rowSpan && rows.length < column.rowSpan) {
      while (rows.length < column.rowSpan) {
        rows.push([]);
      }
    }

    var cellIsLast = isLast && i === columns.length - 1;
    var cell = {
      key: column.key,
      className: column.className || '',
      children: column.title,
      isLast: cellIsLast,
      column: column
    };

    if (column.children) {
      getHeaderRows({
        columns: column.children,
        currentRow: currentRow + 1,
        rows: rows,
        isLast: cellIsLast
      });
    }

    if ('colSpan' in column) {
      cell.colSpan = column.colSpan;
    }

    if ('rowSpan' in column) {
      cell.rowSpan = column.rowSpan;
    }

    if (cell.colSpan !== 0) {
      rows[currentRow].push(cell);
    }
  });
  return rows.filter(function (row) {
    return row.length > 0;
  });
}

var TableHeader = function TableHeader(props, _ref2) {
  var table = _ref2.table;
  var components = table.components;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      showHeader = _table$props.showHeader,
      onHeaderRow = _table$props.onHeaderRow;
  var expander = props.expander,
      columns = props.columns,
      fixed = props.fixed;

  if (!showHeader) {
    return null;
  }

  var rows = getHeaderRows({
    columns: columns
  });
  expander.renderExpandIndentCell(rows, fixed);
  var HeaderWrapper = components.header.wrapper;
  return React.createElement(HeaderWrapper, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function (row, index) {
    return React.createElement(TableHeaderRow_1.default, {
      prefixCls: prefixCls,
      key: index,
      index: index,
      fixed: fixed,
      columns: columns,
      rows: rows,
      row: row,
      components: components,
      onHeaderRow: onHeaderRow
    });
  }));
};

TableHeader.contextTypes = {
  table: PropTypes.any
};
exports.default = TableHeader;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(87);

var classnames_1 = __importDefault(__webpack_require__(5));

function TableHeaderRow(_ref) {
  var row = _ref.row,
      index = _ref.index,
      height = _ref.height,
      components = _ref.components,
      onHeaderRow = _ref.onHeaderRow,
      prefixCls = _ref.prefixCls;
  var HeaderRow = components.header.row;
  var HeaderCell = components.header.cell;
  var rowProps = onHeaderRow(row.map(function (cell) {
    return cell.column;
  }), index);
  var customStyle = rowProps ? rowProps.style : {};

  var style = _objectSpread({
    // https://github.com/ant-design/ant-design/issues/20126
    // https://github.com/ant-design/ant-design/issues/20269
    // https://github.com/ant-design/ant-design/issues/20495
    height: row.length > 1 && index === 0 && height && height !== 'auto' ? parseInt(height.toString(), 10) : height
  }, customStyle);

  return React.createElement(HeaderRow, Object.assign({}, rowProps, {
    style: style
  }), row.map(function (cell, i) {
    var _classnames_1$default;

    var column = cell.column,
        isLast = cell.isLast,
        cellProps = _objectWithoutProperties(cell, ["column", "isLast"]);

    var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};

    if (column.align) {
      customProps.style = _objectSpread({}, customProps.style, {
        textAlign: column.align
      });
    }

    customProps.className = classnames_1.default(customProps.className, column.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-align-").concat(column.align), !!column.align), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-break-word"), !!column.width), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-last"), isLast), _classnames_1$default));
    return React.createElement(HeaderCell, Object.assign({}, cellProps, customProps, {
      key: column.key || column.dataIndex || i
    }));
  }));
}

function getRowHeight(state, props) {
  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
  var columns = props.columns,
      rows = props.rows,
      fixed = props.fixed;
  var headerHeight = fixedColumnsHeadRowsHeight[0];

  if (!fixed) {
    return null;
  }

  if (headerHeight && columns) {
    if (headerHeight === 'auto') {
      return 'auto';
    }

    return headerHeight / rows.length;
  }

  return null;
}

exports.default = mini_store_1.connect(function (state, props) {
  return {
    height: getRowHeight(state, props)
  };
})(TableHeaderRow);

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var classnames_1 = __importDefault(__webpack_require__(5));

var get_1 = __importDefault(__webpack_require__(1589));

function isInvalidRenderCellText(text) {
  return text && !React.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
}

var TableCell =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableCell, _React$Component);

  function TableCell() {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableCell).apply(this, arguments));

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          record = _this$props.record,
          onCellClick = _this$props.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    };

    return _this;
  }

  _createClass(TableCell, [{
    key: "render",
    value: function render() {
      var _classnames_1$default;

      var _this$props2 = this.props,
          record = _this$props2.record,
          indentSize = _this$props2.indentSize,
          prefixCls = _this$props2.prefixCls,
          indent = _this$props2.indent,
          index = _this$props2.index,
          expandIcon = _this$props2.expandIcon,
          column = _this$props2.column,
          BodyCell = _this$props2.component;
      var dataIndex = column.dataIndex,
          render = column.render,
          _column$className = column.className,
          className = _column$className === void 0 ? '' : _column$className; // We should return undefined if no dataIndex is specified, but in order to
      // be compatible with object-path's behavior, we return the record object instead.

      var text;

      if (typeof dataIndex === 'number') {
        text = get_1.default(record, dataIndex);
      } else if (!dataIndex || dataIndex.length === 0) {
        text = record;
      } else {
        text = get_1.default(record, dataIndex);
      }

      var tdProps = {};
      var colSpan;
      var rowSpan;

      if (render) {
        text = render(text, record, index); // `render` support cell with additional config like `props`

        if (isInvalidRenderCellText(text)) {
          tdProps = text.props || tdProps;
          var _tdProps = tdProps;
          colSpan = _tdProps.colSpan;
          rowSpan = _tdProps.rowSpan;
          text = text.children;
        }
      }

      if (column.onCell) {
        tdProps = _objectSpread({}, tdProps, {}, column.onCell(record, index));
      } // Fix https://github.com/ant-design/ant-design/issues/1202


      if (isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? React.createElement("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-indent indent-level-").concat(indent)
      }) : null;

      if (rowSpan === 0 || colSpan === 0) {
        return null;
      }

      if (column.align) {
        tdProps.style = _objectSpread({
          textAlign: column.align
        }, tdProps.style);
      }

      var cellClassName = classnames_1.default(className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-break-word"), !!column.width), _classnames_1$default));

      if (column.ellipsis) {
        if (typeof text === 'string') {
          tdProps.title = text;
        } else if (text) {
          var _text = text,
              textProps = _text.props;

          if (textProps && textProps.children && typeof textProps.children === 'string') {
            tdProps.title = textProps.children;
          }
        }
      }

      return React.createElement(BodyCell, Object.assign({
        className: cellClassName,
        onClick: this.handleClick
      }, tdProps), indentText, expandIcon, text);
    }
  }]);

  return TableCell;
}(React.Component);

exports.default = TableCell;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1590);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1591),
    toKey = __webpack_require__(1599);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(168),
    isKey = __webpack_require__(1592),
    stringToPath = __webpack_require__(1593),
    toString = __webpack_require__(1596);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(168),
    isSymbol = __webpack_require__(339);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1594);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1595);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(514);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1597);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(336),
    arrayMap = __webpack_require__(1598),
    isArray = __webpack_require__(168),
    isSymbol = __webpack_require__(339);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(339);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(87);

var ExpandIcon_1 = __importDefault(__webpack_require__(1601));

var ExpandableRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExpandableRow, _React$Component);

  function ExpandableRow() {
    var _this;

    _classCallCheck(this, ExpandableRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpandableRow).apply(this, arguments)); // Show icon within first column

    _this.hasExpandIcon = function (columnIndex) {
      var _this$props = _this.props,
          expandRowByClick = _this$props.expandRowByClick,
          expandIcon = _this$props.expandIcon;

      if (_this.expandIconAsCell || columnIndex !== _this.expandIconColumnIndex) {
        return false;
      }

      return !!expandIcon || !expandRowByClick;
    };

    _this.handleExpandChange = function (record, event) {
      var _this$props2 = _this.props,
          onExpandedChange = _this$props2.onExpandedChange,
          expanded = _this$props2.expanded,
          rowKey = _this$props2.rowKey;

      if (_this.expandable) {
        onExpandedChange(!expanded, record, event, rowKey);
      }
    };

    _this.handleRowClick = function (record, index, event) {
      var _this$props3 = _this.props,
          expandRowByClick = _this$props3.expandRowByClick,
          onRowClick = _this$props3.onRowClick;

      if (expandRowByClick) {
        _this.handleExpandChange(record, event);
      }

      if (onRowClick) {
        onRowClick(record, index, event);
      }
    };

    _this.renderExpandIcon = function () {
      var _this$props4 = _this.props,
          prefixCls = _this$props4.prefixCls,
          expanded = _this$props4.expanded,
          record = _this$props4.record,
          needIndentSpaced = _this$props4.needIndentSpaced,
          expandIcon = _this$props4.expandIcon;

      if (expandIcon) {
        return expandIcon({
          prefixCls: prefixCls,
          expanded: expanded,
          record: record,
          needIndentSpaced: needIndentSpaced,
          expandable: _this.expandable,
          onExpand: _this.handleExpandChange
        });
      }

      return React.createElement(ExpandIcon_1.default, {
        expandable: _this.expandable,
        prefixCls: prefixCls,
        onExpand: _this.handleExpandChange,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record
      });
    };

    _this.renderExpandIconCell = function (cells) {
      if (!_this.expandIconAsCell) {
        return;
      }

      var prefixCls = _this.props.prefixCls;
      cells.push(React.createElement("td", {
        className: "".concat(prefixCls, "-expand-icon-cell"),
        key: "rc-table-expand-icon-cell"
      }, _this.renderExpandIcon()));
    };

    return _this;
  }

  _createClass(ExpandableRow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleDestroy();
    }
  }, {
    key: "handleDestroy",
    value: function handleDestroy() {
      var _this$props5 = this.props,
          onExpandedChange = _this$props5.onExpandedChange,
          rowKey = _this$props5.rowKey,
          record = _this$props5.record;

      if (this.expandable) {
        onExpandedChange(false, record, null, rowKey, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          childrenColumnName = _this$props6.childrenColumnName,
          expandedRowRender = _this$props6.expandedRowRender,
          indentSize = _this$props6.indentSize,
          record = _this$props6.record,
          fixed = _this$props6.fixed,
          expanded = _this$props6.expanded;
      this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
      this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
      var childrenData = record[childrenColumnName];
      this.expandable = !!(childrenData || expandedRowRender);
      var expandableRowProps = {
        indentSize: indentSize,
        // not used in TableRow, but it's required to re-render TableRow when `expanded` changes
        expanded: expanded,
        onRowClick: this.handleRowClick,
        hasExpandIcon: this.hasExpandIcon,
        renderExpandIcon: this.renderExpandIcon,
        renderExpandIconCell: this.renderExpandIconCell
      };
      return this.props.children(expandableRowProps);
    }
  }]);

  return ExpandableRow;
}(React.Component);

exports.default = mini_store_1.connect(function (_ref, _ref2) {
  var _ref$expandedRowKeys = _ref.expandedRowKeys,
      expandedRowKeys = _ref$expandedRowKeys === void 0 ? [] : _ref$expandedRowKeys;
  var rowKey = _ref2.rowKey;
  return {
    expanded: expandedRowKeys.includes(rowKey)
  };
})(ExpandableRow);

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var shallowequal_1 = __importDefault(__webpack_require__(69));

var ExpandIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExpandIcon, _React$Component);

  function ExpandIcon() {
    _classCallCheck(this, ExpandIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExpandIcon).apply(this, arguments));
  }

  _createClass(ExpandIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowequal_1.default(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          expandable = _this$props.expandable,
          prefixCls = _this$props.prefixCls,
          onExpand = _this$props.onExpand,
          needIndentSpaced = _this$props.needIndentSpaced,
          expanded = _this$props.expanded,
          record = _this$props.record;

      if (expandable) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        return React.createElement("span", {
          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-").concat(expandClassName),
          onClick: function onClick(e) {
            return onExpand(record, e);
          }
        });
      }

      if (needIndentSpaced) {
        return React.createElement("span", {
          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-spaced")
        });
      }

      return null;
    }
  }]);

  return ExpandIcon;
}(React.Component);

exports.default = ExpandIcon;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(12));

var utils_1 = __webpack_require__(139);

var BaseTable_1 = __importDefault(__webpack_require__(527));

function BodyTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      getRowKey = props.getRowKey,
      handleBodyScroll = props.handleBodyScroll,
      handleWheel = props.handleWheel,
      expander = props.expander,
      isAnyColumnsFixed = props.isAnyColumnsFixed;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var bodyStyle = _objectSpread({}, table.props.bodyStyle);

  var innerBodyStyle = {};

  if (scroll.x || fixed) {
    bodyStyle.overflowX = bodyStyle.overflowX || 'scroll'; // Fix weird webkit render bug
    // https://github.com/ant-design/ant-design/issues/7783

    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
  }

  if (scroll.y) {
    // maxHeight will make fixed-Table scrolling not working
    // so we only set maxHeight to body-Table here
    if (fixed) {
      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    } else {
      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
    }

    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug

    var scrollbarWidth = utils_1.measureScrollbar({
      direction: 'vertical'
    });

    if (scrollbarWidth > 0 && fixed) {
      bodyStyle.marginBottom = "-".concat(scrollbarWidth, "px");
      bodyStyle.paddingBottom = '0px';
    }
  }

  var baseTable = React.createElement(BaseTable_1.default, {
    tableClassName: tableClassName,
    hasHead: !useFixedHeader,
    hasBody: true,
    fixed: fixed,
    columns: columns,
    expander: expander,
    getRowKey: getRowKey,
    isAnyColumnsFixed: isAnyColumnsFixed
  });

  if (fixed && columns.length) {
    var refName;

    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
      refName = 'fixedColumnsBodyLeft';
    } else if (columns[0].fixed === 'right') {
      refName = 'fixedColumnsBodyRight';
    }

    delete bodyStyle.overflowX;
    delete bodyStyle.overflowY;
    return React.createElement("div", {
      key: "bodyTable",
      className: "".concat(prefixCls, "-body-outer"),
      style: _objectSpread({}, bodyStyle)
    }, React.createElement("div", {
      className: "".concat(prefixCls, "-body-inner"),
      style: innerBodyStyle,
      ref: saveRef(refName),
      onWheel: handleWheel,
      onScroll: handleBodyScroll
    }, baseTable));
  } // Should provides `tabIndex` if use scroll to enable keyboard scroll


  var useTabIndex = scroll && (scroll.x || scroll.y);
  return React.createElement("div", {
    tabIndex: useTabIndex ? -1 : undefined,
    key: "bodyTable",
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle,
    ref: saveRef('bodyTable'),
    onWheel: handleWheel,
    onScroll: handleBodyScroll
  }, baseTable);
}

exports.default = BodyTable;
BodyTable.contextTypes = {
  table: PropTypes.any
};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(87);

var react_lifecycles_compat_1 = __webpack_require__(38);

var shallowequal_1 = __importDefault(__webpack_require__(69));

var TableRow_1 = __importDefault(__webpack_require__(528));

var utils_1 = __webpack_require__(139);

var ExpandableTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExpandableTable, _React$Component);

  function ExpandableTable(props) {
    var _this;

    _classCallCheck(this, ExpandableTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpandableTable).call(this, props));

    _this.handleExpandChange = function (expanded, record, event, rowKey) {
      var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (event) {
        event.stopPropagation();
      }

      var _this$props = _this.props,
          onExpandedRowsChange = _this$props.onExpandedRowsChange,
          onExpand = _this$props.onExpand;

      var _this$store$getState = _this.store.getState(),
          expandedRowKeys = _this$store$getState.expandedRowKeys;

      if (expanded) {
        // row was expanded
        expandedRowKeys = [].concat(_toConsumableArray(expandedRowKeys), [rowKey]);
      } else {
        // row was collapse
        var expandedRowIndex = expandedRowKeys.indexOf(rowKey);

        if (expandedRowIndex !== -1) {
          expandedRowKeys = utils_1.remove(expandedRowKeys, rowKey);
        }
      }

      if (!_this.props.expandedRowKeys) {
        _this.store.setState({
          expandedRowKeys: expandedRowKeys
        });
      } // De-dup of repeat call


      if (!_this.latestExpandedRows || !shallowequal_1.default(_this.latestExpandedRows, expandedRowKeys)) {
        _this.latestExpandedRows = expandedRowKeys;
        onExpandedRowsChange(expandedRowKeys);
      }

      if (!destroy) {
        onExpand(expanded, record);
      }
    };

    _this.renderExpandIndentCell = function (rows, fixed) {
      var _this$props2 = _this.props,
          prefixCls = _this$props2.prefixCls,
          expandIconAsCell = _this$props2.expandIconAsCell;

      if (!expandIconAsCell || fixed === 'right' || !rows.length) {
        return;
      }

      var iconColumn = {
        key: 'rc-table-expand-icon-cell',
        className: "".concat(prefixCls, "-expand-icon-th"),
        title: '',
        rowSpan: rows.length
      };
      rows[0].unshift(_objectSpread({}, iconColumn, {
        column: iconColumn
      }));
    };

    _this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
      var _this$props3 = _this.props,
          expandedRowClassName = _this$props3.expandedRowClassName,
          expandedRowRender = _this$props3.expandedRowRender,
          childrenColumnName = _this$props3.childrenColumnName;
      var childrenData = record[childrenColumnName];
      var nextAncestorKeys = [].concat(_toConsumableArray(ancestorKeys), [parentKey]);
      var nextIndent = indent + 1;

      if (expandedRowRender) {
        rows.push(_this.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
      }

      if (childrenData) {
        rows.push.apply(rows, _toConsumableArray(renderRows(childrenData, nextIndent, nextAncestorKeys)));
      }
    };

    var data = props.data,
        childrenColumnName = props.childrenColumnName,
        defaultExpandAllRows = props.defaultExpandAllRows,
        expandedRowKeys = props.expandedRowKeys,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
        getRowKey = props.getRowKey;
    var finalExpandedRowKeys = [];

    var rows = _toConsumableArray(data);

    if (defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i += 1) {
        var row = rows[i];
        finalExpandedRowKeys.push(getRowKey(row, i));
        rows = rows.concat(row[childrenColumnName] || []);
      }
    } else {
      finalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
    }

    _this.columnManager = props.columnManager;
    _this.store = props.store;

    _this.store.setState({
      expandedRowsHeight: {},
      expandedRowKeys: finalExpandedRowKeys
    });

    return _this;
  }

  _createClass(ExpandableTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if ('expandedRowKeys' in this.props) {
        this.store.setState({
          expandedRowKeys: this.props.expandedRowKeys
        });
      }

      this.handleUpdated();
    }
  }, {
    key: "handleUpdated",
    value: function handleUpdated() {
      /**
       * We should record latest expanded rows to avoid
       * multiple rows remove cause `onExpandedRowsChange` trigger many times
       */
      this.latestExpandedRows = null;
    }
  }, {
    key: "renderExpandedRow",
    value: function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
      var _this2 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          expandIconAsCell = _this$props4.expandIconAsCell,
          indentSize = _this$props4.indentSize;
      var parentKey = ancestorKeys[ancestorKeys.length - 1];
      var rowKey = "".concat(parentKey, "-extra-row");
      var components = {
        body: {
          row: 'tr',
          cell: 'td'
        }
      };
      var colCount;

      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.leafColumns().length;
      }

      var columns = [{
        key: 'extra-row',
        render: function render() {
          var _this2$store$getState = _this2.store.getState(),
              _this2$store$getState2 = _this2$store$getState.expandedRowKeys,
              expandedRowKeys = _this2$store$getState2 === void 0 ? [] : _this2$store$getState2;

          var expanded = expandedRowKeys.includes(parentKey);
          return {
            props: {
              colSpan: colCount
            },
            children: fixed !== 'right' ? _render(record, index, indent, expanded) : '&nbsp;'
          };
        }
      }];

      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }

      return React.createElement(TableRow_1.default, {
        key: rowKey,
        columns: columns,
        className: className,
        rowKey: rowKey,
        ancestorKeys: ancestorKeys,
        prefixCls: "".concat(prefixCls, "-expanded-row"),
        indentSize: indentSize,
        indent: indent,
        fixed: fixed,
        components: components,
        expandedRow: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          childrenColumnName = _this$props5.childrenColumnName,
          children = _this$props5.children;
      var needIndentSpaced = data.some(function (record) {
        return record[childrenColumnName];
      });
      return children({
        props: this.props,
        needIndentSpaced: needIndentSpaced,
        renderRows: this.renderRows,
        handleExpandChange: this.handleExpandChange,
        renderExpandIndentCell: this.renderExpandIndentCell
      });
    }
  }]);

  return ExpandableTable;
}(React.Component);

ExpandableTable.defaultProps = {
  expandIconAsCell: false,
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  expandIconColumnIndex: 0,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  childrenColumnName: 'children',
  indentSize: 15,
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {}
};
react_lifecycles_compat_1.polyfill(ExpandableTable);
exports.default = mini_store_1.connect()(ExpandableTable);

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var _reactLifecyclesCompat = __webpack_require__(38);

var _rcMenu = _interopRequireWildcard(__webpack_require__(135));

var _domClosest = _interopRequireDefault(__webpack_require__(1605));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _shallowequal = _interopRequireDefault(__webpack_require__(69));

var _dropdown = _interopRequireDefault(__webpack_require__(219));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _checkbox = _interopRequireDefault(__webpack_require__(46));

var _radio = _interopRequireDefault(__webpack_require__(32));

var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1611));

var _util = __webpack_require__(531);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function stopPropagation(e) {
  e.stopPropagation();

  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

var FilterMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilterMenu, _React$Component);

  function FilterMenu(props) {
    var _this;

    _classCallCheck(this, FilterMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterMenu).call(this, props));

    _this.setNeverShown = function (column) {
      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");

      if (filterBelongToScrollBody) {
        // When fixed column have filters, there will be two dropdown menus
        // Filter dropdown menu inside scroll body should never be shown
        // To fix https://github.com/ant-design/ant-design/issues/5010 and
        // https://github.com/ant-design/ant-design/issues/7909
        _this.neverShown = !!column.fixed;
      }
    };

    _this.setSelectedKeys = function (_ref) {
      var selectedKeys = _ref.selectedKeys;

      _this.setState({
        selectedKeys: selectedKeys
      });
    };

    _this.handleClearFilters = function () {
      _this.setState({
        selectedKeys: []
      }, _this.handleConfirm);
    };

    _this.handleConfirm = function () {
      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
      // https://github.com/ant-design/ant-design/issues/12284


      _this.setState({}, _this.confirmFilter);
    };

    _this.onVisibleChange = function (visible) {
      _this.setVisible(visible);

      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833

      if (!visible && !(column.filterDropdown instanceof Function)) {
        _this.confirmFilter();
      }
    };

    _this.handleMenuItemClick = function (info) {
      var selectedKeys = _this.state.selectedKeys;

      if (!info.keyPath || info.keyPath.length <= 1) {
        return;
      }

      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;

      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
        // deselect SubMenu child
        delete keyPathOfSelectedItem[info.key];
      } else {
        // select SubMenu child
        keyPathOfSelectedItem[info.key] = info.keyPath;
      }

      _this.setState({
        keyPathOfSelectedItem: keyPathOfSelectedItem
      });
    };

    _this.renderFilterIcon = function () {
      var _classNames;

      var _this$props = _this.props,
          column = _this$props.column,
          locale = _this$props.locale,
          prefixCls = _this$props.prefixCls,
          selectedKeys = _this$props.selectedKeys;
      var filtered = selectedKeys && selectedKeys.length > 0;
      var filterIcon = column.filterIcon;

      if (typeof filterIcon === 'function') {
        filterIcon = filterIcon(filtered);
      }

      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));

      if (!filterIcon) {
        return React.createElement(_icon["default"], {
          title: locale.filterTitle,
          type: "filter",
          theme: "filled",
          className: dropdownIconClass,
          onClick: stopPropagation
        });
      }

      if (React.isValidElement(filterIcon)) {
        return React.cloneElement(filterIcon, {
          title: filterIcon.props.title || locale.filterTitle,
          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
          onClick: stopPropagation
        });
      }

      return React.createElement("span", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
      }, filterIcon);
    };

    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
    _this.state = {
      selectedKeys: props.selectedKeys,
      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
      keyPathOfSelectedItem: {},
      visible: visible,
      prevProps: props
    };
    return _this;
  }

  _createClass(FilterMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "getDropdownVisible",
    value: function getDropdownVisible() {
      return this.neverShown ? false : this.state.visible;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      var column = this.props.column;

      if (!('filterDropdownVisible' in column)) {
        this.setState({
          visible: visible
        });
      }

      if (column.onFilterDropdownVisibleChange) {
        column.onFilterDropdownVisibleChange(visible);
      }
    }
  }, {
    key: "hasSubMenu",
    value: function hasSubMenu() {
      var _this$props$column$fi = this.props.column.filters,
          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
      return filters.some(function (item) {
        return !!(item.children && item.children.length > 0);
      });
    }
  }, {
    key: "confirmFilter",
    value: function confirmFilter() {
      var _this$props2 = this.props,
          column = _this$props2.column,
          propSelectedKeys = _this$props2.selectedKeys,
          confirmFilter = _this$props2.confirmFilter;
      var _this$state = this.state,
          selectedKeys = _this$state.selectedKeys,
          valueKeys = _this$state.valueKeys;
      var filterDropdown = column.filterDropdown;

      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
          return valueKeys[key];
        }).filter(function (key) {
          return key !== undefined;
        }));
      }
    }
  }, {
    key: "renderMenus",
    value: function renderMenus(items) {
      var _this2 = this;

      var _this$props3 = this.props,
          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
          prefixCls = _this$props3.prefixCls;
      return items.map(function (item) {
        if (item.children && item.children.length > 0) {
          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
          });
          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
          return React.createElement(_rcMenu.SubMenu, {
            title: item.text,
            popupClassName: subMenuCls,
            key: item.value.toString()
          }, _this2.renderMenus(item.children));
        }

        return _this2.renderMenuItem(item);
      });
    }
  }, {
    key: "renderMenuItem",
    value: function renderMenuItem(item) {
      var column = this.props.column;
      var selectedKeys = this.state.selectedKeys;
      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string

      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
        return key.toString();
      });
      var input = multiple ? React.createElement(_checkbox["default"], {
        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
      }) : React.createElement(_radio["default"], {
        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
      });
      return React.createElement(_rcMenu.Item, {
        key: item.value
      }, input, React.createElement("span", null, item.text));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var originSelectedKeys = this.state.selectedKeys;
      var _this$props4 = this.props,
          column = _this$props4.column,
          locale = _this$props4.locale,
          prefixCls = _this$props4.prefixCls,
          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown

      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
      var filterDropdown = column.filterDropdown;

      if (filterDropdown instanceof Function) {
        filterDropdown = filterDropdown({
          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
          setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return _this3.setSelectedKeys({
              selectedKeys: selectedKeys
            });
          },
          selectedKeys: originSelectedKeys,
          confirm: this.handleConfirm,
          clearFilters: this.handleClearFilters,
          filters: column.filters,
          visible: this.getDropdownVisible()
        });
      }

      var menus = filterDropdown ? React.createElement(_FilterDropdownMenuWrapper["default"], {
        className: "".concat(prefixCls, "-dropdown")
      }, filterDropdown) : React.createElement(_FilterDropdownMenuWrapper["default"], {
        className: "".concat(prefixCls, "-dropdown")
      }, React.createElement(_rcMenu["default"], {
        multiple: multiple,
        onClick: this.handleMenuItemClick,
        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
        className: dropdownMenuClass,
        onSelect: this.setSelectedKeys,
        onDeselect: this.setSelectedKeys,
        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
          return val.toString();
        }),
        getPopupContainer: getPopupContainer
      }, this.renderMenus(column.filters)), React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown-btns")
      }, React.createElement("a", {
        className: "".concat(prefixCls, "-dropdown-link confirm"),
        onClick: this.handleConfirm
      }, locale.filterConfirm), React.createElement("a", {
        className: "".concat(prefixCls, "-dropdown-link clear"),
        onClick: this.handleClearFilters
      }, locale.filterReset)));
      return React.createElement(_dropdown["default"], {
        trigger: ['click'],
        placement: "bottomRight",
        overlay: menus,
        visible: this.getDropdownVisible(),
        onVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer,
        forceRender: true
      }, this.renderFilterIcon());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var column = nextProps.column;
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: nextProps
      };
      /**
       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
       * that the user selection is lost
       * this happens frequently when a table is connected on some sort of realtime data
       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
       * https://github.com/ant-design/ant-design/issues/10209
       */

      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
        newState.selectedKeys = nextProps.selectedKeys;
      }

      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
      }

      if ('filterDropdownVisible' in column) {
        newState.visible = column.filterDropdownVisible;
      }

      return newState;
    }
  }]);

  return FilterMenu;
}(React.Component);

FilterMenu.defaultProps = {
  column: {}
};
(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
var _default = FilterMenu;
exports["default"] = _default;
//# sourceMappingURL=filterDropdown.js.map


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var matches = __webpack_require__(1606);

/**
 * @param element {Element}
 * @param selector {String}
 * @param context {Element}
 * @return {Element}
 */
module.exports = function (element, selector, context) {
  context = context || document;
  // guard against orphans
  element = { parentNode: element };

  while ((element = element.parentNode) && element !== context) {
    if (matches(element, selector)) {
      return element;
    }
  }
};


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determine if a DOM element matches a CSS selector
 *
 * @param {Element} elem
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function matches(elem, selector) {
  // Vendor-specific implementations of `Element.prototype.matches()`.
  var proto = window.Element.prototype;
  var nativeMatches = proto.matches ||
      proto.mozMatchesSelector ||
      proto.msMatchesSelector ||
      proto.oMatchesSelector ||
      proto.webkitMatchesSelector;

  if (!elem || elem.nodeType !== 1) {
    return false;
  }

  var parentElem = elem.parentNode;

  // use native 'matches'
  if (nativeMatches) {
    return nativeMatches.call(elem, selector);
  }

  // native support for `matches` is missing and a fallback is required
  var nodes = parentElem.querySelectorAll(selector);
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i] === elem) {
      return true;
    }
  }

  return false;
}

/**
 * Expose `matches`
 */

module.exports = matches;


/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1608);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placements__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    if ('visible' in props) {
      _this.state = {
        visible: props.visible
      };
    } else {
      _this.state = {
        visible: props.defaultVisible
      };
    }
    return _this;
  }

  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }
    return null;
  };

  Dropdown.prototype.getOverlayElement = function getOverlayElement() {
    var overlay = this.props.overlay;

    var overlayElement = void 0;
    if (typeof overlay === 'function') {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  };

  Dropdown.prototype.getMenuElementOrLambda = function getMenuElementOrLambda() {
    var overlay = this.props.overlay;

    if (typeof overlay === 'function') {
      return this.getMenuElement;
    }
    return this.getMenuElement();
  };

  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Dropdown.prototype.getOpenClassName = function getOpenClassName() {
    var _props = this.props,
        openClassName = _props.openClassName,
        prefixCls = _props.prefixCls;

    if (openClassName !== undefined) {
      return openClassName;
    }
    return prefixCls + '-open';
  };

  Dropdown.prototype.renderChildren = function renderChildren() {
    var children = this.props.children;
    var visible = this.state.visible;

    var childrenProps = children.props ? children.props : {};
    var childClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(childrenProps.className, this.getOpenClassName());
    return visible && children ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(children, { className: childClassName }) : children;
  };

  Dropdown.prototype.render = function render() {
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        transitionName = _props2.transitionName,
        animation = _props2.animation,
        align = _props2.align,
        placement = _props2.placement,
        getPopupContainer = _props2.getPopupContainer,
        showAction = _props2.showAction,
        hideAction = _props2.hideAction,
        overlayClassName = _props2.overlayClassName,
        overlayStyle = _props2.overlayStyle,
        trigger = _props2.trigger,
        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);

    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
      triggerHideAction = ['click'];
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"],
      _extends({}, otherProps, {
        prefixCls: prefixCls,
        ref: this.saveTrigger,
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_5__placements__["a" /* default */],
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: this.state.visible,
        afterPopupVisibleChange: this.afterVisibleChange,
        popup: this.getMenuElementOrLambda(),
        onPopupVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer
      }),
      this.renderChildren()
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.propTypes = {
  minOverlayWidthMatchTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  alignPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Dropdown.defaultProps = {
  prefixCls: 'rc-dropdown',
  trigger: ['hover'],
  showAction: [],
  overlayClassName: '',
  overlayStyle: {},
  defaultVisible: false,
  onVisibleChange: function onVisibleChange() {},

  placement: 'bottomLeft'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (e) {
    var props = _this2.props;
    var overlayProps = _this2.getOverlayElement().props;
    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
    if (!('visible' in props)) {
      _this2.setState({
        visible: false
      });
    }
    if (props.onOverlayClick) {
      props.onOverlayClick(e);
    }
    if (overlayProps.onClick) {
      overlayProps.onClick(e);
    }
  };

  this.onVisibleChange = function (visible) {
    var props = _this2.props;
    if (!('visible' in props)) {
      _this2.setState({
        visible: visible
      });
    }
    props.onVisibleChange(visible);
  };

  this.getMinOverlayWidthMatchTrigger = function () {
    var _props3 = _this2.props,
        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
        alignPoint = _props3.alignPoint;

    if ('minOverlayWidthMatchTrigger' in _this2.props) {
      return minOverlayWidthMatchTrigger;
    }

    return !alignPoint;
  };

  this.getMenuElement = function () {
    var prefixCls = _this2.props.prefixCls;

    var overlayElement = _this2.getOverlayElement();
    var extraOverlayProps = {
      prefixCls: prefixCls + '-menu',
      onClick: _this2.onClick
    };
    if (typeof overlayElement.type === 'string') {
      delete extraOverlayProps.prefixCls;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(overlayElement, extraOverlayProps);
  };

  this.afterVisibleChange = function (visible) {
    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
      var overlayNode = _this2.getPopupDomNode();
      var rootNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this2);
      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
          _this2.trigger._component.alignInstance.forceAlign();
        }
      }
    }
  };

  this.saveTrigger = function (node) {
    _this2.trigger = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(Dropdown);

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _button = _interopRequireDefault(__webpack_require__(10));

var _configProvider = __webpack_require__(30);

var _dropdown = _interopRequireDefault(__webpack_require__(340));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = _button["default"].Group;

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownButton, _React$Component);

  function DropdownButton() {
    var _this;

    _classCallCheck(this, DropdownButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownButton).apply(this, arguments));

    _this.renderButton = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          disabled = _a.disabled,
          onClick = _a.onClick,
          htmlType = _a.htmlType,
          children = _a.children,
          className = _a.className,
          overlay = _a.overlay,
          trigger = _a.trigger,
          align = _a.align,
          visible = _a.visible,
          onVisibleChange = _a.onVisibleChange,
          placement = _a.placement,
          getPopupContainer = _a.getPopupContainer,
          href = _a.href,
          _a$icon = _a.icon,
          icon = _a$icon === void 0 ? React.createElement(_icon["default"], {
        type: "ellipsis"
      }) : _a$icon,
          title = _a.title,
          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);

      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
      var dropdownProps = {
        align: align,
        overlay: overlay,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange: onVisibleChange,
        placement: placement,
        getPopupContainer: getPopupContainer || getContextPopupContainer
      };

      if ('visible' in _this.props) {
        dropdownProps.visible = visible;
      }

      return React.createElement(ButtonGroup, _extends({}, restProps, {
        className: (0, _classnames["default"])(prefixCls, className)
      }), React.createElement(_button["default"], {
        type: type,
        disabled: disabled,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
      }, children), React.createElement(_dropdown["default"], dropdownProps, React.createElement(_button["default"], {
        type: type
      }, icon)));
    };

    return _this;
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return DropdownButton;
}(React.Component);

exports["default"] = DropdownButton;
DropdownButton.defaultProps = {
  placement: 'bottomRight',
  type: 'default'
};
//# sourceMappingURL=dropdown-button.js.map


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
};

var _default = FilterDropdownMenuWrapper;
exports["default"] = _default;
//# sourceMappingURL=FilterDropdownMenuWrapper.js.map


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createStore;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createStore(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends(_extends({}, state), partial);

    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);
    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}
//# sourceMappingURL=createStore.js.map


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _checkbox = _interopRequireDefault(__webpack_require__(46));

var _radio = _interopRequireDefault(__webpack_require__(32));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SelectionBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectionBox, _React$Component);

  function SelectionBox(props) {
    var _this;

    _classCallCheck(this, SelectionBox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectionBox).call(this, props));
    _this.state = {
      checked: _this.getCheckState(props)
    };
    return _this;
  }

  _createClass(SelectionBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getCheckState",
    value: function getCheckState(props) {
      var store = props.store,
          defaultSelection = props.defaultSelection,
          rowIndex = props.rowIndex;
      var checked = false;

      if (store.getState().selectionDirty) {
        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
      } else {
        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
      }

      return checked;
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var store = this.props.store;
      this.unsubscribe = store.subscribe(function () {
        var checked = _this2.getCheckState(_this2.props);

        _this2.setState({
          checked: checked
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          type = _a.type,
          rowIndex = _a.rowIndex,
          rest = __rest(_a, ["type", "rowIndex"]);

      var checked = this.state.checked;

      if (type === 'radio') {
        return React.createElement(_radio["default"], _extends({
          checked: checked,
          value: rowIndex
        }, rest));
      }

      return React.createElement(_checkbox["default"], _extends({
        checked: checked
      }, rest));
    }
  }]);

  return SelectionBox;
}(React.Component);

exports["default"] = SelectionBox;
//# sourceMappingURL=SelectionBox.js.map


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(38);

var _checkbox = _interopRequireDefault(__webpack_require__(46));

var _dropdown = _interopRequireDefault(__webpack_require__(219));

var _menu = _interopRequireDefault(__webpack_require__(220));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function checkSelection(_ref) {
  var store = _ref.store,
      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
      getRecordKey = _ref.getRecordKey,
      data = _ref.data,
      type = _ref.type,
      byDefaultChecked = _ref.byDefaultChecked;
  return byDefaultChecked ? data[type](function (item, i) {
    return getCheckboxPropsByItem(item, i).defaultChecked;
  }) : data[type](function (item, i) {
    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
  });
}

function getIndeterminateState(props) {
  var store = props.store,
      data = props.data;

  if (!data.length) {
    return false;
  }

  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'some',
    byDefaultChecked: false
  })) && !checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: false
  }));
  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'some',
    byDefaultChecked: true
  })) && !checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: true
  }));

  if (store.getState().selectionDirty) {
    return someCheckedNotByDefaultChecked;
  }

  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
}

function getCheckState(props) {
  var store = props.store,
      data = props.data;

  if (!data.length) {
    return false;
  }

  if (store.getState().selectionDirty) {
    return checkSelection(_extends(_extends({}, props), {
      data: data,
      type: 'every',
      byDefaultChecked: false
    }));
  }

  return checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: false
  })) || checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: true
  }));
}

var SelectionCheckboxAll =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectionCheckboxAll, _React$Component);

  function SelectionCheckboxAll(props) {
    var _this;

    _classCallCheck(this, SelectionCheckboxAll);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectionCheckboxAll).call(this, props));
    _this.state = {
      checked: false,
      indeterminate: false
    };

    _this.handleSelectAllChange = function (e) {
      var checked = e.target.checked;

      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
    };

    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
      key: 'all',
      text: props.locale.selectAll
    }, {
      key: 'invert',
      text: props.locale.selectInvert
    }];
    return _this;
  }

  _createClass(SelectionCheckboxAll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
  }, {
    key: "setCheckState",
    value: function setCheckState(props) {
      var checked = getCheckState(props);
      var indeterminate = getIndeterminateState(props);
      this.setState(function (prevState) {
        var newState = {};

        if (indeterminate !== prevState.indeterminate) {
          newState.indeterminate = indeterminate;
        }

        if (checked !== prevState.checked) {
          newState.checked = checked;
        }

        return newState;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var store = this.props.store;
      this.unsubscribe = store.subscribe(function () {
        _this2.setCheckState(_this2.props);
      });
    }
  }, {
    key: "renderMenus",
    value: function renderMenus(selections) {
      var _this3 = this;

      return selections.map(function (selection, index) {
        return React.createElement(_menu["default"].Item, {
          key: selection.key || index
        }, React.createElement("div", {
          onClick: function onClick() {
            _this3.props.onSelect(selection.key, index, selection.onSelect);
          }
        }, selection.text));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          prefixCls = _this$props.prefixCls,
          selections = _this$props.selections,
          getPopupContainer = _this$props.getPopupContainer;
      var _this$state = this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;
      var selectionPrefixCls = "".concat(prefixCls, "-selection");
      var customSelections = null;

      if (selections) {
        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
        var menu = React.createElement(_menu["default"], {
          className: "".concat(selectionPrefixCls, "-menu"),
          selectedKeys: []
        }, this.renderMenus(newSelections));
        customSelections = newSelections.length > 0 ? React.createElement(_dropdown["default"], {
          overlay: menu,
          getPopupContainer: getPopupContainer
        }, React.createElement("div", {
          className: "".concat(selectionPrefixCls, "-down")
        }, React.createElement(_icon["default"], {
          type: "down"
        }))) : null;
      }

      return React.createElement("div", {
        className: selectionPrefixCls
      }, React.createElement(_checkbox["default"], {
        className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
        checked: checked,
        indeterminate: indeterminate,
        disabled: disabled,
        onChange: this.handleSelectAllChange
      }), customSelections);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var checked = getCheckState(props);
      var indeterminate = getIndeterminateState(props);
      var newState = {};

      if (indeterminate !== state.indeterminate) {
        newState.indeterminate = indeterminate;
      }

      if (checked !== state.checked) {
        newState.checked = checked;
      }

      return newState;
    }
  }]);

  return SelectionCheckboxAll;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
var _default = SelectionCheckboxAll;
exports["default"] = _default;
//# sourceMappingURL=SelectionCheckboxAll.js.map


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcMenu = __webpack_require__(135);

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _MenuContext = _interopRequireDefault(__webpack_require__(341));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SubMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  function SubMenu() {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).apply(this, arguments));

    _this.onKeyDown = function (e) {
      _this.subMenu.onKeyDown(e);
    };

    _this.saveSubMenu = function (subMenu) {
      _this.subMenu = subMenu;
    };

    return _this;
  }

  _createClass(SubMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rootPrefixCls = _this$props.rootPrefixCls,
          popupClassName = _this$props.popupClassName;
      return React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
        var antdMenuTheme = _ref.antdMenuTheme;
        return React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
          ref: _this2.saveSubMenu,
          popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
        }));
      });
    }
  }]);

  return SubMenu;
}(React.Component);

SubMenu.contextTypes = {
  antdMenuTheme: PropTypes.string
}; // fix issue:https://github.com/ant-design/ant-design/issues/8666

SubMenu.isSubMenu = 1;
var _default = SubMenu;
exports["default"] = _default;
//# sourceMappingURL=SubMenu.js.map


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = __webpack_require__(135);

var _MenuContext = _interopRequireDefault(__webpack_require__(341));

var _tooltip = _interopRequireDefault(__webpack_require__(64));

var _Sider = __webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));

    _this.onKeyDown = function (e) {
      _this.menuItem.onKeyDown(e);
    };

    _this.saveMenuItem = function (menuItem) {
      _this.menuItem = menuItem;
    };

    _this.renderItem = function (_ref) {
      var siderCollapsed = _ref.siderCollapsed;
      var _this$props = _this.props,
          level = _this$props.level,
          children = _this$props.children,
          rootPrefixCls = _this$props.rootPrefixCls;

      var _a = _this.props,
          title = _a.title,
          rest = __rest(_a, ["title"]);

      return React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
        var inlineCollapsed = _ref2.inlineCollapsed;
        var tooltipProps = {
          title: title || (level === 1 ? children : '')
        };

        if (!siderCollapsed && !inlineCollapsed) {
          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
          // ref: https://github.com/ant-design/ant-design/issues/16742

          tooltipProps.visible = false;
        }

        return React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
          placement: "right",
          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
        }), React.createElement(_rcMenu.Item, _extends({}, rest, {
          title: title,
          ref: _this.saveMenuItem
        })));
      });
    };

    return _this;
  }

  _createClass(MenuItem, [{
    key: "render",
    value: function render() {
      return React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem);
    }
  }]);

  return MenuItem;
}(React.Component);

exports["default"] = MenuItem;
MenuItem.isMenuItem = true;
//# sourceMappingURL=MenuItem.js.map


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// ================== Collapse Motion ==================
var getCollapsedHeight = function getCollapsedHeight() {
  return {
    height: 0,
    opacity: 0
  };
};

var getRealHeight = function getRealHeight(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};

var getCurrentHeight = function getCurrentHeight(node) {
  return {
    height: node.offsetHeight
  };
};

var collapseMotion = {
  motionName: 'ant-motion-collapse',
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight
};
var _default = collapseMotion;
exports["default"] = _default;
//# sourceMappingURL=motion.js.map


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/prefer-stateless-function */
var Column =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Column, _React$Component);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _getPrototypeOf(Column).apply(this, arguments));
  }

  return Column;
}(React.Component);

exports["default"] = Column;
//# sourceMappingURL=Column.js.map


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ColumnGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColumnGroup, _React$Component);

  function ColumnGroup() {
    _classCallCheck(this, ColumnGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ColumnGroup).apply(this, arguments));
  }

  return ColumnGroup;
}(React.Component);

exports["default"] = ColumnGroup;
ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;
//# sourceMappingURL=ColumnGroup.js.map


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createBodyRow;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames2 = _interopRequireDefault(__webpack_require__(5));

var _omit = _interopRequireDefault(__webpack_require__(56));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function createBodyRow() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';

  var BodyRow =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(BodyRow, _React$Component);

    function BodyRow(props) {
      var _this;

      _classCallCheck(this, BodyRow);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(BodyRow).call(this, props));
      _this.store = props.store;

      var _this$store$getState = _this.store.getState(),
          selectedRowKeys = _this$store$getState.selectedRowKeys;

      _this.state = {
        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
      };
      return _this;
    }

    _createClass(BodyRow, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.subscribe();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: "subscribe",
      value: function subscribe() {
        var _this2 = this;

        var _this$props = this.props,
            store = _this$props.store,
            rowKey = _this$props.rowKey;
        this.unsubscribe = store.subscribe(function () {
          var _this2$store$getState = _this2.store.getState(),
              selectedRowKeys = _this2$store$getState.selectedRowKeys;

          var selected = selectedRowKeys.indexOf(rowKey) >= 0;

          if (selected !== _this2.state.selected) {
            _this2.setState({
              selected: selected
            });
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
        return React.createElement(Component, _extends(_extends({}, rowProps), {
          className: className
        }), this.props.children);
      }
    }]);

    return BodyRow;
  }(React.Component);

  return BodyRow;
}
//# sourceMappingURL=createBodyRow.js.map


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

var _raf = _interopRequireDefault(__webpack_require__(433));

var _getScroll = _interopRequireDefault(__webpack_require__(1622));

var _easings = __webpack_require__(1623);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function scrollTo(y) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$getContainer = options.getContainer,
      getContainer = _options$getContainer === void 0 ? function () {
    return window;
  } : _options$getContainer,
      callback = options.callback,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 450 : _options$duration;
  var container = getContainer();
  var scrollTop = (0, _getScroll["default"])(container, true);
  var startTime = Date.now();

  var frameFunc = function frameFunc() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);

    if (container === window) {
      window.scrollTo(window.pageXOffset, nextScrollTop);
    } else {
      container.scrollTop = nextScrollTop;
    }

    if (time < duration) {
      (0, _raf["default"])(frameFunc);
    } else if (typeof callback === 'function') {
      callback();
    }
  };

  (0, _raf["default"])(frameFunc);
}
//# sourceMappingURL=scrollTo.js.map


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getScroll;

function getScroll(target, top) {
  if (typeof window === 'undefined') {
    return 0;
  }

  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var isWindow = target === window;
  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

  if (isWindow && typeof ret !== 'number') {
    ret = document.documentElement[method];
  }

  return ret;
}
//# sourceMappingURL=getScroll.js.map


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeInOutCubic = easeInOutCubic;

// eslint-disable-next-line import/prefer-default-export
function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;

  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }

  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}
//# sourceMappingURL=easings.js.map


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcPagination = _interopRequireDefault(__webpack_require__(1625));

var _en_US = _interopRequireDefault(__webpack_require__(405));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _MiniSelect = _interopRequireDefault(__webpack_require__(1630));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _select = _interopRequireDefault(__webpack_require__(7));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));

    _this.getIconsProps = function (prefixCls) {
      var prevIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement(_icon["default"], {
        type: "left"
      }));
      var nextIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement(_icon["default"], {
        type: "right"
      }));
      var jumpPrevIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-left"
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      var jumpNextIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-right"
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      return {
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        jumpPrevIcon: jumpPrevIcon,
        jumpNextIcon: jumpNextIcon
      };
    };

    _this.renderPagination = function (contextLocale) {
      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeSelectPrefixCls = _a.selectPrefixCls,
          className = _a.className,
          size = _a.size,
          customLocale = _a.locale,
          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);

      var locale = _extends(_extends({}, contextLocale), customLocale);

      var isSmall = size === 'small';
      return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefixCls = getPrefixCls('pagination', customizePrefixCls);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        return React.createElement(_rcPagination["default"], _extends({}, restProps, {
          prefixCls: prefixCls,
          selectPrefixCls: selectPrefixCls
        }, _this.getIconsProps(prefixCls), {
          className: (0, _classnames["default"])(className, {
            mini: isSmall
          }),
          selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
          locale: locale
        }));
      });
    };

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      return React.createElement(_LocaleReceiver["default"], {
        componentName: "Pagination",
        defaultLocale: _en_US["default"]
      }, this.renderPagination);
    }
  }]);

  return Pagination;
}(React.Component);

exports["default"] = Pagination;
//# sourceMappingURL=Pagination.js.map


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(1626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pager__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Options__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_lifecycles_compat__ = __webpack_require__(38);















function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type, element) {
  return element;
}

function calculatePage(p, state, props) {
  var pageSize = p;
  if (typeof pageSize === 'undefined') {
    pageSize = state.pageSize;
  }
  return Math.floor((props.total - 1) / pageSize) + 1;
}

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _initialiseProps.call(_this);

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = 'current' in props;
    if (hasCurrent && !hasOnChange) {
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
    }

    var current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    current = Math.min(current, calculatePage(pageSize, undefined, props));

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Pagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: 'getValidValue',
    value: function getValidValue(e) {
      var inputValue = e.target.value;
      var allPages = calculatePage(undefined, this.state, this.props);
      var currentInputValue = this.state.currentInputValue;

      var value = void 0;
      if (inputValue === '') {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = currentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled;

      // When hideOnSinglePage is true and there is only 1 page, hide the pager

      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
        return null;
      }

      var props = this.props;
      var locale = props.locale;

      var allPages = calculatePage(undefined, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;

      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
      var pageBufferSize = props.showLessItems ? 1 : 2;
      var _state = this.state,
          current = _state.current,
          pageSize = _state.pageSize;


      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;

      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          prev[key] = props[key];
        }
        return prev;
      }, {});

      if (props.simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'span',
              {
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              goButton
            );
          }
          gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            gotoButton
          );
        }

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'ul',
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
            style: props.style,
            ref: this.savePaginationNode
          }, dataOrAriaAttributeProps),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.prev_page : null,
              onClick: this.prev,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterPrev,
              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
              'aria-disabled': !this.hasPrev()
            },
            props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
              type: 'text',
              value: this.state.currentInputValue,
              onKeyDown: this.handleKeyDown,
              onKeyUp: this.handleKeyUp,
              onChange: this.handleKeyUp,
              size: '3'
            }),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'span',
              { className: prefixCls + '-slash' },
              '/'
            ),
            allPages
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.next_page : null,
              onClick: this.next,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterNext,
              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
              'aria-disabled': !this.hasNext()
            },
            props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
          ),
          gotoButton
        );
      }

      if (allPages <= 5 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        };
        if (!allPages) {
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: 'noPager',
            page: allPages,
            className: prefixCls + '-disabled'
          })));
        }
        for (var i = 1; i <= allPages; i++) {
          var active = this.state.current === i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: i,
            page: i,
            active: active
          })));
        }
      } else {
        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
        if (props.showPrevNextJumpers) {
          var jumpPrevClassString = prefixCls + '-jump-prev';
          if (props.jumpPrevIcon) {
            jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
          }
          jumpPrev = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? prevItemTitle : null,
              key: 'prev',
              onClick: this.jumpPrev,
              tabIndex: '0',
              onKeyPress: this.runIfEnterJumpPrev,
              className: jumpPrevClassString
            },
            props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon))
          );
          var jumpNextClassString = prefixCls + '-jump-next';
          if (props.jumpNextIcon) {
            jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
          }
          jumpNext = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? nextItemTitle : null,
              key: 'next',
              tabIndex: '0',
              onClick: this.jumpNext,
              onKeyPress: this.runIfEnterJumpNext,
              className: jumpNextClassString
            },
            props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon))
          );
        }
        lastPager = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: props.locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });
        firstPager = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });

        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i++) {
          var _active = current === _i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
            locale: props.locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(pagerList[0], {
            className: prefixCls + '-item-after-jump-prev'
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(pagerList[pagerList.length - 1], {
            className: prefixCls + '-item-before-jump-next'
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (props.showTotal) {
        totalText = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          { className: prefixCls + '-total-text' },
          props.showTotal(props.total, [props.total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        );
      }
      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-disabled', disabled)),
          style: props.style,
          unselectable: 'unselectable',
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps),
        totalText,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.prev_page : null,
            onClick: this.prev,
            tabIndex: prevDisabled ? null : 0,
            onKeyPress: this.runIfEnterPrev,
            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
            'aria-disabled': prevDisabled
          },
          props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
        ),
        pagerList,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.next_page : null,
            onClick: this.next,
            tabIndex: nextDisabled ? null : 0,
            onKeyPress: this.runIfEnterNext,
            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
            'aria-disabled': nextDisabled
          },
          props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Options__["a" /* default */], {
          disabled: disabled,
          locale: props.locale,
          rootPrefixCls: prefixCls,
          selectComponentClass: props.selectComponentClass,
          selectPrefixCls: props.selectPrefixCls,
          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
          current: this.state.current,
          pageSize: this.state.pageSize,
          pageSizeOptions: this.props.pageSizeOptions,
          quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
          goButton: goButton
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};

      if ('current' in props) {
        newState.current = props.current;

        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }

      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;

        if (!('current' in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = props.pageSize;
      }

      return newState;
    }

    /**
     * computed icon node that need to be rendered.
     * @param {React.ReactNode | React.ComponentType<PaginationProps>} icon received icon.
     * @returns {React.ReactNode}
     */

  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  current: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  defaultCurrent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  hideOnSinglePage: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showSizeChanger: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showLessItems: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onShowSizeChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  showPrevNextJumpers: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showQuickJumper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  showTitle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string),
  showTotal: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  itemRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  prevIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  nextIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  jumpPrevIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  jumpNextIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node])
};
Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__["a" /* default */],
  style: {},
  itemRender: defaultItemRender
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getJumpPrevPage = function () {
    return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
  };

  this.getJumpNextPage = function () {
    return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
  };

  this.getItemIcon = function (icon) {
    var prefixCls = _this2.props.prefixCls;

    var iconNode = icon || __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { className: prefixCls + '-item-link' });
    if (typeof icon === 'function') {
      iconNode = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(icon, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.props));
    }
    return iconNode;
  };

  this.savePaginationNode = function (node) {
    _this2.paginationNode = node;
  };

  this.isValid = function (page) {
    return isInteger(page) && page !== _this2.state.current;
  };

  this.shouldDisplayQuickJumper = function () {
    var _props2 = _this2.props,
        showQuickJumper = _props2.showQuickJumper,
        pageSize = _props2.pageSize,
        total = _props2.total;

    if (total <= pageSize) {
      return false;
    }
    return showQuickJumper;
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP || e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
      e.preventDefault();
    }
  };

  this.handleKeyUp = function (e) {
    var value = _this2.getValidValue(e);
    var currentInputValue = _this2.state.currentInputValue;

    if (value !== currentInputValue) {
      _this2.setState({
        currentInputValue: value
      });
    }
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER) {
      _this2.handleChange(value);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP) {
      _this2.handleChange(value - 1);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
      _this2.handleChange(value + 1);
    }
  };

  this.changePageSize = function (size) {
    var current = _this2.state.current;
    var newCurrent = calculatePage(size, _this2.state, _this2.props);
    current = current > newCurrent ? newCurrent : current;
    // fix the issue:
    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
    if (newCurrent === 0) {
      current = _this2.state.current;
    }

    if (typeof size === 'number') {
      if (!('pageSize' in _this2.props)) {
        _this2.setState({
          pageSize: size
        });
      }
      if (!('current' in _this2.props)) {
        _this2.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this2.props.onShowSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var disabled = _this2.props.disabled;


    var page = p;
    if (_this2.isValid(page) && !disabled) {
      var currentPage = calculatePage(undefined, _this2.state, _this2.props);
      if (page > currentPage) {
        page = currentPage;
      } else if (page < 1) {
        page = 1;
      }

      if (!('current' in _this2.props)) {
        _this2.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this2.state.pageSize;
      _this2.props.onChange(page, pageSize);

      return page;
    }

    return _this2.state.current;
  };

  this.prev = function () {
    if (_this2.hasPrev()) {
      _this2.handleChange(_this2.state.current - 1);
    }
  };

  this.next = function () {
    if (_this2.hasNext()) {
      _this2.handleChange(_this2.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this2.handleChange(_this2.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this2.handleChange(_this2.getJumpNextPage());
  };

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.hasNext = function () {
    return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      callback.apply(undefined, restParams);
    }
  };

  this.runIfEnterPrev = function (e) {
    _this2.runIfEnter(e, _this2.prev);
  };

  this.runIfEnterNext = function (e) {
    _this2.runIfEnter(e, _this2.next);
  };

  this.runIfEnterJumpPrev = function (e) {
    _this2.runIfEnter(e, _this2.jumpPrev);
  };

  this.runIfEnterJumpNext = function (e) {
    _this2.runIfEnter(e, _this2.jumpNext);
  };

  this.handleGoTO = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
      _this2.handleChange(_this2.state.currentInputValue);
    }
  };
};

Object(__WEBPACK_IMPORTED_MODULE_13_react_lifecycles_compat__["polyfill"])(Pagination);

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var Pager = function Pager(props) {
  var _classNames;

  var prefixCls = props.rootPrefixCls + '-item';
  var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, prefixCls + '-' + props.page, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-active', props.active), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, props.className, !!props.className), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', !props.page), _classNames));

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: handleClick,
      onKeyPress: handleKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      null,
      props.page
    ))
  );
};

Pager.propTypes = {
  page: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  active: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  last: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  showTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onKeyPress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  itemRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Pager);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KeyCode__ = __webpack_require__(533);








var Options = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Options, _React$Component);

  function Options() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Options);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      goInputText: ''
    }, _this.buildOptionText = function (value) {
      return value + ' ' + _this.props.locale.items_per_page;
    }, _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    }, _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    }, _this.handleBlur = function (e) {
      var _this$props = _this.props,
          goButton = _this$props.goButton,
          quickGo = _this$props.quickGo,
          rootPrefixCls = _this$props.rootPrefixCls;

      if (goButton) {
        return;
      }
      if (e.relatedTarget && (e.relatedTarget.className.indexOf(rootPrefixCls + '-prev') >= 0 || e.relatedTarget.className.indexOf(rootPrefixCls + '-next') >= 0)) {
        return;
      }
      quickGo(_this.getValidValue());
    }, _this.go = function (e) {
      var goInputText = _this.state.goInputText;

      if (goInputText === '') {
        return;
      }
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });
        _this.props.quickGo(_this.getValidValue());
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Options, [{
    key: 'getValidValue',
    value: function getValidValue() {
      var _state = this.state,
          goInputText = _state.goInputText,
          current = _state.current;

      return !goInputText || isNaN(goInputText) ? current : Number(goInputText);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pageSize = _props.pageSize,
          pageSizeOptions = _props.pageSizeOptions,
          locale = _props.locale,
          rootPrefixCls = _props.rootPrefixCls,
          changeSize = _props.changeSize,
          quickGo = _props.quickGo,
          goButton = _props.goButton,
          selectComponentClass = _props.selectComponentClass,
          buildOptionText = _props.buildOptionText,
          selectPrefixCls = _props.selectPrefixCls,
          disabled = _props.disabled;
      var goInputText = this.state.goInputText;

      var prefixCls = rootPrefixCls + '-options';
      var Select = selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!changeSize && !quickGo) {
        return null;
      }

      if (changeSize && Select) {
        var options = pageSizeOptions.map(function (opt, i) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            Select.Option,
            { key: i, value: opt },
            (buildOptionText || _this2.buildOptionText)(opt)
          );
        });

        changeSelect = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          Select,
          {
            disabled: disabled,
            prefixCls: selectPrefixCls,
            showSearch: false,
            className: prefixCls + '-size-changer',
            optionLabelProp: 'children',
            dropdownMatchSelectWidth: false,
            value: (pageSize || pageSizeOptions[0]).toString(),
            onChange: this.changeSize,
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentNode;
            }
          },
          options
        );
      }

      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === 'boolean' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'button',
            {
              type: 'button',
              onClick: this.go,
              onKeyUp: this.go,
              disabled: disabled
            },
            locale.jump_to_confirm
          ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            {
              onClick: this.go,
              onKeyUp: this.go
            },
            goButton
          );
        }
        goInput = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-quick-jumper' },
          locale.jump_to,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', {
            disabled: disabled,
            type: 'text',
            value: goInputText,
            onChange: this.handleChange,
            onKeyUp: this.go,
            onBlur: this.handleBlur
          }),
          locale.page,
          gotoButton
        );
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        { className: '' + prefixCls },
        changeSelect,
        goInput
      );
    }
  }]);

  return Options;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Options.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  changeSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  quickGo: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  current: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string),
  pageSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  buildOptionText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  selectPrefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  goButton: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node])
};
Options.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
};


/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
});

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _select = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MiniSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MiniSelect, _React$Component);

  function MiniSelect() {
    _classCallCheck(this, MiniSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(MiniSelect).apply(this, arguments));
  }

  _createClass(MiniSelect, [{
    key: "render",
    value: function render() {
      return React.createElement(_select["default"], _extends({
        size: "small"
      }, this.props));
    }
  }]);

  return MiniSelect;
}(React.Component);

exports["default"] = MiniSelect;
MiniSelect.Option = _select["default"].Option;
//# sourceMappingURL=MiniSelect.js.map


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _KeyCode = _interopRequireDefault(__webpack_require__(132));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Wrap of sub component which need use as Button capacity (like Icon component).
 * This helps accessibility reader to tread as a interactive button to operation.
 */


var inlineStyle = {
  border: 0,
  background: 'transparent',
  padding: 0,
  lineHeight: 'inherit',
  display: 'inline-block'
};

var TransButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TransButton, _React$Component);

  function TransButton() {
    var _this;

    _classCallCheck(this, TransButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransButton).apply(this, arguments));

    _this.onKeyDown = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === _KeyCode["default"].ENTER) {
        event.preventDefault();
      }
    };

    _this.onKeyUp = function (event) {
      var keyCode = event.keyCode;
      var onClick = _this.props.onClick;

      if (keyCode === _KeyCode["default"].ENTER && onClick) {
        onClick();
      }
    };

    _this.setRef = function (btn) {
      _this.div = btn;
    };

    return _this;
  }

  _createClass(TransButton, [{
    key: "focus",
    value: function focus() {
      if (this.div) {
        this.div.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.div) {
        this.div.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          style = _a.style,
          noStyle = _a.noStyle,
          restProps = __rest(_a, ["style", "noStyle"]);

      return React.createElement("div", _extends({
        role: "button",
        tabIndex: 0,
        ref: this.setRef
      }, restProps, {
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
      }));
    }
  }]);

  return TransButton;
}(React.Component);

var _default = TransButton;
exports["default"] = _default;
//# sourceMappingURL=transButton.js.map


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.28
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(21)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(21)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.28",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1633 */
/***/ (function(module, exports) {

module.exports = {"version":"2019c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Godthab America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export Doughnut */
/* unused harmony export Pie */
/* unused harmony export Line */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HorizontalBar; });
/* unused harmony export Radar */
/* unused harmony export Polar */
/* unused harmony export Bubble */
/* unused harmony export Scatter */
/* unused harmony export defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__);
/* unused harmony reexport Chart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://act-api.dctms.ca","REACT_APP_UI_URL":"https://act.dctms.ca","REACT_APP_SECRET_NAME":"wiZzx1yTU1vSx89QKprP","REACT_APP_SECRET_KEY":"GmjMJuznKRqNxfca3gk6","REACT_APP_RECAPTCHA_SITE_KEY":"6LcGgdoUAAAAAHj_Zc4lmYgJmbgv1nbANULvNcy6"}) && "production";

var ChartComponent = function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  function ChartComponent() {
    _classCallCheck(this, ChartComponent);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.handleOnClick = function (event) {
      var instance = _this.chartInstance;

      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;


      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    };

    _this.ref = function (element) {
      _this.element = element;
    };

    _this.chartInstance = undefined;
    return _this;
  }

  ChartComponent.prototype.componentDidMount = function componentDidMount() {
    this.renderChart();
  };

  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.redraw) {
      this.destroyChart();
      this.renderChart();
      return;
    }

    this.updateChart();
  };

  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _props = this.props,
        redraw = _props.redraw,
        type = _props.type,
        options = _props.options,
        plugins = _props.plugins,
        legend = _props.legend,
        height = _props.height,
        width = _props.width;


    if (nextProps.redraw === true) {
      return true;
    }

    if (height !== nextProps.height || width !== nextProps.width) {
      return true;
    }

    if (type !== nextProps.type) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(legend, nextProps.legend)) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(options, nextProps.options)) {
      return true;
    }

    var nextData = this.transformDataProp(nextProps);

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(this.shadowDataProp, nextData)) {
      return true;
    }

    return !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(plugins, nextProps.plugins);
  };

  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.destroyChart();
  };

  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
    var data = props.data;

    if (typeof data == 'function') {
      var node = this.element;
      return data(node);
    } else {
      return data;
    }
  };

  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
  // this makes impossible to compare the current and next data changes
  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617


  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
    if (!this.props.data) {
      return;
    }

    var data = this.transformDataProp(this.props);

    this.shadowDataProp = _extends({}, data, {
      datasets: data.datasets && data.datasets.map(function (set) {
        return _extends({}, set);
      })
    });

    this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

    return data;
  };

  ChartComponent.prototype.checkDatasets = function checkDatasets(datasets) {
    var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
    var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
    var multipleDatasets = datasets.length > 1;

    if (isDev && multipleDatasets && !usingCustomKeyProvider) {
      var shouldWarn = false;
      datasets.forEach(function (dataset) {
        if (!dataset.label) {
          shouldWarn = true;
        }
      });

      if (shouldWarn) {
        console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
      }
    }
  };

  ChartComponent.prototype.getCurrentDatasets = function getCurrentDatasets() {
    return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
  };

  ChartComponent.prototype.saveCurrentDatasets = function saveCurrentDatasets() {
    var _this2 = this;

    this.datasets = this.datasets || {};
    var currentDatasets = this.getCurrentDatasets();
    currentDatasets.forEach(function (d) {
      _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
    });
  };

  ChartComponent.prototype.updateChart = function updateChart() {
    var _this3 = this;

    var options = this.props.options;


    var data = this.memoizeDataProps(this.props);

    if (!this.chartInstance) return;

    if (options) {
      this.chartInstance.options = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.helpers.configMerge(this.chartInstance.options, options);
    }

    // Pipe datasets to chart instance datasets enabling
    // seamless transitions
    var currentDatasets = this.getCurrentDatasets();
    var nextDatasets = data.datasets || [];
    this.checkDatasets(currentDatasets);

    var currentDatasetsIndexed = __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default()(currentDatasets, this.props.datasetKeyProvider);

    // We can safely replace the dataset array, as long as we retain the _meta property
    // on each dataset.
    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
      var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

      if (current && current.type === next.type && next.data) {
        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
        // The data array must be edited in place. As chart.js adds listeners to it.
        current.data.splice(next.data.length);
        next.data.forEach(function (point, pid) {
          current.data[pid] = next.data[pid];
        });

        var _data = next.data,
            otherProps = _objectWithoutProperties(next, ['data']);
        // Merge properties. Notice a weakness here. If a property is removed
        // from next, it will be retained by current and never disappears.
        // Workaround is to set value to null or undefined in next.


        return _extends({}, current, otherProps);
      } else {
        return next;
      }
    });

    var datasets = data.datasets,
        rest = _objectWithoutProperties(data, ['datasets']);

    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);

    this.chartInstance.update();
  };

  ChartComponent.prototype.renderChart = function renderChart() {
    var _props2 = this.props,
        options = _props2.options,
        legend = _props2.legend,
        type = _props2.type,
        plugins = _props2.plugins;

    var node = this.element;
    var data = this.memoizeDataProps();

    if (typeof legend !== 'undefined' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(ChartComponent.defaultProps.legend, legend)) {
      options.legend = legend;
    }

    this.chartInstance = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(node, {
      type: type,
      data: data,
      options: options,
      plugins: plugins
    });
  };

  ChartComponent.prototype.destroyChart = function destroyChart() {
    if (!this.chartInstance) {
      return;
    }

    // Put all of the datasets that have existed in the chart back on the chart
    // so that the metadata associated with this chart get destroyed.
    // This allows the datasets to be used in another chart. This can happen,
    // for example, in a tabbed UI where the chart gets created each time the
    // tab gets switched to the chart and uses the same data).
    this.saveCurrentDatasets();
    var datasets = Object.values(this.datasets);
    this.chartInstance.config.data.datasets = datasets;

    this.chartInstance.destroy();
  };

  ChartComponent.prototype.render = function render() {
    var _props3 = this.props,
        height = _props3.height,
        width = _props3.width,
        id = _props3.id;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
      ref: this.ref,
      height: height,
      width: width,
      id: id,
      onClick: this.handleOnClick
    });
  };

  return ChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ChartComponent.getLabelAsKey = function (d) {
  return d.label;
};

ChartComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  getDatasetAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementsAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  legend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onElementsClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
  redraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: function type(props, propName, componentName) {
    if (!__WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  datasetKeyProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ChartComponent.defaultProps = {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
};


/* unused harmony default export */ var _unused_webpack_default_export = (ChartComponent);

var Doughnut = function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Doughnut.prototype.render = function render() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref) {
        return _this5.chartInstance = _ref && _ref.chartInstance;
      },
      type: 'doughnut'
    }));
  };

  return Doughnut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Pie = function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  function Pie() {
    _classCallCheck(this, Pie);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  }

  Pie.prototype.render = function render() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref2) {
        return _this7.chartInstance = _ref2 && _ref2.chartInstance;
      },
      type: 'pie'
    }));
  };

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Line = function (_React$Component4) {
  _inherits(Line, _React$Component4);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref3) {
        return _this9.chartInstance = _ref3 && _ref3.chartInstance;
      },
      type: 'line'
    }));
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bar = function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
  }

  Bar.prototype.render = function render() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref4) {
        return _this11.chartInstance = _ref4 && _ref4.chartInstance;
      },
      type: 'bar'
    }));
  };

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var HorizontalBar = function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
  }

  HorizontalBar.prototype.render = function render() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref5) {
        return _this13.chartInstance = _ref5 && _ref5.chartInstance;
      },
      type: 'horizontalBar'
    }));
  };

  return HorizontalBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Radar = function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  function Radar() {
    _classCallCheck(this, Radar);

    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
  }

  Radar.prototype.render = function render() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref6) {
        return _this15.chartInstance = _ref6 && _ref6.chartInstance;
      },
      type: 'radar'
    }));
  };

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Polar = function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  function Polar() {
    _classCallCheck(this, Polar);

    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
  }

  Polar.prototype.render = function render() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref7) {
        return _this17.chartInstance = _ref7 && _ref7.chartInstance;
      },
      type: 'polarArea'
    }));
  };

  return Polar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bubble = function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
  }

  Bubble.prototype.render = function render() {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref8) {
        return _this19.chartInstance = _ref8 && _ref8.chartInstance;
      },
      type: 'bubble'
    }));
  };

  return Bubble;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Scatter = function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
  }

  Scatter.prototype.render = function render() {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref9) {
        return _this21.chartInstance = _ref9 && _ref9.chartInstance;
      },
      type: 'scatter'
    }));
  };

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var defaults = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.defaults;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(154)))

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.3
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(21); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge({}, [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(Math.max.apply(null, widths));
	highest = heights.indexOf(Math.max.apply(null, heights));

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(342);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(535),
    equalArrays = __webpack_require__(540),
    equalByTag = __webpack_require__(1671),
    equalObjects = __webpack_require__(1675),
    getTag = __webpack_require__(1693),
    isArray = __webpack_require__(92),
    isBuffer = __webpack_require__(542),
    isTypedArray = __webpack_require__(544);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1638 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(222);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(222);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(222);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(222);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(221);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1644 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1645 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1646 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(221),
    Map = __webpack_require__(343),
    MapCache = __webpack_require__(345);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(537),
    isMasked = __webpack_require__(1651),
    isObject = __webpack_require__(344),
    toSource = __webpack_require__(539);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1652);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(91);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1653 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1655),
    ListCache = __webpack_require__(221),
    Map = __webpack_require__(343);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1656),
    hashDelete = __webpack_require__(1657),
    hashGet = __webpack_require__(1658),
    hashHas = __webpack_require__(1659),
    hashSet = __webpack_require__(1660);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(224);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1657 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(224);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(224);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(224);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(225);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(225);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(225);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(225);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(345),
    setCacheAdd = __webpack_require__(1667),
    setCacheHas = __webpack_require__(1668);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1667 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1668 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1669 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    Uint8Array = __webpack_require__(1672),
    eq = __webpack_require__(536),
    equalArrays = __webpack_require__(540),
    mapToArray = __webpack_require__(1673),
    setToArray = __webpack_require__(1674);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(91);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1673 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1674 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1676);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1677),
    getSymbols = __webpack_require__(1679),
    keys = __webpack_require__(346);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1678),
    isArray = __webpack_require__(92);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1678 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1680),
    stubArray = __webpack_require__(1681);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1680 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1681 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1683),
    isArguments = __webpack_require__(541),
    isArray = __webpack_require__(92),
    isBuffer = __webpack_require__(542),
    isIndex = __webpack_require__(543),
    isTypedArray = __webpack_require__(544);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1683 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(170);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isLength = __webpack_require__(347),
    isObjectLike = __webpack_require__(170);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1687 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(538);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1690),
    nativeKeys = __webpack_require__(1691);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1690 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1692);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1692 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1694),
    Map = __webpack_require__(343),
    Promise = __webpack_require__(1695),
    Set = __webpack_require__(1696),
    WeakMap = __webpack_require__(1697),
    baseGetTag = __webpack_require__(169),
    toSource = __webpack_require__(539);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(91);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(91);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(91);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(91);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1699),
    createAggregator = __webpack_require__(1701);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1700);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1702),
    baseAggregator = __webpack_require__(1703),
    baseIteratee = __webpack_require__(1709),
    isArray = __webpack_require__(92);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 1702 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1704);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1705),
    createBaseEach = __webpack_require__(1708);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1706),
    keys = __webpack_require__(346);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1707);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1707 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(545);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1710),
    baseMatchesProperty = __webpack_require__(1713),
    identity = __webpack_require__(1724),
    isArray = __webpack_require__(92),
    property = __webpack_require__(1725);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1711),
    getMatchData = __webpack_require__(1712),
    matchesStrictComparable = __webpack_require__(547);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(535),
    baseIsEqual = __webpack_require__(342);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(546),
    keys = __webpack_require__(346);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(342),
    get = __webpack_require__(1714),
    hasIn = __webpack_require__(1721),
    isKey = __webpack_require__(348),
    isStrictComparable = __webpack_require__(546),
    matchesStrictComparable = __webpack_require__(547),
    toKey = __webpack_require__(226);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(548);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1716);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1717);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(345);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1719);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    arrayMap = __webpack_require__(1720),
    isArray = __webpack_require__(92),
    isSymbol = __webpack_require__(349);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1722),
    hasPath = __webpack_require__(1723);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(549),
    isArguments = __webpack_require__(541),
    isArray = __webpack_require__(92),
    isIndex = __webpack_require__(543),
    isLength = __webpack_require__(347),
    toKey = __webpack_require__(226);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1724 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1726),
    basePropertyDeep = __webpack_require__(1727),
    isKey = __webpack_require__(348),
    toKey = __webpack_require__(226);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(548);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(69));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(95);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1732);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-menu {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  font-feature-settings: 'tnum';\n  margin-bottom: 0;\n  padding-left: 0;\n  color: #424242;\n  line-height: 0;\n  list-style: none;\n  background: rgba(0, 0, 0, 0);\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  transition: background 0.3s, width 0.2s;\n  zoom: 1;\n}\n.ant-menu::before,\n.ant-menu::after {\n  display: table;\n  content: '';\n}\n.ant-menu::after {\n  clear: both;\n}\n.ant-menu ul,\n.ant-menu ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-menu-hidden {\n  display: none;\n}\n.ant-menu-item-group-title {\n  padding: 8px 16px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  line-height: 1.5;\n  transition: all 0.3s;\n}\n.ant-menu-submenu,\n.ant-menu-submenu-inline {\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-selected {\n  color: #4CDEF5;\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #f0fffe;\n}\n.ant-menu-submenu .ant-menu-sub {\n  cursor: initial;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item > a {\n  display: block;\n  color: #424242;\n}\n.ant-menu-item > a:hover {\n  color: #4CDEF5;\n}\n.ant-menu-item > a::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: transparent;\n  content: '';\n}\n.ant-menu-item > .ant-badge > a {\n  color: #424242;\n}\n.ant-menu-item > .ant-badge > a:hover {\n  color: #4CDEF5;\n}\n.ant-menu-item-divider {\n  height: 1px;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-menu-item:hover,\n.ant-menu-item-active,\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-submenu-active,\n.ant-menu-submenu-title:hover {\n  color: #4CDEF5;\n}\n.ant-menu-horizontal .ant-menu-item,\n.ant-menu-horizontal .ant-menu-submenu {\n  margin-top: -1px;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: #4CDEF5;\n}\n.ant-menu-item-selected > a,\n.ant-menu-item-selected > a:hover {\n  color: #4CDEF5;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #f0fffe;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-menu-vertical-right {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-vertical.ant-menu-sub,\n.ant-menu-vertical-left.ant-menu-sub,\n.ant-menu-vertical-right.ant-menu-sub {\n  min-width: 160px;\n  padding: 0;\n  border-right: 0;\n  transform-origin: 0 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {\n  transform-origin: 0 0;\n}\n.ant-menu-horizontal.ant-menu-sub {\n  min-width: 114px;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0 20px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  min-width: 14px;\n  margin-right: 10px;\n  font-size: 14px;\n  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .anticon + span,\n.ant-menu-submenu-title .anticon + span {\n  opacity: 1;\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu > .ant-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  padding: 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n  background: #fff;\n  border-radius: 4px;\n}\n.ant-menu-submenu-popup .submenu-title-wrapper {\n  padding-right: 20px;\n}\n.ant-menu-submenu-popup::before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: rgba(0, 0, 0, 0);\n  border-radius: 4px;\n}\n.ant-menu-submenu > .ant-menu-submenu-title::after {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  width: 10px;\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  position: absolute;\n  width: 6px;\n  height: 1.5px;\n  background: rgba(0, 0, 0, 0);\n  background: #424242 \\9;\n  background-image: linear-gradient(to right, #424242, #424242);\n  background-image: none \\9;\n  border-radius: 2px;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  content: '';\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateY(-2px);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateY(2px);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {\n  background: linear-gradient(to right, #4CDEF5, #4CDEF5);\n}\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(-45deg) translateX(2px);\n}\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(45deg) translateX(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  transform: translateY(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateX(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateX(2px);\n}\n.ant-menu-vertical .ant-menu-submenu-selected,\n.ant-menu-vertical-left .ant-menu-submenu-selected,\n.ant-menu-vertical-right .ant-menu-submenu-selected {\n  color: #4CDEF5;\n}\n.ant-menu-vertical .ant-menu-submenu-selected > a,\n.ant-menu-vertical-left .ant-menu-submenu-selected > a,\n.ant-menu-vertical-right .ant-menu-submenu-selected > a {\n  color: #4CDEF5;\n}\n.ant-menu-horizontal {\n  line-height: 46px;\n  white-space: nowrap;\n  border: 0;\n  border-bottom: 1px solid #e8e8e8;\n  box-shadow: none;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  vertical-align: bottom;\n  border-bottom: 2px solid transparent;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  color: #4CDEF5;\n  border-bottom: 2px solid #4CDEF5;\n}\n.ant-menu-horizontal > .ant-menu-item > a {\n  display: block;\n  color: #424242;\n}\n.ant-menu-horizontal > .ant-menu-item > a:hover {\n  color: #4CDEF5;\n}\n.ant-menu-horizontal > .ant-menu-item > a::before {\n  bottom: -2px;\n}\n.ant-menu-horizontal > .ant-menu-item-selected > a {\n  color: #4CDEF5;\n}\n.ant-menu-horizontal::after {\n  display: block;\n  clear: both;\n  height: 0;\n  content: ' ';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item {\n  position: relative;\n}\n.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-inline .ant-menu-item::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border-right: 3px solid #4CDEF5;\n  transform: scaleY(0.0001);\n  opacity: 0;\n  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);\n  content: '';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  height: 40px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 0 16px;\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 40px;\n  text-overflow: ellipsis;\n}\n.ant-menu-vertical .ant-menu-submenu,\n.ant-menu-vertical-left .ant-menu-submenu,\n.ant-menu-vertical-right .ant-menu-submenu,\n.ant-menu-inline .ant-menu-submenu {\n  padding-bottom: 0.02px;\n}\n.ant-menu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 8px;\n}\n.ant-menu-vertical > .ant-menu-item,\n.ant-menu-vertical-left > .ant-menu-item,\n.ant-menu-vertical-right > .ant-menu-item,\n.ant-menu-inline > .ant-menu-item,\n.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 40px;\n  line-height: 40px;\n}\n.ant-menu-inline {\n  width: 100%;\n}\n.ant-menu-inline .ant-menu-selected::after,\n.ant-menu-inline .ant-menu-item-selected::after {\n  transform: scaleY(1);\n  opacity: 1;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-inline .ant-menu-item,\n.ant-menu-inline .ant-menu-submenu-title {\n  width: calc(100% + 1px);\n}\n.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 34px;\n}\n.ant-menu-inline-collapsed {\n  width: 80px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  padding: 0 32px !important;\n  text-overflow: clip;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .anticon,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {\n  margin: 0;\n  font-size: 16px;\n  line-height: 40px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {\n  display: inline-block;\n  max-width: 0;\n  opacity: 0;\n}\n.ant-menu-inline-collapsed-tooltip {\n  pointer-events: none;\n}\n.ant-menu-inline-collapsed-tooltip .anticon {\n  display: none;\n}\n.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  padding-right: 4px;\n  padding-left: 4px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-root.ant-menu-vertical,\n.ant-menu-root.ant-menu-vertical-left,\n.ant-menu-root.ant-menu-vertical-right,\n.ant-menu-root.ant-menu-inline {\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 40px;\n  line-height: 40px;\n  list-style-position: inside;\n  list-style-type: disc;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding-left: 32px;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n  background: none;\n  border-color: transparent !important;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled > a,\n.ant-menu-submenu-disabled > a {\n  color: rgba(0, 0, 0, 0.25) !important;\n  pointer-events: none;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  color: rgba(255, 255, 255, 0.65);\n  background: rgba(0, 0, 0, 0);\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  opacity: 0.45;\n  transition: all 0.3s;\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background: #fff;\n}\n.ant-menu-dark.ant-menu-submenu-popup {\n  background: transparent;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: #000c17;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45) inset;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  top: 0;\n  margin-top: 0;\n  border-color: rgba(0, 0, 0, 0);\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {\n  bottom: 0;\n}\n.ant-menu-dark .ant-menu-item,\n.ant-menu-dark .ant-menu-item-group-title,\n.ant-menu-dark .ant-menu-item > a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-menu-dark.ant-menu-inline,\n.ant-menu-dark.ant-menu-vertical,\n.ant-menu-dark.ant-menu-vertical-left,\n.ant-menu-dark.ant-menu-vertical-right {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {\n  width: 100%;\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark .ant-menu-submenu-open,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu-title:hover {\n  color: #fff;\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark .ant-menu-submenu-open > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow {\n  opacity: 1;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {\n  background: #fff;\n}\n.ant-menu-dark .ant-menu-item:hover {\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  color: #fff;\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected::after {\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected .anticon {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected .anticon + span {\n  color: #fff;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: #4CDEF5;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a {\n  color: rgba(255, 255, 255, 0.35) !important;\n  opacity: 0.8;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(255, 255, 255, 0.35) !important;\n}\n", ""]);

// exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1734);

var iterableToArrayLimit = __webpack_require__(1735);

var nonIterableRest = __webpack_require__(1736);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withNamespaces;
/* unused harmony export translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NamespacesConsumer__ = __webpack_require__(554);













function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function withNamespaces(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Wrapper(WrappedComponent) {
    var LoadNamespace =
    /*#__PURE__*/
    function (_Component) {
      __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(LoadNamespace, _Component);

      function LoadNamespace() {
        __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, LoadNamespace);

        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(LoadNamespace).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(LoadNamespace, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          var i18nOptions = this.props.i18nOptions;

          if (!i18nOptions.usePureComponent && !options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* shallowEqual */])(this.props, nextProps);
        }
      }, {
        key: "render",
        value: function render() {
          var _this = this;

          var _this$props = this.props,
              namespaces = _this$props.namespaces,
              i18nOptions = _this$props.i18nOptions;

          var mergedI18nOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, i18nOptions, options);

          var extraProps = {};

          if (mergedI18nOptions.innerRef) {
            extraProps.ref = mergedI18nOptions.innerRef;
          }

          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NamespacesConsumer__["a" /* NamespacesConsumer */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
            ns: namespaces || namespaceArg
          }, this.props, {
            i18nOptions: Object.keys(mergedI18nOptions).length > 0 ? mergedI18nOptions : null
          }), function (t, _ref) {
            var ready = _ref.ready,
                rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["ready"]);

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
              tReady: ready
            }, _this.props, extraProps, rest));
          });
        }
      }]);

      return LoadNamespace;
    }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

    var LoadNamespaceWithContext = Object(__WEBPACK_IMPORTED_MODULE_10__context__["e" /* withI18n */])()(LoadNamespace);
    LoadNamespaceWithContext.WrappedComponent = WrappedComponent;
    LoadNamespaceWithContext.displayName = "LoadNamespace(".concat(getDisplayName(WrappedComponent), ")");
    LoadNamespaceWithContext.namespaces = namespaceArg;
    return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(LoadNamespaceWithContext, WrappedComponent);
  };
}
withNamespaces.setDefaults = __WEBPACK_IMPORTED_MODULE_10__context__["c" /* setDefaults */];
withNamespaces.setI18n = __WEBPACK_IMPORTED_MODULE_10__context__["d" /* setI18n */];
var translate = withNamespaces;

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1742);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TransComponent */
/* unused harmony export Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html_parse_stringify2__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_html_parse_stringify2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(141);













function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];
  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = "".concat(i);

    if (typeof child === 'string') {
      mem = "".concat(mem).concat(child);
    } else if (hasChildren(child)) {
      mem = "".concat(mem, "<").concat(elementKey, ">").concat(nodesToString('', getChildren(child), i + 1), "</").concat(elementKey, ">");
    } else if (__WEBPACK_IMPORTED_MODULE_8_react___default.a.isValidElement(child)) {
      mem = "".concat(mem, "<").concat(elementKey, "></").concat(elementKey, ">");
    } else if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof___default()(child) === 'object') {
      var clone = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, child);

      var format = clone.format;
      delete clone.format;
      var keys = Object.keys(clone);

      if (format && keys.length === 1) {
        mem = "".concat(mem, "{{").concat(keys[0], ", ").concat(format, "}}");
      } else if (keys.length === 1) {
        mem = "".concat(mem, "{{").concat(keys[0], "}}");
      } else {
        // not a valid interpolation object (can only contain one value plus format)
        Object(__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* warn */])("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* warn */])("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === '') return [];
  if (!children) return [targetString]; // v2 -> interpolates upfront no need for "some <0>{{var}}</0>"" -> will be just "some {{var}}" in translation file

  var data = {};

  function getData(childs) {
    if (Object.prototype.toString.call(childs) !== '[object Array]') childs = [childs];
    childs.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof___default()(child) === 'object' && !__WEBPACK_IMPORTED_MODULE_8_react___default.a.isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  targetString = i18n.services.interpolator.interpolate(targetString, data, i18n.language); // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes

  var ast = __WEBPACK_IMPORTED_MODULE_9_html_parse_stringify2___default.a.parse("<0>".concat(targetString, "</0>"));

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];
    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_8_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!

          mem.push(__WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, child.props, {
            key: i
          }), inner));
        } else if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_typeof___default()(child) === 'object' && !isElement) {
          var content = node.children[0] ? node.children[0].content : null; // v1
          // as interpolation was done already we just have a regular content node
          // in the translation AST while having an object in reactNodes
          // -> push the content no need to interpolate again

          if (content) mem.push(content);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }

      return mem;
    }, []);
  } // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result


  var result = mapAST([{
    dummy: true,
    children: children
  }], ast);
  return getChildren(result[0]);
}

var TransComponent =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(TransComponent, _React$Component);

  function TransComponent() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, TransComponent);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(TransComponent).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(TransComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          count = _this$props.count,
          parent = _this$props.parent,
          i18nKey = _this$props.i18nKey,
          tOptions = _this$props.tOptions,
          values = _this$props.values,
          defaults = _this$props.defaults,
          components = _this$props.components,
          namespace = _this$props.ns,
          i18n = _this$props.i18n,
          tFromContextAndProps = _this$props.t,
          defaultNS = _this$props.defaultNS,
          reportNS = _this$props.reportNS,
          lng = _this$props.lng,
          i18nOptions = _this$props.i18nOptions,
          additionalProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "defaultNS", "reportNS", "lng", "i18nOptions"]);

      var t = tFromContextAndProps || i18n.t.bind(i18n);
      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
      var defaultValue = defaults || nodesToString('', children, 0) || reactI18nextOptions.transEmptyNodeValue;
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : {
        interpolation: {
          prefix: '#$?',
          suffix: '?$#'
        }
      };
      var translation = key ? t(key, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({}, tOptions, values, interpolationOverride, {
        defaultValue: defaultValue,
        count: count,
        ns: namespace
      })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];

        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }

        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({
          ns: ns
        });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return TransComponent;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
var Trans = Object(__WEBPACK_IMPORTED_MODULE_10__context__["e" /* withI18n */])()(TransComponent);

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(1745),
    stringify: __webpack_require__(1748)
};


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(1746);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(1747);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 1747 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 1748 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(141);








var I18nextProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(I18nextProvider, _Component);

  function I18nextProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, I18nextProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(I18nextProvider).call(this, props)); // nextjs / SSR: getting data from next.js or other ssr stack

    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* initSSR */])(props, true);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(I18nextProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          i18n = _this$props.i18n,
          defaultNS = _this$props.defaultNS,
          reportNS = _this$props.reportNS;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context__["a" /* I18nContext */].Provider, {
        value: {
          i18n: i18n,
          defaultNS: defaultNS,
          reportNS: reportNS,
          lng: i18n && i18n.language,
          t: i18n && i18n.t.bind(i18n)
        }
      }, children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InterpolateComponent */
/* unused harmony export Interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(141);









var InterpolateComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(InterpolateComponent, _Component);

  function InterpolateComponent(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, InterpolateComponent);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(InterpolateComponent).call(this, props));
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* deprecated */])('Interpolate is deprecated and will be removed in the next major version (v9.0.0). Usage can be replaced by the "Trans" component');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(InterpolateComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          t = _this$props.t,
          i18nKey = _this$props.i18nKey,
          options = _this$props.options,
          className = _this$props.className,
          style = _this$props.style;
      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || i18n.services.interpolator.regexp; // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, {}, options, {
        interpolation: {
          prefix: '#$?',
          suffix: '?$#'
        }
      });

      var format = t(i18nKey, tOpts);
      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('noscript', null);
      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) i18n.services.logger.warn("interpolator: missed to pass in variable ".concat(key, " for interpolating ").concat(format));
          return props[key];
        }

        var p = key.split(i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(i18n.options.interpolation.formatSeparator).trim();
        if (props[k] === undefined) i18n.services.logger.warn("interpolator: missed to pass in variable ".concat(k, " for interpolating ").concat(format));
        return i18n.options.interpolation.format(props[k], f, i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;

          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, {
              dangerouslySetInnerHTML: {
                __html: match
              }
            });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);
      var additionalProps = {};

      if (i18n.options.react && i18n.options.react.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];

        if (i18nKey && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }

        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({
          ns: ns
        });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return InterpolateComponent;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
var Interpolate = Object(__WEBPACK_IMPORTED_MODULE_7__context__["e" /* withI18n */])()(InterpolateComponent);

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_toArray__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1764);












var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Logger);

    this.init(concreteLogger, options);
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventEmitter);

    this.observers = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  } // Fallback to default values


  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ResourceStore);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Translator);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null
      /* || keys === ''*/
      ) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy$$1[m] = this.translate(deepKey, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy$$1;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          interpolation: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for namespace \"").concat(usedNS, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = baseLogger.create('languageUtils');
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }
  /* eslint no-param-reassign: 0 */


  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        str = str.replace(match[0], regexSafe(value));
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var _temp = missingInterpolationHandler(str, match, options);

            value = typeof _temp === 'string' ? _temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

      delete clonedOptions.defaultValue; // assert we do not get a endless loop on interpolating defaultValue again and again
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        } // assert we do not get a endless loop on interpolating defaultValue again and again


        delete clonedOptions.defaultValue;
        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        /**
         * If there is more than one parameter (contains the format separator). E.g.:
         *   - t(a, b)
         *   - t(a, b, c)
         *
         * And those parameters are not dynamic values (parameters do not include curly braces). E.g.:
         *   - Not t(a, { "key": "{{variable}}" })
         *   - Not t(a, b, {"keyA": "valueA", "keyB": "valueB"})
         */

        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var _match$1$split$map = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });

          var _match$1$split$map2 = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_toArray__["a" /* default */])(_match$1$split$map);

          match[1] = _match$1$split$map2[0];
          formatters = _match$1$split$map2.slice(1);
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Connector);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" for namespace \"").concat(namespace, "\" as the namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      } // ignore non valid keys


      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    postProcessPassResolved: false,
    // pass resolved object into 'options.i18nResolved' for postprocessor
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: false,
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[2]) === 'object' || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, I18n);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(_this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (!this.modules.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1]; // we're in cimode so this shall pass

      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      }; // loaded -> SUCCESS


      if (this.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

      if (!this.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ __webpack_exports__["a"] = (i18next);


/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(1753);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(240);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(1759);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(1762);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(559);



function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(559);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports = {"dashboard":"Dashboard","documentManagement":"Document management"}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports = {"dashboard":"Bord","documentManagement":"Gestionarea Documentelor"}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"AdminHeader__header__3DY0Q","headerTop":"AdminHeader__headerTop__3KJ8h","headerProfile":"AdminHeader__headerProfile__2zU2y","headerTopLink":"AdminHeader__headerTopLink__2CGfW","active":"AdminHeader__active__1bqNr","headerTopLinkIcon":"AdminHeader__headerTopLinkIcon__1Te68","headerProfileLogo":"AdminHeader__headerProfileLogo__23due","headerProfileLinksWrapper":"AdminHeader__headerProfileLinksWrapper__3IynO","headerProfileLink":"AdminHeader__headerProfileLink__3Kpw5","headerProfileLinkRed":"AdminHeader__headerProfileLinkRed__2YvJ_","headerProfileLinksLeft":"AdminHeader__headerProfileLinksLeft__2QBs2","headerMenu":"AdminHeader__headerMenu__2Rni8","headerMenuItem":"AdminHeader__headerMenuItem__FtesC","headerMenuItemActive":"AdminHeader__headerMenuItemActive__htk5N","headerProfileUsername":"AdminHeader__headerProfileUsername__29-sh"};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/act_quicr_logo_red_white.1d4f7cf2.png";

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"AdminDashboard__content__2U5xS","parentContainer":"AdminDashboard__parentContainer__2vSpM","wrapper":"AdminDashboard__wrapper__1q4Gz","viewIcon":"AdminDashboard__viewIcon__2lN_N","selectClear":"AdminDashboard__selectClear__2qmUN"};

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_sortBy__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_PatientProfileForm_PatientProfileForm__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_PatientProfileForm_PatientConsentGivenForm__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_PatientProfileForm_PatientAdjudicatedConsentStatusForm__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__PatientProfile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_PatientProfileForm_PatientRegistryForm__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_PatientProfileForm_PatientEmailStatusForm__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_PatientProfileForm_PatientCoenrollmentForm__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_FileLink_FileLink__ = __webpack_require__(104);























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default.a.Search;var PatientProfile = function (_React$Component) {
  _inherits(PatientProfile, _React$Component);function PatientProfile(props) {
    var _this2 = this;_classCallCheck(this, PatientProfile);var _this = _possibleConstructorReturn(this, (PatientProfile.__proto__ || Object.getPrototypeOf(PatientProfile)).call(this, props));_this.onSubjectSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        var _ref2, data;return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                if (!value.trim()) {
                  _context.next = 17;break;
                }_this.setState({ subjectID: value, errorMessage: null, isLoading: true, responseMessage: null, subject: null });_context.prev = 2;_context.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["_21" /* getSubjectRequest */])(value);case 5:
                _ref2 = _context.sent;data = _ref2.data;_this.setState({ subject: Object.assign({}, data, { profile: data.profile ? Object.assign({}, data.profile) : null }) });_context.next = 16;break;case 10:
                _context.prev = 10;_context.t0 = _context["catch"](2);if (!(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, "response.status") === 401)) {
                  _context.next = 15;break;
                }_this.props.logout();return _context.abrupt("return");case 15:
                _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, "response.data.error", "Error") });case 16:
                _this.setState({ isLoading: false });case 17:case "end":
                return _context.stop();}
          }
        }, _callee, _this2, [[2, 10]]);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.onProfileDelete = function () {
      _this.setState({ subject: null, responseMessage: "Successfully deactivated" });
    };_this.onSubjectChange = function (e) {
      _this.setState({ subjectSearch: e.target.value });
    };_this.collapseSection = function (sectionName) {
      return function () {
        _this.setState(function (state) {
          return _defineProperty({}, sectionName, !state[sectionName]);
        });
      };
    };_this.addDocument = function () {
      _this.setState({ documentEdit: {} });
    };_this.onDocumentEdit = function (document) {
      return function () {
        _this.setState({ documentEdit: document });
      };
    };_this.onDocumentEditHide = function () {
      _this.setState({ documentEdit: null });
    };_this.onDocumentEditSubmit = function () {
      _this.setState({ documentEdit: null }, function () {
        return _this.fetchCurrentSubject({ withLoading: false });
      });
    };_this.onSwitchDocumentActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;if (!(state === "active")) {
                  _context2.next = 6;break;
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["K" /* deletePatientProfileDocumentRequest */])(id);case 4:
                _context2.next = 8;break;case 6:
                _context2.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["e" /* activatePatientProfileDocumentRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("Saved");_this.fetchCurrentSubject({ withLoading: false });_context2.next = 19;break;case 12:
                _context2.prev = 12;_context2.t0 = _context2["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context2.t0, "response.status") === 401)) {
                  _context2.next = 17;break;
                }_this.props.logout();return _context2.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("Error");console.log(_context2.t0);case 19:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 12]]);
      }));
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' });
    };_this.state = { subject: null, subjectSearch: null, subjectID: null, errorMessage: null, responseMessage: null, isLoading: false, showRegistryForm: false, showEmailStatusForm: false, showConsentGivenForm: false, showAdjudicatedConsentStatusForm: false, showDocumentsSection: false, showCoenrollmentForm: false, documentEdit: null, order: null, sortedInfo: { columnKey: 'order_index', order: null } };return _this;
  }_createClass(PatientProfile, [{ key: "componentDidMount", value: function componentDidMount() {
      this.fetchCurrentSubject();
    } }, { key: "fetchCurrentSubject", value: function fetchCurrentSubject() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$withLoading = _ref5.withLoading,
          withLoading = _ref5$withLoading === undefined ? true : _ref5$withLoading;var subjectID = __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, "match.params.subjectID");if (subjectID) {
        this.onSubjectSearch(subjectID, { withLoading: withLoading });this.setState({ subjectSearch: subjectID });
      }
    } }, { key: "documentColumns", value: function documentColumns() {
      var _this3 = this;return [{ dataIndex: "order_index", key: "order_index", title: "Index", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", null, val);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.state.sortedInfo, 'columnKey') === 'order_index' && this.state.sortedInfo.order }, { dataIndex: "name", key: "name", title: "Document Name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, val);
        } }, { dataIndex: "category", key: "category", title: "Document Category", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, "Patient documents");
        } }, { dataIndex: "type", key: "type", title: "Document Type", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["b" /* documentTypes */][val]);
        } }, { dataIndex: "start_year", key: "start_year", title: "Start date" }, { dataIndex: "expiry_year", key: "expiry_year", title: "Expiry date" }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { style: { position: 'relative', top: '8px' } }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_FileLink_FileLink__["a" /* default */], { url: document.url })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Edit Document" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "edit", theme: "filled", onClick: _this3.onDocumentEdit(document) })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Activate / Deactivate Document" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a, { checked: document.state === "active", onChange: _this3.onSwitchDocumentActivation(val, document.state) })));
        } }];
    } }, { key: "render", value: function render() {
      var _state = this.state,
          subject = _state.subject,
          subjectID = _state.subjectID,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          subjectSearch = _state.subjectSearch,
          showRegistryForm = _state.showRegistryForm,
          showEmailStatusForm = _state.showEmailStatusForm,
          showConsentGivenForm = _state.showConsentGivenForm,
          showAdjudicatedConsentStatusForm = _state.showAdjudicatedConsentStatusForm,
          showDocumentsSection = _state.showDocumentsSection,
          showCoenrollmentForm = _state.showCoenrollmentForm,
          documentEdit = _state.documentEdit,
          order = _state.order;var _props = this.props,
          patientProfileReadPermission = _props.patientProfileReadPermission,
          patientDocumentCreatePermission = _props.patientDocumentCreatePermission,
          consentGivenUpdatePermission = _props.consentGivenUpdatePermission;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h3", { className: "headline-default" }, "Patient profile"), !patientProfileReadPermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: "error", message: "Permission denied! You cannot perform this action." }), patientProfileReadPermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.searchWrapperLabel }, "SEARCH"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Search, { placeholder: "By subject ID", enterButton: "Search", size: "large", onSearch: this.onSubjectSearch, value: subjectSearch, onChange: this.onSubjectChange, style: { maxWidth: "500px" } }))), errorMessage && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: "error", message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: "success", message: responseMessage }), subject && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showEmailStatusForm") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showEmailStatusForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showEmailStatusForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Consent - Email status")), showEmailStatusForm && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_PatientProfileForm_PatientEmailStatusForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch })))), subject && consentGivenUpdatePermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showConsentGivenForm") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showConsentGivenForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showConsentGivenForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Custom consent given")), showConsentGivenForm && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_PatientProfileForm_PatientConsentGivenForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch })))), subject && consentGivenUpdatePermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showAdjudicatedConsentStatusForm") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showAdjudicatedConsentStatusForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showAdjudicatedConsentStatusForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Adjudicated consent status")), showAdjudicatedConsentStatusForm && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_PatientProfileForm_PatientAdjudicatedConsentStatusForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch })))), subject && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showRegistryForm") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showRegistryForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showRegistryForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Edit registry")), showRegistryForm && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_PatientProfileForm_PatientRegistryForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch })))), subject && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showCoenrollmentForm") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showCoenrollmentForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showCoenrollmentForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Co-Enrollment")), showCoenrollmentForm && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__components_PatientProfileForm_PatientCoenrollmentForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch })))), subject && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_PatientProfileForm_PatientProfileForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onSubjectSearch, onProfileDelete: this.onProfileDelete })), subject && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.registryFormWrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_25_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleHeadline), onClick: this.collapseSection("showDocumentsSection") }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { title: showDocumentsSection ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showDocumentsSection ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_31__PatientProfile_css___default.a.toggleText }, "Documents")), showDocumentsSection && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, patientDocumentCreatePermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: "primary", onClick: this.addDocument }, "Add new document"), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a, { visible: !!documentEdit, onCancel: this.onDocumentEditHide, footer: null }, documentEdit && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["a" /* default */], Object.assign({}, documentEdit, { patient: subject, withPatient: true, isNew: documentEdit && !documentEdit.id, onSubmit: this.onDocumentEditSubmit, onCancel: this.onDocumentEditHide })))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(subject, "profile.documents") && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a, { columns: this.documentColumns(), onChange: this.handleTableChange, dataSource: __WEBPACK_IMPORTED_MODULE_23_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(subject, "profile.documents", []), function (item) {
          return order === 'asc' ? -item.order_index : item.order_index;
        }), loading: isLoading, rowKey: "id", pagination: false })))), isLoading && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "loading" }))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return PatientProfile;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { patientDocumentCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["_14" /* getPatientDocumentCreatePermission */])(state), patientProfileReadPermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["_18" /* getPatientProfileReadPermission */])(state), consentGivenUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["h" /* getConsentGivenUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_32__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_24_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(PatientProfile)));

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1773);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-modal {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 100px;\n  width: auto;\n  margin: 0 auto;\n  padding-bottom: 24px;\n  pointer-events: none;\n}\n.ant-modal-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  overflow: auto;\n  outline: 0;\n  -webkit-overflow-scrolling: touch;\n}\n.ant-modal-title {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  word-wrap: break-word;\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: auto;\n}\n.ant-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-modal-close-x {\n  display: block;\n  width: 56px;\n  height: 56px;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 56px;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 16px 24px;\n  color: #424242;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 4px 4px 0 0;\n}\n.ant-modal-body {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n.ant-modal-footer {\n  padding: 10px 16px;\n  text-align: right;\n  background: transparent;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 4px 4px;\n}\n.ant-modal-footer button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  transform: none;\n  opacity: 0;\n  animation-duration: 0.3s;\n  user-select: none;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n  filter: alpha(opacity=50);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n.ant-modal-centered {\n  text-align: center;\n}\n.ant-modal-centered::before {\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n  content: '';\n}\n.ant-modal-centered .ant-modal {\n  top: 0;\n  display: inline-block;\n  text-align: left;\n  vertical-align: middle;\n}\n@media (max-width: 767px) {\n  .ant-modal {\n    max-width: calc(100vw - 16px);\n    margin: 8px auto;\n  }\n  .ant-modal-centered .ant-modal {\n    flex: 1;\n  }\n}\n.ant-modal-confirm .ant-modal-header {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-close {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-body {\n  padding: 32px 32px 24px;\n}\n.ant-modal-confirm-body-wrapper {\n  zoom: 1;\n}\n.ant-modal-confirm-body-wrapper::before,\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  clear: both;\n}\n.ant-modal-confirm-body .ant-modal-confirm-title {\n  display: block;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.4;\n}\n.ant-modal-confirm-body .ant-modal-confirm-content {\n  margin-top: 8px;\n  color: #424242;\n  font-size: 14px;\n}\n.ant-modal-confirm-body > .anticon {\n  float: left;\n  margin-right: 16px;\n  font-size: 22px;\n}\n.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-left: 38px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns {\n  float: right;\n  margin-top: 24px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {\n  color: #f5222d;\n}\n.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,\n.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {\n  color: #faad14;\n}\n.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {\n  color: #1890ff;\n}\n.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {\n  color: #52c41a;\n}\n", ""]);

// exports


/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialog__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__ = __webpack_require__(1777);




// fix issue #10656
/*
* getContainer remarks
* Custom container should not be return, because in the Portal component, it will remove the
* return container element here, if the custom container is the only child of it's component,
* like issue #10656, It will has a conflict with removeChild method in react-dom.
* So here should add a child (div element) to custom container.
* */
/* harmony default export */ __webpack_exports__["default"] = (function (props) {
    var visible = props.visible,
        getContainer = props.getContainer,
        forceRender = props.forceRender;
    // 渲染在当前 dom 里；

    if (getContainer === false) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { getOpenCount: function getOpenCount() {
                return 2;
            } }));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__["a" /* default */], { visible: visible, forceRender: forceRender, getContainer: getContainer }, function (childProps) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, childProps));
    });
});

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__ = __webpack_require__(1776);










var uuid = 0;
/* eslint react/no-is-mounted:0 */
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

        _this.inTransition = false;
        _this.onAnimateLeave = function () {
            var afterClose = _this.props.afterClose;
            // need demo?
            // https://github.com/react-component/dialog/pull/28

            if (_this.wrap) {
                _this.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.switchScrollingEffect();
            if (afterClose) {
                afterClose();
            }
        };
        _this.onDialogMouseDown = function () {
            _this.dialogMouseDown = true;
        };
        _this.onMaskMouseUp = function () {
            if (_this.dialogMouseDown) {
                _this.timeoutId = setTimeout(function () {
                    _this.dialogMouseDown = false;
                }, 0);
            }
        };
        _this.onMaskClick = function (e) {
            // android trigger click on open (fastclick??)
            if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget && !_this.dialogMouseDown) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ESC) {
                e.stopPropagation();
                _this.close(e);
                return;
            }
            // keep focus inside dialog
            if (props.visible) {
                if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB) {
                    var activeElement = document.activeElement;
                    var sentinelStart = _this.sentinelStart;
                    if (e.shiftKey) {
                        if (activeElement === sentinelStart) {
                            _this.sentinelEnd.focus();
                        }
                    } else if (activeElement === _this.sentinelEnd) {
                        sentinelStart.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("button", { type: "button", onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", { className: prefixCls + '-close-x' }));
            }
            var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style, dest);
            var sentinelStyle = { width: 0, height: 0, overflow: 'hidden' };
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible, forceRender: props.forceRender, onMouseDown: _this.onDialogMouseDown }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelStart'), style: sentinelStyle, "aria-hidden": "true" }), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelEnd'), style: sentinelStyle, "aria-hidden": "true" }));
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
                onClose(e);
            }
        };
        _this.saveRef = function (name) {
            return function (node) {
                _this[name] = node;
            };
        };
        _this.titleId = 'rcDialogTitle' + uuid++;
        _this.switchScrollingEffect = props.switchScrollingEffect || function () {};
        return _this;
    }

    Dialog.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({});
        // if forceRender is true, set element style display to be none;
        if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
            this.wrap.style.display = 'none';
        }
    };

    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props,
            visible = _props.visible,
            mask = _props.mask,
            focusTriggerAfterClose = _props.focusTriggerAfterClose;

        var mousePosition = this.props.mousePosition;
        if (visible) {
            // first show
            if (!prevProps.visible) {
                this.openTime = Date.now();
                this.switchScrollingEffect();
                this.tryFocus();
                var dialogNode = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](this.dialog);
                if (mousePosition) {
                    var elOffset = offset(dialogNode);
                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                } else {
                    setTransformOrigin(dialogNode, '');
                }
            }
        } else if (prevProps.visible) {
            this.inTransition = true;
            if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
                try {
                    this.lastOutSideFocusNode.focus();
                } catch (e) {
                    this.lastOutSideFocusNode = null;
                }
                this.lastOutSideFocusNode = null;
            }
        }
    };

    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props2 = this.props,
            visible = _props2.visible,
            getOpenCount = _props2.getOpenCount;

        if ((visible || this.inTransition) && !getOpenCount()) {
            this.switchScrollingEffect();
        }
        clearTimeout(this.timeoutId);
    };

    Dialog.prototype.tryFocus = function tryFocus() {
        if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(this.wrap, document.activeElement)) {
            this.lastOutSideFocusNode = document.activeElement;
            this.sentinelStart.focus();
        }
    };

    Dialog.prototype.render = function render() {
        var props = this.props;
        var prefixCls = props.prefixCls,
            maskClosable = props.maskClosable;

        var style = this.getWrapStyle();
        // clear hide display
        // and only set display after async anim, not here for hide
        if (props.visible) {
            style.display = null;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-root' }, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : null, onMouseUp: maskClosable ? this.onMaskMouseUp : null, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
    };

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: 'rc-dialog',
    focusTriggerAfterClose: true
};

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);




var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        if (nextProps.forceRender) {
            return true;
        }
        return !!nextProps.hiddenClassName || !!nextProps.visible;
    };

    LazyRenderBox.prototype.render = function render() {
        var _a = this.props,
            className = _a.className,
            hiddenClassName = _a.hiddenClassName,
            visible = _a.visible,
            forceRender = _a.forceRender,
            restProps = __rest(_a, ["className", "hiddenClassName", "visible", "forceRender"]);
        var useClassName = className;
        if (!!hiddenClassName && !visible) {
            useClassName += " " + hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps, { className: useClassName }));
    };

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContainerRender__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Portal__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setStyle__ = __webpack_require__(561);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable no-underscore-dangle,react/require-default-props */








var openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_REACT_16 = 'createPortal' in __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a; // https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332

var cacheOverflow = {};

var PortalWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PortalWrapper, _React$Component);

  function PortalWrapper(props) {
    var _this;

    _classCallCheck(this, PortalWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PortalWrapper).call(this, props));

    _this.getParent = function () {
      var getContainer = _this.props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }

        if (typeof getContainer === 'function') {
          return getContainer();
        }

        if (_typeof(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }

      return document.body;
    };

    _this.getContainer = function () {
      if (windowIsUndefined) {
        return null;
      }

      if (!_this.container) {
        _this.container = document.createElement('div');

        var parent = _this.getParent();

        if (parent) {
          parent.appendChild(_this.container);
        }
      }

      _this.setWrapperClassName();

      return _this.container;
    };

    _this.setWrapperClassName = function () {
      var wrapperClassName = _this.props.wrapperClassName;

      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    };

    _this.savePortal = function (c) {
      // Warning: don't rename _component
      // https://github.com/react-component/util/pull/65#discussion_r352407916
      _this._component = c;
    };

    _this.removeCurrentContainer = function (visible) {
      _this.container = null;
      _this._component = null;

      if (!IS_REACT_16) {
        if (visible) {
          _this.renderComponent({
            afterClose: _this.removeContainer,
            onClose: function onClose() {},
            visible: false
          });
        } else {
          _this.removeContainer();
        }
      }
    };

    _this.switchScrollingEffect = function () {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        Object(__WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__["a" /* default */])(); // Must be set after switchScrollingEffect

        cacheOverflow = Object(__WEBPACK_IMPORTED_MODULE_7__setStyle__["a" /* default */])({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!openCount) {
        Object(__WEBPACK_IMPORTED_MODULE_7__setStyle__["a" /* default */])(cacheOverflow);
        cacheOverflow = {};
        Object(__WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__["a" /* default */])(true);
      }
    };

    var _visible = props.visible;
    openCount = _visible ? openCount + 1 : openCount;
    _this.state = {
      _self: _assertThisInitialized(_this)
    };
    return _this;
  }

  _createClass(PortalWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setWrapperClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var visible = this.props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。

      openCount = visible && openCount ? openCount - 1 : openCount;
      this.removeCurrentContainer(visible);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          forceRender = _this$props.forceRender,
          visible = _this$props.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect
      }; // suppport react15

      if (!IS_REACT_16) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContainerRender__["a" /* default */], {
          parent: this,
          visible: visible,
          autoDestroy: false,
          getComponent: function getComponent() {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return children(_objectSpread({}, extra, {}, childProps, {
              ref: _this2.savePortal
            }));
          },
          getContainer: this.getContainer,
          forceRender: forceRender
        }, function (_ref) {
          var renderComponent = _ref.renderComponent,
              removeContainer = _ref.removeContainer;
          _this2.renderComponent = renderComponent;
          _this2.removeContainer = removeContainer;
          return null;
        });
      }

      if (forceRender || visible || this._component) {
        portal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Portal__["a" /* default */], {
          getContainer: this.getContainer,
          ref: this.savePortal
        }, children(childProps));
      }

      return portal;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps,
          _self = _ref2._self;
      var visible = props.visible,
          getContainer = props.getContainer;

      if (prevProps) {
        var prevVisible = prevProps.visible,
            prevGetContainer = prevProps.getContainer;

        if (visible !== prevVisible) {
          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
        }

        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';

        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
          _self.removeCurrentContainer(false);
        }
      }

      return {
        prevProps: props
      };
    }
  }]);

  return PortalWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWrapper.propTypes = {
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(PortalWrapper));

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setStyle__ = __webpack_require__(561);



function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

var cacheStyle = {};
/* harmony default export */ __webpack_exports__["a"] = (function (close) {
  if (!isBodyOverflowing() && !close) {
    return;
  } // https://github.com/ant-design/ant-design/issues/19729


  var scrollingEffectClassName = 'ant-scrolling-effect';
  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
  var bodyClassName = document.body.className;

  if (close) {
    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])(cacheStyle);
    cacheStyle = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
    return;
  }

  var scrollBarSize = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__["a" /* default */])();

  if (scrollBarSize) {
    cacheStyle = Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])({
      position: 'relative',
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });

    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
      document.body.className = addClassName.trim();
    }
  }
});

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarSize;
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = confirm;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _Modal = _interopRequireWildcard(__webpack_require__(560));

var _ActionButton = _interopRequireDefault(__webpack_require__(1781));

var _locale = __webpack_require__(269);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IS_REACT_16 = !!ReactDOM.createPortal;

var ConfirmDialog = function ConfirmDialog(props) {
  var onCancel = props.onCancel,
      onOk = props.onOk,
      close = props.close,
      zIndex = props.zIndex,
      afterClose = props.afterClose,
      visible = props.visible,
      keyboard = props.keyboard,
      centered = props.centered,
      getContainer = props.getContainer,
      maskStyle = props.maskStyle,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps,
      _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon

  var icon = props.icon === undefined ? iconType : props.icon;
  var okType = props.okType || 'primary';
  var prefixCls = props.prefixCls || 'ant-modal';
  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

  var okCancel = 'okCancel' in props ? props.okCancel : true;
  var width = props.width || 416;
  var style = props.style || {};
  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为

  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  var runtimeLocale = (0, _locale.getConfirmLocale)();
  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
  var cancelText = props.cancelText || runtimeLocale.cancelText;
  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  var transitionName = props.transitionName || 'zoom';
  var maskTransitionName = props.maskTransitionName || 'fade';
  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
  var cancelButton = okCancel && React.createElement(_ActionButton["default"], {
    actionFn: onCancel,
    closeModal: close,
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps
  }, cancelText);
  var iconNode = typeof icon === 'string' ? React.createElement(_icon["default"], {
    type: icon
  }) : icon;
  return React.createElement(_Modal["default"], {
    prefixCls: prefixCls,
    className: classString,
    wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
    onCancel: function onCancel() {
      return close({
        triggerCancel: true
      });
    },
    visible: visible,
    title: "",
    transitionName: transitionName,
    footer: "",
    maskTransitionName: maskTransitionName,
    mask: mask,
    maskClosable: maskClosable,
    maskStyle: maskStyle,
    style: style,
    width: width,
    zIndex: zIndex,
    afterClose: afterClose,
    keyboard: keyboard,
    centered: centered,
    getContainer: getContainer
  }, React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body-wrapper")
  }, React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body")
  }, iconNode, props.title === undefined ? null : React.createElement("span", {
    className: "".concat(contentPrefixCls, "-title")
  }, props.title), React.createElement("div", {
    className: "".concat(contentPrefixCls, "-content")
  }, props.content)), React.createElement("div", {
    className: "".concat(contentPrefixCls, "-btns")
  }, cancelButton, React.createElement(_ActionButton["default"], {
    type: okType,
    actionFn: onOk,
    closeModal: close,
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps
  }, okText))));
};

function confirm(config) {
  var div = document.createElement('div');
  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define

  var currentConfig = _extends(_extends({}, config), {
    close: close,
    visible: true
  });

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < _Modal.destroyFns.length; i++) {
      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define

      if (fn === close) {
        _Modal.destroyFns.splice(i, 1);

        break;
      }
    }
  }

  function render(props) {
    ReactDOM.render(React.createElement(ConfirmDialog, props), div);
  }

  function close() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    currentConfig = _extends(_extends({}, currentConfig), {
      visible: false,
      afterClose: destroy.bind.apply(destroy, [this].concat(args))
    });

    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy.apply(void 0, args);
    }
  }

  function update(newConfig) {
    currentConfig = _extends(_extends({}, currentConfig), newConfig);
    render(currentConfig);
  }

  render(currentConfig);

  _Modal.destroyFns.push(close);

  return {
    destroy: close,
    update: update
  };
}
//# sourceMappingURL=confirm.js.map


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var _button = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ActionButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActionButton, _React$Component);

  function ActionButton(props) {
    var _this;

    _classCallCheck(this, ActionButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionButton).call(this, props));

    _this.onClick = function () {
      var _this$props = _this.props,
          actionFn = _this$props.actionFn,
          closeModal = _this$props.closeModal;

      if (actionFn) {
        var ret;

        if (actionFn.length) {
          ret = actionFn(closeModal);
        } else {
          ret = actionFn();

          if (!ret) {
            closeModal();
          }
        }

        if (ret && ret.then) {
          _this.setState({
            loading: true
          });

          ret.then(function () {
            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
            // this.setState({ loading: false });
            closeModal.apply(void 0, arguments);
          }, function (e) {
            // Emit error when catch promise reject
            // eslint-disable-next-line no-console
            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183

            _this.setState({
              loading: false
            });
          });
        }
      } else {
        closeModal();
      }
    };

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(ActionButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        var $this = ReactDOM.findDOMNode(this);
        this.timeoutId = setTimeout(function () {
          return $this.focus();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          children = _this$props2.children,
          buttonProps = _this$props2.buttonProps;
      var loading = this.state.loading;
      return React.createElement(_button["default"], _extends({
        type: type,
        onClick: this.onClick,
        loading: loading
      }, buttonProps), children);
    }
  }]);

  return ActionButton;
}(React.Component);

exports["default"] = ActionButton;
//# sourceMappingURL=ActionButton.js.map


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1783);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-switch {\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  min-width: 44px;\n  height: 22px;\n  line-height: 20px;\n  vertical-align: middle;\n  background-color: rgba(0, 0, 0, 0.25);\n  border: 1px solid transparent;\n  border-radius: 100px;\n  cursor: pointer;\n  transition: all 0.36s;\n  user-select: none;\n}\n.ant-switch-inner {\n  display: block;\n  margin-right: 6px;\n  margin-left: 24px;\n  color: #fff;\n  font-size: 12px;\n}\n.ant-switch-loading-icon,\n.ant-switch::after {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  content: ' ';\n}\n.ant-switch::after {\n  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);\n}\n.ant-switch:not(.ant-switch-disabled):active::before,\n.ant-switch:not(.ant-switch-disabled):active::after {\n  width: 24px;\n}\n.ant-switch-loading-icon {\n  z-index: 1;\n  display: none;\n  font-size: 12px;\n  background: transparent;\n}\n.ant-switch-loading-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-switch-loading .ant-switch-loading-icon {\n  display: inline-block;\n  color: #424242;\n}\n.ant-switch-checked.ant-switch-loading .ant-switch-loading-icon {\n  color: #4CDEF5;\n}\n.ant-switch:focus {\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-switch:focus:hover {\n  box-shadow: none;\n}\n.ant-switch-small {\n  min-width: 28px;\n  height: 16px;\n  line-height: 14px;\n}\n.ant-switch-small .ant-switch-inner {\n  margin-right: 3px;\n  margin-left: 18px;\n  font-size: 12px;\n}\n.ant-switch-small::after {\n  width: 12px;\n  height: 12px;\n}\n.ant-switch-small:active::before,\n.ant-switch-small:active::after {\n  width: 16px;\n}\n.ant-switch-small .ant-switch-loading-icon {\n  width: 12px;\n  height: 12px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-inner {\n  margin-right: 18px;\n  margin-left: 3px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-loading-icon {\n  left: 100%;\n  margin-left: -13px;\n}\n.ant-switch-small.ant-switch-loading .ant-switch-loading-icon {\n  font-weight: bold;\n  transform: scale(0.66667);\n}\n.ant-switch-checked {\n  background-color: #4CDEF5;\n}\n.ant-switch-checked .ant-switch-inner {\n  margin-right: 24px;\n  margin-left: 6px;\n}\n.ant-switch-checked::after {\n  left: 100%;\n  margin-left: -1px;\n  transform: translateX(-100%);\n}\n.ant-switch-checked .ant-switch-loading-icon {\n  left: 100%;\n  margin-left: -19px;\n}\n.ant-switch-loading,\n.ant-switch-disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.ant-switch-loading *,\n.ant-switch-disabled * {\n  cursor: not-allowed;\n}\n.ant-switch-loading::before,\n.ant-switch-disabled::before,\n.ant-switch-loading::after,\n.ant-switch-disabled::after {\n  cursor: not-allowed;\n}\n@keyframes AntSwitchSmallLoadingCircle {\n  0% {\n    transform: rotate(0deg) scale(0.66667);\n    transform-origin: 50% 50%;\n  }\n  100% {\n    transform: rotate(360deg) scale(0.66667);\n    transform-origin: 50% 50%;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1785);

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__ = __webpack_require__(38);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var classNames = __webpack_require__(5);

var Switch =
/*#__PURE__*/
function (_Component) {
  _inherits(Switch, _Component);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e) {
      var checked = _this.state.checked;
      var onClick = _this.props.onClick;
      var newChecked = !checked;

      _this.setChecked(newChecked, e);

      if (onClick) {
        onClick(newChecked, e);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (e) {
      if (e.keyCode === 37) {
        // Left
        _this.setChecked(false, e);
      } else if (e.keyCode === 39) {
        // Right
        _this.setChecked(true, e);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseUp", function (e) {
      var onMouseUp = _this.props.onMouseUp;

      if (_this.node) {
        _this.node.blur();
      }

      if (onMouseUp) {
        onMouseUp(e);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "saveNode", function (node) {
      _this.node = node;
    });

    var _checked = false;

    if ('checked' in props) {
      _checked = !!props.checked;
    } else {
      _checked = !!props.defaultChecked;
    }

    _this.state = {
      checked: _checked
    };
    return _this;
  }

  _createClass(Switch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: "setChecked",
    value: function setChecked(checked, e) {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange;

      if (disabled) {
        return;
      }

      if (!('checked' in this.props)) {
        this.setState({
          checked: checked
        });
      }

      if (onChange) {
        onChange(checked, e);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.node.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.node.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          className = _this$props3.className,
          prefixCls = _this$props3.prefixCls,
          disabled = _this$props3.disabled,
          loadingIcon = _this$props3.loadingIcon,
          checkedChildren = _this$props3.checkedChildren,
          unCheckedChildren = _this$props3.unCheckedChildren,
          restProps = _objectWithoutProperties(_this$props3, ["className", "prefixCls", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren"]);

      var checked = this.state.checked;
      var switchClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", _extends({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        className: switchClassName,
        ref: this.saveNode,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        onMouseUp: this.handleMouseUp
      }), loadingIcon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }, checked ? checkedChildren : unCheckedChildren));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};
      var checked = nextProps.checked;

      if ('checked' in nextProps) {
        newState.checked = !!checked;
      }

      return newState;
    }
  }]);

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Switch.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkedChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  unCheckedChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loadingIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
Switch.defaultProps = {
  prefixCls: 'rc-switch',
  checkedChildren: null,
  unCheckedChildren: null,
  className: '',
  defaultChecked: false
};
Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__["polyfill"])(Switch);
/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(121),
    baseGet = __webpack_require__(152),
    baseIteratee = __webpack_require__(157),
    baseMap = __webpack_require__(563),
    baseSortBy = __webpack_require__(1792),
    baseUnary = __webpack_require__(156),
    compareMultiple = __webpack_require__(1793),
    identity = __webpack_require__(186),
    isArray = __webpack_require__(79);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1788),
    createBaseEach = __webpack_require__(1791);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1789),
    keys = __webpack_require__(124);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1790);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1790 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(109);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1792 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1794);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(153);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(182),
    isArrayLike = __webpack_require__(109),
    isIndex = __webpack_require__(184),
    isObject = __webpack_require__(89);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__FileLink_FileLink__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_url__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css__);



































var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var MonthPicker = __WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker___default.a.MonthPicker;var Option = __WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var emailRegex = new RegExp(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);var EventMessage = function (_React$Component) {
  _inherits(EventMessage, _React$Component);function EventMessage() {
    _classCallCheck(this, EventMessage);return _possibleConstructorReturn(this, (EventMessage.__proto__ || Object.getPrototypeOf(EventMessage)).apply(this, arguments));
  }_createClass(EventMessage, [{ key: "renderMessagePart", value: function renderMessagePart(messagePart) {
      if (emailRegex.test(messagePart)) {
        return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("a", { href: "mailto:" + messagePart, target: "_blank" }, messagePart);
      }return messagePart;
    } }, { key: "render", value: function render() {
      var _this2 = this;return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("span", null, this.props.message.split(emailRegex).map(function (messagePart, index) {
        return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react___default.a.Fragment, { key: index }, _this2.renderMessagePart(messagePart));
      }));
    } }]);return EventMessage;
}(__WEBPACK_IMPORTED_MODULE_33_react___default.a.Component);var PatientProfileForm = function (_React$Component2) {
  _inherits(PatientProfileForm, _React$Component2);function PatientProfileForm(props) {
    var _this4 = this;_classCallCheck(this, PatientProfileForm);var _this3 = _possibleConstructorReturn(this, (PatientProfileForm.__proto__ || Object.getPrototypeOf(PatientProfileForm)).call(this, props));_this3.handleSubmit = function (e) {
      e.preventDefault();_this3.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var getFieldValue, _this3$props, profile, patientProfileCreatePermission, patientProfileUpdatePermission, patientAge, ageFromDate, _profile, errors;return __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  getFieldValue = _this3.props.form.getFieldValue;_this3$props = _this3.props, profile = _this3$props.profile, patientProfileCreatePermission = _this3$props.patientProfileCreatePermission, patientProfileUpdatePermission = _this3$props.patientProfileUpdatePermission;_this3.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _this3.setState({ saveError: "Error" });setTimeout(function () {
                      _this3.setState({ saveError: null });
                    }, 2000);
                  }if (!(!err && (patientProfileCreatePermission && !profile || patientProfileUpdatePermission && profile))) {
                    _context.next = 47;break;
                  }patientAge = profile.age;if (!_this3.state.patientAgeFromServer || !patientAge) {
                    ageFromDate = _this3.props.randomization_date ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(_this3.props.randomization_date) : profile.created ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(profile.created) : __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()();patientAge = getFieldValue("birthdate_month") && getFieldValue("birthdate") ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(ageFromDate).diff(getFieldValue("birthdate") + "-" + getFieldValue("birthdate_month"), "years") : null;
                  }if (!((patientAge > 100 || patientAge < 18) && !_this3.state.confirmSubmitModal)) {
                    _context.next = 10;break;
                  }_this3.showConfirmModal();return _context.abrupt("return");case 10:
                  _this3.setState({ isLoading: true });_context.prev = 11;_profile = Object.assign({}, values);if (values.birthdate && values.birthdate_month) {
                    _profile.birthdate = __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(getFieldValue("birthdate") + "-" + getFieldValue("birthdate_month")).format("YYYY-MM-DD");
                  }if (values.death_date) {
                    _profile.death_date = __WEBPACK_IMPORTED_MODULE_37_lodash_cloneDeep___default()(values.death_date).utc().format("YYYY-MM-DDTHH:mm");
                  }_profile.is_consent_given = values.is_consent_given === "true";_profile.is_deceased = values.is_deceased === "true";_profile.is_subject_verified = values.is_subject_verified === true;_profile.is_randomization_verified = values.is_randomization_verified === true;_profile.age = patientAge;_profile.contact_2_phone_number_type = _profile.contact_2_phone_number_type || undefined;_profile.contact_1_relationship_type = _profile.contact_1_relationship_type || undefined;_profile.contact_1_phone_number_type = _profile.contact_1_phone_number_type || undefined;_profile.contact_1_email = _profile.contact_1_email || null;_profile.contact_2_relationship_type = _profile.contact_2_relationship_type || undefined;_profile.contact_2_email = _profile.contact_2_email || undefined;_profile.randomizationDate = undefined;_profile.subjectId = undefined;_profile.birthdate_month = undefined;if (!_this3.props.profile) {
                    _context.next = 34;break;
                  }_context.next = 32;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["_72" /* updateSubjectRequest */])(_this3.props.subjectID, _profile);case 32:
                  _context.next = 36;break;case 34:
                  _context.next = 36;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["B" /* createSubjectRequest */])(_this3.props.subjectID, _profile);case 36:
                  _this3.setState({ requestResult: { isLoading: false, type: "success", message: "Success" } });setTimeout(function () {
                    _this3.hideConfirmModal();_this3.props.onSubmit(_this3.props.subjectID);
                  }, 1500);_context.next = 47;break;case 40:
                  _context.prev = 40;_context.t0 = _context["catch"](11);if (!(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 45;break;
                  }_this3.props.logout();return _context.abrupt("return");case 45:
                  _this3.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this3.props.form.setFields(errors);
                  }case 47:case "end":
                  return _context.stop();}
            }
          }, _callee, _this4, [[11, 40]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this3.showDeleteModal = function () {
      _this3.setState({ deleteSubmitModal: true });
    };_this3.hideDeleteModal = function () {
      _this3.setState({ deleteSubmitModal: false });
    };_this3.showConfirmModal = function () {
      _this3.setState({ confirmSubmitModal: true });
    };_this3.hideConfirmModal = function () {
      _this3.setState({ confirmSubmitModal: false });
    };_this3.showActivateModal = function () {
      _this3.setState({ activateSubmitModal: true });
    };_this3.hideActivateModal = function () {
      _this3.setState({ activateSubmitModal: false });
    };_this3.submitDeletePatient = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var patientProfileDeletePermission;return __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              patientProfileDeletePermission = _this3.props.patientProfileDeletePermission;if (!patientProfileDeletePermission) {
                _context2.next = 11;break;
              }_context2.prev = 2;_context2.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["Q" /* deleteSubjectRequest */])(_this3.props.subjectID);case 5:
              _this3.props.onProfileDelete();_context2.next = 11;break;case 8:
              _context2.prev = 8;_context2.t0 = _context2["catch"](2);if (__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context2.t0, "response.status") === 401) {
                _this3.props.logout();
              }case 11:case "end":
              return _context2.stop();}
        }
      }, _callee2, _this4, [[2, 8]]);
    }));_this3.scrollUp = function () {
      window.scrollTo(0, 0);
    };_this3.togglePreviewEvents = function (eventName) {
      return function () {
        _this3.setState(function (state) {
          var eventStatus = state.previewEvents[eventName] ? false : true;return { previewEvents: Object.assign({}, state.previewEvents, _defineProperty({}, eventName, eventStatus)) };
        });
      };
    };_this3.collapseSection = function (sectionName) {
      return function () {
        _this3.setState(function (state) {
          return _defineProperty({}, sectionName, !state[sectionName]);
        });
      };
    };_this3.activateSubject = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var patientProfileDeletePermission;return __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              patientProfileDeletePermission = _this3.props.patientProfileDeletePermission;if (!patientProfileDeletePermission) {
                _context3.next = 11;break;
              }_context3.prev = 2;_context3.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["j" /* activateSubjectRequest */])(_this3.props.subjectID);case 5:
              _this3.props.onSubmit(_this3.props.subjectID);_context3.next = 11;break;case 8:
              _context3.prev = 8;_context3.t0 = _context3["catch"](2);if (__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context3.t0, "response.status") === 401) {
                _this3.props.logout();
              }case 11:case "end":
              return _context3.stop();}
        }
      }, _callee3, _this4, [[2, 8]]);
    }));_this3.handleBDateChange = function () {
      _this3.setState({ patientAgeFromServer: false });
    };_this3.onSwitchLock = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_32_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {case 0:
              _context4.prev = 0;if (!_this3.state.locked) {
                _context4.next = 7;break;
              }_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["_53" /* unlockSubjectRequest */])(_this3.props.subjectID);case 4:
              _this3.setState({ locked: false });_context4.next = 10;break;case 7:
              _context4.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_41__api_requests__["_28" /* lockSubjectRequest */])(_this3.props.subjectID);case 9:
              _this3.setState({ locked: true });case 10:
              __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.success("Saved");_context4.next = 16;break;case 13:
              _context4.prev = 13;_context4.t0 = _context4["catch"](0);__WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(_context4.t0, "response.data.error", "Error"));case 16:case "end":
              return _context4.stop();}
        }
      }, _callee4, _this4, [[0, 13]]);
    }));_this3.state = { isLoading: false, isSubmitted: false, requestResult: {}, deleteSubmitModal: false, activateSubmitModal: false, previewEvents: {}, showPatientForm: true, showPatientEventSummary: true, showRegistryForm: false, confirmSubmitModal: false, locked: false, saveError: null, patientAgeFromServer: true };return _this3;
  }_createClass(PatientProfileForm, [{ key: "componentDidMount", value: function componentDidMount() {
      this.setState({ locked: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props.profile, "locked") });if (this.props.profile && this.props.profile.age) {
        this.setState({ patientAgeFromServer: !!this.props.profile.age });
      }
    } }, { key: "componentDidUpdate", value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.subjectID !== this.props.subjectID) {
        this.setState({ requestResult: {}, locked: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.locked") });
      }
    } }, { key: "render", value: function render() {
      var _this5 = this;var _state = this.state,
          isLoading = _state.isLoading,
          isSubmitted = _state.isSubmitted,
          requestResult = _state.requestResult,
          deleteSubmitModal = _state.deleteSubmitModal,
          previewEvents = _state.previewEvents,
          showPatientForm = _state.showPatientForm,
          showRegistryForm = _state.showRegistryForm,
          showPatientEventSummary = _state.showPatientEventSummary,
          activateSubmitModal = _state.activateSubmitModal,
          confirmSubmitModal = _state.confirmSubmitModal,
          locked = _state.locked,
          saveError = _state.saveError;var _props = this.props,
          profile = _props.profile,
          patientProfileCreatePermission = _props.patientProfileCreatePermission,
          patientProfileUpdatePermission = _props.patientProfileUpdatePermission,
          patientProfileDeletePermission = _props.patientProfileDeletePermission,
          state = _props.state,
          patientProfileLockPermission = _props.patientProfileLockPermission,
          patientProfileUnlockPermission = _props.patientProfileUnlockPermission,
          patientProfileReadRestrictedPermission = _props.patientProfileReadRestrictedPermission;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldError = _props$form.getFieldError,
          isFieldTouched = _props$form.isFieldTouched,
          getFieldValue = _props$form.getFieldValue;var subjectIdError = (isFieldTouched("subjectId") || isSubmitted) && getFieldError("subjectId");var firstNameError = (isFieldTouched("first_name") || isSubmitted) && getFieldError("first_name");var lastNameError = (isFieldTouched("last_name") || isSubmitted) && getFieldError("last_name");var birthdateError = (isFieldTouched("birthdate") || isSubmitted) && getFieldError("birthdate");var phoneNumber1Error = (isFieldTouched("phone_number_1") || isSubmitted) && getFieldError("phone_number_1");var consentGivenError = (isFieldTouched("is_consent_given") || isSubmitted) && getFieldError("is_consent_given");var emailError = (isFieldTouched("email") || isSubmitted) && getFieldError("email");emailError = emailError ? emailError[0] === "email is required" ? emailError : ["Email looks wrong"] : null;var ageFromDate = this.props.randomization_date ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(this.props.randomization_date) : __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(profile, "created") ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(profile.created) : __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()();var patientAge = __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(profile, "age");if (!this.state.patientAgeFromServer || !patientAge) {
        patientAge = getFieldValue("birthdate") && getFieldValue("birthdate_month") && __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default()(ageFromDate).diff(getFieldValue("birthdate") + "-" + getFieldValue("birthdate_month"), "years");
      }var isEditable = patientProfileCreatePermission && !profile || patientProfileUpdatePermission && profile && !locked;if (state !== "active") {
        isEditable = false;
      }return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.patientProfileFormWrapper }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_35_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.toggleHeadline), onClick: this.collapseSection("showPatientForm") }, !patientProfileReadRestrictedPermission && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip___default.a, { title: showPatientForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showPatientForm ? "0" : "180deg") + ")" } }), "\xA0"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.toggleText }, this.props.subjectID), "\xA0", __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: profile ? "Edit" : "New", style: { backgroundColor: "#2968AE" } }), "\xA0", __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: state, style: { backgroundColor: state === "active" ? "#49c850" : "#f00" } }), "\xA0", profile && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: locked ? "Locked" : "Unlocked", style: { backgroundColor: locked ? "#f00" : "#49c850" } })), showPatientForm && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, !patientProfileReadRestrictedPermission && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Subject ID"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: subjectIdError ? "error" : "", help: subjectIdError || "" }, getFieldDecorator("subjectId", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "code", "") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: true })))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("is_subject_verified", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.is_subject_verified", false), valuePropName: "checked" })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default.a, { disabled: !isEditable }, "Verified?"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Randomization Date"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { style: { display: "flex", alignItems: "center" } }, getFieldDecorator("randomizationDate", { initialValue: this.props.randomization_date ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default.a.utc(this.props.randomization_date).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "site.time_zone") || "UTC") : null })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker___default.a, { format: "YYYY/MM/DD HH:mm", showTime: { format: "HH:mm" }, disabled: true })), "\xA0", this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "site.short_tz") || "UTC"))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("is_randomization_verified", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.is_randomization_verified", false), valuePropName: "checked" })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default.a, { disabled: !isEditable }, "Verified?")))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "First name*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: firstNameError ? "error" : "", help: firstNameError || "" }, getFieldDecorator("first_name", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.first_name", "") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Last name*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: lastNameError ? "error" : "", help: lastNameError || "" }, getFieldDecorator("last_name", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.last_name", "") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Email*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: emailError ? "error" : "", help: emailError || "" }, getFieldDecorator("email", { rules: [{ required: true, pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.email") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "email" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 3 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Birth year*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: birthdateError ? "error" : "", help: birthdateError || "" }, getFieldDecorator("birthdate", { rules: [{ required: true }], onChange: this.handleBDateChange, initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.birthdate") ? __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.birthdate").split("-") : "", "[0]") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, placeholder: "yyyy" }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 3 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Birth month*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("birthdate_month", { rules: [{ required: true, message: "Required" }], onChange: this.handleBDateChange, initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.birthdate") ? __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.birthdate").split("-") : "", "[1]") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "01" }, "January"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "02" }, "February"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "03" }, "March"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "04" }, "April"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "05" }, "May"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "06" }, "June"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "07" }, "July"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "08" }, "August"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "09" }, "September"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "10" }, "October"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "11" }, "November"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "12" }, "December")))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 2 }, !isNaN(patientAge) && patientAge !== undefined && patientAge < 130 && patientAge > 0 && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Age"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { style: { paddingTop: "10px" } }, patientAge)))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", { style: { flex: "0 0 120px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Phone number (1)*"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("phone_number_type_1", { rules: [{ required: false, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.phone_number_type_1", "home") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "home" }, "Home"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "cell" }, "Cell"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "work" }, "Work"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: phoneNumber1Error ? "error" : "", help: phoneNumber1Error || "" }, getFieldDecorator("phone_number_1", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.phone_number_1") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "tel" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", { style: { flex: "0 0 120px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Phone number (2)"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("phone_number_type_2", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.phone_number_type_2", "home") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "home" }, "Home"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "cell" }, "Cell"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "work" }, "Work"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("phone_number_2", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.phone_number_2", "") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "tel" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Consent given?"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { validateStatus: consentGivenError ? "error" : "", help: consentGivenError || "" }, getFieldDecorator("is_consent_given", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "has_consent_given", __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.is_consent_given" || "")).toString() })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: true }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "" }, "Select"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "false" }, "No"))))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Patient Deceased?"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("is_deceased", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.is_deceased", "").toString() })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Group, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a, { value: "false" }, "No"))))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, getFieldValue("is_deceased") === "true" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Decease date"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { style: { display: "flex", alignItems: "center" } }, getFieldDecorator("death_date", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.death_date") ? __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default.a.utc(this.props.profile.death_date).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "site.time_zone") || "UTC") : __WEBPACK_IMPORTED_MODULE_39_moment_timezone___default.a.utc(new Date()).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "site.time_zone") || "UTC") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_date_picker___default.a, { disabled: !isEditable, disabledDate: function disabledDate(currentDate) {
          return currentDate.diff(__WEBPACK_IMPORTED_MODULE_39_moment_timezone___default.a.now()) > 0;
        }, format: "YYYY/MM/DD HH:mm", placeholder: "yyyy-mm-dd HH:mm", showTime: { format: "HH:mm" } })), "\xA0", this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "site.short_tz") || "UTC"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Street address"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("street_address", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.street_address") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "City"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("city", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.city") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Province"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("province", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.province") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "" }, "Select"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "alberta" }, "Alberta"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "british_columbia" }, "British Columbia"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "manitoba" }, "Manitoba"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "new_brunswick" }, "New Brunswick"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "newfoundland_and_labrador" }, "Newfoundland and Labrador"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "nova_scotia" }, "Nova Scotia"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "ontario" }, "Ontario"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "prince_edward_island" }, "Prince Edward Island"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "quebec" }, "Quebec"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "saskatchewan" }, "Saskatchewan"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "northwest_territories" }, "Northwest Territories"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "nunavut" }, "Nunavut"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "Yukon" }, "Yukon"))))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Postal code"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("postal_code", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.postal_code") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h3", { className: "headline-default" }, "Additional contact information"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h4", { className: "headline-default" }, "Other contact (1)"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "First name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_first_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_first_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Last name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_last_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_last_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: getFieldValue("contact_1_relationship_type") === "other" ? 2 : 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Relationship"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_relationship_type", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_relationship_type") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "" }, "Select"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "spouse_partner" }, "Spouse/ Partner"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "daughter" }, "Daughter"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "son" }, "Son"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "mother" }, "Mother"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "father" }, "Father"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other")))))), getFieldValue("contact_1_relationship_type") === "other" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 4 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_relationship_type_value", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_relationship_type_value") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Phone number (1)"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", { style: { flex: "0 0 70px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_phone_number_type", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_phone_number_type", "home") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "home" }, "Home"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "cell" }, "Cell"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "work" }, "Work"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_phone_number", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_phone_number") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "tel" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Email"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_1_email", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_1_email") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h4", { className: "headline-default" }, "Other contact (2)"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "First name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_first_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_first_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Last name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_last_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_last_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: getFieldValue("contact_2_relationship_type") === "other" ? 2 : 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Relationship"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_relationship_type", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_relationship_type") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "" }, "Select"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "spouse_partner" }, "Spouse/ Partner"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "daughter" }, "Daughter"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "son" }, "Son"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "mother" }, "Mother"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "father" }, "Father"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other")))))), getFieldValue("contact_2_relationship_type") === "other" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 4 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "\xA0"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_relationship_type_value", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_relationship_type_value") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Phone number (2):"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", { style: { flex: "0 0 70px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_phone_number_type", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_phone_number_type", "") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "home" }, "Home"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "cell" }, "Cell"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "work" }, "Work"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_phone_number", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_phone_number") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "tel" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Email"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("contact_2_email", { rules: [{ type: "email" }], initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.contact_2_email") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h4", { className: "headline-default" }, "Family Doctor"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "First name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("family_doctor_first_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.family_doctor_first_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Last name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("family_doctor_last_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.family_doctor_last_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Clinic name"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("family_doctor_clinic_name", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.family_doctor_clinic_name") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Phone number (1)"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.fieldInline }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", { style: { flex: "0 0 70px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("family_doctor_phone_number_type", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.family_doctor_phone_number_type", "home") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "home" }, "Home"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "cell" }, "Cell"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "work" }, "Work"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(Option, { value: "other" }, "Other"))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("family_doctor_phone_number", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.family_doctor_phone_number") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, type: "tel" })))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Comments:"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("comments", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.comments") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea, { disabled: !isEditable, rows: "6" }))))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.formActions }, this.props.profile && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Lock / Unlock the Subject Profile" }, "Lock status: \xA0", __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_switch___default.a, { disabled: !patientProfileUnlockPermission && locked || !patientProfileLockPermission && !locked, checked: !locked, onChange: this.onSwitchLock })), patientProfileDeletePermission && isEditable && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.deleteButton, onClick: this.showDeleteModal }, "Deactivate"), patientProfileDeletePermission && state !== "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "button", onClick: this.showActivateModal }, "Activate"), isEditable && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "loading" }))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_35_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.toggleHeadline), onClick: this.collapseSection("showPatientEventSummary") }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_tooltip___default.a, { title: showPatientEventSummary ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showPatientEventSummary ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.toggleText }, "Patient Event Summary")), showPatientEventSummary && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("table", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.table }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("thead", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, "Event"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, "Status"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, "Occurred at site"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, "Data entered / Audit Trial"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, "Actions"))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("tbody", null, this.props.events_summary_report && this.props.events_summary_report.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("tr", { key: i }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, item.event), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, item.status === "green" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "check-square", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.checkIcon }), item.status === "red" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "warning", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.warningIcon }), item.status === "orange" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "clock-circle", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.clockIcon }), item.status === "gray" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "clock-circle", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.checkIconGray }), item.status === "pending" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "clock-circle", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.checkIconGray })), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, item.site), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { style: { maxWidth: "500px" } }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(EventMessage, { message: item.event_comments })), previewEvents[__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "event")] && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.messages", []).map(function (message, index) {
          return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", { key: index }, message);
        })))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("td", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.tableAction }, ["follow_up_90_days"].includes(item.event) && state === "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react_router_dom__["b" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_44__utils_url__["a" /* withParams */])(routes.admin.followUp90DaySingle, { subjectID: _this5.props.subjectID }) }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "edit", theme: "filled" })), ["registry_id"].includes(item.event) && state === "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "edit", theme: "filled", onClick: _this5.scrollUp }), ["sae"].includes(item.event) && state === "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react_router_dom__["b" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_44__utils_url__["a" /* withParams */])(routes.admin.saeReportingSignle, { subjectID: _this5.props.subjectID }) }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "edit", theme: "filled" })), ["validation"].includes(item.event) && state === "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react_router_dom__["b" /* Link */], { to: "/validate-randomization" }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "edit", theme: "filled" })), ["deviation"].includes(item.event) && state === "active" && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react_router_dom__["b" /* Link */], { to: "/validate-randomization" }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "edit", theme: "filled" })), __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link") && !Array.isArray(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link")) && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__FileLink_FileLink__["a" /* default */], { url: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link") }), __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link") && Array.isArray(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link")) && __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.document_link", []).map(function (message, index) {
          return __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__FileLink_FileLink__["a" /* default */], { url: message.link });
        }), __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "other_details.messages") && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: previewEvents[__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "event")] ? "eye-invisible" : "eye", theme: "filled", onClick: _this5.togglePreviewEvents(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(item, "event")) }))));
      })))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("b", null, "Notes:"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, null, getFieldDecorator("notes", { initialValue: __WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(this.props, "profile.notes") })(__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea, { disabled: !isEditable, rows: "6" }))))))), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.formActionsNotes }, isEditable && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_icon___default.a, { type: "loading" }))), saveError && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: saveError, type: "error" }), requestResult.type && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.submitResult })), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: "Confirm submit", visible: confirmSubmitModal, onOk: this.handleSubmit, onCancel: this.hideConfirmModal }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", null, "Confirm submit action"), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", null, "* Patient age looks wrong"), requestResult.type && __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_45__PatientProfileForm_css___default.a.submitResult })), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: "Subject deactivation", visible: deleteSubmitModal, onOk: this.submitDeletePatient, onCancel: this.hideDeleteModal }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", null, "Confirm patient deactivate action")), __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: "Subject activation", visible: activateSubmitModal, onOk: this.activateSubject, onCancel: this.hideActivateModal }, __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p", null, "Confirm patient activate action")));
    } }]);return PatientProfileForm;
}(__WEBPACK_IMPORTED_MODULE_33_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), patientProfileCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_15" /* getPatientProfileCreatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(props, "site.id"))(state), patientProfileReadRestrictedPermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_19" /* getPatientProfileReadRestrictedPermission */])(state), patientProfileUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_21" /* getPatientProfileUpdatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(props, "site.id"))(state), patientProfileDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_16" /* getPatientProfileDeletePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_36_lodash_get___default()(props, "site.id"))(state), patientProfileLockPermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_17" /* getPatientProfileLockPermission */])(state), patientProfileUnlockPermission: Object(__WEBPACK_IMPORTED_MODULE_43__reducers_user_selectors__["_20" /* getPatientProfileUnlockPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_42__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.create({ name: "patientProfile" })(Object(__WEBPACK_IMPORTED_MODULE_38_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(PatientProfileForm)));

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1798);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-badge {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  color: unset;\n  line-height: 1;\n}\n.ant-badge-count {\n  z-index: auto;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  color: #fff;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: center;\n  background: #f5222d;\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-multiple-words {\n  padding: 0 8px;\n}\n.ant-badge-dot {\n  z-index: auto;\n  width: 6px;\n  height: 6px;\n  background: #f5222d;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count,\n.ant-badge-dot,\n.ant-badge .ant-scroll-number-custom-component {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n  transform-origin: 100% 0%;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  vertical-align: middle;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #52c41a;\n}\n.ant-badge-status-processing {\n  position: relative;\n  background-color: #1890ff;\n}\n.ant-badge-status-processing::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #1890ff;\n  border-radius: 50%;\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n  content: '';\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #f5222d;\n}\n.ant-badge-status-warning {\n  background-color: #faad14;\n}\n.ant-badge-status-pink {\n  background: #eb2f96;\n}\n.ant-badge-status-magenta {\n  background: #eb2f96;\n}\n.ant-badge-status-red {\n  background: #f5222d;\n}\n.ant-badge-status-volcano {\n  background: #fa541c;\n}\n.ant-badge-status-orange {\n  background: #fa8c16;\n}\n.ant-badge-status-yellow {\n  background: #fadb14;\n}\n.ant-badge-status-gold {\n  background: #faad14;\n}\n.ant-badge-status-cyan {\n  background: #13c2c2;\n}\n.ant-badge-status-lime {\n  background: #a0d911;\n}\n.ant-badge-status-green {\n  background: #52c41a;\n}\n.ant-badge-status-blue {\n  background: #1890ff;\n}\n.ant-badge-status-geekblue {\n  background: #2f54eb;\n}\n.ant-badge-status-purple {\n  background: #722ed1;\n}\n.ant-badge-status-text {\n  margin-left: 8px;\n  color: #424242;\n  font-size: 14px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper:not(.ant-badge-status) {\n  vertical-align: middle;\n}\n.ant-badge-not-a-wrapper .ant-scroll-number {\n  position: relative;\n  top: auto;\n  display: block;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  transform: none;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n}\n.ant-scroll-number-only {\n  display: inline-block;\n  height: 20px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-scroll-number-only > p.ant-scroll-number-only-unit {\n  height: 20px;\n  margin: 0;\n}\n.ant-scroll-number-symbol {\n  vertical-align: top;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translate(50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(38);

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getNumberArray(num) {
  return num ? num.toString().split('').reverse().map(function (i) {
    var current = Number(i);
    return isNaN(current) ? i : current;
  }) : [];
}

function renderNumberList(position, className) {
  var childrenToReturn = [];

  for (var i = 0; i < 30; i++) {
    childrenToReturn.push(React.createElement("p", {
      key: i.toString(),
      className: (0, _classnames["default"])(className, {
        current: position === i
      })
    }, i % 10));
  }

  return childrenToReturn;
}

var ScrollNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollNumber, _React$Component);

  function ScrollNumber(props) {
    var _this;

    _classCallCheck(this, ScrollNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollNumber).call(this, props));

    _this.onAnimated = function () {
      var onAnimated = _this.props.onAnimated;

      if (onAnimated) {
        onAnimated();
      }
    };

    _this.renderScrollNumber = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          className = _this$props.className,
          style = _this$props.style,
          title = _this$props.title,
          _this$props$component = _this$props.component,
          component = _this$props$component === void 0 ? 'sup' : _this$props$component,
          displayComponent = _this$props.displayComponent; // fix https://fb.me/react-unknown-prop

      var restProps = (0, _omit["default"])(_this.props, ['count', 'onAnimated', 'component', 'prefixCls', 'displayComponent']);
      var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);

      var newProps = _extends(_extends({}, restProps), {
        className: (0, _classnames["default"])(prefixCls, className),
        title: title
      }); // allow specify the border
      // mock border-color by box-shadow for compatible with old usage:
      // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />


      if (style && style.borderColor) {
        newProps.style = _extends(_extends({}, style), {
          boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
        });
      }

      if (displayComponent) {
        return React.cloneElement(displayComponent, {
          className: (0, _classnames["default"])("".concat(prefixCls, "-custom-component"), displayComponent.props && displayComponent.props.className)
        });
      }

      return React.createElement(component, newProps, _this.renderNumberElement(prefixCls));
    };

    _this.state = {
      animateStarted: true,
      count: props.count
    };
    return _this;
  }

  _createClass(ScrollNumber, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      this.lastCount = prevState.count;
      var animateStarted = this.state.animateStarted;

      if (animateStarted) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(function (__, props) {
          return {
            animateStarted: false,
            count: props.count
          };
        }, this.onAnimated);
      }
    }
  }, {
    key: "getPositionByNum",
    value: function getPositionByNum(num, i) {
      var count = this.state.count;
      var currentCount = Math.abs(Number(count));
      var lastCount = Math.abs(Number(this.lastCount));
      var currentDigit = Math.abs(getNumberArray(this.state.count)[i]);
      var lastDigit = Math.abs(getNumberArray(this.lastCount)[i]);

      if (this.state.animateStarted) {
        return 10 + num;
      } // 同方向则在同一侧切换数字


      if (currentCount > lastCount) {
        if (currentDigit >= lastDigit) {
          return 10 + num;
        }

        return 20 + num;
      }

      if (currentDigit <= lastDigit) {
        return 10 + num;
      }

      return num;
    }
  }, {
    key: "renderCurrentNumber",
    value: function renderCurrentNumber(prefixCls, num, i) {
      if (typeof num === 'number') {
        var position = this.getPositionByNum(num, i);
        var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
        return React.createElement('span', {
          className: "".concat(prefixCls, "-only"),
          style: {
            transition: removeTransition ? 'none' : undefined,
            msTransform: "translateY(".concat(-position * 100, "%)"),
            WebkitTransform: "translateY(".concat(-position * 100, "%)"),
            transform: "translateY(".concat(-position * 100, "%)")
          },
          key: i
        }, renderNumberList(position, "".concat(prefixCls, "-only-unit")));
      }

      return React.createElement("span", {
        key: "symbol",
        className: "".concat(prefixCls, "-symbol")
      }, num);
    }
  }, {
    key: "renderNumberElement",
    value: function renderNumberElement(prefixCls) {
      var _this2 = this;

      var count = this.state.count;

      if (count && Number(count) % 1 === 0) {
        return getNumberArray(count).map(function (num, i) {
          return _this2.renderCurrentNumber(prefixCls, num, i);
        }).reverse();
      }

      return count;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderScrollNumber);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, nextState) {
      if ('count' in nextProps) {
        if (nextState.count === nextProps.count) {
          return null;
        }

        return {
          animateStarted: true
        };
      }

      return null;
    }
  }]);

  return ScrollNumber;
}(React.Component);

ScrollNumber.defaultProps = {
  count: null,
  onAnimated: function onAnimated() {}
};
(0, _reactLifecyclesCompat.polyfill)(ScrollNumber);
var _default = ScrollNumber;
exports["default"] = _default;
//# sourceMappingURL=ScrollNumber.js.map


/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css__);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var PatientEmailStatusForm = function (_React$Component) {
  _inherits(PatientEmailStatusForm, _React$Component);function PatientEmailStatusForm(props) {
    var _this2 = this;_classCallCheck(this, PatientEmailStatusForm);var _this = _possibleConstructorReturn(this, (PatientEmailStatusForm.__proto__ || Object.getPrototypeOf(PatientEmailStatusForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_19__api_requests__["_59" /* updateConsentGivenRequest */])(_this.props.subjectID, values.custom_consent_given === "true" ? true : values.custom_consent_given === "false" ? false : null);case 6:
                  _this.setState({ responseMessage: "Success" });setTimeout(function () {
                    _this.props.onSubmit(_this.props.subjectID);
                  }, 1500);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context["catch"](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(_context.t0, "response.data.msg", __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(_context.t0, "response.data.errors._schema[0]", "Error")), isLoading: false });case 13:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, username: "" };return _this;
  }_createClass(PatientEmailStatusForm, [{ key: "render", value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage;return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("b", null, "Custom consent given"), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, getFieldDecorator("custom_consent_given", { initialValue: "" + __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(this.props, "custom_consent_given", "null") })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: "true" }, "True"), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: "false" }, "False"), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: "null" }, "Null"))))))), errorMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: errorMessage, type: "error", className: __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: responseMessage, type: "success", className: __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css___default.a.alertsMb }), !responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_20__PatientProfileForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })))))));
    } }]);return PatientEmailStatusForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({ name: "PatientEmailStatusForm" })(Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["c" /* connect */])(mapStateToProps)(PatientEmailStatusForm)));

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var PatientAdjudicatedConsentStatusForm = function (_React$Component) {
  _inherits(PatientAdjudicatedConsentStatusForm, _React$Component);function PatientAdjudicatedConsentStatusForm(props) {
    var _this2 = this;_classCallCheck(this, PatientAdjudicatedConsentStatusForm);var _this = _possibleConstructorReturn(this, (PatientAdjudicatedConsentStatusForm.__proto__ || Object.getPrototypeOf(PatientAdjudicatedConsentStatusForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["_56" /* updateAdjudicatedConsentStatusRequest */])(_this.props.subjectID, { adjudicated_consent_status: values.adjudicated_consent_status === "null" ? null : values.adjudicated_consent_status, adjudicated_consent_comments: values.adjudicated_consent_comments });case 6:
                  _this.setState({ responseMessage: "Success" });setTimeout(function () {
                    _this.props.onSubmit(_this.props.subjectID);
                  }, 1500);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context["catch"](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context.t0, "response.data.msg", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context.t0, "response.data.errors._schema[0]", "Error")), isLoading: false });case 13:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, username: "" };return _this;
  }_createClass(PatientAdjudicatedConsentStatusForm, [{ key: "render", value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Adjudicated consent status"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("adjudicated_consent_status", { initialValue: "" + __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(this.props, "adjudicated_consent_status", "null") })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "consent_yes_to_study" }, "Consent yes to study"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "consent_yes_data_linkage_only" }, "Consent yes data linkage only"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "consent_no-signed" }, "Consent no-signed"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "consent_no-verbal" }, "Consent no-verbal"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "patient_died" }, "Patient died (consent not obtained)"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "patient_lost_to_follow_up" }, "Patient lost to follow up (consent not obtained)"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "null" }, "Empty"))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("adjudicated_consent_comments", { initialValue: __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(this.props, "adjudicated_consent_comments") })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea, { rows: "3" })))))), errorMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: errorMessage, type: "error", className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: responseMessage, type: "success", className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), !responseMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })))))));
    } }]);return PatientAdjudicatedConsentStatusForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: "PatientAdjudicatedConsentStatusForm" })(Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["c" /* connect */])(mapStateToProps)(PatientAdjudicatedConsentStatusForm)));

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"PatientProfile__content__i-SYz","registryFormWrapper":"PatientProfile__registryFormWrapper__2yjW8","parentContainer":"PatientProfile__parentContainer__1fypu","searchWrapper":"PatientProfile__searchWrapper__3tEle","searchWrapperLabel":"PatientProfile__searchWrapperLabel__1qxEH","toggleHeadline":"PatientProfile__toggleHeadline__Dey8S","collapseIcon":"PatientProfile__collapseIcon__2i8v6","toggleText":"PatientProfile__toggleText__2P4NG"};

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var PatientRegistryForm = function (_React$Component) {
  _inherits(PatientRegistryForm, _React$Component);function PatientRegistryForm(props) {
    var _this2 = this;_classCallCheck(this, PatientRegistryForm);var _this = _possibleConstructorReturn(this, (PatientRegistryForm.__proto__ || Object.getPrototypeOf(PatientRegistryForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var registry;return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 19;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;registry = Object.assign({}, values);if (!_this.props.profile) {
                    _context.next = 10;break;
                  }_context.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["_66" /* updateRegistryIDProfileRequest */])(_this.props.subjectID, registry);case 8:
                  _context.next = 12;break;case 10:
                  _context.next = 12;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["v" /* createRegistryIDProfileRequest */])(_this.props.subjectID, registry);case 12:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.onSubmit(_this.props.subjectID);
                  }, 1500);_context.next = 19;break;case 16:
                  _context.prev = 16;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.error', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.errors._schema[0]')), isLoading: false });case 19:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 16]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: '', username: '' };return _this;
  }_createClass(PatientRegistryForm, [{ key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          checkConfirmRequestError = _state.checkConfirmRequestError;return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('b', null, 'QUICR Registry ID'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('quicr_registry_id', { initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'profile.quicr_registry_id', '') })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, null))))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('b', null, 'Optimize Registry ID'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('optimize_registry_id', { initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'profile.optimize_registry_id', '') })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, null)))))), errorMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })))))));
    } }]);return PatientRegistryForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: 'patientRegistryForm' })(Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(PatientRegistryForm)));

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css__);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var PatientEmailStatusForm = function (_React$Component) {
  _inherits(PatientEmailStatusForm, _React$Component);function PatientEmailStatusForm(props) {
    var _this2 = this;_classCallCheck(this, PatientEmailStatusForm);var _this = _possibleConstructorReturn(this, (PatientEmailStatusForm.__proto__ || Object.getPrototypeOf(PatientEmailStatusForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["_62" /* updateEmailStatusRequest */])(_this.props.subjectID, values.consent_email_status);case 6:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.onSubmit(_this.props.subjectID);
                  }, 1500);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(_context.t0, 'response.data.msg', __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(_context.t0, 'response.data.errors._schema[0]', 'Error')), isLoading: false });case 13:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: '', username: '' };return _this;
  }_createClass(PatientEmailStatusForm, [{ key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          checkConfirmRequestError = _state.checkConfirmRequestError;if (this.props.consent_record === null) {
        return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('p', null, 'Consent record not available.'));
      }return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('b', null, 'Consent email status'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, getFieldDecorator('consent_email_status', { initialValue: __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(this.props, 'consent_record.consent_email_status', 'none') })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: 'none' }, 'None'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: 'participant_email_sent' }, 'Participant Email Sent'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: 'participant_signed' }, 'Participant Signed'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Option, { value: 'link_expired' }, 'Email link expired')))))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { sm: 24 }, __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(this.props, 'consent_record.consent_participant_email') && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('p', null, 'Consent giver e-mail:\xA0', __WEBPACK_IMPORTED_MODULE_17_lodash_get___default()(this.props, 'consent_record.consent_participant_email')))), errorMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_21__PatientProfileForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })))))));
    } }]);return PatientEmailStatusForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_19__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_18__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_18__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({ name: 'PatientEmailStatusForm' })(Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(PatientEmailStatusForm)));

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css__);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var PatientCoenrollmentForm = function (_React$Component) {
  _inherits(PatientCoenrollmentForm, _React$Component);function PatientCoenrollmentForm(props) {
    var _this2 = this;_classCallCheck(this, PatientCoenrollmentForm);var _this = _possibleConstructorReturn(this, (PatientCoenrollmentForm.__proto__ || Object.getPrototypeOf(PatientCoenrollmentForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 19;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;data = Object.assign({}, values);if (!_this.props.profile) {
                    _context.next = 10;break;
                  }_context.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["_58" /* updateCoenrollmentProfileRequest */])(_this.props.subjectID, data);case 8:
                  _context.next = 12;break;case 10:
                  _context.next = 12;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["q" /* createCoenrollmentProfileRequest */])(_this.props.subjectID, data);case 12:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.onSubmit(_this.props.subjectID);
                  }, 1500);_context.next = 19;break;case 16:
                  _context.prev = 16;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.msg', __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors._schema[0]')), isLoading: false });case 19:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 16]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: '' };return _this;
  }_createClass(PatientCoenrollmentForm, [{ key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError,
          getFieldValue = _props$form.getFieldValue;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          checkConfirmRequestError = _state.checkConfirmRequestError;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.patientProfileForm }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, { label: 'Was patient enrolled in any other trial?' }, getFieldDecorator('is_enrolled_other_trial', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'profile.is_enrolled_other_trial', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a, { value: true }, 'Yes'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a, { value: false }, 'No')))))), getFieldValue("is_enrolled_other_trial") && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, { label: 'Please select the co-enrollment trial name' }, getFieldDecorator('enrolled_trial_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'profile.enrolled_trial_name', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option, { value: 'easi_toc' }, 'EASI TOC'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option, { value: 'other' }, 'Other')))))), getFieldValue("enrolled_trial_name") === 'other' && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { sm: 6 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, { label: 'Other trial name' }, getFieldDecorator('other_enrolled_trial_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'profile.other_enrolled_trial_name', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea, null))))), errorMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_22__PatientProfileForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })))))));
    } }]);return PatientCoenrollmentForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({ name: 'patientCoenrollmentForm' })(PatientCoenrollmentForm));

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1807);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-input-number {\n  box-sizing: border-box;\n  color: #424242;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  width: 100%;\n  height: 32px;\n  padding: 4px 11px;\n  color: #F5F5F5;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  transition: all 0.3s;\n  display: inline-block;\n  width: 90px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n}\n.ant-input-number::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input-number:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-input-number:focus {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-input-number-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input-number[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-input-number {\n  max-width: 100%;\n  height: auto;\n  min-height: 32px;\n  line-height: 1.5;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-number-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-number-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-number-handler {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 50%;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: bold;\n  line-height: 0;\n  text-align: center;\n  transition: all 0.1s linear;\n}\n.ant-input-number-handler:active {\n  background: #f4f4f4;\n}\n.ant-input-number-handler:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler:hover .ant-input-number-handler-down-inner {\n  color: #78f1ff;\n}\n.ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-inner {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 4px;\n  width: 12px;\n  height: 12px;\n  color: rgba(0, 0, 0, 0.45);\n  line-height: 12px;\n  transition: all 0.1s linear;\n  user-select: none;\n}\n.ant-input-number-handler-up-inner > *,\n.ant-input-number-handler-down-inner > * {\n  line-height: 1;\n}\n.ant-input-number-handler-up-inner svg,\n.ant-input-number-handler-down-inner svg {\n  display: inline-block;\n}\n.ant-input-number-handler-up-inner::before,\n.ant-input-number-handler-down-inner::before {\n  display: none;\n}\n.ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon {\n  display: block;\n}\n.ant-input-number:hover {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n}\n.ant-input-number-focused {\n  border-color: #78f1ff;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(76, 222, 245, 0.2);\n}\n.ant-input-number-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input-number-disabled .ant-input-number-input {\n  cursor: not-allowed;\n}\n.ant-input-number-disabled .ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-input-number-input {\n  width: 100%;\n  height: 30px;\n  padding: 0 11px;\n  text-align: left;\n  background-color: transparent;\n  border: 0;\n  border-radius: 4px;\n  outline: 0;\n  transition: all 0.3s linear;\n  -moz-appearance: textfield !important;\n}\n.ant-input-number-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input-number-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number-input[type='number']::-webkit-inner-spin-button,\n.ant-input-number-input[type='number']::-webkit-outer-spin-button {\n  margin: 0;\n  -webkit-appearance: none;\n}\n.ant-input-number-lg {\n  padding: 0;\n  font-size: 16px;\n}\n.ant-input-number-lg input {\n  height: 38px;\n}\n.ant-input-number-sm {\n  padding: 0;\n}\n.ant-input-number-sm input {\n  height: 22px;\n  padding: 0 7px;\n}\n.ant-input-number-handler-wrap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 22px;\n  height: 100%;\n  background: #fff;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 0 4px 4px 0;\n  opacity: 0;\n  transition: opacity 0.24s linear 0.1s;\n}\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 7px \\9;\n  transform: scale(0.58333333) rotate(0deg);\n  min-width: auto;\n  margin-right: 0;\n}\n:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,\n:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {\n  font-size: 12px;\n}\n.ant-input-number-handler-wrap:hover .ant-input-number-handler {\n  height: 40%;\n}\n.ant-input-number:hover .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n.ant-input-number-handler-up {\n  border-top-right-radius: 4px;\n  cursor: pointer;\n}\n.ant-input-number-handler-up-inner {\n  top: 50%;\n  margin-top: -5px;\n  text-align: center;\n}\n.ant-input-number-handler-up:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-down {\n  top: 0;\n  border-top: 1px solid #d9d9d9;\n  border-bottom-right-radius: 4px;\n  cursor: pointer;\n}\n.ant-input-number-handler-down-inner {\n  top: 50%;\n  margin-top: -6px;\n  text-align: center;\n}\n.ant-input-number-handler-down:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-up-disabled,\n.ant-input-number-handler-down-disabled {\n  cursor: not-allowed;\n}\n.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner {\n  color: rgba(0, 0, 0, 0.25);\n}\n", ""]);

// exports


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputHandler__ = __webpack_require__(1809);











function noop() {}

function preventDefault(e) {
  e.preventDefault();
}

function defaultParser(input) {
  return input.replace(/[^\w\.-]+/g, '');
}

/**
 * When click and hold on a button - the speed of auto changin the value.
 */
var SPEED = 200;

/**
 * When click and hold on a button - the delay before auto changin the value.
 */
var DELAY = 600;

/**
 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
 */
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var isValidProps = function isValidProps(value) {
  return value !== undefined && value !== null;
};

var isEqual = function isEqual(oldValue, newValue) {
  return newValue === oldValue || typeof newValue === 'number' && typeof oldValue === 'number' && isNaN(newValue) && isNaN(oldValue);
};

var InputNumber = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputNumber, _React$Component);

  function InputNumber(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputNumber);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var value = void 0;
    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    _this.state = {
      focused: props.autoFocus
    };
    var validValue = _this.getValidValue(_this.toNumber(value));
    _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.state, {
      inputValue: _this.toPrecisionAsStep(validValue),
      value: validValue
    });
    return _this;
  }

  InputNumber.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  InputNumber.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        value = _props.value,
        onChange = _props.onChange,
        max = _props.max,
        min = _props.min;
    var focused = this.state.focused;

    // Don't trigger in componentDidMount

    if (prevProps) {
      if (!isEqual(prevProps.value, value) || !isEqual(prevProps.max, max) || !isEqual(prevProps.min, min)) {
        var validValue = focused ? value : this.getValidValue(value);
        var nextInputValue = void 0;
        if (this.pressingUpOrDown) {
          nextInputValue = validValue;
        } else if (this.inputting) {
          nextInputValue = this.rawInput;
        } else {
          nextInputValue = this.toPrecisionAsStep(validValue);
        }
        this.setState({ // eslint-disable-line
          value: validValue,
          inputValue: nextInputValue
        });
      }

      // Trigger onChange when max or min change
      // https://github.com/ant-design/ant-design/issues/11574
      var nextValue = 'value' in this.props ? value : this.state.value;
      // ref: null < 20 === true
      // https://github.com/ant-design/ant-design/issues/14277
      if ('max' in this.props && prevProps.max !== max && typeof nextValue === 'number' && nextValue > max && onChange) {
        onChange(max);
      }
      if ('min' in this.props && prevProps.min !== min && typeof nextValue === 'number' && nextValue < min && onChange) {
        onChange(min);
      }
    }

    // Restore cursor
    try {
      // Firefox set the input cursor after it get focused.
      // This caused that if an input didn't init with the selection,
      // set will cause cursor not correct when first focus.
      // Safari will focus input if set selection. We need skip this.
      if (this.cursorStart !== undefined && this.state.focused) {
        // In most cases, the string after cursor is stable.
        // We can move the cursor before it

        if (
        // If not match full str, try to match part of str
        !this.partRestoreByAfter(this.cursorAfter) && this.state.value !== this.props.value) {
          // If not match any of then, let's just keep the position
          // TODO: Logic should not reach here, need check if happens
          var pos = this.cursorStart + 1;

          // If not have last string, just position to the end
          if (!this.cursorAfter) {
            pos = this.input.value.length;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
            pos = this.cursorStart - 1;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE) {
            pos = this.cursorStart;
          }
          this.fixCaret(pos, pos);
        } else if (this.currentValue === this.input.value) {
          // Handle some special key code
          switch (this.lastKeyCode) {
            case __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].BACKSPACE:
              this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
              break;
            case __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE:
              this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
              break;
            default:
            // Do nothing
          }
        }
      }
    } catch (e) {}
    // Do nothing


    // Reset last key
    this.lastKeyCode = null;

    // pressingUpOrDown is true means that someone just click up or down button
    if (!this.pressingUpOrDown) {
      return;
    }
    if (this.props.focusOnUpDown && this.state.focused) {
      if (document.activeElement !== this.input) {
        this.focus();
      }
    }

    this.pressingUpOrDown = false;
  };

  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
  };

  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
    var val = value;
    if (val === '') {
      val = '';
    } else if (!this.isNotCompleteNumber(parseFloat(val, 10))) {
      val = this.getValidValue(val);
    } else {
      val = this.state.value;
    }
    return this.toNumber(val);
  };

  InputNumber.prototype.getRatio = function getRatio(e) {
    var ratio = 1;
    if (e.metaKey || e.ctrlKey) {
      ratio = 0.1;
    } else if (e.shiftKey) {
      ratio = 10;
    }
    return ratio;
  };

  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
    // optimize for chinese input expierence
    // https://github.com/ant-design/ant-design/issues/8196
    var value = e.target.value.trim().replace(/。/g, '.');

    if (isValidProps(this.props.decimalSeparator)) {
      value = value.replace(this.props.decimalSeparator, '.');
    }

    return value;
  };

  InputNumber.prototype.getValidValue = function getValidValue(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;

    var val = parseFloat(value, 10);
    // https://github.com/ant-design/ant-design/issues/7358
    if (isNaN(val)) {
      return value;
    }
    if (val < min) {
      val = min;
    }
    if (val > max) {
      val = max;
    }
    return val;
  };

  InputNumber.prototype.setValue = function setValue(v, callback) {
    // trigger onChange
    var precision = this.props.precision;

    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? null : parseFloat(v, 10);
    var _state = this.state,
        _state$value = _state.value,
        value = _state$value === undefined ? null : _state$value,
        _state$inputValue = _state.inputValue,
        inputValue = _state$inputValue === undefined ? null : _state$inputValue;
    // https://github.com/ant-design/ant-design/issues/7363
    // https://github.com/ant-design/ant-design/issues/16622

    var newValueInString = typeof newValue === 'number' ? newValue.toFixed(precision) : '' + newValue;
    var changed = newValue !== value || newValueInString !== '' + inputValue;
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      // always set input value same as value
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }

    return newValue;
  };

  InputNumber.prototype.getPrecision = function getPrecision(value) {
    if (isValidProps(this.props.precision)) {
      return this.props.precision;
    }
    var valueString = value.toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  };

  // step={1.0} value={1.51}
  // press +
  // then value should be 2.51, rather than 2.5
  // if this.props.precision is undefined
  // https://github.com/react-component/input-number/issues/39


  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var _props2 = this.props,
        precision = _props2.precision,
        step = _props2.step;

    if (isValidProps(precision)) {
      return precision;
    }
    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  };

  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  };

  InputNumber.prototype.fixCaret = function fixCaret(start, end) {
    if (start === undefined || end === undefined || !this.input || !this.input.value) {
      return;
    }

    try {
      var currentStart = this.input.selectionStart;
      var currentEnd = this.input.selectionEnd;

      if (start !== currentStart || end !== currentEnd) {
        this.input.setSelectionRange(start, end);
      }
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  InputNumber.prototype.focus = function focus() {
    this.input.focus();
    this.recordCursorPosition();
  };

  InputNumber.prototype.blur = function blur() {
    this.input.blur();
  };

  InputNumber.prototype.formatWrapper = function formatWrapper(num) {
    // http://2ality.com/2012/03/signedzero.html
    // https://github.com/ant-design/ant-design/issues/9439
    if (this.props.formatter) {
      return this.props.formatter(num);
    }
    return num;
  };

  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
    if (this.isNotCompleteNumber(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  };

  // '1.' '1x' 'xx' '' => are not complete numbers


  InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
  };

  InputNumber.prototype.toNumber = function toNumber(num) {
    var precision = this.props.precision;
    var focused = this.state.focused;
    // num.length > 16 => This is to prevent input of large numbers

    var numberIsTooLarge = num && num.length > 16 && focused;
    if (this.isNotCompleteNumber(num) || numberIsTooLarge) {
      return num;
    }
    if (isValidProps(precision)) {
      return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
    }
    return Number(num);
  };

  InputNumber.prototype.upStep = function upStep(val, rat) {
    var step = this.props.step;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    return this.toNumber(result);
  };

  InputNumber.prototype.downStep = function downStep(val, rat) {
    var step = this.props.step;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    return this.toNumber(result);
  };

  InputNumber.prototype.step = function step(type, e) {
    var _this2 = this;

    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var recursive = arguments[3];

    this.stop();
    if (e) {
      e.persist();
      e.preventDefault();
    }
    var props = this.props;
    if (props.disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if (this.isNotCompleteNumber(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    var outOfRange = val > props.max || val < props.min;
    if (val > props.max) {
      val = props.max;
    } else if (val < props.min) {
      val = props.min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
    if (outOfRange) {
      return;
    }
    this.autoStepTimer = setTimeout(function () {
      _this2[type](e, ratio, true);
    }, recursive ? SPEED : DELAY);
  };

  InputNumber.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props);

    var prefixCls = props.prefixCls,
        disabled = props.disabled,
        readOnly = props.readOnly,
        useTouch = props.useTouch,
        autoComplete = props.autoComplete,
        upHandler = props.upHandler,
        downHandler = props.downHandler,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'disabled', 'readOnly', 'useTouch', 'autoComplete', 'upHandler', 'downHandler']);

    var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
    var upDisabledClass = '';
    var downDisabledClass = '';
    var value = this.state.value;

    if (value || value === 0) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= props.max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= props.min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var dataOrAriaAttributeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
        dataOrAriaAttributeProps[key] = props[key];
      }
    }

    var editable = !props.readOnly && !props.disabled;

    // focus state, show input value
    // unfocus state, show valid value
    var inputDisplayValue = this.getInputDisplayValue();

    var upEvents = void 0;
    var downEvents = void 0;
    if (useTouch) {
      upEvents = {
        onTouchStart: editable && !upDisabledClass ? this.up : noop,
        onTouchEnd: this.stop
      };
      downEvents = {
        onTouchStart: editable && !downDisabledClass ? this.down : noop,
        onTouchEnd: this.stop
      };
    } else {
      upEvents = {
        onMouseDown: editable && !upDisabledClass ? this.up : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      downEvents = {
        onMouseDown: editable && !downDisabledClass ? this.down : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
    }

    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
    // ref for test
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      {
        className: classes,
        style: props.style,
        title: props.title,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-handler-wrap' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveUp,
            disabled: isUpDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, upEvents, {
            role: 'button',
            'aria-label': 'Increase Value',
            'aria-disabled': !!isUpDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
          }),
          upHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-up-inner',
            onClick: preventDefault
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveDown,
            disabled: isDownDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, downEvents, {
            role: 'button',
            'aria-label': 'Decrease Value',
            'aria-disabled': !!isDownDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
          }),
          downHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-down-inner',
            onClick: preventDefault
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-input-wrap'
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          role: 'spinbutton',
          'aria-valuemin': props.min,
          'aria-valuemax': props.max,
          'aria-valuenow': value,
          required: props.required,
          type: props.type,
          placeholder: props.placeholder,
          onClick: props.onClick,
          onMouseUp: this.onMouseUp,
          className: prefixCls + '-input',
          tabIndex: props.tabIndex,
          autoComplete: autoComplete,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: editable ? this.onKeyDown : noop,
          onKeyUp: editable ? this.onKeyUp : noop,
          autoFocus: props.autoFocus,
          maxLength: props.maxLength,
          readOnly: props.readOnly,
          disabled: props.disabled,
          max: props.max,
          min: props.min,
          step: props.step,
          name: props.name,
          title: props.title,
          id: props.id,
          onChange: this.onChange,
          ref: this.saveInput,
          value: inputDisplayValue,
          pattern: props.pattern,
          inputMode: props.inputMode
        }, dataOrAriaAttributeProps))
      )
    );
  };

  return InputNumber;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

InputNumber.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  focusOnUpDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPressEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  upHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  downHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  useTouch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  formatter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parser: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  precision: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  required: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pattern: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  decimalSeparator: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  inputMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
InputNumber.defaultProps = {
  focusOnUpDown: true,
  useTouch: false,
  prefixCls: 'rc-input-number',
  min: -MAX_SAFE_INTEGER,
  step: 1,
  style: {},
  onChange: noop,
  onKeyDown: noop,
  onPressEnter: noop,
  onFocus: noop,
  onBlur: noop,
  parser: defaultParser,
  required: false,
  autoComplete: 'off'
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _props3 = _this3.props,
        onKeyDown = _props3.onKeyDown,
        onPressEnter = _props3.onPressEnter;


    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP) {
      var ratio = _this3.getRatio(e);
      _this3.up(e, ratio);
      _this3.stop();
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      var _ratio = _this3.getRatio(e);
      _this3.down(e, _ratio);
      _this3.stop();
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER && onPressEnter) {
      onPressEnter(e);
    }

    // Trigger user key down
    _this3.recordCursorPosition();
    _this3.lastKeyCode = e.keyCode;
    if (onKeyDown) {
      onKeyDown.apply(undefined, [e].concat(args));
    }
  };

  this.onKeyUp = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var onKeyUp = _this3.props.onKeyUp;


    _this3.stop();

    _this3.recordCursorPosition();

    // Trigger user key up
    if (onKeyUp) {
      onKeyUp.apply(undefined, [e].concat(args));
    }
  };

  this.onChange = function (e) {
    var onChange = _this3.props.onChange;


    if (_this3.state.focused) {
      _this3.inputting = true;
    }
    _this3.rawInput = _this3.props.parser(_this3.getValueFromEvent(e));
    _this3.setState({ inputValue: _this3.rawInput });
    onChange(_this3.toNumber(_this3.rawInput)); // valid number or invalid string
  };

  this.onMouseUp = function () {
    var onMouseUp = _this3.props.onMouseUp;


    _this3.recordCursorPosition();

    if (onMouseUp) {
      onMouseUp.apply(undefined, arguments);
    }
  };

  this.onFocus = function () {
    var _props4;

    _this3.setState({
      focused: true
    });
    (_props4 = _this3.props).onFocus.apply(_props4, arguments);
  };

  this.onBlur = function () {
    var onBlur = _this3.props.onBlur;

    _this3.inputting = false;
    _this3.setState({
      focused: false
    });
    var value = _this3.getCurrentValidValue(_this3.state.inputValue);
    var newValue = _this3.setValue(value);

    if (onBlur) {
      var originValue = _this3.input.value;
      var inputValue = _this3.getInputDisplayValue({ focus: false, value: newValue });
      _this3.input.value = inputValue;
      onBlur.apply(undefined, arguments);
      _this3.input.value = originValue;
    }
  };

  this.getInputDisplayValue = function (state) {
    var _ref = state || _this3.state,
        focused = _ref.focused,
        inputValue = _ref.inputValue,
        value = _ref.value;

    var inputDisplayValue = void 0;
    if (focused) {
      inputDisplayValue = inputValue;
    } else {
      inputDisplayValue = _this3.toPrecisionAsStep(value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }

    var inputDisplayValueFormat = _this3.formatWrapper(inputDisplayValue);
    if (isValidProps(_this3.props.decimalSeparator)) {
      inputDisplayValueFormat = inputDisplayValueFormat.toString().replace('.', _this3.props.decimalSeparator);
    }

    return inputDisplayValueFormat;
  };

  this.recordCursorPosition = function () {
    // Record position
    try {
      _this3.cursorStart = _this3.input.selectionStart;
      _this3.cursorEnd = _this3.input.selectionEnd;
      _this3.currentValue = _this3.input.value;
      _this3.cursorBefore = _this3.input.value.substring(0, _this3.cursorStart);
      _this3.cursorAfter = _this3.input.value.substring(_this3.cursorEnd);
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  this.restoreByAfter = function (str) {
    if (str === undefined) return false;

    var fullStr = _this3.input.value;
    var index = fullStr.lastIndexOf(str);

    if (index === -1) return false;

    var prevCursorPos = _this3.cursorBefore.length;
    if (_this3.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE && _this3.cursorBefore.charAt(prevCursorPos - 1) === str[0]) {
      _this3.fixCaret(prevCursorPos, prevCursorPos);
      return true;
    }

    if (index + str.length === fullStr.length) {
      _this3.fixCaret(index, index);

      return true;
    }
    return false;
  };

  this.partRestoreByAfter = function (str) {
    if (str === undefined) return false;

    // For loop from full str to the str with last char to map. e.g. 123
    // -> 123
    // -> 23
    // -> 3
    return Array.prototype.some.call(str, function (_, start) {
      var partStr = str.substring(start);

      return _this3.restoreByAfter(partStr);
    });
  };

  this.stop = function () {
    if (_this3.autoStepTimer) {
      clearTimeout(_this3.autoStepTimer);
    }
  };

  this.down = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('down', e, ratio, recursive);
  };

  this.up = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('up', e, ratio, recursive);
  };

  this.saveUp = function (node) {
    _this3.upHandler = node;
  };

  this.saveDown = function (node) {
    _this3.downHandler = node;
  };

  this.saveInput = function (node) {
    _this3.input = node;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (InputNumber);

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__ = __webpack_require__(1810);








var InputHandler = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InputHandler, _Component);

  function InputHandler() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InputHandler);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  InputHandler.prototype.render = function render() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        disabled = _props.disabled,
        otherProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'disabled']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__["a" /* default */],
      {
        disabled: disabled,
        activeClassName: prefixCls + '-handler-active'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', otherProps)
    );
  };

  return InputHandler;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

InputHandler.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InputHandler);

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__ = __webpack_require__(1811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__["a"]; });


/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var TouchFeedback = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TouchFeedback);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                    }
                    className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, activeClassName);
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TouchFeedback);

TouchFeedback.defaultProps = {
    disabled: false
};

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DocumentForm__wrapper__TSgEn","submitResult":"DocumentForm__submitResult__18SDE","actionWrapper":"DocumentForm__actionWrapper__LvprP","wrapper2faOptions":"DocumentForm__wrapper2faOptions__1SEMm"};

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_SAEReportingForm_SAEReportingForm__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__SAEReporting_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reducers_user_selectors__ = __webpack_require__(37);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.Search;var Option = __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;var SAEReporting = function (_React$Component) {
  _inherits(SAEReporting, _React$Component);function SAEReporting(props) {
    var _this2 = this;_classCallCheck(this, SAEReporting);var _this = _possibleConstructorReturn(this, (SAEReporting.__proto__ || Object.getPrototypeOf(SAEReporting)).call(this, props));_this.handleSiteIDChange = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(val) {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ siteID: val, responseMessage: '', sae: null }, _this.searchSae);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.clearSiteSelect = function () {
      _this.setState({ siteID: '', saesBySite: null, sae: null }, _this.searchSae);
    };_this.onSearchBySubjectId = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.setState({ subjectID: value, errorMessage: null, sae: null, responseMessage: '', saesBySite: null }, _this.searchSae);case 1:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();_this.searchSae = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref4, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              _this.setState({ isLoading: true });_context3.prev = 1;_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["_13" /* getSAEsListRequest */])(_this.state.subjectID, _this.state.siteID);case 4:
              _ref4 = _context3.sent;data = _ref4.data;_this.setState({ saesBySite: data });_context3.next = 15;break;case 9:
              _context3.prev = 9;_context3.t0 = _context3['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                _context3.next = 14;break;
              }_this.props.logout();return _context3.abrupt('return');case 14:
              _this.setState({ sae: null, errorMessage: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context3.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context3.stop();}
        }
      }, _callee3, _this2, [[1, 9]]);
    }));_this.onSAEDelete = function () {
      _this.setState({ sae: null, responseMessage: 'Successfully deleted' });
    };_this.onSAECancel = function () {
      _this.setState({ sae: null, responseMessage: '' });_this.searchSae();
    };_this.handleSearchChange = function (e) {
      _this.setState({ subjectID: e.target.value });
    };_this.saeToEdit = function (sae) {
      return function () {
        _this.setState({ sae: sae, saesBySite: null });
      };
    };_this.addSae = function () {
      _this.setState({ sae: {}, saesBySite: null });
    };_this.state = { siteID: null, sites: [], saesBySite: null, sae: null, subjectID: '', isLoading: false, errorMessage: '', responseMessage: '' };return _this;
  }_createClass(SAEReporting, [{ key: 'componentDidMount', value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref6, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _context4.prev = 0;_context4.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["_20" /* getSitesRequest */])();case 3:
                _ref6 = _context4.sent;data = _ref6.data;this.setState({ sites: data });_context4.next = 14;break;case 8:
                _context4.prev = 8;_context4.t0 = _context4['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context4.t0, 'response.status') === 401)) {
                  _context4.next = 13;break;
                }this.props.logout();return _context4.abrupt('return');case 13:
                console.log(_context4.t0);case 14:
                if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'match.params.subjectID')) {
                  this.onSearchBySubjectId(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'match.params.subjectID'));
                }this.searchSae();case 16:case 'end':
                return _context4.stop();}
          }
        }, _callee4, this, [[0, 8]]);
      }));function componentDidMount() {
        return _ref5.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          siteID = _state.siteID,
          sites = _state.sites,
          saesBySite = _state.saesBySite,
          sae = _state.sae,
          subjectID = _state.subjectID,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage;var _props = this.props,
          SAEReadPermission = _props.SAEReadPermission,
          SAECreatePermission = _props.SAECreatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('title', null, 'Trial Management Portal: SAE Reporting')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h3', { className: 'headline-default' }, 'SAE reporting'), !SAEReadPermission && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default.a, { type: 'error', message: 'Permission denied! You cannot perform this action.' }), SAEReadPermission && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h5', { className: 'headline-default' }, 'REPORT A SERIOUS ADVERSE EVENT'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: 'ant-alert ant-alert-error' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, 'A Serious Adverse Event (SAE) is defined as an event that is:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('li', null, 'Life threatening'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('li', null, 'Results in persistent or significant disability or incapacity'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('li', null, 'Results in congenital anomaly/ birth defect'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('li', null, 'Requires in-patient hospitalization or prolongation of existing hospitalization'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('li', null, 'Medically important event')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, 'Whether an event is serious or not is based upon common-sense clinical judgement. Serious events include symptomatic ICH, aspiration pneumonia. Examples of non-serious adverse including petechial or asymptomatic ICH, bruising around an IV site, asymptomatic bacteriuria. Non-serious adverse do not require reporting in the AcT trial.'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, '* Adverse events that are not serious do not need to be reported centrally.'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, '** SAEs occurring within 24 hours of randomization should be reported whether expected or not. Expected SAE\'s beyond 24 hours do not need to be reported centrally.'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, '*** If the adverse event was serious, unexpected AND related, it is a SUADR (Serious Unexpected Adverse Drug Reaction), and should be reported irrespective of time of occurrence.')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), !sae && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Subject'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Search, { enterButton: 'Search', placeholder: 'Links to existing subject IDs', onSearch: this.onSearchBySubjectId, value: subjectID, onChange: this.handleSearchChange })), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Site ID'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.selectSiteWrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { placeholder: 'Select Site ID', onChange: this.handleSiteIDChange, style: { width: '100%' }, value: siteID, allowClear: true }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { key: site.id, value: site.code }, site.code, ' - ', site.name);
      }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: '' }, 'None')), siteID && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.selectSiteClear, onClick: this.clearSiteSelect }, 'Clear')))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' }), !sae && SAECreatePermission && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', onClick: this.addSae }, 'Add SAE')), saesBySite && saesBySite.length > 0 && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('table', { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.table }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('thead', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'Subject ID'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'SAE Code'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'SAE event number'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'Site Number'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'Sae occurred'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'Status'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, 'Actions'))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('tbody', null, saesBySite.map(function (sae) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('tr', { key: sae.id }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'subject.code')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'code')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'code').split('-')[2]), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'site.code')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_21_moment_timezone___default.a.utc(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'sae_date')).tz(_this3.props.userTimezone || __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'site.time_zone') || 'UTC').format('YYYY-MM-DD'), '\xA0', _this3.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'site.short_tz') || 'UTC'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_badge___default.a, { count: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'state'), style: { backgroundColor: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'state') === 'active' ? '#52c41a' : '#777' } }), '\xA0\xA0', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_badge___default.a, { count: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'locked') ? 'Locked' : 'Unlocked', style: { backgroundColor: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sae, 'locked') ? '#777' : '#52c41a' } })), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_28__SAEReporting_css___default.a.tableAction }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', onClick: _this3.saeToEdit(sae) }))));
      }))), saesBySite && saesBySite.length === 0 && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, 'No results found'), errorMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), sae && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_SAEReportingForm_SAEReportingForm__["a" /* default */], Object.assign({}, sae, { subjectID: subjectID, onSubmit: this.onSearchBySubjectId, onDelete: this.onSAEDelete, onCancel: this.onSAECancel })))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SAEReporting;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_31__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_31__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), SAEReadPermission: Object(__WEBPACK_IMPORTED_MODULE_31__reducers_user_selectors__["_42" /* getSAEReadPermission */])(state), SAECreatePermission: Object(__WEBPACK_IMPORTED_MODULE_31__reducers_user_selectors__["_39" /* getSAECreatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_30__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SAEReporting)));

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css__);































var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a.Option;var SAEReportingForm = function (_React$Component) {
  _inherits(SAEReportingForm, _React$Component);function SAEReportingForm(props) {
    var _this2 = this;_classCallCheck(this, SAEReportingForm);var _this = _possibleConstructorReturn(this, (SAEReportingForm.__proto__ || Object.getPrototypeOf(SAEReportingForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();var _this$props = _this.props,
          SAEUpdatePermissionBySite = _this$props.SAEUpdatePermissionBySite,
          SAEUpdatePermission = _this$props.SAEUpdatePermission,
          SAETermCodesUpdatePermission = _this$props.SAETermCodesUpdatePermission;_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var sae, date, _ref3, data, errors;return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 38;break;
                  }if (!(_this.props.sae_date && !(SAEUpdatePermissionBySite || SAETermCodesUpdatePermission))) {
                    _context.next = 4;break;
                  }return _context.abrupt("return");case 4:
                  if (!((_this.props.sae_date || _this.state.wasCreated) && !(SAEUpdatePermission || SAETermCodesUpdatePermission))) {
                    _context.next = 6;break;
                  }return _context.abrupt("return");case 6:
                  _this.setState({ isLoading: true });_context.prev = 7;sae = __WEBPACK_IMPORTED_MODULE_33_lodash_cloneDeep___default()(values);if (values.sae_date) {
                    date = __WEBPACK_IMPORTED_MODULE_33_lodash_cloneDeep___default()(values.sae_date);sae.sae_date = __WEBPACK_IMPORTED_MODULE_30_moment___default.a.tz(date.format("YYYY-MM-DDT") + "12:00", _this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32_lodash_find___default()(_this.state.sites, function (_ref2) {
                      var id = _ref2.id;return id === _this.props.form.getFieldValue("site_id");
                    }), "time_zone") || "UTC").utc().format("YYYY-MM-DDTHH:mm");
                  }sae.is_sae_occurred = values.is_sae_occurred === "true" ? true : values.is_sae_occurred === "false" ? false : null;sae.is_adverse_event_expected = values.is_adverse_event_expected === "true" ? true : values.is_adverse_event_expected === "false" ? false : null;sae.suadr = values.suadr || undefined;sae.subjectID = undefined;sae.site_id = +sae.site_id || __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "site.id");sae.sae_related = sae.sae_related === "true" ? true : sae.sae_related === "false" ? false : undefined;if (!(_this.props.sae_date || _this.state.wasCreated)) {
                    _context.next = 22;break;
                  }_context.next = 19;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["_68" /* updateSAERequest */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "subject.code", _this.state.subjectID), __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "id", _this.state.id), sae);case 19:
                  _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });_context.next = 27;break;case 22:
                  _context.next = 24;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["x" /* createSAERequest */])(_this.props.form.getFieldValue("subjectID"), sae);case 24:
                  _ref3 = _context.sent;data = _ref3.data;_this.setState({ wasCreated: true, id: data.id, subjectID: _this.props.form.getFieldValue("subjectID") });case 27:
                  _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });_context.next = 38;break;case 30:
                  _context.prev = 30;_context.t0 = _context["catch"](7);console.log(_context.t0.response);if (!(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 36;break;
                  }_this.props.logout();return _context.abrupt("return");case 36:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.data.message", __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.data.error", "Error")) } });if (__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 38:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[7, 30]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.toggleActivate = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["_45" /* toggleActivateSAERequest */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "subject.code", _this.state.subjectID), __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "id", _this.state.id), _this.state.saeState);case 3:
              _this.setState({ requestResult: { type: "success", message: "Success" }, saeState: _this.state.saeState === "inactive" ? "active" : "inactive" });_this.hideDeleteModal();_context2.next = 10;break;case 7:
              _context2.prev = 7;_context2.t0 = _context2["catch"](0);if (__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context2.t0, "response.status") === 401) {
                _this.props.logout();
              }case 10:case "end":
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 7]]);
    }));_this.deleteSae = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var SAEDeletePermission;return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              SAEDeletePermission = _this.props.SAEDeletePermission;if (!SAEDeletePermission) {
                _context3.next = 11;break;
              }_context3.prev = 2;_context3.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["L" /* deleteSAERequest */])(_this.props.subjectID, _this.props.id);case 5:
              _this.props.onDelete();_context3.next = 11;break;case 8:
              _context3.prev = 8;_context3.t0 = _context3["catch"](2);if (__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context3.t0, "response.status") === 401) {
                _this.props.logout();
              }case 11:case "end":
              return _context3.stop();}
        }
      }, _callee3, _this2, [[2, 8]]);
    }));_this.showDeleteModal = function () {
      _this.setState({ deleteSubmitModal: true });
    };_this.hideDeleteModal = function () {
      _this.setState({ deleteSubmitModal: false });
    };_this.handleSiteIDChange = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee4(val) {
        return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _this.setState({ siteID: val, responseMessage: "", sae: null }, _this.searchSae);case 1:case "end":
                return _context4.stop();}
          }
        }, _callee4, _this2);
      }));return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }();_this.onSwitchLock = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {case 0:
              _context5.prev = 0;if (!_this.state.locked) {
                _context5.next = 7;break;
              }_context5.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["_52" /* unlockSAERequest */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "subject.code", _this.state.subjectID), __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "id", _this.state.id));case 4:
              _this.setState({ locked: false });_context5.next = 10;break;case 7:
              _context5.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["_27" /* lockSAERequest */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "subject.code", _this.state.subjectID), __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_this.props, "id", _this.state.id));case 9:
              _this.setState({ locked: true });case 10:
              __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success("Saved");_context5.next = 16;break;case 13:
              _context5.prev = 13;_context5.t0 = _context5["catch"](0);__WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(_context5.t0, "response.data.error", "Error"));case 16:case "end":
              return _context5.stop();}
        }
      }, _callee5, _this2, [[0, 13]]);
    }));_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, requestResult: {}, wasCreated: false, saeState: "", subjectID: "", id: "", deleteSubmitModal: false, sites: [], locked: false };return _this;
  }_createClass(SAEReportingForm, [{ key: "componentDidMount", value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _ref9, data;return __WEBPACK_IMPORTED_MODULE_28_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {case 0:
                this.setState({ saeState: this.props.state, locked: __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(this.props, "locked") });_context6.prev = 1;_context6.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_35__api_requests__["_20" /* getSitesRequest */])();case 4:
                _ref9 = _context6.sent;data = _ref9.data;this.setState({ sites: data });_context6.next = 15;break;case 9:
                _context6.prev = 9;_context6.t0 = _context6["catch"](1);if (!(_context6.t0.response.status === 401)) {
                  _context6.next = 14;break;
                }this.props.logout();return _context6.abrupt("return");case 14:
                console.log(_context6.t0);case 15:case "end":
                return _context6.stop();}
          }
        }, _callee6, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref8.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          wasCreated = _state.wasCreated,
          deleteSubmitModal = _state.deleteSubmitModal,
          sites = _state.sites,
          locked = _state.locked;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          SAEDeletePermission = _props.SAEDeletePermission,
          SAEUpdatePermissionBySite = _props.SAEUpdatePermissionBySite,
          SAEUpdatePermission = _props.SAEUpdatePermission,
          SAELockPermission = _props.SAELockPermission,
          SAEUnlockPermission = _props.SAEUnlockPermission,
          SAECentralCommentsReadPermission = _props.SAECentralCommentsReadPermission,
          SAETermCodesViewPermission = _props.SAETermCodesViewPermission,
          SAETermCodesUpdatePermission = _props.SAETermCodesUpdatePermission,
          SAECentralCommentsUpdatePermission = _props.SAECentralCommentsUpdatePermission;var isEventTypeOther = getFieldValue("event_type") ? this.props.form.getFieldValue("event_type") === "other" : this.props.event_type === "other";var isSAEOccured = getFieldValue("is_sae_occurred") === "true";var isAdverseEventExpected = getFieldValue("is_adverse_event_expected") === "true";var isEditing = this.state.wasCreated ? SAEUpdatePermission : this.props.sae_date ? SAEUpdatePermissionBySite && !locked : true;return __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("h4", { className: "headline-default" }, "Has a SAE occurred?"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("is_sae_occurred", { rules: [{ required: true, message: "Required" }], initialValue: this.props.is_sae_occurred ? this.props.is_sae_occurred.toString() : "false" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a.Group, { disabled: !isEditing }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a, { value: "false" }, "No"))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "SubjectID:"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("subjectID", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(this.props, "subject.code", "") })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !isEditing || !!(this.props.sae_date || wasCreated) }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "Site ID"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("site_id", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(this.props, "site.id") })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a, { disabled: !isEditing, placeholder: "Select Site ID", style: { width: "100%" }, allowClear: true }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, " - ", site.name);
      }))))))), this.props.code && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "SAE code:"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: true, value: this.props.code })))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "SAE event number:"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: true, value: this.props.code.split('-')[2] }))))), isSAEOccured && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("p", null, "An expected adverse event is one that is a known complication of the disease or treatment under study. For example, aspiration pneumonia, seizure, UTI, symptomatic ICH area known (expected) serious complication of stroke and its treatment. The underlying cause of the event is not considered when determining if an event is expected or not."), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "Was the adverse event expected?"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("is_adverse_event_expected", { rules: [{ required: true, message: "Required" }], initialValue: this.props.is_adverse_event_expected !== undefined && this.props.is_adverse_event_expected !== null ? this.props.is_adverse_event_expected.toString() : "null" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a.Group, { disabled: !isEditing }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a, { value: "false" }, "No"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a, { value: "null" }, "Unknown")))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "If expected, please indicate type of event"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("event_type", { rules: [{ required: isAdverseEventExpected, message: "Required" }], initialValue: this.props.event_type })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a, { disabled: !isEditing, placeholder: "Select type of event" }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "symptomatic_intracerebral" }, "Symptomatic intracerebral hemorrhage"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "peripheral_bleeding" }, "Peripheral bleeding requiring blood transfusion"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "angioedema" }, "Angioedema"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "other" }, "Others (give diagnosis, if possible)"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "none" }, "None"))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "SAE Related"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("sae_related", { // rules: [{ required: true, message: 'Required' }],
        initialValue: typeof this.props.sae_related === "boolean" ? this.props.sae_related.toString() : null })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a, { disabled: !SAEUpdatePermission, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(Option, { value: "false" }, "No")))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "Date"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div", { style: { display: "flex", alignItems: "center", width: "340px" } }, getFieldDecorator("sae_date", { rules: [{ required: true, message: "Required" }], initialValue: this.props.sae_date ? __WEBPACK_IMPORTED_MODULE_30_moment___default.a.utc(this.props.sae_date).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32_lodash_find___default()(sites, function (_ref10) {
          var id = _ref10.id;return id === getFieldValue("site_id");
        }), "time_zone") || "UTC") : __WEBPACK_IMPORTED_MODULE_30_moment___default.a.utc(new Date()).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32_lodash_find___default()(sites, function (_ref11) {
          var id = _ref11.id;return id === getFieldValue("site_id");
        }), "time_zone") || "UTC") })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default.a, { disabled: !isEditing, format: "YYYY/MM/DD", disabledDate: function disabledDate(currentDate) {
          return currentDate.diff(__WEBPACK_IMPORTED_MODULE_30_moment___default.a.now()) > 86400000;
        } })), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span", { style: { width: "35px" } }, "\xA0", this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32_lodash_find___default()(sites, function (_ref12) {
        var id = _ref12.id;return id === getFieldValue("site_id");
      }), "short_tz") || "UTC")))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), isEventTypeOther && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("b", null, "If other, please indicate what event occurred:"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("other_event_comments", { rules: [{ required: true, message: "Required" }], initialValue: this.props.other_event_comments })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.TextArea, { disabled: !isEditing })))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "SAE comments", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("event_comments", { initialValue: this.props.event_comments || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.TextArea, { disabled: !isEditing, rows: "3" })))), SAECentralCommentsReadPermission && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "Central SAE comments", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("central_sae_comments", { initialValue: this.props.central_sae_comments || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.TextArea, { disabled: !SAECentralCommentsUpdatePermission, rows: "3" })))), SAETermCodesViewPermission && (this.props.sae_date || this.state.wasCreated) && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "LLT Term", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("LLT_term", { initialValue: this.props.LLT_term || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "LLT Code", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("LLT_code", { initialValue: this.props.LLT_code || "", rules: [{ pattern: /^[0-9]{8}$/, message: "8-digit numeric code is allowed" }] })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission })))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "PT Term", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("PT_term", { initialValue: this.props.PT_term || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "PT Code", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("PT_code", { initialValue: this.props.PT_code || "", rules: [{ pattern: /^[0-9]{8}$/, message: "8-digit numeric code is allowed" }] })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission })))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "HLT Term", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("HLT_term", { initialValue: this.props.HLT_term || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "HLT Code", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("HLT_code", { initialValue: this.props.HLT_code || "", rules: [{ pattern: /^[0-9]{8}$/, message: "8-digit numeric code is allowed" }] })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission })))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "HLGT Term", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("HLGT_term", { initialValue: this.props.HLGT_term || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "HLGT Code", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("HLGT_code", { initialValue: this.props.HLGT_code || "", rules: [{ pattern: /^[0-9]{8}$/, message: "8-digit numeric code is allowed" }] })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission })))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "SOC Term", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("SOC_term", { initialValue: this.props.SOC_term || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("label", null, "SOC Code", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("SOC_code", { initialValue: this.props.SOC_code || "", rules: [{ pattern: /^[0-9]{8}$/, message: "8-digit numeric code is allowed" }] })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, { disabled: !SAETermCodesUpdatePermission }))))))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("p", null, "If the adverse event was serious, unexpected and related, it is a Serious Unexpected Adverse Drug Reaction (SUADR). Please report details in narrative review form bellow."), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("h4", { className: "headline-default" }, "Serious Unexpected Adverse Drug Reaction (SUADR)"), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("p", null, "NARRATIVE/DETAILS", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("br", null), "Please describe the SUADR, treatment and outcome. Please also include relevant medical history, any relevant abs or tests performed, and any medications given to the patient. Please describe the resolution of the event (continuing, resolved, death)."), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, null, getFieldDecorator("other_comments", { initialValue: this.props.other_comments || "" })(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.TextArea, { disabled: !isEditing, rows: "6" })))), requestResult.type && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_38__SAEReportingForm_css___default.a.formActions }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", onClick: this.props.onCancel }, "Back"), "\xA0\xA0", (this.props.sae_date || this.state.wasCreated) && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Lock / Unlock the SAE record" }, "Lock status: \xA0", __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_switch___default.a, { disabled: !SAEUnlockPermission && locked || !SAELockPermission && !locked, checked: !locked, onChange: this.onSwitchLock })), this.props.sae_date && !wasCreated && SAEDeletePermission && isEditing && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", style: { backgroundColor: "#f56009", borderColor: "#f56009", color: "#fff" }, onClick: this.showDeleteModal }, this.state.saeState === "inactive" ? "Activate" : "Deactivate"), (isEditing || SAETermCodesUpdatePermission) && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit" }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: "loading" })))), __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: "SAE " + (this.state.saeState === "inactive" ? "Activate" : "Deactivate"), visible: deleteSubmitModal, onOk: this.toggleActivate, onCancel: this.hideDeleteModal }, __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("p", null, "Confirm SAE", " ", this.state.saeState === "inactive" ? "activate" : "deactivate", " ", "action")));
    } }]);return SAEReportingForm;
}(__WEBPACK_IMPORTED_MODULE_29_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), SAEUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_46" /* getSAEUpdatePermission */])(state), SAEUpdatePermissionBySite: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_47" /* getSAEUpdatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(props, "site.id"))(state), SAEDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_40" /* getSAEDeletePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_31_lodash_get___default()(props, "site.id"))(state), SAELockPermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_41" /* getSAELockPermission */])(state), SAEUnlockPermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_45" /* getSAEUnlockPermission */])(state), SAECentralCommentsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_37" /* getSAECentralCommentsReadPermission */])(state), SAECentralCommentsUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_38" /* getSAECentralCommentsUpdatePermission */])(state), SAETermCodesViewPermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_44" /* getSAETermCodesViewPermission */])(state), SAETermCodesUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_37__reducers_user_selectors__["_43" /* getSAETermCodesUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_36__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.create({ name: "saeReporting" })(Object(__WEBPACK_IMPORTED_MODULE_34_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SAEReportingForm)));

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(157),
    isArrayLike = __webpack_require__(109),
    keys = __webpack_require__(124);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(402),
    baseIteratee = __webpack_require__(157),
    toInteger = __webpack_require__(1817);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1818);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1819);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isSymbol = __webpack_require__(153);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SAEReportingForm__wrapper__3xPs0","formActions":"SAEReportingForm__formActions__-Weuh","submitResult":"SAEReportingForm__submitResult__icgbm"};

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SAEReporting__content__1-ExL","parentContainer":"SAEReporting__parentContainer__1M2N7","selectSiteWrapper":"SAEReporting__selectSiteWrapper__3EgJa","selectSiteClear":"SAEReporting__selectSiteClear__2nraM","table":"SAEReporting__table__1KnC4","tableAction":"SAEReporting__tableAction__3B81c"};

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FollowUp90DayForm_FollowUp90DayForm__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__ = __webpack_require__(37);











var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a.Search;var FollowUp90Day = function (_React$Component) {
  _inherits(FollowUp90Day, _React$Component);function FollowUp90Day(props) {
    var _this2 = this;_classCallCheck(this, FollowUp90Day);var _this = _possibleConstructorReturn(this, (FollowUp90Day.__proto__ || Object.getPrototypeOf(FollowUp90Day)).call(this, props));_this.onFollowUpSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        var _ref2, data;return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                if (!value.trim()) {
                  _context.next = 17;break;
                }_this.setState({ subjectID: value, errorMessage: null, subject: null, isLoading: true });_context.prev = 2;_context.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_18__api_requests__["_4" /* getFollowUpRequest */])(value);case 5:
                _ref2 = _context.sent;data = _ref2.data;_this.setState({ subject: Object.assign({}, data) });_context.next = 16;break;case 10:
                _context.prev = 10;_context.t0 = _context['catch'](2);if (!(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                  _context.next = 15;break;
                }_this.props.logout();return _context.abrupt('return');case 15:
                _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 16:
                _this.setState({ isLoading: false });case 17:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2, [[2, 10]]);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.state = { subject: null, subjectID: null, errorMessage: null, isLoading: false };return _this;
  }_createClass(FollowUp90Day, [{ key: 'componentDidMount', value: function componentDidMount() {
      if (__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(this.props, 'match.params.subjectID')) {
        this.onFollowUpSearch(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(this.props, 'match.params.subjectID'));
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          subject = _state.subject,
          subjectID = _state.subjectID,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading;var followUp90dReadPermission = this.props.followUp90dReadPermission;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('title', null, 'Trial Management Portal: 90-day Follow Up')), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('h3', { className: 'headline-default' }, '90-day Follow Up'), !followUp90dReadPermission && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { type: 'error', message: 'Permission denied! You cannot perform this action.' }), followUp90dReadPermission && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_16__FollowUp90Day_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Search, { placeholder: 'By subject ID', enterButton: 'Search', size: 'large', onSearch: this.onFollowUpSearch, style: { maxWidth: '500px' } }))), errorMessage && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), subject && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_FollowUp90DayForm_FollowUp90DayForm__["a" /* default */], Object.assign({}, subject, { subjectID: subjectID, onSubmit: this.onFollowUpSearch })), isLoading && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' }))), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return FollowUp90Day;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { followUp90dReadPermission: Object(__WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__["E" /* getFollowUp90dReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(FollowUp90Day)));

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_slider_style__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_slider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_slider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_slider__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tag_style__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tag_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_tag_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tag__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__FileLink_FileLink__ = __webpack_require__(104);







































var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var FollowUp90DayForm = function (_React$Component) {
  _inherits(FollowUp90DayForm, _React$Component);function FollowUp90DayForm(props) {
    var _this2 = this;_classCallCheck(this, FollowUp90DayForm);var _this = _possibleConstructorReturn(this, (FollowUp90DayForm.__proto__ || Object.getPrototypeOf(FollowUp90DayForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();var followUp90dUpdatePermission = _this.props.followUp90dUpdatePermission;_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var followUp, errors;return __WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (!(!err && followUp90dUpdatePermission)) {
                    _context.next = 29;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;followUp = __WEBPACK_IMPORTED_MODULE_40_lodash_cloneDeep___default()(values);if (followUp.eq_5d_sl_mobility === "null") {
                    followUp.eq_5d_sl_mobility = null;
                  }if (followUp.eq_5d_sl_self_care === "null") {
                    followUp.eq_5d_sl_self_care = null;
                  }if (followUp.eq_5d_sl_usual_tasks === "null") {
                    followUp.eq_5d_sl_usual_tasks = null;
                  }if (followUp.eq_5d_sl_pain_discomfort === "null") {
                    followUp.eq_5d_sl_pain_discomfort = null;
                  }if (followUp.eq_5d_sl_anxiety_depression === "null") {
                    followUp.eq_5d_sl_anxiety_depression = null;
                  }if (followUp.modified_ranking_scale === "null") {
                    followUp.modified_ranking_scale = null;
                  }if (followUp.eq_5d_sl_vas_unknown === true) {
                    followUp.eq_5d_sl_vas = 999;
                  }delete followUp.eq_5d_sl_vas_unknown;if (values.scheduled_date) {
                    followUp.scheduled_date = __WEBPACK_IMPORTED_MODULE_40_lodash_cloneDeep___default()(values.scheduled_date).utc().format("YYYY-MM-DDTHH:mm:ss");
                  }followUp.has_pre_stroke_status = values.has_pre_stroke_status === "true" ? true : values.has_pre_stroke_status === "false" ? false : null;_context.next = 17;return Object(__WEBPACK_IMPORTED_MODULE_43__api_requests__["_63" /* updateFollowUpRequest */])(_this.props.subjectID, followUp);case 17:
                  _this.props.onSubmit(_this.props.subjectID);_this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default.a.success({ message: "Success", description: "Follow up has been successfully updated" });_context.next = 29;break;case 22:
                  _context.prev = 22;_context.t0 = _context["catch"](3);if (!(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 27;break;
                  }_this.props.logout();return _context.abrupt("return");case 27:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 29:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 22]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.collapseSection = function (sectionName) {
      return function () {
        _this.setState(function (state) {
          return _defineProperty({}, sectionName, !state[sectionName]);
        });
      };
    };_this.onSwitchLock = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_36_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;if (!_this.state.locked) {
                _context2.next = 7;break;
              }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_43__api_requests__["_51" /* unlockFollowUpRequest */])(_this.props.subjectID);case 4:
              _this.setState({ locked: false });_context2.next = 10;break;case 7:
              _context2.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_43__api_requests__["_26" /* lockFollowUpRequest */])(_this.props.subjectID);case 9:
              _this.setState({ locked: true });case 10:
              __WEBPACK_IMPORTED_MODULE_31_antd_lib_message___default.a.success("Saved");_context2.next = 16;break;case 13:
              _context2.prev = 13;_context2.t0 = _context2["catch"](0);__WEBPACK_IMPORTED_MODULE_31_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(_context2.t0, "response.data.error", "Error"));case 16:case "end":
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 13]]);
    }));_this.state = { isLoading: false, requestResult: {}, showFollowupForm: true, showContactInformation: false, showAdditionalContactInformation: false, locked: false };return _this;
  }_createClass(FollowUp90DayForm, [{ key: "componentDidMount", value: function componentDidMount() {
      this.setState({ locked: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "locked") });
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          showFollowupForm = _state.showFollowupForm,
          showContactInformation = _state.showContactInformation,
          showAdditionalContactInformation = _state.showAdditionalContactInformation,
          locked = _state.locked;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue,
          setFieldsValue = _props$form.setFieldsValue;var _props = this.props,
          followUp90dUpdatePermission = _props.followUp90dUpdatePermission,
          followUp90dLockPermission = _props.followUp90dLockPermission,
          followUp90dUnlockPermission = _props.followUp90dUnlockPermission;var isEditable = followUp90dUpdatePermission && !locked;var isObtainedBy = getFieldValue("is_obtained_by");var providedBy = getFieldValue("provided_by");var followUpStatus = getFieldValue("follow_up_status");return __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_38_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.toggleHeadline), onClick: this.collapseSection("showContactInformation") }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip___default.a, { title: showContactInformation ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showContactInformation ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.headlineText }, "Contact Information")), showContactInformation && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Name:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.first_name"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.last_name")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Phone number:"), " (", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.phone_number_type_1"), ")", " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.phone_number_1")), __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.phone_number_2") && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Phone number 2:"), " (", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.phone_number_type_2"), ")", " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.phone_number_2")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Email:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.email")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Consent given:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.has_consent_given", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.is_consent_given" || "")) ? "Yes" : "No"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Consent documents:")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("ul", { style: { listStyle: "none" } }, __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.link") && (Array.isArray(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.link")) ? __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.link").map(function (_ref4) {
        var link = _ref4.link,
            name = _ref4.name;return __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("li", { key: name }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__FileLink_FileLink__["a" /* default */], { url: link, text: name })));
      }) : __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.type") ? __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__FileLink_FileLink__["a" /* default */], { url: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.link"), text: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "consent.type") })) : __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("li", null, "None. Please provide", " ", __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47_react_router_dom__["b" /* Link */], { to: "/consent" }, "consent here")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Comments:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.comments"))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_38_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.toggleHeadline), onClick: this.collapseSection("showAdditionalContactInformation") }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip___default.a, { title: showAdditionalContactInformation ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showAdditionalContactInformation ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.headlineText }, "Additional Contact Information")), showAdditionalContactInformation && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "Other contacts"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Contact 1")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Name:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_1_first_name"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_1_last_name")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Relationship:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_1_relationship_type")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Phone number:"), " (", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_1_phone_number_type"), ")", " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_1_phone_number"))), __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_first_name") && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Contact 2")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Name:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_first_name"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_last_name")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Relationship:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_relationship_type")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Phone number:"), " (", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_phone_number_type"), ")", " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.contact_2_phone_number"))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { md: 8 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Family Doctor")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Name:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.family_doctor_first_name"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.family_doctor_last_name")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Clinic name:"), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.family_doctor_clinic_name")), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Phone number:"), " (", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.family_doctor_phone_number_type"), ")", " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "subject.profile.family_doctor_phone_number"))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_38_classnames___default()("headline-default", __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.toggleHeadline), onClick: this.collapseSection("showFollowupForm") }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip___default.a, { title: showFollowupForm ? "collapse" : "show" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_icon___default.a, { type: "arrow-up", className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.collapseIcon, style: { fontSize: "20px", transform: "rotate(" + (showFollowupForm ? "0" : "180deg") + ")" } }), " ", "\xA0"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.headlineText }, this.props.subjectID), " ", __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: "Edit", style: { backgroundColor: "#2968AE" } })), showFollowupForm && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", null, this.props.follow_up_status === "completed" && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tag___default.a, { color: "#49c850" }, "Completed: ", __WEBPACK_IMPORTED_MODULE_42_moment_timezone___default()(this.props.updated).format('YYYY/MM/DD, HH:mm')), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tag___default.a, { color: "#49c850" }, "by ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props.updated_by, 'username'))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, "Scheduled visit(s)"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Date" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", { style: { display: "flex", alignItems: "center" } }, getFieldDecorator("scheduled_date", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "scheduled_date") ? __WEBPACK_IMPORTED_MODULE_42_moment_timezone___default.a.utc(this.props.scheduled_date).tz(this.props.userTimezone || __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "site.time_zone") || "UTC") : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker___default.a, { disabled: !isEditable, placeholder: "yyyy-mm-dd", format: "YYYY/MM/DD HH:mm", showTime: { format: "HH:mm" } })), "\xA0", this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "site.short_tz") || "UTC"))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", { style: { marginTop: "30px" } }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("b", null, "Site: "), " ", __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "site.name")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "1. Method information is obtained:"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Method" }, getFieldDecorator("is_obtained_by", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "is_obtained_by", "") })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "by_phone" }, "By phone"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "in_person" }, "In-person"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "email" }, "Email"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "by_mail" }, "By mail"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "other" }, "Other"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Select"))))), isObtainedBy === "other" && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Other" }, getFieldDecorator("obtained_by_other", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "obtained_by_other") })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "2. Who is providing the following information?"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Provided by" }, getFieldDecorator("provided_by", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "provided_by", "") })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "patient_self" }, "Patient/ Self"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "surrogate" }, "Surrogate"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "family_member" }, "Family Member"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "care_home_nurse" }, "Care Home Nurse"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "other" }, "Other"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Select"))))), providedBy === "other" && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Other" }, getFieldDecorator("provided_by_other", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "provided_by_other") })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "3. EQ-5D-5L Health Questionnaire"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 8 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h6", { className: "headline-default" }, "DESCRIPTIVE SYSTEM"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Mobility" }, getFieldDecorator("eq_5d_sl_mobility", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.eq_5d_sl_mobility) ? this.props.eq_5d_sl_mobility.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1 - You have no problems in walking about"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2 - You have slight problems in walking about"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3 - You have moderate problems in walking about"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4 - You have severe problems in walking about"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5 - You are unable to walk about"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Not selected")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Self care" }, getFieldDecorator("eq_5d_sl_self_care", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.eq_5d_sl_self_care) ? this.props.eq_5d_sl_self_care.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1 - You have no problems washing or dressing yourself"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2 - You have slight problems washing or dressing yourself"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3 - You have moderate problems washing or dressing yourself"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4 - You have severe problems washing or dressing yourself"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5 - You are unable to wash or dress yourself"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Not selected")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Usual tasks" }, getFieldDecorator("eq_5d_sl_usual_tasks", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.eq_5d_sl_usual_tasks) ? this.props.eq_5d_sl_usual_tasks.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1 - You have no problems doing your usual activities"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2 - You have slight problems doing your usual activities"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3 - You have moderate problems doing your usual activities"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4 - You have severe problems doing your usual activities"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5 - You are unable to do your usual activities"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Not selected")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Pain / discomfort" }, getFieldDecorator("eq_5d_sl_pain_discomfort", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.eq_5d_sl_pain_discomfort) ? this.props.eq_5d_sl_pain_discomfort.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1 - You have no pain or discomfort"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2 - You have slight pain or discomfort"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3 - You have moderate pain or discomfort"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4 - You have severe pain or discomfort"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5 - You have extreme pain or discomfort"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Not selected")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Anxiety / depression" }, getFieldDecorator("eq_5d_sl_anxiety_depression", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.eq_5d_sl_anxiety_depression) ? this.props.eq_5d_sl_anxiety_depression.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1 - You are not anxious or depressed"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2 - You are slightly anxious or depressed"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3 - You are moderately anxious or depressed"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4 - You are severely anxious or depressed?"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5 - You are extremely anxious or depressed"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Not selected"))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.sliderWrapper }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h6", { className: "headline-default" }, "VISUAL ANALOG SYSTEM (VAS)"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "The best health you can imagine" }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", { style: { height: "300px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" } }, getFieldDecorator("eq_5d_sl_vas", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: this.props.eq_5d_sl_vas || this.props.eq_5d_sl_vas === 0 ? +this.props.eq_5d_sl_vas : undefined })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_slider___default.a, { disabled: !isEditable || getFieldValue("eq_5d_sl_vas_unknown") === true, type: "number", min: 0, max: 100, vertical: true, marks: { 0: "0", 10: "10", 20: "20", 30: "30", 40: "40", 50: "50", 60: "60", 70: "70", 80: "80", 90: "90", 100: "100" } })), !getFieldValue("eq_5d_sl_vas_unknown") && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("div", { style: { width: "30px", fontSize: "18px", marginLeft: "45px" } }, getFieldValue("eq_5d_sl_vas")))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("p", null, "The worst health you can imagine"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("label", null, getFieldDecorator("eq_5d_sl_vas_unknown", { initialValue: getFieldValue("eq_5d_sl_vas") === 999, valuePropName: "checked" })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a, { onChange: function onChange(e) {
          if (e.target.checked) {
            setFieldsValue({ eq_5d_sl_vas: 999 });
          } else {
            setFieldsValue({ eq_5d_sl_vas: 0 });
          }
        } }, "Unknown"))))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "4. Modified Rankin Scale"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 8 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Rankin Scale" }, getFieldDecorator("modified_ranking_scale", { rules: [{ required: ["in_progress", "lost", "completed", "patient_deceased"].includes(followUpStatus), message: "Required" }], initialValue: Number.isInteger(this.props.modified_ranking_scale) ? this.props.modified_ranking_scale.toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_select___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: null }, "Select"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "99" }, "Unknown"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "0" }, "0"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "1" }, "1"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "2" }, "2"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "3" }, "3"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "4" }, "4"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "5" }, "5"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(Option, { value: "6" }, "6 - Death")))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "5. Is the person back to pre-stroke status?"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, null, getFieldDecorator("has_pre_stroke_status", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: this.props.has_pre_stroke_status !== null ? __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "has_pre_stroke_status", "").toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "true" }, "Yes"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "false" }, "No")))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement("h5", { className: "headline-default" }, "6. What is the status of the follow-up?"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, null, getFieldDecorator("follow_up_status", { rules: [{ required: ["completed"].includes(followUpStatus), message: "Required" }], initialValue: this.props.follow_up_status !== null ? __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "follow_up_status", "").toString() : null })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group, { disabled: !isEditable, onChange: function onChange(e) {
          if (e.target.value === "patient_deceased") {
            _this3.props.form.setFieldsValue({ modified_ranking_scale: "6" });
          }
        } }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "not_started" }, "Not started"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "in_progress" }, "In progress"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "completed" }, "Completed"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "lost" }, "Lost in follow-up"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "consent_not_given" }, "Not required - consent not given"), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a, { value: "patient_deceased" }, "Not required - patient deceased")))))), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { label: "Comments/ Notes:" }, getFieldDecorator("event_comments", { rules: [{ required: ["in_progress", "lost"].includes(followUpStatus), message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(this.props, "event_comments") })(__WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea, { disabled: !isEditable, rows: 4 }))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.formActions }, isEditable && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_45__FollowUp90DayForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_icon___default.a, { type: "loading" })), "\xA0\xA0", __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Lock / Unlock the FollowUp" }, "Lock status: \xA0", __WEBPACK_IMPORTED_MODULE_37_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default.a, { disabled: !followUp90dUnlockPermission && locked || !followUp90dLockPermission && !locked, checked: !locked, onChange: this.onSwitchLock }))))));
    } }]);return FollowUp90DayForm;
}(__WEBPACK_IMPORTED_MODULE_37_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), followUp90dCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["C" /* getFollowUp90dCreatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(props, "site.id"))(state), followUp90dUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["G" /* getFollowUp90dUpdatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(props, "site.id"))(state), followUp90dLockPermission: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["D" /* getFollowUp90dLockPermissionBySite */])(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(props, "site.id"))(state), followUp90dUnlockPermission: Object(__WEBPACK_IMPORTED_MODULE_44__reducers_user_selectors__["F" /* getFollowUp90dUnlockPermissionBySite */])(__WEBPACK_IMPORTED_MODULE_39_lodash_get___default()(props, "site.id"))(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_46__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_29_antd_lib_form___default.a.create({ name: "followUp90Day" })(Object(__WEBPACK_IMPORTED_MODULE_41_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(FollowUp90DayForm)));

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(1825);

__webpack_require__(63);
//# sourceMappingURL=index.js.map


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1826);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-slider {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  height: 12px;\n  margin: 14px 6px 10px;\n  padding: 4px 0;\n  cursor: pointer;\n  touch-action: none;\n}\n.ant-slider-vertical {\n  width: 12px;\n  height: 100%;\n  margin: 6px 10px;\n  padding: 0 4px;\n}\n.ant-slider-vertical .ant-slider-rail {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-track {\n  width: 4px;\n}\n.ant-slider-vertical .ant-slider-handle {\n  margin-bottom: -7px;\n  margin-left: -5px;\n}\n.ant-slider-vertical .ant-slider-mark {\n  top: 0;\n  left: 12px;\n  width: 18px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-mark-text {\n  left: 4px;\n  white-space: nowrap;\n}\n.ant-slider-vertical .ant-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-dot {\n  top: auto;\n  left: 2px;\n  margin-bottom: -4px;\n}\n.ant-slider-tooltip .ant-tooltip-inner {\n  min-width: unset;\n}\n.ant-slider-with-marks {\n  margin-bottom: 28px;\n}\n.ant-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #f5f5f5;\n  border-radius: 2px;\n  transition: background-color 0.3s;\n}\n.ant-slider-track {\n  position: absolute;\n  height: 4px;\n  background-color: #c9fdff;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n.ant-slider-handle {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #c9fdff;\n  border-radius: 50%;\n  box-shadow: 0;\n  cursor: pointer;\n  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n.ant-slider-handle:focus {\n  border-color: #70e5f7;\n  outline: none;\n  box-shadow: 0 0 0 5px rgba(76, 222, 245, 0.2);\n}\n.ant-slider-handle.ant-tooltip-open {\n  border-color: #4CDEF5;\n}\n.ant-slider:hover .ant-slider-rail {\n  background-color: #e1e1e1;\n}\n.ant-slider:hover .ant-slider-track {\n  background-color: #a1f9ff;\n}\n.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n  border-color: #a1f9ff;\n}\n.ant-slider-mark {\n  position: absolute;\n  top: 14px;\n  left: 0;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.45);\n  text-align: center;\n  word-break: keep-all;\n  cursor: pointer;\n}\n.ant-slider-mark-text-active {\n  color: #424242;\n}\n.ant-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.ant-slider-dot {\n  position: absolute;\n  top: -2px;\n  width: 8px;\n  height: 8px;\n  margin-left: -4px;\n  background-color: #fff;\n  border: 2px solid #e8e8e8;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.ant-slider-dot:first-child {\n  margin-left: -4px;\n}\n.ant-slider-dot:last-child {\n  margin-left: -4px;\n}\n.ant-slider-dot-active {\n  border-color: #a6effa;\n}\n.ant-slider-disabled {\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-track {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-slider-disabled .ant-slider-handle,\n.ant-slider-disabled .ant-slider-dot {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25) !important;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-mark-text,\n.ant-slider-disabled .ant-slider-dot {\n  cursor: not-allowed !important;\n}\n", ""]);

// exports


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Slider = _interopRequireDefault(__webpack_require__(1828));

var _Range = _interopRequireDefault(__webpack_require__(1838));

var _Handle = _interopRequireDefault(__webpack_require__(568));

var _tooltip = _interopRequireDefault(__webpack_require__(64));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _this.toggleTooltipVisible = function (index, visible) {
      _this.setState(function (_ref) {
        var visibles = _ref.visibles;
        return {
          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
        };
      });
    };

    _this.handleWithTooltip = function (_a) {
      var tooltipPrefixCls = _a.tooltipPrefixCls,
          prefixCls = _a.prefixCls,
          _b = _a.info,
          value = _b.value,
          dragging = _b.dragging,
          index = _b.index,
          restProps = __rest(_b, ["value", "dragging", "index"]);

      var _this$props = _this.props,
          tipFormatter = _this$props.tipFormatter,
          tooltipVisible = _this$props.tooltipVisible,
          tooltipPlacement = _this$props.tooltipPlacement,
          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
      var visibles = _this.state.visibles;
      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
      return React.createElement(_tooltip["default"], {
        prefixCls: tooltipPrefixCls,
        title: tipFormatter ? tipFormatter(value) : '',
        visible: visible,
        placement: tooltipPlacement || 'top',
        transitionName: "zoom-down",
        key: index,
        overlayClassName: "".concat(prefixCls, "-tooltip"),
        getPopupContainer: getTooltipPopupContainer || function () {
          return document.body;
        }
      }, React.createElement(_Handle["default"], _extends({}, restProps, {
        value: value,
        onMouseEnter: function onMouseEnter() {
          return _this.toggleTooltipVisible(index, true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this.toggleTooltipVisible(index, false);
        }
      })));
    };

    _this.saveSlider = function (node) {
      _this.rcSlider = node;
    };

    _this.renderSlider = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
          range = _a.range,
          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);

      var prefixCls = getPrefixCls('slider', customizePrefixCls);
      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);

      if (range) {
        return React.createElement(_Range["default"], _extends({}, restProps, {
          ref: _this.saveSlider,
          handle: function handle(info) {
            return _this.handleWithTooltip({
              tooltipPrefixCls: tooltipPrefixCls,
              prefixCls: prefixCls,
              info: info
            });
          },
          prefixCls: prefixCls,
          tooltipPrefixCls: tooltipPrefixCls
        }));
      }

      return React.createElement(_Slider["default"], _extends({}, restProps, {
        ref: _this.saveSlider,
        handle: function handle(info) {
          return _this.handleWithTooltip({
            tooltipPrefixCls: tooltipPrefixCls,
            prefixCls: prefixCls,
            info: info
          });
        },
        prefixCls: prefixCls,
        tooltipPrefixCls: tooltipPrefixCls
      }));
    };

    _this.state = {
      visibles: {}
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "focus",
    value: function focus() {
      this.rcSlider.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSlider.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider);
    }
  }]);

  return Slider;
}(React.Component);

exports["default"] = Slider;
Slider.defaultProps = {
  tipFormatter: function tipFormatter(value) {
    return value.toString();
  }
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

var _Track = __webpack_require__(565);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(566);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(355);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var Slider = function (_React$Component) {
  (0, _inherits3['default'])(Slider, _React$Component);

  function Slider(props) {
    (0, _classCallCheck3['default'])(this, Slider);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({ dragging: false });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };

    (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }

  (0, _createClass3['default'])(Slider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({ value: nextValue });
        if (utils.isValueOutOfRange(theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? (0, _extends3['default'])({}, state, { value: this.props.max }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var val = utils.ensureValueInRange(v, mergedProps);
      return utils.ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          min = _props3.min,
          max = _props3.max,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = _react2['default'].createElement(_Track2['default'], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        reverse: reverse,
        length: offset,
        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);
  return Slider;
}(_react2['default'].Component);

Slider.propTypes = {
  defaultValue: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  disabled: _propTypes2['default'].bool,
  autoFocus: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].number,
  reverse: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number
};
exports['default'] = (0, _createSlider2['default'])(Slider);
module.exports = exports['default'];

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(1830);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(1833);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1831), __esModule: true };

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1832);
module.exports = __webpack_require__(74).Object.getPrototypeOf;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(160);
var $getPrototypeOf = __webpack_require__(422);

__webpack_require__(567)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1834), __esModule: true };

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1835);
var $Object = __webpack_require__(74).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(111);
var $getOwnPropertyDescriptor = __webpack_require__(287).f;

__webpack_require__(567)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(41);

var _extends5 = _interopRequireDefault(_extends4);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });
  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'top' : 'bottom', offset)) : (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'right' : 'left', offset));
    if (isActived) {
      style = (0, _extends5['default'])({}, style, activeDotStyle);
    }

    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));

    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
  });

  return _react2['default'].createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

Steps.propTypes = {
  prefixCls: _propTypes2['default'].string,
  activeDotStyle: _propTypes2['default'].object,
  dotStyle: _propTypes2['default'].object,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  included: _propTypes2['default'].bool,
  dots: _propTypes2['default'].bool,
  step: _propTypes2['default'].number,
  marks: _propTypes2['default'].object,
  vertical: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool
};

exports['default'] = Steps;
module.exports = exports['default'];

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = (0, _defineProperty3['default'])({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');

    var leftStyle = (0, _defineProperty3['default'])({
      transform: 'translateX(-50%)',
      msTransform: 'translateX(-50%)'
    }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
    return _react2['default'].createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return _react2['default'].createElement(
    'div',
    { className: className },
    elements
  );
};

Marks.propTypes = {
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool,
  marks: _propTypes2['default'].object,
  included: _propTypes2['default'].bool,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  min: _propTypes2['default'].number,
  onClickLabel: _propTypes2['default'].func
};

exports['default'] = Marks;
module.exports = exports['default'];

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(66);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(303);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(24);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(27);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(28);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLifecyclesCompat = __webpack_require__(38);

var _shallowequal = __webpack_require__(69);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Track = __webpack_require__(565);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(566);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(355);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var _trimAlignValue = function _trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;

  var thershold = Number(pushable);
  var valInRange = utils.ensureValueInRange(value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return utils.ensureValuePrecision(valNotConflict, props);
};

var Range = function (_React$Component) {
  (0, _inherits3['default'])(Range, _React$Component);

  function Range(props) {
    (0, _classCallCheck3['default'])(this, Range);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  (0, _createClass3['default'])(Range, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      if (this.props.min === prevProps.min && this.props.max === prevProps.max && (0, _shallowequal2['default'])(this.props.value, prevProps.value)) {
        return;
      }
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      var currentValue = value || prevState.bounds;
      if (currentValue.some(function (v) {
        return utils.isValueOutOfRange(v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return utils.ensureValueInRange(v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};

        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = (0, _extends3['default'])({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);

      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = (0, _extends3['default'])({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(value) {
      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;

      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var _tabIndex = tabIndex[i] || 0;
        if (disabled || tabIndex[i] === null) {
          _tabIndex = null;
        }
        return handleGenerator({
          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: _tabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return _react2['default'].createElement(_Track2['default'], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });
        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
        return (0, _extends3['default'])({}, state, {
          bounds: nextBounds
        });
      }
      return null;
    }
  }]);
  return Range;
}(_react2['default'].Component);

Range.displayName = 'Range';
Range.propTypes = {
  autoFocus: _propTypes2['default'].bool,
  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  count: _propTypes2['default'].number,
  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
  allowCross: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


(0, _reactLifecyclesCompat.polyfill)(Range);

exports['default'] = (0, _createSlider2['default'])(Range);
module.exports = exports['default'];

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FollowUp90DayForm__wrapper__1ba1W","submitResult":"FollowUp90DayForm__submitResult__16oxm","toggleHeadline":"FollowUp90DayForm__toggleHeadline__1KJma","collapseIcon":"FollowUp90DayForm__collapseIcon__SNKur","headlineText":"FollowUp90DayForm__headlineText__2_To8","sliderWrapper":"FollowUp90DayForm__sliderWrapper__3MTzE"};

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"FollowUp90Day__content__3QfZ_","parentContainer":"FollowUp90Day__parentContainer__1rh5O","searchWrapper":"FollowUp90Day__searchWrapper__2Qikg","searchWrapperLabel":"FollowUp90Day__searchWrapperLabel__1NjiQ"};

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_difference__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_uniq__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_MyProfileForm_MyProfileForm__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ResetProfileForm_ResetProfileForm__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ResetProfileForm_UserProfileIdForm__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__MyProfile_css__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__MyProfile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__ = __webpack_require__(36);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a.Content;var MyProfile = function (_React$Component) {
  _inherits(MyProfile, _React$Component);function MyProfile(props) {
    var _this2 = this;_classCallCheck(this, MyProfile);var _this = _possibleConstructorReturn(this, (MyProfile.__proto__ || Object.getPrototypeOf(MyProfile)).call(this, props));_this.getQR = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data, _ref3, _ref3$data, is_2fa_enabled, username, is_2fa_email_enabled, is_2fa_sms_enabled, is_2fa_mobile_app_enabled, twoFaCheckedList;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.prev = 0;_context.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_11" /* getQRCodeRequest */])();case 3:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ qrCode: data });_context.next = 14;break;case 8:
              _context.prev = 8;_context.t0 = _context["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context.t0, "response.status") === 401)) {
                _context.next = 13;break;
              }_this.props.logout();return _context.abrupt("return");case 13:
              console.log(_context.t0);case 14:
              _context.prev = 14;_context.next = 17;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_23" /* getTwoFactorRequest */])();case 17:
              _ref3 = _context.sent;_ref3$data = _ref3.data;is_2fa_enabled = _ref3$data.is_2fa_enabled;username = _ref3$data.username;is_2fa_email_enabled = _ref3$data.is_2fa_email_enabled;is_2fa_sms_enabled = _ref3$data.is_2fa_sms_enabled;is_2fa_mobile_app_enabled = _ref3$data.is_2fa_mobile_app_enabled;twoFaCheckedList = [];if (is_2fa_email_enabled) {
                twoFaCheckedList.push("Email");
              }if (is_2fa_sms_enabled) {
                twoFaCheckedList.push("SMS");
              }if (is_2fa_mobile_app_enabled) {
                twoFaCheckedList.push("Google Authenticator");
              }_this.setState({ authenticationEnabled: is_2fa_enabled, username: username, twoFaCheckedList: twoFaCheckedList });_context.next = 34;break;case 31:
              _context.prev = 31;_context.t1 = _context["catch"](14);console.log(_context.t1);case 34:
              _this.setState({ isAuthenticationRequest: false });case 35:case "end":
              return _context.stop();}
        }
      }, _callee, _this2, [[0, 8], [14, 31]]);
    }));_this.getProfile = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref5, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_this.props.setAccountInfo(_this.props.token);_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["S" /* getAccountInfoRequest */])();case 4:
              _ref5 = _context2.sent;data = _ref5.data;_this.setState({ profile: data });_context2.next = 12;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2["catch"](0);console.log(_context2.t0);case 12:case "end":
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 9]]);
    }));_this.getNotifications = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref7, data, notificationsCheckedList;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              _context3.prev = 0;_context3.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_7" /* getNotificationSettingsRequest */])();case 3:
              _ref7 = _context3.sent;data = _ref7.data;notificationsCheckedList = [];Object.keys(data).forEach(function (item) {
                if (data[item]) {
                  notificationsCheckedList.push(item.replace(/_/g, " ").replace(/^\w/, function (c) {
                    return c.toUpperCase();
                  }));
                }
              });_this.setState({ notificationsCheckedList: notificationsCheckedList });_context3.next = 13;break;case 10:
              _context3.prev = 10;_context3.t0 = _context3["catch"](0);console.log(_context3.t0);case 13:case "end":
              return _context3.stop();}
        }
      }, _callee3, _this2, [[0, 10]]);
    }));_this.onChangeNotifications = function (group) {
      return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee4(notificationsGroup) {
          var notificationsCheckedListFiltered, notifications, notificationOptions, notificationsCheckedList;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {case 0:
                  notificationsCheckedListFiltered = _this.state.notificationOptions.filter(function (opt) {
                    return _this.state.notificationsCheckedList.includes(opt.value) && opt.group !== group;
                  }).map(function (item) {
                    return item.value;
                  });notifications = __WEBPACK_IMPORTED_MODULE_21_lodash_uniq___default()([].concat(_toConsumableArray(notificationsCheckedListFiltered), _toConsumableArray(notificationsGroup)));notificationOptions = _this.state.notificationOptions;notificationsCheckedList = {};notificationOptions.forEach(function (item) {
                    notificationsCheckedList[item.key] = notifications.includes(item.value);
                  });_context4.prev = 5;_context4.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_40" /* setNotificationSettingsRequest */])(notificationsCheckedList);case 8:
                  _this.setState({ notificationsCheckedList: notifications });__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("Saved");_context4.next = 19;break;case 12:
                  _context4.prev = 12;_context4.t0 = _context4["catch"](5);if (!(__WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context4.t0, "response.status") === 401)) {
                    _context4.next = 17;break;
                  }_this.props.logout();return _context4.abrupt("return");case 17:
                  __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context4.t0, "response.data.errors._schema[0]"));console.log(_context4.t0);case 19:case "end":
                  return _context4.stop();}
            }
          }, _callee4, _this2, [[5, 12]]);
        }));return function (_x) {
          return _ref8.apply(this, arguments);
        };
      }();
    };_this.onChangeAuthentication = function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee5(checked) {
        return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                _this.setState({ isAuthenticationRequest: true });_context5.prev = 1;_context5.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_43" /* setTwoFactorRequest */])(checked ? "enable" : "disable");case 4:
                _this.setState({ authenticationEnabled: checked });__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("Saved");_context5.next = 11;break;case 8:
                _context5.prev = 8;_context5.t0 = _context5["catch"](1);_this.setState({ authError: __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context5.t0, "response.data.error") });case 11:
                _this.setState({ isAuthenticationRequest: false });case 12:case "end":
                return _context5.stop();}
          }
        }, _callee5, _this2, [[1, 8]]);
      }));return function (_x2) {
        return _ref9.apply(this, arguments);
      };
    }();_this.onProfileEdit = function () {
      _this.setState({ isProfileEdit: true });
    };_this.onProfileEditHide = function () {
      _this.setState({ isProfileEdit: false });
    };_this.onSubmitProfile = function () {
      _this.getProfile();setTimeout(function () {
        _this.onProfileEditHide();
      }, 1500);
    };_this.onChange2FA = function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee6(twoFaCheckedList) {
        var updated2FA;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {case 0:
                updated2FA = { is_2fa_mobile_app_enabled: twoFaCheckedList.includes("Google Authenticator"), is_2fa_email_enabled: twoFaCheckedList.includes("Email"), is_2fa_sms_enabled: twoFaCheckedList.includes("SMS") };_context6.prev = 1;_context6.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_73" /* updateTwoFactorMethodsRequest */])(updated2FA);case 4:
                _this.setState({ twoFaCheckedList: twoFaCheckedList });__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("Saved");_context6.next = 15;break;case 8:
                _context6.prev = 8;_context6.t0 = _context6["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context6.t0, "response.status") === 401)) {
                  _context6.next = 13;break;
                }_this.props.logout();return _context6.abrupt("return");case 13:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(_context6.t0, "response.data.errors._schema[0]"));console.log(_context6.t0);case 15:case "end":
                return _context6.stop();}
          }
        }, _callee6, _this2, [[1, 8]]);
      }));return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }();_this.onPasswordEditToggle = function () {
      _this.setState(function (state) {
        return { isPasswordEdit: !state.isPasswordEdit };
      });
    };_this.onShowUserId = function () {
      _this.setState({ showProfileCodeForm: true });
    };_this.state = { qrCode: null, authenticationEnabled: false, isAuthenticationRequest: true, authError: "", username: "", profile: null, isProfileEdit: false, isPasswordEdit: false, twoFaCheckedList: [], notificationsCheckedList: [], notificationOptions: [], profileCode: null, showProfileCodeForm: false };return _this;
  }_createClass(MyProfile, [{ key: "componentDidMount", value: function componentDidMount() {
      if (this.props.twoFactorReadPermission) {
        this.getQR();
      }this.getProfile();this.getNotifications();var notificationOptions = [];if (this.props.notificationRandomizationSummaryPermission) {
        notificationOptions.push({ key: "notification_randomization_summary", value: "Notification randomization summary", group: "randomization" });
      }if (this.props.notificationRandomizationClosedPermission) {
        notificationOptions.push({ key: "notification_randomization_closed", value: "Notification randomization closed", group: "randomization" });
      }if (this.props.notificationRandomizationDetailedPermission) {
        notificationOptions.push({ key: "notification_randomization_detailed", value: "Notification randomization detailed", group: "randomization" });
      }if (this.props.notificationConsentPermission) {
        notificationOptions.push({ key: "notification_consent", value: "Notification consent", group: "randomization" });
      }if (this.props.notificationValidateRandomizationPermission) {
        notificationOptions.push({ key: "notification_validate_randomization", value: "Notification validate randomization", group: "randomization" });
      }if (this.props.notificationValidationDiffersFromRandomizationPermission) {
        notificationOptions.push({ key: "notification_validation_differs_from_randomization", value: "Notification validation differs from randomization", group: "randomization" });
      }if (this.props.notificationValidationSaeOccurredPermission) {
        notificationOptions.push({ key: "notification_validation_sae_occurred", value: "Notification validation sae occurred", group: "randomization" });
      }if (this.props.notification2DayReminderPermission) {
        notificationOptions.push({ key: "notification_2_day_reminder", value: "Notification 2 day reminder", group: "randomization" });
      }if (this.props.notification7DayReminderPermission) {
        notificationOptions.push({ key: "notification_7_day_reminder", value: "Notification 7 day reminder", group: "randomization" });
      }if (this.props.notificationReportSummaryPermission) {
        notificationOptions.push({ key: "report_subject_summary", value: "Report subject summary", group: "randomization" });
      }if (this.props.notificationNewUserWelcomePermission) {
        notificationOptions.push({ key: "notification_new_user_welcome", value: "Notification new user welcome", group: "admin" });
      }if (this.props.notificationNewUserPermission) {
        notificationOptions.push({ key: "notification_new_user", value: "Notification new user", group: "admin" });
      }if (this.props.notificationNewSitePermission) {
        notificationOptions.push({ key: "notification_new_site", value: "Notification new site", group: "admin" });
      }if (this.props.notificationSuspendedSitePermission) {
        notificationOptions.push({ key: "notification_suspended_site", value: "Notification suspended site", group: "admin" });
      }if (this.props.notificationDeathPermission) {
        notificationOptions.push({ key: "notification_death", value: "Notification death", group: "admin" });
      }if (this.props.notification90DayFollowUpCompletedPermission) {
        notificationOptions.push({ key: "notification_90_day_follow_up_completed", value: "Notification 90 day follow up completed", group: "admin" });
      }if (this.props.notification90DayDeviationOccurredPermission) {
        notificationOptions.push({ key: "notification_90_day_deviation_occurred", value: "Notification 90 day deviation occurred", group: "admin" });
      }if (this.props.notificationDocumentPendingApprovalPermission) {
        notificationOptions.push({ key: "notification_document_pending_approval", value: "Notification document pending approval", group: "admin" });
      }if (this.props.notificationDocumentDocumentApprovedPermission) {
        notificationOptions.push({ key: "notification_document_document_approved", value: "Notification document document approved", group: "admin" });
      }if (this.props.notificationTrainingCompletedPermission) {
        notificationOptions.push({ key: "notification_training_completed", value: "Notification training completed", group: "admin" });
      }if (this.props.notificationNewsletterPermission) {
        notificationOptions.push({ key: "notification_newsletter", value: "Notification newsletter", group: "admin" });
      }if (this.props.notificationSiteRandomizationStatusChangedPermission) {
        notificationOptions.push({ key: "notification_site_randomization_status_changed", value: "Notification site randomization status changed", group: "admin" });
      }if (this.props.notificationDocumentExpirePermission) {
        notificationOptions.push({ key: "notification_document_expire", value: "Notification document expire", group: "admin" });
      }if (this.props.notificationConsentMissingReportPermission) {
        notificationOptions.push({ key: "notification_consent_missing_report", value: "Notification consent missing report", group: "admin" });
      }if (this.props.notificationUserStatusChangedPermission) {
        notificationOptions.push({ key: "notification_user_status_changed", value: "Notification user status changed", group: "admin" });
      }this.setState({ notificationOptions: notificationOptions });
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          qrCode = _state.qrCode,
          authenticationEnabled = _state.authenticationEnabled,
          isAuthenticationRequest = _state.isAuthenticationRequest,
          authError = _state.authError,
          profile = _state.profile,
          isProfileEdit = _state.isProfileEdit,
          twoFaCheckedList = _state.twoFaCheckedList,
          notificationsCheckedList = _state.notificationsCheckedList,
          isPasswordEdit = _state.isPasswordEdit,
          notificationOptions = _state.notificationOptions,
          profileCode = _state.profileCode,
          showProfileCodeForm = _state.showProfileCodeForm;var _props = this.props,
          twoFactorReadPermission = _props.twoFactorReadPermission,
          twoFactorUpdatePermission = _props.twoFactorUpdatePermission;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("title", null, "Trial Management Portal: My Profile")), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 8 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h3", { className: "headline-default" }, "My Profile"), profile && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h4", { className: "headline-default" }, "Welcome,", " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "first_name") ? __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "first_name") + " " + __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "last_name") : __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "email")), profile && profile.password_expire_days && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", { style: { color: "#555555", fontSize: "14px", marginTop: "-5px" } }, profile.password_expire_days, " days until password expire"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), twoFactorReadPermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "Enable 2 factor authentication"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default.a, { disabled: !twoFactorUpdatePermission, checked: authenticationEnabled, onChange: this.onChangeAuthentication, loading: isAuthenticationRequest }), authError && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: authError, type: "error", "class": __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.alertStyle })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), authenticationEnabled && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "2FA type:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group, { disabled: !twoFactorUpdatePermission, options: ["Google Authenticator", "Email", "SMS"], value: twoFaCheckedList, onChange: this.onChange2FA }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "QR-code for 2FA-mobile apps:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, "You can use Google Authenticator mobile app"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.qrWrapper, dangerouslySetInnerHTML: { __html: qrCode } }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "Randomization platform notifications:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group, { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.notificationGroup, options: notificationOptions.filter(function (item) {
          return item.group === "randomization";
        }).map(function (item) {
          return item.value;
        }), value: notificationsCheckedList, onChange: this.onChangeNotifications("randomization") }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "Admin notifications:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group, { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.notificationGroup, options: notificationOptions.filter(function (item) {
          return item.group === "admin";
        }).map(function (item) {
          return item.value;
        }), value: notificationsCheckedList, onChange: this.onChangeNotifications("admin") })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, !isProfileEdit ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_31__MyProfile_css___default.a.profileDetailsWrappers }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h3", { className: "headline-default" }, "Profile details"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Email:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "email")), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "First name:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "first_name") || "not indicated"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Last name:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "last_name") || "not indicated"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Timezone:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "time_zone") || "not indicated"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Short Timezone:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "short_tz") || "not indicated"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Phone number:"), " ", __WEBPACK_IMPORTED_MODULE_19_lodash_get___default()(profile, "phone_number") || "not indicated"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "primary", size: "large", onClick: this.onProfileEdit }, "Edit"))) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_MyProfileForm_MyProfileForm__["a" /* default */], Object.assign({}, profile, { onCancel: this.onProfileEditHide, onSubmit: this.onSubmitProfile })), !isProfileEdit && isPasswordEdit ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { maxWidth: "420px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_ResetProfileForm_ResetProfileForm__["a" /* default */], { myProfile: true, toggleFormVisibility: this.onPasswordEditToggle })) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "primary", size: "large", onClick: this.onPasswordEditToggle }, "Edit password")), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), profileCode ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { maxWidth: "420px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h5", { className: "headline-default" }, "User id"), profileCode) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { maxWidth: "420px" } }, showProfileCodeForm ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_ResetProfileForm_UserProfileIdForm__["a" /* default */], { onSubmit: function onSubmit(profileCode) {
          _this3.setState({ profileCode: profileCode });
        } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "primary", size: "large", onClick: this.onShowUserId }, "Show user ID"))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return MyProfile;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { token: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_65" /* getUserToken */])(state), twoFactorReadPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_57" /* getTwoFactorReadPermission */])(state), twoFactorUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_58" /* getTwoFactorUpdatePermission */])(state), notificationRandomizationSummaryPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_5" /* getNotificationRandomizationSummaryPermission */])(state), notificationRandomizationClosedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_3" /* getNotificationRandomizationClosedPermission */])(state), notificationRandomizationDetailedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_4" /* getNotificationRandomizationDetailedPermission */])(state), notificationConsentPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["U" /* getNotificationConsentPermission */])(state), notificationValidateRandomizationPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_11" /* getNotificationValidateRandomizationPermission */])(state), notificationValidationDiffersFromRandomizationPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_12" /* getNotificationValidationDiffersFromRandomizationPermission */])(state), notificationValidationSaeOccurredPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_13" /* getNotificationValidationSaeOccurredPermission */])(state), notification2DayReminderPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["P" /* getNotification2DayReminderPermission */])(state), notification7DayReminderPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["Q" /* getNotification7DayReminderPermission */])(state), notificationReportSummaryPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_6" /* getNotificationReportSummaryPermission */])(state), notificationNewUserWelcomePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_1" /* getNotificationNewUserWelcomePermission */])(state), notificationNewUserPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_0" /* getNotificationNewUserPermission */])(state), notificationNewSitePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["Z" /* getNotificationNewSitePermission */])(state), notificationSuspendedSitePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_8" /* getNotificationSuspendedSitePermission */])(state), notificationDeathPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["V" /* getNotificationDeathPermission */])(state), notification90DayFollowUpCompletedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["S" /* getNotification90DayFollowUpCompletedPermission */])(state), notification90DayDeviationOccurredPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["R" /* getNotification90DayDeviationOccurredPermission */])(state), notificationDocumentPendingApprovalPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["Y" /* getNotificationDocumentPendingApprovalPermission */])(state), notificationTrainingCompletedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_9" /* getNotificationTrainingCompletedPermission */])(state), notificationNewsletterPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_2" /* getNotificationNewsletterPermission */])(state), notificationDocumentDocumentApprovedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["W" /* getNotificationDocumentDocumentApprovedPermission */])(state), notificationSiteRandomizationStatusChangedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_7" /* getNotificationSiteRandomizationStatusChangedPermission */])(state), notificationDocumentExpirePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["X" /* getNotificationDocumentExpirePermission */])(state), notificationConsentMissingReportPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["T" /* getNotificationConsentMissingReportPermission */])(state), notificationUserStatusChangedPermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_10" /* getNotificationUserStatusChangedPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__["e" /* logout */], setAccountInfo: __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__["g" /* setAccountInfo */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_30__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(MyProfile)));

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1843),
    baseFlatten = __webpack_require__(264),
    baseRest = __webpack_require__(564),
    isArrayLikeObject = __webpack_require__(1844);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(266),
    arrayIncludes = __webpack_require__(569),
    arrayIncludesWith = __webpack_require__(570),
    arrayMap = __webpack_require__(121),
    baseUnary = __webpack_require__(156),
    cacheHas = __webpack_require__(267);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(109),
    isObjectLike = __webpack_require__(88);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(266),
    arrayIncludes = __webpack_require__(569),
    arrayIncludesWith = __webpack_require__(570),
    cacheHas = __webpack_require__(267),
    createSet = __webpack_require__(1846),
    setToArray = __webpack_require__(268);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(393),
    noop = __webpack_require__(1847),
    setToArray = __webpack_require__(268);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1847 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css__);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var timeZones = { '': null, 'America/Edmonton': 'MT', 'America/Vancouver': 'PT', 'America/Winnipeg': 'CT', 'America/Toronto': 'ET', 'America/Halifax': 'AT' };var MyProfileForm = function (_React$Component) {
  _inherits(MyProfileForm, _React$Component);function MyProfileForm(props) {
    var _this2 = this;_classCallCheck(this, MyProfileForm);var _this = _possibleConstructorReturn(this, (MyProfileForm.__proto__ || Object.getPrototypeOf(MyProfileForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var profile, errors;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 21;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;profile = Object.assign({}, values);profile.short_tz = timeZones[profile.time_zone];if (profile.time_zone === "") {
                    profile.time_zone = null;
                  }if (!profile.phone_number) {
                    delete profile['phone_number'];
                  }_context.next = 10;return Object(__WEBPACK_IMPORTED_MODULE_19__api_requests__["_55" /* updateAccountInfoRequest */])(profile);case 10:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });_this.props.onSubmit();_context.next = 21;break;case 14:
                  _context.prev = 14;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 19;break;
                  }_this.props.logout();return _context.abrupt('return');case 19:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 21:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 14]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {} };return _this;
  }_createClass(MyProfileForm, [{ key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue,
          setFieldValue = _props$form.setFieldValue;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h3', { className: 'headline-default' }, 'Edit profile'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Email'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('email', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'email') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'email' }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'First name'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('first_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'first_name') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'text' }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Last name'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('last_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'last_name') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'text' }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: 'Changing First and Last name will modify the randomization ID', type: 'warning', style: { margin: '-15px 0 10px' } })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Phone number'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('phone_number', { initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'phone_number') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'phone' }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Time Zone:'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('time_zone', { initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'time_zone', '') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: '' }, 'None'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'America/Edmonton' }, 'America/Edmonton'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'America/Vancouver' }, 'America/Vancouver'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'America/Winnipeg' }, 'America/Winnipeg'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'America/Toronto' }, 'America/Toronto'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: 'America/Halifax' }, 'America/Halifax')))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Short TZ'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('short_tz', { initialValue: timeZones[getFieldValue('time_zone')] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: true, type: 'text' }))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Type your password to confirm the changes'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('password', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(this.props, 'password') })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { type: 'password' })))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_20__MyProfileForm_css___default.a.actionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit' }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', onClick: this.props.onCancel }, 'Cancel'))));
    } }]);return MyProfileForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: 'followUp90Day' })(MyProfileForm));

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"MyProfileForm__wrapper__n3Sw6","submitResult":"MyProfileForm__submitResult__ozcW1","actionWrapper":"MyProfileForm__actionWrapper__E3QXt"};

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css__);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var ResetProfileForm = function (_React$Component) {
  _inherits(ResetProfileForm, _React$Component);function ResetProfileForm(props) {
    var _this2 = this;_classCallCheck(this, ResetProfileForm);var _this = _possibleConstructorReturn(this, (ResetProfileForm.__proto__ || Object.getPrototypeOf(ResetProfileForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 13;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["_35" /* resetPasswordProfileRequest */])(Object.assign({}, values));case 6:
                  _this.setState({ responseMessage: 'Success' });setTimeout(function () {
                    _this.props.toggleFormVisibility();
                  }, 1000);_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context['catch'](3);_this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.msg', __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.errors._schema[0]')), isLoading: false });case 13:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: '', username: '' };return _this;
  }_createClass(ResetProfileForm, [{ key: 'render', value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldsError = _props$form.getFieldsError;var _state = this.state,
          isLoading = _state.isLoading,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          checkConfirmRequestError = _state.checkConfirmRequestError,
          username = _state.username;return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('h2', { style: { color: 'rgb(40, 109, 168)' } }, 'Reset password'), username && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('p', null, 'For: ', __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('b', null, username)), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('current_password', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Current password' }))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('new_password', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'New password' }))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator('confirm_new_password', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { type: 'password', prefix: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: 'Confirm new password' })))), errorMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: errorMessage, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.alertsMb }), responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: responseMessage, type: 'success', className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.alertsMb }), checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: checkConfirmRequestError, type: 'error', className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.alertsMb }), !responseMessage && !checkConfirmRequestError && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', disabled: hasErrors(getFieldsError()), className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.submitButton }, 'Reset password', isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'loading' })))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_22__ResetProfileForm_css___default.a.submitButton, onClick: this.props.toggleFormVisibility }, 'Cancel')))));
    } }]);return ResetProfileForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_20__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_19__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: 'login' })(Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(ResetProfileForm)));

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ResetProfileForm_css__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ResetProfileForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ResetProfileForm_css__);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var UserProfileIdForm = function (_React$Component) {
  _inherits(UserProfileIdForm, _React$Component);function UserProfileIdForm(props) {
    var _this2 = this;_classCallCheck(this, UserProfileIdForm);var _this = _possibleConstructorReturn(this, (UserProfileIdForm.__proto__ || Object.getPrototypeOf(UserProfileIdForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var response, errors;return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true });if (err) {
                    _context.next = 14;break;
                  }_this.setState({ isLoading: true, errorMessage: null, responseMessage: null });_context.prev = 3;_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_18__api_requests__["T" /* getAccountProfileId */])(values.password);case 6:
                  response = _context.sent;_this.props.onSubmit(__WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(response, "data.user_id"));_context.next = 13;break;case 10:
                  _context.prev = 10;_context.t0 = _context["catch"](3);if (__WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });console.log(errors);_this.props.form.setFields(errors);
                  }case 13:
                  _this.setState({ isLoading: false });case 14:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 10]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, responseMessage: null, errorMessage: null, isSubmitted: false, checkConfirmRequestError: "", username: "" };return _this;
  }_createClass(UserProfileIdForm, [{ key: "render", value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;var isLoading = this.state.isLoading;return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_19__ResetProfileForm_css___default.a.loginForm }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, getFieldDecorator("password", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { type: "password", prefix: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: "lock", style: { color: "rgba(0,0,0,.25)" } }), placeholder: "Current password" })))), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: "primary", htmlType: "submit", size: "large", className: __WEBPACK_IMPORTED_MODULE_19__ResetProfileForm_css___default.a.submitButton }, "Show user ID", isLoading && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: "loading" })))))));
    } }]);return UserProfileIdForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userToken: Object(__WEBPACK_IMPORTED_MODULE_17__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { resetPassword: __WEBPACK_IMPORTED_MODULE_16__reducers_user_actions__["f" /* resetPassword */], loginTwoFactor: __WEBPACK_IMPORTED_MODULE_16__reducers_user_actions__["d" /* loginTwoFactor */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({ name: "UserProfileIdForm" })(Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(UserProfileIdForm)));

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"MyProfile__content__1jGMf","parentContainer":"MyProfile__parentContainer__206xX","qrWrapper":"MyProfile__qrWrapper__3BAMK","alertStyle":"MyProfile__alertStyle__1tWl0","profileDetailsWrappers":"MyProfile__profileDetailsWrappers__2lBhM","notificationGroup":"MyProfile__notificationGroup__19fkC"};

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_menu__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_dropdown_style__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_dropdown__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Enrolments_css__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__Enrolments_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_url__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__reducers_user_selectors__ = __webpack_require__(37);

























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default.a.Search;var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var renderIcon = function renderIcon(status) {
  return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.iconStatusWrapper }, status === 'green' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'check-square', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.checkIcon }), status === 'red' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'warning', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.warningIcon }), status === 'orange' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'clock-circle', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.clockIcon }), status === 'gray' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'clock-circle', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.checkIconGray }), status === 'pending' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'clock-circle', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.checkIconGray }));
};var eventList = { 'randomize': 'Randomize', 'consent': 'Consent', 'validation': 'Validation', 'deviation': 'Deviation', 'profile': 'Profile', 'registry_id': 'Registry id', 'follow_up_90_days': 'Follow up 90 days', 'sae': 'SAE', 'death': 'Death' };var Enrolments = function (_React$Component) {
  _inherits(Enrolments, _React$Component);function Enrolments(props) {
    var _this2 = this;_classCallCheck(this, Enrolments);var _this = _possibleConstructorReturn(this, (Enrolments.__proto__ || Object.getPrototypeOf(Enrolments)).call(this, props));_this.onSubjectSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ subjectID: value, filter: null, site: null, eventsSelected: {} }, _this.getSubjects);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.getSubjects = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_32__api_requests__["_22" /* getSubjectSearchRequest */])({ subjectID: _this.state.subjectID, filter_by: _this.state.filter, site_code: _this.state.site, events: Object.keys(_this.state.eventsSelected).join(','), event_status: Object.values(_this.state.eventsSelected).join(','), order_direction: _this.state.order, page: page, per_page: per_page, order_column: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_this.state, 'sortedInfo.columnKey') });case 4:
              _ref3 = _context2.sent;data = _ref3.data;if (Array.isArray(data.data)) {
                _this.setState({ subject: data.data, total: data.total_pages * per_page, currentPage: page });
              } else {
                _this.setState({ subject: [data], total: 1 * per_page, currentPage: page });
              }_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context2.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.onSubjectChange = function (e) {
      _this.setState({ subjectID: e.target.value });
    };_this.clearFilters = function () {
      _this.setState({ subjectID: null, site: null, filter: null, eventsSelected: {}, sortedInfo: null }, _this.getSubjects);
    };_this.handleFilterChange = function (value) {
      _this.setState({ filter: value, site: null, eventsSelected: {}, subjectID: null, sortedInfo: null }, _this.getSubjects);
    };_this.handleSiteChange = function (value) {
      _this.setState({ site: value, sortedInfo: null }, _this.getSubjects);
    };_this.handleOrderChange = function (value) {
      _this.setState({ order: value, sortedInfo: null }, _this.getSubjects);
    };_this.handleMenuClick = function (e) {
      if (e.key === '3') {
        _this.setState({ eventVisibleDropdown: false });
      }
    };_this.handleVisibleChange = function (flag) {
      _this.setState({ eventVisibleDropdown: flag });
    };_this.hideEventDropdown = function () {
      _this.setState({ eventVisibleDropdown: false });
    };_this.onSelectEvent = function (eventName) {
      return function () {
        _this.setState(function (state) {
          var eventsSelected = void 0;if ([true, false].includes(state.eventsSelected[eventName])) {
            eventsSelected = Object.assign({}, state.eventsSelected);delete eventsSelected[eventName];
          } else {
            eventsSelected = Object.assign({}, state.eventsSelected, _defineProperty({}, eventName, true));
          }if (eventName === 'sae') {
            if (['not_entered', 'is_occurred', 'not_occurred'].includes(state.eventsSelected[eventName])) {
              eventsSelected = Object.assign({}, state.eventsSelected);delete eventsSelected[eventName];
            } else {
              eventsSelected = Object.assign({}, state.eventsSelected, _defineProperty({}, eventName, 'not_occurred'));
            }
          }return { eventsSelected: eventsSelected, sortedInfo: null };
        }, _this.getSubjects);
      };
    };_this.onSelectEventOccured = function (eventName, value) {
      return function () {
        _this.setState(function (state) {
          var eventsSelected = state.eventsSelected[eventName] ? Object.assign({}, state.eventsSelected, _defineProperty({}, eventName, false)) : Object.assign({}, state.eventsSelected, _defineProperty({}, eventName, true));if (eventName === 'sae') {
            if (__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(state, 'eventsSelected.sae') === value) {
              eventsSelected.sae = 'not_occurred';
            } else {
              eventsSelected.sae = value;
            }
          }return { eventsSelected: eventsSelected, sortedInfo: null };
        }, _this.getSubjects);
      };
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getSubjects(pagination.current, pagination.pageSize);
      });
    };_this.state = { subject: [], subjectID: null, errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, order: 'asc', currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, eventsSelected: {}, sortedInfo: { columnKey: 'site', order: 'ascend' } };return _this;
  }_createClass(Enrolments, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, data;return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.onSubjectSearch();_context3.prev = 1;_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_32__api_requests__["_20" /* getSitesRequest */])();case 4:
                _ref5 = _context3.sent;data = _ref5.data;this.setState({ sites: data });_context3.next = 15;break;case 9:
                _context3.prev = 9;_context3.t0 = _context3['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                  _context3.next = 14;break;
                }this.props.logout();return _context3.abrupt('return');case 14:
                console.log(_context3.t0);case 15:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          subjectID = _state.subjectID,
          subject = _state.subject,
          sites = _state.sites,
          site = _state.site,
          filter = _state.filter,
          order = _state.order,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          eventVisibleDropdown = _state.eventVisibleDropdown,
          eventsSelected = _state.eventsSelected,
          sortedInfo = _state.sortedInfo;var columns = [{ dataIndex: "site", key: "site", title: "Site", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(val, 'name'));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'site' && sortedInfo.order }, { dataIndex: "code", key: "code", title: "Subject", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'View Subject Profile' }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_34__utils_url__["a" /* withParams */])(routes.admin.patientProfileSingle, { subjectID: val }) }, val));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'code' && sortedInfo.order }, { dataIndex: "profile", key: "registry_id", title: "Registry ID", render: function render(val) {
          var quicrRegistryId = __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(val, 'quicr_registry_id');var optimizeRegistryId = __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(val, 'optimize_registry_id');return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, quicrRegistryId || optimizeRegistryId ? quicrRegistryId + ' ' + (quicrRegistryId && optimizeRegistryId ? '/' : '') + ' ' + (optimizeRegistryId ? optimizeRegistryId : '') : '-');
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'registry_id' && sortedInfo.order }, { dataIndex: "randomization_date", key: "randomization_date", title: "Randomization date", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_35_moment___default.a.utc(val).tz(_this3.props.userTimezone || "UTC").format("YYYY-MM-DD HH:mm"), " ", _this3.props.userShortTimezone || "UTC");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'randomization_date' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "randomize", title: "Randomization", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'randomize';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'randomize' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "consent", title: "Consent", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'consent';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'consent' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "validation", title: "Validation", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'validation';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'validation' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "deviation", title: "Deviation", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'deviation';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'deviation' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "profile", title: "Patient profile", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'profile';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'profile' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "sae", title: "SAE", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'sae';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'sae' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "follow_up_90_days", title: "90-Day Follow UP", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, renderIcon(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'follow_up_90_days';
          }), 'status')));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'follow_up_90_days' && sortedInfo.order }, { dataIndex: "events_summary_report", key: "death", title: "Death", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_find___default()(val, function (event) {
            return event.event === 'death';
          }), 'status') !== 'none' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, 'Yes'));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(sortedInfo, 'columnKey') === 'death' && sortedInfo.order }];return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('h3', { className: 'headline-default' }, 'Enrolled Patients Summary'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Search, { placeholder: 'By subject ID', enterButton: 'Search', size: 'large', onSearch: this.onSubjectSearch, value: subjectID, onChange: this.onSubjectChange, style: { maxWidth: '500px' } })), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperFilter }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperLabel }, 'Filter by'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { onChange: this.handleFilterChange, value: filter, style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Option, { value: 'site' }, 'Site'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Option, { value: 'event' }, 'Event'))), filter === 'site' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperLabel }, 'Site'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { onChange: this.handleSiteChange, value: site, style: { width: '100%' }, placeholder: 'Select' }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Option, { key: site.id, value: site.code }, site.code, ' - ', site.name);
      }), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Option, { value: '' }, 'All sites'))), filter === 'event' && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.searchWrapperLabel }, 'Event'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_dropdown___default.a, { overlay: __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default.a, { onClick: this.handleMenuClick }, Object.keys(eventList).map(function (eventName) {
          return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default.a.Item, { key: eventName, className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.eventDropdownItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: _this3.onSelectEvent(eventName), checked: [true, false, 'not_entered', 'is_occurred', 'not_occurred'].includes(eventsSelected[eventName]) }, eventList[eventName]), eventName !== 'sae' && [true, false].includes(eventsSelected[eventName]) && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: _this3.onSelectEventOccured(eventName), checked: eventsSelected[eventName] }, 'Has occurred?')), eventName === 'sae' && ['not_entered', 'is_occurred', 'not_occurred'].includes(eventsSelected['sae']) && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: _this3.onSelectEventOccured(eventName, 'is_occurred'), checked: eventsSelected[eventName] === 'is_occurred' }, 'Has occurred?'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: _this3.onSelectEventOccured(eventName, 'not_entered'), checked: eventsSelected[eventName] === 'not_entered' }, 'Not entered')));
        }), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', size: 'small', onClick: this.hideEventDropdown }, 'Ok'))), trigger: ['click'], onVisibleChange: this.handleVisibleChange, visible: eventVisibleDropdown }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', null, Object.keys(eventsSelected).length > 0 ? Object.keys(eventsSelected).map(function (eventName, i) {
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', { key: eventName, style: { color: eventsSelected[eventName] ? '#49C850' : '#f00' } }, i !== 0 && ', ', ' ', eventList[eventName]);
      }) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, 'Select events')))), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.clearButton, onClick: this.clearFilters }, 'Clear'))), errorMessage && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a, { columns: columns, dataSource: subject, loading: isLoading, rowKey: 'id', onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), isLoading && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'loading' }), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('h4', { className: 'headline-default' }, 'Legend'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.legendItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'check-square', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.checkIcon }), ' ', __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', null, 'Complete')), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.legendItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'warning', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.warningIcon }), ' ', __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', null, 'Alert')), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.legendItem }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'clock-circle', className: __WEBPACK_IMPORTED_MODULE_30__Enrolments_css___default.a.checkIconGray }), ' ', __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', null, 'Pending'))), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Enrolments;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_36__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_36__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_33__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_31__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_26_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Enrolments)));

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Enrolments__content__3kcjQ","parentContainer":"Enrolments__parentContainer__3NvDH","searchWrapper":"Enrolments__searchWrapper__2wzZg","searchWrapperSearch":"Enrolments__searchWrapperSearch__1cfJj","searchWrapperLabel":"Enrolments__searchWrapperLabel__Lce-D","searchWrapperFilter":"Enrolments__searchWrapperFilter__I9azy","searchWrapperFilterItem":"Enrolments__searchWrapperFilterItem__1YkXP","searchWrapperFilterLabel":"Enrolments__searchWrapperFilterLabel__116LF","clearButton":"Enrolments__clearButton__3xV2H","checkIcon":"Enrolments__checkIcon__1GaFi","clockIcon":"Enrolments__clockIcon__3fimY","checkIconGray":"Enrolments__checkIconGray__1nVVw","warningIcon":"Enrolments__warningIcon__3cl_n","iconStatusWrapper":"Enrolments__iconStatusWrapper__3Hz_O","eventDropdownItem":"Enrolments__eventDropdownItem__1Jck8","legendItem":"Enrolments__legendItem__1-_Ku"};

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AdminSettings_css__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AdminSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AdminSettings_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var AdminSettings = function (_React$Component) {
  _inherits(AdminSettings, _React$Component);function AdminSettings() {
    _classCallCheck(this, AdminSettings);return _possibleConstructorReturn(this, (AdminSettings.__proto__ || Object.getPrototypeOf(AdminSettings)).apply(this, arguments));
  }_createClass(AdminSettings, [{ key: 'render', value: function render() {
      var _props = this.props,
          siteReadPermission = _props.siteReadPermission,
          roleReadPermission = _props.roleReadPermission,
          userReadPermission = _props.userReadPermission,
          consentReadPermission = _props.consentReadPermission,
          generalSettingsReadPermission = _props.generalSettingsReadPermission;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('title', null, 'Trial Management Portal: Settings')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_15__AdminSettings_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_15__AdminSettings_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3', { className: 'headline-default' }, 'Admin Settings'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb___default.a.Item, null, 'Admin Settings')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_15__AdminSettings_css___default.a.buttons }, siteReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsSites }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Site management')), roleReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsRoles }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Role management')), userReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsUsers }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'User management')), userReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsUsersBulk }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Bulk User management')), consentReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.consentEditor }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Consent management')), generalSettingsReadPermission && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Link */], { to: routes.admin.settingsGeneral }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'General Settings')))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return AdminSettings;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { siteReadPermission: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["_54" /* getSiteReadPermission */])(state), roleReadPermission: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["_35" /* getRoleReadPermission */])(state), userReadPermission: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["_62" /* getUserReadPermission */])(state), consentReadPermission: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["i" /* getConsentReadPermission */])(state), generalSettingsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_user_selectors__["J" /* getGeneralSettingsReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_13__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(AdminSettings)));

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1857);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-breadcrumb {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n.ant-breadcrumb .anticon {\n  font-size: 14px;\n}\n.ant-breadcrumb a {\n  color: rgba(0, 0, 0, 0.45);\n  transition: color 0.3s;\n}\n.ant-breadcrumb a:hover {\n  color: #78f1ff;\n}\n.ant-breadcrumb > span:last-child {\n  color: #424242;\n}\n.ant-breadcrumb > span:last-child a {\n  color: #424242;\n}\n.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {\n  display: none;\n}\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-breadcrumb-link > .anticon + span {\n  margin-left: 4px;\n}\n.ant-breadcrumb-overlay-link > .anticon {\n  margin-left: 4px;\n}\n", ""]);

// exports


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _toArray = _interopRequireDefault(__webpack_require__(443));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(572));

var _menu = _interopRequireDefault(__webpack_require__(220));

var _configProvider = __webpack_require__(30);

var _warning = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function getBreadcrumbName(route, params) {
  if (!route.breadcrumbName) {
    return null;
  }

  var paramsKeys = Object.keys(params).join('|');
  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
    return params[key] || replacement;
  });
  return name;
}

function defaultItemRender(route, params, routes, paths) {
  var isLastItem = routes.indexOf(route) === routes.length - 1;
  var name = getBreadcrumbName(route, params);
  return isLastItem ? React.createElement("span", null, name) : React.createElement("a", {
    href: "#/".concat(paths.join('/'))
  }, name);
}

function filterFragment(children) {
  return (0, _toArray["default"])(children).map(function (element) {
    if (React.isValidElement(element) && element.type === React.Fragment) {
      var props = element.props;
      return props.children;
    }

    return element;
  });
}

var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  function Breadcrumb() {
    var _this;

    _classCallCheck(this, Breadcrumb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumb).apply(this, arguments));

    _this.getPath = function (path, params) {
      path = (path || '').replace(/^\//, '');
      Object.keys(params).forEach(function (key) {
        path = path.replace(":".concat(key), params[key]);
      });
      return path;
    };

    _this.addChildPath = function (paths) {
      var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 ? arguments[2] : undefined;

      var originalPaths = _toConsumableArray(paths);

      var path = _this.getPath(childPath, params);

      if (path) {
        originalPaths.push(path);
      }

      return originalPaths;
    };

    _this.genForRoutes = function (_ref) {
      var _ref$routes = _ref.routes,
          routes = _ref$routes === void 0 ? [] : _ref$routes,
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params,
          separator = _ref.separator,
          _ref$itemRender = _ref.itemRender,
          itemRender = _ref$itemRender === void 0 ? defaultItemRender : _ref$itemRender;
      var paths = [];
      return routes.map(function (route) {
        var path = _this.getPath(route.path, params);

        if (path) {
          paths.push(path);
        } // generated overlay by route.children


        var overlay = null;

        if (route.children && route.children.length) {
          overlay = React.createElement(_menu["default"], null, route.children.map(function (child) {
            return React.createElement(_menu["default"].Item, {
              key: child.breadcrumbName || child.path
            }, itemRender(child, params, routes, _this.addChildPath(paths, child.path, params)));
          }));
        }

        return React.createElement(_BreadcrumbItem["default"], {
          overlay: overlay,
          separator: separator,
          key: route.breadcrumbName || path
        }, itemRender(route, params, routes, paths));
      });
    };

    _this.renderBreadcrumb = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;
      var crumbs;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          separator = _a.separator,
          style = _a.style,
          className = _a.className,
          routes = _a.routes,
          children = _a.children,
          restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children"]);

      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);

      if (routes && routes.length > 0) {
        // generated by route
        crumbs = _this.genForRoutes(_this.props);
      } else if (children) {
        crumbs = React.Children.map(filterFragment(children), function (element, index) {
          if (!element) {
            return element;
          }

          (0, _warning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
          return React.cloneElement(element, {
            separator: separator,
            key: index
          });
        });
      }

      return React.createElement("div", _extends({
        className: (0, _classnames["default"])(className, prefixCls),
        style: style
      }, (0, _omit["default"])(restProps, ['itemRender', 'params'])), crumbs);
    };

    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var props = this.props;
      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), 'Breadcrumb', '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb);
    }
  }]);

  return Breadcrumb;
}(React.Component);

exports["default"] = Breadcrumb;
Breadcrumb.defaultProps = {
  separator: '/'
};
Breadcrumb.propTypes = {
  prefixCls: PropTypes.string,
  separator: PropTypes.node,
  routes: PropTypes.array
};
//# sourceMappingURL=Breadcrumb.js.map


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _configProvider = __webpack_require__(30);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BreadcrumbSeparator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BreadcrumbSeparator, _React$Component);

  function BreadcrumbSeparator() {
    var _this;

    _classCallCheck(this, BreadcrumbSeparator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BreadcrumbSeparator).apply(this, arguments));

    _this.renderSeparator = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var children = _this.props.children;
      var prefixCls = getPrefixCls('breadcrumb');
      return React.createElement("span", {
        className: "".concat(prefixCls, "-separator")
      }, children || '/');
    };

    return _this;
  }

  _createClass(BreadcrumbSeparator, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSeparator);
    }
  }]);

  return BreadcrumbSeparator;
}(React.Component);

exports["default"] = BreadcrumbSeparator;
BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
//# sourceMappingURL=BreadcrumbSeparator.js.map


/***/ }),
/* 1860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"AdminSettings__content__cGG-F","buttons":"AdminSettings__buttons__9zs01"};

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_SettingsSiteForm_SettingsSiteForm__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__SettingsSites_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__ = __webpack_require__(37);





























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_23_antd_lib_input___default.a.Search;var Option = __WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a.Option;var SettingsSites = function (_React$Component) {
  _inherits(SettingsSites, _React$Component);function SettingsSites(props) {
    var _this2 = this;_classCallCheck(this, SettingsSites);var _this = _possibleConstructorReturn(this, (SettingsSites.__proto__ || Object.getPrototypeOf(SettingsSites)).call(this, props));_this.getSitesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["_16" /* getSettingsSitesRequest */])({ nameSearch: _this.state.nameSearch, order_direction: _this.state.order, order_column: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.state, 'sortedInfo.columnKey') });case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ sitesList: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context.t0, "response.status") === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt("return");case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context.t0, "response.data.error", "Error") });case 15:
              _this.setState({ isLoading: false });case 16:case "end":
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.onNameSearch = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.setState({ nameSearch: value }, _this.getSitesList);case 1:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getSitesList();
      });
    };_this.clearFilters = function () {
      _this.setState({ nameSearch: null }, _this.getSitesList);
    };_this.onSwitchSiteActivation = function (code, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.prev = 0;if (!(state === "active")) {
                  _context3.next = 6;break;
                }_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["P" /* deleteSiteRequest */])(code);case 4:
                _context3.next = 8;break;case 6:
                _context3.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["i" /* activateSiteRequest */])(code);case 8:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success("Saved");_this.getSitesList();_context3.next = 19;break;case 12:
                _context3.prev = 12;_context3.t0 = _context3["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context3.t0, "response.status") === 401)) {
                  _context3.next = 17;break;
                }_this.props.logout();return _context3.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context3.t0, "response.data.error", "Error"));console.log(_context3.t0);case 19:case "end":
                return _context3.stop();}
          }
        }, _callee3, _this2, [[0, 12]]);
      }));
    };_this.onSwitchSiteRandomization = function (code, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _context4.prev = 0;if (!state) {
                  _context4.next = 6;break;
                }_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["O" /* deleteSiteRandomizationRequest */])(code);case 4:
                _context4.next = 8;break;case 6:
                _context4.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["h" /* activateSiteRandomizationRequest */])(code);case 8:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success("Saved");_this.getSitesList();_context4.next = 19;break;case 12:
                _context4.prev = 12;_context4.t0 = _context4["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context4.t0, "response.status") === 401)) {
                  _context4.next = 17;break;
                }_this.props.logout();return _context4.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context4.t0, "response.data.error", "Error"));console.log(_context4.t0);case 19:case "end":
                return _context4.stop();}
          }
        }, _callee4, _this2, [[0, 12]]);
      }));
    };_this.onSiteEdit = function (site) {
      return function () {
        _this.setState({ siteEdit: site });
      };
    };_this.onSiteEditHide = function () {
      _this.setState({ siteEdit: null });
    };_this.onSiteEditSubmit = function () {
      _this.setState({ siteEdit: null }, _this.getSitesList);
    };_this.addSite = function () {
      _this.setState({ siteEdit: {} });
    };_this.state = { sitesList: [], errorMessage: "", responseMessage: "", siteEdit: null, nameSearch: null, sortedInfo: null, order: null };return _this;
  }_createClass(SettingsSites, [{ key: "componentDidMount", value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                this.getSitesList();case 1:case "end":
                return _context5.stop();}
          }
        }, _callee5, this);
      }));function componentDidMount() {
        return _ref6.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          sitesList = _state.sitesList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          siteEdit = _state.siteEdit,
          nameSearch = _state.nameSearch,
          sortedInfo = _state.sortedInfo;var siteCreatePermission = this.props.siteCreatePermission;var columns = [{ dataIndex: "name", key: "name", title: "Site name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", null, val, " \xA0", " ", __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.state === "active" ? "Enabled" : "Disabled", style: { backgroundColor: record.state === "active" ? "#52c41a" : "#777" } }));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'name' && sortedInfo.order }, { dataIndex: "created", key: "created", title: "Created", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", null, __WEBPACK_IMPORTED_MODULE_30_moment_timezone___default.a.utc(val).tz(_this3.props.userTimezone || __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(record, "time_zone") || "UTC").format("YYYY-MM-DD HH:mm"), " ", _this3.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(record, "short_tz") || "UTC");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'created' && sortedInfo.order }, { dataIndex: "code", key: "code", title: "Code", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'code' && sortedInfo.order }, { dataIndex: "location", key: "location", title: "Location", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'location' && sortedInfo.order }, { dataIndex: "time_zone", key: "time_zone", title: "Time zone", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", null, val, " (", record.short_tz, ")");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'time_zone' && sortedInfo.order }, { dataIndex: "consent_workflow_type", key: "consent_workflow_type", title: "Consent Workflow Type", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'consent_workflow_type' && sortedInfo.order }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, site) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Edit Site" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a, { type: "edit", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.actionIcon, onClick: _this3.onSiteEdit(site) })), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Activate / Deactivate Site" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { disabled: site.state === "active" && !_this3.props.siteDeletePermission || site.state === "inactive" && !_this3.props.siteUpdatePermission, className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.activateBtn, checked: site.state === "active", onChange: _this3.onSwitchSiteActivation(site.code, site.state) }))));
        } }, { dataIndex: "id", key: "randomization_permitted", title: "Randomization Active", render: function render(val, site) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.actions, style: { marginTop: "21px" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Activate / De-activate Site Randomization" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { disabled: site.randomization_permitted && !_this3.props.siteDeletePermission || !site.randomization_permitted && !_this3.props.siteUpdatePermission || site.state === "inactive", className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.activateBtn, checked: site.randomization_permitted, onChange: _this3.onSwitchSiteRandomization(site.code, site.randomization_permitted) })));
        } }];return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("h3", { className: "headline-default" }, "Site Management"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a.Item, { href: "/admin/settings" }, "Admin Settings"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a.Item, null, "Site Management")), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.searchWrapperLabel }, "SEARCH"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Search, { placeholder: "By name", enterButton: "Search", size: "large", onSearch: this.onNameSearch, value: nameSearch, onChange: function onChange(e) {
          _this3.setState({ nameSearch: e.target.value });
        }, style: { maxWidth: '500px' } })), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_35__SettingsSites_css___default.a.clearButton, onClick: this.clearFilters }, "Clear")), errorMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: "error", message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: "success", message: responseMessage }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a, { columns: columns, onChange: this.handleTableChange, dataSource: sitesList, loading: isLoading, rowKey: "id", pagination: false }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("br", null), siteCreatePermission && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", onClick: this.addSite }, "Add site"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!siteEdit, onCancel: this.onSiteEditHide, footer: null }, siteEdit && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_SettingsSiteForm_SettingsSiteForm__["a" /* default */], Object.assign({}, siteEdit, { isNew: siteEdit && !siteEdit.id, onSubmit: this.onSiteEditSubmit, onCancel: this.onSiteEditHide })))), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsSites;
}(__WEBPACK_IMPORTED_MODULE_27_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), siteCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_52" /* getSiteCreatePermission */])(state), siteDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_53" /* getSiteDeletePermission */])(state), siteUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_55" /* getSiteUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_38__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_36__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_29_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsSites)));

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__ = __webpack_require__(36);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var timeZones = { 'America/Edmonton': 'MT', 'America/Vancouver': 'PT', 'America/Winnipeg': 'CT', 'America/Toronto': 'ET', 'America/Halifax': 'AT' };var SettingsSiteForm = function (_React$Component) {
  _inherits(SettingsSiteForm, _React$Component);function SettingsSiteForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsSiteForm);var _this = _possibleConstructorReturn(this, (SettingsSiteForm.__proto__ || Object.getPrototypeOf(SettingsSiteForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var site, errors;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 24;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;site = Object.assign({}, values);site.short_tz = timeZones[site.time_zone];if (!_this.props.id) {
                    _context.next = 11;break;
                  }_context.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["_71" /* updateSiteRequest */])(_this.props.code, site);case 9:
                  _context.next = 13;break;case 11:
                  _context.next = 13;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["A" /* createSiteRequest */])(site);case 13:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 24;break;case 17:
                  _context.prev = 17;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 22;break;
                  }_this.props.logout();return _context.abrupt('return');case 22:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 24:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 17]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {} };return _this;
  }_createClass(SettingsSiteForm, [{ key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          siteUpdatePermission = _props.siteUpdatePermission,
          siteCreatePermission = _props.siteCreatePermission,
          id = _props.id,
          isNew = _props.isNew;var isEditable = id ? siteUpdatePermission : siteCreatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h4', { className: 'headline-default' }, this.props.id ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', null, this.props.name, ' ', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default.a, { count: 'Edit', style: { backgroundColor: '#2968AE' } })) : isNew ? 'Add site' : ''), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Code:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('code', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'code', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Code' }))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Name:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'name', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Name' })))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Consent Workflow Type:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('consent_workflow_type', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'consent_workflow_type', 'calgary') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'calgary' }, 'Type 1 - Calgary'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'edmonton' }, 'Type 2 - Edmonton'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'sunnybrook' }, 'Type 3 - Sunnybrook'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'kelowna' }, 'Type 4 - Kelowna'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'montreal' }, 'Type 5 - Montreal'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'winnipeg' }, 'Type 6 - Winnipeg'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'uhn' }, 'Type 7 - UHN - Toronto Western Hospital'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'halifax' }, 'Type 8 - Halifax'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'lhs' }, 'Type 9 - London'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'grey_nuns' }, 'Type 10 - Grey nuns'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'red_deer' }, 'Type 11 - Red Deer'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'medicine_hat' }, 'Type 12 - Medicine Hat'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'lethbridge' }, 'Type 13 - Lethbridge'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'kingston' }, 'Type 14 - Kingston'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'chus' }, 'Type 15 - CHUS'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'hamilton' }, 'Type 16 - Hamilton'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'ottawa' }, 'Type 17 - Ottawa'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'royal' }, 'Type 18 - Royal Columbian Hospital'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'royal_university' }, 'Type 19 - Royal University Hospital'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'pei' }, 'Type 20 - Pei'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'quebec_chu' }, 'Type 21 - Quebec CHU'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'vancouver' }, 'Type 22 - Vancouver'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'toronto_uh' }, 'Type 23 - Toronto ST. Michaels Unity Health '))))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 9 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Location:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('location', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'location', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Location' }))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 9 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Time Zone:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('time_zone', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'time_zone', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { disabled: !isEditable, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'America/Edmonton' }, 'America/Edmonton'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'America/Vancouver' }, 'America/Vancouver'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'America/Winnipeg' }, 'America/Winnipeg'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'America/Toronto' }, 'America/Toronto'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: 'America/Halifax' }, 'America/Halifax')))))), getFieldValue('time_zone') && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 6 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Short TZ:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { style: { marginTop: '8px' } }, timeZones[getFieldValue('time_zone')])))), requestResult.type && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_24__SettingsSiteForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel'))));
    } }]);return SettingsSiteForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { siteCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__["_52" /* getSiteCreatePermission */])(state), siteUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__["_56" /* getSiteUpdatePermissionBySite */])(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(props, 'id'))(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({ name: 'site' })(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsSiteForm)));

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsSiteForm__wrapper__2ia8M","submitResult":"SettingsSiteForm__submitResult__7Bg8E","actionWrapper":"SettingsSiteForm__actionWrapper__3-Kt-"};

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsSites__content__3QBM5","parentContainer":"SettingsSites__parentContainer__2LNgr","searchWrapper":"SettingsSites__searchWrapper__xt6wK","searchWrapperSearch":"SettingsSites__searchWrapperSearch__3EsiF","searchWrapperLabel":"SettingsSites__searchWrapperLabel__2hvhX","searchWrapperFilter":"SettingsSites__searchWrapperFilter__3nU75","activateBtn":"SettingsSites__activateBtn__5Yo3p","searchWrapperFilterItem":"SettingsSites__searchWrapperFilterItem__2S71_","searchWrapperFilterLabel":"SettingsSites__searchWrapperFilterLabel__3rT9m","clearButton":"SettingsSites__clearButton__cw2v9","checkIcon":"SettingsSites__checkIcon__1J47T","clockIcon":"SettingsSites__clockIcon__3P37L","checkIconGray":"SettingsSites__checkIconGray__3WJCx","warningIcon":"SettingsSites__warningIcon__22Zt8","iconStatusWrapper":"SettingsSites__iconStatusWrapper__3B8PO","eventDropdownItem":"SettingsSites__eventDropdownItem__3Ho52","actionIcon":"SettingsSites__actionIcon__QTLxq","actions":"SettingsSites__actions__36qPy"};

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_SettingsUserForm_SettingsUserForm__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SettingsUserTrainingForm_SettingsUserTrainingForm__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_url__ = __webpack_require__(123);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_21_antd_lib_input___default.a.Search;var SettingsUsers = function (_React$Component) {
  _inherits(SettingsUsers, _React$Component);function SettingsUsers(props) {
    var _this2 = this;_classCallCheck(this, SettingsUsers);var _this = _possibleConstructorReturn(this, (SettingsUsers.__proto__ || Object.getPrototypeOf(SettingsUsers)).call(this, props));_this.getUsersList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref2, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["_18" /* getSettingsUsersRequest */])({ nameSearch: _this.state.nameSearch, page: page, per_page: per_page, order_direction: _this.state.order, order_column: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_this.state, "sortedInfo.columnKey") });case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ usersList: data.data, total: data.total_pages * per_page, currentPage: page });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.status") === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt("return");case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, "response.data.error", "Error") });case 15:
              _this.setState({ isLoading: false });case 16:case "end":
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.onSwitchUserActivation = function (code, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;if (!(state === "active")) {
                  _context2.next = 6;break;
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["R" /* deleteUserRequest */])(code);case 4:
                _context2.next = 8;break;case 6:
                _context2.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["k" /* activateUserRequest */])(code);case 8:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success("Saved");_this.getUsersList();_context2.next = 19;break;case 12:
                _context2.prev = 12;_context2.t0 = _context2["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, "response.status") === 401)) {
                  _context2.next = 17;break;
                }_this.props.logout();return _context2.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, "response.data.error", "Error"));console.log(_context2.t0);case 19:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 12]]);
      }));
    };_this.onUserEdit = function (user) {
      return function () {
        _this.setState({ userEdit: user });
      };
    };_this.onUserTrainingEdit = function (user) {
      return function () {
        _this.setState({ userTrainingEdit: user });
      };
    };_this.onUserEditHide = function () {
      _this.setState({ userEdit: null });
    };_this.onUserTrainingEditHide = function () {
      _this.setState({ userTrainingEdit: null });
    };_this.onUserEditSubmit = function (id, userCreated) {
      _this.setState({ userEdit: null }, _this.getUsersList);console.log(id, userCreated);if (!id && userCreated) {
        _this.onUserTrainingEdit(userCreated)();
      }
    };_this.onUserTrainingEditSubmit = function () {
      _this.setState({ userTrainingEdit: null }, _this.getUsersList);
    };_this.addUser = function () {
      _this.setState({ userEdit: {} });
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sorter, "order") === "ascend" ? "asc" : __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sorter, "order") === "descend" ? "desc" : "asc" }, function () {
        return _this.getUsersList(pagination.current, pagination.pageSize);
      });
    };_this.onSubjectSearch = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee3(value) {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _this.setState({ nameSearch: value, filter: null, site: null, eventsSelected: {} }, _this.getUsersList);case 1:case "end":
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onSubjectChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.clearFilters = function () {
      _this.setState({ nameSearch: null }, _this.getUsersList);
    };_this.state = { usersList: [], errorMessage: "", responseMessage: "", userEdit: null, userTrainingEdit: null, currentPage: 1, total: 1, pageSize: 25, sites: [], additionalSiteAccess: null, sortedInfo: {}, order: null, nameSearch: null };return _this;
  }_createClass(SettingsUsers, [{ key: "componentDidMount", value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref6, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                this.getUsersList();_context4.prev = 1;_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["_20" /* getSitesRequest */])();case 4:
                _ref6 = _context4.sent;data = _ref6.data;this.setState({ sites: data });_context4.next = 15;break;case 9:
                _context4.prev = 9;_context4.t0 = _context4["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context4.t0, "response.status") === 401)) {
                  _context4.next = 14;break;
                }this.props.logout();return _context4.abrupt("return");case 14:
                console.log(_context4.t0);case 15:case "end":
                return _context4.stop();}
          }
        }, _callee4, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref5.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          usersList = _state.usersList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          userEdit = _state.userEdit,
          userTrainingEdit = _state.userTrainingEdit,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          sites = _state.sites,
          additionalSiteAccess = _state.additionalSiteAccess,
          sortedInfo = _state.sortedInfo,
          nameSearch = _state.nameSearch;var userCreatePermission = this.props.userCreatePermission;var columns = [{ dataIndex: "code", key: "code", title: "Code", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", null, val, " \xA0", " ", __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === "active" ? "#52c41a" : "#777" } }));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "code" && sortedInfo.order }, { dataIndex: "user_id", key: "user_id", title: "Randomization Platform - User ID", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "user_id" && sortedInfo.order }, { dataIndex: "username", key: "username", title: "Username", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "username" && sortedInfo.order }, { dataIndex: "first_name", key: "first_name", title: "Name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", null, val, " ", record.last_name);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "first_name" && sortedInfo.order }, { dataIndex: "email", key: "email", title: "Email", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "email" && sortedInfo.order }, { dataIndex: "last_logged_in", key: "last_logged_in", title: "Last Logged In", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", null, val ? __WEBPACK_IMPORTED_MODULE_28_moment_timezone___default.a.utc(val).tz(_this3.props.userTimezone || "UTC").format("YYYY-MM-DD HH:mm") + " " + (_this3.props.userShortTimezone || "UTC") : "No data", " ");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "last_logged_in" && sortedInfo.order }, { dataIndex: "site_access_list", key: "site_access_list", title: "Site access", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, val.slice(0, 3).map(function (item) {
            return item.state === "active" && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("p", { key: item.site.id }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, item.site.name, ":"), " ", item.user_role.name);
          }), val.length > 3 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a, { type: "primary", size: "small", htmlType: "button", onClick: function onClick() {
              return _this3.setState({ additionalSiteAccess: val.slice(3) });
            } }, "Additional site access"));
        } }, { dataIndex: "mode", key: "mode", title: "User Lock-out", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, val === true && "Automatic", val === false && "Manual", val === null && "Nothing");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(sortedInfo, "columnKey") === "mode" && sortedInfo.order }, { dataIndex: "id", key: "id", title: "Actions", render: function render(id, user) {
          return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Edit User" }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "edit", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.actionIcon, onClick: _this3.onUserEdit(user) })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Edit Training" }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "lock", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.actionIcon, onClick: _this3.onUserTrainingEdit(user) })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "User Role Management" }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_router_dom__["b" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_39__utils_url__["a" /* withParams */])(routes.admin.settingsUsersRoles, { userID: id }) }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: "control", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.roleIcon }))), "\xA0\xA0", __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Activate / Deactivate User" }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a, { disabled: user.state === "active" && !_this3.props.userDeletePermission || user.state === "inactive" && !_this3.props.userUpdatePermission, className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.reactivateBtn, checked: user.state === "active", onChange: _this3.onSwitchUserActivation(id, user.state) }))));
        } }];return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("h3", { className: "headline-default" }, "User Management"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb___default.a.Item, { href: "/admin/settings" }, "Admin Settings"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_breadcrumb___default.a.Item, null, "User Management")), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.searchWrapperLabel }, "SEARCH"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Search, { placeholder: "By subject ID", enterButton: "Search", size: "large", onSearch: this.onSubjectSearch, value: nameSearch, onChange: this.onSubjectChange, style: { maxWidth: "500px" } })), nameSearch && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_34__SettingsUsers_css___default.a.clearButton, onClick: this.clearFilters }, "Clear")), errorMessage && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: "error", message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: "success", message: responseMessage }), userCreatePermission && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a, { type: "primary", onClick: this.addUser }, "Add user"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null)), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: usersList, loading: isLoading, rowKey: "id", onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ["10", "25", "50", "100"] } }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!userEdit, onCancel: this.onUserEditHide, footer: null }, userEdit && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_SettingsUserForm_SettingsUserForm__["a" /* default */], Object.assign({}, userEdit, { isNew: userEdit && !userEdit.id, onSubmit: this.onUserEditSubmit, onCancel: this.onUserEditHide }))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!userTrainingEdit, onCancel: this.onUserTrainingEditHide, footer: null }, userTrainingEdit && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_SettingsUserTrainingForm_SettingsUserTrainingForm__["a" /* default */], Object.assign({}, userTrainingEdit, { sites: sites, isNew: userTrainingEdit && !userTrainingEdit.id, onSubmit: this.onUserTrainingEditSubmit, onCancel: this.onUserTrainingEditHide, getUsersList: this.getUsersList }))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: "Additional site access", visible: !!additionalSiteAccess, onCancel: function onCancel() {
          _this3.setState({ additionalSiteAccess: null });
        }, footer: null }, additionalSiteAccess && additionalSiteAccess.map(function (item) {
        return item.state === "active" && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("p", { key: item.site.id }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, item.site.name, ":"), " ", item.user_role.name);
      }))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsUsers;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), userCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["_59" /* getUserCreatePermission */])(state), userDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["_60" /* getUserDeletePermission */])(state), userUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["_68" /* getUserUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_37__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_35__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_27_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUsers)));

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reducers_user_actions__ = __webpack_require__(36);























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a.Option;var timeZones = { '': null, 'America/Edmonton': 'MT', 'America/Vancouver': 'PT', 'America/Winnipeg': 'CT', 'America/Toronto': 'ET', 'America/Halifax': 'AT' };function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var SettingsUserForm = function (_React$Component) {
  _inherits(SettingsUserForm, _React$Component);function SettingsUserForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsUserForm);var _this = _possibleConstructorReturn(this, (SettingsUserForm.__proto__ || Object.getPrototypeOf(SettingsUserForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var user, userCreated, _ref2, data, errors;return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 29;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;user = Object.assign({}, values);userCreated = void 0;user.short_tz = timeZones[user.time_zone];if (user.time_zone === "") {
                    user.time_zone = null;
                  }if (!_this.props.id) {
                    _context.next = 13;break;
                  }_context.next = 11;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["_74" /* updateUserRequest */])(_this.props.id, user);case 11:
                  _context.next = 18;break;case 13:
                  _context.next = 15;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["C" /* createUserRequest */])(user);case 15:
                  _ref2 = _context.sent;data = _ref2.data;userCreated = data;case 18:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id, userCreated);
                  }, 1000);_context.next = 29;break;case 22:
                  _context.prev = 22;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 27;break;
                  }_this.props.logout();return _context.abrupt('return');case 27:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 29:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 22]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {} };return _this;
  }_createClass(SettingsUserForm, [{ key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          userUpdatePermission = _props.userUpdatePermission,
          userCreatePermission = _props.userCreatePermission,
          id = _props.id,
          isNew = _props.isNew;var isEditable = id ? userUpdatePermission : userCreatePermission;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('h4', { className: 'headline-default' }, this.props.id ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span', null, this.props.username, ' ', __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_badge___default.a, { count: 'Edit', style: { backgroundColor: '#2968AE' } })) : isNew ? 'Add user' : ''), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Username:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('username', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'username', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'User name' })))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'First name:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('first_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'first_name', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Last name:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('last_name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'last_name', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: 'Changing First and Last name will modify the randomization ID', type: 'warning', style: { margin: '-15px 0 10px' } }))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Email:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('email', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'email', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Phone number:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('phone_number', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'phone_number', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: !isEditable })))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Time Zone:'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('time_zone', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'time_zone', '') })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a, { placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: '' }, 'None'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: 'America/Edmonton' }, 'America/Edmonton'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: 'America/Vancouver' }, 'America/Vancouver'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: 'America/Winnipeg' }, 'America/Winnipeg'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: 'America/Toronto' }, 'America/Toronto'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option, { value: 'America/Halifax' }, 'America/Halifax')))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Short TZ'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('short_tz', { initialValue: timeZones[getFieldValue('time_zone')] })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: true, type: 'text' })))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, isNew && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('send_password_creation_link', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'send_password_creation_link', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'Send password creation link'))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null)), isNew && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('sending_notifications', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'sending_notifications', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'Do not send out welcome and password creation e-mails?'))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('is_2fa_enabled', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'is_2fa_enabled', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'Is 2fa enabled?'))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.wrapper2faOptions }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('is_2fa_email_enabled', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'is_2fa_email_enabled', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'Email 2fa'))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('is_2fa_mobile_app_enabled', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'is_2fa_mobile_app_enabled', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'Mobile app 2fa'))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, getFieldDecorator('is_2fa_sms_enabled', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'is_2fa_sms_enabled', false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, 'SMS 2fa')))))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, !(getFieldValue('send_password_creation_link') && isNew) && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Set new password ', id && '(optional)'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('password', { rules: [{ required: !id && true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { type: 'password', disabled: !isEditable }))))), __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'user_id', '') && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null, 'Randomization Platform - User ID'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, getFieldDecorator('user_id', { initialValue: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(this.props, 'user_id', ''), rules: [{ required: id && true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, { disabled: true })))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel'))));
    } }]);return SettingsUserForm;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_25__reducers_user_selectors__["_59" /* getUserCreatePermission */])(state), userUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_25__reducers_user_selectors__["_68" /* getUserUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_27__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({ name: 'user' })(Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUserForm)));

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserForm__wrapper__1i6cE","submitResult":"SettingsUserForm__submitResult__2cNAy","actionWrapper":"SettingsUserForm__actionWrapper__klcsJ","wrapper2faOptions":"SettingsUserForm__wrapper2faOptions__2id09","formItem":"SettingsUserForm__formItem__27dmL"};

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_moment__);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var SettingsUserTrainingForm = function (_React$Component) {
  _inherits(SettingsUserTrainingForm, _React$Component);function SettingsUserTrainingForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsUserTrainingForm);var _this = _possibleConstructorReturn(this, (SettingsUserTrainingForm.__proto__ || Object.getPrototypeOf(SettingsUserTrainingForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var training, errors;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 33;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;training = void 0;if (!(values.has_training_required === 'uploaded')) {
                    _context.next = 18;break;
                  }training = new FormData();if (values.document_file && values.document_file.file) {
                    training.append('document_file', values.document_file.file);
                  }training.append('has_training_required', values.has_training_required);training.append('training_completed_date', values.training_completed_date.format('YYYY-MM-DDT') + '12:00');training.append('user_training_type', values.user_training_type);if (values.user_training_type) {
                    training.append('user_training_type_other_comments', values.user_training_type_other_comments ? values.user_training_type_other_comments : '');
                  }training.append('training_comments', values.training_comments ? values.training_comments : '');training.append('site_id', values.site_id);_context.next = 16;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["F" /* createUserTrainingUploadRequest */])(_this.props.id, training);case 16:
                  _context.next = 22;break;case 18:
                  training = Object.assign({}, values);if (values.training_completed_date) {
                    training.training_completed_date = values.training_completed_date.format('YYYY-MM-DDT') + '12:00';
                  }_context.next = 22;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["E" /* createUserTrainingRequest */])(_this.props.id, training);case 22:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.setState({ requestResult: {} });_this.props.onSubmit();
                  }, 1000);_context.next = 33;break;case 26:
                  _context.prev = 26;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 31;break;
                  }_this.props.logout();return _context.abrupt('return');case 31:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 33:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 26]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.handleResetRetries = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.setState({ retriesResetLoading: true });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_29__api_requests__["_37" /* resetUserTrainingRetriesRequest */])(id);case 4:
                _context2.next = 6;return _this.props.getUsersList();case 6:
                _this.props.onCancel();case 7:
                _context2.prev = 7;_this.setState({ retriesResetLoading: false });return _context2.finish(7);case 10:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2, [[1,, 7, 10]]);
      }));return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();_this.state = { isLoading: false, retriesResetLoading: false, requestResult: {} };return _this;
  }_createClass(SettingsUserTrainingForm, [{ key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          userUpdatePermission = _props.userUpdatePermission,
          userCreatePermission = _props.userCreatePermission,
          resetRetriesPermission = _props.resetRetriesPermission,
          id = _props.id,
          sites = _props.sites;var isEditable = id ? userUpdatePermission : userCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h4', { className: 'headline-default' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, this.props.username, ' ', __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: 'Training', style: { backgroundColor: '#2968AE' } }))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Site'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('site_id', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.site_id') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, placeholder: 'Select Site ID', style: { width: '100%' }, allowClear: true }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, ' - ', site.name);
      })))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Retries number'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.retries_number', '-')))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'User requires training'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), getFieldDecorator('has_training_required', { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.has_training_required', ''), rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a, { value: 'no' }, 'No'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a, { value: 'completed' }, 'Training already completed'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a, { value: 'uploaded' }, 'User uploaded certificate'))))), getFieldValue('has_training_required') === 'no' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Reason'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('training_not_required_comments', { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_not_required_comments', ''), rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea, null)))))), getFieldValue('has_training_required') === 'yes' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Training type'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('required_training_type', { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.required_training_type', ''), rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { disabled: !isEditable, placeholder: 'Select Site ID', style: { width: '100%' }, allowClear: true }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'type_1' }, 'Type 1'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'type_2' }, 'Type 2'))))))), getFieldValue('has_training_required') === 'completed' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Training completed date'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { display: 'flex', alignItems: 'center', width: '220px' } }, getFieldDecorator('training_completed_date', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_completed_date', null) ? __WEBPACK_IMPORTED_MODULE_33_moment___default.a.utc(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_completed_date')) : __WEBPACK_IMPORTED_MODULE_33_moment___default.a.utc(new Date()) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, { disabled: !isEditable, format: 'YYYY/MM/DD', disabledDate: function disabledDate(currentDate) {
          return currentDate.diff(__WEBPACK_IMPORTED_MODULE_33_moment___default.a.now()) > 86400000;
        } })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', { style: { width: '35px' } }, '\xA0', this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_27_lodash_find___default()(sites, function (_ref3) {
        var id = _ref3.id;return id === getFieldValue('site_id');
      }), 'short_tz') || 'UTC'))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { padding: '5px 0 0' } }, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.certificate_link') && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('a', { href: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.certificate_link'), target: '_blank' }, 'Certificate link'))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Type of training'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('user_training_type', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.user_training_type', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'siv' }, 'SIV'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'webinar' }, 'Webinar'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'self_training' }, 'Self-Training'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'in_person' }, 'In Person'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'online_quiz_type_1' }, 'Online Quiz - Type 1'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'online_quiz_type_2' }, 'Online Quiz - Type 2'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'other' }, 'Other')))))), getFieldValue('user_training_type') === 'other' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Other'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('user_training_type_other_comments', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.user_training_type_other_comments') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea, null))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Comments'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), getFieldDecorator('training_comments', { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_comments') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea, null))))), getFieldValue('has_training_required') === 'uploaded' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Training completed date'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { display: 'flex', alignItems: 'center', width: '220px' } }, getFieldDecorator('training_completed_date', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_completed_date', null) ? __WEBPACK_IMPORTED_MODULE_33_moment___default.a.utc(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_completed_date')) : __WEBPACK_IMPORTED_MODULE_33_moment___default.a.utc(new Date()) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, { disabled: !isEditable, format: 'YYYY/MM/DD', disabledDate: function disabledDate(currentDate) {
          return currentDate.diff(__WEBPACK_IMPORTED_MODULE_33_moment___default.a.now()) > 86400000;
        } })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', { style: { width: '35px' } }, '\xA0', this.props.userShortTimezone || __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_27_lodash_find___default()(sites, function (_ref4) {
        var id = _ref4.id;return id === getFieldValue('site_id');
      }), 'short_tz') || 'UTC'))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Type of training'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), getFieldDecorator('user_training_type', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.user_training_type') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'siv' }, 'SIV'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'webinar' }, 'Webinar'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'self_training' }, 'Self-Training'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'in_person' }, 'In Person'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'online_quiz_type_1' }, 'Online Quiz - Type 1'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'online_quiz_type_2' }, 'Online Quiz - Type 2'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'other' }, 'Other'))))), getFieldValue('user_training_type') === 'other' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Other'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('user_training_type_other_comments', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.user_training_type_other_comments') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea, null))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Upload certificate'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('document_file', { initialValue: '' })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a, { disabled: !isEditable, accept: '.doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif', action: '', beforeUpload: function beforeUpload() {
          return false;
        }, multiple: false, fileList: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props.form.getFieldValue('document_file'), 'fileList', []).slice(-1) }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'upload' }), !this.props.form.getFieldValue('document_file') && __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.certificate_link') ? 'Change file' : 'Add Certificate')))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { padding: '5px 0 0' } }, !this.props.form.getFieldValue('document_file') && __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.certificate_link') && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('a', { href: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.certificate_link'), target: '_blank' }, 'Certificate link'))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 24 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.formItem }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Comments'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), getFieldDecorator('training_comments', { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.training_comments') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea, null))))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'default', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'training.retries_number') > 0 && resetRetriesPermission && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Fragment, null, '\xA0 \xA0', __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { loading: this.state.retriesResetLoading, type: 'default', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserTrainingForm_css___default.a.submitButton, onClick: function onClick() {
          return _this3.handleResetRetries(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_this3.props, 'training.id'));
        } }, 'Reset training retries')))));
    } }]);return SettingsUserTrainingForm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), userCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_59" /* getUserCreatePermission */])(state), userUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_68" /* getUserUpdatePermission */])(state), resetRetriesPermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_67" /* getUserTrainingResetPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.create({ name: 'user' })(Object(__WEBPACK_IMPORTED_MODULE_28_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUserTrainingForm)));

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserTrainingForm__wrapper__1j_UY","submitResult":"SettingsUserTrainingForm__submitResult__1T7Wq","actionWrapper":"SettingsUserTrainingForm__actionWrapper__wLOzM","wrapper2faOptions":"SettingsUserTrainingForm__wrapper2faOptions__20i_l","formItem":"SettingsUserTrainingForm__formItem__1rGl9"};

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsUsers__content__35whO","parentContainer":"SettingsUsers__parentContainer__19HXN","searchWrapper":"SettingsUsers__searchWrapper__1F-Ax","searchWrapperSearch":"SettingsUsers__searchWrapperSearch__96gAQ","searchWrapperLabel":"SettingsUsers__searchWrapperLabel__Xmetn","searchWrapperFilter":"SettingsUsers__searchWrapperFilter__1QTj1","searchWrapperFilterItem":"SettingsUsers__searchWrapperFilterItem__3rKSb","searchWrapperFilterLabel":"SettingsUsers__searchWrapperFilterLabel__2kK0Q","clearButton":"SettingsUsers__clearButton__QZbma","checkIcon":"SettingsUsers__checkIcon__-nq1O","clockIcon":"SettingsUsers__clockIcon__26qsi","checkIconGray":"SettingsUsers__checkIconGray__16DLU","warningIcon":"SettingsUsers__warningIcon__3QlGJ","iconStatusWrapper":"SettingsUsers__iconStatusWrapper__vJj3j","eventDropdownItem":"SettingsUsers__eventDropdownItem__qb_8o","actionIcon":"SettingsUsers__actionIcon__Ra7aJ","reactivateBtn":"SettingsUsers__reactivateBtn__3o80t","roleIcon":"SettingsUsers__roleIcon__2j_Qx","actions":"SettingsUsers__actions__Yzj_1"};

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_isEqual__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_sortBy__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_CopySitePermissionsForm_CopySitePermissionsForm__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_CopyUserPermissionsForm_CopyUserPermissionsForm__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_CopyUserPermissionsMultiSitesForm_CopyUserPermissionsMultiSitesForm__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__ = __webpack_require__(37);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a.Content;var SiteCell = __WEBPACK_IMPORTED_MODULE_17_react___default.a.memo(function (_ref) {
  var user = _ref.user,
      site = _ref.site,
      loading = _ref.loading,
      form = _ref.form,
      updateUserRole = _ref.updateUserRole,
      findUserSiteAccess = _ref.findUserSiteAccess,
      rolesList = _ref.rolesList;var siteAccess = findUserSiteAccess({ user: user, site: site });return form.getFieldDecorator("user_" + user.id + "_site_" + site.id, { initialValue: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(siteAccess, "state") === "active" ? __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(siteAccess, "user_role.id") : null })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.roleSelect, loading: loading ? loading.isLoading : false, disabled: loading ? loading.isLoading : false, onChange: function onChange(value) {
      return updateUserRole({ user: user, siteAccessId: siteAccess ? siteAccess.id : null, site: site, roleId: value });
    } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option, { value: null }, "\xA0"), rolesList.map(function (role) {
    return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option, { value: role.id, key: role.id }, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(siteAccess, "user_role.id") === role.id && __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(siteAccess, "state") === "inactive" ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.inactiveRole }, role.name, " - Status: Inactive") : role.name);
  })));
}, function (prevProps, nextProps) {
  var userNotUpdated = __WEBPACK_IMPORTED_MODULE_19_lodash_isEqual___default()(prevProps.user, nextProps.user);var loadingNotUpdated = __WEBPACK_IMPORTED_MODULE_19_lodash_isEqual___default()(prevProps.loading, nextProps.loading);return userNotUpdated && loadingNotUpdated;
});var SettingsUsersBulk = function (_React$Component) {
  _inherits(SettingsUsersBulk, _React$Component);function SettingsUsersBulk(props) {
    var _this2 = this;_classCallCheck(this, SettingsUsersBulk);var _this = _possibleConstructorReturn(this, (SettingsUsersBulk.__proto__ || Object.getPrototypeOf(SettingsUsersBulk)).call(this, props));_this.generateSiteCells = function () {
      var filteredSites = _this.state.sitesFilter.length === 0 ? _this.state.sites : _this.state.sites.filter(function (item) {
        return _this.state.sitesFilter.includes(item.id);
      });var siteCells = __WEBPACK_IMPORTED_MODULE_22_lodash_sortBy___default()(filteredSites, "id").map(function (item) {
        return { dataIndex: "site_" + item.id, key: "site_" + item.id, title: item.name, render: function render(val, record) {
            var itemLoading = __WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(_this.state.loadingItems, function (loadingItem) {
              return loadingItem.userId === record.id && loadingItem.siteId === item.id;
            });return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(SiteCell, { user: record, site: item, loading: itemLoading, form: _this.props.form, updateUserRole: _this.updateUserRole, findUserSiteAccess: _this.findUserSiteAccess, rolesList: _this.state.rolesList });
          } };
      });_this.setState({ siteCells: siteCells });
    };_this.getData = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref3, _ref4, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.prev = 0;_context.next = 3;return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_20" /* getSitesRequest */])(), _this.getUsersList(), _this.getRolesList()]);case 3:
              _ref3 = _context.sent;_ref4 = _slicedToArray(_ref3, 1);data = _ref4[0].data;_this.setState({ sites: data, isInitialLoading: false });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.status") === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt("return");case 14:
              console.log(_context.t0);case 15:case "end":
              return _context.stop();}
        }
      }, _callee, _this2, [[0, 9]]);
    }));_this.findUserSiteAccess = function (_ref5) {
      var user = _ref5.user,
          site = _ref5.site;return __WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(user.site_access_list, function (siteAccess) {
        return siteAccess.site.id === site.id;
      });
    };_this.updateUserRole = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6) {
        var user = _ref6.user,
            siteAccessId = _ref6.siteAccessId,
            site = _ref6.site,
            roleId = _ref6.roleId;var _ref8, users, _refetchedUser, siteAccess, _ref9, refetchedUser;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (_this.state.loadingItems.findIndex(function (item) {
                  return item.userId === user.id && item.siteId === site.id;
                }) > -1) {
                  _this.updateLoadingItem({ userId: user.id, siteId: site.id, isLoading: true });
                } else {
                  _this.setState({ loadingItems: [].concat(_toConsumableArray(_this.state.loadingItems), [{ userId: user.id, siteId: site.id, isLoading: true }]) });
                }_context2.prev = 1;if (roleId) {
                  _context2.next = 7;break;
                }_context2.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_46" /* toggleUserActivateRoleRequest */])(user.id, siteAccessId, "active");case 5:
                _context2.next = 24;break;case 7:
                if (siteAccessId) {
                  _context2.next = 12;break;
                }_context2.next = 10;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["D" /* createUserRoleRequest */])(user.id, { site_id: site.id, user_role_id: roleId });case 10:
                _context2.next = 24;break;case 12:
                _context2.next = 14;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_75" /* updateUserRoleRequest */])(user.id, siteAccessId, { user_id: user.id, site_id: site.id, user_role_id: roleId });case 14:
                _context2.next = 16;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_18" /* getSettingsUsersRequest */])({ page: _this.state.currentPage, per_page: _this.state.pageSize });case 16:
                _ref8 = _context2.sent;users = _ref8.data.data;_refetchedUser = __WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(users, function (item) {
                  return item.id === user.id;
                });if (!_refetchedUser) {
                  _context2.next = 24;break;
                }siteAccess = _this.findUserSiteAccess({ user: _refetchedUser, site: site });if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(siteAccess, "state") === "inactive")) {
                  _context2.next = 24;break;
                }_context2.next = 24;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_46" /* toggleUserActivateRoleRequest */])(user.id, siteAccessId, "inactive");case 24:
                _context2.next = 26;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_17" /* getSettingsUserSingleRequest */])(user.id);case 26:
                _ref9 = _context2.sent;refetchedUser = _ref9.data;_this.setState({ usersList: _this.state.usersList.map(function (item) {
                    return item.id === user.id ? Object.assign({}, item, { site_access_list: refetchedUser.site_access_list }) : item;
                  }) });_context2.next = 37;break;case 31:
                _context2.prev = 31;_context2.t0 = _context2["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context2.t0, "response.status") === 401)) {
                  _context2.next = 36;break;
                }_this.props.logout();return _context2.abrupt("return");case 36:
                _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context2.t0, "response.data.error", "Error") });case 37:
                _context2.prev = 37;_this.updateLoadingItem({ userId: user.id, siteId: site.id, isLoading: false });return _context2.finish(37);case 40:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2, [[1, 31, 37, 40]]);
      }));return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }();_this.updateLoadingItem = function (_ref10) {
      var userId = _ref10.userId,
          siteId = _ref10.siteId,
          isLoading = _ref10.isLoading;_this.setState({ loadingItems: _this.state.loadingItems.map(function (item) {
          return item.userId === userId && item.siteId === siteId ? Object.assign({}, item, { isLoading: isLoading }) : item;
        }) });
    };_this.getRolesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref12, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context3.prev = 1;_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_12" /* getRolesLight */])();case 4:
              _ref12 = _context3.sent;data = _ref12.data;_this.setState({ rolesList: data });_context3.next = 15;break;case 9:
              _context3.prev = 9;_context3.t0 = _context3["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context3.t0, "response.status") === 401)) {
                _context3.next = 14;break;
              }_this.props.logout();return _context3.abrupt("return");case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context3.t0, "response.data.error", "Error") });case 15:
              _this.setState({ isLoading: false });case 16:case "end":
              return _context3.stop();}
        }
      }, _callee3, _this2, [[1, 9]]);
    }));_this.getUsersList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref14, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context4.prev = 1;_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_18" /* getSettingsUsersRequest */])({ page: page, per_page: per_page, filter_by: _this.state.userFilter ? "user" : null, user_id: _this.state.userFilter });case 4:
              _ref14 = _context4.sent;data = _ref14.data;_this.setState({ usersList: data.data, total: data.total_pages * per_page, currentPage: page });_context4.next = 15;break;case 9:
              _context4.prev = 9;_context4.t0 = _context4["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context4.t0, "response.status") === 401)) {
                _context4.next = 14;break;
              }_this.props.logout();return _context4.abrupt("return");case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context4.t0, "response.data.error", "Error") });case 15:
              _this.setState({ isLoading: false });case 16:case "end":
              return _context4.stop();}
        }
      }, _callee4, _this2, [[1, 9]]);
    }));_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter }, function () {
        return _this.getUsersList(pagination.current, pagination.pageSize);
      });
    };_this.onCopySiteShow = function () {
      _this.setState({ isCopySiteModal: true });
    };_this.onCopySiteHide = function () {
      _this.setState({ isCopySiteModal: false });
    };_this.onCopySiteSubmit = function () {
      _this.getData();_this.onCopySiteHide();
    };_this.onCopyUserShow = function () {
      _this.setState({ isCopyUserModal: true });
    };_this.onCopyUserHide = function () {
      _this.setState({ isCopyUserModal: false });
    };_this.onCopyUserSubmit = function () {
      _this.getData();_this.onCopyUserHide();
    };_this.onCopyUserMultiShow = function () {
      _this.setState({ isCopyUserMultiModal: true });
    };_this.onCopyUserMultiHide = function () {
      _this.setState({ isCopyUserMultiModal: false });
    };_this.onCopyUserMultiSubmit = function () {
      _this.getData();_this.onCopyUserMultiHide();
    };_this.state = { usersList: [], rolesList: [], errorMessage: "", responseMessage: "", userEdit: null, userTrainingEdit: null, currentPage: 1, total: 1, pageSize: 10, sites: [], isLoading: false, isInitialLoading: true, loadingItems: [], sitesFilter: [], users: [], userFilter: null, siteCells: [], isCopySiteModal: false, isCopyUserModal: false, isCopyUserMultiModal: false };return _this;
  }_createClass(SettingsUsersBulk, [{ key: "componentDidMount", value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref16, users;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                this.getData();_context5.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_30__api_requests__["_25" /* getUsersLight */])();case 3:
                _ref16 = _context5.sent;users = _ref16.data;this.setState({ users: users });case 6:case "end":
                return _context5.stop();}
          }
        }, _callee5, this);
      }));function componentDidMount() {
        return _ref15.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "componentDidUpdate", value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.sitesFilter.length !== this.state.sitesFilter.length || prevState.sites.length !== this.state.sites.length) {
        this.generateSiteCells();
      }
    } }, { key: "columns", value: function columns() {
      return [{ dataIndex: "user_id", key: "user_id", title: "User", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.userColWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.userCol }, record.first_name, " ", record.last_name, " ", record.email, " (ID ", val, ")"));
        } }].concat(_toConsumableArray(this.state.siteCells));
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          usersList = _state.usersList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          isInitialLoading = _state.isInitialLoading,
          isCopySiteModal = _state.isCopySiteModal,
          isCopyUserModal = _state.isCopyUserModal,
          isCopyUserMultiModal = _state.isCopyUserMultiModal,
          rolesList = _state.rolesList,
          sites = _state.sites,
          users = _state.users;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h3", { className: "headline-default" }, "Bulk User Management"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a.Item, { href: "/admin/settings" }, "Admin Settings"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a.Item, null, "Bulk User Management")), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null), errorMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, { type: "error", message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, { type: "success", message: responseMessage }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.siteSearchContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.searchWrapperLabel }, "Sites Filter"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { mode: "multiple", showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }, className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.siteSearchSelect, onChange: function onChange(value) {
          return _this3.setState({ sitesFilter: value });
        }, placeholder: "Select Sites" }, this.state.sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option, { key: site.id, value: site.id }, site.code + " - " + site.name);
      }))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.siteSearchContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.searchWrapperLabel }, "User Filter"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a, { showSearch: true, optionFilterProp: "children", className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.siteSearchSelect, onChange: function onChange(value) {
          return _this3.setState(function () {
            return { userFilter: value };
          }, function () {
            _this3.getUsersList();
          });
        }, placeholder: "Select User" }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option, { value: null }, "None"), users.map(function (users) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option, { key: users.id, value: users.id }, users.username);
      }))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.copyContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: "primary", onClick: this.onCopySiteShow }, "Copy site permissions"), "\xA0", __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: "primary", onClick: this.onCopyUserShow }, "Copy user permissions"), "\xA0", __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: "primary", onClick: this.onCopyUserMultiShow }, "Add/remove user permission to multiple sites")), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_28__SettingsUsersBulk_css___default.a.tableContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a, { columns: this.columns(), dataSource: usersList, loading: isLoading || isInitialLoading, rowKey: "id", onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ["10", "25", "50", "100"] } })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a, { visible: !!isCopySiteModal, onCancel: this.onCopySiteHide, footer: null }, isCopySiteModal && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_CopySitePermissionsForm_CopySitePermissionsForm__["a" /* default */], { onCancel: this.onCopySiteHide, onSubmit: this.onCopySiteSubmit })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a, { visible: !!isCopyUserModal, onCancel: this.onCopyUserHide, footer: null }, isCopyUserModal && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_CopyUserPermissionsForm_CopyUserPermissionsForm__["a" /* default */], { onCancel: this.onCopyUserHide, onSubmit: this.onCopyUserSubmit })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a, { visible: !!isCopyUserMultiModal, onCancel: this.onCopyUserMultiHide, footer: null }, isCopyUserMultiModal && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_CopyUserPermissionsMultiSitesForm_CopyUserPermissionsMultiSitesForm__["a" /* default */], { sitesList: sites, rolesList: rolesList, onCancel: this.onCopyUserMultiHide, onSubmit: this.onCopyUserMultiSubmit }))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsUsersBulk;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), userCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_59" /* getUserCreatePermission */])(state), userDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_60" /* getUserDeletePermission */])(state), userUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_68" /* getUserUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.create({ name: "test" })(Object(__WEBPACK_IMPORTED_MODULE_29__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUsersBulk))));

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(265);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_uniq__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_user_actions__ = __webpack_require__(36);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;var CopySitePermissionsForm = function (_React$Component) {
  _inherits(CopySitePermissionsForm, _React$Component);function CopySitePermissionsForm(props) {
    var _this2 = this;_classCallCheck(this, CopySitePermissionsForm);var _this = _possibleConstructorReturn(this, (CopySitePermissionsForm.__proto__ || Object.getPrototypeOf(CopySitePermissionsForm)).call(this, props));_this.handleKeyDown = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: true });
      }
    };_this.handleKeyUp = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: false });
      }
    };_this.onTargetKeyChange = function (index, key) {
      return function (e) {
        var isChecked = e.target.checked;var _this$state = _this.state,
            rolesKeys = _this$state.rolesKeys,
            roles = _this$state.roles,
            shiftDown = _this$state.shiftDown;if (rolesKeys.length && shiftDown) {
          var lastCheckedItemIndex = roles.findIndex(function (item) {
            return item.key === rolesKeys[rolesKeys.length - 1];
          });var newItems = [];if (lastCheckedItemIndex < index) {
            newItems = roles.reduce(function (result, item, itemIndex) {
              return itemIndex > lastCheckedItemIndex && itemIndex <= index ? [].concat(_toConsumableArray(result), [item.key]) : result;
            }, []);
          } else {
            newItems = roles.reduce(function (result, item, itemIndex) {
              return itemIndex < lastCheckedItemIndex && itemIndex >= index ? [].concat(_toConsumableArray(result), [item.key]) : result;
            }, []);
          }_this.setState(function (_ref) {
            var rolesKeys = _ref.rolesKeys;return { rolesKeys: __WEBPACK_IMPORTED_MODULE_19_lodash_uniq___default()([].concat(_toConsumableArray(rolesKeys), _toConsumableArray(newItems))) };
          });
        } else {
          _this.setState(function (_ref2) {
            var rolesKeys = _ref2.rolesKeys;return { rolesKeys: isChecked ? __WEBPACK_IMPORTED_MODULE_19_lodash_uniq___default()([].concat(_toConsumableArray(rolesKeys), [key])) : __WEBPACK_IMPORTED_MODULE_19_lodash_uniq___default()(rolesKeys.filter(function (item) {
                return item !== key;
              })) };
          });
        }
      };
    };_this.handleSubmit = function (e) {
      e.preventDefault();var rolesKeys = _this.state.rolesKeys; // const rolesChecked = Object.keys(this.state.rolesChecked)
      //   .filter((key) => !!this.state.rolesChecked[key])
      //   .map((key) => +key);
      _this.props.form.validateFields(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 19;break;
                  }if (rolesKeys.length) {
                    _context.next = 5;break;
                  }_this.setState({ requestResult: { type: "warning", message: "Please, select role to copy" } });return _context.abrupt("return");case 5:
                  _this.setState({ isLoading: true });_context.prev = 6;_this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });_context.next = 10;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["o" /* copyBulkSitePermissions */])({ from_site_id: values.from_site_id, to_site_id: values.to_site_id, from_user_roles_ids: rolesKeys });case 10:
                  setTimeout(function () {
                    _this.props.onSubmit();
                  }, 1000);_context.next = 19;break;case 13:
                  _context.prev = 13;_context.t0 = _context["catch"](6);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 18;break;
                  }_this.props.logout();return _context.abrupt("return");case 18:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.data.message", "Error") } });case 19:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[6, 13]]);
        }));return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    };_this.getSiteRoles = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2(siteId) {
        var _ref5, roles;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.setState({ roles: [] });_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["V" /* getBulkSiteRoles */])(siteId);case 3:
                _ref5 = _context2.sent;roles = _ref5.data;_this.setState({ roles: roles.map(function (role) {
                    return { key: role.id, name: role.name, chosen: false };
                  }) });case 6:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();_this.state = { isLoading: false, requestResult: {}, sites: [], roles: [], rolesKeys: [], shiftDown: false };return _this;
  }_createClass(CopySitePermissionsForm, [{ key: "componentDidMount", value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref7, sites;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["W" /* getBulkSites */])();case 2:
                _ref7 = _context3.sent;sites = _ref7.data;this.setState({ sites: sites });document.addEventListener("keydown", this.handleKeyDown);document.addEventListener("keyup", this.handleKeyUp);case 7:case "end":
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref6.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "componentWillUnmount", value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);document.removeEventListener("keyup", this.handleKeyUp);
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          sites = _state.sites,
          roles = _state.roles,
          rolesKeys = _state.rolesKeys;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h4", { className: "headline-default" }, "Copy site permissions"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Source site:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("from_site_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select Site", onChange: this.getSiteRoles, showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: site.id, value: site.id, disabled: getFieldValue("to_site_id") === site.id }, site.code, " - ", site.name);
      })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Destination site:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("to_site_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select Site", showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: site.id, value: site.id, disabled: getFieldValue("from_site_id") === site.id }, site.code, " - ", site.name);
      }))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, roles.length > 0 && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { paddingBottom: "12px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: function onChange(e) {
          if (e.target.checked) {
            _this3.setState(function () {
              return { rolesKeys: roles.map(function (_ref8) {
                  var key = _ref8.key;return key;
                }) };
            });
          } else {
            _this3.setState(function () {
              return { rolesKeys: [] };
            });
          }
        } }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "\xA0 Check all \xA0 (", rolesKeys.length, "/", roles.length, ")"))), roles.map(function (_ref9, i) {
        var key = _ref9.key,
            name = _ref9.name;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { key: key, style: { paddingBottom: "4px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { checked: rolesKeys.findIndex(function (targetKey) {
            return targetKey === key;
          }) > -1, onChange: _this3.onTargetKeyChange(i, key) }), "\xA0", name));
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null))), requestResult.type && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default.a.actionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default.a.submitButton, disabled: isLoading }, "Submit", isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_22__CopySitePermissionsForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"), "\xA0 \xA0"))));
    } }]);return CopySitePermissionsForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(_) {
  return {};
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_23__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: "drugShip" })(Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(CopySitePermissionsForm)));

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopySitePermissionsForm__wrapper__32bBd","submitResult":"CopySitePermissionsForm__submitResult__y-dyU","actionWrapper":"CopySitePermissionsForm__actionWrapper__2ZdqJ","wrapper2faOptions":"CopySitePermissionsForm__wrapper2faOptions__GpW1o"};

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_uniq__);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;var CopyUserPermissionsForm = function (_React$Component) {
  _inherits(CopyUserPermissionsForm, _React$Component);function CopyUserPermissionsForm(props) {
    var _this2 = this;_classCallCheck(this, CopyUserPermissionsForm);var _this = _possibleConstructorReturn(this, (CopyUserPermissionsForm.__proto__ || Object.getPrototypeOf(CopyUserPermissionsForm)).call(this, props));_this.handleKeyDown = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: true });
      }
    };_this.handleKeyUp = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: false });
      }
    };_this.onTargetKeyChange = function (index, key) {
      return function (e) {
        var isChecked = e.target.checked;var _this$state = _this.state,
            sitesKeys = _this$state.sitesKeys,
            sites = _this$state.sites,
            shiftDown = _this$state.shiftDown;if (sitesKeys.length && shiftDown) {
          var lastCheckedItemIndex = sites.findIndex(function (item) {
            return item.key === sitesKeys[sitesKeys.length - 1];
          });var newItems = [];if (lastCheckedItemIndex < index) {
            newItems = sites.reduce(function (result, item, itemIndex) {
              return itemIndex > lastCheckedItemIndex && itemIndex <= index ? [].concat(_toConsumableArray(result), [item.key]) : result;
            }, []);
          } else {
            newItems = sites.reduce(function (result, item, itemIndex) {
              return itemIndex < lastCheckedItemIndex && itemIndex >= index ? [].concat(_toConsumableArray(result), [item.key]) : result;
            }, []);
          }_this.setState(function (_ref) {
            var sitesKeys = _ref.sitesKeys;return { sitesKeys: __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()([].concat(_toConsumableArray(sitesKeys), _toConsumableArray(newItems))) };
          });
        } else {
          _this.setState(function (_ref2) {
            var sitesKeys = _ref2.sitesKeys;return { sitesKeys: isChecked ? __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()([].concat(_toConsumableArray(sitesKeys), [key])) : __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()(sitesKeys.filter(function (item) {
                return item !== key;
              })) };
          });
        }
      };
    };_this.handleSubmit = function (e) {
      e.preventDefault();var sitesKeys = _this.state.sitesKeys;_this.props.form.validateFields(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 19;break;
                  }if (sitesKeys.length) {
                    _context.next = 5;break;
                  }_this.setState({ requestResult: { type: "warning", message: "Please, select role to copy" } });return _context.abrupt("return");case 5:
                  _this.setState({ isLoading: true });_context.prev = 6;_this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });_context.next = 10;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["p" /* copyBulkUserPermissions */])({ from_user_id: values.from_user_id, to_user_id: values.to_user_id, from_site_ids: sitesKeys });case 10:
                  setTimeout(function () {
                    _this.props.onSubmit();
                  }, 1000);_context.next = 19;break;case 13:
                  _context.prev = 13;_context.t0 = _context["catch"](6);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 18;break;
                  }_this.props.logout();return _context.abrupt("return");case 18:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.data.message", "Error") } });case 19:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[6, 13]]);
        }));return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    };_this.getUserSites = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2(userId) {
        var _ref5, sites;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.setState({ sites: [] });_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["_24" /* getUserSites */])(userId);case 3:
                _ref5 = _context2.sent;sites = _ref5.data;_this.setState({ sites: sites.map(function (site) {
                    return { key: site.id, name: site.name, chosen: false };
                  }) });case 6:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();_this.state = { isLoading: false, requestResult: {}, users: [], sites: [], sitesKeys: [], shiftDown: false };return _this;
  }_createClass(CopyUserPermissionsForm, [{ key: "componentDidMount", value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref7, users;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["_25" /* getUsersLight */])();case 2:
                _ref7 = _context3.sent;users = _ref7.data;this.setState({ users: users });document.addEventListener("keydown", this.handleKeyDown);document.addEventListener("keyup", this.handleKeyUp);case 7:case "end":
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref6.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "componentWillUnmount", value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);document.removeEventListener("keyup", this.handleKeyUp);
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          users = _state.users,
          sites = _state.sites,
          sitesKeys = _state.sitesKeys;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h4", { className: "headline-default" }, "Copy user permissions"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Source user:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("from_user_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select User", onChange: this.getUserSites, showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, users.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: user.id, value: user.id, disabled: getFieldValue("to_user_id") === user.id }, user.username);
      })))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Destination user:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("to_user_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select User", showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, users.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: user.id, value: user.id, disabled: getFieldValue("from_user_id") === user.id }, user.username);
      }))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, sites.length > 0 && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { paddingBottom: "12px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: function onChange(e) {
          if (e.target.checked) {
            _this3.setState(function () {
              return { sitesKeys: sites.map(function (_ref8) {
                  var key = _ref8.key;return key;
                }) };
            });
          } else {
            _this3.setState(function () {
              return { sitesKeys: [] };
            });
          }
        } }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "\xA0 Check all \xA0 (", sitesKeys.length, "/", sites.length, ")"))), sites.map(function (_ref9, i) {
        var key = _ref9.key,
            name = _ref9.name;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { key: key, style: { paddingBottom: "4px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { checked: sitesKeys.findIndex(function (targetKey) {
            return targetKey === key;
          }) > -1, onChange: _this3.onTargetKeyChange(i, key) }), "\xA0", name));
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null))), requestResult.type && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default.a.actionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default.a.submitButton, disabled: isLoading }, "Submit", isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"), "\xA0 \xA0"))));
    } }]);return CopyUserPermissionsForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(_) {
  return {};
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: "drugShip" })(Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(CopyUserPermissionsForm)));

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopyUserPermissionsForm__wrapper__18N60","submitResult":"CopyUserPermissionsForm__submitResult__3yBSm","actionWrapper":"CopyUserPermissionsForm__actionWrapper__1I2SR","wrapper2faOptions":"CopyUserPermissionsForm__wrapper2faOptions__eVKLl"};

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_uniq__);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;var CopyUserPermissionsMultiSitesForm = function (_React$Component) {
  _inherits(CopyUserPermissionsMultiSitesForm, _React$Component);function CopyUserPermissionsMultiSitesForm(props) {
    var _this2 = this;_classCallCheck(this, CopyUserPermissionsMultiSitesForm);var _this = _possibleConstructorReturn(this, (CopyUserPermissionsMultiSitesForm.__proto__ || Object.getPrototypeOf(CopyUserPermissionsMultiSitesForm)).call(this, props));_this.handleKeyDown = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: true });
      }
    };_this.handleKeyUp = function (event) {
      if (event.keyCode === 16) {
        _this.setState({ shiftDown: false });
      }
    };_this.onTargetKeyChange = function (index, id) {
      return function (e) {
        var isChecked = e.target.checked;var _this$state = _this.state,
            sitesKeys = _this$state.sitesKeys,
            shiftDown = _this$state.shiftDown;var sites = _this.props.sitesList;if (sitesKeys.length && shiftDown) {
          var lastCheckedItemIndex = sites.findIndex(function (item) {
            return item.id === sitesKeys[sitesKeys.length - 1];
          });var newItems = [];if (lastCheckedItemIndex < index) {
            newItems = sites.reduce(function (result, item, itemIndex) {
              return itemIndex > lastCheckedItemIndex && itemIndex <= index ? [].concat(_toConsumableArray(result), [item.id]) : result;
            }, []);
          } else {
            newItems = sites.reduce(function (result, item, itemIndex) {
              return itemIndex < lastCheckedItemIndex && itemIndex >= index ? [].concat(_toConsumableArray(result), [item.id]) : result;
            }, []);
          }_this.setState(function (_ref) {
            var sitesKeys = _ref.sitesKeys;return { sitesKeys: __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()([].concat(_toConsumableArray(sitesKeys), _toConsumableArray(newItems))) };
          });
        } else {
          _this.setState(function (_ref2) {
            var sitesKeys = _ref2.sitesKeys;return { sitesKeys: isChecked ? __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()([].concat(_toConsumableArray(sitesKeys), [id])) : __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()(sitesKeys.filter(function (item) {
                return item !== id;
              })) };
          });
        }
      };
    };_this.handleSubmit = function (e) {
      e.preventDefault();var sitesKeys = _this.state.sitesKeys;_this.props.form.validateFields(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 19;break;
                  }if (sitesKeys.length) {
                    _context.next = 5;break;
                  }_this.setState({ requestResult: { type: "warning", message: "Please, select role to copy" } });return _context.abrupt("return");case 5:
                  _this.setState({ isLoading: true });_context.prev = 6;_this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });_context.next = 10;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["n" /* copyBulkSiteChangePermissions */])({ type: values.type, user_id: values.from_user_id, role_id: values.role_id, site_ids: sitesKeys });case 10:
                  setTimeout(function () {
                    _this.props.onSubmit();
                  }, 1000);_context.next = 19;break;case 13:
                  _context.prev = 13;_context.t0 = _context["catch"](6);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 18;break;
                  }_this.props.logout();return _context.abrupt("return");case 18:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, "response.data.message", "Error") } });case 19:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[6, 13]]);
        }));return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {}, users: [], rolesKeys: [], sitesKeys: [], shiftDown: false };return _this;
  }_createClass(CopyUserPermissionsMultiSitesForm, [{ key: "componentDidMount", value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref5, users;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_20__api_requests__["_25" /* getUsersLight */])();case 2:
                _ref5 = _context2.sent;users = _ref5.data;this.setState({ users: users });document.addEventListener("keydown", this.handleKeyDown);document.addEventListener("keyup", this.handleKeyUp);case 7:case "end":
                return _context2.stop();}
          }
        }, _callee2, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "componentWillUnmount", value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);document.removeEventListener("keyup", this.handleKeyUp);
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          users = _state.users,
          rolesKeys = _state.rolesKeys,
          sitesKeys = _state.sitesKeys;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          rolesList = _props.rolesList,
          sitesList = _props.sitesList;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h4", { className: "headline-default" }, "Add/remove user permission to multiple sites"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Source user:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("from_user_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select User", showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, users.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: user.id, value: user.id, disabled: getFieldValue("to_user_id") === user.id }, user.username);
      }))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Type:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("type", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select type" }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "add" }, "Add"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { value: "delete" }, "Remove"))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { md: 12 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "Role:"), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, getFieldDecorator("role_id", { rules: [{ required: true, message: "Required" }] })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a, { placeholder: "Select Role", showSearch: true, optionFilterProp: "children", filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } }, rolesList.map(function (role) {
        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Option, { key: role.id, value: role.id }, role.name);
      }))))))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, sitesList.length > 0 && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { style: { paddingBottom: "12px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: function onChange(e) {
          if (e.target.checked) {
            _this3.setState(function () {
              return { sitesKeys: sitesList.map(function (_ref6) {
                  var id = _ref6.id;return id;
                }) };
            });
          } else {
            _this3.setState(function () {
              return { sitesKeys: [] };
            });
          }
        } }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("b", null, "\xA0 Check all \xA0 (", sitesKeys.length, "/", sitesList.length, ")"))), sitesList.map(function (_ref7, i) {
        var id = _ref7.id,
            name = _ref7.name;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { key: id, style: { paddingBottom: "4px" } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { checked: sitesKeys.findIndex(function (targetKey) {
            return targetKey === id;
          }) > -1, onChange: _this3.onTargetKeyChange(i, id) }), "\xA0", name));
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("br", null))), requestResult.type && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default.a.actionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default.a.submitButton, disabled: isLoading }, "Submit", isLoading && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_21__CopyUserPermissionsMultiSitesForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"), "\xA0 \xA0"))));
    } }]);return CopyUserPermissionsMultiSitesForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(_) {
  return {};
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({ name: "drugShip" })(Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(CopyUserPermissionsMultiSitesForm)));

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopyUserPermissionsMultiSitesForm__wrapper__dAhQy","submitResult":"CopyUserPermissionsMultiSitesForm__submitResult__R0Kar","actionWrapper":"CopyUserPermissionsMultiSitesForm__actionWrapper__1jeg0","wrapper2faOptions":"CopyUserPermissionsMultiSitesForm__wrapper2faOptions__2sleC"};

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsUsersBulk__content__3P2F9","parentContainer":"SettingsUsersBulk__parentContainer__17Bkp","searchWrapper":"SettingsUsersBulk__searchWrapper__1XTRG","searchWrapperSearch":"SettingsUsersBulk__searchWrapperSearch__FZnVP","searchWrapperLabel":"SettingsUsersBulk__searchWrapperLabel__3fk2H","searchWrapperFilter":"SettingsUsersBulk__searchWrapperFilter__2m0GV","searchWrapperFilterItem":"SettingsUsersBulk__searchWrapperFilterItem__w_lep","searchWrapperFilterLabel":"SettingsUsersBulk__searchWrapperFilterLabel__cE99b","clearButton":"SettingsUsersBulk__clearButton__Huze2","checkIcon":"SettingsUsersBulk__checkIcon___GVoJ","clockIcon":"SettingsUsersBulk__clockIcon__2SxwT","checkIconGray":"SettingsUsersBulk__checkIconGray__2Z4SY","warningIcon":"SettingsUsersBulk__warningIcon__ZK3R4","iconStatusWrapper":"SettingsUsersBulk__iconStatusWrapper__3IqWH","eventDropdownItem":"SettingsUsersBulk__eventDropdownItem__1f44J","actionIcon":"SettingsUsersBulk__actionIcon__3RWwR","reactivateBtn":"SettingsUsersBulk__reactivateBtn__3SfQi","roleIcon":"SettingsUsersBulk__roleIcon__1prNj","actions":"SettingsUsersBulk__actions__3ia8j","roleSelect":"SettingsUsersBulk__roleSelect__1WLlu","inactiveRole":"SettingsUsersBulk__inactiveRole__1WIef","tableContainer":"SettingsUsersBulk__tableContainer__1Lhc-","siteSearchSelect":"SettingsUsersBulk__siteSearchSelect__27Lzu","siteSearchContainer":"SettingsUsersBulk__siteSearchContainer__39D2j"};

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SettingsRoleForm_SettingsRoleForm__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__ = __webpack_require__(37);



















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a.Content;var SettingsRoles = function (_React$Component) {
  _inherits(SettingsRoles, _React$Component);function SettingsRoles(props) {
    var _this2 = this;_classCallCheck(this, SettingsRoles);var _this = _possibleConstructorReturn(this, (SettingsRoles.__proto__ || Object.getPrototypeOf(SettingsRoles)).call(this, props));_this.getRolesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_27__api_requests__["_15" /* getSettingsRolesRequest */])();case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ rolesList: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.onSelectRole = function (role) {
      return function () {
        _this.setState({ selectedRole: null }, function () {
          _this.setState({ selectedRole: role });
        });
      };
    };_this.onRoleEditHide = function () {
      _this.setState({ selectedRole: null });
    };_this.onRoleEditSubmit = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee2(roleID) {
        return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _this.props.setPermissions(_this.props.userToken);_context2.next = 3;return _this.getRolesList();case 3:
                _this.setState({ selectedRole: null }, function () {
                  _this.setState({ selectedRole: __WEBPACK_IMPORTED_MODULE_19_lodash_find___default()(_this.state.rolesList, function (roleItem) {
                      return roleItem.id === roleID;
                    }) });
                });case 4:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();_this.onAddRole = function () {
      _this.setState({ selectedRole: null }, function () {
        _this.setState({ selectedRole: {} });
      });
    };_this.state = { rolesList: [], errorMessage: '', responseMessage: '', roleEdit: null, selectedRole: null };return _this;
  }_createClass(SettingsRoles, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_16_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.getRolesList();case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          rolesList = _state.rolesList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          selectedRole = _state.selectedRole;var roleCreatePermission = this.props.roleCreatePermission;return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h3', { className: 'headline-default' }, 'Role Management'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item, { href: '/admin/settings' }, 'Admin Settings'), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item, null, 'Role Management')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 24 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('b', null, 'Select a role to edit')), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a, { className: __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.rolesList, bordered: true, dataSource: rolesList, renderItem: function renderItem(item) {
          return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_20_classnames___default()(__WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.roleItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.active, item.id === __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(selectedRole, 'id'))), onClick: _this3.onSelectRole(item) }, item.name, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default.a, { count: item.state, style: { backgroundColor: item.state === 'active' ? '#49c850' : '#f00' } }));
        } }), roleCreatePermission && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_25__SettingsRoles_css___default.a.roleActionWrapper }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', onClick: this.onAddRole }, 'Add role'))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 18 }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p', null, '\xA0'), selectedRole && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_SettingsRoleForm_SettingsRoleForm__["a" /* default */], Object.assign({}, selectedRole, { isNew: selectedRole && !selectedRole.id, onSubmit: this.onRoleEditSubmit, onCancel: this.onRoleEditHide })))), errorMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { type: 'success', message: responseMessage })), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsRoles;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { roleCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_33" /* getRoleCreatePermission */])(state), userToken: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_28__reducers_user_actions__["e" /* logout */], setPermissions: __WEBPACK_IMPORTED_MODULE_28__reducers_user_actions__["h" /* setPermissions */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_26__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsRoles)));

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1882);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n}\n.ant-list * {\n  outline: none;\n}\n.ant-list-pagination {\n  margin-top: 24px;\n  text-align: right;\n}\n.ant-list-pagination .ant-pagination-options {\n  text-align: left;\n}\n.ant-list-more {\n  margin-top: 12px;\n  text-align: center;\n}\n.ant-list-more button {\n  padding-right: 32px;\n  padding-left: 32px;\n}\n.ant-list-spin {\n  min-height: 40px;\n  text-align: center;\n}\n.ant-list-empty-text {\n  padding: 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  text-align: center;\n}\n.ant-list-items {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n.ant-list-item-content {\n  color: #424242;\n}\n.ant-list-item-meta {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  font-size: 0;\n}\n.ant-list-item-meta-avatar {\n  margin-right: 16px;\n}\n.ant-list-item-meta-content {\n  flex: 1 0;\n}\n.ant-list-item-meta-title {\n  margin-bottom: 4px;\n  color: #424242;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-list-item-meta-title > a {\n  color: #424242;\n  transition: all 0.3s;\n}\n.ant-list-item-meta-title > a:hover {\n  color: #4CDEF5;\n}\n.ant-list-item-meta-description {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-list-item-action {\n  flex: 0 0 auto;\n  margin-left: 48px;\n  padding: 0;\n  font-size: 0;\n  list-style: none;\n}\n.ant-list-item-action > li {\n  position: relative;\n  display: inline-block;\n  padding: 0 8px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  cursor: pointer;\n}\n.ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-item-action-split {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 1px;\n  height: 14px;\n  margin-top: -7px;\n  background-color: #e8e8e8;\n}\n.ant-list-header {\n  background: transparent;\n}\n.ant-list-footer {\n  background: transparent;\n}\n.ant-list-header,\n.ant-list-footer {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ant-list-empty {\n  padding: 16px 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n  text-align: center;\n}\n.ant-list-split .ant-list-item {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-split .ant-list-item:last-child {\n  border-bottom: none;\n}\n.ant-list-split .ant-list-header {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-loading .ant-list-spin-nested-loading {\n  min-height: 32px;\n}\n.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-lg .ant-list-item {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.ant-list-sm .ant-list-item {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.ant-list-vertical .ant-list-item {\n  align-items: initial;\n}\n.ant-list-vertical .ant-list-item-main {\n  display: block;\n  flex: 1;\n}\n.ant-list-vertical .ant-list-item-extra {\n  margin-left: 40px;\n}\n.ant-list-vertical .ant-list-item-meta {\n  margin-bottom: 16px;\n}\n.ant-list-vertical .ant-list-item-meta-title {\n  margin-bottom: 12px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-list-vertical .ant-list-item-action {\n  margin-top: 16px;\n  margin-left: auto;\n}\n.ant-list-vertical .ant-list-item-action > li {\n  padding: 0 16px;\n}\n.ant-list-vertical .ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-grid .ant-col > .ant-list-item {\n  display: block;\n  max-width: 100%;\n  margin-bottom: 16px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.ant-list-item-no-flex {\n  display: block;\n}\n.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {\n  float: right;\n}\n.ant-list-bordered {\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n}\n.ant-list-bordered .ant-list-header {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-footer {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-item {\n  padding-right: 24px;\n  padding-left: 24px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-bordered .ant-list-pagination {\n  margin: 16px 24px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-item {\n  padding-right: 16px;\n  padding-left: 16px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-header,\n.ant-list-bordered.ant-list-sm .ant-list-footer {\n  padding: 8px 16px;\n}\n.ant-list-bordered.ant-list-lg .ant-list-header,\n.ant-list-bordered.ant-list-lg .ant-list-footer {\n  padding: 16px 24px;\n}\n@media screen and (max-width: 768px) {\n  .ant-list-item-action {\n    margin-left: 24px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin-left: 24px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .ant-list-item {\n    flex-wrap: wrap;\n  }\n  .ant-list-item-action {\n    margin-left: 12px;\n  }\n  .ant-list-vertical .ant-list-item {\n    flex-wrap: wrap-reverse;\n  }\n  .ant-list-vertical .ant-list-item-main {\n    min-width: 220px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin: auto auto 16px;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Meta = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _grid = __webpack_require__(188);

var _configProvider = __webpack_require__(30);

var _reactNode = __webpack_require__(1884);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Meta = function Meta(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
    var content = React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-content")
    }, title && React.createElement("h4", {
      className: "".concat(prefixCls, "-item-meta-title")
    }, title), description && React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-description")
    }, description));
    return React.createElement("div", _extends({}, others, {
      className: classString
    }), avatar && React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-avatar")
    }, avatar), (title || description) && content);
  });
};

exports.Meta = Meta;

function getGrid(grid, t) {
  return grid[t] && Math.floor(24 / grid[t]);
}

var Item =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Item, _React$Component);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Item).apply(this, arguments));

    _this.renderItem = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;
      var _this$context = _this.context,
          grid = _this$context.grid,
          itemLayout = _this$context.itemLayout;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          children = _a.children,
          actions = _a.actions,
          extra = _a.extra,
          className = _a.className,
          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var actionsContent = actions && actions.length > 0 && React.createElement("ul", {
        className: "".concat(prefixCls, "-item-action"),
        key: "actions"
      }, actions.map(function (action, i) {
        return (// eslint-disable-next-line react/no-array-index-key
          React.createElement("li", {
            key: "".concat(prefixCls, "-item-action-").concat(i)
          }, action, i !== actions.length - 1 && React.createElement("em", {
            className: "".concat(prefixCls, "-item-action-split")
          }))
        );
      }));
      var Tag = grid ? 'div' : 'li';
      var itemChildren = React.createElement(Tag, _extends({}, others, {
        // `li` element `onCopy` prop args is not same as `div`
        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
      }), itemLayout === 'vertical' && extra ? [React.createElement("div", {
        className: "".concat(prefixCls, "-item-main"),
        key: "content"
      }, children, actionsContent), React.createElement("div", {
        className: "".concat(prefixCls, "-item-extra"),
        key: "extra"
      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
        key: 'extra'
      })]);
      return grid ? React.createElement(_grid.Col, {
        span: getGrid(grid, 'column'),
        xs: getGrid(grid, 'xs'),
        sm: getGrid(grid, 'sm'),
        md: getGrid(grid, 'md'),
        lg: getGrid(grid, 'lg'),
        xl: getGrid(grid, 'xl'),
        xxl: getGrid(grid, 'xxl')
      }, itemChildren) : itemChildren;
    };

    return _this;
  }

  _createClass(Item, [{
    key: "isItemContainsTextNodeAndNotSingular",
    value: function isItemContainsTextNodeAndNotSingular() {
      var children = this.props.children;
      var result;
      React.Children.forEach(children, function (element) {
        if (typeof element === 'string') {
          result = true;
        }
      });
      return result && React.Children.count(children) > 1;
    }
  }, {
    key: "isFlexMode",
    value: function isFlexMode() {
      var extra = this.props.extra;
      var itemLayout = this.context.itemLayout;

      if (itemLayout === 'vertical') {
        return !!extra;
      }

      return !this.isItemContainsTextNodeAndNotSingular();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderItem);
    }
  }]);

  return Item;
}(React.Component);

exports["default"] = Item;
Item.Meta = Meta;
Item.contextTypes = {
  grid: PropTypes.any,
  itemLayout: PropTypes.string
};
//# sourceMappingURL=Item.js.map


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElement = cloneElement;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line import/prefer-default-export
function cloneElement(element) {
  if (!React.isValidElement(element)) return element;

  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restArgs[_key - 1] = arguments[_key];
  }

  return React.cloneElement.apply(React, [element].concat(restArgs));
}
//# sourceMappingURL=reactNode.js.map


/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__fieldsMap__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_classnames__);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;var SettingsRoleForm = function (_React$Component) {
  _inherits(SettingsRoleForm, _React$Component);function SettingsRoleForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsRoleForm);var _this = _possibleConstructorReturn(this, (SettingsRoleForm.__proto__ || Object.getPrototypeOf(SettingsRoleForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var roleRaw, role, errors;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 26;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;roleRaw = Object.assign({}, values);role = {};Object.keys(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */]).forEach(function (fieldGroupName) {
                    __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroupName], 'fields', []).forEach(function (field) {
                      if (field.permissions) {
                        field.permissions.forEach(function (permission) {
                          role[field.key + '_' + permission.key] = false;
                        });
                      }
                    });
                  });Object.keys(roleRaw).forEach(function (roleKey) {
                    if (Array.isArray(roleRaw[roleKey])) {
                      roleRaw[roleKey].forEach(function (rolePermission) {
                        role[roleKey + '_' + rolePermission] = true;
                      });
                    } else {
                      role[roleKey] = roleRaw[roleKey];
                    }
                  });if (!_this.props.id) {
                    _context.next = 13;break;
                  }_context.next = 11;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_67" /* updateRoleRequest */])(_this.props.id, role);case 11:
                  _context.next = 15;break;case 13:
                  _context.next = 15;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["w" /* createRoleRequest */])(role);case 15:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 26;break;case 19:
                  _context.prev = 19;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 24;break;
                  }_this.props.logout();return _context.abrupt('return');case 24:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 26:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 19]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.showDeactivateModal = function () {
      _this.setState({ deactivateSubmitModal: true });
    };_this.hideDeactivateModal = function () {
      _this.setState({ deactivateSubmitModal: false });
    };_this.toggleActivate = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_44" /* toggleActivateRoleRequest */])(_this.props.id, _this.state.roleState);case 3:
              _this.setState({ requestResult: { type: 'success', message: 'Success' }, roleState: _this.state.roleState === 'inactive' ? 'active' : 'inactive' });_this.hideDeactivateModal();setTimeout(function () {
                _this.props.onSubmit(_this.props.id);
              }, 1000);_context2.next = 11;break;case 8:
              _context2.prev = 8;_context2.t0 = _context2['catch'](0);if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, 'response.status') === 401) {
                _this.props.logout();
              }case 11:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 8]]);
    }));_this.onCheckAllChange = function (fieldGroup, isCheckedAll) {
      return function () {
        __WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroup].fields.forEach(function (field) {
          if (!field.permissions) {
            _this.props.form.setFieldsValue(_defineProperty({}, field.key, !isCheckedAll));
          } else {
            _this.props.form.setFieldsValue(_defineProperty({}, field.key, isCheckedAll ? [] : field.permissions.map(function (permission) {
              return permission.key;
            })));
          }
        });
      };
    };_this.onCheckField = function (fieldKey, isCheckedFieldAll, fieldPermissions) {
      return function () {
        _this.props.form.setFieldsValue(_defineProperty({}, fieldKey, isCheckedFieldAll ? [] : fieldPermissions.map(function (permission) {
          return permission.key;
        })));
      };
    };_this.collapseSection = function (sectionName) {
      return function () {
        _this.setState(function (state) {
          return { openGroups: Object.assign({}, state.openGroups, _defineProperty({}, sectionName, !state.openGroups[sectionName])) };
        });
      };
    };var openGroups = {};var fieldKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */]);fieldKeys.forEach(function (key) {
      openGroups[key] = true;
    });_this.state = { isLoading: false, requestResult: {}, deactivateSubmitModal: false, roleState: '', openGroups: openGroups };return _this;
  }_createClass(SettingsRoleForm, [{ key: 'componentDidMount', value: function componentDidMount() {
      this.setState({ roleState: this.props.state });
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          deactivateSubmitModal = _state.deactivateSubmitModal,
          openGroups = _state.openGroups;var getFieldDecorator = this.props.form.getFieldDecorator;var _props = this.props,
          roleUpdatePermission = _props.roleUpdatePermission,
          roleCreatePermission = _props.roleCreatePermission,
          roleDeletePermission = _props.roleDeletePermission,
          id = _props.id,
          isNew = _props.isNew,
          state = _props.state;var isEditable = id ? roleUpdatePermission : roleCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h4', { className: 'headline-default' }, this.props.id ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, this.props.name, ' ', state && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: state, style: { backgroundColor: state === 'active' ? '#49c850' : '#f00' } }), ' ', __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: 'Edit', style: { backgroundColor: '#2968AE' } })) : isNew ? 'Add role' : ''), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { sm: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Name:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'name', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Name' }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { sm: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Description:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('description', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'description', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Description' })))))), this.props.id && roleDeletePermission && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: 'default', style: { backgroundColor: this.state.roleState === 'inactive' ? '#44c721' : '#f56009', borderColor: '#fff', color: '#fff' }, onClick: this.showDeactivateModal }, this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate')))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h4', { className: 'headline-default' }, 'Role settings'), Object.keys(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */]).map(function (fieldGroupName) {
        var isCheckedAll = true;var isNotCheckedAll = true;__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroupName].fields.some(function (field) {
          var value = _this3.props.form.getFieldValue(field.key);if (Array.isArray(value)) {
            if (value.length !== field.permissions.length) {
              isCheckedAll = false;return true;
            }
          } else {
            if (!value) {
              isCheckedAll = false;return true;
            }
          }
        });__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroupName].fields.some(function (field) {
          var value = _this3.props.form.getFieldValue(field.key);if (Array.isArray(value)) {
            if (value.length > 0) {
              isNotCheckedAll = false;return true;
            }
          } else {
            if (value) {
              isNotCheckedAll = false;return true;
            }
          }
        });return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { key: fieldGroupName, className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.fieldGroup }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h5', { className: __WEBPACK_IMPORTED_MODULE_33_classnames___default()('headline-default', __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.toggleHeadline), onClick: _this3.collapseSection(fieldGroupName) }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip___default.a, { title: openGroups[fieldGroupName] ? 'collapse' : 'show' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: 'arrow-up', className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.collapseIcon, style: { fontSize: '20px', transform: 'rotate(' + (openGroups[fieldGroupName] ? '0' : '180deg') + ')' } }), ' \xA0'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.headlineText }, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroupName], 'name'))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { display: openGroups[fieldGroupName] ? 'block' : 'none' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('p', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.fieldGroupCheckAll }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { indeterminate: !isCheckedAll && !isNotCheckedAll && true, onChange: _this3.onCheckAllChange(fieldGroupName, isCheckedAll), checked: isCheckedAll }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Check all'))), __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_32__fieldsMap__["a" /* default */][fieldGroupName], 'fields', []).map(function (field) {
          var isCheckedFieldAll = true;if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'permissions')) {
            var value = _this3.props.form.getFieldValue(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key'));if (value && value.length !== field.permissions.length) {
              isCheckedFieldAll = false;
            }
          }return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { key: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key') }, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'permissions') ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.permissionsSelectWrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.permissionsSelectLabel }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'name')), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), getFieldDecorator(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key'), { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'permissions', []).map(function (permission) {
              return __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_this3.props, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key') + '_' + permission.key) ? permission.key : false;
            }).filter(function (permission) {
              return !!permission;
            }) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: 'tags', placeholder: 'Please select', style: { width: '100%' } }, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'permissions').map(function (permission) {
            return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: permission.key, value: permission.key }, permission.value);
          })))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.checkField, onClick: _this3.onCheckField(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key'), isCheckedFieldAll, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'permissions')) }, isCheckedFieldAll ? 'Clear all' : 'Check all')), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null)) : __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('p', null, getFieldDecorator(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key'), { initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_this3.props, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'key'), false), valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a, { disabled: !isEditable }, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(field, 'name')))));
        })));
      }))), requestResult.type && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_30__SettingsRoleForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel'))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: 'Role ' + (this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate'), visible: deactivateSubmitModal, onOk: this.toggleActivate, onCancel: this.hideDeactivateModal }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('p', null, 'Confirm role ', this.state.roleState === 'inactive' ? 'activate' : 'deactivate', ' action')));
    } }]);return SettingsRoleForm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { roleCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_33" /* getRoleCreatePermission */])(state), roleUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_36" /* getRoleUpdatePermission */])(state), roleDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_34" /* getRoleDeletePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.create({ name: 'site' })(Object(__WEBPACK_IMPORTED_MODULE_27_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsRoleForm)));

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsRoleForm__wrapper__1iU8v","submitResult":"SettingsRoleForm__submitResult__2i62-","actionWrapper":"SettingsRoleForm__actionWrapper__20jbU","fieldGroup":"SettingsRoleForm__fieldGroup__2r1NZ","permissionsSelectWrapper":"SettingsRoleForm__permissionsSelectWrapper__1pOPy","checkField":"SettingsRoleForm__checkField__1SUtR","permissionsSelectLabel":"SettingsRoleForm__permissionsSelectLabel___Gm1q","fieldGroupCheckAll":"SettingsRoleForm__fieldGroupCheckAll__3lTrj","toggleHeadline":"SettingsRoleForm__toggleHeadline__1JHCx","collapseIcon":"SettingsRoleForm__collapseIcon__T6-Qu","headlineText":"SettingsRoleForm__headlineText__3JYAA"};

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsRoles__content__MQN3h","parentContainer":"SettingsRoles__parentContainer__2B_4k","searchWrapper":"SettingsRoles__searchWrapper__7IAvH","searchWrapperSearch":"SettingsRoles__searchWrapperSearch__1w5wn","searchWrapperLabel":"SettingsRoles__searchWrapperLabel__1_KlZ","searchWrapperFilter":"SettingsRoles__searchWrapperFilter__1pMmB","searchWrapperFilterItem":"SettingsRoles__searchWrapperFilterItem__1uGHU","searchWrapperFilterLabel":"SettingsRoles__searchWrapperFilterLabel__24eQr","clearButton":"SettingsRoles__clearButton__2NYV5","checkIcon":"SettingsRoles__checkIcon__3q4r_","clockIcon":"SettingsRoles__clockIcon__32GwZ","checkIconGray":"SettingsRoles__checkIconGray__F8xqI","warningIcon":"SettingsRoles__warningIcon__3y04e","iconStatusWrapper":"SettingsRoles__iconStatusWrapper__1VNsW","eventDropdownItem":"SettingsRoles__eventDropdownItem__3bZfN","actionIcon":"SettingsRoles__actionIcon__1TN_E","actions":"SettingsRoles__actions__slALw","roleActionWrapper":"SettingsRoles__roleActionWrapper__106w2","rolesList":"SettingsRoles__rolesList__2bgjL","roleItem":"SettingsRoles__roleItem__vAVEs","active":"SettingsRoles__active__3iC3m"};

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_FileLink_FileLink__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__ = __webpack_require__(171);





























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_23_antd_lib_input___default.a.Search;var Option = __WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a.Option;var mapped_categories = { public: 'Public', general: 'Central Shared', general_private: 'Central Private', per_site: 'Site Specific', training: 'Training', validation: 'Validation' };var DocumentsEditor = function (_React$Component) {
  _inherits(DocumentsEditor, _React$Component);function DocumentsEditor(props) {
    var _this2 = this;_classCallCheck(this, DocumentsEditor);var _this = _possibleConstructorReturn(this, (DocumentsEditor.__proto__ || Object.getPrototypeOf(DocumentsEditor)).call(this, props));_this.onNameSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ nameSearch: value, filterBy: null, filterValue: null, eventsSelected: {} }, _this.getDocuments);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.getDocuments = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["_0" /* getDocumentsSearchRequest */])({ nameSearch: _this.state.nameSearch, order_direction: _this.state.order, order_column: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.state, 'sortedInfo.columnKey'), page: page, per_page: per_page, filter_by: _this.state.filtersBy, filter_value: _this.state.filtersValue, filter_approve: _this.state.approvedSelected !== null ? _this.state.approvedSelected : null });case 4:
              _ref3 = _context2.sent;data = _ref3.data;if (Array.isArray(data.data)) {
                _this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
              } else {
                _this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
              }_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt('return');case 14:
              _this.setState({ documents: null, errorMessage: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context2.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.onNameChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getDocuments(pagination.current, pagination.pageSize);
      });
    };_this.onDocumentEdit = function (document) {
      return function () {
        _this.setState({ documentEdit: document });
      };
    };_this.onDocumentEditHide = function () {
      _this.setState({ documentEdit: null });
    };_this.onDocumentEditSubmit = function () {
      _this.setState({ documentEdit: null }, _this.getDocuments);
    };_this.addDocument = function () {
      _this.setState({ documentEdit: {} });
    };_this.onSwitchDocumentActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.prev = 0;if (!(state === 'active')) {
                  _context3.next = 6;break;
                }_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["I" /* deleteDocumentRequest */])(id);case 4:
                _context3.next = 8;break;case 6:
                _context3.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["c" /* activateDocumentRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success('Saved');_this.getDocuments();_context3.next = 19;break;case 12:
                _context3.prev = 12;_context3.t0 = _context3['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                  _context3.next = 17;break;
                }_this.props.logout();return _context3.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error('Error');console.log(_context3.t0);case 19:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2, [[0, 12]]);
      }));
    };_this.onSwitchDocumentApprove = function (id, approved) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _context4.prev = 0;if (!approved) {
                  _context4.next = 6;break;
                }_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["_50" /* unapproveDocumentRequest */])(id);case 4:
                _context4.next = 8;break;case 6:
                _context4.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["l" /* approveDocumentRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success('Saved');_this.getDocuments();_context4.next = 19;break;case 12:
                _context4.prev = 12;_context4.t0 = _context4['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context4.t0, 'response.status') === 401)) {
                  _context4.next = 17;break;
                }_this.props.logout();return _context4.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error('Error');console.log(_context4.t0);case 19:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[0, 12]]);
      }));
    };_this.handleFilterChange = function (index) {
      return function (value) {
        _this.setState(function (state) {
          var filtersBy = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersBy);var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersBy[index] = value;delete filtersValue[index];return { filtersBy: filtersBy, filtersValue: filtersValue };
        });
      };
    };_this.handleFilterValueChange = function (index) {
      return function (value) {
        _this.setState(function (state) {
          var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersValue[index] = value;return { filtersValue: filtersValue };
        }, _this.getDocuments);
      };
    };_this.clearFilter = function (index) {
      return function () {
        _this.setState(function (state) {
          var filtersBy = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersBy);var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersBy.splice(index, 1);filtersValue.splice(index, 1);return { filtersBy: filtersBy, filtersValue: filtersValue };
        }, _this.getDocuments);
      };
    };_this.clearFilters = function () {
      _this.setState({ nameSearch: null }, _this.getDocuments);
    };_this.onSelectApprovedStatus = function (approvedStatusType) {
      return function () {
        var status = void 0;var approvedSelected = _this.state.approvedSelected;if (approvedSelected === null && approvedStatusType === 'approved') {
          status = false;
        }if (approvedSelected === true && approvedStatusType === 'approved') {
          status = false;
        }if (approvedSelected === false && approvedStatusType === 'approved') {
          status = null;
        }if (approvedSelected === null && approvedStatusType === 'unapproved') {
          status = true;
        }if (approvedSelected === false && approvedStatusType === 'unapproved') {
          status = true;
        }if (approvedSelected === true && approvedStatusType === 'unapproved') {
          status = null;
        }_this.setState(function (_) {
          return { approvedSelected: status };
        }, _this.getDocuments);
      };
    };_this.renderFilterItem = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.filtersBy.length;var _this$state = _this.state,
          filtersBy = _this$state.filtersBy,
          filtersValue = _this$state.filtersValue,
          sites = _this$state.sites;return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.wrapperFilterItem, key: filtersBy[index] }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilter }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Filter by'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { onChange: _this.handleFilterChange(index), value: filtersBy[index], style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'category', disabled: filtersBy.includes('category') }, 'Category'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'type', disabled: filtersBy.includes('type') }, 'Document type'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'site', disabled: filtersBy.includes('site') }, 'Site'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'state', disabled: filtersBy.includes('state') }, 'State')))), filtersBy[index] === 'category' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Category'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { mode: 'multiple', onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'public', disabled: !_this.props.documentPublicReadPermission }, 'Public'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'general', disabled: !_this.props.documentGeneralReadPermission }, 'Central Shared'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'general_private', disabled: !_this.props.documentGeneralPrivateReadPermission }, 'Central Private'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'per_site', disabled: !_this.props.documentPerSiteReadPermission }, 'Site Specific'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'training', disabled: !_this.props.documentTrainingReadPermission }, 'Training'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'validation', disabled: !_this.props.documentValidationReadPermission }, 'Validation'))), filtersBy[index] === 'type' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Document type'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { mode: 'multiple', onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: '100%' }, placeholder: 'Select' }, Object.keys(__WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["b" /* documentTypes */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: key, key: key }, __WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["b" /* documentTypes */][key]);
      }))), filtersBy[index] === 'site' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Site'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: '100%' }, placeholder: 'Select' }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, ' - ', site.name);
      }))), filtersBy[index] === 'state' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Active state'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'active' }, 'Active'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'inactive' }, 'Inactive'))), filtersBy[index] === 'approved' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'Is approved'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: '100%' }, placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'true' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: 'false' }, 'No'))), filtersValue[index] && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.clearButton, onClick: _this.clearFilter(index) }, 'Remove'));
    };_this.state = { documents: [], nameSearch: null, sortedInfo: { columnKey: 'order_index', order: 'ascend' }, order: 'asc', errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, eventsSelected: {}, documentEdit: null, filterBy: null, filterValue: null, filtersBy: [], filtersValue: [], approvedSelected: null };return _this;
  }_createClass(DocumentsEditor, [{ key: 'componentDidMount', value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref7, data;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                this.onNameSearch();_context5.prev = 1;_context5.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_36__api_requests__["_20" /* getSitesRequest */])();case 4:
                _ref7 = _context5.sent;data = _ref7.data;this.setState({ sites: data });_context5.next = 15;break;case 9:
                _context5.prev = 9;_context5.t0 = _context5['catch'](1);if (!(_context5.t0.response.status === 401)) {
                  _context5.next = 14;break;
                }this.props.logout();return _context5.abrupt('return');case 14:
                console.log(_context5.t0);case 15:case 'end':
                return _context5.stop();}
          }
        }, _callee5, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref6.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          nameSearch = _state.nameSearch,
          documents = _state.documents,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          documentEdit = _state.documentEdit,
          sortedInfo = _state.sortedInfo,
          filtersBy = _state.filtersBy,
          filtersValue = _state.filtersValue,
          approvedSelected = _state.approvedSelected;var documentCreatePermission = this.props.documentCreatePermission;var columns = [{ dataIndex: "order_index", key: "order_index", title: "Index", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('span', null, val);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order }, { dataIndex: "name", key: "name", title: "Document Name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.nameDocumentWrapper }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { style: { width: '86px' } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('br', null), record.state === 'active' && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.approved ? 'approved' : 'unapproved', style: { backgroundColor: record.approved ? '#52c41a' : '#777' } })), val);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'name' && sortedInfo.order }, { dataIndex: "type", key: "type", title: "Document Type", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["b" /* documentTypes */][val]);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'type' && sortedInfo.order }, { dataIndex: "site", key: "site", title: "Site", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(document, 'category') === 'public' && __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(val, 'name', 'General'), __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(document, 'category') !== 'public' && __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(val, 'name'));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'site' && sortedInfo.order }, { dataIndex: "category", key: "category", title: "Category", render: function render(category) {
          return category ? mapped_categories[category] || '' : '';
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'category' && sortedInfo.order }, { dataIndex: "start_year", key: "start_year", title: "Start date", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'start_year' && sortedInfo.order }, { dataIndex: "expiry_year", key: "expiry_year", title: "Expiry date", sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'expiry_year' && sortedInfo.order }, { dataIndex: "user", key: "user", title: "Uploaded by", render: function render(user) {
          return __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(user, 'username');
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, 'columnKey') === 'user' && sortedInfo.order }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_FileLink_FileLink__["a" /* default */], { url: document.url }), '\xA0 \xA0', __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Edit Document' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.iconEdit, onClick: _this3.onDocumentEdit(document) })), '\xA0 \xA0', __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { style: { width: '90px', display: 'flex' } }, (_this3.props.documentUpdatePermission && document.state === 'inactive' || _this3.props.documentDeletePermission && document.state === 'active') && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.switchLabel }, 'State'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Activate / Deactivate Document' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.reactivateBtn, checked: document.state === 'active', onChange: _this3.onSwitchDocumentActivation(val, document.state) }))), '\xA0 \xA0', document.state === 'active' && (_this3.props.documentApprovePermission && !document.approved || _this3.props.documentUnapprovePermission && document.approved) && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.switchLabel }, 'Approve'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Approve / Unapprove Document' }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.reactivateBtn, checked: document.approved, onChange: _this3.onSwitchDocumentApprove(val, document.approved) })))));
        } }];return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('h3', { className: 'headline-default' }, 'Trial Documents'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Search, { placeholder: 'By name', enterButton: 'Search', size: 'large', onSearch: this.onNameSearch, value: nameSearch, onChange: this.onNameChange, style: { maxWidth: '500px' } })), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.clearButton, onClick: this.clearFilters }, 'Clear')), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('h4', { className: 'headline-default' }, 'Filter'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.wrapperFilters }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.searchWrapperFilterItemApprove }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a, { onChange: this.onSelectApprovedStatus('approved'), checked: approvedSelected === null || approvedSelected === true }, 'Approved'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a, { onChange: this.onSelectApprovedStatus('unapproved'), checked: !approvedSelected }, 'Unapproved')), filtersBy.map(function (_, index) {
        return _this3.renderFilterItem(index);
      }), filtersBy.length === filtersValue.length && filtersBy.length !== 4 && this.renderFilterItem()), errorMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'error', message: errorMessage, className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.alert }), responseMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'success', message: responseMessage, className: __WEBPACK_IMPORTED_MODULE_34__DocumentsEditor_css___default.a.alert }), documentCreatePermission && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', onClick: this.addDocument }, 'Add new document'), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: documents, loading: isLoading, rowKey: 'id', onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!documentEdit, onCancel: this.onDocumentEditHide, footer: null }, documentEdit && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_DocumentForm_DocumentForm__["a" /* default */], Object.assign({}, documentEdit, { isNew: documentEdit && !documentEdit.id, onSubmit: this.onDocumentEditSubmit, onCancel: this.onDocumentEditHide })))), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return DocumentsEditor;
}(__WEBPACK_IMPORTED_MODULE_27_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { documentCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["r" /* getDocumentCreatePermission */])(state), documentApprovePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["q" /* getDocumentApprovePermission */])(state), documentUnapprovePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["z" /* getDocumentUnapprovePermission */])(state), documentDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["s" /* getDocumentDeletePermission */])(state), documentUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["A" /* getDocumentUpdatePermission */])(state), documentTrainingReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["y" /* getDocumentTrainingReadPermission */])(state), documentPublicReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["w" /* getDocumentPublicReadPermission */])(state), documentGeneralReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["u" /* getDocumentGeneralReadPermission */])(state), documentGeneralPrivateReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["t" /* getDocumentGeneralPrivateReadPermission */])(state), documentPerSiteReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["v" /* getDocumentPerSiteReadPermission */])(state), documentValidationReadPermission: Object(__WEBPACK_IMPORTED_MODULE_38__reducers_user_selectors__["B" /* getDocumentValidationReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_37__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_35__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_30_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(DocumentsEditor)));

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"DocumentsEditor__content__3kj3_","parentContainer":"DocumentsEditor__parentContainer__3QtTl","searchWrapper":"DocumentsEditor__searchWrapper__3ZeQ-","wrapperFilterItem":"DocumentsEditor__wrapperFilterItem__O8Hli","searchWrapperSearch":"DocumentsEditor__searchWrapperSearch__32JP8","searchWrapperLabel":"DocumentsEditor__searchWrapperLabel__1DKTQ","searchWrapperFilter":"DocumentsEditor__searchWrapperFilter__3vvXH","searchWrapperFilterItem":"DocumentsEditor__searchWrapperFilterItem__3-H4A","searchWrapperFilterItemApprove":"DocumentsEditor__searchWrapperFilterItemApprove__15K9u","searchWrapperFilterLabel":"DocumentsEditor__searchWrapperFilterLabel__2EXp5","clearButton":"DocumentsEditor__clearButton__3sS-A","checkIcon":"DocumentsEditor__checkIcon__3Dvf5","clockIcon":"DocumentsEditor__clockIcon__3kBBC","checkIconGray":"DocumentsEditor__checkIconGray__3LXIS","warningIcon":"DocumentsEditor__warningIcon__2cML-","iconStatusWrapper":"DocumentsEditor__iconStatusWrapper__1ci31","eventDropdownItem":"DocumentsEditor__eventDropdownItem__1RcOo","legendItem":"DocumentsEditor__legendItem__3if-Z","icon":"DocumentsEditor__icon__2G3eI","iconEdit":"DocumentsEditor__iconEdit__2hteh","reactivateBtn":"DocumentsEditor__reactivateBtn__1Lp9V","actions":"DocumentsEditor__actions__1ze-d","nameDocumentWrapper":"DocumentsEditor__nameDocumentWrapper__27utW","switchLabel":"DocumentsEditor__switchLabel__1InM-","alert":"DocumentsEditor__alert__1jdLg"};

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_SettingsConsentForm_SettingsConsentForm__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__ = __webpack_require__(37);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default.a.Content;var SettingsConsent = function (_React$Component) {
  _inherits(SettingsConsent, _React$Component);function SettingsConsent(props) {
    var _this2 = this;_classCallCheck(this, SettingsConsent);var _this = _possibleConstructorReturn(this, (SettingsConsent.__proto__ || Object.getPrototypeOf(SettingsConsent)).call(this, props));_this.getConsentList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["X" /* getConsentRequest */])({ nameSearch: _this.state.nameSearch, stateFilter: _this.state.consentFilterState });case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ consentList: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.columns = [{ dataIndex: "name", key: "name", title: "Name", render: function render(val, record) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_badge___default.a, { count: record.state, style: { width: '56px', backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }), ' \xA0', val);
      } }, // {
    //   dataIndex: "site_id",
    //   key: "site_id",
    //   title: "Site id",
    // },
    { dataIndex: "site", key: "site", title: "Site", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(val, 'name'));
      } }, { dataIndex: "applied_to", key: "applied_to", title: "Applied to", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, val.replace(/_/g, ' '));
      } }, { dataIndex: "consent_type", key: "consent_type", title: "Consent type", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, val.replace(/_/g, ' '));
      } }, { dataIndex: "id", key: "id", title: "Actions", render: function render(id, consent) {
        return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Edit Consent' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.actionIcon, onClick: _this.onConsentEdit(consent) })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Activate / Deactivate Consent' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_switch___default.a, { disabled: consent.state === 'active' && !_this.props.consentDeletePermission || consent.state === 'inactive' && !_this.props.consentUpdatePermission, className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.activateBtn, checked: consent.state === 'active', onChange: _this.onSwitchConsentActivation(id, consent.state) }))));
      } }];_this.onSwitchConsentActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;if (!(state === 'active')) {
                  _context2.next = 6;break;
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["H" /* deleteConsentRequest */])(id);case 4:
                _context2.next = 8;break;case 6:
                _context2.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_33__api_requests__["b" /* activateConsentRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Saved');_this.getConsentList();_context2.next = 18;break;case 12:
                _context2.prev = 12;_context2.t0 = _context2['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                  _context2.next = 17;break;
                }_this.props.logout();return _context2.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, 'response.data.error', 'Error'));case 18:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 12]]);
      }));
    };_this.onConsentEdit = function (consent) {
      return function () {
        _this.setState({ consentEdit: consent });
      };
    };_this.onConsentEditHide = function () {
      _this.setState({ consentEdit: null });
    };_this.onConsentEditSubmit = function () {
      _this.setState({ consentEdit: null }, _this.getConsentList);
    };_this.addConsent = function () {
      _this.setState({ consentEdit: {} });
    };_this.onNameSearch = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee3(value) {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _this.setState({ nameSearch: value }, _this.getConsentList);case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onNameChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.clearFilters = function () {
      _this.setState({ nameSearch: null }, _this.getConsentList);
    };_this.state = { consentList: [], consentFilterState: 'active', errorMessage: '', responseMessage: '', consentEdit: null, nameSearch: null };return _this;
  }_createClass(SettingsConsent, [{ key: 'componentDidMount', value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                this.getConsentList();case 1:case 'end':
                return _context4.stop();}
          }
        }, _callee4, this);
      }));function componentDidMount() {
        return _ref5.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          consentList = _state.consentList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          consentEdit = _state.consentEdit,
          nameSearch = _state.nameSearch;var consentCreatePermission = this.props.consentCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h3', { className: 'headline-default' }, 'Consent Management'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a.Item, { href: '/admin/settings' }, 'Admin Settings'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_breadcrumb___default.a.Item, { href: '/admin/consent/editor' }, 'Consent Management')), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a.Search, { placeholder: 'By name', enterButton: 'Search', size: 'large', onSearch: this.onNameSearch, value: nameSearch, onChange: this.onNameChange, style: { maxWidth: '500px' } })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.clearButton, onClick: this.clearFilters }, 'Clear')), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), !consentEdit && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, errorMessage && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), consentCreatePermission && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', onClick: this.addConsent }, 'Add consent'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.filterConsentState }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsConsent_css___default.a.searchWrapperLabel }, 'Show consent with state:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, { defaultValue: 'active', onChange: function onChange(value) {
          _this3.setState({ consentFilterState: value }, function () {
            return _this3.getConsentList();
          });
        } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option, { key: 'state-active', value: 'active' }, 'Active'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option, { key: 'state-inactive', value: 'inactive' }, 'Inactive'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option, { key: 'state-all', value: '' }, 'All'))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a, { columns: this.columns, dataSource: consentList, loading: isLoading, rowKey: 'id', pagination: false })), consentEdit && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_SettingsConsentForm_SettingsConsentForm__["a" /* default */], Object.assign({}, consentEdit, { isNew: consentEdit && !consentEdit.id, onSubmit: this.onConsentEditSubmit, onCancel: this.onConsentEditHide }))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsConsent;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["f" /* getConsentCreatePermission */])(state), consentUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["j" /* getConsentUpdatePermission */])(state), consentDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_35__reducers_user_selectors__["g" /* getConsentDeletePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_32__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_27_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsConsent)));

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_codemirror2__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_codemirror2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_codemirror2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reducers_user_actions__ = __webpack_require__(36);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import prettify from 'html-prettify';
// import { CKEditor } from '../../utils/ckeditor';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import CKEditor from 'ckeditor4-react';
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var SettingsConsentForm = function (_React$Component) {
  _inherits(SettingsConsentForm, _React$Component);function SettingsConsentForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsConsentForm);var _this = _possibleConstructorReturn(this, (SettingsConsentForm.__proto__ || Object.getPrototypeOf(SettingsConsentForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var consent, errors;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 24;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;consent = Object.assign({}, values);consent.content = _this.state.content;if (!_this.props.id) {
                    _context.next = 11;break;
                  }_context.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["_60" /* updateConsentRequest */])(_this.props.id, consent);case 9:
                  _context.next = 13;break;case 11:
                  _context.next = 13;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["r" /* createConsentRequest */])(consent);case 13:
                  _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 24;break;case 17:
                  _context.prev = 17;_context.t0 = _context["catch"](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 22;break;
                  }_this.props.logout();return _context.abrupt("return");case 22:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 24:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 17]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {}, content: null, sites: [], view: "html" };return _this;
  }_createClass(SettingsConsentForm, [{ key: "componentDidMount", value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                this.setState({ content: this.props.content });this.editorInstance.setSize("100%", "500px");_context2.prev = 2;_context2.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["_16" /* getSettingsSitesRequest */])({});case 5:
                _ref3 = _context2.sent;data = _ref3.data;this.setState({ sites: data });_context2.next = 16;break;case 10:
                _context2.prev = 10;_context2.t0 = _context2["catch"](2);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                  _context2.next = 15;break;
                }this.props.logout();return _context2.abrupt("return");case 15:
                console.log(_context2.t0);case 16:case "end":
                return _context2.stop();}
          }
        }, _callee2, this, [[2, 10]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          content = _state.content,
          sites = _state.sites,
          view = _state.view;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          consentUpdatePermission = _props.consentUpdatePermission,
          consentCreatePermission = _props.consentCreatePermission,
          id = _props.id,
          isNew = _props.isNew;var isEditable = id ? consentUpdatePermission : consentCreatePermission;var appliedVal = getFieldValue("applied_to");return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h4", { className: "headline-default" }, this.props.id ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span", null, this.props.name, " ", __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default.a, { count: "Edit", style: { backgroundColor: "#2968AE" } })) : isNew ? "Add consent" : ""), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Name:"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("name", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "name", "") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: "name" }))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Consent type:"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("consent_type", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "consent_type", "") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "subject_form" }, "Subject form"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "surrogate_form" }, "Surrogate form"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "patient_regained_capacity_form" }, "Patient regained capacity form"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "blank_subject_form" }, "Blank subject form"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "randomization_platform_step_3_patient" }, "Randomization Platform Step 3 Patient"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "randomization_platform_step_3_patient_regained_capacity" }, "Randomization Platform Step 3 Patient Regained Capacity"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "randomization_platform_step_3_surrogate" }, "Randomization Platform Step 3 Surrogate"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_form" }, "Edmonton Consent - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_regained_capacity_form" }, "Edmonton Consent - Patient Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_withdraw_form" }, "Edmonton Consent - Patient Withdraw - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_surrogate" }, "Edmonton Consent - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_deferred" }, "Edmonton Consent - Deferred Consent - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_form_ui" }, "Edmonton Consent - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_regained_capacity_form_ui" }, "Edmonton Consent - Patient Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_withdraw_form_ui" }, "Edmonton Consent - Patient Withdraw - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_surrogate_ui" }, "Edmonton Consent - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "edmonton_consent_patient_deferred_ui" }, "Edmonton Consent - Deferred Consent - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_patient_form_pdf" }, "Sunnybrook - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_patient_regained_capacity_form_pdf" }, "Sunnybrook - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_surrogate_pdf" }, "Sunnybrook - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_patient_form_ui" }, "Sunnybrook - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_patient_regained_capacity_form_ui" }, "Sunnybrook - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "sunnybrook_consent_surrogate_ui" }, "Sunnybrook - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_patient_form_pdf" }, "Toronto UH - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_patient_regained_capacity_form_pdf" }, "Toronto UH - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_surrogate_pdf" }, "Toronto UH - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_patient_form_ui" }, "Toronto UH - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_patient_regained_capacity_form_ui" }, "Toronto UH - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "toronto_uh_consent_surrogate_ui" }, "Toronto UH - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "montreal_consent_patient_form_pdf" }, "Montreal - Patient / Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "montreal_consent_patient_form_ui" }, "Montreal - Patient / Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_patient_form_pdf" }, "Winnipeg - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_patient_regained_capacity_form_pdf" }, "Winnipeg - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_surrogate_pdf" }, "Winnipeg - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_substudy_form_pdf" }, "Winnipeg - Patient / Surrogate - Substudy - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_patient_form_ui" }, "Winnipeg - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_patient_regained_capacity_form_ui" }, "Winnipeg Consent - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_surrogate_ui" }, "Winnipeg Consent - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "winnipeg_consent_substudy_form_ui" }, "Winnipeg Consent - Patient / Surrogate - Substudy - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_patient_form_pdf" }, "UHN - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_patient_regained_capacity_form_pdf" }, "UHN - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_surrogate_pdf" }, "UHN - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_patient_form_ui" }, "UHN - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_patient_regained_capacity_form_ui" }, "UHN - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "uhn_consent_surrogate_ui" }, "UHN - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_patient_form_pdf" }, "Halifax - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_patient_regained_capacity_form_pdf" }, "Halifax - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_surrogate_pdf" }, "Halifax - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_patient_form_ui" }, "Halifax - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_patient_regained_capacity_form_ui" }, "Halifax - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "halifax_consent_surrogate_ui" }, "Halifax - Surrogate - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_patient_form_pdf" }, "Pei - Patient - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_patient_regained_capacity_form_pdf" }, "Pei - Patient - Regained Capacity - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_surrogate_pdf" }, "Pei - Surrogate - PDF"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_patient_form_ui" }, "Pei - Patient - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_patient_regained_capacity_form_ui" }, "Pei - Patient - Regained Capacity - UI"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "pei_consent_surrogate_ui" }, "Pei - Surrogate - UI"))))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Applied to:"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("applied_to", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "applied_to", "") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "all_sites" }, "All sites"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "site" }, "Site")))))), appliedVal === "site" && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Site ID"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("site_id", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "site_id") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { placeholder: "Select Site ID", style: { width: "100%" }, allowClear: true }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, " - ", site.name);
      }))))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { style: { marginBottom: "30px" } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: "primary", size: "large", onClick: function onClick() {
          _this3.setState(function (state) {
            return { view: state.view === "html" ? "preview" : "html" };
          });
        } }, "Switch to ", view === "html" ? "Preview" : "Code")), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12, style: { display: view === "html" ? 'block' : 'none' } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { style: { marginBottom: "20px" } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_codemirror2__["Controlled"], { editorDidMount: function editorDidMount(editor) {
          _this3.editorInstance = editor;
        }, value: content, onBeforeChange: function onBeforeChange(editor, data, value) {
          _this3.setState({ content: value });
        }, options: { mode: "html", theme: "material", lineNumbers: true } })))), view === "preview" && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h3", { className: "headline-default" }, "Preview"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("iframe", { id: "previewFrame", onLoad: function onLoad() {
          var iFrameID = document.getElementById('previewFrame');console.log(iFrameID);if (iFrameID) {
            iFrameID.height = "";iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + 60 + "px";
          }
        }, srcDoc: content ? content.replace(/src="{{(.*)}}/g, 'src="{{$1}}" alt="$1"').replace(/src={{(.*)}}/g, 'src="{{$1}}" alt="$1"').replace(/margin-left: -15px/g, '').replace(/static\/images/g, "https://act-staging-api.dctms.ca/static/images").replace(/url\(\"static/g, 'url("https://act-staging-api.dctms.ca/static') : "", className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.previewFrame }))), requestResult.type && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" }))), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_25__SettingsConsentForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"))));
    } }]);return SettingsConsentForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_24__reducers_user_selectors__["f" /* getConsentCreatePermission */])(state), consentUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_24__reducers_user_selectors__["j" /* getConsentUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_26__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({ name: "consent" })(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsConsentForm)));

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}

var __extends = void 0 && (void 0).__extends || function() {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    }
    instanceof Array && function(d, b) {
      d.__proto__ = b;
    } || function(d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function(d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = __webpack_require__(0);

var SERVER_RENDERED = typeof navigator === 'undefined' || global['PREVENT_CODEMIRROR_RENDER'] === true;
var cm;

if (!SERVER_RENDERED) {
  cm = __webpack_require__(1893);
}

var Helper = function() {
  function Helper() {}

  Helper.equals = function(x, y) {
    var _this = this;

    var ok = Object.keys,
      tx = _typeof(x),
      ty = _typeof(y);

    return x && y && tx === 'object' && tx === ty ? ok(x).length === ok(y).length && ok(x).every(function(key) {
      return _this.equals(x[key], y[key]);
    }) : x === y;
  };

  return Helper;
}();

var Shared = function() {
  function Shared(editor, props) {
    this.editor = editor;
    this.props = props;
  }

  Shared.prototype.delegateCursor = function(position, scroll, focus) {
    var doc = this.editor.getDoc();

    if (focus) {
      this.editor.focus();
    }

    scroll ? doc.setCursor(position) : doc.setCursor(position, null, {
      scroll: false
    });
  };

  Shared.prototype.delegateScroll = function(coordinates) {
    this.editor.scrollTo(coordinates.x, coordinates.y);
  };

  Shared.prototype.delegateSelection = function(ranges, focus) {
    var doc = this.editor.getDoc();
    doc.setSelections(ranges);

    if (focus) {
      this.editor.focus();
    }
  };

  Shared.prototype.apply = function(props) {
    if (props && props.selection && props.selection.ranges) {
      this.delegateSelection(props.selection.ranges, props.selection.focus || false);
    }

    if (props && props.cursor) {
      this.delegateCursor(props.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
    }

    if (props && props.scroll) {
      this.delegateScroll(props.scroll);
    }
  };

  Shared.prototype.applyNext = function(props, next, preserved) {
    if (props && props.selection && props.selection.ranges) {
      if (next && next.selection && next.selection.ranges && !Helper.equals(props.selection.ranges, next.selection.ranges)) {
        this.delegateSelection(next.selection.ranges, next.selection.focus || false);
      }
    }

    if (props && props.cursor) {
      if (next && next.cursor && !Helper.equals(props.cursor, next.cursor)) {
        this.delegateCursor(preserved.cursor || next.cursor, next.autoScroll || false, next.autoCursor || false);
      }
    }

    if (props && props.scroll) {
      if (next && next.scroll && !Helper.equals(props.scroll, next.scroll)) {
        this.delegateScroll(next.scroll);
      }
    }
  };

  Shared.prototype.applyUserDefined = function(props, preserved) {
    if (preserved && preserved.cursor) {
      this.delegateCursor(preserved.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
    }
  };

  Shared.prototype.wire = function(props) {
    var _this = this;

    Object.keys(props || {}).filter(function(p) {
      return /^on/.test(p);
    }).forEach(function(prop) {
      switch (prop) {
        case 'onBlur':
          {
            _this.editor.on('blur', function(cm, event) {
              _this.props.onBlur(_this.editor, event);
            });
          }
          break;

        case 'onContextMenu':
          {
            _this.editor.on('contextmenu', function(cm, event) {
              _this.props.onContextMenu(_this.editor, event);
            });

            break;
          }

        case 'onCopy':
          {
            _this.editor.on('copy', function(cm, event) {
              _this.props.onCopy(_this.editor, event);
            });

            break;
          }

        case 'onCursor':
          {
            _this.editor.on('cursorActivity', function(cm) {
              _this.props.onCursor(_this.editor, _this.editor.getDoc().getCursor());
            });
          }
          break;

        case 'onCursorActivity':
          {
            _this.editor.on('cursorActivity', function(cm) {
              _this.props.onCursorActivity(_this.editor);
            });
          }
          break;

        case 'onCut':
          {
            _this.editor.on('cut', function(cm, event) {
              _this.props.onCut(_this.editor, event);
            });

            break;
          }

        case 'onDblClick':
          {
            _this.editor.on('dblclick', function(cm, event) {
              _this.props.onDblClick(_this.editor, event);
            });

            break;
          }

        case 'onDragEnter':
          {
            _this.editor.on('dragenter', function(cm, event) {
              _this.props.onDragEnter(_this.editor, event);
            });
          }
          break;

        case 'onDragLeave':
          {
            _this.editor.on('dragleave', function(cm, event) {
              _this.props.onDragLeave(_this.editor, event);
            });

            break;
          }

        case 'onDragOver':
          {
            _this.editor.on('dragover', function(cm, event) {
              _this.props.onDragOver(_this.editor, event);
            });
          }
          break;

        case 'onDragStart':
          {
            _this.editor.on('dragstart', function(cm, event) {
              _this.props.onDragStart(_this.editor, event);
            });

            break;
          }

        case 'onDrop':
          {
            _this.editor.on('drop', function(cm, event) {
              _this.props.onDrop(_this.editor, event);
            });
          }
          break;

        case 'onFocus':
          {
            _this.editor.on('focus', function(cm, event) {
              _this.props.onFocus(_this.editor, event);
            });
          }
          break;

        case 'onGutterClick':
          {
            _this.editor.on('gutterClick', function(cm, lineNumber, gutter, event) {
              _this.props.onGutterClick(_this.editor, lineNumber, gutter, event);
            });
          }
          break;

        case 'onKeyDown':
          {
            _this.editor.on('keydown', function(cm, event) {
              _this.props.onKeyDown(_this.editor, event);
            });
          }
          break;

        case 'onKeyPress':
          {
            _this.editor.on('keypress', function(cm, event) {
              _this.props.onKeyPress(_this.editor, event);
            });
          }
          break;

        case 'onKeyUp':
          {
            _this.editor.on('keyup', function(cm, event) {
              _this.props.onKeyUp(_this.editor, event);
            });
          }
          break;

        case 'onMouseDown':
          {
            _this.editor.on('mousedown', function(cm, event) {
              _this.props.onMouseDown(_this.editor, event);
            });

            break;
          }

        case 'onPaste':
          {
            _this.editor.on('paste', function(cm, event) {
              _this.props.onPaste(_this.editor, event);
            });

            break;
          }

        case 'onRenderLine':
          {
            _this.editor.on('renderLine', function(cm, line, element) {
              _this.props.onRenderLine(_this.editor, line, element);
            });

            break;
          }

        case 'onScroll':
          {
            _this.editor.on('scroll', function(cm) {
              _this.props.onScroll(_this.editor, _this.editor.getScrollInfo());
            });
          }
          break;

        case 'onSelection':
          {
            _this.editor.on('beforeSelectionChange', function(cm, data) {
              _this.props.onSelection(_this.editor, data);
            });
          }
          break;

        case 'onTouchStart':
          {
            _this.editor.on('touchstart', function(cm, event) {
              _this.props.onTouchStart(_this.editor, event);
            });

            break;
          }

        case 'onUpdate':
          {
            _this.editor.on('update', function(cm) {
              _this.props.onUpdate(_this.editor);
            });
          }
          break;

        case 'onViewportChange':
          {
            _this.editor.on('viewportChange', function(cm, from, to) {
              _this.props.onViewportChange(_this.editor, from, to);
            });
          }
          break;
      }
    });
  };

  return Shared;
}();

var Controlled = function(_super) {
  __extends(Controlled, _super);

  function Controlled(props) {
    var _this = _super.call(this, props) || this;

    if (SERVER_RENDERED) return _this;
    _this.applied = false;
    _this.appliedNext = false;
    _this.appliedUserDefined = false;
    _this.deferred = null;
    _this.emulating = false;
    _this.hydrated = false;

    _this.initCb = function() {
      if (_this.props.editorDidConfigure) {
        _this.props.editorDidConfigure(_this.editor);
      }
    };

    _this.mounted = false;
    return _this;
  }

  Controlled.prototype.hydrate = function(props) {
    var _this = this;

    var _options = props && props.options ? props.options : {};

    var userDefinedOptions = _extends({}, cm.defaults, this.editor.options, _options);

    var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
      return _this.editor.getOption(key) !== userDefinedOptions[key];
    });

    if (optionDelta) {
      Object.keys(userDefinedOptions).forEach(function(key) {
        if (_options.hasOwnProperty(key)) {
          if (_this.editor.getOption(key) !== userDefinedOptions[key]) {
            _this.editor.setOption(key, userDefinedOptions[key]);

            _this.mirror.setOption(key, userDefinedOptions[key]);
          }
        }
      });
    }

    if (!this.hydrated) {
      this.deferred ? this.resolveChange() : this.initChange(props.value || '');
    }

    this.hydrated = true;
  };

  Controlled.prototype.initChange = function(value) {
    this.emulating = true;
    var doc = this.editor.getDoc();
    var lastLine = doc.lastLine();
    var lastChar = doc.getLine(doc.lastLine()).length;
    doc.replaceRange(value || '', {
      line: 0,
      ch: 0
    }, {
      line: lastLine,
      ch: lastChar
    });
    this.mirror.setValue(value);
    doc.clearHistory();
    this.mirror.clearHistory();
    this.emulating = false;
  };

  Controlled.prototype.resolveChange = function() {
    this.emulating = true;
    var doc = this.editor.getDoc();

    if (this.deferred.origin === 'undo') {
      doc.undo();
    } else if (this.deferred.origin === 'redo') {
      doc.redo();
    } else {
      doc.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin);
    }

    this.emulating = false;
    this.deferred = null;
  };

  Controlled.prototype.mirrorChange = function(deferred) {
    var doc = this.editor.getDoc();

    if (deferred.origin === 'undo') {
      doc.setHistory(this.mirror.getHistory());
      this.mirror.undo();
    } else if (deferred.origin === 'redo') {
      doc.setHistory(this.mirror.getHistory());
      this.mirror.redo();
    } else {
      this.mirror.replaceRange(deferred.text, deferred.from, deferred.to, deferred.origin);
    }

    return this.mirror.getValue();
  };

  Controlled.prototype.componentDidMount = function() {
    var _this = this;

    if (SERVER_RENDERED) return;

    if (this.props.defineMode) {
      if (this.props.defineMode.name && this.props.defineMode.fn) {
        cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
      }
    }

    this.editor = cm(this.ref);
    this.shared = new Shared(this.editor, this.props);
    this.mirror = cm(function() {});
    this.editor.on('electricInput', function() {
      _this.mirror.setHistory(_this.editor.getDoc().getHistory());
    });
    this.editor.on('cursorActivity', function() {
      _this.mirror.setCursor(_this.editor.getDoc().getCursor());
    });
    this.editor.on('beforeChange', function(cm, data) {
      if (_this.emulating) {
        return;
      }

      data.cancel();
      _this.deferred = data;

      var phantomChange = _this.mirrorChange(_this.deferred);

      if (_this.props.onBeforeChange) _this.props.onBeforeChange(_this.editor, _this.deferred, phantomChange);
    });
    this.editor.on('change', function(cm, data) {
      if (!_this.mounted) {
        return;
      }

      if (_this.props.onChange) {
        _this.props.onChange(_this.editor, data, _this.editor.getValue());
      }
    });
    this.hydrate(this.props);
    this.shared.apply(this.props);
    this.applied = true;
    this.mounted = true;
    this.shared.wire(this.props);

    if (this.editor.getOption('autofocus')) {
      this.editor.focus();
    }

    if (this.props.editorDidMount) {
      this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
    }
  };

  Controlled.prototype.componentWillReceiveProps = function(nextProps) {
    if (SERVER_RENDERED) return;
    var preserved = {
      cursor: null
    };

    if (nextProps.value !== this.props.value) {
      this.hydrated = false;
    }

    if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
      preserved.cursor = this.editor.getDoc().getCursor();
    }

    this.hydrate(nextProps);

    if (!this.appliedNext) {
      this.shared.applyNext(this.props, nextProps, preserved);
      this.appliedNext = true;
    }

    this.shared.applyUserDefined(this.props, preserved);
    this.appliedUserDefined = true;
  };

  Controlled.prototype.componentWillUnmount = function() {
    if (SERVER_RENDERED) return;

    if (this.props.editorWillUnmount) {
      this.props.editorWillUnmount(cm);
    }
  };

  Controlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
    return !SERVER_RENDERED;
  };

  Controlled.prototype.render = function() {
    var _this = this;

    if (SERVER_RENDERED) return null;
    var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
    return React.createElement('div', {
      className: className,
      ref: function ref(self) {
        return _this.ref = self;
      }
    });
  };

  return Controlled;
}(React.Component);

exports.Controlled = Controlled;

var UnControlled = function(_super) {
  __extends(UnControlled, _super);

  function UnControlled(props) {
    var _this = _super.call(this, props) || this;

    if (SERVER_RENDERED) return _this;
    _this.applied = false;
    _this.appliedUserDefined = false;
    _this.continueChange = false;
    _this.detached = false;
    _this.hydrated = false;

    _this.initCb = function() {
      if (_this.props.editorDidConfigure) {
        _this.props.editorDidConfigure(_this.editor);
      }
    };

    _this.mounted = false;

    _this.onBeforeChangeCb = function() {
      _this.continueChange = true;
    };

    return _this;
  }

  UnControlled.prototype.hydrate = function(props) {
    var _this = this;

    var _options = props && props.options ? props.options : {};

    var userDefinedOptions = _extends({}, cm.defaults, this.editor.options, _options);

    var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
      return _this.editor.getOption(key) !== userDefinedOptions[key];
    });

    if (optionDelta) {
      Object.keys(userDefinedOptions).forEach(function(key) {
        if (_options.hasOwnProperty(key)) {
          if (_this.editor.getOption(key) !== userDefinedOptions[key]) {
            _this.editor.setOption(key, userDefinedOptions[key]);
          }
        }
      });
    }

    if (!this.hydrated) {
      var doc = this.editor.getDoc();
      var lastLine = doc.lastLine();
      var lastChar = doc.getLine(doc.lastLine()).length;
      doc.replaceRange(props.value || '', {
        line: 0,
        ch: 0
      }, {
        line: lastLine,
        ch: lastChar
      });
    }

    this.hydrated = true;
  };

  UnControlled.prototype.componentDidMount = function() {
    var _this = this;

    if (SERVER_RENDERED) return;
    this.detached = this.props.detach === true;

    if (this.props.defineMode) {
      if (this.props.defineMode.name && this.props.defineMode.fn) {
        cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
      }
    }

    this.editor = cm(this.ref);
    this.shared = new Shared(this.editor, this.props);
    this.editor.on('beforeChange', function(cm, data) {
      if (_this.props.onBeforeChange) {
        _this.props.onBeforeChange(_this.editor, data, _this.editor.getValue(), _this.onBeforeChangeCb);
      }
    });
    this.editor.on('change', function(cm, data) {
      if (!_this.mounted || !_this.props.onChange) {
        return;
      }

      if (_this.props.onBeforeChange) {
        if (_this.continueChange) {
          _this.props.onChange(_this.editor, data, _this.editor.getValue());
        }
      } else {
        _this.props.onChange(_this.editor, data, _this.editor.getValue());
      }
    });
    this.hydrate(this.props);
    this.shared.apply(this.props);
    this.applied = true;
    this.mounted = true;
    this.shared.wire(this.props);
    this.editor.getDoc().clearHistory();

    if (this.props.editorDidMount) {
      this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
    }
  };

  UnControlled.prototype.componentWillReceiveProps = function(nextProps) {
    if (this.detached && nextProps.detach === false) {
      this.detached = false;

      if (this.props.editorDidAttach) {
        this.props.editorDidAttach(this.editor);
      }
    }

    if (!this.detached && nextProps.detach === true) {
      this.detached = true;

      if (this.props.editorDidDetach) {
        this.props.editorDidDetach(this.editor);
      }
    }

    if (SERVER_RENDERED || this.detached) return;
    var preserved = {
      cursor: null
    };

    if (nextProps.value !== this.props.value) {
      this.hydrated = false;
      this.applied = false;
      this.appliedUserDefined = false;
    }

    if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
      preserved.cursor = this.editor.getDoc().getCursor();
    }

    this.hydrate(nextProps);

    if (!this.applied) {
      this.shared.apply(this.props);
      this.applied = true;
    }

    if (!this.appliedUserDefined) {
      this.shared.applyUserDefined(this.props, preserved);
      this.appliedUserDefined = true;
    }
  };

  UnControlled.prototype.componentWillUnmount = function() {
    if (SERVER_RENDERED) return;

    if (this.props.editorWillUnmount) {
      this.props.editorWillUnmount(cm);
    }
  };

  UnControlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
    var update = true;
    if (SERVER_RENDERED) update = false;
    if (this.detached) update = false;
    return update;
  };

  UnControlled.prototype.render = function() {
    var _this = this;

    if (SERVER_RENDERED) return null;
    var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
    return React.createElement('div', {
      className: className,
      ref: function ref(self) {
        return _this.ref = self;
      }
    });
  };

  return UnControlled;
}(React.Component);

exports.UnControlled = UnControlled;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.CodeMirror = factory());
}(this, (function () { 'use strict';

  // Kludges for bugs and behavior differences that can't be feature
  // detected are enabled based on userAgent etc sniffing.
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;

  var gecko = /gecko\/\d/i.test(userAgent);
  var ie_upto10 = /MSIE \d/.test(userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
  var edge = /Edge\/(\d+)/.exec(userAgent);
  var ie = ie_upto10 || ie_11up || edge;
  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
  var webkit = !edge && /WebKit\//.test(userAgent);
  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
  var chrome = !edge && /Chrome\//.test(userAgent);
  var presto = /Opera\//.test(userAgent);
  var safari = /Apple Computer/.test(navigator.vendor);
  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
  var phantom = /PhantomJS/.test(userAgent);

  var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
  var android = /Android/.test(userAgent);
  // This is woefully incomplete. Suggestions for alternative methods welcome.
  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
  var mac = ios || /Mac/.test(platform);
  var chromeOS = /\bCrOS\b/.test(userAgent);
  var windows = /win/i.test(platform);

  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
  if (presto_version) { presto_version = Number(presto_version[1]); }
  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
  var captureRightClick = gecko || (ie && ie_version >= 9);

  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

  var rmClass = function(node, cls) {
    var current = node.className;
    var match = classTest(cls).exec(current);
    if (match) {
      var after = current.slice(match.index + match[0].length);
      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
    }
  };

  function removeChildren(e) {
    for (var count = e.childNodes.length; count > 0; --count)
      { e.removeChild(e.firstChild); }
    return e
  }

  function removeChildrenAndAdd(parent, e) {
    return removeChildren(parent).appendChild(e)
  }

  function elt(tag, content, className, style) {
    var e = document.createElement(tag);
    if (className) { e.className = className; }
    if (style) { e.style.cssText = style; }
    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
    return e
  }
  // wrapper for elt, which removes the elt from the accessibility tree
  function eltP(tag, content, className, style) {
    var e = elt(tag, content, className, style);
    e.setAttribute("role", "presentation");
    return e
  }

  var range;
  if (document.createRange) { range = function(node, start, end, endNode) {
    var r = document.createRange();
    r.setEnd(endNode || node, end);
    r.setStart(node, start);
    return r
  }; }
  else { range = function(node, start, end) {
    var r = document.body.createTextRange();
    try { r.moveToElementText(node.parentNode); }
    catch(e) { return r }
    r.collapse(true);
    r.moveEnd("character", end);
    r.moveStart("character", start);
    return r
  }; }

  function contains(parent, child) {
    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
      { child = child.parentNode; }
    if (parent.contains)
      { return parent.contains(child) }
    do {
      if (child.nodeType == 11) { child = child.host; }
      if (child == parent) { return true }
    } while (child = child.parentNode)
  }

  function activeElt() {
    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
    // IE < 10 will throw when accessed while the page is loading or in an iframe.
    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
    var activeElement;
    try {
      activeElement = document.activeElement;
    } catch(e) {
      activeElement = document.body || null;
    }
    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
      { activeElement = activeElement.shadowRoot.activeElement; }
    return activeElement
  }

  function addClass(node, cls) {
    var current = node.className;
    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
  }
  function joinClasses(a, b) {
    var as = a.split(" ");
    for (var i = 0; i < as.length; i++)
      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
    return b
  }

  var selectInput = function(node) { node.select(); };
  if (ios) // Mobile Safari apparently has a bug where select() is broken.
    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
  else if (ie) // Suppress mysterious IE10 errors
    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

  function bind(f) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(){return f.apply(null, args)}
  }

  function copyObj(obj, target, overwrite) {
    if (!target) { target = {}; }
    for (var prop in obj)
      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
        { target[prop] = obj[prop]; } }
    return target
  }

  // Counts the column offset in a string, taking tabs into account.
  // Used mostly to find indentation.
  function countColumn(string, end, tabSize, startIndex, startValue) {
    if (end == null) {
      end = string.search(/[^\s\u00a0]/);
      if (end == -1) { end = string.length; }
    }
    for (var i = startIndex || 0, n = startValue || 0;;) {
      var nextTab = string.indexOf("\t", i);
      if (nextTab < 0 || nextTab >= end)
        { return n + (end - i) }
      n += nextTab - i;
      n += tabSize - (n % tabSize);
      i = nextTab + 1;
    }
  }

  var Delayed = function() {
    this.id = null;
    this.f = null;
    this.time = 0;
    this.handler = bind(this.onTimeout, this);
  };
  Delayed.prototype.onTimeout = function (self) {
    self.id = 0;
    if (self.time <= +new Date) {
      self.f();
    } else {
      setTimeout(self.handler, self.time - +new Date);
    }
  };
  Delayed.prototype.set = function (ms, f) {
    this.f = f;
    var time = +new Date + ms;
    if (!this.id || time < this.time) {
      clearTimeout(this.id);
      this.id = setTimeout(this.handler, ms);
      this.time = time;
    }
  };

  function indexOf(array, elt) {
    for (var i = 0; i < array.length; ++i)
      { if (array[i] == elt) { return i } }
    return -1
  }

  // Number of pixels added to scroller and sizer to hide scrollbar
  var scrollerGap = 30;

  // Returned or thrown by various protocols to signal 'I'm not
  // handling this'.
  var Pass = {toString: function(){return "CodeMirror.Pass"}};

  // Reused option objects for setSelection & friends
  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};

  // The inverse of countColumn -- find the offset that corresponds to
  // a particular column.
  function findColumn(string, goal, tabSize) {
    for (var pos = 0, col = 0;;) {
      var nextTab = string.indexOf("\t", pos);
      if (nextTab == -1) { nextTab = string.length; }
      var skipped = nextTab - pos;
      if (nextTab == string.length || col + skipped >= goal)
        { return pos + Math.min(skipped, goal - col) }
      col += nextTab - pos;
      col += tabSize - (col % tabSize);
      pos = nextTab + 1;
      if (col >= goal) { return pos }
    }
  }

  var spaceStrs = [""];
  function spaceStr(n) {
    while (spaceStrs.length <= n)
      { spaceStrs.push(lst(spaceStrs) + " "); }
    return spaceStrs[n]
  }

  function lst(arr) { return arr[arr.length-1] }

  function map(array, f) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
    return out
  }

  function insertSorted(array, value, score) {
    var pos = 0, priority = score(value);
    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
    array.splice(pos, 0, value);
  }

  function nothing() {}

  function createObj(base, props) {
    var inst;
    if (Object.create) {
      inst = Object.create(base);
    } else {
      nothing.prototype = base;
      inst = new nothing();
    }
    if (props) { copyObj(props, inst); }
    return inst
  }

  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  function isWordCharBasic(ch) {
    return /\w/.test(ch) || ch > "\x80" &&
      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
  }
  function isWordChar(ch, helper) {
    if (!helper) { return isWordCharBasic(ch) }
    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
    return helper.test(ch)
  }

  function isEmpty(obj) {
    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
    return true
  }

  // Extending unicode characters. A series of a non-extending char +
  // any number of extending chars is treated as a single unit as far
  // as editing and measuring is concerned. This is not fully correct,
  // since some scripts/fonts/browsers also treat other configurations
  // of code points as a group.
  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
  function skipExtendingChars(str, pos, dir) {
    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
    return pos
  }

  // Returns the value from the range [`from`; `to`] that satisfies
  // `pred` and is closest to `from`. Assumes that at least `to`
  // satisfies `pred`. Supports `from` being greater than `to`.
  function findFirst(pred, from, to) {
    // At any point we are certain `to` satisfies `pred`, don't know
    // whether `from` does.
    var dir = from > to ? -1 : 1;
    for (;;) {
      if (from == to) { return from }
      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
      if (mid == from) { return pred(mid) ? from : to }
      if (pred(mid)) { to = mid; }
      else { from = mid + dir; }
    }
  }

  // BIDI HELPERS

  function iterateBidiSections(order, from, to, f) {
    if (!order) { return f(from, to, "ltr", 0) }
    var found = false;
    for (var i = 0; i < order.length; ++i) {
      var part = order[i];
      if (part.from < to && part.to > from || from == to && part.to == from) {
        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
        found = true;
      }
    }
    if (!found) { f(from, to, "ltr"); }
  }

  var bidiOther = null;
  function getBidiPartAt(order, ch, sticky) {
    var found;
    bidiOther = null;
    for (var i = 0; i < order.length; ++i) {
      var cur = order[i];
      if (cur.from < ch && cur.to > ch) { return i }
      if (cur.to == ch) {
        if (cur.from != cur.to && sticky == "before") { found = i; }
        else { bidiOther = i; }
      }
      if (cur.from == ch) {
        if (cur.from != cur.to && sticky != "before") { found = i; }
        else { bidiOther = i; }
      }
    }
    return found != null ? found : bidiOther
  }

  // Bidirectional ordering algorithm
  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
  // that this (partially) implements.

  // One-char codes used for character types:
  // L (L):   Left-to-Right
  // R (R):   Right-to-Left
  // r (AL):  Right-to-Left Arabic
  // 1 (EN):  European Number
  // + (ES):  European Number Separator
  // % (ET):  European Number Terminator
  // n (AN):  Arabic Number
  // , (CS):  Common Number Separator
  // m (NSM): Non-Spacing Mark
  // b (BN):  Boundary Neutral
  // s (B):   Paragraph Separator
  // t (S):   Segment Separator
  // w (WS):  Whitespace
  // N (ON):  Other Neutrals

  // Returns null if characters are ordered as they appear
  // (left-to-right), or an array of sections ({from, to, level}
  // objects) in the order in which they occur visually.
  var bidiOrdering = (function() {
    // Character types for codepoints 0 to 0xff
    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
    // Character types for codepoints 0x600 to 0x6f9
    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
    function charType(code) {
      if (code <= 0xf7) { return lowTypes.charAt(code) }
      else if (0x590 <= code && code <= 0x5f4) { return "R" }
      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
      else if (0x2000 <= code && code <= 0x200b) { return "w" }
      else if (code == 0x200c) { return "b" }
      else { return "L" }
    }

    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

    function BidiSpan(level, from, to) {
      this.level = level;
      this.from = from; this.to = to;
    }

    return function(str, direction) {
      var outerType = direction == "ltr" ? "L" : "R";

      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
      var len = str.length, types = [];
      for (var i = 0; i < len; ++i)
        { types.push(charType(str.charCodeAt(i))); }

      // W1. Examine each non-spacing mark (NSM) in the level run, and
      // change the type of the NSM to the type of the previous
      // character. If the NSM is at the start of the level run, it will
      // get the type of sor.
      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
        var type = types[i$1];
        if (type == "m") { types[i$1] = prev; }
        else { prev = type; }
      }

      // W2. Search backwards from each instance of a European number
      // until the first strong type (R, L, AL, or sor) is found. If an
      // AL is found, change the type of the European number to Arabic
      // number.
      // W3. Change all ALs to R.
      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
        var type$1 = types[i$2];
        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
      }

      // W4. A single European separator between two European numbers
      // changes to a European number. A single common separator between
      // two numbers of the same type changes to that type.
      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
        var type$2 = types[i$3];
        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
        else if (type$2 == "," && prev$1 == types[i$3+1] &&
                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
        prev$1 = type$2;
      }

      // W5. A sequence of European terminators adjacent to European
      // numbers changes to all European numbers.
      // W6. Otherwise, separators and terminators change to Other
      // Neutral.
      for (var i$4 = 0; i$4 < len; ++i$4) {
        var type$3 = types[i$4];
        if (type$3 == ",") { types[i$4] = "N"; }
        else if (type$3 == "%") {
          var end = (void 0);
          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
          for (var j = i$4; j < end; ++j) { types[j] = replace; }
          i$4 = end - 1;
        }
      }

      // W7. Search backwards from each instance of a European number
      // until the first strong type (R, L, or sor) is found. If an L is
      // found, then change the type of the European number to L.
      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
        var type$4 = types[i$5];
        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
        else if (isStrong.test(type$4)) { cur$1 = type$4; }
      }

      // N1. A sequence of neutrals takes the direction of the
      // surrounding strong text if the text on both sides has the same
      // direction. European and Arabic numbers act as if they were R in
      // terms of their influence on neutrals. Start-of-level-run (sor)
      // and end-of-level-run (eor) are used at level run boundaries.
      // N2. Any remaining neutrals take the embedding direction.
      for (var i$6 = 0; i$6 < len; ++i$6) {
        if (isNeutral.test(types[i$6])) {
          var end$1 = (void 0);
          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
          var before = (i$6 ? types[i$6-1] : outerType) == "L";
          var after = (end$1 < len ? types[end$1] : outerType) == "L";
          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
          i$6 = end$1 - 1;
        }
      }

      // Here we depart from the documented algorithm, in order to avoid
      // building up an actual levels array. Since there are only three
      // levels (0, 1, 2) in an implementation that doesn't take
      // explicit embedding into account, we can build up the order on
      // the fly, without following the level-based algorithm.
      var order = [], m;
      for (var i$7 = 0; i$7 < len;) {
        if (countsAsLeft.test(types[i$7])) {
          var start = i$7;
          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
          order.push(new BidiSpan(0, start, i$7));
        } else {
          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
          for (var j$2 = pos; j$2 < i$7;) {
            if (countsAsNum.test(types[j$2])) {
              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
              var nstart = j$2;
              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
              at += isRTL;
              pos = j$2;
            } else { ++j$2; }
          }
          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
        }
      }
      if (direction == "ltr") {
        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
          order[0].from = m[0].length;
          order.unshift(new BidiSpan(0, 0, m[0].length));
        }
        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
          lst(order).to -= m[0].length;
          order.push(new BidiSpan(0, len - m[0].length, len));
        }
      }

      return direction == "rtl" ? order.reverse() : order
    }
  })();

  // Get the bidi ordering for the given line (and cache it). Returns
  // false for lines that are fully left-to-right, and an array of
  // BidiSpan objects otherwise.
  function getOrder(line, direction) {
    var order = line.order;
    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
    return order
  }

  // EVENT HANDLING

  // Lightweight event framework. on/off also work on DOM nodes,
  // registering native DOM handlers.

  var noHandlers = [];

  var on = function(emitter, type, f) {
    if (emitter.addEventListener) {
      emitter.addEventListener(type, f, false);
    } else if (emitter.attachEvent) {
      emitter.attachEvent("on" + type, f);
    } else {
      var map = emitter._handlers || (emitter._handlers = {});
      map[type] = (map[type] || noHandlers).concat(f);
    }
  };

  function getHandlers(emitter, type) {
    return emitter._handlers && emitter._handlers[type] || noHandlers
  }

  function off(emitter, type, f) {
    if (emitter.removeEventListener) {
      emitter.removeEventListener(type, f, false);
    } else if (emitter.detachEvent) {
      emitter.detachEvent("on" + type, f);
    } else {
      var map = emitter._handlers, arr = map && map[type];
      if (arr) {
        var index = indexOf(arr, f);
        if (index > -1)
          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
      }
    }
  }

  function signal(emitter, type /*, values...*/) {
    var handlers = getHandlers(emitter, type);
    if (!handlers.length) { return }
    var args = Array.prototype.slice.call(arguments, 2);
    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
  }

  // The DOM events that CodeMirror handles can be overridden by
  // registering a (non-DOM) handler on the editor for the event name,
  // and preventDefault-ing the event in that handler.
  function signalDOMEvent(cm, e, override) {
    if (typeof e == "string")
      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
    signal(cm, override || e.type, cm, e);
    return e_defaultPrevented(e) || e.codemirrorIgnore
  }

  function signalCursorActivity(cm) {
    var arr = cm._handlers && cm._handlers.cursorActivity;
    if (!arr) { return }
    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
      { set.push(arr[i]); } }
  }

  function hasHandler(emitter, type) {
    return getHandlers(emitter, type).length > 0
  }

  // Add on and off methods to a constructor's prototype, to make
  // registering events on such objects more convenient.
  function eventMixin(ctor) {
    ctor.prototype.on = function(type, f) {on(this, type, f);};
    ctor.prototype.off = function(type, f) {off(this, type, f);};
  }

  // Due to the fact that we still support jurassic IE versions, some
  // compatibility wrappers are needed.

  function e_preventDefault(e) {
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
  }
  function e_stopPropagation(e) {
    if (e.stopPropagation) { e.stopPropagation(); }
    else { e.cancelBubble = true; }
  }
  function e_defaultPrevented(e) {
    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
  }
  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

  function e_target(e) {return e.target || e.srcElement}
  function e_button(e) {
    var b = e.which;
    if (b == null) {
      if (e.button & 1) { b = 1; }
      else if (e.button & 2) { b = 3; }
      else if (e.button & 4) { b = 2; }
    }
    if (mac && e.ctrlKey && b == 1) { b = 3; }
    return b
  }

  // Detect drag-and-drop
  var dragAndDrop = function() {
    // There is *some* kind of drag-and-drop support in IE6-8, but I
    // couldn't get it to work yet.
    if (ie && ie_version < 9) { return false }
    var div = elt('div');
    return "draggable" in div || "dragDrop" in div
  }();

  var zwspSupported;
  function zeroWidthElement(measure) {
    if (zwspSupported == null) {
      var test = elt("span", "\u200b");
      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
      if (measure.firstChild.offsetHeight != 0)
        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
    }
    var node = zwspSupported ? elt("span", "\u200b") :
      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
    node.setAttribute("cm-text", "");
    return node
  }

  // Feature-detect IE's crummy client rect reporting for bidi text
  var badBidiRects;
  function hasBadBidiRects(measure) {
    if (badBidiRects != null) { return badBidiRects }
    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
    var r0 = range(txt, 0, 1).getBoundingClientRect();
    var r1 = range(txt, 1, 2).getBoundingClientRect();
    removeChildren(measure);
    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
    return badBidiRects = (r1.right - r0.right < 3)
  }

  // See if "".split is the broken IE version, if so, provide an
  // alternative way to split lines.
  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
    var pos = 0, result = [], l = string.length;
    while (pos <= l) {
      var nl = string.indexOf("\n", pos);
      if (nl == -1) { nl = string.length; }
      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
      var rt = line.indexOf("\r");
      if (rt != -1) {
        result.push(line.slice(0, rt));
        pos += rt + 1;
      } else {
        result.push(line);
        pos = nl + 1;
      }
    }
    return result
  } : function (string) { return string.split(/\r\n?|\n/); };

  var hasSelection = window.getSelection ? function (te) {
    try { return te.selectionStart != te.selectionEnd }
    catch(e) { return false }
  } : function (te) {
    var range;
    try {range = te.ownerDocument.selection.createRange();}
    catch(e) {}
    if (!range || range.parentElement() != te) { return false }
    return range.compareEndPoints("StartToEnd", range) != 0
  };

  var hasCopyEvent = (function () {
    var e = elt("div");
    if ("oncopy" in e) { return true }
    e.setAttribute("oncopy", "return;");
    return typeof e.oncopy == "function"
  })();

  var badZoomedRects = null;
  function hasBadZoomedRects(measure) {
    if (badZoomedRects != null) { return badZoomedRects }
    var node = removeChildrenAndAdd(measure, elt("span", "x"));
    var normal = node.getBoundingClientRect();
    var fromRange = range(node, 0, 1).getBoundingClientRect();
    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
  }

  // Known modes, by name and by MIME
  var modes = {}, mimeModes = {};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  function defineMode(name, mode) {
    if (arguments.length > 2)
      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
    modes[name] = mode;
  }

  function defineMIME(mime, spec) {
    mimeModes[mime] = spec;
  }

  // Given a MIME type, a {name, ...options} config object, or a name
  // string, return a mode config object.
  function resolveMode(spec) {
    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
      spec = mimeModes[spec];
    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
      var found = mimeModes[spec.name];
      if (typeof found == "string") { found = {name: found}; }
      spec = createObj(found, spec);
      spec.name = found.name;
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
      return resolveMode("application/xml")
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
      return resolveMode("application/json")
    }
    if (typeof spec == "string") { return {name: spec} }
    else { return spec || {name: "null"} }
  }

  // Given a mode spec (anything that resolveMode accepts), find and
  // initialize an actual mode object.
  function getMode(options, spec) {
    spec = resolveMode(spec);
    var mfactory = modes[spec.name];
    if (!mfactory) { return getMode(options, "text/plain") }
    var modeObj = mfactory(options, spec);
    if (modeExtensions.hasOwnProperty(spec.name)) {
      var exts = modeExtensions[spec.name];
      for (var prop in exts) {
        if (!exts.hasOwnProperty(prop)) { continue }
        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
        modeObj[prop] = exts[prop];
      }
    }
    modeObj.name = spec.name;
    if (spec.helperType) { modeObj.helperType = spec.helperType; }
    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
      { modeObj[prop$1] = spec.modeProps[prop$1]; } }

    return modeObj
  }

  // This can be used to attach properties to mode objects from
  // outside the actual mode definition.
  var modeExtensions = {};
  function extendMode(mode, properties) {
    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
    copyObj(properties, exts);
  }

  function copyState(mode, state) {
    if (state === true) { return state }
    if (mode.copyState) { return mode.copyState(state) }
    var nstate = {};
    for (var n in state) {
      var val = state[n];
      if (val instanceof Array) { val = val.concat([]); }
      nstate[n] = val;
    }
    return nstate
  }

  // Given a mode and a state (for that mode), find the inner mode and
  // state at the position that the state refers to.
  function innerMode(mode, state) {
    var info;
    while (mode.innerMode) {
      info = mode.innerMode(state);
      if (!info || info.mode == mode) { break }
      state = info.state;
      mode = info.mode;
    }
    return info || {mode: mode, state: state}
  }

  function startState(mode, a1, a2) {
    return mode.startState ? mode.startState(a1, a2) : true
  }

  // STRING STREAM

  // Fed to the mode parsers, provides helper functions to make
  // parsers more succinct.

  var StringStream = function(string, tabSize, lineOracle) {
    this.pos = this.start = 0;
    this.string = string;
    this.tabSize = tabSize || 8;
    this.lastColumnPos = this.lastColumnValue = 0;
    this.lineStart = 0;
    this.lineOracle = lineOracle;
  };

  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
  StringStream.prototype.next = function () {
    if (this.pos < this.string.length)
      { return this.string.charAt(this.pos++) }
  };
  StringStream.prototype.eat = function (match) {
    var ch = this.string.charAt(this.pos);
    var ok;
    if (typeof match == "string") { ok = ch == match; }
    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
    if (ok) {++this.pos; return ch}
  };
  StringStream.prototype.eatWhile = function (match) {
    var start = this.pos;
    while (this.eat(match)){}
    return this.pos > start
  };
  StringStream.prototype.eatSpace = function () {
    var start = this.pos;
    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
    return this.pos > start
  };
  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
  StringStream.prototype.skipTo = function (ch) {
    var found = this.string.indexOf(ch, this.pos);
    if (found > -1) {this.pos = found; return true}
  };
  StringStream.prototype.backUp = function (n) {this.pos -= n;};
  StringStream.prototype.column = function () {
    if (this.lastColumnPos < this.start) {
      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
      this.lastColumnPos = this.start;
    }
    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.indentation = function () {
    return countColumn(this.string, null, this.tabSize) -
      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
    if (typeof pattern == "string") {
      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
      var substr = this.string.substr(this.pos, pattern.length);
      if (cased(substr) == cased(pattern)) {
        if (consume !== false) { this.pos += pattern.length; }
        return true
      }
    } else {
      var match = this.string.slice(this.pos).match(pattern);
      if (match && match.index > 0) { return null }
      if (match && consume !== false) { this.pos += match[0].length; }
      return match
    }
  };
  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
  StringStream.prototype.hideFirstChars = function (n, inner) {
    this.lineStart += n;
    try { return inner() }
    finally { this.lineStart -= n; }
  };
  StringStream.prototype.lookAhead = function (n) {
    var oracle = this.lineOracle;
    return oracle && oracle.lookAhead(n)
  };
  StringStream.prototype.baseToken = function () {
    var oracle = this.lineOracle;
    return oracle && oracle.baseToken(this.pos)
  };

  // Find the line object corresponding to the given line number.
  function getLine(doc, n) {
    n -= doc.first;
    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
    var chunk = doc;
    while (!chunk.lines) {
      for (var i = 0;; ++i) {
        var child = chunk.children[i], sz = child.chunkSize();
        if (n < sz) { chunk = child; break }
        n -= sz;
      }
    }
    return chunk.lines[n]
  }

  // Get the part of a document between two positions, as an array of
  // strings.
  function getBetween(doc, start, end) {
    var out = [], n = start.line;
    doc.iter(start.line, end.line + 1, function (line) {
      var text = line.text;
      if (n == end.line) { text = text.slice(0, end.ch); }
      if (n == start.line) { text = text.slice(start.ch); }
      out.push(text);
      ++n;
    });
    return out
  }
  // Get the lines between from and to, as array of strings.
  function getLines(doc, from, to) {
    var out = [];
    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
    return out
  }

  // Update the height of a line, propagating the height change
  // upwards to parent nodes.
  function updateLineHeight(line, height) {
    var diff = height - line.height;
    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
  }

  // Given a line object, find its line number by walking up through
  // its parent links.
  function lineNo(line) {
    if (line.parent == null) { return null }
    var cur = line.parent, no = indexOf(cur.lines, line);
    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
      for (var i = 0;; ++i) {
        if (chunk.children[i] == cur) { break }
        no += chunk.children[i].chunkSize();
      }
    }
    return no + cur.first
  }

  // Find the line at the given vertical position, using the height
  // information in the document tree.
  function lineAtHeight(chunk, h) {
    var n = chunk.first;
    outer: do {
      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
        var child = chunk.children[i$1], ch = child.height;
        if (h < ch) { chunk = child; continue outer }
        h -= ch;
        n += child.chunkSize();
      }
      return n
    } while (!chunk.lines)
    var i = 0;
    for (; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i], lh = line.height;
      if (h < lh) { break }
      h -= lh;
    }
    return n + i
  }

  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

  function lineNumberFor(options, i) {
    return String(options.lineNumberFormatter(i + options.firstLineNumber))
  }

  // A Pos instance represents a position within the text.
  function Pos(line, ch, sticky) {
    if ( sticky === void 0 ) sticky = null;

    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
    this.line = line;
    this.ch = ch;
    this.sticky = sticky;
  }

  // Compare two positions, return 0 if they are the same, a negative
  // number when a is less, and a positive number otherwise.
  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

  function copyPos(x) {return Pos(x.line, x.ch)}
  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

  // Most of the external API clips given positions to make sure they
  // actually exist within the document.
  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
  function clipPos(doc, pos) {
    if (pos.line < doc.first) { return Pos(doc.first, 0) }
    var last = doc.first + doc.size - 1;
    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
    return clipToLen(pos, getLine(doc, pos.line).text.length)
  }
  function clipToLen(pos, linelen) {
    var ch = pos.ch;
    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
    else if (ch < 0) { return Pos(pos.line, 0) }
    else { return pos }
  }
  function clipPosArray(doc, array) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
    return out
  }

  var SavedContext = function(state, lookAhead) {
    this.state = state;
    this.lookAhead = lookAhead;
  };

  var Context = function(doc, state, line, lookAhead) {
    this.state = state;
    this.doc = doc;
    this.line = line;
    this.maxLookAhead = lookAhead || 0;
    this.baseTokens = null;
    this.baseTokenPos = 1;
  };

  Context.prototype.lookAhead = function (n) {
    var line = this.doc.getLine(this.line + n);
    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
    return line
  };

  Context.prototype.baseToken = function (n) {
    if (!this.baseTokens) { return null }
    while (this.baseTokens[this.baseTokenPos] <= n)
      { this.baseTokenPos += 2; }
    var type = this.baseTokens[this.baseTokenPos + 1];
    return {type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n}
  };

  Context.prototype.nextLine = function () {
    this.line++;
    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
  };

  Context.fromSaved = function (doc, saved, line) {
    if (saved instanceof SavedContext)
      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
    else
      { return new Context(doc, copyState(doc.mode, saved), line) }
  };

  Context.prototype.save = function (copy) {
    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
  };


  // Compute a style array (an array starting with a mode generation
  // -- for invalidation -- followed by pairs of end positions and
  // style strings), which is used to highlight the tokens on the
  // line.
  function highlightLine(cm, line, context, forceToEnd) {
    // A styles array always starts with a number identifying the
    // mode/overlays that it is based on (for easy invalidation).
    var st = [cm.state.modeGen], lineClasses = {};
    // Compute the base array of styles
    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
            lineClasses, forceToEnd);
    var state = context.state;

    // Run overlays, adjust style array.
    var loop = function ( o ) {
      context.baseTokens = st;
      var overlay = cm.state.overlays[o], i = 1, at = 0;
      context.state = true;
      runMode(cm, line.text, overlay.mode, context, function (end, style) {
        var start = i;
        // Ensure there's a token end at the current position, and that i points at it
        while (at < end) {
          var i_end = st[i];
          if (i_end > end)
            { st.splice(i, 1, end, st[i+1], i_end); }
          i += 2;
          at = Math.min(end, i_end);
        }
        if (!style) { return }
        if (overlay.opaque) {
          st.splice(start, i - start, end, "overlay " + style);
          i = start + 2;
        } else {
          for (; start < i; start += 2) {
            var cur = st[start+1];
            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
          }
        }
      }, lineClasses);
      context.state = state;
      context.baseTokens = null;
      context.baseTokenPos = 1;
    };

    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
  }

  function getLineStyles(cm, line, updateFrontier) {
    if (!line.styles || line.styles[0] != cm.state.modeGen) {
      var context = getContextBefore(cm, lineNo(line));
      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
      var result = highlightLine(cm, line, context);
      if (resetState) { context.state = resetState; }
      line.stateAfter = context.save(!resetState);
      line.styles = result.styles;
      if (result.classes) { line.styleClasses = result.classes; }
      else if (line.styleClasses) { line.styleClasses = null; }
      if (updateFrontier === cm.doc.highlightFrontier)
        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
    }
    return line.styles
  }

  function getContextBefore(cm, n, precise) {
    var doc = cm.doc, display = cm.display;
    if (!doc.mode.startState) { return new Context(doc, true, n) }
    var start = findStartLine(cm, n, precise);
    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

    doc.iter(start, n, function (line) {
      processLine(cm, line.text, context);
      var pos = context.line;
      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
      context.nextLine();
    });
    if (precise) { doc.modeFrontier = context.line; }
    return context
  }

  // Lightweight form of highlight -- proceed over this line and
  // update state, but don't save a style array. Used for lines that
  // aren't currently visible.
  function processLine(cm, text, context, startAt) {
    var mode = cm.doc.mode;
    var stream = new StringStream(text, cm.options.tabSize, context);
    stream.start = stream.pos = startAt || 0;
    if (text == "") { callBlankLine(mode, context.state); }
    while (!stream.eol()) {
      readToken(mode, stream, context.state);
      stream.start = stream.pos;
    }
  }

  function callBlankLine(mode, state) {
    if (mode.blankLine) { return mode.blankLine(state) }
    if (!mode.innerMode) { return }
    var inner = innerMode(mode, state);
    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
  }

  function readToken(mode, stream, state, inner) {
    for (var i = 0; i < 10; i++) {
      if (inner) { inner[0] = innerMode(mode, state).mode; }
      var style = mode.token(stream, state);
      if (stream.pos > stream.start) { return style }
    }
    throw new Error("Mode " + mode.name + " failed to advance stream.")
  }

  var Token = function(stream, type, state) {
    this.start = stream.start; this.end = stream.pos;
    this.string = stream.current();
    this.type = type || null;
    this.state = state;
  };

  // Utility for getTokenAt and getLineTokens
  function takeToken(cm, pos, precise, asArray) {
    var doc = cm.doc, mode = doc.mode, style;
    pos = clipPos(doc, pos);
    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
    if (asArray) { tokens = []; }
    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
      stream.start = stream.pos;
      style = readToken(mode, stream, context.state);
      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
    }
    return asArray ? tokens : new Token(stream, style, context.state)
  }

  function extractLineClasses(type, output) {
    if (type) { for (;;) {
      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
      if (!lineClass) { break }
      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
      var prop = lineClass[1] ? "bgClass" : "textClass";
      if (output[prop] == null)
        { output[prop] = lineClass[2]; }
      else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
        { output[prop] += " " + lineClass[2]; }
    } }
    return type
  }

  // Run the given mode's parser over a line, calling f for each token.
  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
    var flattenSpans = mode.flattenSpans;
    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
    var curStart = 0, curStyle = null;
    var stream = new StringStream(text, cm.options.tabSize, context), style;
    var inner = cm.options.addModeClass && [null];
    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
    while (!stream.eol()) {
      if (stream.pos > cm.options.maxHighlightLength) {
        flattenSpans = false;
        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
        stream.pos = text.length;
        style = null;
      } else {
        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
      }
      if (inner) {
        var mName = inner[0].name;
        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
      }
      if (!flattenSpans || curStyle != style) {
        while (curStart < stream.start) {
          curStart = Math.min(stream.start, curStart + 5000);
          f(curStart, curStyle);
        }
        curStyle = style;
      }
      stream.start = stream.pos;
    }
    while (curStart < stream.pos) {
      // Webkit seems to refuse to render text nodes longer than 57444
      // characters, and returns inaccurate measurements in nodes
      // starting around 5000 chars.
      var pos = Math.min(stream.pos, curStart + 5000);
      f(pos, curStyle);
      curStart = pos;
    }
  }

  // Finds the line to start with when starting a parse. Tries to
  // find a line with a stateAfter, so that it can start with a
  // valid state. If that fails, it returns the line with the
  // smallest indentation, which tends to need the least context to
  // parse correctly.
  function findStartLine(cm, n, precise) {
    var minindent, minline, doc = cm.doc;
    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
    for (var search = n; search > lim; --search) {
      if (search <= doc.first) { return doc.first }
      var line = getLine(doc, search - 1), after = line.stateAfter;
      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
        { return search }
      var indented = countColumn(line.text, null, cm.options.tabSize);
      if (minline == null || minindent > indented) {
        minline = search - 1;
        minindent = indented;
      }
    }
    return minline
  }

  function retreatFrontier(doc, n) {
    doc.modeFrontier = Math.min(doc.modeFrontier, n);
    if (doc.highlightFrontier < n - 10) { return }
    var start = doc.first;
    for (var line = n - 1; line > start; line--) {
      var saved = getLine(doc, line).stateAfter;
      // change is on 3
      // state on line 1 looked ahead 2 -- so saw 3
      // test 1 + 2 < 3 should cover this
      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
        start = line + 1;
        break
      }
    }
    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
  }

  // Optimize some code when these features are not used.
  var sawReadOnlySpans = false, sawCollapsedSpans = false;

  function seeReadOnlySpans() {
    sawReadOnlySpans = true;
  }

  function seeCollapsedSpans() {
    sawCollapsedSpans = true;
  }

  // TEXTMARKER SPANS

  function MarkedSpan(marker, from, to) {
    this.marker = marker;
    this.from = from; this.to = to;
  }

  // Search an array of spans for a span matching the given marker.
  function getMarkedSpanFor(spans, marker) {
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.marker == marker) { return span }
    } }
  }
  // Remove a span from an array, returning undefined if no spans are
  // left (we don't store arrays for lines without spans).
  function removeMarkedSpan(spans, span) {
    var r;
    for (var i = 0; i < spans.length; ++i)
      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
    return r
  }
  // Add a span to a line.
  function addMarkedSpan(line, span) {
    line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
    span.marker.attachLine(line);
  }

  // Used for the algorithm that adjusts markers for a change in the
  // document. These functions cut an array of spans at a given
  // character position, returning an array of remaining chunks (or
  // undefined if nothing remains).
  function markedSpansBefore(old, startCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
      }
    } }
    return nw
  }
  function markedSpansAfter(old, endCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                              span.to == null ? null : span.to - endCh));
      }
    } }
    return nw
  }

  // Given a change object, compute the new set of marker spans that
  // cover the line in which the change took place. Removes spans
  // entirely within the change, reconnects spans belonging to the
  // same marker that appear on both sides of the change, and cuts off
  // spans partially within the change. Returns an array of span
  // arrays with one element for each line in (after) the change.
  function stretchSpansOverChange(doc, change) {
    if (change.full) { return null }
    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
    if (!oldFirst && !oldLast) { return null }

    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
    // Get the spans that 'stick out' on both sides
    var first = markedSpansBefore(oldFirst, startCh, isInsert);
    var last = markedSpansAfter(oldLast, endCh, isInsert);

    // Next, merge those two ends
    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
    if (first) {
      // Fix up .to properties of first
      for (var i = 0; i < first.length; ++i) {
        var span = first[i];
        if (span.to == null) {
          var found = getMarkedSpanFor(last, span.marker);
          if (!found) { span.to = startCh; }
          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
        }
      }
    }
    if (last) {
      // Fix up .from in last (or move them into first in case of sameLine)
      for (var i$1 = 0; i$1 < last.length; ++i$1) {
        var span$1 = last[i$1];
        if (span$1.to != null) { span$1.to += offset; }
        if (span$1.from == null) {
          var found$1 = getMarkedSpanFor(first, span$1.marker);
          if (!found$1) {
            span$1.from = offset;
            if (sameLine) { (first || (first = [])).push(span$1); }
          }
        } else {
          span$1.from += offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      }
    }
    // Make sure we didn't create any zero-length spans
    if (first) { first = clearEmptySpans(first); }
    if (last && last != first) { last = clearEmptySpans(last); }

    var newMarkers = [first];
    if (!sameLine) {
      // Fill gap with whole-line-spans
      var gap = change.text.length - 2, gapMarkers;
      if (gap > 0 && first)
        { for (var i$2 = 0; i$2 < first.length; ++i$2)
          { if (first[i$2].to == null)
            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
      for (var i$3 = 0; i$3 < gap; ++i$3)
        { newMarkers.push(gapMarkers); }
      newMarkers.push(last);
    }
    return newMarkers
  }

  // Remove spans that are empty and don't have a clearWhenEmpty
  // option of false.
  function clearEmptySpans(spans) {
    for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
        { spans.splice(i--, 1); }
    }
    if (!spans.length) { return null }
    return spans
  }

  // Used to 'clip' out readOnly ranges when making a change.
  function removeReadOnlyRanges(doc, from, to) {
    var markers = null;
    doc.iter(from.line, to.line + 1, function (line) {
      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
        var mark = line.markedSpans[i].marker;
        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
          { (markers || (markers = [])).push(mark); }
      } }
    });
    if (!markers) { return null }
    var parts = [{from: from, to: to}];
    for (var i = 0; i < markers.length; ++i) {
      var mk = markers[i], m = mk.find(0);
      for (var j = 0; j < parts.length; ++j) {
        var p = parts[j];
        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
          { newParts.push({from: p.from, to: m.from}); }
        if (dto > 0 || !mk.inclusiveRight && !dto)
          { newParts.push({from: m.to, to: p.to}); }
        parts.splice.apply(parts, newParts);
        j += newParts.length - 3;
      }
    }
    return parts
  }

  // Connect or disconnect spans from a line.
  function detachMarkedSpans(line) {
    var spans = line.markedSpans;
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.detachLine(line); }
    line.markedSpans = null;
  }
  function attachMarkedSpans(line, spans) {
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.attachLine(line); }
    line.markedSpans = spans;
  }

  // Helpers used when computing which overlapping collapsed span
  // counts as the larger one.
  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

  // Returns a number indicating which of two overlapping collapsed
  // spans is larger (and thus includes the other). Falls back to
  // comparing ids when the spans cover exactly the same range.
  function compareCollapsedMarkers(a, b) {
    var lenDiff = a.lines.length - b.lines.length;
    if (lenDiff != 0) { return lenDiff }
    var aPos = a.find(), bPos = b.find();
    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
    if (fromCmp) { return -fromCmp }
    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
    if (toCmp) { return toCmp }
    return b.id - a.id
  }

  // Find out whether a line ends or starts in a collapsed span. If
  // so, return the marker for that span.
  function collapsedSpanAtSide(line, start) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
        { found = sp.marker; }
    } }
    return found
  }
  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

  function collapsedSpanAround(line, ch) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
    } }
    return found
  }

  // Test whether there exists a collapsed span that partially
  // overlaps (covers the start or end, but not both) of a new span.
  // Such overlap is not allowed.
  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
    var line = getLine(doc, lineNo);
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      var found = sp.marker.find(0);
      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
        { return true }
    } }
  }

  // A visual line is a line as drawn on the screen. Folding, for
  // example, can cause multiple logical lines to appear on the same
  // visual line. This finds the start of the visual line that the
  // given line is part of (usually that is the line itself).
  function visualLine(line) {
    var merged;
    while (merged = collapsedSpanAtStart(line))
      { line = merged.find(-1, true).line; }
    return line
  }

  function visualLineEnd(line) {
    var merged;
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return line
  }

  // Returns an array of logical lines that continue the visual line
  // started by the argument, or undefined if there are no such lines.
  function visualLineContinued(line) {
    var merged, lines;
    while (merged = collapsedSpanAtEnd(line)) {
      line = merged.find(1, true).line
      ;(lines || (lines = [])).push(line);
    }
    return lines
  }

  // Get the line number of the start of the visual line that the
  // given line number is part of.
  function visualLineNo(doc, lineN) {
    var line = getLine(doc, lineN), vis = visualLine(line);
    if (line == vis) { return lineN }
    return lineNo(vis)
  }

  // Get the line number of the start of the next visual line after
  // the given line.
  function visualLineEndNo(doc, lineN) {
    if (lineN > doc.lastLine()) { return lineN }
    var line = getLine(doc, lineN), merged;
    if (!lineIsHidden(doc, line)) { return lineN }
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return lineNo(line) + 1
  }

  // Compute whether a line is hidden. Lines count as hidden when they
  // are part of a visual line that starts with another line, or when
  // they are entirely covered by collapsed, non-widget span.
  function lineIsHidden(doc, line) {
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      if (sp.from == null) { return true }
      if (sp.marker.widgetNode) { continue }
      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
        { return true }
    } }
  }
  function lineIsHiddenInner(doc, line, span) {
    if (span.to == null) {
      var end = span.marker.find(1, true);
      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
    }
    if (span.marker.inclusiveRight && span.to == line.text.length)
      { return true }
    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
      sp = line.markedSpans[i];
      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
          (sp.to == null || sp.to != span.from) &&
          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
          lineIsHiddenInner(doc, line, sp)) { return true }
    }
  }

  // Find the height above the given line.
  function heightAtLine(lineObj) {
    lineObj = visualLine(lineObj);

    var h = 0, chunk = lineObj.parent;
    for (var i = 0; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i];
      if (line == lineObj) { break }
      else { h += line.height; }
    }
    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
        var cur = p.children[i$1];
        if (cur == chunk) { break }
        else { h += cur.height; }
      }
    }
    return h
  }

  // Compute the character length of a line, taking into account
  // collapsed ranges (see markText) that might hide parts, and join
  // other lines onto it.
  function lineLength(line) {
    if (line.height == 0) { return 0 }
    var len = line.text.length, merged, cur = line;
    while (merged = collapsedSpanAtStart(cur)) {
      var found = merged.find(0, true);
      cur = found.from.line;
      len += found.from.ch - found.to.ch;
    }
    cur = line;
    while (merged = collapsedSpanAtEnd(cur)) {
      var found$1 = merged.find(0, true);
      len -= cur.text.length - found$1.from.ch;
      cur = found$1.to.line;
      len += cur.text.length - found$1.to.ch;
    }
    return len
  }

  // Find the longest line in the document.
  function findMaxLine(cm) {
    var d = cm.display, doc = cm.doc;
    d.maxLine = getLine(doc, doc.first);
    d.maxLineLength = lineLength(d.maxLine);
    d.maxLineChanged = true;
    doc.iter(function (line) {
      var len = lineLength(line);
      if (len > d.maxLineLength) {
        d.maxLineLength = len;
        d.maxLine = line;
      }
    });
  }

  // LINE DATA STRUCTURE

  // Line objects. These hold state related to a line, including
  // highlighting info (the styles array).
  var Line = function(text, markedSpans, estimateHeight) {
    this.text = text;
    attachMarkedSpans(this, markedSpans);
    this.height = estimateHeight ? estimateHeight(this) : 1;
  };

  Line.prototype.lineNo = function () { return lineNo(this) };
  eventMixin(Line);

  // Change the content (text, markers) of a line. Automatically
  // invalidates cached information and tries to re-estimate the
  // line's height.
  function updateLine(line, text, markedSpans, estimateHeight) {
    line.text = text;
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
    if (line.order != null) { line.order = null; }
    detachMarkedSpans(line);
    attachMarkedSpans(line, markedSpans);
    var estHeight = estimateHeight ? estimateHeight(line) : 1;
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  }

  // Detach a line from the document tree and its markers.
  function cleanUpLine(line) {
    line.parent = null;
    detachMarkedSpans(line);
  }

  // Convert a style as returned by a mode (either null, or a string
  // containing one or more styles) to a CSS style. This is cached,
  // and also looks for line-wide styles.
  var styleToClassCache = {}, styleToClassCacheWithMode = {};
  function interpretTokenStyle(style, options) {
    if (!style || /^\s*$/.test(style)) { return null }
    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
    return cache[style] ||
      (cache[style] = style.replace(/\S+/g, "cm-$&"))
  }

  // Render the DOM representation of the text of a line. Also builds
  // up a 'line map', which points at the DOM nodes that represent
  // specific stretches of text, and is used by the measuring code.
  // The returned object contains the DOM node, this map, and
  // information about line-wide styles that were set by the mode.
  function buildLineContent(cm, lineView) {
    // The padding-right forces the element to have a 'border', which
    // is needed on Webkit to be able to get line-level bounding
    // rectangles for it (in measureChar).
    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                   col: 0, pos: 0, cm: cm,
                   trailingSpace: false,
                   splitSpaces: cm.getOption("lineWrapping")};
    lineView.measure = {};

    // Iterate over the logical lines that make up this visual line.
    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
      builder.pos = 0;
      builder.addToken = buildToken;
      // Optionally wire in some hacks into the token-rendering
      // algorithm, to deal with browser quirks.
      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
      builder.map = [];
      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
      if (line.styleClasses) {
        if (line.styleClasses.bgClass)
          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
        if (line.styleClasses.textClass)
          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
      }

      // Ensure at least a single node is present, for measuring.
      if (builder.map.length == 0)
        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

      // Store the map and a cache object for the current logical line
      if (i == 0) {
        lineView.measure.map = builder.map;
        lineView.measure.cache = {};
      } else {
  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
      }
    }

    // See issue #2901
    if (webkit) {
      var last = builder.content.lastChild;
      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
        { builder.content.className = "cm-tab-wrap-hack"; }
    }

    signal(cm, "renderLine", cm, lineView.line, builder.pre);
    if (builder.pre.className)
      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

    return builder
  }

  function defaultSpecialCharPlaceholder(ch) {
    var token = elt("span", "\u2022", "cm-invalidchar");
    token.title = "\\u" + ch.charCodeAt(0).toString(16);
    token.setAttribute("aria-label", token.title);
    return token
  }

  // Build up the DOM representation for a single token, and add it to
  // the line map. Takes care to render special characters separately.
  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
    if (!text) { return }
    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
    var special = builder.cm.state.specialChars, mustWrap = false;
    var content;
    if (!special.test(text)) {
      builder.col += text.length;
      content = document.createTextNode(displayText);
      builder.map.push(builder.pos, builder.pos + text.length, content);
      if (ie && ie_version < 9) { mustWrap = true; }
      builder.pos += text.length;
    } else {
      content = document.createDocumentFragment();
      var pos = 0;
      while (true) {
        special.lastIndex = pos;
        var m = special.exec(text);
        var skipped = m ? m.index - pos : text.length - pos;
        if (skipped) {
          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
          else { content.appendChild(txt); }
          builder.map.push(builder.pos, builder.pos + skipped, txt);
          builder.col += skipped;
          builder.pos += skipped;
        }
        if (!m) { break }
        pos += skipped + 1;
        var txt$1 = (void 0);
        if (m[0] == "\t") {
          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
          txt$1.setAttribute("role", "presentation");
          txt$1.setAttribute("cm-text", "\t");
          builder.col += tabWidth;
        } else if (m[0] == "\r" || m[0] == "\n") {
          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
          txt$1.setAttribute("cm-text", m[0]);
          builder.col += 1;
        } else {
          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
          txt$1.setAttribute("cm-text", m[0]);
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
          else { content.appendChild(txt$1); }
          builder.col += 1;
        }
        builder.map.push(builder.pos, builder.pos + 1, txt$1);
        builder.pos++;
      }
    }
    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
    if (style || startStyle || endStyle || mustWrap || css) {
      var fullStyle = style || "";
      if (startStyle) { fullStyle += startStyle; }
      if (endStyle) { fullStyle += endStyle; }
      var token = elt("span", [content], fullStyle, css);
      if (attributes) {
        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
          { token.setAttribute(attr, attributes[attr]); } }
      }
      return builder.content.appendChild(token)
    }
    builder.content.appendChild(content);
  }

  // Change some spaces to NBSP to prevent the browser from collapsing
  // trailing spaces at the end of a line when rendering text (issue #1362).
  function splitSpaces(text, trailingBefore) {
    if (text.length > 1 && !/  /.test(text)) { return text }
    var spaceBefore = trailingBefore, result = "";
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
        { ch = "\u00a0"; }
      result += ch;
      spaceBefore = ch == " ";
    }
    return result
  }

  // Work around nonsense dimensions being reported for stretches of
  // right-to-left text.
  function buildTokenBadBidi(inner, order) {
    return function (builder, text, style, startStyle, endStyle, css, attributes) {
      style = style ? style + " cm-force-border" : "cm-force-border";
      var start = builder.pos, end = start + text.length;
      for (;;) {
        // Find the part that overlaps with the start of this text
        var part = (void 0);
        for (var i = 0; i < order.length; i++) {
          part = order[i];
          if (part.to > start && part.from <= start) { break }
        }
        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
        startStyle = null;
        text = text.slice(part.to - start);
        start = part.to;
      }
    }
  }

  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
    var widget = !ignoreWidget && marker.widgetNode;
    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
      if (!widget)
        { widget = builder.content.appendChild(document.createElement("span")); }
      widget.setAttribute("cm-marker", marker.id);
    }
    if (widget) {
      builder.cm.display.input.setUneditable(widget);
      builder.content.appendChild(widget);
    }
    builder.pos += size;
    builder.trailingSpace = false;
  }

  // Outputs a number of spans to make up a line, taking highlighting
  // and marked text into account.
  function insertLineContent(line, builder, styles) {
    var spans = line.markedSpans, allText = line.text, at = 0;
    if (!spans) {
      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
      return
    }

    var len = allText.length, pos = 0, i = 1, text = "", style, css;
    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
    for (;;) {
      if (nextChange == pos) { // Update current marker set
        spanStyle = spanEndStyle = spanStartStyle = css = "";
        attributes = null;
        collapsed = null; nextChange = Infinity;
        var foundBookmarks = [], endStyles = (void 0);
        for (var j = 0; j < spans.length; ++j) {
          var sp = spans[j], m = sp.marker;
          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
            foundBookmarks.push(m);
          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
              nextChange = sp.to;
              spanEndStyle = "";
            }
            if (m.className) { spanStyle += " " + m.className; }
            if (m.css) { css = (css ? css + ";" : "") + m.css; }
            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
            // support for the old title property
            // https://github.com/codemirror/CodeMirror/pull/5673
            if (m.title) { (attributes || (attributes = {})).title = m.title; }
            if (m.attributes) {
              for (var attr in m.attributes)
                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
            }
            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
              { collapsed = sp; }
          } else if (sp.from > pos && nextChange > sp.from) {
            nextChange = sp.from;
          }
        }
        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
        if (collapsed && (collapsed.from || 0) == pos) {
          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                             collapsed.marker, collapsed.from == null);
          if (collapsed.to == null) { return }
          if (collapsed.to == pos) { collapsed = false; }
        }
      }
      if (pos >= len) { break }

      var upto = Math.min(len, nextChange);
      while (true) {
        if (text) {
          var end = pos + text.length;
          if (!collapsed) {
            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
          }
          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
          pos = end;
          spanStartStyle = "";
        }
        text = allText.slice(at, at = styles[i++]);
        style = interpretTokenStyle(styles[i++], builder.cm.options);
      }
    }
  }


  // These objects are used to represent the visible (currently drawn)
  // part of the document. A LineView may correspond to multiple
  // logical lines, if those are connected by collapsed ranges.
  function LineView(doc, line, lineN) {
    // The starting line
    this.line = line;
    // Continuing lines, if any
    this.rest = visualLineContinued(line);
    // Number of logical lines in this visual line
    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
    this.node = this.text = null;
    this.hidden = lineIsHidden(doc, line);
  }

  // Create a range of LineView objects for the given lines.
  function buildViewArray(cm, from, to) {
    var array = [], nextPos;
    for (var pos = from; pos < to; pos = nextPos) {
      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
      nextPos = pos + view.size;
      array.push(view);
    }
    return array
  }

  var operationGroup = null;

  function pushOperation(op) {
    if (operationGroup) {
      operationGroup.ops.push(op);
    } else {
      op.ownsGroup = operationGroup = {
        ops: [op],
        delayedCallbacks: []
      };
    }
  }

  function fireCallbacksForOps(group) {
    // Calls delayed callbacks and cursorActivity handlers until no
    // new ones appear
    var callbacks = group.delayedCallbacks, i = 0;
    do {
      for (; i < callbacks.length; i++)
        { callbacks[i].call(null); }
      for (var j = 0; j < group.ops.length; j++) {
        var op = group.ops[j];
        if (op.cursorActivityHandlers)
          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
      }
    } while (i < callbacks.length)
  }

  function finishOperation(op, endCb) {
    var group = op.ownsGroup;
    if (!group) { return }

    try { fireCallbacksForOps(group); }
    finally {
      operationGroup = null;
      endCb(group);
    }
  }

  var orphanDelayedCallbacks = null;

  // Often, we want to signal events at a point where we are in the
  // middle of some work, but don't want the handler to start calling
  // other methods on the editor, which might be in an inconsistent
  // state or simply not expect any other events to happen.
  // signalLater looks whether there are any handlers, and schedules
  // them to be executed when the last operation ends, or, if no
  // operation is active, when a timeout fires.
  function signalLater(emitter, type /*, values...*/) {
    var arr = getHandlers(emitter, type);
    if (!arr.length) { return }
    var args = Array.prototype.slice.call(arguments, 2), list;
    if (operationGroup) {
      list = operationGroup.delayedCallbacks;
    } else if (orphanDelayedCallbacks) {
      list = orphanDelayedCallbacks;
    } else {
      list = orphanDelayedCallbacks = [];
      setTimeout(fireOrphanDelayed, 0);
    }
    var loop = function ( i ) {
      list.push(function () { return arr[i].apply(null, args); });
    };

    for (var i = 0; i < arr.length; ++i)
      loop( i );
  }

  function fireOrphanDelayed() {
    var delayed = orphanDelayedCallbacks;
    orphanDelayedCallbacks = null;
    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
  }

  // When an aspect of a line changes, a string is added to
  // lineView.changes. This updates the relevant part of the line's
  // DOM structure.
  function updateLineForChanges(cm, lineView, lineN, dims) {
    for (var j = 0; j < lineView.changes.length; j++) {
      var type = lineView.changes[j];
      if (type == "text") { updateLineText(cm, lineView); }
      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
      else if (type == "class") { updateLineClasses(cm, lineView); }
      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
    }
    lineView.changes = null;
  }

  // Lines with gutter elements, widgets or a background class need to
  // be wrapped, and have the extra elements added to the wrapper div
  function ensureLineWrapped(lineView) {
    if (lineView.node == lineView.text) {
      lineView.node = elt("div", null, null, "position: relative");
      if (lineView.text.parentNode)
        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
      lineView.node.appendChild(lineView.text);
      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
    }
    return lineView.node
  }

  function updateLineBackground(cm, lineView) {
    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
    if (cls) { cls += " CodeMirror-linebackground"; }
    if (lineView.background) {
      if (cls) { lineView.background.className = cls; }
      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
    } else if (cls) {
      var wrap = ensureLineWrapped(lineView);
      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
      cm.display.input.setUneditable(lineView.background);
    }
  }

  // Wrapper around buildLineContent which will reuse the structure
  // in display.externalMeasured when possible.
  function getLineContent(cm, lineView) {
    var ext = cm.display.externalMeasured;
    if (ext && ext.line == lineView.line) {
      cm.display.externalMeasured = null;
      lineView.measure = ext.measure;
      return ext.built
    }
    return buildLineContent(cm, lineView)
  }

  // Redraw the line's text. Interacts with the background and text
  // classes because the mode may output tokens that influence these
  // classes.
  function updateLineText(cm, lineView) {
    var cls = lineView.text.className;
    var built = getLineContent(cm, lineView);
    if (lineView.text == lineView.node) { lineView.node = built.pre; }
    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
    lineView.text = built.pre;
    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
      lineView.bgClass = built.bgClass;
      lineView.textClass = built.textClass;
      updateLineClasses(cm, lineView);
    } else if (cls) {
      lineView.text.className = cls;
    }
  }

  function updateLineClasses(cm, lineView) {
    updateLineBackground(cm, lineView);
    if (lineView.line.wrapClass)
      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
    else if (lineView.node != lineView.text)
      { lineView.node.className = ""; }
    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
    lineView.text.className = textClass || "";
  }

  function updateLineGutter(cm, lineView, lineN, dims) {
    if (lineView.gutter) {
      lineView.node.removeChild(lineView.gutter);
      lineView.gutter = null;
    }
    if (lineView.gutterBackground) {
      lineView.node.removeChild(lineView.gutterBackground);
      lineView.gutterBackground = null;
    }
    if (lineView.line.gutterClass) {
      var wrap = ensureLineWrapped(lineView);
      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(lineView.gutterBackground);
      wrap.insertBefore(lineView.gutterBackground, lineView.text);
    }
    var markers = lineView.line.gutterMarkers;
    if (cm.options.lineNumbers || markers) {
      var wrap$1 = ensureLineWrapped(lineView);
      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(gutterWrap);
      wrap$1.insertBefore(gutterWrap, lineView.text);
      if (lineView.line.gutterClass)
        { gutterWrap.className += " " + lineView.line.gutterClass; }
      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
        { lineView.lineNumber = gutterWrap.appendChild(
          elt("div", lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
        if (found)
          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
      } }
    }
  }

  function updateLineWidgets(cm, lineView, dims) {
    if (lineView.alignable) { lineView.alignable = null; }
    var isWidget = classTest("CodeMirror-linewidget");
    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
      next = node.nextSibling;
      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
    }
    insertLineWidgets(cm, lineView, dims);
  }

  // Build a line's DOM representation from scratch
  function buildLineElement(cm, lineView, lineN, dims) {
    var built = getLineContent(cm, lineView);
    lineView.text = lineView.node = built.pre;
    if (built.bgClass) { lineView.bgClass = built.bgClass; }
    if (built.textClass) { lineView.textClass = built.textClass; }

    updateLineClasses(cm, lineView);
    updateLineGutter(cm, lineView, lineN, dims);
    insertLineWidgets(cm, lineView, dims);
    return lineView.node
  }

  // A lineView may contain multiple logical lines (when merged by
  // collapsed spans). The widgets for all of them need to be drawn.
  function insertLineWidgets(cm, lineView, dims) {
    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
  }

  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
    if (!line.widgets) { return }
    var wrap = ensureLineWrapped(lineView);
    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
      positionLineWidget(widget, node, lineView, dims);
      cm.display.input.setUneditable(node);
      if (allowAbove && widget.above)
        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
      else
        { wrap.appendChild(node); }
      signalLater(widget, "redraw");
    }
  }

  function positionLineWidget(widget, node, lineView, dims) {
    if (widget.noHScroll) {
  (lineView.alignable || (lineView.alignable = [])).push(node);
      var width = dims.wrapperWidth;
      node.style.left = dims.fixedPos + "px";
      if (!widget.coverGutter) {
        width -= dims.gutterTotalWidth;
        node.style.paddingLeft = dims.gutterTotalWidth + "px";
      }
      node.style.width = width + "px";
    }
    if (widget.coverGutter) {
      node.style.zIndex = 5;
      node.style.position = "relative";
      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
    }
  }

  function widgetHeight(widget) {
    if (widget.height != null) { return widget.height }
    var cm = widget.doc.cm;
    if (!cm) { return 0 }
    if (!contains(document.body, widget.node)) {
      var parentStyle = "position: relative;";
      if (widget.coverGutter)
        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
      if (widget.noHScroll)
        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
    }
    return widget.height = widget.node.parentNode.offsetHeight
  }

  // Return true when the given mouse event happened in a widget
  function eventInWidget(display, e) {
    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
          (n.parentNode == display.sizer && n != display.mover))
        { return true }
    }
  }

  // POSITION MEASUREMENT

  function paddingTop(display) {return display.lineSpace.offsetTop}
  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
  function paddingH(display) {
    if (display.cachedPaddingH) { return display.cachedPaddingH }
    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
    return data
  }

  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
  function displayWidth(cm) {
    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
  }
  function displayHeight(cm) {
    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
  }

  // Ensure the lineView.wrapping.heights array is populated. This is
  // an array of bottom offsets for the lines that make up a drawn
  // line. When lineWrapping is on, there might be more than one
  // height.
  function ensureLineHeights(cm, lineView, rect) {
    var wrapping = cm.options.lineWrapping;
    var curWidth = wrapping && displayWidth(cm);
    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
      var heights = lineView.measure.heights = [];
      if (wrapping) {
        lineView.measure.width = curWidth;
        var rects = lineView.text.firstChild.getClientRects();
        for (var i = 0; i < rects.length - 1; i++) {
          var cur = rects[i], next = rects[i + 1];
          if (Math.abs(cur.bottom - next.bottom) > 2)
            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
        }
      }
      heights.push(rect.bottom - rect.top);
    }
  }

  // Find a line map (mapping character offsets to text nodes) and a
  // measurement cache for the given line number. (A line view might
  // contain multiple lines when collapsed ranges are present.)
  function mapFromLineView(lineView, line, lineN) {
    if (lineView.line == line)
      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
    for (var i = 0; i < lineView.rest.length; i++)
      { if (lineView.rest[i] == line)
        { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
    for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
      { if (lineNo(lineView.rest[i$1]) > lineN)
        { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
  }

  // Render a line into the hidden node display.externalMeasured. Used
  // when measurement is needed for a line that's not in the viewport.
  function updateExternalMeasurement(cm, line) {
    line = visualLine(line);
    var lineN = lineNo(line);
    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
    view.lineN = lineN;
    var built = view.built = buildLineContent(cm, view);
    view.text = built.pre;
    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
    return view
  }

  // Get a {top, bottom, left, right} box (in line-local coordinates)
  // for a given character.
  function measureChar(cm, line, ch, bias) {
    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
  }

  // Find a line view that corresponds to the given line number.
  function findViewForLine(cm, lineN) {
    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
      { return cm.display.view[findViewIndex(cm, lineN)] }
    var ext = cm.display.externalMeasured;
    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
      { return ext }
  }

  // Measurement can be split in two steps, the set-up work that
  // applies to the whole line, and the measurement of the actual
  // character. Functions like coordsChar, that need to do a lot of
  // measurements in a row, can thus ensure that the set-up work is
  // only done once.
  function prepareMeasureForLine(cm, line) {
    var lineN = lineNo(line);
    var view = findViewForLine(cm, lineN);
    if (view && !view.text) {
      view = null;
    } else if (view && view.changes) {
      updateLineForChanges(cm, view, lineN, getDimensions(cm));
      cm.curOp.forceUpdate = true;
    }
    if (!view)
      { view = updateExternalMeasurement(cm, line); }

    var info = mapFromLineView(view, line, lineN);
    return {
      line: line, view: view, rect: null,
      map: info.map, cache: info.cache, before: info.before,
      hasHeights: false
    }
  }

  // Given a prepared measurement object, measures the position of an
  // actual character (or fetches it from the cache).
  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
    if (prepared.before) { ch = -1; }
    var key = ch + (bias || ""), found;
    if (prepared.cache.hasOwnProperty(key)) {
      found = prepared.cache[key];
    } else {
      if (!prepared.rect)
        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
      if (!prepared.hasHeights) {
        ensureLineHeights(cm, prepared.view, prepared.rect);
        prepared.hasHeights = true;
      }
      found = measureCharInner(cm, prepared, ch, bias);
      if (!found.bogus) { prepared.cache[key] = found; }
    }
    return {left: found.left, right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom}
  }

  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

  function nodeAndOffsetInLineMap(map, ch, bias) {
    var node, start, end, collapse, mStart, mEnd;
    // First, search the line map for the text node corresponding to,
    // or closest to, the target character.
    for (var i = 0; i < map.length; i += 3) {
      mStart = map[i];
      mEnd = map[i + 1];
      if (ch < mStart) {
        start = 0; end = 1;
        collapse = "left";
      } else if (ch < mEnd) {
        start = ch - mStart;
        end = start + 1;
      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
        end = mEnd - mStart;
        start = end - 1;
        if (ch >= mEnd) { collapse = "right"; }
      }
      if (start != null) {
        node = map[i + 2];
        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
          { collapse = bias; }
        if (bias == "left" && start == 0)
          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
            node = map[(i -= 3) + 2];
            collapse = "left";
          } }
        if (bias == "right" && start == mEnd - mStart)
          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
            node = map[(i += 3) + 2];
            collapse = "right";
          } }
        break
      }
    }
    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
  }

  function getUsefulRect(rects, bias) {
    var rect = nullRect;
    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
      if ((rect = rects[i]).left != rect.right) { break }
    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
      if ((rect = rects[i$1]).left != rect.right) { break }
    } }
    return rect
  }

  function measureCharInner(cm, prepared, ch, bias) {
    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

    var rect;
    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
          { rect = node.parentNode.getBoundingClientRect(); }
        else
          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
        if (rect.left || rect.right || start == 0) { break }
        end = start;
        start = start - 1;
        collapse = "right";
      }
      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
    } else { // If it is a widget, simply get the box for the whole widget.
      if (start > 0) { collapse = bias = "right"; }
      var rects;
      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
      else
        { rect = node.getBoundingClientRect(); }
    }
    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
      var rSpan = node.parentNode.getClientRects()[0];
      if (rSpan)
        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
      else
        { rect = nullRect; }
    }

    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
    var mid = (rtop + rbot) / 2;
    var heights = prepared.view.measure.heights;
    var i = 0;
    for (; i < heights.length - 1; i++)
      { if (mid < heights[i]) { break } }
    var top = i ? heights[i - 1] : 0, bot = heights[i];
    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                  top: top, bottom: bot};
    if (!rect.left && !rect.right) { result.bogus = true; }
    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

    return result
  }

  // Work around problem with bounding client rects on ranges being
  // returned incorrectly when zoomed on IE10 and below.
  function maybeUpdateRectForZooming(measure, rect) {
    if (!window.screen || screen.logicalXDPI == null ||
        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
      { return rect }
    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
    return {left: rect.left * scaleX, right: rect.right * scaleX,
            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
  }

  function clearLineMeasurementCacheFor(lineView) {
    if (lineView.measure) {
      lineView.measure.cache = {};
      lineView.measure.heights = null;
      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
        { lineView.measure.caches[i] = {}; } }
    }
  }

  function clearLineMeasurementCache(cm) {
    cm.display.externalMeasure = null;
    removeChildren(cm.display.lineMeasure);
    for (var i = 0; i < cm.display.view.length; i++)
      { clearLineMeasurementCacheFor(cm.display.view[i]); }
  }

  function clearCaches(cm) {
    clearLineMeasurementCache(cm);
    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
    cm.display.lineNumChars = null;
  }

  function pageScrollX() {
    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
    // which causes page_Offset and bounding client rects to use
    // different reference viewports and invalidate our calculations.
    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
  }
  function pageScrollY() {
    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
    return window.pageYOffset || (document.documentElement || document.body).scrollTop
  }

  function widgetTopHeight(lineObj) {
    var height = 0;
    if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
      { height += widgetHeight(lineObj.widgets[i]); } } }
    return height
  }

  // Converts a {top, bottom, left, right} box from line-local
  // coordinates into another coordinate system. Context may be one of
  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
  // or "page".
  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
    if (!includeWidgets) {
      var height = widgetTopHeight(lineObj);
      rect.top += height; rect.bottom += height;
    }
    if (context == "line") { return rect }
    if (!context) { context = "local"; }
    var yOff = heightAtLine(lineObj);
    if (context == "local") { yOff += paddingTop(cm.display); }
    else { yOff -= cm.display.viewOffset; }
    if (context == "page" || context == "window") {
      var lOff = cm.display.lineSpace.getBoundingClientRect();
      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
      rect.left += xOff; rect.right += xOff;
    }
    rect.top += yOff; rect.bottom += yOff;
    return rect
  }

  // Coverts a box from "div" coords to another coordinate system.
  // Context may be "window", "page", "div", or "local"./null.
  function fromCoordSystem(cm, coords, context) {
    if (context == "div") { return coords }
    var left = coords.left, top = coords.top;
    // First move into "page" coordinate system
    if (context == "page") {
      left -= pageScrollX();
      top -= pageScrollY();
    } else if (context == "local" || !context) {
      var localBox = cm.display.sizer.getBoundingClientRect();
      left += localBox.left;
      top += localBox.top;
    }

    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
  }

  function charCoords(cm, pos, context, lineObj, bias) {
    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
  }

  // Returns a box for a given cursor position, which may have an
  // 'other' property containing the position of the secondary cursor
  // on a bidi boundary.
  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
  // and after `char - 1` in writing order of `char - 1`
  // A cursor Pos(line, char, "after") is on the same visual line as `char`
  // and before `char` in writing order of `char`
  // Examples (upper-case letters are RTL, lower-case are LTR):
  //     Pos(0, 1, ...)
  //     before   after
  // ab     a|b     a|b
  // aB     a|B     aB|
  // Ab     |Ab     A|b
  // AB     B|A     B|A
  // Every position after the last character on a line is considered to stick
  // to the last character on the line.
  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
    lineObj = lineObj || getLine(cm.doc, pos.line);
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    function get(ch, right) {
      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
      if (right) { m.left = m.right; } else { m.right = m.left; }
      return intoCoordSystem(cm, lineObj, m, context)
    }
    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
    if (ch >= lineObj.text.length) {
      ch = lineObj.text.length;
      sticky = "before";
    } else if (ch <= 0) {
      ch = 0;
      sticky = "after";
    }
    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

    function getBidi(ch, partPos, invert) {
      var part = order[partPos], right = part.level == 1;
      return get(invert ? ch - 1 : ch, right != invert)
    }
    var partPos = getBidiPartAt(order, ch, sticky);
    var other = bidiOther;
    var val = getBidi(ch, partPos, sticky == "before");
    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
    return val
  }

  // Used to cheaply estimate the coordinates for a position. Used for
  // intermediate scroll updates.
  function estimateCoords(cm, pos) {
    var left = 0;
    pos = clipPos(cm.doc, pos);
    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
    var lineObj = getLine(cm.doc, pos.line);
    var top = heightAtLine(lineObj) + paddingTop(cm.display);
    return {left: left, right: left, top: top, bottom: top + lineObj.height}
  }

  // Positions returned by coordsChar contain some extra information.
  // xRel is the relative x position of the input coordinates compared
  // to the found position (so xRel > 0 means the coordinates are to
  // the right of the character position, for example). When outside
  // is true, that means the coordinates lie outside the line's
  // vertical range.
  function PosWithInfo(line, ch, sticky, outside, xRel) {
    var pos = Pos(line, ch, sticky);
    pos.xRel = xRel;
    if (outside) { pos.outside = outside; }
    return pos
  }

  // Compute the character position closest to the given coordinates.
  // Input must be lineSpace-local ("div" coordinate system).
  function coordsChar(cm, x, y) {
    var doc = cm.doc;
    y += cm.display.viewOffset;
    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
    if (lineN > last)
      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
    if (x < 0) { x = 0; }

    var lineObj = getLine(doc, lineN);
    for (;;) {
      var found = coordsCharInner(cm, lineObj, lineN, x, y);
      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
      if (!collapsed) { return found }
      var rangeEnd = collapsed.find(1);
      if (rangeEnd.line == lineN) { return rangeEnd }
      lineObj = getLine(doc, lineN = rangeEnd.line);
    }
  }

  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
    y -= widgetTopHeight(lineObj);
    var end = lineObj.text.length;
    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
    return {begin: begin, end: end}
  }

  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
  }

  // Returns true if the given side of a box is after the given
  // coordinates, in top-to-bottom, left-to-right order.
  function boxIsAfter(box, x, y, left) {
    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
  }

  function coordsCharInner(cm, lineObj, lineNo, x, y) {
    // Move y into line-local coordinate space
    y -= heightAtLine(lineObj);
    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
    // When directly calling `measureCharPrepared`, we have to adjust
    // for the widgets at this line.
    var widgetHeight = widgetTopHeight(lineObj);
    var begin = 0, end = lineObj.text.length, ltr = true;

    var order = getOrder(lineObj, cm.doc.direction);
    // If the line isn't plain left-to-right text, first figure out
    // which bidi section the coordinates fall into.
    if (order) {
      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
      ltr = part.level != 1;
      // The awkward -1 offsets are needed because findFirst (called
      // on these below) will treat its first bound as inclusive,
      // second as exclusive, but we want to actually address the
      // characters in the part's range
      begin = ltr ? part.from : part.to - 1;
      end = ltr ? part.to : part.from - 1;
    }

    // A binary search to find the first character whose bounding box
    // starts after the coordinates. If we run across any whose box wrap
    // the coordinates, store that.
    var chAround = null, boxAround = null;
    var ch = findFirst(function (ch) {
      var box = measureCharPrepared(cm, preparedMeasure, ch);
      box.top += widgetHeight; box.bottom += widgetHeight;
      if (!boxIsAfter(box, x, y, false)) { return false }
      if (box.top <= y && box.left <= x) {
        chAround = ch;
        boxAround = box;
      }
      return true
    }, begin, end);

    var baseX, sticky, outside = false;
    // If a box around the coordinates was found, use that
    if (boxAround) {
      // Distinguish coordinates nearer to the left or right side of the box
      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
      ch = chAround + (atStart ? 0 : 1);
      sticky = atStart ? "after" : "before";
      baseX = atLeft ? boxAround.left : boxAround.right;
    } else {
      // (Adjust for extended bound, if necessary.)
      if (!ltr && (ch == end || ch == begin)) { ch++; }
      // To determine which side to associate with, get the box to the
      // left of the character and compare it's vertical position to the
      // coordinates
      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
        "after" : "before";
      // Now get accurate coordinates for this place, in order to get a
      // base X position
      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
      baseX = coords.left;
      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
    }

    ch = skipExtendingChars(lineObj.text, ch, 1);
    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
  }

  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
    // situation, we can take this ordering to correspond to the visual
    // ordering. This finds the first part whose end is after the given
    // coordinates.
    var index = findFirst(function (i) {
      var part = order[i], ltr = part.level != 1;
      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                     "line", lineObj, preparedMeasure), x, y, true)
    }, 0, order.length - 1);
    var part = order[index];
    // If this isn't the first part, the part's start is also after
    // the coordinates, and the coordinates aren't on the same line as
    // that start, move one part back.
    if (index > 0) {
      var ltr = part.level != 1;
      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
                               "line", lineObj, preparedMeasure);
      if (boxIsAfter(start, x, y, true) && start.top > y)
        { part = order[index - 1]; }
    }
    return part
  }

  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
    // In a wrapped line, rtl text on wrapping boundaries can do things
    // that don't correspond to the ordering in our `order` array at
    // all, so a binary search doesn't work, and we want to return a
    // part that only spans one line so that the binary search in
    // coordsCharInner is safe. As such, we first find the extent of the
    // wrapped line, and then do a flat search in which we discard any
    // spans that aren't on the line.
    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
    var begin = ref.begin;
    var end = ref.end;
    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
    var part = null, closestDist = null;
    for (var i = 0; i < order.length; i++) {
      var p = order[i];
      if (p.from >= end || p.to <= begin) { continue }
      var ltr = p.level != 1;
      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
      // Weigh against spans ending before this, so that they are only
      // picked if nothing ends after
      var dist = endX < x ? x - endX + 1e9 : endX - x;
      if (!part || closestDist > dist) {
        part = p;
        closestDist = dist;
      }
    }
    if (!part) { part = order[order.length - 1]; }
    // Clip the part to the wrapped line.
    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
    return part
  }

  var measureText;
  // Compute the default text height.
  function textHeight(display) {
    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
    if (measureText == null) {
      measureText = elt("pre", null, "CodeMirror-line-like");
      // Measure a bunch of lines, for browsers that compute
      // fractional heights.
      for (var i = 0; i < 49; ++i) {
        measureText.appendChild(document.createTextNode("x"));
        measureText.appendChild(elt("br"));
      }
      measureText.appendChild(document.createTextNode("x"));
    }
    removeChildrenAndAdd(display.measure, measureText);
    var height = measureText.offsetHeight / 50;
    if (height > 3) { display.cachedTextHeight = height; }
    removeChildren(display.measure);
    return height || 1
  }

  // Compute the default character width.
  function charWidth(display) {
    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
    var anchor = elt("span", "xxxxxxxxxx");
    var pre = elt("pre", [anchor], "CodeMirror-line-like");
    removeChildrenAndAdd(display.measure, pre);
    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
    if (width > 2) { display.cachedCharWidth = width; }
    return width || 10
  }

  // Do a bulk-read of the DOM positions and sizes needed to draw the
  // view, so that we don't interleave reading and writing to the DOM.
  function getDimensions(cm) {
    var d = cm.display, left = {}, width = {};
    var gutterLeft = d.gutters.clientLeft;
    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
      var id = cm.display.gutterSpecs[i].className;
      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
      width[id] = n.clientWidth;
    }
    return {fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth}
  }

  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
  // but using getBoundingClientRect to get a sub-pixel-accurate
  // result.
  function compensateForHScroll(display) {
    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
  }

  // Returns a function that estimates the height of a line, to use as
  // first approximation until the line becomes visible (and is thus
  // properly measurable).
  function estimateHeight(cm) {
    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
    return function (line) {
      if (lineIsHidden(cm.doc, line)) { return 0 }

      var widgetsHeight = 0;
      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
      } }

      if (wrapping)
        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
      else
        { return widgetsHeight + th }
    }
  }

  function estimateLineHeights(cm) {
    var doc = cm.doc, est = estimateHeight(cm);
    doc.iter(function (line) {
      var estHeight = est(line);
      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
    });
  }

  // Given a mouse event, find the corresponding position. If liberal
  // is false, it checks whether a gutter or scrollbar was clicked,
  // and returns null if it was. forRect is used by rectangular
  // selections, and tries to estimate a character position even for
  // coordinates beyond the right of the text.
  function posFromMouse(cm, e, liberal, forRect) {
    var display = cm.display;
    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

    var x, y, space = display.lineSpace.getBoundingClientRect();
    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
    try { x = e.clientX - space.left; y = e.clientY - space.top; }
    catch (e) { return null }
    var coords = coordsChar(cm, x, y), line;
    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
    }
    return coords
  }

  // Find the view element corresponding to a given line. Return null
  // when the line isn't visible.
  function findViewIndex(cm, n) {
    if (n >= cm.display.viewTo) { return null }
    n -= cm.display.viewFrom;
    if (n < 0) { return null }
    var view = cm.display.view;
    for (var i = 0; i < view.length; i++) {
      n -= view[i].size;
      if (n < 0) { return i }
    }
  }

  // Updates the display.view data structure for a given change to the
  // document. From and to are in pre-change coordinates. Lendiff is
  // the amount of lines added or subtracted by the change. This is
  // used for changes that span multiple lines, or change the way
  // lines are divided into visual lines. regLineChange (below)
  // registers single-line changes.
  function regChange(cm, from, to, lendiff) {
    if (from == null) { from = cm.doc.first; }
    if (to == null) { to = cm.doc.first + cm.doc.size; }
    if (!lendiff) { lendiff = 0; }

    var display = cm.display;
    if (lendiff && to < display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers > from))
      { display.updateLineNumbers = from; }

    cm.curOp.viewChanged = true;

    if (from >= display.viewTo) { // Change after
      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
        { resetView(cm); }
    } else if (to <= display.viewFrom) { // Change before
      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
        resetView(cm);
      } else {
        display.viewFrom += lendiff;
        display.viewTo += lendiff;
      }
    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
      resetView(cm);
    } else if (from <= display.viewFrom) { // Top overlap
      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cut) {
        display.view = display.view.slice(cut.index);
        display.viewFrom = cut.lineN;
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    } else if (to >= display.viewTo) { // Bottom overlap
      var cut$1 = viewCuttingPoint(cm, from, from, -1);
      if (cut$1) {
        display.view = display.view.slice(0, cut$1.index);
        display.viewTo = cut$1.lineN;
      } else {
        resetView(cm);
      }
    } else { // Gap in the middle
      var cutTop = viewCuttingPoint(cm, from, from, -1);
      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cutTop && cutBot) {
        display.view = display.view.slice(0, cutTop.index)
          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
          .concat(display.view.slice(cutBot.index));
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    }

    var ext = display.externalMeasured;
    if (ext) {
      if (to < ext.lineN)
        { ext.lineN += lendiff; }
      else if (from < ext.lineN + ext.size)
        { display.externalMeasured = null; }
    }
  }

  // Register a change to a single line. Type must be one of "text",
  // "gutter", "class", "widget"
  function regLineChange(cm, line, type) {
    cm.curOp.viewChanged = true;
    var display = cm.display, ext = cm.display.externalMeasured;
    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
      { display.externalMeasured = null; }

    if (line < display.viewFrom || line >= display.viewTo) { return }
    var lineView = display.view[findViewIndex(cm, line)];
    if (lineView.node == null) { return }
    var arr = lineView.changes || (lineView.changes = []);
    if (indexOf(arr, type) == -1) { arr.push(type); }
  }

  // Clear the view.
  function resetView(cm) {
    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
    cm.display.view = [];
    cm.display.viewOffset = 0;
  }

  function viewCuttingPoint(cm, oldN, newN, dir) {
    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
      { return {index: index, lineN: newN} }
    var n = cm.display.viewFrom;
    for (var i = 0; i < index; i++)
      { n += view[i].size; }
    if (n != oldN) {
      if (dir > 0) {
        if (index == view.length - 1) { return null }
        diff = (n + view[index].size) - oldN;
        index++;
      } else {
        diff = n - oldN;
      }
      oldN += diff; newN += diff;
    }
    while (visualLineNo(cm.doc, newN) != newN) {
      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
      index += dir;
    }
    return {index: index, lineN: newN}
  }

  // Force the view to cover a given range, adding empty view element
  // or clipping off existing ones as needed.
  function adjustView(cm, from, to) {
    var display = cm.display, view = display.view;
    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
      display.view = buildViewArray(cm, from, to);
      display.viewFrom = from;
    } else {
      if (display.viewFrom > from)
        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
      else if (display.viewFrom < from)
        { display.view = display.view.slice(findViewIndex(cm, from)); }
      display.viewFrom = from;
      if (display.viewTo < to)
        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
      else if (display.viewTo > to)
        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
    }
    display.viewTo = to;
  }

  // Count the number of lines in the view whose DOM representation is
  // out of date (or nonexistent).
  function countDirtyView(cm) {
    var view = cm.display.view, dirty = 0;
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
    }
    return dirty
  }

  function updateSelection(cm) {
    cm.display.input.showSelection(cm.display.input.prepareSelection());
  }

  function prepareSelection(cm, primary) {
    if ( primary === void 0 ) primary = true;

    var doc = cm.doc, result = {};
    var curFragment = result.cursors = document.createDocumentFragment();
    var selFragment = result.selection = document.createDocumentFragment();

    for (var i = 0; i < doc.sel.ranges.length; i++) {
      if (!primary && i == doc.sel.primIndex) { continue }
      var range = doc.sel.ranges[i];
      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
      var collapsed = range.empty();
      if (collapsed || cm.options.showCursorWhenSelecting)
        { drawSelectionCursor(cm, range.head, curFragment); }
      if (!collapsed)
        { drawSelectionRange(cm, range, selFragment); }
    }
    return result
  }

  // Draws a cursor for the given range
  function drawSelectionCursor(cm, head, output) {
    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
    cursor.style.left = pos.left + "px";
    cursor.style.top = pos.top + "px";
    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

    if (pos.other) {
      // Secondary cursor, shown when on a 'jump' in bi-directional text
      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
      otherCursor.style.display = "";
      otherCursor.style.left = pos.other.left + "px";
      otherCursor.style.top = pos.other.top + "px";
      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
    }
  }

  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

  // Draws the given range as a highlighted selection
  function drawSelectionRange(cm, range, output) {
    var display = cm.display, doc = cm.doc;
    var fragment = document.createDocumentFragment();
    var padding = paddingH(cm.display), leftSide = padding.left;
    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
    var docLTR = doc.direction == "ltr";

    function add(left, top, width, bottom) {
      if (top < 0) { top = 0; }
      top = Math.round(top);
      bottom = Math.round(bottom);
      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
    }

    function drawForLine(line, fromArg, toArg) {
      var lineObj = getLine(doc, line);
      var lineLen = lineObj.text.length;
      var start, end;
      function coords(ch, bias) {
        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
      }

      function wrapX(pos, dir, side) {
        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
        return coords(ch, prop)[prop]
      }

      var order = getOrder(lineObj, doc.direction);
      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
        var ltr = dir == "ltr";
        var fromPos = coords(from, ltr ? "left" : "right");
        var toPos = coords(to - 1, ltr ? "right" : "left");

        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
        var first = i == 0, last = !order || i == order.length - 1;
        if (toPos.top - fromPos.top <= 3) { // Single line
          var openLeft = (docLTR ? openStart : openEnd) && first;
          var openRight = (docLTR ? openEnd : openStart) && last;
          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
          add(left, fromPos.top, right - left, fromPos.bottom);
        } else { // Multiple lines
          var topLeft, topRight, botLeft, botRight;
          if (ltr) {
            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
          } else {
            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
          }
          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
        }

        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
        if (cmpCoords(toPos, start) < 0) { start = toPos; }
        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
        if (cmpCoords(toPos, end) < 0) { end = toPos; }
      });
      return {start: start, end: end}
    }

    var sFrom = range.from(), sTo = range.to();
    if (sFrom.line == sTo.line) {
      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
    } else {
      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
      var singleVLine = visualLine(fromLine) == visualLine(toLine);
      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
      if (singleVLine) {
        if (leftEnd.top < rightStart.top - 2) {
          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
        } else {
          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
        }
      }
      if (leftEnd.bottom < rightStart.top)
        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
    }

    output.appendChild(fragment);
  }

  // Cursor-blinking
  function restartBlink(cm) {
    if (!cm.state.focused) { return }
    var display = cm.display;
    clearInterval(display.blinker);
    var on = true;
    display.cursorDiv.style.visibility = "";
    if (cm.options.cursorBlinkRate > 0)
      { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
        cm.options.cursorBlinkRate); }
    else if (cm.options.cursorBlinkRate < 0)
      { display.cursorDiv.style.visibility = "hidden"; }
  }

  function ensureFocus(cm) {
    if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
  }

  function delayBlurEvent(cm) {
    cm.state.delayingBlurEvent = true;
    setTimeout(function () { if (cm.state.delayingBlurEvent) {
      cm.state.delayingBlurEvent = false;
      onBlur(cm);
    } }, 100);
  }

  function onFocus(cm, e) {
    if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }

    if (cm.options.readOnly == "nocursor") { return }
    if (!cm.state.focused) {
      signal(cm, "focus", cm, e);
      cm.state.focused = true;
      addClass(cm.display.wrapper, "CodeMirror-focused");
      // This test prevents this from firing when a context
      // menu is closed (since the input reset would kill the
      // select-all detection hack)
      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
        cm.display.input.reset();
        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
      }
      cm.display.input.receivedFocus();
    }
    restartBlink(cm);
  }
  function onBlur(cm, e) {
    if (cm.state.delayingBlurEvent) { return }

    if (cm.state.focused) {
      signal(cm, "blur", cm, e);
      cm.state.focused = false;
      rmClass(cm.display.wrapper, "CodeMirror-focused");
    }
    clearInterval(cm.display.blinker);
    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
  }

  // Read the actual heights of the rendered lines, and update their
  // stored heights to match.
  function updateHeightsInViewport(cm) {
    var display = cm.display;
    var prevBottom = display.lineDiv.offsetTop;
    for (var i = 0; i < display.view.length; i++) {
      var cur = display.view[i], wrapping = cm.options.lineWrapping;
      var height = (void 0), width = 0;
      if (cur.hidden) { continue }
      if (ie && ie_version < 8) {
        var bot = cur.node.offsetTop + cur.node.offsetHeight;
        height = bot - prevBottom;
        prevBottom = bot;
      } else {
        var box = cur.node.getBoundingClientRect();
        height = box.bottom - box.top;
        // Check that lines don't extend past the right of the current
        // editor width
        if (!wrapping && cur.text.firstChild)
          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
      }
      var diff = cur.line.height - height;
      if (diff > .005 || diff < -.005) {
        updateLineHeight(cur.line, height);
        updateWidgetHeight(cur.line);
        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
          { updateWidgetHeight(cur.rest[j]); } }
      }
      if (width > cm.display.sizerWidth) {
        var chWidth = Math.ceil(width / charWidth(cm.display));
        if (chWidth > cm.display.maxLineLength) {
          cm.display.maxLineLength = chWidth;
          cm.display.maxLine = cur.line;
          cm.display.maxLineChanged = true;
        }
      }
    }
  }

  // Read and store the height of line widgets associated with the
  // given line.
  function updateWidgetHeight(line) {
    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
      var w = line.widgets[i], parent = w.node.parentNode;
      if (parent) { w.height = parent.offsetHeight; }
    } }
  }

  // Compute the lines that are visible in a given viewport (defaults
  // the the current scroll position). viewport may contain top,
  // height, and ensure (see op.scrollToPos) properties.
  function visibleLines(display, doc, viewport) {
    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
    top = Math.floor(top - paddingTop(display));
    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
    // forces those lines into the viewport (if possible).
    if (viewport && viewport.ensure) {
      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
      if (ensureFrom < from) {
        from = ensureFrom;
        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
        to = ensureTo;
      }
    }
    return {from: from, to: Math.max(to, from + 1)}
  }

  // SCROLLING THINGS INTO VIEW

  // If an editor sits on the top or bottom of the window, partially
  // scrolled out of view, this ensures that the cursor is visible.
  function maybeScrollWindow(cm, rect) {
    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
    if (rect.top + box.top < 0) { doScroll = true; }
    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
    if (doScroll != null && !phantom) {
      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
      cm.display.lineSpace.appendChild(scrollNode);
      scrollNode.scrollIntoView(doScroll);
      cm.display.lineSpace.removeChild(scrollNode);
    }
  }

  // Scroll a given position into view (immediately), verifying that
  // it actually became visible (as line heights are accurately
  // measured, the position of something may 'drift' during drawing).
  function scrollPosIntoView(cm, pos, end, margin) {
    if (margin == null) { margin = 0; }
    var rect;
    if (!cm.options.lineWrapping && pos == end) {
      // Set pos and end to the cursor positions around the character pos sticks to
      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
      // If pos == Pos(_, 0, "before"), pos and end are unchanged
      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
    }
    for (var limit = 0; limit < 5; limit++) {
      var changed = false;
      var coords = cursorCoords(cm, pos);
      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
      rect = {left: Math.min(coords.left, endCoords.left),
              top: Math.min(coords.top, endCoords.top) - margin,
              right: Math.max(coords.left, endCoords.left),
              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
      var scrollPos = calculateScrollPos(cm, rect);
      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
      }
      if (!changed) { break }
    }
    return rect
  }

  // Scroll a given set of coordinates into view (immediately).
  function scrollIntoView(cm, rect) {
    var scrollPos = calculateScrollPos(cm, rect);
    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
  }

  // Calculate a new scroll position needed to scroll the given
  // rectangle into view. Returns an object with scrollTop and
  // scrollLeft properties. When these are undefined, the
  // vertical/horizontal position does not need to be adjusted.
  function calculateScrollPos(cm, rect) {
    var display = cm.display, snapMargin = textHeight(cm.display);
    if (rect.top < 0) { rect.top = 0; }
    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
    var screen = displayHeight(cm), result = {};
    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
    var docBottom = cm.doc.height + paddingVert(display);
    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
    if (rect.top < screentop) {
      result.scrollTop = atTop ? 0 : rect.top;
    } else if (rect.bottom > screentop + screen) {
      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
      if (newTop != screentop) { result.scrollTop = newTop; }
    }

    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
    var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
    var tooWide = rect.right - rect.left > screenw;
    if (tooWide) { rect.right = rect.left + screenw; }
    if (rect.left < 10)
      { result.scrollLeft = 0; }
    else if (rect.left < screenleft)
      { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
    else if (rect.right > screenw + screenleft - 3)
      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
    return result
  }

  // Store a relative adjustment to the scroll position in the current
  // operation (to be applied when the operation finishes).
  function addToScrollTop(cm, top) {
    if (top == null) { return }
    resolveScrollToPos(cm);
    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
  }

  // Make sure that at the end of the operation the current cursor is
  // shown.
  function ensureCursorVisible(cm) {
    resolveScrollToPos(cm);
    var cur = cm.getCursor();
    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
  }

  function scrollToCoords(cm, x, y) {
    if (x != null || y != null) { resolveScrollToPos(cm); }
    if (x != null) { cm.curOp.scrollLeft = x; }
    if (y != null) { cm.curOp.scrollTop = y; }
  }

  function scrollToRange(cm, range) {
    resolveScrollToPos(cm);
    cm.curOp.scrollToPos = range;
  }

  // When an operation has its scrollToPos property set, and another
  // scroll action is applied before the end of the operation, this
  // 'simulates' scrolling that position into view in a cheap way, so
  // that the effect of intermediate scroll commands is not ignored.
  function resolveScrollToPos(cm) {
    var range = cm.curOp.scrollToPos;
    if (range) {
      cm.curOp.scrollToPos = null;
      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
      scrollToCoordsRange(cm, from, to, range.margin);
    }
  }

  function scrollToCoordsRange(cm, from, to, margin) {
    var sPos = calculateScrollPos(cm, {
      left: Math.min(from.left, to.left),
      top: Math.min(from.top, to.top) - margin,
      right: Math.max(from.right, to.right),
      bottom: Math.max(from.bottom, to.bottom) + margin
    });
    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
  }

  // Sync the scrollable area and scrollbars, ensure the viewport
  // covers the visible area.
  function updateScrollTop(cm, val) {
    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
    setScrollTop(cm, val, true);
    if (gecko) { updateDisplaySimple(cm); }
    startWorker(cm, 100);
  }

  function setScrollTop(cm, val, forceScroll) {
    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
    cm.doc.scrollTop = val;
    cm.display.scrollbars.setScrollTop(val);
    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
  }

  // Sync scroller and scrollbar, ensure the gutter elements are
  // aligned.
  function setScrollLeft(cm, val, isScroller, forceScroll) {
    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
    cm.doc.scrollLeft = val;
    alignHorizontally(cm);
    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
    cm.display.scrollbars.setScrollLeft(val);
  }

  // SCROLLBARS

  // Prepare DOM reads needed to update the scrollbars. Done in one
  // shot to minimize update/measure roundtrips.
  function measureForScrollbars(cm) {
    var d = cm.display, gutterW = d.gutters.offsetWidth;
    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
    return {
      clientHeight: d.scroller.clientHeight,
      viewHeight: d.wrapper.clientHeight,
      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
      viewWidth: d.wrapper.clientWidth,
      barLeft: cm.options.fixedGutter ? gutterW : 0,
      docHeight: docH,
      scrollHeight: docH + scrollGap(cm) + d.barHeight,
      nativeBarWidth: d.nativeBarWidth,
      gutterWidth: gutterW
    }
  }

  var NativeScrollbars = function(place, scroll, cm) {
    this.cm = cm;
    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
    vert.tabIndex = horiz.tabIndex = -1;
    place(vert); place(horiz);

    on(vert, "scroll", function () {
      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
    });
    on(horiz, "scroll", function () {
      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
    });

    this.checkedZeroWidth = false;
    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
  };

  NativeScrollbars.prototype.update = function (measure) {
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    var sWidth = measure.nativeBarWidth;

    if (needsV) {
      this.vert.style.display = "block";
      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
      // A bug in IE8 can cause this value to be negative, so guard it.
      this.vert.firstChild.style.height =
        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
    } else {
      this.vert.style.display = "";
      this.vert.firstChild.style.height = "0";
    }

    if (needsH) {
      this.horiz.style.display = "block";
      this.horiz.style.right = needsV ? sWidth + "px" : "0";
      this.horiz.style.left = measure.barLeft + "px";
      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
      this.horiz.firstChild.style.width =
        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
    } else {
      this.horiz.style.display = "";
      this.horiz.firstChild.style.width = "0";
    }

    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
      if (sWidth == 0) { this.zeroWidthHack(); }
      this.checkedZeroWidth = true;
    }

    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
  };

  NativeScrollbars.prototype.setScrollLeft = function (pos) {
    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
  };

  NativeScrollbars.prototype.setScrollTop = function (pos) {
    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
  };

  NativeScrollbars.prototype.zeroWidthHack = function () {
    var w = mac && !mac_geMountainLion ? "12px" : "18px";
    this.horiz.style.height = this.vert.style.width = w;
    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
    this.disableHoriz = new Delayed;
    this.disableVert = new Delayed;
  };

  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
    bar.style.pointerEvents = "auto";
    function maybeDisable() {
      // To find out whether the scrollbar is still visible, we
      // check whether the element under the pixel in the bottom
      // right corner of the scrollbar box is the scrollbar box
      // itself (when the bar is still visible) or its filler child
      // (when the bar is hidden). If it is still visible, we keep
      // it enabled, if it's hidden, we disable pointer events.
      var box = bar.getBoundingClientRect();
      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
      if (elt != bar) { bar.style.pointerEvents = "none"; }
      else { delay.set(1000, maybeDisable); }
    }
    delay.set(1000, maybeDisable);
  };

  NativeScrollbars.prototype.clear = function () {
    var parent = this.horiz.parentNode;
    parent.removeChild(this.horiz);
    parent.removeChild(this.vert);
  };

  var NullScrollbars = function () {};

  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
  NullScrollbars.prototype.setScrollLeft = function () {};
  NullScrollbars.prototype.setScrollTop = function () {};
  NullScrollbars.prototype.clear = function () {};

  function updateScrollbars(cm, measure) {
    if (!measure) { measure = measureForScrollbars(cm); }
    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
    updateScrollbarsInner(cm, measure);
    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
        { updateHeightsInViewport(cm); }
      updateScrollbarsInner(cm, measureForScrollbars(cm));
      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
    }
  }

  // Re-synchronize the fake scrollbars with the actual size of the
  // content.
  function updateScrollbarsInner(cm, measure) {
    var d = cm.display;
    var sizes = d.scrollbars.update(measure);

    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

    if (sizes.right && sizes.bottom) {
      d.scrollbarFiller.style.display = "block";
      d.scrollbarFiller.style.height = sizes.bottom + "px";
      d.scrollbarFiller.style.width = sizes.right + "px";
    } else { d.scrollbarFiller.style.display = ""; }
    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
      d.gutterFiller.style.display = "block";
      d.gutterFiller.style.height = sizes.bottom + "px";
      d.gutterFiller.style.width = measure.gutterWidth + "px";
    } else { d.gutterFiller.style.display = ""; }
  }

  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

  function initScrollbars(cm) {
    if (cm.display.scrollbars) {
      cm.display.scrollbars.clear();
      if (cm.display.scrollbars.addClass)
        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
    }

    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
      // Prevent clicks in the scrollbars from killing focus
      on(node, "mousedown", function () {
        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
      });
      node.setAttribute("cm-not-content", "true");
    }, function (pos, axis) {
      if (axis == "horizontal") { setScrollLeft(cm, pos); }
      else { updateScrollTop(cm, pos); }
    }, cm);
    if (cm.display.scrollbars.addClass)
      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  // Operations are used to wrap a series of changes to the editor
  // state in such a way that each change won't have to update the
  // cursor and display (which would be awkward, slow, and
  // error-prone). Instead, display updates are batched and then all
  // combined and executed at once.

  var nextOpId = 0;
  // Start a new operation.
  function startOperation(cm) {
    cm.curOp = {
      cm: cm,
      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
      startHeight: cm.doc.height, // Used to detect need to update scrollbar
      forceUpdate: false,      // Used to force a redraw
      updateInput: 0,       // Whether to reset the input textarea
      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
      changeObjs: null,        // Accumulated changes, for firing change events
      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
      selectionChanged: false, // Whether the selection needs to be redrawn
      updateMaxLine: false,    // Set when the widest line needs to be determined anew
      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
      scrollToPos: null,       // Used to scroll to a specific position
      focus: false,
      id: ++nextOpId           // Unique ID
    };
    pushOperation(cm.curOp);
  }

  // Finish an operation, updating the display and signalling delayed events
  function endOperation(cm) {
    var op = cm.curOp;
    if (op) { finishOperation(op, function (group) {
      for (var i = 0; i < group.ops.length; i++)
        { group.ops[i].cm.curOp = null; }
      endOperations(group);
    }); }
  }

  // The DOM updates done when an operation finishes are batched so
  // that the minimum number of relayouts are required.
  function endOperations(group) {
    var ops = group.ops;
    for (var i = 0; i < ops.length; i++) // Read DOM
      { endOperation_R1(ops[i]); }
    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
      { endOperation_W1(ops[i$1]); }
    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
      { endOperation_R2(ops[i$2]); }
    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
      { endOperation_W2(ops[i$3]); }
    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
      { endOperation_finish(ops[i$4]); }
  }

  function endOperation_R1(op) {
    var cm = op.cm, display = cm.display;
    maybeClipScrollbars(cm);
    if (op.updateMaxLine) { findMaxLine(cm); }

    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                         op.scrollToPos.to.line >= display.viewTo) ||
      display.maxLineChanged && cm.options.lineWrapping;
    op.update = op.mustUpdate &&
      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
  }

  function endOperation_W1(op) {
    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
  }

  function endOperation_R2(op) {
    var cm = op.cm, display = cm.display;
    if (op.updatedDisplay) { updateHeightsInViewport(cm); }

    op.barMeasure = measureForScrollbars(cm);

    // If the max line changed since it was last measured, measure it,
    // and ensure the document's width matches it.
    // updateDisplay_W2 will use these properties to do the actual resizing
    if (display.maxLineChanged && !cm.options.lineWrapping) {
      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
      cm.display.sizerWidth = op.adjustWidthTo;
      op.barMeasure.scrollWidth =
        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
    }

    if (op.updatedDisplay || op.selectionChanged)
      { op.preparedSelection = display.input.prepareSelection(); }
  }

  function endOperation_W2(op) {
    var cm = op.cm;

    if (op.adjustWidthTo != null) {
      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
      if (op.maxScrollLeft < cm.doc.scrollLeft)
        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
      cm.display.maxLineChanged = false;
    }

    var takeFocus = op.focus && op.focus == activeElt();
    if (op.preparedSelection)
      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
    if (op.updatedDisplay || op.startHeight != cm.doc.height)
      { updateScrollbars(cm, op.barMeasure); }
    if (op.updatedDisplay)
      { setDocumentHeight(cm, op.barMeasure); }

    if (op.selectionChanged) { restartBlink(cm); }

    if (cm.state.focused && op.updateInput)
      { cm.display.input.reset(op.typing); }
    if (takeFocus) { ensureFocus(op.cm); }
  }

  function endOperation_finish(op) {
    var cm = op.cm, display = cm.display, doc = cm.doc;

    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

    // Abort mouse wheel delta measurement, when scrolling explicitly
    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
      { display.wheelStartX = display.wheelStartY = null; }

    // Propagate the scroll position to the actual DOM scroller
    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
    // If we need to scroll a specific position into view, do so.
    if (op.scrollToPos) {
      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
      maybeScrollWindow(cm, rect);
    }

    // Fire events for markers that are hidden/unidden by editing or
    // undoing
    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
    if (hidden) { for (var i = 0; i < hidden.length; ++i)
      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

    if (display.wrapper.offsetHeight)
      { doc.scrollTop = cm.display.scroller.scrollTop; }

    // Fire change events, and delayed event handlers
    if (op.changeObjs)
      { signal(cm, "changes", cm, op.changeObjs); }
    if (op.update)
      { op.update.finish(); }
  }

  // Run the given function in an operation
  function runInOp(cm, f) {
    if (cm.curOp) { return f() }
    startOperation(cm);
    try { return f() }
    finally { endOperation(cm); }
  }
  // Wraps a function in an operation. Returns the wrapped function.
  function operation(cm, f) {
    return function() {
      if (cm.curOp) { return f.apply(cm, arguments) }
      startOperation(cm);
      try { return f.apply(cm, arguments) }
      finally { endOperation(cm); }
    }
  }
  // Used to add methods to editor and doc instances, wrapping them in
  // operations.
  function methodOp(f) {
    return function() {
      if (this.curOp) { return f.apply(this, arguments) }
      startOperation(this);
      try { return f.apply(this, arguments) }
      finally { endOperation(this); }
    }
  }
  function docMethodOp(f) {
    return function() {
      var cm = this.cm;
      if (!cm || cm.curOp) { return f.apply(this, arguments) }
      startOperation(cm);
      try { return f.apply(this, arguments) }
      finally { endOperation(cm); }
    }
  }

  // HIGHLIGHT WORKER

  function startWorker(cm, time) {
    if (cm.doc.highlightFrontier < cm.display.viewTo)
      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
  }

  function highlightWorker(cm) {
    var doc = cm.doc;
    if (doc.highlightFrontier >= cm.display.viewTo) { return }
    var end = +new Date + cm.options.workTime;
    var context = getContextBefore(cm, doc.highlightFrontier);
    var changedLines = [];

    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
      if (context.line >= cm.display.viewFrom) { // Visible
        var oldStyles = line.styles;
        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
        var highlighted = highlightLine(cm, line, context, true);
        if (resetState) { context.state = resetState; }
        line.styles = highlighted.styles;
        var oldCls = line.styleClasses, newCls = highlighted.classes;
        if (newCls) { line.styleClasses = newCls; }
        else if (oldCls) { line.styleClasses = null; }
        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
        if (ischange) { changedLines.push(context.line); }
        line.stateAfter = context.save();
        context.nextLine();
      } else {
        if (line.text.length <= cm.options.maxHighlightLength)
          { processLine(cm, line.text, context); }
        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
        context.nextLine();
      }
      if (+new Date > end) {
        startWorker(cm, cm.options.workDelay);
        return true
      }
    });
    doc.highlightFrontier = context.line;
    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
    if (changedLines.length) { runInOp(cm, function () {
      for (var i = 0; i < changedLines.length; i++)
        { regLineChange(cm, changedLines[i], "text"); }
    }); }
  }

  // DISPLAY DRAWING

  var DisplayUpdate = function(cm, viewport, force) {
    var display = cm.display;

    this.viewport = viewport;
    // Store some values that we'll need later (but don't want to force a relayout for)
    this.visible = visibleLines(display, cm.doc, viewport);
    this.editorIsHidden = !display.wrapper.offsetWidth;
    this.wrapperHeight = display.wrapper.clientHeight;
    this.wrapperWidth = display.wrapper.clientWidth;
    this.oldDisplayWidth = displayWidth(cm);
    this.force = force;
    this.dims = getDimensions(cm);
    this.events = [];
  };

  DisplayUpdate.prototype.signal = function (emitter, type) {
    if (hasHandler(emitter, type))
      { this.events.push(arguments); }
  };
  DisplayUpdate.prototype.finish = function () {
    for (var i = 0; i < this.events.length; i++)
      { signal.apply(null, this.events[i]); }
  };

  function maybeClipScrollbars(cm) {
    var display = cm.display;
    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
      display.heightForcer.style.height = scrollGap(cm) + "px";
      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
      display.scrollbarsClipped = true;
    }
  }

  function selectionSnapshot(cm) {
    if (cm.hasFocus()) { return null }
    var active = activeElt();
    if (!active || !contains(cm.display.lineDiv, active)) { return null }
    var result = {activeElt: active};
    if (window.getSelection) {
      var sel = window.getSelection();
      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
        result.anchorNode = sel.anchorNode;
        result.anchorOffset = sel.anchorOffset;
        result.focusNode = sel.focusNode;
        result.focusOffset = sel.focusOffset;
      }
    }
    return result
  }

  function restoreSelection(snapshot) {
    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
    snapshot.activeElt.focus();
    if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
      var sel = window.getSelection(), range = document.createRange();
      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
      sel.extend(snapshot.focusNode, snapshot.focusOffset);
    }
  }

  // Does the actual updating of the line display. Bails out
  // (returning false) when there is nothing to be done and forced is
  // false.
  function updateDisplayIfNeeded(cm, update) {
    var display = cm.display, doc = cm.doc;

    if (update.editorIsHidden) {
      resetView(cm);
      return false
    }

    // Bail out if the visible area is already rendered and nothing changed.
    if (!update.force &&
        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
        display.renderedView == display.view && countDirtyView(cm) == 0)
      { return false }

    if (maybeUpdateLineNumberWidth(cm)) {
      resetView(cm);
      update.dims = getDimensions(cm);
    }

    // Compute a suitable new viewport (from & to)
    var end = doc.first + doc.size;
    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
    if (sawCollapsedSpans) {
      from = visualLineNo(cm.doc, from);
      to = visualLineEndNo(cm.doc, to);
    }

    var different = from != display.viewFrom || to != display.viewTo ||
      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
    adjustView(cm, from, to);

    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
    // Position the mover div to align with the current scroll position
    cm.display.mover.style.top = display.viewOffset + "px";

    var toUpdate = countDirtyView(cm);
    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
      { return false }

    // For big changes, we hide the enclosing element during the
    // update, since that speeds up the operations on most browsers.
    var selSnapshot = selectionSnapshot(cm);
    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
    patchDisplay(cm, display.updateLineNumbers, update.dims);
    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
    display.renderedView = display.view;
    // There might have been a widget with a focused element that got
    // hidden or updated, if so re-focus it.
    restoreSelection(selSnapshot);

    // Prevent selection and cursors from interfering with the scroll
    // width and height.
    removeChildren(display.cursorDiv);
    removeChildren(display.selectionDiv);
    display.gutters.style.height = display.sizer.style.minHeight = 0;

    if (different) {
      display.lastWrapHeight = update.wrapperHeight;
      display.lastWrapWidth = update.wrapperWidth;
      startWorker(cm, 400);
    }

    display.updateLineNumbers = null;

    return true
  }

  function postUpdateDisplay(cm, update) {
    var viewport = update.viewport;

    for (var first = true;; first = false) {
      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
        // Clip forced viewport to actual scrollable area.
        if (viewport && viewport.top != null)
          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
        // Updated line heights might result in the drawn area not
        // actually covering the viewport. Keep looping until it does.
        update.visible = visibleLines(cm.display, cm.doc, viewport);
        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
          { break }
      }
      if (!updateDisplayIfNeeded(cm, update)) { break }
      updateHeightsInViewport(cm);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.force = false;
    }

    update.signal(cm, "update", cm);
    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
    }
  }

  function updateDisplaySimple(cm, viewport) {
    var update = new DisplayUpdate(cm, viewport);
    if (updateDisplayIfNeeded(cm, update)) {
      updateHeightsInViewport(cm);
      postUpdateDisplay(cm, update);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.finish();
    }
  }

  // Sync the actual display DOM structure with display.view, removing
  // nodes for lines that are no longer in view, and creating the ones
  // that are not there yet, and updating the ones that are out of
  // date.
  function patchDisplay(cm, updateNumbersFrom, dims) {
    var display = cm.display, lineNumbers = cm.options.lineNumbers;
    var container = display.lineDiv, cur = container.firstChild;

    function rm(node) {
      var next = node.nextSibling;
      // Works around a throw-scroll bug in OS X Webkit
      if (webkit && mac && cm.display.currentWheelTarget == node)
        { node.style.display = "none"; }
      else
        { node.parentNode.removeChild(node); }
      return next
    }

    var view = display.view, lineN = display.viewFrom;
    // Loop over the elements in the view, syncing cur (the DOM nodes
    // in display.lineDiv) with the view as we go.
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
        var node = buildLineElement(cm, lineView, lineN, dims);
        container.insertBefore(node, cur);
      } else { // Already drawn
        while (cur != lineView.node) { cur = rm(cur); }
        var updateNumber = lineNumbers && updateNumbersFrom != null &&
          updateNumbersFrom <= lineN && lineView.lineNumber;
        if (lineView.changes) {
          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
          updateLineForChanges(cm, lineView, lineN, dims);
        }
        if (updateNumber) {
          removeChildren(lineView.lineNumber);
          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
        }
        cur = lineView.node.nextSibling;
      }
      lineN += lineView.size;
    }
    while (cur) { cur = rm(cur); }
  }

  function updateGutterSpace(display) {
    var width = display.gutters.offsetWidth;
    display.sizer.style.marginLeft = width + "px";
  }

  function setDocumentHeight(cm, measure) {
    cm.display.sizer.style.minHeight = measure.docHeight + "px";
    cm.display.heightForcer.style.top = measure.docHeight + "px";
    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
  }

  // Re-align line numbers and gutter marks to compensate for
  // horizontal scrolling.
  function alignHorizontally(cm) {
    var display = cm.display, view = display.view;
    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
    var gutterW = display.gutters.offsetWidth, left = comp + "px";
    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
      if (cm.options.fixedGutter) {
        if (view[i].gutter)
          { view[i].gutter.style.left = left; }
        if (view[i].gutterBackground)
          { view[i].gutterBackground.style.left = left; }
      }
      var align = view[i].alignable;
      if (align) { for (var j = 0; j < align.length; j++)
        { align[j].style.left = left; } }
    } }
    if (cm.options.fixedGutter)
      { display.gutters.style.left = (comp + gutterW) + "px"; }
  }

  // Used to ensure that the line number gutter is still the right
  // size for the current document size. Returns true when an update
  // is needed.
  function maybeUpdateLineNumberWidth(cm) {
    if (!cm.options.lineNumbers) { return false }
    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
    if (last.length != display.lineNumChars) {
      var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
      display.lineGutter.style.width = "";
      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
      display.lineNumWidth = display.lineNumInnerWidth + padding;
      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
      display.lineGutter.style.width = display.lineNumWidth + "px";
      updateGutterSpace(cm.display);
      return true
    }
    return false
  }

  function getGutters(gutters, lineNumbers) {
    var result = [], sawLineNumbers = false;
    for (var i = 0; i < gutters.length; i++) {
      var name = gutters[i], style = null;
      if (typeof name != "string") { style = name.style; name = name.className; }
      if (name == "CodeMirror-linenumbers") {
        if (!lineNumbers) { continue }
        else { sawLineNumbers = true; }
      }
      result.push({className: name, style: style});
    }
    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
    return result
  }

  // Rebuild the gutter elements, ensure the margin to the left of the
  // code matches their width.
  function renderGutters(display) {
    var gutters = display.gutters, specs = display.gutterSpecs;
    removeChildren(gutters);
    display.lineGutter = null;
    for (var i = 0; i < specs.length; ++i) {
      var ref = specs[i];
      var className = ref.className;
      var style = ref.style;
      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
      if (style) { gElt.style.cssText = style; }
      if (className == "CodeMirror-linenumbers") {
        display.lineGutter = gElt;
        gElt.style.width = (display.lineNumWidth || 1) + "px";
      }
    }
    gutters.style.display = specs.length ? "" : "none";
    updateGutterSpace(display);
  }

  function updateGutters(cm) {
    renderGutters(cm.display);
    regChange(cm);
    alignHorizontally(cm);
  }

  // The display handles the DOM integration, both for input reading
  // and content drawing. It holds references to DOM nodes and
  // display-related state.

  function Display(place, doc, input, options) {
    var d = this;
    this.input = input;

    // Covers bottom-right square when both scrollbars are present.
    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
    d.scrollbarFiller.setAttribute("cm-not-content", "true");
    // Covers bottom of gutter when coverGutterNextToScrollbar is on
    // and h scrollbar is present.
    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
    d.gutterFiller.setAttribute("cm-not-content", "true");
    // Will contain the actual code, positioned to cover the viewport.
    d.lineDiv = eltP("div", null, "CodeMirror-code");
    // Elements are added to these to represent selection and cursors.
    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
    // A visibility: hidden element used to find the size of things.
    d.measure = elt("div", null, "CodeMirror-measure");
    // When lines outside of the viewport are measured, they are drawn in this.
    d.lineMeasure = elt("div", null, "CodeMirror-measure");
    // Wraps everything that needs to exist inside the vertically-padded coordinate system
    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                      null, "position: relative; outline: none");
    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
    // Moved around its parent to cover visible view.
    d.mover = elt("div", [lines], null, "position: relative");
    // Set to the height of the document, allowing scrolling.
    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
    d.sizerWidth = null;
    // Behavior of elts with overflow: auto and padding is
    // inconsistent across browsers. This is used to ensure the
    // scrollable area is big enough.
    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
    // Will contain the gutters, if any.
    d.gutters = elt("div", null, "CodeMirror-gutters");
    d.lineGutter = null;
    // Actual scrollable element.
    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
    d.scroller.setAttribute("tabIndex", "-1");
    // The element in which the editor lives.
    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

    if (place) {
      if (place.appendChild) { place.appendChild(d.wrapper); }
      else { place(d.wrapper); }
    }

    // Current rendered range (may be bigger than the view window).
    d.viewFrom = d.viewTo = doc.first;
    d.reportedViewFrom = d.reportedViewTo = doc.first;
    // Information about the rendered lines.
    d.view = [];
    d.renderedView = null;
    // Holds info about a single rendered line when it was rendered
    // for measurement, while not in view.
    d.externalMeasured = null;
    // Empty space (in pixels) above the view
    d.viewOffset = 0;
    d.lastWrapHeight = d.lastWrapWidth = 0;
    d.updateLineNumbers = null;

    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
    d.scrollbarsClipped = false;

    // Used to only resize the line number gutter when necessary (when
    // the amount of lines crosses a boundary that makes its width change)
    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
    // Set to true when a non-horizontal-scrolling line widget is
    // added. As an optimization, line widget aligning is skipped when
    // this is false.
    d.alignWidgets = false;

    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

    // Tracks the maximum line length so that the horizontal scrollbar
    // can be kept static when scrolling.
    d.maxLine = null;
    d.maxLineLength = 0;
    d.maxLineChanged = false;

    // Used for measuring wheel scrolling granularity
    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

    // True when shift is held down.
    d.shift = false;

    // Used to track whether anything happened since the context menu
    // was opened.
    d.selForContextMenu = null;

    d.activeTouch = null;

    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
    renderGutters(d);

    input.init(d);
  }

  // Since the delta values reported on mouse wheel events are
  // unstandardized between browsers and even browser versions, and
  // generally horribly unpredictable, this code starts by measuring
  // the scroll effect that the first few mouse wheel events have,
  // and, from that, detects the way it can convert deltas to pixel
  // offsets afterwards.
  //
  // The reason we want to know the amount a wheel event will scroll
  // is that it gives us a chance to update the display before the
  // actual scrolling happens, reducing flickering.

  var wheelSamples = 0, wheelPixelsPerUnit = null;
  // Fill in a browser-detected starting value on browsers where we
  // know one. These don't have to be accurate -- the result of them
  // being wrong would just be a slight flicker on the first wheel
  // scroll (if it is large enough).
  if (ie) { wheelPixelsPerUnit = -.53; }
  else if (gecko) { wheelPixelsPerUnit = 15; }
  else if (chrome) { wheelPixelsPerUnit = -.7; }
  else if (safari) { wheelPixelsPerUnit = -1/3; }

  function wheelEventDelta(e) {
    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
    else if (dy == null) { dy = e.wheelDelta; }
    return {x: dx, y: dy}
  }
  function wheelEventPixels(e) {
    var delta = wheelEventDelta(e);
    delta.x *= wheelPixelsPerUnit;
    delta.y *= wheelPixelsPerUnit;
    return delta
  }

  function onScrollWheel(cm, e) {
    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

    var display = cm.display, scroll = display.scroller;
    // Quit if there's nothing to scroll here
    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
    if (!(dx && canScrollX || dy && canScrollY)) { return }

    // Webkit browsers on OS X abort momentum scrolls when the target
    // of the scroll event is removed from the scrollable element.
    // This hack (see related code in patchDisplay) makes sure the
    // element is kept around.
    if (dy && mac && webkit) {
      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
        for (var i = 0; i < view.length; i++) {
          if (view[i].node == cur) {
            cm.display.currentWheelTarget = cur;
            break outer
          }
        }
      }
    }

    // On some browsers, horizontal scrolling will cause redraws to
    // happen before the gutter has been realigned, causing it to
    // wriggle around in a most unseemly way. When we have an
    // estimated pixels/delta value, we just handle horizontal
    // scrolling entirely here. It'll be slightly off from native, but
    // better than glitching out.
    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
      if (dy && canScrollY)
        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
      // Only prevent default scrolling if vertical scrolling is
      // actually possible. Otherwise, it causes vertical scroll
      // jitter on OSX trackpads when deltaX is small and deltaY
      // is large (issue #3579)
      if (!dy || (dy && canScrollY))
        { e_preventDefault(e); }
      display.wheelStartX = null; // Abort measurement, if in progress
      return
    }

    // 'Project' the visible viewport to cover the area that is being
    // scrolled into view (if we know enough to estimate it).
    if (dy && wheelPixelsPerUnit != null) {
      var pixels = dy * wheelPixelsPerUnit;
      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
      updateDisplaySimple(cm, {top: top, bottom: bot});
    }

    if (wheelSamples < 20) {
      if (display.wheelStartX == null) {
        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
        display.wheelDX = dx; display.wheelDY = dy;
        setTimeout(function () {
          if (display.wheelStartX == null) { return }
          var movedX = scroll.scrollLeft - display.wheelStartX;
          var movedY = scroll.scrollTop - display.wheelStartY;
          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
            (movedX && display.wheelDX && movedX / display.wheelDX);
          display.wheelStartX = display.wheelStartY = null;
          if (!sample) { return }
          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
          ++wheelSamples;
        }, 200);
      } else {
        display.wheelDX += dx; display.wheelDY += dy;
      }
    }
  }

  // Selection objects are immutable. A new one is created every time
  // the selection changes. A selection is one or more non-overlapping
  // (and non-touching) ranges, sorted, and an integer that indicates
  // which one is the primary selection (the one that's scrolled into
  // view, that getCursor returns, etc).
  var Selection = function(ranges, primIndex) {
    this.ranges = ranges;
    this.primIndex = primIndex;
  };

  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

  Selection.prototype.equals = function (other) {
    if (other == this) { return true }
    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
    for (var i = 0; i < this.ranges.length; i++) {
      var here = this.ranges[i], there = other.ranges[i];
      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
    }
    return true
  };

  Selection.prototype.deepCopy = function () {
    var out = [];
    for (var i = 0; i < this.ranges.length; i++)
      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
    return new Selection(out, this.primIndex)
  };

  Selection.prototype.somethingSelected = function () {
    for (var i = 0; i < this.ranges.length; i++)
      { if (!this.ranges[i].empty()) { return true } }
    return false
  };

  Selection.prototype.contains = function (pos, end) {
    if (!end) { end = pos; }
    for (var i = 0; i < this.ranges.length; i++) {
      var range = this.ranges[i];
      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
        { return i }
    }
    return -1
  };

  var Range = function(anchor, head) {
    this.anchor = anchor; this.head = head;
  };

  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

  // Take an unsorted, potentially overlapping set of ranges, and
  // build a selection out of it. 'Consumes' ranges array (modifying
  // it).
  function normalizeSelection(cm, ranges, primIndex) {
    var mayTouch = cm && cm.options.selectionsMayTouch;
    var prim = ranges[primIndex];
    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
    primIndex = indexOf(ranges, prim);
    for (var i = 1; i < ranges.length; i++) {
      var cur = ranges[i], prev = ranges[i - 1];
      var diff = cmp(prev.to(), cur.from());
      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
        if (i <= primIndex) { --primIndex; }
        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
      }
    }
    return new Selection(ranges, primIndex)
  }

  function simpleSelection(anchor, head) {
    return new Selection([new Range(anchor, head || anchor)], 0)
  }

  // Compute the position of the end of a change (its 'to' property
  // refers to the pre-change end).
  function changeEnd(change) {
    if (!change.text) { return change.to }
    return Pos(change.from.line + change.text.length - 1,
               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
  }

  // Adjust a position to refer to the post-change position of the
  // same text, or the end of the change if the change covers it.
  function adjustForChange(pos, change) {
    if (cmp(pos, change.from) < 0) { return pos }
    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
    return Pos(line, ch)
  }

  function computeSelAfterChange(doc, change) {
    var out = [];
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      var range = doc.sel.ranges[i];
      out.push(new Range(adjustForChange(range.anchor, change),
                         adjustForChange(range.head, change)));
    }
    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
  }

  function offsetPos(pos, old, nw) {
    if (pos.line == old.line)
      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
    else
      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
  }

  // Used by replaceSelections to allow moving the selection to the
  // start or around the replaced test. Hint may be "start" or "around".
  function computeReplacedSel(doc, changes, hint) {
    var out = [];
    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var from = offsetPos(change.from, oldPrev, newPrev);
      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
      oldPrev = change.to;
      newPrev = to;
      if (hint == "around") {
        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
        out[i] = new Range(inv ? to : from, inv ? from : to);
      } else {
        out[i] = new Range(from, from);
      }
    }
    return new Selection(out, doc.sel.primIndex)
  }

  // Used to get the editor into a consistent state again when options change.

  function loadMode(cm) {
    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
    resetModeState(cm);
  }

  function resetModeState(cm) {
    cm.doc.iter(function (line) {
      if (line.stateAfter) { line.stateAfter = null; }
      if (line.styles) { line.styles = null; }
    });
    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
    startWorker(cm, 100);
    cm.state.modeGen++;
    if (cm.curOp) { regChange(cm); }
  }

  // DOCUMENT DATA STRUCTURE

  // By default, updates that start and end at the beginning of a line
  // are treated specially, in order to make the association of line
  // widgets and marker elements with the text behave more intuitive.
  function isWholeLineUpdate(doc, change) {
    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
  }

  // Perform a change on the document data structure.
  function updateDoc(doc, change, markedSpans, estimateHeight) {
    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
    function update(line, text, spans) {
      updateLine(line, text, spans, estimateHeight);
      signalLater(line, "change", line, change);
    }
    function linesFor(start, end) {
      var result = [];
      for (var i = start; i < end; ++i)
        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
      return result
    }

    var from = change.from, to = change.to, text = change.text;
    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

    // Adjust the line structure
    if (change.full) {
      doc.insert(0, linesFor(0, text.length));
      doc.remove(text.length, doc.size - text.length);
    } else if (isWholeLineUpdate(doc, change)) {
      // This is a whole-line replace. Treated specially to make
      // sure line objects move the way they are supposed to.
      var added = linesFor(0, text.length - 1);
      update(lastLine, lastLine.text, lastSpans);
      if (nlines) { doc.remove(from.line, nlines); }
      if (added.length) { doc.insert(from.line, added); }
    } else if (firstLine == lastLine) {
      if (text.length == 1) {
        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
      } else {
        var added$1 = linesFor(1, text.length - 1);
        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        doc.insert(from.line + 1, added$1);
      }
    } else if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
      doc.remove(from.line + 1, nlines);
    } else {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
      var added$2 = linesFor(1, text.length - 1);
      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
      doc.insert(from.line + 1, added$2);
    }

    signalLater(doc, "change", doc, change);
  }

  // Call f for all linked documents.
  function linkedDocs(doc, f, sharedHistOnly) {
    function propagate(doc, skip, sharedHist) {
      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
        var rel = doc.linked[i];
        if (rel.doc == skip) { continue }
        var shared = sharedHist && rel.sharedHist;
        if (sharedHistOnly && !shared) { continue }
        f(rel.doc, shared);
        propagate(rel.doc, doc, shared);
      } }
    }
    propagate(doc, null, true);
  }

  // Attach a document to an editor.
  function attachDoc(cm, doc) {
    if (doc.cm) { throw new Error("This document is already in use.") }
    cm.doc = doc;
    doc.cm = cm;
    estimateLineHeights(cm);
    loadMode(cm);
    setDirectionClass(cm);
    if (!cm.options.lineWrapping) { findMaxLine(cm); }
    cm.options.mode = doc.modeOption;
    regChange(cm);
  }

  function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
  }

  function directionChanged(cm) {
    runInOp(cm, function () {
      setDirectionClass(cm);
      regChange(cm);
    });
  }

  function History(startGen) {
    // Arrays of change events and selections. Doing something adds an
    // event to done and clears undo. Undoing moves events from done
    // to undone, redoing moves them in the other direction.
    this.done = []; this.undone = [];
    this.undoDepth = Infinity;
    // Used to track when changes can be merged into a single undo
    // event
    this.lastModTime = this.lastSelTime = 0;
    this.lastOp = this.lastSelOp = null;
    this.lastOrigin = this.lastSelOrigin = null;
    // Used by the isClean() method
    this.generation = this.maxGeneration = startGen || 1;
  }

  // Create a history change event from an updateDoc-style change
  // object.
  function historyChangeFromChange(doc, change) {
    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
    return histChange
  }

  // Pop all selection events off the end of a history array. Stop at
  // a change event.
  function clearSelectionEvents(array) {
    while (array.length) {
      var last = lst(array);
      if (last.ranges) { array.pop(); }
      else { break }
    }
  }

  // Find the top change event in the history. Pop off selection
  // events that are in the way.
  function lastChangeEvent(hist, force) {
    if (force) {
      clearSelectionEvents(hist.done);
      return lst(hist.done)
    } else if (hist.done.length && !lst(hist.done).ranges) {
      return lst(hist.done)
    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
      hist.done.pop();
      return lst(hist.done)
    }
  }

  // Register a change in the history. Merges changes that are within
  // a single operation, or are close together with an origin that
  // allows merging (starting with "+") into a single event.
  function addChangeToHistory(doc, change, selAfter, opId) {
    var hist = doc.history;
    hist.undone.length = 0;
    var time = +new Date, cur;
    var last;

    if ((hist.lastOp == opId ||
         hist.lastOrigin == change.origin && change.origin &&
         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
          change.origin.charAt(0) == "*")) &&
        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
      // Merge this change into the last event
      last = lst(cur.changes);
      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
        // Optimized case for simple insertion -- don't want to add
        // new changesets for every character typed
        last.to = changeEnd(change);
      } else {
        // Add new sub-event
        cur.changes.push(historyChangeFromChange(doc, change));
      }
    } else {
      // Can not be merged, start a new event.
      var before = lst(hist.done);
      if (!before || !before.ranges)
        { pushSelectionToHistory(doc.sel, hist.done); }
      cur = {changes: [historyChangeFromChange(doc, change)],
             generation: hist.generation};
      hist.done.push(cur);
      while (hist.done.length > hist.undoDepth) {
        hist.done.shift();
        if (!hist.done[0].ranges) { hist.done.shift(); }
      }
    }
    hist.done.push(selAfter);
    hist.generation = ++hist.maxGeneration;
    hist.lastModTime = hist.lastSelTime = time;
    hist.lastOp = hist.lastSelOp = opId;
    hist.lastOrigin = hist.lastSelOrigin = change.origin;

    if (!last) { signal(doc, "historyAdded"); }
  }

  function selectionEventCanBeMerged(doc, origin, prev, sel) {
    var ch = origin.charAt(0);
    return ch == "*" ||
      ch == "+" &&
      prev.ranges.length == sel.ranges.length &&
      prev.somethingSelected() == sel.somethingSelected() &&
      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
  }

  // Called whenever the selection changes, sets the new selection as
  // the pending selection in the history, and pushes the old pending
  // selection into the 'done' array when it was significantly
  // different (in number of selected ranges, emptiness, or time).
  function addSelectionToHistory(doc, sel, opId, options) {
    var hist = doc.history, origin = options && options.origin;

    // A new event is started when the previous origin does not match
    // the current, or the origins don't allow matching. Origins
    // starting with * are always merged, those starting with + are
    // merged when similar and close together in time.
    if (opId == hist.lastSelOp ||
        (origin && hist.lastSelOrigin == origin &&
         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
      { hist.done[hist.done.length - 1] = sel; }
    else
      { pushSelectionToHistory(sel, hist.done); }

    hist.lastSelTime = +new Date;
    hist.lastSelOrigin = origin;
    hist.lastSelOp = opId;
    if (options && options.clearRedo !== false)
      { clearSelectionEvents(hist.undone); }
  }

  function pushSelectionToHistory(sel, dest) {
    var top = lst(dest);
    if (!(top && top.ranges && top.equals(sel)))
      { dest.push(sel); }
  }

  // Used to store marked span information in the history.
  function attachLocalSpans(doc, change, from, to) {
    var existing = change["spans_" + doc.id], n = 0;
    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
      if (line.markedSpans)
        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
      ++n;
    });
  }

  // When un/re-doing restores text containing marked spans, those
  // that have been explicitly cleared should not be restored.
  function removeClearedSpans(spans) {
    if (!spans) { return null }
    var out;
    for (var i = 0; i < spans.length; ++i) {
      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
      else if (out) { out.push(spans[i]); }
    }
    return !out ? spans : out.length ? out : null
  }

  // Retrieve and filter the old marked spans stored in a change event.
  function getOldSpans(doc, change) {
    var found = change["spans_" + doc.id];
    if (!found) { return null }
    var nw = [];
    for (var i = 0; i < change.text.length; ++i)
      { nw.push(removeClearedSpans(found[i])); }
    return nw
  }

  // Used for un/re-doing changes from the history. Combines the
  // result of computing the existing spans with the set of spans that
  // existed in the history (so that deleting around a span and then
  // undoing brings back the span).
  function mergeOldSpans(doc, change) {
    var old = getOldSpans(doc, change);
    var stretched = stretchSpansOverChange(doc, change);
    if (!old) { return stretched }
    if (!stretched) { return old }

    for (var i = 0; i < old.length; ++i) {
      var oldCur = old[i], stretchCur = stretched[i];
      if (oldCur && stretchCur) {
        spans: for (var j = 0; j < stretchCur.length; ++j) {
          var span = stretchCur[j];
          for (var k = 0; k < oldCur.length; ++k)
            { if (oldCur[k].marker == span.marker) { continue spans } }
          oldCur.push(span);
        }
      } else if (stretchCur) {
        old[i] = stretchCur;
      }
    }
    return old
  }

  // Used both to provide a JSON-safe object in .getHistory, and, when
  // detaching a document, to split the history in two
  function copyHistoryArray(events, newGroup, instantiateSel) {
    var copy = [];
    for (var i = 0; i < events.length; ++i) {
      var event = events[i];
      if (event.ranges) {
        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
        continue
      }
      var changes = event.changes, newChanges = [];
      copy.push({changes: newChanges});
      for (var j = 0; j < changes.length; ++j) {
        var change = changes[j], m = (void 0);
        newChanges.push({from: change.from, to: change.to, text: change.text});
        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
          if (indexOf(newGroup, Number(m[1])) > -1) {
            lst(newChanges)[prop] = change[prop];
            delete change[prop];
          }
        } } }
      }
    }
    return copy
  }

  // The 'scroll' parameter given to many of these indicated whether
  // the new cursor position should be scrolled into view after
  // modifying the selection.

  // If shift is held or the extend flag is set, extends a range to
  // include a given position (and optionally a second position).
  // Otherwise, simply returns the range between the given positions.
  // Used for cursor motion and such.
  function extendRange(range, head, other, extend) {
    if (extend) {
      var anchor = range.anchor;
      if (other) {
        var posBefore = cmp(head, anchor) < 0;
        if (posBefore != (cmp(other, anchor) < 0)) {
          anchor = head;
          head = other;
        } else if (posBefore != (cmp(head, other) < 0)) {
          head = other;
        }
      }
      return new Range(anchor, head)
    } else {
      return new Range(other || head, head)
    }
  }

  // Extend the primary selection range, discard the rest.
  function extendSelection(doc, head, other, options, extend) {
    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
  }

  // Extend all selections (pos is an array of selections with length
  // equal the number of selections)
  function extendSelections(doc, heads, options) {
    var out = [];
    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
    for (var i = 0; i < doc.sel.ranges.length; i++)
      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
    setSelection(doc, newSel, options);
  }

  // Updates a single range in the selection.
  function replaceOneSelection(doc, i, range, options) {
    var ranges = doc.sel.ranges.slice(0);
    ranges[i] = range;
    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
  }

  // Reset the selection to a single range.
  function setSimpleSelection(doc, anchor, head, options) {
    setSelection(doc, simpleSelection(anchor, head), options);
  }

  // Give beforeSelectionChange handlers a change to influence a
  // selection update.
  function filterSelectionChange(doc, sel, options) {
    var obj = {
      ranges: sel.ranges,
      update: function(ranges) {
        this.ranges = [];
        for (var i = 0; i < ranges.length; i++)
          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                     clipPos(doc, ranges[i].head)); }
      },
      origin: options && options.origin
    };
    signal(doc, "beforeSelectionChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
    else { return sel }
  }

  function setSelectionReplaceHistory(doc, sel, options) {
    var done = doc.history.done, last = lst(done);
    if (last && last.ranges) {
      done[done.length - 1] = sel;
      setSelectionNoUndo(doc, sel, options);
    } else {
      setSelection(doc, sel, options);
    }
  }

  // Set a new selection.
  function setSelection(doc, sel, options) {
    setSelectionNoUndo(doc, sel, options);
    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
  }

  function setSelectionNoUndo(doc, sel, options) {
    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
      { sel = filterSelectionChange(doc, sel, options); }

    var bias = options && options.bias ||
      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

    if (!(options && options.scroll === false) && doc.cm)
      { ensureCursorVisible(doc.cm); }
  }

  function setSelectionInner(doc, sel) {
    if (sel.equals(doc.sel)) { return }

    doc.sel = sel;

    if (doc.cm) {
      doc.cm.curOp.updateInput = 1;
      doc.cm.curOp.selectionChanged = true;
      signalCursorActivity(doc.cm);
    }
    signalLater(doc, "cursorActivity", doc);
  }

  // Verify that the selection does not partially select any atomic
  // marked ranges.
  function reCheckSelection(doc) {
    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
  }

  // Return a selection that does not partially select any atomic
  // ranges.
  function skipAtomicInSelection(doc, sel, bias, mayClear) {
    var out;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range = sel.ranges[i];
      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
      if (out || newAnchor != range.anchor || newHead != range.head) {
        if (!out) { out = sel.ranges.slice(0, i); }
        out[i] = new Range(newAnchor, newHead);
      }
    }
    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
  }

  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
    var line = getLine(doc, pos.line);
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var sp = line.markedSpans[i], m = sp.marker;

      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
      // is with selectLeft/Right
      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;

      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
        if (mayClear) {
          signal(m, "beforeCursorEnter");
          if (m.explicitlyCleared) {
            if (!line.markedSpans) { break }
            else {--i; continue}
          }
        }
        if (!m.atomic) { continue }

        if (oldPos) {
          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
          if (dir < 0 ? preventCursorRight : preventCursorLeft)
            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
        }

        var far = m.find(dir < 0 ? -1 : 1);
        if (dir < 0 ? preventCursorLeft : preventCursorRight)
          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
      }
    } }
    return pos
  }

  // Ensure a given position is not inside an atomic range.
  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
    var dir = bias || 1;
    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
    if (!found) {
      doc.cantEdit = true;
      return Pos(doc.first, 0)
    }
    return found
  }

  function movePos(doc, pos, dir, line) {
    if (dir < 0 && pos.ch == 0) {
      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
      else { return null }
    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
      else { return null }
    } else {
      return new Pos(pos.line, pos.ch + dir)
    }
  }

  function selectAll(cm) {
    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
  }

  // UPDATING

  // Allow "beforeChange" event handlers to influence a change
  function filterChange(doc, change, update) {
    var obj = {
      canceled: false,
      from: change.from,
      to: change.to,
      text: change.text,
      origin: change.origin,
      cancel: function () { return obj.canceled = true; }
    };
    if (update) { obj.update = function (from, to, text, origin) {
      if (from) { obj.from = clipPos(doc, from); }
      if (to) { obj.to = clipPos(doc, to); }
      if (text) { obj.text = text; }
      if (origin !== undefined) { obj.origin = origin; }
    }; }
    signal(doc, "beforeChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

    if (obj.canceled) {
      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
      return null
    }
    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
  }

  // Apply a change to a document, and add it to the document's
  // history, and propagating it to all linked documents.
  function makeChange(doc, change, ignoreReadOnly) {
    if (doc.cm) {
      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
      if (doc.cm.state.suppressEdits) { return }
    }

    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
      change = filterChange(doc, change, true);
      if (!change) { return }
    }

    // Possibly split or suppress the update based on the presence
    // of read-only spans in its range.
    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
    if (split) {
      for (var i = split.length - 1; i >= 0; --i)
        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
    } else {
      makeChangeInner(doc, change);
    }
  }

  function makeChangeInner(doc, change) {
    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
    var selAfter = computeSelAfterChange(doc, change);
    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
    var rebased = [];

    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
    });
  }

  // Revert a change stored in a document's history.
  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
    var suppress = doc.cm && doc.cm.state.suppressEdits;
    if (suppress && !allowSelectionOnly) { return }

    var hist = doc.history, event, selAfter = doc.sel;
    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

    // Verify that there is a useable event (so that ctrl-z won't
    // needlessly clear selection events)
    var i = 0;
    for (; i < source.length; i++) {
      event = source[i];
      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
        { break }
    }
    if (i == source.length) { return }
    hist.lastOrigin = hist.lastSelOrigin = null;

    for (;;) {
      event = source.pop();
      if (event.ranges) {
        pushSelectionToHistory(event, dest);
        if (allowSelectionOnly && !event.equals(doc.sel)) {
          setSelection(doc, event, {clearRedo: false});
          return
        }
        selAfter = event;
      } else if (suppress) {
        source.push(event);
        return
      } else { break }
    }

    // Build up a reverse change object to add to the opposite history
    // stack (redo when undoing, and vice versa).
    var antiChanges = [];
    pushSelectionToHistory(selAfter, dest);
    dest.push({changes: antiChanges, generation: hist.generation});
    hist.generation = event.generation || ++hist.maxGeneration;

    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

    var loop = function ( i ) {
      var change = event.changes[i];
      change.origin = type;
      if (filter && !filterChange(doc, change, false)) {
        source.length = 0;
        return {}
      }

      antiChanges.push(historyChangeFromChange(doc, change));

      var after = i ? computeSelAfterChange(doc, change) : lst(source);
      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
      var rebased = [];

      // Propagate to the linked documents
      linkedDocs(doc, function (doc, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
          rebaseHist(doc.history, change);
          rebased.push(doc.history);
        }
        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
      });
    };

    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
      var returned = loop( i$1 );

      if ( returned ) return returned.v;
    }
  }

  // Sub-views need their line numbers shifted when text is added
  // above or below them in the parent document.
  function shiftDoc(doc, distance) {
    if (distance == 0) { return }
    doc.first += distance;
    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
      Pos(range.anchor.line + distance, range.anchor.ch),
      Pos(range.head.line + distance, range.head.ch)
    ); }), doc.sel.primIndex);
    if (doc.cm) {
      regChange(doc.cm, doc.first, doc.first - distance, distance);
      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
        { regLineChange(doc.cm, l, "gutter"); }
    }
  }

  // More lower-level change function, handling only a single document
  // (not linked ones).
  function makeChangeSingleDoc(doc, change, selAfter, spans) {
    if (doc.cm && !doc.cm.curOp)
      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

    if (change.to.line < doc.first) {
      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
      return
    }
    if (change.from.line > doc.lastLine()) { return }

    // Clip the change to the size of this doc
    if (change.from.line < doc.first) {
      var shift = change.text.length - 1 - (doc.first - change.from.line);
      shiftDoc(doc, shift);
      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
                text: [lst(change.text)], origin: change.origin};
    }
    var last = doc.lastLine();
    if (change.to.line > last) {
      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
                text: [change.text[0]], origin: change.origin};
    }

    change.removed = getBetween(doc, change.from, change.to);

    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
    else { updateDoc(doc, change, spans); }
    setSelectionNoUndo(doc, selAfter, sel_dontScroll);

    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
      { doc.cantEdit = false; }
  }

  // Handle the interaction of a change to a document with the editor
  // that this document is part of.
  function makeChangeSingleDocInEditor(cm, change, spans) {
    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

    var recomputeMaxLength = false, checkWidthStart = from.line;
    if (!cm.options.lineWrapping) {
      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
      doc.iter(checkWidthStart, to.line + 1, function (line) {
        if (line == display.maxLine) {
          recomputeMaxLength = true;
          return true
        }
      });
    }

    if (doc.sel.contains(change.from, change.to) > -1)
      { signalCursorActivity(cm); }

    updateDoc(doc, change, spans, estimateHeight(cm));

    if (!cm.options.lineWrapping) {
      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
        var len = lineLength(line);
        if (len > display.maxLineLength) {
          display.maxLine = line;
          display.maxLineLength = len;
          display.maxLineChanged = true;
          recomputeMaxLength = false;
        }
      });
      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
    }

    retreatFrontier(doc, from.line);
    startWorker(cm, 400);

    var lendiff = change.text.length - (to.line - from.line) - 1;
    // Remember that these lines changed, for updating the display
    if (change.full)
      { regChange(cm); }
    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
      { regLineChange(cm, from.line, "text"); }
    else
      { regChange(cm, from.line, to.line + 1, lendiff); }

    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
    if (changeHandler || changesHandler) {
      var obj = {
        from: from, to: to,
        text: change.text,
        removed: change.removed,
        origin: change.origin
      };
      if (changeHandler) { signalLater(cm, "change", cm, obj); }
      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
    }
    cm.display.selForContextMenu = null;
  }

  function replaceRange(doc, code, from, to, origin) {
    var assign;

    if (!to) { to = from; }
    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
    if (typeof code == "string") { code = doc.splitLines(code); }
    makeChange(doc, {from: from, to: to, text: code, origin: origin});
  }

  // Rebasing/resetting history to deal with externally-sourced changes

  function rebaseHistSelSingle(pos, from, to, diff) {
    if (to < pos.line) {
      pos.line += diff;
    } else if (from < pos.line) {
      pos.line = from;
      pos.ch = 0;
    }
  }

  // Tries to rebase an array of history events given a change in the
  // document. If the change touches the same lines as the event, the
  // event, and everything 'behind' it, is discarded. If the change is
  // before the event, the event's positions are updated. Uses a
  // copy-on-write scheme for the positions, to avoid having to
  // reallocate them all on every rebase, but also avoid problems with
  // shared position objects being unsafely updated.
  function rebaseHistArray(array, from, to, diff) {
    for (var i = 0; i < array.length; ++i) {
      var sub = array[i], ok = true;
      if (sub.ranges) {
        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
        for (var j = 0; j < sub.ranges.length; j++) {
          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
        }
        continue
      }
      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
        var cur = sub.changes[j$1];
        if (to < cur.from.line) {
          cur.from = Pos(cur.from.line + diff, cur.from.ch);
          cur.to = Pos(cur.to.line + diff, cur.to.ch);
        } else if (from <= cur.to.line) {
          ok = false;
          break
        }
      }
      if (!ok) {
        array.splice(0, i + 1);
        i = 0;
      }
    }
  }

  function rebaseHist(hist, change) {
    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
    rebaseHistArray(hist.done, from, to, diff);
    rebaseHistArray(hist.undone, from, to, diff);
  }

  // Utility for applying a change to a line by handle or number,
  // returning the number and optionally registering the line as
  // changed.
  function changeLine(doc, handle, changeType, op) {
    var no = handle, line = handle;
    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
    else { no = lineNo(handle); }
    if (no == null) { return null }
    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
    return line
  }

  // The document is represented as a BTree consisting of leaves, with
  // chunk of lines in them, and branches, with up to ten leaves or
  // other branch nodes below them. The top node is always a branch
  // node, and is the document object itself (meaning it has
  // additional methods and properties).
  //
  // All nodes have parent links. The tree is used both to go from
  // line numbers to line objects, and to go from objects to numbers.
  // It also indexes by height, and is used to convert between height
  // and line object, and to find the total height of the document.
  //
  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

  function LeafChunk(lines) {
    this.lines = lines;
    this.parent = null;
    var height = 0;
    for (var i = 0; i < lines.length; ++i) {
      lines[i].parent = this;
      height += lines[i].height;
    }
    this.height = height;
  }

  LeafChunk.prototype = {
    chunkSize: function() { return this.lines.length },

    // Remove the n lines at offset 'at'.
    removeInner: function(at, n) {
      for (var i = at, e = at + n; i < e; ++i) {
        var line = this.lines[i];
        this.height -= line.height;
        cleanUpLine(line);
        signalLater(line, "delete");
      }
      this.lines.splice(at, n);
    },

    // Helper used to collapse a small branch into a single leaf.
    collapse: function(lines) {
      lines.push.apply(lines, this.lines);
    },

    // Insert the given array of lines at offset 'at', count them as
    // having the given height.
    insertInner: function(at, lines, height) {
      this.height += height;
      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
    },

    // Used to iterate over a part of the tree.
    iterN: function(at, n, op) {
      for (var e = at + n; at < e; ++at)
        { if (op(this.lines[at])) { return true } }
    }
  };

  function BranchChunk(children) {
    this.children = children;
    var size = 0, height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.chunkSize(); height += ch.height;
      ch.parent = this;
    }
    this.size = size;
    this.height = height;
    this.parent = null;
  }

  BranchChunk.prototype = {
    chunkSize: function() { return this.size },

    removeInner: function(at, n) {
      this.size -= n;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at), oldHeight = child.height;
          child.removeInner(at, rm);
          this.height -= oldHeight - child.height;
          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
          if ((n -= rm) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
      // If the result is smaller than 25 lines, ensure that it is a
      // single leaf node.
      if (this.size - n < 25 &&
          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
        var lines = [];
        this.collapse(lines);
        this.children = [new LeafChunk(lines)];
        this.children[0].parent = this;
      }
    },

    collapse: function(lines) {
      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
    },

    insertInner: function(at, lines, height) {
      this.size += lines.length;
      this.height += height;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at <= sz) {
          child.insertInner(at, lines, height);
          if (child.lines && child.lines.length > 50) {
            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.lines.length % 25 + 25;
            for (var pos = remaining; pos < child.lines.length;) {
              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
              child.height -= leaf.height;
              this.children.splice(++i, 0, leaf);
              leaf.parent = this;
            }
            child.lines = child.lines.slice(0, remaining);
            this.maybeSpill();
          }
          break
        }
        at -= sz;
      }
    },

    // When a node has grown, check whether it should be split.
    maybeSpill: function() {
      if (this.children.length <= 10) { return }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BranchChunk(spilled);
        if (!me.parent) { // Become the parent node
          var copy = new BranchChunk(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
       } else {
          me.size -= sibling.size;
          me.height -= sibling.height;
          var myIndex = indexOf(me.parent.children, me);
          me.parent.children.splice(myIndex + 1, 0, sibling);
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10)
      me.parent.maybeSpill();
    },

    iterN: function(at, n, op) {
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.iterN(at, used, op)) { return true }
          if ((n -= used) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
    }
  };

  // Line widgets are block elements displayed above or below a line.

  var LineWidget = function(doc, node, options) {
    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
      { this[opt] = options[opt]; } } }
    this.doc = doc;
    this.node = node;
  };

  LineWidget.prototype.clear = function () {
    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
    if (no == null || !ws) { return }
    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
    if (!ws.length) { line.widgets = null; }
    var height = widgetHeight(this);
    updateLineHeight(line, Math.max(0, line.height - height));
    if (cm) {
      runInOp(cm, function () {
        adjustScrollWhenAboveVisible(cm, line, -height);
        regLineChange(cm, no, "widget");
      });
      signalLater(cm, "lineWidgetCleared", cm, this, no);
    }
  };

  LineWidget.prototype.changed = function () {
      var this$1 = this;

    var oldH = this.height, cm = this.doc.cm, line = this.line;
    this.height = null;
    var diff = widgetHeight(this) - oldH;
    if (!diff) { return }
    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
    if (cm) {
      runInOp(cm, function () {
        cm.curOp.forceUpdate = true;
        adjustScrollWhenAboveVisible(cm, line, diff);
        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
      });
    }
  };
  eventMixin(LineWidget);

  function adjustScrollWhenAboveVisible(cm, line, diff) {
    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
      { addToScrollTop(cm, diff); }
  }

  function addLineWidget(doc, handle, node, options) {
    var widget = new LineWidget(doc, node, options);
    var cm = doc.cm;
    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
    changeLine(doc, handle, "widget", function (line) {
      var widgets = line.widgets || (line.widgets = []);
      if (widget.insertAt == null) { widgets.push(widget); }
      else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
      widget.line = line;
      if (cm && !lineIsHidden(doc, line)) {
        var aboveVisible = heightAtLine(line) < doc.scrollTop;
        updateLineHeight(line, line.height + widgetHeight(widget));
        if (aboveVisible) { addToScrollTop(cm, widget.height); }
        cm.curOp.forceUpdate = true;
      }
      return true
    });
    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
    return widget
  }

  // TEXTMARKERS

  // Created with markText and setBookmark methods. A TextMarker is a
  // handle that can be used to clear or find a marked position in the
  // document. Line objects hold arrays (markedSpans) containing
  // {from, to, marker} object pointing to such marker objects, and
  // indicating that such a marker is present on that line. Multiple
  // lines may point to the same marker when it spans across lines.
  // The spans will have null for their from/to properties when the
  // marker continues beyond the start/end of the line. Markers have
  // links back to the lines they currently touch.

  // Collapsed markers have unique ids, in order to be able to order
  // them, which is needed for uniquely determining an outer marker
  // when they overlap (they may nest, but not partially overlap).
  var nextMarkerId = 0;

  var TextMarker = function(doc, type) {
    this.lines = [];
    this.type = type;
    this.doc = doc;
    this.id = ++nextMarkerId;
  };

  // Clear the marker.
  TextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    var cm = this.doc.cm, withOp = cm && !cm.curOp;
    if (withOp) { startOperation(cm); }
    if (hasHandler(this, "clear")) {
      var found = this.find();
      if (found) { signalLater(this, "clear", found.from, found.to); }
    }
    var min = null, max = null;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
      else if (cm) {
        if (span.to != null) { max = lineNo(line); }
        if (span.from != null) { min = lineNo(line); }
      }
      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
        { updateLineHeight(line, textHeight(cm.display)); }
    }
    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
      if (len > cm.display.maxLineLength) {
        cm.display.maxLine = visual;
        cm.display.maxLineLength = len;
        cm.display.maxLineChanged = true;
      }
    } }

    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
    this.lines.length = 0;
    this.explicitlyCleared = true;
    if (this.atomic && this.doc.cantEdit) {
      this.doc.cantEdit = false;
      if (cm) { reCheckSelection(cm.doc); }
    }
    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
    if (withOp) { endOperation(cm); }
    if (this.parent) { this.parent.clear(); }
  };

  // Find the position of the marker in the document. Returns a {from,
  // to} object by default. Side can be passed to get a specific side
  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
  // Pos objects returned contain a line object, rather than a line
  // number (used to prevent looking up the same line twice).
  TextMarker.prototype.find = function (side, lineObj) {
    if (side == null && this.type == "bookmark") { side = 1; }
    var from, to;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (span.from != null) {
        from = Pos(lineObj ? line : lineNo(line), span.from);
        if (side == -1) { return from }
      }
      if (span.to != null) {
        to = Pos(lineObj ? line : lineNo(line), span.to);
        if (side == 1) { return to }
      }
    }
    return from && {from: from, to: to}
  };

  // Signals that the marker's widget changed, and surrounding layout
  // should be recomputed.
  TextMarker.prototype.changed = function () {
      var this$1 = this;

    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
    if (!pos || !cm) { return }
    runInOp(cm, function () {
      var line = pos.line, lineN = lineNo(pos.line);
      var view = findViewForLine(cm, lineN);
      if (view) {
        clearLineMeasurementCacheFor(view);
        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
      }
      cm.curOp.updateMaxLine = true;
      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
        var oldHeight = widget.height;
        widget.height = null;
        var dHeight = widgetHeight(widget) - oldHeight;
        if (dHeight)
          { updateLineHeight(line, line.height + dHeight); }
      }
      signalLater(cm, "markerChanged", cm, this$1);
    });
  };

  TextMarker.prototype.attachLine = function (line) {
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp;
      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
    }
    this.lines.push(line);
  };

  TextMarker.prototype.detachLine = function (line) {
    this.lines.splice(indexOf(this.lines, line), 1);
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp
      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
    }
  };
  eventMixin(TextMarker);

  // Create a marker, wire it up to the right lines, and
  function markText(doc, from, to, options, type) {
    // Shared markers (across linked documents) are handled separately
    // (markTextShared will call out to this again, once per
    // document).
    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
    // Ensure we are in an operation.
    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

    var marker = new TextMarker(doc, type), diff = cmp(from, to);
    if (options) { copyObj(options, marker, false); }
    // Don't connect empty markers unless clearWhenEmpty is false
    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
      { return marker }
    if (marker.replacedWith) {
      // Showing up as a widget implies collapsed (widget replaces text)
      marker.collapsed = true;
      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
    }
    if (marker.collapsed) {
      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
      seeCollapsedSpans();
    }

    if (marker.addToHistory)
      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

    var curLine = from.line, cm = doc.cm, updateMaxLine;
    doc.iter(curLine, to.line + 1, function (line) {
      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
        { updateMaxLine = true; }
      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
      addMarkedSpan(line, new MarkedSpan(marker,
                                         curLine == from.line ? from.ch : null,
                                         curLine == to.line ? to.ch : null));
      ++curLine;
    });
    // lineIsHidden depends on the presence of the spans, so needs a second pass
    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
    }); }

    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

    if (marker.readOnly) {
      seeReadOnlySpans();
      if (doc.history.done.length || doc.history.undone.length)
        { doc.clearHistory(); }
    }
    if (marker.collapsed) {
      marker.id = ++nextMarkerId;
      marker.atomic = true;
    }
    if (cm) {
      // Sync editor state
      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
      if (marker.collapsed)
        { regChange(cm, from.line, to.line + 1); }
      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
               marker.attributes || marker.title)
        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
      if (marker.atomic) { reCheckSelection(cm.doc); }
      signalLater(cm, "markerAdded", cm, marker);
    }
    return marker
  }

  // SHARED TEXTMARKERS

  // A shared marker spans multiple linked documents. It is
  // implemented as a meta-marker-object controlling multiple normal
  // markers.
  var SharedTextMarker = function(markers, primary) {
    this.markers = markers;
    this.primary = primary;
    for (var i = 0; i < markers.length; ++i)
      { markers[i].parent = this; }
  };

  SharedTextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    this.explicitlyCleared = true;
    for (var i = 0; i < this.markers.length; ++i)
      { this.markers[i].clear(); }
    signalLater(this, "clear");
  };

  SharedTextMarker.prototype.find = function (side, lineObj) {
    return this.primary.find(side, lineObj)
  };
  eventMixin(SharedTextMarker);

  function markTextShared(doc, from, to, options, type) {
    options = copyObj(options);
    options.shared = false;
    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
    var widget = options.widgetNode;
    linkedDocs(doc, function (doc) {
      if (widget) { options.widgetNode = widget.cloneNode(true); }
      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
      for (var i = 0; i < doc.linked.length; ++i)
        { if (doc.linked[i].isParent) { return } }
      primary = lst(markers);
    });
    return new SharedTextMarker(markers, primary)
  }

  function findSharedMarkers(doc) {
    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
  }

  function copySharedMarkers(doc, markers) {
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i], pos = marker.find();
      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
      if (cmp(mFrom, mTo)) {
        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
        marker.markers.push(subMark);
        subMark.parent = marker;
      }
    }
  }

  function detachSharedMarkers(markers) {
    var loop = function ( i ) {
      var marker = markers[i], linked = [marker.primary.doc];
      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
      for (var j = 0; j < marker.markers.length; j++) {
        var subMarker = marker.markers[j];
        if (indexOf(linked, subMarker.doc) == -1) {
          subMarker.parent = null;
          marker.markers.splice(j--, 1);
        }
      }
    };

    for (var i = 0; i < markers.length; i++) loop( i );
  }

  var nextDocId = 0;
  var Doc = function(text, mode, firstLine, lineSep, direction) {
    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
    if (firstLine == null) { firstLine = 0; }

    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
    this.first = firstLine;
    this.scrollTop = this.scrollLeft = 0;
    this.cantEdit = false;
    this.cleanGeneration = 1;
    this.modeFrontier = this.highlightFrontier = firstLine;
    var start = Pos(firstLine, 0);
    this.sel = simpleSelection(start);
    this.history = new History(null);
    this.id = ++nextDocId;
    this.modeOption = mode;
    this.lineSep = lineSep;
    this.direction = (direction == "rtl") ? "rtl" : "ltr";
    this.extend = false;

    if (typeof text == "string") { text = this.splitLines(text); }
    updateDoc(this, {from: start, to: start, text: text});
    setSelection(this, simpleSelection(start), sel_dontScroll);
  };

  Doc.prototype = createObj(BranchChunk.prototype, {
    constructor: Doc,
    // Iterate over the document. Supports two forms -- with only one
    // argument, it calls that for each line in the document. With
    // three, it iterates over the range given by the first two (with
    // the second being non-inclusive).
    iter: function(from, to, op) {
      if (op) { this.iterN(from - this.first, to - from, op); }
      else { this.iterN(this.first, this.first + this.size, from); }
    },

    // Non-public interface for adding and removing lines.
    insert: function(at, lines) {
      var height = 0;
      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
      this.insertInner(at - this.first, lines, height);
    },
    remove: function(at, n) { this.removeInner(at - this.first, n); },

    // From here, the methods are part of the public interface. Most
    // are also available from CodeMirror (editor) instances.

    getValue: function(lineSep) {
      var lines = getLines(this, this.first, this.first + this.size);
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },
    setValue: docMethodOp(function(code) {
      var top = Pos(this.first, 0), last = this.first + this.size - 1;
      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                        text: this.splitLines(code), origin: "setValue", full: true}, true);
      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
      setSelection(this, simpleSelection(top), sel_dontScroll);
    }),
    replaceRange: function(code, from, to, origin) {
      from = clipPos(this, from);
      to = to ? clipPos(this, to) : from;
      replaceRange(this, code, from, to, origin);
    },
    getRange: function(from, to, lineSep) {
      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },

    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
    getLineNumber: function(line) {return lineNo(line)},

    getLineHandleVisualStart: function(line) {
      if (typeof line == "number") { line = getLine(this, line); }
      return visualLine(line)
    },

    lineCount: function() {return this.size},
    firstLine: function() {return this.first},
    lastLine: function() {return this.first + this.size - 1},

    clipPos: function(pos) {return clipPos(this, pos)},

    getCursor: function(start) {
      var range = this.sel.primary(), pos;
      if (start == null || start == "head") { pos = range.head; }
      else if (start == "anchor") { pos = range.anchor; }
      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
      else { pos = range.from(); }
      return pos
    },
    listSelections: function() { return this.sel.ranges },
    somethingSelected: function() {return this.sel.somethingSelected()},

    setCursor: docMethodOp(function(line, ch, options) {
      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
    }),
    setSelection: docMethodOp(function(anchor, head, options) {
      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
    }),
    extendSelection: docMethodOp(function(head, other, options) {
      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
    }),
    extendSelections: docMethodOp(function(heads, options) {
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    extendSelectionsBy: docMethodOp(function(f, options) {
      var heads = map(this.sel.ranges, f);
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    setSelections: docMethodOp(function(ranges, primary, options) {
      if (!ranges.length) { return }
      var out = [];
      for (var i = 0; i < ranges.length; i++)
        { out[i] = new Range(clipPos(this, ranges[i].anchor),
                           clipPos(this, ranges[i].head)); }
      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
      setSelection(this, normalizeSelection(this.cm, out, primary), options);
    }),
    addSelection: docMethodOp(function(anchor, head, options) {
      var ranges = this.sel.ranges.slice(0);
      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
    }),

    getSelection: function(lineSep) {
      var ranges = this.sel.ranges, lines;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        lines = lines ? lines.concat(sel) : sel;
      }
      if (lineSep === false) { return lines }
      else { return lines.join(lineSep || this.lineSeparator()) }
    },
    getSelections: function(lineSep) {
      var parts = [], ranges = this.sel.ranges;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
        parts[i] = sel;
      }
      return parts
    },
    replaceSelection: function(code, collapse, origin) {
      var dup = [];
      for (var i = 0; i < this.sel.ranges.length; i++)
        { dup[i] = code; }
      this.replaceSelections(dup, collapse, origin || "+input");
    },
    replaceSelections: docMethodOp(function(code, collapse, origin) {
      var changes = [], sel = this.sel;
      for (var i = 0; i < sel.ranges.length; i++) {
        var range = sel.ranges[i];
        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
      }
      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
        { makeChange(this, changes[i$1]); }
      if (newSel) { setSelectionReplaceHistory(this, newSel); }
      else if (this.cm) { ensureCursorVisible(this.cm); }
    }),
    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

    setExtending: function(val) {this.extend = val;},
    getExtending: function() {return this.extend},

    historySize: function() {
      var hist = this.history, done = 0, undone = 0;
      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
      return {undo: done, redo: undone}
    },
    clearHistory: function() {
      var this$1 = this;

      this.history = new History(this.history.maxGeneration);
      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
    },

    markClean: function() {
      this.cleanGeneration = this.changeGeneration(true);
    },
    changeGeneration: function(forceSplit) {
      if (forceSplit)
        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
      return this.history.generation
    },
    isClean: function (gen) {
      return this.history.generation == (gen || this.cleanGeneration)
    },

    getHistory: function() {
      return {done: copyHistoryArray(this.history.done),
              undone: copyHistoryArray(this.history.undone)}
    },
    setHistory: function(histData) {
      var hist = this.history = new History(this.history.maxGeneration);
      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
    },

    setGutterMarker: docMethodOp(function(line, gutterID, value) {
      return changeLine(this, line, "gutter", function (line) {
        var markers = line.gutterMarkers || (line.gutterMarkers = {});
        markers[gutterID] = value;
        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
        return true
      })
    }),

    clearGutter: docMethodOp(function(gutterID) {
      var this$1 = this;

      this.iter(function (line) {
        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
          changeLine(this$1, line, "gutter", function () {
            line.gutterMarkers[gutterID] = null;
            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
            return true
          });
        }
      });
    }),

    lineInfo: function(line) {
      var n;
      if (typeof line == "number") {
        if (!isLine(this, line)) { return null }
        n = line;
        line = getLine(this, line);
        if (!line) { return null }
      } else {
        n = lineNo(line);
        if (n == null) { return null }
      }
      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
              widgets: line.widgets}
    },

    addLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        if (!line[prop]) { line[prop] = cls; }
        else if (classTest(cls).test(line[prop])) { return false }
        else { line[prop] += " " + cls; }
        return true
      })
    }),
    removeLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        var cur = line[prop];
        if (!cur) { return false }
        else if (cls == null) { line[prop] = null; }
        else {
          var found = cur.match(classTest(cls));
          if (!found) { return false }
          var end = found.index + found[0].length;
          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
        }
        return true
      })
    }),

    addLineWidget: docMethodOp(function(handle, node, options) {
      return addLineWidget(this, handle, node, options)
    }),
    removeLineWidget: function(widget) { widget.clear(); },

    markText: function(from, to, options) {
      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
    },
    setBookmark: function(pos, options) {
      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                      insertLeft: options && options.insertLeft,
                      clearWhenEmpty: false, shared: options && options.shared,
                      handleMouseEvents: options && options.handleMouseEvents};
      pos = clipPos(this, pos);
      return markText(this, pos, pos, realOpts, "bookmark")
    },
    findMarksAt: function(pos) {
      pos = clipPos(this, pos);
      var markers = [], spans = getLine(this, pos.line).markedSpans;
      if (spans) { for (var i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if ((span.from == null || span.from <= pos.ch) &&
            (span.to == null || span.to >= pos.ch))
          { markers.push(span.marker.parent || span.marker); }
      } }
      return markers
    },
    findMarks: function(from, to, filter) {
      from = clipPos(this, from); to = clipPos(this, to);
      var found = [], lineNo = from.line;
      this.iter(from.line, to.line + 1, function (line) {
        var spans = line.markedSpans;
        if (spans) { for (var i = 0; i < spans.length; i++) {
          var span = spans[i];
          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
                span.from == null && lineNo != from.line ||
                span.from != null && lineNo == to.line && span.from >= to.ch) &&
              (!filter || filter(span.marker)))
            { found.push(span.marker.parent || span.marker); }
        } }
        ++lineNo;
      });
      return found
    },
    getAllMarks: function() {
      var markers = [];
      this.iter(function (line) {
        var sps = line.markedSpans;
        if (sps) { for (var i = 0; i < sps.length; ++i)
          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
      });
      return markers
    },

    posFromIndex: function(off) {
      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
      this.iter(function (line) {
        var sz = line.text.length + sepSize;
        if (sz > off) { ch = off; return true }
        off -= sz;
        ++lineNo;
      });
      return clipPos(this, Pos(lineNo, ch))
    },
    indexFromPos: function (coords) {
      coords = clipPos(this, coords);
      var index = coords.ch;
      if (coords.line < this.first || coords.ch < 0) { return 0 }
      var sepSize = this.lineSeparator().length;
      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
        index += line.text.length + sepSize;
      });
      return index
    },

    copy: function(copyHistory) {
      var doc = new Doc(getLines(this, this.first, this.first + this.size),
                        this.modeOption, this.first, this.lineSep, this.direction);
      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
      doc.sel = this.sel;
      doc.extend = false;
      if (copyHistory) {
        doc.history.undoDepth = this.history.undoDepth;
        doc.setHistory(this.getHistory());
      }
      return doc
    },

    linkedDoc: function(options) {
      if (!options) { options = {}; }
      var from = this.first, to = this.first + this.size;
      if (options.from != null && options.from > from) { from = options.from; }
      if (options.to != null && options.to < to) { to = options.to; }
      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
      if (options.sharedHist) { copy.history = this.history
      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
      copySharedMarkers(copy, findSharedMarkers(this));
      return copy
    },
    unlinkDoc: function(other) {
      if (other instanceof CodeMirror) { other = other.doc; }
      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
        var link = this.linked[i];
        if (link.doc != other) { continue }
        this.linked.splice(i, 1);
        other.unlinkDoc(this);
        detachSharedMarkers(findSharedMarkers(this));
        break
      } }
      // If the histories were shared, split them again
      if (other.history == this.history) {
        var splitIds = [other.id];
        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
        other.history = new History(null);
        other.history.done = copyHistoryArray(this.history.done, splitIds);
        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
      }
    },
    iterLinkedDocs: function(f) {linkedDocs(this, f);},

    getMode: function() {return this.mode},
    getEditor: function() {return this.cm},

    splitLines: function(str) {
      if (this.lineSep) { return str.split(this.lineSep) }
      return splitLinesAuto(str)
    },
    lineSeparator: function() { return this.lineSep || "\n" },

    setDirection: docMethodOp(function (dir) {
      if (dir != "rtl") { dir = "ltr"; }
      if (dir == this.direction) { return }
      this.direction = dir;
      this.iter(function (line) { return line.order = null; });
      if (this.cm) { directionChanged(this.cm); }
    })
  });

  // Public alias.
  Doc.prototype.eachLine = Doc.prototype.iter;

  // Kludge to work around strange IE behavior where it'll sometimes
  // re-fire a series of drag-related events right after the drop (#1551)
  var lastDrop = 0;

  function onDrop(e) {
    var cm = this;
    clearDragCursor(cm);
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
      { return }
    e_preventDefault(e);
    if (ie) { lastDrop = +new Date; }
    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
    if (!pos || cm.isReadOnly()) { return }
    // Might be a file drop, in which case we simply extract the text
    // and insert it.
    if (files && files.length && window.FileReader && window.File) {
      var n = files.length, text = Array(n), read = 0;
      var markAsReadAndPasteIfAllFilesAreRead = function () {
        if (++read == n) {
          operation(cm, function () {
            pos = clipPos(cm.doc, pos);
            var change = {from: pos, to: pos,
                          text: cm.doc.splitLines(
                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
                          origin: "paste"};
            makeChange(cm.doc, change);
            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
          })();
        }
      };
      var readTextFromFile = function (file, i) {
        if (cm.options.allowDropFileTypes &&
            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
          markAsReadAndPasteIfAllFilesAreRead();
          return
        }
        var reader = new FileReader;
        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
        reader.onload = function () {
          var content = reader.result;
          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
            markAsReadAndPasteIfAllFilesAreRead();
            return
          }
          text[i] = content;
          markAsReadAndPasteIfAllFilesAreRead();
        };
        reader.readAsText(file);
      };
      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
    } else { // Normal drop
      // Don't do a replace if the drop happened inside of the selected text.
      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
        cm.state.draggingText(e);
        // Ensure the editor is re-focused
        setTimeout(function () { return cm.display.input.focus(); }, 20);
        return
      }
      try {
        var text$1 = e.dataTransfer.getData("Text");
        if (text$1) {
          var selected;
          if (cm.state.draggingText && !cm.state.draggingText.copy)
            { selected = cm.listSelections(); }
          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
          cm.replaceSelection(text$1, "around", "paste");
          cm.display.input.focus();
        }
      }
      catch(e){}
    }
  }

  function onDragStart(cm, e) {
    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

    e.dataTransfer.setData("Text", cm.getSelection());
    e.dataTransfer.effectAllowed = "copyMove";

    // Use dummy image instead of default browsers image.
    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
    if (e.dataTransfer.setDragImage && !safari) {
      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      if (presto) {
        img.width = img.height = 1;
        cm.display.wrapper.appendChild(img);
        // Force a relayout, or Opera won't use our image for some obscure reason
        img._top = img.offsetTop;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      if (presto) { img.parentNode.removeChild(img); }
    }
  }

  function onDragOver(cm, e) {
    var pos = posFromMouse(cm, e);
    if (!pos) { return }
    var frag = document.createDocumentFragment();
    drawSelectionCursor(cm, pos, frag);
    if (!cm.display.dragCursor) {
      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
    }
    removeChildrenAndAdd(cm.display.dragCursor, frag);
  }

  function clearDragCursor(cm) {
    if (cm.display.dragCursor) {
      cm.display.lineSpace.removeChild(cm.display.dragCursor);
      cm.display.dragCursor = null;
    }
  }

  // These must be handled carefully, because naively registering a
  // handler for each editor will cause the editors to never be
  // garbage collected.

  function forEachCodeMirror(f) {
    if (!document.getElementsByClassName) { return }
    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
    for (var i = 0; i < byClass.length; i++) {
      var cm = byClass[i].CodeMirror;
      if (cm) { editors.push(cm); }
    }
    if (editors.length) { editors[0].operation(function () {
      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
    }); }
  }

  var globalsRegistered = false;
  function ensureGlobalHandlers() {
    if (globalsRegistered) { return }
    registerGlobalHandlers();
    globalsRegistered = true;
  }
  function registerGlobalHandlers() {
    // When the window resizes, we need to refresh active editors.
    var resizeTimer;
    on(window, "resize", function () {
      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
        resizeTimer = null;
        forEachCodeMirror(onResize);
      }, 100); }
    });
    // When the window loses focus, we want to show the editor as blurred
    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
  }
  // Called when the window resizes
  function onResize(cm) {
    var d = cm.display;
    // Might be a text scaling operation, clear size caches.
    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
    d.scrollbarsClipped = false;
    cm.setSize();
  }

  var keyNames = {
    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
    221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
  };

  // Number keys
  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
  // Alphabetic keys
  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
  // Function keys
  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

  var keyMap = {};

  keyMap.basic = {
    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
    "Esc": "singleSelection"
  };
  // Note that the save and find-related commands aren't defined by
  // default. User code or addons can define them. Unknown commands
  // are simply ignored.
  keyMap.pcDefault = {
    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
    "fallthrough": "basic"
  };
  // Very basic readline/emacs-style bindings, which are standard on Mac.
  keyMap.emacsy = {
    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
    "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
    "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
    "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
    "Ctrl-O": "openLine"
  };
  keyMap.macDefault = {
    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
    "fallthrough": ["basic", "emacsy"]
  };
  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

  // KEYMAP DISPATCH

  function normalizeKeyName(name) {
    var parts = name.split(/-(?!$)/);
    name = parts[parts.length - 1];
    var alt, ctrl, shift, cmd;
    for (var i = 0; i < parts.length - 1; i++) {
      var mod = parts[i];
      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
      else { throw new Error("Unrecognized modifier name: " + mod) }
    }
    if (alt) { name = "Alt-" + name; }
    if (ctrl) { name = "Ctrl-" + name; }
    if (cmd) { name = "Cmd-" + name; }
    if (shift) { name = "Shift-" + name; }
    return name
  }

  // This is a kludge to keep keymaps mostly working as raw objects
  // (backwards compatibility) while at the same time support features
  // like normalization and multi-stroke key bindings. It compiles a
  // new normalized keymap, and then updates the old object to reflect
  // this.
  function normalizeKeyMap(keymap) {
    var copy = {};
    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
      var value = keymap[keyname];
      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
      if (value == "...") { delete keymap[keyname]; continue }

      var keys = map(keyname.split(" "), normalizeKeyName);
      for (var i = 0; i < keys.length; i++) {
        var val = (void 0), name = (void 0);
        if (i == keys.length - 1) {
          name = keys.join(" ");
          val = value;
        } else {
          name = keys.slice(0, i + 1).join(" ");
          val = "...";
        }
        var prev = copy[name];
        if (!prev) { copy[name] = val; }
        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
      }
      delete keymap[keyname];
    } }
    for (var prop in copy) { keymap[prop] = copy[prop]; }
    return keymap
  }

  function lookupKey(key, map, handle, context) {
    map = getKeyMap(map);
    var found = map.call ? map.call(key, context) : map[key];
    if (found === false) { return "nothing" }
    if (found === "...") { return "multi" }
    if (found != null && handle(found)) { return "handled" }

    if (map.fallthrough) {
      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
        { return lookupKey(key, map.fallthrough, handle, context) }
      for (var i = 0; i < map.fallthrough.length; i++) {
        var result = lookupKey(key, map.fallthrough[i], handle, context);
        if (result) { return result }
      }
    }
  }

  // Modifier key presses don't count as 'real' key presses for the
  // purpose of keymap fallthrough.
  function isModifierKey(value) {
    var name = typeof value == "string" ? value : keyNames[value.keyCode];
    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
  }

  function addModifierNames(name, event, noShift) {
    var base = name;
    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
    return name
  }

  // Look up the name of a key as indicated by an event object.
  function keyName(event, noShift) {
    if (presto && event.keyCode == 34 && event["char"]) { return false }
    var name = keyNames[event.keyCode];
    if (name == null || event.altGraphKey) { return false }
    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
    if (event.keyCode == 3 && event.code) { name = event.code; }
    return addModifierNames(name, event, noShift)
  }

  function getKeyMap(val) {
    return typeof val == "string" ? keyMap[val] : val
  }

  // Helper for deleting text near the selection(s), used to implement
  // backspace, delete, and similar functionality.
  function deleteNearSelection(cm, compute) {
    var ranges = cm.doc.sel.ranges, kill = [];
    // Build up a set of ranges to kill first, merging overlapping
    // ranges.
    for (var i = 0; i < ranges.length; i++) {
      var toKill = compute(ranges[i]);
      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
        var replaced = kill.pop();
        if (cmp(replaced.from, toKill.from) < 0) {
          toKill.from = replaced.from;
          break
        }
      }
      kill.push(toKill);
    }
    // Next, remove those actual ranges.
    runInOp(cm, function () {
      for (var i = kill.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
      ensureCursorVisible(cm);
    });
  }

  function moveCharLogically(line, ch, dir) {
    var target = skipExtendingChars(line.text, ch + dir, dir);
    return target < 0 || target > line.text.length ? null : target
  }

  function moveLogically(line, start, dir) {
    var ch = moveCharLogically(line, start.ch, dir);
    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
  }

  function endOfLine(visually, cm, lineObj, lineNo, dir) {
    if (visually) {
      if (cm.doc.direction == "rtl") { dir = -dir; }
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = dir < 0 ? lst(order) : order[0];
        var moveInStorageOrder = (dir < 0) == (part.level == 1);
        var sticky = moveInStorageOrder ? "after" : "before";
        var ch;
        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
        // it could be that the last bidi part is not on the last visual line,
        // since visual lines contain content order-consecutive chunks.
        // Thus, in rtl, we are looking for the first (content-order) character
        // in the rtl chunk that is on the last line (that is, the same line
        // as the last (content-order) character).
        if (part.level > 0 || cm.doc.direction == "rtl") {
          var prep = prepareMeasureForLine(cm, lineObj);
          ch = dir < 0 ? lineObj.text.length - 1 : 0;
          var targetTop = measureCharPrepared(cm, prep, ch).top;
          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
        } else { ch = dir < 0 ? part.to : part.from; }
        return new Pos(lineNo, ch, sticky)
      }
    }
    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
  }

  function moveVisually(cm, line, start, dir) {
    var bidi = getOrder(line, cm.doc.direction);
    if (!bidi) { return moveLogically(line, start, dir) }
    if (start.ch >= line.text.length) {
      start.ch = line.text.length;
      start.sticky = "before";
    } else if (start.ch <= 0) {
      start.ch = 0;
      start.sticky = "after";
    }
    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
      // nothing interesting happens.
      return moveLogically(line, start, dir)
    }

    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
    var prep;
    var getWrappedLineExtent = function (ch) {
      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
      prep = prep || prepareMeasureForLine(cm, line);
      return wrappedLineExtentChar(cm, line, prep, ch)
    };
    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

    if (cm.doc.direction == "rtl" || part.level == 1) {
      var moveInStorageOrder = (part.level == 1) == (dir < 0);
      var ch = mv(start, moveInStorageOrder ? 1 : -1);
      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
        var sticky = moveInStorageOrder ? "before" : "after";
        return new Pos(start.line, ch, sticky)
      }
    }

    // Case 3: Could not move within this bidi part in this visual line, so leave
    // the current bidi part

    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
        ? new Pos(start.line, mv(ch, 1), "before")
        : new Pos(start.line, ch, "after"); };

      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
        var part = bidi[partPos];
        var moveInStorageOrder = (dir > 0) == (part.level != 1);
        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
      }
    };

    // Case 3a: Look for other bidi parts on the same visual line
    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
    if (res) { return res }

    // Case 3b: Look for other bidi parts on the next visual line
    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
      if (res) { return res }
    }

    // Case 4: Nowhere to move
    return null
  }

  // Commands are parameter-less actions that can be performed on an
  // editor, mostly used for keybindings.
  var commands = {
    selectAll: selectAll,
    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
      if (range.empty()) {
        var len = getLine(cm.doc, range.head.line).text.length;
        if (range.head.ch == len && range.head.line < cm.lastLine())
          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
        else
          { return {from: range.head, to: Pos(range.head.line, len)} }
      } else {
        return {from: range.from(), to: range.to()}
      }
    }); },
    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0),
      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
    }); }); },
    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0), to: range.from()
    }); }); },
    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
      return {from: leftPos, to: range.from()}
    }); },
    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
      return {from: range.from(), to: rightPos }
    }); },
    undo: function (cm) { return cm.undo(); },
    redo: function (cm) { return cm.redo(); },
    undoSelection: function (cm) { return cm.undoSelection(); },
    redoSelection: function (cm) { return cm.redoSelection(); },
    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
      {origin: "+move", bias: 1}
    ); },
    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
      {origin: "+move", bias: 1}
    ); },
    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
      {origin: "+move", bias: -1}
    ); },
    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
    }, sel_move); },
    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: 0, top: top}, "div")
    }, sel_move); },
    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      var pos = cm.coordsChar({left: 0, top: top}, "div");
      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
      return pos
    }, sel_move); },
    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
    goLineDown: function (cm) { return cm.moveV(1, "line"); },
    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
    goPageDown: function (cm) { return cm.moveV(1, "page"); },
    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
    goCharRight: function (cm) { return cm.moveH(1, "char"); },
    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
    goWordRight: function (cm) { return cm.moveH(1, "word"); },
    delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
    indentAuto: function (cm) { return cm.indentSelection("smart"); },
    indentMore: function (cm) { return cm.indentSelection("add"); },
    indentLess: function (cm) { return cm.indentSelection("subtract"); },
    insertTab: function (cm) { return cm.replaceSelection("\t"); },
    insertSoftTab: function (cm) {
      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
      for (var i = 0; i < ranges.length; i++) {
        var pos = ranges[i].from();
        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
        spaces.push(spaceStr(tabSize - col % tabSize));
      }
      cm.replaceSelections(spaces);
    },
    defaultTab: function (cm) {
      if (cm.somethingSelected()) { cm.indentSelection("add"); }
      else { cm.execCommand("insertTab"); }
    },
    // Swap the two chars left and right of each selection's head.
    // Move cursor behind the two swapped characters afterwards.
    //
    // Doesn't consider line feeds a character.
    // Doesn't scan more than one line above to find a character.
    // Doesn't do anything on an empty line.
    // Doesn't do anything with non-empty selections.
    transposeChars: function (cm) { return runInOp(cm, function () {
      var ranges = cm.listSelections(), newSel = [];
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty()) { continue }
        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
        if (line) {
          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
          if (cur.ch > 0) {
            cur = new Pos(cur.line, cur.ch + 1);
            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
          } else if (cur.line > cm.doc.first) {
            var prev = getLine(cm.doc, cur.line - 1).text;
            if (prev) {
              cur = new Pos(cur.line, 1);
              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                              prev.charAt(prev.length - 1),
                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
            }
          }
        }
        newSel.push(new Range(cur, cur));
      }
      cm.setSelections(newSel);
    }); },
    newlineAndIndent: function (cm) { return runInOp(cm, function () {
      var sels = cm.listSelections();
      for (var i = sels.length - 1; i >= 0; i--)
        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
      sels = cm.listSelections();
      for (var i$1 = 0; i$1 < sels.length; i$1++)
        { cm.indentLine(sels[i$1].from().line, null, true); }
      ensureCursorVisible(cm);
    }); },
    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
  };


  function lineStart(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLine(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, visual, lineN, 1)
  }
  function lineEnd(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLineEnd(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, line, lineN, -1)
  }
  function lineStartSmart(cm, pos) {
    var start = lineStart(cm, pos.line);
    var line = getLine(cm.doc, start.line);
    var order = getOrder(line, cm.doc.direction);
    if (!order || order[0].level == 0) {
      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
    }
    return start
  }

  // Run a handler that was bound to a key.
  function doHandleBinding(cm, bound, dropShift) {
    if (typeof bound == "string") {
      bound = commands[bound];
      if (!bound) { return false }
    }
    // Ensure previous input has been read, so that the handler sees a
    // consistent view of the document
    cm.display.input.ensurePolled();
    var prevShift = cm.display.shift, done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      if (dropShift) { cm.display.shift = false; }
      done = bound(cm) != Pass;
    } finally {
      cm.display.shift = prevShift;
      cm.state.suppressEdits = false;
    }
    return done
  }

  function lookupKeyForEditor(cm, name, handle) {
    for (var i = 0; i < cm.state.keyMaps.length; i++) {
      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
      if (result) { return result }
    }
    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
      || lookupKey(name, cm.options.keyMap, handle, cm)
  }

  // Note that, despite the name, this function is also used to check
  // for bound mouse clicks.

  var stopSeq = new Delayed;

  function dispatchKey(cm, name, e, handle) {
    var seq = cm.state.keySeq;
    if (seq) {
      if (isModifierKey(name)) { return "handled" }
      if (/\'$/.test(name))
        { cm.state.keySeq = null; }
      else
        { stopSeq.set(50, function () {
          if (cm.state.keySeq == seq) {
            cm.state.keySeq = null;
            cm.display.input.reset();
          }
        }); }
      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
    }
    return dispatchKeyInner(cm, name, e, handle)
  }

  function dispatchKeyInner(cm, name, e, handle) {
    var result = lookupKeyForEditor(cm, name, handle);

    if (result == "multi")
      { cm.state.keySeq = name; }
    if (result == "handled")
      { signalLater(cm, "keyHandled", cm, name, e); }

    if (result == "handled" || result == "multi") {
      e_preventDefault(e);
      restartBlink(cm);
    }

    return !!result
  }

  // Handle a key from the keydown event.
  function handleKeyBinding(cm, e) {
    var name = keyName(e, true);
    if (!name) { return false }

    if (e.shiftKey && !cm.state.keySeq) {
      // First try to resolve full name (including 'Shift-'). Failing
      // that, see if there is a cursor-motion command (starting with
      // 'go') bound to the keyname without 'Shift-'.
      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
          || dispatchKey(cm, name, e, function (b) {
               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
                 { return doHandleBinding(cm, b) }
             })
    } else {
      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
    }
  }

  // Handle a key from the keypress event
  function handleCharBinding(cm, e, ch) {
    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
  }

  var lastStoppedKey = null;
  function onKeyDown(e) {
    var cm = this;
    cm.curOp.focus = activeElt();
    if (signalDOMEvent(cm, e)) { return }
    // IE does strange things with escape.
    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
    var code = e.keyCode;
    cm.display.shift = code == 16 || e.shiftKey;
    var handled = handleKeyBinding(cm, e);
    if (presto) {
      lastStoppedKey = handled ? code : null;
      // Opera has no cut event... we try to at least catch the key combo
      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
        { cm.replaceSelection("", null, "cut"); }
    }
    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
      { document.execCommand("cut"); }

    // Turn mouse into crosshair when Alt is held on Mac.
    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
      { showCrossHair(cm); }
  }

  function showCrossHair(cm) {
    var lineDiv = cm.display.lineDiv;
    addClass(lineDiv, "CodeMirror-crosshair");

    function up(e) {
      if (e.keyCode == 18 || !e.altKey) {
        rmClass(lineDiv, "CodeMirror-crosshair");
        off(document, "keyup", up);
        off(document, "mouseover", up);
      }
    }
    on(document, "keyup", up);
    on(document, "mouseover", up);
  }

  function onKeyUp(e) {
    if (e.keyCode == 16) { this.doc.sel.shift = false; }
    signalDOMEvent(this, e);
  }

  function onKeyPress(e) {
    var cm = this;
    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
    var keyCode = e.keyCode, charCode = e.charCode;
    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
    // Some browsers fire keypress events for backspace
    if (ch == "\x08") { return }
    if (handleCharBinding(cm, e, ch)) { return }
    cm.display.input.onKeyPress(e);
  }

  var DOUBLECLICK_DELAY = 400;

  var PastClick = function(time, pos, button) {
    this.time = time;
    this.pos = pos;
    this.button = button;
  };

  PastClick.prototype.compare = function (time, pos, button) {
    return this.time + DOUBLECLICK_DELAY > time &&
      cmp(pos, this.pos) == 0 && button == this.button
  };

  var lastClick, lastDoubleClick;
  function clickRepeat(pos, button) {
    var now = +new Date;
    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
      lastClick = lastDoubleClick = null;
      return "triple"
    } else if (lastClick && lastClick.compare(now, pos, button)) {
      lastDoubleClick = new PastClick(now, pos, button);
      lastClick = null;
      return "double"
    } else {
      lastClick = new PastClick(now, pos, button);
      lastDoubleClick = null;
      return "single"
    }
  }

  // A mouse down can be a single click, double click, triple click,
  // start of selection drag, start of text drag, new cursor
  // (ctrl-click), rectangle drag (alt-drag), or xwin
  // middle-click-paste. Or it might be a click on something we should
  // not interfere with, such as a scrollbar or widget.
  function onMouseDown(e) {
    var cm = this, display = cm.display;
    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
    display.input.ensurePolled();
    display.shift = e.shiftKey;

    if (eventInWidget(display, e)) {
      if (!webkit) {
        // Briefly turn off draggability, to allow widgets to do
        // normal dragging things.
        display.scroller.draggable = false;
        setTimeout(function () { return display.scroller.draggable = true; }, 100);
      }
      return
    }
    if (clickInGutter(cm, e)) { return }
    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
    window.focus();

    // #3261: make sure, that we're not starting a second selection
    if (button == 1 && cm.state.selectingText)
      { cm.state.selectingText(e); }

    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

    if (button == 1) {
      if (pos) { leftButtonDown(cm, pos, repeat, e); }
      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
    } else if (button == 2) {
      if (pos) { extendSelection(cm.doc, pos); }
      setTimeout(function () { return display.input.focus(); }, 20);
    } else if (button == 3) {
      if (captureRightClick) { cm.display.input.onContextMenu(e); }
      else { delayBlurEvent(cm); }
    }
  }

  function handleMappedButton(cm, button, pos, repeat, event) {
    var name = "Click";
    if (repeat == "double") { name = "Double" + name; }
    else if (repeat == "triple") { name = "Triple" + name; }
    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
      if (typeof bound == "string") { bound = commands[bound]; }
      if (!bound) { return false }
      var done = false;
      try {
        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
        done = bound(cm, pos) != Pass;
      } finally {
        cm.state.suppressEdits = false;
      }
      return done
    })
  }

  function configureMouse(cm, repeat, event) {
    var option = cm.getOption("configureMouse");
    var value = option ? option(cm, repeat, event) : {};
    if (value.unit == null) {
      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
    }
    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
    return value
  }

  function leftButtonDown(cm, pos, repeat, event) {
    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
    else { cm.curOp.focus = activeElt(); }

    var behavior = configureMouse(cm, repeat, event);

    var sel = cm.doc.sel, contained;
    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
      { leftButtonStartDrag(cm, event, pos, behavior); }
    else
      { leftButtonSelect(cm, event, pos, behavior); }
  }

  // Start a text drag. When it ends, see if any dragging actually
  // happen, and treat as a click if it didn't.
  function leftButtonStartDrag(cm, event, pos, behavior) {
    var display = cm.display, moved = false;
    var dragEnd = operation(cm, function (e) {
      if (webkit) { display.scroller.draggable = false; }
      cm.state.draggingText = false;
      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
      off(display.scroller, "dragstart", dragStart);
      off(display.scroller, "drop", dragEnd);
      if (!moved) {
        e_preventDefault(e);
        if (!behavior.addNew)
          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
        if (webkit || ie && ie_version == 9)
          { setTimeout(function () {display.wrapper.ownerDocument.body.focus(); display.input.focus();}, 20); }
        else
          { display.input.focus(); }
      }
    });
    var mouseMove = function(e2) {
      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
    };
    var dragStart = function () { return moved = true; };
    // Let the drag handler handle this.
    if (webkit) { display.scroller.draggable = true; }
    cm.state.draggingText = dragEnd;
    dragEnd.copy = !behavior.moveOnDrag;
    // IE's approach to draggable
    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
    on(display.scroller, "dragstart", dragStart);
    on(display.scroller, "drop", dragEnd);

    delayBlurEvent(cm);
    setTimeout(function () { return display.input.focus(); }, 20);
  }

  function rangeForUnit(cm, pos, unit) {
    if (unit == "char") { return new Range(pos, pos) }
    if (unit == "word") { return cm.findWordAt(pos) }
    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
    var result = unit(cm, pos);
    return new Range(result.from, result.to)
  }

  // Normal selection, as opposed to text dragging.
  function leftButtonSelect(cm, event, start, behavior) {
    var display = cm.display, doc = cm.doc;
    e_preventDefault(event);

    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
    if (behavior.addNew && !behavior.extend) {
      ourIndex = doc.sel.contains(start);
      if (ourIndex > -1)
        { ourRange = ranges[ourIndex]; }
      else
        { ourRange = new Range(start, start); }
    } else {
      ourRange = doc.sel.primary();
      ourIndex = doc.sel.primIndex;
    }

    if (behavior.unit == "rectangle") {
      if (!behavior.addNew) { ourRange = new Range(start, start); }
      start = posFromMouse(cm, event, true, true);
      ourIndex = -1;
    } else {
      var range = rangeForUnit(cm, start, behavior.unit);
      if (behavior.extend)
        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
      else
        { ourRange = range; }
    }

    if (!behavior.addNew) {
      ourIndex = 0;
      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
      startSel = doc.sel;
    } else if (ourIndex == -1) {
      ourIndex = ranges.length;
      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
                   {scroll: false, origin: "*mouse"});
    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                   {scroll: false, origin: "*mouse"});
      startSel = doc.sel;
    } else {
      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
    }

    var lastPos = start;
    function extendTo(pos) {
      if (cmp(lastPos, pos) == 0) { return }
      lastPos = pos;

      if (behavior.unit == "rectangle") {
        var ranges = [], tabSize = cm.options.tabSize;
        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
             line <= end; line++) {
          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
          if (left == right)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
          else if (text.length > leftPos)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
        }
        if (!ranges.length) { ranges.push(new Range(start, start)); }
        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                     {origin: "*mouse", scroll: false});
        cm.scrollIntoView(pos);
      } else {
        var oldRange = ourRange;
        var range = rangeForUnit(cm, pos, behavior.unit);
        var anchor = oldRange.anchor, head;
        if (cmp(range.anchor, anchor) > 0) {
          head = range.head;
          anchor = minPos(oldRange.from(), range.anchor);
        } else {
          head = range.anchor;
          anchor = maxPos(oldRange.to(), range.head);
        }
        var ranges$1 = startSel.ranges.slice(0);
        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
      }
    }

    var editorSize = display.wrapper.getBoundingClientRect();
    // Used to ensure timeout re-tries don't fire when another extend
    // happened in the meantime (clearTimeout isn't reliable -- at
    // least on Chrome, the timeouts still happen even when cleared,
    // if the clear happens after their scheduled firing time).
    var counter = 0;

    function extend(e) {
      var curCount = ++counter;
      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
      if (!cur) { return }
      if (cmp(cur, lastPos) != 0) {
        cm.curOp.focus = activeElt();
        extendTo(cur);
        var visible = visibleLines(display, doc);
        if (cur.line >= visible.to || cur.line < visible.from)
          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
      } else {
        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
        if (outside) { setTimeout(operation(cm, function () {
          if (counter != curCount) { return }
          display.scroller.scrollTop += outside;
          extend(e);
        }), 50); }
      }
    }

    function done(e) {
      cm.state.selectingText = false;
      counter = Infinity;
      // If e is null or undefined we interpret this as someone trying
      // to explicitly cancel the selection rather than the user
      // letting go of the mouse button.
      if (e) {
        e_preventDefault(e);
        display.input.focus();
      }
      off(display.wrapper.ownerDocument, "mousemove", move);
      off(display.wrapper.ownerDocument, "mouseup", up);
      doc.history.lastSelOrigin = null;
    }

    var move = operation(cm, function (e) {
      if (e.buttons === 0 || !e_button(e)) { done(e); }
      else { extend(e); }
    });
    var up = operation(cm, done);
    cm.state.selectingText = up;
    on(display.wrapper.ownerDocument, "mousemove", move);
    on(display.wrapper.ownerDocument, "mouseup", up);
  }

  // Used when mouse-selecting to adjust the anchor to the proper side
  // of a bidi jump depending on the visual position of the head.
  function bidiSimplify(cm, range) {
    var anchor = range.anchor;
    var head = range.head;
    var anchorLine = getLine(cm.doc, anchor.line);
    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
    var order = getOrder(anchorLine);
    if (!order) { return range }
    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
    if (boundary == 0 || boundary == order.length) { return range }

    // Compute the relative visual position of the head compared to the
    // anchor (<0 is to the left, >0 to the right)
    var leftSide;
    if (head.line != anchor.line) {
      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
    } else {
      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
      if (headIndex == boundary - 1 || headIndex == boundary)
        { leftSide = dir < 0; }
      else
        { leftSide = dir > 0; }
    }

    var usePart = order[boundary + (leftSide ? -1 : 0)];
    var from = leftSide == (usePart.level == 1);
    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
  }


  // Determines whether an event happened in the gutter, and fires the
  // handlers for the corresponding event.
  function gutterEvent(cm, e, type, prevent) {
    var mX, mY;
    if (e.touches) {
      mX = e.touches[0].clientX;
      mY = e.touches[0].clientY;
    } else {
      try { mX = e.clientX; mY = e.clientY; }
      catch(e) { return false }
    }
    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
    if (prevent) { e_preventDefault(e); }

    var display = cm.display;
    var lineBox = display.lineDiv.getBoundingClientRect();

    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
    mY -= lineBox.top - display.viewOffset;

    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
      var g = display.gutters.childNodes[i];
      if (g && g.getBoundingClientRect().right >= mX) {
        var line = lineAtHeight(cm.doc, mY);
        var gutter = cm.display.gutterSpecs[i];
        signal(cm, type, cm, line, gutter.className, e);
        return e_defaultPrevented(e)
      }
    }
  }

  function clickInGutter(cm, e) {
    return gutterEvent(cm, e, "gutterClick", true)
  }

  // CONTEXT MENU HANDLING

  // To make the context menu work, we need to briefly unhide the
  // textarea (making it as unobtrusive as possible) to let the
  // right-click take effect on it.
  function onContextMenu(cm, e) {
    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
    if (signalDOMEvent(cm, e, "contextmenu")) { return }
    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
  }

  function contextMenuInGutter(cm, e) {
    if (!hasHandler(cm, "gutterContextMenu")) { return false }
    return gutterEvent(cm, e, "gutterContextMenu", false)
  }

  function themeChanged(cm) {
    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
    clearCaches(cm);
  }

  var Init = {toString: function(){return "CodeMirror.Init"}};

  var defaults = {};
  var optionHandlers = {};

  function defineOptions(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    function option(name, deflt, handle, notOnInit) {
      CodeMirror.defaults[name] = deflt;
      if (handle) { optionHandlers[name] =
        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
    }

    CodeMirror.defineOption = option;

    // Passed to option handlers when there is no old value.
    CodeMirror.Init = Init;

    // These two are, on init, called from the constructor because they
    // have to be initialized before the editor can start at all.
    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
    option("mode", null, function (cm, val) {
      cm.doc.modeOption = val;
      loadMode(cm);
    }, true);

    option("indentUnit", 2, loadMode, true);
    option("indentWithTabs", false);
    option("smartIndent", true);
    option("tabSize", 4, function (cm) {
      resetModeState(cm);
      clearCaches(cm);
      regChange(cm);
    }, true);

    option("lineSeparator", null, function (cm, val) {
      cm.doc.lineSep = val;
      if (!val) { return }
      var newBreaks = [], lineNo = cm.doc.first;
      cm.doc.iter(function (line) {
        for (var pos = 0;;) {
          var found = line.text.indexOf(val, pos);
          if (found == -1) { break }
          pos = found + val.length;
          newBreaks.push(Pos(lineNo, found));
        }
        lineNo++;
      });
      for (var i = newBreaks.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
    });
    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
      if (old != Init) { cm.refresh(); }
    });
    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
    option("electricChars", true);
    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
    }, true);
    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
    option("rtlMoveVisually", !windows);
    option("wholeLineUpdateBefore", true);

    option("theme", "default", function (cm) {
      themeChanged(cm);
      updateGutters(cm);
    }, true);
    option("keyMap", "default", function (cm, val, old) {
      var next = getKeyMap(val);
      var prev = old != Init && getKeyMap(old);
      if (prev && prev.detach) { prev.detach(cm, next); }
      if (next.attach) { next.attach(cm, prev || null); }
    });
    option("extraKeys", null);
    option("configureMouse", null);

    option("lineWrapping", false, wrappingChanged, true);
    option("gutters", [], function (cm, val) {
      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
      updateGutters(cm);
    }, true);
    option("fixedGutter", true, function (cm, val) {
      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
      cm.refresh();
    }, true);
    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
    option("scrollbarStyle", "native", function (cm) {
      initScrollbars(cm);
      updateScrollbars(cm);
      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
    }, true);
    option("lineNumbers", false, function (cm, val) {
      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
      updateGutters(cm);
    }, true);
    option("firstLineNumber", 1, updateGutters, true);
    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
    option("showCursorWhenSelecting", false, updateSelection, true);

    option("resetSelectionOnContextMenu", true);
    option("lineWiseCopyCut", true);
    option("pasteLinesPerSelection", true);
    option("selectionsMayTouch", false);

    option("readOnly", false, function (cm, val) {
      if (val == "nocursor") {
        onBlur(cm);
        cm.display.input.blur();
      }
      cm.display.input.readOnlyChanged(val);
    });
    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
    option("dragDrop", true, dragDropChanged);
    option("allowDropFileTypes", null);

    option("cursorBlinkRate", 530);
    option("cursorScrollMargin", 0);
    option("cursorHeight", 1, updateSelection, true);
    option("singleCursorHeightPerLine", true, updateSelection, true);
    option("workTime", 100);
    option("workDelay", 100);
    option("flattenSpans", true, resetModeState, true);
    option("addModeClass", false, resetModeState, true);
    option("pollInterval", 100);
    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
    option("historyEventDelay", 1250);
    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
    option("maxHighlightLength", 10000, resetModeState, true);
    option("moveInputWithCursor", true, function (cm, val) {
      if (!val) { cm.display.input.resetPosition(); }
    });

    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
    option("autofocus", null);
    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
    option("phrases", null);
  }

  function dragDropChanged(cm, value, old) {
    var wasOn = old && old != Init;
    if (!value != !wasOn) {
      var funcs = cm.display.dragFunctions;
      var toggle = value ? on : off;
      toggle(cm.display.scroller, "dragstart", funcs.start);
      toggle(cm.display.scroller, "dragenter", funcs.enter);
      toggle(cm.display.scroller, "dragover", funcs.over);
      toggle(cm.display.scroller, "dragleave", funcs.leave);
      toggle(cm.display.scroller, "drop", funcs.drop);
    }
  }

  function wrappingChanged(cm) {
    if (cm.options.lineWrapping) {
      addClass(cm.display.wrapper, "CodeMirror-wrap");
      cm.display.sizer.style.minWidth = "";
      cm.display.sizerWidth = null;
    } else {
      rmClass(cm.display.wrapper, "CodeMirror-wrap");
      findMaxLine(cm);
    }
    estimateLineHeights(cm);
    regChange(cm);
    clearCaches(cm);
    setTimeout(function () { return updateScrollbars(cm); }, 100);
  }

  // A CodeMirror instance represents an editor. This is the object
  // that user code is usually dealing with.

  function CodeMirror(place, options) {
    var this$1 = this;

    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }

    this.options = options = options ? copyObj(options) : {};
    // Determine effective options based on given values and defaults.
    copyObj(defaults, options, false);

    var doc = options.value;
    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
    else if (options.mode) { doc.modeOption = options.mode; }
    this.doc = doc;

    var input = new CodeMirror.inputStyles[options.inputStyle](this);
    var display = this.display = new Display(place, doc, input, options);
    display.wrapper.CodeMirror = this;
    themeChanged(this);
    if (options.lineWrapping)
      { this.display.wrapper.className += " CodeMirror-wrap"; }
    initScrollbars(this);

    this.state = {
      keyMaps: [],  // stores maps added by addKeyMap
      overlays: [], // highlighting overlays, as added by addOverlay
      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
      overwrite: false,
      delayingBlurEvent: false,
      focused: false,
      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
      selectingText: false,
      draggingText: false,
      highlight: new Delayed(), // stores highlight worker timeout
      keySeq: null,  // Unfinished key sequence
      specialChars: null
    };

    if (options.autofocus && !mobile) { display.input.focus(); }

    // Override magic textarea content restore that IE sometimes does
    // on our hidden textarea on reload
    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

    registerEventHandlers(this);
    ensureGlobalHandlers();

    startOperation(this);
    this.curOp.forceUpdate = true;
    attachDoc(this, doc);

    if ((options.autofocus && !mobile) || this.hasFocus())
      { setTimeout(bind(onFocus, this), 20); }
    else
      { onBlur(this); }

    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
      { optionHandlers[opt](this, options[opt], Init); } }
    maybeUpdateLineNumberWidth(this);
    if (options.finishInit) { options.finishInit(this); }
    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
    endOperation(this);
    // Suppress optimizelegibility in Webkit, since it breaks text
    // measuring on line wrapping boundaries.
    if (webkit && options.lineWrapping &&
        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
      { display.lineDiv.style.textRendering = "auto"; }
  }

  // The default configuration options.
  CodeMirror.defaults = defaults;
  // Functions to run when options are changed.
  CodeMirror.optionHandlers = optionHandlers;

  // Attach the necessary event handlers when initializing the editor
  function registerEventHandlers(cm) {
    var d = cm.display;
    on(d.scroller, "mousedown", operation(cm, onMouseDown));
    // Older IE's will not fire a second mousedown for a double click
    if (ie && ie_version < 11)
      { on(d.scroller, "dblclick", operation(cm, function (e) {
        if (signalDOMEvent(cm, e)) { return }
        var pos = posFromMouse(cm, e);
        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
        e_preventDefault(e);
        var word = cm.findWordAt(pos);
        extendSelection(cm.doc, word.anchor, word.head);
      })); }
    else
      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
    // Some browsers fire contextmenu *after* opening the menu, at
    // which point we can't mess with it anymore. Context menu is
    // handled in onMouseDown for these browsers.
    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
    on(d.input.getField(), "contextmenu", function (e) {
      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
    });

    // Used to suppress mouse event handling when a touch happens
    var touchFinished, prevTouch = {end: 0};
    function finishTouch() {
      if (d.activeTouch) {
        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
        prevTouch = d.activeTouch;
        prevTouch.end = +new Date;
      }
    }
    function isMouseLikeTouchEvent(e) {
      if (e.touches.length != 1) { return false }
      var touch = e.touches[0];
      return touch.radiusX <= 1 && touch.radiusY <= 1
    }
    function farAway(touch, other) {
      if (other.left == null) { return true }
      var dx = other.left - touch.left, dy = other.top - touch.top;
      return dx * dx + dy * dy > 20 * 20
    }
    on(d.scroller, "touchstart", function (e) {
      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
        d.input.ensurePolled();
        clearTimeout(touchFinished);
        var now = +new Date;
        d.activeTouch = {start: now, moved: false,
                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
        if (e.touches.length == 1) {
          d.activeTouch.left = e.touches[0].pageX;
          d.activeTouch.top = e.touches[0].pageY;
        }
      }
    });
    on(d.scroller, "touchmove", function () {
      if (d.activeTouch) { d.activeTouch.moved = true; }
    });
    on(d.scroller, "touchend", function (e) {
      var touch = d.activeTouch;
      if (touch && !eventInWidget(d, e) && touch.left != null &&
          !touch.moved && new Date - touch.start < 300) {
        var pos = cm.coordsChar(d.activeTouch, "page"), range;
        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
          { range = new Range(pos, pos); }
        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
          { range = cm.findWordAt(pos); }
        else // Triple tap
          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
        cm.setSelection(range.anchor, range.head);
        cm.focus();
        e_preventDefault(e);
      }
      finishTouch();
    });
    on(d.scroller, "touchcancel", finishTouch);

    // Sync scrolling between fake scrollbars and real scrollable
    // area, ensure viewport is updated when scrolling.
    on(d.scroller, "scroll", function () {
      if (d.scroller.clientHeight) {
        updateScrollTop(cm, d.scroller.scrollTop);
        setScrollLeft(cm, d.scroller.scrollLeft, true);
        signal(cm, "scroll", cm);
      }
    });

    // Listen to wheel events in order to try and update the viewport on time.
    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

    // Prevent wrapper from ever scrolling
    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

    d.dragFunctions = {
      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
      start: function (e) { return onDragStart(cm, e); },
      drop: operation(cm, onDrop),
      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
    };

    var inp = d.input.getField();
    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
    on(inp, "keydown", operation(cm, onKeyDown));
    on(inp, "keypress", operation(cm, onKeyPress));
    on(inp, "focus", function (e) { return onFocus(cm, e); });
    on(inp, "blur", function (e) { return onBlur(cm, e); });
  }

  var initHooks = [];
  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };

  // Indent the given line. The how parameter can be "smart",
  // "add"/null, "subtract", or "prev". When aggressive is false
  // (typically set to true for forced single-line indents), empty
  // lines are not indented, and places where the mode returns Pass
  // are left alone.
  function indentLine(cm, n, how, aggressive) {
    var doc = cm.doc, state;
    if (how == null) { how = "add"; }
    if (how == "smart") {
      // Fall back to "prev" when the mode doesn't have an indentation
      // method.
      if (!doc.mode.indent) { how = "prev"; }
      else { state = getContextBefore(cm, n).state; }
    }

    var tabSize = cm.options.tabSize;
    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
    if (line.stateAfter) { line.stateAfter = null; }
    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
    if (!aggressive && !/\S/.test(line.text)) {
      indentation = 0;
      how = "not";
    } else if (how == "smart") {
      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
      if (indentation == Pass || indentation > 150) {
        if (!aggressive) { return }
        how = "prev";
      }
    }
    if (how == "prev") {
      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
      else { indentation = 0; }
    } else if (how == "add") {
      indentation = curSpace + cm.options.indentUnit;
    } else if (how == "subtract") {
      indentation = curSpace - cm.options.indentUnit;
    } else if (typeof how == "number") {
      indentation = curSpace + how;
    }
    indentation = Math.max(0, indentation);

    var indentString = "", pos = 0;
    if (cm.options.indentWithTabs)
      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
    if (pos < indentation) { indentString += spaceStr(indentation - pos); }

    if (indentString != curSpaceString) {
      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
      line.stateAfter = null;
      return true
    } else {
      // Ensure that, if the cursor was in the whitespace at the start
      // of the line, it is moved to the end of that space.
      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
        var range = doc.sel.ranges[i$1];
        if (range.head.line == n && range.head.ch < curSpaceString.length) {
          var pos$1 = Pos(n, curSpaceString.length);
          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
          break
        }
      }
    }
  }

  // This will be set to a {lineWise: bool, text: [string]} object, so
  // that, when pasting, we know what kind of selections the copied
  // text was made out of.
  var lastCopied = null;

  function setLastCopied(newLastCopied) {
    lastCopied = newLastCopied;
  }

  function applyTextInput(cm, inserted, deleted, sel, origin) {
    var doc = cm.doc;
    cm.display.shift = false;
    if (!sel) { sel = doc.sel; }

    var recent = +new Date - 200;
    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
    var textLines = splitLinesAuto(inserted), multiPaste = null;
    // When pasting N lines into N selections, insert one line per selection
    if (paste && sel.ranges.length > 1) {
      if (lastCopied && lastCopied.text.join("\n") == inserted) {
        if (sel.ranges.length % lastCopied.text.length == 0) {
          multiPaste = [];
          for (var i = 0; i < lastCopied.text.length; i++)
            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
        }
      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
        multiPaste = map(textLines, function (l) { return [l]; });
      }
    }

    var updateInput = cm.curOp.updateInput;
    // Normal behavior is to insert the new text into every selection
    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
      var range = sel.ranges[i$1];
      var from = range.from(), to = range.to();
      if (range.empty()) {
        if (deleted && deleted > 0) // Handle deletion
          { from = Pos(from.line, from.ch - deleted); }
        else if (cm.state.overwrite && !paste) // Handle overwrite
          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
          { from = to = Pos(from.line, 0); }
      }
      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
      makeChange(cm.doc, changeEvent);
      signalLater(cm, "inputRead", cm, changeEvent);
    }
    if (inserted && !paste)
      { triggerElectric(cm, inserted); }

    ensureCursorVisible(cm);
    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
    cm.curOp.typing = true;
    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
  }

  function handlePaste(e, cm) {
    var pasted = e.clipboardData && e.clipboardData.getData("Text");
    if (pasted) {
      e.preventDefault();
      if (!cm.isReadOnly() && !cm.options.disableInput)
        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
      return true
    }
  }

  function triggerElectric(cm, inserted) {
    // When an 'electric' character is inserted, immediately trigger a reindent
    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
    var sel = cm.doc.sel;

    for (var i = sel.ranges.length - 1; i >= 0; i--) {
      var range = sel.ranges[i];
      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
      var mode = cm.getModeAt(range.head);
      var indented = false;
      if (mode.electricChars) {
        for (var j = 0; j < mode.electricChars.length; j++)
          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
            indented = indentLine(cm, range.head.line, "smart");
            break
          } }
      } else if (mode.electricInput) {
        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
          { indented = indentLine(cm, range.head.line, "smart"); }
      }
      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
    }
  }

  function copyableRanges(cm) {
    var text = [], ranges = [];
    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
      var line = cm.doc.sel.ranges[i].head.line;
      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
      ranges.push(lineRange);
      text.push(cm.getRange(lineRange.anchor, lineRange.head));
    }
    return {text: text, ranges: ranges}
  }

  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
    field.setAttribute("autocorrect", autocorrect ? "" : "off");
    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
    field.setAttribute("spellcheck", !!spellcheck);
  }

  function hiddenTextarea() {
    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
    // The textarea is kept positioned near the cursor to prevent the
    // fact that it'll be scrolled into view on input from scrolling
    // our fake cursor out of view. On webkit, when wrap=off, paste is
    // very slow. So make the area wide instead.
    if (webkit) { te.style.width = "1000px"; }
    else { te.setAttribute("wrap", "off"); }
    // If border: 0; -- iOS fails to open keyboard (issue #1287)
    if (ios) { te.style.border = "1px solid black"; }
    disableBrowserMagic(te);
    return div
  }

  // The publicly visible API. Note that methodOp(f) means
  // 'wrap f in an operation, performed on its `this` parameter'.

  // This is not the complete set of editor methods. Most of the
  // methods defined on the Doc type are also injected into
  // CodeMirror.prototype, for backwards compatibility and
  // convenience.

  function addEditorMethods(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    var helpers = CodeMirror.helpers = {};

    CodeMirror.prototype = {
      constructor: CodeMirror,
      focus: function(){window.focus(); this.display.input.focus();},

      setOption: function(option, value) {
        var options = this.options, old = options[option];
        if (options[option] == value && option != "mode") { return }
        options[option] = value;
        if (optionHandlers.hasOwnProperty(option))
          { operation(this, optionHandlers[option])(this, value, old); }
        signal(this, "optionChange", this, option);
      },

      getOption: function(option) {return this.options[option]},
      getDoc: function() {return this.doc},

      addKeyMap: function(map, bottom) {
        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
      },
      removeKeyMap: function(map) {
        var maps = this.state.keyMaps;
        for (var i = 0; i < maps.length; ++i)
          { if (maps[i] == map || maps[i].name == map) {
            maps.splice(i, 1);
            return true
          } }
      },

      addOverlay: methodOp(function(spec, options) {
        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
        insertSorted(this.state.overlays,
                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                      priority: (options && options.priority) || 0},
                     function (overlay) { return overlay.priority; });
        this.state.modeGen++;
        regChange(this);
      }),
      removeOverlay: methodOp(function(spec) {
        var overlays = this.state.overlays;
        for (var i = 0; i < overlays.length; ++i) {
          var cur = overlays[i].modeSpec;
          if (cur == spec || typeof spec == "string" && cur.name == spec) {
            overlays.splice(i, 1);
            this.state.modeGen++;
            regChange(this);
            return
          }
        }
      }),

      indentLine: methodOp(function(n, dir, aggressive) {
        if (typeof dir != "string" && typeof dir != "number") {
          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
          else { dir = dir ? "add" : "subtract"; }
        }
        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
      }),
      indentSelection: methodOp(function(how) {
        var ranges = this.doc.sel.ranges, end = -1;
        for (var i = 0; i < ranges.length; i++) {
          var range = ranges[i];
          if (!range.empty()) {
            var from = range.from(), to = range.to();
            var start = Math.max(end, from.line);
            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
            for (var j = start; j < end; ++j)
              { indentLine(this, j, how); }
            var newRanges = this.doc.sel.ranges;
            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
          } else if (range.head.line > end) {
            indentLine(this, range.head.line, how, true);
            end = range.head.line;
            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
          }
        }
      }),

      // Fetch the parser token for a given character. Useful for hacks
      // that want to inspect the mode state (say, for completion).
      getTokenAt: function(pos, precise) {
        return takeToken(this, pos, precise)
      },

      getLineTokens: function(line, precise) {
        return takeToken(this, Pos(line), precise, true)
      },

      getTokenTypeAt: function(pos) {
        pos = clipPos(this.doc, pos);
        var styles = getLineStyles(this, getLine(this.doc, pos.line));
        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
        var type;
        if (ch == 0) { type = styles[2]; }
        else { for (;;) {
          var mid = (before + after) >> 1;
          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
          else { type = styles[mid * 2 + 2]; break }
        } }
        var cut = type ? type.indexOf("overlay ") : -1;
        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
      },

      getModeAt: function(pos) {
        var mode = this.doc.mode;
        if (!mode.innerMode) { return mode }
        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
      },

      getHelper: function(pos, type) {
        return this.getHelpers(pos, type)[0]
      },

      getHelpers: function(pos, type) {
        var found = [];
        if (!helpers.hasOwnProperty(type)) { return found }
        var help = helpers[type], mode = this.getModeAt(pos);
        if (typeof mode[type] == "string") {
          if (help[mode[type]]) { found.push(help[mode[type]]); }
        } else if (mode[type]) {
          for (var i = 0; i < mode[type].length; i++) {
            var val = help[mode[type][i]];
            if (val) { found.push(val); }
          }
        } else if (mode.helperType && help[mode.helperType]) {
          found.push(help[mode.helperType]);
        } else if (help[mode.name]) {
          found.push(help[mode.name]);
        }
        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
          var cur = help._global[i$1];
          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
            { found.push(cur.val); }
        }
        return found
      },

      getStateAfter: function(line, precise) {
        var doc = this.doc;
        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
        return getContextBefore(this, line + 1, precise).state
      },

      cursorCoords: function(start, mode) {
        var pos, range = this.doc.sel.primary();
        if (start == null) { pos = range.head; }
        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
        else { pos = start ? range.from() : range.to(); }
        return cursorCoords(this, pos, mode || "page")
      },

      charCoords: function(pos, mode) {
        return charCoords(this, clipPos(this.doc, pos), mode || "page")
      },

      coordsChar: function(coords, mode) {
        coords = fromCoordSystem(this, coords, mode || "page");
        return coordsChar(this, coords.left, coords.top)
      },

      lineAtHeight: function(height, mode) {
        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
        return lineAtHeight(this.doc, height + this.display.viewOffset)
      },
      heightAtLine: function(line, mode, includeWidgets) {
        var end = false, lineObj;
        if (typeof line == "number") {
          var last = this.doc.first + this.doc.size - 1;
          if (line < this.doc.first) { line = this.doc.first; }
          else if (line > last) { line = last; end = true; }
          lineObj = getLine(this.doc, line);
        } else {
          lineObj = line;
        }
        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
          (end ? this.doc.height - heightAtLine(lineObj) : 0)
      },

      defaultTextHeight: function() { return textHeight(this.display) },
      defaultCharWidth: function() { return charWidth(this.display) },

      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

      addWidget: function(pos, node, scroll, vert, horiz) {
        var display = this.display;
        pos = cursorCoords(this, clipPos(this.doc, pos));
        var top = pos.bottom, left = pos.left;
        node.style.position = "absolute";
        node.setAttribute("cm-ignore-events", "true");
        this.display.input.setUneditable(node);
        display.sizer.appendChild(node);
        if (vert == "over") {
          top = pos.top;
        } else if (vert == "above" || vert == "near") {
          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
          // Default to positioning above (if specified and possible); otherwise default to positioning below
          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
            { top = pos.top - node.offsetHeight; }
          else if (pos.bottom + node.offsetHeight <= vspace)
            { top = pos.bottom; }
          if (left + node.offsetWidth > hspace)
            { left = hspace - node.offsetWidth; }
        }
        node.style.top = top + "px";
        node.style.left = node.style.right = "";
        if (horiz == "right") {
          left = display.sizer.clientWidth - node.offsetWidth;
          node.style.right = "0px";
        } else {
          if (horiz == "left") { left = 0; }
          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
          node.style.left = left + "px";
        }
        if (scroll)
          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
      },

      triggerOnKeyDown: methodOp(onKeyDown),
      triggerOnKeyPress: methodOp(onKeyPress),
      triggerOnKeyUp: onKeyUp,
      triggerOnMouseDown: methodOp(onMouseDown),

      execCommand: function(cmd) {
        if (commands.hasOwnProperty(cmd))
          { return commands[cmd].call(null, this) }
      },

      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

      findPosH: function(from, amount, unit, visually) {
        var dir = 1;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          cur = findPosH(this.doc, cur, dir, unit, visually);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveH: methodOp(function(dir, unit) {
        var this$1 = this;

        this.extendSelectionsBy(function (range) {
          if (this$1.display.shift || this$1.doc.extend || range.empty())
            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
          else
            { return dir < 0 ? range.from() : range.to() }
        }, sel_move);
      }),

      deleteH: methodOp(function(dir, unit) {
        var sel = this.doc.sel, doc = this.doc;
        if (sel.somethingSelected())
          { doc.replaceSelection("", null, "+delete"); }
        else
          { deleteNearSelection(this, function (range) {
            var other = findPosH(doc, range.head, dir, unit, false);
            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
          }); }
      }),

      findPosV: function(from, amount, unit, goalColumn) {
        var dir = 1, x = goalColumn;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          var coords = cursorCoords(this, cur, "div");
          if (x == null) { x = coords.left; }
          else { coords.left = x; }
          cur = findPosV(this, coords, dir, unit);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveV: methodOp(function(dir, unit) {
        var this$1 = this;

        var doc = this.doc, goals = [];
        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
        doc.extendSelectionsBy(function (range) {
          if (collapse)
            { return dir < 0 ? range.from() : range.to() }
          var headPos = cursorCoords(this$1, range.head, "div");
          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
          goals.push(headPos.left);
          var pos = findPosV(this$1, headPos, dir, unit);
          if (unit == "page" && range == doc.sel.primary())
            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
          return pos
        }, sel_move);
        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
          { doc.sel.ranges[i].goalColumn = goals[i]; } }
      }),

      // Find the word at the given position (as returned by coordsChar).
      findWordAt: function(pos) {
        var doc = this.doc, line = getLine(doc, pos.line).text;
        var start = pos.ch, end = pos.ch;
        if (line) {
          var helper = this.getHelper(pos, "wordChars");
          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
          var startChar = line.charAt(start);
          var check = isWordChar(startChar, helper)
            ? function (ch) { return isWordChar(ch, helper); }
            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
          while (start > 0 && check(line.charAt(start - 1))) { --start; }
          while (end < line.length && check(line.charAt(end))) { ++end; }
        }
        return new Range(Pos(pos.line, start), Pos(pos.line, end))
      },

      toggleOverwrite: function(value) {
        if (value != null && value == this.state.overwrite) { return }
        if (this.state.overwrite = !this.state.overwrite)
          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
        else
          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

        signal(this, "overwriteToggle", this, this.state.overwrite);
      },
      hasFocus: function() { return this.display.input.getField() == activeElt() },
      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
      getScrollInfo: function() {
        var scroller = this.display.scroller;
        return {left: scroller.scrollLeft, top: scroller.scrollTop,
                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
      },

      scrollIntoView: methodOp(function(range, margin) {
        if (range == null) {
          range = {from: this.doc.sel.primary().head, to: null};
          if (margin == null) { margin = this.options.cursorScrollMargin; }
        } else if (typeof range == "number") {
          range = {from: Pos(range, 0), to: null};
        } else if (range.from == null) {
          range = {from: range, to: null};
        }
        if (!range.to) { range.to = range.from; }
        range.margin = margin || 0;

        if (range.from.line != null) {
          scrollToRange(this, range);
        } else {
          scrollToCoordsRange(this, range.from, range.to, range.margin);
        }
      }),

      setSize: methodOp(function(width, height) {
        var this$1 = this;

        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
        if (width != null) { this.display.wrapper.style.width = interpret(width); }
        if (height != null) { this.display.wrapper.style.height = interpret(height); }
        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
        var lineNo = this.display.viewFrom;
        this.doc.iter(lineNo, this.display.viewTo, function (line) {
          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
          ++lineNo;
        });
        this.curOp.forceUpdate = true;
        signal(this, "refresh", this);
      }),

      operation: function(f){return runInOp(this, f)},
      startOperation: function(){return startOperation(this)},
      endOperation: function(){return endOperation(this)},

      refresh: methodOp(function() {
        var oldHeight = this.display.cachedTextHeight;
        regChange(this);
        this.curOp.forceUpdate = true;
        clearCaches(this);
        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
        updateGutterSpace(this.display);
        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
          { estimateLineHeights(this); }
        signal(this, "refresh", this);
      }),

      swapDoc: methodOp(function(doc) {
        var old = this.doc;
        old.cm = null;
        // Cancel the current text selection if any (#5821)
        if (this.state.selectingText) { this.state.selectingText(); }
        attachDoc(this, doc);
        clearCaches(this);
        this.display.input.reset();
        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
        this.curOp.forceScroll = true;
        signalLater(this, "swapDoc", this, old);
        return old
      }),

      phrase: function(phraseText) {
        var phrases = this.options.phrases;
        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
      },

      getInputField: function(){return this.display.input.getField()},
      getWrapperElement: function(){return this.display.wrapper},
      getScrollerElement: function(){return this.display.scroller},
      getGutterElement: function(){return this.display.gutters}
    };
    eventMixin(CodeMirror);

    CodeMirror.registerHelper = function(type, name, value) {
      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
      helpers[type][name] = value;
    };
    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
      CodeMirror.registerHelper(type, name, value);
      helpers[type]._global.push({pred: predicate, val: value});
    };
  }

  // Used for horizontal relative motion. Dir is -1 or 1 (left or
  // right), unit can be "char", "column" (like char, but doesn't
  // cross line boundaries), "word" (across next word), or "group" (to
  // the start of next group of word or non-word-non-whitespace
  // chars). The visually param controls whether, in right-to-left
  // text, direction 1 means to move towards the next index in the
  // string, or towards the character to the right of the current
  // position. The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosH(doc, pos, dir, unit, visually) {
    var oldPos = pos;
    var origDir = dir;
    var lineObj = getLine(doc, pos.line);
    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
    function findNextLine() {
      var l = pos.line + lineDir;
      if (l < doc.first || l >= doc.first + doc.size) { return false }
      pos = new Pos(l, pos.ch, pos.sticky);
      return lineObj = getLine(doc, l)
    }
    function moveOnce(boundToLine) {
      var next;
      if (visually) {
        next = moveVisually(doc.cm, lineObj, pos, dir);
      } else {
        next = moveLogically(lineObj, pos, dir);
      }
      if (next == null) {
        if (!boundToLine && findNextLine())
          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
        else
          { return false }
      } else {
        pos = next;
      }
      return true
    }

    if (unit == "char") {
      moveOnce();
    } else if (unit == "column") {
      moveOnce(true);
    } else if (unit == "word" || unit == "group") {
      var sawType = null, group = unit == "group";
      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
      for (var first = true;; first = false) {
        if (dir < 0 && !moveOnce(!first)) { break }
        var cur = lineObj.text.charAt(pos.ch) || "\n";
        var type = isWordChar(cur, helper) ? "w"
          : group && cur == "\n" ? "n"
          : !group || /\s/.test(cur) ? null
          : "p";
        if (group && !first && !type) { type = "s"; }
        if (sawType && sawType != type) {
          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
          break
        }

        if (type) { sawType = type; }
        if (dir > 0 && !moveOnce(!first)) { break }
      }
    }
    var result = skipAtomic(doc, pos, oldPos, origDir, true);
    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
    return result
  }

  // For relative vertical movement. Dir may be -1 or 1. Unit can be
  // "page" or "line". The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosV(cm, pos, dir, unit) {
    var doc = cm.doc, x = pos.left, y;
    if (unit == "page") {
      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

    } else if (unit == "line") {
      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
    }
    var target;
    for (;;) {
      target = coordsChar(cm, x, y);
      if (!target.outside) { break }
      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
      y += dir * 5;
    }
    return target
  }

  // CONTENTEDITABLE INPUT STYLE

  var ContentEditableInput = function(cm) {
    this.cm = cm;
    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
    this.polling = new Delayed();
    this.composing = null;
    this.gracePeriod = false;
    this.readDOMTimeout = null;
  };

  ContentEditableInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = input.cm;
    var div = input.div = display.lineDiv;
    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);

    on(div, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
    });

    on(div, "compositionstart", function (e) {
      this$1.composing = {data: e.data, done: false};
    });
    on(div, "compositionupdate", function (e) {
      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
    });
    on(div, "compositionend", function (e) {
      if (this$1.composing) {
        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
        this$1.composing.done = true;
      }
    });

    on(div, "touchstart", function () { return input.forceCompositionEnd(); });

    on(div, "input", function () {
      if (!this$1.composing) { this$1.readFromDOMSoon(); }
    });

    function onCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.operation(function () {
            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
            cm.replaceSelection("", null, "cut");
          });
        }
      }
      if (e.clipboardData) {
        e.clipboardData.clearData();
        var content = lastCopied.text.join("\n");
        // iOS exposes the clipboard API, but seems to discard content inserted into it
        e.clipboardData.setData("Text", content);
        if (e.clipboardData.getData("Text") == content) {
          e.preventDefault();
          return
        }
      }
      // Old-fashioned briefly-focus-a-textarea hack
      var kludge = hiddenTextarea(), te = kludge.firstChild;
      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
      te.value = lastCopied.text.join("\n");
      var hadFocus = document.activeElement;
      selectInput(te);
      setTimeout(function () {
        cm.display.lineSpace.removeChild(kludge);
        hadFocus.focus();
        if (hadFocus == div) { input.showPrimarySelection(); }
      }, 50);
    }
    on(div, "copy", onCopyCut);
    on(div, "cut", onCopyCut);
  };

  ContentEditableInput.prototype.prepareSelection = function () {
    var result = prepareSelection(this.cm, false);
    result.focus = this.cm.state.focused;
    return result
  };

  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
    if (!info || !this.cm.display.view.length) { return }
    if (info.focus || takeFocus) { this.showPrimarySelection(); }
    this.showMultipleSelections(info);
  };

  ContentEditableInput.prototype.getSelection = function () {
    return this.cm.display.wrapper.ownerDocument.getSelection()
  };

  ContentEditableInput.prototype.showPrimarySelection = function () {
    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
    var from = prim.from(), to = prim.to();

    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
      sel.removeAllRanges();
      return
    }

    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
        cmp(minPos(curAnchor, curFocus), from) == 0 &&
        cmp(maxPos(curAnchor, curFocus), to) == 0)
      { return }

    var view = cm.display.view;
    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
        {node: view[0].measure.map[2], offset: 0};
    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
    if (!end) {
      var measure = view[view.length - 1].measure;
      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
    }

    if (!start || !end) {
      sel.removeAllRanges();
      return
    }

    var old = sel.rangeCount && sel.getRangeAt(0), rng;
    try { rng = range(start.node, start.offset, end.offset, end.node); }
    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
    if (rng) {
      if (!gecko && cm.state.focused) {
        sel.collapse(start.node, start.offset);
        if (!rng.collapsed) {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
      } else {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
      if (old && sel.anchorNode == null) { sel.addRange(old); }
      else if (gecko) { this.startGracePeriod(); }
    }
    this.rememberSelection();
  };

  ContentEditableInput.prototype.startGracePeriod = function () {
      var this$1 = this;

    clearTimeout(this.gracePeriod);
    this.gracePeriod = setTimeout(function () {
      this$1.gracePeriod = false;
      if (this$1.selectionChanged())
        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
    }, 20);
  };

  ContentEditableInput.prototype.showMultipleSelections = function (info) {
    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
  };

  ContentEditableInput.prototype.rememberSelection = function () {
    var sel = this.getSelection();
    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
  };

  ContentEditableInput.prototype.selectionInEditor = function () {
    var sel = this.getSelection();
    if (!sel.rangeCount) { return false }
    var node = sel.getRangeAt(0).commonAncestorContainer;
    return contains(this.div, node)
  };

  ContentEditableInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor") {
      if (!this.selectionInEditor())
        { this.showSelection(this.prepareSelection(), true); }
      this.div.focus();
    }
  };
  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
  ContentEditableInput.prototype.getField = function () { return this.div };

  ContentEditableInput.prototype.supportsTouch = function () { return true };

  ContentEditableInput.prototype.receivedFocus = function () {
    var input = this;
    if (this.selectionInEditor())
      { this.pollSelection(); }
    else
      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

    function poll() {
      if (input.cm.state.focused) {
        input.pollSelection();
        input.polling.set(input.cm.options.pollInterval, poll);
      }
    }
    this.polling.set(this.cm.options.pollInterval, poll);
  };

  ContentEditableInput.prototype.selectionChanged = function () {
    var sel = this.getSelection();
    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
  };

  ContentEditableInput.prototype.pollSelection = function () {
    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
    var sel = this.getSelection(), cm = this.cm;
    // On Android Chrome (version 56, at least), backspacing into an
    // uneditable block element will put the cursor in that element,
    // and then, because it's not editable, hide the virtual keyboard.
    // Because Android doesn't allow us to actually detect backspace
    // presses in a sane way, this code checks for when that happens
    // and simulates a backspace press in this case.
    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
      this.blur();
      this.focus();
      return
    }
    if (this.composing) { return }
    this.rememberSelection();
    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (anchor && head) { runInOp(cm, function () {
      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
    }); }
  };

  ContentEditableInput.prototype.pollContent = function () {
    if (this.readDOMTimeout != null) {
      clearTimeout(this.readDOMTimeout);
      this.readDOMTimeout = null;
    }

    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
    var from = sel.from(), to = sel.to();
    if (from.ch == 0 && from.line > cm.firstLine())
      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
      { to = Pos(to.line + 1, 0); }
    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

    var fromIndex, fromLine, fromNode;
    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
      fromLine = lineNo(display.view[0].line);
      fromNode = display.view[0].node;
    } else {
      fromLine = lineNo(display.view[fromIndex].line);
      fromNode = display.view[fromIndex - 1].node.nextSibling;
    }
    var toIndex = findViewIndex(cm, to.line);
    var toLine, toNode;
    if (toIndex == display.view.length - 1) {
      toLine = display.viewTo - 1;
      toNode = display.lineDiv.lastChild;
    } else {
      toLine = lineNo(display.view[toIndex + 1].line) - 1;
      toNode = display.view[toIndex + 1].node.previousSibling;
    }

    if (!fromNode) { return false }
    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
    while (newText.length > 1 && oldText.length > 1) {
      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
      else { break }
    }

    var cutFront = 0, cutEnd = 0;
    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
      { ++cutFront; }
    var newBot = lst(newText), oldBot = lst(oldText);
    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
    while (cutEnd < maxCutEnd &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
      { ++cutEnd; }
    // Try to move start of change to start of selection if ambiguous
    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
      while (cutFront && cutFront > from.ch &&
             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        cutFront--;
        cutEnd++;
      }
    }

    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

    var chFrom = Pos(fromLine, cutFront);
    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
      return true
    }
  };

  ContentEditableInput.prototype.ensurePolled = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.reset = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.forceCompositionEnd = function () {
    if (!this.composing) { return }
    clearTimeout(this.readDOMTimeout);
    this.composing = null;
    this.updateFromDOM();
    this.div.blur();
    this.div.focus();
  };
  ContentEditableInput.prototype.readFromDOMSoon = function () {
      var this$1 = this;

    if (this.readDOMTimeout != null) { return }
    this.readDOMTimeout = setTimeout(function () {
      this$1.readDOMTimeout = null;
      if (this$1.composing) {
        if (this$1.composing.done) { this$1.composing = null; }
        else { return }
      }
      this$1.updateFromDOM();
    }, 80);
  };

  ContentEditableInput.prototype.updateFromDOM = function () {
      var this$1 = this;

    if (this.cm.isReadOnly() || !this.pollContent())
      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
  };

  ContentEditableInput.prototype.setUneditable = function (node) {
    node.contentEditable = "false";
  };

  ContentEditableInput.prototype.onKeyPress = function (e) {
    if (e.charCode == 0 || this.composing) { return }
    e.preventDefault();
    if (!this.cm.isReadOnly())
      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
  };

  ContentEditableInput.prototype.readOnlyChanged = function (val) {
    this.div.contentEditable = String(val != "nocursor");
  };

  ContentEditableInput.prototype.onContextMenu = function () {};
  ContentEditableInput.prototype.resetPosition = function () {};

  ContentEditableInput.prototype.needsContentAttribute = true;

  function posToDOM(cm, pos) {
    var view = findViewForLine(cm, pos.line);
    if (!view || view.hidden) { return null }
    var line = getLine(cm.doc, pos.line);
    var info = mapFromLineView(view, line, pos.line);

    var order = getOrder(line, cm.doc.direction), side = "left";
    if (order) {
      var partPos = getBidiPartAt(order, pos.ch);
      side = partPos % 2 ? "right" : "left";
    }
    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
    result.offset = result.collapse == "right" ? result.end : result.start;
    return result
  }

  function isInGutter(node) {
    for (var scan = node; scan; scan = scan.parentNode)
      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
    return false
  }

  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

  function domTextBetween(cm, from, to, fromLine, toLine) {
    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
    function close() {
      if (closing) {
        text += lineSep;
        if (extraLinebreak) { text += lineSep; }
        closing = extraLinebreak = false;
      }
    }
    function addText(str) {
      if (str) {
        close();
        text += str;
      }
    }
    function walk(node) {
      if (node.nodeType == 1) {
        var cmText = node.getAttribute("cm-text");
        if (cmText) {
          addText(cmText);
          return
        }
        var markerID = node.getAttribute("cm-marker"), range;
        if (markerID) {
          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
          if (found.length && (range = found[0].find(0)))
            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
          return
        }
        if (node.getAttribute("contenteditable") == "false") { return }
        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

        if (isBlock) { close(); }
        for (var i = 0; i < node.childNodes.length; i++)
          { walk(node.childNodes[i]); }

        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
        if (isBlock) { closing = true; }
      } else if (node.nodeType == 3) {
        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
    }
    for (;;) {
      walk(from);
      if (from == to) { break }
      from = from.nextSibling;
      extraLinebreak = false;
    }
    return text
  }

  function domToPos(cm, node, offset) {
    var lineNode;
    if (node == cm.display.lineDiv) {
      lineNode = cm.display.lineDiv.childNodes[offset];
      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
      node = null; offset = 0;
    } else {
      for (lineNode = node;; lineNode = lineNode.parentNode) {
        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
      }
    }
    for (var i = 0; i < cm.display.view.length; i++) {
      var lineView = cm.display.view[i];
      if (lineView.node == lineNode)
        { return locateNodeInLineView(lineView, node, offset) }
    }
  }

  function locateNodeInLineView(lineView, node, offset) {
    var wrapper = lineView.text.firstChild, bad = false;
    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
    if (node == wrapper) {
      bad = true;
      node = wrapper.childNodes[offset];
      offset = 0;
      if (!node) {
        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
        return badPos(Pos(lineNo(line), line.text.length), bad)
      }
    }

    var textNode = node.nodeType == 3 ? node : null, topNode = node;
    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
      textNode = node.firstChild;
      if (offset) { offset = textNode.nodeValue.length; }
    }
    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
    var measure = lineView.measure, maps = measure.maps;

    function find(textNode, topNode, offset) {
      for (var i = -1; i < (maps ? maps.length : 0); i++) {
        var map = i < 0 ? measure.map : maps[i];
        for (var j = 0; j < map.length; j += 3) {
          var curNode = map[j + 2];
          if (curNode == textNode || curNode == topNode) {
            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
            var ch = map[j] + offset;
            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
            return Pos(line, ch)
          }
        }
      }
    }
    var found = find(textNode, topNode, offset);
    if (found) { return badPos(found, bad) }

    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
      found = find(after, after.firstChild, 0);
      if (found)
        { return badPos(Pos(found.line, found.ch - dist), bad) }
      else
        { dist += after.textContent.length; }
    }
    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
      found = find(before, before.firstChild, -1);
      if (found)
        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
      else
        { dist$1 += before.textContent.length; }
    }
  }

  // TEXTAREA INPUT STYLE

  var TextareaInput = function(cm) {
    this.cm = cm;
    // See input.poll and input.reset
    this.prevInput = "";

    // Flag that indicates whether we expect input to appear real soon
    // now (after some event like 'keypress' or 'input') and are
    // polling intensively.
    this.pollingFast = false;
    // Self-resetting timeout for the poller
    this.polling = new Delayed();
    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
    this.hasSelection = false;
    this.composing = null;
  };

  TextareaInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = this.cm;
    this.createField(display);
    var te = this.textarea;

    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
    if (ios) { te.style.width = "0px"; }

    on(te, "input", function () {
      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
      input.poll();
    });

    on(te, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

      cm.state.pasteIncoming = +new Date;
      input.fastPoll();
    });

    function prepareCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.setSelections(ranges.ranges, null, sel_dontScroll);
        } else {
          input.prevInput = "";
          te.value = ranges.text.join("\n");
          selectInput(te);
        }
      }
      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
    }
    on(te, "cut", prepareCopyCut);
    on(te, "copy", prepareCopyCut);

    on(display.scroller, "paste", function (e) {
      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
      if (!te.dispatchEvent) {
        cm.state.pasteIncoming = +new Date;
        input.focus();
        return
      }

      // Pass the `paste` event to the textarea so it's handled by its event listener.
      var event = new Event("paste");
      event.clipboardData = e.clipboardData;
      te.dispatchEvent(event);
    });

    // Prevent normal selection in the editor (we handle our own)
    on(display.lineSpace, "selectstart", function (e) {
      if (!eventInWidget(display, e)) { e_preventDefault(e); }
    });

    on(te, "compositionstart", function () {
      var start = cm.getCursor("from");
      if (input.composing) { input.composing.range.clear(); }
      input.composing = {
        start: start,
        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
      };
    });
    on(te, "compositionend", function () {
      if (input.composing) {
        input.poll();
        input.composing.range.clear();
        input.composing = null;
      }
    });
  };

  TextareaInput.prototype.createField = function (_display) {
    // Wraps and hides input textarea
    this.wrapper = hiddenTextarea();
    // The semihidden textarea that is focused when the editor is
    // focused, and receives input.
    this.textarea = this.wrapper.firstChild;
  };

  TextareaInput.prototype.prepareSelection = function () {
    // Redraw the selection and/or cursor
    var cm = this.cm, display = cm.display, doc = cm.doc;
    var result = prepareSelection(cm);

    // Move the hidden textarea near the cursor to prevent scrolling artifacts
    if (cm.options.moveInputWithCursor) {
      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                          headPos.top + lineOff.top - wrapOff.top));
      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                           headPos.left + lineOff.left - wrapOff.left));
    }

    return result
  };

  TextareaInput.prototype.showSelection = function (drawn) {
    var cm = this.cm, display = cm.display;
    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
    if (drawn.teTop != null) {
      this.wrapper.style.top = drawn.teTop + "px";
      this.wrapper.style.left = drawn.teLeft + "px";
    }
  };

  // Reset the input to correspond to the selection (or to be empty,
  // when not typing and nothing is selected)
  TextareaInput.prototype.reset = function (typing) {
    if (this.contextMenuPending || this.composing) { return }
    var cm = this.cm;
    if (cm.somethingSelected()) {
      this.prevInput = "";
      var content = cm.getSelection();
      this.textarea.value = content;
      if (cm.state.focused) { selectInput(this.textarea); }
      if (ie && ie_version >= 9) { this.hasSelection = content; }
    } else if (!typing) {
      this.prevInput = this.textarea.value = "";
      if (ie && ie_version >= 9) { this.hasSelection = null; }
    }
  };

  TextareaInput.prototype.getField = function () { return this.textarea };

  TextareaInput.prototype.supportsTouch = function () { return false };

  TextareaInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
      try { this.textarea.focus(); }
      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    }
  };

  TextareaInput.prototype.blur = function () { this.textarea.blur(); };

  TextareaInput.prototype.resetPosition = function () {
    this.wrapper.style.top = this.wrapper.style.left = 0;
  };

  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

  // Poll for input changes, using the normal rate of polling. This
  // runs as long as the editor is focused.
  TextareaInput.prototype.slowPoll = function () {
      var this$1 = this;

    if (this.pollingFast) { return }
    this.polling.set(this.cm.options.pollInterval, function () {
      this$1.poll();
      if (this$1.cm.state.focused) { this$1.slowPoll(); }
    });
  };

  // When an event has just come in that is likely to add or change
  // something in the input textarea, we poll faster, to ensure that
  // the change appears on the screen quickly.
  TextareaInput.prototype.fastPoll = function () {
    var missed = false, input = this;
    input.pollingFast = true;
    function p() {
      var changed = input.poll();
      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
      else {input.pollingFast = false; input.slowPoll();}
    }
    input.polling.set(20, p);
  };

  // Read input from the textarea, and update the document to match.
  // When something is selected, it is present in the textarea, and
  // selected (unless it is huge, in which case a placeholder is
  // used). When nothing is selected, the cursor sits after previously
  // seen text (can be empty), which is stored in prevInput (we must
  // not reset the textarea when typing, because that breaks IME).
  TextareaInput.prototype.poll = function () {
      var this$1 = this;

    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
    // Since this is called a *lot*, try to bail out as cheaply as
    // possible when it is clear that nothing happened. hasSelection
    // will be the case when there is a lot of text in the textarea,
    // in which case reading its value would be expensive.
    if (this.contextMenuPending || !cm.state.focused ||
        (hasSelection(input) && !prevInput && !this.composing) ||
        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
      { return false }

    var text = input.value;
    // If nothing changed, bail.
    if (text == prevInput && !cm.somethingSelected()) { return false }
    // Work around nonsensical selection resetting in IE9/10, and
    // inexplicable appearance of private area unicode characters on
    // some key combos in Mac (#2689).
    if (ie && ie_version >= 9 && this.hasSelection === text ||
        mac && /[\uf700-\uf7ff]/.test(text)) {
      cm.display.input.reset();
      return false
    }

    if (cm.doc.sel == cm.display.selForContextMenu) {
      var first = text.charCodeAt(0);
      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
    }
    // Find the part of the input that is actually new
    var same = 0, l = Math.min(prevInput.length, text.length);
    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

    runInOp(cm, function () {
      applyTextInput(cm, text.slice(same), prevInput.length - same,
                     null, this$1.composing ? "*compose" : null);

      // Don't leave long text in the textarea, since it makes further polling slow
      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
      else { this$1.prevInput = text; }

      if (this$1.composing) {
        this$1.composing.range.clear();
        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                           {className: "CodeMirror-composing"});
      }
    });
    return true
  };

  TextareaInput.prototype.ensurePolled = function () {
    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
  };

  TextareaInput.prototype.onKeyPress = function () {
    if (ie && ie_version >= 9) { this.hasSelection = null; }
    this.fastPoll();
  };

  TextareaInput.prototype.onContextMenu = function (e) {
    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
    if (input.contextMenuPending) { input.contextMenuPending(); }
    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
    if (!pos || presto) { return } // Opera is difficult.

    // Reset the current text selection only if the click is done outside of the selection
    // and 'resetSelectionOnContextMenu' option is true.
    var reset = cm.options.resetSelectionOnContextMenu;
    if (reset && cm.doc.sel.contains(pos) == -1)
      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
    input.wrapper.style.cssText = "position: static";
    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
    var oldScrollY;
    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
    display.input.focus();
    if (webkit) { window.scrollTo(null, oldScrollY); }
    display.input.reset();
    // Adds "Select all" to context menu in FF
    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
    input.contextMenuPending = rehide;
    display.selForContextMenu = cm.doc.sel;
    clearTimeout(display.detectingSelectAll);

    // Select-all will be greyed out if there's nothing to select, so
    // this adds a zero-width space so that we can later check whether
    // it got selected.
    function prepareSelectAllHack() {
      if (te.selectionStart != null) {
        var selected = cm.somethingSelected();
        var extval = "\u200b" + (selected ? te.value : "");
        te.value = "\u21da"; // Used to catch context-menu undo
        te.value = extval;
        input.prevInput = selected ? "" : "\u200b";
        te.selectionStart = 1; te.selectionEnd = extval.length;
        // Re-set this, in case some other handler touched the
        // selection in the meantime.
        display.selForContextMenu = cm.doc.sel;
      }
    }
    function rehide() {
      if (input.contextMenuPending != rehide) { return }
      input.contextMenuPending = false;
      input.wrapper.style.cssText = oldWrapperCSS;
      te.style.cssText = oldCSS;
      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

      // Try to detect the user choosing select-all
      if (te.selectionStart != null) {
        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
        var i = 0, poll = function () {
          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
              te.selectionEnd > 0 && input.prevInput == "\u200b") {
            operation(cm, selectAll)(cm);
          } else if (i++ < 10) {
            display.detectingSelectAll = setTimeout(poll, 500);
          } else {
            display.selForContextMenu = null;
            display.input.reset();
          }
        };
        display.detectingSelectAll = setTimeout(poll, 200);
      }
    }

    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
    if (captureRightClick) {
      e_stop(e);
      var mouseup = function () {
        off(window, "mouseup", mouseup);
        setTimeout(rehide, 20);
      };
      on(window, "mouseup", mouseup);
    } else {
      setTimeout(rehide, 50);
    }
  };

  TextareaInput.prototype.readOnlyChanged = function (val) {
    if (!val) { this.reset(); }
    this.textarea.disabled = val == "nocursor";
  };

  TextareaInput.prototype.setUneditable = function () {};

  TextareaInput.prototype.needsContentAttribute = false;

  function fromTextArea(textarea, options) {
    options = options ? copyObj(options) : {};
    options.value = textarea.value;
    if (!options.tabindex && textarea.tabIndex)
      { options.tabindex = textarea.tabIndex; }
    if (!options.placeholder && textarea.placeholder)
      { options.placeholder = textarea.placeholder; }
    // Set autofocus to true if this textarea is focused, or if it has
    // autofocus and no other element is focused.
    if (options.autofocus == null) {
      var hasFocus = activeElt();
      options.autofocus = hasFocus == textarea ||
        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
    }

    function save() {textarea.value = cm.getValue();}

    var realSubmit;
    if (textarea.form) {
      on(textarea.form, "submit", save);
      // Deplorable hack to make the submit method do the right thing.
      if (!options.leaveSubmitMethodAlone) {
        var form = textarea.form;
        realSubmit = form.submit;
        try {
          var wrappedSubmit = form.submit = function () {
            save();
            form.submit = realSubmit;
            form.submit();
            form.submit = wrappedSubmit;
          };
        } catch(e) {}
      }
    }

    options.finishInit = function (cm) {
      cm.save = save;
      cm.getTextArea = function () { return textarea; };
      cm.toTextArea = function () {
        cm.toTextArea = isNaN; // Prevent this from being ran twice
        save();
        textarea.parentNode.removeChild(cm.getWrapperElement());
        textarea.style.display = "";
        if (textarea.form) {
          off(textarea.form, "submit", save);
          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
            { textarea.form.submit = realSubmit; }
        }
      };
    };

    textarea.style.display = "none";
    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
      options);
    return cm
  }

  function addLegacyProps(CodeMirror) {
    CodeMirror.off = off;
    CodeMirror.on = on;
    CodeMirror.wheelEventPixels = wheelEventPixels;
    CodeMirror.Doc = Doc;
    CodeMirror.splitLines = splitLinesAuto;
    CodeMirror.countColumn = countColumn;
    CodeMirror.findColumn = findColumn;
    CodeMirror.isWordChar = isWordCharBasic;
    CodeMirror.Pass = Pass;
    CodeMirror.signal = signal;
    CodeMirror.Line = Line;
    CodeMirror.changeEnd = changeEnd;
    CodeMirror.scrollbarModel = scrollbarModel;
    CodeMirror.Pos = Pos;
    CodeMirror.cmpPos = cmp;
    CodeMirror.modes = modes;
    CodeMirror.mimeModes = mimeModes;
    CodeMirror.resolveMode = resolveMode;
    CodeMirror.getMode = getMode;
    CodeMirror.modeExtensions = modeExtensions;
    CodeMirror.extendMode = extendMode;
    CodeMirror.copyState = copyState;
    CodeMirror.startState = startState;
    CodeMirror.innerMode = innerMode;
    CodeMirror.commands = commands;
    CodeMirror.keyMap = keyMap;
    CodeMirror.keyName = keyName;
    CodeMirror.isModifierKey = isModifierKey;
    CodeMirror.lookupKey = lookupKey;
    CodeMirror.normalizeKeyMap = normalizeKeyMap;
    CodeMirror.StringStream = StringStream;
    CodeMirror.SharedTextMarker = SharedTextMarker;
    CodeMirror.TextMarker = TextMarker;
    CodeMirror.LineWidget = LineWidget;
    CodeMirror.e_preventDefault = e_preventDefault;
    CodeMirror.e_stopPropagation = e_stopPropagation;
    CodeMirror.e_stop = e_stop;
    CodeMirror.addClass = addClass;
    CodeMirror.contains = contains;
    CodeMirror.rmClass = rmClass;
    CodeMirror.keyNames = keyNames;
  }

  // EDITOR CONSTRUCTOR

  defineOptions(CodeMirror);

  addEditorMethods(CodeMirror);

  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
    { CodeMirror.prototype[prop] = (function(method) {
      return function() {return method.apply(this.doc, arguments)}
    })(Doc.prototype[prop]); } }

  eventMixin(Doc);
  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  CodeMirror.defineMode = function(name/*, mode, …*/) {
    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
    defineMode.apply(this, arguments);
  };

  CodeMirror.defineMIME = defineMIME;

  // Minimal default mode.
  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
  CodeMirror.defineMIME("text/plain", "null");

  // EXTENSIONS

  CodeMirror.defineExtension = function (name, func) {
    CodeMirror.prototype[name] = func;
  };
  CodeMirror.defineDocExtension = function (name, func) {
    Doc.prototype[name] = func;
  };

  CodeMirror.fromTextArea = fromTextArea;

  addLegacyProps(CodeMirror);

  CodeMirror.version = "5.52.0";

  return CodeMirror;

})));


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsConsentForm__wrapper__3Ok74","submitResult":"SettingsConsentForm__submitResult__YVGxn","actionWrapper":"SettingsConsentForm__actionWrapper__u6Mju","wrapper2faOptions":"SettingsConsentForm__wrapper2faOptions__3jt4p","previewFrame":"SettingsConsentForm__previewFrame__84x-w","checkoutButton":"SettingsConsentForm__checkoutButton__dnkjr","active":"SettingsConsentForm__active__2epAt"};

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsConsent__content__3HZ9r","parentContainer":"SettingsConsent__parentContainer__3m_ae","searchWrapper":"SettingsConsent__searchWrapper__TtyJ6","searchWrapperSearch":"SettingsConsent__searchWrapperSearch__3fA8c","activateBtn":"SettingsConsent__activateBtn__1Bzz0","searchWrapperLabel":"SettingsConsent__searchWrapperLabel__3SMwc","searchWrapperFilter":"SettingsConsent__searchWrapperFilter__1CICr","searchWrapperFilterItem":"SettingsConsent__searchWrapperFilterItem__33ChW","searchWrapperFilterLabel":"SettingsConsent__searchWrapperFilterLabel__3bjJD","clearButton":"SettingsConsent__clearButton__2H4ms","checkIcon":"SettingsConsent__checkIcon__3G8y_","clockIcon":"SettingsConsent__clockIcon__jVEYt","checkIconGray":"SettingsConsent__checkIconGray__uQV8F","warningIcon":"SettingsConsent__warningIcon__3YbbW","iconStatusWrapper":"SettingsConsent__iconStatusWrapper__3q2Gp","eventDropdownItem":"SettingsConsent__eventDropdownItem__1_XlF","actionIcon":"SettingsConsent__actionIcon__3Bovu","actions":"SettingsConsent__actions__382dF","filterConsentState":"SettingsConsent__filterConsentState__2prX8"};

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DocumentForm_DocumentForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_FileLink_FileLink__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reducers_user_selectors__ = __webpack_require__(37);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.Search;var DocumentsTraining = function (_React$Component) {
  _inherits(DocumentsTraining, _React$Component);function DocumentsTraining(props) {
    var _this2 = this;_classCallCheck(this, DocumentsTraining);var _this = _possibleConstructorReturn(this, (DocumentsTraining.__proto__ || Object.getPrototypeOf(DocumentsTraining)).call(this, props));_this.onNameSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ nameSearch: value, filter: null, site: null, eventsSelected: {} }, _this.getDocuments);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.getDocuments = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_25__api_requests__["_1" /* getDocumentsTrainingSearchRequest */])({ nameSearch: _this.state.nameSearch, order_direction: _this.state.order, page: page, per_page: per_page, order_column: __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(_this.state, 'sortedInfo.columnKey') });case 4:
              _ref3 = _context2.sent;data = _ref3.data;if (Array.isArray(data.data)) {
                _this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
              } else {
                _this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
              }_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt('return');case 14:
              _this.setState({ documents: null, errorMessage: __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(_context2.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.onNameChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getDocuments(pagination.current, pagination.pageSize);
      });
    };_this.state = { documents: [], nameSearch: null, errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, order: 'asc', currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, eventsSelected: {}, sortedInfo: { columnKey: 'order_index', order: 'ascend' }, documentEdit: null };return _this;
  }_createClass(DocumentsTraining, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.onNameSearch();case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          nameSearch = _state.nameSearch,
          documents = _state.documents,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          sortedInfo = _state.sortedInfo;var userTrainingReadPermission = this.props.userTrainingReadPermission;var columns = [{ dataIndex: "order_index", key: "order_index", title: "Index", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span', null, val);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order }, { dataIndex: "name", key: "name", title: "Document Name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.nameDocumentWrapper }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { style: { width: '86px' } }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null), record.state === 'active' && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_badge___default.a, { count: record.approved ? 'approved' : 'unapproved', style: { backgroundColor: record.approved ? '#52c41a' : '#777' } })), val);
        } }, { dataIndex: "type", key: "type", title: "Document Type", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_22__components_DocumentForm_DocumentForm__["b" /* documentTypes */][val]);
        } }, { dataIndex: "site", key: "site", title: "Site", render: function render(site) {
          return __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(site, 'name');
        } }, { dataIndex: "start_year", key: "start_year", title: "Start date" }, { dataIndex: "expiry_year", key: "expiry_year", title: "Expiry date" }, { dataIndex: "user", key: "user", title: "Uploaded by", render: function render(user) {
          return __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(user, 'username');
        } }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_FileLink_FileLink__["a" /* default */], { url: document.url }));
        } }];return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('h3', { className: 'headline-default' }, 'Training Documents'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_21__DocumentsTraining_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Search, { placeholder: 'By name', enterButton: 'Search', size: 'large', onSearch: this.onNameSearch, value: nameSearch, onChange: this.onNameChange, style: { maxWidth: '500px' } }))), userTrainingReadPermission && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { style: { margin: '20px 0' } }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["b" /* Link */], { to: routes.admin.training }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary' }, 'Go to quiz'))), errorMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: documents, loading: isLoading, rowKey: 'id', onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return DocumentsTraining;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTrainingReadPermission: Object(__WEBPACK_IMPORTED_MODULE_27__reducers_user_selectors__["_66" /* getUserTrainingReadPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_26__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(DocumentsTraining)));

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"DocumentsTraining__content__2mqjN","parentContainer":"DocumentsTraining__parentContainer__3ZxNR","searchWrapper":"DocumentsTraining__searchWrapper__3rdlP","searchWrapperSearch":"DocumentsTraining__searchWrapperSearch__3ogI-","searchWrapperLabel":"DocumentsTraining__searchWrapperLabel__1AgJG","searchWrapperFilter":"DocumentsTraining__searchWrapperFilter__1LiPO","searchWrapperFilterItem":"DocumentsTraining__searchWrapperFilterItem__1y_dI","searchWrapperFilterLabel":"DocumentsTraining__searchWrapperFilterLabel__2OQ-X","clearButton":"DocumentsTraining__clearButton__2oPm4","checkIcon":"DocumentsTraining__checkIcon__RsUqQ","clockIcon":"DocumentsTraining__clockIcon__269DW","checkIconGray":"DocumentsTraining__checkIconGray__3Q5ls","warningIcon":"DocumentsTraining__warningIcon__1rvd5","iconStatusWrapper":"DocumentsTraining__iconStatusWrapper__1g6jp","eventDropdownItem":"DocumentsTraining__eventDropdownItem__3hXDF","legendItem":"DocumentsTraining__legendItem__1B1vO","icon":"DocumentsTraining__icon__38fHv","actions":"DocumentsTraining__actions__27UNu","nameDocumentWrapper":"DocumentsTraining__nameDocumentWrapper__1wvew","switchLabel":"DocumentsTraining__switchLabel__145B7"};

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_DocumentForm_DocumentForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_FileLink_FileLink__ = __webpack_require__(104);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a.Search;var DocumentsPublic = function (_React$Component) {
  _inherits(DocumentsPublic, _React$Component);function DocumentsPublic(props) {
    var _this2 = this;_classCallCheck(this, DocumentsPublic);var _this = _possibleConstructorReturn(this, (DocumentsPublic.__proto__ || Object.getPrototypeOf(DocumentsPublic)).call(this, props));_this.onNameSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ nameSearch: value, filter: null, site: null, eventsSelected: {} }, _this.getDocuments);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.getDocuments = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_21__api_requests__["Z" /* getDocumentsPublicSearchRequest */])({ nameSearch: _this.state.nameSearch, order_direction: _this.state.order, page: page, per_page: per_page, order_column: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_this.state, 'sortedInfo.columnKey') });case 4:
              _ref3 = _context2.sent;data = _ref3.data;if (Array.isArray(data.data)) {
                _this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
              } else {
                _this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
              }_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt('return');case 14:
              _this.setState({ documents: null, errorMessage: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(_context2.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.onNameChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getDocuments(pagination.current, pagination.pageSize);
      });
    };_this.state = { documents: [], nameSearch: null, errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, order: 'asc', currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, eventsSelected: {}, sortedInfo: { columnKey: 'order_index', order: 'ascend' }, documentEdit: null };return _this;
  }_createClass(DocumentsPublic, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.onNameSearch();case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          nameSearch = _state.nameSearch,
          documents = _state.documents,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          sortedInfo = _state.sortedInfo;var columns = [{ dataIndex: "order_index", key: "order_index", title: "Index", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', null, val);
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order }, { dataIndex: "name", key: "name", title: "Document Name", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.nameDocumentWrapper }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { style: { width: '86px' } }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null), record.state === 'active' && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_badge___default.a, { count: record.approved ? 'approved' : 'unapproved', style: { backgroundColor: record.approved ? '#52c41a' : '#777' } })), val);
        } }, { dataIndex: "type", key: "type", title: "Document Type", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_19__components_DocumentForm_DocumentForm__["b" /* documentTypes */][val]);
        } }, { dataIndex: "site", key: "site", title: "Site", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(document, 'category') === 'public' && __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(val, 'name', 'General'), __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(document, 'category') !== 'public' && __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(val, 'name'));
        } }, { dataIndex: "start_year", key: "start_year", title: "Start date" }, { dataIndex: "expiry_year", key: "expiry_year", title: "Expiry date" }, { dataIndex: "user", key: "user", title: "Uploaded by", render: function render(user) {
          return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(user, 'username');
        } }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, document) {
          return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_FileLink_FileLink__["a" /* default */], { url: document.url }));
        } }];return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('h3', { className: 'headline-default' }, 'Public Documents'), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_18__DocumentsPublic_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(Search, { placeholder: 'By name', enterButton: 'Search', size: 'large', onSearch: this.onNameSearch, value: nameSearch, onChange: this.onNameChange, style: { maxWidth: '500px' } }))), errorMessage && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: documents, loading: isLoading, rowKey: 'id', onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), isLoading && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return DocumentsPublic;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);var mapStateToProps = function mapStateToProps() {
  return {};
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(DocumentsPublic)));

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"DocumentsPublic__content__3jmEN","parentContainer":"DocumentsPublic__parentContainer__3GxKY","searchWrapper":"DocumentsPublic__searchWrapper__2-I7w","searchWrapperSearch":"DocumentsPublic__searchWrapperSearch__1b5cD","searchWrapperLabel":"DocumentsPublic__searchWrapperLabel__3Mn8d","searchWrapperFilter":"DocumentsPublic__searchWrapperFilter__2VFRC","searchWrapperFilterItem":"DocumentsPublic__searchWrapperFilterItem__2ePAs","searchWrapperFilterLabel":"DocumentsPublic__searchWrapperFilterLabel__TNRVK","clearButton":"DocumentsPublic__clearButton__3S2Xg","checkIcon":"DocumentsPublic__checkIcon__1eLPQ","clockIcon":"DocumentsPublic__clockIcon__2J8U7","checkIconGray":"DocumentsPublic__checkIconGray__32sII","warningIcon":"DocumentsPublic__warningIcon__1w-tJ","iconStatusWrapper":"DocumentsPublic__iconStatusWrapper__3ozdC","eventDropdownItem":"DocumentsPublic__eventDropdownItem__3P9Hu","legendItem":"DocumentsPublic__legendItem__b2aL0","icon":"DocumentsPublic__icon__fnkNo","actions":"DocumentsPublic__actions__1B-0r","nameDocumentWrapper":"DocumentsPublic__nameDocumentWrapper__Lnp4z","switchLabel":"DocumentsPublic__switchLabel__3fkHe"};

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_SettingsUserRoleForm_SettingsUserRoleForm__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css__);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a.Content;var SettingsUserRoles = function (_React$Component) {
  _inherits(SettingsUserRoles, _React$Component);function SettingsUserRoles(props) {
    var _this2 = this;_classCallCheck(this, SettingsUserRoles);var _this = _possibleConstructorReturn(this, (SettingsUserRoles.__proto__ || Object.getPrototypeOf(SettingsUserRoles)).call(this, props));_this.getUser = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_17" /* getSettingsUserSingleRequest */])(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.props, 'match.params.userID'));case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ user: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.getSitesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref4, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_16" /* getSettingsSitesRequest */])({});case 3:
              _ref4 = _context2.sent;data = _ref4.data;_this.setState({ sitesList: data });_context2.next = 14;break;case 8:
              _context2.prev = 8;_context2.t0 = _context2['catch'](0);if (!(_context2.t0.response && _context2.t0.response.status === 401)) {
                _context2.next = 13;break;
              }_this.props.logout();return _context2.abrupt('return');case 13:
              console.log(_context2.t0);case 14:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 8]]);
    }));_this.getRolesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref6, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context3.prev = 1;_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_15" /* getSettingsRolesRequest */])();case 4:
              _ref6 = _context3.sent;data = _ref6.data;_this.setState({ rolesList: data });_context3.next = 15;break;case 9:
              _context3.prev = 9;_context3.t0 = _context3['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                _context3.next = 14;break;
              }_this.props.logout();return _context3.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context3.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context3.stop();}
        }
      }, _callee3, _this2, [[1, 9]]);
    }));_this.onSelectRole = function (role) {
      return function () {
        _this.setState({ selectedRole: null }, function () {
          _this.setState({ selectedRole: role });
        });
      };
    };_this.onRoleEditHide = function () {
      _this.setState({ selectedRole: null });
    };_this.onRoleEditSubmit = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee4(roleID) {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _this.props.setPermissions(_this.props.userToken);_context4.next = 3;return _this.getUser();case 3:
                _this.setState({ selectedRole: null }, function () {
                  _this.setState({ selectedRole: __WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.state.user, 'site_access_list', []), function (roleItem) {
                      return roleItem.id === roleID;
                    }) });
                });case 4:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2);
      }));return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }();_this.onAddRole = function () {
      _this.setState({ selectedRole: null }, function () {
        _this.setState({ selectedRole: {} });
      });
    };_this.state = { rolesList: [], sitesList: [], errorMessage: '', responseMessage: '', roleEdit: null, selectedRole: null, user: {} };return _this;
  }_createClass(SettingsUserRoles, [{ key: 'componentDidMount', value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                this.getUser();this.getRolesList();this.getSitesList();case 3:case 'end':
                return _context5.stop();}
          }
        }, _callee5, this);
      }));function componentDidMount() {
        return _ref8.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          rolesList = _state.rolesList,
          sitesList = _state.sitesList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          selectedRole = _state.selectedRole,
          user = _state.user;var roleCreatePermission = this.props.roleCreatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h3', { className: 'headline-default' }, 'User roles for ', __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(user, 'username', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'loading' }))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item, { href: '/admin/settings' }, 'Admin Settings'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item, { href: '/admin/settings/users' }, 'User Management'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item, null, 'User Role Management')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 24 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 6 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Select a site and role to edit')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a, { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.rolesList, bordered: true, dataSource: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(user, 'site_access_list', []), renderItem: function renderItem(item) {
          return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item, { className: __WEBPACK_IMPORTED_MODULE_22_classnames___default()(__WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.roleItem, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.active, item.id === __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(selectedRole, 'id'))), onClick: _this3.onSelectRole(item) }, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(item, 'site.name'), ' - ', __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(item, 'user_role.name'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default.a, { count: item.state, style: { backgroundColor: item.state === 'active' ? '#49c850' : '#f00' } }));
        } }), roleCreatePermission && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_31__SettingsUserRoles_css___default.a.roleActionWrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', onClick: this.onAddRole }, 'Add role'))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 18 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, '\xA0'), selectedRole && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_SettingsUserRoleForm_SettingsUserRoleForm__["a" /* default */], { selectedRole: selectedRole, userID: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(user, 'id'), isNew: selectedRole && !selectedRole.id, onSubmit: this.onRoleEditSubmit, onCancel: this.onRoleEditHide, rolesList: rolesList, sitesList: sitesList }))), errorMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { type: 'success', message: responseMessage })), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsUserRoles;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { roleCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_33" /* getRoleCreatePermission */])(state), userToken: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["_65" /* getUserToken */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_29__reducers_user_actions__["e" /* logout */], setPermissions: __WEBPACK_IMPORTED_MODULE_29__reducers_user_actions__["h" /* setPermissions */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUserRoles)));

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_map__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SettingsRoleForm_fieldsMap__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_classnames__);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}var SettingsUserRoleForm = function (_React$Component) {
  _inherits(SettingsUserRoleForm, _React$Component);function SettingsUserRoleForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsUserRoleForm);var _this = _possibleConstructorReturn(this, (SettingsUserRoleForm.__proto__ || Object.getPrototypeOf(SettingsUserRoleForm)).call(this, props));_this.showDeactivateModal = function () {
      _this.setState({ deactivateSubmitModal: true });
    };_this.hideDeactivateModal = function () {
      _this.setState({ deactivateSubmitModal: false });
    };_this.toggleActivate = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.prev = 0;_context.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["_46" /* toggleUserActivateRoleRequest */])(_this.props.userID, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.props, 'selectedRole.id'), _this.state.roleState);case 3:
              _this.setState({ requestResult: { type: 'success', message: 'Success' }, roleState: _this.state.roleState === 'inactive' ? 'active' : 'inactive' });_this.hideDeactivateModal();setTimeout(function () {
                _this.props.onSubmit(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.props, 'selectedRole.id'));
              }, 1000);_context.next = 11;break;case 8:
              _context.prev = 8;_context.t0 = _context['catch'](0);if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.status') === 401) {
                _this.props.logout();
              }case 11:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[0, 8]]);
    }));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
          var errors;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context2.next = 22;break;
                  }_this.setState({ isLoading: true });_context2.prev = 3;if (_this.props.isNew) {
                    _context2.next = 9;break;
                  }_context2.next = 7;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["_75" /* updateUserRoleRequest */])(_this.props.userID, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.props, 'selectedRole.id'), { user_id: _this.props.userID, site_id: values.site_id, user_role_id: values.user_role_id });case 7:
                  _context2.next = 11;break;case 9:
                  _context2.next = 11;return Object(__WEBPACK_IMPORTED_MODULE_24__api_requests__["D" /* createUserRoleRequest */])(_this.props.userID, { site_id: values.site_id, user_role_id: values.user_role_id });case 11:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context2.next = 22;break;case 15:
                  _context2.prev = 15;_context2.t0 = _context2['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                    _context2.next = 20;break;
                  }_this.props.logout();return _context2.abrupt('return');case 20:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 22:case 'end':
                  return _context2.stop();}
            }
          }, _callee2, _this2, [[3, 15]]);
        }));return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    };_this.collapseSection = function (sectionName) {
      return function () {
        _this.setState(function (state) {
          return { openGroups: Object.assign({}, state.openGroups, _defineProperty({}, sectionName, !state.openGroups[sectionName])) };
        });
      };
    };var openGroups = {};var fieldKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_28__SettingsRoleForm_fieldsMap__["a" /* default */]);fieldKeys.forEach(function (key) {
      openGroups[key] = true;
    });_this.state = { isLoading: false, requestResult: {}, deactivateSubmitModal: false, roleState: '', openGroups: openGroups };return _this;
  }_createClass(SettingsUserRoleForm, [{ key: 'componentDidMount', value: function componentDidMount() {
      this.setState({ roleState: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'selectedRole.state') });
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          deactivateSubmitModal = _state.deactivateSubmitModal,
          openGroups = _state.openGroups;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          userUpdatePermission = _props.userUpdatePermission,
          isNew = _props.isNew,
          rolesList = _props.rolesList,
          sitesList = _props.sitesList,
          selectedRole = _props.selectedRole;var selectedRolePermissions = __WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(rolesList, function (roleItem) {
        return roleItem.id === getFieldValue('user_role_id');
      }) || {};var isEditable = userUpdatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h4', { className: 'headline-default' }, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(selectedRole, 'id') ? 'Edit role' : isNew ? 'Add role' : ''), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Sites:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('site_id', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'selectedRole.site.id', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { disabled: !isEditable, placeholder: 'Select Site' }, sitesList.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, ' - ', site.name);
      })))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Roles:'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('user_role_id', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'selectedRole.user_role.id', '') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { disabled: !isEditable, placeholder: 'Select Role' }, rolesList.map(function (role) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { key: role.id, value: role.id, disabled: role.state === 'inactive' }, role.name);
      }))))))), !isNew && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: 'default', style: { backgroundColor: this.state.roleState === 'inactive' ? '#44c721' : '#f56009', borderColor: '#fff', color: '#fff' }, onClick: this.showDeactivateModal }, this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate')))), requestResult.type && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'loading' }))), '\xA0 \xA0', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel')), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), Object.keys(__WEBPACK_IMPORTED_MODULE_28__SettingsRoleForm_fieldsMap__["a" /* default */]).map(function (fieldGroupName) {
        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { key: fieldGroupName, className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.fieldGroupwrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h5', { className: __WEBPACK_IMPORTED_MODULE_29_classnames___default()('headline-default', __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.toggleHeadline), onClick: _this3.collapseSection(fieldGroupName) }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tooltip___default.a, { title: openGroups[fieldGroupName] ? 'collapse' : 'show' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { type: 'arrow-up', className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.collapseIcon, style: { fontSize: '20px', transform: 'rotate(' + (openGroups[fieldGroupName] ? '0' : '180deg') + ')' } }), ' \xA0'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.headlineText }, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_28__SettingsRoleForm_fieldsMap__["a" /* default */][fieldGroupName], 'name'))), openGroups[fieldGroupName] && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_28__SettingsRoleForm_fieldsMap__["a" /* default */][fieldGroupName], 'fields', []).map(function (field) {
          return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.fieldItemwrapper, key: field.key }, field.permissions ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h6', { className: 'headline-default' }, field.name), field.permissions.map(function (permission) {
            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { key: permission.key }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { className: selectedRolePermissions[field.key + '_' + permission.key] ? __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.iconOk : __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.iconNot, type: selectedRolePermissions[field.key + '_' + permission.key] ? 'check-square' : 'stop' }), '\xA0', permission.value);
          })) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h6', { className: 'headline-default' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a, { className: selectedRolePermissions[field.key] ? __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.iconOk : __WEBPACK_IMPORTED_MODULE_26__SettingsUserRoleForm_css___default.a.iconNot, type: selectedRolePermissions[field.key] ? 'check-square' : 'stop' }), ' \xA0', field.name));
        })));
      })), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { title: 'Role ' + (this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate'), visible: deactivateSubmitModal, onOk: this.toggleActivate, onCancel: this.hideDeactivateModal }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, 'Confirm role ', this.state.roleState === 'inactive' ? 'activate' : 'deactivate', ' action')));
    } }]);return SettingsUserRoleForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_25__reducers_user_selectors__["_68" /* getUserUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_27__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({ name: 'user' })(Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsUserRoleForm)));

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(121),
    baseIteratee = __webpack_require__(157),
    baseMap = __webpack_require__(563),
    isArray = __webpack_require__(79);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserRoleForm__wrapper__6voNf","submitResult":"SettingsUserRoleForm__submitResult__2YYoV","actionWrapper":"SettingsUserRoleForm__actionWrapper__4nmay","wrapper2faOptions":"SettingsUserRoleForm__wrapper2faOptions__FrUV6","fieldGroupwrapper":"SettingsUserRoleForm__fieldGroupwrapper__3hBTW","fieldItemwrapper":"SettingsUserRoleForm__fieldItemwrapper__phrrT","iconOk":"SettingsUserRoleForm__iconOk__KtRgv","iconNot":"SettingsUserRoleForm__iconNot__IdTyL","toggleHeadline":"SettingsUserRoleForm__toggleHeadline__2uR7O","collapseIcon":"SettingsUserRoleForm__collapseIcon__3S6n8","headlineText":"SettingsUserRoleForm__headlineText__wTpJb"};

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsUserRoles__content__3MVZl","parentContainer":"SettingsUserRoles__parentContainer__3rZsL","searchWrapper":"SettingsUserRoles__searchWrapper__3RNqg","searchWrapperSearch":"SettingsUserRoles__searchWrapperSearch__MxXJK","searchWrapperLabel":"SettingsUserRoles__searchWrapperLabel__1Bfp2","searchWrapperFilter":"SettingsUserRoles__searchWrapperFilter__2Xd5P","searchWrapperFilterItem":"SettingsUserRoles__searchWrapperFilterItem__22EFt","searchWrapperFilterLabel":"SettingsUserRoles__searchWrapperFilterLabel__3o6tO","clearButton":"SettingsUserRoles__clearButton__1FHKN","checkIcon":"SettingsUserRoles__checkIcon__3m5hW","clockIcon":"SettingsUserRoles__clockIcon__2iNm4","checkIconGray":"SettingsUserRoles__checkIconGray__8dk2B","warningIcon":"SettingsUserRoles__warningIcon__1PMaR","iconStatusWrapper":"SettingsUserRoles__iconStatusWrapper__CNOSD","eventDropdownItem":"SettingsUserRoles__eventDropdownItem__3zCSG","actionIcon":"SettingsUserRoles__actionIcon__1Pi1n","actions":"SettingsUserRoles__actions__2SYzg","roleActionWrapper":"SettingsUserRoles__roleActionWrapper__3V_2o","rolesList":"SettingsUserRoles__rolesList__2UJOm","roleItem":"SettingsUserRoles__roleItem__2Q-RF","active":"SettingsUserRoles__active__2oo4_"};

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_SettingsGeneralForm_SettingsGeneralForm__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_url__ = __webpack_require__(123);

























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var routes = __webpack_require__(65);var Content = __WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default.a.Content;var SettingsGeneral = function (_React$Component) {
  _inherits(SettingsGeneral, _React$Component);function SettingsGeneral(props) {
    var _this2 = this;_classCallCheck(this, SettingsGeneral);var _this = _possibleConstructorReturn(this, (SettingsGeneral.__proto__ || Object.getPrototypeOf(SettingsGeneral)).call(this, props));_this.getSettingsList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_32__api_requests__["_14" /* getSettingsGeneralRequest */])();case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ settingsList: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.columns = [{ dataIndex: 'name', key: 'name', title: 'Name', render: function render(val, record) {
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: record.state, style: { width: '56px', backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }), ' \xA0', val);
      } }, { dataIndex: 'content', key: 'content', title: 'Content' }, { dataIndex: 'id', key: 'id', title: 'Actions', render: function render(id, settings) {
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Edit Setting' }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default.a.actionIcon, onClick: _this.onSettingsEdit(settings) })), '\xA0\xA0', __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('b', null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Activate / Deactivate Setting' }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_switch___default.a, { disabled: settings.state === 'active' && !_this.props.settingsDeletePermission || settings.state === 'inactive' && !_this.props.settingsUpdatePermission, className: __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default.a.activateBtn, checked: settings.state === 'active', onChange: _this.onSwitchSettingsActivation(id, settings.state) }))));
      } }];_this.onSwitchSettingsActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;if (!(state === 'active')) {
                  _context2.next = 6;break;
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_32__api_requests__["M" /* deleteSettingsGeneralRequest */])(id);case 4:
                _context2.next = 8;break;case 6:
                _context2.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_32__api_requests__["f" /* activateSettingsGeneralRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success('Saved');_this.getSettingsList();_context2.next = 19;break;case 12:
                _context2.prev = 12;_context2.t0 = _context2['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_24_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                  _context2.next = 17;break;
                }_this.props.logout();return _context2.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('Error');console.log(_context2.t0);case 19:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 12]]);
      }));
    };_this.onSettingsEdit = function (settings) {
      return function () {
        _this.setState({ settingsEdit: settings });
      };
    };_this.onSettingsEditHide = function () {
      _this.setState({ settingsEdit: null });
    };_this.onSettingsEditSubmit = function () {
      _this.setState({ settingsEdit: null }, _this.getSettingsList);
    };_this.addSettings = function () {
      _this.setState({ settingsEdit: {} });
    };_this.state = { settingsList: [], errorMessage: '', responseMessage: '', settingsEdit: null };return _this;
  }_createClass(SettingsGeneral, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.getSettingsList();case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _state = this.state,
          settingsList = _state.settingsList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          settingsEdit = _state.settingsEdit;var settingsCreatePermission = this.props.settingsCreatePermission;return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_30__SettingsGeneral_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('h3', { className: 'headline-default' }, 'General Settings Management'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a, null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a.Item, { href: '/admin/settings' }, 'Admin Settings'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a.Item, null, 'General Settings Management')), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null), errorMessage && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), settingsCreatePermission && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', onClick: this.addSettings }, 'Add setting'), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: this.columns, dataSource: settingsList, loading: isLoading, rowKey: 'id', pagination: false }), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!settingsEdit, onCancel: this.onSettingsEditHide, footer: null }, settingsEdit && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_SettingsGeneralForm_SettingsGeneralForm__["a" /* default */], Object.assign({}, settingsEdit, { isNew: settingsEdit && !settingsEdit.id, onSubmit: this.onSettingsEditSubmit, onCancel: this.onSettingsEditHide })))), __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return SettingsGeneral;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { settingsCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_34__reducers_user_selectors__["H" /* getGeneralSettingsCreatePermission */])(state), settingsUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_34__reducers_user_selectors__["K" /* getGeneralSettingsUpdatePermission */])(state), settingsDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_34__reducers_user_selectors__["I" /* getGeneralSettingsDeletePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_33__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_31__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsGeneral)));

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__ = __webpack_require__(36);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var SettingsGeneralForm = function (_React$Component) {
  _inherits(SettingsGeneralForm, _React$Component);function SettingsGeneralForm(props) {
    var _this2 = this;_classCallCheck(this, SettingsGeneralForm);var _this = _possibleConstructorReturn(this, (SettingsGeneralForm.__proto__ || Object.getPrototypeOf(SettingsGeneralForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var settings, errors;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 23;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;settings = Object.assign({}, values);if (!_this.props.id) {
                    _context.next = 10;break;
                  }_context.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["_69" /* updateSettingsGeneralRequest */])(_this.props.id, settings);case 8:
                  _context.next = 12;break;case 10:
                  _context.next = 12;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["y" /* createSettingsGeneralRequest */])(settings);case 12:
                  _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 23;break;case 16:
                  _context.prev = 16;_context.t0 = _context["catch"](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.status") === 401)) {
                    _context.next = 21;break;
                  }_this.props.logout();return _context.abrupt("return");case 21:
                  _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors")) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 23:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 16]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {}, sites: [] };return _this;
  }_createClass(SettingsGeneralForm, [{ key: "componentDidMount", value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:case "end":
                return _context2.stop();}
          }
        }, _callee2, this);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var getFieldDecorator = this.props.form.getFieldDecorator;var _props = this.props,
          generalSettingsCreatePermission = _props.generalSettingsCreatePermission,
          generalSettingsUpdatePermission = _props.generalSettingsUpdatePermission,
          id = _props.id,
          isNew = _props.isNew;var isEditable = id ? generalSettingsUpdatePermission : generalSettingsCreatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h4", { className: "headline-default" }, this.props.id ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span", null, this.props.name, " ", __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default.a, { count: "Edit", style: { backgroundColor: "#2968AE" } })) : isNew ? "Add setting" : ""), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Name:"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("name", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "name", "") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: "Name" }))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Value:"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("content", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "content", "") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, placeholder: "Content" })))))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("b", null, "Type"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator("setting_type", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, "setting_type") })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a, { disabled: !isEditable, placeholder: "Setting type", style: { width: "100%" }, allowClear: true }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "contact_us_email" }, "Contact us email"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "password_expire_policy" }, "Password expire policy(days)"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "private_url_expire_policy" }, "Private url expire policy (seconds)"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "disable_private_urls" }, "Disable private urls"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option, { value: "maximum_number_of_subjects" }, "Maximum number of subjects"))))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0"), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_24__SettingsGeneralForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"))));
    } }]);return SettingsGeneralForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { generalSettingsCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__["H" /* getGeneralSettingsCreatePermission */])(state), generalSettingsUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__["K" /* getGeneralSettingsUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({ name: "settings-general" })(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SettingsGeneralForm)));

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsGeneralForm__wrapper__v2fvv","submitResult":"SettingsGeneralForm__submitResult__O86PN","actionWrapper":"SettingsGeneralForm__actionWrapper__1AFX1","wrapper2faOptions":"SettingsGeneralForm__wrapper2faOptions__1cSug"};

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"SettingsGeneral__content__2wx3q","parentContainer":"SettingsGeneral__parentContainer__3q3n6","searchWrapper":"SettingsGeneral__searchWrapper__Yd9iM","activateBtn":"SettingsGeneral__activateBtn__3lai2","searchWrapperSearch":"SettingsGeneral__searchWrapperSearch__GDTUu","searchWrapperLabel":"SettingsGeneral__searchWrapperLabel__KRJaV","searchWrapperFilter":"SettingsGeneral__searchWrapperFilter__SMvzY","searchWrapperFilterItem":"SettingsGeneral__searchWrapperFilterItem__2UYZi","searchWrapperFilterLabel":"SettingsGeneral__searchWrapperFilterLabel__t5-pK","clearButton":"SettingsGeneral__clearButton__2gvM9","checkIcon":"SettingsGeneral__checkIcon__2_K6-","clockIcon":"SettingsGeneral__clockIcon__iygY-","checkIconGray":"SettingsGeneral__checkIconGray__2e1Tt","warningIcon":"SettingsGeneral__warningIcon__2pJCB","iconStatusWrapper":"SettingsGeneral__iconStatusWrapper__bhdlO","eventDropdownItem":"SettingsGeneral__eventDropdownItem__3Roes","actionIcon":"SettingsGeneral__actionIcon__3BZyo","actions":"SettingsGeneral__actions__3GTG6"};

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__AuditLogs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_AuditForm_AuditForm__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_DocumentForm_DocumentForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__actionTypes__ = __webpack_require__(1913);





























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a.Content;var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;var errorLevelColors = { none: "#52c41a", low: "#c4c400", medium: "#c49904", high: "#ff2702", critical: "#c40200" };var AuditLogs = function (_React$Component) {
  _inherits(AuditLogs, _React$Component);function AuditLogs(props) {
    var _this2 = this;_classCallCheck(this, AuditLogs);var _this = _possibleConstructorReturn(this, (AuditLogs.__proto__ || Object.getPrototypeOf(AuditLogs)).call(this, props));_this.onNameSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ nameSearch: value, filter: null, site: null }, _this.getAudits);case 1:case "end":
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.getAudits = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["U" /* getAuditLogsRequest */])({ nameSearch: _this.state.nameSearch, order_direction: _this.state.order, page: page, per_page: per_page, order_column: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.state, "sortedInfo.columnKey"), filter_by: _this.state.filtersBy, filter_value: _this.state.filtersValue, filter_approve: _this.state.approvedSelected });case 4:
              _ref3 = _context2.sent;data = _ref3.data;if (Array.isArray(data.data)) {
                _this.setState({ audits: data.data, total: data.total_pages * per_page, currentPage: page });
              } else {
                _this.setState({ audits: [data], total: 1 * per_page, currentPage: page });
              }_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2["catch"](1);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context2.t0, "response.status") === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt("return");case 14:
              _this.setState({ audits: null, errorMessage: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context2.t0, "response.data.error", "Error") });case 15:
              _this.setState({ isLoading: false });case 16:case "end":
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.clearFilters = function () {
      _this.setState({ nameSearch: null, site: null, filter: null, filterValue: null, filterBy: null, sortedInfo: null, approvedSelected: null }, _this.getAudits);
    };_this.handleFilterChange = function (index) {
      return function (value) {
        _this.setState(function (state) {
          var filtersBy = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersBy);var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersBy[index] = value;delete filtersValue[index];return { filtersBy: filtersBy, filtersValue: filtersValue };
        });
      };
    };_this.handleFilterValueChange = function (index) {
      return Object(__WEBPACK_IMPORTED_MODULE_32_lodash__["debounce"])(function (value) {
        _this.setState(function (state) {
          var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersValue[index] = value;return { filtersValue: filtersValue };
        }, _this.getAudits);
      }, 500);
    };_this.clearFilter = function (index) {
      return function () {
        _this.setState(function (state) {
          var filtersBy = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersBy);var filtersValue = __WEBPACK_IMPORTED_MODULE_29_lodash_cloneDeep___default()(state.filtersValue);filtersBy.splice(index, 1);filtersValue.splice(index, 1);return { filtersBy: filtersBy, filtersValue: filtersValue };
        }, _this.getAudits);
      };
    };_this.onSelectApprovedStatus = function (approvedStatusType) {
      return function () {
        var status = void 0;var approvedSelected = _this.state.approvedSelected;if (approvedSelected === null && approvedStatusType === "approved") {
          status = false;
        }if (approvedSelected === true && approvedStatusType === "approved") {
          status = false;
        }if (approvedSelected === false && approvedStatusType === "approved") {
          status = null;
        }if (approvedSelected === null && approvedStatusType === "unapproved") {
          status = true;
        }if (approvedSelected === false && approvedStatusType === "unapproved") {
          status = true;
        }if (approvedSelected === true && approvedStatusType === "unapproved") {
          status = null;
        }_this.setState(function (_) {
          return { approvedSelected: status };
        }, _this.getAudits);
      };
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, "order") === "ascend" ? "asc" : __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sorter, "order") === "descend" ? "desc" : "asc" }, function () {
        return _this.getAudits(pagination.current, pagination.pageSize);
      });
    };_this.onAuditEdit = function (audit) {
      return function () {
        _this.setState({ auditEdit: audit });
      };
    };_this.onAuditEditHide = function () {
      _this.setState({ auditEdit: null });
    };_this.onAuditEditSubmit = function () {
      _this.setState({ auditEdit: null }, _this.getAudits);
    };_this.onSwitchAuditActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.prev = 0;if (!(state === "active")) {
                  _context3.next = 6;break;
                }_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["G" /* deleteAuditLogsRequest */])(id);case 4:
                _context3.next = 8;break;case 6:
                _context3.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["a" /* activateAuditLogsRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success("Saved");_this.getAudits();_context3.next = 19;break;case 12:
                _context3.prev = 12;_context3.t0 = _context3["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context3.t0, "response.status") === 401)) {
                  _context3.next = 17;break;
                }_this.props.logout();return _context3.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error("Error");console.log(_context3.t0);case 19:case "end":
                return _context3.stop();}
          }
        }, _callee3, _this2, [[0, 12]]);
      }));
    };_this.onResendClick = function (id) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result, msg;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _context4.prev = 0;_context4.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["_32" /* resendAuditLogsRequest */])(id);case 3:
                result = _context4.sent;msg = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(result, "data.message", "Email resent.");__WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success(msg);_this.getAudits();_context4.next = 16;break;case 9:
                _context4.prev = 9;_context4.t0 = _context4["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context4.t0, "response.status") === 401)) {
                  _context4.next = 14;break;
                }_this.props.logout();return _context4.abrupt("return");case 14:
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context4.t0, "response.data.error", "Error!"));console.log(_context4.t0);case 16:case "end":
                return _context4.stop();}
          }
        }, _callee4, _this2, [[0, 9]]);
      }));
    };_this.onSwitchAuditReview = function (id, reviewed) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                _context5.prev = 0;if (!reviewed) {
                  _context5.next = 6;break;
                }_context5.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["_54" /* unreviewedAuditLogsRequest */])(id);case 4:
                _context5.next = 8;break;case 6:
                _context5.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["_38" /* reviewedAuditLogsRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success("Saved");_this.getAudits();_context5.next = 19;break;case 12:
                _context5.prev = 12;_context5.t0 = _context5["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_context5.t0, "response.status") === 401)) {
                  _context5.next = 17;break;
                }_this.props.logout();return _context5.abrupt("return");case 17:
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error("Error");console.log(_context5.t0);case 19:case "end":
                return _context5.stop();}
          }
        }, _callee5, _this2, [[0, 12]]);
      }));
    };_this.renderFilterItem = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.filtersBy.length;var _this$state = _this.state,
          filtersBy = _this$state.filtersBy,
          filtersValue = _this$state.filtersValue,
          sites = _this$state.sites;return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.wrapperFilterItem, key: filtersBy[index] }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilter }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Filter by"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { onChange: _this.handleFilterChange(index), value: filtersBy[index], style: { width: "100%" }, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "action_type", disabled: filtersBy.includes("action_type") }, "Action type"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "error_level", disabled: filtersBy.includes("error_level") }, "Error level"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "result", disabled: filtersBy.includes("result") }, "Result"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "state", disabled: filtersBy.includes("state") }, "State"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "site", disabled: filtersBy.includes("site") }, "Site"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "user", disabled: filtersBy.includes("user") }, "User"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "audit_log_email_type", disabled: filtersBy.includes("audit_log_email_type") }, "Audit log email type")))), filtersBy[index] === "action_type" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Result"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: "multiple", showSearch: true, onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, Object.keys(__WEBPACK_IMPORTED_MODULE_42__actionTypes__["a" /* default */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { key: key, value: key }, __WEBPACK_IMPORTED_MODULE_42__actionTypes__["a" /* default */][key]);
      }))), filtersBy[index] === "error_level" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Result"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: "multiple", onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "none" }, "None"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "low" }, "Low"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "medium" }, "Medium"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "high" }, "High"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "critical" }, "Critical"))), filtersBy[index] === "result" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Result"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "success" }, "Success"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "failure" }, "Failure"))), filtersBy[index] === "state" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "State"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "active" }, "Active"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "inactive" }, "Inactive"))), filtersBy[index] === "audit_log_email_type" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Result"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "sent" }, "Sent"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: "not_sent" }, "Not sent"))), filtersBy[index] === "site" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "Site"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: "multiple", onChange: _this.handleFilterValueChange(index), value: filtersValue[index], style: { width: "100%" }, placeholder: "Select" }, sites.map(function (site) {
        return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { key: site.id, value: site.id }, site.code, " - ", site.name);
      }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Option, { value: null }, "None"))), filtersBy[index] === "user" && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItem }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperLabel }, "User"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default.a, { onChange: function onChange(e) {
          return _this.handleFilterValueChange(index)(e.target.value);
        }, style: { width: "100%" }, placeholder: "User" })), filtersValue[index] && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.clearButton, onClick: _this.clearFilter(index) }, "Remove")));
    };_this.state = { audits: [], nameSearch: null, errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, order: "desc", currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, sortedInfo: {}, auditEdit: null, filterBy: null, filterValue: null, filtersBy: [], filtersValue: [], approvedSelected: null };return _this;
  }_createClass(AuditLogs, [{ key: "componentDidMount", value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _ref8, data;return __WEBPACK_IMPORTED_MODULE_26_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {case 0:
                this.onNameSearch();_context6.prev = 1;_context6.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_37__api_requests__["_20" /* getSitesRequest */])();case 4:
                _ref8 = _context6.sent;data = _ref8.data;this.setState({ sites: data });_context6.next = 15;break;case 9:
                _context6.prev = 9;_context6.t0 = _context6["catch"](1);if (!(_context6.t0.response.status === 401)) {
                  _context6.next = 14;break;
                }this.props.logout();return _context6.abrupt("return");case 14:
                console.log(_context6.t0);case 15:case "end":
                return _context6.stop();}
          }
        }, _callee6, this, [[1, 9]]);
      }));function componentDidMount() {
        return _ref7.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          errorMessage = _state.errorMessage,
          isLoading = _state.isLoading,
          responseMessage = _state.responseMessage,
          nameSearch = _state.nameSearch,
          audits = _state.audits,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          auditEdit = _state.auditEdit,
          sortedInfo = _state.sortedInfo,
          filtersBy = _state.filtersBy,
          filtersValue = _state.filtersValue,
          sites = _state.sites,
          approvedSelected = _state.approvedSelected;var columns = [{ dataIndex: "id", key: "id", title: "State/ Reviewed", render: function render(val, record) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.nameAuditWrapper }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { width: "86px" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === "active" ? "#52c41a" : "#777" } }), "\xA0", __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.reviewed ? "reviewed" : "unreviewed", style: { backgroundColor: record.reviewed ? "#52c41a" : "#777" } })));
        } }, { dataIndex: "site", key: "site", title: "Site", render: function render(site) {
          return __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(site, "name");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "site" && sortedInfo.order }, { dataIndex: "result", key: "result", title: "Result", render: function render(val, audit) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: audit.message }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: val, style: { backgroundColor: val === "success" ? "#52c41a" : "#f00" } }));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "result" && sortedInfo.order }, { dataIndex: "error_level", key: "error_level", title: "Error level", sorter: true, render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: val, style: { backgroundColor: errorLevelColors[val] } });
        }, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "error_level" && sortedInfo.order }, { dataIndex: "user", key: "user", title: "User", render: function render(user) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(user, "username"));
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "user" && sortedInfo.order }, { dataIndex: "action_type", key: "action_type", title: "Action type", render: function render(val) {
          return val.replace(/_/g, " ");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "action_type" && sortedInfo.order }, { dataIndex: "created", key: "created", title: "Created", render: function render(val) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", null, __WEBPACK_IMPORTED_MODULE_30_moment_timezone___default.a.utc(val).tz(_this3.props.userTimezone || "UTC").format("YYYY-MM-DD, HH:mm"), " ", "\xA0", _this3.props.userShortTimezone || "UTC");
        }, sorter: true, sortOrder: __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(sortedInfo, "columnKey") === "created" && sortedInfo.order }, { dataIndex: "id", key: "id_actions", title: "Actions", render: function render(val, audit) {
          return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Edit Audit" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a, { type: "edit", theme: "filled", className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.iconEdit, onClick: _this3.onAuditEdit(audit) })), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { width: "60px", display: "flex" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.switchLabel }, "State"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Activate / Deactivate Audit" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { disabled: !_this3.props.auditLogUpdatePermission && audit.state === "inactive" || !_this3.props.auditLogDeletePermission && audit.state === "active", className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.reactivateBtn, checked: audit.state === "active", onChange: _this3.onSwitchAuditActivation(val, audit.state) })))), "\xA0 \xA0", __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { width: "60px", display: "flex" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("b", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.switchLabel }, "Reviewed"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Reviewed / Unreviewed Audit" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { disabled: !_this3.props.auditLogReviewPermission, className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.reactivateBtn, checked: audit.reviewed, onChange: _this3.onSwitchAuditReview(val, audit.reviewed) })))), audit.action_type.endsWith("_email") && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { width: "60px", display: "flex" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: "topLeft", title: "Resend email notification" }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a, { type: "primary", size: "small", className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.resendBtn, onClick: _this3.onResendClick(audit.id) }, "Resend"))));
        } }];return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("h3", { className: "headline-default" }, "Audit logs"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("h4", { className: "headline-default" }, "Filter"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.wrapperFilters }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.searchWrapperFilterItemApprove }, __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: this.onSelectApprovedStatus("approved"), checked: approvedSelected === null || approvedSelected === true }, "Reviewed"), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a, { onChange: this.onSelectApprovedStatus("unapproved"), checked: !approvedSelected }, "Unreviewed")), filtersBy.map(function (_, index) {
        return _this3.renderFilterItem(index);
      }), filtersBy.length === filtersValue.length && filtersBy.length !== 5 && this.renderFilterItem()), errorMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: "error", message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: "success", message: responseMessage }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: audits, loading: isLoading, rowKey: "id", onChange: this.handleTableChange, className: __WEBPACK_IMPORTED_MODULE_35__AuditLogs_css___default.a.table, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ["10", "25", "50", "100"] } }), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!auditEdit, onCancel: this.onAuditEditHide, footer: null }, auditEdit && __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_AuditForm_AuditForm__["a" /* default */], Object.assign({}, auditEdit, { isNew: auditEdit && !auditEdit.id, onSubmit: this.onAuditEditSubmit, onCancel: this.onAuditEditHide })))), __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return AuditLogs;
}(__WEBPACK_IMPORTED_MODULE_27_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), auditLogDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["b" /* getAuditLogDeletePermission */])(state), auditLogUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["e" /* getAuditLogUpdatePermission */])(state), auditLogReviewPermission: Object(__WEBPACK_IMPORTED_MODULE_39__reducers_user_selectors__["d" /* getAuditLogReviewPermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_38__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_36__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_31_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(AuditLogs)));

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"AuditLogs__content__h1LoQ","parentContainer":"AuditLogs__parentContainer__3UeRz","searchWrapper":"AuditLogs__searchWrapper__BE6NI","wrapperFilterItem":"AuditLogs__wrapperFilterItem__2uiM0","searchWrapperSearch":"AuditLogs__searchWrapperSearch__3V50B","searchWrapperLabel":"AuditLogs__searchWrapperLabel__2bX8e","searchWrapperFilter":"AuditLogs__searchWrapperFilter__t5OrO","searchWrapperFilterItem":"AuditLogs__searchWrapperFilterItem__T2QVR","searchWrapperFilterLabel":"AuditLogs__searchWrapperFilterLabel__33t5w","clearButton":"AuditLogs__clearButton__1Ltlx","checkIcon":"AuditLogs__checkIcon__1GvQo","clockIcon":"AuditLogs__clockIcon__12umt","checkIconGray":"AuditLogs__checkIconGray__3IlTv","warningIcon":"AuditLogs__warningIcon__2EEEK","iconStatusWrapper":"AuditLogs__iconStatusWrapper__3paT1","eventDropdownItem":"AuditLogs__eventDropdownItem__2DLmj","legendItem":"AuditLogs__legendItem__1mF-0","icon":"AuditLogs__icon__18_uQ","iconEdit":"AuditLogs__iconEdit__2B996","reactivateBtn":"AuditLogs__reactivateBtn__2c8O3","actions":"AuditLogs__actions__2iZxC","nameAuditWrapper":"AuditLogs__nameAuditWrapper__1jxV4","switchLabel":"AuditLogs__switchLabel__iF5EQ","table":"AuditLogs__table__1HTSz","resendBtn":"AuditLogs__resendBtn__1CMk6","searchWrapperFilterItemApprove":"AuditLogs__searchWrapperFilterItemApprove__37-oK"};

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AuditForm_css__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__AuditForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__ = __webpack_require__(36);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var AuditForm = function (_React$Component) {
  _inherits(AuditForm, _React$Component);function AuditForm(props) {
    var _this2 = this;_classCallCheck(this, AuditForm);var _this = _possibleConstructorReturn(this, (AuditForm.__proto__ || Object.getPrototypeOf(AuditForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var audit, errors;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 18;break;
                  }_this.setState({ isLoading: true });_context.prev = 3;audit = Object.assign({}, values);_context.next = 7;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["_57" /* updateAuditLogsRequest */])(_this.props.id, audit);case 7:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context.next = 18;break;case 11:
                  _context.prev = 11;_context.t0 = _context['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                    _context.next = 16;break;
                  }_this.props.logout();return _context.abrupt('return');case 16:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 18:case 'end':
                  return _context.stop();}
            }
          }, _callee, _this2, [[3, 11]]);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.state = { isLoading: false, requestResult: {}, sites: [] };return _this;
  }_createClass(AuditForm, [{ key: 'componentDidMount', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_22__api_requests__["_16" /* getSettingsSitesRequest */])();case 3:
                _ref3 = _context2.sent;data = _ref3.data;this.setState({ sites: data });_context2.next = 14;break;case 8:
                _context2.prev = 8;_context2.t0 = _context2['catch'](0);if (!(_context2.t0.response.status === 401)) {
                  _context2.next = 13;break;
                }this.props.logout();return _context2.abrupt('return');case 13:
                console.log(_context2.t0);case 14:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this, [[0, 8]]);
      }));function componentDidMount() {
        return _ref2.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          sites = _state.sites;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          auditUpdatePermission = _props.auditUpdatePermission,
          isNew = _props.isNew;var categoryVal = getFieldValue('category');var isEditable = auditUpdatePermission;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h4', { className: 'headline-default' }, this.props.id ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', null, 'Audit Log', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_badge___default.a, { count: 'Edit', style: { backgroundColor: '#2968AE' } })) : isNew ? 'Create audit' : ''), this.props.subject && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Subject'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'subject.code'))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Message'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p', null, this.props.message), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', null, 'Comments'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, getFieldDecorator('comments', { initialValue: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(this.props, 'comments') })(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea, { disabled: !isEditable })))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', size: 'large', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_24__AuditForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel'))));
    } }]);return AuditForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { auditUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_23__reducers_user_selectors__["e" /* getAuditLogUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_25__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({ name: 'user' })(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(AuditForm)));

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AuditForm__wrapper__1nbRM","submitResult":"AuditForm__submitResult__19irb","actionWrapper":"AuditForm__actionWrapper__2OTzk","wrapper2faOptions":"AuditForm__wrapper2faOptions__1VdZo"};

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({ two_day_reminder_notification_email: "Two day reminder notification email", seven_day_reminder_notification_email: "Seven day reminder notification email", ninety_day_follow_up_completed_notification_email: "Ninety day follow up completed notification email", account_my_profile: "Account my profile", account_my_profile_mfa_settings: "Account my profile mfa settings", account_my_profile_notifications: "Account my profile notifications", account_my_profile_password: "Account my profile password", admin_account_permissions: "Admin account permissions", admin_consent_settings_activate: "Admin consent settings activate", admin_consent_settings_create: "Admin consent settings create", admin_consent_settings_deactivate: "Admin consent settings deactivate", admin_consent_settings_list: "Admin consent settings list", admin_consent_settings_record: "Admin consent settings record", admin_consent_settings_update: "Admin consent settings update", admin_dashboard: "Admin dashboard", admin_dashboard_follow_up_records: "Admin dashboard follow up records", admin_document_management: "Admin document management", admin_document_management_item: "Admin document management item", admin_document_management_item_activate: "Admin document management item activate", admin_document_management_item_approved: "Admin document management item approved", admin_document_management_item_create: "Admin document management item create", admin_document_management_item_deactivate: "Admin document management item deactivate", admin_document_management_item_unapproved: "Admin document management item unapproved", admin_document_management_item_update: "Admin document management item update", admin_document_public: "Admin document public", admin_document_training: "Admin document training", admin_follow_up_item: "Admin follow up item", admin_follow_up_item_create: "Admin follow up item create", admin_follow_up_item_deactivate: "Admin follow up item deactivate", admin_follow_up_item_lock: "Admin follow up item lock", admin_follow_up_item_unlock: "Admin follow up item unlock", admin_follow_up_item_update: "Admin follow up item update", admin_general_settings_activate: "Admin general settings activate", admin_general_settings_create: "Admin general settings create", admin_general_settings_deactivate: "Admin general settings deactivate", admin_general_settings_list: "Admin general settings list", admin_general_settings_record: "Admin general settings record", admin_general_settings_update: "Admin general settings update", admin_permissions_list: "Admin permissions list", admin_sae_item: "Admin sae item", admin_sae_item_activated: "Admin sae item activated", admin_sae_item_create: "Admin sae item create", admin_sae_item_deactivated: "Admin sae item deactivated", admin_sae_item_lock: "Admin sae item lock", admin_sae_item_unlock: "Admin sae item unlock", admin_sae_item_update: "Admin sae item update", admin_sae_list: "Admin sae list", admin_site_create: "Admin site create", admin_site_item: "Admin site item", admin_site_item_activate: "Admin site item activate", admin_site_item_deactivate: "Admin site item deactivate", admin_site_item_update: "Admin site item update", admin_site_list: "Admin site list", admin_user_roles_create: "Admin user roles create", admin_user_roles_item: "Admin user roles item", admin_user_roles_item_activate: "Admin user roles item activate", admin_user_roles_item_deactivate: "Admin user roles item deactivate", admin_user_roles_item_update: "Admin user roles item update", admin_user_roles_list: "Admin user roles list", admin_user_site_access_activate: "Admin user site access activate", admin_user_site_access_create: "Admin user site access create", admin_user_site_access_deactivate: "Admin user site access deactivate", admin_user_site_access_update: "Admin user site access update", admin_users_item: "Admin users item", admin_users_item_activate: "Admin users item activate", admin_users_item_create: "Admin users item create", admin_users_item_deactivate: "Admin users item deactivate", admin_users_item_update: "Admin users item update", admin_users_list: "Admin users list", consent: "Consent", consent_recorded_notification_email: "Consent recorded notification email", consent_step_1: "Consent step 1", consent_step_3_electronic: "Consent step 3 electronic", consent_step_3_paper: "Consent step 3 paper", contact_us: "Contact us", contact_us_email: "Contact us email", death_occurred_notification_email: "Death occurred notification email", document_approved_notification_email: "Document approved notification email", document_pending_approval_notification_email: "Document pending approval notification email", new_site_notification_email: "New site notification email", new_user_welcome_email: "New user welcome email", owned_site_list: "Owned site list", patient_item: "Patient item", patient_item_activate: "Patient item activate", patient_item_deactivate: "Patient item deactivate", patient_list: "Patient list", patient_list_by_event: "Patient list by event", patient_list_by_site: "Patient list by site", patient_profile_item: "Patient profile item", patient_profile_item_create: "Patient profile item create", patient_profile_item_lock: "Patient profile item lock", patient_profile_item_unlock: "Patient profile item unlock", patient_profile_item_update: "Patient profile item update", patient_profile_list: "Patient profile list", patient_profile_preview_item_deactivate: "Patient profile preview item deactivate", randomization: "Randomization", randomization_follow_up_create: "Randomization follow up create", report_subject_summary_notification_email: "Report subject summary notification email", resource_permission_check: "Resource permission check", sae_occurred_notification_email: "Sae occurred notification email", sae_reporting: "Sae reporting", sae_reporting_step_1: "Sae reporting step 1", sae_reporting_step_2: "Sae reporting step 2", site_access_list: "Site access list", site_suspended_notification_email: "Site suspended notification email", sms: "Sms", subject_randomization_detailed_email: "Subject randomization detailed email", subject_randomization_summary_email: "Subject randomization summary email", trial_documents: "Trial documents", user_login: "User login", user_login_validate_mfa_code: "User login validate mfa code", user_login_with_mfa: "User login with mfa", user_login_with_mfa_email: "User login with mfa email", user_login_with_mfa_sms: "User login with mfa sms", user_login_without_mfa: "User login without mfa", user_logout: "User logout", user_recover: "User recover", user_recover_confirm_token: "User recover confirm token", user_recover_email: "User recover email", user_recover_update_password: "User recover update password", validate_randomization_notification_email: "Validate randomization notification email", validation: "Validation", validation_differs_from_randomization_notification_email: "Validation differs from randomization notification email", validation_protocol_deviation_notification_email: "Validation protocol deviation notification email", validation_step_1: "Validation step 1", validation_step_3: "Validation step 3", audit_log_list: "Audit Log List", audit_log_item: "Audit Log Item", audit_log_item_edit: "Audit Log Item Edit", audit_log_item_deactivate: "Audit Log Item Deactivate", audit_log_item_activate: "Audit Log Item Activate", audit_log_item_reviewed: "Audit Log Item Reviewed", audit_log_item_unreviewed: "Audit Log Item Unreviewed", audit_log_item_email_resend: "Audit Log Item Email Resend", randomization_rate_limit: "Randomization Rate Limit", audit_log_simulation_generate_csv: "Audit Log Simulation Generated CSV file", audit_log_simulation_list: "Audit Log Simulation List", audit_log_simulation_item_create: "Audit Log Simulation Item Create", audit_log_simulation_item: "Audit Log Simulation Item", audit_log_simulation_item_update: "Audit Log Simulation Item Update", audit_log_simulation_item_deactivate: "Audit Log Simulation Item Deactivate", audit_log_simulation_item_activate: "Audit Log Simulation Item Activate", newsletter_email: "Newsletter email" });

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment_timezone__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ant_design_icons__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_SimulationForm_SimulationForm__ = __webpack_require__(3495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Simulation_css__ = __webpack_require__(3529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__Simulation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_FileLink_FileLink__ = __webpack_require__(104);























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default.a.Content;var statusColors = { not_started: '#777', ready: '#c4c400', in_progress: '#c4c400', completed: '#14950b' };var Simulation = function (_React$Component) {
  _inherits(Simulation, _React$Component);function Simulation(props) {
    var _this2 = this;_classCallCheck(this, Simulation);var _this = _possibleConstructorReturn(this, (Simulation.__proto__ || Object.getPrototypeOf(Simulation)).call(this, props));_this.getSimulationList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["_19" /* getSimulationRequest */])();case 4:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ simulationList: data });_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              _this.setState({ subject: null, errorMessage: __WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.columns = [{ dataIndex: "name", key: "name", title: "Name", render: function render(val, record) {
        return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span', null, val, ' \xA0 ', __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: record.state, style: { backgroundColor: record.state === 'active' ? '#52c41a' : '#777' } }));
      } }, { dataIndex: "simulation_date", key: "simulation_date", title: "Simulation date", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_24_moment_timezone___default.a.utc(val).tz(_this.props.userTimezone || 'UTC').format('YYYY-MM-DD HH:mm'), ' \xA0', _this.props.userShortTimezone || 'UTC');
      } }, { dataIndex: "subject_count", key: "subject_count", title: "Number of patients" }, { dataIndex: "simulation_count", key: "simulation_count", title: "Number of Simulations" }, { dataIndex: "min_weight", key: "min_weight", title: "Min weight" }, { dataIndex: "max_weight", key: "max_weight", title: "Max weight" }, { dataIndex: "status", key: "status", title: "Status", render: function render(val) {
        return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: val.replace(/_/g, ' '), style: { backgroundColor: statusColors[val] } });
      } }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, simulation) {
        return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Edit simulation' }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default.a.actionIcon, onClick: _this.onSimulationEdit(simulation) })), simulation.link && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_FileLink_FileLink__["a" /* default */], { url: simulation.link }), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('b', null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Activate / Deactivate simulation' }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a, { disabled: simulation.state === 'active' && !_this.props.simulationDeletePermission || simulation.state === 'inactive' && !_this.props.simulationUpdatePermission, className: __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default.a.activateBtn, checked: simulation.state === 'active', onChange: _this.onSwitchSimulationActivation(simulation.id, simulation.state) }))));
      } }];_this.onSwitchSimulationActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;if (!(state === 'active')) {
                  _context2.next = 6;break;
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["N" /* deleteSimulationRequest */])(id);case 4:
                _context2.next = 8;break;case 6:
                _context2.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["g" /* activateSimulationRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success('Saved');_this.getSimulationList();_context2.next = 19;break;case 12:
                _context2.prev = 12;_context2.t0 = _context2['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                  _context2.next = 17;break;
                }_this.props.logout();return _context2.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_22_lodash_get___default()(_context2.t0, 'response.data.error', 'Error'));console.log(_context2.t0);case 19:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 12]]);
      }));
    };_this.onSimulationEdit = function (simulation) {
      return function () {
        _this.setState({ simulationEdit: simulation });
      };
    };_this.onSimulationEditHide = function () {
      _this.setState({ simulationEdit: null });
    };_this.onSimulationEditSubmit = function () {
      _this.setState({ simulationEdit: null }, _this.getSimulationList);
    };_this.addSimulation = function () {
      _this.setState({ simulationEdit: {} });
    };_this.state = { simulationList: [], errorMessage: '', responseMessage: '', simulationEdit: null };return _this;
  }_createClass(Simulation, [{ key: 'componentDidMount', value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                this.getSimulationList();case 1:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref4.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _state = this.state,
          simulationList = _state.simulationList,
          errorMessage = _state.errorMessage,
          responseMessage = _state.responseMessage,
          isLoading = _state.isLoading,
          simulationEdit = _state.simulationEdit;var simulationCreatePermission = this.props.simulationCreatePermission;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_29__Simulation_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('h3', { className: 'headline-default' }, 'Simulation management'), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), simulationCreatePermission && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', onClick: this.addSimulation }, 'Add simulation'), '  ', __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tooltip___default.a, { title: 'Refresh' }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', onClick: this.getSimulationList, shape: 'circle' }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ant_design_icons__["a" /* SyncOutlined */], { spin: isLoading }))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('br', null), errorMessage && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'error', message: errorMessage }), responseMessage && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { type: 'success', message: responseMessage }), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: this.columns, dataSource: simulationList, loading: isLoading, rowKey: 'id', pagination: false }), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!simulationEdit, onCancel: this.onSimulationEditHide, footer: null }, simulationEdit && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_SimulationForm_SimulationForm__["a" /* default */], Object.assign({}, simulationEdit, { isNew: simulationEdit && !simulationEdit.id, onSubmit: this.onSimulationEditSubmit, onCancel: this.onSimulationEditHide })))), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Simulation;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { userTimezone: Object(__WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__["_64" /* getUserTimezone */])(state), userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), simulationCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__["_48" /* getSimulationCreatePermission */])(state), simulationDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__["_49" /* getSimulationDeletePermission */])(state), simulationUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_33__reducers_user_selectors__["_51" /* getSimulationUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_32__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_30__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Simulation)));

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons__ = __webpack_require__(1916);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__icons__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_twoTonePrimaryColor__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IconFont__ = __webpack_require__(3494);
/* unused harmony reexport createFromIconfontCN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icon__ = __webpack_require__(578);
/* unused harmony reexport default */





/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountBookFilled__ = __webpack_require__(1917);
/* unused harmony reexport AccountBookFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountBookOutlined__ = __webpack_require__(1920);
/* unused harmony reexport AccountBookOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccountBookTwoTone__ = __webpack_require__(1922);
/* unused harmony reexport AccountBookTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AimOutlined__ = __webpack_require__(1924);
/* unused harmony reexport AimOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlertFilled__ = __webpack_require__(1926);
/* unused harmony reexport AlertFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AlertOutlined__ = __webpack_require__(1928);
/* unused harmony reexport AlertOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AlertTwoTone__ = __webpack_require__(1930);
/* unused harmony reexport AlertTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AlibabaOutlined__ = __webpack_require__(1932);
/* unused harmony reexport AlibabaOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AlignCenterOutlined__ = __webpack_require__(1934);
/* unused harmony reexport AlignCenterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AlignLeftOutlined__ = __webpack_require__(1936);
/* unused harmony reexport AlignLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AlignRightOutlined__ = __webpack_require__(1938);
/* unused harmony reexport AlignRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AlipayCircleFilled__ = __webpack_require__(1940);
/* unused harmony reexport AlipayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AlipayCircleOutlined__ = __webpack_require__(1942);
/* unused harmony reexport AlipayCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AlipayOutlined__ = __webpack_require__(1944);
/* unused harmony reexport AlipayOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AlipaySquareFilled__ = __webpack_require__(1946);
/* unused harmony reexport AlipaySquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AliwangwangFilled__ = __webpack_require__(1948);
/* unused harmony reexport AliwangwangFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AliwangwangOutlined__ = __webpack_require__(1950);
/* unused harmony reexport AliwangwangOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AliyunOutlined__ = __webpack_require__(1952);
/* unused harmony reexport AliyunOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AmazonCircleFilled__ = __webpack_require__(1954);
/* unused harmony reexport AmazonCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AmazonOutlined__ = __webpack_require__(1956);
/* unused harmony reexport AmazonOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AmazonSquareFilled__ = __webpack_require__(1958);
/* unused harmony reexport AmazonSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AndroidFilled__ = __webpack_require__(1960);
/* unused harmony reexport AndroidFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AndroidOutlined__ = __webpack_require__(1962);
/* unused harmony reexport AndroidOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AntCloudOutlined__ = __webpack_require__(1964);
/* unused harmony reexport AntCloudOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AntDesignOutlined__ = __webpack_require__(1966);
/* unused harmony reexport AntDesignOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ApartmentOutlined__ = __webpack_require__(1968);
/* unused harmony reexport ApartmentOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ApiFilled__ = __webpack_require__(1970);
/* unused harmony reexport ApiFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ApiOutlined__ = __webpack_require__(1972);
/* unused harmony reexport ApiOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ApiTwoTone__ = __webpack_require__(1974);
/* unused harmony reexport ApiTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AppleFilled__ = __webpack_require__(1976);
/* unused harmony reexport AppleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AppleOutlined__ = __webpack_require__(1978);
/* unused harmony reexport AppleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AppstoreAddOutlined__ = __webpack_require__(1980);
/* unused harmony reexport AppstoreAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AppstoreFilled__ = __webpack_require__(1982);
/* unused harmony reexport AppstoreFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__AppstoreOutlined__ = __webpack_require__(1984);
/* unused harmony reexport AppstoreOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AppstoreTwoTone__ = __webpack_require__(1986);
/* unused harmony reexport AppstoreTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__AreaChartOutlined__ = __webpack_require__(1988);
/* unused harmony reexport AreaChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ArrowDownOutlined__ = __webpack_require__(1990);
/* unused harmony reexport ArrowDownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ArrowLeftOutlined__ = __webpack_require__(1992);
/* unused harmony reexport ArrowLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ArrowRightOutlined__ = __webpack_require__(1994);
/* unused harmony reexport ArrowRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ArrowUpOutlined__ = __webpack_require__(1996);
/* unused harmony reexport ArrowUpOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ArrowsAltOutlined__ = __webpack_require__(1998);
/* unused harmony reexport ArrowsAltOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__AudioFilled__ = __webpack_require__(2000);
/* unused harmony reexport AudioFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__AudioMutedOutlined__ = __webpack_require__(2002);
/* unused harmony reexport AudioMutedOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__AudioOutlined__ = __webpack_require__(2004);
/* unused harmony reexport AudioOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__AudioTwoTone__ = __webpack_require__(2006);
/* unused harmony reexport AudioTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__AuditOutlined__ = __webpack_require__(2008);
/* unused harmony reexport AuditOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__BackwardFilled__ = __webpack_require__(2010);
/* unused harmony reexport BackwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__BackwardOutlined__ = __webpack_require__(2012);
/* unused harmony reexport BackwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__BankFilled__ = __webpack_require__(2014);
/* unused harmony reexport BankFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__BankOutlined__ = __webpack_require__(2016);
/* unused harmony reexport BankOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__BankTwoTone__ = __webpack_require__(2018);
/* unused harmony reexport BankTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__BarChartOutlined__ = __webpack_require__(2020);
/* unused harmony reexport BarChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__BarcodeOutlined__ = __webpack_require__(2022);
/* unused harmony reexport BarcodeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__BarsOutlined__ = __webpack_require__(2024);
/* unused harmony reexport BarsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__BehanceCircleFilled__ = __webpack_require__(2026);
/* unused harmony reexport BehanceCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__BehanceOutlined__ = __webpack_require__(2028);
/* unused harmony reexport BehanceOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__BehanceSquareFilled__ = __webpack_require__(2030);
/* unused harmony reexport BehanceSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__BehanceSquareOutlined__ = __webpack_require__(2032);
/* unused harmony reexport BehanceSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__BellFilled__ = __webpack_require__(2034);
/* unused harmony reexport BellFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__BellOutlined__ = __webpack_require__(2036);
/* unused harmony reexport BellOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__BellTwoTone__ = __webpack_require__(2038);
/* unused harmony reexport BellTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__BgColorsOutlined__ = __webpack_require__(2040);
/* unused harmony reexport BgColorsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__BlockOutlined__ = __webpack_require__(2042);
/* unused harmony reexport BlockOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__BoldOutlined__ = __webpack_require__(2044);
/* unused harmony reexport BoldOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__BookFilled__ = __webpack_require__(2046);
/* unused harmony reexport BookFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__BookOutlined__ = __webpack_require__(2048);
/* unused harmony reexport BookOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__BookTwoTone__ = __webpack_require__(2050);
/* unused harmony reexport BookTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__BorderBottomOutlined__ = __webpack_require__(2052);
/* unused harmony reexport BorderBottomOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__BorderHorizontalOutlined__ = __webpack_require__(2054);
/* unused harmony reexport BorderHorizontalOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__BorderInnerOutlined__ = __webpack_require__(2056);
/* unused harmony reexport BorderInnerOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__BorderLeftOutlined__ = __webpack_require__(2058);
/* unused harmony reexport BorderLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__BorderOuterOutlined__ = __webpack_require__(2060);
/* unused harmony reexport BorderOuterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__BorderOutlined__ = __webpack_require__(2062);
/* unused harmony reexport BorderOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__BorderRightOutlined__ = __webpack_require__(2064);
/* unused harmony reexport BorderRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__BorderTopOutlined__ = __webpack_require__(2066);
/* unused harmony reexport BorderTopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__BorderVerticleOutlined__ = __webpack_require__(2068);
/* unused harmony reexport BorderVerticleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__BorderlessTableOutlined__ = __webpack_require__(2070);
/* unused harmony reexport BorderlessTableOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__BoxPlotFilled__ = __webpack_require__(2072);
/* unused harmony reexport BoxPlotFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__BoxPlotOutlined__ = __webpack_require__(2074);
/* unused harmony reexport BoxPlotOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__BoxPlotTwoTone__ = __webpack_require__(2076);
/* unused harmony reexport BoxPlotTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__BranchesOutlined__ = __webpack_require__(2078);
/* unused harmony reexport BranchesOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__BugFilled__ = __webpack_require__(2080);
/* unused harmony reexport BugFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__BugOutlined__ = __webpack_require__(2082);
/* unused harmony reexport BugOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__BugTwoTone__ = __webpack_require__(2084);
/* unused harmony reexport BugTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__BuildFilled__ = __webpack_require__(2086);
/* unused harmony reexport BuildFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__BuildOutlined__ = __webpack_require__(2088);
/* unused harmony reexport BuildOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__BuildTwoTone__ = __webpack_require__(2090);
/* unused harmony reexport BuildTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__BulbFilled__ = __webpack_require__(2092);
/* unused harmony reexport BulbFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__BulbOutlined__ = __webpack_require__(2094);
/* unused harmony reexport BulbOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__BulbTwoTone__ = __webpack_require__(2096);
/* unused harmony reexport BulbTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__CalculatorFilled__ = __webpack_require__(2098);
/* unused harmony reexport CalculatorFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__CalculatorOutlined__ = __webpack_require__(2100);
/* unused harmony reexport CalculatorOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__CalculatorTwoTone__ = __webpack_require__(2102);
/* unused harmony reexport CalculatorTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__CalendarFilled__ = __webpack_require__(2104);
/* unused harmony reexport CalendarFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__CalendarOutlined__ = __webpack_require__(2106);
/* unused harmony reexport CalendarOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__CalendarTwoTone__ = __webpack_require__(2108);
/* unused harmony reexport CalendarTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__CameraFilled__ = __webpack_require__(2110);
/* unused harmony reexport CameraFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__CameraOutlined__ = __webpack_require__(2112);
/* unused harmony reexport CameraOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__CameraTwoTone__ = __webpack_require__(2114);
/* unused harmony reexport CameraTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__CarFilled__ = __webpack_require__(2116);
/* unused harmony reexport CarFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__CarOutlined__ = __webpack_require__(2118);
/* unused harmony reexport CarOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__CarTwoTone__ = __webpack_require__(2120);
/* unused harmony reexport CarTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__CaretDownFilled__ = __webpack_require__(2122);
/* unused harmony reexport CaretDownFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__CaretDownOutlined__ = __webpack_require__(2124);
/* unused harmony reexport CaretDownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__CaretLeftFilled__ = __webpack_require__(2126);
/* unused harmony reexport CaretLeftFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__CaretLeftOutlined__ = __webpack_require__(2128);
/* unused harmony reexport CaretLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__CaretRightFilled__ = __webpack_require__(2130);
/* unused harmony reexport CaretRightFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__CaretRightOutlined__ = __webpack_require__(2132);
/* unused harmony reexport CaretRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__CaretUpFilled__ = __webpack_require__(2134);
/* unused harmony reexport CaretUpFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__CaretUpOutlined__ = __webpack_require__(2136);
/* unused harmony reexport CaretUpOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__CarryOutFilled__ = __webpack_require__(2138);
/* unused harmony reexport CarryOutFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__CarryOutOutlined__ = __webpack_require__(2140);
/* unused harmony reexport CarryOutOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__CarryOutTwoTone__ = __webpack_require__(2142);
/* unused harmony reexport CarryOutTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__CheckCircleFilled__ = __webpack_require__(2144);
/* unused harmony reexport CheckCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__CheckCircleOutlined__ = __webpack_require__(2146);
/* unused harmony reexport CheckCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__CheckCircleTwoTone__ = __webpack_require__(2148);
/* unused harmony reexport CheckCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__CheckOutlined__ = __webpack_require__(2150);
/* unused harmony reexport CheckOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__CheckSquareFilled__ = __webpack_require__(2152);
/* unused harmony reexport CheckSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__CheckSquareOutlined__ = __webpack_require__(2154);
/* unused harmony reexport CheckSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__CheckSquareTwoTone__ = __webpack_require__(2156);
/* unused harmony reexport CheckSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__ChromeFilled__ = __webpack_require__(2158);
/* unused harmony reexport ChromeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__ChromeOutlined__ = __webpack_require__(2160);
/* unused harmony reexport ChromeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__CiCircleFilled__ = __webpack_require__(2162);
/* unused harmony reexport CiCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__CiCircleOutlined__ = __webpack_require__(2164);
/* unused harmony reexport CiCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__CiCircleTwoTone__ = __webpack_require__(2166);
/* unused harmony reexport CiCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__CiOutlined__ = __webpack_require__(2168);
/* unused harmony reexport CiOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__CiTwoTone__ = __webpack_require__(2170);
/* unused harmony reexport CiTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__ClearOutlined__ = __webpack_require__(2172);
/* unused harmony reexport ClearOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__ClockCircleFilled__ = __webpack_require__(2174);
/* unused harmony reexport ClockCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__ClockCircleOutlined__ = __webpack_require__(2176);
/* unused harmony reexport ClockCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__ClockCircleTwoTone__ = __webpack_require__(2178);
/* unused harmony reexport ClockCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__CloseCircleFilled__ = __webpack_require__(2180);
/* unused harmony reexport CloseCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__CloseCircleOutlined__ = __webpack_require__(2182);
/* unused harmony reexport CloseCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__CloseCircleTwoTone__ = __webpack_require__(2184);
/* unused harmony reexport CloseCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__CloseOutlined__ = __webpack_require__(2186);
/* unused harmony reexport CloseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__CloseSquareFilled__ = __webpack_require__(2188);
/* unused harmony reexport CloseSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__CloseSquareOutlined__ = __webpack_require__(2190);
/* unused harmony reexport CloseSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__CloseSquareTwoTone__ = __webpack_require__(2192);
/* unused harmony reexport CloseSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__CloudDownloadOutlined__ = __webpack_require__(2194);
/* unused harmony reexport CloudDownloadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__CloudFilled__ = __webpack_require__(2196);
/* unused harmony reexport CloudFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__CloudOutlined__ = __webpack_require__(2198);
/* unused harmony reexport CloudOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__CloudServerOutlined__ = __webpack_require__(2200);
/* unused harmony reexport CloudServerOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__CloudSyncOutlined__ = __webpack_require__(2202);
/* unused harmony reexport CloudSyncOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__CloudTwoTone__ = __webpack_require__(2204);
/* unused harmony reexport CloudTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__CloudUploadOutlined__ = __webpack_require__(2206);
/* unused harmony reexport CloudUploadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__ClusterOutlined__ = __webpack_require__(2208);
/* unused harmony reexport ClusterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__CodeFilled__ = __webpack_require__(2210);
/* unused harmony reexport CodeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__CodeOutlined__ = __webpack_require__(2212);
/* unused harmony reexport CodeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__CodeSandboxCircleFilled__ = __webpack_require__(2214);
/* unused harmony reexport CodeSandboxCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__CodeSandboxOutlined__ = __webpack_require__(2216);
/* unused harmony reexport CodeSandboxOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__CodeSandboxSquareFilled__ = __webpack_require__(2218);
/* unused harmony reexport CodeSandboxSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__CodeTwoTone__ = __webpack_require__(2220);
/* unused harmony reexport CodeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__CodepenCircleFilled__ = __webpack_require__(2222);
/* unused harmony reexport CodepenCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__CodepenCircleOutlined__ = __webpack_require__(2224);
/* unused harmony reexport CodepenCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__CodepenOutlined__ = __webpack_require__(2226);
/* unused harmony reexport CodepenOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__CodepenSquareFilled__ = __webpack_require__(2228);
/* unused harmony reexport CodepenSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__CoffeeOutlined__ = __webpack_require__(2230);
/* unused harmony reexport CoffeeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__ColumnHeightOutlined__ = __webpack_require__(2232);
/* unused harmony reexport ColumnHeightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__ColumnWidthOutlined__ = __webpack_require__(2234);
/* unused harmony reexport ColumnWidthOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__CommentOutlined__ = __webpack_require__(2236);
/* unused harmony reexport CommentOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__CompassFilled__ = __webpack_require__(2238);
/* unused harmony reexport CompassFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__CompassOutlined__ = __webpack_require__(2240);
/* unused harmony reexport CompassOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__CompassTwoTone__ = __webpack_require__(2242);
/* unused harmony reexport CompassTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__CompressOutlined__ = __webpack_require__(2244);
/* unused harmony reexport CompressOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__ConsoleSqlOutlined__ = __webpack_require__(2246);
/* unused harmony reexport ConsoleSqlOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__ContactsFilled__ = __webpack_require__(2248);
/* unused harmony reexport ContactsFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__ContactsOutlined__ = __webpack_require__(2250);
/* unused harmony reexport ContactsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__ContactsTwoTone__ = __webpack_require__(2252);
/* unused harmony reexport ContactsTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__ContainerFilled__ = __webpack_require__(2254);
/* unused harmony reexport ContainerFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__ContainerOutlined__ = __webpack_require__(2256);
/* unused harmony reexport ContainerOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__ContainerTwoTone__ = __webpack_require__(2258);
/* unused harmony reexport ContainerTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__ControlFilled__ = __webpack_require__(2260);
/* unused harmony reexport ControlFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__ControlOutlined__ = __webpack_require__(2262);
/* unused harmony reexport ControlOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__ControlTwoTone__ = __webpack_require__(2264);
/* unused harmony reexport ControlTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__CopyFilled__ = __webpack_require__(2266);
/* unused harmony reexport CopyFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__CopyOutlined__ = __webpack_require__(2268);
/* unused harmony reexport CopyOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__CopyTwoTone__ = __webpack_require__(2270);
/* unused harmony reexport CopyTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__CopyrightCircleFilled__ = __webpack_require__(2272);
/* unused harmony reexport CopyrightCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__CopyrightCircleOutlined__ = __webpack_require__(2274);
/* unused harmony reexport CopyrightCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__CopyrightCircleTwoTone__ = __webpack_require__(2276);
/* unused harmony reexport CopyrightCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__CopyrightOutlined__ = __webpack_require__(2278);
/* unused harmony reexport CopyrightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__CopyrightTwoTone__ = __webpack_require__(2280);
/* unused harmony reexport CopyrightTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__CreditCardFilled__ = __webpack_require__(2282);
/* unused harmony reexport CreditCardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__CreditCardOutlined__ = __webpack_require__(2284);
/* unused harmony reexport CreditCardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__CreditCardTwoTone__ = __webpack_require__(2286);
/* unused harmony reexport CreditCardTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__CrownFilled__ = __webpack_require__(2288);
/* unused harmony reexport CrownFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__CrownOutlined__ = __webpack_require__(2290);
/* unused harmony reexport CrownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__CrownTwoTone__ = __webpack_require__(2292);
/* unused harmony reexport CrownTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__CustomerServiceFilled__ = __webpack_require__(2294);
/* unused harmony reexport CustomerServiceFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__CustomerServiceOutlined__ = __webpack_require__(2296);
/* unused harmony reexport CustomerServiceOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__CustomerServiceTwoTone__ = __webpack_require__(2298);
/* unused harmony reexport CustomerServiceTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__DashOutlined__ = __webpack_require__(2300);
/* unused harmony reexport DashOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__DashboardFilled__ = __webpack_require__(2302);
/* unused harmony reexport DashboardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__DashboardOutlined__ = __webpack_require__(2304);
/* unused harmony reexport DashboardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__DashboardTwoTone__ = __webpack_require__(2306);
/* unused harmony reexport DashboardTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__DatabaseFilled__ = __webpack_require__(2308);
/* unused harmony reexport DatabaseFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__DatabaseOutlined__ = __webpack_require__(2310);
/* unused harmony reexport DatabaseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__DatabaseTwoTone__ = __webpack_require__(2312);
/* unused harmony reexport DatabaseTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__DeleteColumnOutlined__ = __webpack_require__(2314);
/* unused harmony reexport DeleteColumnOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__DeleteFilled__ = __webpack_require__(2316);
/* unused harmony reexport DeleteFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__DeleteOutlined__ = __webpack_require__(2318);
/* unused harmony reexport DeleteOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__DeleteRowOutlined__ = __webpack_require__(2320);
/* unused harmony reexport DeleteRowOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__DeleteTwoTone__ = __webpack_require__(2322);
/* unused harmony reexport DeleteTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__DeliveredProcedureOutlined__ = __webpack_require__(2324);
/* unused harmony reexport DeliveredProcedureOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__DeploymentUnitOutlined__ = __webpack_require__(2326);
/* unused harmony reexport DeploymentUnitOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__DesktopOutlined__ = __webpack_require__(2328);
/* unused harmony reexport DesktopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__DiffFilled__ = __webpack_require__(2330);
/* unused harmony reexport DiffFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__DiffOutlined__ = __webpack_require__(2332);
/* unused harmony reexport DiffOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__DiffTwoTone__ = __webpack_require__(2334);
/* unused harmony reexport DiffTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__DingdingOutlined__ = __webpack_require__(2336);
/* unused harmony reexport DingdingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__DingtalkCircleFilled__ = __webpack_require__(2338);
/* unused harmony reexport DingtalkCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__DingtalkOutlined__ = __webpack_require__(2340);
/* unused harmony reexport DingtalkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__DingtalkSquareFilled__ = __webpack_require__(2342);
/* unused harmony reexport DingtalkSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__DisconnectOutlined__ = __webpack_require__(2344);
/* unused harmony reexport DisconnectOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__DislikeFilled__ = __webpack_require__(2346);
/* unused harmony reexport DislikeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__DislikeOutlined__ = __webpack_require__(2348);
/* unused harmony reexport DislikeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__DislikeTwoTone__ = __webpack_require__(2350);
/* unused harmony reexport DislikeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__DollarCircleFilled__ = __webpack_require__(2352);
/* unused harmony reexport DollarCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__DollarCircleOutlined__ = __webpack_require__(2354);
/* unused harmony reexport DollarCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__DollarCircleTwoTone__ = __webpack_require__(2356);
/* unused harmony reexport DollarCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__DollarOutlined__ = __webpack_require__(2358);
/* unused harmony reexport DollarOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__DollarTwoTone__ = __webpack_require__(2360);
/* unused harmony reexport DollarTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__DotChartOutlined__ = __webpack_require__(2362);
/* unused harmony reexport DotChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__DoubleLeftOutlined__ = __webpack_require__(2364);
/* unused harmony reexport DoubleLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__DoubleRightOutlined__ = __webpack_require__(2366);
/* unused harmony reexport DoubleRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__DownCircleFilled__ = __webpack_require__(2368);
/* unused harmony reexport DownCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__DownCircleOutlined__ = __webpack_require__(2370);
/* unused harmony reexport DownCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__DownCircleTwoTone__ = __webpack_require__(2372);
/* unused harmony reexport DownCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__DownOutlined__ = __webpack_require__(2374);
/* unused harmony reexport DownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__DownSquareFilled__ = __webpack_require__(2376);
/* unused harmony reexport DownSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__DownSquareOutlined__ = __webpack_require__(2378);
/* unused harmony reexport DownSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__DownSquareTwoTone__ = __webpack_require__(2380);
/* unused harmony reexport DownSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__DownloadOutlined__ = __webpack_require__(2382);
/* unused harmony reexport DownloadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__DragOutlined__ = __webpack_require__(2384);
/* unused harmony reexport DragOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__DribbbleCircleFilled__ = __webpack_require__(2386);
/* unused harmony reexport DribbbleCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__DribbbleOutlined__ = __webpack_require__(2388);
/* unused harmony reexport DribbbleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__DribbbleSquareFilled__ = __webpack_require__(2390);
/* unused harmony reexport DribbbleSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__DribbbleSquareOutlined__ = __webpack_require__(2392);
/* unused harmony reexport DribbbleSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__DropboxCircleFilled__ = __webpack_require__(2394);
/* unused harmony reexport DropboxCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__DropboxOutlined__ = __webpack_require__(2396);
/* unused harmony reexport DropboxOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__DropboxSquareFilled__ = __webpack_require__(2398);
/* unused harmony reexport DropboxSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__EditFilled__ = __webpack_require__(2400);
/* unused harmony reexport EditFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__EditOutlined__ = __webpack_require__(2402);
/* unused harmony reexport EditOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__EditTwoTone__ = __webpack_require__(2404);
/* unused harmony reexport EditTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__EllipsisOutlined__ = __webpack_require__(2406);
/* unused harmony reexport EllipsisOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__EnterOutlined__ = __webpack_require__(2408);
/* unused harmony reexport EnterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__EnvironmentFilled__ = __webpack_require__(2410);
/* unused harmony reexport EnvironmentFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__EnvironmentOutlined__ = __webpack_require__(2412);
/* unused harmony reexport EnvironmentOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__EnvironmentTwoTone__ = __webpack_require__(2414);
/* unused harmony reexport EnvironmentTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__EuroCircleFilled__ = __webpack_require__(2416);
/* unused harmony reexport EuroCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__EuroCircleOutlined__ = __webpack_require__(2418);
/* unused harmony reexport EuroCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__EuroCircleTwoTone__ = __webpack_require__(2420);
/* unused harmony reexport EuroCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__EuroOutlined__ = __webpack_require__(2422);
/* unused harmony reexport EuroOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__EuroTwoTone__ = __webpack_require__(2424);
/* unused harmony reexport EuroTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__ExceptionOutlined__ = __webpack_require__(2426);
/* unused harmony reexport ExceptionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__ExclamationCircleFilled__ = __webpack_require__(2428);
/* unused harmony reexport ExclamationCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__ExclamationCircleOutlined__ = __webpack_require__(2430);
/* unused harmony reexport ExclamationCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__ExclamationCircleTwoTone__ = __webpack_require__(2432);
/* unused harmony reexport ExclamationCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__ExclamationOutlined__ = __webpack_require__(2434);
/* unused harmony reexport ExclamationOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__ExpandAltOutlined__ = __webpack_require__(2436);
/* unused harmony reexport ExpandAltOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__ExpandOutlined__ = __webpack_require__(2438);
/* unused harmony reexport ExpandOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__ExperimentFilled__ = __webpack_require__(2440);
/* unused harmony reexport ExperimentFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__ExperimentOutlined__ = __webpack_require__(2442);
/* unused harmony reexport ExperimentOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__ExperimentTwoTone__ = __webpack_require__(2444);
/* unused harmony reexport ExperimentTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__ExportOutlined__ = __webpack_require__(2446);
/* unused harmony reexport ExportOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__EyeFilled__ = __webpack_require__(2448);
/* unused harmony reexport EyeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__EyeInvisibleFilled__ = __webpack_require__(2450);
/* unused harmony reexport EyeInvisibleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__EyeInvisibleOutlined__ = __webpack_require__(2452);
/* unused harmony reexport EyeInvisibleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__EyeInvisibleTwoTone__ = __webpack_require__(2454);
/* unused harmony reexport EyeInvisibleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__EyeOutlined__ = __webpack_require__(2456);
/* unused harmony reexport EyeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__EyeTwoTone__ = __webpack_require__(2458);
/* unused harmony reexport EyeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__FacebookFilled__ = __webpack_require__(2460);
/* unused harmony reexport FacebookFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__FacebookOutlined__ = __webpack_require__(2462);
/* unused harmony reexport FacebookOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__FallOutlined__ = __webpack_require__(2464);
/* unused harmony reexport FallOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__FastBackwardFilled__ = __webpack_require__(2466);
/* unused harmony reexport FastBackwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__FastBackwardOutlined__ = __webpack_require__(2468);
/* unused harmony reexport FastBackwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__FastForwardFilled__ = __webpack_require__(2470);
/* unused harmony reexport FastForwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__FastForwardOutlined__ = __webpack_require__(2472);
/* unused harmony reexport FastForwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__FieldBinaryOutlined__ = __webpack_require__(2474);
/* unused harmony reexport FieldBinaryOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__FieldNumberOutlined__ = __webpack_require__(2476);
/* unused harmony reexport FieldNumberOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__FieldStringOutlined__ = __webpack_require__(2478);
/* unused harmony reexport FieldStringOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__FieldTimeOutlined__ = __webpack_require__(2480);
/* unused harmony reexport FieldTimeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__FileAddFilled__ = __webpack_require__(2482);
/* unused harmony reexport FileAddFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__FileAddOutlined__ = __webpack_require__(2484);
/* unused harmony reexport FileAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__FileAddTwoTone__ = __webpack_require__(2486);
/* unused harmony reexport FileAddTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__FileDoneOutlined__ = __webpack_require__(2488);
/* unused harmony reexport FileDoneOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__FileExcelFilled__ = __webpack_require__(2490);
/* unused harmony reexport FileExcelFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__FileExcelOutlined__ = __webpack_require__(2492);
/* unused harmony reexport FileExcelOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__FileExcelTwoTone__ = __webpack_require__(2494);
/* unused harmony reexport FileExcelTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__FileExclamationFilled__ = __webpack_require__(2496);
/* unused harmony reexport FileExclamationFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__FileExclamationOutlined__ = __webpack_require__(2498);
/* unused harmony reexport FileExclamationOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__FileExclamationTwoTone__ = __webpack_require__(2500);
/* unused harmony reexport FileExclamationTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__FileFilled__ = __webpack_require__(2502);
/* unused harmony reexport FileFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__FileGifOutlined__ = __webpack_require__(2504);
/* unused harmony reexport FileGifOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__FileImageFilled__ = __webpack_require__(2506);
/* unused harmony reexport FileImageFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__FileImageOutlined__ = __webpack_require__(2508);
/* unused harmony reexport FileImageOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__FileImageTwoTone__ = __webpack_require__(2510);
/* unused harmony reexport FileImageTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__FileJpgOutlined__ = __webpack_require__(2512);
/* unused harmony reexport FileJpgOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__FileMarkdownFilled__ = __webpack_require__(2514);
/* unused harmony reexport FileMarkdownFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__FileMarkdownOutlined__ = __webpack_require__(2516);
/* unused harmony reexport FileMarkdownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__FileMarkdownTwoTone__ = __webpack_require__(2518);
/* unused harmony reexport FileMarkdownTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__FileOutlined__ = __webpack_require__(2520);
/* unused harmony reexport FileOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__FilePdfFilled__ = __webpack_require__(2522);
/* unused harmony reexport FilePdfFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__FilePdfOutlined__ = __webpack_require__(2524);
/* unused harmony reexport FilePdfOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__FilePdfTwoTone__ = __webpack_require__(2526);
/* unused harmony reexport FilePdfTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__FilePptFilled__ = __webpack_require__(2528);
/* unused harmony reexport FilePptFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__FilePptOutlined__ = __webpack_require__(2530);
/* unused harmony reexport FilePptOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__FilePptTwoTone__ = __webpack_require__(2532);
/* unused harmony reexport FilePptTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__FileProtectOutlined__ = __webpack_require__(2534);
/* unused harmony reexport FileProtectOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__FileSearchOutlined__ = __webpack_require__(2536);
/* unused harmony reexport FileSearchOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__FileSyncOutlined__ = __webpack_require__(2538);
/* unused harmony reexport FileSyncOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__FileTextFilled__ = __webpack_require__(2540);
/* unused harmony reexport FileTextFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__FileTextOutlined__ = __webpack_require__(2542);
/* unused harmony reexport FileTextOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__FileTextTwoTone__ = __webpack_require__(2544);
/* unused harmony reexport FileTextTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__FileTwoTone__ = __webpack_require__(2546);
/* unused harmony reexport FileTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__FileUnknownFilled__ = __webpack_require__(2548);
/* unused harmony reexport FileUnknownFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__FileUnknownOutlined__ = __webpack_require__(2550);
/* unused harmony reexport FileUnknownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__FileUnknownTwoTone__ = __webpack_require__(2552);
/* unused harmony reexport FileUnknownTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__FileWordFilled__ = __webpack_require__(2554);
/* unused harmony reexport FileWordFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__FileWordOutlined__ = __webpack_require__(2556);
/* unused harmony reexport FileWordOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__FileWordTwoTone__ = __webpack_require__(2558);
/* unused harmony reexport FileWordTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__FileZipFilled__ = __webpack_require__(2560);
/* unused harmony reexport FileZipFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__FileZipOutlined__ = __webpack_require__(2562);
/* unused harmony reexport FileZipOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__FileZipTwoTone__ = __webpack_require__(2564);
/* unused harmony reexport FileZipTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__FilterFilled__ = __webpack_require__(2566);
/* unused harmony reexport FilterFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__FilterOutlined__ = __webpack_require__(2568);
/* unused harmony reexport FilterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__FilterTwoTone__ = __webpack_require__(2570);
/* unused harmony reexport FilterTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__FireFilled__ = __webpack_require__(2572);
/* unused harmony reexport FireFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__FireOutlined__ = __webpack_require__(2574);
/* unused harmony reexport FireOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__FireTwoTone__ = __webpack_require__(2576);
/* unused harmony reexport FireTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__FlagFilled__ = __webpack_require__(2578);
/* unused harmony reexport FlagFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__FlagOutlined__ = __webpack_require__(2580);
/* unused harmony reexport FlagOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__FlagTwoTone__ = __webpack_require__(2582);
/* unused harmony reexport FlagTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__FolderAddFilled__ = __webpack_require__(2584);
/* unused harmony reexport FolderAddFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__FolderAddOutlined__ = __webpack_require__(2586);
/* unused harmony reexport FolderAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__FolderAddTwoTone__ = __webpack_require__(2588);
/* unused harmony reexport FolderAddTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__FolderFilled__ = __webpack_require__(2590);
/* unused harmony reexport FolderFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__FolderOpenFilled__ = __webpack_require__(2592);
/* unused harmony reexport FolderOpenFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__FolderOpenOutlined__ = __webpack_require__(2594);
/* unused harmony reexport FolderOpenOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__FolderOpenTwoTone__ = __webpack_require__(2596);
/* unused harmony reexport FolderOpenTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__FolderOutlined__ = __webpack_require__(2598);
/* unused harmony reexport FolderOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__FolderTwoTone__ = __webpack_require__(2600);
/* unused harmony reexport FolderTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__FolderViewOutlined__ = __webpack_require__(2602);
/* unused harmony reexport FolderViewOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__FontColorsOutlined__ = __webpack_require__(2604);
/* unused harmony reexport FontColorsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__FontSizeOutlined__ = __webpack_require__(2606);
/* unused harmony reexport FontSizeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__ForkOutlined__ = __webpack_require__(2608);
/* unused harmony reexport ForkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__FormOutlined__ = __webpack_require__(2610);
/* unused harmony reexport FormOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__FormatPainterFilled__ = __webpack_require__(2612);
/* unused harmony reexport FormatPainterFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__FormatPainterOutlined__ = __webpack_require__(2614);
/* unused harmony reexport FormatPainterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__ForwardFilled__ = __webpack_require__(2616);
/* unused harmony reexport ForwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__ForwardOutlined__ = __webpack_require__(2618);
/* unused harmony reexport ForwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__FrownFilled__ = __webpack_require__(2620);
/* unused harmony reexport FrownFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__FrownOutlined__ = __webpack_require__(2622);
/* unused harmony reexport FrownOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__FrownTwoTone__ = __webpack_require__(2624);
/* unused harmony reexport FrownTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__FullscreenExitOutlined__ = __webpack_require__(2626);
/* unused harmony reexport FullscreenExitOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__FullscreenOutlined__ = __webpack_require__(2628);
/* unused harmony reexport FullscreenOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__FunctionOutlined__ = __webpack_require__(2630);
/* unused harmony reexport FunctionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__FundFilled__ = __webpack_require__(2632);
/* unused harmony reexport FundFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__FundOutlined__ = __webpack_require__(2634);
/* unused harmony reexport FundOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__FundProjectionScreenOutlined__ = __webpack_require__(2636);
/* unused harmony reexport FundProjectionScreenOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__FundTwoTone__ = __webpack_require__(2638);
/* unused harmony reexport FundTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__FundViewOutlined__ = __webpack_require__(2640);
/* unused harmony reexport FundViewOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__FunnelPlotFilled__ = __webpack_require__(2642);
/* unused harmony reexport FunnelPlotFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__FunnelPlotOutlined__ = __webpack_require__(2644);
/* unused harmony reexport FunnelPlotOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__FunnelPlotTwoTone__ = __webpack_require__(2646);
/* unused harmony reexport FunnelPlotTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__GatewayOutlined__ = __webpack_require__(2648);
/* unused harmony reexport GatewayOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__GifOutlined__ = __webpack_require__(2650);
/* unused harmony reexport GifOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__GiftFilled__ = __webpack_require__(2652);
/* unused harmony reexport GiftFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__GiftOutlined__ = __webpack_require__(2654);
/* unused harmony reexport GiftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__GiftTwoTone__ = __webpack_require__(2656);
/* unused harmony reexport GiftTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__GithubFilled__ = __webpack_require__(2658);
/* unused harmony reexport GithubFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__GithubOutlined__ = __webpack_require__(2660);
/* unused harmony reexport GithubOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__GitlabFilled__ = __webpack_require__(2662);
/* unused harmony reexport GitlabFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__GitlabOutlined__ = __webpack_require__(2664);
/* unused harmony reexport GitlabOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__GlobalOutlined__ = __webpack_require__(2666);
/* unused harmony reexport GlobalOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__GoldFilled__ = __webpack_require__(2668);
/* unused harmony reexport GoldFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__GoldOutlined__ = __webpack_require__(2670);
/* unused harmony reexport GoldOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__GoldTwoTone__ = __webpack_require__(2672);
/* unused harmony reexport GoldTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__GoldenFilled__ = __webpack_require__(2674);
/* unused harmony reexport GoldenFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__GoogleCircleFilled__ = __webpack_require__(2676);
/* unused harmony reexport GoogleCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__GoogleOutlined__ = __webpack_require__(2678);
/* unused harmony reexport GoogleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__GooglePlusCircleFilled__ = __webpack_require__(2680);
/* unused harmony reexport GooglePlusCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__GooglePlusOutlined__ = __webpack_require__(2682);
/* unused harmony reexport GooglePlusOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__GooglePlusSquareFilled__ = __webpack_require__(2684);
/* unused harmony reexport GooglePlusSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__GoogleSquareFilled__ = __webpack_require__(2686);
/* unused harmony reexport GoogleSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__GroupOutlined__ = __webpack_require__(2688);
/* unused harmony reexport GroupOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__HddFilled__ = __webpack_require__(2690);
/* unused harmony reexport HddFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__HddOutlined__ = __webpack_require__(2692);
/* unused harmony reexport HddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__HddTwoTone__ = __webpack_require__(2694);
/* unused harmony reexport HddTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__HeartFilled__ = __webpack_require__(2696);
/* unused harmony reexport HeartFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__HeartOutlined__ = __webpack_require__(2698);
/* unused harmony reexport HeartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__HeartTwoTone__ = __webpack_require__(2700);
/* unused harmony reexport HeartTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__HeatMapOutlined__ = __webpack_require__(2702);
/* unused harmony reexport HeatMapOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__HighlightFilled__ = __webpack_require__(2704);
/* unused harmony reexport HighlightFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__HighlightOutlined__ = __webpack_require__(2706);
/* unused harmony reexport HighlightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__HighlightTwoTone__ = __webpack_require__(2708);
/* unused harmony reexport HighlightTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__HistoryOutlined__ = __webpack_require__(2710);
/* unused harmony reexport HistoryOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__HomeFilled__ = __webpack_require__(2712);
/* unused harmony reexport HomeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__HomeOutlined__ = __webpack_require__(2714);
/* unused harmony reexport HomeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__HomeTwoTone__ = __webpack_require__(2716);
/* unused harmony reexport HomeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__HourglassFilled__ = __webpack_require__(2718);
/* unused harmony reexport HourglassFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__HourglassOutlined__ = __webpack_require__(2720);
/* unused harmony reexport HourglassOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__HourglassTwoTone__ = __webpack_require__(2722);
/* unused harmony reexport HourglassTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__Html5Filled__ = __webpack_require__(2724);
/* unused harmony reexport Html5Filled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__Html5Outlined__ = __webpack_require__(2726);
/* unused harmony reexport Html5Outlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Html5TwoTone__ = __webpack_require__(2728);
/* unused harmony reexport Html5TwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__IdcardFilled__ = __webpack_require__(2730);
/* unused harmony reexport IdcardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__IdcardOutlined__ = __webpack_require__(2732);
/* unused harmony reexport IdcardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__IdcardTwoTone__ = __webpack_require__(2734);
/* unused harmony reexport IdcardTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__IeCircleFilled__ = __webpack_require__(2736);
/* unused harmony reexport IeCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__IeOutlined__ = __webpack_require__(2738);
/* unused harmony reexport IeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__IeSquareFilled__ = __webpack_require__(2740);
/* unused harmony reexport IeSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__ImportOutlined__ = __webpack_require__(2742);
/* unused harmony reexport ImportOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__InboxOutlined__ = __webpack_require__(2744);
/* unused harmony reexport InboxOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__InfoCircleFilled__ = __webpack_require__(2746);
/* unused harmony reexport InfoCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__InfoCircleOutlined__ = __webpack_require__(2748);
/* unused harmony reexport InfoCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__InfoCircleTwoTone__ = __webpack_require__(2750);
/* unused harmony reexport InfoCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__InfoOutlined__ = __webpack_require__(2752);
/* unused harmony reexport InfoOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__InsertRowAboveOutlined__ = __webpack_require__(2754);
/* unused harmony reexport InsertRowAboveOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__InsertRowBelowOutlined__ = __webpack_require__(2756);
/* unused harmony reexport InsertRowBelowOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__InsertRowLeftOutlined__ = __webpack_require__(2758);
/* unused harmony reexport InsertRowLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__InsertRowRightOutlined__ = __webpack_require__(2760);
/* unused harmony reexport InsertRowRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__InstagramFilled__ = __webpack_require__(2762);
/* unused harmony reexport InstagramFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__InstagramOutlined__ = __webpack_require__(2764);
/* unused harmony reexport InstagramOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__InsuranceFilled__ = __webpack_require__(2766);
/* unused harmony reexport InsuranceFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__InsuranceOutlined__ = __webpack_require__(2768);
/* unused harmony reexport InsuranceOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__InsuranceTwoTone__ = __webpack_require__(2770);
/* unused harmony reexport InsuranceTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__InteractionFilled__ = __webpack_require__(2772);
/* unused harmony reexport InteractionFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__InteractionOutlined__ = __webpack_require__(2774);
/* unused harmony reexport InteractionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__InteractionTwoTone__ = __webpack_require__(2776);
/* unused harmony reexport InteractionTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__IssuesCloseOutlined__ = __webpack_require__(2778);
/* unused harmony reexport IssuesCloseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__ItalicOutlined__ = __webpack_require__(2780);
/* unused harmony reexport ItalicOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__KeyOutlined__ = __webpack_require__(2782);
/* unused harmony reexport KeyOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__LaptopOutlined__ = __webpack_require__(2784);
/* unused harmony reexport LaptopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__LayoutFilled__ = __webpack_require__(2786);
/* unused harmony reexport LayoutFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__LayoutOutlined__ = __webpack_require__(2788);
/* unused harmony reexport LayoutOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__LayoutTwoTone__ = __webpack_require__(2790);
/* unused harmony reexport LayoutTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__LeftCircleFilled__ = __webpack_require__(2792);
/* unused harmony reexport LeftCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__LeftCircleOutlined__ = __webpack_require__(2794);
/* unused harmony reexport LeftCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__LeftCircleTwoTone__ = __webpack_require__(2796);
/* unused harmony reexport LeftCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__LeftOutlined__ = __webpack_require__(2798);
/* unused harmony reexport LeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__LeftSquareFilled__ = __webpack_require__(2800);
/* unused harmony reexport LeftSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__LeftSquareOutlined__ = __webpack_require__(2802);
/* unused harmony reexport LeftSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__LeftSquareTwoTone__ = __webpack_require__(2804);
/* unused harmony reexport LeftSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__LikeFilled__ = __webpack_require__(2806);
/* unused harmony reexport LikeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__LikeOutlined__ = __webpack_require__(2808);
/* unused harmony reexport LikeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__LikeTwoTone__ = __webpack_require__(2810);
/* unused harmony reexport LikeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__LineChartOutlined__ = __webpack_require__(2812);
/* unused harmony reexport LineChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__LineHeightOutlined__ = __webpack_require__(2814);
/* unused harmony reexport LineHeightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__LineOutlined__ = __webpack_require__(2816);
/* unused harmony reexport LineOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__LinkOutlined__ = __webpack_require__(2818);
/* unused harmony reexport LinkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__LinkedinFilled__ = __webpack_require__(2820);
/* unused harmony reexport LinkedinFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__LinkedinOutlined__ = __webpack_require__(2822);
/* unused harmony reexport LinkedinOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__Loading3QuartersOutlined__ = __webpack_require__(2824);
/* unused harmony reexport Loading3QuartersOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__LoadingOutlined__ = __webpack_require__(2826);
/* unused harmony reexport LoadingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__LockFilled__ = __webpack_require__(2828);
/* unused harmony reexport LockFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__LockOutlined__ = __webpack_require__(2830);
/* unused harmony reexport LockOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__LockTwoTone__ = __webpack_require__(2832);
/* unused harmony reexport LockTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__LoginOutlined__ = __webpack_require__(2834);
/* unused harmony reexport LoginOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__LogoutOutlined__ = __webpack_require__(2836);
/* unused harmony reexport LogoutOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__MacCommandFilled__ = __webpack_require__(2838);
/* unused harmony reexport MacCommandFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__MacCommandOutlined__ = __webpack_require__(2840);
/* unused harmony reexport MacCommandOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__MailFilled__ = __webpack_require__(2842);
/* unused harmony reexport MailFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__MailOutlined__ = __webpack_require__(2844);
/* unused harmony reexport MailOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__MailTwoTone__ = __webpack_require__(2846);
/* unused harmony reexport MailTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__ManOutlined__ = __webpack_require__(2848);
/* unused harmony reexport ManOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__MedicineBoxFilled__ = __webpack_require__(2850);
/* unused harmony reexport MedicineBoxFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__MedicineBoxOutlined__ = __webpack_require__(2852);
/* unused harmony reexport MedicineBoxOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__MedicineBoxTwoTone__ = __webpack_require__(2854);
/* unused harmony reexport MedicineBoxTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__MediumCircleFilled__ = __webpack_require__(2856);
/* unused harmony reexport MediumCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__MediumOutlined__ = __webpack_require__(2858);
/* unused harmony reexport MediumOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__MediumSquareFilled__ = __webpack_require__(2860);
/* unused harmony reexport MediumSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__MediumWorkmarkOutlined__ = __webpack_require__(2862);
/* unused harmony reexport MediumWorkmarkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__MehFilled__ = __webpack_require__(2864);
/* unused harmony reexport MehFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__MehOutlined__ = __webpack_require__(2866);
/* unused harmony reexport MehOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__MehTwoTone__ = __webpack_require__(2868);
/* unused harmony reexport MehTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__MenuFoldOutlined__ = __webpack_require__(2870);
/* unused harmony reexport MenuFoldOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__MenuOutlined__ = __webpack_require__(2872);
/* unused harmony reexport MenuOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__MenuUnfoldOutlined__ = __webpack_require__(2874);
/* unused harmony reexport MenuUnfoldOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__MergeCellsOutlined__ = __webpack_require__(2876);
/* unused harmony reexport MergeCellsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__MessageFilled__ = __webpack_require__(2878);
/* unused harmony reexport MessageFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__MessageOutlined__ = __webpack_require__(2880);
/* unused harmony reexport MessageOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__MessageTwoTone__ = __webpack_require__(2882);
/* unused harmony reexport MessageTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__MinusCircleFilled__ = __webpack_require__(2884);
/* unused harmony reexport MinusCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__MinusCircleOutlined__ = __webpack_require__(2886);
/* unused harmony reexport MinusCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__MinusCircleTwoTone__ = __webpack_require__(2888);
/* unused harmony reexport MinusCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__MinusOutlined__ = __webpack_require__(2890);
/* unused harmony reexport MinusOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__MinusSquareFilled__ = __webpack_require__(2892);
/* unused harmony reexport MinusSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__MinusSquareOutlined__ = __webpack_require__(2894);
/* unused harmony reexport MinusSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__MinusSquareTwoTone__ = __webpack_require__(2896);
/* unused harmony reexport MinusSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__MobileFilled__ = __webpack_require__(2898);
/* unused harmony reexport MobileFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__MobileOutlined__ = __webpack_require__(2900);
/* unused harmony reexport MobileOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__MobileTwoTone__ = __webpack_require__(2902);
/* unused harmony reexport MobileTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__MoneyCollectFilled__ = __webpack_require__(2904);
/* unused harmony reexport MoneyCollectFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__MoneyCollectOutlined__ = __webpack_require__(2906);
/* unused harmony reexport MoneyCollectOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__MoneyCollectTwoTone__ = __webpack_require__(2908);
/* unused harmony reexport MoneyCollectTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__MonitorOutlined__ = __webpack_require__(2910);
/* unused harmony reexport MonitorOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__MoreOutlined__ = __webpack_require__(2912);
/* unused harmony reexport MoreOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__NodeCollapseOutlined__ = __webpack_require__(2914);
/* unused harmony reexport NodeCollapseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__NodeExpandOutlined__ = __webpack_require__(2916);
/* unused harmony reexport NodeExpandOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__NodeIndexOutlined__ = __webpack_require__(2918);
/* unused harmony reexport NodeIndexOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__NotificationFilled__ = __webpack_require__(2920);
/* unused harmony reexport NotificationFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__NotificationOutlined__ = __webpack_require__(2922);
/* unused harmony reexport NotificationOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__NotificationTwoTone__ = __webpack_require__(2924);
/* unused harmony reexport NotificationTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__NumberOutlined__ = __webpack_require__(2926);
/* unused harmony reexport NumberOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__OneToOneOutlined__ = __webpack_require__(2928);
/* unused harmony reexport OneToOneOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__OrderedListOutlined__ = __webpack_require__(2930);
/* unused harmony reexport OrderedListOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__PaperClipOutlined__ = __webpack_require__(2932);
/* unused harmony reexport PaperClipOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__PartitionOutlined__ = __webpack_require__(2934);
/* unused harmony reexport PartitionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__PauseCircleFilled__ = __webpack_require__(2936);
/* unused harmony reexport PauseCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__PauseCircleOutlined__ = __webpack_require__(2938);
/* unused harmony reexport PauseCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__PauseCircleTwoTone__ = __webpack_require__(2940);
/* unused harmony reexport PauseCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__PauseOutlined__ = __webpack_require__(2942);
/* unused harmony reexport PauseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__PayCircleFilled__ = __webpack_require__(2944);
/* unused harmony reexport PayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__PayCircleOutlined__ = __webpack_require__(2946);
/* unused harmony reexport PayCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__PercentageOutlined__ = __webpack_require__(2948);
/* unused harmony reexport PercentageOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__PhoneFilled__ = __webpack_require__(2950);
/* unused harmony reexport PhoneFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__PhoneOutlined__ = __webpack_require__(2952);
/* unused harmony reexport PhoneOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__PhoneTwoTone__ = __webpack_require__(2954);
/* unused harmony reexport PhoneTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__PicCenterOutlined__ = __webpack_require__(2956);
/* unused harmony reexport PicCenterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__PicLeftOutlined__ = __webpack_require__(2958);
/* unused harmony reexport PicLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__PicRightOutlined__ = __webpack_require__(2960);
/* unused harmony reexport PicRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__PictureFilled__ = __webpack_require__(2962);
/* unused harmony reexport PictureFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__PictureOutlined__ = __webpack_require__(2964);
/* unused harmony reexport PictureOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__PictureTwoTone__ = __webpack_require__(2966);
/* unused harmony reexport PictureTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__PieChartFilled__ = __webpack_require__(2968);
/* unused harmony reexport PieChartFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__PieChartOutlined__ = __webpack_require__(2970);
/* unused harmony reexport PieChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__PieChartTwoTone__ = __webpack_require__(2972);
/* unused harmony reexport PieChartTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__PlayCircleFilled__ = __webpack_require__(2974);
/* unused harmony reexport PlayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__PlayCircleOutlined__ = __webpack_require__(2976);
/* unused harmony reexport PlayCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__PlayCircleTwoTone__ = __webpack_require__(2978);
/* unused harmony reexport PlayCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__PlaySquareFilled__ = __webpack_require__(2980);
/* unused harmony reexport PlaySquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__PlaySquareOutlined__ = __webpack_require__(2982);
/* unused harmony reexport PlaySquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__PlaySquareTwoTone__ = __webpack_require__(2984);
/* unused harmony reexport PlaySquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__PlusCircleFilled__ = __webpack_require__(2986);
/* unused harmony reexport PlusCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__PlusCircleOutlined__ = __webpack_require__(2988);
/* unused harmony reexport PlusCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__PlusCircleTwoTone__ = __webpack_require__(2990);
/* unused harmony reexport PlusCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__PlusOutlined__ = __webpack_require__(2992);
/* unused harmony reexport PlusOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__PlusSquareFilled__ = __webpack_require__(2994);
/* unused harmony reexport PlusSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__PlusSquareOutlined__ = __webpack_require__(2996);
/* unused harmony reexport PlusSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__PlusSquareTwoTone__ = __webpack_require__(2998);
/* unused harmony reexport PlusSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__PoundCircleFilled__ = __webpack_require__(3000);
/* unused harmony reexport PoundCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__PoundCircleOutlined__ = __webpack_require__(3002);
/* unused harmony reexport PoundCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__PoundCircleTwoTone__ = __webpack_require__(3004);
/* unused harmony reexport PoundCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__PoundOutlined__ = __webpack_require__(3006);
/* unused harmony reexport PoundOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__PoweroffOutlined__ = __webpack_require__(3008);
/* unused harmony reexport PoweroffOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__PrinterFilled__ = __webpack_require__(3010);
/* unused harmony reexport PrinterFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__PrinterOutlined__ = __webpack_require__(3012);
/* unused harmony reexport PrinterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__PrinterTwoTone__ = __webpack_require__(3014);
/* unused harmony reexport PrinterTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__ProfileFilled__ = __webpack_require__(3016);
/* unused harmony reexport ProfileFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__ProfileOutlined__ = __webpack_require__(3018);
/* unused harmony reexport ProfileOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__ProfileTwoTone__ = __webpack_require__(3020);
/* unused harmony reexport ProfileTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__ProjectFilled__ = __webpack_require__(3022);
/* unused harmony reexport ProjectFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__ProjectOutlined__ = __webpack_require__(3024);
/* unused harmony reexport ProjectOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__ProjectTwoTone__ = __webpack_require__(3026);
/* unused harmony reexport ProjectTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__PropertySafetyFilled__ = __webpack_require__(3028);
/* unused harmony reexport PropertySafetyFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__PropertySafetyOutlined__ = __webpack_require__(3030);
/* unused harmony reexport PropertySafetyOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__PropertySafetyTwoTone__ = __webpack_require__(3032);
/* unused harmony reexport PropertySafetyTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__PullRequestOutlined__ = __webpack_require__(3034);
/* unused harmony reexport PullRequestOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__PushpinFilled__ = __webpack_require__(3036);
/* unused harmony reexport PushpinFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__PushpinOutlined__ = __webpack_require__(3038);
/* unused harmony reexport PushpinOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__PushpinTwoTone__ = __webpack_require__(3040);
/* unused harmony reexport PushpinTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__QqCircleFilled__ = __webpack_require__(3042);
/* unused harmony reexport QqCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__QqOutlined__ = __webpack_require__(3044);
/* unused harmony reexport QqOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__QqSquareFilled__ = __webpack_require__(3046);
/* unused harmony reexport QqSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__QrcodeOutlined__ = __webpack_require__(3048);
/* unused harmony reexport QrcodeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__QuestionCircleFilled__ = __webpack_require__(3050);
/* unused harmony reexport QuestionCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__QuestionCircleOutlined__ = __webpack_require__(3052);
/* unused harmony reexport QuestionCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__QuestionCircleTwoTone__ = __webpack_require__(3054);
/* unused harmony reexport QuestionCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__QuestionOutlined__ = __webpack_require__(3056);
/* unused harmony reexport QuestionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__RadarChartOutlined__ = __webpack_require__(3058);
/* unused harmony reexport RadarChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__RadiusBottomleftOutlined__ = __webpack_require__(3060);
/* unused harmony reexport RadiusBottomleftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__RadiusBottomrightOutlined__ = __webpack_require__(3062);
/* unused harmony reexport RadiusBottomrightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__RadiusSettingOutlined__ = __webpack_require__(3064);
/* unused harmony reexport RadiusSettingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__RadiusUpleftOutlined__ = __webpack_require__(3066);
/* unused harmony reexport RadiusUpleftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__RadiusUprightOutlined__ = __webpack_require__(3068);
/* unused harmony reexport RadiusUprightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__ReadFilled__ = __webpack_require__(3070);
/* unused harmony reexport ReadFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__ReadOutlined__ = __webpack_require__(3072);
/* unused harmony reexport ReadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__ReconciliationFilled__ = __webpack_require__(3074);
/* unused harmony reexport ReconciliationFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__ReconciliationOutlined__ = __webpack_require__(3076);
/* unused harmony reexport ReconciliationOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__ReconciliationTwoTone__ = __webpack_require__(3078);
/* unused harmony reexport ReconciliationTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__RedEnvelopeFilled__ = __webpack_require__(3080);
/* unused harmony reexport RedEnvelopeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__RedEnvelopeOutlined__ = __webpack_require__(3082);
/* unused harmony reexport RedEnvelopeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__RedEnvelopeTwoTone__ = __webpack_require__(3084);
/* unused harmony reexport RedEnvelopeTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__RedditCircleFilled__ = __webpack_require__(3086);
/* unused harmony reexport RedditCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__RedditOutlined__ = __webpack_require__(3088);
/* unused harmony reexport RedditOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__RedditSquareFilled__ = __webpack_require__(3090);
/* unused harmony reexport RedditSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__RedoOutlined__ = __webpack_require__(3092);
/* unused harmony reexport RedoOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__ReloadOutlined__ = __webpack_require__(3094);
/* unused harmony reexport ReloadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__RestFilled__ = __webpack_require__(3096);
/* unused harmony reexport RestFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__RestOutlined__ = __webpack_require__(3098);
/* unused harmony reexport RestOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__RestTwoTone__ = __webpack_require__(3100);
/* unused harmony reexport RestTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__RetweetOutlined__ = __webpack_require__(3102);
/* unused harmony reexport RetweetOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__RightCircleFilled__ = __webpack_require__(3104);
/* unused harmony reexport RightCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__RightCircleOutlined__ = __webpack_require__(3106);
/* unused harmony reexport RightCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__RightCircleTwoTone__ = __webpack_require__(3108);
/* unused harmony reexport RightCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__RightOutlined__ = __webpack_require__(3110);
/* unused harmony reexport RightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__RightSquareFilled__ = __webpack_require__(3112);
/* unused harmony reexport RightSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__RightSquareOutlined__ = __webpack_require__(3114);
/* unused harmony reexport RightSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__RightSquareTwoTone__ = __webpack_require__(3116);
/* unused harmony reexport RightSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__RiseOutlined__ = __webpack_require__(3118);
/* unused harmony reexport RiseOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__RobotFilled__ = __webpack_require__(3120);
/* unused harmony reexport RobotFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__RobotOutlined__ = __webpack_require__(3122);
/* unused harmony reexport RobotOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__RocketFilled__ = __webpack_require__(3124);
/* unused harmony reexport RocketFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__RocketOutlined__ = __webpack_require__(3126);
/* unused harmony reexport RocketOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__RocketTwoTone__ = __webpack_require__(3128);
/* unused harmony reexport RocketTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__RollbackOutlined__ = __webpack_require__(3130);
/* unused harmony reexport RollbackOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__RotateLeftOutlined__ = __webpack_require__(3132);
/* unused harmony reexport RotateLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__RotateRightOutlined__ = __webpack_require__(3134);
/* unused harmony reexport RotateRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__SafetyCertificateFilled__ = __webpack_require__(3136);
/* unused harmony reexport SafetyCertificateFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__SafetyCertificateOutlined__ = __webpack_require__(3138);
/* unused harmony reexport SafetyCertificateOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__SafetyCertificateTwoTone__ = __webpack_require__(3140);
/* unused harmony reexport SafetyCertificateTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__SafetyOutlined__ = __webpack_require__(3142);
/* unused harmony reexport SafetyOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__SaveFilled__ = __webpack_require__(3144);
/* unused harmony reexport SaveFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__SaveOutlined__ = __webpack_require__(3146);
/* unused harmony reexport SaveOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__SaveTwoTone__ = __webpack_require__(3148);
/* unused harmony reexport SaveTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__ScanOutlined__ = __webpack_require__(3150);
/* unused harmony reexport ScanOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__ScheduleFilled__ = __webpack_require__(3152);
/* unused harmony reexport ScheduleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__ScheduleOutlined__ = __webpack_require__(3154);
/* unused harmony reexport ScheduleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__ScheduleTwoTone__ = __webpack_require__(3156);
/* unused harmony reexport ScheduleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__ScissorOutlined__ = __webpack_require__(3158);
/* unused harmony reexport ScissorOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__SearchOutlined__ = __webpack_require__(3160);
/* unused harmony reexport SearchOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__SecurityScanFilled__ = __webpack_require__(3162);
/* unused harmony reexport SecurityScanFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__SecurityScanOutlined__ = __webpack_require__(3164);
/* unused harmony reexport SecurityScanOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__SecurityScanTwoTone__ = __webpack_require__(3166);
/* unused harmony reexport SecurityScanTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__SelectOutlined__ = __webpack_require__(3168);
/* unused harmony reexport SelectOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__SendOutlined__ = __webpack_require__(3170);
/* unused harmony reexport SendOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__SettingFilled__ = __webpack_require__(3172);
/* unused harmony reexport SettingFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__SettingOutlined__ = __webpack_require__(3174);
/* unused harmony reexport SettingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__SettingTwoTone__ = __webpack_require__(3176);
/* unused harmony reexport SettingTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__ShakeOutlined__ = __webpack_require__(3178);
/* unused harmony reexport ShakeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__ShareAltOutlined__ = __webpack_require__(3180);
/* unused harmony reexport ShareAltOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__ShopFilled__ = __webpack_require__(3182);
/* unused harmony reexport ShopFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__ShopOutlined__ = __webpack_require__(3184);
/* unused harmony reexport ShopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__ShopTwoTone__ = __webpack_require__(3186);
/* unused harmony reexport ShopTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__ShoppingCartOutlined__ = __webpack_require__(3188);
/* unused harmony reexport ShoppingCartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__ShoppingFilled__ = __webpack_require__(3190);
/* unused harmony reexport ShoppingFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__ShoppingOutlined__ = __webpack_require__(3192);
/* unused harmony reexport ShoppingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__ShoppingTwoTone__ = __webpack_require__(3194);
/* unused harmony reexport ShoppingTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__ShrinkOutlined__ = __webpack_require__(3196);
/* unused harmony reexport ShrinkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__SignalFilled__ = __webpack_require__(3198);
/* unused harmony reexport SignalFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__SisternodeOutlined__ = __webpack_require__(3200);
/* unused harmony reexport SisternodeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__SketchCircleFilled__ = __webpack_require__(3202);
/* unused harmony reexport SketchCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__SketchOutlined__ = __webpack_require__(3204);
/* unused harmony reexport SketchOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__SketchSquareFilled__ = __webpack_require__(3206);
/* unused harmony reexport SketchSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__SkinFilled__ = __webpack_require__(3208);
/* unused harmony reexport SkinFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__SkinOutlined__ = __webpack_require__(3210);
/* unused harmony reexport SkinOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__SkinTwoTone__ = __webpack_require__(3212);
/* unused harmony reexport SkinTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__SkypeFilled__ = __webpack_require__(3214);
/* unused harmony reexport SkypeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__SkypeOutlined__ = __webpack_require__(3216);
/* unused harmony reexport SkypeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__SlackCircleFilled__ = __webpack_require__(3218);
/* unused harmony reexport SlackCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__SlackOutlined__ = __webpack_require__(3220);
/* unused harmony reexport SlackOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__SlackSquareFilled__ = __webpack_require__(3222);
/* unused harmony reexport SlackSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__SlackSquareOutlined__ = __webpack_require__(3224);
/* unused harmony reexport SlackSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__SlidersFilled__ = __webpack_require__(3226);
/* unused harmony reexport SlidersFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__SlidersOutlined__ = __webpack_require__(3228);
/* unused harmony reexport SlidersOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__SlidersTwoTone__ = __webpack_require__(3230);
/* unused harmony reexport SlidersTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__SmallDashOutlined__ = __webpack_require__(3232);
/* unused harmony reexport SmallDashOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__SmileFilled__ = __webpack_require__(3234);
/* unused harmony reexport SmileFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__SmileOutlined__ = __webpack_require__(3236);
/* unused harmony reexport SmileOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__SmileTwoTone__ = __webpack_require__(3238);
/* unused harmony reexport SmileTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__SnippetsFilled__ = __webpack_require__(3240);
/* unused harmony reexport SnippetsFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__SnippetsOutlined__ = __webpack_require__(3242);
/* unused harmony reexport SnippetsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__SnippetsTwoTone__ = __webpack_require__(3244);
/* unused harmony reexport SnippetsTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__SolutionOutlined__ = __webpack_require__(3246);
/* unused harmony reexport SolutionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__SortAscendingOutlined__ = __webpack_require__(3248);
/* unused harmony reexport SortAscendingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__SortDescendingOutlined__ = __webpack_require__(3250);
/* unused harmony reexport SortDescendingOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__SoundFilled__ = __webpack_require__(3252);
/* unused harmony reexport SoundFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__SoundOutlined__ = __webpack_require__(3254);
/* unused harmony reexport SoundOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__SoundTwoTone__ = __webpack_require__(3256);
/* unused harmony reexport SoundTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__SplitCellsOutlined__ = __webpack_require__(3258);
/* unused harmony reexport SplitCellsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__StarFilled__ = __webpack_require__(3260);
/* unused harmony reexport StarFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__StarOutlined__ = __webpack_require__(3262);
/* unused harmony reexport StarOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__StarTwoTone__ = __webpack_require__(3264);
/* unused harmony reexport StarTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__StepBackwardFilled__ = __webpack_require__(3266);
/* unused harmony reexport StepBackwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__StepBackwardOutlined__ = __webpack_require__(3268);
/* unused harmony reexport StepBackwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__StepForwardFilled__ = __webpack_require__(3270);
/* unused harmony reexport StepForwardFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__StepForwardOutlined__ = __webpack_require__(3272);
/* unused harmony reexport StepForwardOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__StockOutlined__ = __webpack_require__(3274);
/* unused harmony reexport StockOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__StopFilled__ = __webpack_require__(3276);
/* unused harmony reexport StopFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__StopOutlined__ = __webpack_require__(3278);
/* unused harmony reexport StopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__StopTwoTone__ = __webpack_require__(3280);
/* unused harmony reexport StopTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__StrikethroughOutlined__ = __webpack_require__(3282);
/* unused harmony reexport StrikethroughOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__SubnodeOutlined__ = __webpack_require__(3284);
/* unused harmony reexport SubnodeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__SwapLeftOutlined__ = __webpack_require__(3286);
/* unused harmony reexport SwapLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__SwapOutlined__ = __webpack_require__(3288);
/* unused harmony reexport SwapOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__SwapRightOutlined__ = __webpack_require__(3290);
/* unused harmony reexport SwapRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__SwitcherFilled__ = __webpack_require__(3292);
/* unused harmony reexport SwitcherFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__SwitcherOutlined__ = __webpack_require__(3294);
/* unused harmony reexport SwitcherOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__SwitcherTwoTone__ = __webpack_require__(3296);
/* unused harmony reexport SwitcherTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__SyncOutlined__ = __webpack_require__(3298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_690__SyncOutlined__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__TableOutlined__ = __webpack_require__(3300);
/* unused harmony reexport TableOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__TabletFilled__ = __webpack_require__(3302);
/* unused harmony reexport TabletFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__TabletOutlined__ = __webpack_require__(3304);
/* unused harmony reexport TabletOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__TabletTwoTone__ = __webpack_require__(3306);
/* unused harmony reexport TabletTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__TagFilled__ = __webpack_require__(3308);
/* unused harmony reexport TagFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__TagOutlined__ = __webpack_require__(3310);
/* unused harmony reexport TagOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__TagTwoTone__ = __webpack_require__(3312);
/* unused harmony reexport TagTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__TagsFilled__ = __webpack_require__(3314);
/* unused harmony reexport TagsFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__TagsOutlined__ = __webpack_require__(3316);
/* unused harmony reexport TagsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__TagsTwoTone__ = __webpack_require__(3318);
/* unused harmony reexport TagsTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__TaobaoCircleFilled__ = __webpack_require__(3320);
/* unused harmony reexport TaobaoCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__TaobaoCircleOutlined__ = __webpack_require__(3322);
/* unused harmony reexport TaobaoCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__TaobaoOutlined__ = __webpack_require__(3324);
/* unused harmony reexport TaobaoOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__TaobaoSquareFilled__ = __webpack_require__(3326);
/* unused harmony reexport TaobaoSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__TeamOutlined__ = __webpack_require__(3328);
/* unused harmony reexport TeamOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__ThunderboltFilled__ = __webpack_require__(3330);
/* unused harmony reexport ThunderboltFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__ThunderboltOutlined__ = __webpack_require__(3332);
/* unused harmony reexport ThunderboltOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__ThunderboltTwoTone__ = __webpack_require__(3334);
/* unused harmony reexport ThunderboltTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__ToTopOutlined__ = __webpack_require__(3336);
/* unused harmony reexport ToTopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__ToolFilled__ = __webpack_require__(3338);
/* unused harmony reexport ToolFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__ToolOutlined__ = __webpack_require__(3340);
/* unused harmony reexport ToolOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__ToolTwoTone__ = __webpack_require__(3342);
/* unused harmony reexport ToolTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__TrademarkCircleFilled__ = __webpack_require__(3344);
/* unused harmony reexport TrademarkCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__TrademarkCircleOutlined__ = __webpack_require__(3346);
/* unused harmony reexport TrademarkCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__TrademarkCircleTwoTone__ = __webpack_require__(3348);
/* unused harmony reexport TrademarkCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__TrademarkOutlined__ = __webpack_require__(3350);
/* unused harmony reexport TrademarkOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__TransactionOutlined__ = __webpack_require__(3352);
/* unused harmony reexport TransactionOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__TranslationOutlined__ = __webpack_require__(3354);
/* unused harmony reexport TranslationOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__TrophyFilled__ = __webpack_require__(3356);
/* unused harmony reexport TrophyFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__TrophyOutlined__ = __webpack_require__(3358);
/* unused harmony reexport TrophyOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__TrophyTwoTone__ = __webpack_require__(3360);
/* unused harmony reexport TrophyTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__TwitterCircleFilled__ = __webpack_require__(3362);
/* unused harmony reexport TwitterCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__TwitterOutlined__ = __webpack_require__(3364);
/* unused harmony reexport TwitterOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__TwitterSquareFilled__ = __webpack_require__(3366);
/* unused harmony reexport TwitterSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__UnderlineOutlined__ = __webpack_require__(3368);
/* unused harmony reexport UnderlineOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__UndoOutlined__ = __webpack_require__(3370);
/* unused harmony reexport UndoOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__UngroupOutlined__ = __webpack_require__(3372);
/* unused harmony reexport UngroupOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__UnlockFilled__ = __webpack_require__(3374);
/* unused harmony reexport UnlockFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__UnlockOutlined__ = __webpack_require__(3376);
/* unused harmony reexport UnlockOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__UnlockTwoTone__ = __webpack_require__(3378);
/* unused harmony reexport UnlockTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__UnorderedListOutlined__ = __webpack_require__(3380);
/* unused harmony reexport UnorderedListOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__UpCircleFilled__ = __webpack_require__(3382);
/* unused harmony reexport UpCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__UpCircleOutlined__ = __webpack_require__(3384);
/* unused harmony reexport UpCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__UpCircleTwoTone__ = __webpack_require__(3386);
/* unused harmony reexport UpCircleTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__UpOutlined__ = __webpack_require__(3388);
/* unused harmony reexport UpOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__UpSquareFilled__ = __webpack_require__(3390);
/* unused harmony reexport UpSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__UpSquareOutlined__ = __webpack_require__(3392);
/* unused harmony reexport UpSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__UpSquareTwoTone__ = __webpack_require__(3394);
/* unused harmony reexport UpSquareTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__UploadOutlined__ = __webpack_require__(3396);
/* unused harmony reexport UploadOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__UsbFilled__ = __webpack_require__(3398);
/* unused harmony reexport UsbFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__UsbOutlined__ = __webpack_require__(3400);
/* unused harmony reexport UsbOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__UsbTwoTone__ = __webpack_require__(3402);
/* unused harmony reexport UsbTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__UserAddOutlined__ = __webpack_require__(3404);
/* unused harmony reexport UserAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__UserDeleteOutlined__ = __webpack_require__(3406);
/* unused harmony reexport UserDeleteOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__UserOutlined__ = __webpack_require__(3408);
/* unused harmony reexport UserOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__UserSwitchOutlined__ = __webpack_require__(3410);
/* unused harmony reexport UserSwitchOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__UsergroupAddOutlined__ = __webpack_require__(3412);
/* unused harmony reexport UsergroupAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__UsergroupDeleteOutlined__ = __webpack_require__(3414);
/* unused harmony reexport UsergroupDeleteOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__VerifiedOutlined__ = __webpack_require__(3416);
/* unused harmony reexport VerifiedOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__VerticalAlignBottomOutlined__ = __webpack_require__(3418);
/* unused harmony reexport VerticalAlignBottomOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__VerticalAlignMiddleOutlined__ = __webpack_require__(3420);
/* unused harmony reexport VerticalAlignMiddleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__VerticalAlignTopOutlined__ = __webpack_require__(3422);
/* unused harmony reexport VerticalAlignTopOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__VerticalLeftOutlined__ = __webpack_require__(3424);
/* unused harmony reexport VerticalLeftOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__VerticalRightOutlined__ = __webpack_require__(3426);
/* unused harmony reexport VerticalRightOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__VideoCameraAddOutlined__ = __webpack_require__(3428);
/* unused harmony reexport VideoCameraAddOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__VideoCameraFilled__ = __webpack_require__(3430);
/* unused harmony reexport VideoCameraFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__VideoCameraOutlined__ = __webpack_require__(3432);
/* unused harmony reexport VideoCameraOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__VideoCameraTwoTone__ = __webpack_require__(3434);
/* unused harmony reexport VideoCameraTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__WalletFilled__ = __webpack_require__(3436);
/* unused harmony reexport WalletFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__WalletOutlined__ = __webpack_require__(3438);
/* unused harmony reexport WalletOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__WalletTwoTone__ = __webpack_require__(3440);
/* unused harmony reexport WalletTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__WarningFilled__ = __webpack_require__(3442);
/* unused harmony reexport WarningFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__WarningOutlined__ = __webpack_require__(3444);
/* unused harmony reexport WarningOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__WarningTwoTone__ = __webpack_require__(3446);
/* unused harmony reexport WarningTwoTone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__WechatFilled__ = __webpack_require__(3448);
/* unused harmony reexport WechatFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__WechatOutlined__ = __webpack_require__(3450);
/* unused harmony reexport WechatOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__WeiboCircleFilled__ = __webpack_require__(3452);
/* unused harmony reexport WeiboCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__WeiboCircleOutlined__ = __webpack_require__(3454);
/* unused harmony reexport WeiboCircleOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__WeiboOutlined__ = __webpack_require__(3456);
/* unused harmony reexport WeiboOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__WeiboSquareFilled__ = __webpack_require__(3458);
/* unused harmony reexport WeiboSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__WeiboSquareOutlined__ = __webpack_require__(3460);
/* unused harmony reexport WeiboSquareOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__WhatsAppOutlined__ = __webpack_require__(3462);
/* unused harmony reexport WhatsAppOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__WifiOutlined__ = __webpack_require__(3464);
/* unused harmony reexport WifiOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__WindowsFilled__ = __webpack_require__(3466);
/* unused harmony reexport WindowsFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__WindowsOutlined__ = __webpack_require__(3468);
/* unused harmony reexport WindowsOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__WomanOutlined__ = __webpack_require__(3470);
/* unused harmony reexport WomanOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__YahooFilled__ = __webpack_require__(3472);
/* unused harmony reexport YahooFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__YahooOutlined__ = __webpack_require__(3474);
/* unused harmony reexport YahooOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__YoutubeFilled__ = __webpack_require__(3476);
/* unused harmony reexport YoutubeFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__YoutubeOutlined__ = __webpack_require__(3478);
/* unused harmony reexport YoutubeOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__YuqueFilled__ = __webpack_require__(3480);
/* unused harmony reexport YuqueFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__YuqueOutlined__ = __webpack_require__(3482);
/* unused harmony reexport YuqueOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__ZhihuCircleFilled__ = __webpack_require__(3484);
/* unused harmony reexport ZhihuCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__ZhihuOutlined__ = __webpack_require__(3486);
/* unused harmony reexport ZhihuOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__ZhihuSquareFilled__ = __webpack_require__(3488);
/* unused harmony reexport ZhihuSquareFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__ZoomInOutlined__ = __webpack_require__(3490);
/* unused harmony reexport ZoomInOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__ZoomOutOutlined__ = __webpack_require__(3492);
/* unused harmony reexport ZoomOutOutlined */
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY





















































































































































































































































































































































































































































































































































































































































































































































































































/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookFilled__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AccountBookFilled = function AccountBookFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookFilled__["a" /* default */]
  }));
};

AccountBookFilled.displayName = 'AccountBookFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AccountBookFilled));

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AccountBookFilled = { "name": "account-book", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AccountBookFilled);


/***/ }),
/* 1919 */
/***/ (function(module, exports) {

var containers = []; // will store container HTMLElement references
var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}

var usage = 'insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).';

function insertCss(css, options) {
    options = options || {};

    if (css === undefined) {
        throw new Error(usage);
    }

    var position = options.prepend === true ? 'prepend' : 'append';
    var container = options.container !== undefined ? options.container : document.querySelector('head');
    var containerId = containers.indexOf(container);

    // first time we see this container, create the necessary entries
    if (containerId === -1) {
        containerId = containers.push(container) - 1;
        styleElements[containerId] = {};
    }

    // try to get the correponding container + position styleElement, create it otherwise
    var styleElement;

    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
        styleElement = styleElements[containerId][position];
    } else {
        styleElement = styleElements[containerId][position] = createStyleElement();

        if (position === 'prepend') {
            container.insertBefore(styleElement, container.childNodes[0]);
        } else {
            container.appendChild(styleElement);
        }
    }

    // strip potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xFEFF) { css = css.substr(1, css.length); }

    // actually add the stylesheet
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText += css
    } else {
        styleElement.textContent += css;
    }

    return styleElement;
};

function createStyleElement() {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    return styleElement;
}

module.exports = insertCss;
module.exports.insertCss = insertCss;


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookOutlined__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookOutlined__["a" /* default */]
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AccountBookOutlined));

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AccountBookOutlined = { "name": "account-book", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AccountBookOutlined);


/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookTwoTone__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AccountBookTwoTone__["a" /* default */]
  }));
};

AccountBookTwoTone.displayName = 'AccountBookTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AccountBookTwoTone));

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AccountBookTwoTone = { "name": "account-book", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 017.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (AccountBookTwoTone);


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AimOutlined__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AimOutlined = function AimOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AimOutlined__["a" /* default */]
  }));
};

AimOutlined.displayName = 'AimOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AimOutlined));

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AimOutlined = { "name": "aim", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" } }, { "tag": "path", "attrs": { "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AimOutlined);


/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertFilled__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlertFilled = function AlertFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertFilled__["a" /* default */]
  }));
};

AlertFilled.displayName = 'AlertFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlertFilled));

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlertFilled = { "name": "alert", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 01-32 32H225a32 32 0 01-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 018 8v96a8 8 0 01-8 8h-56a8 8 0 01-8-8V76a8 8 0 018-8zM177.25 191.66a8 8 0 0111.32 0l67.88 67.88a8 8 0 010 11.31l-39.6 39.6a8 8 0 01-11.31 0l-67.88-67.88a8 8 0 010-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 010 11.3l-67.88 67.9a8 8 0 01-11.32 0l-39.6-39.6a8 8 0 010-11.32l67.89-67.88a8 8 0 0111.31 0zM192 892h640a32 32 0 0132 32v24a8 8 0 01-8 8H168a8 8 0 01-8-8v-24a32 32 0 0132-32zm148-317v253h64V575h-64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlertFilled);


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertOutlined__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlertOutlined = function AlertOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertOutlined__["a" /* default */]
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlertOutlined));

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlertOutlined = { "name": "alert", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlertOutlined);


/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertTwoTone__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlertTwoTone = function AlertTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlertTwoTone__["a" /* default */]
  }));
};

AlertTwoTone.displayName = 'AlertTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlertTwoTone));

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlertTwoTone = { "name": "alert", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (AlertTwoTone);


/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlibabaOutlined__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlibabaOutlined__["a" /* default */]
  }));
};

AlibabaOutlined.displayName = 'AlibabaOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlibabaOutlined));

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlibabaOutlined = { "name": "alibaba", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlibabaOutlined);


/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignCenterOutlined__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignCenterOutlined__["a" /* default */]
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlignCenterOutlined));

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlignCenterOutlined = { "name": "align-center", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlignCenterOutlined);


/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignLeftOutlined__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignLeftOutlined__["a" /* default */]
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlignLeftOutlined));

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlignLeftOutlined = { "name": "align-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlignLeftOutlined);


/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignRightOutlined__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlignRightOutlined__["a" /* default */]
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlignRightOutlined));

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlignRightOutlined = { "name": "align-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlignRightOutlined);


/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayCircleFilled__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayCircleFilled__["a" /* default */]
  }));
};

AlipayCircleFilled.displayName = 'AlipayCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlipayCircleFilled));

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlipayCircleFilled = { "name": "alipay-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlipayCircleFilled);


/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayCircleOutlined__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayCircleOutlined__["a" /* default */]
  }));
};

AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlipayCircleOutlined));

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlipayCircleOutlined = { "name": "alipay-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlipayCircleOutlined);


/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayOutlined__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlipayOutlined = function AlipayOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipayOutlined__["a" /* default */]
  }));
};

AlipayOutlined.displayName = 'AlipayOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlipayOutlined));

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlipayOutlined = { "name": "alipay", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 01-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlipayOutlined);


/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipaySquareFilled__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AlipaySquareFilled__["a" /* default */]
  }));
};

AlipaySquareFilled.displayName = 'AlipaySquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AlipaySquareFilled));

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AlipaySquareFilled = { "name": "alipay-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AlipaySquareFilled);


/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliwangwangFilled__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliwangwangFilled__["a" /* default */]
  }));
};

AliwangwangFilled.displayName = 'AliwangwangFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AliwangwangFilled));

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AliwangwangFilled = { "name": "aliwangwang", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AliwangwangFilled);


/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliwangwangOutlined__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliwangwangOutlined__["a" /* default */]
  }));
};

AliwangwangOutlined.displayName = 'AliwangwangOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AliwangwangOutlined));

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AliwangwangOutlined = { "name": "aliwangwang", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 01-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 01-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 01217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AliwangwangOutlined);


/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliyunOutlined__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AliyunOutlined = function AliyunOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AliyunOutlined__["a" /* default */]
  }));
};

AliyunOutlined.displayName = 'AliyunOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AliyunOutlined));

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AliyunOutlined = { "name": "aliyun", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0132.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 01-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 01-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AliyunOutlined);


/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonCircleFilled__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonCircleFilled__["a" /* default */]
  }));
};

AmazonCircleFilled.displayName = 'AmazonCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AmazonCircleFilled));

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AmazonCircleFilled = { "name": "amazon-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AmazonCircleFilled);


/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonOutlined__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AmazonOutlined = function AmazonOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonOutlined__["a" /* default */]
  }));
};

AmazonOutlined.displayName = 'AmazonOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AmazonOutlined));

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AmazonOutlined = { "name": "amazon", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 00-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AmazonOutlined);


/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonSquareFilled__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AmazonSquareFilled__["a" /* default */]
  }));
};

AmazonSquareFilled.displayName = 'AmazonSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AmazonSquareFilled));

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AmazonSquareFilled = { "name": "amazon-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AmazonSquareFilled);


/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AndroidFilled__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AndroidFilled = function AndroidFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AndroidFilled__["a" /* default */]
  }));
};

AndroidFilled.displayName = 'AndroidFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AndroidFilled));

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AndroidFilled = { "name": "android", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AndroidFilled);


/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AndroidOutlined__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AndroidOutlined = function AndroidOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AndroidOutlined__["a" /* default */]
  }));
};

AndroidOutlined.displayName = 'AndroidOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AndroidOutlined));

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AndroidOutlined = { "name": "android", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AndroidOutlined);


/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AntCloudOutlined__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AntCloudOutlined__["a" /* default */]
  }));
};

AntCloudOutlined.displayName = 'AntCloudOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AntCloudOutlined));

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AntCloudOutlined = { "name": "ant-cloud", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0122.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 01-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1096 0 48 48 0 10-96 0zm-65.7 61.3a24 24 0 1048 0 24 24 0 10-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AntCloudOutlined);


/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AntDesignOutlined__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AntDesignOutlined__["a" /* default */]
  }));
};

AntDesignOutlined.displayName = 'AntDesignOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AntDesignOutlined));

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AntDesignOutlined = { "name": "ant-design", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 000 76.4L474.6 944a54.14 54.14 0 0076.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 00-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 10212.6 0 106.3 106.2 0 10-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 000 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 000 68.6 48.7 48.7 0 0068.7 0l121.8-121.7a53.93 53.93 0 00-.1-76.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AntDesignOutlined);


/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApartmentOutlined__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApartmentOutlined__["a" /* default */]
  }));
};

ApartmentOutlined.displayName = 'ApartmentOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ApartmentOutlined));

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ApartmentOutlined = { "name": "apartment", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ApartmentOutlined);


/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiFilled__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ApiFilled = function ApiFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiFilled__["a" /* default */]
  }));
};

ApiFilled.displayName = 'ApiFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ApiFilled));

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ApiFilled = { "name": "api", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ApiFilled);


/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiOutlined__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ApiOutlined = function ApiOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiOutlined__["a" /* default */]
  }));
};

ApiOutlined.displayName = 'ApiOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ApiOutlined));

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ApiOutlined = { "name": "api", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ApiOutlined);


/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiTwoTone__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ApiTwoTone = function ApiTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ApiTwoTone__["a" /* default */]
  }));
};

ApiTwoTone.displayName = 'ApiTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ApiTwoTone));

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ApiTwoTone = { "name": "api", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 00-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ApiTwoTone);


/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppleFilled__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppleFilled = function AppleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppleFilled__["a" /* default */]
  }));
};

AppleFilled.displayName = 'AppleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppleFilled));

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppleFilled = { "name": "apple", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AppleFilled);


/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppleOutlined__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppleOutlined = function AppleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppleOutlined__["a" /* default */]
  }));
};

AppleOutlined.displayName = 'AppleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppleOutlined));

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppleOutlined = { "name": "apple", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AppleOutlined);


/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreAddOutlined__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreAddOutlined__["a" /* default */]
  }));
};

AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppstoreAddOutlined));

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppstoreAddOutlined = { "name": "appstore-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zm52 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AppstoreAddOutlined);


/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreFilled__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppstoreFilled = function AppstoreFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreFilled__["a" /* default */]
  }));
};

AppstoreFilled.displayName = 'AppstoreFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppstoreFilled));

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppstoreFilled = { "name": "appstore", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AppstoreFilled);


/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreOutlined__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreOutlined__["a" /* default */]
  }));
};

AppstoreOutlined.displayName = 'AppstoreOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppstoreOutlined));

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppstoreOutlined = { "name": "appstore", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AppstoreOutlined);


/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreTwoTone__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AppstoreTwoTone__["a" /* default */]
  }));
};

AppstoreTwoTone.displayName = 'AppstoreTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AppstoreTwoTone));

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AppstoreTwoTone = { "name": "appstore", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (AppstoreTwoTone);


/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AreaChartOutlined__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AreaChartOutlined__["a" /* default */]
  }));
};

AreaChartOutlined.displayName = 'AreaChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AreaChartOutlined));

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AreaChartOutlined = { "name": "area-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 00-11.3 0l-189 189.6a7.87 7.87 0 00-2.3 5.6V720c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AreaChartOutlined);


/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowDownOutlined__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowDownOutlined__["a" /* default */]
  }));
};

ArrowDownOutlined.displayName = 'ArrowDownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ArrowDownOutlined));

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ArrowDownOutlined = { "name": "arrow-down", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ArrowDownOutlined);


/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowLeftOutlined__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowLeftOutlined__["a" /* default */]
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ArrowLeftOutlined));

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ArrowLeftOutlined = { "name": "arrow-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ArrowLeftOutlined);


/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowRightOutlined__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowRightOutlined__["a" /* default */]
  }));
};

ArrowRightOutlined.displayName = 'ArrowRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ArrowRightOutlined));

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ArrowRightOutlined = { "name": "arrow-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ArrowRightOutlined);


/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowUpOutlined__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowUpOutlined__["a" /* default */]
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ArrowUpOutlined));

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ArrowUpOutlined = { "name": "arrow-up", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ArrowUpOutlined);


/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowsAltOutlined__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ArrowsAltOutlined__["a" /* default */]
  }));
};

ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ArrowsAltOutlined));

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ArrowsAltOutlined = { "name": "arrows-alt", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ArrowsAltOutlined);


/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioFilled__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AudioFilled = function AudioFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioFilled__["a" /* default */]
  }));
};

AudioFilled.displayName = 'AudioFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AudioFilled));

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AudioFilled = { "name": "audio", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AudioFilled);


/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioMutedOutlined__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioMutedOutlined__["a" /* default */]
  }));
};

AudioMutedOutlined.displayName = 'AudioMutedOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AudioMutedOutlined));

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AudioMutedOutlined = { "name": "audio-muted", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z" } }, { "tag": "path", "attrs": { "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AudioMutedOutlined);


/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioOutlined__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AudioOutlined = function AudioOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioOutlined__["a" /* default */]
  }));
};

AudioOutlined.displayName = 'AudioOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AudioOutlined));

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AudioOutlined = { "name": "audio", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AudioOutlined);


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioTwoTone__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AudioTwoTone = function AudioTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AudioTwoTone__["a" /* default */]
  }));
};

AudioTwoTone.displayName = 'AudioTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AudioTwoTone));

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AudioTwoTone = { "name": "audio", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (AudioTwoTone);


/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AuditOutlined__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var AuditOutlined = function AuditOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_AuditOutlined__["a" /* default */]
  }));
};

AuditOutlined.displayName = 'AuditOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(AuditOutlined));

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var AuditOutlined = { "name": "audit", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (AuditOutlined);


/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BackwardFilled__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BackwardFilled = function BackwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BackwardFilled__["a" /* default */]
  }));
};

BackwardFilled.displayName = 'BackwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BackwardFilled));

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BackwardFilled = { "name": "backward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BackwardFilled);


/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BackwardOutlined__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BackwardOutlined = function BackwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BackwardOutlined__["a" /* default */]
  }));
};

BackwardOutlined.displayName = 'BackwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BackwardOutlined));

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BackwardOutlined = { "name": "backward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BackwardOutlined);


/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankFilled__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BankFilled = function BankFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankFilled__["a" /* default */]
  }));
};

BankFilled.displayName = 'BankFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BankFilled));

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BankFilled = { "name": "bank", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BankFilled);


/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankOutlined__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BankOutlined = function BankOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankOutlined__["a" /* default */]
  }));
};

BankOutlined.displayName = 'BankOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BankOutlined));

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BankOutlined = { "name": "bank", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BankOutlined);


/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankTwoTone__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BankTwoTone = function BankTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BankTwoTone__["a" /* default */]
  }));
};

BankTwoTone.displayName = 'BankTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BankTwoTone));

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BankTwoTone = { "name": "bank", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M240.9 393.9h542.2L512 196.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BankTwoTone);


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarChartOutlined__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BarChartOutlined = function BarChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarChartOutlined__["a" /* default */]
  }));
};

BarChartOutlined.displayName = 'BarChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BarChartOutlined));

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BarChartOutlined = { "name": "bar-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BarChartOutlined);


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarcodeOutlined__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarcodeOutlined__["a" /* default */]
  }));
};

BarcodeOutlined.displayName = 'BarcodeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BarcodeOutlined));

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BarcodeOutlined = { "name": "barcode", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BarcodeOutlined);


/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarsOutlined__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BarsOutlined = function BarsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BarsOutlined__["a" /* default */]
  }));
};

BarsOutlined.displayName = 'BarsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BarsOutlined));

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BarsOutlined = { "name": "bars", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BarsOutlined);


/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceCircleFilled__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceCircleFilled__["a" /* default */]
  }));
};

BehanceCircleFilled.displayName = 'BehanceCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BehanceCircleFilled));

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BehanceCircleFilled = { "name": "behance-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0017.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BehanceCircleFilled);


/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceOutlined__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BehanceOutlined = function BehanceOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceOutlined__["a" /* default */]
  }));
};

BehanceOutlined.displayName = 'BehanceOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BehanceOutlined));

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BehanceOutlined = { "name": "behance", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BehanceOutlined);


/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceSquareFilled__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceSquareFilled__["a" /* default */]
  }));
};

BehanceSquareFilled.displayName = 'BehanceSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BehanceSquareFilled));

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BehanceSquareFilled = { "name": "behance-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BehanceSquareFilled);


/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceSquareOutlined__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BehanceSquareOutlined__["a" /* default */]
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BehanceSquareOutlined));

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BehanceSquareOutlined = { "name": "behance-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BehanceSquareOutlined);


/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellFilled__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BellFilled = function BellFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellFilled__["a" /* default */]
  }));
};

BellFilled.displayName = 'BellFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BellFilled));

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BellFilled = { "name": "bell", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BellFilled);


/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellOutlined__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BellOutlined = function BellOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellOutlined__["a" /* default */]
  }));
};

BellOutlined.displayName = 'BellOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BellOutlined));

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BellOutlined = { "name": "bell", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BellOutlined);


/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellTwoTone__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BellTwoTone = function BellTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BellTwoTone__["a" /* default */]
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BellTwoTone));

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BellTwoTone = { "name": "bell", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BellTwoTone);


/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BgColorsOutlined__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BgColorsOutlined__["a" /* default */]
  }));
};

BgColorsOutlined.displayName = 'BgColorsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BgColorsOutlined));

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BgColorsOutlined = { "name": "bg-colors", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BgColorsOutlined);


/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BlockOutlined__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BlockOutlined = function BlockOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BlockOutlined__["a" /* default */]
  }));
};

BlockOutlined.displayName = 'BlockOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BlockOutlined));

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BlockOutlined = { "name": "block", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BlockOutlined);


/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoldOutlined__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BoldOutlined = function BoldOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoldOutlined__["a" /* default */]
  }));
};

BoldOutlined.displayName = 'BoldOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BoldOutlined));

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BoldOutlined = { "name": "bold", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BoldOutlined);


/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookFilled__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BookFilled = function BookFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookFilled__["a" /* default */]
  }));
};

BookFilled.displayName = 'BookFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BookFilled));

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BookFilled = { "name": "book", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BookFilled);


/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookOutlined__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BookOutlined = function BookOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookOutlined__["a" /* default */]
  }));
};

BookOutlined.displayName = 'BookOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BookOutlined));

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BookOutlined = { "name": "book", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BookOutlined);


/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookTwoTone__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BookTwoTone = function BookTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BookTwoTone__["a" /* default */]
  }));
};

BookTwoTone.displayName = 'BookTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BookTwoTone));

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BookTwoTone = { "name": "book", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M668 345.9V136h-96v211.4l49.5-35.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 01-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BookTwoTone);


/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderBottomOutlined__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderBottomOutlined__["a" /* default */]
  }));
};

BorderBottomOutlined.displayName = 'BorderBottomOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderBottomOutlined));

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderBottomOutlined = { "name": "border-bottom", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderBottomOutlined);


/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderHorizontalOutlined__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderHorizontalOutlined__["a" /* default */]
  }));
};

BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderHorizontalOutlined));

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderHorizontalOutlined = { "name": "border-horizontal", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderHorizontalOutlined);


/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderInnerOutlined__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderInnerOutlined__["a" /* default */]
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderInnerOutlined));

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderInnerOutlined = { "name": "border-inner", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderInnerOutlined);


/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderLeftOutlined__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderLeftOutlined__["a" /* default */]
  }));
};

BorderLeftOutlined.displayName = 'BorderLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderLeftOutlined));

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderLeftOutlined = { "name": "border-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderLeftOutlined);


/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderOuterOutlined__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderOuterOutlined__["a" /* default */]
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderOuterOutlined));

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderOuterOutlined = { "name": "border-outer", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderOuterOutlined);


/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderOutlined__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderOutlined = function BorderOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderOutlined__["a" /* default */]
  }));
};

BorderOutlined.displayName = 'BorderOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderOutlined));

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderOutlined = { "name": "border", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderOutlined);


/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderRightOutlined__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderRightOutlined__["a" /* default */]
  }));
};

BorderRightOutlined.displayName = 'BorderRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderRightOutlined));

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderRightOutlined = { "name": "border-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderRightOutlined);


/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderTopOutlined__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderTopOutlined__["a" /* default */]
  }));
};

BorderTopOutlined.displayName = 'BorderTopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderTopOutlined));

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderTopOutlined = { "name": "border-top", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderTopOutlined);


/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderVerticleOutlined__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderVerticleOutlined = function BorderVerticleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderVerticleOutlined__["a" /* default */]
  }));
};

BorderVerticleOutlined.displayName = 'BorderVerticleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderVerticleOutlined));

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderVerticleOutlined = { "name": "border-verticle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderVerticleOutlined);


/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderlessTableOutlined__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BorderlessTableOutlined__["a" /* default */]
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BorderlessTableOutlined));

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BorderlessTableOutlined = { "name": "borderless-table", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M117 368h231v64H117zm559 0h241v64H676zm-264 0h200v64H412zm0 224h200v64H412zm264 0h241v64H676zm-559 0h231v64H117zm295-160V179h-64v666h64V592zm264-64V179h-64v666h64V432z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BorderlessTableOutlined);


/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotFilled__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotFilled__["a" /* default */]
  }));
};

BoxPlotFilled.displayName = 'BoxPlotFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BoxPlotFilled));

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BoxPlotFilled = { "name": "box-plot", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BoxPlotFilled);


/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotOutlined__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotOutlined__["a" /* default */]
  }));
};

BoxPlotOutlined.displayName = 'BoxPlotOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BoxPlotOutlined));

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BoxPlotOutlined = { "name": "box-plot", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BoxPlotOutlined);


/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotTwoTone__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BoxPlotTwoTone__["a" /* default */]
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BoxPlotTwoTone));

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BoxPlotTwoTone = { "name": "box-plot", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 368h88v288h-88zm152 0h280v288H448z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BoxPlotTwoTone);


/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BranchesOutlined__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BranchesOutlined = function BranchesOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BranchesOutlined__["a" /* default */]
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BranchesOutlined));

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BranchesOutlined = { "name": "branches", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0034.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm408-491a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BranchesOutlined);


/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugFilled__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BugFilled = function BugFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugFilled__["a" /* default */]
  }));
};

BugFilled.displayName = 'BugFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BugFilled));

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BugFilled = { "name": "bug", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 00123.2-149.5A120.4 120.4 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BugFilled);


/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugOutlined__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BugOutlined = function BugOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugOutlined__["a" /* default */]
  }));
};

BugOutlined.displayName = 'BugOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BugOutlined));

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BugOutlined = { "name": "bug", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 00123.2-149.5A120 120 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 01308 680V412h408v268z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BugOutlined);


/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugTwoTone__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BugTwoTone = function BugTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BugTwoTone__["a" /* default */]
  }));
};

BugTwoTone.displayName = 'BugTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BugTwoTone));

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BugTwoTone = { "name": "bug", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 01-22.66 49.02 281.39 281.39 0 01-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 01-100.45-100.45 278.63 278.63 0 01-22.66-49.02A119.95 119.95 0 00188 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 01232 680v-96H84a8 8 0 01-8-8v-56a8 8 0 018-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 018-8h60a8 8 0 018 8 63 63 0 0063 63h560a63 63 0 0063-63 8 8 0 018-8h60a8 8 0 018 8c0 76.77-62.23 139-139 139v100h148a8 8 0 018 8v56a8 8 0 01-8 8H792zM368 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0174.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0174.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 00-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 00-45.4 45.39C373.95 218.85 368 243.67 368 272z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BugTwoTone);


/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildFilled__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BuildFilled = function BuildFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildFilled__["a" /* default */]
  }));
};

BuildFilled.displayName = 'BuildFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BuildFilled));

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BuildFilled = { "name": "build", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BuildFilled);


/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildOutlined__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BuildOutlined = function BuildOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildOutlined__["a" /* default */]
  }));
};

BuildOutlined.displayName = 'BuildOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BuildOutlined));

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BuildOutlined = { "name": "build", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BuildOutlined);


/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildTwoTone__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BuildTwoTone = function BuildTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BuildTwoTone__["a" /* default */]
  }));
};

BuildTwoTone.displayName = 'BuildTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BuildTwoTone));

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BuildTwoTone = { "name": "build", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M144 546h200v200H144zm268-268h200v200H412z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BuildTwoTone);


/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbFilled__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BulbFilled = function BulbFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbFilled__["a" /* default */]
  }));
};

BulbFilled.displayName = 'BulbFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BulbFilled));

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BulbFilled = { "name": "bulb", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BulbFilled);


/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbOutlined__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BulbOutlined = function BulbOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbOutlined__["a" /* default */]
  }));
};

BulbOutlined.displayName = 'BulbOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BulbOutlined));

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BulbOutlined = { "name": "bulb", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (BulbOutlined);


/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbTwoTone__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var BulbTwoTone = function BulbTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_BulbTwoTone__["a" /* default */]
  }));
};

BulbTwoTone.displayName = 'BulbTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(BulbTwoTone));

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var BulbTwoTone = { "name": "bulb", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (BulbTwoTone);


/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorFilled__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalculatorFilled = function CalculatorFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorFilled__["a" /* default */]
  }));
};

CalculatorFilled.displayName = 'CalculatorFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalculatorFilled));

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalculatorFilled = { "name": "calculator", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CalculatorFilled);


/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorOutlined__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorOutlined__["a" /* default */]
  }));
};

CalculatorOutlined.displayName = 'CalculatorOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalculatorOutlined));

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalculatorOutlined = { "name": "calculator", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CalculatorOutlined);


/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorTwoTone__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalculatorTwoTone__["a" /* default */]
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalculatorTwoTone));

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalculatorTwoTone = { "name": "calculator", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CalculatorTwoTone);


/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarFilled__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalendarFilled = function CalendarFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarFilled__["a" /* default */]
  }));
};

CalendarFilled.displayName = 'CalendarFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalendarFilled));

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalendarFilled = { "name": "calendar", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CalendarFilled);


/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarOutlined__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalendarOutlined = function CalendarOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarOutlined__["a" /* default */]
  }));
};

CalendarOutlined.displayName = 'CalendarOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalendarOutlined));

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalendarOutlined = { "name": "calendar", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CalendarOutlined);


/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarTwoTone__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CalendarTwoTone__["a" /* default */]
  }));
};

CalendarTwoTone.displayName = 'CalendarTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CalendarTwoTone));

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CalendarTwoTone = { "name": "calendar", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CalendarTwoTone);


/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraFilled__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CameraFilled = function CameraFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraFilled__["a" /* default */]
  }));
};

CameraFilled.displayName = 'CameraFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CameraFilled));

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CameraFilled = { "name": "camera", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 10192 0 96 96 0 10-192 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CameraFilled);


/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraOutlined__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CameraOutlined = function CameraOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraOutlined__["a" /* default */]
  }));
};

CameraOutlined.displayName = 'CameraOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CameraOutlined));

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CameraOutlined = { "name": "camera", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CameraOutlined);


/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraTwoTone__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CameraTwoTone = function CameraTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CameraTwoTone__["a" /* default */]
  }));
};

CameraTwoTone.displayName = 'CameraTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CameraTwoTone));

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CameraTwoTone = { "name": "camera", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CameraTwoTone);


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarFilled__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarFilled = function CarFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarFilled__["a" /* default */]
  }));
};

CarFilled.displayName = 'CarFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarFilled));

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarFilled = { "name": "car", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CarFilled);


/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarOutlined__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarOutlined = function CarOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarOutlined__["a" /* default */]
  }));
};

CarOutlined.displayName = 'CarOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarOutlined));

/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarOutlined = { "name": "car", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1080 0 40 40 0 10-80 0zm239-167.6L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CarOutlined);


/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarTwoTone__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarTwoTone = function CarTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarTwoTone__["a" /* default */]
  }));
};

CarTwoTone.displayName = 'CarTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarTwoTone));

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarTwoTone = { "name": "car", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M720 581a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M224 581a40 40 0 1080 0 40 40 0 10-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CarTwoTone);


/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretDownFilled__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretDownFilled = function CaretDownFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretDownFilled__["a" /* default */]
  }));
};

CaretDownFilled.displayName = 'CaretDownFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretDownFilled));

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretDownFilled = { "name": "caret-down", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretDownFilled);


/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretDownOutlined__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretDownOutlined__["a" /* default */]
  }));
};

CaretDownOutlined.displayName = 'CaretDownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretDownOutlined));

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretDownOutlined = { "name": "caret-down", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretDownOutlined);


/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretLeftFilled__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretLeftFilled__["a" /* default */]
  }));
};

CaretLeftFilled.displayName = 'CaretLeftFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretLeftFilled));

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretLeftFilled = { "name": "caret-left", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretLeftFilled);


/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretLeftOutlined__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretLeftOutlined__["a" /* default */]
  }));
};

CaretLeftOutlined.displayName = 'CaretLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretLeftOutlined));

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretLeftOutlined = { "name": "caret-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretLeftOutlined);


/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretRightFilled__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretRightFilled = function CaretRightFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretRightFilled__["a" /* default */]
  }));
};

CaretRightFilled.displayName = 'CaretRightFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretRightFilled));

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretRightFilled = { "name": "caret-right", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretRightFilled);


/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretRightOutlined__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretRightOutlined__["a" /* default */]
  }));
};

CaretRightOutlined.displayName = 'CaretRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretRightOutlined));

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretRightOutlined = { "name": "caret-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretRightOutlined);


/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretUpFilled__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretUpFilled = function CaretUpFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretUpFilled__["a" /* default */]
  }));
};

CaretUpFilled.displayName = 'CaretUpFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretUpFilled));

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretUpFilled = { "name": "caret-up", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretUpFilled);


/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretUpOutlined__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CaretUpOutlined__["a" /* default */]
  }));
};

CaretUpOutlined.displayName = 'CaretUpOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CaretUpOutlined));

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CaretUpOutlined = { "name": "caret-up", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CaretUpOutlined);


/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutFilled__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarryOutFilled = function CarryOutFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutFilled__["a" /* default */]
  }));
};

CarryOutFilled.displayName = 'CarryOutFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarryOutFilled));

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarryOutFilled = { "name": "carry-out", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CarryOutFilled);


/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutOutlined__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutOutlined__["a" /* default */]
  }));
};

CarryOutOutlined.displayName = 'CarryOutOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarryOutOutlined));

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarryOutOutlined = { "name": "carry-out", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CarryOutOutlined);


/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutTwoTone__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CarryOutTwoTone__["a" /* default */]
  }));
};

CarryOutTwoTone.displayName = 'CarryOutTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CarryOutTwoTone));

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CarryOutTwoTone = { "name": "carry-out", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CarryOutTwoTone);


/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleFilled__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleFilled__["a" /* default */]
  }));
};

CheckCircleFilled.displayName = 'CheckCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckCircleFilled));

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckCircleFilled = { "name": "check-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CheckCircleFilled);


/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleOutlined__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleOutlined__["a" /* default */]
  }));
};

CheckCircleOutlined.displayName = 'CheckCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckCircleOutlined));

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckCircleOutlined = { "name": "check-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CheckCircleOutlined);


/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleTwoTone__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckCircleTwoTone__["a" /* default */]
  }));
};

CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckCircleTwoTone));

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckCircleTwoTone = { "name": "check-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CheckCircleTwoTone);


/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckOutlined__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckOutlined = function CheckOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckOutlined__["a" /* default */]
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckOutlined));

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckOutlined = { "name": "check", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CheckOutlined);


/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareFilled__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareFilled__["a" /* default */]
  }));
};

CheckSquareFilled.displayName = 'CheckSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckSquareFilled));

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckSquareFilled = { "name": "check-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CheckSquareFilled);


/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareOutlined__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareOutlined__["a" /* default */]
  }));
};

CheckSquareOutlined.displayName = 'CheckSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckSquareOutlined));

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckSquareOutlined = { "name": "check-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.1 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CheckSquareOutlined);


/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareTwoTone__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CheckSquareTwoTone__["a" /* default */]
  }));
};

CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CheckSquareTwoTone));

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CheckSquareTwoTone = { "name": "check-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 01-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M432.2 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CheckSquareTwoTone);


/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ChromeFilled__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ChromeFilled = function ChromeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ChromeFilled__["a" /* default */]
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ChromeFilled));

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ChromeFilled = { "name": "chrome", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0096 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ChromeFilled);


/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ChromeOutlined__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ChromeOutlined = function ChromeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ChromeOutlined__["a" /* default */]
  }));
};

ChromeOutlined.displayName = 'ChromeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ChromeOutlined));

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ChromeOutlined = { "name": "chrome", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ChromeOutlined);


/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleFilled__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CiCircleFilled = function CiCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleFilled__["a" /* default */]
  }));
};

CiCircleFilled.displayName = 'CiCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CiCircleFilled));

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CiCircleFilled = { "name": "ci-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CiCircleFilled);


/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleOutlined__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleOutlined__["a" /* default */]
  }));
};

CiCircleOutlined.displayName = 'CiCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CiCircleOutlined));

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CiCircleOutlined = { "name": "ci-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CiCircleOutlined);


/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleTwoTone__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiCircleTwoTone__["a" /* default */]
  }));
};

CiCircleTwoTone.displayName = 'CiCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CiCircleTwoTone));

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CiCircleTwoTone = { "name": "ci-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CiCircleTwoTone);


/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiOutlined__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CiOutlined = function CiOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiOutlined__["a" /* default */]
  }));
};

CiOutlined.displayName = 'CiOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CiOutlined));

/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CiOutlined = { "name": "ci", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CiOutlined);


/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiTwoTone__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CiTwoTone = function CiTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CiTwoTone__["a" /* default */]
  }));
};

CiTwoTone.displayName = 'CiTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CiTwoTone));

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CiTwoTone = { "name": "ci", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CiTwoTone);


/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClearOutlined__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClearOutlined = function ClearOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClearOutlined__["a" /* default */]
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ClearOutlined));

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ClearOutlined = { "name": "clear", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ClearOutlined);


/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleFilled__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleFilled__["a" /* default */]
  }));
};

ClockCircleFilled.displayName = 'ClockCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ClockCircleFilled));

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ClockCircleFilled = { "name": "clock-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ClockCircleFilled);


/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleOutlined__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleOutlined__["a" /* default */]
  }));
};

ClockCircleOutlined.displayName = 'ClockCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ClockCircleOutlined));

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ClockCircleOutlined = { "name": "clock-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ClockCircleOutlined);


/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleTwoTone__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClockCircleTwoTone__["a" /* default */]
  }));
};

ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ClockCircleTwoTone));

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ClockCircleTwoTone = { "name": "clock-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ClockCircleTwoTone);


/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleFilled__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleFilled__["a" /* default */]
  }));
};

CloseCircleFilled.displayName = 'CloseCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseCircleFilled));

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseCircleFilled = { "name": "close-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloseCircleFilled);


/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleOutlined__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleOutlined__["a" /* default */]
  }));
};

CloseCircleOutlined.displayName = 'CloseCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseCircleOutlined));

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseCircleOutlined = { "name": "close-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloseCircleOutlined);


/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleTwoTone__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseCircleTwoTone__["a" /* default */]
  }));
};

CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseCircleTwoTone));

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseCircleTwoTone = { "name": "close-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CloseCircleTwoTone);


/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseOutlined__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseOutlined = function CloseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseOutlined__["a" /* default */]
  }));
};

CloseOutlined.displayName = 'CloseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseOutlined));

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseOutlined = { "name": "close", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloseOutlined);


/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareFilled__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareFilled__["a" /* default */]
  }));
};

CloseSquareFilled.displayName = 'CloseSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseSquareFilled));

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseSquareFilled = { "name": "close-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloseSquareFilled);


/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareOutlined__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareOutlined__["a" /* default */]
  }));
};

CloseSquareOutlined.displayName = 'CloseSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseSquareOutlined));

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseSquareOutlined = { "name": "close-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloseSquareOutlined);


/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareTwoTone__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloseSquareTwoTone__["a" /* default */]
  }));
};

CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloseSquareTwoTone));

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloseSquareTwoTone = { "name": "close-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CloseSquareTwoTone);


/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudDownloadOutlined__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudDownloadOutlined__["a" /* default */]
  }));
};

CloudDownloadOutlined.displayName = 'CloudDownloadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudDownloadOutlined));

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudDownloadOutlined = { "name": "cloud-download", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudDownloadOutlined);


/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudFilled__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudFilled = function CloudFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudFilled__["a" /* default */]
  }));
};

CloudFilled.displayName = 'CloudFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudFilled));

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudFilled = { "name": "cloud", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudFilled);


/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudOutlined__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudOutlined = function CloudOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudOutlined__["a" /* default */]
  }));
};

CloudOutlined.displayName = 'CloudOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudOutlined));

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudOutlined = { "name": "cloud", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudOutlined);


/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudServerOutlined__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudServerOutlined__["a" /* default */]
  }));
};

CloudServerOutlined.displayName = 'CloudServerOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudServerOutlined));

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudServerOutlined = { "name": "cloud-server", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z" } }, { "tag": "path", "attrs": { "d": "M424 748a32 32 0 1064 0 32 32 0 10-64 0zm0-178a32 32 0 1064 0 32 32 0 10-64 0z" } }, { "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudServerOutlined);


/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudSyncOutlined__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudSyncOutlined__["a" /* default */]
  }));
};

CloudSyncOutlined.displayName = 'CloudSyncOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudSyncOutlined));

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudSyncOutlined = { "name": "cloud-sync", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }, { "tag": "path", "attrs": { "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 003 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 00-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudSyncOutlined);


/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudTwoTone__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudTwoTone = function CloudTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudTwoTone__["a" /* default */]
  }));
};

CloudTwoTone.displayName = 'CloudTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudTwoTone));

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudTwoTone = { "name": "cloud", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 00-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 00-52.4 49.9 240.47 240.47 0 00-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 00-66.1 43.7A123.1 123.1 0 00140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 00884 612c0-56.2-37.8-105.5-92.1-120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CloudTwoTone);


/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudUploadOutlined__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CloudUploadOutlined__["a" /* default */]
  }));
};

CloudUploadOutlined.displayName = 'CloudUploadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CloudUploadOutlined));

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CloudUploadOutlined = { "name": "cloud-upload", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CloudUploadOutlined);


/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClusterOutlined__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ClusterOutlined = function ClusterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ClusterOutlined__["a" /* default */]
  }));
};

ClusterOutlined.displayName = 'ClusterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ClusterOutlined));

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ClusterOutlined = { "name": "cluster", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ClusterOutlined);


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeFilled__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeFilled = function CodeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeFilled__["a" /* default */]
  }));
};

CodeFilled.displayName = 'CodeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeFilled));

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeFilled = { "name": "code", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodeFilled);


/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeOutlined__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeOutlined = function CodeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeOutlined__["a" /* default */]
  }));
};

CodeOutlined.displayName = 'CodeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeOutlined));

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeOutlined = { "name": "code", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodeOutlined);


/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxCircleFilled__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxCircleFilled__["a" /* default */]
  }));
};

CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeSandboxCircleFilled));

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeSandboxCircleFilled = { "name": "code-sandbox-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodeSandboxCircleFilled);


/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxOutlined__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxOutlined__["a" /* default */]
  }));
};

CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeSandboxOutlined));

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeSandboxOutlined = { "name": "code-sandbox", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodeSandboxOutlined);


/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxSquareFilled__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeSandboxSquareFilled__["a" /* default */]
  }));
};

CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeSandboxSquareFilled));

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeSandboxSquareFilled = { "name": "code-sandbox-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodeSandboxSquareFilled);


/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeTwoTone__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodeTwoTone = function CodeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodeTwoTone__["a" /* default */]
  }));
};

CodeTwoTone.displayName = 'CodeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodeTwoTone));

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodeTwoTone = { "name": "code", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CodeTwoTone);


/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenCircleFilled__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenCircleFilled__["a" /* default */]
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodepenCircleFilled));

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodepenCircleFilled = { "name": "codepen-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodepenCircleFilled);


/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenCircleOutlined__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenCircleOutlined__["a" /* default */]
  }));
};

CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodepenCircleOutlined));

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodepenCircleOutlined = { "name": "codepen-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodepenCircleOutlined);


/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenOutlined__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodepenOutlined = function CodepenOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenOutlined__["a" /* default */]
  }));
};

CodepenOutlined.displayName = 'CodepenOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodepenOutlined));

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodepenOutlined = { "name": "codepen", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 00-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodepenOutlined);


/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenSquareFilled__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CodepenSquareFilled__["a" /* default */]
  }));
};

CodepenSquareFilled.displayName = 'CodepenSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CodepenSquareFilled));

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CodepenSquareFilled = { "name": "codepen-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CodepenSquareFilled);


/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CoffeeOutlined__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CoffeeOutlined__["a" /* default */]
  }));
};

CoffeeOutlined.displayName = 'CoffeeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CoffeeOutlined));

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CoffeeOutlined = { "name": "coffee", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CoffeeOutlined);


/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ColumnHeightOutlined__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ColumnHeightOutlined__["a" /* default */]
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ColumnHeightOutlined));

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ColumnHeightOutlined = { "name": "column-height", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 00-11.3 0L403.6 366.3a7.23 7.23 0 005.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ColumnHeightOutlined);


/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ColumnWidthOutlined__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ColumnWidthOutlined__["a" /* default */]
  }));
};

ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ColumnWidthOutlined));

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ColumnWidthOutlined = { "name": "column-width", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 00-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ColumnWidthOutlined);


/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CommentOutlined__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CommentOutlined = function CommentOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CommentOutlined__["a" /* default */]
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CommentOutlined));

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CommentOutlined = { "name": "comment", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zm-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }, { "tag": "path", "attrs": { "d": "M894 345a343.92 343.92 0 00-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0040.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102zm505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.31 367.31 0 00729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z" } }, { "tag": "path", "attrs": { "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CommentOutlined);


/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassFilled__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CompassFilled = function CompassFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassFilled__["a" /* default */]
  }));
};

CompassFilled.displayName = 'CompassFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CompassFilled));

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CompassFilled = { "name": "compass", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CompassFilled);


/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassOutlined__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CompassOutlined = function CompassOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassOutlined__["a" /* default */]
  }));
};

CompassOutlined.displayName = 'CompassOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CompassOutlined));

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CompassOutlined = { "name": "compass", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 00-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 00-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CompassOutlined);


/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassTwoTone__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CompassTwoTone = function CompassTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompassTwoTone__["a" /* default */]
  }));
};

CompassTwoTone.displayName = 'CompassTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CompassTwoTone));

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CompassTwoTone = { "name": "compass", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CompassTwoTone);


/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompressOutlined__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CompressOutlined = function CompressOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CompressOutlined__["a" /* default */]
  }));
};

CompressOutlined.displayName = 'CompressOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CompressOutlined));

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CompressOutlined = { "name": "compress", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zm16-576h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zm578 576H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm0-384H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CompressOutlined);


/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ConsoleSqlOutlined__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ConsoleSqlOutlined__["a" /* default */]
  }));
};

ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ConsoleSqlOutlined));

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ConsoleSqlOutlined = { "name": "console-sql", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4.1 14.7-14.5 25.1-36 25.1z" } }, { "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }, { "tag": "path", "attrs": { "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zm-298.6 53.4c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-.1 73.7 43 118.9 111.1 118.9zm0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2.1-43.6 21.2-71.1 52.9-71.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ConsoleSqlOutlined);


/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsFilled__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContactsFilled = function ContactsFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsFilled__["a" /* default */]
  }));
};

ContactsFilled.displayName = 'ContactsFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContactsFilled));

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContactsFilled = { "name": "contacts", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ContactsFilled);


/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsOutlined__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContactsOutlined = function ContactsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsOutlined__["a" /* default */]
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContactsOutlined));

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContactsOutlined = { "name": "contacts", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ContactsOutlined);


/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsTwoTone__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContactsTwoTone__["a" /* default */]
  }));
};

ContactsTwoTone.displayName = 'ContactsTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContactsTwoTone));

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContactsTwoTone = { "name": "contacts", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M460.3 526a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 01-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 01-8 8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ContactsTwoTone);


/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerFilled__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContainerFilled = function ContainerFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerFilled__["a" /* default */]
  }));
};

ContainerFilled.displayName = 'ContainerFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContainerFilled));

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContainerFilled = { "name": "container", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ContainerFilled);


/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerOutlined__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContainerOutlined = function ContainerOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerOutlined__["a" /* default */]
  }));
};

ContainerOutlined.displayName = 'ContainerOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContainerOutlined));

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContainerOutlined = { "name": "container", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ContainerOutlined);


/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerTwoTone__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ContainerTwoTone__["a" /* default */]
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ContainerTwoTone));

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ContainerTwoTone = { "name": "container", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ContainerTwoTone);


/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlFilled__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ControlFilled = function ControlFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlFilled__["a" /* default */]
  }));
};

ControlFilled.displayName = 'ControlFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ControlFilled));

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ControlFilled = { "name": "control", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1072 0 36 36 0 10-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ControlFilled);


/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlOutlined__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ControlOutlined = function ControlOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlOutlined__["a" /* default */]
  }));
};

ControlOutlined.displayName = 'ControlOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ControlOutlined));

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ControlOutlined = { "name": "control", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ControlOutlined);


/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlTwoTone__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ControlTwoTone = function ControlTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ControlTwoTone__["a" /* default */]
  }));
};

ControlTwoTone.displayName = 'ControlTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ControlTwoTone));

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ControlTwoTone = { "name": "control", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M616 440a36 36 0 1072 0 36 36 0 10-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 01408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ControlTwoTone);


/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyFilled__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyFilled = function CopyFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyFilled__["a" /* default */]
  }));
};

CopyFilled.displayName = 'CopyFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyFilled));

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyFilled = { "name": "copy", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CopyFilled);


/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyOutlined__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyOutlined = function CopyOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyOutlined__["a" /* default */]
  }));
};

CopyOutlined.displayName = 'CopyOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyOutlined));

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyOutlined = { "name": "copy", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CopyOutlined);


/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyTwoTone__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyTwoTone = function CopyTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyTwoTone__["a" /* default */]
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyTwoTone));

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyTwoTone = { "name": "copy", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CopyTwoTone);


/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleFilled__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleFilled__["a" /* default */]
  }));
};

CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyrightCircleFilled));

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyrightCircleFilled = { "name": "copyright-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CopyrightCircleFilled);


/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleOutlined__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleOutlined__["a" /* default */]
  }));
};

CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyrightCircleOutlined));

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyrightCircleOutlined = { "name": "copyright-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CopyrightCircleOutlined);


/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleTwoTone__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightCircleTwoTone__["a" /* default */]
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyrightCircleTwoTone));

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyrightCircleTwoTone = { "name": "copyright-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CopyrightCircleTwoTone);


/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightOutlined__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyrightOutlined = function CopyrightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightOutlined__["a" /* default */]
  }));
};

CopyrightOutlined.displayName = 'CopyrightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyrightOutlined));

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyrightOutlined = { "name": "copyright", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CopyrightOutlined);


/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightTwoTone__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CopyrightTwoTone__["a" /* default */]
  }));
};

CopyrightTwoTone.displayName = 'CopyrightTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CopyrightTwoTone));

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CopyrightTwoTone = { "name": "copyright", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CopyrightTwoTone);


/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardFilled__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CreditCardFilled = function CreditCardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardFilled__["a" /* default */]
  }));
};

CreditCardFilled.displayName = 'CreditCardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CreditCardFilled));

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CreditCardFilled = { "name": "credit-card", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CreditCardFilled);


/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardOutlined__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardOutlined__["a" /* default */]
  }));
};

CreditCardOutlined.displayName = 'CreditCardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CreditCardOutlined));

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CreditCardOutlined = { "name": "credit-card", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CreditCardOutlined);


/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardTwoTone__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CreditCardTwoTone__["a" /* default */]
  }));
};

CreditCardTwoTone.displayName = 'CreditCardTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CreditCardTwoTone));

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CreditCardTwoTone = { "name": "credit-card", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CreditCardTwoTone);


/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownFilled__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CrownFilled = function CrownFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownFilled__["a" /* default */]
  }));
};

CrownFilled.displayName = 'CrownFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CrownFilled));

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CrownFilled = { "name": "crown", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CrownFilled);


/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownOutlined__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CrownOutlined = function CrownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownOutlined__["a" /* default */]
  }));
};

CrownOutlined.displayName = 'CrownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CrownOutlined));

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CrownOutlined = { "name": "crown", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CrownOutlined);


/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownTwoTone__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CrownTwoTone = function CrownTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CrownTwoTone__["a" /* default */]
  }));
};

CrownTwoTone.displayName = 'CrownTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CrownTwoTone));

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CrownTwoTone = { "name": "crown", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CrownTwoTone);


/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceFilled__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceFilled__["a" /* default */]
  }));
};

CustomerServiceFilled.displayName = 'CustomerServiceFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CustomerServiceFilled));

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CustomerServiceFilled = { "name": "customer-service", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CustomerServiceFilled);


/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceOutlined__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceOutlined__["a" /* default */]
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CustomerServiceOutlined));

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CustomerServiceOutlined = { "name": "customer-service", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (CustomerServiceOutlined);


/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceTwoTone__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_CustomerServiceTwoTone__["a" /* default */]
  }));
};

CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(CustomerServiceTwoTone));

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var CustomerServiceTwoTone = { "name": "customer-service", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 632h128v192H696zm-496 0h128v192H200z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (CustomerServiceTwoTone);


/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashOutlined__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DashOutlined = function DashOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashOutlined__["a" /* default */]
  }));
};

DashOutlined.displayName = 'DashOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DashOutlined));

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DashOutlined = { "name": "dash", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DashOutlined);


/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardFilled__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DashboardFilled = function DashboardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardFilled__["a" /* default */]
  }));
};

DashboardFilled.displayName = 'DashboardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DashboardFilled));

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DashboardFilled = { "name": "dashboard", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 01-11.3 0L261.7 352a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DashboardFilled);


/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardOutlined__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DashboardOutlined = function DashboardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardOutlined__["a" /* default */]
  }));
};

DashboardOutlined.displayName = 'DashboardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DashboardOutlined));

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DashboardOutlined = { "name": "dashboard", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DashboardOutlined);


/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardTwoTone__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DashboardTwoTone__["a" /* default */]
  }));
};

DashboardTwoTone.displayName = 'DashboardTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DashboardTwoTone));

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DashboardTwoTone = { "name": "dashboard", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 00884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 01-11.3 0l-56.6-56.6a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DashboardTwoTone);


/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseFilled__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DatabaseFilled = function DatabaseFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseFilled__["a" /* default */]
  }));
};

DatabaseFilled.displayName = 'DatabaseFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DatabaseFilled));

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DatabaseFilled = { "name": "database", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DatabaseFilled);


/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseOutlined__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseOutlined__["a" /* default */]
  }));
};

DatabaseOutlined.displayName = 'DatabaseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DatabaseOutlined));

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DatabaseOutlined = { "name": "database", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DatabaseOutlined);


/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseTwoTone__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DatabaseTwoTone__["a" /* default */]
  }));
};

DatabaseTwoTone.displayName = 'DatabaseTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DatabaseTwoTone));

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DatabaseTwoTone = { "name": "database", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 512a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0-544a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DatabaseTwoTone);


/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteColumnOutlined__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteColumnOutlined__["a" /* default */]
  }));
};

DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeleteColumnOutlined));

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeleteColumnOutlined = { "name": "delete-column", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M651.1 641.9a7.84 7.84 0 00-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H378c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L474.2 776 371.8 898.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zm556-256h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeleteColumnOutlined);


/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteFilled__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteFilled = function DeleteFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteFilled__["a" /* default */]
  }));
};

DeleteFilled.displayName = 'DeleteFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeleteFilled));

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeleteFilled = { "name": "delete", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeleteFilled);


/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteOutlined__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteOutlined = function DeleteOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteOutlined__["a" /* default */]
  }));
};

DeleteOutlined.displayName = 'DeleteOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeleteOutlined));

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeleteOutlined = { "name": "delete", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeleteOutlined);


/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteRowOutlined__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteRowOutlined__["a" /* default */]
  }));
};

DeleteRowOutlined.displayName = 'DeleteRowOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeleteRowOutlined));

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeleteRowOutlined = { "name": "delete-row", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M819.8 512l102.4-122.9a8.06 8.06 0 00-6.1-13.2h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H648c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L744.2 512 641.8 634.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-84 204h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeleteRowOutlined);


/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteTwoTone__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeleteTwoTone__["a" /* default */]
  }));
};

DeleteTwoTone.displayName = 'DeleteTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeleteTwoTone));

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeleteTwoTone = { "name": "delete", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M292.7 840h438.6l24.2-512h-487z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DeleteTwoTone);


/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeliveredProcedureOutlined__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeliveredProcedureOutlined__["a" /* default */]
  }));
};

DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeliveredProcedureOutlined));

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeliveredProcedureOutlined = { "name": "delivered-procedure", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M632 698.3l141.9-112a8 8 0 000-12.6L632 461.7c-5.3-4.2-13-.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zm261.3-405L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zm264 436h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeliveredProcedureOutlined);


/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeploymentUnitOutlined__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DeploymentUnitOutlined__["a" /* default */]
  }));
};

DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DeploymentUnitOutlined));

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DeploymentUnitOutlined = { "name": "deployment-unit", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 01-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0165.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DeploymentUnitOutlined);


/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DesktopOutlined__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DesktopOutlined = function DesktopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DesktopOutlined__["a" /* default */]
  }));
};

DesktopOutlined.displayName = 'DesktopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DesktopOutlined));

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DesktopOutlined = { "name": "desktop", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DesktopOutlined);


/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffFilled__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DiffFilled = function DiffFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffFilled__["a" /* default */]
  }));
};

DiffFilled.displayName = 'DiffFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DiffFilled));

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DiffFilled = { "name": "diff", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DiffFilled);


/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffOutlined__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DiffOutlined = function DiffOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffOutlined__["a" /* default */]
  }));
};

DiffOutlined.displayName = 'DiffOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DiffOutlined));

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DiffOutlined = { "name": "diff", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DiffOutlined);


/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffTwoTone__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DiffTwoTone = function DiffTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DiffTwoTone__["a" /* default */]
  }));
};

DiffTwoTone.displayName = 'DiffTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DiffTwoTone));

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DiffTwoTone = { "name": "diff", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DiffTwoTone);


/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingdingOutlined__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DingdingOutlined = function DingdingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingdingOutlined__["a" /* default */]
  }));
};

DingdingOutlined.displayName = 'DingdingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DingdingOutlined));

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DingdingOutlined = { "name": "dingding", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DingdingOutlined);


/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkCircleFilled__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkCircleFilled__["a" /* default */]
  }));
};

DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DingtalkCircleFilled));

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DingtalkCircleFilled = { "name": "dingtalk-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DingtalkCircleFilled);


/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkOutlined__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkOutlined__["a" /* default */]
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DingtalkOutlined));

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DingtalkOutlined = { "name": "dingtalk", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DingtalkOutlined);


/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkSquareFilled__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DingtalkSquareFilled__["a" /* default */]
  }));
};

DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DingtalkSquareFilled));

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DingtalkSquareFilled = { "name": "dingtalk-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DingtalkSquareFilled);


/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DisconnectOutlined__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DisconnectOutlined__["a" /* default */]
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DisconnectOutlined));

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DisconnectOutlined = { "name": "disconnect", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 00-11.3 0L209.4 249a8.03 8.03 0 000 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DisconnectOutlined);


/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeFilled__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DislikeFilled = function DislikeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeFilled__["a" /* default */]
  }));
};

DislikeFilled.displayName = 'DislikeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DislikeFilled));

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DislikeFilled = { "name": "dislike", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DislikeFilled);


/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeOutlined__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DislikeOutlined = function DislikeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeOutlined__["a" /* default */]
  }));
};

DislikeOutlined.displayName = 'DislikeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DislikeOutlined));

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DislikeOutlined = { "name": "dislike", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DislikeOutlined);


/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeTwoTone__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DislikeTwoTone__["a" /* default */]
  }));
};

DislikeTwoTone.displayName = 'DislikeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DislikeTwoTone));

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DislikeTwoTone = { "name": "dislike", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0042.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DislikeTwoTone);


/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleFilled__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleFilled__["a" /* default */]
  }));
};

DollarCircleFilled.displayName = 'DollarCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DollarCircleFilled));

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DollarCircleFilled = { "name": "dollar-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DollarCircleFilled);


/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleOutlined__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleOutlined__["a" /* default */]
  }));
};

DollarCircleOutlined.displayName = 'DollarCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DollarCircleOutlined));

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DollarCircleOutlined = { "name": "dollar-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DollarCircleOutlined);


/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleTwoTone__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarCircleTwoTone__["a" /* default */]
  }));
};

DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DollarCircleTwoTone));

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DollarCircleTwoTone = { "name": "dollar-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DollarCircleTwoTone);


/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarOutlined__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DollarOutlined = function DollarOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarOutlined__["a" /* default */]
  }));
};

DollarOutlined.displayName = 'DollarOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DollarOutlined));

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DollarOutlined = { "name": "dollar", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DollarOutlined);


/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarTwoTone__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DollarTwoTone = function DollarTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DollarTwoTone__["a" /* default */]
  }));
};

DollarTwoTone.displayName = 'DollarTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DollarTwoTone));

/***/ }),
/* 2361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DollarTwoTone = { "name": "dollar", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DollarTwoTone);


/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DotChartOutlined__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DotChartOutlined = function DotChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DotChartOutlined__["a" /* default */]
  }));
};

DotChartOutlined.displayName = 'DotChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DotChartOutlined));

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DotChartOutlined = { "name": "dot-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DotChartOutlined);


/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DoubleLeftOutlined__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DoubleLeftOutlined__["a" /* default */]
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DoubleLeftOutlined));

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DoubleLeftOutlined = { "name": "double-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DoubleLeftOutlined);


/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DoubleRightOutlined__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DoubleRightOutlined__["a" /* default */]
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DoubleRightOutlined));

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DoubleRightOutlined = { "name": "double-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DoubleRightOutlined);


/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleFilled__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownCircleFilled = function DownCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleFilled__["a" /* default */]
  }));
};

DownCircleFilled.displayName = 'DownCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownCircleFilled));

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownCircleFilled = { "name": "down-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownCircleFilled);


/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleOutlined__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleOutlined__["a" /* default */]
  }));
};

DownCircleOutlined.displayName = 'DownCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownCircleOutlined));

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownCircleOutlined = { "name": "down-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownCircleOutlined);


/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleTwoTone__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownCircleTwoTone = function DownCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownCircleTwoTone__["a" /* default */]
  }));
};

DownCircleTwoTone.displayName = 'DownCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownCircleTwoTone));

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownCircleTwoTone = { "name": "down-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DownCircleTwoTone);


/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownOutlined__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownOutlined = function DownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownOutlined__["a" /* default */]
  }));
};

DownOutlined.displayName = 'DownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownOutlined));

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownOutlined = { "name": "down", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownOutlined);


/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareFilled__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownSquareFilled = function DownSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareFilled__["a" /* default */]
  }));
};

DownSquareFilled.displayName = 'DownSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownSquareFilled));

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownSquareFilled = { "name": "down-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownSquareFilled);


/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareOutlined__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareOutlined__["a" /* default */]
  }));
};

DownSquareOutlined.displayName = 'DownSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownSquareOutlined));

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownSquareOutlined = { "name": "down-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownSquareOutlined);


/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareTwoTone__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownSquareTwoTone__["a" /* default */]
  }));
};

DownSquareTwoTone.displayName = 'DownSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownSquareTwoTone));

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownSquareTwoTone = { "name": "down-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (DownSquareTwoTone);


/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownloadOutlined__ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownloadOutlined = function DownloadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DownloadOutlined__["a" /* default */]
  }));
};

DownloadOutlined.displayName = 'DownloadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DownloadOutlined));

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DownloadOutlined = { "name": "download", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DownloadOutlined);


/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DragOutlined__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DragOutlined = function DragOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DragOutlined__["a" /* default */]
  }));
};

DragOutlined.displayName = 'DragOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DragOutlined));

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DragOutlined = { "name": "drag", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DragOutlined);


/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleCircleFilled__ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleCircleFilled__["a" /* default */]
  }));
};

DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DribbbleCircleFilled));

/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DribbbleCircleFilled = { "name": "dribbble-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M675.1 328.3a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DribbbleCircleFilled);


/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleOutlined__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleOutlined__["a" /* default */]
  }));
};

DribbbleOutlined.displayName = 'DribbbleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DribbbleOutlined));

/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DribbbleOutlined = { "name": "dribbble", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 01512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DribbbleOutlined);


/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleSquareFilled__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleSquareFilled__["a" /* default */]
  }));
};

DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DribbbleSquareFilled));

/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DribbbleSquareFilled = { "name": "dribbble-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DribbbleSquareFilled);


/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleSquareOutlined__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DribbbleSquareOutlined__["a" /* default */]
  }));
};

DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DribbbleSquareOutlined));

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DribbbleSquareOutlined = { "name": "dribbble-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DribbbleSquareOutlined);


/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxCircleFilled__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxCircleFilled__["a" /* default */]
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DropboxCircleFilled));

/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DropboxCircleFilled = { "name": "dropbox-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DropboxCircleFilled);


/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxOutlined__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DropboxOutlined = function DropboxOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxOutlined__["a" /* default */]
  }));
};

DropboxOutlined.displayName = 'DropboxOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DropboxOutlined));

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DropboxOutlined = { "name": "dropbox", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DropboxOutlined);


/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxSquareFilled__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_DropboxSquareFilled__["a" /* default */]
  }));
};

DropboxSquareFilled.displayName = 'DropboxSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DropboxSquareFilled));

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var DropboxSquareFilled = { "name": "dropbox-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (DropboxSquareFilled);


/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditFilled__ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EditFilled = function EditFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditFilled__["a" /* default */]
  }));
};

EditFilled.displayName = 'EditFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EditFilled));

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EditFilled = { "name": "edit", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EditFilled);


/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditOutlined__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EditOutlined = function EditOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditOutlined__["a" /* default */]
  }));
};

EditOutlined.displayName = 'EditOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EditOutlined));

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EditOutlined = { "name": "edit", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EditOutlined);


/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditTwoTone__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EditTwoTone = function EditTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EditTwoTone__["a" /* default */]
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EditTwoTone));

/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EditTwoTone = { "name": "edit", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EditTwoTone);


/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EllipsisOutlined__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EllipsisOutlined__["a" /* default */]
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EllipsisOutlined));

/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EllipsisOutlined = { "name": "ellipsis", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EllipsisOutlined);


/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnterOutlined__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EnterOutlined = function EnterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnterOutlined__["a" /* default */]
  }));
};

EnterOutlined.displayName = 'EnterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EnterOutlined));

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EnterOutlined = { "name": "enter", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EnterOutlined);


/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentFilled__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentFilled__["a" /* default */]
  }));
};

EnvironmentFilled.displayName = 'EnvironmentFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EnvironmentFilled));

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EnvironmentFilled = { "name": "environment", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 00400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 00512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EnvironmentFilled);


/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentOutlined__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentOutlined__["a" /* default */]
  }));
};

EnvironmentOutlined.displayName = 'EnvironmentOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EnvironmentOutlined));

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EnvironmentOutlined = { "name": "environment", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EnvironmentOutlined);


/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentTwoTone__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EnvironmentTwoTone__["a" /* default */]
  }));
};

EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EnvironmentTwoTone));

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EnvironmentTwoTone = { "name": "environment", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EnvironmentTwoTone);


/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleFilled__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleFilled__["a" /* default */]
  }));
};

EuroCircleFilled.displayName = 'EuroCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EuroCircleFilled));

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EuroCircleFilled = { "name": "euro-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EuroCircleFilled);


/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleOutlined__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleOutlined__["a" /* default */]
  }));
};

EuroCircleOutlined.displayName = 'EuroCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EuroCircleOutlined));

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EuroCircleOutlined = { "name": "euro-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EuroCircleOutlined);


/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleTwoTone__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroCircleTwoTone__["a" /* default */]
  }));
};

EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EuroCircleTwoTone));

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EuroCircleTwoTone = { "name": "euro-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EuroCircleTwoTone);


/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroOutlined__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EuroOutlined = function EuroOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroOutlined__["a" /* default */]
  }));
};

EuroOutlined.displayName = 'EuroOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EuroOutlined));

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EuroOutlined = { "name": "euro", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EuroOutlined);


/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroTwoTone__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EuroTwoTone = function EuroTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EuroTwoTone__["a" /* default */]
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EuroTwoTone));

/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EuroTwoTone = { "name": "euro", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EuroTwoTone);


/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExceptionOutlined__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExceptionOutlined__["a" /* default */]
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExceptionOutlined));

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExceptionOutlined = { "name": "exception", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1064 0 32 32 0 10-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExceptionOutlined);


/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleFilled__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleFilled__["a" /* default */]
  }));
};

ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExclamationCircleFilled));

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExclamationCircleFilled = { "name": "exclamation-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExclamationCircleFilled);


/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleOutlined__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleOutlined__["a" /* default */]
  }));
};

ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExclamationCircleOutlined));

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExclamationCircleOutlined = { "name": "exclamation-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExclamationCircleOutlined);


/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleTwoTone__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationCircleTwoTone__["a" /* default */]
  }));
};

ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExclamationCircleTwoTone));

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExclamationCircleTwoTone = { "name": "exclamation-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ExclamationCircleTwoTone);


/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationOutlined__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExclamationOutlined__["a" /* default */]
  }));
};

ExclamationOutlined.displayName = 'ExclamationOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExclamationOutlined));

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExclamationOutlined = { "name": "exclamation", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 804a64 64 0 10128 0 64 64 0 10-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExclamationOutlined);


/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExpandAltOutlined__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExpandAltOutlined__["a" /* default */]
  }));
};

ExpandAltOutlined.displayName = 'ExpandAltOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExpandAltOutlined));

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExpandAltOutlined = { "name": "expand-alt", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExpandAltOutlined);


/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExpandOutlined__ = __webpack_require__(2439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExpandOutlined = function ExpandOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExpandOutlined__["a" /* default */]
  }));
};

ExpandOutlined.displayName = 'ExpandOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExpandOutlined));

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExpandOutlined = { "name": "expand", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExpandOutlined);


/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentFilled__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExperimentFilled = function ExperimentFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentFilled__["a" /* default */]
  }));
};

ExperimentFilled.displayName = 'ExperimentFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExperimentFilled));

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExperimentFilled = { "name": "experiment", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0094.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 01164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0036.6-82.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExperimentFilled);


/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentOutlined__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentOutlined__["a" /* default */]
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExperimentOutlined));

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExperimentOutlined = { "name": "experiment", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 472a40 40 0 1080 0 40 40 0 10-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExperimentOutlined);


/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentTwoTone__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExperimentTwoTone__["a" /* default */]
  }));
};

ExperimentTwoTone.displayName = 'ExperimentTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExperimentTwoTone));

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExperimentTwoTone = { "name": "experiment", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 01552 512a40 40 0 01-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0040 39.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ExperimentTwoTone);


/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExportOutlined__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ExportOutlined = function ExportOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ExportOutlined__["a" /* default */]
  }));
};

ExportOutlined.displayName = 'ExportOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ExportOutlined));

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ExportOutlined = { "name": "export", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ExportOutlined);


/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeFilled__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeFilled = function EyeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeFilled__["a" /* default */]
  }));
};

EyeFilled.displayName = 'EyeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeFilled));

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeFilled = { "name": "eye", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 512a112 112 0 10224 0 112 112 0 10-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EyeFilled);


/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleFilled__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleFilled__["a" /* default */]
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeInvisibleFilled));

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeInvisibleFilled = { "name": "eye-invisible", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M508 624a112 112 0 00112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 00-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 000 11.31L155.25 889a8 8 0 0011.31 0l712.16-712.12a8 8 0 000-11.32zM332 512a176 176 0 01258.88-155.28l-48.62 48.62a112.08 112.08 0 00-140.92 140.92l-48.62 48.62A175.09 175.09 0 01332 512z" } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 01445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EyeInvisibleFilled);


/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleOutlined__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleOutlined__["a" /* default */]
  }));
};

EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeInvisibleOutlined));

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeInvisibleOutlined = { "name": "eye-invisible", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EyeInvisibleOutlined);


/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleTwoTone__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeInvisibleTwoTone__["a" /* default */]
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeInvisibleTwoTone));

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeInvisibleTwoTone = { "name": "eye-invisible", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M254.89 758.85l125.57-125.57a176 176 0 01248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 01-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zM878.63 165.56L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EyeInvisibleTwoTone);


/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeOutlined__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeOutlined = function EyeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeOutlined__["a" /* default */]
  }));
};

EyeOutlined.displayName = 'EyeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeOutlined));

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeOutlined = { "name": "eye", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (EyeOutlined);


/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeTwoTone__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeTwoTone = function EyeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_EyeTwoTone__["a" /* default */]
  }));
};

EyeTwoTone.displayName = 'EyeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(EyeTwoTone));

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var EyeTwoTone = { "name": "eye", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M81.8 537.8a60.3 60.3 0 010-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (EyeTwoTone);


/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FacebookFilled__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FacebookFilled = function FacebookFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FacebookFilled__["a" /* default */]
  }));
};

FacebookFilled.displayName = 'FacebookFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FacebookFilled));

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FacebookFilled = { "name": "facebook", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FacebookFilled);


/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FacebookOutlined__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FacebookOutlined = function FacebookOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FacebookOutlined__["a" /* default */]
  }));
};

FacebookOutlined.displayName = 'FacebookOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FacebookOutlined));

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FacebookOutlined = { "name": "facebook", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FacebookOutlined);


/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FallOutlined__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FallOutlined = function FallOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FallOutlined__["a" /* default */]
  }));
};

FallOutlined.displayName = 'FallOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FallOutlined));

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FallOutlined = { "name": "fall", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 00-11.3 0l-45 45.2a8.03 8.03 0 000 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 004.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FallOutlined);


/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastBackwardFilled__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastBackwardFilled__["a" /* default */]
  }));
};

FastBackwardFilled.displayName = 'FastBackwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FastBackwardFilled));

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FastBackwardFilled = { "name": "fast-backward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FastBackwardFilled);


/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastBackwardOutlined__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastBackwardOutlined__["a" /* default */]
  }));
};

FastBackwardOutlined.displayName = 'FastBackwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FastBackwardOutlined));

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FastBackwardOutlined = { "name": "fast-backward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FastBackwardOutlined);


/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastForwardFilled__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FastForwardFilled = function FastForwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastForwardFilled__["a" /* default */]
  }));
};

FastForwardFilled.displayName = 'FastForwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FastForwardFilled));

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FastForwardFilled = { "name": "fast-forward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FastForwardFilled);


/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastForwardOutlined__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FastForwardOutlined__["a" /* default */]
  }));
};

FastForwardOutlined.displayName = 'FastForwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FastForwardOutlined));

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FastForwardOutlined = { "name": "fast-forward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FastForwardOutlined);


/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldBinaryOutlined__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldBinaryOutlined__["a" /* default */]
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FieldBinaryOutlined));

/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FieldBinaryOutlined = { "name": "field-binary", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9a86.14 86.14 0 01-26.3 24.4c-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1a8 8 0 00-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8zm-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8.1-19.4.4-31.8.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2a87.94 87.94 0 0127.4 28.2c6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4.2 12.4.4 23 .4 31.8.1 14.8-.4 32.5-1.4 53.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FieldBinaryOutlined);


/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldNumberOutlined__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldNumberOutlined__["a" /* default */]
  }));
};

FieldNumberOutlined.displayName = 'FieldNumberOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FieldNumberOutlined));

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FieldNumberOutlined = { "name": "field-number", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zm378 413H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-152.2-63c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2zm-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6.1-35.8 8.2-63 24.5-83.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FieldNumberOutlined);


/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldStringOutlined__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldStringOutlined__["a" /* default */]
  }));
};

FieldStringOutlined.displayName = 'FieldStringOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FieldStringOutlined));

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FieldStringOutlined = { "name": "field-string", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M875.6 515.9c2.1.8 4.4-.3 5.2-2.4.2-.4.2-.9.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4.1 26.6 1.8 30.7 3.4zm-537-40.5l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9zM841 729a36 36 0 1072 0 36 36 0 10-72 0zM653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-.4c-4.9.5-6.2.6-8.3.8-4.1.3-7.8.5-12.6.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FieldStringOutlined);


/***/ }),
/* 2480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldTimeOutlined__ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FieldTimeOutlined__["a" /* default */]
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FieldTimeOutlined));

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FieldTimeOutlined = { "name": "field-time", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" } }, { "tag": "path", "attrs": { "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FieldTimeOutlined);


/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddFilled__ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileAddFilled = function FileAddFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddFilled__["a" /* default */]
  }));
};

FileAddFilled.displayName = 'FileAddFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileAddFilled));

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileAddFilled = { "name": "file-add", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M480 580H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V644h108a8 8 0 008-8v-48a8 8 0 00-8-8H544V472a8 8 0 00-8-8h-48a8 8 0 00-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileAddFilled);


/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddOutlined__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileAddOutlined = function FileAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddOutlined__["a" /* default */]
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileAddOutlined));

/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileAddOutlined = { "name": "file-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileAddOutlined);


/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddTwoTone__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileAddTwoTone__["a" /* default */]
  }));
};

FileAddTwoTone.displayName = 'FileAddTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileAddTwoTone));

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileAddTwoTone = { "name": "file-add", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileAddTwoTone);


/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileDoneOutlined__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileDoneOutlined__["a" /* default */]
  }));
};

FileDoneOutlined.displayName = 'FileDoneOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileDoneOutlined));

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileDoneOutlined = { "name": "file-done", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 00-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileDoneOutlined);


/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelFilled__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExcelFilled = function FileExcelFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelFilled__["a" /* default */]
  }));
};

FileExcelFilled.displayName = 'FileExcelFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExcelFilled));

/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExcelFilled = { "name": "file-excel", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 00-10.27-5.79h-38.44a12 12 0 00-6.4 1.85 12 12 0 00-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 00-1.84 6.39 12 12 0 0012 12h34.46a12 12 0 0010.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0010.23 5.72h37.48a12 12 0 006.48-1.9 12 12 0 003.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 001.9-6.5 12 12 0 00-12-12h-35.7a12 12 0 00-10.29 5.84z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileExcelFilled);


/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelOutlined__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExcelOutlined = function FileExcelOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelOutlined__["a" /* default */]
  }));
};

FileExcelOutlined.displayName = 'FileExcelOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExcelOutlined));

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExcelOutlined = { "name": "file-excel", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileExcelOutlined);


/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelTwoTone__ = __webpack_require__(2495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExcelTwoTone__["a" /* default */]
  }));
};

FileExcelTwoTone.displayName = 'FileExcelTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExcelTwoTone));

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExcelTwoTone = { "name": "file-excel", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm51.6 120h35.7a12.04 12.04 0 0110.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 01-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileExcelTwoTone);


/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationFilled__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationFilled__["a" /* default */]
  }));
};

FileExclamationFilled.displayName = 'FileExclamationFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExclamationFilled));

/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExclamationFilled = { "name": "file-exclamation", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 100-80 40 40 0 000 80zm32-152V448a8 8 0 00-8-8h-48a8 8 0 00-8 8v184a8 8 0 008 8h48a8 8 0 008-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileExclamationFilled);


/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationOutlined__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationOutlined__["a" /* default */]
  }));
};

FileExclamationOutlined.displayName = 'FileExclamationOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExclamationOutlined));

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExclamationOutlined = { "name": "file-exclamation", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM472 744a40 40 0 1080 0 40 40 0 10-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileExclamationOutlined);


/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationTwoTone__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileExclamationTwoTone__["a" /* default */]
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileExclamationTwoTone));

/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileExclamationTwoTone = { "name": "file-exclamation", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileExclamationTwoTone);


/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileFilled__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileFilled = function FileFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileFilled__["a" /* default */]
  }));
};

FileFilled.displayName = 'FileFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileFilled));

/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileFilled = { "name": "file", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileFilled);


/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileGifOutlined__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileGifOutlined = function FileGifOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileGifOutlined__["a" /* default */]
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileGifOutlined));

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileGifOutlined = { "name": "file-gif", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v.7c-.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l.9 2.8h49.2l-.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z" } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z" } }, { "tag": "path", "attrs": { "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileGifOutlined);


/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageFilled__ = __webpack_require__(2507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileImageFilled = function FileImageFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageFilled__["a" /* default */]
  }));
};

FileImageFilled.displayName = 'FileImageFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileImageFilled));

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileImageFilled = { "name": "file-image", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileImageFilled);


/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageOutlined__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileImageOutlined = function FileImageOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageOutlined__["a" /* default */]
  }));
};

FileImageOutlined.displayName = 'FileImageOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileImageOutlined));

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileImageOutlined = { "name": "file-image", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileImageOutlined);


/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageTwoTone__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileImageTwoTone__["a" /* default */]
  }));
};

FileImageTwoTone.displayName = 'FileImageTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileImageTwoTone));

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileImageTwoTone = { "name": "file-image", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0112.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileImageTwoTone);


/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileJpgOutlined__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileJpgOutlined__["a" /* default */]
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileJpgOutlined));

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileJpgOutlined = { "name": "file-jpg", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileJpgOutlined);


/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownFilled__ = __webpack_require__(2515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownFilled__["a" /* default */]
  }));
};

FileMarkdownFilled.displayName = 'FileMarkdownFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileMarkdownFilled));

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileMarkdownFilled = { "name": "file-markdown", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0014.62 9.5h24.06a16 16 0 0014.63-9.51l59.1-133.35V758a16 16 0 0016.01 16H641a16 16 0 0016-16V486a16 16 0 00-16-16h-34.75a16 16 0 00-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 00-14.67-9.61H383a16 16 0 00-16 16v272a16 16 0 0016 16h27.13a16 16 0 0016-16V600.93z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileMarkdownFilled);


/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownOutlined__ = __webpack_require__(2517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownOutlined__["a" /* default */]
  }));
};

FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileMarkdownOutlined));

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileMarkdownOutlined = { "name": "file-markdown", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileMarkdownOutlined);


/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownTwoTone__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileMarkdownTwoTone__["a" /* default */]
  }));
};

FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileMarkdownTwoTone));

/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileMarkdownTwoTone = { "name": "file-markdown", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 01-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileMarkdownTwoTone);


/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileOutlined__ = __webpack_require__(2521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileOutlined = function FileOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileOutlined__["a" /* default */]
  }));
};

FileOutlined.displayName = 'FileOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileOutlined));

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileOutlined = { "name": "file", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileOutlined);


/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfFilled__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePdfFilled = function FilePdfFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfFilled__["a" /* default */]
  }));
};

FilePdfFilled.displayName = 'FilePdfFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePdfFilled));

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePdfFilled = { "name": "file-pdf", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 015.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 01-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 01-1.12-.15 2.07 2.07 0 01-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 01-1.36 6.31 6.7 6.7 0 01-2.17 1.28z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilePdfFilled);


/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfOutlined__ = __webpack_require__(2525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePdfOutlined = function FilePdfOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfOutlined__["a" /* default */]
  }));
};

FilePdfOutlined.displayName = 'FilePdfOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePdfOutlined));

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePdfOutlined = { "name": "file-pdf", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilePdfOutlined);


/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfTwoTone__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePdfTwoTone__["a" /* default */]
  }));
};

FilePdfTwoTone.displayName = 'FilePdfTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePdfTwoTone));

/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePdfTwoTone = { "name": "file-pdf", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FilePdfTwoTone);


/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptFilled__ = __webpack_require__(2529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePptFilled = function FilePptFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptFilled__["a" /* default */]
  }));
};

FilePptFilled.displayName = 'FilePptFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePptFilled));

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePptFilled = { "name": "file-ppt", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 00-12 12v276a12 12 0 0012 12h32.53a12 12 0 0012-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilePptFilled);


/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptOutlined__ = __webpack_require__(2531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePptOutlined = function FilePptOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptOutlined__["a" /* default */]
  }));
};

FilePptOutlined.displayName = 'FilePptOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePptOutlined));

/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePptOutlined = { "name": "file-ppt", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilePptOutlined);


/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptTwoTone__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilePptTwoTone__["a" /* default */]
  }));
};

FilePptTwoTone.displayName = 'FilePptTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilePptTwoTone));

/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilePptTwoTone = { "name": "file-ppt", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FilePptTwoTone);


/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileProtectOutlined__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileProtectOutlined__["a" /* default */]
  }));
};

FileProtectOutlined.displayName = 'FileProtectOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileProtectOutlined));

/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileProtectOutlined = { "name": "file-protect", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M644.7 669.2a7.92 7.92 0 00-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 00-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileProtectOutlined);


/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileSearchOutlined__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileSearchOutlined__["a" /* default */]
  }));
};

FileSearchOutlined.displayName = 'FileSearchOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileSearchOutlined));

/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileSearchOutlined = { "name": "file-search", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 000-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileSearchOutlined);


/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileSyncOutlined__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileSyncOutlined__["a" /* default */]
  }));
};

FileSyncOutlined.displayName = 'FileSyncOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileSyncOutlined));

/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileSyncOutlined = { "name": "file-sync", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 003 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 00-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 00-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0012.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileSyncOutlined);


/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextFilled__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTextFilled = function FileTextFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextFilled__["a" /* default */]
  }));
};

FileTextFilled.displayName = 'FileTextFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileTextFilled));

/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileTextFilled = { "name": "file-text", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileTextFilled);


/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextOutlined__ = __webpack_require__(2543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTextOutlined = function FileTextOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextOutlined__["a" /* default */]
  }));
};

FileTextOutlined.displayName = 'FileTextOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileTextOutlined));

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileTextOutlined = { "name": "file-text", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileTextOutlined);


/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextTwoTone__ = __webpack_require__(2545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTextTwoTone__["a" /* default */]
  }));
};

FileTextTwoTone.displayName = 'FileTextTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileTextTwoTone));

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileTextTwoTone = { "name": "file-text", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileTextTwoTone);


/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTwoTone__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileTwoTone = function FileTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileTwoTone__["a" /* default */]
  }));
};

FileTwoTone.displayName = 'FileTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileTwoTone));

/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileTwoTone = { "name": "file", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileTwoTone);


/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownFilled__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownFilled__["a" /* default */]
  }));
};

FileUnknownFilled.displayName = 'FileUnknownFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileUnknownFilled));

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileUnknownFilled = { "name": "file-unknown", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 100-64 32 32 0 000 64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileUnknownFilled);


/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownOutlined__ = __webpack_require__(2551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownOutlined__["a" /* default */]
  }));
};

FileUnknownOutlined.displayName = 'FileUnknownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileUnknownOutlined));

/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileUnknownOutlined = { "name": "file-unknown", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1064 0 32 32 0 10-64 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileUnknownOutlined);


/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownTwoTone__ = __webpack_require__(2553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileUnknownTwoTone__["a" /* default */]
  }));
};

FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileUnknownTwoTone));

/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileUnknownTwoTone = { "name": "file-unknown", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M480 744a32 32 0 1064 0 32 32 0 10-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileUnknownTwoTone);


/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordFilled__ = __webpack_require__(2555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileWordFilled = function FileWordFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordFilled__["a" /* default */]
  }));
};

FileWordFilled.displayName = 'FileWordFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileWordFilled));

/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileWordFilled = { "name": "file-word", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0011.6 8.9h31.77a12 12 0 0011.6-8.88l74.37-276a12 12 0 00.4-3.12 12 12 0 00-12-12h-35.57a12 12 0 00-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 00528.1 472h-32.2a12 12 0 00-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 00-11.68-9.29h-35.39a12 12 0 00-3.11.41 12 12 0 00-8.47 14.7l74.17 276A12 12 0 00415.6 772h31.99a12 12 0 0011.59-8.9l52.81-197z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileWordFilled);


/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordOutlined__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileWordOutlined = function FileWordOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordOutlined__["a" /* default */]
  }));
};

FileWordOutlined.displayName = 'FileWordOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileWordOutlined));

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileWordOutlined = { "name": "file-word", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileWordOutlined);


/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordTwoTone__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileWordTwoTone__["a" /* default */]
  }));
};

FileWordTwoTone.displayName = 'FileWordTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileWordTwoTone));

/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileWordTwoTone = { "name": "file-word", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0111.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0111.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileWordTwoTone);


/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipFilled__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileZipFilled = function FileZipFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipFilled__["a" /* default */]
  }));
};

FileZipFilled.displayName = 'FileZipFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileZipFilled));

/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileZipFilled = { "name": "file-zip", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileZipFilled);


/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipOutlined__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileZipOutlined = function FileZipOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipOutlined__["a" /* default */]
  }));
};

FileZipOutlined.displayName = 'FileZipOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileZipOutlined));

/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileZipOutlined = { "name": "file-zip", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FileZipOutlined);


/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipTwoTone__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FileZipTwoTone__["a" /* default */]
  }));
};

FileZipTwoTone.displayName = 'FileZipTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FileZipTwoTone));

/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FileZipTwoTone = { "name": "file-zip", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M344 630h32v2h-32z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FileZipTwoTone);


/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterFilled__ = __webpack_require__(2567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilterFilled = function FilterFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterFilled__["a" /* default */]
  }));
};

FilterFilled.displayName = 'FilterFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilterFilled));

/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilterFilled = { "name": "filter", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilterFilled);


/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterOutlined__ = __webpack_require__(2569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilterOutlined = function FilterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterOutlined__["a" /* default */]
  }));
};

FilterOutlined.displayName = 'FilterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilterOutlined));

/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilterOutlined = { "name": "filter", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FilterOutlined);


/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterTwoTone__ = __webpack_require__(2571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FilterTwoTone = function FilterTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FilterTwoTone__["a" /* default */]
  }));
};

FilterTwoTone.displayName = 'FilterTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FilterTwoTone));

/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FilterTwoTone = { "name": "filter", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FilterTwoTone);


/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireFilled__ = __webpack_require__(2573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FireFilled = function FireFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireFilled__["a" /* default */]
  }));
};

FireFilled.displayName = 'FireFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FireFilled));

/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FireFilled = { "name": "fire", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FireFilled);


/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireOutlined__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FireOutlined = function FireOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireOutlined__["a" /* default */]
  }));
};

FireOutlined.displayName = 'FireOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FireOutlined));

/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FireOutlined = { "name": "fire", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FireOutlined);


/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireTwoTone__ = __webpack_require__(2577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FireTwoTone = function FireTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FireTwoTone__["a" /* default */]
  }));
};

FireTwoTone.displayName = 'FireTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FireTwoTone));

/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FireTwoTone = { "name": "fire", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 01-51 24.4 73.36 73.36 0 01-53.4-18.8 74.01 74.01 0 01-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 01-12.1 46.5 354.26 354.26 0 01-58.2 101 349.6 349.6 0 01-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 00-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FireTwoTone);


/***/ }),
/* 2578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagFilled__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FlagFilled = function FlagFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagFilled__["a" /* default */]
  }));
};

FlagFilled.displayName = 'FlagFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FlagFilled));

/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FlagFilled = { "name": "flag", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FlagFilled);


/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagOutlined__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FlagOutlined = function FlagOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagOutlined__["a" /* default */]
  }));
};

FlagOutlined.displayName = 'FlagOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FlagOutlined));

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FlagOutlined = { "name": "flag", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FlagOutlined);


/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagTwoTone__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FlagTwoTone = function FlagTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FlagTwoTone__["a" /* default */]
  }));
};

FlagTwoTone.displayName = 'FlagTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FlagTwoTone));

/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FlagTwoTone = { "name": "flag", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 232h368v336H184z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FlagTwoTone);


/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddFilled__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderAddFilled = function FolderAddFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddFilled__["a" /* default */]
  }));
};

FolderAddFilled.displayName = 'FolderAddFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderAddFilled));

/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderAddFilled = { "name": "folder-add", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderAddFilled);


/***/ }),
/* 2586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddOutlined__ = __webpack_require__(2587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddOutlined__["a" /* default */]
  }));
};

FolderAddOutlined.displayName = 'FolderAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderAddOutlined));

/***/ }),
/* 2587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderAddOutlined = { "name": "folder-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderAddOutlined);


/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddTwoTone__ = __webpack_require__(2589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderAddTwoTone__["a" /* default */]
  }));
};

FolderAddTwoTone.displayName = 'FolderAddTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderAddTwoTone));

/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderAddTwoTone = { "name": "folder-add", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FolderAddTwoTone);


/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderFilled__ = __webpack_require__(2591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderFilled = function FolderFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderFilled__["a" /* default */]
  }));
};

FolderFilled.displayName = 'FolderFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderFilled));

/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderFilled = { "name": "folder", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderFilled);


/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenFilled__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenFilled__["a" /* default */]
  }));
};

FolderOpenFilled.displayName = 'FolderOpenFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderOpenFilled));

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderOpenFilled = { "name": "folder-open", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderOpenFilled);


/***/ }),
/* 2594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenOutlined__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenOutlined__["a" /* default */]
  }));
};

FolderOpenOutlined.displayName = 'FolderOpenOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderOpenOutlined));

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderOpenOutlined = { "name": "folder-open", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderOpenOutlined);


/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenTwoTone__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOpenTwoTone__["a" /* default */]
  }));
};

FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderOpenTwoTone));

/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderOpenTwoTone = { "name": "folder-open", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M159 768h612.3l103.4-256H262.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FolderOpenTwoTone);


/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOutlined__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderOutlined = function FolderOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderOutlined__["a" /* default */]
  }));
};

FolderOutlined.displayName = 'FolderOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderOutlined));

/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderOutlined = { "name": "folder", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderOutlined);


/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderTwoTone__ = __webpack_require__(2601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderTwoTone = function FolderTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderTwoTone__["a" /* default */]
  }));
};

FolderTwoTone.displayName = 'FolderTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderTwoTone));

/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderTwoTone = { "name": "folder", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FolderTwoTone);


/***/ }),
/* 2602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderViewOutlined__ = __webpack_require__(2603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FolderViewOutlined__["a" /* default */]
  }));
};

FolderViewOutlined.displayName = 'FolderViewOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FolderViewOutlined));

/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FolderViewOutlined = { "name": "folder-view", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M309.1 554.3a42.92 42.92 0 000 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.3l-.1-.1-.1-.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z" } }, { "tag": "path", "attrs": { "d": "M457 573a56 56 0 10112 0 56 56 0 10-112 0z" } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FolderViewOutlined);


/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FontColorsOutlined__ = __webpack_require__(2605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FontColorsOutlined__["a" /* default */]
  }));
};

FontColorsOutlined.displayName = 'FontColorsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FontColorsOutlined));

/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FontColorsOutlined = { "name": "font-colors", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 006-12.4L573.6 118.6a9.9 9.9 0 00-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FontColorsOutlined);


/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FontSizeOutlined__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FontSizeOutlined__["a" /* default */]
  }));
};

FontSizeOutlined.displayName = 'FontSizeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FontSizeOutlined));

/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FontSizeOutlined = { "name": "font-size", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FontSizeOutlined);


/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForkOutlined__ = __webpack_require__(2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ForkOutlined = function ForkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForkOutlined__["a" /* default */]
  }));
};

ForkOutlined.displayName = 'ForkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ForkOutlined));

/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ForkOutlined = { "name": "fork", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm336 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm192-552a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ForkOutlined);


/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormOutlined__ = __webpack_require__(2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FormOutlined = function FormOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormOutlined__["a" /* default */]
  }));
};

FormOutlined.displayName = 'FormOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FormOutlined));

/***/ }),
/* 2611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FormOutlined = { "name": "form", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FormOutlined);


/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormatPainterFilled__ = __webpack_require__(2613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormatPainterFilled__["a" /* default */]
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FormatPainterFilled));

/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FormatPainterFilled = { "name": "format-painter", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1.2 2.2.6 3.1-.4 1.6-.6 3.2-.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-.2-3.3-.6-4.9.4-1 .6-2 .6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FormatPainterFilled);


/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormatPainterOutlined__ = __webpack_require__(2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FormatPainterOutlined__["a" /* default */]
  }));
};

FormatPainterOutlined.displayName = 'FormatPainterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FormatPainterOutlined));

/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FormatPainterOutlined = { "name": "format-painter", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 .6.1 1.3.2 1.9A83.99 83.99 0 00457 960c46.4 0 84-37.6 84-84 0-2.1-.1-4.1-.2-6.1.1-.6.2-1.2.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FormatPainterOutlined);


/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForwardFilled__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ForwardFilled = function ForwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForwardFilled__["a" /* default */]
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ForwardFilled));

/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ForwardFilled = { "name": "forward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ForwardFilled);


/***/ }),
/* 2618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForwardOutlined__ = __webpack_require__(2619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ForwardOutlined = function ForwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ForwardOutlined__["a" /* default */]
  }));
};

ForwardOutlined.displayName = 'ForwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ForwardOutlined));

/***/ }),
/* 2619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ForwardOutlined = { "name": "forward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ForwardOutlined);


/***/ }),
/* 2620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownFilled__ = __webpack_require__(2621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FrownFilled = function FrownFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownFilled__["a" /* default */]
  }));
};

FrownFilled.displayName = 'FrownFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FrownFilled));

/***/ }),
/* 2621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FrownFilled = { "name": "frown", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FrownFilled);


/***/ }),
/* 2622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownOutlined__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FrownOutlined = function FrownOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownOutlined__["a" /* default */]
  }));
};

FrownOutlined.displayName = 'FrownOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FrownOutlined));

/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FrownOutlined = { "name": "frown", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FrownOutlined);


/***/ }),
/* 2624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownTwoTone__ = __webpack_require__(2625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FrownTwoTone = function FrownTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FrownTwoTone__["a" /* default */]
  }));
};

FrownTwoTone.displayName = 'FrownTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FrownTwoTone));

/***/ }),
/* 2625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FrownTwoTone = { "name": "frown", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FrownTwoTone);


/***/ }),
/* 2626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FullscreenExitOutlined__ = __webpack_require__(2627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FullscreenExitOutlined = function FullscreenExitOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FullscreenExitOutlined__["a" /* default */]
  }));
};

FullscreenExitOutlined.displayName = 'FullscreenExitOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FullscreenExitOutlined));

/***/ }),
/* 2627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FullscreenExitOutlined = { "name": "fullscreen-exit", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FullscreenExitOutlined);


/***/ }),
/* 2628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FullscreenOutlined__ = __webpack_require__(2629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FullscreenOutlined__["a" /* default */]
  }));
};

FullscreenOutlined.displayName = 'FullscreenOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FullscreenOutlined));

/***/ }),
/* 2629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FullscreenOutlined = { "name": "fullscreen", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FullscreenOutlined);


/***/ }),
/* 2630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunctionOutlined__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FunctionOutlined = function FunctionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunctionOutlined__["a" /* default */]
  }));
};

FunctionOutlined.displayName = 'FunctionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FunctionOutlined));

/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FunctionOutlined = { "name": "function", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M841 370c3-3.3 2.7-8.3-.6-11.3a8.24 8.24 0 00-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6a7.96 7.96 0 01-13.4-1.9l-63.5-141.3a7.9 7.9 0 00-7.3-4.7H380.7l.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415a8.07 8.07 0 007.8 9.7H284l-89 429.9a8.07 8.07 0 007.8 9.7H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 .9.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6a8.02 8.02 0 007.2-11.5l-95.2-198.9c-1.4-2.9-.9-6.4 1.3-8.8L841 370z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FunctionOutlined);


/***/ }),
/* 2632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundFilled__ = __webpack_require__(2633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FundFilled = function FundFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundFilled__["a" /* default */]
  }));
};

FundFilled.displayName = 'FundFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FundFilled));

/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FundFilled = { "name": "fund", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 01-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 01-11.3 0l-36.8-36.8a8.03 8.03 0 010-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FundFilled);


/***/ }),
/* 2634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundOutlined__ = __webpack_require__(2635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FundOutlined = function FundOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundOutlined__["a" /* default */]
  }));
};

FundOutlined.displayName = 'FundOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FundOutlined));

/***/ }),
/* 2635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FundOutlined = { "name": "fund", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FundOutlined);


/***/ }),
/* 2636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundProjectionScreenOutlined__ = __webpack_require__(2637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundProjectionScreenOutlined__["a" /* default */]
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FundProjectionScreenOutlined));

/***/ }),
/* 2637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FundProjectionScreenOutlined = { "name": "fund-projection-screen", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L517 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L275.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8z" } }, { "tag": "path", "attrs": { "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1a7.92 7.92 0 00-2.3 11l30.3 47.2v.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-.1l30.3-47.2a8 8 0 00-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 512H160V232h704v440z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FundProjectionScreenOutlined);


/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundTwoTone__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FundTwoTone = function FundTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundTwoTone__["a" /* default */]
  }));
};

FundTwoTone.displayName = 'FundTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FundTwoTone));

/***/ }),
/* 2639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FundTwoTone = { "name": "fund", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 01-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 01-11.3 0l-36.7-36.9a8.03 8.03 0 010-11.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L533 561 418.6 446.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FundTwoTone);


/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundViewOutlined__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FundViewOutlined = function FundViewOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FundViewOutlined__["a" /* default */]
  }));
};

FundViewOutlined.displayName = 'FundViewOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FundViewOutlined));

/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FundViewOutlined = { "name": "fund-view", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M956 686.5l-.1-.1-.1-.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v.1a42.92 42.92 0 000 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z" } }, { "tag": "path", "attrs": { "d": "M697 705a56 56 0 10112 0 56 56 0 10-112 0zM136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z" } }, { "tag": "path", "attrs": { "d": "M724.9 338.1l-36.8-36.8a8.03 8.03 0 00-11.3 0L493 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L251.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FundViewOutlined);


/***/ }),
/* 2642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotFilled__ = __webpack_require__(2643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotFilled__["a" /* default */]
  }));
};

FunnelPlotFilled.displayName = 'FunnelPlotFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FunnelPlotFilled));

/***/ }),
/* 2643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FunnelPlotFilled = { "name": "funnel-plot", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FunnelPlotFilled);


/***/ }),
/* 2644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotOutlined__ = __webpack_require__(2645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotOutlined__["a" /* default */]
  }));
};

FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FunnelPlotOutlined));

/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FunnelPlotOutlined = { "name": "funnel-plot", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (FunnelPlotOutlined);


/***/ }),
/* 2646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotTwoTone__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_FunnelPlotTwoTone__["a" /* default */]
  }));
};

FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(FunnelPlotTwoTone));

/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var FunnelPlotTwoTone = { "name": "funnel-plot", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (FunnelPlotTwoTone);


/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GatewayOutlined__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GatewayOutlined = function GatewayOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GatewayOutlined__["a" /* default */]
  }));
};

GatewayOutlined.displayName = 'GatewayOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GatewayOutlined));

/***/ }),
/* 2649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GatewayOutlined = { "name": "gateway", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GatewayOutlined);


/***/ }),
/* 2650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GifOutlined__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GifOutlined = function GifOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GifOutlined__["a" /* default */]
  }));
};

GifOutlined.displayName = 'GifOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GifOutlined));

/***/ }),
/* 2651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GifOutlined = { "name": "gif", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zm-356 1h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GifOutlined);


/***/ }),
/* 2652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftFilled__ = __webpack_require__(2653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GiftFilled = function GiftFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftFilled__["a" /* default */]
  }));
};

GiftFilled.displayName = 'GiftFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GiftFilled));

/***/ }),
/* 2653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GiftFilled = { "name": "gift", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GiftFilled);


/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftOutlined__ = __webpack_require__(2655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GiftOutlined = function GiftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftOutlined__["a" /* default */]
  }));
};

GiftOutlined.displayName = 'GiftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GiftOutlined));

/***/ }),
/* 2655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GiftOutlined = { "name": "gift", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GiftOutlined);


/***/ }),
/* 2656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftTwoTone__ = __webpack_require__(2657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GiftTwoTone = function GiftTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GiftTwoTone__["a" /* default */]
  }));
};

GiftTwoTone.displayName = 'GiftTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GiftTwoTone));

/***/ }),
/* 2657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GiftTwoTone = { "name": "gift", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (GiftTwoTone);


/***/ }),
/* 2658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GithubFilled__ = __webpack_require__(2659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GithubFilled = function GithubFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GithubFilled__["a" /* default */]
  }));
};

GithubFilled.displayName = 'GithubFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GithubFilled));

/***/ }),
/* 2659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GithubFilled = { "name": "github", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GithubFilled);


/***/ }),
/* 2660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GithubOutlined__ = __webpack_require__(2661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GithubOutlined = function GithubOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GithubOutlined__["a" /* default */]
  }));
};

GithubOutlined.displayName = 'GithubOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GithubOutlined));

/***/ }),
/* 2661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GithubOutlined = { "name": "github", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GithubOutlined);


/***/ }),
/* 2662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GitlabFilled__ = __webpack_require__(2663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GitlabFilled = function GitlabFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GitlabFilled__["a" /* default */]
  }));
};

GitlabFilled.displayName = 'GitlabFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GitlabFilled));

/***/ }),
/* 2663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GitlabFilled = { "name": "gitlab", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GitlabFilled);


/***/ }),
/* 2664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GitlabOutlined__ = __webpack_require__(2665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GitlabOutlined = function GitlabOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GitlabOutlined__["a" /* default */]
  }));
};

GitlabOutlined.displayName = 'GitlabOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GitlabOutlined));

/***/ }),
/* 2665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GitlabOutlined = { "name": "gitlab", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GitlabOutlined);


/***/ }),
/* 2666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GlobalOutlined__ = __webpack_require__(2667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GlobalOutlined = function GlobalOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GlobalOutlined__["a" /* default */]
  }));
};

GlobalOutlined.displayName = 'GlobalOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GlobalOutlined));

/***/ }),
/* 2667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GlobalOutlined = { "name": "global", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GlobalOutlined);


/***/ }),
/* 2668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldFilled__ = __webpack_require__(2669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoldFilled = function GoldFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldFilled__["a" /* default */]
  }));
};

GoldFilled.displayName = 'GoldFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoldFilled));

/***/ }),
/* 2669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoldFilled = { "name": "gold", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoldFilled);


/***/ }),
/* 2670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldOutlined__ = __webpack_require__(2671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoldOutlined = function GoldOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldOutlined__["a" /* default */]
  }));
};

GoldOutlined.displayName = 'GoldOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoldOutlined));

/***/ }),
/* 2671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoldOutlined = { "name": "gold", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoldOutlined);


/***/ }),
/* 2672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldTwoTone__ = __webpack_require__(2673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoldTwoTone = function GoldTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldTwoTone__["a" /* default */]
  }));
};

GoldTwoTone.displayName = 'GoldTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoldTwoTone));

/***/ }),
/* 2673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoldTwoTone = { "name": "gold", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (GoldTwoTone);


/***/ }),
/* 2674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldenFilled__ = __webpack_require__(2675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoldenFilled = function GoldenFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoldenFilled__["a" /* default */]
  }));
};

GoldenFilled.displayName = 'GoldenFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoldenFilled));

/***/ }),
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoldenFilled = { "name": "golden", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoldenFilled);


/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleCircleFilled__ = __webpack_require__(2677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleCircleFilled__["a" /* default */]
  }));
};

GoogleCircleFilled.displayName = 'GoogleCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoogleCircleFilled));

/***/ }),
/* 2677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoogleCircleFilled = { "name": "google-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoogleCircleFilled);


/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleOutlined__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoogleOutlined = function GoogleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleOutlined__["a" /* default */]
  }));
};

GoogleOutlined.displayName = 'GoogleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoogleOutlined));

/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoogleOutlined = { "name": "google", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoogleOutlined);


/***/ }),
/* 2680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusCircleFilled__ = __webpack_require__(2681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusCircleFilled__["a" /* default */]
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GooglePlusCircleFilled));

/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GooglePlusCircleFilled = { "name": "google-plus-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GooglePlusCircleFilled);


/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusOutlined__ = __webpack_require__(2683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusOutlined__["a" /* default */]
  }));
};

GooglePlusOutlined.displayName = 'GooglePlusOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GooglePlusOutlined));

/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GooglePlusOutlined = { "name": "google-plus", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GooglePlusOutlined);


/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusSquareFilled__ = __webpack_require__(2685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GooglePlusSquareFilled__["a" /* default */]
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GooglePlusSquareFilled));

/***/ }),
/* 2685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GooglePlusSquareFilled = { "name": "google-plus-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GooglePlusSquareFilled);


/***/ }),
/* 2686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleSquareFilled__ = __webpack_require__(2687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GoogleSquareFilled__["a" /* default */]
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GoogleSquareFilled));

/***/ }),
/* 2687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GoogleSquareFilled = { "name": "google-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 01272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GoogleSquareFilled);


/***/ }),
/* 2688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GroupOutlined__ = __webpack_require__(2689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GroupOutlined = function GroupOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_GroupOutlined__["a" /* default */]
  }));
};

GroupOutlined.displayName = 'GroupOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(GroupOutlined));

/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var GroupOutlined = { "name": "group", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm704 680H184V184h656v656zm48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }, { "tag": "path", "attrs": { "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64zm-56 420h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (GroupOutlined);


/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddFilled__ = __webpack_require__(2691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HddFilled = function HddFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddFilled__["a" /* default */]
  }));
};

HddFilled.displayName = 'HddFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HddFilled));

/***/ }),
/* 2691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HddFilled = { "name": "hdd", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HddFilled);


/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddOutlined__ = __webpack_require__(2693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HddOutlined = function HddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddOutlined__["a" /* default */]
  }));
};

HddOutlined.displayName = 'HddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HddOutlined));

/***/ }),
/* 2693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HddOutlined = { "name": "hdd", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HddOutlined);


/***/ }),
/* 2694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddTwoTone__ = __webpack_require__(2695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HddTwoTone = function HddTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HddTwoTone__["a" /* default */]
  }));
};

HddTwoTone.displayName = 'HddTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HddTwoTone));

/***/ }),
/* 2695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HddTwoTone = { "name": "hdd", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (HddTwoTone);


/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartFilled__ = __webpack_require__(2697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HeartFilled = function HeartFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartFilled__["a" /* default */]
  }));
};

HeartFilled.displayName = 'HeartFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HeartFilled));

/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HeartFilled = { "name": "heart", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HeartFilled);


/***/ }),
/* 2698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartOutlined__ = __webpack_require__(2699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HeartOutlined = function HeartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartOutlined__["a" /* default */]
  }));
};

HeartOutlined.displayName = 'HeartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HeartOutlined));

/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HeartOutlined = { "name": "heart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HeartOutlined);


/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartTwoTone__ = __webpack_require__(2701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HeartTwoTone = function HeartTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeartTwoTone__["a" /* default */]
  }));
};

HeartTwoTone.displayName = 'HeartTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HeartTwoTone));

/***/ }),
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HeartTwoTone = { "name": "heart", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (HeartTwoTone);


/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeatMapOutlined__ = __webpack_require__(2703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HeatMapOutlined__["a" /* default */]
  }));
};

HeatMapOutlined.displayName = 'HeatMapOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HeatMapOutlined));

/***/ }),
/* 2703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HeatMapOutlined = { "name": "heat-map", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HeatMapOutlined);


/***/ }),
/* 2704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightFilled__ = __webpack_require__(2705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HighlightFilled = function HighlightFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightFilled__["a" /* default */]
  }));
};

HighlightFilled.displayName = 'HighlightFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HighlightFilled));

/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HighlightFilled = { "name": "highlight", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HighlightFilled);


/***/ }),
/* 2706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightOutlined__ = __webpack_require__(2707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HighlightOutlined = function HighlightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightOutlined__["a" /* default */]
  }));
};

HighlightOutlined.displayName = 'HighlightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HighlightOutlined));

/***/ }),
/* 2707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HighlightOutlined = { "name": "highlight", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HighlightOutlined);


/***/ }),
/* 2708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightTwoTone__ = __webpack_require__(2709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HighlightTwoTone__["a" /* default */]
  }));
};

HighlightTwoTone.displayName = 'HighlightTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HighlightTwoTone));

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HighlightTwoTone = { "name": "highlight", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 00-11.2 0L353.3 393.5a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (HighlightTwoTone);


/***/ }),
/* 2710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HistoryOutlined__ = __webpack_require__(2711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HistoryOutlined = function HistoryOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HistoryOutlined__["a" /* default */]
  }));
};

HistoryOutlined.displayName = 'HistoryOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HistoryOutlined));

/***/ }),
/* 2711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HistoryOutlined = { "name": "history", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HistoryOutlined);


/***/ }),
/* 2712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeFilled__ = __webpack_require__(2713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HomeFilled = function HomeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeFilled__["a" /* default */]
  }));
};

HomeFilled.displayName = 'HomeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HomeFilled));

/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HomeFilled = { "name": "home", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HomeFilled);


/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeOutlined__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HomeOutlined = function HomeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeOutlined__["a" /* default */]
  }));
};

HomeOutlined.displayName = 'HomeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HomeOutlined));

/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HomeOutlined = { "name": "home", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HomeOutlined);


/***/ }),
/* 2716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeTwoTone__ = __webpack_require__(2717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HomeTwoTone = function HomeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HomeTwoTone__["a" /* default */]
  }));
};

HomeTwoTone.displayName = 'HomeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HomeTwoTone));

/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HomeTwoTone = { "name": "home", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.6 63.6 0 00-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0018.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (HomeTwoTone);


/***/ }),
/* 2718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassFilled__ = __webpack_require__(2719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HourglassFilled = function HourglassFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassFilled__["a" /* default */]
  }));
};

HourglassFilled.displayName = 'HourglassFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HourglassFilled));

/***/ }),
/* 2719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HourglassFilled = { "name": "hourglass", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HourglassFilled);


/***/ }),
/* 2720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassOutlined__ = __webpack_require__(2721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HourglassOutlined = function HourglassOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassOutlined__["a" /* default */]
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HourglassOutlined));

/***/ }),
/* 2721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HourglassOutlined = { "name": "hourglass", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (HourglassOutlined);


/***/ }),
/* 2722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassTwoTone__ = __webpack_require__(2723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_HourglassTwoTone__["a" /* default */]
  }));
};

HourglassTwoTone.displayName = 'HourglassTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(HourglassTwoTone));

/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var HourglassTwoTone = { "name": "hourglass", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 00354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 00512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (HourglassTwoTone);


/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5Filled__ = __webpack_require__(2725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var Html5Filled = function Html5Filled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5Filled__["a" /* default */]
  }));
};

Html5Filled.displayName = 'Html5Filled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Html5Filled));

/***/ }),
/* 2725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var Html5Filled = { "name": "html5", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (Html5Filled);


/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5Outlined__ = __webpack_require__(2727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var Html5Outlined = function Html5Outlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5Outlined__["a" /* default */]
  }));
};

Html5Outlined.displayName = 'Html5Outlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Html5Outlined));

/***/ }),
/* 2727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var Html5Outlined = { "name": "html5", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (Html5Outlined);


/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5TwoTone__ = __webpack_require__(2729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var Html5TwoTone = function Html5TwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Html5TwoTone__["a" /* default */]
  }));
};

Html5TwoTone.displayName = 'Html5TwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Html5TwoTone));

/***/ }),
/* 2729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var Html5TwoTone = { "name": "html5", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (Html5TwoTone);


/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardFilled__ = __webpack_require__(2731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IdcardFilled = function IdcardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardFilled__["a" /* default */]
  }));
};

IdcardFilled.displayName = 'IdcardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IdcardFilled));

/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IdcardFilled = { "name": "idcard", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IdcardFilled);


/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardOutlined__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IdcardOutlined = function IdcardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardOutlined__["a" /* default */]
  }));
};

IdcardOutlined.displayName = 'IdcardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IdcardOutlined));

/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IdcardOutlined = { "name": "idcard", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IdcardOutlined);


/***/ }),
/* 2734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardTwoTone__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IdcardTwoTone__["a" /* default */]
  }));
};

IdcardTwoTone.displayName = 'IdcardTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IdcardTwoTone));

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IdcardTwoTone = { "name": "idcard", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 01-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.3 463a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (IdcardTwoTone);


/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeCircleFilled__ = __webpack_require__(2737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IeCircleFilled = function IeCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeCircleFilled__["a" /* default */]
  }));
};

IeCircleFilled.displayName = 'IeCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IeCircleFilled));

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IeCircleFilled = { "name": "ie-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IeCircleFilled);


/***/ }),
/* 2738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeOutlined__ = __webpack_require__(2739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IeOutlined = function IeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeOutlined__["a" /* default */]
  }));
};

IeOutlined.displayName = 'IeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IeOutlined));

/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IeOutlined = { "name": "ie", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IeOutlined);


/***/ }),
/* 2740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeSquareFilled__ = __webpack_require__(2741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IeSquareFilled = function IeSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IeSquareFilled__["a" /* default */]
  }));
};

IeSquareFilled.displayName = 'IeSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IeSquareFilled));

/***/ }),
/* 2741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IeSquareFilled = { "name": "ie-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IeSquareFilled);


/***/ }),
/* 2742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ImportOutlined__ = __webpack_require__(2743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ImportOutlined = function ImportOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ImportOutlined__["a" /* default */]
  }));
};

ImportOutlined.displayName = 'ImportOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ImportOutlined));

/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ImportOutlined = { "name": "import", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ImportOutlined);


/***/ }),
/* 2744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InboxOutlined__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InboxOutlined = function InboxOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InboxOutlined__["a" /* default */]
  }));
};

InboxOutlined.displayName = 'InboxOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InboxOutlined));

/***/ }),
/* 2745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InboxOutlined = { "name": "inbox", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InboxOutlined);


/***/ }),
/* 2746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleFilled__ = __webpack_require__(2747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleFilled__["a" /* default */]
  }));
};

InfoCircleFilled.displayName = 'InfoCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InfoCircleFilled));

/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InfoCircleFilled = { "name": "info-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InfoCircleFilled);


/***/ }),
/* 2748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleOutlined__ = __webpack_require__(2749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleOutlined__["a" /* default */]
  }));
};

InfoCircleOutlined.displayName = 'InfoCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InfoCircleOutlined));

/***/ }),
/* 2749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InfoCircleOutlined = { "name": "info-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InfoCircleOutlined);


/***/ }),
/* 2750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleTwoTone__ = __webpack_require__(2751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoCircleTwoTone__["a" /* default */]
  }));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InfoCircleTwoTone));

/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InfoCircleTwoTone = { "name": "info-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (InfoCircleTwoTone);


/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoOutlined__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InfoOutlined = function InfoOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InfoOutlined__["a" /* default */]
  }));
};

InfoOutlined.displayName = 'InfoOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InfoOutlined));

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InfoOutlined = { "name": "info", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 224a64 64 0 10128 0 64 64 0 10-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InfoOutlined);


/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowAboveOutlined__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowAboveOutlined__["a" /* default */]
  }));
};

InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsertRowAboveOutlined));

/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsertRowAboveOutlined = { "name": "insert-row-above", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160zm0-224H184V408h176v160zm240 224H424V632h176v160zm0-224H424V408h176v160zm240 224H664V632h176v160zm0-224H664V408h176v160zm64-408H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsertRowAboveOutlined);


/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowBelowOutlined__ = __webpack_require__(2757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsertRowBelowOutlined = function InsertRowBelowOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowBelowOutlined__["a" /* default */]
  }));
};

InsertRowBelowOutlined.displayName = 'InsertRowBelowOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsertRowBelowOutlined));

/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsertRowBelowOutlined = { "name": "insert-row-below", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-25.3-608H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160zm0-224H184V232h176v160zm240 224H424V456h176v160zm0-224H424V232h176v160zm240 224H664V456h176v160zm0-224H664V232h176v160z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsertRowBelowOutlined);


/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowLeftOutlined__ = __webpack_require__(2759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowLeftOutlined__["a" /* default */]
  }));
};

InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsertRowLeftOutlined));

/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsertRowLeftOutlined = { "name": "insert-row-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm584 0H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176zm0-240H408V424h160v176zm0-240H408V184h160v176zm224 480H632V664h160v176zm0-240H632V424h160v176zm0-240H632V184h160v176z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsertRowLeftOutlined);


/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowRightOutlined__ = __webpack_require__(2761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsertRowRightOutlined__["a" /* default */]
  }));
};

InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsertRowRightOutlined));

/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsertRowRightOutlined = { "name": "insert-row-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm-200 0H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176zm0-240H232V424h160v176zm0-240H232V184h160v176zm224 480H456V664h160v176zm0-240H456V424h160v176zm0-240H456V184h160v176z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsertRowRightOutlined);


/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InstagramFilled__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InstagramFilled = function InstagramFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InstagramFilled__["a" /* default */]
  }));
};

InstagramFilled.displayName = 'InstagramFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InstagramFilled));

/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InstagramFilled = { "name": "instagram", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InstagramFilled);


/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InstagramOutlined__ = __webpack_require__(2765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InstagramOutlined = function InstagramOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InstagramOutlined__["a" /* default */]
  }));
};

InstagramOutlined.displayName = 'InstagramOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InstagramOutlined));

/***/ }),
/* 2765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InstagramOutlined = { "name": "instagram", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InstagramOutlined);


/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceFilled__ = __webpack_require__(2767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsuranceFilled = function InsuranceFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceFilled__["a" /* default */]
  }));
};

InsuranceFilled.displayName = 'InsuranceFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsuranceFilled));

/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsuranceFilled = { "name": "insurance", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 01-8.9-1.4L430 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsuranceFilled);


/***/ }),
/* 2768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceOutlined__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceOutlined__["a" /* default */]
  }));
};

InsuranceOutlined.displayName = 'InsuranceOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsuranceOutlined));

/***/ }),
/* 2769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsuranceOutlined = { "name": "insurance", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M441.6 306.8L403 288.6a6.1 6.1 0 00-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 00-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0033.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InsuranceOutlined);


/***/ }),
/* 2770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceTwoTone__ = __webpack_require__(2771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InsuranceTwoTone__["a" /* default */]
  }));
};

InsuranceTwoTone.displayName = 'InsuranceTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InsuranceTwoTone));

/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InsuranceTwoTone = { "name": "insurance", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M521.9 358.8h97.9v41.6h-97.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 01-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 00-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0033.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (InsuranceTwoTone);


/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionFilled__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InteractionFilled = function InteractionFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionFilled__["a" /* default */]
  }));
};

InteractionFilled.displayName = 'InteractionFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InteractionFilled));

/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InteractionFilled = { "name": "interaction", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InteractionFilled);


/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionOutlined__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InteractionOutlined = function InteractionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionOutlined__["a" /* default */]
  }));
};

InteractionOutlined.displayName = 'InteractionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InteractionOutlined));

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InteractionOutlined = { "name": "interaction", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (InteractionOutlined);


/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionTwoTone__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_InteractionTwoTone__["a" /* default */]
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(InteractionTwoTone));

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var InteractionTwoTone = { "name": "interaction", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (InteractionTwoTone);


/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IssuesCloseOutlined__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_IssuesCloseOutlined__["a" /* default */]
  }));
};

IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(IssuesCloseOutlined));

/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var IssuesCloseOutlined = { "name": "issues-close", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 00-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0026 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 01-49.8 62.2A355.92 355.92 0 01651.1 840a355 355 0 01-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 01-113.3-76.3A353.06 353.06 0 01184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 01138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 00892 694z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (IssuesCloseOutlined);


/***/ }),
/* 2780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ItalicOutlined__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ItalicOutlined = function ItalicOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ItalicOutlined__["a" /* default */]
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ItalicOutlined));

/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ItalicOutlined = { "name": "italic", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ItalicOutlined);


/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_KeyOutlined__ = __webpack_require__(2783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var KeyOutlined = function KeyOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_KeyOutlined__["a" /* default */]
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(KeyOutlined));

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var KeyOutlined = { "name": "key", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 00608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (KeyOutlined);


/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LaptopOutlined__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LaptopOutlined = function LaptopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LaptopOutlined__["a" /* default */]
  }));
};

LaptopOutlined.displayName = 'LaptopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LaptopOutlined));

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LaptopOutlined = { "name": "laptop", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LaptopOutlined);


/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutFilled__ = __webpack_require__(2787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LayoutFilled = function LayoutFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutFilled__["a" /* default */]
  }));
};

LayoutFilled.displayName = 'LayoutFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LayoutFilled));

/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LayoutFilled = { "name": "layout", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LayoutFilled);


/***/ }),
/* 2788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutOutlined__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LayoutOutlined = function LayoutOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutOutlined__["a" /* default */]
  }));
};

LayoutOutlined.displayName = 'LayoutOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LayoutOutlined));

/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LayoutOutlined = { "name": "layout", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LayoutOutlined);


/***/ }),
/* 2790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutTwoTone__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LayoutTwoTone__["a" /* default */]
  }));
};

LayoutTwoTone.displayName = 'LayoutTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LayoutTwoTone));

/***/ }),
/* 2791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LayoutTwoTone = { "name": "layout", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (LayoutTwoTone);


/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleFilled__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleFilled__["a" /* default */]
  }));
};

LeftCircleFilled.displayName = 'LeftCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftCircleFilled));

/***/ }),
/* 2793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftCircleFilled = { "name": "left-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178a8 8 0 0112.7 6.5v46.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LeftCircleFilled);


/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleOutlined__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleOutlined__["a" /* default */]
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftCircleOutlined));

/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftCircleOutlined = { "name": "left-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LeftCircleOutlined);


/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleTwoTone__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftCircleTwoTone__["a" /* default */]
  }));
};

LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftCircleTwoTone));

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftCircleTwoTone = { "name": "left-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (LeftCircleTwoTone);


/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftOutlined__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftOutlined = function LeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftOutlined__["a" /* default */]
  }));
};

LeftOutlined.displayName = 'LeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftOutlined));

/***/ }),
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftOutlined = { "name": "left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LeftOutlined);


/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareFilled__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareFilled__["a" /* default */]
  }));
};

LeftSquareFilled.displayName = 'LeftSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftSquareFilled));

/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftSquareFilled = { "name": "left-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LeftSquareFilled);


/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareOutlined__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareOutlined__["a" /* default */]
  }));
};

LeftSquareOutlined.displayName = 'LeftSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftSquareOutlined));

/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftSquareOutlined = { "name": "left-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 000 13z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LeftSquareOutlined);


/***/ }),
/* 2804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareTwoTone__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LeftSquareTwoTone__["a" /* default */]
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LeftSquareTwoTone));

/***/ }),
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LeftSquareTwoTone = { "name": "left-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 010-12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 000 12.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (LeftSquareTwoTone);


/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeFilled__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LikeFilled = function LikeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeFilled__["a" /* default */]
  }));
};

LikeFilled.displayName = 'LikeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LikeFilled));

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LikeFilled = { "name": "like", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LikeFilled);


/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeOutlined__ = __webpack_require__(2809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LikeOutlined = function LikeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeOutlined__["a" /* default */]
  }));
};

LikeOutlined.displayName = 'LikeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LikeOutlined));

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LikeOutlined = { "name": "like", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LikeOutlined);


/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeTwoTone__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LikeTwoTone = function LikeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LikeTwoTone__["a" /* default */]
  }));
};

LikeTwoTone.displayName = 'LikeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LikeTwoTone));

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LikeTwoTone = { "name": "like", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0033.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0019.6-43c0-19.1-11-37.5-28.8-48.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 00-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 00-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0142.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (LikeTwoTone);


/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineChartOutlined__ = __webpack_require__(2813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LineChartOutlined = function LineChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineChartOutlined__["a" /* default */]
  }));
};

LineChartOutlined.displayName = 'LineChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LineChartOutlined));

/***/ }),
/* 2813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LineChartOutlined = { "name": "line-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 00-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 00-11.3 0L266.3 586.7a8.03 8.03 0 000 11.3l39.5 39.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LineChartOutlined);


/***/ }),
/* 2814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineHeightOutlined__ = __webpack_require__(2815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineHeightOutlined__["a" /* default */]
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LineHeightOutlined));

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LineHeightOutlined = { "name": "line-height", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 00-11.3 0L713.6 306.3a7.23 7.23 0 005.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 00-5.6-11.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LineHeightOutlined);


/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineOutlined__ = __webpack_require__(2817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LineOutlined = function LineOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LineOutlined__["a" /* default */]
  }));
};

LineOutlined.displayName = 'LineOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LineOutlined));

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LineOutlined = { "name": "line", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LineOutlined);


/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkOutlined__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LinkOutlined = function LinkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkOutlined__["a" /* default */]
  }));
};

LinkOutlined.displayName = 'LinkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LinkOutlined));

/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LinkOutlined = { "name": "link", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LinkOutlined);


/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkedinFilled__ = __webpack_require__(2821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LinkedinFilled = function LinkedinFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkedinFilled__["a" /* default */]
  }));
};

LinkedinFilled.displayName = 'LinkedinFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LinkedinFilled));

/***/ }),
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LinkedinFilled = { "name": "linkedin", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LinkedinFilled);


/***/ }),
/* 2822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkedinOutlined__ = __webpack_require__(2823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LinkedinOutlined__["a" /* default */]
  }));
};

LinkedinOutlined.displayName = 'LinkedinOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LinkedinOutlined));

/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LinkedinOutlined = { "name": "linkedin", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 10-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LinkedinOutlined);


/***/ }),
/* 2824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Loading3QuartersOutlined__ = __webpack_require__(2825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_Loading3QuartersOutlined__["a" /* default */]
  }));
};

Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(Loading3QuartersOutlined));

/***/ }),
/* 2825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var Loading3QuartersOutlined = { "name": "loading-3-quarters", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (Loading3QuartersOutlined);


/***/ }),
/* 2826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LoadingOutlined__ = __webpack_require__(2827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LoadingOutlined = function LoadingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LoadingOutlined__["a" /* default */]
  }));
};

LoadingOutlined.displayName = 'LoadingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LoadingOutlined));

/***/ }),
/* 2827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LoadingOutlined = { "name": "loading", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LoadingOutlined);


/***/ }),
/* 2828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockFilled__ = __webpack_require__(2829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LockFilled = function LockFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockFilled__["a" /* default */]
  }));
};

LockFilled.displayName = 'LockFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LockFilled));

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LockFilled = { "name": "lock", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LockFilled);


/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockOutlined__ = __webpack_require__(2831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LockOutlined = function LockOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockOutlined__["a" /* default */]
  }));
};

LockOutlined.displayName = 'LockOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LockOutlined));

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LockOutlined = { "name": "lock", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LockOutlined);


/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockTwoTone__ = __webpack_require__(2833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LockTwoTone = function LockTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LockTwoTone__["a" /* default */]
  }));
};

LockTwoTone.displayName = 'LockTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LockTwoTone));

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LockTwoTone = { "name": "lock", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (LockTwoTone);


/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LoginOutlined__ = __webpack_require__(2835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LoginOutlined = function LoginOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LoginOutlined__["a" /* default */]
  }));
};

LoginOutlined.displayName = 'LoginOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LoginOutlined));

/***/ }),
/* 2835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LoginOutlined = { "name": "login", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LoginOutlined);


/***/ }),
/* 2836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LogoutOutlined__ = __webpack_require__(2837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var LogoutOutlined = function LogoutOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_LogoutOutlined__["a" /* default */]
  }));
};

LogoutOutlined.displayName = 'LogoutOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(LogoutOutlined));

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var LogoutOutlined = { "name": "logout", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (LogoutOutlined);


/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MacCommandFilled__ = __webpack_require__(2839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MacCommandFilled = function MacCommandFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MacCommandFilled__["a" /* default */]
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MacCommandFilled));

/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MacCommandFilled = { "name": "mac-command", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M624 672a48.01 48.01 0 0096 0c0-26.5-21.5-48-48-48h-48v48zm96-320a48.01 48.01 0 00-96 0v48h48c26.5 0 48-21.5 48-48z" } }, { "tag": "path", "attrs": { "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z" } }, { "tag": "path", "attrs": { "d": "M464 464h96v96h-96zM352 304a48.01 48.01 0 000 96h48v-48c0-26.5-21.5-48-48-48zm-48 368a48.01 48.01 0 0096 0v-48h-48c-26.5 0-48 21.5-48 48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MacCommandFilled);


/***/ }),
/* 2840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MacCommandOutlined__ = __webpack_require__(2841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MacCommandOutlined__["a" /* default */]
  }));
};

MacCommandOutlined.displayName = 'MacCommandOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MacCommandOutlined));

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MacCommandOutlined = { "name": "mac-command", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4zm42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4zm197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4zm0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7zm-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MacCommandOutlined);


/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailFilled__ = __webpack_require__(2843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MailFilled = function MailFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailFilled__["a" /* default */]
  }));
};

MailFilled.displayName = 'MailFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MailFilled));

/***/ }),
/* 2843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MailFilled = { "name": "mail", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 01194 256h648.8a7.2 7.2 0 014.4 12.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MailFilled);


/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailOutlined__ = __webpack_require__(2845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MailOutlined = function MailOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailOutlined__["a" /* default */]
  }));
};

MailOutlined.displayName = 'MailOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MailOutlined));

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MailOutlined = { "name": "mail", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MailOutlined);


/***/ }),
/* 2846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailTwoTone__ = __webpack_require__(2847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MailTwoTone = function MailTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MailTwoTone__["a" /* default */]
  }));
};

MailTwoTone.displayName = 'MailTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MailTwoTone));

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MailTwoTone = { "name": "mail", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 01-68.7 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MailTwoTone);


/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ManOutlined__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ManOutlined = function ManOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ManOutlined__["a" /* default */]
  }));
};

ManOutlined.displayName = 'ManOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ManOutlined));

/***/ }),
/* 2849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ManOutlined = { "name": "man", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ManOutlined);


/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxFilled__ = __webpack_require__(2851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxFilled__["a" /* default */]
  }));
};

MedicineBoxFilled.displayName = 'MedicineBoxFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MedicineBoxFilled));

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MedicineBoxFilled = { "name": "medicine-box", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MedicineBoxFilled);


/***/ }),
/* 2852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxOutlined__ = __webpack_require__(2853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxOutlined__["a" /* default */]
  }));
};

MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MedicineBoxOutlined));

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MedicineBoxOutlined = { "name": "medicine-box", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MedicineBoxOutlined);


/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxTwoTone__ = __webpack_require__(2855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MedicineBoxTwoTone__["a" /* default */]
  }));
};

MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MedicineBoxTwoTone));

/***/ }),
/* 2855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MedicineBoxTwoTone = { "name": "medicine-box", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MedicineBoxTwoTone);


/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumCircleFilled__ = __webpack_require__(2857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumCircleFilled__["a" /* default */]
  }));
};

MediumCircleFilled.displayName = 'MediumCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MediumCircleFilled));

/***/ }),
/* 2857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MediumCircleFilled = { "name": "medium-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MediumCircleFilled);


/***/ }),
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumOutlined__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MediumOutlined = function MediumOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumOutlined__["a" /* default */]
  }));
};

MediumOutlined.displayName = 'MediumOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MediumOutlined));

/***/ }),
/* 2859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MediumOutlined = { "name": "medium", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 01-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 016.8-17.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MediumOutlined);


/***/ }),
/* 2860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumSquareFilled__ = __webpack_require__(2861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumSquareFilled__["a" /* default */]
  }));
};

MediumSquareFilled.displayName = 'MediumSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MediumSquareFilled));

/***/ }),
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MediumSquareFilled = { "name": "medium-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MediumSquareFilled);


/***/ }),
/* 2862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumWorkmarkOutlined__ = __webpack_require__(2863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MediumWorkmarkOutlined__["a" /* default */]
  }));
};

MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MediumWorkmarkOutlined));

/***/ }),
/* 2863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MediumWorkmarkOutlined = { "name": "medium-workmark", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 01-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0134.61 21.67v-56.19a6.99 6.99 0 00-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 00-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0019.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 00-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 01-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 00-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0019.35-12.2v-80.85a7.65 7.65 0 00-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 00-21.19 11.64 99.68 99.68 0 012.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 002.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 00-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0144.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 002.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 002.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 002.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 002.96-17.78V457.97A19.71 19.71 0 0024 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 00-2.72 6.8v139.37a6.5 6.5 0 002.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0040.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MediumWorkmarkOutlined);


/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehFilled__ = __webpack_require__(2865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MehFilled = function MehFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehFilled__["a" /* default */]
  }));
};

MehFilled.displayName = 'MehFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MehFilled));

/***/ }),
/* 2865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MehFilled = { "name": "meh", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MehFilled);


/***/ }),
/* 2866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehOutlined__ = __webpack_require__(2867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MehOutlined = function MehOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehOutlined__["a" /* default */]
  }));
};

MehOutlined.displayName = 'MehOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MehOutlined));

/***/ }),
/* 2867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MehOutlined = { "name": "meh", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MehOutlined);


/***/ }),
/* 2868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehTwoTone__ = __webpack_require__(2869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MehTwoTone = function MehTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MehTwoTone__["a" /* default */]
  }));
};

MehTwoTone.displayName = 'MehTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MehTwoTone));

/***/ }),
/* 2869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MehTwoTone = { "name": "meh", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MehTwoTone);


/***/ }),
/* 2870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuFoldOutlined__ = __webpack_require__(2871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuFoldOutlined__["a" /* default */]
  }));
};

MenuFoldOutlined.displayName = 'MenuFoldOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MenuFoldOutlined));

/***/ }),
/* 2871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MenuFoldOutlined = { "name": "menu-fold", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MenuFoldOutlined);


/***/ }),
/* 2872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuOutlined__ = __webpack_require__(2873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MenuOutlined = function MenuOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuOutlined__["a" /* default */]
  }));
};

MenuOutlined.displayName = 'MenuOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MenuOutlined));

/***/ }),
/* 2873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MenuOutlined = { "name": "menu", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MenuOutlined);


/***/ }),
/* 2874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuUnfoldOutlined__ = __webpack_require__(2875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MenuUnfoldOutlined__["a" /* default */]
  }));
};

MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MenuUnfoldOutlined));

/***/ }),
/* 2875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MenuUnfoldOutlined = { "name": "menu-unfold", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MenuUnfoldOutlined);


/***/ }),
/* 2876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MergeCellsOutlined__ = __webpack_require__(2877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MergeCellsOutlined__["a" /* default */]
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MergeCellsOutlined));

/***/ }),
/* 2877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MergeCellsOutlined = { "name": "merge-cells", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MergeCellsOutlined);


/***/ }),
/* 2878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageFilled__ = __webpack_require__(2879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MessageFilled = function MessageFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageFilled__["a" /* default */]
  }));
};

MessageFilled.displayName = 'MessageFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MessageFilled));

/***/ }),
/* 2879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MessageFilled = { "name": "message", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.3 338.4a447.57 447.57 0 00-96.1-143.3 443.09 443.09 0 00-143-96.3A443.91 443.91 0 00512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 00-141.7 96.5 445 445 0 00-95 142.8A449.89 449.89 0 0065 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 00199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 00827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MessageFilled);


/***/ }),
/* 2880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageOutlined__ = __webpack_require__(2881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MessageOutlined = function MessageOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageOutlined__["a" /* default */]
  }));
};

MessageOutlined.displayName = 'MessageOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MessageOutlined));

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MessageOutlined = { "name": "message", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MessageOutlined);


/***/ }),
/* 2882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageTwoTone__ = __webpack_require__(2883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MessageTwoTone = function MessageTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MessageTwoTone__["a" /* default */]
  }));
};

MessageTwoTone.displayName = 'MessageTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MessageTwoTone));

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MessageTwoTone = { "name": "message", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M775.3 248.9a369.62 369.62 0 00-119-80A370.2 370.2 0 00512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 00-80-119zM312 560a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M664 512a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MessageTwoTone);


/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleFilled__ = __webpack_require__(2885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleFilled__["a" /* default */]
  }));
};

MinusCircleFilled.displayName = 'MinusCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusCircleFilled));

/***/ }),
/* 2885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusCircleFilled = { "name": "minus-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MinusCircleFilled);


/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleOutlined__ = __webpack_require__(2887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleOutlined__["a" /* default */]
  }));
};

MinusCircleOutlined.displayName = 'MinusCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusCircleOutlined));

/***/ }),
/* 2887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusCircleOutlined = { "name": "minus-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MinusCircleOutlined);


/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleTwoTone__ = __webpack_require__(2889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusCircleTwoTone__["a" /* default */]
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusCircleTwoTone));

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusCircleTwoTone = { "name": "minus-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MinusCircleTwoTone);


/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusOutlined__ = __webpack_require__(2891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusOutlined = function MinusOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusOutlined__["a" /* default */]
  }));
};

MinusOutlined.displayName = 'MinusOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusOutlined));

/***/ }),
/* 2891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusOutlined = { "name": "minus", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MinusOutlined);


/***/ }),
/* 2892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareFilled__ = __webpack_require__(2893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareFilled__["a" /* default */]
  }));
};

MinusSquareFilled.displayName = 'MinusSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusSquareFilled));

/***/ }),
/* 2893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusSquareFilled = { "name": "minus-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MinusSquareFilled);


/***/ }),
/* 2894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareOutlined__ = __webpack_require__(2895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareOutlined__["a" /* default */]
  }));
};

MinusSquareOutlined.displayName = 'MinusSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusSquareOutlined));

/***/ }),
/* 2895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusSquareOutlined = { "name": "minus-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MinusSquareOutlined);


/***/ }),
/* 2896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareTwoTone__ = __webpack_require__(2897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MinusSquareTwoTone__["a" /* default */]
  }));
};

MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MinusSquareTwoTone));

/***/ }),
/* 2897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MinusSquareTwoTone = { "name": "minus-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MinusSquareTwoTone);


/***/ }),
/* 2898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileFilled__ = __webpack_require__(2899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MobileFilled = function MobileFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileFilled__["a" /* default */]
  }));
};

MobileFilled.displayName = 'MobileFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MobileFilled));

/***/ }),
/* 2899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MobileFilled = { "name": "mobile", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MobileFilled);


/***/ }),
/* 2900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileOutlined__ = __webpack_require__(2901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MobileOutlined = function MobileOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileOutlined__["a" /* default */]
  }));
};

MobileOutlined.displayName = 'MobileOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MobileOutlined));

/***/ }),
/* 2901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MobileOutlined = { "name": "mobile", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MobileOutlined);


/***/ }),
/* 2902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileTwoTone__ = __webpack_require__(2903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MobileTwoTone = function MobileTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MobileTwoTone__["a" /* default */]
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MobileTwoTone));

/***/ }),
/* 2903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MobileTwoTone = { "name": "mobile", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 786a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MobileTwoTone);


/***/ }),
/* 2904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectFilled__ = __webpack_require__(2905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectFilled__["a" /* default */]
  }));
};

MoneyCollectFilled.displayName = 'MoneyCollectFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MoneyCollectFilled));

/***/ }),
/* 2905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MoneyCollectFilled = { "name": "money-collect", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 699.7a8 8 0 00-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MoneyCollectFilled);


/***/ }),
/* 2906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectOutlined__ = __webpack_require__(2907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectOutlined__["a" /* default */]
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MoneyCollectOutlined));

/***/ }),
/* 2907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MoneyCollectOutlined = { "name": "money-collect", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MoneyCollectOutlined);


/***/ }),
/* 2908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectTwoTone__ = __webpack_require__(2909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoneyCollectTwoTone__["a" /* default */]
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MoneyCollectTwoTone));

/***/ }),
/* 2909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MoneyCollectTwoTone = { "name": "money-collect", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (MoneyCollectTwoTone);


/***/ }),
/* 2910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MonitorOutlined__ = __webpack_require__(2911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MonitorOutlined = function MonitorOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MonitorOutlined__["a" /* default */]
  }));
};

MonitorOutlined.displayName = 'MonitorOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MonitorOutlined));

/***/ }),
/* 2911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MonitorOutlined = { "name": "monitor", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 00-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 00-11.2-1.4l-37.9 29.7a7.97 7.97 0 00-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MonitorOutlined);


/***/ }),
/* 2912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoreOutlined__ = __webpack_require__(2913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var MoreOutlined = function MoreOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_MoreOutlined__["a" /* default */]
  }));
};

MoreOutlined.displayName = 'MoreOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(MoreOutlined));

/***/ }),
/* 2913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var MoreOutlined = { "name": "more", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (MoreOutlined);


/***/ }),
/* 2914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeCollapseOutlined__ = __webpack_require__(2915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeCollapseOutlined__["a" /* default */]
  }));
};

NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NodeCollapseOutlined));

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NodeCollapseOutlined = { "name": "node-collapse", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3a9.9 9.9 0 000 15.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NodeCollapseOutlined);


/***/ }),
/* 2916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeExpandOutlined__ = __webpack_require__(2917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeExpandOutlined__["a" /* default */]
  }));
};

NodeExpandOutlined.displayName = 'NodeExpandOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NodeExpandOutlined));

/***/ }),
/* 2917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NodeExpandOutlined = { "name": "node-expand", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NodeExpandOutlined);


/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeIndexOutlined__ = __webpack_require__(2919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NodeIndexOutlined__["a" /* default */]
  }));
};

NodeIndexOutlined.displayName = 'NodeIndexOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NodeIndexOutlined));

/***/ }),
/* 2919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NodeIndexOutlined = { "name": "node-index", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7.2 3.5.3 5.2.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-.8-6.6-1.5-7.8-1.8l-3.1-.6c-2.2-.3-5.9-.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2a83.3 83.3 0 11.01-166.61 83.3 83.3 0 01-.01 166.61zM695.6 845a83.3 83.3 0 11.01-166.61A83.3 83.3 0 01695.6 845z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NodeIndexOutlined);


/***/ }),
/* 2920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationFilled__ = __webpack_require__(2921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NotificationFilled = function NotificationFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationFilled__["a" /* default */]
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NotificationFilled));

/***/ }),
/* 2921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NotificationFilled = { "name": "notification", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NotificationFilled);


/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationOutlined__ = __webpack_require__(2923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NotificationOutlined = function NotificationOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationOutlined__["a" /* default */]
  }));
};

NotificationOutlined.displayName = 'NotificationOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NotificationOutlined));

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NotificationOutlined = { "name": "notification", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NotificationOutlined);


/***/ }),
/* 2924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationTwoTone__ = __webpack_require__(2925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NotificationTwoTone__["a" /* default */]
  }));
};

NotificationTwoTone.displayName = 'NotificationTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NotificationTwoTone));

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NotificationTwoTone = { "name": "notification", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (NotificationTwoTone);


/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NumberOutlined__ = __webpack_require__(2927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var NumberOutlined = function NumberOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_NumberOutlined__["a" /* default */]
  }));
};

NumberOutlined.displayName = 'NumberOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(NumberOutlined));

/***/ }),
/* 2927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var NumberOutlined = { "name": "number", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (NumberOutlined);


/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_OneToOneOutlined__ = __webpack_require__(2929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_OneToOneOutlined__["a" /* default */]
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(OneToOneOutlined));

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var OneToOneOutlined = { "name": "one-to-one", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zm196-50c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zm0-140c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (OneToOneOutlined);


/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_OrderedListOutlined__ = __webpack_require__(2931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_OrderedListOutlined__["a" /* default */]
  }));
};

OrderedListOutlined.displayName = 'OrderedListOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(OrderedListOutlined));

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var OrderedListOutlined = { "name": "ordered-list", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 00-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 002.1-5.4V432c0-2.2-1.8-4-4-4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (OrderedListOutlined);


/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PaperClipOutlined__ = __webpack_require__(2933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PaperClipOutlined__["a" /* default */]
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PaperClipOutlined));

/***/ }),
/* 2933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PaperClipOutlined = { "name": "paper-clip", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PaperClipOutlined);


/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PartitionOutlined__ = __webpack_require__(2935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PartitionOutlined = function PartitionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PartitionOutlined__["a" /* default */]
  }));
};

PartitionOutlined.displayName = 'PartitionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PartitionOutlined));

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PartitionOutlined = { "name": "partition", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3zm53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150zm364.2 75.1h150v150.1h-150V662.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PartitionOutlined);


/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleFilled__ = __webpack_require__(2937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleFilled__["a" /* default */]
  }));
};

PauseCircleFilled.displayName = 'PauseCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PauseCircleFilled));

/***/ }),
/* 2937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PauseCircleFilled = { "name": "pause-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PauseCircleFilled);


/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleOutlined__ = __webpack_require__(2939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleOutlined__["a" /* default */]
  }));
};

PauseCircleOutlined.displayName = 'PauseCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PauseCircleOutlined));

/***/ }),
/* 2939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PauseCircleOutlined = { "name": "pause-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PauseCircleOutlined);


/***/ }),
/* 2940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleTwoTone__ = __webpack_require__(2941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseCircleTwoTone__["a" /* default */]
  }));
};

PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PauseCircleTwoTone));

/***/ }),
/* 2941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PauseCircleTwoTone = { "name": "pause-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PauseCircleTwoTone);


/***/ }),
/* 2942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseOutlined__ = __webpack_require__(2943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PauseOutlined = function PauseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PauseOutlined__["a" /* default */]
  }));
};

PauseOutlined.displayName = 'PauseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PauseOutlined));

/***/ }),
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PauseOutlined = { "name": "pause", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PauseOutlined);


/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PayCircleFilled__ = __webpack_require__(2945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PayCircleFilled = function PayCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PayCircleFilled__["a" /* default */]
  }));
};

PayCircleFilled.displayName = 'PayCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PayCircleFilled));

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PayCircleFilled = { "name": "pay-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 017-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 017.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PayCircleFilled);


/***/ }),
/* 2946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PayCircleOutlined__ = __webpack_require__(2947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PayCircleOutlined__["a" /* default */]
  }));
};

PayCircleOutlined.displayName = 'PayCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PayCircleOutlined));

/***/ }),
/* 2947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PayCircleOutlined = { "name": "pay-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 00-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PayCircleOutlined);


/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PercentageOutlined__ = __webpack_require__(2949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PercentageOutlined = function PercentageOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PercentageOutlined__["a" /* default */]
  }));
};

PercentageOutlined.displayName = 'PercentageOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PercentageOutlined));

/***/ }),
/* 2949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PercentageOutlined = { "name": "percentage", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 00-11.3 0L168.3 801.9a8.03 8.03 0 000 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PercentageOutlined);


/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneFilled__ = __webpack_require__(2951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PhoneFilled = function PhoneFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneFilled__["a" /* default */]
  }));
};

PhoneFilled.displayName = 'PhoneFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PhoneFilled));

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PhoneFilled = { "name": "phone", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 00-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 01553.1 553 395.34 395.34 0 01437 633.8L353.2 550a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 00-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PhoneFilled);


/***/ }),
/* 2952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneOutlined__ = __webpack_require__(2953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PhoneOutlined = function PhoneOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneOutlined__["a" /* default */]
  }));
};

PhoneOutlined.displayName = 'PhoneOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PhoneOutlined));

/***/ }),
/* 2953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PhoneOutlined = { "name": "phone", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PhoneOutlined);


/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneTwoTone__ = __webpack_require__(2955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PhoneTwoTone__["a" /* default */]
  }));
};

PhoneTwoTone.displayName = 'PhoneTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PhoneTwoTone));

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PhoneTwoTone = { "name": "phone", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 01438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PhoneTwoTone);


/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicCenterOutlined__ = __webpack_require__(2957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicCenterOutlined__["a" /* default */]
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PicCenterOutlined));

/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PicCenterOutlined = { "name": "pic-center", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PicCenterOutlined);


/***/ }),
/* 2958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicLeftOutlined__ = __webpack_require__(2959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicLeftOutlined__["a" /* default */]
  }));
};

PicLeftOutlined.displayName = 'PicLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PicLeftOutlined));

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PicLeftOutlined = { "name": "pic-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PicLeftOutlined);


/***/ }),
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicRightOutlined__ = __webpack_require__(2961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PicRightOutlined = function PicRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PicRightOutlined__["a" /* default */]
  }));
};

PicRightOutlined.displayName = 'PicRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PicRightOutlined));

/***/ }),
/* 2961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PicRightOutlined = { "name": "pic-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PicRightOutlined);


/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureFilled__ = __webpack_require__(2963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PictureFilled = function PictureFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureFilled__["a" /* default */]
  }));
};

PictureFilled.displayName = 'PictureFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PictureFilled));

/***/ }),
/* 2963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PictureFilled = { "name": "picture", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 01-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PictureFilled);


/***/ }),
/* 2964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureOutlined__ = __webpack_require__(2965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PictureOutlined = function PictureOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureOutlined__["a" /* default */]
  }));
};

PictureOutlined.displayName = 'PictureOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PictureOutlined));

/***/ }),
/* 2965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PictureOutlined = { "name": "picture", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PictureOutlined);


/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureTwoTone__ = __webpack_require__(2967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PictureTwoTone = function PictureTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PictureTwoTone__["a" /* default */]
  }));
};

PictureTwoTone.displayName = 'PictureTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PictureTwoTone));

/***/ }),
/* 2967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PictureTwoTone = { "name": "picture", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PictureTwoTone);


/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartFilled__ = __webpack_require__(2969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PieChartFilled = function PieChartFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartFilled__["a" /* default */]
  }));
};

PieChartFilled.displayName = 'PieChartFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PieChartFilled));

/***/ }),
/* 2969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PieChartFilled = { "name": "pie-chart", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 00-282.5 117 397.47 397.47 0 00-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 00155.6 31.5 398.57 398.57 0 00282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0031.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 00588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PieChartFilled);


/***/ }),
/* 2970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartOutlined__ = __webpack_require__(2971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PieChartOutlined = function PieChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartOutlined__["a" /* default */]
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PieChartOutlined));

/***/ }),
/* 2971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PieChartOutlined = { "name": "pie-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552a398.46 398.46 0 00117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952a398.46 398.46 0 00282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PieChartOutlined);


/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartTwoTone__ = __webpack_require__(2973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PieChartTwoTone__["a" /* default */]
  }));
};

PieChartTwoTone.displayName = 'PieChartTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PieChartTwoTone));

/***/ }),
/* 2973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PieChartTwoTone = { "name": "pie-chart", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 01-85.7-127.1A397.12 397.12 0 0172 552.2v.2a398.57 398.57 0 00117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 00471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 00-166.4-89.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 00-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 004.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PieChartTwoTone);


/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleFilled__ = __webpack_require__(2975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleFilled__["a" /* default */]
  }));
};

PlayCircleFilled.displayName = 'PlayCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlayCircleFilled));

/***/ }),
/* 2975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlayCircleFilled = { "name": "play-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlayCircleFilled);


/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleOutlined__ = __webpack_require__(2977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleOutlined__["a" /* default */]
  }));
};

PlayCircleOutlined.displayName = 'PlayCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlayCircleOutlined));

/***/ }),
/* 2977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlayCircleOutlined = { "name": "play-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlayCircleOutlined);


/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleTwoTone__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlayCircleTwoTone__["a" /* default */]
  }));
};

PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlayCircleTwoTone));

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlayCircleTwoTone = { "name": "play-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PlayCircleTwoTone);


/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareFilled__ = __webpack_require__(2981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareFilled__["a" /* default */]
  }));
};

PlaySquareFilled.displayName = 'PlaySquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlaySquareFilled));

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlaySquareFilled = { "name": "play-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlaySquareFilled);


/***/ }),
/* 2982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareOutlined__ = __webpack_require__(2983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareOutlined__["a" /* default */]
  }));
};

PlaySquareOutlined.displayName = 'PlaySquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlaySquareOutlined));

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlaySquareOutlined = { "name": "play-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlaySquareOutlined);


/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareTwoTone__ = __webpack_require__(2985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlaySquareTwoTone__["a" /* default */]
  }));
};

PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlaySquareTwoTone));

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlaySquareTwoTone = { "name": "play-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 000-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PlaySquareTwoTone);


/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleFilled__ = __webpack_require__(2987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleFilled__["a" /* default */]
  }));
};

PlusCircleFilled.displayName = 'PlusCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusCircleFilled));

/***/ }),
/* 2987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusCircleFilled = { "name": "plus-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlusCircleFilled);


/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleOutlined__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleOutlined__["a" /* default */]
  }));
};

PlusCircleOutlined.displayName = 'PlusCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusCircleOutlined));

/***/ }),
/* 2989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusCircleOutlined = { "name": "plus-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlusCircleOutlined);


/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleTwoTone__ = __webpack_require__(2991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusCircleTwoTone__["a" /* default */]
  }));
};

PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusCircleTwoTone));

/***/ }),
/* 2991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusCircleTwoTone = { "name": "plus-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PlusCircleTwoTone);


/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusOutlined__ = __webpack_require__(2993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusOutlined = function PlusOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusOutlined__["a" /* default */]
  }));
};

PlusOutlined.displayName = 'PlusOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusOutlined));

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusOutlined = { "name": "plus", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlusOutlined);


/***/ }),
/* 2994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareFilled__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusSquareFilled = function PlusSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareFilled__["a" /* default */]
  }));
};

PlusSquareFilled.displayName = 'PlusSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusSquareFilled));

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusSquareFilled = { "name": "plus-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlusSquareFilled);


/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareOutlined__ = __webpack_require__(2997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareOutlined__["a" /* default */]
  }));
};

PlusSquareOutlined.displayName = 'PlusSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusSquareOutlined));

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusSquareOutlined = { "name": "plus-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PlusSquareOutlined);


/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareTwoTone__ = __webpack_require__(2999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PlusSquareTwoTone__["a" /* default */]
  }));
};

PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PlusSquareTwoTone));

/***/ }),
/* 2999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PlusSquareTwoTone = { "name": "plus-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PlusSquareTwoTone);


/***/ }),
/* 3000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleFilled__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleFilled__["a" /* default */]
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PoundCircleFilled));

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PoundCircleFilled = { "name": "pound-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PoundCircleFilled);


/***/ }),
/* 3002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleOutlined__ = __webpack_require__(3003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleOutlined__["a" /* default */]
  }));
};

PoundCircleOutlined.displayName = 'PoundCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PoundCircleOutlined));

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PoundCircleOutlined = { "name": "pound-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PoundCircleOutlined);


/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleTwoTone__ = __webpack_require__(3005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundCircleTwoTone__["a" /* default */]
  }));
};

PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PoundCircleTwoTone));

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PoundCircleTwoTone = { "name": "pound-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0010.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PoundCircleTwoTone);


/***/ }),
/* 3006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundOutlined__ = __webpack_require__(3007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PoundOutlined = function PoundOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoundOutlined__["a" /* default */]
  }));
};

PoundOutlined.displayName = 'PoundOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PoundOutlined));

/***/ }),
/* 3007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PoundOutlined = { "name": "pound", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PoundOutlined);


/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoweroffOutlined__ = __webpack_require__(3009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PoweroffOutlined__["a" /* default */]
  }));
};

PoweroffOutlined.displayName = 'PoweroffOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PoweroffOutlined));

/***/ }),
/* 3009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PoweroffOutlined = { "name": "poweroff", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M705.6 124.9a8 8 0 00-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0162.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0127.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 01-76.3 113.3 353.06 353.06 0 01-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 01-113.2-76.4A355.92 355.92 0 01184 650.4a355 355 0 01-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PoweroffOutlined);


/***/ }),
/* 3010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterFilled__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PrinterFilled = function PrinterFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterFilled__["a" /* default */]
  }));
};

PrinterFilled.displayName = 'PrinterFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PrinterFilled));

/***/ }),
/* 3011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PrinterFilled = { "name": "printer", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PrinterFilled);


/***/ }),
/* 3012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterOutlined__ = __webpack_require__(3013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PrinterOutlined = function PrinterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterOutlined__["a" /* default */]
  }));
};

PrinterOutlined.displayName = 'PrinterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PrinterOutlined));

/***/ }),
/* 3013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PrinterOutlined = { "name": "printer", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PrinterOutlined);


/***/ }),
/* 3014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterTwoTone__ = __webpack_require__(3015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PrinterTwoTone__["a" /* default */]
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PrinterTwoTone));

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PrinterTwoTone = { "name": "printer", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PrinterTwoTone);


/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileFilled__ = __webpack_require__(3017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProfileFilled = function ProfileFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileFilled__["a" /* default */]
  }));
};

ProfileFilled.displayName = 'ProfileFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProfileFilled));

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProfileFilled = { "name": "profile", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ProfileFilled);


/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileOutlined__ = __webpack_require__(3019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProfileOutlined = function ProfileOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileOutlined__["a" /* default */]
  }));
};

ProfileOutlined.displayName = 'ProfileOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProfileOutlined));

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProfileOutlined = { "name": "profile", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ProfileOutlined);


/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileTwoTone__ = __webpack_require__(3021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProfileTwoTone__["a" /* default */]
  }));
};

ProfileTwoTone.displayName = 'ProfileTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProfileTwoTone));

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProfileTwoTone = { "name": "profile", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 656a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ProfileTwoTone);


/***/ }),
/* 3022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectFilled__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProjectFilled = function ProjectFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectFilled__["a" /* default */]
  }));
};

ProjectFilled.displayName = 'ProjectFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProjectFilled));

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProjectFilled = { "name": "project", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ProjectFilled);


/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectOutlined__ = __webpack_require__(3025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProjectOutlined = function ProjectOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectOutlined__["a" /* default */]
  }));
};

ProjectOutlined.displayName = 'ProjectOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProjectOutlined));

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProjectOutlined = { "name": "project", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ProjectOutlined);


/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectTwoTone__ = __webpack_require__(3027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ProjectTwoTone__["a" /* default */]
  }));
};

ProjectTwoTone.displayName = 'ProjectTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ProjectTwoTone));

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ProjectTwoTone = { "name": "project", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ProjectTwoTone);


/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyFilled__ = __webpack_require__(3029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PropertySafetyFilled = function PropertySafetyFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyFilled__["a" /* default */]
  }));
};

PropertySafetyFilled.displayName = 'PropertySafetyFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PropertySafetyFilled));

/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PropertySafetyFilled = { "name": "property-safety", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PropertySafetyFilled);


/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyOutlined__ = __webpack_require__(3031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyOutlined__["a" /* default */]
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PropertySafetyOutlined));

/***/ }),
/* 3031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PropertySafetyOutlined = { "name": "property-safety", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 00-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 00-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PropertySafetyOutlined);


/***/ }),
/* 3032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyTwoTone__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PropertySafetyTwoTone__["a" /* default */]
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PropertySafetyTwoTone));

/***/ }),
/* 3033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PropertySafetyTwoTone = { "name": "property-safety", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 018.9-5.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438.9 323.5a9.88 9.88 0 00-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 00-8.9 5.5l-73.2 144.3-72.9-144.3z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PropertySafetyTwoTone);


/***/ }),
/* 3034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PullRequestOutlined__ = __webpack_require__(3035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PullRequestOutlined__["a" /* default */]
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PullRequestOutlined));

/***/ }),
/* 3035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PullRequestOutlined = { "name": "pull-request", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 010-96 48.01 48.01 0 010 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PullRequestOutlined);


/***/ }),
/* 3036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinFilled__ = __webpack_require__(3037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PushpinFilled = function PushpinFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinFilled__["a" /* default */]
  }));
};

PushpinFilled.displayName = 'PushpinFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PushpinFilled));

/***/ }),
/* 3037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PushpinFilled = { "name": "pushpin", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PushpinFilled);


/***/ }),
/* 3038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinOutlined__ = __webpack_require__(3039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PushpinOutlined = function PushpinOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinOutlined__["a" /* default */]
  }));
};

PushpinOutlined.displayName = 'PushpinOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PushpinOutlined));

/***/ }),
/* 3039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PushpinOutlined = { "name": "pushpin", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (PushpinOutlined);


/***/ }),
/* 3040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinTwoTone__ = __webpack_require__(3041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_PushpinTwoTone__["a" /* default */]
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PushpinTwoTone));

/***/ }),
/* 3041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var PushpinTwoTone = { "name": "pushpin", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0030.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (PushpinTwoTone);


/***/ }),
/* 3042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqCircleFilled__ = __webpack_require__(3043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QqCircleFilled = function QqCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqCircleFilled__["a" /* default */]
  }));
};

QqCircleFilled.displayName = 'QqCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QqCircleFilled));

/***/ }),
/* 3043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QqCircleFilled = { "name": "qq-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QqCircleFilled);


/***/ }),
/* 3044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqOutlined__ = __webpack_require__(3045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QqOutlined = function QqOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqOutlined__["a" /* default */]
  }));
};

QqOutlined.displayName = 'QqOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QqOutlined));

/***/ }),
/* 3045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QqOutlined = { "name": "qq", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QqOutlined);


/***/ }),
/* 3046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqSquareFilled__ = __webpack_require__(3047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QqSquareFilled = function QqSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QqSquareFilled__["a" /* default */]
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QqSquareFilled));

/***/ }),
/* 3047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QqSquareFilled = { "name": "qq-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QqSquareFilled);


/***/ }),
/* 3048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QrcodeOutlined__ = __webpack_require__(3049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QrcodeOutlined__["a" /* default */]
  }));
};

QrcodeOutlined.displayName = 'QrcodeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QrcodeOutlined));

/***/ }),
/* 3049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QrcodeOutlined = { "name": "qrcode", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QrcodeOutlined);


/***/ }),
/* 3050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleFilled__ = __webpack_require__(3051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleFilled__["a" /* default */]
  }));
};

QuestionCircleFilled.displayName = 'QuestionCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QuestionCircleFilled));

/***/ }),
/* 3051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QuestionCircleFilled = { "name": "question-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QuestionCircleFilled);


/***/ }),
/* 3052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleOutlined__ = __webpack_require__(3053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleOutlined__["a" /* default */]
  }));
};

QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QuestionCircleOutlined));

/***/ }),
/* 3053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QuestionCircleOutlined = { "name": "question-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QuestionCircleOutlined);


/***/ }),
/* 3054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleTwoTone__ = __webpack_require__(3055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QuestionCircleTwoTone = function QuestionCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionCircleTwoTone__["a" /* default */]
  }));
};

QuestionCircleTwoTone.displayName = 'QuestionCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QuestionCircleTwoTone));

/***/ }),
/* 3055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QuestionCircleTwoTone = { "name": "question-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 732a40 40 0 1080 0 40 40 0 10-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (QuestionCircleTwoTone);


/***/ }),
/* 3056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionOutlined__ = __webpack_require__(3057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var QuestionOutlined = function QuestionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_QuestionOutlined__["a" /* default */]
  }));
};

QuestionOutlined.displayName = 'QuestionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(QuestionOutlined));

/***/ }),
/* 3057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var QuestionOutlined = { "name": "question", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 00-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (QuestionOutlined);


/***/ }),
/* 3058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadarChartOutlined__ = __webpack_require__(3059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadarChartOutlined__["a" /* default */]
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadarChartOutlined));

/***/ }),
/* 3059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadarChartOutlined = { "name": "radar-chart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926.8 397.1l-396-288a31.81 31.81 0 00-37.6 0l-396 288a31.99 31.99 0 00-11.6 35.8l151.3 466a32 32 0 0030.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadarChartOutlined);


/***/ }),
/* 3060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusBottomleftOutlined__ = __webpack_require__(3061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusBottomleftOutlined__["a" /* default */]
  }));
};

RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadiusBottomleftOutlined));

/***/ }),
/* 3061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadiusBottomleftOutlined = { "name": "radius-bottomleft", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadiusBottomleftOutlined);


/***/ }),
/* 3062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusBottomrightOutlined__ = __webpack_require__(3063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusBottomrightOutlined__["a" /* default */]
  }));
};

RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadiusBottomrightOutlined));

/***/ }),
/* 3063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadiusBottomrightOutlined = { "name": "radius-bottomright", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadiusBottomrightOutlined);


/***/ }),
/* 3064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusSettingOutlined__ = __webpack_require__(3065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusSettingOutlined__["a" /* default */]
  }));
};

RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadiusSettingOutlined));

/***/ }),
/* 3065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadiusSettingOutlined = { "name": "radius-setting", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadiusSettingOutlined);


/***/ }),
/* 3066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusUpleftOutlined__ = __webpack_require__(3067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusUpleftOutlined__["a" /* default */]
  }));
};

RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadiusUpleftOutlined));

/***/ }),
/* 3067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadiusUpleftOutlined = { "name": "radius-upleft", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadiusUpleftOutlined);


/***/ }),
/* 3068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusUprightOutlined__ = __webpack_require__(3069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RadiusUprightOutlined__["a" /* default */]
  }));
};

RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RadiusUprightOutlined));

/***/ }),
/* 3069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RadiusUprightOutlined = { "name": "radius-upright", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RadiusUprightOutlined);


/***/ }),
/* 3070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReadFilled__ = __webpack_require__(3071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReadFilled = function ReadFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReadFilled__["a" /* default */]
  }));
};

ReadFilled.displayName = 'ReadFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReadFilled));

/***/ }),
/* 3071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReadFilled = { "name": "read", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ReadFilled);


/***/ }),
/* 3072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReadOutlined__ = __webpack_require__(3073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReadOutlined = function ReadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReadOutlined__["a" /* default */]
  }));
};

ReadOutlined.displayName = 'ReadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReadOutlined));

/***/ }),
/* 3073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReadOutlined = { "name": "read", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ReadOutlined);


/***/ }),
/* 3074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationFilled__ = __webpack_require__(3075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationFilled__["a" /* default */]
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReconciliationFilled));

/***/ }),
/* 3075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReconciliationFilled = { "name": "reconciliation", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ReconciliationFilled);


/***/ }),
/* 3076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationOutlined__ = __webpack_require__(3077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationOutlined__["a" /* default */]
  }));
};

ReconciliationOutlined.displayName = 'ReconciliationOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReconciliationOutlined));

/***/ }),
/* 3077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReconciliationOutlined = { "name": "reconciliation", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ReconciliationOutlined);


/***/ }),
/* 3078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationTwoTone__ = __webpack_require__(3079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReconciliationTwoTone__["a" /* default */]
  }));
};

ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReconciliationTwoTone));

/***/ }),
/* 3079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReconciliationTwoTone = { "name": "reconciliation", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M642 657a34 34 0 1068 0 34 34 0 10-68 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ReconciliationTwoTone);


/***/ }),
/* 3080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeFilled__ = __webpack_require__(3081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeFilled__["a" /* default */]
  }));
};

RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedEnvelopeFilled));

/***/ }),
/* 3081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedEnvelopeFilled = { "name": "red-envelope", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 017.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedEnvelopeFilled);


/***/ }),
/* 3082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeOutlined__ = __webpack_require__(3083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeOutlined__["a" /* default */]
  }));
};

RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedEnvelopeOutlined));

/***/ }),
/* 3083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedEnvelopeOutlined = { "name": "red-envelope", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedEnvelopeOutlined);


/***/ }),
/* 3084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeTwoTone__ = __webpack_require__(3085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedEnvelopeTwoTone__["a" /* default */]
  }));
};

RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedEnvelopeTwoTone));

/***/ }),
/* 3085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedEnvelopeTwoTone = { "name": "red-envelope", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 01-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 017.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 013.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 017.5-4.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (RedEnvelopeTwoTone);


/***/ }),
/* 3086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditCircleFilled__ = __webpack_require__(3087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditCircleFilled__["a" /* default */]
  }));
};

RedditCircleFilled.displayName = 'RedditCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedditCircleFilled));

/***/ }),
/* 3087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedditCircleFilled = { "name": "reddit-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm72 108a36 36 0 1072 0 36 36 0 10-72 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedditCircleFilled);


/***/ }),
/* 3088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditOutlined__ = __webpack_require__(3089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedditOutlined = function RedditOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditOutlined__["a" /* default */]
  }));
};

RedditOutlined.displayName = 'RedditOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedditOutlined));

/***/ }),
/* 3089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedditOutlined = { "name": "reddit", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 568a56 56 0 10112 0 56 56 0 10-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 10-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 00-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 00176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 110 63 31.5 31.5 0 010-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0150.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 01-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedditOutlined);


/***/ }),
/* 3090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditSquareFilled__ = __webpack_require__(3091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedditSquareFilled__["a" /* default */]
  }));
};

RedditSquareFilled.displayName = 'RedditSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedditSquareFilled));

/***/ }),
/* 3091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedditSquareFilled = { "name": "reddit-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM368 548a36 36 0 1072 0 36 36 0 10-72 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedditSquareFilled);


/***/ }),
/* 3092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedoOutlined__ = __webpack_require__(3093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RedoOutlined = function RedoOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RedoOutlined__["a" /* default */]
  }));
};

RedoOutlined.displayName = 'RedoOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RedoOutlined));

/***/ }),
/* 3093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RedoOutlined = { "name": "redo", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RedoOutlined);


/***/ }),
/* 3094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReloadOutlined__ = __webpack_require__(3095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ReloadOutlined = function ReloadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ReloadOutlined__["a" /* default */]
  }));
};

ReloadOutlined.displayName = 'ReloadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ReloadOutlined));

/***/ }),
/* 3095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ReloadOutlined = { "name": "reload", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ReloadOutlined);


/***/ }),
/* 3096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestFilled__ = __webpack_require__(3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RestFilled = function RestFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestFilled__["a" /* default */]
  }));
};

RestFilled.displayName = 'RestFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RestFilled));

/***/ }),
/* 3097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RestFilled = { "name": "rest", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 10160 0 80 80 0 10-160 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RestFilled);


/***/ }),
/* 3098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestOutlined__ = __webpack_require__(3099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RestOutlined = function RestOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestOutlined__["a" /* default */]
  }));
};

RestOutlined.displayName = 'RestOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RestOutlined));

/***/ }),
/* 3099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RestOutlined = { "name": "rest", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RestOutlined);


/***/ }),
/* 3100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestTwoTone__ = __webpack_require__(3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RestTwoTone = function RestTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RestTwoTone__["a" /* default */]
  }));
};

RestTwoTone.displayName = 'RestTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RestTwoTone));

/***/ }),
/* 3101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RestTwoTone = { "name": "rest", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (RestTwoTone);


/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RetweetOutlined__ = __webpack_require__(3103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RetweetOutlined = function RetweetOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RetweetOutlined__["a" /* default */]
  }));
};

RetweetOutlined.displayName = 'RetweetOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RetweetOutlined));

/***/ }),
/* 3103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RetweetOutlined = { "name": "retweet", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0011.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 00-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 00-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RetweetOutlined);


/***/ }),
/* 3104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleFilled__ = __webpack_require__(3105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightCircleFilled = function RightCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleFilled__["a" /* default */]
  }));
};

RightCircleFilled.displayName = 'RightCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightCircleFilled));

/***/ }),
/* 3105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightCircleFilled = { "name": "right-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RightCircleFilled);


/***/ }),
/* 3106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleOutlined__ = __webpack_require__(3107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleOutlined__["a" /* default */]
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightCircleOutlined));

/***/ }),
/* 3107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightCircleOutlined = { "name": "right-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178A8 8 0 00408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RightCircleOutlined);


/***/ }),
/* 3108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleTwoTone__ = __webpack_require__(3109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightCircleTwoTone__["a" /* default */]
  }));
};

RightCircleTwoTone.displayName = 'RightCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightCircleTwoTone));

/***/ }),
/* 3109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightCircleTwoTone = { "name": "right-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (RightCircleTwoTone);


/***/ }),
/* 3110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightOutlined__ = __webpack_require__(3111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightOutlined = function RightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightOutlined__["a" /* default */]
  }));
};

RightOutlined.displayName = 'RightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightOutlined));

/***/ }),
/* 3111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightOutlined = { "name": "right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RightOutlined);


/***/ }),
/* 3112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareFilled__ = __webpack_require__(3113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightSquareFilled = function RightSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareFilled__["a" /* default */]
  }));
};

RightSquareFilled.displayName = 'RightSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightSquareFilled));

/***/ }),
/* 3113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightSquareFilled = { "name": "right-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RightSquareFilled);


/***/ }),
/* 3114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareOutlined__ = __webpack_require__(3115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareOutlined__["a" /* default */]
  }));
};

RightSquareOutlined.displayName = 'RightSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightSquareOutlined));

/***/ }),
/* 3115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightSquareOutlined = { "name": "right-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RightSquareOutlined);


/***/ }),
/* 3116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareTwoTone__ = __webpack_require__(3117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RightSquareTwoTone__["a" /* default */]
  }));
};

RightSquareTwoTone.displayName = 'RightSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RightSquareTwoTone));

/***/ }),
/* 3117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RightSquareTwoTone = { "name": "right-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (RightSquareTwoTone);


/***/ }),
/* 3118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RiseOutlined__ = __webpack_require__(3119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RiseOutlined = function RiseOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RiseOutlined__["a" /* default */]
  }));
};

RiseOutlined.displayName = 'RiseOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RiseOutlined));

/***/ }),
/* 3119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RiseOutlined = { "name": "rise", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RiseOutlined);


/***/ }),
/* 3120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RobotFilled__ = __webpack_require__(3121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RobotFilled = function RobotFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RobotFilled__["a" /* default */]
  }));
};

RobotFilled.displayName = 'RobotFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RobotFilled));

/***/ }),
/* 3121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RobotFilled = { "name": "robot", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60zm372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60zm-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm135 476H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c.1-17.7-11.1-32-24.9-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RobotFilled);


/***/ }),
/* 3122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RobotOutlined__ = __webpack_require__(3123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RobotOutlined = function RobotOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RobotOutlined__["a" /* default */]
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RobotOutlined));

/***/ }),
/* 3123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RobotOutlined = { "name": "robot", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RobotOutlined);


/***/ }),
/* 3124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketFilled__ = __webpack_require__(3125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RocketFilled = function RocketFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketFilled__["a" /* default */]
  }));
};

RocketFilled.displayName = 'RocketFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RocketFilled));

/***/ }),
/* 3125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RocketFilled = { "name": "rocket", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 010 96 48.01 48.01 0 010-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RocketFilled);


/***/ }),
/* 3126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketOutlined__ = __webpack_require__(3127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RocketOutlined = function RocketOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketOutlined__["a" /* default */]
  }));
};

RocketOutlined.displayName = 'RocketOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RocketOutlined));

/***/ }),
/* 3127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RocketOutlined = { "name": "rocket", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0162.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1096 0 48 48 0 10-96 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RocketOutlined);


/***/ }),
/* 3128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketTwoTone__ = __webpack_require__(3129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RocketTwoTone = function RocketTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RocketTwoTone__["a" /* default */]
  }));
};

RocketTwoTone.displayName = 'RocketTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RocketTwoTone));

/***/ }),
/* 3129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RocketTwoTone = { "name": "rocket", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 00-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0162.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 400a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (RocketTwoTone);


/***/ }),
/* 3130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RollbackOutlined__ = __webpack_require__(3131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RollbackOutlined = function RollbackOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RollbackOutlined__["a" /* default */]
  }));
};

RollbackOutlined.displayName = 'RollbackOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RollbackOutlined));

/***/ }),
/* 3131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RollbackOutlined = { "name": "rollback", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 000 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RollbackOutlined);


/***/ }),
/* 3132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RotateLeftOutlined__ = __webpack_require__(3133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RotateLeftOutlined__["a" /* default */]
  }));
};

RotateLeftOutlined.displayName = 'RotateLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RotateLeftOutlined));

/***/ }),
/* 3133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RotateLeftOutlined = { "name": "rotate-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RotateLeftOutlined);


/***/ }),
/* 3134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RotateRightOutlined__ = __webpack_require__(3135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_RotateRightOutlined__["a" /* default */]
  }));
};

RotateRightOutlined.displayName = 'RotateRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(RotateRightOutlined));

/***/ }),
/* 3135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var RotateRightOutlined = { "name": "rotate-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (RotateRightOutlined);


/***/ }),
/* 3136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateFilled__ = __webpack_require__(3137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateFilled__["a" /* default */]
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SafetyCertificateFilled));

/***/ }),
/* 3137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SafetyCertificateFilled = { "name": "safety-certificate", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SafetyCertificateFilled);


/***/ }),
/* 3138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateOutlined__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateOutlined__["a" /* default */]
  }));
};

SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SafetyCertificateOutlined));

/***/ }),
/* 3139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SafetyCertificateOutlined = { "name": "safety-certificate", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SafetyCertificateOutlined);


/***/ }),
/* 3140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateTwoTone__ = __webpack_require__(3141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyCertificateTwoTone__["a" /* default */]
  }));
};

SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SafetyCertificateTwoTone));

/***/ }),
/* 3141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SafetyCertificateTwoTone = { "name": "safety-certificate", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SafetyCertificateTwoTone);


/***/ }),
/* 3142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyOutlined__ = __webpack_require__(3143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SafetyOutlined = function SafetyOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SafetyOutlined__["a" /* default */]
  }));
};

SafetyOutlined.displayName = 'SafetyOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SafetyOutlined));

/***/ }),
/* 3143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SafetyOutlined = { "name": "safety", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z" } }, { "tag": "path", "attrs": { "d": "M378.4 475.1a35.91 35.91 0 00-50.9 0 35.91 35.91 0 000 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0048.1 0L730.6 434a33.98 33.98 0 000-48.1l-2.8-2.8a33.98 33.98 0 00-48.1 0L483 579.7 378.4 475.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SafetyOutlined);


/***/ }),
/* 3144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveFilled__ = __webpack_require__(3145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SaveFilled = function SaveFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveFilled__["a" /* default */]
  }));
};

SaveFilled.displayName = 'SaveFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SaveFilled));

/***/ }),
/* 3145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SaveFilled = { "name": "save", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SaveFilled);


/***/ }),
/* 3146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveOutlined__ = __webpack_require__(3147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SaveOutlined = function SaveOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveOutlined__["a" /* default */]
  }));
};

SaveOutlined.displayName = 'SaveOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SaveOutlined));

/***/ }),
/* 3147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SaveOutlined = { "name": "save", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SaveOutlined);


/***/ }),
/* 3148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveTwoTone__ = __webpack_require__(3149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SaveTwoTone = function SaveTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SaveTwoTone__["a" /* default */]
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SaveTwoTone));

/***/ }),
/* 3149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SaveTwoTone = { "name": "save", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 00-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SaveTwoTone);


/***/ }),
/* 3150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScanOutlined__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ScanOutlined = function ScanOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScanOutlined__["a" /* default */]
  }));
};

ScanOutlined.displayName = 'ScanOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ScanOutlined));

/***/ }),
/* 3151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ScanOutlined = { "name": "scan", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ScanOutlined);


/***/ }),
/* 3152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleFilled__ = __webpack_require__(3153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ScheduleFilled = function ScheduleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleFilled__["a" /* default */]
  }));
};

ScheduleFilled.displayName = 'ScheduleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ScheduleFilled));

/***/ }),
/* 3153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ScheduleFilled = { "name": "schedule", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ScheduleFilled);


/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleOutlined__ = __webpack_require__(3155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleOutlined__["a" /* default */]
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ScheduleOutlined));

/***/ }),
/* 3155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ScheduleOutlined = { "name": "schedule", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ScheduleOutlined);


/***/ }),
/* 3156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleTwoTone__ = __webpack_require__(3157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScheduleTwoTone__["a" /* default */]
  }));
};

ScheduleTwoTone.displayName = 'ScheduleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ScheduleTwoTone));

/***/ }),
/* 3157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ScheduleTwoTone = { "name": "schedule", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ScheduleTwoTone);


/***/ }),
/* 3158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScissorOutlined__ = __webpack_require__(3159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ScissorOutlined = function ScissorOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ScissorOutlined__["a" /* default */]
  }));
};

ScissorOutlined.displayName = 'ScissorOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ScissorOutlined));

/***/ }),
/* 3159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ScissorOutlined = { "name": "scissor", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 00288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ScissorOutlined);


/***/ }),
/* 3160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SearchOutlined__ = __webpack_require__(3161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SearchOutlined = function SearchOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SearchOutlined__["a" /* default */]
  }));
};

SearchOutlined.displayName = 'SearchOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SearchOutlined));

/***/ }),
/* 3161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SearchOutlined = { "name": "search", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SearchOutlined);


/***/ }),
/* 3162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanFilled__ = __webpack_require__(3163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SecurityScanFilled = function SecurityScanFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanFilled__["a" /* default */]
  }));
};

SecurityScanFilled.displayName = 'SecurityScanFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SecurityScanFilled));

/***/ }),
/* 3163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SecurityScanFilled = { "name": "security-scan", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 10113.27-113.28 80.1 80.1 0 10-113.27 113.28z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SecurityScanFilled);


/***/ }),
/* 3164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanOutlined__ = __webpack_require__(3165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanOutlined__["a" /* default */]
  }));
};

SecurityScanOutlined.displayName = 'SecurityScanOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SecurityScanOutlined));

/***/ }),
/* 3165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SecurityScanOutlined = { "name": "security-scan", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SecurityScanOutlined);


/***/ }),
/* 3166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanTwoTone__ = __webpack_require__(3167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SecurityScanTwoTone__["a" /* default */]
  }));
};

SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SecurityScanTwoTone));

/***/ }),
/* 3167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SecurityScanTwoTone = { "name": "security-scan", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.7 451.1a80.1 80.1 0 10160.2 0 80.1 80.1 0 10-160.2 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 01113.3 0 80.1 80.1 0 010 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SecurityScanTwoTone);


/***/ }),
/* 3168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SelectOutlined__ = __webpack_require__(3169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SelectOutlined = function SelectOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SelectOutlined__["a" /* default */]
  }));
};

SelectOutlined.displayName = 'SelectOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SelectOutlined));

/***/ }),
/* 3169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SelectOutlined = { "name": "select", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 00-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SelectOutlined);


/***/ }),
/* 3170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SendOutlined__ = __webpack_require__(3171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SendOutlined = function SendOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SendOutlined__["a" /* default */]
  }));
};

SendOutlined.displayName = 'SendOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SendOutlined));

/***/ }),
/* 3171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SendOutlined = { "name": "send", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SendOutlined);


/***/ }),
/* 3172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingFilled__ = __webpack_require__(3173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SettingFilled = function SettingFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingFilled__["a" /* default */]
  }));
};

SettingFilled.displayName = 'SettingFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SettingFilled));

/***/ }),
/* 3173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SettingFilled = { "name": "setting", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SettingFilled);


/***/ }),
/* 3174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingOutlined__ = __webpack_require__(3175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SettingOutlined = function SettingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingOutlined__["a" /* default */]
  }));
};

SettingOutlined.displayName = 'SettingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SettingOutlined));

/***/ }),
/* 3175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SettingOutlined = { "name": "setting", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SettingOutlined);


/***/ }),
/* 3176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingTwoTone__ = __webpack_require__(3177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SettingTwoTone = function SettingTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SettingTwoTone__["a" /* default */]
  }));
};

SettingTwoTone.displayName = 'SettingTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SettingTwoTone));

/***/ }),
/* 3177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SettingTwoTone = { "name": "setting", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 00-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 01-79.7 137.9l-1.8 2.1a32 32 0 01-35.1 9.5l-81.3-28.9a350 350 0 01-99.7 57.6l-15.7 85a32.05 32.05 0 01-25.8 25.7l-2.7.5a445.2 445.2 0 01-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M594.1 952.2a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 00-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6a32.09 32.09 0 007.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SettingTwoTone);


/***/ }),
/* 3178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShakeOutlined__ = __webpack_require__(3179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShakeOutlined = function ShakeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShakeOutlined__["a" /* default */]
  }));
};

ShakeOutlined.displayName = 'ShakeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShakeOutlined));

/***/ }),
/* 3179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShakeOutlined = { "name": "shake", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M324 666a48 48 0 1096 0 48 48 0 10-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 000 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0011.2 0L373.7 164a7.9 7.9 0 000-11.2l-38.4-38.4a7.9 7.9 0 00-11.2 0L114.3 323.9a7.9 7.9 0 000 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 00-11.2 0L650.3 860.1a7.9 7.9 0 000 11.2l38.4 38.4a7.9 7.9 0 0011.2 0L909.7 700a7.9 7.9 0 000-11.2l-38.3-38.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShakeOutlined);


/***/ }),
/* 3180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShareAltOutlined__ = __webpack_require__(3181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShareAltOutlined__["a" /* default */]
  }));
};

ShareAltOutlined.displayName = 'ShareAltOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShareAltOutlined));

/***/ }),
/* 3181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShareAltOutlined = { "name": "share-alt", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 000-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShareAltOutlined);


/***/ }),
/* 3182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopFilled__ = __webpack_require__(3183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShopFilled = function ShopFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopFilled__["a" /* default */]
  }));
};

ShopFilled.displayName = 'ShopFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShopFilled));

/***/ }),
/* 3183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShopFilled = { "name": "shop", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShopFilled);


/***/ }),
/* 3184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopOutlined__ = __webpack_require__(3185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShopOutlined = function ShopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopOutlined__["a" /* default */]
  }));
};

ShopOutlined.displayName = 'ShopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShopOutlined));

/***/ }),
/* 3185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShopOutlined = { "name": "shop", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShopOutlined);


/***/ }),
/* 3186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopTwoTone__ = __webpack_require__(3187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShopTwoTone = function ShopTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShopTwoTone__["a" /* default */]
  }));
};

ShopTwoTone.displayName = 'ShopTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShopTwoTone));

/***/ }),
/* 3187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShopTwoTone = { "name": "shop", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ShopTwoTone);


/***/ }),
/* 3188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingCartOutlined__ = __webpack_require__(3189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingCartOutlined__["a" /* default */]
  }));
};

ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShoppingCartOutlined));

/***/ }),
/* 3189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShoppingCartOutlined = { "name": "shopping-cart", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 00-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 100 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 00-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 00-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShoppingCartOutlined);


/***/ }),
/* 3190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingFilled__ = __webpack_require__(3191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShoppingFilled = function ShoppingFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingFilled__["a" /* default */]
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShoppingFilled));

/***/ }),
/* 3191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShoppingFilled = { "name": "shopping", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShoppingFilled);


/***/ }),
/* 3192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingOutlined__ = __webpack_require__(3193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingOutlined__["a" /* default */]
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShoppingOutlined));

/***/ }),
/* 3193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShoppingOutlined = { "name": "shopping", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShoppingOutlined);


/***/ }),
/* 3194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingTwoTone__ = __webpack_require__(3195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShoppingTwoTone__["a" /* default */]
  }));
};

ShoppingTwoTone.displayName = 'ShoppingTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShoppingTwoTone));

/***/ }),
/* 3195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShoppingTwoTone = { "name": "shopping", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ShoppingTwoTone);


/***/ }),
/* 3196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShrinkOutlined__ = __webpack_require__(3197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ShrinkOutlined__["a" /* default */]
  }));
};

ShrinkOutlined.displayName = 'ShrinkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ShrinkOutlined));

/***/ }),
/* 3197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ShrinkOutlined = { "name": "shrink", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ShrinkOutlined);


/***/ }),
/* 3198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SignalFilled__ = __webpack_require__(3199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SignalFilled = function SignalFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SignalFilled__["a" /* default */]
  }));
};

SignalFilled.displayName = 'SignalFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SignalFilled));

/***/ }),
/* 3199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SignalFilled = { "name": "signal", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SignalFilled);


/***/ }),
/* 3200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SisternodeOutlined__ = __webpack_require__(3201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SisternodeOutlined__["a" /* default */]
  }));
};

SisternodeOutlined.displayName = 'SisternodeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SisternodeOutlined));

/***/ }),
/* 3201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SisternodeOutlined = { "name": "sisternode", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432zm128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SisternodeOutlined);


/***/ }),
/* 3202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchCircleFilled__ = __webpack_require__(3203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchCircleFilled__["a" /* default */]
  }));
};

SketchCircleFilled.displayName = 'SketchCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SketchCircleFilled));

/***/ }),
/* 3203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SketchCircleFilled = { "name": "sketch-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SketchCircleFilled);


/***/ }),
/* 3204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchOutlined__ = __webpack_require__(3205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SketchOutlined = function SketchOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchOutlined__["a" /* default */]
  }));
};

SketchOutlined.displayName = 'SketchOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SketchOutlined));

/***/ }),
/* 3205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SketchOutlined = { "name": "sketch", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 00-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 00.2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 00.2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SketchOutlined);


/***/ }),
/* 3206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchSquareFilled__ = __webpack_require__(3207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SketchSquareFilled__["a" /* default */]
  }));
};

SketchSquareFilled.displayName = 'SketchSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SketchSquareFilled));

/***/ }),
/* 3207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SketchSquareFilled = { "name": "sketch-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SketchSquareFilled);


/***/ }),
/* 3208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinFilled__ = __webpack_require__(3209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SkinFilled = function SkinFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinFilled__["a" /* default */]
  }));
};

SkinFilled.displayName = 'SkinFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SkinFilled));

/***/ }),
/* 3209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SkinFilled = { "name": "skin", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SkinFilled);


/***/ }),
/* 3210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinOutlined__ = __webpack_require__(3211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SkinOutlined = function SkinOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinOutlined__["a" /* default */]
  }));
};

SkinOutlined.displayName = 'SkinOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SkinOutlined));

/***/ }),
/* 3211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SkinOutlined = { "name": "skin", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SkinOutlined);


/***/ }),
/* 3212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinTwoTone__ = __webpack_require__(3213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SkinTwoTone = function SkinTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkinTwoTone__["a" /* default */]
  }));
};

SkinTwoTone.displayName = 'SkinTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SkinTwoTone));

/***/ }),
/* 3213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SkinTwoTone = { "name": "skin", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SkinTwoTone);


/***/ }),
/* 3214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkypeFilled__ = __webpack_require__(3215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SkypeFilled = function SkypeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkypeFilled__["a" /* default */]
  }));
};

SkypeFilled.displayName = 'SkypeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SkypeFilled));

/***/ }),
/* 3215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SkypeFilled = { "name": "skype", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SkypeFilled);


/***/ }),
/* 3216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkypeOutlined__ = __webpack_require__(3217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SkypeOutlined = function SkypeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SkypeOutlined__["a" /* default */]
  }));
};

SkypeOutlined.displayName = 'SkypeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SkypeOutlined));

/***/ }),
/* 3217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SkypeOutlined = { "name": "skype", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 01-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 01-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0171.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SkypeOutlined);


/***/ }),
/* 3218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackCircleFilled__ = __webpack_require__(3219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackCircleFilled__["a" /* default */]
  }));
};

SlackCircleFilled.displayName = 'SlackCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlackCircleFilled));

/***/ }),
/* 3219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlackCircleFilled = { "name": "slack-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlackCircleFilled);


/***/ }),
/* 3220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackOutlined__ = __webpack_require__(3221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlackOutlined = function SlackOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackOutlined__["a" /* default */]
  }));
};

SlackOutlined.displayName = 'SlackOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlackOutlined));

/***/ }),
/* 3221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlackOutlined = { "name": "slack", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 00-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlackOutlined);


/***/ }),
/* 3222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackSquareFilled__ = __webpack_require__(3223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackSquareFilled__["a" /* default */]
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlackSquareFilled));

/***/ }),
/* 3223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlackSquareFilled = { "name": "slack-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlackSquareFilled);


/***/ }),
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackSquareOutlined__ = __webpack_require__(3225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlackSquareOutlined__["a" /* default */]
  }));
};

SlackSquareOutlined.displayName = 'SlackSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlackSquareOutlined));

/***/ }),
/* 3225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlackSquareOutlined = { "name": "slack-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlackSquareOutlined);


/***/ }),
/* 3226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersFilled__ = __webpack_require__(3227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlidersFilled = function SlidersFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersFilled__["a" /* default */]
  }));
};

SlidersFilled.displayName = 'SlidersFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlidersFilled));

/***/ }),
/* 3227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlidersFilled = { "name": "sliders", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlidersFilled);


/***/ }),
/* 3228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersOutlined__ = __webpack_require__(3229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlidersOutlined = function SlidersOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersOutlined__["a" /* default */]
  }));
};

SlidersOutlined.displayName = 'SlidersOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlidersOutlined));

/***/ }),
/* 3229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlidersOutlined = { "name": "sliders", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SlidersOutlined);


/***/ }),
/* 3230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersTwoTone__ = __webpack_require__(3231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SlidersTwoTone__["a" /* default */]
  }));
};

SlidersTwoTone.displayName = 'SlidersTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SlidersTwoTone));

/***/ }),
/* 3231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SlidersTwoTone = { "name": "sliders", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 00-3 3v74a3 3 0 003 3h74a3 3 0 003-3v-74a3 3 0 00-3-3zm215-108h80v296h-80z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SlidersTwoTone);


/***/ }),
/* 3232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmallDashOutlined__ = __webpack_require__(3233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmallDashOutlined__["a" /* default */]
  }));
};

SmallDashOutlined.displayName = 'SmallDashOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SmallDashOutlined));

/***/ }),
/* 3233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SmallDashOutlined = { "name": "small-dash", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SmallDashOutlined);


/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileFilled__ = __webpack_require__(3235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SmileFilled = function SmileFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileFilled__["a" /* default */]
  }));
};

SmileFilled.displayName = 'SmileFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SmileFilled));

/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SmileFilled = { "name": "smile", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SmileFilled);


/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileOutlined__ = __webpack_require__(3237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SmileOutlined = function SmileOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileOutlined__["a" /* default */]
  }));
};

SmileOutlined.displayName = 'SmileOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SmileOutlined));

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SmileOutlined = { "name": "smile", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SmileOutlined);


/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileTwoTone__ = __webpack_require__(3239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SmileTwoTone = function SmileTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SmileTwoTone__["a" /* default */]
  }));
};

SmileTwoTone.displayName = 'SmileTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SmileTwoTone));

/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SmileTwoTone = { "name": "smile", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4zm-24-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SmileTwoTone);


/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsFilled__ = __webpack_require__(3241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SnippetsFilled = function SnippetsFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsFilled__["a" /* default */]
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SnippetsFilled));

/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SnippetsFilled = { "name": "snippets", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SnippetsFilled);


/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsOutlined__ = __webpack_require__(3243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsOutlined__["a" /* default */]
  }));
};

SnippetsOutlined.displayName = 'SnippetsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SnippetsOutlined));

/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SnippetsOutlined = { "name": "snippets", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SnippetsOutlined);


/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsTwoTone__ = __webpack_require__(3245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SnippetsTwoTone__["a" /* default */]
  }));
};

SnippetsTwoTone.displayName = 'SnippetsTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SnippetsTwoTone));

/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SnippetsTwoTone = { "name": "snippets", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SnippetsTwoTone);


/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SolutionOutlined__ = __webpack_require__(3247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SolutionOutlined = function SolutionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SolutionOutlined__["a" /* default */]
  }));
};

SolutionOutlined.displayName = 'SolutionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SolutionOutlined));

/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SolutionOutlined = { "name": "solution", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SolutionOutlined);


/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SortAscendingOutlined__ = __webpack_require__(3249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SortAscendingOutlined__["a" /* default */]
  }));
};

SortAscendingOutlined.displayName = 'SortAscendingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SortAscendingOutlined));

/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SortAscendingOutlined = { "name": "sort-ascending", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0012.6 0l112-141.9c4.1-5.2.4-13-6.3-13z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SortAscendingOutlined);


/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SortDescendingOutlined__ = __webpack_require__(3251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SortDescendingOutlined__["a" /* default */]
  }));
};

SortDescendingOutlined.displayName = 'SortDescendingOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SortDescendingOutlined));

/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SortDescendingOutlined = { "name": "sort-descending", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM310.3 167.1a8 8 0 00-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SortDescendingOutlined);


/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundFilled__ = __webpack_require__(3253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SoundFilled = function SoundFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundFilled__["a" /* default */]
  }));
};

SoundFilled.displayName = 'SoundFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SoundFilled));

/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SoundFilled = { "name": "sound", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SoundFilled);


/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundOutlined__ = __webpack_require__(3255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SoundOutlined = function SoundOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundOutlined__["a" /* default */]
  }));
};

SoundOutlined.displayName = 'SoundOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SoundOutlined));

/***/ }),
/* 3255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SoundOutlined = { "name": "sound", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SoundOutlined);


/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundTwoTone__ = __webpack_require__(3257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SoundTwoTone = function SoundTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SoundTwoTone__["a" /* default */]
  }));
};

SoundTwoTone.displayName = 'SoundTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SoundTwoTone));

/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SoundTwoTone = { "name": "sound", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SoundTwoTone);


/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SplitCellsOutlined__ = __webpack_require__(3259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SplitCellsOutlined__["a" /* default */]
  }));
};

SplitCellsOutlined.displayName = 'SplitCellsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SplitCellsOutlined));

/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SplitCellsOutlined = { "name": "split-cells", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SplitCellsOutlined);


/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarFilled__ = __webpack_require__(3261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StarFilled = function StarFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarFilled__["a" /* default */]
  }));
};

StarFilled.displayName = 'StarFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StarFilled));

/***/ }),
/* 3261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StarFilled = { "name": "star", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StarFilled);


/***/ }),
/* 3262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarOutlined__ = __webpack_require__(3263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StarOutlined = function StarOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarOutlined__["a" /* default */]
  }));
};

StarOutlined.displayName = 'StarOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StarOutlined));

/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StarOutlined = { "name": "star", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StarOutlined);


/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarTwoTone__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StarTwoTone = function StarTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StarTwoTone__["a" /* default */]
  }));
};

StarTwoTone.displayName = 'StarTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StarTwoTone));

/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StarTwoTone = { "name": "star", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0046.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (StarTwoTone);


/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepBackwardFilled__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StepBackwardFilled = function StepBackwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepBackwardFilled__["a" /* default */]
  }));
};

StepBackwardFilled.displayName = 'StepBackwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StepBackwardFilled));

/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StepBackwardFilled = { "name": "step-backward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StepBackwardFilled);


/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepBackwardOutlined__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepBackwardOutlined__["a" /* default */]
  }));
};

StepBackwardOutlined.displayName = 'StepBackwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StepBackwardOutlined));

/***/ }),
/* 3269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StepBackwardOutlined = { "name": "step-backward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StepBackwardOutlined);


/***/ }),
/* 3270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepForwardFilled__ = __webpack_require__(3271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StepForwardFilled = function StepForwardFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepForwardFilled__["a" /* default */]
  }));
};

StepForwardFilled.displayName = 'StepForwardFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StepForwardFilled));

/***/ }),
/* 3271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StepForwardFilled = { "name": "step-forward", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StepForwardFilled);


/***/ }),
/* 3272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepForwardOutlined__ = __webpack_require__(3273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StepForwardOutlined__["a" /* default */]
  }));
};

StepForwardOutlined.displayName = 'StepForwardOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StepForwardOutlined));

/***/ }),
/* 3273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StepForwardOutlined = { "name": "step-forward", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StepForwardOutlined);


/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StockOutlined__ = __webpack_require__(3275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StockOutlined = function StockOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StockOutlined__["a" /* default */]
  }));
};

StockOutlined.displayName = 'StockOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StockOutlined));

/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StockOutlined = { "name": "stock", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0045.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 00-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 00-45.2 0L165.7 610.5a7.94 7.94 0 000 11.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StockOutlined);


/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopFilled__ = __webpack_require__(3277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StopFilled = function StopFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopFilled__["a" /* default */]
  }));
};

StopFilled.displayName = 'StopFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StopFilled));

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StopFilled = { "name": "stop", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StopFilled);


/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopOutlined__ = __webpack_require__(3279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StopOutlined = function StopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopOutlined__["a" /* default */]
  }));
};

StopOutlined.displayName = 'StopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StopOutlined));

/***/ }),
/* 3279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StopOutlined = { "name": "stop", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StopOutlined);


/***/ }),
/* 3280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopTwoTone__ = __webpack_require__(3281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StopTwoTone = function StopTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StopTwoTone__["a" /* default */]
  }));
};

StopTwoTone.displayName = 'StopTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StopTwoTone));

/***/ }),
/* 3281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StopTwoTone = { "name": "stop", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (StopTwoTone);


/***/ }),
/* 3282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StrikethroughOutlined__ = __webpack_require__(3283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_StrikethroughOutlined__["a" /* default */]
  }));
};

StrikethroughOutlined.displayName = 'StrikethroughOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(StrikethroughOutlined));

/***/ }),
/* 3283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var StrikethroughOutlined = { "name": "strikethrough", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 00-8-7.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (StrikethroughOutlined);


/***/ }),
/* 3284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SubnodeOutlined__ = __webpack_require__(3285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SubnodeOutlined__["a" /* default */]
  }));
};

SubnodeOutlined.displayName = 'SubnodeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SubnodeOutlined));

/***/ }),
/* 3285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SubnodeOutlined = { "name": "subnode", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M688 240c-138 0-252 102.8-269.6 236H249a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240zm128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SubnodeOutlined);


/***/ }),
/* 3286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapLeftOutlined__ = __webpack_require__(3287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapLeftOutlined__["a" /* default */]
  }));
};

SwapLeftOutlined.displayName = 'SwapLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwapLeftOutlined));

/***/ }),
/* 3287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwapLeftOutlined = { "name": "swap-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SwapLeftOutlined);


/***/ }),
/* 3288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapOutlined__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwapOutlined = function SwapOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapOutlined__["a" /* default */]
  }));
};

SwapOutlined.displayName = 'SwapOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwapOutlined));

/***/ }),
/* 3289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwapOutlined = { "name": "swap", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SwapOutlined);


/***/ }),
/* 3290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapRightOutlined__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwapRightOutlined__["a" /* default */]
  }));
};

SwapRightOutlined.displayName = 'SwapRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwapRightOutlined));

/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwapRightOutlined = { "name": "swap-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SwapRightOutlined);


/***/ }),
/* 3292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherFilled__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwitcherFilled = function SwitcherFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherFilled__["a" /* default */]
  }));
};

SwitcherFilled.displayName = 'SwitcherFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwitcherFilled));

/***/ }),
/* 3293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwitcherFilled = { "name": "switcher", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SwitcherFilled);


/***/ }),
/* 3294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherOutlined__ = __webpack_require__(3295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherOutlined__["a" /* default */]
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwitcherOutlined));

/***/ }),
/* 3295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwitcherOutlined = { "name": "switcher", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SwitcherOutlined);


/***/ }),
/* 3296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherTwoTone__ = __webpack_require__(3297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SwitcherTwoTone__["a" /* default */]
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SwitcherTwoTone));

/***/ }),
/* 3297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SwitcherTwoTone = { "name": "switcher", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M300 550h296v64H300z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (SwitcherTwoTone);


/***/ }),
/* 3298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SyncOutlined__ = __webpack_require__(3299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var SyncOutlined = function SyncOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_SyncOutlined__["a" /* default */]
  }));
};

SyncOutlined.displayName = 'SyncOutlined';
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(SyncOutlined));

/***/ }),
/* 3299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var SyncOutlined = { "name": "sync", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (SyncOutlined);


/***/ }),
/* 3300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TableOutlined__ = __webpack_require__(3301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TableOutlined = function TableOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TableOutlined__["a" /* default */]
  }));
};

TableOutlined.displayName = 'TableOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TableOutlined));

/***/ }),
/* 3301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TableOutlined = { "name": "table", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TableOutlined);


/***/ }),
/* 3302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletFilled__ = __webpack_require__(3303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TabletFilled = function TabletFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletFilled__["a" /* default */]
  }));
};

TabletFilled.displayName = 'TabletFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TabletFilled));

/***/ }),
/* 3303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TabletFilled = { "name": "tablet", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TabletFilled);


/***/ }),
/* 3304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletOutlined__ = __webpack_require__(3305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TabletOutlined = function TabletOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletOutlined__["a" /* default */]
  }));
};

TabletOutlined.displayName = 'TabletOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TabletOutlined));

/***/ }),
/* 3305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TabletOutlined = { "name": "tablet", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TabletOutlined);


/***/ }),
/* 3306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletTwoTone__ = __webpack_require__(3307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TabletTwoTone = function TabletTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TabletTwoTone__["a" /* default */]
  }));
};

TabletTwoTone.displayName = 'TabletTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TabletTwoTone));

/***/ }),
/* 3307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TabletTwoTone = { "name": "tablet", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 784a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (TabletTwoTone);


/***/ }),
/* 3308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagFilled__ = __webpack_require__(3309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagFilled = function TagFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagFilled__["a" /* default */]
  }));
};

TagFilled.displayName = 'TagFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagFilled));

/***/ }),
/* 3309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagFilled = { "name": "tag", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TagFilled);


/***/ }),
/* 3310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagOutlined__ = __webpack_require__(3311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagOutlined = function TagOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagOutlined__["a" /* default */]
  }));
};

TagOutlined.displayName = 'TagOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagOutlined));

/***/ }),
/* 3311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagOutlined = { "name": "tag", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TagOutlined);


/***/ }),
/* 3312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagTwoTone__ = __webpack_require__(3313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagTwoTone = function TagTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagTwoTone__["a" /* default */]
  }));
};

TagTwoTone.displayName = 'TagTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagTwoTone));

/***/ }),
/* 3313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagTwoTone = { "name": "tag", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8a9.9 9.9 0 007.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (TagTwoTone);


/***/ }),
/* 3314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsFilled__ = __webpack_require__(3315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagsFilled = function TagsFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsFilled__["a" /* default */]
  }));
};

TagsFilled.displayName = 'TagsFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagsFilled));

/***/ }),
/* 3315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagsFilled = { "name": "tags", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TagsFilled);


/***/ }),
/* 3316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsOutlined__ = __webpack_require__(3317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagsOutlined = function TagsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsOutlined__["a" /* default */]
  }));
};

TagsOutlined.displayName = 'TagsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagsOutlined));

/***/ }),
/* 3317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagsOutlined = { "name": "tags", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1067.88-67.89 48 48 0 10-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TagsOutlined);


/***/ }),
/* 3318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsTwoTone__ = __webpack_require__(3319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TagsTwoTone = function TagsTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TagsTwoTone__["a" /* default */]
  }));
};

TagsTwoTone.displayName = 'TagsTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TagsTwoTone));

/***/ }),
/* 3319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TagsTwoTone = { "name": "tags", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0133.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0112.4 46.4 47.81 47.81 0 01-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 01-12.4-46.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 010-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0033.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 00-46.4-12.4 47.81 47.81 0 00-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0046.4 12.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (TagsTwoTone);


/***/ }),
/* 3320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoCircleFilled__ = __webpack_require__(3321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoCircleFilled__["a" /* default */]
  }));
};

TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TaobaoCircleFilled));

/***/ }),
/* 3321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TaobaoCircleFilled = { "name": "taobao-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TaobaoCircleFilled);


/***/ }),
/* 3322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoCircleOutlined__ = __webpack_require__(3323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoCircleOutlined__["a" /* default */]
  }));
};

TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TaobaoCircleOutlined));

/***/ }),
/* 3323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TaobaoCircleOutlined = { "name": "taobao-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TaobaoCircleOutlined);


/***/ }),
/* 3324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoOutlined__ = __webpack_require__(3325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoOutlined__["a" /* default */]
  }));
};

TaobaoOutlined.displayName = 'TaobaoOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TaobaoOutlined));

/***/ }),
/* 3325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TaobaoOutlined = { "name": "taobao", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168.5 273.7a68.7 68.7 0 10137.4 0 68.7 68.7 0 10-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TaobaoOutlined);


/***/ }),
/* 3326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoSquareFilled__ = __webpack_require__(3327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TaobaoSquareFilled__["a" /* default */]
  }));
};

TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TaobaoSquareFilled));

/***/ }),
/* 3327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TaobaoSquareFilled = { "name": "taobao-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TaobaoSquareFilled);


/***/ }),
/* 3328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TeamOutlined__ = __webpack_require__(3329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TeamOutlined = function TeamOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TeamOutlined__["a" /* default */]
  }));
};

TeamOutlined.displayName = 'TeamOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TeamOutlined));

/***/ }),
/* 3329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TeamOutlined = { "name": "team", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TeamOutlined);


/***/ }),
/* 3330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltFilled__ = __webpack_require__(3331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltFilled__["a" /* default */]
  }));
};

ThunderboltFilled.displayName = 'ThunderboltFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ThunderboltFilled));

/***/ }),
/* 3331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ThunderboltFilled = { "name": "thunderbolt", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ThunderboltFilled);


/***/ }),
/* 3332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltOutlined__ = __webpack_require__(3333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltOutlined__["a" /* default */]
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ThunderboltOutlined));

/***/ }),
/* 3333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ThunderboltOutlined = { "name": "thunderbolt", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ThunderboltOutlined);


/***/ }),
/* 3334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltTwoTone__ = __webpack_require__(3335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ThunderboltTwoTone__["a" /* default */]
  }));
};

ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ThunderboltTwoTone));

/***/ }),
/* 3335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ThunderboltTwoTone = { "name": "thunderbolt", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ThunderboltTwoTone);


/***/ }),
/* 3336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToTopOutlined__ = __webpack_require__(3337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ToTopOutlined = function ToTopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToTopOutlined__["a" /* default */]
  }));
};

ToTopOutlined.displayName = 'ToTopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ToTopOutlined));

/***/ }),
/* 3337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ToTopOutlined = { "name": "to-top", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ToTopOutlined);


/***/ }),
/* 3338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolFilled__ = __webpack_require__(3339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ToolFilled = function ToolFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolFilled__["a" /* default */]
  }));
};

ToolFilled.displayName = 'ToolFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ToolFilled));

/***/ }),
/* 3339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ToolFilled = { "name": "tool", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ToolFilled);


/***/ }),
/* 3340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolOutlined__ = __webpack_require__(3341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ToolOutlined = function ToolOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolOutlined__["a" /* default */]
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ToolOutlined));

/***/ }),
/* 3341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ToolOutlined = { "name": "tool", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ToolOutlined);


/***/ }),
/* 3342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolTwoTone__ = __webpack_require__(3343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ToolTwoTone = function ToolTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ToolTwoTone__["a" /* default */]
  }));
};

ToolTwoTone.displayName = 'ToolTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ToolTwoTone));

/***/ }),
/* 3343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ToolTwoTone = { "name": "tool", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M706.8 488.7a32.05 32.05 0 01-45.3 0L537 364.2a32.05 32.05 0 010-45.3l132.9-132.8a184.2 184.2 0 00-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (ToolTwoTone);


/***/ }),
/* 3344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleFilled__ = __webpack_require__(3345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleFilled__["a" /* default */]
  }));
};

TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrademarkCircleFilled));

/***/ }),
/* 3345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrademarkCircleFilled = { "name": "trademark-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TrademarkCircleFilled);


/***/ }),
/* 3346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleOutlined__ = __webpack_require__(3347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleOutlined__["a" /* default */]
  }));
};

TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrademarkCircleOutlined));

/***/ }),
/* 3347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrademarkCircleOutlined = { "name": "trademark-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TrademarkCircleOutlined);


/***/ }),
/* 3348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleTwoTone__ = __webpack_require__(3349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkCircleTwoTone__["a" /* default */]
  }));
};

TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrademarkCircleTwoTone));

/***/ }),
/* 3349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrademarkCircleTwoTone = { "name": "trademark-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (TrademarkCircleTwoTone);


/***/ }),
/* 3350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkOutlined__ = __webpack_require__(3351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrademarkOutlined__["a" /* default */]
  }));
};

TrademarkOutlined.displayName = 'TrademarkOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrademarkOutlined));

/***/ }),
/* 3351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrademarkOutlined = { "name": "trademark", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TrademarkOutlined);


/***/ }),
/* 3352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TransactionOutlined__ = __webpack_require__(3353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TransactionOutlined = function TransactionOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TransactionOutlined__["a" /* default */]
  }));
};

TransactionOutlined.displayName = 'TransactionOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TransactionOutlined));

/***/ }),
/* 3353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TransactionOutlined = { "name": "transaction", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 01103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 003 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 008 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 01-103.5 242.4 352.57 352.57 0 01-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 01-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 00-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 00-8-8.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TransactionOutlined);


/***/ }),
/* 3354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TranslationOutlined__ = __webpack_require__(3355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TranslationOutlined = function TranslationOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TranslationOutlined__["a" /* default */]
  }));
};

TranslationOutlined.displayName = 'TranslationOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TranslationOutlined));

/***/ }),
/* 3355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TranslationOutlined = { "name": "translation", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z" } }, { "tag": "path", "attrs": { "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TranslationOutlined);


/***/ }),
/* 3356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyFilled__ = __webpack_require__(3357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrophyFilled = function TrophyFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyFilled__["a" /* default */]
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrophyFilled));

/***/ }),
/* 3357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrophyFilled = { "name": "trophy", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TrophyFilled);


/***/ }),
/* 3358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyOutlined__ = __webpack_require__(3359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrophyOutlined = function TrophyOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyOutlined__["a" /* default */]
  }));
};

TrophyOutlined.displayName = 'TrophyOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrophyOutlined));

/***/ }),
/* 3359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrophyOutlined = { "name": "trophy", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TrophyOutlined);


/***/ }),
/* 3360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyTwoTone__ = __webpack_require__(3361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TrophyTwoTone__["a" /* default */]
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TrophyTwoTone));

/***/ }),
/* 3361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TrophyTwoTone = { "name": "trophy", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6a91.99 91.99 0 01-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (TrophyTwoTone);


/***/ }),
/* 3362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterCircleFilled__ = __webpack_require__(3363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterCircleFilled__["a" /* default */]
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TwitterCircleFilled));

/***/ }),
/* 3363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TwitterCircleFilled = { "name": "twitter-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TwitterCircleFilled);


/***/ }),
/* 3364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterOutlined__ = __webpack_require__(3365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TwitterOutlined = function TwitterOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterOutlined__["a" /* default */]
  }));
};

TwitterOutlined.displayName = 'TwitterOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TwitterOutlined));

/***/ }),
/* 3365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TwitterOutlined = { "name": "twitter", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 00-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 01-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 01-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TwitterOutlined);


/***/ }),
/* 3366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterSquareFilled__ = __webpack_require__(3367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_TwitterSquareFilled__["a" /* default */]
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(TwitterSquareFilled));

/***/ }),
/* 3367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var TwitterSquareFilled = { "name": "twitter-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (TwitterSquareFilled);


/***/ }),
/* 3368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnderlineOutlined__ = __webpack_require__(3369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnderlineOutlined__["a" /* default */]
  }));
};

UnderlineOutlined.displayName = 'UnderlineOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UnderlineOutlined));

/***/ }),
/* 3369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UnderlineOutlined = { "name": "underline", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UnderlineOutlined);


/***/ }),
/* 3370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UndoOutlined__ = __webpack_require__(3371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UndoOutlined = function UndoOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UndoOutlined__["a" /* default */]
  }));
};

UndoOutlined.displayName = 'UndoOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UndoOutlined));

/***/ }),
/* 3371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UndoOutlined = { "name": "undo", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UndoOutlined);


/***/ }),
/* 3372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UngroupOutlined__ = __webpack_require__(3373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UngroupOutlined = function UngroupOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UngroupOutlined__["a" /* default */]
  }));
};

UngroupOutlined.displayName = 'UngroupOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UngroupOutlined));

/***/ }),
/* 3373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UngroupOutlined = { "name": "ungroup", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208 130c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208-194c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72zm0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 656c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UngroupOutlined);


/***/ }),
/* 3374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockFilled__ = __webpack_require__(3375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UnlockFilled = function UnlockFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockFilled__["a" /* default */]
  }));
};

UnlockFilled.displayName = 'UnlockFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UnlockFilled));

/***/ }),
/* 3375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UnlockFilled = { "name": "unlock", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UnlockFilled);


/***/ }),
/* 3376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockOutlined__ = __webpack_require__(3377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UnlockOutlined = function UnlockOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockOutlined__["a" /* default */]
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UnlockOutlined));

/***/ }),
/* 3377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UnlockOutlined = { "name": "unlock", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UnlockOutlined);


/***/ }),
/* 3378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockTwoTone__ = __webpack_require__(3379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnlockTwoTone__["a" /* default */]
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UnlockTwoTone));

/***/ }),
/* 3379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UnlockTwoTone = { "name": "unlock", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (UnlockTwoTone);


/***/ }),
/* 3380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnorderedListOutlined__ = __webpack_require__(3381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UnorderedListOutlined__["a" /* default */]
  }));
};

UnorderedListOutlined.displayName = 'UnorderedListOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UnorderedListOutlined));

/***/ }),
/* 3381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UnorderedListOutlined = { "name": "unordered-list", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UnorderedListOutlined);


/***/ }),
/* 3382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleFilled__ = __webpack_require__(3383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpCircleFilled = function UpCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleFilled__["a" /* default */]
  }));
};

UpCircleFilled.displayName = 'UpCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpCircleFilled));

/***/ }),
/* 3383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpCircleFilled = { "name": "up-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UpCircleFilled);


/***/ }),
/* 3384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleOutlined__ = __webpack_require__(3385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleOutlined__["a" /* default */]
  }));
};

UpCircleOutlined.displayName = 'UpCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpCircleOutlined));

/***/ }),
/* 3385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpCircleOutlined = { "name": "up-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.5 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UpCircleOutlined);


/***/ }),
/* 3386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleTwoTone__ = __webpack_require__(3387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpCircleTwoTone__["a" /* default */]
  }));
};

UpCircleTwoTone.displayName = 'UpCircleTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpCircleTwoTone));

/***/ }),
/* 3387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpCircleTwoTone = { "name": "up-circle", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M518.4 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (UpCircleTwoTone);


/***/ }),
/* 3388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpOutlined__ = __webpack_require__(3389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpOutlined = function UpOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpOutlined__["a" /* default */]
  }));
};

UpOutlined.displayName = 'UpOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpOutlined));

/***/ }),
/* 3389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpOutlined = { "name": "up", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UpOutlined);


/***/ }),
/* 3390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareFilled__ = __webpack_require__(3391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpSquareFilled = function UpSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareFilled__["a" /* default */]
  }));
};

UpSquareFilled.displayName = 'UpSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpSquareFilled));

/***/ }),
/* 3391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpSquareFilled = { "name": "up-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UpSquareFilled);


/***/ }),
/* 3392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareOutlined__ = __webpack_require__(3393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareOutlined__["a" /* default */]
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpSquareOutlined));

/***/ }),
/* 3393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpSquareOutlined = { "name": "up-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246A7.96 7.96 0 00334 624z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UpSquareOutlined);


/***/ }),
/* 3394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareTwoTone__ = __webpack_require__(3395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UpSquareTwoTone__["a" /* default */]
  }));
};

UpSquareTwoTone.displayName = 'UpSquareTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UpSquareTwoTone));

/***/ }),
/* 3395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UpSquareTwoTone = { "name": "up-square", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (UpSquareTwoTone);


/***/ }),
/* 3396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UploadOutlined__ = __webpack_require__(3397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UploadOutlined = function UploadOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UploadOutlined__["a" /* default */]
  }));
};

UploadOutlined.displayName = 'UploadOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UploadOutlined));

/***/ }),
/* 3397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UploadOutlined = { "name": "upload", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UploadOutlined);


/***/ }),
/* 3398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbFilled__ = __webpack_require__(3399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UsbFilled = function UsbFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbFilled__["a" /* default */]
  }));
};

UsbFilled.displayName = 'UsbFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UsbFilled));

/***/ }),
/* 3399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UsbFilled = { "name": "usb", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UsbFilled);


/***/ }),
/* 3400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbOutlined__ = __webpack_require__(3401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UsbOutlined = function UsbOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbOutlined__["a" /* default */]
  }));
};

UsbOutlined.displayName = 'UsbOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UsbOutlined));

/***/ }),
/* 3401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UsbOutlined = { "name": "usb", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UsbOutlined);


/***/ }),
/* 3402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbTwoTone__ = __webpack_require__(3403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UsbTwoTone = function UsbTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsbTwoTone__["a" /* default */]
  }));
};

UsbTwoTone.displayName = 'UsbTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UsbTwoTone));

/***/ }),
/* 3403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UsbTwoTone = { "name": "usb", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (UsbTwoTone);


/***/ }),
/* 3404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserAddOutlined__ = __webpack_require__(3405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UserAddOutlined = function UserAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserAddOutlined__["a" /* default */]
  }));
};

UserAddOutlined.displayName = 'UserAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UserAddOutlined));

/***/ }),
/* 3405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UserAddOutlined = { "name": "user-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UserAddOutlined);


/***/ }),
/* 3406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserDeleteOutlined__ = __webpack_require__(3407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserDeleteOutlined__["a" /* default */]
  }));
};

UserDeleteOutlined.displayName = 'UserDeleteOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UserDeleteOutlined));

/***/ }),
/* 3407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UserDeleteOutlined = { "name": "user-delete", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UserDeleteOutlined);


/***/ }),
/* 3408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserOutlined__ = __webpack_require__(3409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UserOutlined = function UserOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserOutlined__["a" /* default */]
  }));
};

UserOutlined.displayName = 'UserOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UserOutlined));

/***/ }),
/* 3409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UserOutlined = { "name": "user", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UserOutlined);


/***/ }),
/* 3410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserSwitchOutlined__ = __webpack_require__(3411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UserSwitchOutlined__["a" /* default */]
  }));
};

UserSwitchOutlined.displayName = 'UserSwitchOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UserSwitchOutlined));

/***/ }),
/* 3411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UserSwitchOutlined = { "name": "user-switch", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-.4.2-.7.3-.9.4-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00136 874.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zm105 221h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1a8.1 8.1 0 001.7-4.9c0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8.1 17.7 14.4 32 32.1 32zm240 64H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1a8.1 8.1 0 00-1.7 4.9c0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-.1-17.7-14.4-32-32.1-32z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UserSwitchOutlined);


/***/ }),
/* 3412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsergroupAddOutlined__ = __webpack_require__(3413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsergroupAddOutlined__["a" /* default */]
  }));
};

UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UsergroupAddOutlined));

/***/ }),
/* 3413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UsergroupAddOutlined = { "name": "usergroup-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UsergroupAddOutlined);


/***/ }),
/* 3414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsergroupDeleteOutlined__ = __webpack_require__(3415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_UsergroupDeleteOutlined__["a" /* default */]
  }));
};

UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(UsergroupDeleteOutlined));

/***/ }),
/* 3415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var UsergroupDeleteOutlined = { "name": "usergroup-delete", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (UsergroupDeleteOutlined);


/***/ }),
/* 3416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerifiedOutlined__ = __webpack_require__(3417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerifiedOutlined__["a" /* default */]
  }));
};

VerifiedOutlined.displayName = 'VerifiedOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerifiedOutlined));

/***/ }),
/* 3417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerifiedOutlined = { "name": "verified", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M447.8 588.8l-7.3-32.5c-.2-1-.6-1.9-1.1-2.7a7.94 7.94 0 00-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4a8 8 0 0012.7 6.5l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zm-56.7-216.6l.2.2c3.2 3 8.3 2.8 11.3-.5l24.1-26.2a8.1 8.1 0 00-.3-11.2l-53.7-52.1a8 8 0 00-11.2.1l-24.7 24.7c-3.1 3.1-3.1 8.2.1 11.3l54.2 53.7z" } }, { "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }, { "tag": "path", "attrs": { "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerifiedOutlined);


/***/ }),
/* 3418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignBottomOutlined__ = __webpack_require__(3419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignBottomOutlined__["a" /* default */]
  }));
};

VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerticalAlignBottomOutlined));

/***/ }),
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerticalAlignBottomOutlined = { "name": "vertical-align-bottom", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerticalAlignBottomOutlined);


/***/ }),
/* 3420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignMiddleOutlined__ = __webpack_require__(3421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalAlignMiddleOutlined = function VerticalAlignMiddleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignMiddleOutlined__["a" /* default */]
  }));
};

VerticalAlignMiddleOutlined.displayName = 'VerticalAlignMiddleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerticalAlignMiddleOutlined));

/***/ }),
/* 3421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerticalAlignMiddleOutlined = { "name": "vertical-align-middle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 00-11.3 0L405.6 752.3a7.23 7.23 0 005.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerticalAlignMiddleOutlined);


/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignTopOutlined__ = __webpack_require__(3423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalAlignTopOutlined__["a" /* default */]
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerticalAlignTopOutlined));

/***/ }),
/* 3423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerticalAlignTopOutlined = { "name": "vertical-align-top", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerticalAlignTopOutlined);


/***/ }),
/* 3424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalLeftOutlined__ = __webpack_require__(3425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalLeftOutlined__["a" /* default */]
  }));
};

VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerticalLeftOutlined));

/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerticalLeftOutlined = { "name": "vertical-left", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 00254 164z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerticalLeftOutlined);


/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalRightOutlined__ = __webpack_require__(3427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VerticalRightOutlined__["a" /* default */]
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VerticalRightOutlined));

/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VerticalRightOutlined = { "name": "vertical-right", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VerticalRightOutlined);


/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraAddOutlined__ = __webpack_require__(3429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VideoCameraAddOutlined = function VideoCameraAddOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraAddOutlined__["a" /* default */]
  }));
};

VideoCameraAddOutlined.displayName = 'VideoCameraAddOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VideoCameraAddOutlined));

/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VideoCameraAddOutlined = { "name": "video-camera-add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z" } }, { "tag": "path", "attrs": { "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VideoCameraAddOutlined);


/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraFilled__ = __webpack_require__(3431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraFilled__["a" /* default */]
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VideoCameraFilled));

/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VideoCameraFilled = { "name": "video-camera", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VideoCameraFilled);


/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraOutlined__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraOutlined__["a" /* default */]
  }));
};

VideoCameraOutlined.displayName = 'VideoCameraOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VideoCameraOutlined));

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VideoCameraOutlined = { "name": "video-camera", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (VideoCameraOutlined);


/***/ }),
/* 3434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraTwoTone__ = __webpack_require__(3435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_VideoCameraTwoTone__["a" /* default */]
  }));
};

VideoCameraTwoTone.displayName = 'VideoCameraTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(VideoCameraTwoTone));

/***/ }),
/* 3435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var VideoCameraTwoTone = { "name": "video-camera", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (VideoCameraTwoTone);


/***/ }),
/* 3436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletFilled__ = __webpack_require__(3437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WalletFilled = function WalletFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletFilled__["a" /* default */]
  }));
};

WalletFilled.displayName = 'WalletFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WalletFilled));

/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WalletFilled = { "name": "wallet", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WalletFilled);


/***/ }),
/* 3438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletOutlined__ = __webpack_require__(3439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WalletOutlined = function WalletOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletOutlined__["a" /* default */]
  }));
};

WalletOutlined.displayName = 'WalletOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WalletOutlined));

/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WalletOutlined = { "name": "wallet", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1080 0 40 40 0 10-80 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WalletOutlined);


/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletTwoTone__ = __webpack_require__(3441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WalletTwoTone = function WalletTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WalletTwoTone__["a" /* default */]
  }));
};

WalletTwoTone.displayName = 'WalletTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WalletTwoTone));

/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WalletTwoTone = { "name": "wallet", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M580 512a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z", "fill": secondaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (WalletTwoTone);


/***/ }),
/* 3442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningFilled__ = __webpack_require__(3443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WarningFilled = function WarningFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningFilled__["a" /* default */]
  }));
};

WarningFilled.displayName = 'WarningFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WarningFilled));

/***/ }),
/* 3443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WarningFilled = { "name": "warning", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WarningFilled);


/***/ }),
/* 3444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningOutlined__ = __webpack_require__(3445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WarningOutlined = function WarningOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningOutlined__["a" /* default */]
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WarningOutlined));

/***/ }),
/* 3445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WarningOutlined = { "name": "warning", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WarningOutlined);


/***/ }),
/* 3446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningTwoTone__ = __webpack_require__(3447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WarningTwoTone = function WarningTwoTone(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WarningTwoTone__["a" /* default */]
  }));
};

WarningTwoTone.displayName = 'WarningTwoTone';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WarningTwoTone));

/***/ }),
/* 3447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WarningTwoTone = { "name": "warning", "theme": "twotone", "icon": function (primaryColor, secondaryColor) {
        return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }] };
    } };
/* harmony default export */ __webpack_exports__["a"] = (WarningTwoTone);


/***/ }),
/* 3448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WechatFilled__ = __webpack_require__(3449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WechatFilled = function WechatFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WechatFilled__["a" /* default */]
  }));
};

WechatFilled.displayName = 'WechatFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WechatFilled));

/***/ }),
/* 3449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WechatFilled = { "name": "wechat", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WechatFilled);


/***/ }),
/* 3450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WechatOutlined__ = __webpack_require__(3451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WechatOutlined = function WechatOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WechatOutlined__["a" /* default */]
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WechatOutlined));

/***/ }),
/* 3451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WechatOutlined = { "name": "wechat", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WechatOutlined);


/***/ }),
/* 3452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboCircleFilled__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboCircleFilled__["a" /* default */]
  }));
};

WeiboCircleFilled.displayName = 'WeiboCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WeiboCircleFilled));

/***/ }),
/* 3453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WeiboCircleFilled = { "name": "weibo-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WeiboCircleFilled);


/***/ }),
/* 3454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboCircleOutlined__ = __webpack_require__(3455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboCircleOutlined__["a" /* default */]
  }));
};

WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WeiboCircleOutlined));

/***/ }),
/* 3455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WeiboCircleOutlined = { "name": "weibo-circle", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WeiboCircleOutlined);


/***/ }),
/* 3456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboOutlined__ = __webpack_require__(3457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WeiboOutlined = function WeiboOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboOutlined__["a" /* default */]
  }));
};

WeiboOutlined.displayName = 'WeiboOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WeiboOutlined));

/***/ }),
/* 3457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WeiboOutlined = { "name": "weibo", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 00-106-34.3 28.45 28.45 0 00-21.9 33.8 28.39 28.39 0 0033.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0111.3 53.3 28.45 28.45 0 0018.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 00-25.4 39.3 33.12 33.12 0 0039.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WeiboOutlined);


/***/ }),
/* 3458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboSquareFilled__ = __webpack_require__(3459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboSquareFilled__["a" /* default */]
  }));
};

WeiboSquareFilled.displayName = 'WeiboSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WeiboSquareFilled));

/***/ }),
/* 3459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WeiboSquareFilled = { "name": "weibo-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WeiboSquareFilled);


/***/ }),
/* 3460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboSquareOutlined__ = __webpack_require__(3461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WeiboSquareOutlined__["a" /* default */]
  }));
};

WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WeiboSquareOutlined));

/***/ }),
/* 3461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WeiboSquareOutlined = { "name": "weibo-square", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WeiboSquareOutlined);


/***/ }),
/* 3462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WhatsAppOutlined__ = __webpack_require__(3463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WhatsAppOutlined__["a" /* default */]
  }));
};

WhatsAppOutlined.displayName = 'WhatsAppOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WhatsAppOutlined));

/***/ }),
/* 3463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WhatsAppOutlined = { "name": "whats-app", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-.4-13.7-.4-21.1-.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z" } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WhatsAppOutlined);


/***/ }),
/* 3464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WifiOutlined__ = __webpack_require__(3465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WifiOutlined = function WifiOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WifiOutlined__["a" /* default */]
  }));
};

WifiOutlined.displayName = 'WifiOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WifiOutlined));

/***/ }),
/* 3465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WifiOutlined = { "name": "wifi", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 00-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 00-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 00-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 10128 0 64 64 0 10-128 0z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WifiOutlined);


/***/ }),
/* 3466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WindowsFilled__ = __webpack_require__(3467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WindowsFilled = function WindowsFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WindowsFilled__["a" /* default */]
  }));
};

WindowsFilled.displayName = 'WindowsFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WindowsFilled));

/***/ }),
/* 3467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WindowsFilled = { "name": "windows", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WindowsFilled);


/***/ }),
/* 3468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WindowsOutlined__ = __webpack_require__(3469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WindowsOutlined = function WindowsOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WindowsOutlined__["a" /* default */]
  }));
};

WindowsOutlined.displayName = 'WindowsOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WindowsOutlined));

/***/ }),
/* 3469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WindowsOutlined = { "name": "windows", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WindowsOutlined);


/***/ }),
/* 3470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WomanOutlined__ = __webpack_require__(3471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var WomanOutlined = function WomanOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_WomanOutlined__["a" /* default */]
  }));
};

WomanOutlined.displayName = 'WomanOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(WomanOutlined));

/***/ }),
/* 3471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var WomanOutlined = { "name": "woman", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (WomanOutlined);


/***/ }),
/* 3472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YahooFilled__ = __webpack_require__(3473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YahooFilled = function YahooFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YahooFilled__["a" /* default */]
  }));
};

YahooFilled.displayName = 'YahooFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YahooFilled));

/***/ }),
/* 3473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YahooFilled = { "name": "yahoo", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YahooFilled);


/***/ }),
/* 3474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YahooOutlined__ = __webpack_require__(3475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YahooOutlined = function YahooOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YahooOutlined__["a" /* default */]
  }));
};

YahooOutlined.displayName = 'YahooOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YahooOutlined));

/***/ }),
/* 3475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YahooOutlined = { "name": "yahoo", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YahooOutlined);


/***/ }),
/* 3476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YoutubeFilled__ = __webpack_require__(3477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YoutubeFilled = function YoutubeFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YoutubeFilled__["a" /* default */]
  }));
};

YoutubeFilled.displayName = 'YoutubeFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YoutubeFilled));

/***/ }),
/* 3477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YoutubeFilled = { "name": "youtube", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M941.3 296.1a112.3 112.3 0 00-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0082.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YoutubeFilled);


/***/ }),
/* 3478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YoutubeOutlined__ = __webpack_require__(3479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YoutubeOutlined__["a" /* default */]
  }));
};

YoutubeOutlined.displayName = 'YoutubeOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YoutubeOutlined));

/***/ }),
/* 3479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YoutubeOutlined = { "name": "youtube", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 00-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0082.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YoutubeOutlined);


/***/ }),
/* 3480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YuqueFilled__ = __webpack_require__(3481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YuqueFilled = function YuqueFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YuqueFilled__["a" /* default */]
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YuqueFilled));

/***/ }),
/* 3481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YuqueFilled = { "name": "yuque", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YuqueFilled);


/***/ }),
/* 3482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YuqueOutlined__ = __webpack_require__(3483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var YuqueOutlined = function YuqueOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_YuqueOutlined__["a" /* default */]
  }));
};

YuqueOutlined.displayName = 'YuqueOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(YuqueOutlined));

/***/ }),
/* 3483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var YuqueOutlined = { "name": "yuque", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (YuqueOutlined);


/***/ }),
/* 3484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuCircleFilled__ = __webpack_require__(3485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZhihuCircleFilled = function ZhihuCircleFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuCircleFilled__["a" /* default */]
  }));
};

ZhihuCircleFilled.displayName = 'ZhihuCircleFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ZhihuCircleFilled));

/***/ }),
/* 3485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ZhihuCircleFilled = { "name": "zhihu-circle", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ZhihuCircleFilled);


/***/ }),
/* 3486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuOutlined__ = __webpack_require__(3487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuOutlined__["a" /* default */]
  }));
};

ZhihuOutlined.displayName = 'ZhihuOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ZhihuOutlined));

/***/ }),
/* 3487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ZhihuOutlined = { "name": "zhihu", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ZhihuOutlined);


/***/ }),
/* 3488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuSquareFilled__ = __webpack_require__(3489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZhihuSquareFilled__["a" /* default */]
  }));
};

ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ZhihuSquareFilled));

/***/ }),
/* 3489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ZhihuSquareFilled = { "name": "zhihu-square", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ZhihuSquareFilled);


/***/ }),
/* 3490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZoomInOutlined__ = __webpack_require__(3491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZoomInOutlined__["a" /* default */]
  }));
};

ZoomInOutlined.displayName = 'ZoomInOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ZoomInOutlined));

/***/ }),
/* 3491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ZoomInOutlined = { "name": "zoom-in", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ZoomInOutlined);


/***/ }),
/* 3492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZoomOutOutlined__ = __webpack_require__(3493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__ = __webpack_require__(1);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_AntdIcon__["a" /* default */], Object.assign({}, props, {
    ref: ref,
    icon: __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_svg_es_asn_ZoomOutOutlined__["a" /* default */]
  }));
};

ZoomOutOutlined.displayName = 'ZoomOutOutlined';
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(ZoomOutOutlined));

/***/ }),
/* 3493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This icon file is generated automatically.
// tslint:disable
var ZoomOutOutlined = { "name": "zoom-out", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] } };
/* harmony default export */ __webpack_exports__["a"] = (ZoomOutOutlined);


/***/ }),
/* 3494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(578);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var customCache = new Set();
function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    var type = props.type,
        children = props.children,
        restProps = _objectWithoutProperties(props, ["type", "children"]); // children > type


    var content = null;

    if (props.type) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */], Object.assign({}, extraCommonProps, restProps), content);
  };

  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

/***/ }),
/* 3495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_transfer_style__ = __webpack_require__(3496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_transfer_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_transfer_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_transfer__ = __webpack_require__(3499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_transfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_steps_style__ = __webpack_require__(3511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_steps_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_steps_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_steps__ = __webpack_require__(3514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css__ = __webpack_require__(3528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__SimulationForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__ = __webpack_require__(36);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;var Step = __WEBPACK_IMPORTED_MODULE_21_antd_lib_steps___default.a.Step;var SimulationForm = function (_React$Component) {
  _inherits(SimulationForm, _React$Component);function SimulationForm(props) {
    var _this2 = this;_classCallCheck(this, SimulationForm);var _this = _possibleConstructorReturn(this, (SimulationForm.__proto__ || Object.getPrototypeOf(SimulationForm)).call(this, props));_this.getUsersList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentUserPage;var _ref2, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.prev = 0;_context.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_18" /* getSettingsUsersRequest */])({ page: page, per_page: _this.state.pageUserSize });case 3:
              _ref2 = _context.sent;data = _ref2.data;_this.setState({ usersList: data.data.map(function (user) {
                  return { key: user.id, title: user.username, description: user.username, chosen: false };
                }), total: data.total_pages * _this.state.pageUserSize, currentUserPage: page });_context.next = 14;break;case 8:
              _context.prev = 8;_context.t0 = _context['catch'](0);console.log(_context.t0);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context.t0, 'response.status') === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[0, 8]]);
    }));_this.getSitesList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref4, data;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.prev = 0;_context2.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_20" /* getSitesRequest */])();case 3:
              _ref4 = _context2.sent;data = _ref4.data;_this.setState({ siteList: data.map(function (site) {
                  return { key: site.id, title: site.code + ' - ' + site.name };
                }) });_context2.next = 14;break;case 8:
              _context2.prev = 8;_context2.t0 = _context2['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 13;break;
              }_this.props.logout();return _context2.abrupt('return');case 13:
              console.log(_context2.t0);case 14:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[0, 8]]);
    }));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee3(err, values) {
          var simulation, errors;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context3.next = 26;break;
                  }_this.setState({ isLoading: true });_context3.prev = 3;simulation = Object.assign({}, values);simulation.name = _this.state.name;simulation.user_ids = _this.state.userTargetKeys;simulation.site_ids = _this.state.siteTargetKeys;if (!_this.props.id) {
                    _context3.next = 13;break;
                  }_context3.next = 11;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_70" /* updateSimulationRequest */])(_this.props.id, simulation);case 11:
                  _context3.next = 15;break;case 13:
                  _context3.next = 15;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["z" /* createSimulationRequest */])(simulation);case 15:
                  _this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });setTimeout(function () {
                    _this.props.onSubmit(_this.props.id);
                  }, 1000);_context3.next = 26;break;case 19:
                  _context3.prev = 19;_context3.t0 = _context3['catch'](3);if (!(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                    _context3.next = 24;break;
                  }_this.props.logout();return _context3.abrupt('return');case 24:
                  _this.setState({ isLoading: false, requestResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context3.t0, 'response.data.message', 'Error') } });if (__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context3.t0, 'response.data.errors')) {
                    errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context3.t0, 'response.data.errors')).forEach(function (errorFieldKey) {
                      errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(_context3.t0, 'response.data.errors.' + errorFieldKey).map(function (errorMessage) {
                          return new Error(errorMessage);
                        }) };
                    });_this.props.form.setFields(errors);
                  }case 26:case 'end':
                  return _context3.stop();}
            }
          }, _callee3, _this2, [[3, 19]]);
        }));return function (_x2, _x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    };_this.onPrev = function () {
      _this.setState(function (state) {
        return { currentStep: state.currentStep - 1 };
      });
    };_this.onNext = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this$props$form, validateFields, getFieldValue, name;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {case 0:
              _this$props$form = _this.props.form, validateFields = _this$props$form.validateFields, getFieldValue = _this$props$form.getFieldValue;name = getFieldValue('name') || _this.state.name;_context4.prev = 2;_context4.next = 5;return validateFields();case 5:
              _this.setState(function (state) {
                return { currentStep: state.currentStep + 1, name: name };
              });_context4.next = 10;break;case 8:
              _context4.prev = 8;_context4.t0 = _context4['catch'](2);case 10:case 'end':
              return _context4.stop();}
        }
      }, _callee4, _this2, [[2, 8]]);
    }));_this.handleTransferChange = function (targetName) {
      return function (targetKeys) {
        _this.setState(_defineProperty({}, targetName, targetKeys));
      };
    };_this.state = { isLoading: false, usersList: [], userTargetKeys: props.user_ids || [], siteList: [], siteTargetKeys: props.site_ids || [], requestResult: {}, currentStep: 0, currentUserPage: 1, total: 1, pageUserSize: 1000, name: '' };return _this;
  }_createClass(SimulationForm, [{ key: 'componentDidMount', value: function componentDidMount() {
      this.getUsersList();this.getSitesList();
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult,
          currentStep = _state.currentStep,
          usersList = _state.usersList,
          userTargetKeys = _state.userTargetKeys,
          siteList = _state.siteList,
          siteTargetKeys = _state.siteTargetKeys;var getFieldDecorator = this.props.form.getFieldDecorator;var _props = this.props,
          simulationUpdatePermission = _props.simulationUpdatePermission,
          simulationCreatePermission = _props.simulationCreatePermission,
          id = _props.id,
          isNew = _props.isNew;var isEditable = id ? simulationUpdatePermission : simulationCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('h4', { className: 'headline-default' }, this.props.id ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('span', null, this.props.name, ' ', __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_badge___default.a, { count: 'Edit', style: { backgroundColor: '#2968AE' } })) : isNew ? 'Add simulation' : ''), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_steps___default.a, { current: currentStep }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Step, { title: 'Step 1', description: 'Edit name' }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Step, { title: 'Step 2', description: 'Sites and users' }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Step, { title: 'Step 3', description: 'Edit simulation' })), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('br', null), currentStep === 0 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Name:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('name', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.state, 'name') || __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'name', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Name' }))))))), currentStep === 1 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Select users:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('user_ids', { rules: [{ required: true, message: 'Required' }], initialValue: this.state.userTargetKeys && this.state.userTargetKeys.length > 0 ? this.state.userTargetKeys : __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'user_ids', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_transfer___default.a, { dataSource: usersList, targetKeys: userTargetKeys, onChange: this.handleTransferChange('userTargetKeys'), showSearch: true, render: function render(item) {
          return item.title;
        }, listStyle: { height: 250 } }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Select sites:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('site_ids', { rules: [{ required: true, message: 'Required' }], initialValue: this.state.siteTargetKeys && this.state.siteTargetKeys.length > 0 ? this.state.siteTargetKeys : __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'site_ids', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_transfer___default.a, { dataSource: siteList, targetKeys: siteTargetKeys, onChange: this.handleTransferChange('siteTargetKeys'), showSearch: true, render: function render(item) {
          return item.title;
        }, listStyle: { height: 250 } }))))))), currentStep === 2 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Number of patients:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('subject_count', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'subject_count', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Subject count' }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Number of Simulations:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('simulation_count', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'simulation_count', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { disabled: !isEditable, placeholder: 'Simulation count' }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Min weight:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('min_weight', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'min_weight', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, { disabled: !isEditable, placeholder: 'Simulation count' }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Max weight:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('max_weight', { rules: [{ required: true }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'max_weight', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, { disabled: !isEditable, placeholder: 'Simulation count' }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a, { lg: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('b', null, 'Status:'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, getFieldDecorator('status', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_26_lodash_get___default()(this.props, 'status', 'not_started') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { placeholder: 'Select' }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'not_started' }, 'Draft'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: 'ready' }, 'Ready'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { disabled: true, value: 'in_progress' }, 'In progress'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { disabled: true, value: 'completed' }, 'Completed')))))))), requestResult.type && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.actionWrapper }, isEditable && currentStep !== 0 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.submitButton, onClick: this.onPrev }, 'Prev', isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), isEditable && currentStep === 2 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', htmlType: 'submit', className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.submitButton }, 'Save', isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'loading' })), '\xA0 \xA0'), isEditable && currentStep !== 2 && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'primary', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.submitButton, onClick: this.onNext }, 'Next'), '\xA0 \xA0'), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, { type: 'default', htmlType: 'button', className: __WEBPACK_IMPORTED_MODULE_30__SimulationForm_css___default.a.submitButton, onClick: this.props.onCancel }, 'Cancel')))));
    } }]);return SimulationForm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { simulationCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_48" /* getSimulationCreatePermission */])(state), simulationUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_29__reducers_user_selectors__["_51" /* getSimulationUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_31__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.create({ name: 'simulation' })(Object(__WEBPACK_IMPORTED_MODULE_27_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(SimulationForm)));

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(3497);

__webpack_require__(209);

__webpack_require__(47);

__webpack_require__(11);

__webpack_require__(13);
//# sourceMappingURL=index.js.map


/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3498);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-transfer-customize-list {\n  display: flex;\n}\n.ant-transfer-customize-list .ant-transfer-operation {\n  flex: none;\n  align-self: center;\n}\n.ant-transfer-customize-list .ant-transfer-list {\n  flex: auto;\n  width: auto;\n  height: auto;\n  min-height: 200px;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-with-search {\n  padding-top: 0;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-search-wrapper {\n  position: relative;\n  padding-bottom: 0;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-customize-wrapper {\n  padding: 12px;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {\n  border: 0;\n  border-radius: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {\n  background: #fafafa;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {\n  margin: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {\n  margin: 16px 0 4px;\n}\n.ant-transfer {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n}\n.ant-transfer-disabled .ant-transfer-list {\n  background: #f5f5f5;\n}\n.ant-transfer-list {\n  position: relative;\n  display: inline-block;\n  width: 180px;\n  height: 200px;\n  padding-top: 40px;\n  vertical-align: middle;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n}\n.ant-transfer-list-with-footer {\n  padding-bottom: 34px;\n}\n.ant-transfer-list-search {\n  padding: 0 24px 0 8px;\n}\n.ant-transfer-list-search-action {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  bottom: 12px;\n  width: 28px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 32px;\n  text-align: center;\n}\n.ant-transfer-list-search-action .anticon {\n  color: rgba(0, 0, 0, 0.25);\n  transition: all 0.3s;\n}\n.ant-transfer-list-search-action .anticon:hover {\n  color: rgba(0, 0, 0, 0.45);\n}\nspan.ant-transfer-list-search-action {\n  pointer-events: none;\n}\n.ant-transfer-list-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 8px 12px 9px;\n  overflow: hidden;\n  color: #424242;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 4px 4px 0 0;\n}\n.ant-transfer-list-header-title {\n  position: absolute;\n  right: 12px;\n}\n.ant-transfer-list-header .ant-checkbox-wrapper + span {\n  padding-left: 8px;\n}\n.ant-transfer-list-body {\n  position: relative;\n  height: 100%;\n  font-size: 14px;\n}\n.ant-transfer-list-body-search-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 12px;\n}\n.ant-transfer-list-body-with-search {\n  padding-top: 56px;\n}\n.ant-transfer-list-content {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  list-style: none;\n}\n.ant-transfer-list-content > .LazyLoad {\n  animation: transferHighlightIn 1s;\n}\n.ant-transfer-list-content-item {\n  min-height: 32px;\n  padding: 6px 12px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-transfer-list-content-item > span {\n  padding-right: 0;\n}\n.ant-transfer-list-content-item-text {\n  padding-left: 8px;\n}\n.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {\n  background-color: #f0fffe;\n  cursor: pointer;\n}\n.ant-transfer-list-content-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-transfer-list-body-not-found {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 0;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n  transform: translateY(-50%);\n}\n.ant-transfer-list-body-with-search .ant-transfer-list-body-not-found {\n  margin-top: 16px;\n}\n.ant-transfer-list-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 4px 4px;\n}\n.ant-transfer-operation {\n  display: inline-block;\n  margin: 0 8px;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.ant-transfer-operation .ant-btn {\n  display: block;\n}\n.ant-transfer-operation .ant-btn:first-child {\n  margin-bottom: 4px;\n}\n.ant-transfer-operation .ant-btn .anticon {\n  font-size: 12px;\n}\n@keyframes transferHighlightIn {\n  0% {\n    background: #f0ffff;\n  }\n  100% {\n    background: transparent;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(38);

var _list = _interopRequireDefault(__webpack_require__(3500));

var _operation = _interopRequireDefault(__webpack_require__(3510));

var _search = _interopRequireDefault(__webpack_require__(580));

var _warning = _interopRequireDefault(__webpack_require__(55));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(83));

var _default2 = _interopRequireDefault(__webpack_require__(158));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Transfer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Transfer, _React$Component);

  function Transfer(props) {
    var _this;

    _classCallCheck(this, Transfer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Transfer).call(this, props));
    _this.separatedDataSource = null;

    _this.getLocale = function (transferLocale, renderEmpty) {
      // Keep old locale props still working.
      var oldLocale = {
        notFoundContent: renderEmpty('Transfer')
      };

      if ('notFoundContent' in _this.props) {
        oldLocale.notFoundContent = _this.props.notFoundContent;
      }

      if ('searchPlaceholder' in _this.props) {
        oldLocale.searchPlaceholder = _this.props.searchPlaceholder;
      }

      return _extends(_extends(_extends({}, transferLocale), oldLocale), _this.props.locale);
    };

    _this.moveTo = function (direction) {
      var _this$props = _this.props,
          _this$props$targetKey = _this$props.targetKeys,
          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
          _this$props$dataSourc = _this$props.dataSource,
          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
          onChange = _this$props.onChange;
      var _this$state = _this.state,
          sourceSelectedKeys = _this$state.sourceSelectedKeys,
          targetSelectedKeys = _this$state.targetSelectedKeys;
      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options

      var newMoveKeys = moveKeys.filter(function (key) {
        return !dataSource.some(function (data) {
          return !!(key === data.key && data.disabled);
        });
      }); // move items to target box

      var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
        return newMoveKeys.indexOf(targetKey) === -1;
      }); // empty checked keys

      var oppositeDirection = direction === 'right' ? 'left' : 'right';

      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));

      _this.handleSelectChange(oppositeDirection, []);

      if (onChange) {
        onChange(newTargetKeys, direction, newMoveKeys);
      }
    };

    _this.moveToLeft = function () {
      return _this.moveTo('left');
    };

    _this.moveToRight = function () {
      return _this.moveTo('right');
    };

    _this.onItemSelectAll = function (direction, selectedKeys, checkAll) {
      var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
      var mergedCheckedKeys = [];

      if (checkAll) {
        // Merge current keys with origin key
        mergedCheckedKeys = Array.from(new Set([].concat(_toConsumableArray(originalSelectedKeys), _toConsumableArray(selectedKeys))));
      } else {
        // Remove current keys from origin keys
        mergedCheckedKeys = originalSelectedKeys.filter(function (key) {
          return selectedKeys.indexOf(key) === -1;
        });
      }

      _this.handleSelectChange(direction, mergedCheckedKeys);

      if (!_this.props.selectedKeys) {
        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), mergedCheckedKeys));
      }
    };

    _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
      (0, _warning["default"])(false, 'Transfer', '`handleSelectAll` will be removed, please use `onSelectAll` instead.');

      _this.onItemSelectAll(direction, filteredDataSource.map(function (_ref) {
        var key = _ref.key;
        return key;
      }), !checkAll);
    }; // [Legacy] Old prop `body` pass origin check as arg. It's confusing.
    // TODO: Remove this in next version.


    _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
      return _this.handleSelectAll('left', filteredDataSource, !checkAll);
    };

    _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
      return _this.handleSelectAll('right', filteredDataSource, !checkAll);
    };

    _this.onLeftItemSelectAll = function (selectedKeys, checkAll) {
      return _this.onItemSelectAll('left', selectedKeys, checkAll);
    };

    _this.onRightItemSelectAll = function (selectedKeys, checkAll) {
      return _this.onItemSelectAll('right', selectedKeys, checkAll);
    };

    _this.handleFilter = function (direction, e) {
      var _this$props2 = _this.props,
          onSearchChange = _this$props2.onSearchChange,
          onSearch = _this$props2.onSearch;
      var value = e.target.value;

      if (onSearchChange) {
        (0, _warning["default"])(false, 'Transfer', '`onSearchChange` is deprecated. Please use `onSearch` instead.');
        onSearchChange(direction, e);
      }

      if (onSearch) {
        onSearch(direction, value);
      }
    };

    _this.handleLeftFilter = function (e) {
      return _this.handleFilter('left', e);
    };

    _this.handleRightFilter = function (e) {
      return _this.handleFilter('right', e);
    };

    _this.handleClear = function (direction) {
      var onSearch = _this.props.onSearch;

      if (onSearch) {
        onSearch(direction, '');
      }
    };

    _this.handleLeftClear = function () {
      return _this.handleClear('left');
    };

    _this.handleRightClear = function () {
      return _this.handleClear('right');
    };

    _this.onItemSelect = function (direction, selectedKey, checked) {
      var _this$state2 = _this.state,
          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
          targetSelectedKeys = _this$state2.targetSelectedKeys;
      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
      var index = holder.indexOf(selectedKey);

      if (index > -1) {
        holder.splice(index, 1);
      }

      if (checked) {
        holder.push(selectedKey);
      }

      _this.handleSelectChange(direction, holder);

      if (!_this.props.selectedKeys) {
        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
      }
    };

    _this.handleSelect = function (direction, selectedItem, checked) {
      (0, _warning["default"])(false, 'Transfer', '`handleSelect` will be removed, please use `onSelect` instead.');

      _this.onItemSelect(direction, selectedItem.key, checked);
    };

    _this.handleLeftSelect = function (selectedItem, checked) {
      return _this.handleSelect('left', selectedItem, checked);
    };

    _this.handleRightSelect = function (selectedItem, checked) {
      return _this.handleSelect('right', selectedItem, checked);
    };

    _this.onLeftItemSelect = function (selectedKey, checked) {
      return _this.onItemSelect('left', selectedKey, checked);
    };

    _this.onRightItemSelect = function (selectedKey, checked) {
      return _this.onItemSelect('right', selectedKey, checked);
    };

    _this.handleScroll = function (direction, e) {
      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(direction, e);
      }
    };

    _this.handleLeftScroll = function (e) {
      return _this.handleScroll('left', e);
    };

    _this.handleRightScroll = function (e) {
      return _this.handleScroll('right', e);
    };

    _this.handleListStyle = function (listStyle, direction) {
      if (typeof listStyle === 'function') {
        return listStyle({
          direction: direction
        });
      }

      return listStyle;
    };

    _this.renderTransfer = function (transferLocale) {
      return React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
        var _classNames;

        var getPrefixCls = _ref2.getPrefixCls,
            renderEmpty = _ref2.renderEmpty;
        var _this$props3 = _this.props,
            customizePrefixCls = _this$props3.prefixCls,
            className = _this$props3.className,
            disabled = _this$props3.disabled,
            _this$props3$operatio = _this$props3.operations,
            operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
            showSearch = _this$props3.showSearch,
            body = _this$props3.body,
            footer = _this$props3.footer,
            style = _this$props3.style,
            listStyle = _this$props3.listStyle,
            operationStyle = _this$props3.operationStyle,
            filterOption = _this$props3.filterOption,
            render = _this$props3.render,
            lazy = _this$props3.lazy,
            children = _this$props3.children,
            showSelectAll = _this$props3.showSelectAll;
        var prefixCls = getPrefixCls('transfer', customizePrefixCls);

        var locale = _this.getLocale(transferLocale, renderEmpty);

        var _this$state3 = _this.state,
            sourceSelectedKeys = _this$state3.sourceSelectedKeys,
            targetSelectedKeys = _this$state3.targetSelectedKeys;

        var _this$separateDataSou = _this.separateDataSource(),
            leftDataSource = _this$separateDataSou.leftDataSource,
            rightDataSource = _this$separateDataSou.rightDataSource;

        var leftActive = targetSelectedKeys.length > 0;
        var rightActive = sourceSelectedKeys.length > 0;
        var cls = (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-customize-list"), !!children), _classNames));

        var titles = _this.getTitles(locale);

        return React.createElement("div", {
          className: cls,
          style: style
        }, React.createElement(_list["default"], _extends({
          prefixCls: "".concat(prefixCls, "-list"),
          titleText: titles[0],
          dataSource: leftDataSource,
          filterOption: filterOption,
          style: _this.handleListStyle(listStyle, 'left'),
          checkedKeys: sourceSelectedKeys,
          handleFilter: _this.handleLeftFilter,
          handleClear: _this.handleLeftClear,
          handleSelect: _this.handleLeftSelect,
          handleSelectAll: _this.handleLeftSelectAll,
          onItemSelect: _this.onLeftItemSelect,
          onItemSelectAll: _this.onLeftItemSelectAll,
          render: render,
          showSearch: showSearch,
          body: body,
          renderList: children,
          footer: footer,
          lazy: lazy,
          onScroll: _this.handleLeftScroll,
          disabled: disabled,
          direction: "left",
          showSelectAll: showSelectAll
        }, locale)), React.createElement(_operation["default"], {
          className: "".concat(prefixCls, "-operation"),
          rightActive: rightActive,
          rightArrowText: operations[0],
          moveToRight: _this.moveToRight,
          leftActive: leftActive,
          leftArrowText: operations[1],
          moveToLeft: _this.moveToLeft,
          style: operationStyle,
          disabled: disabled
        }), React.createElement(_list["default"], _extends({
          prefixCls: "".concat(prefixCls, "-list"),
          titleText: titles[1],
          dataSource: rightDataSource,
          filterOption: filterOption,
          style: _this.handleListStyle(listStyle, 'right'),
          checkedKeys: targetSelectedKeys,
          handleFilter: _this.handleRightFilter,
          handleClear: _this.handleRightClear,
          handleSelect: _this.handleRightSelect,
          handleSelectAll: _this.handleRightSelectAll,
          onItemSelect: _this.onRightItemSelect,
          onItemSelectAll: _this.onRightItemSelectAll,
          render: render,
          showSearch: showSearch,
          body: body,
          renderList: children,
          footer: footer,
          lazy: lazy,
          onScroll: _this.handleRightScroll,
          disabled: disabled,
          direction: "right",
          showSelectAll: showSelectAll
        }, locale)));
      });
    };

    (0, _warning["default"])(!('notFoundContent' in props || 'searchPlaceholder' in props), 'Transfer', '`notFoundContent` and `searchPlaceholder` will be removed, ' + 'please use `locale` instead.');
    (0, _warning["default"])(!('body' in props), 'Transfer', '`body` is internal usage and will bre removed, please use `children` instead.');
    var _props$selectedKeys = props.selectedKeys,
        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
        _props$targetKeys = props.targetKeys,
        targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;
    _this.state = {
      sourceSelectedKeys: selectedKeys.filter(function (key) {
        return targetKeys.indexOf(key) === -1;
      }),
      targetSelectedKeys: selectedKeys.filter(function (key) {
        return targetKeys.indexOf(key) > -1;
      })
    };
    return _this;
  }

  _createClass(Transfer, [{
    key: "getSelectedKeysName",
    // eslint-disable-next-line
    value: function getSelectedKeysName(direction) {
      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
    }
  }, {
    key: "getTitles",
    value: function getTitles(transferLocale) {
      var props = this.props;

      if (props.titles) {
        return props.titles;
      }

      return transferLocale.titles;
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(direction, holder) {
      var _this$state4 = this.state,
          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
          targetSelectedKeys = _this$state4.targetSelectedKeys;
      var onSelectChange = this.props.onSelectChange;

      if (!onSelectChange) {
        return;
      }

      if (direction === 'left') {
        onSelectChange(holder, targetSelectedKeys);
      } else {
        onSelectChange(sourceSelectedKeys, holder);
      }
    }
  }, {
    key: "separateDataSource",
    value: function separateDataSource() {
      var _this$props4 = this.props,
          dataSource = _this$props4.dataSource,
          rowKey = _this$props4.rowKey,
          _this$props4$targetKe = _this$props4.targetKeys,
          targetKeys = _this$props4$targetKe === void 0 ? [] : _this$props4$targetKe;
      var leftDataSource = [];
      var rightDataSource = new Array(targetKeys.length);
      dataSource.forEach(function (record) {
        if (rowKey) {
          record.key = rowKey(record);
        } // rightDataSource should be ordered by targetKeys
        // leftDataSource should be ordered by dataSource


        var indexOfKey = targetKeys.indexOf(record.key);

        if (indexOfKey !== -1) {
          rightDataSource[indexOfKey] = record;
        } else {
          leftDataSource.push(record);
        }
      });
      return {
        leftDataSource: leftDataSource,
        rightDataSource: rightDataSource
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_LocaleReceiver["default"], {
        componentName: "Transfer",
        defaultLocale: _default2["default"].Transfer
      }, this.renderTransfer);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.selectedKeys) {
        var targetKeys = nextProps.targetKeys || [];
        return {
          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return !targetKeys.includes(key);
          }),
          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return targetKeys.includes(key);
          })
        };
      }

      return null;
    }
  }]);

  return Transfer;
}(React.Component); // For high-level customized Transfer @dqaria


Transfer.List = _list["default"];
Transfer.Operation = _operation["default"];
Transfer.Search = _search["default"];
Transfer.defaultProps = {
  dataSource: [],
  locale: {},
  showSearch: false,
  listStyle: function listStyle() {}
};
Transfer.propTypes = {
  prefixCls: PropTypes.string,
  disabled: PropTypes.bool,
  dataSource: PropTypes.array,
  render: PropTypes.func,
  targetKeys: PropTypes.array,
  onChange: PropTypes.func,
  height: PropTypes.number,
  style: PropTypes.object,
  listStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  operationStyle: PropTypes.object,
  className: PropTypes.string,
  titles: PropTypes.array,
  operations: PropTypes.array,
  showSearch: PropTypes.bool,
  filterOption: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  notFoundContent: PropTypes.node,
  locale: PropTypes.object,
  body: PropTypes.func,
  footer: PropTypes.func,
  rowKey: PropTypes.func,
  lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};
(0, _reactLifecyclesCompat.polyfill)(Transfer);
var _default = Transfer;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(26));

var _omit = _interopRequireDefault(__webpack_require__(56));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _PureRenderMixin = _interopRequireDefault(__webpack_require__(579));

var _checkbox = _interopRequireDefault(__webpack_require__(46));

var _search = _interopRequireDefault(__webpack_require__(580));

var _renderListBody = _interopRequireWildcard(__webpack_require__(3501));

var _triggerEvent = _interopRequireDefault(__webpack_require__(3509));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var defaultRender = function defaultRender() {
  return null;
};

function isRenderResultPlainObject(result) {
  return result && !React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
}

function renderListNode(renderList, props) {
  var bodyContent = renderList ? renderList(props) : null;
  var customize = !!bodyContent;

  if (!customize) {
    bodyContent = (0, _renderListBody["default"])(props);
  }

  return {
    customize: customize,
    bodyContent: bodyContent
  };
}

var TransferList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TransferList, _React$Component);

  function TransferList(props) {
    var _this;

    _classCallCheck(this, TransferList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransferList).call(this, props));

    _this.handleFilter = function (e) {
      var handleFilter = _this.props.handleFilter;
      var filterValue = e.target.value;

      _this.setState({
        filterValue: filterValue
      });

      handleFilter(e);

      if (!filterValue) {
        return;
      } // Manually trigger scroll event for lazy search bug
      // https://github.com/ant-design/ant-design/issues/5631


      _this.triggerScrollTimer = window.setTimeout(function () {
        var transferNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];

        if (listNode) {
          (0, _triggerEvent["default"])(listNode, 'scroll');
        }
      }, 0);
    };

    _this.handleClear = function () {
      var handleClear = _this.props.handleClear;

      _this.setState({
        filterValue: ''
      });

      handleClear();
    };

    _this.matchFilter = function (text, item) {
      var filterValue = _this.state.filterValue;
      var filterOption = _this.props.filterOption;

      if (filterOption) {
        return filterOption(filterValue, item);
      }

      return text.indexOf(filterValue) >= 0;
    };

    _this.renderItem = function (item) {
      var _this$props$render = _this.props.render,
          render = _this$props$render === void 0 ? defaultRender : _this$props$render;
      var renderResult = render(item);
      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
      return {
        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
        item: item
      };
    };

    _this.state = {
      filterValue: ''
    };
    return _this;
  }

  _createClass(TransferList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.triggerScrollTimer);
    }
  }, {
    key: "getCheckStatus",
    value: function getCheckStatus(filteredItems) {
      var checkedKeys = this.props.checkedKeys;

      if (checkedKeys.length === 0) {
        return 'none';
      }

      if (filteredItems.every(function (item) {
        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
      })) {
        return 'all';
      }

      return 'part';
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems(dataSource, filterValue) {
      var _this2 = this;

      var filteredItems = [];
      var filteredRenderItems = [];
      dataSource.forEach(function (item) {
        var renderedItem = _this2.renderItem(item);

        var renderedText = renderedItem.renderedText; // Filter skip

        if (filterValue && filterValue.trim() && !_this2.matchFilter(renderedText, item)) {
          return null;
        }

        filteredItems.push(item);
        filteredRenderItems.push(renderedItem);
      });
      return {
        filteredItems: filteredItems,
        filteredRenderItems: filteredRenderItems
      };
    }
  }, {
    key: "getListBody",
    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
      var search = showSearch ? React.createElement("div", {
        className: "".concat(prefixCls, "-body-search-wrapper")
      }, React.createElement(_search["default"], {
        prefixCls: "".concat(prefixCls, "-search"),
        onChange: this.handleFilter,
        handleClear: this.handleClear,
        placeholder: searchPlaceholder,
        value: filterValue,
        disabled: disabled
      })) : null;
      var listBody = bodyDom;

      if (!listBody) {
        var bodyNode;

        var _renderListNode = renderListNode(renderList, _extends(_extends({}, (0, _omit["default"])(this.props, _renderListBody.OmitProps)), {
          filteredItems: filteredItems,
          filteredRenderItems: filteredRenderItems,
          selectedKeys: checkedKeys
        })),
            bodyContent = _renderListNode.bodyContent,
            customize = _renderListNode.customize; // We should wrap customize list body in a classNamed div to use flex layout.


        if (customize) {
          bodyNode = React.createElement("div", {
            className: "".concat(prefixCls, "-body-customize-wrapper")
          }, bodyContent);
        } else {
          bodyNode = filteredItems.length ? bodyContent : React.createElement("div", {
            className: "".concat(prefixCls, "-body-not-found")
          }, notFoundContent);
        }

        listBody = React.createElement("div", {
          className: (0, _classnames["default"])(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
        }, search, bodyNode);
      }

      return listBody;
    }
  }, {
    key: "getCheckBox",
    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled) {
      var checkStatus = this.getCheckStatus(filteredItems);
      var checkedAll = checkStatus === 'all';
      var checkAllCheckbox = showSelectAll !== false && React.createElement(_checkbox["default"], {
        disabled: disabled,
        checked: checkedAll,
        indeterminate: checkStatus === 'part',
        onChange: function onChange() {
          // Only select enabled items
          onItemSelectAll(filteredItems.filter(function (item) {
            return !item.disabled;
          }).map(function (_ref) {
            var key = _ref.key;
            return key;
          }), !checkedAll);
        }
      });
      return checkAllCheckbox;
    }
  }, {
    key: "render",
    value: function render() {
      var filterValue = this.state.filterValue;
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          dataSource = _this$props.dataSource,
          titleText = _this$props.titleText,
          checkedKeys = _this$props.checkedKeys,
          disabled = _this$props.disabled,
          body = _this$props.body,
          footer = _this$props.footer,
          showSearch = _this$props.showSearch,
          style = _this$props.style,
          searchPlaceholder = _this$props.searchPlaceholder,
          notFoundContent = _this$props.notFoundContent,
          itemUnit = _this$props.itemUnit,
          itemsUnit = _this$props.itemsUnit,
          renderList = _this$props.renderList,
          onItemSelectAll = _this$props.onItemSelectAll,
          showSelectAll = _this$props.showSelectAll; // Custom Layout

      var footerDom = footer && footer(this.props);
      var bodyDom = body && body(this.props);
      var listCls = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerDom)); // ====================== Get filtered, checked item list ======================

      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue),
          filteredItems = _this$getFilteredItem.filteredItems,
          filteredRenderItems = _this$getFilteredItem.filteredRenderItems; // ================================= List Body =================================


      var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled); // ================================ List Footer ================================

      var listFooter = footerDom ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footerDom) : null;
      var checkAllCheckbox = this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled); // ================================== Render ===================================

      return React.createElement("div", {
        className: listCls,
        style: style
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, checkAllCheckbox, React.createElement("span", {
        className: "".concat(prefixCls, "-header-selected")
      }, React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + filteredItems.length, ' ', unit), React.createElement("span", {
        className: "".concat(prefixCls, "-header-title")
      }, titleText))), listBody, listFooter);
    }
  }]);

  return TransferList;
}(React.Component);

exports["default"] = TransferList;
TransferList.defaultProps = {
  dataSource: [],
  titleText: '',
  showSearch: false,
  lazy: {}
};
//# sourceMappingURL=list.js.map


/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OmitProps = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(26);

var _rcAnimate = _interopRequireDefault(__webpack_require__(90));

var _raf = _interopRequireDefault(__webpack_require__(198));

var _type = __webpack_require__(81);

var _ListItem = _interopRequireDefault(__webpack_require__(3502));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var OmitProps = (0, _type.tuple)('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
exports.OmitProps = OmitProps;

var ListBody =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListBody, _React$Component);

  function ListBody() {
    var _this;

    _classCallCheck(this, ListBody);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListBody).apply(this, arguments));
    _this.state = {
      mounted: false
    };

    _this.onItemSelect = function (item) {
      var _this$props = _this.props,
          onItemSelect = _this$props.onItemSelect,
          selectedKeys = _this$props.selectedKeys;
      var checked = selectedKeys.indexOf(item.key) >= 0;
      onItemSelect(item.key, !checked);
    };

    return _this;
  }

  _createClass(ListBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mountId = (0, _raf["default"])(function () {
        _this2.setState({
          mounted: true
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          filteredRenderItems = _this$props2.filteredRenderItems,
          lazy = _this$props2.lazy;

      if (prevProps.filteredRenderItems.length !== filteredRenderItems.length && lazy !== false) {
        // TODO: Replace this with ref when react 15 support removed.
        var container = (0, _reactDom.findDOMNode)(this);

        _raf["default"].cancel(this.lazyId);

        this.lazyId = (0, _raf["default"])(function () {
          if (container) {
            var scrollEvent = new Event('scroll', {
              bubbles: true
            });
            container.dispatchEvent(scrollEvent);
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.mountId);

      _raf["default"].cancel(this.lazyId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var mounted = this.state.mounted;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          onScroll = _this$props3.onScroll,
          filteredRenderItems = _this$props3.filteredRenderItems,
          lazy = _this$props3.lazy,
          selectedKeys = _this$props3.selectedKeys,
          globalDisabled = _this$props3.disabled;
      return React.createElement(_rcAnimate["default"], {
        component: "ul",
        componentProps: {
          onScroll: onScroll
        },
        className: "".concat(prefixCls, "-content"),
        transitionName: mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
        transitionLeave: false
      }, filteredRenderItems.map(function (_ref) {
        var renderedEl = _ref.renderedEl,
            renderedText = _ref.renderedText,
            item = _ref.item;
        var disabled = item.disabled;
        var checked = selectedKeys.indexOf(item.key) >= 0;
        return React.createElement(_ListItem["default"], {
          disabled: globalDisabled || disabled,
          key: item.key,
          item: item,
          lazy: lazy,
          renderedText: renderedText,
          renderedEl: renderedEl,
          checked: checked,
          prefixCls: prefixCls,
          onClick: _this3.onItemSelect
        });
      }));
    }
  }]);

  return ListBody;
}(React.Component);

var ListBodyWrapper = function ListBodyWrapper(props) {
  return React.createElement(ListBody, props);
};

var _default = ListBodyWrapper;
exports["default"] = _default;
//# sourceMappingURL=renderListBody.js.map


/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _PureRenderMixin = _interopRequireDefault(__webpack_require__(579));

var _reactLazyLoad = _interopRequireDefault(__webpack_require__(3503));

var _checkbox = _interopRequireDefault(__webpack_require__(46));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListItem, _React$Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItem).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          renderedText = _this$props.renderedText,
          renderedEl = _this$props.renderedEl,
          item = _this$props.item,
          lazy = _this$props.lazy,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          prefixCls = _this$props.prefixCls,
          onClick = _this$props.onClick;
      var className = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _classNames));
      var title;

      if (typeof renderedText === 'string' || typeof renderedText === 'number') {
        title = String(renderedText);
      }

      var listItem = React.createElement("li", {
        className: className,
        title: title,
        onClick: disabled || item.disabled ? undefined : function () {
          return onClick(item);
        }
      }, React.createElement(_checkbox["default"], {
        checked: checked,
        disabled: disabled || item.disabled
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-content-item-text")
      }, renderedEl));
      var children = null;

      if (lazy) {
        var lazyProps = _extends({
          height: 32,
          offset: 500,
          throttle: 0,
          debounce: false
        }, lazy);

        children = React.createElement(_reactLazyLoad["default"], lazyProps, listItem);
      } else {
        children = listItem;
      }

      return children;
    }
  }]);

  return ListItem;
}(React.Component);

exports["default"] = ListItem;
//# sourceMappingURL=ListItem.js.map


/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(26);

var _eventlistener = __webpack_require__(3504);

var _lodash = __webpack_require__(428);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(3505);

var _lodash4 = _interopRequireDefault(_lodash3);

var _parentScroll = __webpack_require__(3506);

var _parentScroll2 = _interopRequireDefault(_parentScroll);

var _inViewport = __webpack_require__(3507);

var _inViewport2 = _interopRequireDefault(_inViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);

    if (props.throttle > 0) {
      if (props.debounce) {
        _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler, props.throttle);
      } else {
        _this.lazyLoadHandler = (0, _lodash4.default)(_this.lazyLoadHandler, props.throttle);
      }
    }

    _this.state = { visible: false };
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._mounted = true;
      var eventNode = this.getEventNode();

      this.lazyLoadHandler();

      if (this.lazyLoadHandler.flush) {
        this.lazyLoadHandler.flush();
      }

      (0, _eventlistener.add)(window, 'resize', this.lazyLoadHandler);
      (0, _eventlistener.add)(eventNode, 'scroll', this.lazyLoadHandler);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (!this.state.visible) {
        this.lazyLoadHandler();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_nextProps, nextState) {
      return nextState.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
      if (this.lazyLoadHandler.cancel) {
        this.lazyLoadHandler.cancel();
      }

      this.detachListeners();
    }
  }, {
    key: 'getEventNode',
    value: function getEventNode() {
      return (0, _parentScroll2.default)((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'getOffset',
    value: function getOffset() {
      var _props = this.props,
          offset = _props.offset,
          offsetVertical = _props.offsetVertical,
          offsetHorizontal = _props.offsetHorizontal,
          offsetTop = _props.offsetTop,
          offsetBottom = _props.offsetBottom,
          offsetLeft = _props.offsetLeft,
          offsetRight = _props.offsetRight,
          threshold = _props.threshold;


      var _offsetAll = threshold || offset;
      var _offsetVertical = offsetVertical || _offsetAll;
      var _offsetHorizontal = offsetHorizontal || _offsetAll;

      return {
        top: offsetTop || _offsetVertical,
        bottom: offsetBottom || _offsetVertical,
        left: offsetLeft || _offsetHorizontal,
        right: offsetRight || _offsetHorizontal
      };
    }
  }, {
    key: 'lazyLoadHandler',
    value: function lazyLoadHandler() {
      if (!this._mounted) {
        return;
      }
      var offset = this.getOffset();
      var node = (0, _reactDom.findDOMNode)(this);
      var eventNode = this.getEventNode();

      if ((0, _inViewport2.default)(node, eventNode, offset)) {
        var onContentVisible = this.props.onContentVisible;


        this.setState({ visible: true }, function () {
          if (onContentVisible) {
            onContentVisible();
          }
        });
        this.detachListeners();
      }
    }
  }, {
    key: 'detachListeners',
    value: function detachListeners() {
      var eventNode = this.getEventNode();

      (0, _eventlistener.remove)(window, 'resize', this.lazyLoadHandler);
      (0, _eventlistener.remove)(eventNode, 'scroll', this.lazyLoadHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          height = _props2.height,
          width = _props2.width;
      var visible = this.state.visible;


      var elStyles = { height: height, width: width };
      var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');

      return _react2.default.createElement(this.props.elementType, {
        className: elClasses,
        style: elStyles
      }, visible && _react.Children.only(children));
    }
  }]);

  return LazyLoad;
}(_react.Component);

exports.default = LazyLoad;


LazyLoad.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  debounce: _propTypes2.default.bool,
  elementType: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  offset: _propTypes2.default.number,
  offsetBottom: _propTypes2.default.number,
  offsetHorizontal: _propTypes2.default.number,
  offsetLeft: _propTypes2.default.number,
  offsetRight: _propTypes2.default.number,
  offsetTop: _propTypes2.default.number,
  offsetVertical: _propTypes2.default.number,
  threshold: _propTypes2.default.number,
  throttle: _propTypes2.default.number,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onContentVisible: _propTypes2.default.func
};

LazyLoad.defaultProps = {
  elementType: 'div',
  debounce: true,
  offset: 0,
  offsetBottom: 0,
  offsetHorizontal: 0,
  offsetLeft: 0,
  offsetRight: 0,
  offsetTop: 0,
  offsetVertical: 0,
  throttle: 250
};

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.eventListener = factory();
  }
}(this, function () {
	function wrap(standard, fallback) {
		return function (el, evtName, listener, useCapture) {
			if (el[standard]) {
				el[standard](evtName, listener, useCapture);
			} else if (el[fallback]) {
				el[fallback]('on' + evtName, listener);
			}
		}
	}

    return {
		add: wrap('addEventListener', 'attachEvent'),
		remove: wrap('removeEventListener', 'detachEvent')
	};
}));

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var style = function style(element, prop) {
  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
};

var overflow = function overflow(element) {
  return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
};

var scrollParent = function scrollParent(element) {
  if (!(element instanceof HTMLElement)) {
    return window;
  }

  var parent = element;

  while (parent) {
    if (parent === document.body || parent === document.documentElement) {
      break;
    }

    if (!parent.parentNode) {
      break;
    }

    if (/(scroll|auto)/.test(overflow(parent))) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return window;
};

exports.default = scrollParent;

/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inViewport;

var _getElementPosition = __webpack_require__(3508);

var _getElementPosition2 = _interopRequireDefault(_getElementPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isHidden = function isHidden(element) {
  return element.offsetParent === null;
};

function inViewport(element, container, customOffset) {
  if (isHidden(element)) {
    return false;
  }

  var top = void 0;
  var bottom = void 0;
  var left = void 0;
  var right = void 0;

  if (typeof container === 'undefined' || container === window) {
    top = window.pageYOffset;
    left = window.pageXOffset;
    bottom = top + window.innerHeight;
    right = left + window.innerWidth;
  } else {
    var containerPosition = (0, _getElementPosition2.default)(container);

    top = containerPosition.top;
    left = containerPosition.left;
    bottom = top + container.offsetHeight;
    right = left + container.offsetWidth;
  }

  var elementPosition = (0, _getElementPosition2.default)(element);

  return top <= elementPosition.top + element.offsetHeight + customOffset.top && bottom >= elementPosition.top - customOffset.bottom && left <= elementPosition.left + element.offsetWidth + customOffset.left && right >= elementPosition.left - customOffset.right;
}

/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementPosition;
/*
* Finds element's position relative to the whole document,
* rather than to the viewport as it is the case with .getBoundingClientRect().
*/
function getElementPosition(element) {
  var rect = element.getBoundingClientRect();

  return {
    top: rect.top + window.pageYOffset,
    left: rect.left + window.pageXOffset
  };
}

/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = triggerEvent;

function triggerEvent(el, type) {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  }
}
//# sourceMappingURL=triggerEvent.js.map


/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _button = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Operation = function Operation(_ref) {
  var disabled = _ref.disabled,
      moveToLeft = _ref.moveToLeft,
      moveToRight = _ref.moveToRight,
      _ref$leftArrowText = _ref.leftArrowText,
      leftArrowText = _ref$leftArrowText === void 0 ? '' : _ref$leftArrowText,
      _ref$rightArrowText = _ref.rightArrowText,
      rightArrowText = _ref$rightArrowText === void 0 ? '' : _ref$rightArrowText,
      leftActive = _ref.leftActive,
      rightActive = _ref.rightActive,
      className = _ref.className,
      style = _ref.style;
  return React.createElement("div", {
    className: className,
    style: style
  }, React.createElement(_button["default"], {
    type: "primary",
    size: "small",
    disabled: disabled || !rightActive,
    onClick: moveToRight,
    icon: "right"
  }, rightArrowText), React.createElement(_button["default"], {
    type: "primary",
    size: "small",
    disabled: disabled || !leftActive,
    onClick: moveToLeft,
    icon: "left"
  }, leftArrowText));
};

var _default = Operation;
exports["default"] = _default;
//# sourceMappingURL=operation.js.map


/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(3512);
//# sourceMappingURL=index.js.map


/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3513);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-steps {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #424242;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: flex;\n  width: 100%;\n  font-size: 0;\n}\n.ant-steps-item {\n  position: relative;\n  display: inline-block;\n  flex: 1;\n  overflow: hidden;\n  vertical-align: top;\n}\n.ant-steps-item-container {\n  outline: none;\n}\n.ant-steps-item:last-child {\n  flex: none;\n}\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail,\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-item-icon,\n.ant-steps-item-content {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps-item-icon {\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  font-size: 16px;\n  font-family: Oxygen \", BlinkMacSystemFont, Ubuntu, Segoe UI, Roboto, Arial, sans-serif, \" Apple Color Emoji \", \" Segoe UI Emoji \", \" Segoe UI Symbol;\n  line-height: 32px;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 32px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n.ant-steps-item-icon > .ant-steps-icon {\n  position: relative;\n  top: -1px;\n  color: #4CDEF5;\n  line-height: 1;\n}\n.ant-steps-item-tail {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  width: 100%;\n  padding: 0 10px;\n}\n.ant-steps-item-tail::after {\n  display: inline-block;\n  width: 100%;\n  height: 1px;\n  background: #e8e8e8;\n  border-radius: 1px;\n  transition: background 0.3s;\n  content: '';\n}\n.ant-steps-item-title {\n  position: relative;\n  display: inline-block;\n  padding-right: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 32px;\n}\n.ant-steps-item-title::after {\n  position: absolute;\n  top: 16px;\n  left: 100%;\n  display: block;\n  width: 9999px;\n  height: 1px;\n  background: #e8e8e8;\n  content: '';\n}\n.ant-steps-item-subtitle {\n  display: inline;\n  margin-left: 8px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-steps-item-description {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n.ant-steps-item-wait .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #4CDEF5;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #4CDEF5;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #4CDEF5;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #424242;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background: #4CDEF5;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #fff;\n}\n.ant-steps-item-process .ant-steps-item-title {\n  font-weight: 500;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #4CDEF5;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #4CDEF5;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #4CDEF5;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #424242;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #4CDEF5;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #4CDEF5;\n}\n.ant-steps-item-error .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {\n  color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item.ant-steps-next-error .ant-steps-item-title::after {\n  background: #f5222d;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-description,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-icon .ant-steps-icon {\n  transition: color 0.3s;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {\n  color: #4CDEF5;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {\n  border-color: #4CDEF5;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {\n  color: #4CDEF5;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  margin-right: 16px;\n  white-space: nowrap;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {\n  margin-right: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {\n  padding-right: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {\n  display: none;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {\n  max-width: 140px;\n  white-space: normal;\n}\n.ant-steps-item-custom .ant-steps-item-icon {\n  height: auto;\n  background: none;\n  border: 0;\n}\n.ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  top: 0;\n  left: 0.5px;\n  width: 32px;\n  height: 32px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #4CDEF5;\n}\n.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {\n  width: auto;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  margin-right: 12px;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {\n  margin-right: 0;\n}\n.ant-steps-small .ant-steps-item-icon {\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 24px;\n}\n.ant-steps-small .ant-steps-item-title {\n  padding-right: 12px;\n  font-size: 14px;\n  line-height: 24px;\n}\n.ant-steps-small .ant-steps-item-title::after {\n  top: 12px;\n}\n.ant-steps-small .ant-steps-item-description {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n.ant-steps-small .ant-steps-item-tail {\n  top: 8px;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  background: none;\n  border: 0;\n  border-radius: 0;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  font-size: 24px;\n  line-height: 24px;\n  transform: none;\n}\n.ant-steps-vertical {\n  display: block;\n}\n.ant-steps-vertical .ant-steps-item {\n  display: block;\n  overflow: visible;\n}\n.ant-steps-vertical .ant-steps-item-icon {\n  float: left;\n  margin-right: 16px;\n}\n.ant-steps-vertical .ant-steps-item-content {\n  display: block;\n  min-height: 48px;\n  overflow: hidden;\n}\n.ant-steps-vertical .ant-steps-item-title {\n  line-height: 32px;\n}\n.ant-steps-vertical .ant-steps-item-description {\n  padding-bottom: 12px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  width: 1px;\n  height: 100%;\n  padding: 38px 0 6px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {\n  width: 1px;\n  height: 100%;\n}\n.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {\n  display: block;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 12px;\n  padding: 30px 0 6px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {\n  line-height: 24px;\n}\n@media (max-width: 480px) {\n  .ant-steps-horizontal.ant-steps-label-horizontal {\n    display: block;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {\n    display: block;\n    overflow: visible;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {\n    float: left;\n    margin-right: 16px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {\n    display: block;\n    min-height: 48px;\n    overflow: hidden;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {\n    line-height: 32px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-description {\n    padding-bottom: 12px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    position: absolute;\n    top: 0;\n    left: 16px;\n    width: 1px;\n    height: 100%;\n    padding: 38px 0 6px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {\n    width: 1px;\n    height: 100%;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {\n    display: block;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n    display: none;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n    position: absolute;\n    top: 0;\n    left: 12px;\n    padding: 30px 0 6px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-title {\n    line-height: 24px;\n  }\n}\n.ant-steps-label-vertical .ant-steps-item {\n  overflow: visible;\n}\n.ant-steps-label-vertical .ant-steps-item-tail {\n  margin-left: 58px;\n  padding: 3.5px 24px;\n}\n.ant-steps-label-vertical .ant-steps-item-content {\n  display: block;\n  width: 116px;\n  margin-top: 8px;\n  text-align: center;\n}\n.ant-steps-label-vertical .ant-steps-item-icon {\n  display: inline-block;\n  margin-left: 42px;\n}\n.ant-steps-label-vertical .ant-steps-item-title {\n  padding-right: 0;\n}\n.ant-steps-label-vertical .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-label-vertical .ant-steps-item-subtitle {\n  display: block;\n  margin-bottom: 4px;\n  margin-left: 0;\n  line-height: 1.5;\n}\n.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {\n  margin-left: 46px;\n}\n.ant-steps-dot .ant-steps-item-title,\n.ant-steps-dot.ant-steps-small .ant-steps-item-title {\n  line-height: 1.5;\n}\n.ant-steps-dot .ant-steps-item-tail,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail {\n  top: 2px;\n  width: 100%;\n  margin: 0 0 0 70px;\n  padding: 0;\n}\n.ant-steps-dot .ant-steps-item-tail::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {\n  width: calc(100% - 20px);\n  height: 3px;\n  margin-left: 12px;\n}\n.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 2px;\n}\n.ant-steps-dot .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon {\n  width: 8px;\n  height: 8px;\n  margin-left: 67px;\n  padding-right: 0;\n  line-height: 8px;\n  background: transparent;\n  border: 0;\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 100px;\n  transition: all 0.3s;\n  /* expand hover area */\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {\n  position: absolute;\n  top: -12px;\n  left: -26px;\n  width: 60px;\n  height: 32px;\n  background: rgba(0, 0, 0, 0.001);\n  content: '';\n}\n.ant-steps-dot .ant-steps-item-content,\n.ant-steps-dot.ant-steps-small .ant-steps-item-content {\n  width: 140px;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot {\n  top: -1px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {\n  margin-top: 8px;\n  margin-left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  top: 2px;\n  left: -9px;\n  margin: 0;\n  padding: 22px 0 4px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {\n  left: -2px;\n}\n.ant-steps-navigation {\n  padding-top: 12px;\n}\n.ant-steps-navigation.ant-steps-small .ant-steps-item-container {\n  margin-left: -12px;\n}\n.ant-steps-navigation .ant-steps-item {\n  overflow: visible;\n  text-align: center;\n}\n.ant-steps-navigation .ant-steps-item-container {\n  display: inline-block;\n  height: 100%;\n  margin-left: -16px;\n  padding-bottom: 12px;\n  text-align: left;\n  transition: opacity 0.3s;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {\n  max-width: auto;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {\n  max-width: 100%;\n  padding-right: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button']:hover {\n  opacity: 0.85;\n}\n.ant-steps-navigation .ant-steps-item:last-child {\n  flex: 1;\n}\n.ant-steps-navigation .ant-steps-item:last-child::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item::after {\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -14px;\n  margin-left: -2px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-bottom: none;\n  border-left: none;\n  transform: rotate(45deg);\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item::before {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: inline-block;\n  width: 0;\n  height: 3px;\n  background-color: #4CDEF5;\n  transition: width 0.3s, left 0.3s;\n  transition-timing-function: ease-out;\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {\n  left: 0;\n  width: 100%;\n}\n@media (max-width: 480px) {\n  .ant-steps-navigation > .ant-steps-item {\n    margin-right: 0 !important;\n  }\n  .ant-steps-navigation > .ant-steps-item::before {\n    display: none;\n  }\n  .ant-steps-navigation > .ant-steps-item.ant-steps-item-active::before {\n    top: 0;\n    right: 0;\n    left: unset;\n    display: block;\n    width: 3px;\n    height: calc(100% - 24px);\n  }\n  .ant-steps-navigation > .ant-steps-item::after {\n    position: relative;\n    top: -2px;\n    left: 50%;\n    display: block;\n    width: 8px;\n    height: 8px;\n    margin-bottom: 8px;\n    text-align: center;\n    transform: rotate(135deg);\n  }\n  .ant-steps-navigation > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    visibility: hidden;\n  }\n}\n.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {\n  margin-left: -16px;\n  padding-left: 16px;\n  background: #fff;\n}\n.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item {\n  margin-left: -12px;\n  padding-left: 12px;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child {\n  overflow: hidden;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child .ant-steps-icon-dot::after {\n  right: -200px;\n  width: 200px;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::before,\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {\n  position: absolute;\n  top: 0;\n  left: -10px;\n  width: 10px;\n  height: 8px;\n  background: #fff;\n  content: '';\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {\n  right: -10px;\n  left: auto;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #ccc;\n}\n", ""]);

// exports


/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _rcSteps = _interopRequireDefault(__webpack_require__(3515));

var _icon = _interopRequireDefault(__webpack_require__(4));

var _configProvider = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Steps =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps() {
    var _this;

    _classCallCheck(this, Steps);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).apply(this, arguments));

    _this.renderSteps = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
      var icons = {
        finish: React.createElement(_icon["default"], {
          type: "check",
          className: "".concat(prefixCls, "-finish-icon")
        }),
        error: React.createElement(_icon["default"], {
          type: "close",
          className: "".concat(prefixCls, "-error-icon")
        })
      };
      return React.createElement(_rcSteps["default"], _extends({
        icons: icons
      }, _this.props, {
        prefixCls: prefixCls,
        iconPrefix: iconPrefix
      }));
    };

    return _this;
  }

  _createClass(Steps, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps);
    }
  }]);

  return Steps;
}(React.Component);

exports["default"] = Steps;
Steps.Step = _rcSteps["default"].Step;
Steps.defaultProps = {
  current: 0
};
Steps.propTypes = {
  prefixCls: PropTypes.string,
  iconPrefix: PropTypes.string,
  current: PropTypes.number
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 3515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Steps__ = __webpack_require__(3516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Step__ = __webpack_require__(3527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Step", function() { return __WEBPACK_IMPORTED_MODULE_1__Step__["a"]; });


__WEBPACK_IMPORTED_MODULE_0__Steps__["a" /* default */].Step = __WEBPACK_IMPORTED_MODULE_1__Step__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Steps__["a" /* default */]);

/***/ }),
/* 3516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Steps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(3517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3526);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/no-did-mount-set-state: 0 */







var Steps =
/*#__PURE__*/
function (_Component) {
  _inherits(Steps, _Component);

  function Steps(props) {
    var _this;

    _classCallCheck(this, Steps);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onStepClick", function (next) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          current = _this$props.current;

      if (onChange && current !== next) {
        onChange(next);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calcStepOffsetWidth", function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* isFlexSupported */])()) {
        return;
      }

      var lastStepOffsetWidth = _this.state.lastStepOffsetWidth; // Just for IE9

      var domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(_assertThisInitialized(_this));

      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }

        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var offsetWidth = (domNode.lastChild.offsetWidth || 0) + 1; // Reduce shake bug

          if (lastStepOffsetWidth === offsetWidth || Math.abs(lastStepOffsetWidth - offsetWidth) <= 3) {
            return;
          }

          _this.setState({
            lastStepOffsetWidth: offsetWidth
          });
        });
      }
    });

    _this.state = {
      flexSupported: true,
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  _createClass(Steps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calcStepOffsetWidth();

      if (!Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* isFlexSupported */])()) {
        this.setState({
          flexSupported: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.calcStepOffsetWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.calcTimeout) {
        clearTimeout(this.calcTimeout);
      }

      if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
        this.calcStepOffsetWidth.cancel();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style,
          className = _this$props2.className,
          children = _this$props2.children,
          direction = _this$props2.direction,
          type = _this$props2.type,
          labelPlacement = _this$props2.labelPlacement,
          iconPrefix = _this$props2.iconPrefix,
          status = _this$props2.status,
          size = _this$props2.size,
          current = _this$props2.current,
          progressDot = _this$props2.progressDot,
          initial = _this$props2.initial,
          icons = _this$props2.icons,
          onChange = _this$props2.onChange,
          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "initial", "icons", "onChange"]);

      var isNav = type === 'navigation';
      var _this$state = this.state,
          lastStepOffsetWidth = _this$state.lastStepOffsetWidth,
          flexSupported = _this$state.flexSupported;
      var filteredChildren = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children).filter(function (c) {
        return !!c;
      });
      var lastIndex = filteredChildren.length - 1;
      var adjustedlabelPlacement = progressDot ? 'vertical' : labelPlacement;
      var classString = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(direction), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty(_classNames, "".concat(prefixCls, "-label-").concat(adjustedlabelPlacement), direction === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-dot"), !!progressDot), _defineProperty(_classNames, "".concat(prefixCls, "-navigation"), isNav), _defineProperty(_classNames, "".concat(prefixCls, "-flex-not-supported"), !flexSupported), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
        className: classString,
        style: style
      }, restProps), __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(filteredChildren, function (child, index) {
        if (!child) {
          return null;
        }

        var stepNumber = initial + index;

        var childProps = _objectSpread({
          stepNumber: "".concat(stepNumber + 1),
          stepIndex: stepNumber,
          prefixCls: prefixCls,
          iconPrefix: iconPrefix,
          wrapperStyle: style,
          progressDot: progressDot,
          icons: icons,
          onStepClick: onChange && _this2.onStepClick
        }, child.props);

        if (!flexSupported && direction !== 'vertical') {
          if (isNav) {
            childProps.itemWidth = "".concat(100 / (lastIndex + 1), "%");
            childProps.adjustMarginRight = 0;
          } else if (index !== lastIndex) {
            childProps.itemWidth = "".concat(100 / lastIndex, "%");
            childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
          }
        } // fix tail color


        if (status === 'error' && index === current - 1) {
          childProps.className = "".concat(prefixCls, "-next-error");
        }

        if (!child.props.status) {
          if (stepNumber === current) {
            childProps.status = status;
          } else if (stepNumber < current) {
            childProps.status = 'finish';
          } else {
            childProps.status = 'wait';
          }
        }

        childProps.active = stepNumber === current;
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, childProps);
      }));
    }
  }]);

  return Steps;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Steps, "propTypes", {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  progressDot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  initial: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  icons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    finish: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  }),
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

_defineProperty(Steps, "defaultProps", {
  type: 'default',
  prefixCls: 'rc-steps',
  iconPrefix: 'rc',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  initial: 0,
  current: 0,
  status: 'process',
  size: '',
  progressDot: false
});



/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(581),
    now = __webpack_require__(3518),
    toNumber = __webpack_require__(3520);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(582);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(581),
    isSymbol = __webpack_require__(3521);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(3522),
    isObjectLike = __webpack_require__(3525);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(583),
    getRawTag = __webpack_require__(3523),
    objectToString = __webpack_require__(3524);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 3523 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(583);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 3524 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 3525 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 3526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFlexSupported;
// eslint-disable-next-line import/prefer-default-export
function isFlexSupported() {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    var documentElement = window.document.documentElement;
    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
  }

  return false;
}

/***/ }),
/* 3527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Step; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function isString(str) {
  return typeof str === 'string';
}

var Step =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Step, _React$Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Step);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Step)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onStepClick = _this$props.onStepClick,
          stepIndex = _this$props.stepIndex;

      if (onClick) {
        onClick.apply(void 0, arguments);
      }

      onStepClick(stepIndex);
    });

    return _this;
  }

  _createClass(Step, [{
    key: "renderIconNode",
    value: function renderIconNode() {
      var _classNames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          progressDot = _this$props2.progressDot,
          stepNumber = _this$props2.stepNumber,
          status = _this$props2.status,
          title = _this$props2.title,
          description = _this$props2.description,
          icon = _this$props2.icon,
          iconPrefix = _this$props2.iconPrefix,
          icons = _this$props2.icons;
      var iconNode;
      var iconClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && isString(icon)), _defineProperty(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === 'finish' && icons && !icons.finish), _defineProperty(_classNames, "".concat(iconPrefix, "icon-close"), !icon && status === 'error' && icons && !icons.error), _classNames));
      var iconDot = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-icon-dot")
      }); // `progressDot` enjoy the highest priority

      if (progressDot) {
        if (typeof progressDot === 'function') {
          iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "".concat(prefixCls, "-icon")
          }, progressDot(iconDot, {
            index: stepNumber - 1,
            status: status,
            title: title,
            description: description
          }));
        } else {
          iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "".concat(prefixCls, "-icon")
          }, iconDot);
        }
      } else if (icon && !isString(icon)) {
        iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icon);
      } else if (icons && icons.finish && status === 'finish') {
        iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icons.finish);
      } else if (icons && icons.error && status === 'error') {
        iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icons.error);
      } else if (icon || status === 'finish' || status === 'error') {
        iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: iconClassName
        });
      } else {
        iconNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, stepNumber);
      }

      return iconNode;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2;

      var _this$props3 = this.props,
          className = _this$props3.className,
          prefixCls = _this$props3.prefixCls,
          style = _this$props3.style,
          itemWidth = _this$props3.itemWidth,
          active = _this$props3.active,
          _this$props3$status = _this$props3.status,
          status = _this$props3$status === void 0 ? 'wait' : _this$props3$status,
          iconPrefix = _this$props3.iconPrefix,
          icon = _this$props3.icon,
          wrapperStyle = _this$props3.wrapperStyle,
          adjustMarginRight = _this$props3.adjustMarginRight,
          stepNumber = _this$props3.stepNumber,
          disabled = _this$props3.disabled,
          description = _this$props3.description,
          title = _this$props3.title,
          subTitle = _this$props3.subTitle,
          progressDot = _this$props3.progressDot,
          tailContent = _this$props3.tailContent,
          icons = _this$props3.icons,
          stepIndex = _this$props3.stepIndex,
          onStepClick = _this$props3.onStepClick,
          onClick = _this$props3.onClick,
          restProps = _objectWithoutProperties(_this$props3, ["className", "prefixCls", "style", "itemWidth", "active", "status", "iconPrefix", "icon", "wrapperStyle", "adjustMarginRight", "stepNumber", "disabled", "description", "title", "subTitle", "progressDot", "tailContent", "icons", "stepIndex", "onStepClick", "onClick"]);

      var classString = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(status), className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-custom"), icon), _defineProperty(_classNames2, "".concat(prefixCls, "-item-active"), active), _defineProperty(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));

      var stepItemStyle = _objectSpread({}, style);

      if (itemWidth) {
        stepItemStyle.width = itemWidth;
      }

      if (adjustMarginRight) {
        stepItemStyle.marginRight = adjustMarginRight;
      }

      var accessibilityProps = {};

      if (onStepClick && !disabled) {
        accessibilityProps.role = 'button';
        accessibilityProps.tabIndex = 0;
        accessibilityProps.onClick = this.onClick;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, restProps, {
        className: classString,
        style: stepItemStyle
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
        onClick: onClick
      }, accessibilityProps, {
        className: "".concat(prefixCls, "-item-container")
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-item-tail")
      }, tailContent), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-item-icon")
      }, this.renderIconNode()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-item-content")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-item-title")
      }, title, subTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        title: subTitle,
        className: "".concat(prefixCls, "-item-subtitle")
      }, subTitle)), description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-item-description")
      }, description))));
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

_defineProperty(Step, "propTypes", {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  itemWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  adjustMarginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  stepNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  stepIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  subTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  progressDot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tailContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  icons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    finish: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  }),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStepClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});



/***/ }),
/* 3528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SimulationForm__wrapper__2Mpog","submitResult":"SimulationForm__submitResult__1A-nq","actionWrapper":"SimulationForm__actionWrapper__1bgcL"};

/***/ }),
/* 3529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Simulation__content__16bvY","parentContainer":"Simulation__parentContainer__1s_ou","searchWrapper":"Simulation__searchWrapper__2KI1E","searchWrapperSearch":"Simulation__searchWrapperSearch__2nHoK","searchWrapperLabel":"Simulation__searchWrapperLabel__UJI0f","searchWrapperFilter":"Simulation__searchWrapperFilter__3Y7MI","activateBtn":"Simulation__activateBtn__3LDH0","searchWrapperFilterItem":"Simulation__searchWrapperFilterItem__3LnaQ","searchWrapperFilterLabel":"Simulation__searchWrapperFilterLabel___HYyk","clearButton":"Simulation__clearButton__3_fcp","checkIcon":"Simulation__checkIcon__y3-iT","clockIcon":"Simulation__clockIcon__j-w9H","checkIconGray":"Simulation__checkIconGray__2WFyC","warningIcon":"Simulation__warningIcon__UmN3I","iconStatusWrapper":"Simulation__iconStatusWrapper__13HZD","eventDropdownItem":"Simulation__eventDropdownItem__12oKr","actionIcon":"Simulation__actionIcon__2Ggw4","actions":"Simulation__actions__1bryS"};

/***/ }),
/* 3530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_result_style__ = __webpack_require__(3531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_result_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_result_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_result__ = __webpack_require__(3534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_helmet__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Training_css__ = __webpack_require__(3538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Training_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Training_css__);

















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default.a.Content;var Training = function (_React$Component) {
  _inherits(Training, _React$Component);function Training(props) {
    var _this2 = this;_classCallCheck(this, Training);var _this = _possibleConstructorReturn(this, (Training.__proto__ || Object.getPrototypeOf(Training)).call(this, props));_this.startQuiz = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _this.setState({ isLoading: true });_context.prev = 1;_context.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["_49" /* trainingStartRequest */])();case 4:
              _ref2 = _context.sent;data = _ref2.data;if (__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token')) {
                _this.setState({ token: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token'), is_completed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_completed'), is_passed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_passed'), current_question: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'current_question'), question_number: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'question_number'), total_questions: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'total_questions'), statusResult: null });
              }_context.next = 15;break;case 9:
              _context.prev = 9;_context.t0 = _context['catch'](1);if (!(_context.t0.response.status === 401)) {
                _context.next = 14;break;
              }_this.props.logout();return _context.abrupt('return');case 14:
              console.log(_context.t0);case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2, [[1, 9]]);
    }));_this.verifyQuiz = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this$state, token, current_question, answer, _ref4, data;return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this$state = _this.state, token = _this$state.token, current_question = _this$state.current_question, answer = _this$state.answer;_this.setState({ isLoadingStep: true });_context2.prev = 2;_context2.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["_47" /* trainingCheckRequest */])({ token: token, q_id: current_question.id, q_ans: answer });case 5:
              _ref4 = _context2.sent;data = _ref4.data;if (__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token')) {
                _this.setState({ token: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token'), is_completed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_completed'), is_passed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_passed'), next_question: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'current_question'), q_number: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'question_number'), total_q: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'total_questions'), preview_correct_answer: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'preview_correct_answer'), answerResult: { type: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'preview_correct_answer') === answer ? 'success' : 'error', message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'preview_correct_answer') === answer ? 'Correct' : 'Correct answer is: ' + __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'preview_correct_answer')) } });
              }_context2.next = 16;break;case 10:
              _context2.prev = 10;_context2.t0 = _context2['catch'](2);if (!(_context2.t0.response.status === 401)) {
                _context2.next = 15;break;
              }_this.props.logout();return _context2.abrupt('return');case 15:
              console.log(_context2.t0);case 16:
              _this.setState({ isLoadingStep: false });case 17:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[2, 10]]);
    }));_this.nextStep = function () {
      _this.setState(function (state) {
        return { current_question: state.next_question, next_question: {}, question_number: state.q_number, total_questions: state.total_q, answer: null, answerResult: null, statusResult: null };
      });
    };_this.onChangeAnswer = function (e) {
      _this.setState({ answer: e.target.value });
    };_this.state = { answer: null, answerResult: null, is_completed: false, is_passed: false, current_question: {}, next_question: {}, token: null, preview_correct_answer: null, isLoading: true, isLoadingStep: false, statusResult: null, total_questions: 10, question_number: 1, total_q: 10, q_number: 1 };return _this;
  }_createClass(Training, [{ key: 'componentDidMount', value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref6, data;return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.prev = 0;_context3.next = 3;return Object(__WEBPACK_IMPORTED_MODULE_23__api_requests__["_48" /* trainingGetRequest */])();case 3:
                _ref6 = _context3.sent;data = _ref6.data;if (__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token')) {
                  this.setState({ token: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'token'), is_completed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_completed'), is_passed: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'is_passed'), current_question: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'current_question'), question_number: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'question_number'), total_questions: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(data, 'total_questions') });
                }_context3.next = 14;break;case 8:
                _context3.prev = 8;_context3.t0 = _context3['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                  _context3.next = 13;break;
                }this.props.logout();return _context3.abrupt('return');case 13:
                this.setState({ statusResult: { type: 'error', message: __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(_context3.t0, 'response.data.error') } });case 14:
                this.setState({ isLoading: false });case 15:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this, [[0, 8]]);
      }));function componentDidMount() {
        return _ref5.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _state = this.state,
          answer = _state.answer,
          answerResult = _state.answerResult,
          current_question = _state.current_question,
          is_completed = _state.is_completed,
          isLoading = _state.isLoading,
          is_passed = _state.is_passed,
          statusResult = _state.statusResult,
          total_questions = _state.total_questions,
          question_number = _state.question_number;return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_helmet__["Helmet"], null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('title', null, 'Trial Management Portal: Settings')), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_24__Training_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_24__Training_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('h3', { className: 'headline-default' }, 'Training'), isLoading && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'loading' }), statusResult && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, { message: statusResult.message, type: statusResult.type, className: __WEBPACK_IMPORTED_MODULE_24__Training_css___default.a.submitResult }), !isLoading && !__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, 'id') && !is_completed && !statusResult && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { style: { margin: '10px 0 0' } }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', onClick: this.startQuiz }, 'Start quiz')), !isLoading && __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, 'id') && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_badge___default.a, { count: 'Question ' + question_number + ' from ' + total_questions, style: { backgroundColor: '#2968AE', margin: '0 0 10px' } }), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, 'question')), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, { disabled: !!answerResult, options: Object.keys(current_question).filter(function (item) {
          return item.includes('answer');
        }).map(function (value) {
          return { label: current_question[value], value: value };
        }), onChange: this.onChangeAnswer, value: answer })), answerResult && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, { message: answerResult.message, type: answerResult.type, className: __WEBPACK_IMPORTED_MODULE_24__Training_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_24__Training_css___default.a.submitWrapper }, !answerResult && __WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, 'id') && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', onClick: this.verifyQuiz }, 'Answer'), answerResult && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', onClick: this.nextStep }, is_completed ? 'Finish' : 'Next step')), is_completed && !__WEBPACK_IMPORTED_MODULE_18_lodash_get___default()(current_question, 'id') && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Fragment, null, is_passed ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_result___default.a, { status: 'success', title: 'Congratulations on passing the AcT Training!', subTitle: 'Your training certificate has automatically been uploaded to the system. Please log out and you will receive an e-mail with instructions on how to use your active AcT account!' }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_result___default.a, { status: 'error', title: 'Testing Failed', subTitle: 'Testing has been failed', extra: [__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a, { type: 'primary', key: 'console', onClick: this.startQuiz }, 'Retry')] }))), __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Training;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);var mapStateToProps = function mapStateToProps(_) {
  return {};
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_22__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Training)));

/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(44);

__webpack_require__(3532);
//# sourceMappingURL=index.js.map


/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3533);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js??ref--2-oneOf-2-2!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-result {\n  padding: 48px 32px;\n}\n.ant-result-success .ant-result-icon > .anticon {\n  color: #52c41a;\n}\n.ant-result-error .ant-result-icon > .anticon {\n  color: #f5222d;\n}\n.ant-result-info .ant-result-icon > .anticon {\n  color: #1890ff;\n}\n.ant-result-warning .ant-result-icon > .anticon {\n  color: #faad14;\n}\n.ant-result-image {\n  width: 250px;\n  height: 295px;\n  margin: auto;\n}\n.ant-result-icon {\n  margin-bottom: 24px;\n  text-align: center;\n}\n.ant-result-icon > .anticon {\n  font-size: 72px;\n}\n.ant-result-title {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 24px;\n  line-height: 1.8;\n  text-align: center;\n}\n.ant-result-subtitle {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  line-height: 1.6;\n  text-align: center;\n}\n.ant-result-extra {\n  margin-top: 32px;\n  text-align: center;\n}\n.ant-result-extra > * {\n  margin-right: 8px;\n}\n.ant-result-extra > *:last-child {\n  margin-right: 0;\n}\n.ant-result-content {\n  margin-top: 24px;\n  padding: 24px 40px;\n  background-color: #fafafa;\n}\n", ""]);

// exports


/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExceptionMap = exports.IconMap = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(30);

var _icon = _interopRequireDefault(__webpack_require__(4));

var _noFound = _interopRequireDefault(__webpack_require__(3535));

var _serverError = _interopRequireDefault(__webpack_require__(3536));

var _unauthorized = _interopRequireDefault(__webpack_require__(3537));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IconMap = {
  success: 'check-circle',
  error: 'close-circle',
  info: 'exclamation-circle',
  warning: 'warning'
};
exports.IconMap = IconMap;
var ExceptionMap = {
  '404': _noFound["default"],
  '500': _serverError["default"],
  '403': _unauthorized["default"]
}; // ExceptionImageMap keys

exports.ExceptionMap = ExceptionMap;
var ExceptionStatus = Object.keys(ExceptionMap);
/**
 * render icon
 * if ExceptionStatus includes ,render svg image
 * else render iconNode
 * @param prefixCls
 * @param {status, icon}
 */

var renderIcon = function renderIcon(prefixCls, _ref) {
  var status = _ref.status,
      icon = _ref.icon;
  var className = (0, _classnames["default"])("".concat(prefixCls, "-icon"));

  if (ExceptionStatus.includes(status)) {
    var SVGComponent = ExceptionMap[status];
    return React.createElement("div", {
      className: "".concat(className, " ").concat(prefixCls, "-image")
    }, React.createElement(SVGComponent, null));
  }

  var iconString = IconMap[status];
  var iconNode = icon || React.createElement(_icon["default"], {
    type: iconString,
    theme: "filled"
  });
  return React.createElement("div", {
    className: className
  }, iconNode);
};

var renderExtra = function renderExtra(prefixCls, _ref2) {
  var extra = _ref2.extra;
  return extra && React.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra);
};

var Result = function Result(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
    var getPrefixCls = _ref3.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        customizeClassName = props.className,
        subTitle = props.subTitle,
        title = props.title,
        style = props.style,
        children = props.children,
        status = props.status;
    var prefixCls = getPrefixCls('result', customizePrefixCls);
    var className = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName);
    return React.createElement("div", {
      className: className,
      style: style
    }, renderIcon(prefixCls, props), React.createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, title), subTitle && React.createElement("div", {
      className: "".concat(prefixCls, "-subtitle")
    }, subTitle), children && React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children), renderExtra(prefixCls, props));
  });
};

Result.defaultProps = {
  status: 'info'
};
Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
var _default = Result;
exports["default"] = _default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NoFound = function NoFound() {
  return React.createElement("svg", {
    width: "252",
    height: "294"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M0 .387h251.772v251.772H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(0 .012)"
  }, React.createElement("mask", {
    fill: "#fff"
  }), React.createElement("path", {
    d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
    fill: "#E4EBF7",
    mask: "url(#b)"
  })), React.createElement("path", {
    d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2",
    d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
  }), React.createElement("path", {
    d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
    fill: "#1890FF"
  }), React.createElement("path", {
    d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
    fill: "#FFB594"
  }), React.createElement("path", {
    d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
    fill: "#7BB2F9"
  }), React.createElement("path", {
    d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M107.275 222.1s2.773-1.11 6.102-3.884",
    stroke: "#648BD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
    fill: "#520038"
  }), React.createElement("path", {
    d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
    fill: "#552950"
  }), React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
  }), React.createElement("path", {
    d: "M110.846 74.481s1.79-.716 2.506.537",
    stroke: "#5C2552",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M103.287 72.93s1.83 1.113 4.137.954",
    stroke: "#5C2552",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M119.306 107.329s.452 4.366-2.127 32.062",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
    fill: "#F2D7AD"
  }), React.createElement("path", {
    d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
    fill: "#F4D19D"
  }), React.createElement("path", {
    d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
    fill: "#F2D7AD"
  }), React.createElement("path", {
    fill: "#CC9B6E",
    d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
  }), React.createElement("path", {
    d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
    fill: "#F4D19D"
  }), React.createElement("path", {
    fill: "#CC9B6E",
    d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
  }), React.createElement("path", {
    fill: "#CC9B6E",
    d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
  }), React.createElement("path", {
    d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
    fill: "#5BA02E"
  }), React.createElement("path", {
    d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
    fill: "#92C110"
  }), React.createElement("path", {
    d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
    fill: "#F2D7AD"
  }), React.createElement("path", {
    d: "M88.979 89.48s7.776 5.384 16.6 2.842",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _default = NoFound;
exports["default"] = _default;
//# sourceMappingURL=noFound.js.map


/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ServerError = function ServerError() {
  return React.createElement("svg", {
    width: "254",
    height: "294"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M0 .335h253.49v253.49H0z"
  }), React.createElement("path", {
    d: "M0 293.665h253.49V.401H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(0 .067)"
  }, React.createElement("mask", {
    fill: "#fff"
  }), React.createElement("path", {
    d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
    fill: "#E4EBF7",
    mask: "url(#b)"
  })), React.createElement("path", {
    d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
    fill: "#FF603B"
  }), React.createElement("path", {
    d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
    fill: "#FFB594"
  }), React.createElement("path", {
    d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
    fill: "#FFB594"
  }), React.createElement("path", {
    d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
    fill: "#520038"
  }), React.createElement("path", {
    d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
    fill: "#552950"
  }), React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.063",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
  }), React.createElement("path", {
    d: "M99.926 73.284s1.8-.72 2.52.54",
    stroke: "#5C2552",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
    stroke: "#DB836E",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M92.326 71.724s1.84 1.12 4.16.96",
    stroke: "#5C2552",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
    stroke: "#DB836E",
    strokeWidth: "1.063",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
    stroke: "#E4EBF7",
    strokeWidth: "1.136",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
    fill: "#7BB2F9"
  }), React.createElement("path", {
    d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M96.973 219.373s2.882-1.153 6.34-4.034",
    stroke: "#648BD8",
    strokeWidth: "1.032",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
    stroke: "#DB836E",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M109.278 112.533s3.38-3.613 7.575-4.662",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M107.375 123.006s9.697-2.745 11.445-.88",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
    stroke: "#BFCDDD",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
    fill: "#A3B4C6"
  }), React.createElement("path", {
    d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
    fill: "#A3B4C6"
  }), React.createElement("mask", {
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#A3B4C6",
    mask: "url(#d)",
    d: "M154.098 190.096h70.513v-84.617h-70.513z"
  }), React.createElement("path", {
    d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
    fill: "#FFF",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
    stroke: "#7C90A5",
    strokeWidth: "1.124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
    fill: "#FFF",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M177.259 207.217v11.52M201.05 207.217v11.52",
    stroke: "#A3B4C6",
    strokeWidth: "1.124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
    fill: "#5BA02E",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
    fill: "#92C110",
    mask: "url(#d)"
  }), React.createElement("path", {
    d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
    fill: "#F2D7AD",
    mask: "url(#d)"
  })));
};

var _default = ServerError;
exports["default"] = _default;
//# sourceMappingURL=serverError.js.map


/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Unauthorized = function Unauthorized() {
  return React.createElement("svg", {
    width: "251",
    height: "294"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
    fill: "#E4EBF7"
  }), React.createElement("path", {
    d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
    stroke: "#FFF",
    strokeWidth: "2"
  }), React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2",
    d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
  }), React.createElement("path", {
    d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
    fill: "#A26EF4"
  }), React.createElement("path", {
    d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
    fill: "#5BA02E"
  }), React.createElement("path", {
    d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
    fill: "#92C110"
  }), React.createElement("path", {
    d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
    fill: "#F2D7AD"
  }), React.createElement("path", {
    d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
    fill: "#FFB594"
  }), React.createElement("path", {
    d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M78.18 94.656s.911 7.41-4.914 13.078",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
    stroke: "#E4EBF7",
    strokeWidth: ".932",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
    fill: "#FFB594"
  }), React.createElement("path", {
    d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
    fill: "#5C2552"
  }), React.createElement("path", {
    d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
  }), React.createElement("path", {
    d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
    fill: "#552950"
  }), React.createElement("path", {
    d: "M91.132 86.786s5.269 4.957 12.679 2.327",
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
    fill: "#DB836E"
  }), React.createElement("path", {
    d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
    stroke: "#5C2552",
    strokeWidth: "1.526",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
    stroke: "#E4EBF7",
    strokeWidth: "1.114",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M128.31 87.934s3.013 4.121 4.06 11.785",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
    stroke: "#DB836E",
    strokeWidth: ".795",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
    fill: "#FFC6A0"
  }), React.createElement("path", {
    d: "M130.532 85.488s4.588 5.757 11.619 6.214",
    stroke: "#DB836E",
    strokeWidth: ".75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M121.708 105.73s-.393 8.564-1.34 13.612",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
    fill: "#CBD1D1"
  }), React.createElement("path", {
    d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
    fill: "#2B0849"
  }), React.createElement("path", {
    d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
    fill: "#A4AABA"
  }), React.createElement("path", {
    d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
    fill: "#7BB2F9"
  }), React.createElement("path", {
    d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M108.459 220.905s2.759-1.104 6.07-3.863",
    stroke: "#648BD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
    fill: "#192064"
  }), React.createElement("path", {
    d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _default = Unauthorized;
exports["default"] = _default;
//# sourceMappingURL=unauthorized.js.map


/***/ }),
/* 3538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Training__content__3LuNS","submitResult":"Training__submitResult__ONXj3","submitWrapper":"Training__submitWrapper__14oUk"};

/***/ }),
/* 3539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tooltip_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_NewsletterForm_NewsletterForm__ = __webpack_require__(3540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Newsletter_css__ = __webpack_require__(3645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Newsletter_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__ = __webpack_require__(37);





















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a.Content;var Search = __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.Search;var Newsletter = function (_React$Component) {
  _inherits(Newsletter, _React$Component);function Newsletter(props) {
    var _this2 = this;_classCallCheck(this, Newsletter);var _this = _possibleConstructorReturn(this, (Newsletter.__proto__ || Object.getPrototypeOf(Newsletter)).call(this, props));_this.onNameSearch = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _this.setState({ nameSearch: value, filterBy: null, filterValue: null, eventsSelected: {} }, _this.getNewsletter);case 1:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.clearFilters = function () {
      _this.setState({ nameSearch: null }, _this.getNewsletter);
    };_this.getNewsletter = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.currentPage;var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pageSize;var _ref3, data;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.setState({ errorMessage: null, isLoading: true, responseMessage: null });_context2.prev = 1;_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_6" /* getNewsletterRequest */])({ search: _this.state.nameSearch, order_direction: _this.state.order, page: page, per_page: per_page, order_column: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_this.state, 'sortedInfo.columnKey'), filter_by: _this.state.filtersBy, filter_value: _this.state.filtersValue, filter_approve: _this.state.approvedSelected !== null ? _this.state.approvedSelected : null });case 4:
              _ref3 = _context2.sent;data = _ref3.data;_this.setState({ newsletters: data.data, total: data.total_pages * per_page, currentPage: page });_context2.next = 15;break;case 9:
              _context2.prev = 9;_context2.t0 = _context2['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.status') === 401)) {
                _context2.next = 14;break;
              }_this.props.logout();return _context2.abrupt('return');case 14:
              _this.setState({ newsletters: null, errorMessage: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context2.t0, 'response.data.error', 'Error') });case 15:
              _this.setState({ isLoading: false });case 16:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2, [[1, 9]]);
    }));_this.onNameChange = function (e) {
      _this.setState({ nameSearch: e.target.value });
    };_this.handleTableChange = function (pagination, filters, sorter) {
      _this.setState({ isLoading: true, pageSize: pagination.pageSize, sortedInfo: sorter, order: __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sorter, 'order') === 'ascend' ? 'asc' : __WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(sorter, 'order') === 'descend' ? 'desc' : 'asc' }, function () {
        return _this.getNewsletter(pagination.current, pagination.pageSize);
      });
    };_this.onNewsletterEdit = function (newsletter) {
      return function () {
        _this.setState({ newsletterEdit: newsletter });
      };
    };_this.onNewsletterEditHide = function () {
      _this.setState({ newsletterEdit: null });
    };_this.onNewsletterEditSubmit = function () {
      _this.setState({ newsletterEdit: null }, _this.getNewsletter);
    };_this.addNewsletter = function () {
      _this.setState({ newsletterEdit: {} });
    };_this.onSwitchNewsletterActivation = function (id, state) {
      return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                _context3.prev = 0;if (!(state === 'active')) {
                  _context3.next = 6;break;
                }_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["J" /* deleteNewsletterRequest */])(id);case 4:
                _context3.next = 8;break;case 6:
                _context3.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["d" /* activateNewsletterRequest */])(id);case 8:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Saved');_this.getNewsletter();_context3.next = 18;break;case 12:
                _context3.prev = 12;_context3.t0 = _context3['catch'](0);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context3.t0, 'response.status') === 401)) {
                  _context3.next = 17;break;
                }_this.props.logout();return _context3.abrupt('return');case 17:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Error');case 18:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2, [[0, 12]]);
      }));
    };_this.onSend = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                _this.setState({ sendingId: id });_context4.prev = 1;_context4.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_39" /* sendNewsletterRequest */])(id);case 4:
                _context4.next = 12;break;case 6:
                _context4.prev = 6;_context4.t0 = _context4['catch'](1);if (!(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context4.t0, 'response.status') === 401)) {
                  _context4.next = 11;break;
                }_this.props.logout();return _context4.abrupt('return');case 11:
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_20_lodash_get___default()(_context4.t0, 'response.data.error', 'Error'));case 12:
                _this.setState({ sendingId: null });_this.getNewsletter();case 14:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[1, 6]]);
      }));return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }();_this.state = { newsletters: [], nameSearch: null, errorMessage: null, responseMessage: null, isLoading: false, sites: [], site: null, filter: null, order: 'asc', currentPage: 1, total: 1, pageSize: 25, eventVisibleDropdown: false, eventsSelected: {}, sortedInfo: {}, newsletterEdit: null, filterBy: null, filterValue: null, filtersBy: [], filtersValue: [], approvedSelected: null, sendingId: null, roles: [] };return _this;
  }_createClass(Newsletter, [{ key: 'componentDidMount', value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref7, data, _ref8, sites;return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {case 0:
                _context5.next = 2;return this.onNameSearch();case 2:
                _context5.prev = 2;_context5.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_15" /* getSettingsRolesRequest */])();case 5:
                _ref7 = _context5.sent;data = _ref7.data;_context5.next = 9;return Object(__WEBPACK_IMPORTED_MODULE_28__api_requests__["_20" /* getSitesRequest */])();case 9:
                _ref8 = _context5.sent;sites = _ref8.data;this.setState({ roles: data, sites: sites });_context5.next = 20;break;case 14:
                _context5.prev = 14;_context5.t0 = _context5['catch'](2);if (!(_context5.t0.response.status === 401)) {
                  _context5.next = 19;break;
                }this.props.logout();return _context5.abrupt('return');case 19:
                console.log(_context5.t0);case 20:case 'end':
                return _context5.stop();}
          }
        }, _callee5, this, [[2, 14]]);
      }));function componentDidMount() {
        return _ref6.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          sites = _state.sites,
          newsletters = _state.newsletters,
          currentPage = _state.currentPage,
          total = _state.total,
          pageSize = _state.pageSize,
          newsletterEdit = _state.newsletterEdit,
          roles = _state.roles,
          nameSearch = _state.nameSearch;var _props = this.props,
          newsletterCreatePermission = _props.newsletterCreatePermission,
          newsletterUpdatePermission = _props.newsletterUpdatePermission,
          newsletterDeletePermission = _props.newsletterDeletePermission;var columns = [{ dataIndex: "subject", key: "subject", title: "Subject" }, { dataIndex: "is_scheduled", key: "is_scheduled", title: "Is scheduled", render: function render(val) {
          return val ? 'Yes' : 'No';
        } }, { dataIndex: "sent_at", key: "sent_at", title: "Sent at", render: function render(val, row) {
          return val ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(val).format('YYYY MM DD, HH:mm') + (' ' + row.time_zone) : '';
        } }, { dataIndex: "send_at", key: "send_at", title: "Date scheduled", render: function render(val, row) {
          return val ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(val).format('YYYY MM DD, HH:mm') + (' ' + row.time_zone) : '';
        } }, { dataIndex: "repeat", key: "repeat", title: "Recurrence options" }, { dataIndex: "id", key: "id", title: "Actions", render: function render(val, newsletter) {
          return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.actions }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Edit newsletter' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'edit', theme: 'filled', className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.iconEdit, onClick: _this3.onNewsletterEdit(newsletter) })), '\xA0 \xA0', __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { style: { width: '90px', display: 'flex' } }, (newsletterUpdatePermission && newsletter.state === 'inactive' || newsletterDeletePermission && newsletter.state === 'active') && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.switchLabel }, 'State'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tooltip___default.a, { placement: 'topLeft', title: 'Activate / Deactivate' }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default.a, { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.reactivateBtn, checked: newsletter.state === 'active', onChange: _this3.onSwitchNewsletterActivation(val, newsletter.state) })))));
        } }];return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('h3', { className: 'headline-default' }, 'Mailing List'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.searchWrapper }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.searchWrapperSearch }, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('b', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.searchWrapperLabel }, 'SEARCH'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Search, { placeholder: 'By name', enterButton: 'Search', size: 'large', onSearch: this.onNameSearch, value: nameSearch, onChange: this.onNameChange, style: { maxWidth: '500px' } })), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_26__Newsletter_css___default.a.clearButton, onClick: this.clearFilters }, 'Clear')), newsletterCreatePermission && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { type: 'primary', onClick: this.addNewsletter }, 'Add newsletter'), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a, { columns: columns, dataSource: newsletters, loading: isLoading, rowKey: 'id', onChange: this.handleTableChange, pagination: { onShowSizeChange: function onShowSizeChange(current, size) {
            _this3.setState({ pageSize: size });
          }, current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] } }), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a, { visible: !!newsletterEdit, onCancel: this.onNewsletterEditHide, footer: null, width: '90%' }, newsletterEdit && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_NewsletterForm_NewsletterForm__["a" /* default */], Object.assign({ roles: roles, sites: sites }, newsletterEdit, { isNew: newsletterEdit && !newsletterEdit.id, onSubmit: this.onNewsletterEditSubmit, onCancel: this.onNewsletterEditHide })))), __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Newsletter;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { newsletterCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["L" /* getNewsletterCreatePermission */])(state), newsletterUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["O" /* getNewsletterUpdatePermission */])(state), newsletterDeletePermission: Object(__WEBPACK_IMPORTED_MODULE_30__reducers_user_selectors__["M" /* getNewsletterDeletePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_29__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Newsletter)));

/***/ }),
/* 3540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_number_style__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input_number__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_badge_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_quill__ = __webpack_require__(3541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_img_image_placeholder_jpg__ = __webpack_require__(3643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_img_image_placeholder_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_img_image_placeholder_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css__ = __webpack_require__(3644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_input_TextArea__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_input_TextArea__);



























var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option;var NewsletterForm = function (_React$Component) {
  _inherits(NewsletterForm, _React$Component);function NewsletterForm(props) {
    var _this2 = this;_classCallCheck(this, NewsletterForm);var _this = _possibleConstructorReturn(this, (NewsletterForm.__proto__ || Object.getPrototypeOf(NewsletterForm)).call(this, props));_this.handleSubmit = function (e) {
      e.preventDefault();_this.props.form.validateFields(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {case 0:
                  _this.setState({ isSubmitted: true, requestResult: {} });if (err) {
                    _context.next = 5;break;
                  }_this.setState({ isLoading: true });_context.next = 5;return _this.submit(values);case 5:case "end":
                  return _context.stop();}
            }
          }, _callee, _this2);
        }));return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };_this.submit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2(values, isSend) {
        var _document, formData, errors;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                _context2.prev = 0;_document = Object.assign({}, values);_document.name = __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_document, "document_file.fileList", []).slice(-1).name;_document.category = "per_site";_document.document_file = values.document_file.file;formData = new FormData();if (values.document_file && values.document_file.file) {
                  formData.append("document_file", values.document_file.file);
                }formData.append("send_at", values.send_at.format('YYYY-MM-DD HH:mm'));if (values.ends) {
                  formData.append("ends", values.ends);
                }if (values.ends === 'on_date') {
                  formData.append("ends_date", values.ends_date.format('YYYY-MM-DD'));
                }if (values.ends === 'after_occurrences') {
                  formData.append("ends_occurrences", values.ends_occurrences);
                }if (isSend) {
                  formData.append("is_scheduled", 'true');
                }formData.append("subject", values.subject);formData.append("repeat", values.repeat);formData.append("text", values.text);formData.append("site_ids", "[" + values.site_ids + "]");formData.append("user_roles_ids", "[" + values.user_roles_ids + "]");formData.append("time_zone", values.time_zone);if (!_this.props.id) {
                  _context2.next = 23;break;
                }_context2.next = 21;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["_64" /* updateNewsletterRequest */])(_this.props.id, formData);case 21:
                _context2.next = 25;break;case 23:
                _context2.next = 25;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["t" /* createNewsletterRequest */])(formData);case 25:
                _this.setState({ isLoading: false, requestResult: { type: "success", message: "Success" } });setTimeout(function () {
                  _this.props.onSubmit(_this.props.id);
                }, 1000);_context2.next = 36;break;case 29:
                _context2.prev = 29;_context2.t0 = _context2["catch"](0);if (!(__WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_context2.t0, "response.status") === 401)) {
                  _context2.next = 34;break;
                }_this.props.logout();return _context2.abrupt("return");case 34:
                _this.setState({ isLoading: false, requestResult: { type: "error", message: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_context2.t0, "response.data.message", "Error") } });if (__WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_context2.t0, "response.data.errors")) {
                  errors = {};Object.keys(__WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_context2.t0, "response.data.errors")).forEach(function (errorFieldKey) {
                    errors[errorFieldKey] = { value: values[errorFieldKey], errors: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(_context2.t0, "response.data.errors." + errorFieldKey).map(function (errorMessage) {
                        return new Error(errorMessage);
                      }) };
                  });_this.props.form.setFields(errors);
                }case 36:case "end":
                return _context2.stop();}
          }
        }, _callee2, _this2, [[0, 29]]);
      }));return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();_this.onSend = function () {
      _this.submit(_this.props.form.getFieldsValue(), true);
    };_this.onCategoryChange = function () {
      _this.props.form.setFieldsValue({ type: null });
    };_this.imageHandler = function () {
      var input = document.createElement('input');input.setAttribute('type', 'file');input.setAttribute('accept', 'image/*');input.click();input.onchange = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var file, formData, range, _ref4, url;return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                file = input.files[0];formData = new FormData();formData.append('document_file', file); // Save current cursor state
                range = _this.quillRef.current.editor.getSelection(true); // Insert temporary loading placeholder image
                _this.quillRef.current.editor.insertEmbed(range.index, 'image', __WEBPACK_IMPORTED_MODULE_30__assets_img_image_placeholder_jpg___default.a); // Move cursor to right side of image (easier to continue typing)
                _this.quillRef.current.editor.setSelection(range.index + 1);_context3.next = 8;return Object(__WEBPACK_IMPORTED_MODULE_31__api_requests__["_76" /* uploadNewsletterImage */])(formData);case 8:
                _ref4 = _context3.sent;url = _ref4.data.url; // Remove placeholder image
                _this.quillRef.current.editor.deleteText(range.index, 1); // Insert uploaded image
                // this.quillRef.current.editor.insertEmbed(range.index, 'image', res.body.image);
                _this.quillRef.current.editor.insertEmbed(range.index, 'image', url);case 12:case "end":
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));
    };_this.quillModules = { toolbar: { container: [[{ size: [] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ list: 'ordered' }, { list: 'bullet' }], ['color', 'background'], ['link', 'image'], ['clean']], handlers: { image: _this.imageHandler, color: function color() {
            return _this.colorHandler('color-picker', 'ql-color', 'color', '-3rem');
          }, background: function background() {
            return _this.colorHandler('background-picker', 'ql-background', 'background', '-1.5rem');
          } } } };_this.colorHandler = function (id, toolbarClass, type, margin) {
      var picker = document.getElementById(id);var pickerButton = document.getElementsByClassName(toolbarClass)[0];if (!picker) {
        picker = document.createElement('input');picker.id = id;picker.type = 'color'; // picker.style.display = 'none';
        picker.style.position = 'absolute';picker.style.width = '1rem';picker.style.marginLeft = margin;picker.style.opacity = 0;picker.value = '#FF0000';pickerButton.parentElement.appendChild(picker);picker.addEventListener('change', function (e) {
          _this.quillRef.current.editor.format(type, picker.value);
        }, false);
      }setTimeout(function () {
        picker.click();
      });
    };_this.state = { isLoading: false, requestResult: {}, html: props.form.getFieldValue('text'), htmlVisible: false };_this.quillRef = __WEBPACK_IMPORTED_MODULE_25_react___default.a.createRef();return _this;
  }_createClass(NewsletterForm, [{ key: "componentDidMount", value: function componentDidMount() {
      this.setState({ html: this.props.form.getFieldValue('text') });
    } }, { key: "render", value: function render() {
      var _this3 = this;var _state = this.state,
          isLoading = _state.isLoading,
          requestResult = _state.requestResult;var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;var _props = this.props,
          roles = _props.roles,
          newsletterUpdatePermission = _props.newsletterUpdatePermission,
          newsletterCreatePermission = _props.newsletterCreatePermission,
          id = _props.id,
          isNew = _props.isNew,
          send_at = _props.send_at,
          ends_date = _props.ends_date,
          sites = _props.sites;var isEditable = id ? newsletterUpdatePermission : newsletterCreatePermission;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.wrapper }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a, { onSubmit: this.handleSubmit }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("h4", { className: "headline-default" }, this.props.id ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", null, this.props.subject, " ", __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_badge___default.a, { count: "Edit", style: { backgroundColor: "#2968AE" } })) : isNew ? "Add New Newsletter" : ""), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("document_file", { initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, "document_file", "") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a, { disabled: !isEditable, accept: ".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4", action: "", beforeUpload: function beforeUpload() {
          return false;
        }, multiple: false, fileList: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props.form.getFieldValue("document_file"), "fileList", []).slice(-1) }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: "upload" }), !this.props.form.getFieldValue("document_file") && this.props.attachment_url ? "Change file" : "Attach a document")))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, !this.props.form.getFieldValue("document_file") && this.props.attachment_url && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("a", { href: this.props.attachment_url, target: "_blank" }, this.props.attachment_name), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("br", null)))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Subject"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator("subject", { rules: [{ required: true, message: "Required" }], initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, "subject") })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: !isEditable, type: "text" }))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Select roles:"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('user_roles_ids', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'user_roles_ids', []) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: "multiple" }, roles.map(function (_ref5) {
        var id = _ref5.id,
            name = _ref5.name;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: id, value: id }, name);
      })))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Select Sites:"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('site_ids', { initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'site_ids', []) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { mode: "multiple" }, sites.map(function (_ref6) {
        var id = _ref6.id,
            name = _ref6.name,
            code = _ref6.code;return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { key: id, value: id }, code, " - ", name);
      }))))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Send time"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { style: { display: 'flex', alignItems: 'center', maxWidth: '400px' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, getFieldDecorator('send_at', { rules: [{ required: true }], initialValue: send_at ? __WEBPACK_IMPORTED_MODULE_26_moment___default()(send_at) : null })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a, { showTime: true, id: "send_at", name: "send_at", allowClear: true }))))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Time Zone:"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('time_zone', { initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'time_zone', 'UTC') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, { placeholder: "Select" }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "UTC" }, "None (UTC)"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "America/Edmonton" }, "America/Edmonton"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "America/Vancouver" }, "America/Vancouver"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "America/Winnipeg" }, "America/Winnipeg"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "America/Toronto" }, "America/Toronto"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "America/Halifax" }, "America/Halifax"))))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, getFieldValue('ends') === 'after_occurrences' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Occurrences"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('ends_occurrences', { initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'ends_occurrences') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input_number___default.a, null)))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Repeat:"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('repeat', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'repeat', null) })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "none" }, "Does not repeat"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "daily" }, "Daily"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "weekly" }, "Weekly"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "monthly" }, "Monthly"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "annually" }, "Annually"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "week_day" }, "Every week day (Monday to Friday)"))))))), getFieldValue('repeat') && getFieldValue('repeat') !== 'none' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Ends"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('ends', { initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'ends') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "never" }, "Never"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "on_date" }, "On date"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(Option, { value: "after_occurrences" }, "After occurrences")))))), getFieldValue('ends') === 'on_date' && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, { span: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "End date"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { style: { display: 'flex', alignItems: 'center', maxWidth: '400px' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, getFieldDecorator('ends_date', { rules: [{ required: true }], initialValue: ends_date ? __WEBPACK_IMPORTED_MODULE_26_moment___default()(ends_date) : null })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_date_picker___default.a, { id: "ends_date", name: "ends_date", allowClear: true })))))))), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12 }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("span", { style: { display: 'flex', justifyContent: 'space-between' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "Text"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { style: { marginTop: '-0.5rem' }, size: "small", type: "button", onClick: function onClick() {
          _this3.setState(function (state) {
            return { htmlVisible: !state.htmlVisible };
          });
        } }, this.state.htmlVisible ? 'Hide' : 'Edit', " HTML")), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, getFieldDecorator('text', { rules: [{ required: true, message: 'Required' }], initialValue: __WEBPACK_IMPORTED_MODULE_27_lodash_get___default()(this.props, 'text', '') })(__WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_quill___default.a, { ref: this.quillRef, disabled: !isEditable, theme: "snow", onBlur: function onBlur(range, source, editor) {
          return _this3.setState({ html: editor.getHTML() });
        }, modules: this.quillModules })))))), this.state.htmlVisible && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row___default.a, { gutter: 12, style: { marginBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("label", null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("b", null, "HTML"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_input_TextArea___default.a, { rows: 8, value: this.state.html, onChange: function onChange(e) {
          return _this3.setState({ html: e.target.value });
        }, onFocus: function onFocus(e) {
          return _this3.quillRef.current.editor.disable();
        }, onBlur: function onBlur(e) {
          _this3.quillRef.current.editor.clipboard.dangerouslyPasteHTML(e.target.value);_this3.quillRef.current.editor.enable();
        } })))), requestResult.type && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a, { message: requestResult.message, type: requestResult.type, className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.submitResult }), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.actionWrapper }, isEditable && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "submit", className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.submitButton }, "Save", isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0"), isEditable && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: "primary", size: "large", htmlType: "button", onClick: this.onSend, className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.submitButton }, "Send", isLoading && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: "loading" })), "\xA0 \xA0"), __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a, { type: "default", size: "large", htmlType: "button", className: __WEBPACK_IMPORTED_MODULE_33__NewsletterForm_css___default.a.submitButton, onClick: this.props.onCancel }, "Cancel"))));
    } }]);return NewsletterForm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);var mapStateToProps = function mapStateToProps(state, props) {
  return { userShortTimezone: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["_63" /* getUserShortTimezone */])(state), newsletterCreatePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["L" /* getNewsletterCreatePermission */])(state), newsletterUpdatePermission: Object(__WEBPACK_IMPORTED_MODULE_32__reducers_user_selectors__["O" /* getNewsletterUpdatePermission */])(state) };
};var mapDispatchToProps = { logout: __WEBPACK_IMPORTED_MODULE_34__reducers_user_actions__["e" /* logout */] };/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_21_antd_lib_form___default.a.create({ name: "user" })(Object(__WEBPACK_IMPORTED_MODULE_28_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(NewsletterForm)));

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = __webpack_require__(584);
var Component = __webpack_require__(3546);

module.exports = Component;
module.exports.default = Component;
module.exports.Quill = Quill;
module.exports.Mixin = __webpack_require__(586);
module.exports.Toolbar = __webpack_require__(3640);


/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(3543)
var ieee754 = __webpack_require__(3544)
var isArray = __webpack_require__(3545)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 3544 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 3545 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);
var createClass = __webpack_require__(585);
var QuillMixin = __webpack_require__(586);
var find = __webpack_require__(587);
var some = __webpack_require__(3632);
var isEqual = __webpack_require__(601);
var T = __webpack_require__(12);
var DOM = __webpack_require__(602);

var QuillComponent = createClass({

	displayName: 'Quill',

	mixins: [ QuillMixin ],

	propTypes: {
		id: T.string,
		className: T.string,
		theme: T.string,
		style: T.object,
		readOnly: T.bool,
		value: T.oneOfType([T.string, T.shape({ops: T.array})]),
		defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
		placeholder: T.string,
		tabIndex: T.number,
		bounds: T.oneOfType([T.string, T.element]),
		onChange: T.func,
		onChangeSelection: T.func,
		onFocus: T.func,
		onBlur: T.func,
		onKeyPress: T.func,
		onKeyDown: T.func,
		onKeyUp: T.func,
		preserveWhitespace: T.bool,

		modules: function(props) {
			var isNotObject = T.object.apply(this, arguments);
			if (isNotObject) return isNotObject;

			if (
				props.modules && 
				props.modules.toolbar &&
				props.modules.toolbar[0] &&
				props.modules.toolbar[0].type
			) return new Error(
				'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
				'anymore. Create a toolbar explictly, or let Quill create one. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
			);
		},

		toolbar: function(props) {
			if ('toolbar' in props) return new Error(
				'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
			);
		},

		formats: function(props) {
			var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);

			if (isNotArrayOfString) return new Error(
				'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		styles: function(props) {
			if ('styles' in props) return new Error(
				'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		pollInterval: function(props) {
			if ('pollInterval' in props) return new Error(
				'The `pollInterval` property does not have any effect anymore. ' +
				'You can safely remove it from your props.' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		children: function(props) {
			// Validate that the editor has only one child element and it is not a <textarea>
			var isNotASingleElement = T.element.apply(this, arguments);
			if (isNotASingleElement) return new Error(
				'The Quill editing area can only be composed of a single React element.'
			);

			if (React.Children.count(props.children)) {
				var child = React.Children.only(props.children);
				if (child.type === 'textarea') return new Error(
					'Quill does not support editing on a <textarea>. Use a <div> instead.'
				);
			}
		}
	},
		
	/*
	Changing one of these props should cause a full re-render.
	*/
	dirtyProps: [
		'modules',
		'formats',
		'bounds',
		'theme',
		'children',
	],

	/*
	Changing one of these props should cause a regular update.
	*/
	cleanProps: [
		'id',
		'className',
		'style',
		'placeholder',
		'tabIndex',
		'onChange',
		'onChangeSelection',
		'onFocus',
		'onBlur',
		'onKeyPress',
		'onKeyDown',
		'onKeyUp',
	],

	getDefaultProps: function() {
		return {
			theme: 'snow',
			modules: {},
		};
	},

	/*
	We consider the component to be controlled if `value` is being sent in props.
	*/
	isControlled: function() {
		return 'value' in this.props;
	},

	getInitialState: function() {
		return {
			generation: 0,
			value: this.isControlled()
				? this.props.value
				: this.props.defaultValue
		};
	},

	componentWillReceiveProps: function(nextProps, nextState) {
		var editor = this.editor;

		// If the component is unmounted and mounted too quickly
		// an error is thrown in setEditorContents since editor is
		// still undefined. Must check if editor is undefined
		// before performing this call.
		if (!editor) return;
		
		// Update only if we've been passed a new `value`.
		// This leaves components using `defaultValue` alone.
		if ('value' in nextProps) {
			var currentContents = this.getEditorContents();
			var nextContents = nextProps.value;

			if (nextContents === this.lastDeltaChangeSet) throw new Error(
				'You are passing the `delta` object from the `onChange` event back ' +
				'as `value`. You most probably want `editor.getContents()` instead. ' +
				'See: https://github.com/zenoamaro/react-quill#using-deltas'
			);

			// NOTE: Seeing that Quill is missing a way to prevent
			//       edits, we have to settle for a hybrid between
			//       controlled and uncontrolled mode. We can't prevent
			//       the change, but we'll still override content
			//       whenever `value` differs from current state.
			// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
			//       a change, regardless of whether they represent the same document.
			if (!this.isEqualValue(nextContents, currentContents)) {
				this.setEditorContents(editor, nextContents);
			}
		}
		
		// We can update readOnly state in-place.
		if ('readOnly' in nextProps) {
			if (nextProps.readOnly !== this.props.readOnly) {
				this.setEditorReadOnly(editor, nextProps.readOnly);
			}
		}

		// If we need to regenerate the component, we can avoid a detailed
		// in-place update step, and just let everything rerender.
		if (this.shouldComponentRegenerate(nextProps, nextState)) {
			return this.regenerate();
		}
	},

	componentDidMount: function() {
		this.editor = this.createEditor(
			this.getEditingArea(),
			this.getEditorConfig()
		);
		// Restore editor from Quill's native formats in regeneration scenario
		if (this.quillDelta) {
			this.editor.setContents(this.quillDelta);
			this.editor.setSelection(this.quillSelection);		
			this.editor.focus();
			this.quillDelta = this.quillSelection = null;
			return;
		}
		if (this.state.value) {
			this.setEditorContents(this.editor, this.state.value);
			return;
		}
	},

	componentWillUnmount: function() {
		var editor; if ((editor = this.getEditor())) {
			this.unhookEditor(editor);
			this.editor = null;
		}
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		var self = this;

		// If the component has been regenerated, we already know we should update.
		if (this.state.generation !== nextState.generation) {
			return true;
		}
		
		// Compare props that require React updating the DOM.
		return some(this.cleanProps, function(prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	shouldComponentRegenerate: function(nextProps, nextState) {
		var self = this;
		// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
		return some(this.dirtyProps, function(prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	/*
	If we could not update settings from the new props in-place, we have to tear
	down everything and re-render from scratch.
	*/
	componentWillUpdate: function(nextProps, nextState) {
		if (this.state.generation !== nextState.generation) {
			this.componentWillUnmount();
		}
	},

	componentDidUpdate: function(prevProps, prevState) {
		if (this.state.generation !== prevState.generation) {
			this.componentDidMount();
		}
	},

	getEditorConfig: function() {
		return {
			bounds:       this.props.bounds,
			formats:      this.props.formats,
			modules:      this.props.modules,
			placeholder:  this.props.placeholder,
			readOnly:     this.props.readOnly,
      			scrollingContainer: this.props.scrollingContainer,
			tabIndex:     this.props.tabIndex,
			theme:        this.props.theme,
		};
	},

	getEditor: function() {
		return this.editor;
	},

	getEditingArea: function () {
		return ReactDOM.findDOMNode(this.editingArea);
	},

	getEditorContents: function() {
		return this.state.value;
	},

	getEditorSelection: function() {
		return this.state.selection;
	},

	/*
	True if the value is a Delta instance or a Delta look-alike.
	*/
	isDelta: function(value) {
		return value && value.ops;
	},

	/*
	Special comparison function that knows how to compare Deltas.
	*/
	isEqualValue: function(value, nextValue) {
		if (this.isDelta(value) && this.isDelta(nextValue)) {
			return isEqual(value.ops, nextValue.ops);
		} else {
			return isEqual(value, nextValue);
		}
	},

	/*
	Regenerating the editor will cause the whole tree, including the container,
	to be cleaned up and re-rendered from scratch.
	*/
	regenerate: function() {
		// Cache selection and contents in Quill's native format to be restored later
		this.quillDelta = this.editor.getContents();
		this.quillSelection = this.editor.getSelection();
		this.setState({
			generation: this.state.generation + 1,
		});
	},

	/*
	Renders an editor area, unless it has been provided one to clone.
	*/
	renderEditingArea: function() {
		var self = this;
		var children = this.props.children;
		var preserveWhitespace = this.props.preserveWhitespace;

		var properties = {
			key: this.state.generation,
			tabIndex: this.props.tabIndex,
			ref: function(element) { self.editingArea = element },
		};

		var customElement = React.Children.count(children)
			? React.Children.only(children)
			: null;
		var defaultElement = preserveWhitespace ? DOM.pre : DOM.div;
		var editingArea = customElement
			? React.cloneElement(customElement, properties)
			: defaultElement(properties);

		return editingArea;
	},

	render: function() {
		return DOM.div({
			id: this.props.id,
			style: this.props.style,
			key: this.state.generation,
			className: ['quill'].concat(this.props.className).join(' '),
			onKeyPress: this.props.onKeyPress,
			onKeyDown: this.props.onKeyDown,
			onKeyUp: this.props.onKeyUp },
			this.renderEditingArea()
		);
	},

	onEditorChangeText: function(value, delta, source, editor) {
		var currentContents = this.getEditorContents();

		// We keep storing the same type of value as what the user gives us,
		// so that value comparisons will be more stable and predictable.
		var nextContents = this.isDelta(currentContents)
			? editor.getContents()
			: editor.getHTML();
		
		if (!this.isEqualValue(nextContents, currentContents)) {
			// Taint this `delta` object, so we can recognize whether the user
			// is trying to send it back as `value`, preventing a likely loop.
			this.lastDeltaChangeSet = delta;

			this.setState({ value: nextContents });

			if (this.props.onChange) {
				this.props.onChange(value, delta, source, editor);
			}
		}
	},

	onEditorChangeSelection: function(nextSelection, source, editor) {
		var currentSelection = this.getEditorSelection();
		var hasGainedFocus = !currentSelection && nextSelection;
		var hasLostFocus = currentSelection && !nextSelection;

		if (isEqual(nextSelection, currentSelection)) {
			return;
		}
		
		this.setState({ selection: nextSelection });
		
		if (this.props.onChangeSelection) {
			this.props.onChangeSelection(nextSelection, source, editor);
		}

		if (hasGainedFocus && this.props.onFocus) {
			this.props.onFocus(nextSelection, source, editor);
		} else if (hasLostFocus && this.props.onBlur) {
			this.props.onBlur(currentSelection, source, editor);
		}
	},

	focus: function() {
		this.editor.focus();
	},

	blur: function() {
		this.setEditorSelection(this.editor, null);
	}

});

module.exports = QuillComponent;


/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(95);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(356),
    isArrayLike = __webpack_require__(236),
    keys = __webpack_require__(235);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(3550),
    getMatchData = __webpack_require__(3611),
    matchesStrictComparable = __webpack_require__(598);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(588),
    baseIsEqual = __webpack_require__(360);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 3551 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 3554 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 3557 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 3558 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 3559 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230),
    Map = __webpack_require__(358),
    MapCache = __webpack_require__(359);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 3561 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(589),
    isMasked = __webpack_require__(3564),
    isObject = __webpack_require__(173),
    toSource = __webpack_require__(591);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 3562 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(232);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 3563 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(3565);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(93);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 3566 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(3568),
    ListCache = __webpack_require__(230),
    Map = __webpack_require__(358);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(3569),
    hashDelete = __webpack_require__(3570),
    hashGet = __webpack_require__(3571),
    hashHas = __webpack_require__(3572),
    hashSet = __webpack_require__(3573);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(233);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 3570 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(233);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(233);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(233);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(234);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 3575 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(234);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(234);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(234);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(588),
    equalArrays = __webpack_require__(592),
    equalByTag = __webpack_require__(3584),
    equalObjects = __webpack_require__(3588),
    getTag = __webpack_require__(3606),
    isArray = __webpack_require__(94),
    isBuffer = __webpack_require__(595),
    isTypedArray = __webpack_require__(596);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(359),
    setCacheAdd = __webpack_require__(3581),
    setCacheHas = __webpack_require__(3582);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 3581 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 3582 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 3583 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(232),
    Uint8Array = __webpack_require__(3585),
    eq = __webpack_require__(357),
    equalArrays = __webpack_require__(592),
    mapToArray = __webpack_require__(3586),
    setToArray = __webpack_require__(3587);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(93);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 3586 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 3587 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(3589);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(3590),
    getSymbols = __webpack_require__(3592),
    keys = __webpack_require__(235);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 3590 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(3591),
    isArray = __webpack_require__(94);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 3591 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(3593),
    stubArray = __webpack_require__(3594);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 3593 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 3594 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(3596),
    isArguments = __webpack_require__(594),
    isArray = __webpack_require__(94),
    isBuffer = __webpack_require__(595),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(596);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 3596 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObjectLike = __webpack_require__(174);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 3598 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 3599 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isLength = __webpack_require__(362),
    isObjectLike = __webpack_require__(174);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 3600 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(590);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(3603),
    nativeKeys = __webpack_require__(3604);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 3603 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(3605);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 3605 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(3607),
    Map = __webpack_require__(358),
    Promise = __webpack_require__(3608),
    Set = __webpack_require__(3609),
    WeakMap = __webpack_require__(3610),
    baseGetTag = __webpack_require__(172),
    toSource = __webpack_require__(591);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 3607 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149),
    root = __webpack_require__(93);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149),
    root = __webpack_require__(93);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149),
    root = __webpack_require__(93);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(149),
    root = __webpack_require__(93);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(597),
    keys = __webpack_require__(235);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(360),
    get = __webpack_require__(3613),
    hasIn = __webpack_require__(3620),
    isKey = __webpack_require__(363),
    isStrictComparable = __webpack_require__(597),
    matchesStrictComparable = __webpack_require__(598),
    toKey = __webpack_require__(238);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(599);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(3615);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(3616);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(359);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(3618);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(232),
    arrayMap = __webpack_require__(3619),
    isArray = __webpack_require__(94),
    isSymbol = __webpack_require__(237);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 3619 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(3621),
    hasPath = __webpack_require__(3622);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 3621 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(600),
    isArguments = __webpack_require__(594),
    isArray = __webpack_require__(94),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(362),
    toKey = __webpack_require__(238);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 3623 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(3625),
    basePropertyDeep = __webpack_require__(3626),
    isKey = __webpack_require__(363),
    toKey = __webpack_require__(238);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 3625 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(599);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(3628),
    baseIteratee = __webpack_require__(356),
    toInteger = __webpack_require__(3629);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 3628 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(3630);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(3631);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(173),
    isSymbol = __webpack_require__(237);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(593),
    baseIteratee = __webpack_require__(356),
    baseSome = __webpack_require__(3633),
    isArray = __webpack_require__(94),
    isIterateeCall = __webpack_require__(3639);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(3634);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(3635),
    createBaseEach = __webpack_require__(3638);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(3636),
    keys = __webpack_require__(235);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3637);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 3637 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 3638 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(236);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 3639 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(357),
    isArrayLike = __webpack_require__(236),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(173);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
QuillToolbar is deprecated. Consider switching to the official Quill
toolbar format, or providing your own toolbar instead. 
See https://quilljs.com/docs/modules/toolbar
*/



var React = __webpack_require__(0);
var ReactDOMServer = __webpack_require__(3641);
var createClass = __webpack_require__(585);
var find = __webpack_require__(587);
var isEqual = __webpack_require__(601);
var T = __webpack_require__(12);
var DOM = __webpack_require__(602);

var defaultColors = [
	'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
	'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
	'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
	'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
	'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
	'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
	'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
	'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
	'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
	'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
	'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
	'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
].map(function(color){ return { value: color } });

var defaultItems = [

	{ label:'Formats', type:'group', items: [
		{ label:'Font', type:'font', items: [
			{ label:'Sans Serif',  value:'sans-serif', selected:true },
			{ label:'Serif',       value:'serif' },
			{ label:'Monospace',   value:'monospace' }
		]},
		{ label:'Size', type:'size', items: [
			{ label:'Small',  value:'10px' },
			{ label:'Normal', value:'13px', selected:true },
			{ label:'Large',  value:'18px' },
			{ label:'Huge',   value:'32px' }
		]},
		{ label:'Alignment', type:'align', items: [
			{ label:'', value:'', selected:true },
			{ label:'', value:'center' },
			{ label:'', value:'right' },
			{ label:'', value:'justify' }
		]}
	]},

	{ label:'Text', type:'group', items: [
		{ type:'bold', label:'Bold' },
		{ type:'italic', label:'Italic' },
		{ type:'strike', label:'Strike' },
		{ type:'underline', label:'Underline' },
		{ type:'color', label:'Color', items:defaultColors },
		{ type:'background', label:'Background color', items:defaultColors },
		{ type:'link', label:'Link' }
	]},

	{ label:'Blocks', type:'group', items: [
		{ type:'list', value:'bullet' },
		{ type:'list', value:'ordered' }
	]},

	{ label:'Blocks', type:'group', items: [
		{ type:'image', label:'Image' }
	]}

];

var QuillToolbar = createClass({

	displayName: 'Quill Toolbar',

	propTypes: {
		id:        T.string,
		className: T.string,
		style:     T.object,
		items:     T.array
	},

	getDefaultProps: function() {
		return {
			items: defaultItems
		};
	},

	componentDidMount: function() {
		console.warn(
			'QuillToolbar is deprecated. Consider switching to the official Quill ' +
			'toolbar format, or providing your own toolbar instead. ' +
			'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
		);
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		return !isEqual(nextProps, this.props);
	},

	renderGroup: function(item, key) {
		return DOM.span({
			key: item.label || key,
			className:'ql-formats' },
			item.items.map(this.renderItem)
		);
	},

	renderChoiceItem: function(item, key) {
		return DOM.option({
			key: item.label || item.value || key,
			value: item.value },
			item.label
		);
	},

	renderChoices: function(item, key) {
		var choiceItems = item.items.map(this.renderChoiceItem);
		var selectedItem = find(item.items, function(item){ return item.selected });
		var attrs = {
			key: item.label || key,
			title: item.label,
			className: 'ql-'+item.type,
			value: selectedItem.value,
		};
		return DOM.select(attrs, choiceItems);
	},

	renderButton: function(item, key) {
		return DOM.button({
			type: 'button',
			key: item.label || item.value || key,
			value: item.value,
			className: 'ql-'+item.type,
			title: item.label },
			item.children
		);
	},

	renderAction: function(item, key) {
		return DOM.button({
			key: item.label || item.value || key,
			className: 'ql-'+item.type,
			title: item.label },
			item.children
		);
	},

	/* jshint maxcomplexity: false */
	renderItem: function(item, key) {
		switch (item.type) {
			case 'group':
				return this.renderGroup(item, key);
			case 'font':
			case 'header':
			case 'align':
			case 'size':
			case 'color':
			case 'background':
				return this.renderChoices(item, key);
			case 'bold':
			case 'italic':
			case 'underline':
			case 'strike':
			case 'link':
			case 'list':
			case 'bullet':
			case 'ordered':
			case 'indent':
			case 'image':
			case 'video':
				return this.renderButton(item, key);
			default:
				return this.renderAction(item, key);
		}
	},

	getClassName: function() {
		return 'quill-toolbar ' + (this.props.className||'');
	},

	render: function() {
		var children = this.props.items.map(this.renderItem);
		var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
		return DOM.div({
			id: this.props.id,
			className: this.getClassName(),
			style: this.props.style,
			dangerouslySetInnerHTML: { __html:html }
		});
	},

});

module.exports = QuillToolbar;
QuillToolbar.defaultItems = defaultItems;
QuillToolbar.defaultColors = defaultColors;


/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3642);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 3642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(95),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,v=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.block"):60121,la=t?Symbol.for("react.fundamental"):60117,ma=t?Symbol.for("react.scope"):60119;function na(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case v:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return C(a.type);case ka:return C(a.render);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var D=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var oa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}
function pa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=oa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var qa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ra=Object.prototype.hasOwnProperty,sa={},ta={};
function ua(a){if(ra.call(ta,a))return!0;if(ra.call(sa,a))return!1;if(qa.test(a))return ta[a]=!0;sa[a]=!0;return!1}function va(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wa(a,b,c,d){if(null===b||"undefined"===typeof b||va(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var xa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function ya(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||wa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return ua(a)?a+'="'+(N(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Aa="function"===typeof Object.is?Object.is:za,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Ba(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===Q?null===P?(R=!1,P=Q=Ba()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ba()):(R=!0,Q=Q.next);return Q}function Da(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Ea(a,b){return"function"===typeof b?b(a):b}
function Fa(a,b,c){O=W();Q=Ca();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Ea?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ga.bind(null,O,a);return[Q.memoizedState,a]}
function Ga(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ha(){}
var X=0,Ia={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ca();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Fa,useRef:function(a){O=W();Q=Ca();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Fa(Ea,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ha,useEffect:Ha,useDebugValue:Ha,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ja={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ka(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var La={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ma=k({menuitem:!0},La),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Na=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Oa=/([A-Z])/g,Pa=/^ms-/,Z=l.Children.toArray,Qa=D.ReactCurrentDispatcher,Ra={listing:!0,pre:!0,textarea:!0},Sa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ta={},Ua={};function Va(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Wa=Object.prototype.hasOwnProperty,Xa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Ya(a,b){if(void 0===a)throw Error(q(152,C(b)||"Component"));}
function Za(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=pa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var w=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=w&&(e.state=k({},e.state,w))}}else if(O={},e=g(d.props,
f,m),e=Da(g,d.props,e,f),null==e||null==e.render){a=e;Ya(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{w=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,w,d.props,f):p;null!=p&&(y?(y=!1,w=k({},w,p)):k(w,p))}e.state=w}}else x=null;a=e.render();Ya(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,C(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var $a=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ja.html,children:a,childIndex:0,context:oa,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Qa.current;Qa.current=Ia;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===v)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
w="";try{w+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=w}}return g[0]}finally{Qa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Za(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case v:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case la:throw Error(q(338));case ja:switch(c=a.type,na(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case ma:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ja.html&&Ka(c);if(!Ta.hasOwnProperty(c)){if(!Sa.test(c))throw Error(q(65,c));Ta[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Va(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(Ma[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Wa.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var w="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ua.hasOwnProperty(A))A=Ua[A];else{var T=A.replace(Oa,"-$1").toLowerCase().replace(Pa,"-ms-");A=Ua[A]=T}w+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";w+=y;r=";"}}m=w||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Xa.hasOwnProperty(z)||(n=z,n=ua(n)&&null!=m?n+'="'+(N(m)+'"'):""):n=ya(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";La.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Ra.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ka(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),ab={renderToString:function(a){a=new $a(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new $a(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.13.0"};module.exports=ab.default||ab;


/***/ }),
/* 3643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image_placeholder.3863dbbc.jpg";

/***/ }),
/* 3644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"NewsletterForm__wrapper__11nwz","submitResult":"NewsletterForm__submitResult__1jWtz","actionWrapper":"NewsletterForm__actionWrapper__Y5y7g","wrapper2faOptions":"NewsletterForm__wrapper2faOptions__RNsqn"};

/***/ }),
/* 3645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Newsletter__content__JiiH4","parentContainer":"Newsletter__parentContainer__3vGPu","searchWrapper":"Newsletter__searchWrapper__1fYnu","wrapperFilterItem":"Newsletter__wrapperFilterItem__2Qs6K","searchWrapperSearch":"Newsletter__searchWrapperSearch__1OVfU","searchWrapperLabel":"Newsletter__searchWrapperLabel__1WvN8","searchWrapperFilter":"Newsletter__searchWrapperFilter__3JR97","searchWrapperFilterItem":"Newsletter__searchWrapperFilterItem__1gPel","searchWrapperFilterItemApprove":"Newsletter__searchWrapperFilterItemApprove__3auk9","searchWrapperFilterLabel":"Newsletter__searchWrapperFilterLabel__2D1bZ","clearButton":"Newsletter__clearButton__2EmDU","checkIcon":"Newsletter__checkIcon__3qjr4","clockIcon":"Newsletter__clockIcon__3crgX","checkIconGray":"Newsletter__checkIconGray__29qj6","warningIcon":"Newsletter__warningIcon__3gFEB","iconStatusWrapper":"Newsletter__iconStatusWrapper__YqawF","eventDropdownItem":"Newsletter__eventDropdownItem__3HU3Q","legendItem":"Newsletter__legendItem__14fLI","icon":"Newsletter__icon__34XNe","iconEdit":"Newsletter__iconEdit__1-xwe","reactivateBtn":"Newsletter__reactivateBtn__2vT4D","actions":"Newsletter__actions__18nxs","nameDocumentWrapper":"Newsletter__nameDocumentWrapper__24oUi","switchLabel":"Newsletter__switchLabel__U1TYx","alert":"Newsletter__alert__D5NL9"};

/***/ }),
/* 3646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AdminHeader_AdminHeader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Reporting_css__ = __webpack_require__(3647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Reporting_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Reporting_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_isAuthenticated__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_requests__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__ = __webpack_require__(37);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default.a.Content;var reportTypes = { PDF: "pdf", CSV: "csv", TXT: "txt" };var Reporting = function (_React$Component) {
  _inherits(Reporting, _React$Component);function Reporting() {
    var _ref,
        _this2 = this;var _temp, _this, _ret;_classCallCheck(this, Reporting);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Reporting.__proto__ || Object.getPrototypeOf(Reporting)).call.apply(_ref, [this].concat(args))), _this), _this.state = { loadingReports: [] }, _this.downloadReport = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(report, type, label) {
        var data, response, _response, blob, link;return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _context.prev = 0;if (!(report === 'follow_up' || report === 'user' || report === 'combined_reports')) {
                  _context.next = 6;break;
                }_this.openNotification();Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_2" /* getFileReporting */])(report, type);_context.next = 25;break;case 6:
                _this.setState(function (state) {
                  return { loadingReports: Object.assign({}, state.loadingReports, _defineProperty({}, report, true)) };
                });data = null;if (!(report === 'reports_drug_inventory_by_depot_read')) {
                  _context.next = 15;break;
                }_context.next = 11;return Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_3" /* getFileReportingByDepot */])(report, type);case 11:
                response = _context.sent;data = response.data;_context.next = 19;break;case 15:
                _context.next = 17;return Object(__WEBPACK_IMPORTED_MODULE_17__api_requests__["_2" /* getFileReporting */])(report, type);case 17:
                _response = _context.sent;data = _response.data;case 19:
                blob = new Blob([data]);link = document.createElement('a');link.href = window.URL.createObjectURL(blob);link.download = label + "." + type;link.click();_this.setState(function (state) {
                  return { loadingReports: Object.assign({}, state.loadingReports, _defineProperty({}, report, false)) };
                });case 25:
                _context.next = 30;break;case 27:
                _context.prev = 27;_context.t0 = _context["catch"](0);console.log(_context.t0);case 30:case "end":
                return _context.stop();}
          }
        }, _callee, _this2, [[0, 27]]);
      }));return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.openNotification = function () {
      __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default.a.open({ message: "Success", description: "A report email has been sent" });
    }, _this.reports = [{ label: "Site status report", name: "site", permission: _this.props.reportsSitesReadPermission }, { label: "User account report (E-mail Report)", name: "user", permission: _this.props.reportsUsersReadPermission }, { label: "Subject listing", name: "subject", permission: _this.props.reportsSubjectsReadPermission }, { label: "SAE", name: "sae", permission: _this.props.reportsSaeReadPermission }, { label: "Deviations", name: "deviations", permission: _this.props.reportsDeviationsReadPermission }, { label: "Consent", name: "consent", permission: _this.props.reportsConsentReadPermission }, { label: "Death", name: "death", permission: _this.props.reportsDeathReadPermission }, { label: "Blinded allocations", name: "blinded_allocations", permission: _this.props.reportsBlindedAllocationsReadPermission }, { label: "Combined reports (E-mail Report)", name: "combined_reports", permission: _this.props.reportsCombinedReadPermission }, { label: "90d Follow-up Report (E-mail Report)", name: "follow_up", permission: _this.props.reportsFollowUpReadPermission }], _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Reporting, [{ key: "columns", value: function columns() {
      var _this3 = this;return [{ key: "report", title: "Report", render: function render(item) {
          return item.label;
        } }, { key: "actions", title: "Download", render: function render(item) {
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", { style: { display: "flex", alignItems: "center", position: 'relative' } }, item.permission && item.name !== 'combined_reports' && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { marginRight: "1rem", flex: 1 }, onClick: function onClick() {
              return _this3.downloadReport(item.name, reportTypes.PDF, item.label);
            }, disabled: _this3.state.loadingReports[item.name] || !item.permission }, "PDF"), item.permission && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { marginRight: "1rem", flex: 1 }, onClick: function onClick() {
              return _this3.downloadReport(item.name, reportTypes.CSV, item.label);
            }, disabled: _this3.state.loadingReports[item.name] || !item.permission }, "CSV"), item.permission && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a, { style: { marginRight: "1rem", flex: 1 }, onClick: function onClick() {
              return _this3.downloadReport(item.name, reportTypes.TXT, item.label);
            }, disabled: _this3.state.loadingReports[item.name] || !item.permission }, "TXT"), _this3.state.loadingReports[item.name] && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", { style: { position: 'absolute', paddingTop: '0.3rem', background: 'rgba(255,255,255,0.9)', textAlign: 'center', width: '100%', height: '100%' } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span", { style: { marginRight: '1rem', fontSize: '0.9rem', fontWeight: 'bold', color: "#faa41a" } }, "Report generation in progress"), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { style: { color: "#faa41a" }, type: "loading" })));
        } }];
    } }, { key: "render", value: function render() {
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", { style: { backgroundColor: "#FAFAFA" } }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_15__Reporting_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_AdminHeader_AdminHeader__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_15__Reporting_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("h3", { className: "headline-default" }, "Reporting"), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a, { columns: this.columns(), dataSource: this.reports.filter(function (_ref3) {
          var permission = _ref3.permission;return permission;
        }), className: __WEBPACK_IMPORTED_MODULE_15__Reporting_css___default.a.table, pagination: false, rowKey: "name" })), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Footer_Footer__["a" /* default */], { noAdminLink: true })));
    } }]);return Reporting;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { reportsSitesReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_30" /* getReportsSitesReadPermission */])(state), reportsUsersReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_32" /* getReportsUsersReadPermission */])(state), reportsSubjectsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_31" /* getReportsSubjectsReadPermission */])(state), reportsSaeReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_29" /* getReportsSaeReadPermission */])(state), reportsDeviationsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_26" /* getReportsDeviationsReadPermission */])(state), reportsConsentReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_24" /* getReportsConsentReadPermission */])(state), reportsDeathReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_25" /* getReportsDeathReadPermission */])(state), reportsBlindedAllocationsReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_22" /* getReportsBlindedAllocationsReadPermission */])(state), reportsCombinedReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_23" /* getReportsCombinedReadPermission */])(state), reportsFollowUpReadPermission: Object(__WEBPACK_IMPORTED_MODULE_18__reducers_user_selectors__["_27" /* getReportsFollowUpReadPermission */])(state) };
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16__utils_isAuthenticated__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["c" /* connect */])(mapStateToProps)(Reporting)));

/***/ }),
/* 3647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Reporting__content__31ULV","parentContainer":"Reporting__parentContainer__2Xp8U","searchWrapper":"Reporting__searchWrapper__14RVk","wrapperFilterItem":"Reporting__wrapperFilterItem__M9e12","searchWrapperSearch":"Reporting__searchWrapperSearch__1JJ6D","searchWrapperLabel":"Reporting__searchWrapperLabel__2Wq9y","searchWrapperFilter":"Reporting__searchWrapperFilter__28lZk","searchWrapperFilterItem":"Reporting__searchWrapperFilterItem__2dGDj","searchWrapperFilterLabel":"Reporting__searchWrapperFilterLabel___GGwZ","clearButton":"Reporting__clearButton__22np2","checkIcon":"Reporting__checkIcon__2Z2BY","clockIcon":"Reporting__clockIcon__1tpR-","checkIconGray":"Reporting__checkIconGray__2ekyN","warningIcon":"Reporting__warningIcon__19HlH","iconStatusWrapper":"Reporting__iconStatusWrapper__QySqS","eventDropdownItem":"Reporting__eventDropdownItem__1wFTd","legendItem":"Reporting__legendItem__13-ZC","icon":"Reporting__icon__2YdL6","iconEdit":"Reporting__iconEdit__115U6","reactivateBtn":"Reporting__reactivateBtn__37seJ","actions":"Reporting__actions__1m215","nameAuditWrapper":"Reporting__nameAuditWrapper__1fhGh","switchLabel":"Reporting__switchLabel__3fiYX","table":"Reporting__table__3rMxi","resendBtn":"Reporting__resendBtn__jsyB4","searchWrapperFilterItemApprove":"Reporting__searchWrapperFilterItemApprove__3j952"};

/***/ }),
/* 3648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alert":"App__alert__I4U0d","msg":"App__msg__ceihP","toggleAlert":"App__toggleAlert__1Nux0","errorBox":"App__errorBox__1acDc","verticalCenter":"App__verticalCenter__3QTtL"};

/***/ }),
/* 3649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeVancouver_ConsentForm__ = __webpack_require__(3650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css__ = __webpack_require__(3658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    _classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.state = { step: {} };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, _ref2, data, _step;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');if (!this.props.consentData) {
                  _context.next = 6;break;
                }this.setState({ step: Object.assign({}, this.props.consentData) });this.props.consentUpdate({});_context.next = 22;break;case 6:
                if (!token) {
                  _context.next = 21;break;
                }_context.prev = 7;_context.next = 10;return __WEBPACK_IMPORTED_MODULE_13__services__["c" /* consentServices */].getConsentVancouverByToken(token);case 10:
                _ref2 = _context.sent;data = _ref2.data;_step = { consentMethodType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsMethodType'), consentPersonType: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType'), subjectID: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'subjectID'), consentDate: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentDate') };this.setState({ step: _step, currentStepPerson: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(data, 'consentExistsPersonType') });_context.next = 19;break;case 16:
                _context.prev = 16;_context.t0 = _context['catch'](7);this.props.history.push('/consent_error');case 19:
                _context.next = 22;break;case 21:
                this.props.history.push('/consent');case 22:case 'end':
                return _context.stop();}
          }
        }, _callee, this, [[7, 16]]);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var token = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(this.props, 'match.params.token');var _state$step = this.state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { style: { backgroundColor: '#FAFAFA' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css___default.a.parentContainer }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Content, { className: __WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css___default.a.content }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { xs: { span: 24 }, sm: { span: 20, offset: 2 }, md: { span: 16, offset: 4 }, style: { paddingTop: '4rem' } }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h1', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { style: { color: '#286DA8' } }, 'AcT')), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a, { type: 'flex', justify: 'center' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__ConsentTypeVancouver_css___default.a.contentWrap, 'frosted-card-edm'), xs: 24, sm: 18, md: 18, lg: 20, xl: 22 }, (!token || token && consentMethodType && consentPersonType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConsentTypeVancouver_ConsentForm__["a" /* default */], { token: token, step: Object.assign({}, this.state.step), currentStepPerson: this.state.currentStepPerson, history: this.props.history })))))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer_Footer__["a" /* default */], null)));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var mapStateToProps = function mapStateToProps(state) {
  return { consentData: Object(__WEBPACK_IMPORTED_MODULE_14__reducers_consent_selectors__["a" /* getConsentData */])(state) };
};var mapDispatchToProps = { consentUpdate: __WEBPACK_IMPORTED_MODULE_15__reducers_consent_actions__["b" /* consentUpdate */] };/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["c" /* connect */])(mapStateToProps, mapDispatchToProps)(Consent));

/***/ }),
/* 3650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsentTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Step2__ = __webpack_require__(3651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Step3aPatient__ = __webpack_require__(3652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__ = __webpack_require__(3655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Step3b__ = __webpack_require__(3656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Step4__ = __webpack_require__(3657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services__ = __webpack_require__(39);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Signature from "./Signature";
 // const { Option } = Select;
var ConsentTypes = { 'Patient_Electronic': 'consent_patient_electronic', 'Patient_Paper': 'consent_patient_paper', 'Patient_Email': 'consent_patient_email', 'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form', 'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper', 'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email', 'Patient_WithdrawConsentElectronic': 'consent_patient_withdraw_electronic', 'Patient_WithdrawConsentPaper': 'consent_patient_withdraw_paper', 'Patient_WithdrawConsentEmail': 'consent_patient_withdraw_email', 'Surrogate_Electronic': 'consent_surrogate_electronic', 'Surrogate_Paper': 'consent_surrogate_paper', 'Surrogate_Email': 'consent_surrogate_email' };var Consent = function (_React$Component) {
  _inherits(Consent, _React$Component);function Consent(props) {
    var _this2 = this;_classCallCheck(this, Consent);var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this, props));_this.initialStep = {};_this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileList: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileDc = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListDc: e.fileList }) };
      });return e && e.fileList;
    };_this.normFileWithdraw = function (e) {
      if (Array.isArray(e)) {
        return e;
      }if (e.fileList.length > 1) {
        e.fileList.shift();
      }_this.setState(function (state) {
        return { step: Object.assign({}, state.step, { fileListWithdraw: e.fileList }) };
      });return e && e.fileList;
    };_this.handleSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                e.preventDefault();_this.props.form.validateFields(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(err, values) {
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {case 0:
                            if (!err) {
                              if (values['dateOfBirth']) {
                                values['dateOfBirth'] = __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD');
                              }_this.setState(function (state) {
                                return { step: Object.assign({}, state.step, _this.normalizeValues(values)) };
                              }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
                                var _this$state, currentStep, _this$state$step, consentMethodType, consentPersonType, currentStepPerson;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {case 0:
                                        _this$state = _this.state, currentStep = _this$state.currentStep, _this$state$step = _this$state.step, consentMethodType = _this$state$step.consentMethodType, consentPersonType = _this$state$step.consentPersonType, currentStepPerson = _this$state.currentStepPerson;if (!(currentStep === 'Step 2')) {
                                          _context.next = 6;break;
                                        }if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                          });
                                        }if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step) };
                                          });
                                        }if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
                                          _this.setState(function (state) {
                                            return { currentStepInt: 3, currentStep: 'Step 3b', step: Object.assign({}, state.step) };
                                          });
                                        }return _context.abrupt('return');case 6:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator')) {
                                          _context.next = 9;break;
                                        }_this.setState(function (state) {
                                          return { currentStepInt: 3, currentStep: 'Step 3a', step: Object.assign({}, state.step), currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' };
                                        });return _context.abrupt('return');case 9:
                                        if (!(currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator')) {
                                          _context.next = 13;break;
                                        }_context.next = 12;return _this.sendForm(_this.normalizeValues(values));case 12:
                                        return _context.abrupt('return');case 13:
                                        if (!(currentStep === 'Step 3a')) {
                                          _context.next = 16;break;
                                        }_context.next = 16;return _this.sendForm(_this.normalizeValues(values));case 16:
                                        if (!(currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType))) {
                                          _context.next = 25;break;
                                        }_context.prev = 17;_context.next = 20;return _this.sendForm(_this.normalizeValues(values), values['consentFile']);case 20:
                                        _context.next = 25;break;case 22:
                                        _context.prev = 22;_context.t0 = _context['catch'](17);if (_context.t0.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t0, 'response.data.error', 'Error'), 5);
                                        }case 25:
                                        if (!(currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType))) {
                                          _context.next = 34;break;
                                        }_context.prev = 26;_context.next = 29;return _this.sendForm(_this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);case 29:
                                        _context.next = 34;break;case 31:
                                        _context.prev = 31;_context.t1 = _context['catch'](26);if (_context.t1.response) {
                                          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context.t1, 'response.data.error', 'Error'), 5);
                                        }case 34:case 'end':
                                        return _context.stop();}
                                  }
                                }, _callee, _this2, [[17, 22], [26, 31]]);
                              })));
                            }case 1:case 'end':
                            return _context2.stop();}
                      }
                    }, _callee2, _this2);
                  }));return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());case 2:case 'end':
                return _context3.stop();}
          }
        }, _callee3, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.normalizeValues = function (values) {
      var normalizedValues = Object.assign({}, values);for (var key in values) {
        if (__WEBPACK_IMPORTED_MODULE_11_moment___default.a.isMoment(values[key])) {
          var date = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(values[key]);normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm'); // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
        }if (values[key] === 'true') {
          normalizedValues[key] = true;
        }if (values[key] === 'false') {
          normalizedValues[key] = false;
        }
      }return normalizedValues;
    };_this.sendForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(values, file) {
        var fileDc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var fileWithdraw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var token, propsFormValues, formData, _ref5, data;return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {case 0:
                token = _this.props.token;_this.setState({ loading: true });propsFormValues = { siteID: _this.props.step.siteID, subjectID: _this.props.step.subjectID, userID: _this.props.step.userID };formData = Object.assign({}, _this.state.step, propsFormValues, { consent_type: ConsentTypes[_this.state.step.consentPersonType + '_' + _this.state.step.consentMethodType], consentMethodType: undefined, consentPersonType: undefined });_context4.prev = 4;_context4.next = 7;return __WEBPACK_IMPORTED_MODULE_17__services__["c" /* consentServices */].createVancouver(formData, file);case 7:
                _ref5 = _context4.sent;data = _ref5.data;_this.setState(function (state) {
                  return { currentStep: 'Step 4', step: Object.assign({}, state.step, data) };
                });_context4.next = 16;break;case 12:
                _context4.prev = 12;_context4.t0 = _context4['catch'](4);console.log(_context4.t0);if (_context4.t0.response) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_context4.t0, 'response.data.error'), 5);
                }case 16:
                _this.setState({ loading: false });case 17:case 'end':
                return _context4.stop();}
          }
        }, _callee4, _this2, [[4, 12]]);
      }));return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onPrev = function () {
      var currentStep = _this.state.currentStep;if (currentStep === 'Step 2') {
        _this.props.history.push('/consent');
      } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
        _this.setState({ step: Object.assign({}, _this.initialStep), currentStep: 'Step 2', currentStepPerson: '' });
      }
    };_this.state = { loading: false, currentStepPerson: '', currentStep: 'Step 2', step: Object.assign({}, _this.initialStep), currentStepInt: 2 };return _this;
  }_createClass(Consent, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;if (this.props.token) {
        this.setState(function (state) {
          return { currentStepPerson: _this3.props.currentStepPerson, currentStep: 'Step 3a', step: Object.assign({}, state.step, _this3.props.step) };
        });
      }
    } }, { key: 'render', value: function render() {
      var _state = this.state,
          loading = _state.loading,
          currentStep = _state.currentStep,
          _state$step = _state.step,
          consentMethodType = _state$step.consentMethodType,
          consentPersonType = _state$step.consentPersonType,
          step = _state.step,
          currentStepPerson = _state.currentStepPerson;var token = this.props.token;window.form = this.props.form;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h2', null, 'Consent - ', this.state.currentStep), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a, { onSubmit: this.handleSubmit, className: 'main-form' }, currentStep === 'Step 2' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Step2__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step)), currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Step3aPatient__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Step3aRegainedCapacity__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { token: token }))), currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile })), currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Step3b__["a" /* default */], Object.assign({}, this.props.step, { form: this.props.form }, this.state.step, { normFile: this.normFile, normFileDc: this.normFileDc, normFileWithdraw: this.normFileWithdraw })), currentStep === 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Step4__["a" /* default */], Object.assign({}, this.props.step, this.state.step, { token: token })), currentStep !== 'Step 4' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'action-wrapper' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large', htmlType: 'submit', loading: loading }, currentStep === 'Step 1' || currentStep === 'Step 2' || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson) ? 'Next' : 'Submit'), (currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'secondary', size: 'large', htmlType: 'button', onClick: this.onPrev }, 'Back'))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5', null, 'or select one of the following options:'), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */], { to: '/' }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a, { type: 'primary', size: 'large' }, 'Home'))));
    } }]);return Consent;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);var ConsentForm = __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(Consent);/* harmony default export */ __webpack_exports__["a"] = (ConsentForm);

/***/ }),
/* 3651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var Option = __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option;/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4', null, 'Subject Found! Please verify details below:'), props.siteID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Exists: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExists === true ? 'Yes' : 'No')), props.consentExists && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'consent-exists' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Date: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsDate)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Person: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsPersonType)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', { key: name }, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name)))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Who will be providing Consent?'), props.form.getFieldDecorator('consentPersonType', { initialValue: props.consentPersonType || props.consentExistsPersonType, rules: [{ required: true, message: 'Please select who will be providing consent' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Patient' }, 'Patient'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Surrogate' }, 'Surrogate'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Consent Type'), props.form.getFieldDecorator('consentMethodType', { initialValue: props.consentExistsMethodType, rules: [{ required: true, message: 'Please select the type of consent desired' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'Paper' }, 'Paper Consent'), props.form.getFieldValue('consentPersonType') === 'Patient' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'RegainedCapacityPaper' }, 'Regained Capacity Paper'))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'form-label' }, 'Overwrite existing consent, if it exists?'), props.form.getFieldDecorator('consent_overwrite', { rules: [{ required: true, message: 'You need to agree to override data if you wish to proceed with this entry!' }] })(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 3652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__ = __webpack_require__(3653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__ = __webpack_require__(3654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Signature__ = __webpack_require__(603);















var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'Email' && !props.token);var isEmail = props.consentMethodType === 'Email';return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-group-details' }, props.siteID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, props.subjectID))), props.consentPersonType === 'Surrogate' ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Texts_SurrogateElectronicText__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Texts_PatientElectronicText__["a" /* default */], props), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.date || props.consentDate)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), props.consentPersonType === 'Patient' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE'), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai pris connaissance du formulaire d\u2019information et de consentement. On m\u2019a expliqu\xE9 le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement. On a r\xE9pondu \xE0 mes questions et on m\u2019a laiss\xE9 le temps voulu pour prendre une d\xE9cision. Apr\xE8s r\xE9flexion, je consens \xE0 participer \xE0 ce projet de recherche aux conditions qui y sont \xE9nonc\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de recherche \xE0 avoir acc\xE8s \xE0 mon dossier m\xE9dical."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_authorize_investigator', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non')))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom et coordonn\xE9es du m\xE9decin traitant:'), props.form.getFieldDecorator('mtl_consent_attending_physician_name_and_contact', { initialValue: props.mtl_consent_attending_physician_name_and_contact, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom et coordonn\xE9es du m\xE9decin traitant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_participant_name', { initialValue: props.mtl_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_participant_signature', label: 'Signature du/de la participant(e)', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DE LA PERSONNE QUI OBTIENT LE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au/\xE0 la participant(e) le projet de recherche et le pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu aux questions qu\u2019il/elle m\u2019a pos\xE9es."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_consent_investigator_name_1', { initialValue: props.mtl_consent_investigator_name_1, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_1', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), !isEmail && showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "SIGNATURE D\u2019UN T\xC9MOIN"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "J\u2019autorise le chercheur ou son \xE9quipe \xE0 informer mon m\xE9decin traitant de ma participation \xE0 ce projet et \xE0 lui transmettre toute information pertinente:"), props.form.getFieldDecorator('mtl_consent_has_witness', { rules: [{ initialValue: props.mtl_consent_has_witness || 'false', required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), props.form.getFieldValue('mtl_consent_has_witness') === 'true' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "La signature d\u2019un t\xE9moin est requise pour les raisons suivantes:"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_1', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Difficult\xE9 ou incapacit\xE9 \xE0 lire. La personne (t\xE9moin impartial) qui appose sa signature ci-dessous atteste qu\u2019on a lu le formulaire de consentement et qu\u2019on a expliqu\xE9 pr\xE9cis\xE9ment le projet au (\xE0 la) participant(e), qui semble l\u2019avoir compris.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, props.form.getFieldDecorator('mtl_consent_witness_reason_2', { initialValue: false, valuePropName: 'checked' })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a, null, "Incompr\xE9hension de la langue du formulaire de consentement - La personne qui appose sa signature ci-dessous a fait fonction d\u2019interpr\xE8te pour le ou la participant(e) au cours du processus visant \xE0 obtenir le consentement.")))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es)'), props.form.getFieldDecorator('mtl_consent_witness_name', { initialValue: props.mtl_consent_witness_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_witness_signature', label: 'Signature du t\xE9moin', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('u', null, 'Veuillez noter:'))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Il faut consigner dans le dossier de recherche du (de la) participant(e), le cas \xE9ch\xE9ant, d\u2019autres renseignements sur l\u2019aide fournie au cours du processus visant \xE0 obtenir le consentement.")), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, "APPROBATION PAR LE COMIT\xC9 D\u2019\xC9THIQUE DE LA RECHERCHE"), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Le comit\xE9 d\u2019\xE9thique de la recherche du CHUM a approuv\xE9 le projet et assurera le suivi du projet pour les \xE9tablissements du r\xE9seau de la sant\xE9 et des services sociaux du Qu\xE9bec participants.")), props.consentPersonType === 'Surrogate' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'SIGNATURE DU REPR\xC9SENTANT L\xC9GALEMENT AUTORIS\xC9'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature du repr\xE9sentant l\xE9galement autoris\xE9')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "\xC0titre de repr\xE9sentant l\xE9galement autoris\xE9, j\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "De plus, on m\u2019a inform\xE9 que si la personne que je repr\xE9sente redevient apte \xE0 consentir \xE0 ce projet par elle-m\xEAme, et si sa participation au projet de recherche est toujours en cours, elle sera aussi invit\xE9e \xE0 signer ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Apr\xE8s r\xE9flexion, j\u2019accepte que la personne que je repr\xE9sente participe \xE0 ce projet de recherche, conform\xE9ment aux conditions \xE9nonc\xE9es ci-dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der au dossier m\xE9dical de la personne que je repr\xE9sente pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, "(Facultatif) J\u2019autorise le m\xE9decin de l\u2019\xE9tude \xE0 informer le ou les m\xE9decins traitants de la personne que je repr\xE9sente qu\u2019elle participe \xE0 cette \xE9tude:"), props.form.getFieldDecorator('mtl_consent_study_physician', { rules: [{ initialValue: props.mtl_consent_study_physician, required: false }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'true' }, 'Oui'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'false' }, 'Non'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant /lien avec le repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name_and_relationship', { initialValue: props.mtl_consent_representative_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant /lien avec le repr\xE9sentant' })))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du repr\xE9sentant:'), props.form.getFieldDecorator('mtl_consent_representative_name', { initialValue: props.mtl_consent_representative_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du repr\xE9sentant' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_representative_signature', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au repr\xE9sentant l\xE9galement autoris\xE9 du participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Nom de la personne obtenant le consentement:'), props.form.getFieldDecorator('mtl_consent_investigator_name_2', { initialValue: props.mtl_consent_investigator_name_2, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom de la personne obtenant le consentement' })))), !props.token && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Signature__["a" /* default */], { fieldName: 'mtl_consent_investigator_signature_2', label: 'Signature', form: props.form }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), showForEmail && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 3653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_patient ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Yan Deschaintre', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Nicole ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), ' Dre Laura Gioia ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Gr\xE9gory Jacquin ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Alexandre Poppe ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dre C\xE9line Odier ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Christian Stapf', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologues')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUM.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUS au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUS pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUM au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 3654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, props.has_randomization_platform_step_3_surrogate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_surrogate_content } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { align: 'center' }, 'FORMULAIRE D\u2019INFORMATION ET DE CONSENTEMENT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { width: '100%', textAlign: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Titre du projet'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'L\u2019alt\xE9plasecompar\xE9  au t\xE9nect\xE9plasechez  des  patients  avec AVC isch\xE9mique aigu: essai comparatif randomis\xE9 pragmatique bas\xE9 sur les registres QuICR et OPTIMISE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Chercheur responsable au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dr Yan Deschaintre', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologue')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Co-chercheursau CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Dre Nicole ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), ' Dre Laura Gioia ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Gr\xE9gory Jacquin ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Alexandre Poppe ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dre C\xE9line Odier ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Dr Christian Stapf', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Neurologues')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Organisme Subventionnaire'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'Universit\xE9 de Calgary')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'Identifiant multicentrique'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, 'MP-20-2020-8866')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '30%' }, valign: 'top' }, 'No de projet au CHUM'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '70%' }, valign: 'top' }, '20.027'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { border: '1px solid white', padding: '15px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Processus de consentement dans le contexte actuel de la pand\xE9miede COVID-19'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est apte\xE0 consentir:'), ' consentement verbal et confirmation du consentement, lorsque possible, par \xE9crit ou de fa\xE7on \xE9lectronique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'Si le patient est inapte \xE0 consentir:'), ' consentement verbal par un repr\xE9sentant l\xE9gal et confirmation du consentement par \xE9crit ou de fa\xE7on \xE9lectronique par le repr\xE9sentant et, par la suite, par le participant lui-m\xEAme si recouvrement de sa capacit\xE9 d\xE9cisionnelle.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PR\xC9AMBULE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Ce formulaire s\u2019adresse au participant ou, en cas d\u2019incapacit\xE9 subite, \xE0 son repr\xE9sentant')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Nous  sollicitons  votre  participation  \xE0  un  projet  de  recherche  parce  que vous souffrez d\u2019un accident vasculaire  c\xE9r\xE9bral  isch\xE9mique  (AVC).  Cependant, avant d\u2019accepter de participer \xE0 ce projet et de signer ce formulaire d\u2019information et de consentement, veuillez prendre le temps de lire, de comprendre et de consid\xE9rer attentivement les renseignements qui suivent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ce formulaire peut contenir des mots que vous ne comprenez pas. Nous vous invitons \xE0 poser toutes les  questions que  vous  jugerez  utiles  au  chercheur  responsable  du  projet  ou  aux  autres  membres  du personnel  affect\xE9  au  projet  de  recherche  et\xE0  leur  demander  de  vous  expliquer  tout  mot  ou renseignement qui n\u2019est pas clair.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE ET OBJECTIFS DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un AVC isch\xE9mique se produit lorsqu\u2019un caillot produit un blocage dans une art\xE8re du cerveau.et r\xE9duit l\u2019apport sanguin n\xE9cessaire \xE0 son bon fonctionnement. Lorsque ceci se produit, la r\xE9gion du cerveau qui est affect\xE9e subit des dommages parfois permanents.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le premier m\xE9dicament \xE0 l\u2019\xE9tude, l\u2019alt\xE9plase, est le m\xE9dicament standard actuellement utilis\xE9 pour traiter l\u2019AVC isch\xE9mique en phase aig\xFCe. Il aide \xE0 dissoudre le caillot qui bloque l\u2019art\xE8re dans le but de restaurer la circulation sanguine au cerveau avant que les dommages ne soient permanents. Il est administr\xE9 dans une veine du bras. La dose est calcul\xE9e selon le poids de la personne et est administr\xE9e en une dose d\u2019attaque suivie d\u2019une perfusion d\u2019une (1) heure. L\u2019alt\xE9plase est approuv\xE9 par Sant\xE9 Canada.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'L\u2019autre m\xE9dicament \xE0 l\u2019\xE9tude, le t\xE9nect\xE9plase, est un m\xE9dicament similaire \xE0 l\u2019alt\xE9plase. Il est souvent utilis\xE9 chez les patients qui pr\xE9sentent une crise cardiaque avec un caillot qui bloque une art\xE8re du c\u0153ur. La dose de t\xE9nect\xE9plase est calcul\xE9e aussi selon le poids de la personne mais est administr\xE9 en un (1) bolus seulement (ce qui signifie que la dose de m\xE9dicament est administr\xE9e au complet par injection intraveineuse d\'un seul coup, par opposition \xE0 l\'administration lente par perfusion). Le t\xE9nect\xE9plase a d\xE9montr\xE9 des r\xE9sultats prometteurs. Des donn\xE9es pr\xE9liminaires sugg\xE8rent que le t\xE9nect\xE9plase pourrait \xEAtre sup\xE9rieur \xE0 l\'alt\xE9plase en terme d\'efficacit\xE9, et ce sans augmenter le risque h\xE9morragique. Si les deux m\xE9dicaments se montraient \xE9quivalents, le t\xE9nect\xE9plase serait favoris\xE9 car il est beaucoup plus rapide et facile \xE0 administrer. Le t\xE9nect\xE9plase n\u2019est pr\xE9sentement pas approuv\xE9 par Sant\xE9 Canada pour le traitement de l\u2019AVC isch\xE9mique aigue. Sant\xE9 Canada a toutefois approuv\xE9 l\u2019utilisation du t\xE9nect\xE9plase dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le but principal de cette \xE9tude est donc de comparer l\u2019utilisation de l\u2019alt\xE9plase et du t\xE9nect\xE9plase dans le traitement de l\u2019AVC afin de d\xE9terminer si les patients trait\xE9s par t\xE9nect\xE9plase se r\xE9tablissent aussi bien que ceux trait\xE9s par l\u2019alt\xE9plase apr\xE8s l\u2019AVC \xE0 l\u2019aide de l\u2019\xE9chelle Rankin, un questionnaire qui \xE9value votre niveau d\u2019autonomie dans l\u2019accomplissement de vos activit\xE9s quotidiennes apr\xE8s trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NOMBRE DE PARTICIPANT(E)S ET DUR\xC9E DE LA PARTICIPATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Un total de 1600 patients seront inclus dans cette \xE9tude dans plusieurs h\xF4pitaux au Canada, dont environ 450 au CHUM.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La dur\xE9e globale de l\u2019\xE9tude sera de trois (3) ans. Votre participation \xE0 l\u2019\xE9tude sera de trois (3) mois.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'NATURE DE LA PARTICIPATION DEMAND\xC9E')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de participer \xE0 l\u2019\xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire d\u2019information et de consentement, vous serez assign\xE9(e) al\xE9atoirement, c\u2019est-\xE0-dire au hasard, comme lorsqu\u2019on tire \xE0 pile ou face, par ordinateur, \xE0 l\u2019un des 2 groupes suivants de l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 1 (exp\xE9rimental):'), 'Vous recevrez le t\xE9nect\xE9plase en un (1) bolus, soit injection intraveineuse d\'un seul coup'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Groupe 2 (soins standard):'), 'Vous recevrez l\u2019alt\xE9plase par perfusion intraveineuse')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous aurez 1 possibilit\xE9 sur 2 (50%) d\u2019\xEAtre assign\xE9(e) au groupe 1 et 1 possibilit\xE9 sur 2 (50 %) d\u2019\xEAtre assign\xE9(e) au groupe 2.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous et votre m\xE9decin saurez \xE0 quel groupe vous \xEAtes assign\xE9(e).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous devrez \xE9galement vous soumettre aux tests et proc\xE9dures d\xE9crits dans la section \xABD\xE9roulement du projet/Proc\xE9dures\xBB ci-dessous. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '\xC0 noter que les proc\xE9dures de l\u2019\xE9tude font toutes partie des soins cliniques usuels standards et qu\u2019il n\u2019y aura pas de visite suppl\xE9mentaire li\xE9e \xE0 l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'D\xC9ROULEMENT DU PROJET / PROC\xC9DURES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous trouverez un tableau des visites et proc\xE9dures \xE0 l\u2019\xE9tude \xE0 la fin de ce document.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cette \xE9tude comportera 3 p\xE9riodes:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de traitement'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'la p\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '1) P\xE9riode de d\xE9termination de l\u2019\xE9ligibilit\xE9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous acceptez de prendre part \xE0 cette \xE9tude, et apr\xE8s avoir sign\xE9 le pr\xE9sent formulaire, vous devrez vous soumettre aux \xE9valuations suivantes effectu\xE9es dans le cadre de la prise en charge clinique usuelle afin que votre m\xE9decin de l\u2019\xE9tude et son personnel de recherche puissent confirmer que vous rencontrez les crit\xE8res d\u2019\xE9ligibilit\xE9 pour participer \xE0 l\u2019\xE9tude:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 1 \u2013 Jour 1 (dur\xE9e: 1h00 environ)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins clinique usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation de votre autonomie avant vos sympt\xF4mes d\u2019AVC (\xC9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos ant\xE9c\xE9dents m\xE9dicaux'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique, incluant \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de votre tension art\xE9rielle et de votre pouls'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de sang, dans le cadre exclusif de l\u2019\xE9tude:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '15 mL-3 cuill\xE8res \xE0 th\xE9 afin de v\xE9rifier votre fonction r\xE9nale, la pr\xE9sence d\u2019an\xE9mie, le taux de sodium et de potassium, et les \xE9l\xE9ments de coagulation de base.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '5 mL-1 cuill\xE8re \xE0 th\xE9 pour les femmes en mesure de procr\xE9er, afin de v\xE9rifier si vous \xEAtes enceinte. Si vous \xEAtes enceinte et selon votre histoire m\xE9dicale, votre m\xE9decin de l\u2019\xE9tude d\xE9cidera si vous pouvez ou non participer \xE0 l\u2019\xE9tude.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Imagerie de votre cerveau et de vos art\xE8res (scan et angioscanner c\xE9r\xE9bral)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si le r\xE9sultat des proc\xE9dures effectu\xE9es dans le cadre de la p\xE9riode de l\u2019\xE9valuation de d\xE9termination de l\u2019\xE9ligibilit\xE9 confirme que vous pouvez continuer \xE0 prendre part \xE0 l\u2019\xE9tude vous d\xE9buterez la phase de traitement:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '2) P\xE9riode de traitement')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 2 \u2013 Jour 1, assignation \xE0 un traitement de l\u2019\xE9tude (dur\xE9e: 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez l\u2019alt\xE9plase dans une veine ou'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous recevrez le t\xE9nect\xE9plase dans une veine')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, '3) P\xE9riode de suivi')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 3 \u2013 24 heures apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude \xE0 l\u2019\xE9tude (dur\xE9e: 30 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique: \xE9valuation de votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle. (\xC9chelle NIH)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Scanner c\xE9r\xE9bral (imagerie de votre cerveau)')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Visite 4 \u2013 3 mois apr\xE8s le d\xE9but du traitement \xE0 l\u2019\xE9tude suivi en clinique (dur\xE9e: 1 heure) et suivi t\xE9l\xE9phonique centralis\xE9 (dur\xE9e 15 minutes)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans le cadre de cette visite, les proc\xE9dures et tests suivants seront effectu\xE9s:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre des soins cliniques usuels'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen neurologique pour \xE9valuer votre capacit\xE9 \xE0 parler, votre force motrice, votre capacit\xE9 visuelle (\xC9chelle NIHSS)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Examen physique incluant l\u2019auscultation de votre c\u0153ur et de vos poumons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de votre \xE9tat de sant\xE9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Revue de vos m\xE9dicaments'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaire d\u2019\xE9valuation globale de votre autonomie: votre capacit\xE9 \xE0 marcher seul et \xE0 faire vos activit\xE9s quotidiennes de fa\xE7on autonome (\xE9chelle Rankin)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Prise de la tension art\xE9rielle et de votre pouls'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Dans le cadre de la recherche'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Questionnaires d\u2019\xE9valuation de votre r\xE9cup\xE9ration, de votre niveau fonctionnel et de votre qualit\xE9 de vie par entrevue t\xE9l\xE9phonique:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\xC9chelle Rankin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-5D-5L (un questionnaire comprenant cinq (5) questions \xE0 choix multiples vous permettant d\u2019\xE9valuer vous-m\xEAme votre qualit\xE9 de vie.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'EQ-VAS, une \xE9chelle gradu\xE9e de 0% \xE0 100% ou l\u2019on vous demande d\u2019appr\xE9cier, en pourcentage, votre \xE9tat de sant\xE9 globale au moment de l\u2019entrevue et une br\xE8ve \xE9valuation cognitive.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Partage de donn\xE9es m\xE9dico-administratives d\xE9-nominalis\xE9es (cod\xE9es) entre le Minist\xE8re de la Sant\xE9 et des Services sociaux du Qu\xE9bec (MSSS) et le personnel de recherche autoris\xE9, via l\u2019Institut canadien d\u2019information sur la sant\xE9 (ICIS). En effet, lors de chaque visite \xE0 l\'urgence et de chaque hospitalisation au Qu\xE9bec, des donn\xE9es telles la dur\xE9e de s\xE9jour, les diagnostics concernant la raison d\'admission, les complications et les maladies associ\xE9es sont collig\xE9es par le MSSS. Ces donn\xE9es seront d\xE9nominalis\xE9es, c\u2019est-\xE0-dire que le nom et donn\xE9es identificatoires sont remplac\xE9es par un code, avant d\u2019\xEAtre transmises \xE0 l\u2019\xE9quipe de recherche, et ce afin d\u2019assurer la confidentialit\xE9 des patients. .Cela permet d\u2019assurer la confidentialit\xE9 Les donn\xE9es recueillies dans le cadre la pr\xE9sente \xE9tude concernent les codes diagnostiques pos\xE9s et les dur\xE9es de s\xE9jour en \xE9tablissement de sant\xE9 durant la p\xE9riode de suivi de 3 mois, afin de s\u2019assurer qu\u2019il n\u2019y a pas d\u2019effet secondaire inattendu ou de prolongation de la dur\xE9e d\u2019hospitalisation en lien avec les traitements \xE0 l\u2019\xE9tude.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'VOS RESPONSABILIT\xC9S ET PR\xC9CAUTIONS IMPORTANTES \xC0 PRENDRE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En signant le pr\xE9sent formulaire de consentement, vous acceptez de suivre les consignes de votre m\xE9decin de l\u2019\xE9tude, de vous pr\xE9senter aux visites pr\xE9vues en lien avec l\u2019\xE9tude et de vous soumettre \xE0 toutes les \xE9valuations requises dans le cadre de l\u2019\xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Vous devrez informer le plus rapidement possible votre m\xE9decin de l\u2019\xE9tude ou un membre de son \xE9quipe, si vous pr\xE9sentez tout sympt\xF4me inhabituel ou effet secondaire, car cela pourrait avoir un impact sur votre sant\xE9. Vous pourrez les joindre aux num\xE9ros de t\xE9l\xE9phone indiqu\xE9s dans la section \xABIdentification des personnes ressources\xBB.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'En cas d\u2019urgence (soir, nuit, fin de semaine et jour f\xE9ri\xE9), pour rapporter des effets secondaires ou toute l\xE9sion li\xE9e \xE0 la recherche, vous devrez vous pr\xE9senter \xE0 l\u2019urgence du CHUM au besoin et vous serez vu(e) par l\u2019urgentologue et probablement le m\xE9decin de garde en neurologie. Vous devrez mentionner que vous participer \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Si, pendant votre participation \xE0 l\u2019\xE9tude, vous \xEAtes soign\xE9(e) dans un centre autre que le CHUM pour un probl\xE8me de sant\xE9 pouvant \xEAtre li\xE9 \xE0 votre AVC (incluant: r\xE9cidive d\u2019AVC, h\xE9morragie c\xE9r\xE9brale ou autre h\xE9morragie, chirurgie vasculaire ou installation de tuteur pour votre art\xE8re carotide, thrombose de votre art\xE8re carotide), vous devrez aviser le personnel m\xE9dical de cet autre centre de votre participation \xE0 cette \xE9tude, ainsi que votre m\xE9decin de l\u2019\xE9tude.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATIONS POUR LE REPR\xC9SENTANT L\xC9GAL HABILIT\xC9 \xC0 CONSENTIR EN CAS D\u2019INAPTITUDE DU/DE LA PARTICIPANT(E), EN SITUATION D\u2019URGENCE M\xC9DICALE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Dans l\u2019impossibilit\xE9 actuelle pour le participant de consentir \xE0 participer \xE0 l\u2019\xE9tude en raison de son inaptitude, le repr\xE9sentant l\xE9gal est sollicit\xE9 pour donner son consentement \xE0 la place du patient, tenant compte du meilleur int\xE9r\xEAt de ce dernier. Si toutefois le patient \xE9tait de nouveau en mesure de consentir par lui-m\xEAme, on lui demandera son consentement pour la poursuite \xE9ventuelle de sa participation \xE0 cette \xE9tude. Il pourra alors d\xE9cider de continuer ou de cesser de participer \xE0 l\u2019\xE9tude. Il pourra \xE9galement s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0noter que, si aucun repr\xE9sentant autoris\xE9 n\u2019est pas d\xE9j\xE0 sur place et ne peut \xEAtre joint en temps utile, les chercheurs pourront proc\xE9der au recrutement du/de la patient(e) dans l\u2019\xE9tude, si celle-ci r\xE9pond \xE0 ses besoins imm\xE9diats et si toutes les conditions pr\xE9vues dans les l\xE9gislations et politiques gouvernementales applicables sont r\xE9unies, \xE9tant entendu que le consentement du repr\xE9sentant sera sollicit\xE9 le plus rapidement possible par la suite. En cas de refus de ce dernier, il pourra retirer le/la patient(e) de l\u2019\xE9tude et s\u2019opposer \xE0 l\u2019utilisation des donn\xE9es le/la concernant recueillies dans le cadre de cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ET INCONV\xC9NIENTS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'La participation \xE0 cette \xE9tude vous exposera aux effets ind\xE9sirables \xE9num\xE9r\xE9s ci-dessous. Votre m\xE9decin de l\u2019\xE9tude en discutera avec vous. Comme dans le cas de tout m\xE9dicament, d\u2019autres effets ind\xE9sirables inattendus et parfois graves peuvent faire leur apparition. Votre m\xE9decin de l\u2019\xE9tude vous suivra de pr\xE8s pour voir si vous avez des effets ind\xE9sirables. Si c\u2019est possible, on vous donnera d\u2019autres m\xE9dicaments ou effectuera d\u2019autres interventions pour les att\xE9nuer et les rendre plus tol\xE9rables. Certains effets ind\xE9sirables peuvent \xEAtre s\xE9rieux, durer longtemps, \xEAtre permanents ou m\xEAme causer la mort.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Les risques associ\xE9s \xE0 la m\xE9dication de l\u2019\xE9tude (t\xE9nect\xE9plase) et \xE0 la m\xE9dication de soins usuels (alt\xE9plase) sont similaires:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Fr\xE9quents (entre 1 et 5%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement au cerveau.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Ecchymoses (bleu sur la peau)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement de nez, des gencives et du site d\u2019injection'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Moins fr\xE9quents (entre 0% et 1%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement digestif sang dans les sels (noirs ou rouge) ou vomissements de sang'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Saignement dans l\u2019urine'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, 'Rares (entre 0% et 0.0001%)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'R\xE9action allergique se manifestant par \u0153d\xE8me de la gorge avec difficult\xE9 \xE0 respirer et baisse de la tension art\xE9rielle')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'RISQUES ASSOCI\xC9S \xC0 LA GROSSESSE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche peut comporter des risques, connus ou non, pour les femmes enceintes, les enfants \xE0 na\xEEtre ou encore les nourrissons allait\xE9s au sein. Selon votre histoire et votre examen physique, votre m\xE9decin sp\xE9cialiste en AVC, d\xE9cidera si vous pouvez participer ou non \xE0 cette \xE9tude.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AVANTAGES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Il se peut que vous retiriez un b\xE9n\xE9fice personnel de votre participation \xE0 ce projet de recherche, mais on ne peut vous l\u2019assurer. \xC0 tout le moins, les r\xE9sultats obtenus contribueront \xE0 l\u2019avancement des connaissances dans ce domaine.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'CONFIDENTIALIT\xC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Durant votre participation \xE0 ce projet de recherche, le chercheur responsable de ce projet ainsi que les membres de son personnel de recherche recueilleront, dans un dossier de recherche, les renseignements vous concernant et n\xE9cessaires pour r\xE9pondre aux objectifs scientifiques de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces renseignements peuvent comprendre les informations contenues dans votre dossier m\xE9dical, concernant votre \xE9tat de sant\xE9 pass\xE9 et pr\xE9sent, vos habitudes de vie ainsi que les r\xE9sultats de tous les tests, examens et proc\xE9dures qui seront r\xE9alis\xE9s. Votre dossier peut aussi comprendre d\u2019autres renseignements tels que votre nom, votre sexe, votre date de naissance et votre origine ethnique.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Tous les renseignements recueillis demeureront confidentiels dans les limites pr\xE9vues par la loi. Vous ne serez identifi\xE9(e) que par un num\xE9ro de code. La cl\xE9 du code reliant votre nom \xE0 votre dossier de recherche sera conserv\xE9e par le chercheur responsable de ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour assurer votre s\xE9curit\xE9, une copie du formulaire de consentement sera vers\xE9e dans votre dossier m\xE9dical. Par cons\xE9quent, toute personne ou compagnie \xE0 qui vous donnerez acc\xE8s \xE0 votre dossier m\xE9dical aura acc\xE8s \xE0 ces informations.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche fera parvenir, \xE0 l\u2019organisme subventionnaire ou \xE0 ses repr\xE9sentants, les donn\xE9es cod\xE9es vous concernant.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche cod\xE9es pourront \xEAtre transmises par le commanditaire \xE0 ses partenaires commerciaux. Cependant l\u2019organisme subventionnaire et ses partenaires \xE0 l\u2019\xE9tranger sont tenus de respecter les r\xE8gles de confidentialit\xE9 en vigueur au Qu\xE9bec et au Canada, et ce, quels que soient les pays.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Ces donn\xE9es de recherche seront conserv\xE9es pendant au moins 25 ans par le chercheur responsable de ce projet de recherche et l\u2019organisme subventionnaire.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Les donn\xE9es de recherche pourront \xEAtre publi\xE9es ou faire l\u2019objet de discussions scientifiques, mais il ne sera pas possible de vous identifier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\xC0des fins de surveillance, de contr\xF4le, de protection, de s\xE9curit\xE9 et de mise en march\xE9 du m\xE9dicament \xE0 l\u2019\xE9tude, votre dossier de recherche ainsi que vos dossiers m\xE9dicaux pourront \xEAtre consult\xE9s par une personne mandat\xE9e par des organismes r\xE9glementaires, au Canada ou \xE0 l\u2019\xE9tranger, tel que Sant\xE9 Canada, ainsi que par des repr\xE9sentants de l\u2019organisme subventionnaire, de l\u2019\xE9tablissement ou du comit\xE9 d\u2019\xE9thique de la recherche. Ces personnes et ces organismes adh\xE8rent \xE0 une politique de confidentialit\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous avez le droit de consulter votre dossier de recherche pour v\xE9rifier les renseignements recueillis et les faire rectifier au besoin.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMMUNICATION DES R\xC9SULTATS G\xC9N\xC9RAUX TODO')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous pourrez conna\xEEtre les r\xE9sultats g\xE9n\xE9raux de cette \xE9tude si vous en faites la demande au chercheur responsable \xE0 la fin de l\u2019\xE9tude. Une lettre vous sera envoy\xE9e par la poste.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'POSSIBILIT\xC9 DE COMMERCIALISATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation au projet de recherche pourrait mener \xE0 la cr\xE9ation de produits commerciaux qui pourraient \xEAtre \xE9ventuellement prot\xE9g\xE9s par voie de brevet ou autres droits de propri\xE9t\xE9 intellectuelle. Cependant, dans un tel cas, vous ne pourrez en retirer aucun avantage financier.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'FINANCEMENT DU PROJET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable du projet et l\u2019\xE9tablissement ont re\xE7u un financement de l\u2019organisme subventionnaire pour mener \xE0 bien ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'COMPENSATION')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Vous ne recevrez pas de compensation financi\xE8re pour votre participation \xE0 ce projet de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'EN CAS DE PR\xC9JUDICE')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous deviez subir quelque pr\xE9judice que ce soit par suite de l\u2019administration du m\xE9dicament \xE0 l\u2019\xE9tude ou de toute proc\xE9dure reli\xE9e \xE0 ce projet de recherche, vous recevrez tous les soins et services requis par votre \xE9tat de sant\xE9.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'En acceptant de participer \xE0 ce projet de recherche, vous ne renoncez \xE0 aucun de vos droits et vous ne lib\xE9rez pas le chercheur responsable de ce projet de recherche, l\u2019organisme subventionnaire et l\'\xE9tablissement de leur responsabilit\xE9 civile et professionnelle.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'PARTICIPATION VOLONTAIRE ET DROIT DE RETRAIT')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre participation \xE0 ce projet de recherche est volontaire. Vous \xEAtes donc libre de refuser d\u2019y participer. Vous pouvez \xE9galement vous retirer de ce projet \xE0 n\u2019importe quel moment, sans avoir \xE0 donner de raisons, en informant l\u2019\xE9quipe de recherche.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Votre d\xE9cision de ne pas participer \xE0 ce projet de recherche ou de vous en retirer n\u2019aura aucune cons\xE9quence sur la qualit\xE9 des soins et des services auxquels vous avez droit ou sur votre relation avec les \xE9quipes qui les dispensent.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Le chercheur responsable de ce projet de recherche, le comit\xE9 d\u2019\xE9thique de la recherche ou l\u2019organisme subventionnaire peuvent mettre fin \xE0 votre participation, sans votre consentement. Cela peut se produire si de nouvelles d\xE9couvertes ou informations indiquent que votre participation au projet n\u2019est plus dans votre int\xE9r\xEAt, si vous ne respectez pas les consignes du projet de recherche ou encore s\u2019il existe des raisons administratives d\u2019abandonner le projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Cependant, avant de vous retirer de ce projet de recherche, nous vous sugg\xE9rons, \xE0 des fins de s\xE9curit\xE9, de revenir une derni\xE8re fois pour une \xE9valuation finale, 3 mois suite \xE0 votre AVC. Ce rendez- vous en clinique est une visite standard pour tout patient avec AVC.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous vous retirez du projet ou \xEAtes retir\xE9(e) du projet, l\u2019information et le mat\xE9riel d\xE9j\xE0 recueillis dans le cadre de ce projet seront n\xE9anmoins conserv\xE9s, analys\xE9s ou utilis\xE9s pour assurer l\u2019int\xE9grit\xE9 du projet.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Toute nouvelle connaissance acquise durant le d\xE9roulement du projet qui pourrait avoir un impact sur votre d\xE9cision de continuer \xE0 participer \xE0 ce projet vous sera communiqu\xE9e rapidement.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'AUTRES TRAITEMENTS POSSIBLES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous d\xE9cidez de ne pas participer \xE0 cette \xE9tude, votre m\xE9decin discutera avec vous des autres traitements disponibles.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'IDENTIFICATION DES PERSONNES-RESSOURCES')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Si vous avez des questions ou \xE9prouvez des probl\xE8mes en lien avec le projet de recherche, ou si vous souhaitez vous en retirer, vous pouvez communiquer avec le chercheur responsable, Dr Yan Deschaintre, ou avec une personne de l\u2019\xE9quipe de recherche au num\xE9ro suivant: 514-890-8000, poste 26242, entre 8h00 et 16h00, du lundi au vendredi.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Pour toute question concernant vos droits en tant que participant(e) \xE0 ce projet de recherche ou si vous avez des plaintes ou des commentaires \xE0 formuler, vous pouvez communiquer avec le commissaire local aux plaintes et \xE0 la qualit\xE9 des services du CHUM au 514-890-8484.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u', null, 'INFORMATION AU SUJET DE L\u2019\xC9TUDE SUR UN SITE INTERNET')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Une description de cette \xE9tude est disponible en anglais seulement sur ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.ClinicalTrials.gov', rel: 'noopener noreferrer', target: '_blank' }, 'http://www.ClinicalTrials.gov'), '. Ce site ne contient aucune information permettant de vous identifier. Le site inclura tout au plus un sommaire des r\xE9sultats lorsqu\u2019ils seront disponibles. Vous pouvez consulter ce site en tout temps. Le num\xE9ro d\u2019enregistrement de ce projet est le NCT03889249.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));
});

/***/ }),
/* 3655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Signature__ = __webpack_require__(603);













var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var _class = function (_React$Component) {
  _inherits(_class, _React$Component);function _class() {
    _classCallCheck(this, _class);return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }_createClass(_class, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.scrollTo(0, 0);
    } }, { key: 'render', value: function render() {
      var props = this.props;var showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);var isEmail = props.consentMethodType === 'EmailRegainedCapacity';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), props.siteID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID))), props.has_randomization_platform_step_3_patient_regained_capacity ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: props.randomization_platform_step_3_patient_regained_capacity_content } }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'justify' } }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e).")), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Server Date (UTC): ', props.consentDate || props.date)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Type: ', props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('strong', null, 'Consent Method: ', props.consentMethodType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, '\xA0'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { style: { textAlign: 'left' } }, isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Email'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('mtl_consent_participant_email', { initialValue: props.mtl_consent_participant_email, rules: [{ required: true, message: 'Veuillez saisir l\'email du participant' }, { type: 'email' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, placeholder: 'Email du participant' })))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'SIGNATURE DU PARTICIPANT REDEVENU APTE'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai examin\xE9 l\u2019ensemble du formulaire d\u2019information et de consentement et je comprends que mon repr\xE9sentant l\xE9galement autoris\xE9 a accept\xE9, en mon nom, que je participe \xE0 ce projet de recherche. Je reconnais que ce projet de recherche m\u2019a \xE9t\xE9 expliqu\xE9, qu\u2019on a r\xE9pondu \xE0 mes questions \xE0 ma satisfaction et que j\u2019ai eu assez de temps pour prendre une d\xE9cision."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je consens \xE0 continuer \xE0 participer \xE0 ce projet de recherche conform\xE9ment aux conditions \xE9nonc\xE9es ci- dessus. Je recevrai une copie sign\xE9e et dat\xE9e de ce formulaire d\u2019information et de consentement."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019autorise l\u2019\xE9quipe de l\u2019\xE9tude de recherche \xE0 acc\xE9der \xE0 mon dossier m\xE9dical pour les besoins de cette \xE9tude."), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Veuillez cocher la case appropri\xE9e pour indiquer votre d\xE9cision:'), props.form.getFieldDecorator('mtl_rccf_consent_option', { rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'stay_in_study' }, "Je d\xE9sire demeurer dans l\u2019\xE9tude."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a, { value: 'withdraw_from_study' }, "Je d\xE9sire me retirer de l\u2019\xE9tude.")))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du participant (patient):'), props.form.getFieldDecorator('mtl_rccf_consent_participant_name', { initialValue: props.mtl_rccf_consent_participant_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du participant (patient)' })))), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_participant_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom du t\xE9moin/lien avec le participant:'), props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', { initialValue: props.mtl_rccf_consent_witness_name_and_relationship, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom du t\xE9moin/lien avec le participant' })))), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_witness_signature', label: 'Signature', form: props.form }), !isEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Un t\xE9moin appose sa signature (i) en plus du patient si le consentement \xE9clair\xE9 est lu au patient, ou (ii) \xE0 la place du patient pour les patients qui sont l\xE9galement aptes \xE0 donner leur consentement, mais qui sont incapables de lire ou d\u2019\xE9crire (p. ex., la signature du t\xE9moin est appos\xE9e \xE0 c\xF4t\xE9 de l\u2019empreinte du pouce du patient)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, 'Signature de la personne obtenant le consentement')), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "J\u2019ai expliqu\xE9 au participant \xE0 la recherche l\u2019\xE9tude de recherche et les termes du pr\xE9sent formulaire d\u2019information et de consentement et j\u2019ai r\xE9pondu \xE0 toutes ses questions."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Nom (en lettres moul\xE9es):'), props.form.getFieldDecorator('mtl_rccf_consent_investigator_name', { initialValue: props.mtl_rccf_consent_investigator_name, rules: [{ required: true, message: 'Required' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a, { disabled: props.token, prefix: __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'user', style: { color: '#eee' } }), placeholder: 'Nom (en lettres moul\xE9es)' })))), !props.token && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Signature__["a" /* default */], { fieldName: 'mtl_rccf_consent_investigator_signature', label: 'Signature de la personne qui obtient le consentement', form: props.form }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je certifie qu\u2019on a expliqu\xE9 au/\xE0 la participant(e) le pr\xE9sent formulaire d\u2019information et de consentement, que l\u2019on a r\xE9pondu aux questions que le sujet de recherche avait."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('p', null, "Je m\u2019engage, avec l\u2019\xE9quipe de recherche, \xE0 respecter ce qui a \xE9t\xE9 convenu au formulaire d\u2019information et de consentement et \xE0 en remettre une copie sign\xE9e et dat\xE9e au/\xE0 la participant(e)."), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null), showForEmail && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above?'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)));
    } }]);return _class;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 3656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);












var Option = __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var fileDummyRequest = function fileDummyRequest(_ref) {
  var file = _ref.file,
      onSuccess = _ref.onSuccess;setTimeout(function () {
    onSuccess("ok");
  }, 0);
};/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h4', null, 'Paper Consent Process'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.siteID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b', null, props.consentMethodType))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, props.form.getFieldDecorator('consentFile', { initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [], valuePropName: 'fileList', getValueFromEvent: props.normFile, rules: [{ required: true, message: 'Please upload the consent file!' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a, { id: 'consentFile', name: 'consentFile', customRequest: fileDummyRequest, accept: '.pdf', allowClear: true, size: 'large' }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a, { type: 'upload' }), ' Upload Consent Form')))), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'form-label' }, 'Do you consent to the terms described above? If no, please click on the Back button!'), props.form.getFieldDecorator('consent_provided', { initialValue: props.consent_provided, rules: [{ required: true, message: 'Do you consent to the terms described above?' }] })(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a, null, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: 'yes' }, 'Yes'), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Option, { value: '' }, 'No'))))));
});

/***/ }),
/* 3657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', null, !props.token && ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(props, 'consentMethodType')) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!'), props.siteID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Site ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.siteID)), props.userID && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'User ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.userID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Subject ID: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.subjectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Type: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentPersonType)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Method: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentMethodType)), ['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Consent Email Status: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, props.consentExistsEmailStatus.replace(/_/g, ' '))), props.consentExistsLink && (Array.isArray(props.consentExistsLink) ? props.consentExistsLink.map(function (_ref) {
    var link = _ref.link,
        name = _ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: link, target: '_blank' }, name)));
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', null, 'Document Link: ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: props.consentExistsLink.link, target: '_blank' }, props.consentExistsLink.name))))));
});

/***/ }),
/* 3658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeVancouver__contentWrap__s4qb4"};

/***/ }),
/* 3659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3660);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(45)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-oneOf-5-1!../../node_modules/postcss-loader/lib/index.js??postcss!./index.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-oneOf-5-1!../../node_modules/postcss-loader/lib/index.js??postcss!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports
exports.i(__webpack_require__(3661), "");
exports.i(__webpack_require__(3662), "");
exports.i(__webpack_require__(3663), "");

// module
exports.push([module.i, "html {\n    scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Oxygen', BlinkMacSystemFont, Ubuntu, Segoe UI, Roboto, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #424242;\n  text-align: left; }\n\n  @-webkit-keyframes autofill {\n    to {\n        color: #F5F5F5;\n        background: rgba(0, 0, 0, 0);\n    }\n}\n\ninput:-webkit-autofill {\n    -webkit-animation-name: autofill;\n    -webkit-animation-fill-mode: both;\n}\n\n  h1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: 'Lato', sans-serif;\n  text-transform: capitalize;\n }\n\nh1, .h1 {\n  font-size: 6rem;\n  color: #757575;\n  text-align: center;  }\n\nh2, .h2 {\n  font-size: 2rem; }\n\nh3, .h3 {\n  font-size: 1.75rem; }\n\nh4, .h4 {\n  font-size: 1.5rem;\n  color: #FAFAFA; }\n\nh5, .h5 {\n  font-size: 1.25rem; }\n\nh6, .h6 {\n  font-size: 1rem; }\n\n\nh1 span,\nh2 span,\nh3 span,\nh4 span,\nh5 span,\nh6 span {\n    font-size: 0.85em;\n}\nh1 span.bigger,\nh2 span.bigger,\nh3 span.bigger,\nh4 span.bigger,\nh5 span.bigger,\nh6 span.bigger {\n    font-size: 1.15em;\n}\n\nh1.headline-default,\nh2.headline-default,\nh3.headline-default,\nh4.headline-default,\nh5.headline-default,\nh6.headline-default {\n    color: #111;\n}\n\n.small {\n  font-size: 80%;\n  font-weight: 400; }\n\n.btn-custom{\n  color: #4CDEF5;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: none;\n  cursor: pointer;\n  float: right;\n}\n\n.btn-submit {\n  border-radius: 2rem;\n  border: none;\n  -webkit-transition: 0.75s;\n  -o-transition: 0.75s;\n  transition: 0.75s;\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  width: 12rem;\n  max-width: 100%;\n  height: 4rem;\n}\n\n.btn-submit:hover {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n          box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n}\n\n.btn-submit:focus {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n}\n\n\n.menu-item {\n  border-radius: 2rem;\n  border: none;\n  -webkit-transition: 0.75s;\n  -o-transition: 0.75s;\n  transition: 0.75s;\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  max-width: 100%;\n  height: 4rem;\n}\n\n.menu-item:hover {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n          box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n}\n\n.menu-item:focus {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#286DA8), color-stop(51%, #4CDEF5), to(#286DA8));\n  background-image: -webkit-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: -o-linear-gradient(left, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n  background-image: linear-gradient(to right, #286DA8 0%, #4CDEF5 51%, #286DA8 100%);\n}\n\n\n.menu-item-green {\n  border-radius: 2rem;\n  border: none;\n  -webkit-transition: 0.75s;\n  -o-transition: 0.75s;\n  transition: 0.75s;\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#008000), color-stop(51%, #00cc33), to(#008000));\n  background-image: -webkit-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: -o-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: linear-gradient(to right, #008000 0%, #00cc33 51%, #008000 100%);\n  max-width: 100%;\n  height: 4rem;\n}\n\n.menu-item-green:hover {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#008000), color-stop(51%, #00cc33), to(#008000));\n  background-image: -webkit-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: -o-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: linear-gradient(to right, #008000 0%, #00cc33 51%, #008000 100%);\n  -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n          box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n}\n\n.menu-item-green:focus {\n  background-size: 200% auto;\n  background-image: -webkit-gradient(linear, left top, right top, from(#008000), color-stop(51%, #00cc33), to(#008000));\n  background-image: -webkit-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: -o-linear-gradient(left, #008000 0%, #00cc33 51%, #008000 100%);\n  background-image: linear-gradient(to right, #008000 0%, #00cc33 51%, #008000 100%);\n}\n\n\n.frosted-card,\n.frosted-card-edm {\n  background-image: url(data:image/png;base64,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);\n  background-color: rgba(66, 66, 66, 0.9);\n  padding: 3rem;\n  border-radius: 2rem;\n  text-align: center;\n  -webkit-box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);\n          box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);\n}\n\n.frosted-card input, select,\n.frosted-card-edm input, .frosted-card-edm select {\n  background-color: rgba(66, 66, 66, 0.9) !important;\n}\n\n.frosted-card ul,\n.frosted-card ol {\n    padding: 0;\n    color: #fff;\n}\n\n\n.frosted-card ul li {\n  list-style-type: none;\n  margin-bottom: 1rem;\n}\n\n.frosted-card ul li a {\n  display: block;\n  width: 100% !important;\n  padding: 1rem;\n  vertical-align: middle;\n  font-size: 1.25rem;\n  font-weight: bold;\n  overflow: hidden;\n  height: 100% !important;\n}\n\n.frosted-card button {\n  width: 100%;\n  padding: 1rem;\n  vertical-align: middle;\n  font-size: 1.25rem;\n  font-weight: bold;\n  text-align: center;\n  overflow: hidden;\n  height: 100% !important;\n}\n\n.frosted-card ul {\n  padding: 0;\n}\n\n.frosted-card p {\n  color: #FFFFFF;\n  text-align: left;\n}\n\n.frosted-card h1,h2,h3,h4,h5,h6 {\n  color: #FFFFFF;\n  text-align: centre;\n}\n\n.signature-canvas {\n  background-color: #FFFFFF;\n  width: 100% !important;\n}\n\n.contentMb-12 {\n    margin-bottom: 12px;\n}\n\n.contentMb-18 {\n    margin-bottom: 18px;\n}\n\n.contentMb-24 {\n    margin-bottom: 24px;\n}\n\n.table-default {\n    font-size: 14px;\n}\n\n.table-default td {\n    padding: 16px;\n}\n\n.table-default thead td {\n    color: rgba(0, 0, 0, 0.85);\n    font-weight: 500;\n    text-align: left;\n    background: #fafafa;\n    border-bottom: 1px solid #e8e8e8;\n}\n\n.table-default tbody td {\n    color: rgba(0, 0, 0, 0.85);\n    font-weight: 500;\n    text-align: left;\n    background: #fff;\n    border-bottom: 1px solid #e8e8e8;\n}\n\n.table-default .actions i {\n    margin: 0 8px;\n    cursor: pointer;\n}\n\n.table-default .actions i svg {\n    width: 20px;\n    height: 20px;\n    fill: #555;\n}\n\n.ant-calendar-input {\n    background: #fff;\n    color: #424242 !important;\n}\n\n.ant-calendar-range .ant-calendar-in-range-cell::before {\n    background: #69edfc !important;\n}\n\n.ant-calendar-selected-day .ant-calendar-date {\n    background: #286DA8 !important;\n    color: #fff !important;\n}\n\n@media screen and (max-width: 700px) {\n  h1, .h1 {\n    font-size: 2.8rem;\n  }\n}\n\n/* Stops text from appearing on new line */\n@media screen and (max-width: 900px) and (min-width: 701px) {\n  h1, .h1 {\n    font-size: 5rem;\n  }\n}\n\n.ql-editor{\n  min-height:200px !important;\n}\n\n", ""]);

// exports


/***/ }),
/* 3661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  font-family: monospace;\n  height: 300px;\n  color: black;\n  direction: ltr;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n.CodeMirror-linenumbers {}\n.CodeMirror-linenumber {\n  padding: 0 3px 0 5px;\n  min-width: 20px;\n  text-align: right;\n  color: #999;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker { color: black; }\n.CodeMirror-guttermarker-subtle { color: #999; }\n\n/* CURSOR */\n\n.CodeMirror-cursor {\n  border-left: 1px solid black;\n  border-right: none;\n  width: 0;\n}\n/* Shown when moving in bi-directional text */\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n.cm-fat-cursor .CodeMirror-cursor {\n  width: auto;\n  border: 0 !important;\n  background: #7e7;\n}\n.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n.cm-fat-cursor-mark {\n  background-color: rgba(20, 255, 20, 0.5);\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n}\n.cm-animate-fat-cursor {\n  width: auto;\n  border: 0;\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n  background-color: #7e7;\n}\n@-webkit-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n.CodeMirror-overwrite .CodeMirror-cursor {}\n\n.cm-tab { display: inline-block; text-decoration: inherit; }\n\n.CodeMirror-rulers {\n  position: absolute;\n  left: 0; right: 0; top: -50px; bottom: 0;\n  overflow: hidden;\n}\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  top: 0; bottom: 0;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-header {color: blue;}\n.cm-s-default .cm-quote {color: #090;}\n.cm-negative {color: #d44;}\n.cm-positive {color: #292;}\n.cm-header, .cm-strong {font-weight: bold;}\n.cm-em {font-style: italic;}\n.cm-link {text-decoration: underline;}\n.cm-strikethrough {text-decoration: line-through;}\n\n.cm-s-default .cm-keyword {color: #708;}\n.cm-s-default .cm-atom {color: #219;}\n.cm-s-default .cm-number {color: #164;}\n.cm-s-default .cm-def {color: #00f;}\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {}\n.cm-s-default .cm-variable-2 {color: #05a;}\n.cm-s-default .cm-variable-3, .cm-s-default .cm-type {color: #085;}\n.cm-s-default .cm-comment {color: #a50;}\n.cm-s-default .cm-string {color: #a11;}\n.cm-s-default .cm-string-2 {color: #f50;}\n.cm-s-default .cm-meta {color: #555;}\n.cm-s-default .cm-qualifier {color: #555;}\n.cm-s-default .cm-builtin {color: #30a;}\n.cm-s-default .cm-bracket {color: #997;}\n.cm-s-default .cm-tag {color: #170;}\n.cm-s-default .cm-attribute {color: #00c;}\n.cm-s-default .cm-hr {color: #999;}\n.cm-s-default .cm-link {color: #00c;}\n\n.cm-s-default .cm-error {color: #f00;}\n.cm-invalidchar {color: #f00;}\n\n.CodeMirror-composing { border-bottom: 2px solid; }\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {color: #0b0;}\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {color: #a22;}\n.CodeMirror-matchingtag { background: rgba(255, 150, 0, .3); }\n.CodeMirror-activeline-background {background: #e8f2ff;}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  position: relative;\n  overflow: hidden;\n  background: white;\n}\n\n.CodeMirror-scroll {\n  overflow: scroll !important; /* Things will break if this is overridden */\n  /* 30px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -30px; margin-right: -30px;\n  padding-bottom: 30px;\n  height: 100%;\n  outline: none; /* Prevent dragging from highlighting the element */\n  position: relative;\n}\n.CodeMirror-sizer {\n  position: relative;\n  border-right: 30px solid transparent;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n.CodeMirror-vscrollbar, .CodeMirror-hscrollbar, .CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  position: absolute;\n  z-index: 6;\n  display: none;\n}\n.CodeMirror-vscrollbar {\n  right: 0; top: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.CodeMirror-hscrollbar {\n  bottom: 0; left: 0;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.CodeMirror-scrollbar-filler {\n  right: 0; bottom: 0;\n}\n.CodeMirror-gutter-filler {\n  left: 0; bottom: 0;\n}\n\n.CodeMirror-gutters {\n  position: absolute; left: 0; top: 0;\n  min-height: 100%;\n  z-index: 3;\n}\n.CodeMirror-gutter {\n  white-space: normal;\n  height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: -30px;\n}\n.CodeMirror-gutter-wrapper {\n  position: absolute;\n  z-index: 4;\n  background: none !important;\n  border: none !important;\n}\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0; bottom: 0;\n  z-index: 4;\n}\n.CodeMirror-gutter-elt {\n  position: absolute;\n  cursor: default;\n  z-index: 4;\n}\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  /* Reset some styles that the rest of the page might have set */ border-radius: 0;\n  border-width: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  white-space: pre;\n  word-wrap: normal;\n  line-height: inherit;\n  color: inherit;\n  z-index: 2;\n  position: relative;\n  overflow: visible;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-variant-ligatures: contextual;\n  font-variant-ligatures: contextual;\n}\n.CodeMirror-wrap pre.CodeMirror-line,\n.CodeMirror-wrap pre.CodeMirror-line-like {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0; right: 0; top: 0; bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  position: relative;\n  z-index: 2;\n  padding: 0.1px; /* Force widget margins to stay inside of the container */\n}\n\n.CodeMirror-widget {}\n\n.CodeMirror-rtl pre { direction: rtl; }\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n  pointer-events: none;\n}\n.CodeMirror-measure pre { position: static; }\n\ndiv.CodeMirror-cursors {\n  visibility: hidden;\n  position: relative;\n  z-index: 3;\n}\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected { background: #d9d9d9; }\n.CodeMirror-focused .CodeMirror-selected { background: #d7d4f0; }\n.CodeMirror-crosshair { cursor: crosshair; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n.CodeMirror-line::selection, .CodeMirror-line > span::selection, .CodeMirror-line > span > span::selection { background: #d7d4f0; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n\n.cm-searching {\n  background-color: #ffa;\n  background-color: rgba(255, 255, 0, .4);\n}\n\n/* Used to force a border model for a node */\n.cm-force-border { padding-right: .1px; }\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n.cm-tab-wrap-hack:after { content: ''; }\n\n/* Help users use markselection to safely style text background */\nspan.CodeMirror-selectedtext { background: none; }\n", ""]);

// exports


/***/ }),
/* 3662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/*\n  Name:       material\n  Author:     Mattia Astorino (http://github.com/equinusocio)\n  Website:    https://material-theme.site/\n*/\n\n.cm-s-material.CodeMirror {\n  background-color: #263238;\n  color: #EEFFFF;\n}\n\n.cm-s-material .CodeMirror-gutters {\n  background: #263238;\n  color: #546E7A;\n  border: none;\n}\n\n.cm-s-material .CodeMirror-guttermarker,\n.cm-s-material .CodeMirror-guttermarker-subtle,\n.cm-s-material .CodeMirror-linenumber {\n  color: #546E7A;\n}\n\n.cm-s-material .CodeMirror-cursor {\n  border-left: 1px solid #FFCC00;\n}\n\n.cm-s-material div.CodeMirror-selected {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material.CodeMirror-focused div.CodeMirror-selected {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material .CodeMirror-line::-moz-selection,\n.cm-s-material .CodeMirror-line>span::-moz-selection,\n.cm-s-material .CodeMirror-line>span>span::-moz-selection {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material .CodeMirror-line::selection,\n.cm-s-material .CodeMirror-line>span::selection,\n.cm-s-material .CodeMirror-line>span>span::selection {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material .CodeMirror-line::-moz-selection,\n.cm-s-material .CodeMirror-line>span::-moz-selection,\n.cm-s-material .CodeMirror-line>span>span::-moz-selection {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material .CodeMirror-activeline-background {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.cm-s-material .cm-keyword {\n  color: #C792EA;\n}\n\n.cm-s-material .cm-operator {\n  color: #89DDFF;\n}\n\n.cm-s-material .cm-variable-2 {\n  color: #EEFFFF;\n}\n\n.cm-s-material .cm-variable-3,\n.cm-s-material .cm-type {\n  color: #f07178;\n}\n\n.cm-s-material .cm-builtin {\n  color: #FFCB6B;\n}\n\n.cm-s-material .cm-atom {\n  color: #F78C6C;\n}\n\n.cm-s-material .cm-number {\n  color: #FF5370;\n}\n\n.cm-s-material .cm-def {\n  color: #82AAFF;\n}\n\n.cm-s-material .cm-string {\n  color: #C3E88D;\n}\n\n.cm-s-material .cm-string-2 {\n  color: #f07178;\n}\n\n.cm-s-material .cm-comment {\n  color: #546E7A;\n}\n\n.cm-s-material .cm-variable {\n  color: #f07178;\n}\n\n.cm-s-material .cm-tag {\n  color: #FF5370;\n}\n\n.cm-s-material .cm-meta {\n  color: #FFCB6B;\n}\n\n.cm-s-material .cm-attribute {\n  color: #C792EA;\n}\n\n.cm-s-material .cm-property {\n  color: #C792EA;\n}\n\n.cm-s-material .cm-qualifier {\n  color: #DECB6B;\n}\n\n.cm-s-material .cm-variable-3,\n.cm-s-material .cm-type {\n  color: #DECB6B;\n}\n\n\n.cm-s-material .cm-error {\n  color: rgba(255, 255, 255, 1.0);\n  background-color: #FF5370;\n}\n\n.cm-s-material .CodeMirror-matchingbracket {\n  text-decoration: underline;\n  color: white !important;\n}", ""]);

// exports


/***/ }),
/* 3663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  -o-tab-size: 4;\n     tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file],\n.ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active),\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ql-snow * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  -webkit-transform: translateY(10px);\n      -ms-transform: translateY(10px);\n          transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  -webkit-transform: translateY(-10px);\n      -ms-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  -webkit-box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n          box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  -webkit-box-shadow: 0px 0px 5px #ddd;\n          box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  -o-text-overflow: ellipsis;\n     text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.0c077777.js